import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  S3UrlCloudFront: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type TAbnormalityAnalysis = {
  __typename?: 'AbnormalityAnalysis';
  annual_number_of_exams_performed: Scalars['Float']['output'];
  cost_center: Scalars['String']['output'];
  nature: Scalars['String']['output'];
  number_of_abnormal_results: Scalars['Float']['output'];
  ratio_of_abnormal_results_by_total_number_of_exams: Scalars['Float']['output'];
  total_exams_next_year: Scalars['Float']['output'];
};

export type TAbsenceType = {
  __typename?: 'AbsenceType';
  /** Descrição do tipo de afastamento */
  description: Scalars['String']['output'];
  /** Identificador único do tipo de afastamento */
  id: Scalars['String']['output'];
  /** Identificador de referência */
  referenceId?: Maybe<Scalars['String']['output']>;
  /** Sugestão de uso */
  suggestion?: Maybe<Scalars['String']['output']>;
};

export type TAbsenceTypeInput = {
  /** Descrição do tipo de afastamento */
  description: Scalars['String']['input'];
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type TAbsenceTypeIntegration = {
  /** Identificador da filial */
  branch: Scalars['String']['input'];
  /** Descrição do tipo de afastamento */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único do tipo de afastamento */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type TAbsenceTypeUpdate = {
  /** Descrição do tipo de afastamento */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único do tipo de afastamento */
  id: Scalars['String']['input'];
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

/** Forma de acesso ao sistema. */
export enum TAccessBy {
  /** Autenticação pelo Fluig */
  Fluig = 'Fluig',
  /** Autenticação pelo Quírons */
  Internal = 'Internal',
  /** Autenticação pela Microsoft */
  Microsoft = 'Microsoft'
}

export type TAccessToken = {
  __typename?: 'AccessToken';
  /** ID do acesso à API */
  apiAccessId: Scalars['String']['output'];
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** Data de exclusão */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Token de acesso */
  token: Scalars['String']['output'];
};

export type TAccessTokenInput = {
  /** Chave de acesso */
  accessKey: Scalars['String']['input'];
  /** Segredo de acesso */
  accessSecret: Scalars['String']['input'];
  /** Fuso horário */
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type TAccident = {
  __typename?: 'Accident';
  /** Indica se aceitou responsabilidade */
  accept?: Maybe<Scalars['Boolean']['output']>;
  /** Partes do corpo atingidas no acidente */
  accidentBodyParts?: Maybe<Array<TAccidentBodyPart>>;
  /** Código do acidente */
  accidentCode?: Maybe<TAccidentCode>;
  /** Despesas do acidente */
  accidentExpenses?: Maybe<Array<TExpenseOnAccident>>;
  /** Local do acidente */
  accidentLocation?: Maybe<TAccidentLocation>;
  /** Potencial de gravidade do acidente */
  accidentPotential?: Maybe<TAccidentPotentialEnum>;
  /** Tipo de acidente (classificação) */
  accidentType?: Maybe<TAccidentType>;
  /** Tipo do acidente */
  accidentTypeEnum: TAccidentTypeEnum;
  /** Testemunhas relacionadas ao acidente */
  accidentWitness?: Maybe<Array<TAccidentWitness>>;
  /** Anexos relacionados ao acidente */
  attachments?: Maybe<Array<TAttachment>>;
  /** Partes do corpo afetadas */
  bodyParts?: Maybe<Array<TBodyPartOnAccident>>;
  /** Agente causador relacionado */
  causerAgent?: Maybe<Array<TCauserAgentOnAccident>>;
  /** Agentes causadores do acidente */
  causerAgents?: Maybe<Array<TCauserAgentOnAccident>>;
  /** Cidade */
  city?: Maybe<Scalars['String']['output']>;
  /** Registro da empresa */
  companyRegistration?: Maybe<Scalars['String']['output']>;
  /** Tipo de comunicação de acidente de trabalho (CAT) */
  comunicationType?: Maybe<TComunicationType>;
  /** Conclusão da investigação */
  conclusion?: Maybe<Scalars['String']['output']>;
  /** Centro de custo */
  costCenter?: Maybe<TCostCenter>;
  /** País */
  country?: Maybe<Scalars['String']['output']>;
  /** Data do acidente */
  date: Scalars['DateTime']['output'];
  /** Dias perdidos de trabalho */
  daysLost?: Maybe<Scalars['Float']['output']>;
  /** Data do óbito */
  deathDate?: Maybe<Scalars['DateTime']['output']>;
  /** Descrição do acidente */
  description?: Maybe<Scalars['String']['output']>;
  /** Distância percorrida */
  distance?: Maybe<Scalars['String']['output']>;
  /** Data de emissão da CAT */
  emissionDate?: Maybe<Scalars['DateTime']['output']>;
  /** Órgão emissor do documento */
  emitter?: Maybe<TEmitter>;
  /** E-mail do emitente */
  emitterEmail?: Maybe<Scalars['String']['output']>;
  /** Horário de saída */
  exitHour?: Maybe<Scalars['String']['output']>;
  /** Tipo de despesa relacionada ao acidente */
  expenseType?: Maybe<TAccidentExpenseType>;
  /** Despesas relacionadas ao acidente */
  expenses?: Maybe<Array<TExpenseOnAccident>>;
  /** Indica se houve mudança de percurso */
  hadPathChange?: Maybe<Scalars['Boolean']['output']>;
  /** Indica se houve afastamento */
  hasAbsence?: Maybe<Scalars['Boolean']['output']>;
  /** CID do acidente */
  icd?: Maybe<TIcd>;
  /** Grupo do CID */
  icdGroup?: Maybe<TIcdGroup>;
  /** Identificador do grupo do CID */
  icdGroupId?: Maybe<Scalars['String']['output']>;
  /** CIDs complementares */
  icds?: Maybe<Array<TComplementaryIcdOnAccident>>;
  /** Identificador único do acidente */
  id: Scalars['String']['output'];
  /** Natureza da lesão */
  injuryNature?: Maybe<TInjuryNature>;
  /** Último dia trabalhado */
  lastDayWork?: Maybe<Scalars['DateTime']['output']>;
  /** Descrição do local */
  locationDescription?: Maybe<Scalars['String']['output']>;
  /** Meio de locomoção */
  locomotion?: Maybe<Scalars['String']['output']>;
  /** Percurso da ocorrência */
  occurencePath?: Maybe<TOccurencePath>;
  /** Data de origem */
  originDate?: Maybe<Scalars['DateTime']['output']>;
  /** Número de origem */
  originNumber?: Maybe<Scalars['String']['output']>;
  /** Indica se possui outra ocupação */
  otherOccupation?: Maybe<Scalars['Boolean']['output']>;
  /** Pessoa acidentada */
  person?: Maybe<TPerson>;
  /** Indica se houve boletim de ocorrência */
  policeRecord?: Maybe<Scalars['Boolean']['output']>;
  /** Tipo de logradouro */
  publicPlace?: Maybe<TGenericPublicPlace>;
  /** Motivo da mudança de percurso */
  reason?: Maybe<Scalars['String']['output']>;
  /** Indica se está aposentado */
  retired?: Maybe<Scalars['Boolean']['output']>;
  /** Área de atendimento */
  serviceArea?: Maybe<TServiceArea>;
  /** Afiliação previdenciária */
  socialSecurityAffiliation?: Maybe<TSocialSecurityAffiliation>;
  /** Código da previdência social */
  socialSecurityCode?: Maybe<Scalars['String']['output']>;
  /** Tempo padrão de deslocamento */
  standarTime?: Maybe<Scalars['String']['output']>;
  /** Estado */
  state?: Maybe<Scalars['String']['output']>;
  /** Rua */
  street?: Maybe<Scalars['String']['output']>;
  /** Número do endereço */
  streetNumber?: Maybe<Scalars['String']['output']>;
  /** Sugestão ou observação adicional */
  suggestion?: Maybe<Scalars['String']['output']>;
  /** Resumo do acidente */
  summary: Scalars['String']['output'];
  /** Etiqueta para categorização */
  tag?: Maybe<Scalars['String']['output']>;
  /** Tempo trabalhado na empresa */
  timeWorked?: Maybe<Scalars['String']['output']>;
  /** Tipo de acidente de trânsito */
  trafficAccidentType?: Maybe<TTrafficAccidentType>;
  /** Percurso habitual */
  usualPath?: Maybe<Scalars['String']['output']>;
  /** Indica se haverá mudança de setor */
  willTransferSector?: Maybe<Scalars['Boolean']['output']>;
  /** Testemunhas do acidente */
  witnesses?: Maybe<Array<TWitnessOnAccident>>;
  /** Horas trabalhadas no dia */
  workedHours?: Maybe<Scalars['String']['output']>;
  /** CEP */
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type TAccidentAbsence = {
  __typename?: 'AccidentAbsence';
  /** Tipo de afastamento */
  absence: Scalars['String']['output'];
  /** Quantidade de afastamentos */
  amount: Scalars['Float']['output'];
  /** Mês */
  month: Scalars['Float']['output'];
  /** Ano */
  year: Scalars['Float']['output'];
};

export type TAccidentAmount = {
  __typename?: 'AccidentAmount';
  /** Quantidade de acidentes */
  amount: Scalars['Float']['output'];
  /** Mês */
  month: Scalars['Float']['output'];
  /** Nome da pessoa */
  person: Scalars['String']['output'];
  /** Ano */
  year: Scalars['Float']['output'];
};

export type TAccidentAnalysis = {
  __typename?: 'AccidentAnalysis';
  cost_center: Scalars['String']['output'];
  icd: Scalars['String']['output'];
  total: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TAccidentBodyPart = {
  __typename?: 'AccidentBodyPart';
  /** Parte do corpo */
  bodyPart: TBodyPart;
  /** É parte principal */
  isMain?: Maybe<Scalars['Boolean']['output']>;
  /** Lateralidade */
  laterality?: Maybe<TLaterality>;
};

export type TAccidentBodyPartInput = {
  /** Identificador do acidente */
  accidentId: Scalars['String']['input'];
  /** Identificador da parte do corpo */
  bodyPartId: Scalars['String']['input'];
  /** Identificador da filial */
  branch: Scalars['String']['input'];
  /** É parte principal */
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  /** Lateralidade */
  laterality?: InputMaybe<TLaterality>;
};

export type TAccidentBodyPartInputBranch = {
  /** Identificador da parte do corpo */
  bodyPartId: Scalars['String']['input'];
  /** Identificador da filial */
  branch: Scalars['String']['input'];
  /** Lateralidade */
  laterality?: InputMaybe<TLaterality>;
};

export type TAccidentCause = {
  __typename?: 'AccidentCause';
  /** Tipo da causa */
  causeType: TCauseType;
  /** Descrição da causa */
  description: Scalars['String']['output'];
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Indica se está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Identificador de referência */
  referenceId?: Maybe<Scalars['String']['output']>;
};

export type TAccidentCauseInput = {
  /** Tipo da causa */
  causeType: TCauseType;
  /** Descrição da causa */
  description: Scalars['String']['input'];
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type TAccidentCauseUpdate = {
  /** Tipo da causa */
  causeType?: InputMaybe<TCauseType>;
  /** Descrição da causa */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Indica se está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type TAccidentCauses = {
  __typename?: 'AccidentCauses';
  /** Tipo de causa do acidente */
  causeType: TCauseType;
  /** Total de ocorrências desta causa */
  total: Scalars['Float']['output'];
};

export type TAccidentCharts = {
  __typename?: 'AccidentCharts';
  /** Dados */
  data: Array<TData>;
  /** Indica se há acidentes registrados */
  hasAccident: Scalars['Boolean']['output'];
  /** Dados por total */
  perTotal: Array<TData>;
};

/** Circunstância do acidente com material biológico. */
export enum TAccidentCircumstance {
  /** Punção para coleta de sangue */
  BloodCollectionPuncture = 'BloodCollectionPuncture',
  /** Monitoramento de glicemia */
  BloodGlucoseMonitoring = 'BloodGlucoseMonitoring',
  /** Procedimento odontológico */
  DentalProcedure = 'DentalProcedure',
  /** Descarte inadequado em saco */
  ImproperBagDisposal = 'ImproperBagDisposal',
  /** Descarte inadequado em superfície */
  ImproperSurfaceDisposal = 'ImproperSurfaceDisposal',
  /** Medicação intradérmica */
  IntradermalMedication = 'IntradermalMedication',
  /** Medicação intramuscular */
  IntramuscularMedication = 'IntramuscularMedication',
  /** Medicação intravenosa */
  IntravenousMedication = 'IntravenousMedication',
  /** Procedimento laboratorial */
  LaboratoryProcedure = 'LaboratoryProcedure',
  /** Roupa suja */
  Laundry = 'Laundry',
  /** Lavagem de material */
  MaterialWashing = 'MaterialWashing',
  /** Recapagem de agulha */
  NeedleRecapping = 'NeedleRecapping',
  /** Outros */
  Others = 'Others',
  /** Caixa de objetos cortantes */
  SharpObjectsBox = 'SharpObjectsBox',
  /** Medicação subcutânea */
  SubcutaneousMedication = 'SubcutaneousMedication',
  /** Procedimento cirúrgico */
  SurgicalProcedure = 'SurgicalProcedure',
  /** Punção não especificada */
  UnspecifiedPuncture = 'UnspecifiedPuncture'
}

export type TAccidentCode = {
  __typename?: 'AccidentCode';
  /** Descrição do código de acidente */
  description: Scalars['String']['output'];
  /** Código eSocial */
  eSocialCode: Scalars['String']['output'];
  /** Identificador único do código de acidente */
  id: Scalars['String']['output'];
  /** Sugestão de uso do código */
  suggestion: Scalars['String']['output'];
};

/** Condução do acidente com material biológico. */
export enum TAccidentConduction {
  /** AZT + 3TC */
  Azt_3Tc = 'AZT_3TC',
  /** AZT + 3TC + Indinavir */
  Azt_3TcIndinavir = 'AZT_3TC_Indinavir',
  /** AZT + 3TC + Nelfinavir */
  Azt_3TcNelfinavir = 'AZT_3TC_Nelfinavir',
  /** Vacina contra hepatite B */
  HepatitisBVaccine = 'HepatitisBVaccine',
  /** Imunoglobulina humana anti-hepatite B */
  HumanImmunoglobulinAgainstHepatitisB = 'HumanImmunoglobulinAgainstHepatitisB',
  /** Sem indicação de quimioprofilaxia */
  NoChemoprophylaxisIndication = 'NoChemoprophylaxisIndication',
  /** Outros */
  Others = 'Others',
  /** Recusou quimioprofilaxia */
  RefusedChemoprophylaxis = 'RefusedChemoprophylaxis'
}

export type TAccidentDashboard = {
  __typename?: 'AccidentDashboard';
  /** Gráfico de acidentes por tipo eSocial */
  accidentsESocialTypeChart: TAccidentCharts;
  /** Gráfico de acidentes por dia da semana */
  accidentsPerDayChart: TAccidentsPerDayChart;
  /** Gráfico de acidentes por mês */
  accidentsPerMonthChart: TAccidentsPerMonthChart;
  /** Gráfico de acidentes por tag */
  accidentsTagChart: TAccidentCharts;
  /** Gráfico de acidentes por horário */
  accidentsTimeChart: TAccidentsTimeChart;
  /** Gráfico de acidentes por faixa etária */
  ageChart: TAgeAccidentChart;
  /** Gráfico de partes do corpo afetadas */
  bodyPartsChart: TIndexChart;
  /** Gráfico de custos por tipo */
  costPerTypeChart: TCostPerTypeChart;
  /** Gráfico de dias sem acidentes */
  daysWithoutAccidentChart: TDaysWithoutAccidentChart;
  /** Gráfico de acidentes com óbito */
  deathAccidentChart: TIndexChart;
  /** Gráfico de acidentes mais custosos */
  expensiveAccidentsChart: TExpensiveAccidentsChart;
  /** Gráfico do índice de frequência de acidentes */
  frequencyIndexChart: TIndexChart;
  /** Gráfico de acidentes por natureza da lesão */
  injuryNatureChart: TAccidentCharts;
  /** Gráfico de quantidade de investigações */
  investigationAmountChart: TInvestigationAmountChart;
  /** Gráfico de indicadores de investigação */
  investigationIndicatorsChart: TInvestigationIndicatorsChart;
  /** Gráfico de dias perdidos por centro de custo */
  lostDaysCostCenterChart: TAccidentCharts;
  /** Gráfico do índice de dias perdidos */
  lostIndexChart: TIndexChart;
  /** Gráfico do índice relativo de acidentes */
  relativeIndexChart: TIndexChart;
  /** Pirâmide de segurança */
  securityPyramid: TSecurityPyramid;
  /** Gráfico do índice de gravidade de acidentes */
  severityIndexChart: TIndexChart;
  /** Gráfico de acidentes por tipo */
  typeChart: TTypeChart;
  /** Gráfico de tipos de acidentes por centro de custo */
  typeCostCenterChart: TTypeCostCenterChart;
};

export type TAccidentDescription = {
  __typename?: 'AccidentDescription';
  /** Descrição do acidente */
  description: Scalars['String']['output'];
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Sugestão de uso */
  suggestion: Scalars['String']['output'];
};

export type TAccidentExpenseAmount = {
  __typename?: 'AccidentExpenseAmount';
  amount: Scalars['Float']['output'];
  month: Scalars['Float']['output'];
  year: Scalars['Float']['output'];
};

export type TAccidentExpenseInput = {
  accidentId: Scalars['String']['input'];
  branch?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  expenseId: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** Tipo de despesa do acidente. */
export enum TAccidentExpenseType {
  /** Indenização */
  Indemnity = 'Indemnity',
  /** Despesa com material */
  Material = 'Material',
  /** Despesa médica */
  Medical = 'Medical',
  /** Não aplicável */
  NotAplicable = 'NotAplicable',
  /** Outros */
  Others = 'Others',
  /** Perda de produção */
  ProductionLoss = 'ProductionLoss'
}

export type TAccidentExpenseUpdate = {
  accidentId?: InputMaybe<Scalars['String']['input']>;
  branch?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  expenseId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** Tipos de exposição em acidentes com material biológico. */
export enum TAccidentExposureType {
  /** Exposição em pele íntegra */
  IntactSkin = 'IntactSkin',
  /** Exposição em mucosas (p. ex., contato com olhos, boca) */
  Mucosa = 'Mucosa',
  /** Exposição em pele não íntegra (p. ex., cortes, abrasões) */
  NonIntactSkin = 'NonIntactSkin',
  /** Outros tipos de exposição */
  Others = 'Others',
  /** Exposição percutânea (p. ex., punção com agulha contaminada) */
  Percutaneous = 'Percutaneous'
}

export type TAccidentFilter = {
  /** Códigos de acidente */
  accidentCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tipos de acidente */
  accidentTypes?: InputMaybe<Array<TAccidentTypeEnum>>;
  /** Centros de custo */
  costCenters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Intervalo de datas */
  dates?: InputMaybe<TDateRange>;
  /** Grupos de CID */
  icdGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  /** CIDs */
  icds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Naturezas de lesão */
  injuryNatures?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Locais do acidente */
  location?: InputMaybe<Array<TAccidentLocation>>;
  /** Pessoas */
  people?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TAccidentInput = {
  /** Indica se aceitou responsabilidade */
  accept?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador do código do acidente */
  accidentCodeId?: InputMaybe<Scalars['String']['input']>;
  /** Local do acidente */
  accidentLocation?: InputMaybe<TAccidentLocation>;
  /** Potencial de gravidade do acidente */
  accidentPotential?: InputMaybe<TAccidentPotentialEnum>;
  /** Tipo do acidente */
  accidentTypeEnum: TAccidentTypeEnum;
  /** Identificador do tipo de acidente */
  accidentTypeId?: InputMaybe<Scalars['String']['input']>;
  /** Partes do corpo afetadas */
  bodyParts?: InputMaybe<Array<TBodyPartOnAccidentInput>>;
  /** Agentes causadores do acidente */
  causerAgents?: InputMaybe<Array<TCauserAgentOnAccidentInput>>;
  /** Cidade */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Registro da empresa */
  companyRegistration?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de comunicação de acidente de trabalho (CAT) */
  comunicationType?: InputMaybe<TComunicationType>;
  /** Conclusão da investigação */
  conclusion?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do centro de custo */
  costCenterId?: InputMaybe<Scalars['String']['input']>;
  /** País */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Data do acidente */
  date: Scalars['DateTime']['input'];
  /** Dias perdidos de trabalho */
  daysLost?: InputMaybe<Scalars['Float']['input']>;
  /** Data do óbito */
  deathDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Descrição do acidente */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Distância percorrida */
  distance?: InputMaybe<Scalars['String']['input']>;
  /** Data de emissão da CAT */
  emissionDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Órgão emissor do documento */
  emitter?: InputMaybe<TEmitter>;
  /** E-mail do emitente */
  emitterEmail?: InputMaybe<Scalars['String']['input']>;
  /** Horário de saída */
  exitHour?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de despesa relacionada ao acidente */
  expenseType?: InputMaybe<TAccidentExpenseType>;
  /** Despesas relacionadas ao acidente */
  expenses?: InputMaybe<Array<TExpenseOnAccidentInput>>;
  /** Indica se houve mudança de percurso */
  hadPathChange?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se houve afastamento */
  hasAbsence?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador do grupo do CID */
  icdGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do CID */
  icdId?: InputMaybe<Scalars['String']['input']>;
  /** CIDs complementares */
  icds?: InputMaybe<Array<TComplementaryIcdOnAccidentInput>>;
  /** Identificador da natureza da lesão */
  injuryNatureId?: InputMaybe<Scalars['String']['input']>;
  /** Último dia trabalhado */
  lastDayWork?: InputMaybe<Scalars['DateTime']['input']>;
  /** Descrição do local */
  locationDescription?: InputMaybe<Scalars['String']['input']>;
  /** Meio de locomoção */
  locomotion?: InputMaybe<Scalars['String']['input']>;
  /** Percurso da ocorrência */
  occurencePath?: InputMaybe<TOccurencePath>;
  /** Data de origem */
  originDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Número de origem */
  originNumber?: InputMaybe<Scalars['String']['input']>;
  /** Indica se possui outra ocupação */
  otherOccupation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador da pessoa */
  personId?: InputMaybe<Scalars['String']['input']>;
  /** Indica se houve boletim de ocorrência */
  policeRecord?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador do tipo de logradouro */
  publicPlaceId?: InputMaybe<Scalars['String']['input']>;
  /** Motivo da mudança de percurso */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Indica se está aposentado */
  retired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Área de atendimento */
  serviceArea?: InputMaybe<TServiceArea>;
  /** Afiliação previdenciária */
  socialSecurityAffiliation?: InputMaybe<TSocialSecurityAffiliation>;
  /** Código da previdência social */
  socialSecurityCode?: InputMaybe<Scalars['String']['input']>;
  /** Tempo padrão de deslocamento */
  standarTime?: InputMaybe<Scalars['String']['input']>;
  /** Estado */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Rua */
  street?: InputMaybe<Scalars['String']['input']>;
  /** Número do endereço */
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  /** Sugestão ou observação adicional */
  suggestion?: InputMaybe<Scalars['String']['input']>;
  /** Resumo do acidente */
  summary: Scalars['String']['input'];
  /** Etiqueta para categorização */
  tag?: InputMaybe<Scalars['String']['input']>;
  /** Tempo trabalhado na empresa */
  timeWorked?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de acidente de trânsito */
  trafficAccidentType?: InputMaybe<TTrafficAccidentType>;
  /** Percurso habitual */
  usualPath?: InputMaybe<Scalars['String']['input']>;
  /** Indica se haverá mudança de setor */
  willTransferSector?: InputMaybe<Scalars['Boolean']['input']>;
  /** Testemunhas do acidente */
  witnesses?: InputMaybe<Array<TWitnessOnAccidentInput>>;
  /** Horas trabalhadas no dia */
  workedHours?: InputMaybe<Scalars['String']['input']>;
  /** CEP */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Locais onde podem ocorrer acidentes. */
export enum TAccidentLocation {
  /** Dentro da empresa onde o colaborador trabalha. */
  Company = 'company',
  /** Outros locais não especificados. */
  Other = 'other',
  /** Em outra empresa que não a do colaborador. */
  OtherCompany = 'otherCompany',
  /** Fora do país de residência do colaborador. */
  OutsideContry = 'outsideContry',
  /** Em vias públicas. */
  PublicHigway = 'publicHigway',
  /** Em áreas rurais. */
  RuralArea = 'ruralArea',
  /** Em embarcações. */
  Ship = 'ship'
}

export type TAccidentObject = {
  __typename?: 'AccidentObject';
  /** Descrição do objeto do acidente */
  description: Scalars['String']['output'];
  /** Código eSocial */
  eSocialCode: Scalars['String']['output'];
  /** Identificador único do objeto do acidente */
  id: Scalars['String']['output'];
};

/** Campos de ordenação de acidentes */
export enum TAccidentOrderByFields {
  /** Tipo de acidente */
  AccidentType = 'AccidentType',
  /** Data */
  Date = 'Date',
  /** Resumo */
  Summary = 'Summary'
}

export type TAccidentOrderByInput = {
  /** Campo para ordenação */
  field?: InputMaybe<TAccidentOrderByFields>;
  /** Tipo de ordenação */
  type?: InputMaybe<TOrderBy>;
};

/** Potencial do acidente */
export enum TAccidentPotentialEnum {
  /** Alto */
  High = 'High',
  /** Baixo */
  Low = 'Low',
  /** Médio */
  Medium = 'Medium'
}

export type TAccidentQueryInput = {
  /** Filtros de consulta */
  filter?: InputMaybe<TAccidentFilter>;
  /** Identificador ou termo de busca */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Retornar apenas registros ativos */
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Incluir tags */
  tags?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TAccidentType = {
  __typename?: 'AccidentType';
  /** Código eSocial */
  eSocialCode: Scalars['String']['output'];
  /** Identificador único do tipo de acidente */
  id: Scalars['String']['output'];
  /** Indica se é doença ocupacional */
  occupationalDesease: Scalars['Boolean']['output'];
  /** Descrição da doença ocupacional */
  occupationalDeseaseDescription: Scalars['String']['output'];
  /** Sugestão de uso do tipo */
  suggestion: Scalars['String']['output'];
  /** Indica se é acidente de trabalho */
  workAccident: Scalars['Boolean']['output'];
  /** Descrição do acidente de trabalho */
  workAccidentDescription: Scalars['String']['output'];
};

/** Tipo de acidente */
export enum TAccidentTypeEnum {
  /** Incidente */
  Incident = 'Incident',
  /** Trajeto */
  OnWay = 'OnWay',
  /** Típico */
  Typical = 'Typical',
  /** Doença ocupacional */
  WorkDisease = 'WorkDisease'
}

export type TAccidentUpdate = {
  /** Indica se aceitou responsabilidade */
  accept?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador do código do acidente */
  accidentCodeId?: InputMaybe<Scalars['String']['input']>;
  /** Local do acidente */
  accidentLocation?: InputMaybe<TAccidentLocation>;
  /** Potencial de gravidade do acidente */
  accidentPotential?: InputMaybe<TAccidentPotentialEnum>;
  /** Tipo do acidente */
  accidentTypeEnum?: InputMaybe<TAccidentTypeEnum>;
  /** Identificador do tipo de acidente */
  accidentTypeId?: InputMaybe<Scalars['String']['input']>;
  /** Partes do corpo afetadas */
  bodyParts?: InputMaybe<Array<TBodyPartOnAccidentInput>>;
  /** Atualização de agentes causadores */
  causerAgents?: InputMaybe<TCauserAgentOnAccidentUpdate>;
  /** Cidade */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Registro da empresa */
  companyRegistration?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de comunicação de acidente de trabalho (CAT) */
  comunicationType?: InputMaybe<TComunicationType>;
  /** Conclusão da investigação */
  conclusion?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do centro de custo */
  costCenterId?: InputMaybe<Scalars['String']['input']>;
  /** País */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Data do acidente */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Dias perdidos de trabalho */
  daysLost?: InputMaybe<Scalars['Float']['input']>;
  /** Data do óbito */
  deathDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Descrição do acidente */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Distância percorrida */
  distance?: InputMaybe<Scalars['String']['input']>;
  /** Data de emissão da CAT */
  emissionDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Órgão emissor do documento */
  emitter?: InputMaybe<TEmitter>;
  /** E-mail do emitente */
  emitterEmail?: InputMaybe<Scalars['String']['input']>;
  /** Horário de saída */
  exitHour?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de despesa relacionada ao acidente */
  expenseType?: InputMaybe<TAccidentExpenseType>;
  /** Atualização de despesas */
  expenses?: InputMaybe<TExpenseOnAccidentUpdate>;
  /** Indica se houve mudança de percurso */
  hadPathChange?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se houve afastamento */
  hasAbsence?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador do grupo do CID */
  icdGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do CID */
  icdId?: InputMaybe<Scalars['String']['input']>;
  /** Atualização de CIDs complementares */
  icds?: InputMaybe<TComplementaryIcdOnAccidentUpdate>;
  /** Identificador do acidente */
  id: Scalars['String']['input'];
  /** Identificador da natureza da lesão */
  injuryNatureId?: InputMaybe<Scalars['String']['input']>;
  /** Último dia trabalhado */
  lastDayWork?: InputMaybe<Scalars['DateTime']['input']>;
  /** Descrição do local */
  locationDescription?: InputMaybe<Scalars['String']['input']>;
  /** Meio de locomoção */
  locomotion?: InputMaybe<Scalars['String']['input']>;
  /** Percurso da ocorrência */
  occurencePath?: InputMaybe<TOccurencePath>;
  /** Data de origem */
  originDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Número de origem */
  originNumber?: InputMaybe<Scalars['String']['input']>;
  /** Indica se possui outra ocupação */
  otherOccupation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador da pessoa */
  personId?: InputMaybe<Scalars['String']['input']>;
  /** Indica se houve boletim de ocorrência */
  policeRecord?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador do tipo de logradouro */
  publicPlaceId?: InputMaybe<Scalars['String']['input']>;
  /** Motivo da mudança de percurso */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Indica se está aposentado */
  retired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Área de atendimento */
  serviceArea?: InputMaybe<TServiceArea>;
  /** Afiliação previdenciária */
  socialSecurityAffiliation?: InputMaybe<TSocialSecurityAffiliation>;
  /** Código da previdência social */
  socialSecurityCode?: InputMaybe<Scalars['String']['input']>;
  /** Tempo padrão de deslocamento */
  standarTime?: InputMaybe<Scalars['String']['input']>;
  /** Estado */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Rua */
  street?: InputMaybe<Scalars['String']['input']>;
  /** Número do endereço */
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  /** Sugestão ou observação adicional */
  suggestion?: InputMaybe<Scalars['String']['input']>;
  /** Resumo do acidente */
  summary?: InputMaybe<Scalars['String']['input']>;
  /** Etiqueta para categorização */
  tag?: InputMaybe<Scalars['String']['input']>;
  /** Tempo trabalhado na empresa */
  timeWorked?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de acidente de trânsito */
  trafficAccidentType?: InputMaybe<TTrafficAccidentType>;
  /** Percurso habitual */
  usualPath?: InputMaybe<Scalars['String']['input']>;
  /** Indica se haverá mudança de setor */
  willTransferSector?: InputMaybe<Scalars['Boolean']['input']>;
  /** Atualização de testemunhas */
  witnesses?: InputMaybe<TWitnessOnAccidentUpdate>;
  /** Horas trabalhadas no dia */
  workedHours?: InputMaybe<Scalars['String']['input']>;
  /** CEP */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type TAccidentVictim = {
  __typename?: 'AccidentVictim';
  /** Quantidade */
  amount: Scalars['Float']['output'];
  /** Descrição do tipo de vítima */
  description: Scalars['String']['output'];
};

export type TAccidentWithInvestigation = {
  __typename?: 'AccidentWithInvestigation';
  /** Identificador do acidente */
  accidentId: Scalars['String']['output'];
  /** Sugestão do acidente */
  accidentSuggestion: Scalars['String']['output'];
  /** Indicativo da ocorrência */
  accidentTypeEnum: TAccidentTypeEnum;
  /** Data da investigação */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** Data do acidente */
  dateAccident: Scalars['DateTime']['output'];
  /** Data da investigação */
  dateInvestigation?: Maybe<Scalars['DateTime']['output']>;
  /** Indica se houve equipamento defeituoso */
  defectiveEquipment?: Maybe<Scalars['Boolean']['output']>;
  /** Indica se houve improvização */
  improvisation?: Maybe<Scalars['Boolean']['output']>;
  /** Identificador da investigação */
  investigationId?: Maybe<Scalars['String']['output']>;
  /** Indica se o funcionário conhecia as normas */
  knewNorms?: Maybe<Scalars['Boolean']['output']>;
  /** Nome da pessoa */
  name?: Maybe<Scalars['String']['output']>;
  /** Identificador da pessoa */
  personId?: Maybe<Scalars['String']['output']>;
  /** Sugestão da pessoa */
  personSuggestion?: Maybe<Scalars['String']['output']>;
  /** Foto de perfil */
  profilePicture?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** Relatório da investigação */
  report?: Maybe<Scalars['String']['output']>;
  /** Resumo do acidente */
  summary: Scalars['String']['output'];
  /** Indica se o funcionário foi treinado */
  trained?: Maybe<Scalars['Boolean']['output']>;
  /** Indica se o EPI foi utilizado */
  wasUsedEpi?: Maybe<Scalars['Boolean']['output']>;
};

export type TAccidentWitness = {
  __typename?: 'AccidentWitness';
  /** Acidente */
  accident: TAccident;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Pessoa testemunha */
  person: TPerson;
  /** Depoimento da testemunha */
  testimony?: Maybe<Scalars['String']['output']>;
};

export type TAccidentWitnessInput = {
  /** Identificador do acidente */
  accidentId: Scalars['String']['input'];
  /** Identificador da filial */
  branch?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
  /** Depoimento da testemunha */
  testimony?: InputMaybe<Scalars['String']['input']>;
};

export type TAccidentsPerDayChart = {
  __typename?: 'AccidentsPerDayChart';
  /** Dados */
  data: Array<Scalars['Float']['output']>;
  /** Indica se há acidentes registrados */
  hasAccident: Scalars['Boolean']['output'];
  /** Valor máximo dos dados */
  maxDataValue: Scalars['Float']['output'];
};

export type TAccidentsPerMonthChart = {
  __typename?: 'AccidentsPerMonthChart';
  /** Acidentes com óbito por mês */
  death: Array<TData>;
  /** Indica se há acidentes registrados */
  hasAccident: Scalars['Boolean']['output'];
  /** Acidentes com menos de 15 dias de afastamento por mês */
  lessThanFifteen: Array<TData>;
  /** Acidentes com mais de 15 dias de afastamento por mês */
  moreThanFifteen: Array<TData>;
  /** Acidentes sem vítimas por mês */
  noVictim: Array<TData>;
};

export type TAccidentsTimeChart = {
  __typename?: 'AccidentsTimeChart';
  /** Acidentes à tarde */
  afternoon: Array<TData>;
  /** Acidentes na madrugada */
  earlyMorning: Array<TData>;
  /** Acidentes à noite */
  evening: Array<TData>;
  /** Indica se há acidentes registrados */
  hasAccident: Scalars['Boolean']['output'];
  /** Acidentes pela manhã */
  morning: Array<TData>;
};

export type TAccredited = {
  __typename?: 'Accredited';
  /** Endereço */
  address?: Maybe<Scalars['String']['output']>;
  /** Filial */
  branch?: Maybe<Scalars['String']['output']>;
  /** Filial associada */
  branchRef?: Maybe<TBranchWithOptionalOrganization>;
  /** Cidade */
  city?: Maybe<Scalars['String']['output']>;
  /** CNPJ */
  cnpj?: Maybe<Scalars['String']['output']>;
  /** Data de término do contrato */
  contractEnd?: Maybe<Scalars['DateTime']['output']>;
  /** Data de início do contrato */
  contractStart: Scalars['DateTime']['output'];
  /** Criador do credenciamento */
  createdBy: TAccreditedCreator;
  /** Identificador no ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** Exames credenciados */
  exams?: Maybe<Array<TAccreditedExam>>;
  /** Identificador único do credenciado */
  id: Scalars['String']['output'];
  /** Indica se está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Nome do credenciado */
  name: Scalars['String']['output'];
  /** Bairro */
  neighborhood?: Maybe<Scalars['String']['output']>;
  /** Filial do prestador */
  providerBranch?: Maybe<Scalars['String']['output']>;
  /** Filial do prestador */
  providerBranchRef?: Maybe<TBranchWithOptionalOrganization>;
  /** Telefone */
  telephone?: Maybe<Scalars['String']['output']>;
};

export type TAccreditedBilling = {
  __typename?: 'AccreditedBilling';
  exam: Scalars['String']['output'];
  examCost: Scalars['Float']['output'];
  realized: Scalars['Float']['output'];
  realizedBillings: Scalars['Float']['output'];
  scheduled: Scalars['Float']['output'];
  scheduledBillings: Scalars['Float']['output'];
  subject: Scalars['String']['output'];
};

export type TAccreditedConsultation = {
  __typename?: 'AccreditedConsultation';
  consultationType: TConsultationType;
  examDescription?: Maybe<Scalars['String']['output']>;
  examId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  medicalRecordId?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['String']['output']>;
  patientName: Scalars['String']['output'];
  patientPicture?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  previewDate?: Maybe<Scalars['DateTime']['output']>;
};

/** Criador do credenciado */
export enum TAccreditedCreator {
  /** Contratante */
  Contractor = 'Contractor',
  /** Prestador de serviço */
  ServiceProvider = 'ServiceProvider'
}

export type TAccreditedExam = {
  __typename?: 'AccreditedExam';
  /** Data de término do contrato */
  contractEnd?: Maybe<Scalars['DateTime']['output']>;
  /** Data de início do contrato */
  contractStart?: Maybe<Scalars['DateTime']['output']>;
  /** Exame */
  exam: TExam;
  /** Identificador do exame */
  examId: Scalars['String']['output'];
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Preço do exame */
  price: Scalars['Float']['output'];
};

export type TAccreditedExamInput = {
  /** Data de término do contrato */
  contractEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de início do contrato */
  contractStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador do exame */
  examId: Scalars['String']['input'];
  /** Identificador único */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Preço do exame */
  price: Scalars['Float']['input'];
};

export type TAccreditedInput = {
  /** Endereço */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Filial */
  branch?: InputMaybe<Scalars['String']['input']>;
  /** Cidade */
  city?: InputMaybe<Scalars['String']['input']>;
  /** CNPJ */
  cnpj?: InputMaybe<Scalars['String']['input']>;
  /** Data de término do contrato */
  contractEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de início do contrato */
  contractStart: Scalars['DateTime']['input'];
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Exames credenciados */
  exams?: InputMaybe<Array<TAccreditedExamInput>>;
  /** Nome do credenciado */
  name: Scalars['String']['input'];
  /** Bairro */
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  /** Filial do prestador */
  providerBranch?: InputMaybe<Scalars['String']['input']>;
  /** Telefone */
  telephone?: InputMaybe<Scalars['String']['input']>;
};

export type TAccreditedReportsParameters = {
  __typename?: 'AccreditedReportsParameters';
  accreditedId?: Maybe<Scalars['String']['output']>;
  branches?: Maybe<Array<Scalars['String']['output']>>;
  costCenters?: Maybe<Array<Scalars['String']['output']>>;
  exams?: Maybe<Array<Scalars['String']['output']>>;
  fromDate: Scalars['String']['output'];
  natures?: Maybe<Array<TConsultationNature>>;
  occupations?: Maybe<Array<Scalars['String']['output']>>;
  showsLate: Scalars['Boolean']['output'];
  showsNonRealized: Scalars['Boolean']['output'];
  showsRealized: Scalars['Boolean']['output'];
  situations?: Maybe<Array<TEmployeeSituation>>;
  toDate: Scalars['String']['output'];
};

export type TAccreditedUpdate = {
  /** Endereço */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Filial */
  branch?: InputMaybe<Scalars['String']['input']>;
  /** Cidade */
  city?: InputMaybe<Scalars['String']['input']>;
  /** CNPJ */
  cnpj?: InputMaybe<Scalars['String']['input']>;
  /** Data de término do contrato */
  contractEnd?: InputMaybe<Scalars['DateTime']['input']>;
  contractStart?: InputMaybe<Scalars['DateTime']['input']>;
  exams?: InputMaybe<Array<TAccreditedExamInput>>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Bairro */
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  /** Filial do prestador */
  providerBranch?: InputMaybe<Scalars['String']['input']>;
  /** Telefone */
  telephone?: InputMaybe<Scalars['String']['input']>;
};

export type TAcknowledgmentFormReport = {
  __typename?: 'AcknowledgmentFormReport';
  /** Centro de custo */
  costCenter: Scalars['String']['output'];
  /** Data formatada */
  date: Scalars['String']['output'];
  /** Quantidade entregue */
  deliveryAmount: Scalars['String']['output'];
  /** Motivo da entrega */
  deliveryReason: Scalars['String']['output'];
  /** Rodapé do formulário */
  footer: Scalars['String']['output'];
  /** Descrição do IPE */
  ipeDescription: Scalars['String']['output'];
  /** Nome da pessoa */
  person: Scalars['String']['output'];
  /** Matrícula do funcionário */
  registration: Scalars['String']['output'];
};

export type TActionOnMeeting = {
  __typename?: 'ActionOnMeeting';
  /** Indica se está ativo */
  active: Scalars['Boolean']['output'];
  /** Data da ação */
  dateAction: Scalars['DateTime']['output'];
  /** Descrição */
  description: Scalars['String']['output'];
};

export type TActionOnMeetingInput = {
  /** Indica se está ativo */
  active: Scalars['Boolean']['input'];
  /** Data da ação */
  dateAction: Scalars['DateTime']['input'];
  /** Descrição */
  description: Scalars['String']['input'];
};

export type TActionOnMeetingRemove = {
  /** Data da ação */
  dateAction: Scalars['DateTime']['input'];
  /** Descrição */
  description: Scalars['String']['input'];
};

export type TActionOnMeetingUpdate = {
  /** Ações a serem criadas */
  toCreate: Array<TActionOnMeetingInput>;
  /** Ações a serem removidas */
  toRemove: Array<TActionOnMeetingRemove>;
  /** Ações a serem atualizadas */
  toUpdate: Array<TActionOnMeetingInput>;
};

export type TActionPlan = {
  __typename?: 'ActionPlan';
  /** Anexos */
  attachments?: Maybe<Array<TAttachment>>;
  /** Valor atual */
  currentValue: Scalars['Float']['output'];
  /** Data de término */
  dateEnd: Scalars['DateTime']['output'];
  /** Data de início */
  dateStart: Scalars['DateTime']['output'];
  /** Detecção */
  detection?: Maybe<Scalars['Float']['output']>;
  /** Custo esperado */
  expectedCost: Scalars['Float']['output'];
  /** Metas esperadas */
  expectedGoals?: Maybe<Array<TExpectedGoalOnActionPlan>>;
  /** Meta */
  goal: Scalars['Float']['output'];
  /** Como executar */
  how: Scalars['String']['output'];
  /** Identificador único do plano de ação */
  id: Scalars['String']['output'];
  /** Medida */
  measure: TMeasure;
  /** Tipo de medida */
  measureType: TMeasureType;
  /** Micro ações */
  microActions?: Maybe<Array<TActionPlanMicroAction>>;
  /** Observações */
  observation?: Maybe<Scalars['String']['output']>;
  /** Probabilidade */
  probability?: Maybe<Scalars['Float']['output']>;
  /** Custo real */
  realCost?: Maybe<Scalars['Float']['output']>;
  /** Metas reais */
  realGoals?: Maybe<Array<TRealGoalOnActionPlan>>;
  /** Responsáveis pela ação */
  responsiblesAction?: Maybe<Array<TResponsibleOnActionPlan>>;
  /** RPN (Número de Prioridade de Risco) */
  rpn?: Maybe<Scalars['Float']['output']>;
  /** Severidade */
  severity?: Maybe<Scalars['Float']['output']>;
  /** Situação */
  situation: TSituation;
  /** O que fazer */
  what: Scalars['String']['output'];
  /** Onde executar */
  where: Scalars['String']['output'];
  /** Por que executar */
  why: Scalars['String']['output'];
};

export type TActionPlanConclusionChart = {
  __typename?: 'ActionPlanConclusionChart';
  entries: Array<TActionPlanConclusionEntry>;
  hasData: Scalars['Boolean']['output'];
};

export type TActionPlanConclusionEntry = {
  __typename?: 'ActionPlanConclusionEntry';
  label: Scalars['String']['output'];
  result: Scalars['Float']['output'];
};

export type TActionPlanCount = {
  __typename?: 'ActionPlanCount';
  situationA: TSituationCount;
  situationB: TSituationCount;
  situationC: TSituationCount;
  situationD: TSituationCount;
};

export type TActionPlanDashboard = {
  __typename?: 'ActionPlanDashboard';
  actionStatus: TActionPlanStatusChart;
  conclusion: TActionPlanConclusionChart;
  measurements: TActionPlanMeasurementsChart;
  microActionsByResponsible: TActionPlanParetoChart;
  microActionsByStatus: TMicroActionStatusChart;
  plansByPriority: TActionPlanPriorityChart;
  plansByResponsible: TActionPlanParetoChart;
};

export type TActionPlanExpectedGoalInput = {
  /** Data da meta */
  date: Scalars['DateTime']['input'];
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Detalhes */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do responsável */
  responsibleId?: InputMaybe<Scalars['String']['input']>;
  /** Valor da meta */
  value: Scalars['Float']['input'];
};

export type TActionPlanExpectedGoalUpdate = {
  /** Metas esperadas a criar */
  toCreate: Array<TActionPlanExpectedGoalInput>;
  /** Datas das metas a remover */
  toRemove: Array<Scalars['DateTime']['input']>;
  /** Datas das metas a serem atualizadas */
  toUpdate: Array<TActionPlanExpectedGoalInput>;
};

export type TActionPlanFilter = {
  conclusion?: InputMaybe<TFloatRange>;
  endDates?: InputMaybe<TDateRange>;
  indicator?: InputMaybe<Array<Scalars['String']['input']>>;
  measureTypes?: InputMaybe<Array<TMeasureType>>;
  people?: InputMaybe<Array<Scalars['String']['input']>>;
  startDates?: InputMaybe<TDateRange>;
};

export type TActionPlanInput = {
  /** Valor atual */
  currentValue: Scalars['Float']['input'];
  /** Data de término */
  dateEnd: Scalars['DateTime']['input'];
  /** Data de início */
  dateStart: Scalars['DateTime']['input'];
  /** Detecção */
  detection?: InputMaybe<Scalars['Float']['input']>;
  /** Custo esperado */
  expectedCost: Scalars['Float']['input'];
  expectedGoals?: InputMaybe<Array<TActionPlanExpectedGoalInput>>;
  /** Meta */
  goal: Scalars['Float']['input'];
  /** Como executar */
  how: Scalars['String']['input'];
  investigationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Medida */
  measure: TMeasure;
  measureType: TMeasureType;
  microActions?: InputMaybe<Array<TActionPlanMicroActionInput>>;
  /** Observações */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Probabilidade */
  probability?: InputMaybe<Scalars['Float']['input']>;
  /** Custo real */
  realCost?: InputMaybe<Scalars['Float']['input']>;
  realGoals?: InputMaybe<Array<TActionPlanRealGoalInput>>;
  reportIds?: InputMaybe<Array<Scalars['String']['input']>>;
  responsiblesAction?: InputMaybe<Array<TActionPlanResponsibleInput>>;
  riskIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** RPN (Número de Prioridade de Risco) */
  rpn?: InputMaybe<Scalars['Float']['input']>;
  /** Severidade */
  severity?: InputMaybe<Scalars['Float']['input']>;
  situation?: InputMaybe<TSituation>;
  /** O que fazer */
  what: Scalars['String']['input'];
  /** Onde executar */
  where: Scalars['String']['input'];
  /** Por que executar */
  why: Scalars['String']['input'];
};

export type TActionPlanInvestigation = {
  __typename?: 'ActionPlanInvestigation';
  /** Identificador do plano de ação */
  actionPlanId: Scalars['String']['output'];
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Identificador da investigação */
  investigationId: Scalars['String']['output'];
};

export type TActionPlanInvestigationInput = {
  /** Identificador do plano de ação */
  actionPlanId: Scalars['String']['input'];
  /** Identificador da investigação */
  investigationId: Scalars['String']['input'];
};

export type TActionPlanInvestigationSuggestion = {
  __typename?: 'ActionPlanInvestigationSuggestion';
  /** Rótulo da sugestão */
  label: Scalars['String']['output'];
  /** Valor da sugestão */
  value: Scalars['String']['output'];
};

export type TActionPlanInvestigationUpdate = {
  /** Identificador do plano de ação */
  actionPlanId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Identificador da investigação */
  investigationId?: InputMaybe<Scalars['String']['input']>;
};

export type TActionPlanMeasurementEntry = {
  __typename?: 'ActionPlanMeasurementEntry';
  label: Scalars['String']['output'];
  planned: Scalars['Int']['output'];
  realized: Scalars['Int']['output'];
};

export type TActionPlanMeasurementsChart = {
  __typename?: 'ActionPlanMeasurementsChart';
  entries: Array<TActionPlanMeasurementEntry>;
  hasData: Scalars['Boolean']['output'];
};

export type TActionPlanMicroAction = {
  __typename?: 'ActionPlanMicroAction';
  /** Identificador do plano de ação */
  actionPlanId: Scalars['String']['output'];
  /** Data de início */
  date: Scalars['String']['output'];
  /** Data de término */
  dateEnd: Scalars['String']['output'];
  /** Descrição da microação */
  description: Scalars['String']['output'];
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Percentual de conclusão */
  percent: Scalars['Float']['output'];
  /** Responsável */
  personRef?: Maybe<TPerson>;
  /** Identificador do responsável */
  responsibleId?: Maybe<Scalars['String']['output']>;
  /** Status da microação */
  status: TMicroActionStatus;
};

export type TActionPlanMicroActionInput = {
  /** Identificador do plano de ação */
  actionPlanId: Scalars['String']['input'];
  /** Data de início */
  date: Scalars['String']['input'];
  /** Data de término */
  dateEnd: Scalars['String']['input'];
  /** Descrição da microação */
  description: Scalars['String']['input'];
  /** Identificador único */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Percentual de conclusão */
  percent: Scalars['Float']['input'];
  /** Identificador do responsável */
  responsibleId?: InputMaybe<Scalars['String']['input']>;
  /** Status da microação */
  status: TMicroActionStatus;
};

export type TActionPlanMicroActionUpdate = {
  /** Identificador do plano de ação */
  actionPlanId?: InputMaybe<Scalars['String']['input']>;
  /** Data de início */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Data de término */
  dateEnd?: InputMaybe<Scalars['String']['input']>;
  /** Descrição da microação */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Percentual de conclusão */
  percent?: InputMaybe<Scalars['Float']['input']>;
  /** Identificador do responsável */
  responsibleId?: InputMaybe<Scalars['String']['input']>;
  /** Status da microação */
  status?: InputMaybe<TMicroActionStatus>;
};

/** Campos de ordenação de planos de ação */
export enum TActionPlanOrderByFields {
  /** Conclusão */
  Conclusion = 'Conclusion',
  /** Data de início */
  DateStart = 'DateStart',
  /** RPN */
  Rpn = 'RPN',
  /** O que */
  What = 'What',
  /** Por que */
  Why = 'Why'
}

export type TActionPlanOrderByInput = {
  field?: InputMaybe<TActionPlanOrderByFields>;
  type?: InputMaybe<TOrderBy>;
};

export type TActionPlanParetoChart = {
  __typename?: 'ActionPlanParetoChart';
  entries: Array<TActionPlanParetoEntry>;
  hasData: Scalars['Boolean']['output'];
};

export type TActionPlanParetoEntry = {
  __typename?: 'ActionPlanParetoEntry';
  cumulativePercent: Scalars['Float']['output'];
  label: Scalars['String']['output'];
  result: Scalars['Int']['output'];
};

export type TActionPlanPriorityChart = {
  __typename?: 'ActionPlanPriorityChart';
  entries: Array<TActionPlanPriorityEntry>;
  hasData: Scalars['Boolean']['output'];
};

export type TActionPlanPriorityEntry = {
  __typename?: 'ActionPlanPriorityEntry';
  label: Scalars['String']['output'];
  result: Scalars['Int']['output'];
};

export type TActionPlanQueryInput = {
  filter?: InputMaybe<TActionPlanFilter>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TActionPlanRealGoalInput = {
  /** Data da meta */
  date: Scalars['DateTime']['input'];
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Detalhes */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do responsável */
  responsibleId?: InputMaybe<Scalars['String']['input']>;
  /** Valor alcançado na meta */
  value: Scalars['Float']['input'];
};

export type TActionPlanRealGoalUpdate = {
  /** Metas a serem criadas */
  toCreate: Array<TActionPlanRealGoalInput>;
  /** Datas das metas a serem removidas */
  toRemove: Array<Scalars['DateTime']['input']>;
  /** Datas das metas a serem atualizadas */
  toUpdate: Array<TActionPlanRealGoalInput>;
};

export type TActionPlanReport = {
  __typename?: 'ActionPlanReport';
  /** Identificador do plano de ação */
  actionPlanId: Scalars['String']['output'];
  /** Identificador do laudo ambiental */
  environmentalReportId: Scalars['String']['output'];
  /** Identificador único */
  id: Scalars['String']['output'];
};

export type TActionPlanReportInput = {
  /** Identificador do plano de ação */
  actionPlanId: Scalars['String']['input'];
  /** Identificador do laudo ambiental */
  environmentalReportId: Scalars['String']['input'];
};

export type TActionPlanReportSuggestion = {
  __typename?: 'ActionPlanReportSuggestion';
  /** Rótulo da sugestão */
  label: Scalars['String']['output'];
  /** Valor da sugestão */
  value: Scalars['String']['output'];
};

export type TActionPlanReportUpdate = {
  /** Identificador do plano de ação */
  actionPlanId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do laudo ambiental */
  environmentalReportId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
};

export type TActionPlanResponsibleInput = {
  /** ID da pessoa responsável */
  personId: Scalars['String']['input'];
};

export type TActionPlanResponsibleUpdate = {
  /** Responsáveis a serem adicionados */
  toCreate: Array<TActionPlanResponsibleInput>;
  /** IDs dos responsáveis a serem removidos */
  toRemove: Array<Scalars['String']['input']>;
};

export type TActionPlanSchedule = {
  __typename?: 'ActionPlanSchedule';
  executed: Array<Scalars['String']['output']>;
  planned: Array<Scalars['String']['output']>;
  what: Scalars['String']['output'];
};

export type TActionPlanStatusChart = {
  __typename?: 'ActionPlanStatusChart';
  entries: Array<TActionPlanStatusEntry>;
  hasData: Scalars['Boolean']['output'];
};

export type TActionPlanStatusEntry = {
  __typename?: 'ActionPlanStatusEntry';
  label: Scalars['String']['output'];
  result: Scalars['Int']['output'];
};

export type TActionPlanUpdate = {
  attachmentsToRemove?: InputMaybe<Array<Scalars['String']['input']>>;
  currentValue?: InputMaybe<Scalars['Float']['input']>;
  dateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  dateStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Detecção */
  detection?: InputMaybe<Scalars['Float']['input']>;
  expectedCost?: InputMaybe<Scalars['Float']['input']>;
  expectedGoals?: InputMaybe<TActionPlanExpectedGoalUpdate>;
  goal?: InputMaybe<Scalars['Float']['input']>;
  how?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  investigationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  measure?: InputMaybe<TMeasure>;
  measureType?: InputMaybe<TMeasureType>;
  microActions?: InputMaybe<Array<TActionPlanMicroActionInput>>;
  /** Observações */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Probabilidade */
  probability?: InputMaybe<Scalars['Float']['input']>;
  /** Custo real */
  realCost?: InputMaybe<Scalars['Float']['input']>;
  realGoals?: InputMaybe<TActionPlanRealGoalUpdate>;
  reportIds?: InputMaybe<Array<Scalars['String']['input']>>;
  responsiblesAction?: InputMaybe<Array<TActionPlanResponsibleInput>>;
  riskIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** RPN (Número de Prioridade de Risco) */
  rpn?: InputMaybe<Scalars['Float']['input']>;
  /** Severidade */
  severity?: InputMaybe<Scalars['Float']['input']>;
  situation?: InputMaybe<TSituation>;
  what?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['String']['input']>;
  why?: InputMaybe<Scalars['String']['input']>;
};

export type TActivityGroup = {
  __typename?: 'ActivityGroup';
  /** Código CIPA do grupo de atividades */
  cipaCode: Scalars['String']['output'];
  /** Código do grupo de atividades */
  code: Scalars['String']['output'];
  /** Descrição do grupo de atividades */
  description: Scalars['String']['output'];
  /** ID do grupo de atividades */
  id: Scalars['String']['output'];
  /** Grau de risco do grupo de atividades */
  riskDegree: Scalars['Float']['output'];
};

export type TActivityIcd = {
  __typename?: 'ActivityIcd';
  /** Atividade econômica */
  economicActivity: TEconomicActivity;
  /** Grupo CID final */
  icdGroupEnd: TIcdGroup;
  /** Grupo CID inicial */
  icdGroupStart: TIcdGroup;
  /** Identificador único */
  id: Scalars['String']['output'];
};

/** Tipo de atividade econômica */
export enum TActivityType {
  /** Alojamento e alimentação */
  AccommodationAndFood = 'AccommodationAndFood',
  /** Atividades administrativas e serviços complementares */
  AdministrativeAndComplementaryServices = 'AdministrativeAndComplementaryServices',
  /** Agricultura, pecuária, produção florestal, pesca e aquicultura */
  AgricultureLivestockForestryAndAquaculture = 'AgricultureLivestockForestryAndAquaculture',
  /** Artes, cultura, esporte e recreação */
  ArtsCultureSportAndRecreation = 'ArtsCultureSportAndRecreation',
  /** Construção */
  Construction = 'Construction',
  /** Serviços domésticos */
  DomesticServices = 'DomesticServices',
  /** Educação */
  Education = 'Education',
  /** Eletricidade e gás */
  ElectricityAndGas = 'ElectricityAndGas',
  /** Indústrias extrativas */
  ExtractiveIndustries = 'ExtractiveIndustries',
  /** Atividades financeiras, de seguros e serviços relacionados */
  FinancialAndInsurance = 'FinancialAndInsurance',
  /** Saúde humana e serviços sociais */
  HumanHealthAndSocialServices = 'HumanHealthAndSocialServices',
  /** Informação e comunicação */
  InformationAndCommunication = 'InformationAndCommunication',
  /** Organismos internacionais e outras instituições extraterritoriais */
  InternationalOrganizations = 'InternationalOrganizations',
  /** Indústrias de transformação */
  ManufacturingIndustries = 'ManufacturingIndustries',
  /** Comércio, reparação de veículos automotores e motocicletas */
  MotorVehiclesTradeAndRepair = 'MotorVehiclesTradeAndRepair',
  /** Outras atividades de serviços */
  OtherServices = 'OtherServices',
  /** Atividades profissionais, científicas e técnicas */
  ProfessionalScientificAndTechnical = 'ProfessionalScientificAndTechnical',
  /** Administração pública, defesa e seguridade social */
  PublicAdministrationDefenseAndSocialSecurity = 'PublicAdministrationDefenseAndSocialSecurity',
  /** Atividades imobiliárias */
  RealEstate = 'RealEstate',
  /** Transporte, armazenagem e correio */
  TransportStorageAndMail = 'TransportStorageAndMail',
  /** Água, esgoto, atividades de gestão de resíduos e descontaminação */
  WaterSewageWasteManagementAndDecontamination = 'WaterSewageWasteManagementAndDecontamination'
}

export type TAdditionalData = {
  __typename?: 'AdditionalData';
  /** Campo adicional */
  field: Scalars['String']['output'];
  /** Valor do campo */
  value: Scalars['String']['output'];
};

export type TAdditionalDataInput = {
  /** Campo adicional */
  field: Scalars['String']['input'];
  /** Valor do campo */
  value: Scalars['String']['input'];
};

export type TAgeAccidentChart = {
  __typename?: 'AgeAccidentChart';
  /** Dados de acidentes por idade */
  data: Array<TDivergingStackedBarChart>;
  /** Indica se há acidentes registrados */
  hasAccident: Scalars['Boolean']['output'];
};

export type TAgeChart = {
  __typename?: 'AgeChart';
  /** Dados */
  data: Array<Scalars['Float']['output']>;
  /** Nome */
  name: Scalars['String']['output'];
};

export type TAgeRange = {
  __typename?: 'AgeRange';
  /** Idade inicial */
  fromAge: Scalars['Float']['output'];
  /** Identificador */
  id: Scalars['String']['output'];
  /** Identificador do período periódico */
  periodicRangeId: Scalars['String']['output'];
  /** Periodicidade */
  periodicity: Scalars['Float']['output'];
  /** Idade final */
  toAge: Scalars['Float']['output'];
};

export type TAgeRangeEntry = {
  __typename?: 'AgeRangeEntry';
  /** Idade inicial */
  fromAge: Scalars['Float']['output'];
  /** Identificador */
  id?: Maybe<Scalars['String']['output']>;
  /** Periodicidade */
  periodicity: Scalars['Float']['output'];
  /** Idade final */
  toAge: Scalars['Float']['output'];
};

export type TAgeRangeInput = {
  /** Idade inicial */
  fromAge: Scalars['Float']['input'];
  /** Identificador */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Periodicidade */
  periodicity: Scalars['Float']['input'];
  /** Idade final */
  toAge: Scalars['Float']['input'];
};

/** Adicional do agente de risco */
export enum TAgentBonus {
  /** Não se aplica */
  NotTypify = 'NotTypify',
  /** Periculosidade */
  Dangerousness = 'dangerousness',
  /** Insalubridade */
  Unhealthiness = 'unhealthiness'
}

export type TAgentBonusChart = {
  __typename?: 'AgentBonusChart';
  /** Quantidade de adicional de 40% */
  forty: Scalars['Float']['output'];
  /** Indica se existem riscos */
  hasRisk: Scalars['Boolean']['output'];
  /** Quantidade não exposta */
  notExposed: Scalars['Float']['output'];
  /** Quantidade não tipificada */
  notTypify: Scalars['Float']['output'];
  /** Quantidade de adicional de 10% */
  ten: Scalars['Float']['output'];
  /** Quantidade de adicional de 30% */
  thirty: Scalars['Float']['output'];
  /** Quantidade de adicional de 20% */
  twenty: Scalars['Float']['output'];
};

/** Classificação do agente biológico */
export enum TAgentClassification {
  /** Bactéria */
  Bacteria = 'bacteria',
  /** Fungo */
  Fungus = 'fungus',
  /** Parasita */
  Parasites = 'parasites',
  /** Vírus */
  Virus = 'virus'
}

/** Tipo de avaliação do agente */
export enum TAgentEvaluation {
  /** Qualitativa */
  Qualitative = 'qualitative',
  /** Quantitativa */
  Quantitative = 'quantitative'
}

/** Grupo do agente de risco */
export enum TAgentGroup {
  /** Associação */
  Association = 'Association',
  /** Biológico */
  Biological = 'Biological',
  /** Químico */
  Chemical = 'Chemical',
  /** Perigosos */
  Dangerous = 'Dangerous',
  /** Ergonômico */
  Ergonomic = 'Ergonomic',
  /** Mecânico */
  Mechanical = 'Mechanical',
  /** Outros */
  Other = 'Other',
  /** Físico */
  Physical = 'Physical'
}

export type TAgentGroupChart = {
  __typename?: 'AgentGroupChart';
  /** Quantidade de riscos por associação */
  association: Scalars['Float']['output'];
  /** Quantidade de riscos biológicos */
  biological: Scalars['Float']['output'];
  /** Quantidade de riscos químicos */
  chemical: Scalars['Float']['output'];
  /** Quantidade de riscos perigosos */
  dangerous: Scalars['Float']['output'];
  /** Quantidade de riscos ergonômicos */
  ergonomic: Scalars['Float']['output'];
  /** Indica se existem riscos */
  hasRisk: Scalars['Boolean']['output'];
  /** Quantidade de riscos mecânicos */
  mechanical: Scalars['Float']['output'];
  /** Quantidade de outros riscos */
  other: Scalars['Float']['output'];
  /** Quantidade de riscos físicos */
  physical: Scalars['Float']['output'];
};

export type TAgreement = {
  __typename?: 'Agreement';
  createdAt: Scalars['DateTime']['output'];
  ipAddress: Scalars['String']['output'];
  terms: Scalars['String']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type TAllowanceType = {
  __typename?: 'AllowanceType';
  /** Descrição do tipo de adiantamento */
  description: Scalars['String']['output'];
  /** Identificador único do tipo de adiantamento */
  id: Scalars['String']['output'];
  /** Sugestão de uso */
  suggestion?: Maybe<Scalars['String']['output']>;
};

export type TAllowanceTypeInput = {
  /** Descrição do tipo de adiantamento */
  description: Scalars['String']['input'];
};

export type TAllowanceTypeIntegration = {
  /** Identificador da filial */
  branch: Scalars['String']['input'];
  /** Descrição do tipo de adiantamento */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único do tipo de adiantamento */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TAllowanceTypeUpdate = {
  /** Descrição do tipo de adiantamento */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único do tipo de adiantamento */
  id: Scalars['String']['input'];
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type TAnalysis = {
  __typename?: 'Analysis';
  /** Descrição */
  description: Scalars['String']['output'];
  /** Medida do exame */
  examMeasure?: Maybe<TExamMeasure>;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Referências */
  references?: Maybe<Array<TReferences>>;
};

export type TAnalysisInput = {
  /** Descrição */
  description: Scalars['String']['input'];
  /** Medida do exame */
  examMeasure?: InputMaybe<TExamMeasure>;
  /** Referências do exame */
  references?: InputMaybe<Array<TReferencesInput>>;
};

export type TAnalysisUpdate = {
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Medida do exame */
  examMeasure?: InputMaybe<TExamMeasure>;
  /** Identificador */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Referências do exame */
  references?: InputMaybe<Array<TReferencesUpdate>>;
};

export type TAnnualDeliveryVariationChart = {
  __typename?: 'AnnualDeliveryVariationChart';
  /** Quantidade de entregas nos últimos 12 meses */
  currentDeliveries: Scalars['Float']['output'];
  /** Pessoas distintas atendidas no período atual */
  currentPeople: Scalars['Float']['output'];
  /** Indica se há dados no período anterior */
  hasPrevious: Scalars['Boolean']['output'];
  /** Quantidade de entregas nos 12 meses anteriores */
  previousDeliveries: Scalars['Float']['output'];
  /** Pessoas distintas atendidas no período anterior */
  previousPeople: Scalars['Float']['output'];
  /** Variação percentual; nulo quando não há base de comparação */
  variationPct?: Maybe<Scalars['Float']['output']>;
};

export type TApiAccess = {
  __typename?: 'ApiAccess';
  /** Chave de acesso */
  accessKey: Scalars['String']['output'];
  /** Segredo de acesso */
  accessSecret?: Maybe<Scalars['String']['output']>;
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** ID do acesso à API */
  id: Scalars['String']['output'];
  /** Nome do acesso */
  name: Scalars['String']['output'];
};

export type TAsaasCreditCardToken = {
  __typename?: 'AsaasCreditCardToken';
  /** Código de segurança do cartão */
  ccv: Scalars['String']['output'];
  /** Mês de expiração */
  expiryMonth: Scalars['String']['output'];
  /** Ano de expiração */
  expiryYear: Scalars['String']['output'];
  /** Nome do titular */
  holderName: Scalars['String']['output'];
  /** Número do cartão */
  number: Scalars['String']['output'];
};

export type TAsaasCreditCardTokenInput = {
  /** Código de segurança do cartão */
  ccv: Scalars['String']['input'];
  /** Mês de expiração */
  expiryMonth: Scalars['String']['input'];
  /** Ano de expiração */
  expiryYear: Scalars['String']['input'];
  /** Nome do titular */
  holderName: Scalars['String']['input'];
  /** Número do cartão */
  number: Scalars['String']['input'];
};

export type TAsoEvolutionEntry = {
  __typename?: 'AsoEvolutionEntry';
  /** Data do ASO */
  date: Scalars['DateTime']['output'];
  /** Natureza do ASO */
  nature: Scalars['String']['output'];
  /** Aptidão */
  recommendation?: Maybe<Scalars['String']['output']>;
};

export type TAsoNatureChart = {
  __typename?: 'AsoNatureChart';
  /** Admissional */
  admission: Scalars['Float']['output'];
  /** Retorno ao trabalho */
  backToWork: Scalars['Float']['output'];
  /** Mudança de função */
  changeOfFunction: Scalars['Float']['output'];
  /** Demissional */
  dismissal: Scalars['Float']['output'];
  /** Possui ocupacional */
  hasOccupational: Scalars['Boolean']['output'];
  /** Periódico */
  periodic: Scalars['Float']['output'];
  /** Monitoramento pontual */
  spotMonitoring: Scalars['Float']['output'];
};

export type TAsoQuantityChart = {
  __typename?: 'AsoQuantityChart';
  /** Esperado */
  expected: Array<TData>;
  /** Possui ocupacional */
  hasOccupational: Scalars['Boolean']['output'];
  /** Realizado */
  realized: Array<TData>;
};

export type TAsoSituationChart = {
  __typename?: 'AsoSituationChart';
  /** Possui consulta */
  hasConsultation: Scalars['Boolean']['output'];
  /** Atrasado */
  late: Scalars['Float']['output'];
  /** A vencer */
  toExpire: Scalars['Float']['output'];
  /** Em dia */
  upToDate: Scalars['Float']['output'];
};

export type TAttachment = {
  __typename?: 'Attachment';
  /** Tamanho do anexo */
  contentLength: Scalars['Float']['output'];
  /** Tipo de conteúdo */
  contentType: Scalars['String']['output'];
  /** Data de criação do anexo */
  createdAt: Scalars['DateTime']['output'];
  /** Nome do arquivo */
  filename: Scalars['String']['output'];
  /** Identificador único do anexo */
  id: Scalars['String']['output'];
  /** Indica se o anexo é um documento assinado */
  isSignDocument?: Maybe<Scalars['Boolean']['output']>;
  /** URL de upload do anexo */
  uploadUrl?: Maybe<Scalars['String']['output']>;
  /** Usuário que fez o upload */
  uploadedBy: Scalars['String']['output'];
  /** URL do anexo */
  url: Scalars['S3UrlCloudFront']['output'];
};

export type TAttachmentAndThumbnailUpload = {
  contentLength: Scalars['Float']['input'];
  contentThumbLength?: InputMaybe<Scalars['Float']['input']>;
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  isTable?: InputMaybe<Scalars['Boolean']['input']>;
  thumbUpload?: InputMaybe<Scalars['Upload']['input']>;
  upload: Scalars['Upload']['input'];
};

export type TAttachmentDto = {
  __typename?: 'AttachmentDTO';
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** Mensagem de erro */
  error?: Maybe<Scalars['String']['output']>;
  /** ID do anexo */
  id: Scalars['String']['output'];
  /** Chave identificadora */
  key: Scalars['String']['output'];
  /** Mensagem */
  message: Scalars['String']['output'];
  /** ID da fila */
  queueId: Scalars['String']['output'];
  /** Status do processamento */
  status: TStatus;
  /** Data de atualização */
  updatedAt: Scalars['DateTime']['output'];
};

export type TAudiometryClassificationChart = {
  __typename?: 'AudiometryClassificationChart';
  /** Distribuição por classificação NR7 */
  data: Array<TPieChart>;
};

/** Classificação clínica da audiometria */
export enum TAudiometryClinicalEnum {
  /** Surdez leve */
  MildDeafness = 'MildDeafness',
  /** Surdez moderada */
  ModerateDeafness = 'ModerateDeafness',
  /** Normal */
  Normal = 'Normal',
  /** Surdez profunda */
  ProfoundDeafness = 'ProfoundDeafness',
  /** Surdez severa */
  SevereDeafness = 'SevereDeafness',
  /** Surdez total */
  TotalDeafness = 'TotalDeafness'
}

export type TAudiometryCostCenterChart = {
  __typename?: 'AudiometryCostCenterChart';
  /** Exames classificados por lotação */
  data: Array<TData>;
};

export type TAudiometryDashboard = {
  __typename?: 'AudiometryDashboard';
  /** Distribuição por classificação NR7 */
  classificationChart: TAudiometryClassificationChart;
  /** Exames classificados por lotação */
  costCenterChart: TAudiometryCostCenterChart;
  /** Evolução temporal de exames por classificação */
  evolutionChart: TAudiometryEvolutionChart;
  /** Possui dados no período */
  hasData: Scalars['Boolean']['output'];
  /** Proporção avaliados no PCA vs fora do PCA */
  pcaChart: TAudiometryPcaChart;
  /** Comparativo por ano (atual vs anterior) */
  yearComparisonChart: TAudiometryYearComparisonChart;
};

export type TAudiometryEvolutionChart = {
  __typename?: 'AudiometryEvolutionChart';
  /** Evolução mensal por classificação (ano atual) */
  data: Array<TLineChart>;
};

/** Classificação INSS da audiometria */
export enum TAudiometryInssEnum {
  /** Diminuição de grau médio */
  DecreaseMediumGrade = 'DecreaseMediumGrade',
  /** Diminuição de grau leve */
  DecreaseMildDegree = 'DecreaseMildDegree',
  /** Diminuição de grau mínimo */
  DecreaseMinimumDegree = 'DecreaseMinimumDegree',
  /** Perda auditiva */
  HearingLoss = 'HearingLoss',
  /** Diminuição de grau máximo */
  MaximumCraneReduction = 'MaximumCraneReduction',
  /** Normal */
  Normal = 'Normal'
}

/** Tipo de perda auditiva */
export enum TAudiometryLossTypeEnum {
  /** Central */
  Central = 'Central',
  /** Condutiva */
  Conductive = 'Conductive',
  /** Mista */
  Mixed = 'Mixed',
  /** Sensorioneural */
  Sensorioneural = 'Sensorioneural'
}

/** Classificação da audiometria segundo portaria */
export enum TAudiometryOrdinanceEnum {
  /** Limiares aceitáveis */
  AcceptableThresholds = 'AcceptableThresholds',
  /** Perda auditiva */
  HearingLoss = 'HearingLoss',
  /** Par não sugestivo */
  PairNonSuggestive = 'PairNonSuggestive',
  /** Par sugestivo */
  PairSuggestive = 'PairSuggestive',
  /** Requer interpretação */
  RequiresInterpretations = 'RequiresInterpretations',
  /** Sugestão de agravamento */
  SuggestionOfAggravation = 'SuggestionOfAggravation',
  /** Desencadeante sugestivo */
  SuggestiveTrigger = 'SuggestiveTrigger'
}

export type TAudiometryPcaChart = {
  __typename?: 'AudiometryPcaChart';
  /** Possui pessoas avaliadas no período */
  hasData: Scalars['Boolean']['output'];
  /** Pessoas avaliadas no PCA */
  inPca: Scalars['Float']['output'];
  /** Pessoas avaliadas fora do PCA */
  outPca: Scalars['Float']['output'];
};

export type TAudiometryYearComparisonChart = {
  __typename?: 'AudiometryYearComparisonChart';
  /** Rótulos das 7 categorias */
  categories: Array<Scalars['String']['output']>;
  /** Contagens do ano atual por categoria */
  currentYear: Array<Scalars['Float']['output']>;
  /** Ano atual */
  currentYearLabel: Scalars['String']['output'];
  /** Possui exames classificados no período */
  hasData: Scalars['Boolean']['output'];
  /** Contagens do ano anterior por categoria */
  previousYear: Array<Scalars['Float']['output']>;
  /** Ano anterior */
  previousYearLabel: Scalars['String']['output'];
};

/** Tipos de ação auditados (RF-1 do T2-06): CRUD, acesso, login/logout. */
export enum TAuditAction {
  AccessDenied = 'AccessDenied',
  Create = 'Create',
  Delete = 'Delete',
  Export = 'Export',
  Login = 'Login',
  Logout = 'Logout',
  Read = 'Read',
  Update = 'Update'
}

/** Formato de exportação dos logs de auditoria (CSV ou JSON). */
export enum TAuditExportFormat {
  Csv = 'Csv',
  Json = 'Json'
}

/** Status inicial da solicitação de exportação. */
export enum TAuditExportStatus {
  Queued = 'Queued'
}

export type TAuditLogChange = {
  __typename?: 'AuditLogChange';
  /** Nome do campo alterado */
  field: Scalars['String']['output'];
  /** Valor anterior (ou "***" se mascarado por política de PII) */
  from?: Maybe<Scalars['JSON']['output']>;
  /** Indica se o valor foi mascarado */
  masked?: Maybe<Scalars['Boolean']['output']>;
  /** Novo valor (ou "***" se mascarado por política de PII) */
  to?: Maybe<Scalars['JSON']['output']>;
};

export type TAuditLogDetailsDto = {
  __typename?: 'AuditLogDetailsDto';
  /** Diff campo-a-campo em updates */
  changes?: Maybe<Array<TAuditLogChange>>;
  /** Metadados adicionais */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Motivo opcional do evento */
  reason?: Maybe<Scalars['String']['output']>;
  /** Snapshot do registro em inserts e deletes */
  snapshot?: Maybe<Scalars['JSON']['output']>;
  /** Flag indicando soft delete */
  softDelete?: Maybe<Scalars['Boolean']['output']>;
};

export type TAuditLogEntry = {
  __typename?: 'AuditLogEntry';
  /** Tipo de ação */
  action: TAuditAction;
  /** Filial em que o evento ocorreu */
  branch?: Maybe<Scalars['String']['output']>;
  /** Entidade pai quando o evento faz parte de um cascade */
  cascadeParentId?: Maybe<Scalars['String']['output']>;
  /** Data em que o evento foi persistido */
  createdAt: Scalars['DateTime']['output'];
  /** Payload com snapshot/changes/metadata sanitizados */
  details?: Maybe<TAuditLogDetailsDto>;
  /** Identificador da entidade afetada */
  entityId?: Maybe<Scalars['String']['output']>;
  /** Tipo de entidade afetada */
  entityType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** IP de origem da requisição */
  ipAddress?: Maybe<Scalars['String']['output']>;
  /** Organização dona do registro */
  organizationId: Scalars['String']['output'];
  /** User-Agent da requisição */
  userAgent?: Maybe<Scalars['String']['output']>;
  /** Usuário que disparou a ação */
  userId?: Maybe<Scalars['String']['output']>;
};

export type TAuditLogExportRequest = {
  __typename?: 'AuditLogExportRequest';
  /** Formato solicitado */
  format: TAuditExportFormat;
  /** Email do solicitante — único destinatário autorizado a receber o link */
  recipientEmail: Scalars['String']['output'];
  /** Momento em que a solicitação foi enfileirada */
  requestedAt: Scalars['DateTime']['output'];
  /** Status imediato da solicitação — sempre "queued" em v1 */
  status: TAuditExportStatus;
};

export type TAuditLogQueryInput = {
  /** Filtrar por uma ou mais ações */
  actions?: InputMaybe<Array<TAuditAction>>;
  /** Filtrar por entidade específica */
  entityId?: InputMaybe<Scalars['String']['input']>;
  /** Filtrar por tipo de entidade */
  entityType?: InputMaybe<Scalars['String']['input']>;
  /** Data inicial (inclusiva) */
  from?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data final (inclusiva) */
  to?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtrar por usuário (id, nome ou e-mail) */
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Tipo de autenticação */
export enum TAuthType {
  /** Básica */
  Basic = 'Basic',
  /** Bearer */
  Bearer = 'Bearer',
  /** Chave */
  Key = 'Key',
  /** Token */
  Token = 'Token'
}

/** Tipo de autenticação TotvsSign */
export enum TAuthTypeTotvsSign {
  Login = 'Login',
  VerificationCode = 'VerificationCode'
}

export type TAvailabilityChart = {
  __typename?: 'AvailabilityChart';
  /** Dados */
  data: Array<TData>;
  /** Indica se existem entregas de IPE */
  hasIpeDeliveries: Scalars['Boolean']['output'];
};

export type TBaseAttachmentArgs = {
  contentLength: Scalars['Float']['input'];
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  upload: Scalars['Upload']['input'];
};

export type TBaseAttachmentToUploadArgs = {
  contentLength: Scalars['Float']['input'];
  contentThumbLength?: InputMaybe<Scalars['Float']['input']>;
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

export type TBaseDocumentResponse = {
  __typename?: 'BaseDocumentResponse';
  attachmentId: Scalars['String']['output'];
  certificateId: Scalars['String']['output'];
  documentId: Scalars['Int']['output'];
  isEmbedded?: Maybe<Scalars['Boolean']['output']>;
  pending?: Maybe<Array<TDocumentPending>>;
  status?: Maybe<TDocumentStatus>;
};

export type TBaseFeatureReturn = {
  __typename?: 'BaseFeatureReturn';
  removedFlags: Array<TFlag>;
  updatedFlags: Array<TFlag>;
};

export type TBaseFlagReturn = {
  __typename?: 'BaseFlagReturn';
  flags: Array<TFlag>;
};

export type TBaseInput = {
  /** CPF do funcionário */
  individualRegistration: Scalars['String']['input'];
  /** Identificador da organização */
  organizationId: Scalars['String']['input'];
  /** Senha */
  password: Scalars['String']['input'];
};

/** Nível de bilirrubina */
export enum TBilirubinEnum {
  /** Grande */
  Big = 'Big',
  /** Moderado */
  Moderate = 'Moderate',
  /** Negativo */
  Negative = 'Negative',
  /** Pequeno */
  Small = 'Small'
}

/** Método de cobrança */
export enum TBillingMethod {
  /** Asaas - Boleto bancário */
  AsaasBankSlip = 'AsaasBankSlip',
  /** Asaas - Cartão de crédito */
  AsaasCredit = 'AsaasCredit',
  /** Interno */
  Internal = 'Internal',
  /** PayPal */
  Paypal = 'Paypal'
}

export type TBiologicMonitoring = {
  __typename?: 'BiologicMonitoring';
  accidentDate: Array<Scalars['String']['output']>;
  addressCodePerson: Array<Scalars['String']['output']>;
  addressPerson: Scalars['String']['output'];
  age: Array<Scalars['String']['output']>;
  agent: Scalars['String']['output'];
  apron: Scalars['String']['output'];
  birthDate: Array<Scalars['String']['output']>;
  boot: Scalars['String']['output'];
  cepPerson: Array<Scalars['String']['output']>;
  circumstance: Scalars['String']['output'];
  cityAccident: Scalars['String']['output'];
  cityPerson: Scalars['String']['output'];
  codeLocal: Array<Scalars['String']['output']>;
  colorRace: Scalars['String']['output'];
  companyAddress: Scalars['String']['output'];
  companyCity: Scalars['String']['output'];
  companyCnae: Scalars['String']['output'];
  companyDistrict: Scalars['String']['output'];
  companyIbge: Array<Scalars['String']['output']>;
  companyInfo: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  companyNeighborhood: Scalars['String']['output'];
  companyNumber: Scalars['String']['output'];
  companyReference: Scalars['String']['output'];
  companyTelephone: Array<Scalars['String']['output']>;
  companyUf: Array<Scalars['String']['output']>;
  complementPerson: Scalars['String']['output'];
  conductAZT3TC: Scalars['String']['output'];
  conductAZT3TCIndinavir: Scalars['String']['output'];
  conductAZT3TCNelfinavir: Scalars['String']['output'];
  conductImunoglobulin: Scalars['String']['output'];
  conductNotIndication: Scalars['String']['output'];
  conductOther: Scalars['String']['output'];
  conductOtherDescription: Scalars['String']['output'];
  conductRefuse: Scalars['String']['output'];
  conductVaccine: Scalars['String']['output'];
  countryPerson: Scalars['String']['output'];
  deathDate: Array<Scalars['String']['output']>;
  districtPerson: Scalars['String']['output'];
  documentNumber: Array<Scalars['String']['output']>;
  educationLevel: Scalars['String']['output'];
  evolution: Scalars['String']['output'];
  examAntiHBc: Scalars['String']['output'];
  examAntiHCV: Scalars['String']['output'];
  examAntiHIV: Scalars['String']['output'];
  examHbsAg: Scalars['String']['output'];
  expositionComplement: Scalars['String']['output'];
  expositionIntactSkin: Scalars['String']['output'];
  expositionMucosa: Scalars['String']['output'];
  expositionNonIntactSkin: Scalars['String']['output'];
  expositionOther: Scalars['String']['output'];
  expositionPercutaneous: Scalars['String']['output'];
  facialProtection: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  geographicZonePerson: Scalars['String']['output'];
  geographicZonePersonTwo: Scalars['String']['output'];
  glasses: Scalars['String']['output'];
  gloves: Scalars['String']['output'];
  hasCat: Scalars['String']['output'];
  ibgeAccident: Array<Scalars['String']['output']>;
  ibgePerson: Array<Scalars['String']['output']>;
  icdCode: Scalars['String']['output'];
  localMedical: Scalars['String']['output'];
  mask: Scalars['String']['output'];
  materialComplement: Scalars['String']['output'];
  materialType: Scalars['String']['output'];
  mothersName: Scalars['String']['output'];
  neighborhoodPerson: Scalars['String']['output'];
  notificationDate: Array<Scalars['String']['output']>;
  numberPerson: Scalars['String']['output'];
  occupation: Scalars['String']['output'];
  occupationCode: Array<Scalars['String']['output']>;
  personName: Scalars['String']['output'];
  pregnant: Scalars['String']['output'];
  referencePerson: Scalars['String']['output'];
  source: Scalars['String']['output'];
  sourceExamAntiHBc: Scalars['String']['output'];
  sourceExamAntiHCV: Scalars['String']['output'];
  sourceExamAntiHIV: Scalars['String']['output'];
  sourceExamHbsAg: Scalars['String']['output'];
  susNumber: Array<Scalars['String']['output']>;
  telephonePerson: Array<Scalars['String']['output']>;
  timeWork: Array<Scalars['String']['output']>;
  ufAccident: Array<Scalars['String']['output']>;
  ufPerson: Array<Scalars['String']['output']>;
  vaccine: Scalars['String']['output'];
  zone: Scalars['String']['output'];
};

export type TBiologicalExams = {
  __typename?: 'BiologicalExams';
  firstConsultation: Scalars['String']['output'];
  secondConsultation: Scalars['String']['output'];
  zeroDate: Scalars['String']['output'];
};

/** Material biológico */
export enum TBiologicalMaterial {
  /** Sangue */
  Blood = 'Blood',
  /** Urina */
  Urine = 'Urine'
}

export type TBiologicalMonitoring = {
  __typename?: 'BiologicalMonitoring';
  /** Acidente */
  accident: TAccident;
  /** Credenciado */
  accredited?: Maybe<TAccredited>;
  /** Agente de monitoramento biológico */
  biologicalMonitoringAgent?: Maybe<TBiologicalMonitoringAgent>;
  /** Circunstância do acidente */
  circumstance?: Maybe<TAccidentCircumstance>;
  /** Condução complementar */
  complementaryConduction?: Maybe<Scalars['String']['output']>;
  /** Material complementar */
  complementaryMaterial?: Maybe<Scalars['String']['output']>;
  /** Tipo complementar */
  complementaryType?: Maybe<Scalars['String']['output']>;
  /** Condução do acidente */
  conduction?: Maybe<TAccidentConduction>;
  /** Tipo de exposição ao acidente */
  exposureType?: Maybe<TAccidentExposureType>;
  /** Indica se o exame foi finalizado */
  hasFinishedExam?: Maybe<Scalars['Boolean']['output']>;
  /** Grupo de exames de monitoramento */
  monitoringExamGroup?: Maybe<TBiologicalMonitoringExamGroup>;
  /** Material orgânico */
  organicMaterial?: Maybe<TOrganicMaterial>;
  /** Pessoa de origem */
  originPerson?: Maybe<TPerson>;
  /** Médico responsável */
  responsibleDoctor?: Maybe<TPerson>;
};

/** Agente causador do acidente com material biológico */
export enum TBiologicalMonitoringAgent {
  /** Lâmina/Lanceta */
  BladeLancet = 'BladeLancet',
  /** Agulha romba */
  BluntNeedle = 'BluntNeedle',
  /** Vidro */
  Glass = 'Glass',
  /** Intracath */
  Intracath = 'Intracath',
  /** Agulha com lúmen */
  NeedleWithLumen = 'NeedleWithLumen',
  /** Outros */
  Others = 'Others'
}

export type TBiologicalMonitoringCommon = {
  __typename?: 'BiologicalMonitoringCommon';
  accidentDate: Scalars['String']['output'];
  costCenter: Scalars['String']['output'];
  expositionType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  occupation: Scalars['String']['output'];
  workShift: Scalars['String']['output'];
};

export type TBiologicalMonitoringExam = {
  __typename?: 'BiologicalMonitoringExam';
  /** Exame */
  exam: TExam;
  /** Grupo de exames de monitoramento */
  group: TBiologicalMonitoringExamGroup;
  /** Identificador único do exame de monitoramento */
  id: Scalars['String']['output'];
  /** Identificador de referência */
  referenceId?: Maybe<Scalars['String']['output']>;
  /** Intervalo do segundo exame em dias */
  secondExamInterval: Scalars['Float']['output'];
  /** Intervalo do terceiro exame em dias */
  thirdExamInterval: Scalars['Float']['output'];
};

export type TBiologicalMonitoringExamGroup = {
  __typename?: 'BiologicalMonitoringExamGroup';
  /** Exames biológicos do grupo */
  biologicalExams?: Maybe<Array<TBiologicalMonitoringExam>>;
  /** Descrição do grupo de exames */
  description: Scalars['String']['output'];
  /** Identificador único do grupo de exames */
  id: Scalars['String']['output'];
  /** Identificador de referência */
  referenceId?: Maybe<Scalars['String']['output']>;
};

export type TBiologicalMonitoringExamGroupInput = {
  /** Exames biológicos do grupo */
  biologicalExams?: InputMaybe<Array<TBiologicalMonitoringExamInput>>;
  /** Descrição do grupo de exames */
  description: Scalars['String']['input'];
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type TBiologicalMonitoringExamGroupUpdate = {
  /** Exames biológicos do grupo */
  biologicalExams?: InputMaybe<Array<TBiologicalMonitoringExamInput>>;
  /** Descrição do grupo de exames */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único do grupo de exames */
  id: Scalars['String']['input'];
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type TBiologicalMonitoringExamInput = {
  /** Identificador do exame */
  examId: Scalars['String']['input'];
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Intervalo do segundo exame em dias */
  secondExamInterval: Scalars['Float']['input'];
  /** Intervalo do terceiro exame em dias */
  thirdExamInterval: Scalars['Float']['input'];
};

export type TBiologicalMonitoringInput = {
  /** Identificador do acidente */
  accidentId: Scalars['String']['input'];
  /** Agente de monitoramento biológico */
  biologicalMonitoringAgent?: InputMaybe<TBiologicalMonitoringAgent>;
  /** Circunstância do acidente */
  circumstance?: InputMaybe<TAccidentCircumstance>;
  /** Condução complementar */
  complementaryConduction?: InputMaybe<Scalars['String']['input']>;
  /** Material complementar */
  complementaryMaterial?: InputMaybe<Scalars['String']['input']>;
  /** Tipo complementar */
  complementaryType?: InputMaybe<Scalars['String']['input']>;
  /** Condução do acidente */
  conduction?: InputMaybe<TAccidentConduction>;
  /** Tipo de exposição ao acidente */
  exposureType?: InputMaybe<TAccidentExposureType>;
  /** Identificador do grupo de exames de monitoramento */
  monitoringExamGroupId: Scalars['String']['input'];
  /** Material orgânico */
  organicMaterial?: InputMaybe<TOrganicMaterial>;
  /** Identificador da pessoa de origem */
  originPersonId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do médico responsável */
  responsibleDoctorId?: InputMaybe<Scalars['String']['input']>;
};

export type TBiologicalMonitoringProtocol = {
  __typename?: 'BiologicalMonitoringProtocol';
  accidentDate: Scalars['String']['output'];
  costCenter: Scalars['String']['output'];
  exams?: Maybe<Array<TBiologicalMonitoringProtocolExams>>;
  expositionType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  occupation: Scalars['String']['output'];
  workShift: Scalars['String']['output'];
};

export type TBiologicalMonitoringProtocolExams = {
  __typename?: 'BiologicalMonitoringProtocolExams';
  exam: Scalars['String']['output'];
  result: Scalars['String']['output'];
};

export type TBiologicalMonitoringProtocolParams = {
  __typename?: 'BiologicalMonitoringProtocolParams';
  statementsResponsibility?: Maybe<Scalars['String']['output']>;
};

export type TBiologicalMonitoringReport = {
  __typename?: 'BiologicalMonitoringReport';
  accidentDate: Scalars['String']['output'];
  costCenter: Scalars['String']['output'];
  examDate: Scalars['String']['output'];
  examName: Scalars['String']['output'];
  expositionType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  occupation: Scalars['String']['output'];
  status: Scalars['String']['output'];
  workShift: Scalars['String']['output'];
};

export type TBiologicalMonitoringUpdate = {
  accidentId: Scalars['String']['input'];
  /** Agente de monitoramento biológico */
  biologicalMonitoringAgent?: InputMaybe<TBiologicalMonitoringAgent>;
  /** Circunstância do acidente */
  circumstance?: InputMaybe<TAccidentCircumstance>;
  /** Condução complementar */
  complementaryConduction?: InputMaybe<Scalars['String']['input']>;
  /** Material complementar */
  complementaryMaterial?: InputMaybe<Scalars['String']['input']>;
  /** Tipo complementar */
  complementaryType?: InputMaybe<Scalars['String']['input']>;
  /** Condução do acidente */
  conduction?: InputMaybe<TAccidentConduction>;
  /** Tipo de exposição ao acidente */
  exposureType?: InputMaybe<TAccidentExposureType>;
  monitoringExamGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Material orgânico */
  organicMaterial?: InputMaybe<TOrganicMaterial>;
  originPersonId?: InputMaybe<Scalars['String']['input']>;
  responsibleDoctorId?: InputMaybe<Scalars['String']['input']>;
};

export type TBiologicalProtocol = {
  __typename?: 'BiologicalProtocol';
  complement?: Maybe<Scalars['String']['output']>;
  costCenter: Scalars['String']['output'];
  exams: Array<TExamPerson>;
  exposition: Scalars['String']['output'];
  individualRegistration: Scalars['String']['output'];
  name: Scalars['String']['output'];
  occupation: Scalars['String']['output'];
  occurrenceDate: Scalars['String']['output'];
  registration: Scalars['String']['output'];
  source: Array<Scalars['String']['output']>;
  workShift: Scalars['String']['output'];
};

export type TBiologicalRelease = {
  __typename?: 'BiologicalRelease';
  accidentDate: Scalars['String']['output'];
  crm: Scalars['String']['output'];
  doctorName: Scalars['String']['output'];
  individualRegistration: Scalars['String']['output'];
  name: Scalars['String']['output'];
  releaseDate: Scalars['String']['output'];
  result: Scalars['String']['output'];
};

export type TBiometry = {
  __typename?: 'Biometry';
  /** Imagem BMP */
  bmp?: Maybe<Scalars['String']['output']>;
  /** Dedo */
  finger: TFingers;
  /** Mão */
  fingerHand: TFingerHand;
  /** Identificador único da biometria */
  id: Scalars['String']['output'];
  /** Dados da imagem */
  imageData: Scalars['String']['output'];
  /** DPI da imagem */
  imageDpi?: Maybe<Scalars['Float']['output']>;
  /** Altura da imagem */
  imageHeight?: Maybe<Scalars['Float']['output']>;
  /** Qualidade da imagem */
  imageQuality?: Maybe<Scalars['Float']['output']>;
  /** Largura da imagem */
  imageWidth?: Maybe<Scalars['Float']['output']>;
  /** Fabricante do equipamento */
  manufacturer: Scalars['String']['output'];
  /** Modelo do equipamento */
  model?: Maybe<Scalars['String']['output']>;
  /** NFIQ (NIST Fingerprint Image Quality) */
  nfiq?: Maybe<Scalars['Float']['output']>;
  /** Número de série */
  serialNumber?: Maybe<Scalars['String']['output']>;
  /** Template da biometria */
  template?: Maybe<Scalars['String']['output']>;
  /** Imagem WSQ */
  wsqImage?: Maybe<Scalars['String']['output']>;
  /** Tamanho da imagem WSQ */
  wsqImageSize?: Maybe<Scalars['Float']['output']>;
};

/** Tipo de verificação biométrica */
export enum TBiometryCheck {
  /** Prontuário médico */
  MedicalRecord = 'MedicalRecord',
  /** Pessoa */
  Person = 'Person',
  /** Usuário */
  User = 'User'
}

/** Equipamento de biometria */
export enum TBiometryEquipment {
  /** Control ID */
  ControlId = 'ControlId',
  /** Não se aplica */
  Na = 'Na',
  /** Nitgen */
  Nitgen = 'Nitgen',
  /** Sagem */
  Sagem = 'Sagem',
  /** Secugen */
  Secugen = 'Secugen',
  /** Suprema */
  Suprema = 'Suprema',
  /** ZKTeco 9 */
  ZkTeco9 = 'ZKTeco9',
  /** ZKTeco 10 */
  ZkTeco10 = 'ZKTeco10'
}

export type TBiometryInput = {
  /** Imagem BMP */
  bmp?: InputMaybe<Scalars['String']['input']>;
  /** Dedo */
  finger: TFingers;
  /** Mão */
  fingerHand: TFingerHand;
  /** Dados da imagem */
  imageData: Scalars['String']['input'];
  /** DPI da imagem */
  imageDpi?: InputMaybe<Scalars['Float']['input']>;
  /** Altura da imagem */
  imageHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Qualidade da imagem */
  imageQuality?: InputMaybe<Scalars['Float']['input']>;
  /** Largura da imagem */
  imageWidth?: InputMaybe<Scalars['Float']['input']>;
  /** Fabricante do equipamento */
  manufacturer: Scalars['String']['input'];
  /** Modelo do equipamento */
  model?: InputMaybe<Scalars['String']['input']>;
  /** NFIQ (NIST Fingerprint Image Quality) */
  nfiq?: InputMaybe<Scalars['Float']['input']>;
  /** Número de série */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Template da biometria */
  template?: InputMaybe<Scalars['String']['input']>;
  /** Imagem WSQ */
  wsqImage?: InputMaybe<Scalars['String']['input']>;
  /** Tamanho da imagem WSQ */
  wsqImageSize?: InputMaybe<Scalars['Float']['input']>;
};

export type TBiometryUpdate = {
  /** Imagem BMP */
  bmp?: InputMaybe<Scalars['String']['input']>;
  /** Dedo */
  finger: TFingers;
  /** Mão */
  fingerHand: TFingerHand;
  /** Identificador único da biometria */
  id: Scalars['String']['input'];
  /** Dados da imagem */
  imageData?: InputMaybe<Scalars['String']['input']>;
  /** DPI da imagem */
  imageDpi?: InputMaybe<Scalars['Float']['input']>;
  /** Altura da imagem */
  imageHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Qualidade da imagem */
  imageQuality?: InputMaybe<Scalars['Float']['input']>;
  /** Largura da imagem */
  imageWidth?: InputMaybe<Scalars['Float']['input']>;
  /** Fabricante do equipamento */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Modelo do equipamento */
  model?: InputMaybe<Scalars['String']['input']>;
  /** NFIQ (NIST Fingerprint Image Quality) */
  nfiq?: InputMaybe<Scalars['Float']['input']>;
  /** Número de série */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Template da biometria */
  template?: InputMaybe<Scalars['String']['input']>;
  /** Imagem WSQ */
  wsqImage?: InputMaybe<Scalars['String']['input']>;
  /** Tamanho da imagem WSQ */
  wsqImageSize?: InputMaybe<Scalars['Float']['input']>;
};

/** Tipo sanguíneo */
export enum TBloodType {
  /** AB- */
  AbNegative = 'ABNegative',
  /** AB+ */
  AbPositive = 'ABPositive',
  /** A- */
  ANegative = 'ANegative',
  /** A+ */
  APositive = 'APositive',
  /** B- */
  BNegative = 'BNegative',
  /** B+ */
  BPositive = 'BPositive',
  /** Não informado */
  Na = 'NA',
  /** O- */
  ONegative = 'ONegative',
  /** O+ */
  OPositive = 'OPositive'
}

export type TBloodTypeChart = {
  __typename?: 'BloodTypeChart';
  /** A- */
  aNegative: Scalars['Float']['output'];
  /** A+ */
  aPositive: Scalars['Float']['output'];
  /** AB- */
  abNegative: Scalars['Float']['output'];
  /** AB+ */
  abPositive: Scalars['Float']['output'];
  /** B- */
  bNegative: Scalars['Float']['output'];
  /** B+ */
  bPositive: Scalars['Float']['output'];
  /** Não informado */
  na: Scalars['Float']['output'];
  /** O- */
  oNegative: Scalars['Float']['output'];
  /** O+ */
  oPositive: Scalars['Float']['output'];
};

export type TBodyPart = {
  __typename?: 'BodyPart';
  /** Descrição da parte do corpo */
  description: Scalars['String']['output'];
  /** Código eSocial */
  eSocialCode: Scalars['String']['output'];
  /** Identificador único da parte do corpo */
  id: Scalars['String']['output'];
};

export type TBodyPartOnAccident = {
  __typename?: 'BodyPartOnAccident';
  /** Código eSocial */
  eSocialCode?: Maybe<Scalars['String']['output']>;
  /** É parte principal */
  isMain?: Maybe<Scalars['Boolean']['output']>;
  /** Lateralidade */
  laterality?: Maybe<TLaterality>;
};

export type TBodyPartOnAccidentInput = {
  /** Código eSocial */
  eSocialCode: Scalars['String']['input'];
  /** É parte principal */
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  /** Lateralidade */
  laterality?: InputMaybe<TLaterality>;
};

export type TBranch = {
  __typename?: 'Branch';
  /** Tipo de atividade */
  activityType?: Maybe<TActivityType>;
  /** Equipamento de biometria */
  biometryEquipment?: Maybe<TBiometryEquipment>;
  /** Cidade */
  city?: Maybe<Scalars['String']['output']>;
  /** País */
  country?: Maybe<Scalars['String']['output']>;
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** Tarefas agendadas */
  crons?: Maybe<Array<TCronTab>>;
  /** Data de exclusão */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Número do documento (CNPJ) */
  documentNumber?: Maybe<Scalars['String']['output']>;
  /** Atividade econômica */
  economicActivity?: Maybe<TEconomicActivity>;
  /** ID da atividade econômica */
  economicActivityId?: Maybe<Scalars['String']['output']>;
  /** E-mail da filial */
  email?: Maybe<Scalars['String']['output']>;
  /** Endpoints configurados */
  endpoints: Array<TEndpoint>;
  /** Documento ambiental */
  environmentDocument?: Maybe<Scalars['String']['output']>;
  /** Data de envio eSocial */
  esocialSendDate?: Maybe<Scalars['DateTime']['output']>;
  /** Data final de envio eSocial */
  esocialSendDateEnd?: Maybe<Scalars['DateTime']['output']>;
  /** ID da filial */
  id: Scalars['String']['output'];
  /** Logo da filial */
  logoUrl?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** Nome da filial */
  name: Scalars['String']['output'];
  /** Bairro */
  neighborhood?: Maybe<Scalars['String']['output']>;
  /** Número */
  number?: Maybe<Scalars['String']['output']>;
  /** ID da organização */
  organizationId: Scalars['String']['output'];
  /** Número de telefone */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Configurações da filial */
  settings?: Maybe<TSettings>;
  /** Estado */
  state?: Maybe<Scalars['String']['output']>;
  /** Rua */
  street?: Maybe<Scalars['String']['output']>;
  /** Fuso horário */
  timeZone?: Maybe<Scalars['String']['output']>;
  /** Data de atualização */
  updatedAt: Scalars['DateTime']['output'];
  /** CEP */
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type TBranchCreationInput = {
  /** Tipo de atividade */
  activityType?: InputMaybe<TActivityType>;
  /** Equipamento de biometria */
  biometryEquipment?: InputMaybe<TBiometryEquipment>;
  /** Cidade */
  city?: InputMaybe<Scalars['String']['input']>;
  /** País */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Número do documento (CNPJ) */
  documentNumber: Scalars['String']['input'];
  /** ID da atividade econômica */
  economicActivityId?: InputMaybe<Scalars['String']['input']>;
  /** E-mail da filial */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Endpoints a serem configurados */
  endpoints?: InputMaybe<Array<TEndpointInput>>;
  /** Documento ambiental */
  environmentDocument?: InputMaybe<Scalars['String']['input']>;
  /** Data final de envio eSocial */
  esocialSendDateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Nome da filial */
  name: Scalars['String']['input'];
  /** Bairro */
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  /** Número */
  number?: InputMaybe<Scalars['String']['input']>;
  /** Número de telefone */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Configurações da filial */
  settings?: InputMaybe<TSettingsInput>;
  /** Estado */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Rua */
  street?: InputMaybe<Scalars['String']['input']>;
  /** Fuso horário */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  /** CEP */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type TBranchInput = {
  /** Tipo de atividade */
  activityType?: InputMaybe<TActivityType>;
  /** Equipamento de biometria */
  biometryEquipment?: InputMaybe<TBiometryEquipment>;
  /** Cidade */
  city?: InputMaybe<Scalars['String']['input']>;
  /** País */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Número do documento (CNPJ) */
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  /** ID da atividade econômica */
  economicActivityId?: InputMaybe<Scalars['String']['input']>;
  /** E-mail da filial */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Endpoints a serem configurados */
  endpoints?: InputMaybe<Array<TEndpointInput>>;
  /** Documento ambiental */
  environmentDocument?: InputMaybe<Scalars['String']['input']>;
  /** Data final de envio eSocial */
  esocialSendDateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Nome da filial */
  name: Scalars['String']['input'];
  /** Bairro */
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  /** Número */
  number?: InputMaybe<Scalars['String']['input']>;
  /** Número de telefone */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Configurações da filial */
  settings?: InputMaybe<TSettingsInput>;
  /** Estado */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Rua */
  street?: InputMaybe<Scalars['String']['input']>;
  /** Fuso horário */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  /** CEP */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type TBranchTtalkInfo = {
  __typename?: 'BranchTtalkInfo';
  /** ID da filial */
  branchId: Scalars['String']['output'];
  /** Nome da filial */
  branchName: Scalars['String']['output'];
  /** Tem endpoint TTalk configurado */
  hasActiveTtalkEndpoint: Scalars['Boolean']['output'];
};

export type TBranchUpdateInput = {
  /** Tipo de atividade */
  activityType?: InputMaybe<TActivityType>;
  /** Equipamento de biometria */
  biometryEquipment?: InputMaybe<TBiometryEquipment>;
  /** Cidade */
  city?: InputMaybe<Scalars['String']['input']>;
  /** País */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Número do documento (CNPJ) */
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  /** ID da atividade econômica */
  economicActivityId?: InputMaybe<Scalars['String']['input']>;
  /** E-mail da filial */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Endpoints a serem configurados */
  endpoints?: InputMaybe<Array<TEndpointInput>>;
  /** Documento ambiental */
  environmentDocument?: InputMaybe<Scalars['String']['input']>;
  /** Data final de envio eSocial */
  esocialSendDateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID da filial */
  id: Scalars['String']['input'];
  /** Nome da filial */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Bairro */
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  /** Número */
  number?: InputMaybe<Scalars['String']['input']>;
  /** Número de telefone */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Configurações da filial */
  settings?: InputMaybe<TSettingsInput>;
  /** Estado */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Rua */
  street?: InputMaybe<Scalars['String']['input']>;
  /** Fuso horário */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  /** CEP */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type TBranchWithOptionalOrganization = {
  __typename?: 'BranchWithOptionalOrganization';
  /** Tipo de atividade */
  activityType?: Maybe<TActivityType>;
  /** Equipamento de biometria */
  biometryEquipment?: Maybe<TBiometryEquipment>;
  /** Cidade */
  city?: Maybe<Scalars['String']['output']>;
  /** País */
  country?: Maybe<Scalars['String']['output']>;
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** Tarefas agendadas */
  crons?: Maybe<Array<TCronTab>>;
  /** Data de exclusão */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Número do documento (CNPJ) */
  documentNumber?: Maybe<Scalars['String']['output']>;
  /** Atividade econômica */
  economicActivity?: Maybe<TEconomicActivity>;
  /** ID da atividade econômica */
  economicActivityId?: Maybe<Scalars['String']['output']>;
  /** E-mail da filial */
  email?: Maybe<Scalars['String']['output']>;
  /** Endpoints configurados */
  endpoints: Array<TEndpoint>;
  /** Documento ambiental */
  environmentDocument?: Maybe<Scalars['String']['output']>;
  /** Data de envio eSocial */
  esocialSendDate?: Maybe<Scalars['DateTime']['output']>;
  /** Data final de envio eSocial */
  esocialSendDateEnd?: Maybe<Scalars['DateTime']['output']>;
  /** ID da filial */
  id: Scalars['String']['output'];
  /** Logo da filial */
  logoUrl?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** Nome da filial */
  name: Scalars['String']['output'];
  /** Bairro */
  neighborhood?: Maybe<Scalars['String']['output']>;
  /** Número */
  number?: Maybe<Scalars['String']['output']>;
  /** Organização da filial */
  organization?: Maybe<TOrganization>;
  /** ID da organização */
  organizationId: Scalars['String']['output'];
  /** Número de telefone */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Configurações da filial */
  settings?: Maybe<TSettings>;
  /** Estado */
  state?: Maybe<Scalars['String']['output']>;
  /** Rua */
  street?: Maybe<Scalars['String']['output']>;
  /** Fuso horário */
  timeZone?: Maybe<Scalars['String']['output']>;
  /** Data de atualização */
  updatedAt: Scalars['DateTime']['output'];
  /** CEP */
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type TBranchWithOrganization = {
  __typename?: 'BranchWithOrganization';
  /** Tipo de atividade */
  activityType?: Maybe<TActivityType>;
  /** Equipamento de biometria */
  biometryEquipment?: Maybe<TBiometryEquipment>;
  /** Cidade */
  city?: Maybe<Scalars['String']['output']>;
  /** País */
  country?: Maybe<Scalars['String']['output']>;
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** Tarefas agendadas */
  crons?: Maybe<Array<TCronTab>>;
  /** Data de exclusão */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Número do documento (CNPJ) */
  documentNumber?: Maybe<Scalars['String']['output']>;
  /** Atividade econômica */
  economicActivity?: Maybe<TEconomicActivity>;
  /** ID da atividade econômica */
  economicActivityId?: Maybe<Scalars['String']['output']>;
  /** E-mail da filial */
  email?: Maybe<Scalars['String']['output']>;
  /** Endpoints configurados */
  endpoints: Array<TEndpoint>;
  /** Documento ambiental */
  environmentDocument?: Maybe<Scalars['String']['output']>;
  /** Data de envio eSocial */
  esocialSendDate?: Maybe<Scalars['DateTime']['output']>;
  /** Data final de envio eSocial */
  esocialSendDateEnd?: Maybe<Scalars['DateTime']['output']>;
  /** ID da filial */
  id: Scalars['String']['output'];
  /** Logo da filial */
  logoUrl?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** Nome da filial */
  name: Scalars['String']['output'];
  /** Bairro */
  neighborhood?: Maybe<Scalars['String']['output']>;
  /** Número */
  number?: Maybe<Scalars['String']['output']>;
  /** Organização da filial */
  organization: TOrganization;
  /** ID da organização */
  organizationId: Scalars['String']['output'];
  /** Número de telefone */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Configurações da filial */
  settings?: Maybe<TSettings>;
  /** Estado */
  state?: Maybe<Scalars['String']['output']>;
  /** Rua */
  street?: Maybe<Scalars['String']['output']>;
  /** Fuso horário */
  timeZone?: Maybe<Scalars['String']['output']>;
  /** Data de atualização */
  updatedAt: Scalars['DateTime']['output'];
  /** CEP */
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type TBulkSyncRun = {
  __typename?: 'BulkSyncRun';
  /** Criação */
  createdAt: Scalars['DateTime']['output'];
  /** Término do run (null enquanto running) */
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID do run (UUID) */
  id: Scalars['String']['output'];
  /** Último heartbeat (para recovery) */
  lastHeartbeatAt?: Maybe<Scalars['DateTime']['output']>;
  /** Organização do bulk */
  organization: Scalars['String']['output'];
  /** Início do run */
  startedAt: Scalars['DateTime']['output'];
  /** Usuário que disparou */
  startedByUser: Scalars['String']['output'];
  /** Status atual */
  status: TBulkSyncRunStatus;
  /** Snapshot do progresso por filial × entidade (JSON serializado). Schema: BulkSyncSummary em models/mdt/bulk-sync-run.ts */
  summary?: Maybe<Scalars['String']['output']>;
  /** Total de filiais no escopo */
  totalBranches: Scalars['Int']['output'];
  /** Total de entidades por filial (7 fixo) */
  totalEntities: Scalars['Int']['output'];
  /** Atualização */
  updatedAt: Scalars['DateTime']['output'];
};

/** Estado de uma execução de sincronização global Phase 1 */
export enum TBulkSyncRunStatus {
  /** Abortado por recovery (heartbeat sem atualização > 10 min) */
  Aborted = 'Aborted',
  /** Todas as filiais sincronizadas com sucesso */
  Completed = 'Completed',
  /** Uma ou mais filiais não concluíram completamente */
  PartialFailed = 'PartialFailed',
  /** Em execução; ocupa o slot da org */
  Running = 'Running'
}

/** Entidade de negócio */
export enum TBusinessEntity {
  /** Tipo de ausência */
  AbsenceType = 'AbsenceType',
  /** Tipo de subsídio */
  AllowanceType = 'AllowanceType',
  /** Centro de custo */
  CostCenter = 'CostCenter',
  /** Superior imediato */
  EmployeesManager = 'EmployeesManager',
  /** Item */
  Item = 'Item',
  /** Ocupação */
  Occupation = 'Occupation',
  /** Tipo de estabilidade */
  StabilityType = 'StabilityType',
  /** Nível de estoque */
  StockLevel = 'StockLevel',
  /** Treinamento */
  Training = 'Training',
  /** Unidade de medida */
  UnityOfMeasure = 'UnityOfMeasure',
  /** Almoxarifado */
  Warehouse = 'Warehouse',
  /** Turno de trabalho */
  WorkShift = 'WorkShift'
}

export type TCaInUseChart = {
  __typename?: 'CaInUseChart';
  /** Indica se existem entregas de IPE */
  hasIpeDeliveries: Scalars['Boolean']['output'];
  /** Quantidade de CAs vencidos */
  overdue: Scalars['Float']['output'];
  /** Quantidade de CAs a vencer */
  toExpire: Scalars['Float']['output'];
  /** Quantidade de CAs válidos */
  valid: Scalars['Float']['output'];
};

/** Situação do CA (Certificado de Aprovação) */
export enum TCaSituation {
  /** Vencido */
  Overdue = 'Overdue',
  /** Válido */
  Valid = 'Valid'
}

export type TCalendar = {
  __typename?: 'Calendar';
  calendarWorkShifts: Array<TCalendarWorkShift>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type TCalendarInput = {
  calendarWorkShifts: Array<TCalendarWorkShiftInput>;
  name: Scalars['String']['input'];
};

export type TCalendarUpdate = {
  /** Turnos do calendário */
  calendarWorkShifts?: InputMaybe<Array<TCalendarWorkShiftInput>>;
  /** Identificador único do calendário */
  id: Scalars['String']['input'];
  /** Indica se está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Nome do calendário */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TCalendarWorkShift = {
  __typename?: 'CalendarWorkShift';
  calendarId: Scalars['String']['output'];
  end: TTimePoint;
  id: Scalars['String']['output'];
  start: TTimePoint;
};

export type TCalendarWorkShiftEntry = {
  __typename?: 'CalendarWorkShiftEntry';
  end: TTimePoint;
  start: TTimePoint;
};

export type TCalendarWorkShiftInput = {
  end: TTimePointInput;
  start: TTimePointInput;
};

export type TCandidate = {
  __typename?: 'Candidate';
  /** Erro de integração */
  errorIntegration?: Maybe<Scalars['String']['output']>;
  /** Identificador único do candidato */
  id: Scalars['String']['output'];
  /** Indica se está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Mandato */
  mandate: TMandate;
  /** Pessoa */
  person: TPerson;
  /** Motivo */
  reason?: Maybe<Scalars['String']['output']>;
  /** Tipo de estabilidade */
  stabilityType?: Maybe<TStabilityType>;
};

export type TCandidateByMandate = {
  __typename?: 'CandidateByMandate';
  /** Erro de integração com o ERP */
  errorIntegration?: Maybe<Scalars['String']['output']>;
  /** Identificador único do candidato */
  id: Scalars['String']['output'];
  /** Indica se está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Identificador do mandato */
  mandateId: Scalars['String']['output'];
  /** Pessoa candidata */
  person: TPersonByMandate;
  /** Motivo */
  reason?: Maybe<Scalars['String']['output']>;
  /** Tipo de estabilidade */
  stabilityType?: Maybe<TStabilityType>;
  /** Número de votos */
  votes: Scalars['Float']['output'];
};

export type TCandidateInput = {
  /** Indica se está ativo */
  isActive: Scalars['Boolean']['input'];
  /** Identificador do mandato */
  mandateId: Scalars['String']['input'];
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
  /** Identificador do tipo de estabilidade */
  stabilityId?: InputMaybe<Scalars['String']['input']>;
};

export type TCandidateUpdate = {
  /** Identificador único do candidato */
  id: Scalars['String']['input'];
  /** Indica se está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador do mandato */
  mandateId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da pessoa */
  personId?: InputMaybe<Scalars['String']['input']>;
  /** Motivo */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do tipo de estabilidade */
  stabilityId?: InputMaybe<Scalars['String']['input']>;
};

export type TCategoriesChart = {
  __typename?: 'CategoriesChart';
  /** Proteção respiratória */
  breathProtection: Scalars['Float']['output'];
  /** Proteção para olhos e face */
  eyeFaceProtection: Scalars['Float']['output'];
  /** Proteção contra quedas */
  fallProtection: Scalars['Float']['output'];
  /** Proteção para o corpo inteiro */
  fullBodyProtection: Scalars['Float']['output'];
  /** Indica se existem entregas de IPE */
  hasIpeDeliveries: Scalars['Boolean']['output'];
  /** Proteção para a cabeça */
  headProtection: Scalars['Float']['output'];
  /** Proteção auditiva */
  hearingProtection: Scalars['Float']['output'];
  /** Proteção para membros inferiores */
  lowerLimbProtection: Scalars['Float']['output'];
  /** Outras categorias */
  other: Scalars['Float']['output'];
  /** Proteção para o tronco */
  trunkProtection: Scalars['Float']['output'];
  /** Proteção para membros superiores */
  upperLimbProtection: Scalars['Float']['output'];
};

export type TCategorizedInputData = {
  __typename?: 'CategorizedInputData';
  /** Nome da categoria */
  name: Scalars['String']['output'];
  /** Opções disponíveis */
  options: Array<TInputData>;
};

/** Tipo de causa de acidente */
export enum TCauseType {
  /** Ato inseguro */
  InsecureAct = 'InsecureAct',
  /** Condição insegura */
  UnsafeCondition = 'UnsafeCondition'
}

export type TCauserAgent = {
  __typename?: 'CauserAgent';
  /** Acidente */
  accident: TAccident;
  /** Objeto do acidente */
  accidentObject: TAccidentObject;
  /** Identificador único do agente causador */
  id: Scalars['String']['output'];
};

export type TCauserAgentInput = {
  /** Identificador do acidente */
  accidentId: Scalars['String']['input'];
  /** Identificador do objeto do acidente */
  accidentObjectId: Scalars['String']['input'];
  /** Identificador da filial */
  branch: Scalars['String']['input'];
};

export type TCauserAgentOnAccident = {
  __typename?: 'CauserAgentOnAccident';
  /** Objeto do acidente */
  accidentObject: TAccidentObject;
  /** Identificador único do agente causador */
  id: Scalars['String']['output'];
  /** Indica se é o principal */
  isMain?: Maybe<Scalars['Boolean']['output']>;
};

export type TCauserAgentOnAccidentInput = {
  /** Identificador do objeto do acidente */
  accidentObjectId: Scalars['String']['input'];
  /** Indica se é o principal */
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TCauserAgentOnAccidentUpdate = {
  /** Agentes causadores a criar */
  toCreate: Array<TCauserAgentOnAccidentInput>;
  /** IDs dos agentes a remover */
  toRemove: Array<Scalars['String']['input']>;
};

export type TCauses = {
  __typename?: 'Causes';
  /** Quantidade de casos com equipamento defeituoso */
  defectiveEquipment: Scalars['Float']['output'];
  /** Quantidade de casos com improvização */
  improvisation: Scalars['Float']['output'];
  /** Quantidade de casos com conhecimento das normas */
  knewNorms: Scalars['Float']['output'];
  /** Quantidade de casos com treinamento */
  trained: Scalars['Float']['output'];
  /** Quantidade de casos com uso de EPI */
  wasUsedEpi: Scalars['Float']['output'];
};

/** Origem do atestado */
export enum TCertificateOrigin {
  /** Externo */
  External = 'External',
  /** Interno */
  Internal = 'Internal'
}

export type TCertificatePerDayChart = {
  __typename?: 'CertificatePerDayChart';
  /** Dados */
  data: Array<Scalars['Float']['output']>;
  /** Possui atestado */
  hasCertificate: Scalars['Boolean']['output'];
  /** Valor máximo dos dados */
  maxDataValue: Scalars['Float']['output'];
};

/** Tipo de certificado */
export enum TCertificateType {
  /** Atestado */
  Certificate = 'Certificate',
  /** Declaração */
  Declaration = 'Declaration',
  /** Aposentadoria por invalidez */
  DisabilityRetirement = 'DisabilityRetirement',
  /** Licença maternidade */
  MaternityLeave = 'MaternityLeave'
}

export type TCertificatesRankingDashboard = {
  __typename?: 'CertificatesRankingDashboard';
  /** Ranking de empregados */
  employeeRanking: Array<TRanking>;
  /** Ranking de ocupações */
  occupationRanking: Array<TRanking>;
};

export type TChangeStatusPreMedicalCertificateInput = {
  /** Identificador */
  id: Scalars['String']['input'];
  /** Detalhes da rejeição */
  rejectionDetails?: InputMaybe<Scalars['String']['input']>;
  /** Motivo da rejeição */
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  /** Situação */
  status: TPreMedicalCertificateStatus;
};

export type TChartData = {
  __typename?: 'ChartData';
  /** Dados de contagem de atestados */
  certificateCountData: Array<TData>;
  /** Dias por HC */
  daysPerHC: Array<TData>;
  /** Possui atestado */
  hasCertificate: Scalars['Boolean']['output'];
  /** Dados de dias perdidos */
  lostDayData: Array<TData>;
  /** Dados de contagem de pessoas */
  peopleCountData: Array<TData>;
};

export type TCheckTableData = {
  __typename?: 'CheckTableData';
  /** Entidade verificada */
  entity: TCsvImports;
  /** Indica se possui dados */
  hasData: Scalars['Boolean']['output'];
};

export type TChecklist = {
  __typename?: 'Checklist';
  /** Questionários clínicos (anamneses) */
  clinicalQuizzes?: Maybe<Array<TClinicalQuiz>>;
  /** Questionários de centro de custo */
  costCenters?: Maybe<Array<TQuizCostCenter>>;
  /** Questionários de departamento */
  departments?: Maybe<Array<TQuizDepartment>>;
  /** Questionários de fonte geradora */
  generatingSources?: Maybe<Array<TQuizGeneratingSource>>;
  /** Questionários de ocupação */
  occupations?: Maybe<Array<TQuizOccupation>>;
  /** Questionários de pessoa */
  people?: Maybe<Array<TQuizPerson>>;
  /** Questionários de ambiente físico */
  physicalEnvironments?: Maybe<Array<TQuizPhysicalEnvironment>>;
  /** Questionários de segurança */
  safetyQuizzes?: Maybe<Array<TSafetyQuiz>>;
};

export type TChecklistInput = {
  costCenters?: InputMaybe<Array<TQuizCostCenterInput>>;
  departments?: InputMaybe<Array<TQuizDepartmentInput>>;
  generatingSources?: InputMaybe<Array<TQuizGeneratingSourceInput>>;
  occupations?: InputMaybe<Array<TQuizOccupationInput>>;
  people?: InputMaybe<Array<TQuizPersonInput>>;
  physicalEnvironments?: InputMaybe<Array<TQuizPhysicalEnvironmentInput>>;
};

export type TChemicalRisk = {
  __typename?: 'ChemicalRisk';
  descriptionCC: Scalars['String']['output'];
  descriptionOcup: Scalars['String']['output'];
  descriptionRA: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Estado civil */
export enum TCivilStatus {
  /** Divorciado(a) */
  Divorced = 'Divorced',
  /** Separado(a) judicialmente */
  JudiciallySeparated = 'JudiciallySeparated',
  /** Casado(a) */
  Married = 'Married',
  /** Solteiro(a) */
  Single = 'Single',
  /** Viúvo(a) */
  Widower = 'Widower'
}

/** Tipo de classificação do CID */
export enum TClassIcdType {
  /** Etiologia */
  Etiology = 'Etiology',
  /** Manifestação */
  Manifestation = 'Manifestation'
}

export type TClassificationPure = {
  __typename?: 'ClassificationPure';
  /** Matriz de classificação de riscos */
  data: Array<Array<Scalars['Int']['output']>>;
  /** Indica se existem riscos */
  hasRisk: Scalars['Boolean']['output'];
};

export type TClinicalQuiz = {
  __typename?: 'ClinicalQuiz';
  /** Identificador no ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** Identificador único do questionário */
  id: Scalars['String']['output'];
  /** Registro médico */
  medicalRecord: TMedicalRecord;
  /** Identificador da pessoa (funcionário) que respondeu em autoatendimento; nulo quando respondido por um responsável */
  personId?: Maybe<Scalars['String']['output']>;
  /** Questionário */
  quiz: TQuiz;
  /** Data de realização */
  realizationDate: Scalars['DateTime']['output'];
  /** Respostas */
  responses: Array<TResponsesClinicalQuiz>;
};

export type TClinicalQuizInput = {
  /** Identificador da consulta */
  consultationId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do registro médico */
  medicalRecordId: Scalars['String']['input'];
  /** Identificador do questionário */
  quizId: Scalars['String']['input'];
  /** Data de realização */
  realizationDate: Scalars['DateTime']['input'];
  /** Respostas */
  responses?: InputMaybe<Array<TResponseClinicalQuizInput>>;
};

export type TClinicalQuizUpdate = {
  /** Identificador único do questionário */
  id: Scalars['String']['input'];
  /** Identificador do registro médico */
  medicalRecordId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do questionário */
  quizId?: InputMaybe<Scalars['String']['input']>;
  /** Data de realização */
  realizationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Respostas */
  responses: Array<TResponseClinicalQuizUpdate>;
};

export type TCollisionReturn = {
  __typename?: 'CollisionReturn';
  feature: TFeature;
  flags: Array<TFlagRelation>;
};

export type TComparativeResultsDashboard = {
  __typename?: 'ComparativeResultsDashboard';
  /** Evolução do ASO */
  asoEvolution: Array<TAsoEvolutionEntry>;
  /** Tendência de alterações por ano */
  examAlterationTrend: Array<TExamAlterationTrend>;
  /** Distribuição de resultados por tipo de exame */
  examDiagnosticCount: Array<TExamDiagnosticCount>;
  /** Linha do tempo de exames */
  examTimeline: Array<TExamTimelineEntry>;
};

export type TComplementaryExam = {
  __typename?: 'ComplementaryExam';
  /** Credenciado */
  accredited?: Maybe<TAccredited>;
  /** Consulta */
  consultation: TConsultation;
  /** Exame */
  exam: TExam;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Repetição de monitoramento */
  monitoringRepetition?: Maybe<Scalars['Float']['output']>;
};

export type TComplementaryExamInput = {
  /** Identificador do credenciado */
  accreditedId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da consulta */
  consultationId: Scalars['String']['input'];
  /** Identificador do exame */
  examId: Scalars['String']['input'];
  /** Repetição de monitoramento */
  monitoringRepetition?: InputMaybe<Scalars['Float']['input']>;
};

export type TComplementaryExams = {
  __typename?: 'ComplementaryExams';
  date: Scalars['String']['output'];
  exam: Scalars['String']['output'];
  result: Scalars['String']['output'];
};

export type TComplementaryIcd = {
  __typename?: 'ComplementaryIcd';
  /** Acidente */
  accident: TAccident;
  /** CID */
  icd: TIcd;
  /** Grupo do CID */
  icdGroup: TIcdGroup;
  /** Identificador único */
  id: Scalars['String']['output'];
};

export type TComplementaryIcdInput = {
  /** Identificador do acidente */
  accidentId: Scalars['String']['input'];
  /** Identificador da filial */
  branch: Scalars['String']['input'];
  /** Identificador do grupo do CID */
  icdGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do CID */
  icdId?: InputMaybe<Scalars['String']['input']>;
};

export type TComplementaryIcdOnAccident = {
  __typename?: 'ComplementaryIcdOnAccident';
  /** CID */
  icd?: Maybe<TIcd>;
  /** Grupo do CID */
  icdGroup?: Maybe<TIcdGroup>;
  /** Identificador único */
  id: Scalars['String']['output'];
};

export type TComplementaryIcdOnAccidentInput = {
  /** Identificador do grupo do CID */
  icdGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do CID */
  icdId?: InputMaybe<Scalars['String']['input']>;
};

export type TComplementaryIcdOnAccidentUpdate = {
  /** CIDs complementares a criar */
  toCreate: Array<TComplementaryIcdOnAccidentInput>;
  /** IDs dos CIDs complementares a remover */
  toRemove: Array<Scalars['String']['input']>;
};

export type TComplementaryIcdOnDiagnostic = {
  __typename?: 'ComplementaryIcdOnDiagnostic';
  /** CID */
  icd?: Maybe<TIcd>;
  /** Grupo do CID */
  icdGroup?: Maybe<TIcdGroup>;
  /** Identificador único */
  id: Scalars['String']['output'];
};

export type TComplementaryIcdOnDiagnosticInput = {
  /** Identificador do grupo do CID */
  icdGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do CID */
  icdId?: InputMaybe<Scalars['String']['input']>;
};

export type TComplementaryIcdOnDiagnosticUpdate = {
  /** CIDs complementares a criar */
  toCreate: Array<TComplementaryIcdOnDiagnosticInput>;
  /** IDs dos CIDs complementares a remover */
  toRemove: Array<Scalars['String']['input']>;
};

export type TComponent = {
  __typename?: 'Component';
  /** Indica se está ativo */
  active: Scalars['Boolean']['output'];
  /** Tipo de componente */
  componentType: TComponentType;
  /** Erro na integração */
  errorIntegration?: Maybe<Scalars['String']['output']>;
  /** Identificador único do componente */
  id: Scalars['String']['output'];
  /** Indicação */
  indication: TIndication;
  /** Mandato */
  mandate: TMandate;
  /** Pessoa */
  person: TPerson;
  /** Motivo */
  reason?: Maybe<Scalars['String']['output']>;
  /** Função específica */
  specificFunction: TSpecificFunction;
  /** Tipo de estabilidade */
  stabilityType?: Maybe<TStabilityType>;
  /** Faltas injustificadas em reuniões ordinárias (apenas titulares) */
  unjustifiedAbsenceCount?: Maybe<Scalars['Int']['output']>;
};

export type TComponentActiveStatusEntry = {
  __typename?: 'ComponentActiveStatusEntry';
  label: Scalars['String']['output'];
  result: Scalars['Int']['output'];
};

export type TComponentInput = {
  /** Indica se está ativo */
  active: Scalars['Boolean']['input'];
  /** Tipo de componente */
  componentType: TComponentType;
  /** Indicação */
  indication: TIndication;
  /** Identificador do mandato */
  mandateId: Scalars['String']['input'];
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
  /** Função específica */
  specificFunction: TSpecificFunction;
  /** Identificador da estabilidade */
  stabilityId?: InputMaybe<Scalars['String']['input']>;
};

/** Tipo de componente */
export enum TComponentType {
  /** Designado */
  Designated = 'designated',
  /** Titular */
  Main = 'main',
  /** Suplente */
  Substitute = 'substitute'
}

export type TComponentUpdate = {
  /** Indica se está ativo */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tipo de componente */
  componentType?: InputMaybe<TComponentType>;
  /** Identificador único do componente */
  id: Scalars['String']['input'];
  /** Motivo */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Função específica */
  specificFunction?: InputMaybe<TSpecificFunction>;
  /** Identificador da estabilidade */
  stabilityId?: InputMaybe<Scalars['String']['input']>;
};

/** Tipo de comunicação de acidente de trabalho */
export enum TComunicationType {
  /** Óbito */
  Death = 'death',
  /** Inicial */
  Initial = 'initial',
  /** Reabertura */
  Reopening = 'reopening'
}

export type TConfirmImport = {
  __typename?: 'ConfirmImport';
  /** ID do processo de importação */
  importId: Scalars['String']['output'];
  /** Número total de linhas do arquivo */
  totalRows: Scalars['Float']['output'];
};

/** Considerar impressão */
export enum TConsiderPrint {
  /** ASO */
  Aso = 'Aso',
  /** ASO e PPP */
  AsoPpp = 'AsoPpp',
  /** Nenhum */
  None = 'None',
  /** PPP */
  Ppp = 'Ppp'
}

export type TConsultReport = {
  __typename?: 'ConsultReport';
  /** Endereço */
  address: Scalars['String']['output'];
  /** Etilismo */
  alcoholism: Scalars['String']['output'];
  /** Detalhes do etilismo */
  alcoholismDetails: Scalars['String']['output'];
  /** Quantidade consumida */
  amountConsumed: Scalars['String']['output'];
  /** Atendimento */
  attendance: Scalars['String']['output'];
  /** Atendimento em HTML, com cada trecho ( | ) em uma linha */
  attendanceBr: Scalars['String']['output'];
  /** Data de nascimento */
  birthday: Scalars['String']['output'];
  /** Doador de sangue */
  bloodDonator: Scalars['String']['output'];
  /** Tipo sanguíneo */
  bloodType: Scalars['String']['output'];
  /** Portador de doenças crônicas ou em tratamento */
  chronicDiseaseOrTreatment: Scalars['String']['output'];
  /** Detalhes de doenças crônicas ou tratamentos em andamento */
  chronicDiseaseOrTreatmentDetails: Scalars['String']['output'];
  /** Queixa */
  complaint: Scalars['String']['output'];
  /** CIDs complementares */
  complementaryICD: Array<Scalars['String']['output']>;
  /** Altura na consulta */
  consultationHeight: Scalars['String']['output'];
  /** Tipo de consulta */
  consultationType: Scalars['String']['output'];
  /** Peso na consulta */
  consultationWeight: Scalars['String']['output'];
  /** Uso de medicamento controlado */
  controlledMedication: Scalars['String']['output'];
  /** Detalhes do medicamento controlado */
  controlledMedicationDetails: Scalars['String']['output'];
  /** Data */
  date: Scalars['String']['output'];
  /** Diagnóstico */
  diagnostic: Scalars['String']['output'];
  /** Diagnóstico em HTML, com cada trecho ( | ) em uma linha */
  diagnosticBr: Scalars['String']['output'];
  /** Pressão diastólica */
  diastolicPressure: Scalars['String']['output'];
  /** CRM */
  doctorCRM?: Maybe<Scalars['String']['output']>;
  /** Médico Responsável */
  doctorName?: Maybe<Scalars['String']['output']>;
  /** Snapshot formatado dos RQEs do médico para impressão */
  doctorRqeDisplay?: Maybe<Scalars['String']['output']>;
  /** Exames */
  exams: Array<TExamReport>;
  /** Rodapé */
  footer: Scalars['String']['output'];
  /** Gênero */
  gender: Scalars['String']['output'];
  /** Altura */
  height: Scalars['String']['output'];
  /** CID */
  icd: Scalars['String']['output'];
  /** Nome do CID */
  icdName: Scalars['String']['output'];
  /** Data de implantação */
  implantation: Scalars['String']['output'];
  /** Medicamentos */
  meds: Array<TMedConsultReport>;
  /** Acompanhamento de saúde mental */
  mentalHealthFollowUp: Scalars['String']['output'];
  /** Detalhes do acompanhamento de saúde mental */
  mentalHealthFollowUpDetails: Scalars['String']['output'];
  /** Nome do paciente */
  name: Scalars['String']['output'];
  /** Bairro */
  neighborhood: Scalars['String']['output'];
  /** Consulta ocupacional */
  occupational: Scalars['Boolean']['output'];
  /** Prática de atividade física */
  physicalActivity: Scalars['String']['output'];
  /** Detalhes da atividade física */
  physicalActivityDetails: Scalars['String']['output'];
  /** Fumante */
  smoker: Scalars['String']['output'];
  /** Pressão sistólica */
  systolicPressure: Scalars['String']['output'];
  /** Período de tabagismo */
  tamagistPeriod: Scalars['String']['output'];
  /** Documento do Responsável pelo Atendimento */
  triageResponsibleDocument?: Maybe<Scalars['String']['output']>;
  /** Responsável pelo Atendimento */
  triageResponsibleName?: Maybe<Scalars['String']['output']>;
  /** Peso */
  weight: Scalars['String']['output'];
};

export type TConsultation = {
  __typename?: 'Consultation';
  /** Acidente relacionado */
  accident?: Maybe<TAccident>;
  /** Credenciado */
  accredited?: Maybe<TAccredited>;
  /** Indica se foi atendida */
  attended?: Maybe<Scalars['Boolean']['output']>;
  /** Filial */
  branch: Scalars['String']['output'];
  /** Identificador de referência do exame */
  cExmRefId?: Maybe<Scalars['String']['output']>;
  /** Questionário clínico */
  clinicalQuiz?: Maybe<TClinicalQuiz>;
  /** Identificador do questionário clínico */
  clinicalQuizId?: Maybe<Scalars['String']['output']>;
  /** Exames complementares */
  complementaryExams?: Maybe<Array<TExamOnConsultation>>;
  /** Centro de custo */
  costCenter?: Maybe<TCostCenter>;
  /** Identificador do centro de custo */
  costCenterId?: Maybe<Scalars['String']['output']>;
  /** CRM do médico */
  crm?: Maybe<Scalars['String']['output']>;
  /** Identificador do departamento */
  departmentId?: Maybe<Scalars['String']['output']>;
  /** Diagnóstico */
  diagnostics?: Maybe<TDiagnostic>;
  /** Médico responsável */
  doctor?: Maybe<TPerson>;
  /** Identificador do médico */
  doctorId?: Maybe<Scalars['String']['output']>;
  /** Snapshot granular dos RQEs do médico responsável no momento da assinatura. Hidrata o input externo na edição. */
  doctorRqeEntries?: Maybe<Array<TDoctorRqeEntry>>;
  /** Data de término da consulta */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Data estimada da consulta */
  estimatedDate: Scalars['DateTime']['output'];
  /** Tempo estimado em minutos */
  estimatedTime?: Maybe<Scalars['Float']['output']>;
  /** Exame principal */
  exam?: Maybe<TExam>;
  /** Questionário de anamnese esperado para esta consulta */
  expectedClinicalQuiz?: Maybe<TQuiz>;
  /** Identificador do questionário de anamnese esperado para esta consulta */
  expectedClinicalQuizId?: Maybe<Scalars['String']['output']>;
  /** Nome do médico externo */
  externalDoctor?: Maybe<Scalars['String']['output']>;
  /** Forçar agendamento */
  forceSchedule?: Maybe<Scalars['Boolean']['output']>;
  /** Obter próximo horário disponível */
  getNextAvailableTime?: Maybe<Scalars['Boolean']['output']>;
  /** Indica se está oculta */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Identificador da consulta */
  id: Scalars['String']['output'];
  /** Ignorar validação ocupacional */
  ignoreOccupationalValidation?: Maybe<Scalars['Boolean']['output']>;
  /** Prontuário médico */
  medicalRecord: TMedicalRecord;
  /** Natureza da consulta */
  nature?: Maybe<TConsultationNature>;
  /** Enfermeiro responsável */
  nurse?: Maybe<TPerson>;
  /** Identificador do enfermeiro */
  nurseId?: Maybe<Scalars['String']['output']>;
  /** Observações */
  observation?: Maybe<Scalars['String']['output']>;
  /** Ocupação */
  occupation?: Maybe<TOccupation>;
  /** Identificador da ocupação */
  occupationId?: Maybe<Scalars['String']['output']>;
  /** Atestado de Saúde Ocupacional (ASO) */
  occupationalCertificate?: Maybe<TOccupationalHealthCertificate>;
  /** Motivo da consulta */
  reason: Scalars['String']['output'];
  /** Retornar erro em caso de conflito */
  returnOnConflictError?: Maybe<Scalars['Boolean']['output']>;
  /** Data da triagem */
  screeningDate?: Maybe<Scalars['DateTime']['output']>;
  /** Data de início da consulta */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Estado do CRM */
  state?: Maybe<TState>;
  /** Identificador da tarefa */
  taskId?: Maybe<Scalars['String']['output']>;
  /** Tipo de consulta */
  type: TConsultationType;
};

export type TConsultationBiologicalMonitoring = {
  __typename?: 'ConsultationBiologicalMonitoring';
  /** Exames complementares */
  cExm?: Maybe<Array<TExamOnConsultation>>;
  /** Identificador da consulta */
  id: Scalars['String']['output'];
};

export type TConsultationByBranchToPrint = {
  __typename?: 'ConsultationByBranchToPrint';
  accredited?: Maybe<Scalars['String']['output']>;
  admissionDate?: Maybe<Scalars['String']['output']>;
  branch?: Maybe<Scalars['String']['output']>;
  /** Centro de custo */
  costCenter?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  /** Diagnóstico */
  diagnostic: Scalars['String']['output'];
  /** Data do diagnóstico */
  diagnosticDate: Scalars['String']['output'];
  dismissalDate?: Maybe<Scalars['String']['output']>;
  doctor?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  /** Categoria eSocial */
  eSocialCategory?: Maybe<Scalars['String']['output']>;
  /** Data de término */
  endDate: Scalars['String']['output'];
  erpBranch?: Maybe<Scalars['String']['output']>;
  /** Data estimada */
  estimatedDate: Scalars['String']['output'];
  /** CID */
  icd: Scalars['String']['output'];
  /** Matrícula individual */
  individualRegistration?: Maybe<Scalars['String']['output']>;
  /** Prontuário médico */
  medicalRecord: Scalars['String']['output'];
  /** Natureza da consulta */
  nature: Scalars['String']['output'];
  nurse?: Maybe<Scalars['String']['output']>;
  /** Ocupação */
  occupation?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  /** Matrícula */
  registration?: Maybe<Scalars['String']['output']>;
  screeningBy?: Maybe<Scalars['String']['output']>;
  screeningDate?: Maybe<Scalars['String']['output']>;
  /** Data de início */
  startDate: Scalars['String']['output'];
  /** Status */
  status: Scalars['String']['output'];
  /** Tipo de consulta */
  type: Scalars['String']['output'];
};

export type TConsultationByDoctorToPrint = {
  __typename?: 'ConsultationByDoctorToPrint';
  accredited?: Maybe<Scalars['String']['output']>;
  admissionDate?: Maybe<Scalars['String']['output']>;
  branch?: Maybe<Scalars['String']['output']>;
  /** Centro de custo */
  costCenter?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  /** Diagnóstico */
  diagnostic: Scalars['String']['output'];
  /** Data do diagnóstico */
  diagnosticDate: Scalars['String']['output'];
  dismissalDate?: Maybe<Scalars['String']['output']>;
  /** Categoria eSocial */
  eSocialCategory?: Maybe<Scalars['String']['output']>;
  /** Data de término */
  endDate: Scalars['String']['output'];
  /** Data estimada */
  estimatedDate: Scalars['String']['output'];
  /** CID */
  icd: Scalars['String']['output'];
  /** Matrícula individual */
  individualRegistration?: Maybe<Scalars['String']['output']>;
  /** Prontuário médico */
  medicalRecord: Scalars['String']['output'];
  /** Natureza da consulta */
  nature: Scalars['String']['output'];
  nurse?: Maybe<Scalars['String']['output']>;
  /** Ocupação */
  occupation?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  /** Matrícula */
  registration?: Maybe<Scalars['String']['output']>;
  screeningBy?: Maybe<Scalars['String']['output']>;
  screeningDate?: Maybe<Scalars['String']['output']>;
  /** Data de início */
  startDate: Scalars['String']['output'];
  /** Status */
  status: Scalars['String']['output'];
  /** Tipo de consulta */
  type: Scalars['String']['output'];
};

export type TConsultationExamsResult = {
  __typename?: 'ConsultationExamsResult';
  /** Identificador do exame complementar */
  complementaryExamId: Scalars['String']['output'];
  /** Identificador da consulta */
  consultationId: Scalars['String']['output'];
  /** Data do resultado */
  date: Scalars['String']['output'];
  /** Detalhes do resultado */
  details?: Maybe<Scalars['String']['output']>;
  /** Nome do exame */
  exam: Scalars['String']['output'];
  /** Documento do médico responsável */
  examResponsibleDocument?: Maybe<Scalars['String']['output']>;
  /** Nome do médico responsável */
  examResponsibleName?: Maybe<Scalars['String']['output']>;
  /** Observação do resultado */
  observations?: Maybe<Scalars['String']['output']>;
  /** Resultado */
  result: Scalars['String']['output'];
  /** Descrição do resultado */
  resultDescription: Scalars['String']['output'];
};

export type TConsultationInput = {
  /** ID do acidente */
  accidentId?: InputMaybe<Scalars['String']['input']>;
  /** ID do credenciado */
  accreditedId?: InputMaybe<Scalars['String']['input']>;
  /** Indica se foi atendida */
  attended?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID do Exame de Referência */
  cExmRefId?: InputMaybe<Scalars['String']['input']>;
  complementaryExams?: InputMaybe<Array<TExamOnConsultationInput>>;
  /** Identificador do centro de custo */
  costCenterId?: InputMaybe<Scalars['String']['input']>;
  /** CRM do médico */
  crm?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do departamento */
  departmentId?: InputMaybe<Scalars['String']['input']>;
  /** ID do médico interno */
  doctorId?: InputMaybe<Scalars['String']['input']>;
  /** RQEs do médico (até 2) para snapshot no documento. Quando médico é externo (externalDoctor + crm preenchidos), digitar no formulário. Quando interno (doctorId), o backend resolve automaticamente a partir de mdt.user_specialty. */
  doctorRqeInput?: InputMaybe<Array<TDoctorRqeEntryInput>>;
  /** Data de término da consulta */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data estimada da consulta */
  estimatedDate: Scalars['DateTime']['input'];
  /** Tempo estimado em minutos */
  estimatedTime?: InputMaybe<Scalars['Float']['input']>;
  /** ID do exame principal */
  examId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do questionário de anamnese esperado para esta consulta */
  expectedClinicalQuizId?: InputMaybe<Scalars['String']['input']>;
  /** Nome do médico externo */
  externalDoctor?: InputMaybe<Scalars['String']['input']>;
  /** Forçar agendamento */
  forceSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  /** Obter próximo horário disponível */
  getNextAvailableTime?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se está oculta */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ignorar validação ocupacional */
  ignoreOccupationalValidation?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID do Prontuário Médico */
  medicalRecordId: Scalars['String']['input'];
  /** Natureza da consulta */
  nature?: InputMaybe<TConsultationNature>;
  /** Identificador do enfermeiro */
  nurseId?: InputMaybe<Scalars['String']['input']>;
  /** Observações */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da ocupação */
  occupationId?: InputMaybe<Scalars['String']['input']>;
  /** Motivo da consulta */
  reason: Scalars['String']['input'];
  /** Retornar erro em caso de conflito */
  returnOnConflictError?: InputMaybe<Scalars['Boolean']['input']>;
  /** Data da triagem */
  screeningDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de início da consulta */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Estado do CRM */
  state?: InputMaybe<TState>;
  /** Identificador da tarefa */
  taskId?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de Consulta (Occupational - Ocupacional; ToxicologicalExam - Toxicológico; Clinical - Clínica; Urgency - Urgência; QualityOfLife - Qualidade de VideoFrame; Monitoring - Monitoramento) */
  type: TConsultationType;
};

export type TConsultationMinimal = {
  __typename?: 'ConsultationMinimal';
  /** Credenciado */
  accredited?: Maybe<TAccredited>;
  /** Indica se foi atendida */
  attended?: Maybe<Scalars['Boolean']['output']>;
  /** Filial */
  branch: Scalars['String']['output'];
  /** Identificador de referência do exame */
  cExmRefId?: Maybe<Scalars['String']['output']>;
  /** Centro de custo */
  costCenter?: Maybe<TCostCenter>;
  /** Identificador do centro de custo */
  costCenterId?: Maybe<Scalars['String']['output']>;
  /** CRM do médico */
  crm?: Maybe<Scalars['String']['output']>;
  /** Identificador do departamento */
  departmentId?: Maybe<Scalars['String']['output']>;
  /** Médico responsável */
  doctor?: Maybe<TPerson>;
  /** Identificador do médico */
  doctorId?: Maybe<Scalars['String']['output']>;
  /** Data de término da consulta */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Data estimada da consulta */
  estimatedDate: Scalars['DateTime']['output'];
  /** Tempo estimado em minutos */
  estimatedTime?: Maybe<Scalars['Float']['output']>;
  /** Exame principal */
  exam?: Maybe<TExam>;
  /** Identificador do questionário de anamnese esperado para esta consulta */
  expectedClinicalQuizId?: Maybe<Scalars['String']['output']>;
  /** Nome do médico externo */
  externalDoctor?: Maybe<Scalars['String']['output']>;
  /** Forçar agendamento */
  forceSchedule?: Maybe<Scalars['Boolean']['output']>;
  /** Obter próximo horário disponível */
  getNextAvailableTime?: Maybe<Scalars['Boolean']['output']>;
  /** Indica se está oculta */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Identificador da consulta */
  id: Scalars['String']['output'];
  /** Ignorar validação ocupacional */
  ignoreOccupationalValidation?: Maybe<Scalars['Boolean']['output']>;
  /** Prontuário médico */
  medicalRecord: TMedicalRecord;
  /** Natureza da consulta */
  nature?: Maybe<TConsultationNature>;
  /** Enfermeiro responsável */
  nurse?: Maybe<TPerson>;
  /** Identificador do enfermeiro */
  nurseId?: Maybe<Scalars['String']['output']>;
  /** Observações */
  observation?: Maybe<Scalars['String']['output']>;
  /** Ocupação */
  occupation?: Maybe<TOccupation>;
  /** Identificador da ocupação */
  occupationId?: Maybe<Scalars['String']['output']>;
  /** Atestado de Saúde Ocupacional (ASO) */
  occupationalCertificate?: Maybe<TOccupationalHealthCertificate>;
  /** Motivo da consulta */
  reason: Scalars['String']['output'];
  /** Retornar erro em caso de conflito */
  returnOnConflictError?: Maybe<Scalars['Boolean']['output']>;
  /** Data da triagem */
  screeningDate?: Maybe<Scalars['DateTime']['output']>;
  /** Data de início da consulta */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Estado do CRM */
  state?: Maybe<TState>;
  /** Identificador da tarefa */
  taskId?: Maybe<Scalars['String']['output']>;
  /** Tipo de consulta */
  type: TConsultationType;
};

/** Natureza da consulta médica */
export enum TConsultationNature {
  /** Admissional */
  Admissional = 'Admissional',
  /** Retorno ao trabalho */
  BackToWork = 'BackToWork',
  /** Mudança de função */
  ChangeOfFunction = 'ChangeOfFunction',
  /** Demissional */
  Dismissal = 'Dismissal',
  /** Periódico */
  Periodic = 'Periodic',
  /** Monitoramento pontual */
  SpotMonitoring = 'SpotMonitoring'
}

export type TConsultationReason = {
  __typename?: 'ConsultationReason';
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Motivo da consulta */
  reason: Scalars['String']['output'];
};

/** Tipo de consulta */
export enum TConsultationType {
  /** Clínica */
  Clinical = 'Clinical',
  /** Monitoramento */
  Monitoring = 'Monitoring',
  /** Ocupacional */
  Occupational = 'Occupational',
  /** Qualidade de vida */
  QualityOfLife = 'QualityOfLife',
  /** Exame toxicológico */
  ToxicologicalExam = 'ToxicologicalExam',
  /** Urgência */
  Urgency = 'Urgency'
}

export type TConsultationUpdate = {
  /** Identificador do credenciado */
  accreditedId?: InputMaybe<Scalars['String']['input']>;
  /** Indica se foi atendida */
  attended?: InputMaybe<Scalars['Boolean']['input']>;
  /** Atualização de exames complementares */
  cExm?: InputMaybe<TExamOnConsultationUpdate>;
  /** Identificador de referência do exame */
  cExmRefId?: InputMaybe<Scalars['String']['input']>;
  /** Indica se foi confirmada */
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador do centro de custo */
  costCenterId?: InputMaybe<Scalars['String']['input']>;
  /** CRM do médico */
  crm?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do departamento */
  departmentId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do médico */
  doctorId?: InputMaybe<Scalars['String']['input']>;
  /** RQEs do médico (até 2) para snapshot. Quando externo, vem do formulário. Quando interno, backend resolve automaticamente. */
  doctorRqeInput?: InputMaybe<Array<TDoctorRqeEntryInput>>;
  /** Data de término da consulta */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data estimada da consulta */
  estimatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Tempo estimado em minutos */
  estimatedTime?: InputMaybe<Scalars['Float']['input']>;
  /** Identificador do exame */
  examId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do questionário de anamnese esperado para esta consulta */
  expectedClinicalQuizId?: InputMaybe<Scalars['String']['input']>;
  /** Nome do médico externo */
  externalDoctor?: InputMaybe<Scalars['String']['input']>;
  /** Forçar agendamento */
  forceSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  /** Obter próximo horário disponível */
  getNextAvailableTime?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se está oculta */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador da consulta */
  id: Scalars['String']['input'];
  /** Ignorar validação ocupacional */
  ignoreOccupationalValidation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador do prontuário médico */
  medicalRecordId?: InputMaybe<Scalars['String']['input']>;
  /** Natureza da consulta */
  nature?: InputMaybe<TConsultationNature>;
  /** Identificador do enfermeiro */
  nurseId?: InputMaybe<Scalars['String']['input']>;
  /** Observações */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da ocupação */
  occupationId?: InputMaybe<Scalars['String']['input']>;
  /** Motivo da consulta */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Retornar erro em caso de conflito */
  returnOnConflictError?: InputMaybe<Scalars['Boolean']['input']>;
  /** Data da triagem */
  screeningDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de início da consulta */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Estado do CRM */
  state?: InputMaybe<TState>;
  /** Identificador da tarefa */
  taskId?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de consulta */
  type?: InputMaybe<TConsultationType>;
};

export type TContactRequest = {
  __typename?: 'ContactRequest';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TContactRequestInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type TControlMeasure = {
  __typename?: 'ControlMeasure';
  /** Tipo de controle */
  controlType: TControlType;
  /** Descrição da medida de controle */
  description?: Maybe<Scalars['String']['output']>;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Indica se está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Nome da medida de controle */
  name: Scalars['String']['output'];
};

export type TControlMeasureByRisk = {
  __typename?: 'ControlMeasureByRisk';
  /** Medida de controle vinculada */
  controlMeasure: TControlMeasure;
  /** ID da relação */
  id: Scalars['String']['output'];
  /** Indica se é efetiva */
  isEffective?: Maybe<Scalars['Boolean']['output']>;
};

export type TControlMeasureByRiskInput = {
  /** ID da medida de controle */
  controlMeasureId: Scalars['String']['input'];
  /** Indica se é efetiva */
  isEffective?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID do risco */
  riskId: Scalars['String']['input'];
};

export type TControlMeasureFrame = {
  __typename?: 'ControlMeasureFrame';
  /** Descrição da medida de controle */
  description: Scalars['String']['output'];
  /** Nome da medida de controle */
  name: Scalars['String']['output'];
};

export type TControlMeasureInput = {
  /** Tipo de controle */
  controlType: TControlType;
  /** Descrição da medida de controle */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Nome da medida de controle */
  name: Scalars['String']['input'];
};

export type TControlMeasureOnRiskInput = {
  /** ID da medida de controle */
  controlMeasureId: Scalars['String']['input'];
  /** Indica se é efetiva */
  isEffective?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TControlMeasureOnRiskUpdate = {
  /** Medidas de controle a serem criadas */
  toCreate: Array<TControlMeasureOnRiskInput>;
  /** IDs das medidas de controle a serem removidas */
  toRemove: Array<Scalars['String']['input']>;
};

export type TControlMeasureUpdate = {
  /** Tipo de controle */
  controlType?: InputMaybe<TControlType>;
  /** Descrição da medida de controle */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Indica se está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Nome da medida de controle */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TControlMeasuresChart = {
  __typename?: 'ControlMeasuresChart';
  /** Quantidade de medidas efetivas */
  effective: Scalars['Float']['output'];
  /** Indica se existem riscos */
  hasRisk: Scalars['Boolean']['output'];
  /** Quantidade de medidas não efetivas */
  noEffective: Scalars['Float']['output'];
};

/** Tipo de controle */
export enum TControlType {
  /** Medidas administrativas */
  AdministrativeMeasures = 'AdministrativeMeasures',
  /** Monitoramento biológico */
  BiologicalMonitoring = 'BiologicalMonitoring',
  /** Proteção coletiva */
  CollectiveProtection = 'CollectiveProtection',
  /** Engenharia */
  Engineering = 'Engineering',
  /** Proteção individual */
  IndividualProtection = 'IndividualProtection',
  /** Outros */
  Others = 'Others'
}

export type TCostCenter = {
  __typename?: 'CostCenter';
  /** Classe do centro de custo */
  classCostCenter?: Maybe<Scalars['String']['output']>;
  /** Descrição do centro de custo */
  description: Scalars['String']['output'];
  /** Equipamentos */
  equipments?: Maybe<Array<TEquipmentByCostCenter>>;
  /** Código no ERP */
  erpCode?: Maybe<Scalars['String']['output']>;
  /** Identificador no ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Indica se está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Necessita de equipamento */
  needEquipment?: Maybe<Scalars['Boolean']['output']>;
  /** Identificador de referência */
  referenceId?: Maybe<Scalars['String']['output']>;
  /** Identificador do estoque no ERP */
  stockErpId?: Maybe<Scalars['String']['output']>;
  /** Sugestão de uso */
  suggestion?: Maybe<Scalars['String']['output']>;
  /** Identificador da filial de destino */
  targetBranchId?: Maybe<Scalars['String']['output']>;
};

export type TCostCenterByRisk = {
  __typename?: 'CostCenterByRisk';
  /** Centro de custo vinculado */
  costCenter: TCostCenter;
  /** ID da relação */
  id: Scalars['String']['output'];
};

export type TCostCenterByRiskInput = {
  /** ID do centro de custo */
  costCenterId: Scalars['String']['input'];
  /** ID do risco */
  riskId: Scalars['String']['input'];
};

export type TCostCenterEntry = {
  __typename?: 'CostCenterEntry';
  cumulativePercent: Scalars['Float']['output'];
  label: Scalars['String']['output'];
  result: Scalars['Int']['output'];
};

export type TCostCenterGroup = {
  __typename?: 'CostCenterGroup';
  /** Descrição do centro de custo */
  description: Scalars['String']['output'];
  /** Identificador do centro de custo */
  id: Scalars['String']['output'];
  /** Cargos agrupados neste centro de custo */
  occupations: Array<TOccupationsGroup>;
};

export type TCostCenterInput = {
  /** Classe do centro de custo */
  classCostCenter?: InputMaybe<Scalars['String']['input']>;
  /** Descrição do centro de custo */
  description: Scalars['String']['input'];
  /** Equipamentos */
  equipments?: InputMaybe<Array<TEquipmentOnCostCenterInput>>;
  /** Código no ERP */
  erpCode?: InputMaybe<Scalars['String']['input']>;
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Necessita de equipamento */
  needEquipment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do estoque no ERP */
  stockErpId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da filial de destino */
  targetBranchId?: InputMaybe<Scalars['String']['input']>;
};

export type TCostCenterIntegration = {
  /** Identificador da filial */
  branch: Scalars['String']['input'];
  /** Classe do centro de custo */
  classCostCenter?: InputMaybe<Scalars['String']['input']>;
  /** Descrição do centro de custo */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Código no ERP */
  erpCode?: InputMaybe<Scalars['String']['input']>;
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Indica se está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Necessita de equipamento */
  needEquipment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do estoque no ERP */
  stockErpId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da filial de destino */
  targetBranchId?: InputMaybe<Scalars['String']['input']>;
};

export type TCostCenterOccupationChart = {
  __typename?: 'CostCenterOccupationChart';
  /** Dados de contagem de atestados */
  certificateCountData: Array<TData>;
  /** Atestados por HC */
  certificatePerHC: Array<TData>;
  /** Possui atestado */
  hasCertificate: Scalars['Boolean']['output'];
};

export type TCostCenterOccupationDeficienciesChart = {
  __typename?: 'CostCenterOccupationDeficienciesChart';
  /** Dados */
  data: Array<TData>;
  /** Possui deficiências */
  hasDeficiencies: Scalars['Boolean']['output'];
};

export type TCostCenterOnMandate = {
  __typename?: 'CostCenterOnMandate';
  /** Centro de custo */
  costCenter: TCostCenter;
  /** Identificador */
  id: Scalars['String']['output'];
};

export type TCostCenterOnMandateInput = {
  /** Identificador do centro de custo */
  costCenterId: Scalars['String']['input'];
};

export type TCostCenterOnRiskInput = {
  /** ID do centro de custo */
  costCenterId: Scalars['String']['input'];
};

export type TCostCenterOnVaccine = {
  __typename?: 'CostCenterOnVaccine';
  /** Centro de custo associado à vacina */
  costCenter: TCostCenter;
  /** ID da associação vacina-centro de custo */
  id: Scalars['String']['output'];
};

export type TCostCenterOnVaccineInput = {
  /** ID do centro de custo */
  costCenterId: Scalars['String']['input'];
};

export type TCostCenterStock = {
  /** Identificador da filial */
  branch: Scalars['String']['input'];
  /** Descrição do centro de custo */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Código no ERP */
  erpCode?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Indica se está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador do estoque no ERP */
  stockErpId?: InputMaybe<Scalars['String']['input']>;
};

export type TCostCenterUpdate = {
  /** Classe do centro de custo */
  classCostCenter?: InputMaybe<Scalars['String']['input']>;
  /** Descrição do centro de custo */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Equipamentos */
  equipments?: InputMaybe<TEquipmentOnCostCenterUpdate>;
  /** Código no ERP */
  erpCode?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Indica se está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Necessita de equipamento */
  needEquipment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do estoque no ERP */
  stockErpId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da filial de destino */
  targetBranchId?: InputMaybe<Scalars['String']['input']>;
};

export type TCostCenterVolumeChart = {
  __typename?: 'CostCenterVolumeChart';
  /** Dias por HC */
  daysPerHC: Array<TData>;
  /** Possui atestado */
  hasCertificate: Scalars['Boolean']['output'];
  /** Dados de dias perdidos */
  lostDayData: Array<TData>;
  /** Dados de contagem de pessoas */
  peopleCountData: Array<TData>;
};

export type TCostPerTypeChart = {
  __typename?: 'CostPerTypeChart';
  /** Indica se há acidentes registrados */
  hasAccident: Scalars['Boolean']['output'];
  /** Indenizações */
  indemnity: Scalars['Float']['output'];
  /** Custos com materiais */
  material: Scalars['Float']['output'];
  /** Custos médicos */
  medical: Scalars['Float']['output'];
  /** Outros custos */
  others: Scalars['Float']['output'];
  /** Perda de produção */
  productionLoss: Scalars['Float']['output'];
};

export type TCreateMetadataInput = {
  /** Campos */
  fields?: InputMaybe<Array<TFieldsInput>>;
  /** ID do metadado genérico */
  genericMetadataId: Scalars['String']['input'];
  /** Tipo de integração */
  integrationType: TErpType;
  /** Indica se é customizável */
  isCustomizable: Scalars['Boolean']['input'];
  /** Nome do metadado */
  name: Scalars['String']['input'];
  /** Versão */
  version: Scalars['Float']['input'];
};

export type TCreditCard = {
  __typename?: 'CreditCard';
  /** Bandeira do cartão */
  brand: Scalars['String']['output'];
  /** Número do cartão (parcialmente oculto) */
  number: Scalars['String']['output'];
};

export type TCronTab = {
  __typename?: 'CronTab';
  /** ID da filial */
  branchId: Scalars['String']['output'];
  /** Entidade de negócio */
  businessEntity: TBusinessEntity;
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** Descrição da tarefa */
  description: Scalars['String']['output'];
  /** Tipo de ERP */
  erpType: TErpType;
  /** ID da tarefa agendada */
  id: Scalars['String']['output'];
  /** Indica se está ativa */
  isActive: Scalars['Boolean']['output'];
  /** Último código HTTP retornado */
  lastHttpCode: Scalars['Float']['output'];
  /** Último estado HTTP */
  lastHttpState?: Maybe<Scalars['String']['output']>;
  /** Periodicidade em minutos */
  periodicity: Scalars['Float']['output'];
  /** Data de atualização */
  updatedAt: Scalars['DateTime']['output'];
};

export type TCronTabInput = {
  /** Entidade de negócio */
  businessEntity?: InputMaybe<TBusinessEntity>;
  /** Descrição da tarefa */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de ERP */
  erpType: TErpType;
  /** ID da tarefa agendada */
  id: Scalars['String']['input'];
  /** Indica se está ativa */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Último código HTTP retornado */
  lastHttpCode?: InputMaybe<Scalars['Float']['input']>;
  /** Último estado HTTP */
  lastHttpState?: InputMaybe<Scalars['String']['input']>;
  /** Periodicidade em minutos */
  periodicity?: InputMaybe<Scalars['Float']['input']>;
};

export type TCrontabExecution = {
  __typename?: 'CrontabExecution';
  /** ID do crontab parent */
  crontabId: Scalars['String']['output'];
  /** Detalhe do erro (quando status=failed) */
  errorDetail?: Maybe<Scalars['String']['output']>;
  /** Fim da execução */
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID da execução */
  id: Scalars['String']['output'];
  /** Última página com checkpoint persistido */
  lastCheckpointPage: Scalars['Float']['output'];
  /** Início da execução */
  startedAt: Scalars['DateTime']['output'];
  /** Status da execução (running/completed/interrupted/failed) */
  status: TCrontabExecutionStatus;
  /** Total criados localmente */
  totalCreated: Scalars['Float']['output'];
  /** Total de erros */
  totalErrors: Scalars['Float']['output'];
  /** Total ignorados (sem mudança) */
  totalIgnored: Scalars['Float']['output'];
  /** Total de páginas processadas */
  totalPages: Scalars['Float']['output'];
  /** Total de registros recebidos do ERP */
  totalReceived: Scalars['Float']['output'];
  /** Total atualizados localmente */
  totalUpdated: Scalars['Float']['output'];
};

/** Ação aplicada a um registro pelo job de carga incremental Fase 1 */
export enum TCrontabExecutionAction {
  /** Registro criado localmente */
  Created = 'Created',
  /** Falha ao processar o registro */
  Error = 'Error',
  /** Registro inalterado (campos iguais) */
  Ignored = 'Ignored',
  /** Registro atualizado (campos divergiam) */
  Updated = 'Updated'
}

export type TCrontabExecutionDetail = {
  __typename?: 'CrontabExecutionDetail';
  /** Ação aplicada (created/updated/ignored/error) */
  action: TCrontabExecutionAction;
  /** erpId do registro processado */
  entityErpId: Scalars['String']['output'];
  /** Nome legível do registro (description) */
  entityName?: Maybe<Scalars['String']['output']>;
  /** Detalhe do erro (quando action=error) */
  errorDetail?: Maybe<Scalars['String']['output']>;
  /** ID da execução pai */
  executionId: Scalars['String']['output'];
  /** ID do detail */
  id: Scalars['String']['output'];
  /** Página em que o registro foi processado */
  pageNumber: Scalars['Float']['output'];
  /** Quando foi processado */
  processedAt: Scalars['DateTime']['output'];
};

/** Status de uma execução do job de carga incremental Fase 1 */
export enum TCrontabExecutionStatus {
  /** Concluída com sucesso */
  Completed = 'Completed',
  /** Falhou de forma irrecuperável */
  Failed = 'Failed',
  /** Interrompida (retomável a partir do último checkpoint) */
  Interrupted = 'Interrupted',
  /** Em execução */
  Running = 'Running'
}

/** Tipos de importação CSV */
export enum TCsvImports {
  /** Credenciado */
  Accredited = 'Accredited',
  /** Questionário clínico */
  ClinicalQuiz = 'ClinicalQuiz',
  /** Deficiência */
  Deficiency = 'Deficiency',
  /** Atestado médico */
  MedicalCertificate = 'MedicalCertificate',
  /** Prontuário médico */
  MedicalRecord = 'MedicalRecord',
  /** Vacina do prontuário médico */
  MedicalRecordVaccine = 'MedicalRecordVaccine',
  /** Atestado de saúde ocupacional */
  OccupationalHealthCertificate = 'OccupationalHealthCertificate',
  /** Questionário */
  Quiz = 'Quiz',
  /** Risco */
  Risk = 'Risk'
}

/** Customização por organização do Document Builder v2 — UNIQUE por (organização, tipo). */
export type TCustomDocument = {
  __typename?: 'CustomDocument';
  /** Snapshot do schemaVersion do default no momento do fork (D9). */
  basedOnSchemaVersion: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  /** JSON canônico (DocumentDefinition) customizado. Backend converte para HBS no PDF time. */
  definition: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** ID da organização dona da customização. */
  organization: Scalars['ID']['output'];
  schemaVersion: Scalars['Int']['output'];
  /** Variante opcional dentro do `type`. NULL = variante default. */
  subType?: Maybe<TCustomDocumentSubType>;
  type: TDocumentType;
  /** Usado pelo cliente como `expectedUpdatedAt` no `updateCustomDocument` para detectar stale write. */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['ID']['output']>;
};

/** Variante opcional de um tipo de documento customizado. NULL = variante default. */
export enum TCustomDocumentSubType {
  /** FireBrigadeMeetingMinute — Em branco */
  FireBrigadeMeetingMinuteBlank = 'FireBrigadeMeetingMinuteBlank',
  /** IpeDelivery — Em branco */
  IpeDeliveryBlank = 'IpeDeliveryBlank',
  /** IpeDelivery — Última entrega */
  IpeDeliveryLastDelivery = 'IpeDeliveryLastDelivery',
  /** MeetingMinute — Em branco */
  MeetingMinuteBlank = 'MeetingMinuteBlank'
}

export type TCustomOrganization = {
  __typename?: 'CustomOrganization';
  /** ID da customização */
  id: Scalars['String']['output'];
  /** Tipo de customização */
  type: TCustomType;
  /** Valor da customização */
  value: Scalars['String']['output'];
};

export type TCustomOrganizationInput = {
  /** Tipo de customização */
  type: TCustomType;
  /** Valor da customização */
  value: Scalars['String']['input'];
};

/** Tipo de personalização */
export enum TCustomType {
  AiCertificatesToken = 'AiCertificatesToken',
  /** Entrega automática de EPI */
  AutoIpeDelivery = 'AutoIpeDelivery',
  /** Bloquear adicional */
  BlockAdditional = 'BlockAdditional',
  /** Dias para desconexão */
  DisconnectDays = 'DisconnectDays',
  ESocialDirect = 'ESocialDirect',
  /** Chave de reconhecimento facial */
  FaceRecognitionKey = 'FaceRecognitionKey',
  /** Segredo de reconhecimento facial */
  FaceRecognitionSecret = 'FaceRecognitionSecret',
  /** Período de inatividade */
  InactivePeriod = 'InactivePeriod',
  /** Estoque interno */
  InternalStock = 'InternalStock',
  /** Gestão local de treinamento (não envia necessidade ao RH) */
  LocalTrainingManagement = 'LocalTrainingManagement',
  /** Enviar notificação */
  SendNotify = 'SendNotify'
}

export type TCustomer = {
  __typename?: 'Customer';
  /** Endereço */
  address?: Maybe<Scalars['String']['output']>;
  /** Número do endereço */
  addressNumber?: Maybe<Scalars['String']['output']>;
  /** Forma de pagamento */
  billingType?: Maybe<TBillingMethod>;
  /** Nome da empresa */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Dados do cartão de crédito */
  creditCard?: Maybe<TCreditCard>;
  /** Número do documento */
  documentNumber?: Maybe<Scalars['String']['output']>;
  /** E-mails */
  emails: Array<TEmail>;
  /** Nome */
  name?: Maybe<Scalars['String']['output']>;
  /** Bairro */
  neighborhood?: Maybe<Scalars['String']['output']>;
  /** Telefone */
  phone?: Maybe<Scalars['String']['output']>;
  /** CEP */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Razão social */
  socialName?: Maybe<Scalars['String']['output']>;
};

export type TCustomerInput = {
  /** Endereço */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Número do endereço */
  addressNumber: Scalars['String']['input'];
  /** Forma de pagamento */
  billingType?: InputMaybe<TBillingMethod>;
  /** Nome da empresa */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Dados do cartão de crédito */
  creditCard?: InputMaybe<TAsaasCreditCardTokenInput>;
  /** Número do documento */
  documentNumber: Scalars['String']['input'];
  /** E-mails */
  emails: Array<TEmailInput>;
  /** Nome */
  name: Scalars['String']['input'];
  /** Bairro */
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  /** Telefone */
  phone: Scalars['String']['input'];
  /** CEP */
  postalCode: Scalars['String']['input'];
  /** Razão social */
  socialName?: InputMaybe<Scalars['String']['input']>;
};

export type TDashboardExport = {
  __typename?: 'DashboardExport';
  /** Lista de exportações */
  items: Array<TExportStatus>;
  /** Total de exportações retornadas */
  total: Scalars['Int']['output'];
};

export type TData = {
  __typename?: 'Data';
  /** Rótulo */
  label: Scalars['String']['output'];
  /** Resultado */
  result: Scalars['Float']['output'];
};

export type TDataCharts = {
  __typename?: 'DataCharts';
  /** Dados */
  data: Array<TData>;
};

export type TDataLogin = {
  __typename?: 'DataLogin';
  /** Dados do funcionário */
  person: TEmployee;
};

export type TDateRange = {
  /** Data máxima */
  max?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data mínima */
  min?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Dia da semana */
export enum TDayOfWeek {
  /** Sexta-feira */
  Friday = 'Friday',
  /** Segunda-feira */
  Monday = 'Monday',
  /** Sábado */
  Saturday = 'Saturday',
  /** Domingo */
  Sunday = 'Sunday',
  /** Quinta-feira */
  Thursday = 'Thursday',
  /** Terça-feira */
  Tuesday = 'Tuesday',
  /** Quarta-feira */
  Wednesday = 'Wednesday'
}

export type TDaysAbsentChart = {
  __typename?: 'DaysAbsentChart';
  /** Dados de dias médios */
  averageDayData: Array<TData>;
  /** Possui atestado */
  hasCertificate: Scalars['Boolean']['output'];
  /** Tempo perdido */
  lostTime: Array<TData>;
  /** Dados de contagem de pessoas */
  peopleCountData: Array<TData>;
};

export type TDaysLostWithIcdChart = {
  __typename?: 'DaysLostWithIcdChart';
  /** Quantidade de atestados com CID */
  certificateCount: Scalars['Float']['output'];
  /** Indica se há atestados com CID no período */
  hasCertificate: Scalars['Boolean']['output'];
  /** Total de dias perdidos em atestados com CID */
  totalDays: Scalars['Float']['output'];
};

export type TDaysLostWithoutIcdChart = {
  __typename?: 'DaysLostWithoutIcdChart';
  /** Quantidade de atestados sem CID */
  certificateCount: Scalars['Float']['output'];
  /** Indica se há atestados sem CID no período */
  hasCertificate: Scalars['Boolean']['output'];
  /** Total de dias perdidos em atestados sem CID */
  totalDays: Scalars['Float']['output'];
};

export type TDaysWithoutAccidentChart = {
  __typename?: 'DaysWithoutAccidentChart';
  /** Dias desde o último acidente */
  lastAccident: Scalars['Float']['output'];
  /** Percentual de dias sem acidentes */
  percentual: Scalars['Float']['output'];
  /** Recorde de dias sem acidentes */
  record: Scalars['Float']['output'];
};

export type TDefaultRecipientUserDto = {
  __typename?: 'DefaultRecipientUserDto';
  /** E-mail do usuário */
  email: Scalars['String']['output'];
  /** Nome do usuário */
  name: Scalars['String']['output'];
  /** Cargo MDT (ex.: engineer, technician) */
  roleId: Scalars['String']['output'];
  /** Rótulo do cargo em pt-BR */
  roleLabel: Scalars['String']['output'];
};

export type TDeficienciesChart = {
  __typename?: 'DeficienciesChart';
  /** Possui deficiências */
  hasDeficiencies: Scalars['Boolean']['output'];
  /** Auditiva */
  hearing: Scalars['Float']['output'];
  /** Intelectual */
  intellectual: Scalars['Float']['output'];
  /** Mental */
  mental: Scalars['Float']['output'];
  /** Física */
  physical: Scalars['Float']['output'];
  /** Psicossocial */
  psychosocial: Scalars['Float']['output'];
  /** Reabilitado */
  rehabilitated: Scalars['Float']['output'];
  /** Fala */
  speech: Scalars['Float']['output'];
  /** Visual */
  visual: Scalars['Float']['output'];
};

export type TDeficiency = {
  __typename?: 'Deficiency';
  /** Anexos */
  attachments?: Maybe<Array<TAttachment>>;
  /** Data da deficiência */
  date: Scalars['DateTime']['output'];
  /** Origem da deficiência */
  deficiencyOrigin?: Maybe<TDeficiencyOrigin>;
  /** Identificador no ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** CID */
  icd?: Maybe<TIcd>;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Impedimentos causados */
  impediments?: Maybe<Scalars['String']['output']>;
  /** Limitações causadas */
  limitations?: Maybe<Scalars['String']['output']>;
  /** Identificador do registro médico */
  medicalRecordId: Scalars['String']['output'];
  /** Observação sobre a deficiência */
  observation?: Maybe<Scalars['String']['output']>;
  /** Data de recuperação */
  recoveryDate?: Maybe<Scalars['DateTime']['output']>;
  /** Tipo de deficiência */
  type: TDeficiencyType;
  /** Tipo de deficiência intelectual */
  typeIntellectualDeficiency?: Maybe<TTypeIntellectualDeficiency>;
  /** Tipo de deficiência física */
  typePhysicalDeficiency?: Maybe<TTypePhysicalDeficiency>;
  /** Tipo de deficiência visual */
  typeVisualDeficiency?: Maybe<TTypeVisualDeficiency>;
  /** Especificação da deficiência visual */
  visualDeficiencySpecification?: Maybe<TVisualDeficiencySpecification>;
};

export type TDeficiencyInput = {
  /** Data da deficiência */
  date: Scalars['DateTime']['input'];
  /** Origem da deficiência */
  deficiencyOrigin?: InputMaybe<TDeficiencyOrigin>;
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do CID */
  icdId?: InputMaybe<Scalars['String']['input']>;
  /** Impedimentos causados */
  impediments?: InputMaybe<Scalars['String']['input']>;
  /** Limitações causadas */
  limitations?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do registro médico */
  medicalRecordId: Scalars['String']['input'];
  /** Observação sobre a deficiência */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Data de recuperação */
  recoveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Tipo de deficiência */
  type: TDeficiencyType;
  /** Tipo de deficiência intelectual */
  typeIntellectualDeficiency?: InputMaybe<TTypeIntellectualDeficiency>;
  /** Tipo de deficiência física */
  typePhysicalDeficiency?: InputMaybe<TTypePhysicalDeficiency>;
  /** Tipo de deficiência visual */
  typeVisualDeficiency?: InputMaybe<TTypeVisualDeficiency>;
  /** Especificação da deficiência visual */
  visualDeficiencySpecification?: InputMaybe<TVisualDeficiencySpecification>;
};

/** Origem da deficiência */
export enum TDeficiencyOrigin {
  /** Adquirida após cirurgia */
  AcquiredAfterSurgery = 'AcquiredAfterSurgery',
  /** Acidente comum */
  CommonAccident = 'CommonAccident',
  /** Doença comum */
  CommonDisease = 'CommonDisease',
  /** Congênita */
  Congenital = 'Congenital',
  /** Acidente ou doença ocupacional */
  OccupationalAccidentOrDisease = 'OccupationalAccidentOrDisease'
}

/** Tipo de deficiência */
export enum TDeficiencyType {
  /** Auditiva */
  Hearing = 'Hearing',
  /** Intelectual */
  Intellectual = 'Intellectual',
  /** Mental */
  Mental = 'Mental',
  /** Física */
  Physical = 'Physical',
  /** Psicossocial */
  Psychosocial = 'Psychosocial',
  /** Reabilitado */
  Rehabilitated = 'Rehabilitated',
  /** Fala */
  Speech = 'Speech',
  /** Visual */
  Visual = 'Visual'
}

export type TDeficiencyUpdate = {
  /** Data da deficiência */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Origem da deficiência */
  deficiencyOrigin?: InputMaybe<TDeficiencyOrigin>;
  /** Identificador do CID */
  icdId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Impedimentos causados */
  impediments?: InputMaybe<Scalars['String']['input']>;
  /** Limitações causadas */
  limitations?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do registro médico */
  medicalRecordId?: InputMaybe<Scalars['String']['input']>;
  /** Observação sobre a deficiência */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Data de recuperação */
  recoveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Tipo de deficiência */
  type?: InputMaybe<TDeficiencyType>;
  /** Tipo de deficiência intelectual */
  typeIntellectualDeficiency?: InputMaybe<TTypeIntellectualDeficiency>;
  /** Tipo de deficiência física */
  typePhysicalDeficiency?: InputMaybe<TTypePhysicalDeficiency>;
  /** Tipo de deficiência visual */
  typeVisualDeficiency?: InputMaybe<TTypeVisualDeficiency>;
  /** Especificação da deficiência visual */
  visualDeficiencySpecification?: InputMaybe<TVisualDeficiencySpecification>;
};

/** Grau de risco de incêndio */
export enum TDegreeOfFire {
  /** Alto */
  High = 'High',
  /** Baixo */
  Low = 'Low',
  /** Médio */
  Medium = 'Medium'
}

export type TDeliveredIpesParams = {
  __typename?: 'DeliveredIpesParams';
  /** Identificador do centro de custo para filtro */
  costCenterId?: Maybe<Scalars['String']['output']>;
  /** Rodapé personalizado */
  footer?: Maybe<Scalars['String']['output']>;
  /** Data inicial do período */
  fromDate: Scalars['DateTime']['output'];
  /** Identificador do cargo para filtro */
  occupationId?: Maybe<Scalars['String']['output']>;
  /** Data final do período */
  toDate: Scalars['DateTime']['output'];
};

export type TDeliveredIpesReport = {
  __typename?: 'DeliveredIpesReport';
  /** Endereço da empresa */
  address: Scalars['String']['output'];
  /** CNPJ da empresa */
  cnpj: Scalars['String']['output'];
  /** Nome da empresa */
  companyName: Scalars['String']['output'];
  /** Centros de custo com entregas de IPE */
  costCenters: Array<TCostCenterGroup>;
  /** Rodapé do relatório */
  footer: Scalars['String']['output'];
  /** Telefone da empresa */
  telephone: Scalars['String']['output'];
};

export type TDeliveredProductsParams = {
  __typename?: 'DeliveredProductsParams';
  /** Identificador do centro de custo */
  costCenterId?: Maybe<Scalars['String']['output']>;
  /** Data inicial */
  fromDate: Scalars['DateTime']['output'];
  /** Identificador da ocupação */
  occupationId?: Maybe<Scalars['String']['output']>;
  /** Data final */
  toDate: Scalars['DateTime']['output'];
};

export type TDeliveredSparePartsParams = {
  __typename?: 'DeliveredSparePartsParams';
  costCenterId?: Maybe<Scalars['String']['output']>;
  fromDate: Scalars['DateTime']['output'];
  occupationId?: Maybe<Scalars['String']['output']>;
  toDate: Scalars['DateTime']['output'];
};

/** Filtro de entregas */
export enum TDeliveryFilter {
  /** Em branco */
  Blank = 'Blank',
  /** Histórico */
  History = 'History',
  /** Última entrega */
  LastDelivery = 'LastDelivery',
  /** Não assinadas */
  Unsigned = 'Unsigned'
}

/** Motivo da entrega de EPI */
export enum TDeliveryReason {
  /** Admissional */
  Admissional = 'Admissional',
  /** Dano */
  Damage = 'Damage',
  /** Defeito */
  Defect = 'Defect',
  /** Demissional */
  Demissional = 'Demissional',
  /** Teste dielétrico */
  DielectricTest = 'DielectricTest',
  /** Mudança de função */
  FunctionChange = 'FunctionChange',
  /** Perda */
  Loss = 'Loss',
  /** Prescrição médica */
  MedicalPrescription = 'MedicalPrescription',
  /** Outro */
  Other = 'Other',
  /** Higienização */
  Sanitation = 'Sanitation',
  /** Roubo */
  Theft = 'Theft',
  /** Desgaste */
  Wear = 'Wear'
}

export type TDeliverySpareParts = {
  __typename?: 'DeliverySpareParts';
  /** Quantidade entregue */
  amount: Scalars['Float']['output'];
  /** Quantidade devolvida */
  amountReturned?: Maybe<Scalars['Float']['output']>;
  /** Identificador da filial */
  branch: Scalars['String']['output'];
  /** Data da entrega */
  deliveryDate: Scalars['DateTime']['output'];
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Entrega de IPE */
  ipeDelivery: TIpeDelivery;
  /** Identificador da entrega de IPE */
  ipeDeliveryId: Scalars['String']['output'];
  /** Indica se foi descartado */
  isDiscarted: Scalars['Boolean']['output'];
  /** Data de emissão */
  issueDate?: Maybe<Scalars['DateTime']['output']>;
  /** Número do lote */
  lotNumber?: Maybe<Scalars['String']['output']>;
  /** Produto */
  product: TProduct;
  /** Identificador do produto */
  productId: Scalars['String']['output'];
  /** Número do lote devolvido */
  returnedLotNumber?: Maybe<Scalars['String']['output']>;
  /** Identificador do produto devolvido */
  returnedProductId?: Maybe<Scalars['String']['output']>;
  /** Identificador do armazém de devolução */
  returnedWarehouseId?: Maybe<Scalars['String']['output']>;
  /** Movimentações de estoque */
  stockMovement?: Maybe<Array<TStockMovement>>;
  /** Armazém */
  warehouse: TWarehouse;
  /** Identificador do armazém */
  warehouseId: Scalars['String']['output'];
};

export type TDeliverySparePartsInput = {
  /** Quantidade entregue */
  amount: Scalars['Float']['input'];
  /** Quantidade devolvida */
  amountReturned?: InputMaybe<Scalars['Float']['input']>;
  /** Data da entrega */
  deliveryDate: Scalars['DateTime']['input'];
  /** Identificador da entrega de IPE */
  ipeDeliveryId: Scalars['String']['input'];
  /** Indica se foi descartado */
  isDiscarted: Scalars['Boolean']['input'];
  /** Data de emissão */
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Número do lote */
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do produto */
  productId: Scalars['String']['input'];
  /** Número do lote devolvido */
  returnedLotNumber?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do produto devolvido */
  returnedProductId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do armazém de devolução */
  returnedWarehouseId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do armazém */
  warehouseId: Scalars['String']['input'];
};

export type TDeliverySparePartsParams = {
  __typename?: 'DeliverySparePartsParams';
  /** Filtro de entrega */
  filter?: Maybe<TDeliveryFilter>;
  /** Indica se é verificação */
  isCheck?: Maybe<Scalars['Boolean']['output']>;
  /** Declaração de responsabilidade */
  statementsResponsibility?: Maybe<Scalars['String']['output']>;
};

export type TDeliverySparePartsReport = {
  __typename?: 'DeliverySparePartsReport';
  address: Scalars['String']['output'];
  admission?: Maybe<Scalars['String']['output']>;
  cnpj: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  costCenter?: Maybe<Scalars['String']['output']>;
  footer: Scalars['String']['output'];
  generalRegistration?: Maybe<Scalars['String']['output']>;
  individualRegistration: Scalars['String']['output'];
  name: Scalars['String']['output'];
  occupation?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Scalars['String']['output']>;
  sparePartBiometry?: Maybe<TIpeBiometry>;
  sparePartFace?: Maybe<TIpeFace>;
  spareParts: Array<TSparePartsReport>;
  statement: Scalars['String']['output'];
  telephone: Scalars['String']['output'];
};

export type TDeliverySparePartsUpdate = {
  /** Quantidade entregue */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Quantidade devolvida */
  amountReturned?: InputMaybe<Scalars['Float']['input']>;
  /** Data da entrega */
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Identificador da entrega de IPE */
  ipeDeliveryId?: InputMaybe<Scalars['String']['input']>;
  /** Indica se foi descartado */
  isDiscarted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Data de emissão */
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Número do lote */
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do produto */
  productId?: InputMaybe<Scalars['String']['input']>;
  /** Número do lote devolvido */
  returnedLotNumber?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do produto devolvido */
  returnedProductId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do armazém de devolução */
  returnedWarehouseId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do armazém */
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

/** Densidade */
export enum TDensityEnum {
  /** 1.000 */
  OneThousand = 'OneThousand',
  /** 1.015 */
  OneThousandFifteen = 'OneThousandFifteen',
  /** 1.005 */
  OneThousandFive = 'OneThousandFive',
  /** 1.010 */
  OneThousandTen = 'OneThousandTen',
  /** 1.030 */
  OneThousandTirty = 'OneThousandTirty',
  /** 1.025 */
  OneThousandTwentiFive = 'OneThousandTwentiFive',
  /** 1.020 */
  OneThousandTwenty = 'OneThousandTwenty'
}

export type TDepartment = {
  __typename?: 'Department';
  /** Descrição do departamento */
  description: Scalars['String']['output'];
  /** Identificador no ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Indica se está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Sugestão de uso */
  suggestion?: Maybe<Scalars['String']['output']>;
};

export type TDepartmentByRisk = {
  __typename?: 'DepartmentByRisk';
  /** Departamento vinculado ao risco */
  department: TDepartment;
  /** ID da relação */
  id: Scalars['String']['output'];
};

export type TDepartmentByRiskInput = {
  /** ID do departamento */
  departmentId: Scalars['String']['input'];
  /** ID do risco */
  riskId: Scalars['String']['input'];
};

export type TDepartmentInput = {
  /** Descrição do departamento */
  description: Scalars['String']['input'];
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da filial de destino */
  targetBranchId?: InputMaybe<Scalars['String']['input']>;
};

export type TDepartmentIntegration = {
  /** Identificador da filial */
  branch: Scalars['String']['input'];
  /** Descrição do departamento */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único */
  id?: InputMaybe<Scalars['String']['input']>;
};

export type TDepartmentOnMandate = {
  __typename?: 'DepartmentOnMandate';
  /** Departamento */
  department: TDepartment;
  /** Identificador */
  id: Scalars['String']['output'];
};

export type TDepartmentOnMandateInput = {
  /** Identificador do departamento */
  departmentId: Scalars['String']['input'];
};

export type TDepartmentOnRiskInput = {
  /** ID do departamento */
  departmentId: Scalars['String']['input'];
};

export type TDepartmentUpdate = {
  /** Descrição do departamento */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Indica se está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TDependent = {
  __typename?: 'Dependent';
  /** Data de nascimento */
  birthday: Scalars['DateTime']['output'];
  /** Identificador no ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** Gênero */
  gender: TGender;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Matrícula individual */
  individualRegistration?: Maybe<Scalars['String']['output']>;
  /** Nome do dependente */
  name: Scalars['String']['output'];
  /** Pessoa */
  person: TPerson;
};

export type TDependentByPerson = {
  __typename?: 'DependentByPerson';
  /** Data de nascimento */
  birthday: Scalars['DateTime']['output'];
  /** Identificador no ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** Gênero */
  gender: TGender;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Matrícula individual */
  individualRegistration?: Maybe<Scalars['String']['output']>;
  /** Nome do dependente */
  name: Scalars['String']['output'];
};

export type TDependentInput = {
  /** Data de nascimento */
  birthday: Scalars['DateTime']['input'];
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Gênero */
  gender: TGender;
  /** Matrícula individual */
  individualRegistration?: InputMaybe<Scalars['String']['input']>;
  /** Nome do dependente */
  name: Scalars['String']['input'];
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
};

export type TDependentOnPersonInput = {
  /** Data de nascimento */
  birthday: Scalars['DateTime']['input'];
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Gênero */
  gender: TGender;
  /** Identificador único */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Matrícula individual */
  individualRegistration?: InputMaybe<Scalars['String']['input']>;
  /** Nome do dependente */
  name: Scalars['String']['input'];
};

export type TDependentOnPersonRemove = {
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Matrícula individual */
  individualRegistration?: InputMaybe<Scalars['String']['input']>;
  /** Nome do dependente */
  name: Scalars['String']['input'];
};

export type TDependentOnPersonUpdate = {
  /** Dependentes a criar */
  toCreate: Array<TDependentOnPersonInput>;
  /** Dependentes a remover */
  toRemove: Array<TDependentOnPersonRemove>;
  /** Dependentes a atualizar */
  toUpdate: Array<TDependentOnPersonInput>;
};

export type TDependentUpdate = {
  /** Data de nascimento */
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Gênero */
  gender?: InputMaybe<TGender>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Matrícula individual */
  individualRegistration?: InputMaybe<Scalars['String']['input']>;
  /** Nome do dependente */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
};

/** Versão do design (layout) utilizada pelo usuário */
export enum TDesignVersion {
  /** Layout v1 (legado) */
  V1 = 'v1',
  /** Layout v2 (novo) */
  V2 = 'v2'
}

export type TDiagnostic = {
  __typename?: 'Diagnostic';
  /** Indica se há etilismo */
  alcoholism?: Maybe<Scalars['Boolean']['output']>;
  /** Frequência do etilismo */
  alcoholismFrequency?: Maybe<Scalars['String']['output']>;
  /** Período de etilismo */
  alcoholismPeriod?: Maybe<Scalars['String']['output']>;
  /** Tipo de etilismo */
  alcoholismType?: Maybe<Scalars['String']['output']>;
  /** Quantidade consumida */
  amountConsumed?: Maybe<Scalars['Float']['output']>;
  /** Atendimento */
  attendance?: Maybe<Scalars['String']['output']>;
  /** Indica se é portador de doenças crônicas ou está em tratamento */
  chronicDiseaseOrTreatment?: Maybe<Scalars['Boolean']['output']>;
  /** Detalhes de doenças crônicas ou tratamentos em andamento */
  chronicDiseaseOrTreatmentDetails?: Maybe<Scalars['String']['output']>;
  /** Queixa */
  complaint?: Maybe<Scalars['String']['output']>;
  /** Consulta */
  consultation: TConsultation;
  /** Indica se usa medicamento controlado */
  controlledMedication?: Maybe<Scalars['Boolean']['output']>;
  /** Detalhes do medicamento controlado */
  controlledMedicationDetails?: Maybe<Scalars['String']['output']>;
  /** Indica se tem diabetes */
  diabetes: Scalars['Boolean']['output'];
  /** Diagnóstico */
  diagnostic: Scalars['String']['output'];
  /** Data do diagnóstico */
  diagnosticDate: Scalars['DateTime']['output'];
  /** Medicamentos do diagnóstico */
  diagnosticMedicine?: Maybe<Array<TMedicineOnDiagnostic>>;
  /** Pressão diastólica */
  diastolicPressure?: Maybe<Scalars['Float']['output']>;
  /** Altura */
  height?: Maybe<Scalars['Float']['output']>;
  /** Indica se faz tratamento para hipertensão */
  hypertensionTreatment: Scalars['Boolean']['output'];
  /** CID */
  icd?: Maybe<TIcd>;
  /** Grupo do CID */
  icdGroup?: Maybe<TIcdGroup>;
  /** Identificador do grupo do CID */
  icdGroupId?: Maybe<Scalars['String']['output']>;
  /** Identificador do CID */
  icdId?: Maybe<Scalars['String']['output']>;
  /** CIDs complementares */
  icds?: Maybe<Array<TComplementaryIcdOnDiagnostic>>;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Indica se realiza acompanhamento de saúde mental */
  mentalHealthFollowUp?: Maybe<Scalars['Boolean']['output']>;
  /** Frequência do acompanhamento de saúde mental */
  mentalHealthFollowUpFrequency?: Maybe<Scalars['String']['output']>;
  /** Há quanto tempo realiza acompanhamento de saúde mental */
  mentalHealthFollowUpPeriod?: Maybe<Scalars['String']['output']>;
  /** Indica se pratica atividade física */
  physicalActivity?: Maybe<Scalars['Boolean']['output']>;
  /** Frequência da atividade física */
  physicalActivityFrequency?: Maybe<Scalars['String']['output']>;
  /** Atividade física mais praticada */
  physicalActivityMain?: Maybe<Scalars['String']['output']>;
  /** Pulso */
  pulse?: Maybe<Scalars['Float']['output']>;
  /** Indica se é fumante */
  smoker: Scalars['Boolean']['output'];
  /** Pressão sistólica */
  systolicPressure?: Maybe<Scalars['Float']['output']>;
  /** Período de tabagismo */
  tamagistPeriod?: Maybe<Scalars['Float']['output']>;
  /** Temperatura */
  temperature?: Maybe<Scalars['Float']['output']>;
  /** Peso */
  weight?: Maybe<Scalars['Float']['output']>;
};

export type TDiagnosticComplementaryIcd = {
  __typename?: 'DiagnosticComplementaryIcd';
  /** Diagnóstico */
  diagnostic: TDiagnostic;
  /** CID */
  icd: TIcd;
  /** Grupo do CID */
  icdGroup: TIcdGroup;
  /** Identificador único */
  id: Scalars['String']['output'];
};

export type TDiagnosticComplementaryIcdInput = {
  /** Identificador da filial */
  branch: Scalars['String']['input'];
  /** Identificador do diagnóstico */
  diagnosticId: Scalars['String']['input'];
  /** Identificador do grupo do CID */
  icdGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do CID */
  icdId?: InputMaybe<Scalars['String']['input']>;
};

export type TDiagnosticInput = {
  /** Indica se há etilismo */
  alcoholism?: InputMaybe<Scalars['Boolean']['input']>;
  /** Frequência do etilismo */
  alcoholismFrequency?: InputMaybe<Scalars['String']['input']>;
  /** Período de etilismo */
  alcoholismPeriod?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de etilismo */
  alcoholismType?: InputMaybe<Scalars['String']['input']>;
  /** Quantidade consumida */
  amountConsumed?: InputMaybe<Scalars['Float']['input']>;
  /** Atendimento */
  attendance?: InputMaybe<Scalars['String']['input']>;
  /** Indica se é portador de doenças crônicas ou está em tratamento */
  chronicDiseaseOrTreatment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Detalhes de doenças crônicas ou tratamentos em andamento */
  chronicDiseaseOrTreatmentDetails?: InputMaybe<Scalars['String']['input']>;
  /** Queixa */
  complaint?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da consulta */
  consultationId: Scalars['String']['input'];
  /** Indica se usa medicamento controlado */
  controlledMedication?: InputMaybe<Scalars['Boolean']['input']>;
  /** Detalhes do medicamento controlado */
  controlledMedicationDetails?: InputMaybe<Scalars['String']['input']>;
  /** Indica se tem diabetes */
  diabetes: Scalars['Boolean']['input'];
  /** Diagnóstico */
  diagnostic: Scalars['String']['input'];
  /** Data do diagnóstico */
  diagnosticDate: Scalars['DateTime']['input'];
  /** Pressão diastólica */
  diastolicPressure?: InputMaybe<Scalars['Float']['input']>;
  /** Altura */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** Indica se faz tratamento para hipertensão */
  hypertensionTreatment: Scalars['Boolean']['input'];
  /** Identificador do grupo do CID */
  icdGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do CID */
  icdId?: InputMaybe<Scalars['String']['input']>;
  /** CIDs complementares */
  icds?: InputMaybe<Array<TComplementaryIcdOnDiagnosticInput>>;
  /** Medicamentos */
  medicines?: InputMaybe<Array<TMedicineOnDiagnosticInput>>;
  /** Indica se realiza acompanhamento de saúde mental */
  mentalHealthFollowUp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Frequência do acompanhamento de saúde mental */
  mentalHealthFollowUpFrequency?: InputMaybe<Scalars['String']['input']>;
  /** Há quanto tempo realiza acompanhamento de saúde mental */
  mentalHealthFollowUpPeriod?: InputMaybe<Scalars['String']['input']>;
  /** Indica se pratica atividade física */
  physicalActivity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Frequência da atividade física */
  physicalActivityFrequency?: InputMaybe<Scalars['String']['input']>;
  /** Atividade física mais praticada */
  physicalActivityMain?: InputMaybe<Scalars['String']['input']>;
  /** Pulso */
  pulse?: InputMaybe<Scalars['Float']['input']>;
  /** Indica se é fumante */
  smoker: Scalars['Boolean']['input'];
  /** Pressão sistólica */
  systolicPressure?: InputMaybe<Scalars['Float']['input']>;
  /** Período de tabagismo */
  tamagistPeriod?: InputMaybe<Scalars['Float']['input']>;
  /** Temperatura */
  temperature?: InputMaybe<Scalars['Float']['input']>;
  /** Peso */
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type TDiagnosticMedicine = {
  __typename?: 'DiagnosticMedicine';
  /** Quantidade */
  amount: Scalars['Float']['output'];
  /** Diagnóstico */
  diagnostic: TDiagnostic;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Unidade de medida */
  measurementUnit?: Maybe<TMedicineMeasurementUnit>;
  /** Medicamento */
  medicine: TMedicine;
  /** Posologia */
  posology?: Maybe<Scalars['String']['output']>;
  /** Indica se exibe na prescrição */
  showsInPrescription: Scalars['Boolean']['output'];
};

export type TDiagnosticMedicineInput = {
  /** Quantidade */
  amount: Scalars['Float']['input'];
  /** Identificador do diagnóstico */
  diagnosticId: Scalars['String']['input'];
  /** Unidade de medida */
  measurementUnit?: InputMaybe<TMedicineMeasurementUnit>;
  /** Identificador do medicamento */
  medicineId: Scalars['String']['input'];
  /** Posologia */
  posology?: InputMaybe<Scalars['String']['input']>;
  /** Indica se exibe na prescrição */
  showsInPrescription: Scalars['Boolean']['input'];
};

export type TDiagnosticOptional = {
  /** Indica se há etilismo */
  alcoholism?: InputMaybe<Scalars['Boolean']['input']>;
  /** Frequência do etilismo */
  alcoholismFrequency?: InputMaybe<Scalars['String']['input']>;
  /** Período de etilismo */
  alcoholismPeriod?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de etilismo */
  alcoholismType?: InputMaybe<Scalars['String']['input']>;
  /** Quantidade consumida */
  amountConsumed?: InputMaybe<Scalars['Float']['input']>;
  /** Atendimento */
  attendance?: InputMaybe<Scalars['String']['input']>;
  /** Indica se é portador de doenças crônicas ou está em tratamento */
  chronicDiseaseOrTreatment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Detalhes de doenças crônicas ou tratamentos em andamento */
  chronicDiseaseOrTreatmentDetails?: InputMaybe<Scalars['String']['input']>;
  /** Queixa */
  complaint?: InputMaybe<Scalars['String']['input']>;
  /** Indica se usa medicamento controlado */
  controlledMedication?: InputMaybe<Scalars['Boolean']['input']>;
  /** Detalhes do medicamento controlado */
  controlledMedicationDetails?: InputMaybe<Scalars['String']['input']>;
  /** Indica se tem diabetes */
  diabetes: Scalars['Boolean']['input'];
  /** Diagnóstico */
  diagnostic: Scalars['String']['input'];
  /** Pressão diastólica */
  diastolicPressure?: InputMaybe<Scalars['Float']['input']>;
  /** Altura */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** Indica se faz tratamento para hipertensão */
  hypertensionTreatment: Scalars['Boolean']['input'];
  /** Identificador do grupo do CID */
  icdGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do CID */
  icdId?: InputMaybe<Scalars['String']['input']>;
  /** Indica se realiza acompanhamento de saúde mental */
  mentalHealthFollowUp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Frequência do acompanhamento de saúde mental */
  mentalHealthFollowUpFrequency?: InputMaybe<Scalars['String']['input']>;
  /** Há quanto tempo realiza acompanhamento de saúde mental */
  mentalHealthFollowUpPeriod?: InputMaybe<Scalars['String']['input']>;
  /** Indica se pratica atividade física */
  physicalActivity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Frequência da atividade física */
  physicalActivityFrequency?: InputMaybe<Scalars['String']['input']>;
  /** Atividade física mais praticada */
  physicalActivityMain?: InputMaybe<Scalars['String']['input']>;
  /** Pulso */
  pulse?: InputMaybe<Scalars['Float']['input']>;
  /** Indica se é fumante */
  smoker: Scalars['Boolean']['input'];
  /** Pressão sistólica */
  systolicPressure?: InputMaybe<Scalars['Float']['input']>;
  /** Período de tabagismo */
  tamagistPeriod?: InputMaybe<Scalars['Float']['input']>;
  /** Temperatura */
  temperature?: InputMaybe<Scalars['Float']['input']>;
  /** Peso */
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type TDiagnosticUpdate = {
  /** Indica se há etilismo */
  alcoholism?: InputMaybe<Scalars['Boolean']['input']>;
  /** Frequência do etilismo */
  alcoholismFrequency?: InputMaybe<Scalars['String']['input']>;
  /** Período de etilismo */
  alcoholismPeriod?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de etilismo */
  alcoholismType?: InputMaybe<Scalars['String']['input']>;
  /** Quantidade consumida */
  amountConsumed?: InputMaybe<Scalars['Float']['input']>;
  /** Atendimento */
  attendance?: InputMaybe<Scalars['String']['input']>;
  /** Indica se é portador de doenças crônicas ou está em tratamento */
  chronicDiseaseOrTreatment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Detalhes de doenças crônicas ou tratamentos em andamento */
  chronicDiseaseOrTreatmentDetails?: InputMaybe<Scalars['String']['input']>;
  /** Queixa */
  complaint?: InputMaybe<Scalars['String']['input']>;
  /** Indica se usa medicamento controlado */
  controlledMedication?: InputMaybe<Scalars['Boolean']['input']>;
  /** Detalhes do medicamento controlado */
  controlledMedicationDetails?: InputMaybe<Scalars['String']['input']>;
  /** Indica se tem diabetes */
  diabetes: Scalars['Boolean']['input'];
  /** Diagnóstico */
  diagnostic: Scalars['String']['input'];
  /** Pressão diastólica */
  diastolicPressure?: InputMaybe<Scalars['Float']['input']>;
  /** Altura */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** Indica se faz tratamento para hipertensão */
  hypertensionTreatment: Scalars['Boolean']['input'];
  /** Identificador do grupo do CID */
  icdGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do CID */
  icdId?: InputMaybe<Scalars['String']['input']>;
  /** Atualizações nos CIDs complementares */
  icds?: InputMaybe<TComplementaryIcdOnDiagnosticUpdate>;
  /** Identificador único do diagnóstico */
  id: Scalars['String']['input'];
  /** Alterações nos medicamentos */
  medicines?: InputMaybe<TMedicineOnDiagnosticChanges>;
  /** Indica se realiza acompanhamento de saúde mental */
  mentalHealthFollowUp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Frequência do acompanhamento de saúde mental */
  mentalHealthFollowUpFrequency?: InputMaybe<Scalars['String']['input']>;
  /** Há quanto tempo realiza acompanhamento de saúde mental */
  mentalHealthFollowUpPeriod?: InputMaybe<Scalars['String']['input']>;
  /** Indica se pratica atividade física */
  physicalActivity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Frequência da atividade física */
  physicalActivityFrequency?: InputMaybe<Scalars['String']['input']>;
  /** Atividade física mais praticada */
  physicalActivityMain?: InputMaybe<Scalars['String']['input']>;
  /** Pulso */
  pulse?: InputMaybe<Scalars['Float']['input']>;
  /** Indica se é fumante */
  smoker: Scalars['Boolean']['input'];
  /** Pressão sistólica */
  systolicPressure?: InputMaybe<Scalars['Float']['input']>;
  /** Período de tabagismo */
  tamagistPeriod?: InputMaybe<Scalars['Float']['input']>;
  /** Temperatura */
  temperature?: InputMaybe<Scalars['Float']['input']>;
  /** Peso */
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type TDimension = {
  __typename?: 'Dimension';
  /** Atual */
  actual: Scalars['Float']['output'];
  /** Extra */
  extra: Scalars['Float']['output'];
  /** Faltante */
  miss: Scalars['Float']['output'];
  /** Total */
  total: Scalars['Float']['output'];
};

export type TDivergingStackedBarChart = {
  __typename?: 'DivergingStackedBarChart';
  /** Dados */
  data: Array<Scalars['Float']['output']>;
  /** Nome */
  name: Scalars['String']['output'];
};

export type TDoctor = {
  __typename?: 'Doctor';
  document: Scalars['String']['output'];
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type TDoctorRqeEntry = {
  __typename?: 'DoctorRqeEntry';
  /** UF do conselho onde o RQE foi registrado */
  councilState?: Maybe<TState>;
  /** Anunciável em laudo no momento da assinatura. */
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  /** Número do RQE (apenas dígitos) */
  rqeNumber?: Maybe<Scalars['String']['output']>;
  /** Especialidade vinculada ao RQE */
  specialty?: Maybe<TMedicalSpecialty>;
};

export type TDoctorRqeEntryInput = {
  /** UF do conselho onde o RQE foi registrado */
  councilState: TState;
  /** Anunciável em laudo. Opcional no input — quando ausente, o backend assume true (todas as entries informadas no fluxo externo são anunciáveis por convenção). No fluxo interno o backend mapeia a partir de mdt.user_specialty.is_primary. */
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Número do RQE (apenas dígitos) */
  rqeNumber: Scalars['String']['input'];
  /** Especialidade vinculada ao RQE */
  specialty: TMedicalSpecialty;
};

/** Tipo de profissional de saúde */
export enum TDoctorType {
  /** Dentista */
  Dentist = 'Dentist',
  /** Médico */
  Doctor = 'Doctor',
  /** Fisioterapeuta */
  Physiotherapist = 'Physiotherapist',
  /** Psicólogo */
  Psychologist = 'Psychologist'
}

/** Classe de documento profissional */
export enum TDocumentClass {
  /** Conselho Regional de Engenharia e Agronomia */
  Crea = 'CREA',
  /** Conselho Regional de Medicina */
  Crm = 'CRM',
  /** Conselho Regional de Odontologia */
  Cro = 'CRO',
  /** Outro */
  Other = 'Other',
  /** Registro no Ministério da Saúde */
  Rms = 'RMS'
}

export type TDocumentFromEntityResponse = {
  __typename?: 'DocumentFromEntityResponse';
  entity: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  signedBy?: Maybe<Array<Scalars['String']['output']>>;
  signers?: Maybe<Array<Scalars['String']['output']>>;
  signinType?: Maybe<Scalars['String']['output']>;
  status: TDocumentStatus;
};

export type TDocumentObserver = {
  __typename?: 'DocumentObserver';
  email: Scalars['String']['output'];
};

export type TDocumentPending = {
  __typename?: 'DocumentPending';
  email: Scalars['String']['output'];
  isSigned: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type TDocumentPendingSigner = {
  __typename?: 'DocumentPendingSigner';
  action: TSignPublicationAction;
  email: Scalars['String']['output'];
  isEmbedded?: Maybe<Scalars['Boolean']['output']>;
  isPending: Scalars['Boolean']['output'];
};

export type TDocumentPermissions = {
  __typename?: 'DocumentPermissions';
  canCancel: Scalars['Boolean']['output'];
  canDelete: Scalars['Boolean']['output'];
  canDownloadDigital: Scalars['Boolean']['output'];
  canDownloadManifest: Scalars['Boolean']['output'];
  canDownloadOriginal: Scalars['Boolean']['output'];
  canResendEmails: Scalars['Boolean']['output'];
  canSign: Scalars['Boolean']['output'];
};

export type TDocumentSigner = {
  __typename?: 'DocumentSigner';
  data?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  isPrimary: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type TDocumentSignerDb = {
  __typename?: 'DocumentSignerDB';
  data?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  isPrimary: Scalars['Boolean']['output'];
};

/** Status do documento no TotvsSign */
export enum TDocumentStatus {
  AwaitingMySignature = 'AwaitingMySignature',
  Canceled = 'Canceled',
  Completed = 'Completed',
  Draft = 'Draft',
  PartiallySigned = 'PartiallySigned',
  Pending = 'Pending',
  Rejected = 'Rejected',
  Removed = 'Removed'
}

/** Tipos de documento customizáveis pelo Document Builder v2 (espelha SQL generic.document_type_enum). */
export enum TDocumentType {
  AcknowledgmentForm = 'AcknowledgmentForm',
  AudiometricExam = 'AudiometricExam',
  BiologicMonitoring = 'BiologicMonitoring',
  BiologicProtocol = 'BiologicProtocol',
  BiologicRelease = 'BiologicRelease',
  Cat = 'Cat',
  CipaActivityReport = 'CipaActivityReport',
  CipaApplicationForm = 'CipaApplicationForm',
  CipaCandidate = 'CipaCandidate',
  CipaElectionCall = 'CipaElectionCall',
  CipaElectionComission = 'CipaElectionComission',
  CipaElectionCommunication = 'CipaElectionCommunication',
  CipaElectionMinute = 'CipaElectionMinute',
  CipaInstallationOwnership = 'CipaInstallationOwnership',
  CipaMeetingPlanning = 'CipaMeetingPlanning',
  CipaRegistration = 'CipaRegistration',
  CipaRegistrationCall = 'CipaRegistrationCall',
  CipaVotingBallot = 'CipaVotingBallot',
  CipaVotingSheet = 'CipaVotingSheet',
  Consultation = 'Consultation',
  DeficiencyCharacterizationReport = 'DeficiencyCharacterizationReport',
  DeliveredIpes = 'DeliveredIpes',
  DiagnosticImageExam = 'DiagnosticImageExam',
  EmployeeWarning = 'EmployeeWarning',
  EquipmentReplacement = 'EquipmentReplacement',
  ExamsReferral = 'ExamsReferral',
  FireBrigadeMeetingMinute = 'FireBrigadeMeetingMinute',
  HealthInformationReport = 'HealthInformationReport',
  HidraulicInspection = 'HidraulicInspection',
  IbmpExam = 'IbmpExam',
  Inspection = 'Inspection',
  IpeDelivery = 'IpeDelivery',
  IpeDeliveryControl = 'IpeDeliveryControl',
  IpeDeliveryMedicalPrescription = 'IpeDeliveryMedicalPrescription',
  MedicalCertificate = 'MedicalCertificate',
  MedicalRecord = 'MedicalRecord',
  MedicalRecordVaccines = 'MedicalRecordVaccines',
  MedicalReferral = 'MedicalReferral',
  MeetingMinute = 'MeetingMinute',
  NormalExam = 'NormalExam',
  OccupationalCertificate = 'OccupationalCertificate',
  OtologicalExam = 'OtologicalExam',
  Ppp = 'Ppp',
  Prescription = 'Prescription',
  ProductDelivered = 'ProductDelivered',
  Quiz = 'Quiz',
  RiskMap = 'RiskMap',
  RiskMapByBranch = 'RiskMapByBranch',
  RiskReview = 'RiskReview',
  SafetyQuiz = 'SafetyQuiz',
  SecurityWorkOrder = 'SecurityWorkOrder',
  Sipat = 'Sipat',
  SparePartReplacement = 'SparePartReplacement',
  SparePartsDelivered = 'SparePartsDelivered',
  WorkPermission = 'WorkPermission'
}

export type TDocumentUser = {
  __typename?: 'DocumentUser';
  email: Scalars['String']['output'];
};

export type TDownloadSignedDocumentInput = {
  documentId: Scalars['Int']['input'];
  downloadType: TDownloadType;
  entity: TEntities;
};

/** Tipo de download do documento */
export enum TDownloadType {
  All = 'All',
  AllZip = 'AllZip',
  OriginalDocument = 'OriginalDocument',
  SignedDocument = 'SignedDocument',
  SignedDocumentWithCertificate = 'SignedDocumentWithCertificate'
}

export type TESocialDeliveriesParameters = {
  __typename?: 'ESocialDeliveriesParameters';
  /** Períodos de entrega */
  periods: Array<TESocialDeliveriesPeriod>;
};

export type TESocialDeliveriesPeriod = {
  __typename?: 'ESocialDeliveriesPeriod';
  /** Data inicial */
  fromDate: Scalars['String']['output'];
  /** Data final */
  toDate: Scalars['String']['output'];
};

export type TESocialFirstLoadInput = {
  /** Filial */
  branch: Scalars['String']['input'];
};

export type TESocialQueue = {
  __typename?: 'ESocialQueue';
  /** Filial */
  branch: Scalars['String']['output'];
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** Data de exclusão */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Erros do envio */
  errors?: Maybe<Array<TESocialQueueError>>;
  /** Histórico de processamento */
  histories?: Maybe<Array<TESocialQueueHistory>>;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Indica se está reenviando mensagens */
  isResendingMessages?: Maybe<Scalars['Boolean']['output']>;
  /** Mensagem XML */
  message: Scalars['String']['output'];
  /** Origem da mensagem */
  origin: TOriginMessage;
  /** Identificador da origem */
  originId: Scalars['String']['output'];
  /** Nome da pessoa */
  person?: Maybe<Scalars['String']['output']>;
  /** Número do recibo */
  receiptNumber?: Maybe<Scalars['String']['output']>;
  /** Data de envio */
  send: Scalars['DateTime']['output'];
  /** Status da mensagem */
  status: TStatusMessage;
  /** Descrição do status */
  statusDescription?: Maybe<Scalars['String']['output']>;
  /** Lote TAF */
  tafBatch?: Maybe<Scalars['String']['output']>;
  /** Data de atualização */
  updatedAt: Scalars['DateTime']['output'];
};

export type TESocialQueueAll = {
  __typename?: 'ESocialQueueAll';
  /** Quantidade total de registros */
  count: Scalars['Float']['output'];
  /** Dados paginados */
  data: TPaginatedESocialQueue;
  /** Indica se está reenviando mensagens */
  isResendingMessages?: Maybe<Scalars['Boolean']['output']>;
  /** Data de início do filtro */
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type TESocialQueueError = {
  __typename?: 'ESocialQueueError';
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** Código do erro */
  errorCode: Scalars['String']['output'];
  /** Descrição do erro */
  errorDescription?: Maybe<Scalars['String']['output']>;
  /** Detalhes do erro */
  errorDetails?: Maybe<Scalars['String']['output']>;
  /** Identificador único */
  id: Scalars['String']['output'];
};

export type TESocialQueueErrorInput = {
  /** Filial */
  branch: Scalars['String']['input'];
  /** Identificador da fila eSocial */
  eSocialQueueId?: InputMaybe<Scalars['String']['input']>;
  /** Código do erro */
  errorCode: Scalars['String']['input'];
  /** Descrição do erro */
  errorDescription?: InputMaybe<Scalars['String']['input']>;
  /** Detalhes do erro */
  errorDetails?: InputMaybe<Scalars['String']['input']>;
};

export type TESocialQueueFilter = {
  /** Filiais para filtrar */
  branch?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Eventos para filtrar */
  events?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Data inicial do filtro */
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Incluir eventos deletados */
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Pessoas para filtrar */
  people?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Status para filtrar */
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Data final do filtro */
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TESocialQueueHistory = {
  __typename?: 'ESocialQueueHistory';
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Mensagem do histórico */
  message: Scalars['String']['output'];
};

export type TESocialQueueIndicators = {
  __typename?: 'ESocialQueueIndicators';
  /** Quantidade de mensagens aguardando envio */
  awaitingSend: Scalars['Float']['output'];
  /** Quantidade concluídos */
  completed: Scalars['Float']['output'];
  /** Quantidade com erro */
  error: Scalars['Float']['output'];
  /** Quantidade processados */
  processed: Scalars['Float']['output'];
  /** Quantidade de envios */
  send: Scalars['Float']['output'];
};

export type TESocialQueueInput = {
  /** Filial */
  branch: Scalars['String']['input'];
  /** Erros do envio */
  errors?: InputMaybe<Array<TESocialQueueErrorInput>>;
  /** Evento de exclusão */
  exclusionEvent?: InputMaybe<TOriginMessage>;
  /** Mensagem XML */
  message: Scalars['String']['input'];
  /** Origem da mensagem */
  origin: TOriginMessage;
  /** Identificador da origem */
  originId: Scalars['String']['input'];
  /** Número do recibo */
  receiptNumber?: InputMaybe<Scalars['String']['input']>;
  /** Data de envio */
  send: Scalars['DateTime']['input'];
  /** Status da mensagem */
  status?: InputMaybe<TStatusMessage>;
  /** Lote TAF */
  tafBatch?: InputMaybe<Scalars['String']['input']>;
};

export type TESocialQueueUpdate = {
  /** Filial */
  branch: Scalars['String']['input'];
  /** Evento de exclusão */
  exclusionEvent?: InputMaybe<TOriginMessage>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Mensagem XML */
  message: Scalars['String']['input'];
  /** Origem da mensagem */
  origin: TOriginMessage;
  /** Identificador da origem */
  originId: Scalars['String']['input'];
  /** Data de envio */
  send: Scalars['DateTime']['input'];
  /** Status da mensagem */
  status?: InputMaybe<TStatusMessage>;
  /** Lote TAF */
  tafBatch?: InputMaybe<Scalars['String']['input']>;
};

export type TESocialResendMessages = {
  /** Identificadores das mensagens */
  ids: Array<Scalars['String']['input']>;
  /** Indica se está enviando */
  sending: Scalars['Boolean']['input'];
};

/** Status de protocolo dos eventos RH (S-2190/S-2200) no eSocial */
export enum TESocialRhEventStatus {
  /** Recepcionado pelo eSocial */
  Confirmed = 'Confirmed',
  /** Pendente no eSocial */
  Pending = 'Pending',
  /** Não identificado */
  Unknown = 'Unknown'
}

/** Status do eSocial */
export enum TESocialStatus {
  /** Não se aplica */
  Na = 'NA',
  /** Produção */
  Production = 'Production',
  /** Restrito */
  Restrict = 'Restrict'
}

/** Versão do eSocial */
export enum TESocialVersion {
  /** Versão 1.0.0 */
  S_01_00_00 = 'S_01_00_00',
  /** Versão 1.1.0 */
  S_01_01_00 = 'S_01_01_00',
  /** Versão 1.2.0 */
  S_01_02_00 = 'S_01_02_00',
  /** Versão 1.3.0 */
  S_01_03_00 = 'S_01_03_00'
}

export type TEarPart = {
  __typename?: 'EarPart';
  /** Indica se há anormalidade */
  abnormality: Scalars['Boolean']['output'];
  /** Descrição da anormalidade */
  description?: Maybe<Scalars['String']['output']>;
  /** Parte da orelha */
  earPart: TEarPartEnum;
  /** Exame otológico */
  examOtological: TExamOtological;
  /** Identificador único */
  id: Scalars['String']['output'];
};

/** Parte da orelha */
export enum TEarPartEnum {
  /** Anti-hélice */
  AntiHelix = 'AntiHelix',
  /** Cartilagem */
  Cartilage = 'Cartilage',
  /** Concha */
  Concha = 'Concha',
  /** Lóbulo da orelha */
  Earlobe = 'Earlobe',
  /** Meato acústico externo */
  ExternalAcousticMeatus = 'ExternalAcousticMeatus',
  /** Hélice */
  Helix = 'Helix',
  /** Escafa */
  Scapha = 'Scapha',
  /** Osso temporal */
  TemporalBone = 'TemporalBone',
  /** Músculo temporal */
  TemporalMuscle = 'TemporalMuscle',
  /** Fossa triangular */
  TringularFossa = 'TringularFossa'
}

export type TEarPartInput = {
  /** Indica se há anormalidade */
  abnormality: Scalars['Boolean']['input'];
  /** Descrição da anormalidade */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Parte da orelha */
  earPart: TEarPartEnum;
};

export type TEarPartUpdate = {
  /** Indica se há anormalidade */
  abnormality?: InputMaybe<Scalars['Boolean']['input']>;
  /** Descrição da anormalidade */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Parte da orelha */
  earPart?: InputMaybe<TEarPartEnum>;
  /** Identificador único */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do exame otológico */
  otologicalId?: InputMaybe<Scalars['String']['input']>;
};

export type TEconomicActivity = {
  __typename?: 'EconomicActivity';
  /** Grupo de atividade */
  activityGroup: TActivityGroup;
  /** Código da atividade econômica */
  code: Scalars['String']['output'];
  /** Descrição da atividade econômica */
  description: Scalars['String']['output'];
  /** Identificador do grupo de atividade */
  groupId: Scalars['String']['output'];
  /** Identificador único da atividade econômica */
  id: Scalars['String']['output'];
  /** Sugestão de uso */
  suggestion: Scalars['String']['output'];
};

/** Nível de escolaridade */
export enum TEducationLevel {
  /** Doutorado */
  DoctorateDegree = 'DoctorateDegree',
  /** Ensino fundamental */
  ElementarySchool = 'ElementarySchool',
  /** Ensino médio */
  HighSchool = 'HighSchool',
  /** Mestrado */
  MastersDegree = 'MastersDegree',
  /** Ensino superior */
  UniversityGraduate = 'UniversityGraduate'
}

/** Template efetivo para (organização, tipo): retorna o custom da org se existir; caso contrário o default declarado em código (D13). `isCustom` discrimina. */
export type TEffectiveDocumentTemplate = {
  __typename?: 'EffectiveDocumentTemplate';
  definition: Scalars['JSON']['output'];
  /** ID da fonte: UUID do CustomDocument quando `isCustom = true`, ou sentinela `default:<type>` quando vem do código. */
  id: Scalars['ID']['output'];
  /** true = vem de saas.custom_documents (org já customizou); false = default declarado em código. */
  isCustom: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Sample data fictícia pra preview no canvas em modo edit. Vem do `DEFAULT_SAMPLE_DATA` do tipo (declarado em `backend/src/document-templates/`). Em PDF time real o backend substitui pelos dados reais (ex.: `MedicalRecordService.getReportData`). `null` quando o tipo não tem sample registrada. */
  sampleData?: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Int']['output'];
  /** Variante opcional dentro do `type`. NULL = variante default. */
  subType?: Maybe<TCustomDocumentSubType>;
  type: TDocumentType;
  /** updatedAt do registro custom. `null` quando vem do default (default vive no Git, sem timestamp dinâmico). Usado pelo editor como `expectedUpdatedAt` no save (stale write protection). */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TEfficiencyChart = {
  __typename?: 'EfficiencyChart';
  /** Eficiência - proteção respiratória */
  breath?: Maybe<Scalars['Float']['output']>;
  /** Eficiência - proteção para olhos e face */
  eyeFace?: Maybe<Scalars['Float']['output']>;
  /** Eficiência - proteção contra quedas */
  fall?: Maybe<Scalars['Float']['output']>;
  /** Eficiência - proteção corpo inteiro */
  fullBody?: Maybe<Scalars['Float']['output']>;
  /** Indica se existem entregas de IPE */
  hasIpeDeliveries?: Maybe<Scalars['Boolean']['output']>;
  /** Eficiência - proteção para cabeça */
  head?: Maybe<Scalars['Float']['output']>;
  /** Eficiência - proteção auditiva */
  hearing?: Maybe<Scalars['Float']['output']>;
  /** Eficiência - proteção para membros inferiores */
  lowerLimb?: Maybe<Scalars['Float']['output']>;
  /** Eficiência - outras categorias */
  other?: Maybe<Scalars['Float']['output']>;
  /** Eficiência total */
  total?: Maybe<Scalars['Float']['output']>;
  /** Eficiência - proteção para tronco */
  trunk?: Maybe<Scalars['Float']['output']>;
  /** Eficiência - proteção para membros superiores */
  upperLimb?: Maybe<Scalars['Float']['output']>;
};

/** Nível de esforço */
export enum TEffort {
  /** Excessivo */
  Excessive = 'Excessive',
  /** Leve */
  Light = 'Light',
  /** Moderado */
  Moderate = 'Moderate'
}

export type TElaboratorDocument = {
  __typename?: 'ElaboratorDocument';
  documentNumber?: Maybe<Scalars['String']['output']>;
  documentState?: Maybe<TState>;
};

export type TElectionComission = {
  __typename?: 'ElectionComission';
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Mandato */
  mandate: TMandate;
  /** Pessoa */
  person: TPerson;
};

export type TElectionComissionInput = {
  /** Identificador do mandato */
  mandateId: Scalars['String']['input'];
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
};

export type TElectionComissionInputByMandate = {
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
};

export type TEmail = {
  __typename?: 'Email';
  /** Endereço de e-mail */
  email: Scalars['String']['output'];
  /** Indica se é o e-mail principal */
  isMain?: Maybe<Scalars['Boolean']['output']>;
};

export type TEmailHasInvite = {
  __typename?: 'EmailHasInvite';
  hasInvite: Scalars['Boolean']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
};

export type TEmailInput = {
  /** Endereço de e-mail */
  email: Scalars['String']['input'];
  /** Indica se é o e-mail principal */
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Emissor da CAT (Comunicação de Acidente de Trabalho) */
export enum TEmitter {
  /** Médico */
  Doctor = 'doctor',
  /** Empregador */
  Employer = 'employer',
  /** Segurado */
  Insured = 'insured',
  /** Autoridade pública */
  PublicAuthority = 'publicAuthority',
  /** Sindicato */
  Syndicate = 'syndicate'
}

export type TEmployee = {
  __typename?: 'Employee';
  /** Endereço */
  address?: Maybe<Scalars['String']['output']>;
  /** Data de admissão */
  admissionDate?: Maybe<Scalars['DateTime']['output']>;
  /** Data de nascimento */
  birthday: Scalars['DateTime']['output'];
  /** Nome da filial */
  branchName?: Maybe<Scalars['String']['output']>;
  /** Cidade */
  city?: Maybe<Scalars['String']['output']>;
  /** Estado civil */
  civilStatus?: Maybe<TCivilStatus>;
  /** Centro de custo */
  costCenter?: Maybe<TCostCenter>;
  /** CTPS */
  ctps?: Maybe<Scalars['String']['output']>;
  /** Departamento */
  department?: Maybe<TDepartment>;
  /** Data de demissão */
  dismissalDate?: Maybe<Scalars['DateTime']['output']>;
  /** Categoria eSocial */
  eSocialCategory?: Maybe<Scalars['String']['output']>;
  /** Status do protocolo do evento RH (S-2190/S-2200) no eSocial */
  eSocialRhEventStatus?: Maybe<TESocialRhEventStatus>;
  /** Nível de escolaridade */
  educationLevel?: Maybe<TEducationLevel>;
  /** Email */
  email?: Maybe<Scalars['String']['output']>;
  /** Situação do funcionário */
  employeeSituation?: Maybe<TEmployeeSituation>;
  /** Identificador no ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** É externo */
  external?: Maybe<Scalars['Boolean']['output']>;
  /** Gênero */
  gender: TGender;
  /** RG */
  generalRegistration?: Maybe<Scalars['String']['output']>;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** CPF */
  individualRegistration: Scalars['String']['output'];
  /** Está ativo */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Último exame */
  lastExam?: Maybe<Scalars['DateTime']['output']>;
  /** Identificador do gestor/superior imediato */
  managerId?: Maybe<Scalars['String']['output']>;
  /** Nome da mãe */
  mothersName?: Maybe<Scalars['String']['output']>;
  /** Nome do funcionário */
  name: Scalars['String']['output'];
  /** Bairro */
  neighborhood?: Maybe<Scalars['String']['output']>;
  /** Próxima troca */
  nextChange?: Maybe<Scalars['DateTime']['output']>;
  /** Apelido */
  nickname?: Maybe<Scalars['String']['output']>;
  /** Número do endereço */
  numberAddress?: Maybe<Scalars['String']['output']>;
  /** Cargo */
  occupation?: Maybe<TOccupation>;
  /** Foto da organização */
  organizationPicture?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** Código PIS */
  pisCode?: Maybe<Scalars['String']['output']>;
  /** Função */
  position?: Maybe<TPosition>;
  /** Preferências do funcionário (layout, sidebar, favoritos) */
  preferences?: Maybe<TEmployeePreferences>;
  /** Foto de perfil */
  profilePicture?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** RAIS */
  rais?: Maybe<Scalars['String']['output']>;
  /** Matrícula */
  registration?: Maybe<Scalars['String']['output']>;
  /** Situação de substituição */
  replacementSituation?: Maybe<TReplacementSituation>;
  /** SEFIP */
  sefip?: Maybe<Scalars['String']['output']>;
  /** Identificador do vendedor */
  sellerId?: Maybe<Scalars['String']['output']>;
  /** Nome social */
  socialName?: Maybe<Scalars['String']['output']>;
  /** Estado */
  state?: Maybe<Scalars['String']['output']>;
  /** Sugestão */
  suggestion?: Maybe<Scalars['String']['output']>;
  /** Telefone */
  telephone?: Maybe<Scalars['String']['output']>;
  /** Identificador único eSocial */
  unicESocialId?: Maybe<Scalars['String']['output']>;
  /** URL de upload */
  uploadUrl?: Maybe<Scalars['String']['output']>;
  /** Usuário */
  user?: Maybe<Scalars['String']['output']>;
  /** Turno de trabalho */
  workShift?: Maybe<TWorkShift>;
  /** CEP */
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type TEmployeeAgentGroupChart = {
  __typename?: 'EmployeeAgentGroupChart';
  /** Quantidade de riscos por associação */
  association: Scalars['Float']['output'];
  /** Quantidade de riscos biológicos */
  biological: Scalars['Float']['output'];
  /** Quantidade de riscos químicos */
  chemical: Scalars['Float']['output'];
  /** Quantidade de riscos perigosos */
  dangerous: Scalars['Float']['output'];
  /** Quantidade de riscos ergonômicos */
  ergonomic: Scalars['Float']['output'];
  /** Quantidade de riscos mecânicos */
  mechanical: Scalars['Float']['output'];
  /** Quantidade de outros riscos */
  other: Scalars['Float']['output'];
  /** Quantidade de riscos físicos */
  physical: Scalars['Float']['output'];
};

export type TEmployeeAnamnesis = {
  __typename?: 'EmployeeAnamnesis';
  /** Identificador da consulta */
  consultationId: Scalars['String']['output'];
  /** Descrição do questionário de anamnese */
  description: Scalars['String']['output'];
  /** Data prevista da consulta */
  estimatedDate: Scalars['DateTime']['output'];
  /** Natureza da consulta */
  nature?: Maybe<TConsultationNature>;
  /** Identificador do questionário de anamnese */
  quizId: Scalars['String']['output'];
  /** Data em que foi respondida (se Answered) */
  realizationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Nome do responsável pela consulta (médico, enfermeiro, credenciado ou externo) */
  responsibleName?: Maybe<Scalars['String']['output']>;
  /** Status da anamnese: Pendente (a responder) ou Respondido */
  status: TEmployeeQuizStatusEnum;
};

export type TEmployeeAnswerClinicalQuizInput = {
  /** Identificador da consulta à qual a anamnese deve ser vinculada */
  consultationId: Scalars['String']['input'];
  /** Identificador do questionário respondido (deve corresponder ao expectedClinicalQuizId da consulta) */
  quizId: Scalars['String']['input'];
  /** Data de realização do questionário */
  realizationDate: Scalars['DateTime']['input'];
  /** Respostas do questionário */
  responses: Array<TResponseClinicalQuizInput>;
};

export type TEmployeeAnswerSafetyQuizInput = {
  /** Identificador do questionário respondido */
  quizId: Scalars['String']['input'];
  /** Data de realização do questionário */
  realizationDate: Scalars['DateTime']['input'];
  /** Respostas do questionário */
  responses: Array<TResponseSafetyQuizInput>;
};

export type TEmployeeByEventTypeInput = {
  /** Tipo de evento do mandato */
  type: TMandateEventType;
};

export type TEmployeeByMandateIdInput = {
  /** Identificador do mandato */
  mandateId: Scalars['String']['input'];
};

export type TEmployeeByOccupation = {
  __typename?: 'EmployeeByOccupation';
  /** Quantidade */
  amount: Scalars['Float']['output'];
  /** Descrição */
  description: Scalars['String']['output'];
  /** Detalhes */
  details: Scalars['String']['output'];
};

export type TEmployeeCandidate = {
  __typename?: 'EmployeeCandidate';
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Dados da pessoa */
  person: TEmployeePerson;
};

export type TEmployeeConsultation = {
  __typename?: 'EmployeeConsultation';
  /** Nome do credenciado */
  accreditedName?: Maybe<Scalars['String']['output']>;
  /** Identificador da anamnese (clinical_quiz) já respondida para esta consulta */
  clinicalQuizId?: Maybe<Scalars['String']['output']>;
  /** CRM do médico */
  doctorCrm?: Maybe<Scalars['String']['output']>;
  /** Nome do médico */
  doctorName?: Maybe<Scalars['String']['output']>;
  /** Foto de perfil do médico */
  doctorPhotoUrl?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** Especialidade principal do médico (rótulo) */
  doctorSpecialty?: Maybe<Scalars['String']['output']>;
  /** Data de término */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Data estimada */
  estimatedDate: Scalars['DateTime']['output'];
  /** Tempo estimado em minutos */
  estimatedTime?: Maybe<Scalars['Float']['output']>;
  /** Exames da consulta */
  exams: Array<TEmployeeExam>;
  /** Identificador do questionário de anamnese esperado para esta consulta */
  expectedClinicalQuizId?: Maybe<Scalars['String']['output']>;
  /** Resultado geral da consulta liberado ao colaborador */
  generalResultReleasedToEmployee: Scalars['Boolean']['output'];
  /** Identificador da consulta */
  id: Scalars['String']['output'];
  /** Natureza da consulta */
  nature?: Maybe<TConsultationNature>;
  /** Identificador do certificado de saúde ocupacional */
  occupationalHealthCertificateId?: Maybe<Scalars['String']['output']>;
  /** Motivo da consulta */
  reason: Scalars['String']['output'];
  /** Data de início */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Tipo de consulta */
  type: TConsultationType;
};

export type TEmployeeControlMeasure = {
  __typename?: 'EmployeeControlMeasure';
  /** Descrição da medida de controle */
  description: Scalars['String']['output'];
  /** Indica se a medida de controle é efetiva */
  effective?: Maybe<Scalars['Boolean']['output']>;
};

export type TEmployeeExam = {
  __typename?: 'EmployeeExam';
  /** Identificador do exame complementar */
  id: Scalars['String']['output'];
  /** Nome do exame */
  name: Scalars['String']['output'];
  /** Resultado liberado para o colaborador */
  releasedToEmployee: Scalars['Boolean']['output'];
  /** Tipo de resultado do exame */
  resultType?: Maybe<TResultTypeEnum>;
};

/** Item favoritado pelo funcionário na sidebar do portal */
export type TEmployeeFavoriteOption = {
  __typename?: 'EmployeeFavoriteOption';
  /** Chave do ícone (mapping de QuironsIconComponent) */
  iconType: Scalars['String']['output'];
  /** Identificador do favorito */
  id: Scalars['String']['output'];
  /** Rótulo exibido */
  label: Scalars['String']['output'];
  /** Rota para a qual o favorito navega */
  route: Scalars['String']['output'];
};

export type TEmployeeFavoriteOptionInput = {
  /** Chave do ícone (mapping de QuironsIconComponent) */
  iconType: Scalars['String']['input'];
  /** Identificador do favorito */
  id: Scalars['String']['input'];
  /** Rótulo exibido */
  label: Scalars['String']['input'];
  /** Rota para a qual o favorito navega */
  route: Scalars['String']['input'];
};

export type TEmployeeIpeDelivery = {
  __typename?: 'EmployeeIpeDelivery';
  /** Centro de custo */
  costCenter?: Maybe<TCostCenter>;
  /** Situação do funcionário */
  employeeSituation?: Maybe<TEmployeeSituation>;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Entregas de EPI */
  ipeDeliveries: Array<TIpeDelivery>;
  /** Nome */
  name: Scalars['String']['output'];
  /** Ocupação */
  occupation?: Maybe<TOccupation>;
  /** Foto de perfil */
  profilePicture?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** EPIs obrigatórios */
  requiredIpes: Array<TIpe>;
};

export type TEmployeeIpes = {
  __typename?: 'EmployeeIpes';
  /** Quantidade entregue */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Código do CA */
  caCode?: Maybe<Scalars['String']['output']>;
  /** Data da entrega */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** Indica se está efetivado */
  effective?: Maybe<Scalars['Boolean']['output']>;
  /** Descrição do equipamento */
  equipmentDescription: Scalars['String']['output'];
  /** Identificador do equipamento */
  equipmentId: Scalars['String']['output'];
  /** Data de emissão */
  issueDate?: Maybe<Scalars['DateTime']['output']>;
  /** Data da última manutenção */
  lastMaintenance?: Maybe<Scalars['DateTime']['output']>;
  /** Data da próxima troca */
  nextChange?: Maybe<Scalars['DateTime']['output']>;
  /** Observação */
  observation?: Maybe<Scalars['String']['output']>;
  /** Motivo da entrega */
  reason?: Maybe<TDeliveryReason>;
};

export type TEmployeeMandateEvent = {
  __typename?: 'EmployeeMandateEvent';
  /** Candidatos do evento */
  candidates?: Maybe<Array<TEmployeeCandidate>>;
  /** Descrição do mandato */
  description: Scalars['String']['output'];
  /** Informações do evento */
  event: TMandateEventInfo;
  /** Identificador do mandato */
  mandateId: Scalars['String']['output'];
  /** Validade do mandato */
  validity: TMandateValidity;
};

export type TEmployeeNicknameInput = {
  /** Apelido do funcionário */
  nickname?: InputMaybe<Scalars['String']['input']>;
};

/** Tipo de operação para funcionário */
export enum TEmployeeOperationType {
  /** Alteração */
  Change = 'Change',
  /** Criação */
  Create = 'Create'
}

export type TEmployeePerson = {
  __typename?: 'EmployeePerson';
  /** Identificador do centro de custo */
  costCenterId?: Maybe<Scalars['String']['output']>;
  /** Nome do centro de custo (setor) */
  costCenterName?: Maybe<Scalars['String']['output']>;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Nome da pessoa */
  name: Scalars['String']['output'];
  /** Apelido */
  nickname?: Maybe<Scalars['String']['output']>;
  /** Foto de perfil */
  profilePicture?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** Matrícula */
  registration?: Maybe<Scalars['String']['output']>;
  /** Quantidade de riscos ativos a que a pessoa está exposta */
  riskCount?: Maybe<Scalars['Int']['output']>;
  /** Nome social */
  socialName?: Maybe<Scalars['String']['output']>;
  /** Sugestão de busca */
  suggestion?: Maybe<Scalars['String']['output']>;
};

/** Preferências do funcionário no portal (layout, sidebar, favoritos) */
export type TEmployeePreferences = {
  __typename?: 'EmployeePreferences';
  /** Versão do layout escolhida pelo funcionário */
  designVersion?: Maybe<TDesignVersion>;
  /** Sidebar expandida (true) ou colapsada (false) */
  expandedSidebar?: Maybe<Scalars['Boolean']['output']>;
  /** Lista de itens favoritados na sidebar */
  favorites?: Maybe<Array<TEmployeeFavoriteOption>>;
  /** Bloco de Favoritos aberto na sidebar V2 */
  favoritesOpen?: Maybe<Scalars['Boolean']['output']>;
};

export type TEmployeePreferencesInput = {
  /** Versão do layout escolhida pelo funcionário */
  designVersion?: InputMaybe<TDesignVersion>;
  /** Sidebar expandida (true) ou colapsada (false) */
  expandedSidebar?: InputMaybe<Scalars['Boolean']['input']>;
  /** Lista de itens favoritados na sidebar */
  favorites?: InputMaybe<Array<TEmployeeFavoriteOptionInput>>;
  /** Bloco de Favoritos aberto na sidebar V2 */
  favoritesOpen?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TEmployeeQuiz = {
  __typename?: 'EmployeeQuiz';
  /** Descrição do questionário */
  description: Scalars['String']['output'];
  /** Identificador do questionário */
  id: Scalars['String']['output'];
  /** Indica se o questionário está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Data da última resposta do funcionário a este questionário */
  lastAnsweredAt?: Maybe<Scalars['DateTime']['output']>;
  /** Data prevista para a próxima resposta. Null em Pending ou em questionários one-shot já respondidos */
  nextDueDate?: Maybe<Scalars['DateTime']['output']>;
  /** Periodicidade de resposta em meses (null = uma vez só) */
  periodicity?: Maybe<Scalars['Float']['output']>;
  /** Tipo do questionário */
  quizType: TQuizTypeEnum;
  /** Status do questionário para o funcionário (Pendente, Respondido, Vencido) */
  status: TEmployeeQuizStatusEnum;
};

/** Status do questionário em relação ao funcionário logado */
export enum TEmployeeQuizStatusEnum {
  /** Respondido e dentro da periodicidade */
  Answered = 'Answered',
  /** Pendente — funcionário ainda não respondeu ou venceu a periodicidade */
  Pending = 'Pending'
}

export type TEmployeeRisk = {
  __typename?: 'EmployeeRisk';
  /** Nível de ação */
  actionLevel?: Maybe<Scalars['Float']['output']>;
  /** Categoria do risco */
  category?: Maybe<TRiskCategory>;
  /** Classificação do risco */
  classification?: Maybe<TRiskClassification>;
  /** Medidas de controle */
  controlMeasures: Array<TEmployeeControlMeasure>;
  /** Periodicidade de troca */
  exchangePeriodicity: Scalars['Boolean']['output'];
  /** Data de validade */
  expirationDate: Scalars['Boolean']['output'];
  /** Tempo de exposição */
  exposureTime?: Maybe<Scalars['String']['output']>;
  /** Fonte geradora */
  generationSource: Scalars['String']['output'];
  /** Intervalo */
  interval?: Maybe<Scalars['String']['output']>;
  /** IPEs do risco */
  ipes: Array<TEmployeeRiskIpe>;
  /** Tipo de medida */
  measureType?: Maybe<TRiskMeasureType>;
  /** Necessita CPE */
  needCpe?: Maybe<Scalars['Boolean']['output']>;
  /** Necessita IPE */
  needIpe?: Maybe<Scalars['Boolean']['output']>;
  /** Ambiente físico */
  physicalEnvironment: Scalars['String']['output'];
  /** Probabilidade do risco */
  probability?: Maybe<TRiskProbability>;
  /** Possui medida de proteção */
  protectionMeasure?: Maybe<Scalars['Boolean']['output']>;
  /** Data de reconhecimento do risco */
  recognitionDate: Scalars['DateTime']['output'];
  /** Repetição */
  repetition?: Maybe<Scalars['String']['output']>;
  /** Agente de risco */
  riskAgent: Scalars['String']['output'];
  /** Grau de risco */
  riskDegree?: Maybe<TRiskDegree>;
  /** Grupo do agente de risco */
  riskGroup: TAgentGroup;
  /** Mapa de risco */
  riskMap?: Maybe<TRiskMap>;
  /** Higienização */
  sanitation: Scalars['Boolean']['output'];
  /** Severidade do risco */
  severity?: Maybe<TRiskSeverity>;
  /** Uso ininterrupto */
  uninterruptedUse: Scalars['Boolean']['output'];
  /** Unidade de medida */
  unitMeasurement?: Maybe<TRiskMeasure>;
  /** Condição de trabalho */
  workingCondition: Scalars['Boolean']['output'];
};

export type TEmployeeRiskDashboard = {
  __typename?: 'EmployeeRiskDashboard';
  /** Gráfico de adicional por agente */
  agentBonusChart: TAgentBonusChart;
  /** Gráfico de colaboradores por agente */
  employeesAgentChart: Array<TPieChart>;
  /** Gráfico de colaboradores por tipo de agente */
  employeesAgentTypeChart: TEmployeeAgentGroupChart;
  /** Gráfico de pessoas */
  personChart: TPersonChart;
  /** Gráfico de riscos por colaborador */
  risksPerEmployeeChart: TPersonChart;
};

export type TEmployeeRiskIpe = {
  __typename?: 'EmployeeRiskIpe';
  /** Periodicidade de troca em dias */
  change: Scalars['Float']['output'];
  /** Descrição do IPE */
  description: Scalars['String']['output'];
};

/** Situação do funcionário */
export enum TEmployeeSituation {
  /** Ausência */
  Absence = 'Absence',
  /** Ativo */
  Active = 'Active',
  /** Afastado */
  Discharge = 'Discharge',
  /** Demitido */
  Dismissed = 'Dismissed',
  /** Atestado médico */
  DoctorStatement = 'DoctorStatement',
  /** Férias */
  Vacations = 'Vacations'
}

export type TEmployeeTask = {
  __typename?: 'EmployeeTask';
  /** Data de término */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Pessoa */
  person: TPerson;
  /** Data de início */
  startDate: Scalars['DateTime']['output'];
  /** Atividade */
  task: TTask;
};

export type TEmployeeTaskInput = {
  /** Data de término */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
  /** Data de início */
  startDate: Scalars['DateTime']['input'];
  /** Identificador da atividade */
  taskId: Scalars['String']['input'];
};

export type TEmployeeTaskOnPerson = {
  /** Identificador único */
  id: Scalars['String']['input'];
};

export type TEmployeeTaskOnPersonInput = {
  /** Data de término */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de início */
  startDate: Scalars['DateTime']['input'];
  /** Identificador da atividade */
  taskId: Scalars['String']['input'];
};

export type TEmployeeTaskOnPersonRemove = {
  /** Data de início */
  startDate: Scalars['DateTime']['input'];
  /** Identificador da atividade */
  taskId: Scalars['String']['input'];
};

export type TEmployeeTaskOnPersonUpdate = {
  /** Atividades a criar */
  toCreate: Array<TEmployeeTaskOnPersonInput>;
  /** Atividades a remover */
  toRemove: Array<TEmployeeTaskOnPersonRemove>;
  /** Atividades a atualizar */
  toUpdate: Array<TEmployeeTaskOnPersonInput>;
};

export type TEmployeeTaskUpdate = {
  /** Data de término */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Identificador da pessoa */
  personId?: InputMaybe<Scalars['String']['input']>;
  /** Data de início */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador da atividade */
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type TEmployeeVolumeChart = {
  __typename?: 'EmployeeVolumeChart';
  /** Possui atestado */
  hasCertificate: Scalars['Boolean']['output'];
  /** Alto */
  high: Scalars['Float']['output'];
  /** Baixo */
  low: Scalars['Float']['output'];
  /** Médio */
  medium: Scalars['Float']['output'];
};

export type TEmployeeVoteInput = {
  /** Identificador do candidato */
  candidateId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do mandato */
  mandateId: Scalars['String']['input'];
  /** Indica se é voto nulo */
  nullVote?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se é voto em branco */
  whiteVote?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TEmployeeVotes = {
  __typename?: 'EmployeeVotes';
  /** Identificador único */
  id?: Maybe<Scalars['String']['output']>;
  /** CPF */
  individualRegistration: Scalars['String']['output'];
  /** Nome da pessoa */
  name: Scalars['String']['output'];
  /** Foto */
  picture?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** Matrícula */
  registration: Scalars['String']['output'];
  /** Nome social */
  socialName?: Maybe<Scalars['String']['output']>;
};

export type TEmployeeWarningOnPersonInput = {
  /** Data da advertência */
  date: Scalars['DateTime']['input'];
  /** Detalhes */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Motivo da advertência */
  reason: TWarningReason;
  /** Tipo de advertência */
  type: TWarningType;
  /** Indica se foi assinada */
  wasSignature: Scalars['Boolean']['input'];
};

export type TEmployeeWarningReport = {
  __typename?: 'EmployeeWarningReport';
  /** Endereço */
  address: Scalars['String']['output'];
  /** CNPJ */
  cnpj: Scalars['String']['output'];
  /** Nome da empresa */
  companyName: Scalars['String']['output'];
  /** Data */
  date: Scalars['String']['output'];
  /** Detalhes */
  details: Scalars['String']['output'];
  /** Rodapé */
  footer: Scalars['String']['output'];
  /** Matrícula individual */
  individualRegistration: Scalars['String']['output'];
  /** Nome do funcionário */
  name: Scalars['String']['output'];
  /** Motivo */
  reason: Scalars['String']['output'];
  /** Telefone */
  telephone: Scalars['String']['output'];
  /** Tipo */
  type: Scalars['String']['output'];
};

export type TEndpoint = {
  __typename?: 'Endpoint';
  /** Dados adicionais */
  additionalData?: Maybe<Array<TAdditionalData>>;
  /** Tipo de autenticação */
  authType?: Maybe<TAuthType>;
  /** Filial */
  branch: TBranch;
  /** ID da filial */
  branchId?: Maybe<Scalars['String']['output']>;
  /** ID do cliente */
  clientId?: Maybe<Scalars['String']['output']>;
  /** Segredo do cliente */
  clientSecret?: Maybe<Scalars['String']['output']>;
  /** Filial no ERP */
  erpBranch?: Maybe<Scalars['String']['output']>;
  /** Empresa no ERP */
  erpCompany: Scalars['String']['output'];
  /** Linha do ERP */
  erpLine?: Maybe<TErpLine>;
  /** Tipo de ERP */
  erpType: TErpType;
  /** ID do endpoint */
  id?: Maybe<Scalars['String']['output']>;
  /** Nome do card de integração */
  integrationCardName?: Maybe<Scalars['String']['output']>;
  /** Contexto de integração */
  integrationContext?: Maybe<TIntegrationContext>;
  /** Senha */
  password?: Maybe<Scalars['String']['output']>;
  /** Porta de conexão */
  port?: Maybe<Scalars['Float']['output']>;
  /** Descrição do serviço */
  serviceDescription?: Maybe<Scalars['String']['output']>;
  /** URL do endpoint */
  url?: Maybe<Scalars['String']['output']>;
  urlCertificate?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** URL do TSS */
  urlTSS?: Maybe<Scalars['String']['output']>;
  /** Usuário */
  user?: Maybe<Scalars['String']['output']>;
};

export type TEndpointInput = {
  /** Dados adicionais */
  additionalData?: InputMaybe<Array<TAdditionalDataInput>>;
  /** Tipo de autenticação */
  authType?: InputMaybe<TAuthType>;
  /** ID da filial */
  branchId?: InputMaybe<Scalars['String']['input']>;
  /** ID do cliente */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** Segredo do cliente */
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  /** Filial no ERP */
  erpBranch?: InputMaybe<Scalars['String']['input']>;
  /** Empresa no ERP */
  erpCompany: Scalars['String']['input'];
  /** Linha do ERP */
  erpLine?: InputMaybe<TErpLine>;
  /** Tipo de ERP */
  erpType: TErpType;
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** ID do endpoint */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Nome do card de integração */
  integrationCardName?: InputMaybe<Scalars['String']['input']>;
  /** Contexto de integração */
  integrationContext?: InputMaybe<TIntegrationContext>;
  /** Senha */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Porta de conexão */
  port?: InputMaybe<Scalars['Float']['input']>;
  /** Descrição do serviço */
  serviceDescription?: InputMaybe<Scalars['String']['input']>;
  upload?: InputMaybe<Scalars['Upload']['input']>;
  /** URL do endpoint */
  url?: InputMaybe<Scalars['String']['input']>;
  /** URL do TSS */
  urlTSS?: InputMaybe<Scalars['String']['input']>;
  /** Usuário */
  user?: InputMaybe<Scalars['String']['input']>;
};

/** Entidades utilizadas no sistema */
export enum TEntities {
  /** Tipo de ausência */
  AbsenceType = 'AbsenceType',
  /** Acidente */
  Accident = 'Accident',
  /** Parte do corpo afetada em acidente */
  AccidentBodyPart = 'AccidentBodyPart',
  /** Causa do acidente */
  AccidentCause = 'AccidentCause',
  /** Despesa relacionada ao acidente */
  AccidentExpense = 'AccidentExpense',
  /** Testemunha do acidente */
  AccidentWitness = 'AccidentWitness',
  /** Credenciado */
  Accredited = 'Accredited',
  /** Exame do credenciado */
  AccreditedExam = 'AccreditedExam',
  /** Plano de ação */
  ActionPlan = 'ActionPlan',
  /** Investigação do plano de ação */
  ActionPlanInvestigation = 'ActionPlanInvestigation',
  /** Microações do plano de ação */
  ActionPlanMicroActions = 'ActionPlanMicroActions',
  /** Relatório do plano de ação */
  ActionPlanReport = 'ActionPlanReport',
  /** Risco do plano de ação */
  ActionPlanRisk = 'ActionPlanRisk',
  /** Faixa etária */
  AgeRange = 'AgeRange',
  /** Tipo de benefício */
  AllowanceType = 'AllowanceType',
  /** Análise */
  Analysis = 'Analysis',
  /** Exame de monitoramento biológico */
  BiologicalMonitoringExam = 'BiologicalMonitoringExam',
  /** Grupo de exame de monitoramento biológico */
  BiologicalMonitoringExamGroup = 'BiologicalMonitoringExamGroup',
  /** Filial */
  Branch = 'Branch',
  /** Calendário */
  Calendar = 'Calendar',
  /** Turno de trabalho do calendário */
  CalendarWorkShift = 'CalendarWorkShift',
  /** Candidato */
  Candidate = 'Candidate',
  /** Agente causador */
  CauserAgent = 'CauserAgent',
  /** Questionário clínico */
  ClinicalQuiz = 'ClinicalQuiz',
  /** Exame complementar */
  ComplementaryExam = 'ComplementaryExam',
  /** CID complementar */
  ComplementaryIcd = 'ComplementaryIcd',
  /** Componente */
  Component = 'Component',
  /** Consulta */
  Consultation = 'Consultation',
  /** Medida de controle */
  ControlMeasure = 'ControlMeasure',
  /** Centro de custo */
  CostCenter = 'CostCenter',
  /** Deficiência */
  Deficiency = 'Deficiency',
  /** Entrega de peças de reposição */
  DeliverySpareParts = 'DeliverySpareParts',
  /** Departamento */
  Department = 'Department',
  /** Dependente */
  Dependent = 'Dependent',
  /** Diagnóstico */
  Diagnostic = 'Diagnostic',
  /** CID complementar de diagnóstico */
  DiagnosticComplementaryIcd = 'DiagnosticComplementaryIcd',
  /** Medicamento de diagnóstico */
  DiagnosticMedicine = 'DiagnosticMedicine',
  /** Parte da orelha */
  EarPart = 'EarPart',
  /** Comissão eleitoral */
  ElectionComission = 'ElectionComission',
  /** Tarefa do funcionário */
  EmployeeTask = 'EmployeeTask',
  /** Advertência de funcionário */
  EmployeeWarning = 'EmployeeWarning',
  /** Relatório ambiental */
  EnvironmentalReport = 'EnvironmentalReport',
  /** Face do relatório ambiental */
  EnvironmentalReportFace = 'EnvironmentalReportFace',
  /** Centro de custo do equipamento */
  EquipmentCostCenter = 'EquipmentCostCenter',
  /** Ocupação do equipamento */
  EquipmentOccupation = 'EquipmentOccupation',
  /** Exame */
  Exam = 'Exam',
  /** Exame de audiometria */
  ExamAudiometry = 'ExamAudiometry',
  /** Exame de imagem diagnóstica */
  ExamDiagnosticImage = 'ExamDiagnosticImage',
  /** Exame IBMP */
  ExamIbmp = 'ExamIbmp',
  /** Item de exame */
  ExamItem = 'ExamItem',
  /** Valor do item de exame */
  ExamItemValue = 'ExamItemValue',
  /** Exame normal */
  ExamNormal = 'ExamNormal',
  /** Ocupação do exame */
  ExamOccupation = 'ExamOccupation',
  /** Exame otológico */
  ExamOtological = 'ExamOtological',
  /** Risco do exame */
  ExamRisk = 'ExamRisk',
  /** Espirometria */
  ExamSpirometry = 'ExamSpirometry',
  /** Exame toxicológico */
  ExamToxicological = 'ExamToxicological',
  /** Meta esperada */
  ExpectedGoal = 'ExpectedGoal',
  /** Despesa */
  Expense = 'Expense',
  /** Grupo de exposição */
  ExposureGroup = 'ExposureGroup',
  /** Centro de custo do grupo de exposição */
  ExposureGroupCostCenter = 'ExposureGroupCostCenter',
  /** Departamento do grupo de exposição */
  ExposureGroupDepartment = 'ExposureGroupDepartment',
  /** Ocupação do grupo de exposição */
  ExposureGroupOccupation = 'ExposureGroupOccupation',
  /** Pessoa do grupo de exposição */
  ExposureGroupPerson = 'ExposureGroupPerson',
  /** Tarefa do grupo de exposição */
  ExposureGroupTask = 'ExposureGroupTask',
  /** Sistema de extinção */
  ExtinguishingSystem = 'ExtinguishingSystem',
  /** Inspeção de sistema de extinção */
  ExtinguishingSystemInspection = 'ExtinguishingSystemInspection',
  /** Brigada de incêndio */
  FireBrigade = 'FireBrigade',
  /** Componente da brigada de incêndio */
  FireBrigadeComponent = 'FireBrigadeComponent',
  /** Exame da brigada de incêndio */
  FireBrigadeExam = 'FireBrigadeExam',
  /** Reunião da brigada de incêndio */
  FireBrigadeMeeting = 'FireBrigadeMeeting',
  /** Ação de reunião da brigada de incêndio */
  FireBrigadeMeetingAction = 'FireBrigadeMeetingAction',
  /** Participante de reunião da brigada de incêndio */
  FireBrigadeMeetingParticipant = 'FireBrigadeMeetingParticipant',
  /** Ocorrência da brigada de incêndio */
  FireBrigadeOccurrence = 'FireBrigadeOccurrence',
  /** Treinamento da brigada de incêndio */
  FireBrigadeTraining = 'FireBrigadeTraining',
  /** Histórico funcional */
  FuncionalHistory = 'FuncionalHistory',
  /** Fonte geradora */
  GeneratingSource = 'GeneratingSource',
  /** Análise de grupo */
  GroupAnalysis = 'GroupAnalysis',
  /** Programa de saúde */
  HealthProgram = 'HealthProgram',
  /** Exame de programa de saúde */
  HealthProgramExam = 'HealthProgramExam',
  /** Ocupação de programa de saúde */
  HealthProgramOccupation = 'HealthProgramOccupation',
  /** Treinamento de programa de saúde */
  HealthProgramTraining = 'HealthProgramTraining',
  /** Inspeção de sistema hidráulico */
  HidraulicSystemInspection = 'HidraulicSystemInspection',
  /** Log de importação */
  ImporterLog = 'ImporterLog',
  /** Erro de integração */
  IntegrationError = 'IntegrationError',
  /** Investigação */
  Investigation = 'Investigation',
  /** Causa da investigação */
  InvestigationCause = 'InvestigationCause',
  /** Convite */
  Invite = 'Invite',
  /** Entrega de EPI */
  IpeDelivery = 'IpeDelivery',
  /** Solicitações LGPD */
  LgpdRequests = 'LgpdRequests',
  /** Mandato */
  Mandate = 'Mandate',
  /** Ação de mandato */
  MandateAction = 'MandateAction',
  /** Centro de custo de mandato */
  MandateCostCenter = 'MandateCostCenter',
  /** Departamento de mandato */
  MandateDepartment = 'MandateDepartment',
  /** Evento de mandato */
  MandateEvent = 'MandateEvent',
  /** Perda de mandato */
  MandateLoss = 'MandateLoss',
  /** Treinamento de mandato */
  MandateTraining = 'MandateTraining',
  /** Medição */
  Measurement = 'Measurement',
  /** Instrumento de medição */
  MeasuringInstrument = 'MeasuringInstrument',
  /** Atestado médico */
  MedicalCertificate = 'MedicalCertificate',
  /** Prontuário médico */
  MedicalRecord = 'MedicalRecord',
  /** Prontuário de programa de saúde */
  MedicalRecordHealthProgram = 'MedicalRecordHealthProgram',
  /** Prontuário de vacina */
  MedicalRecordVaccine = 'MedicalRecordVaccine',
  /** Encaminhamento médico */
  MedicalReferral = 'MedicalReferral',
  /** Restrição médica */
  MedicalRestriction = 'MedicalRestriction',
  /** Medicamento */
  Medicine = 'Medicine',
  /** Reunião */
  Meeting = 'Meeting',
  /** Ação de reunião */
  MeetingAction = 'MeetingAction',
  /** Participante de reunião */
  MeetingParticipant = 'MeetingParticipant',
  /** Ocupação */
  Occupation = 'Occupation',
  /** Atestado de saúde ocupacional */
  OccupationalHealthCertificate = 'OccupationalHealthCertificate',
  /** Avaliador ortopédico */
  OrthoRater = 'OrthoRater',
  /** Faixa periódica */
  PeriodicRange = 'PeriodicRange',
  /** Pessoa */
  Person = 'Person',
  /** Ativação de histórico de pessoa */
  PersonHistoryActivate = 'PersonHistoryActivate',
  /** Situação de histórico de pessoa */
  PersonHistorySituation = 'PersonHistorySituation',
  /** Ambiente físico */
  PhysicalEnvironment = 'PhysicalEnvironment',
  /** Cargo */
  Position = 'Position',
  /** Pré-atestado médico */
  PreMedicalCertificate = 'PreMedicalCertificate',
  /** Produto */
  Product = 'Product',
  /** Entrega de produto */
  ProductDelivery = 'ProductDelivery',
  /** Fabricante de EPI do produto */
  ProductIpeManufacturer = 'ProductIpeManufacturer',
  /** Grupo de questões */
  QuestionGroup = 'QuestionGroup',
  /** Questionário de questões */
  QuestionQuiz = 'QuestionQuiz',
  /** Quiz */
  Quiz = 'Quiz',
  /** Centro de custo do quiz */
  QuizCostCenter = 'QuizCostCenter',
  /** Departamento do quiz */
  QuizDepartment = 'QuizDepartment',
  /** Fonte geradora do quiz */
  QuizGeneratingSource = 'QuizGeneratingSource',
  /** Ocupação do quiz */
  QuizOccupation = 'QuizOccupation',
  /** Pessoa do quiz */
  QuizPerson = 'QuizPerson',
  /** Ambiente físico do quiz */
  QuizPhysicalEnvironment = 'QuizPhysicalEnvironment',
  /** Meta real */
  RealGoal = 'RealGoal',
  /** Referências */
  References = 'References',
  /** Resposta do questionário clínico */
  ResponseClinicalQuiz = 'ResponseClinicalQuiz',
  /** Opção de resposta */
  ResponseOption = 'ResponseOption',
  /** Resposta do questionário de segurança */
  ResponseSafetyQuiz = 'ResponseSafetyQuiz',
  /** Ação responsável do plano */
  ResponsibleAction = 'ResponsibleAction',
  /** Resultado do exame IBMP */
  ResultExamIbmp = 'ResultExamIbmp',
  /** Risco */
  Risk = 'Risk',
  /** Agente de risco */
  RiskAgent = 'RiskAgent',
  /** Composição de risco */
  RiskComposition = 'RiskComposition',
  /** Controle de risco */
  RiskControl = 'RiskControl',
  /** Centro de custo de risco */
  RiskCostCenter = 'RiskCostCenter',
  /** Departamento de risco */
  RiskDepartment = 'RiskDepartment',
  /** EPI de risco */
  RiskIpe = 'RiskIpe',
  /** Ocupação de risco */
  RiskOccupation = 'RiskOccupation',
  /** Pessoa de risco */
  RiskPerson = 'RiskPerson',
  /** Tarefa de risco */
  RiskTask = 'RiskTask',
  /** Treinamento de risco */
  RiskTraining = 'RiskTraining',
  /** Função do usuário */
  Role = 'Role',
  /** Questionário de segurança */
  SafetyQuiz = 'SafetyQuiz',
  /** Restrição de agenda */
  ScheduleRestriction = 'ScheduleRestriction',
  SecurityWorkOrder = 'SecurityWorkOrder',
  /** Simulação */
  Simulation = 'Simulation',
  /** Ação de simulação */
  SimulationAction = 'SimulationAction',
  /** Plano de simulação */
  SimulationPlan = 'SimulationPlan',
  /** Ação do plano de simulação */
  SimulationPlanAction = 'SimulationPlanAction',
  /** SIPAT */
  Sipat = 'Sipat',
  /** Evento SIPAT */
  SipatEvent = 'SipatEvent',
  /** Snellen */
  Snellen = 'Snellen',
  /** Peças de reposição */
  SpareParts = 'SpareParts',
  /** Tipo de estabilidade */
  StabilityType = 'StabilityType',
  /** Termo de responsabilidade */
  StatementResponsibility = 'StatementResponsibility',
  /** Nível de estoque */
  StockLevel = 'StockLevel',
  /** Movimentação de estoque */
  StockMovement = 'StockMovement',
  /** Caixa de sugestões */
  SuggestionBox = 'SuggestionBox',
  /** Tarefa */
  Task = 'Task',
  /** Treinamento */
  Training = 'Training',
  /** Histórico de treinamento */
  TrainingHistory = 'TrainingHistory',
  /** Unidade de medida */
  UnityOfMeasure = 'UnityOfMeasure',
  /** Urinálise */
  Urinalysis = 'Urinalysis',
  /** Usuário */
  User = 'User',
  /** Função do usuário */
  UserRole = 'UserRole',
  /** Vacina */
  Vaccine = 'Vaccine',
  /** Centro de custo de vacina */
  VaccineCostCenter = 'VaccineCostCenter',
  /** Ocupação de vacina */
  VaccineOccupation = 'VaccineOccupation',
  /** Voto */
  Vote = 'Vote',
  /** Armazém */
  Warehouse = 'Warehouse',
  /** Turno de trabalho */
  WorkShift = 'WorkShift'
}

/** Tipo de ambiente */
export enum TEnvironmentType {
  /** Próprio */
  Owned = 'Owned',
  /** Terceiros */
  ThirdParty = 'ThirdParty'
}

export type TEnvironmentalReport = {
  __typename?: 'EnvironmentalReport';
  attachments?: Maybe<Array<TEnvironmentalReportAttachment>>;
  content?: Maybe<Scalars['String']['output']>;
  costCenter?: Maybe<TCostCenter>;
  documentClass?: Maybe<TDocumentClass>;
  documentDescription?: Maybe<Scalars['String']['output']>;
  documentNumber?: Maybe<Scalars['String']['output']>;
  /** Snapshot granular das entries (UF + número + especialidade) preenchidas no formulário externo. Usado para hidratar a edição. */
  documentRqeEntries?: Maybe<Array<TDoctorRqeEntry>>;
  documentState?: Maybe<TState>;
  elaborator: TPerson;
  endDate: Scalars['DateTime']['output'];
  environmentalReportCostCenter?: Maybe<Array<TEnvironmentalReportCostCenter>>;
  expirationDate: Scalars['DateTime']['output'];
  finality?: Maybe<TReportFinality>;
  id: Scalars['String']['output'];
  initialDate: Scalars['DateTime']['output'];
  objective: Scalars['String']['output'];
  physicalEnvironment?: Maybe<TPhysicalEnvironment>;
  reportAttachments?: Maybe<Array<TAttachment>>;
  reportStructure?: Maybe<TReportStructure>;
  reportStructureId?: Maybe<Scalars['String']['output']>;
  review: Scalars['String']['output'];
  statementResponsibility?: Maybe<TStatementResponsibility>;
  type: TReportType;
};

export type TEnvironmentalReportAttachment = {
  __typename?: 'EnvironmentalReportAttachment';
  /** Tamanho do anexo */
  contentLength: Scalars['Float']['output'];
  /** Tipo de conteúdo */
  contentType: Scalars['String']['output'];
  /** Data de criação do anexo */
  createdAt: Scalars['DateTime']['output'];
  /** Nome do arquivo */
  filename: Scalars['String']['output'];
  /** Identificador único do anexo */
  id: Scalars['String']['output'];
  /** Indica se o anexo é um documento assinado */
  isSignDocument?: Maybe<Scalars['Boolean']['output']>;
  isTable?: Maybe<Scalars['Boolean']['output']>;
  /** URL de upload do anexo */
  uploadUrl?: Maybe<Scalars['String']['output']>;
  /** Usuário que fez o upload */
  uploadedBy: Scalars['String']['output'];
  /** URL do anexo */
  url: Scalars['S3UrlCloudFront']['output'];
};

export type TEnvironmentalReportAttachmentInput = {
  contentLength: Scalars['Float']['input'];
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  isTable?: InputMaybe<Scalars['Boolean']['input']>;
  upload: Scalars['Upload']['input'];
};

export type TEnvironmentalReportBiometry = {
  __typename?: 'EnvironmentalReportBiometry';
  /** Biometria */
  biometry: TBiometry;
  /** Identificador único */
  id: Scalars['String']['output'];
};

export type TEnvironmentalReportBiometryInput = {
  /** Identificador da biometria */
  biometryId: Scalars['String']['input'];
  /** Imagem BMP */
  bmp?: InputMaybe<Scalars['String']['input']>;
  /** Dados da imagem */
  imageData: Scalars['String']['input'];
  /** DPI da imagem */
  imageDpi?: InputMaybe<Scalars['Float']['input']>;
  /** Altura da imagem */
  imageHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Qualidade da imagem */
  imageQuality?: InputMaybe<Scalars['Float']['input']>;
  /** Largura da imagem */
  imageWidth?: InputMaybe<Scalars['Float']['input']>;
  /** Fabricante do equipamento */
  manufacturer: Scalars['String']['input'];
  /** Modelo do equipamento */
  model?: InputMaybe<Scalars['String']['input']>;
  /** NFIQ (NIST Fingerprint Image Quality) */
  nfiq?: InputMaybe<Scalars['Float']['input']>;
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
  /** Número de série */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Template da biometria */
  template?: InputMaybe<Scalars['String']['input']>;
  /** Imagem WSQ */
  wsqImage?: InputMaybe<Scalars['String']['input']>;
  /** Tamanho da imagem WSQ */
  wsqImageSize?: InputMaybe<Scalars['Float']['input']>;
};

export type TEnvironmentalReportCostCenter = {
  __typename?: 'EnvironmentalReportCostCenter';
  branch: Scalars['String']['output'];
  costCenter?: Maybe<TCostCenter>;
  id: Scalars['String']['output'];
};

export type TEnvironmentalReportCostCenterInput = {
  costCenterId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type TEnvironmentalReportDocumentResponse = {
  __typename?: 'EnvironmentalReportDocumentResponse';
  attachmentId: Scalars['String']['output'];
  certificateId: Scalars['String']['output'];
  documentId: Scalars['Int']['output'];
  environmentalReportId: Scalars['String']['output'];
  isEmbedded?: Maybe<Scalars['Boolean']['output']>;
  pending?: Maybe<Array<TDocumentPending>>;
  status?: Maybe<TDocumentStatus>;
};

export type TEnvironmentalReportFace = {
  __typename?: 'EnvironmentalReportFace';
  /** Identificador do relatório ambiental */
  environmentalReportId: Scalars['String']['output'];
  /** Identificador único */
  id: Scalars['String']['output'];
  /** URL para upload do thumbnail */
  uploadThumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** URL do arquivo */
  uploadUrl?: Maybe<Scalars['String']['output']>;
};

export type TEnvironmentalReportFaceInput = {
  /** Tamanho do conteúdo */
  contentLength: Scalars['Float']['input'];
  /** Tipo de conteúdo */
  contentType: Scalars['String']['input'];
  /** Latitude */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** Longitude */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** Permissão concedida */
  permissionGranted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
  /** Precisão */
  precision?: InputMaybe<Scalars['Float']['input']>;
};

export type TEnvironmentalReportFilter = {
  costCenters?: InputMaybe<Array<Scalars['String']['input']>>;
  expirationDates?: InputMaybe<TDateRange>;
  initialDates?: InputMaybe<TDateRange>;
  physicalEnvironments?: InputMaybe<Array<Scalars['String']['input']>>;
  reportStructures?: InputMaybe<Array<Scalars['String']['input']>>;
  types?: InputMaybe<Array<TReportType>>;
};

export type TEnvironmentalReportInput = {
  attachmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  content?: InputMaybe<Scalars['String']['input']>;
  costCenterId?: InputMaybe<Scalars['String']['input']>;
  costCenters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** RQEs do elaborador médico (até 2) para snapshot. Backend usa automaticamente quando elaborator é User com RQEs primários cadastrados; caso contrário, são digitados no formulário (elaborador externo). */
  doctorRqeInput?: InputMaybe<Array<TDoctorRqeEntryInput>>;
  documentClass?: InputMaybe<TDocumentClass>;
  documentDescription?: InputMaybe<Scalars['String']['input']>;
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  documentState?: InputMaybe<TState>;
  elaboratorId: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  expirationDate: Scalars['DateTime']['input'];
  finality?: InputMaybe<TReportFinality>;
  initialDate: Scalars['DateTime']['input'];
  objective: Scalars['String']['input'];
  physicalEnvironmentId?: InputMaybe<Scalars['String']['input']>;
  reportStructureId?: InputMaybe<Scalars['String']['input']>;
  review: Scalars['String']['input'];
  statementResponsibilityId?: InputMaybe<Scalars['String']['input']>;
  type: TReportType;
};

/** Campos disponíveis para ordenação dos laudos e programas */
export enum TEnvironmentalReportOrderByField {
  ExpirationDate = 'ExpirationDate',
  InitialDate = 'InitialDate',
  Objective = 'Objective'
}

export type TEnvironmentalReportOrderByInput = {
  field?: InputMaybe<TEnvironmentalReportOrderByField>;
  type?: InputMaybe<TOrderBy>;
};

export type TEnvironmentalReportParams = {
  costCenterId?: InputMaybe<Scalars['String']['input']>;
  documentClass?: InputMaybe<Scalars['String']['input']>;
  documentDescription?: InputMaybe<Scalars['String']['input']>;
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  documentState?: InputMaybe<Scalars['String']['input']>;
  elaboratorId?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  expirationDate: Scalars['DateTime']['input'];
  generateHTML?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  initialDate: Scalars['DateTime']['input'];
  physicalEnvironmentId?: InputMaybe<Scalars['String']['input']>;
  reportStructureId?: InputMaybe<Scalars['String']['input']>;
  review?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TReportType>;
};

export type TEnvironmentalReportQueryInput = {
  filter?: InputMaybe<TEnvironmentalReportFilter>;
  /** Identificador ou termo de busca */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Retornar apenas registros ativos */
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TEnvironmentalReportSuggestion = {
  __typename?: 'EnvironmentalReportSuggestion';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TEnvironmentalReportUpdate = {
  attachmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  attachmentsToRemove?: InputMaybe<Array<Scalars['String']['input']>>;
  content?: InputMaybe<Scalars['String']['input']>;
  costCenterId?: InputMaybe<Scalars['String']['input']>;
  costCenters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** RQEs do elaborador médico (até 2) para snapshot. Backend usa automaticamente quando elaborator é User com RQEs primários cadastrados; caso contrário, são digitados no formulário (elaborador externo). */
  doctorRqeInput?: InputMaybe<Array<TDoctorRqeEntryInput>>;
  documentClass?: InputMaybe<TDocumentClass>;
  documentDescription?: InputMaybe<Scalars['String']['input']>;
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  documentState?: InputMaybe<TState>;
  elaboratorId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  environmentalReportCostCenter?: InputMaybe<Array<TEnvironmentalReportCostCenterInput>>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  finality?: InputMaybe<TReportFinality>;
  id: Scalars['String']['input'];
  initialDate?: InputMaybe<Scalars['DateTime']['input']>;
  objective?: InputMaybe<Scalars['String']['input']>;
  physicalEnvironmentId?: InputMaybe<Scalars['String']['input']>;
  reportAttachments?: InputMaybe<Array<Scalars['String']['input']>>;
  reportStructureId?: InputMaybe<Scalars['String']['input']>;
  review?: InputMaybe<Scalars['String']['input']>;
  shouldUpdateAttachments?: InputMaybe<Scalars['Boolean']['input']>;
  statementResponsibilityId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TReportType>;
};

export type TEnvironmentalReportVersion = {
  __typename?: 'EnvironmentalReportVersion';
  /** Tamanho do anexo */
  contentLength: Scalars['Float']['output'];
  /** Tipo de conteúdo */
  contentType: Scalars['String']['output'];
  /** Data de criação do anexo */
  createdAt: Scalars['DateTime']['output'];
  /** Data de soft-delete da versão */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID do laudo ambiental ao qual a versão pertence */
  environmentalReportId: Scalars['String']['output'];
  /** Nome do arquivo */
  filename: Scalars['String']['output'];
  /** Identificador único do anexo */
  id: Scalars['String']['output'];
  /** Indica se o anexo é um documento assinado */
  isSignDocument?: Maybe<Scalars['Boolean']['output']>;
  /** Identificador da revisão digitado pelo usuário */
  revision: Scalars['String']['output'];
  /** Data da última atualização da versão */
  updatedAt: Scalars['DateTime']['output'];
  /** URL de upload do anexo */
  uploadUrl?: Maybe<Scalars['String']['output']>;
  /** Usuário que fez o upload */
  uploadedBy: Scalars['String']['output'];
  /** URL do anexo */
  url: Scalars['S3UrlCloudFront']['output'];
};

export type TEpcByAgentGroupItem = {
  __typename?: 'EpcByAgentGroupItem';
  /** Quantidade de riscos com EPC necessário */
  count: Scalars['Int']['output'];
  /** Grupo do agente */
  group: TAgentGroup;
};

export type TEpcIncidenceChart = {
  __typename?: 'EpcIncidenceChart';
  /** Distribuição dos riscos com EPC necessário por grupo de agente */
  byAgentGroup: Array<TEpcByAgentGroupItem>;
  /** Indica se há riscos com EPC necessário no período */
  hasEpc: Scalars['Boolean']['output'];
  /** Quantidade total de riscos cadastrados no período */
  totalRisks: Scalars['Int']['output'];
  /** Quantidade de riscos com EPC necessário no período */
  withEpc: Scalars['Int']['output'];
};

export type TEpiLifespanChart = {
  __typename?: 'EpiLifespanChart';
  /** Indica se há dados suficientes para o cálculo */
  hasData: Scalars['Boolean']['output'];
  /** Top 5 CAs com maior variação entre cadastrado e real */
  items: Array<TEpiLifespanItem>;
};

export type TEpiLifespanItem = {
  __typename?: 'EpiLifespanItem';
  /** Aderência percentual (real/cadastrado * 100) */
  adherencePct: Scalars['Float']['output'];
  /** Código do CA */
  caCode: Scalars['String']['output'];
  /** Quantidade de pares consecutivos usados no cálculo */
  deliveries: Scalars['Float']['output'];
  /** Descrição do EPI */
  description: Scalars['String']['output'];
  /** Quantidade de pessoas distintas no cálculo */
  distinctPeople: Scalars['Float']['output'];
  /** Vida útil real em dias (média entre entregas) */
  real: Scalars['Float']['output'];
  /** Vida útil cadastrada em dias (média entre contextos) */
  registered: Scalars['Float']['output'];
};

export type TEquipmentByCostCenter = {
  __typename?: 'EquipmentByCostCenter';
  /** Certificado de Aprovação */
  caCode?: Maybe<Scalars['String']['output']>;
  /** Centro de custo */
  costCenter: TCostCenter;
  /** Dias para substituição */
  daysForReplacement?: Maybe<Scalars['Float']['output']>;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Equipamento de proteção individual */
  ipe: TIpe;
};

export type TEquipmentByCostCenterInput = {
  /** Certificado de Aprovação */
  caCode?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do centro de custo */
  costCenterId: Scalars['String']['input'];
  /** Dias para substituição */
  daysForReplacement?: InputMaybe<Scalars['Float']['input']>;
  /** Identificador do IPE */
  ipeId: Scalars['String']['input'];
};

export type TEquipmentByOccupation = {
  __typename?: 'EquipmentByOccupation';
  /** Certificado de Aprovação */
  caCode?: Maybe<Scalars['String']['output']>;
  /** Dias para substituição */
  daysForReplacement?: Maybe<Scalars['Float']['output']>;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Equipamento de proteção individual */
  ipe: TIpe;
  /** Cargo */
  occupation: TOccupation;
};

export type TEquipmentByOccupationInput = {
  /** Certificado de Aprovação */
  caCode?: InputMaybe<Scalars['String']['input']>;
  /** Dias para substituição */
  daysForReplacement?: InputMaybe<Scalars['Float']['input']>;
  /** Identificador do IPE */
  ipeId: Scalars['String']['input'];
  /** Identificador do cargo */
  occupationId: Scalars['String']['input'];
};

export type TEquipmentOnCostCenterInput = {
  /** Certificado de Aprovação */
  caCode?: InputMaybe<Scalars['String']['input']>;
  /** Dias para substituição */
  daysForReplacement?: InputMaybe<Scalars['Float']['input']>;
  /** Identificador do IPE */
  ipeId: Scalars['String']['input'];
};

export type TEquipmentOnCostCenterUpdate = {
  /** Equipamentos a criar */
  toCreate: Array<TEquipmentOnCostCenterInput>;
  /** Equipamentos a remover */
  toRemove: Array<Scalars['String']['input']>;
};

export type TEquipmentOnOccupationInput = {
  /** Certificado de Aprovação */
  caCode?: InputMaybe<Scalars['String']['input']>;
  /** Dias para substituição */
  daysForReplacement?: InputMaybe<Scalars['Float']['input']>;
  /** Identificador do IPE */
  ipeId: Scalars['String']['input'];
};

export type TEquipmentOnOccupationUpdate = {
  /** Equipamentos a criar */
  toCreate: Array<TEquipmentOnOccupationInput>;
  /** Equipamentos a remover */
  toRemove: Array<Scalars['String']['input']>;
};

/** Status ergonômico */
export enum TErgonomicStatus {
  /** Adequado */
  Adequate = 'Adequate',
  /** Inadequado */
  Inadequate = 'Inadequate'
}

/** Linha de ERP */
export enum TErpLine {
  /** Datasul */
  Datasul = 'Datasul',
  /** Protheus */
  Protheus = 'Protheus',
  /** RM */
  Rm = 'RM'
}

/** Tipo de ERP */
export enum TErpType {
  /** Personalizado */
  Custom = 'Custom',
  ESocial = 'ESocial',
  /** Fake ERP */
  FakeErp = 'FakeERP',
  /** Movimentação de inventário */
  InventoryMovement = 'InventoryMovement',
  /** Solicitação de inventário */
  InventoryRequest = 'InventoryRequest',
  /** Keepfy Inventário */
  KeepfyInventory = 'KeepfyInventory',
  /** Middleware */
  Middleware = 'Middleware',
  /** Omie (entrada) */
  OmieIn = 'OmieIn',
  /** Omie (saída) */
  OmieOut = 'OmieOut',
  /** SOC */
  Soc = 'SOC',
  /** TAF */
  Taf = 'TAF',
  /** TTalk */
  TTalk = 'TTalk',
  /** TOTVS Moda */
  TotvsModa = 'TotvsModa',
  /** WEG MFM */
  WegMfm = 'WegMfm'
}

export type TErrorResponse = {
  __typename?: 'ErrorResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type TEvent = {
  __typename?: 'Event';
  /** Data de referência */
  dateReference: Scalars['String']['output'];
  /** Identificador único do evento */
  id: Scalars['String']['output'];
  /** Indica se o evento está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Mensagem do evento */
  message: Scalars['String']['output'];
  /** Dias antes do fim */
  subDaysEnd: Scalars['Float']['output'];
  /** Dias antes do início */
  subDaysStart: Scalars['Float']['output'];
  /** Tipo do evento */
  type: Scalars['String']['output'];
};

export type TEventOnSipatInput = {
  /** Comentários adicionais sobre o evento */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Custo do evento */
  cost?: InputMaybe<Scalars['Float']['input']>;
  /** Data de término do evento */
  dateEnd: Scalars['DateTime']['input'];
  /** Data de início do evento */
  dateStart: Scalars['DateTime']['input'];
  /** Local onde o evento será realizado */
  localEvent: Scalars['String']['input'];
  /** ID da pessoa responsável pelo evento */
  personId: Scalars['String']['input'];
  /** Assunto do evento */
  subject: Scalars['String']['input'];
};

export type TEventOnSipatRemove = {
  /** Data de início do evento */
  dateStart: Scalars['DateTime']['input'];
  /** ID da pessoa responsável pelo evento */
  personId: Scalars['String']['input'];
};

export type TEventOnSipatUpdate = {
  /** Eventos a serem criados */
  toCreate: Array<TEventOnSipatInput>;
  /** Eventos a serem removidos */
  toRemove: Array<TEventOnSipatRemove>;
  /** Eventos a serem atualizados */
  toUpdate: Array<TEventOnSipatInput>;
};

/** Caráter evolutivo da doença */
export enum TEvolutionaryCharacterEnum {
  /** Não confirmado */
  NotConfirmed = 'NotConfirmed',
  /** Em progressão */
  Progression = 'Progression',
  /** Estável */
  Stable = 'Stable'
}

export type TExam = {
  __typename?: 'Exam';
  /** Indica se o exame é admissional */
  admission: Scalars['Boolean']['output'];
  /** Indica se o exame é de volta ao trabalho */
  backToWork: Scalars['Boolean']['output'];
  /** Indica se o exame é de mudança de função */
  changeOfFunction: Scalars['Boolean']['output'];
  /** Descrição */
  description: Scalars['String']['output'];
  /** Indica se o exame é demissional */
  dismissal: Scalars['Boolean']['output'];
  /** Procedimento de exame */
  examinationProcedure?: Maybe<TGenericExaminationProcedure>;
  /** Análise de grupo */
  groupAnalysis?: Maybe<Array<TGroupAnalysis>>;
  /** Exame IBMP */
  ibmp?: Maybe<TExamIbmp>;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Indica se está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Indica se o exame é periódico */
  periodic: Scalars['Boolean']['output'];
  /** Faixa periódica */
  periodicRange?: Maybe<TPeriodicRange>;
  /** Preparação */
  preparation?: Maybe<Scalars['String']['output']>;
  /** Identificador de referência */
  referenceId?: Maybe<Scalars['String']['output']>;
  /** Tipo de Resultado */
  resultType: TResultTypeEnum;
  /** Sugestão */
  suggestion: Scalars['String']['output'];
};

/** Agravamento do exame */
export enum TExamAggravationEnum {
  /** Não ocupacional */
  NonOccupational = 'NonOccupational',
  /** Ocupacional */
  Occupational = 'Occupational'
}

export type TExamAlterationTrend = {
  __typename?: 'ExamAlterationTrend';
  /** Total de exames alterados */
  altered: Scalars['Float']['output'];
  /** Total de exames normais */
  normal: Scalars['Float']['output'];
  /** Ano */
  period: Scalars['String']['output'];
};

export type TExamAnalysis = {
  __typename?: 'ExamAnalysis';
  annual_number_of_exams_performed: Scalars['String']['output'];
  exam: Scalars['String']['output'];
  number_of_abnormal_results: Scalars['String']['output'];
  percentage_of_abnormal_results: Scalars['String']['output'];
};

export type TExamAudiometry = {
  __typename?: 'ExamAudiometry';
  calibrationDate: Scalars['DateTime']['output'];
  complementaryExam?: Maybe<TComplementaryExam>;
  consultation?: Maybe<TConsultation>;
  /** CRM do médico */
  crm?: Maybe<Scalars['String']['output']>;
  date: Scalars['DateTime']['output'];
  /** Detalhes do exame */
  details?: Maybe<Scalars['String']['output']>;
  diagnosticIndicator: TExamDiagnosticIndicatorEnum;
  /** Nome do médico */
  doctor?: Maybe<Scalars['String']['output']>;
  equipment: TMeasuringInstrument;
  examAuthorization: Scalars['Boolean']['output'];
  gaugingDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  indicator: TExamResultIndicatorEnum;
  /** Observações */
  observations?: Maybe<Scalars['String']['output']>;
  odAirEight?: Maybe<Scalars['Float']['output']>;
  odAirFour?: Maybe<Scalars['Float']['output']>;
  odAirHigherAvg?: Maybe<Scalars['Float']['output']>;
  odAirLowerAvg?: Maybe<Scalars['Float']['output']>;
  odAirMaskEight?: Maybe<Scalars['Float']['output']>;
  odAirMaskFour?: Maybe<Scalars['Float']['output']>;
  odAirMaskMarkedEight: Scalars['Boolean']['output'];
  odAirMaskMarkedFour: Scalars['Boolean']['output'];
  odAirMaskMarkedOne: Scalars['Boolean']['output'];
  odAirMaskMarkedPointFive: Scalars['Boolean']['output'];
  odAirMaskMarkedPointTwentyFive: Scalars['Boolean']['output'];
  odAirMaskMarkedSix: Scalars['Boolean']['output'];
  odAirMaskMarkedThree: Scalars['Boolean']['output'];
  odAirMaskMarkedTwo: Scalars['Boolean']['output'];
  odAirMaskMax?: Maybe<Scalars['Float']['output']>;
  odAirMaskMin?: Maybe<Scalars['Float']['output']>;
  odAirMaskOne?: Maybe<Scalars['Float']['output']>;
  odAirMaskPointFive?: Maybe<Scalars['Float']['output']>;
  odAirMaskPointTwentyFive?: Maybe<Scalars['Float']['output']>;
  odAirMaskSix?: Maybe<Scalars['Float']['output']>;
  odAirMaskThree?: Maybe<Scalars['Float']['output']>;
  odAirMaskTwo?: Maybe<Scalars['Float']['output']>;
  odAirOne?: Maybe<Scalars['Float']['output']>;
  odAirPointFive?: Maybe<Scalars['Float']['output']>;
  odAirPointTwentyFive?: Maybe<Scalars['Float']['output']>;
  odAirSix?: Maybe<Scalars['Float']['output']>;
  odAirThree?: Maybe<Scalars['Float']['output']>;
  odAirTwo?: Maybe<Scalars['Float']['output']>;
  odBoneFour?: Maybe<Scalars['Float']['output']>;
  odBoneMaskFour?: Maybe<Scalars['Float']['output']>;
  odBoneMaskMarkedFour: Scalars['Boolean']['output'];
  odBoneMaskMarkedOne: Scalars['Boolean']['output'];
  odBoneMaskMarkedPointFive: Scalars['Boolean']['output'];
  odBoneMaskMarkedThree: Scalars['Boolean']['output'];
  odBoneMaskMarkedTwo: Scalars['Boolean']['output'];
  odBoneMaskMax?: Maybe<Scalars['Float']['output']>;
  odBoneMaskMin?: Maybe<Scalars['Float']['output']>;
  odBoneMaskOne?: Maybe<Scalars['Float']['output']>;
  odBoneMaskPointFive?: Maybe<Scalars['Float']['output']>;
  odBoneMaskThree?: Maybe<Scalars['Float']['output']>;
  odBoneMaskTwo?: Maybe<Scalars['Float']['output']>;
  odBoneOne?: Maybe<Scalars['Float']['output']>;
  odBonePointFive?: Maybe<Scalars['Float']['output']>;
  odBoneThree?: Maybe<Scalars['Float']['output']>;
  odBoneTwo?: Maybe<Scalars['Float']['output']>;
  odClinicalResult: TAudiometryClinicalEnum;
  odInssResult: TAudiometryInssEnum;
  odIrfMasking?: Maybe<Scalars['Float']['output']>;
  odIrfMonosyllables?: Maybe<Scalars['Float']['output']>;
  odIrfSyllables?: Maybe<Scalars['Float']['output']>;
  odLossTypeResult?: Maybe<TAudiometryLossTypeEnum>;
  odMeatoscopy?: Maybe<Scalars['String']['output']>;
  odOrdinanceResult: TAudiometryOrdinanceEnum;
  odSdtIndex?: Maybe<Scalars['Float']['output']>;
  odSrtIndex?: Maybe<Scalars['Float']['output']>;
  odSrtMasking?: Maybe<Scalars['Float']['output']>;
  oeAirEight?: Maybe<Scalars['Float']['output']>;
  oeAirFour?: Maybe<Scalars['Float']['output']>;
  oeAirHigherAvg?: Maybe<Scalars['Float']['output']>;
  oeAirLowerAvg?: Maybe<Scalars['Float']['output']>;
  oeAirMaskEight?: Maybe<Scalars['Float']['output']>;
  oeAirMaskFour?: Maybe<Scalars['Float']['output']>;
  oeAirMaskMarkedEight: Scalars['Boolean']['output'];
  oeAirMaskMarkedFour: Scalars['Boolean']['output'];
  oeAirMaskMarkedOne: Scalars['Boolean']['output'];
  oeAirMaskMarkedPointFive: Scalars['Boolean']['output'];
  oeAirMaskMarkedPointTwentyFive: Scalars['Boolean']['output'];
  oeAirMaskMarkedSix: Scalars['Boolean']['output'];
  oeAirMaskMarkedThree: Scalars['Boolean']['output'];
  oeAirMaskMarkedTwo: Scalars['Boolean']['output'];
  oeAirMaskMax?: Maybe<Scalars['Float']['output']>;
  oeAirMaskMin?: Maybe<Scalars['Float']['output']>;
  oeAirMaskOne?: Maybe<Scalars['Float']['output']>;
  oeAirMaskPointFive?: Maybe<Scalars['Float']['output']>;
  oeAirMaskPointTwentyFive?: Maybe<Scalars['Float']['output']>;
  oeAirMaskSix?: Maybe<Scalars['Float']['output']>;
  oeAirMaskThree?: Maybe<Scalars['Float']['output']>;
  oeAirMaskTwo?: Maybe<Scalars['Float']['output']>;
  oeAirOne?: Maybe<Scalars['Float']['output']>;
  oeAirPointFive?: Maybe<Scalars['Float']['output']>;
  oeAirPointTwentyFive?: Maybe<Scalars['Float']['output']>;
  oeAirSix?: Maybe<Scalars['Float']['output']>;
  oeAirThree?: Maybe<Scalars['Float']['output']>;
  oeAirTwo?: Maybe<Scalars['Float']['output']>;
  oeBoneFour?: Maybe<Scalars['Float']['output']>;
  oeBoneMaskFour?: Maybe<Scalars['Float']['output']>;
  oeBoneMaskMarkedFour: Scalars['Boolean']['output'];
  oeBoneMaskMarkedOne: Scalars['Boolean']['output'];
  oeBoneMaskMarkedPointFive: Scalars['Boolean']['output'];
  oeBoneMaskMarkedThree: Scalars['Boolean']['output'];
  oeBoneMaskMarkedTwo: Scalars['Boolean']['output'];
  oeBoneMaskMax?: Maybe<Scalars['Float']['output']>;
  oeBoneMaskMin?: Maybe<Scalars['Float']['output']>;
  oeBoneMaskOne?: Maybe<Scalars['Float']['output']>;
  oeBoneMaskPointFive?: Maybe<Scalars['Float']['output']>;
  oeBoneMaskThree?: Maybe<Scalars['Float']['output']>;
  oeBoneMaskTwo?: Maybe<Scalars['Float']['output']>;
  oeBoneOne?: Maybe<Scalars['Float']['output']>;
  oeBonePointFive?: Maybe<Scalars['Float']['output']>;
  oeBoneThree?: Maybe<Scalars['Float']['output']>;
  oeBoneTwo?: Maybe<Scalars['Float']['output']>;
  oeClinicalResult: TAudiometryClinicalEnum;
  oeInssResult: TAudiometryInssEnum;
  oeIrfMasking?: Maybe<Scalars['Float']['output']>;
  oeIrfMonosyllables?: Maybe<Scalars['Float']['output']>;
  oeIrfSyllables?: Maybe<Scalars['Float']['output']>;
  oeLossTypeResult?: Maybe<TAudiometryLossTypeEnum>;
  oeMeatoscopy?: Maybe<Scalars['String']['output']>;
  oeOrdinanceResult: TAudiometryOrdinanceEnum;
  oeSdtIndex?: Maybe<Scalars['Float']['output']>;
  oeSrtIndex?: Maybe<Scalars['Float']['output']>;
  oeSrtMasking?: Maybe<Scalars['Float']['output']>;
  responsibleForMeasuring: TPerson;
  restTime?: Maybe<Scalars['String']['output']>;
  result: Scalars['String']['output'];
  /** Agravamento do resultado */
  resultAggravation?: Maybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: Maybe<TExamResultAlterationEnum>;
  /** Estado do CRM */
  state?: Maybe<TState>;
};

export type TExamAudiometryInput = {
  calibrationDate: Scalars['DateTime']['input'];
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  consultationId?: InputMaybe<Scalars['String']['input']>;
  /** CRM do médico */
  crm?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['DateTime']['input'];
  /** Detalhes do exame */
  details?: InputMaybe<Scalars['String']['input']>;
  diagnosticIndicator: TExamDiagnosticIndicatorEnum;
  /** Nome do médico */
  doctor?: InputMaybe<Scalars['String']['input']>;
  equipmentId: Scalars['String']['input'];
  examAuthorization: Scalars['Boolean']['input'];
  gaugingDate: Scalars['DateTime']['input'];
  indicator: TExamResultIndicatorEnum;
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  odAirEight?: InputMaybe<Scalars['Float']['input']>;
  odAirFour?: InputMaybe<Scalars['Float']['input']>;
  odAirHigherAvg?: InputMaybe<Scalars['Float']['input']>;
  odAirLowerAvg?: InputMaybe<Scalars['Float']['input']>;
  odAirMaskEight?: InputMaybe<Scalars['Float']['input']>;
  odAirMaskFour?: InputMaybe<Scalars['Float']['input']>;
  odAirMaskMarkedEight: Scalars['Boolean']['input'];
  odAirMaskMarkedFour: Scalars['Boolean']['input'];
  odAirMaskMarkedOne: Scalars['Boolean']['input'];
  odAirMaskMarkedPointFive: Scalars['Boolean']['input'];
  odAirMaskMarkedPointTwentyFive: Scalars['Boolean']['input'];
  odAirMaskMarkedSix: Scalars['Boolean']['input'];
  odAirMaskMarkedThree: Scalars['Boolean']['input'];
  odAirMaskMarkedTwo: Scalars['Boolean']['input'];
  odAirMaskMax?: InputMaybe<Scalars['Float']['input']>;
  odAirMaskMin?: InputMaybe<Scalars['Float']['input']>;
  odAirMaskOne?: InputMaybe<Scalars['Float']['input']>;
  odAirMaskPointFive?: InputMaybe<Scalars['Float']['input']>;
  odAirMaskPointTwentyFive?: InputMaybe<Scalars['Float']['input']>;
  odAirMaskSix?: InputMaybe<Scalars['Float']['input']>;
  odAirMaskThree?: InputMaybe<Scalars['Float']['input']>;
  odAirMaskTwo?: InputMaybe<Scalars['Float']['input']>;
  odAirOne?: InputMaybe<Scalars['Float']['input']>;
  odAirPointFive?: InputMaybe<Scalars['Float']['input']>;
  odAirPointTwentyFive?: InputMaybe<Scalars['Float']['input']>;
  odAirSix?: InputMaybe<Scalars['Float']['input']>;
  odAirThree?: InputMaybe<Scalars['Float']['input']>;
  odAirTwo?: InputMaybe<Scalars['Float']['input']>;
  odBoneFour?: InputMaybe<Scalars['Float']['input']>;
  odBoneMaskFour?: InputMaybe<Scalars['Float']['input']>;
  odBoneMaskMarkedFour: Scalars['Boolean']['input'];
  odBoneMaskMarkedOne: Scalars['Boolean']['input'];
  odBoneMaskMarkedPointFive: Scalars['Boolean']['input'];
  odBoneMaskMarkedThree: Scalars['Boolean']['input'];
  odBoneMaskMarkedTwo: Scalars['Boolean']['input'];
  odBoneMaskMax?: InputMaybe<Scalars['Float']['input']>;
  odBoneMaskMin?: InputMaybe<Scalars['Float']['input']>;
  odBoneMaskOne?: InputMaybe<Scalars['Float']['input']>;
  odBoneMaskPointFive?: InputMaybe<Scalars['Float']['input']>;
  odBoneMaskThree?: InputMaybe<Scalars['Float']['input']>;
  odBoneMaskTwo?: InputMaybe<Scalars['Float']['input']>;
  odBoneOne?: InputMaybe<Scalars['Float']['input']>;
  odBonePointFive?: InputMaybe<Scalars['Float']['input']>;
  odBoneThree?: InputMaybe<Scalars['Float']['input']>;
  odBoneTwo?: InputMaybe<Scalars['Float']['input']>;
  odClinicalResult: TAudiometryClinicalEnum;
  odInssResult: TAudiometryInssEnum;
  odIrfMasking?: InputMaybe<Scalars['Float']['input']>;
  odIrfMonosyllables?: InputMaybe<Scalars['Float']['input']>;
  odIrfSyllables?: InputMaybe<Scalars['Float']['input']>;
  odLossTypeResult?: InputMaybe<TAudiometryLossTypeEnum>;
  odMeatoscopy?: InputMaybe<Scalars['String']['input']>;
  odOrdinanceResult: TAudiometryOrdinanceEnum;
  odSdtIndex?: InputMaybe<Scalars['Float']['input']>;
  odSrtIndex?: InputMaybe<Scalars['Float']['input']>;
  odSrtMasking?: InputMaybe<Scalars['Float']['input']>;
  oeAirEight?: InputMaybe<Scalars['Float']['input']>;
  oeAirFour?: InputMaybe<Scalars['Float']['input']>;
  oeAirHigherAvg?: InputMaybe<Scalars['Float']['input']>;
  oeAirLowerAvg?: InputMaybe<Scalars['Float']['input']>;
  oeAirMaskEight?: InputMaybe<Scalars['Float']['input']>;
  oeAirMaskFour?: InputMaybe<Scalars['Float']['input']>;
  oeAirMaskMarkedEight: Scalars['Boolean']['input'];
  oeAirMaskMarkedFour: Scalars['Boolean']['input'];
  oeAirMaskMarkedOne: Scalars['Boolean']['input'];
  oeAirMaskMarkedPointFive: Scalars['Boolean']['input'];
  oeAirMaskMarkedPointTwentyFive: Scalars['Boolean']['input'];
  oeAirMaskMarkedSix: Scalars['Boolean']['input'];
  oeAirMaskMarkedThree: Scalars['Boolean']['input'];
  oeAirMaskMarkedTwo: Scalars['Boolean']['input'];
  oeAirMaskMax?: InputMaybe<Scalars['Float']['input']>;
  oeAirMaskMin?: InputMaybe<Scalars['Float']['input']>;
  oeAirMaskOne?: InputMaybe<Scalars['Float']['input']>;
  oeAirMaskPointFive?: InputMaybe<Scalars['Float']['input']>;
  oeAirMaskPointTwentyFive?: InputMaybe<Scalars['Float']['input']>;
  oeAirMaskSix?: InputMaybe<Scalars['Float']['input']>;
  oeAirMaskThree?: InputMaybe<Scalars['Float']['input']>;
  oeAirMaskTwo?: InputMaybe<Scalars['Float']['input']>;
  oeAirOne?: InputMaybe<Scalars['Float']['input']>;
  oeAirPointFive?: InputMaybe<Scalars['Float']['input']>;
  oeAirPointTwentyFive?: InputMaybe<Scalars['Float']['input']>;
  oeAirSix?: InputMaybe<Scalars['Float']['input']>;
  oeAirThree?: InputMaybe<Scalars['Float']['input']>;
  oeAirTwo?: InputMaybe<Scalars['Float']['input']>;
  oeBoneFour?: InputMaybe<Scalars['Float']['input']>;
  oeBoneMaskFour?: InputMaybe<Scalars['Float']['input']>;
  oeBoneMaskMarkedFour: Scalars['Boolean']['input'];
  oeBoneMaskMarkedOne: Scalars['Boolean']['input'];
  oeBoneMaskMarkedPointFive: Scalars['Boolean']['input'];
  oeBoneMaskMarkedThree: Scalars['Boolean']['input'];
  oeBoneMaskMarkedTwo: Scalars['Boolean']['input'];
  oeBoneMaskMax?: InputMaybe<Scalars['Float']['input']>;
  oeBoneMaskMin?: InputMaybe<Scalars['Float']['input']>;
  oeBoneMaskOne?: InputMaybe<Scalars['Float']['input']>;
  oeBoneMaskPointFive?: InputMaybe<Scalars['Float']['input']>;
  oeBoneMaskThree?: InputMaybe<Scalars['Float']['input']>;
  oeBoneMaskTwo?: InputMaybe<Scalars['Float']['input']>;
  oeBoneOne?: InputMaybe<Scalars['Float']['input']>;
  oeBonePointFive?: InputMaybe<Scalars['Float']['input']>;
  oeBoneThree?: InputMaybe<Scalars['Float']['input']>;
  oeBoneTwo?: InputMaybe<Scalars['Float']['input']>;
  oeClinicalResult: TAudiometryClinicalEnum;
  oeInssResult: TAudiometryInssEnum;
  oeIrfMasking?: InputMaybe<Scalars['Float']['input']>;
  oeIrfMonosyllables?: InputMaybe<Scalars['Float']['input']>;
  oeIrfSyllables?: InputMaybe<Scalars['Float']['input']>;
  oeLossTypeResult?: InputMaybe<TAudiometryLossTypeEnum>;
  oeMeatoscopy?: InputMaybe<Scalars['String']['input']>;
  oeOrdinanceResult: TAudiometryOrdinanceEnum;
  oeSdtIndex?: InputMaybe<Scalars['Float']['input']>;
  oeSrtIndex?: InputMaybe<Scalars['Float']['input']>;
  oeSrtMasking?: InputMaybe<Scalars['Float']['input']>;
  responsibleForMeasuringId: Scalars['String']['input'];
  restTime?: InputMaybe<Scalars['String']['input']>;
  result: Scalars['String']['input'];
  /** Agravamento do resultado */
  resultAggravation?: InputMaybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: InputMaybe<TExamResultAlterationEnum>;
  /** Estado do CRM */
  state?: InputMaybe<TState>;
};

export type TExamAudiometryUpdate = {
  calibrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** CRM do médico */
  crm?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Detalhes do exame */
  details?: InputMaybe<Scalars['String']['input']>;
  diagnosticIndicator?: InputMaybe<TExamDiagnosticIndicatorEnum>;
  /** Nome do médico */
  doctor?: InputMaybe<Scalars['String']['input']>;
  equipmentId?: InputMaybe<Scalars['String']['input']>;
  examAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
  gaugingDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  indicator?: InputMaybe<TExamResultIndicatorEnum>;
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  odAirEight?: InputMaybe<Scalars['Float']['input']>;
  odAirFour?: InputMaybe<Scalars['Float']['input']>;
  odAirHigherAvg?: InputMaybe<Scalars['Float']['input']>;
  odAirLowerAvg?: InputMaybe<Scalars['Float']['input']>;
  odAirMaskEight?: InputMaybe<Scalars['Float']['input']>;
  odAirMaskFour?: InputMaybe<Scalars['Float']['input']>;
  odAirMaskMarkedEight?: InputMaybe<Scalars['Boolean']['input']>;
  odAirMaskMarkedFour?: InputMaybe<Scalars['Boolean']['input']>;
  odAirMaskMarkedOne?: InputMaybe<Scalars['Boolean']['input']>;
  odAirMaskMarkedPointFive?: InputMaybe<Scalars['Boolean']['input']>;
  odAirMaskMarkedPointTwentyFive?: InputMaybe<Scalars['Boolean']['input']>;
  odAirMaskMarkedSix?: InputMaybe<Scalars['Boolean']['input']>;
  odAirMaskMarkedThree?: InputMaybe<Scalars['Boolean']['input']>;
  odAirMaskMarkedTwo?: InputMaybe<Scalars['Boolean']['input']>;
  odAirMaskMax?: InputMaybe<Scalars['Float']['input']>;
  odAirMaskMin?: InputMaybe<Scalars['Float']['input']>;
  odAirMaskOne?: InputMaybe<Scalars['Float']['input']>;
  odAirMaskPointFive?: InputMaybe<Scalars['Float']['input']>;
  odAirMaskPointTwentyFive?: InputMaybe<Scalars['Float']['input']>;
  odAirMaskSix?: InputMaybe<Scalars['Float']['input']>;
  odAirMaskThree?: InputMaybe<Scalars['Float']['input']>;
  odAirMaskTwo?: InputMaybe<Scalars['Float']['input']>;
  odAirOne?: InputMaybe<Scalars['Float']['input']>;
  odAirPointFive?: InputMaybe<Scalars['Float']['input']>;
  odAirPointTwentyFive?: InputMaybe<Scalars['Float']['input']>;
  odAirSix?: InputMaybe<Scalars['Float']['input']>;
  odAirThree?: InputMaybe<Scalars['Float']['input']>;
  odAirTwo?: InputMaybe<Scalars['Float']['input']>;
  odBoneFour?: InputMaybe<Scalars['Float']['input']>;
  odBoneMaskFour?: InputMaybe<Scalars['Float']['input']>;
  odBoneMaskMarkedFour?: InputMaybe<Scalars['Boolean']['input']>;
  odBoneMaskMarkedOne?: InputMaybe<Scalars['Boolean']['input']>;
  odBoneMaskMarkedPointFive?: InputMaybe<Scalars['Boolean']['input']>;
  odBoneMaskMarkedThree?: InputMaybe<Scalars['Boolean']['input']>;
  odBoneMaskMarkedTwo?: InputMaybe<Scalars['Boolean']['input']>;
  odBoneMaskMax?: InputMaybe<Scalars['Float']['input']>;
  odBoneMaskMin?: InputMaybe<Scalars['Float']['input']>;
  odBoneMaskOne?: InputMaybe<Scalars['Float']['input']>;
  odBoneMaskPointFive?: InputMaybe<Scalars['Float']['input']>;
  odBoneMaskThree?: InputMaybe<Scalars['Float']['input']>;
  odBoneMaskTwo?: InputMaybe<Scalars['Float']['input']>;
  odBoneOne?: InputMaybe<Scalars['Float']['input']>;
  odBonePointFive?: InputMaybe<Scalars['Float']['input']>;
  odBoneThree?: InputMaybe<Scalars['Float']['input']>;
  odBoneTwo?: InputMaybe<Scalars['Float']['input']>;
  odClinicalResult?: InputMaybe<TAudiometryClinicalEnum>;
  odInssResult?: InputMaybe<TAudiometryInssEnum>;
  odIrfMasking?: InputMaybe<Scalars['Float']['input']>;
  odIrfMonosyllables?: InputMaybe<Scalars['Float']['input']>;
  odIrfSyllables?: InputMaybe<Scalars['Float']['input']>;
  odLossTypeResult?: InputMaybe<TAudiometryLossTypeEnum>;
  odMeatoscopy?: InputMaybe<Scalars['String']['input']>;
  odOrdinanceResult?: InputMaybe<TAudiometryOrdinanceEnum>;
  odSdtIndex?: InputMaybe<Scalars['Float']['input']>;
  odSrtIndex?: InputMaybe<Scalars['Float']['input']>;
  odSrtMasking?: InputMaybe<Scalars['Float']['input']>;
  oeAirEight?: InputMaybe<Scalars['Float']['input']>;
  oeAirFour?: InputMaybe<Scalars['Float']['input']>;
  oeAirHigherAvg?: InputMaybe<Scalars['Float']['input']>;
  oeAirLowerAvg?: InputMaybe<Scalars['Float']['input']>;
  oeAirMaskEight?: InputMaybe<Scalars['Float']['input']>;
  oeAirMaskFour?: InputMaybe<Scalars['Float']['input']>;
  oeAirMaskMarkedEight?: InputMaybe<Scalars['Boolean']['input']>;
  oeAirMaskMarkedFour?: InputMaybe<Scalars['Boolean']['input']>;
  oeAirMaskMarkedOne?: InputMaybe<Scalars['Boolean']['input']>;
  oeAirMaskMarkedPointFive?: InputMaybe<Scalars['Boolean']['input']>;
  oeAirMaskMarkedPointTwentyFive?: InputMaybe<Scalars['Boolean']['input']>;
  oeAirMaskMarkedSix?: InputMaybe<Scalars['Boolean']['input']>;
  oeAirMaskMarkedThree?: InputMaybe<Scalars['Boolean']['input']>;
  oeAirMaskMarkedTwo?: InputMaybe<Scalars['Boolean']['input']>;
  oeAirMaskMax?: InputMaybe<Scalars['Float']['input']>;
  oeAirMaskMin?: InputMaybe<Scalars['Float']['input']>;
  oeAirMaskOne?: InputMaybe<Scalars['Float']['input']>;
  oeAirMaskPointFive?: InputMaybe<Scalars['Float']['input']>;
  oeAirMaskPointTwentyFive?: InputMaybe<Scalars['Float']['input']>;
  oeAirMaskSix?: InputMaybe<Scalars['Float']['input']>;
  oeAirMaskThree?: InputMaybe<Scalars['Float']['input']>;
  oeAirMaskTwo?: InputMaybe<Scalars['Float']['input']>;
  oeAirOne?: InputMaybe<Scalars['Float']['input']>;
  oeAirPointFive?: InputMaybe<Scalars['Float']['input']>;
  oeAirPointTwentyFive?: InputMaybe<Scalars['Float']['input']>;
  oeAirSix?: InputMaybe<Scalars['Float']['input']>;
  oeAirThree?: InputMaybe<Scalars['Float']['input']>;
  oeAirTwo?: InputMaybe<Scalars['Float']['input']>;
  oeBoneFour?: InputMaybe<Scalars['Float']['input']>;
  oeBoneMaskFour?: InputMaybe<Scalars['Float']['input']>;
  oeBoneMaskMarkedFour?: InputMaybe<Scalars['Boolean']['input']>;
  oeBoneMaskMarkedOne?: InputMaybe<Scalars['Boolean']['input']>;
  oeBoneMaskMarkedPointFive?: InputMaybe<Scalars['Boolean']['input']>;
  oeBoneMaskMarkedThree?: InputMaybe<Scalars['Boolean']['input']>;
  oeBoneMaskMarkedTwo?: InputMaybe<Scalars['Boolean']['input']>;
  oeBoneMaskMax?: InputMaybe<Scalars['Float']['input']>;
  oeBoneMaskMin?: InputMaybe<Scalars['Float']['input']>;
  oeBoneMaskOne?: InputMaybe<Scalars['Float']['input']>;
  oeBoneMaskPointFive?: InputMaybe<Scalars['Float']['input']>;
  oeBoneMaskThree?: InputMaybe<Scalars['Float']['input']>;
  oeBoneMaskTwo?: InputMaybe<Scalars['Float']['input']>;
  oeBoneOne?: InputMaybe<Scalars['Float']['input']>;
  oeBonePointFive?: InputMaybe<Scalars['Float']['input']>;
  oeBoneThree?: InputMaybe<Scalars['Float']['input']>;
  oeBoneTwo?: InputMaybe<Scalars['Float']['input']>;
  oeClinicalResult?: InputMaybe<TAudiometryClinicalEnum>;
  oeInssResult?: InputMaybe<TAudiometryInssEnum>;
  oeIrfMasking?: InputMaybe<Scalars['Float']['input']>;
  oeIrfMonosyllables?: InputMaybe<Scalars['Float']['input']>;
  oeIrfSyllables?: InputMaybe<Scalars['Float']['input']>;
  oeLossTypeResult?: InputMaybe<TAudiometryLossTypeEnum>;
  oeMeatoscopy?: InputMaybe<Scalars['String']['input']>;
  oeOrdinanceResult?: InputMaybe<TAudiometryOrdinanceEnum>;
  oeSdtIndex?: InputMaybe<Scalars['Float']['input']>;
  oeSrtIndex?: InputMaybe<Scalars['Float']['input']>;
  oeSrtMasking?: InputMaybe<Scalars['Float']['input']>;
  responsibleForMeasuringId?: InputMaybe<Scalars['String']['input']>;
  restTime?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Scalars['String']['input']>;
  /** Agravamento do resultado */
  resultAggravation?: InputMaybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: InputMaybe<TExamResultAlterationEnum>;
  /** Estado do CRM */
  state?: InputMaybe<TState>;
};

export type TExamByBranchToPrint = {
  __typename?: 'ExamByBranchToPrint';
  accredited?: Maybe<Scalars['String']['output']>;
  branch?: Maybe<Scalars['String']['output']>;
  /** Centro de custo */
  costCenter?: Maybe<Scalars['String']['output']>;
  doctor?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  /** Categoria eSocial */
  eSocialCategory?: Maybe<Scalars['String']['output']>;
  /** Data de término */
  endDate: Scalars['String']['output'];
  erpBranch?: Maybe<Scalars['String']['output']>;
  /** Data estimada */
  estimatedDate: Scalars['String']['output'];
  /** Nome do exame */
  exam: Scalars['String']['output'];
  /** Matrícula individual */
  individualRegistration?: Maybe<Scalars['String']['output']>;
  /** Prontuário médico */
  medicalRecord: Scalars['String']['output'];
  /** Natureza da consulta */
  nature: Scalars['String']['output'];
  /** Ocupação */
  occupation?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  /** Matrícula */
  registration?: Maybe<Scalars['String']['output']>;
  /** Resultado */
  result: Scalars['String']['output'];
  /** Data de início */
  startDate: Scalars['String']['output'];
  /** Status */
  status: Scalars['String']['output'];
  /** Tipo de consulta */
  type: Scalars['String']['output'];
};

export type TExamByHealthProgram = {
  __typename?: 'ExamByHealthProgram';
  /** Indica se o exame é realizado na admissão */
  admission: Scalars['Boolean']['output'];
  /** Indica se o exame é realizado no retorno ao trabalho */
  backToWork: Scalars['Boolean']['output'];
  /** Indica se o exame é realizado na mudança de função */
  changeOfFunction: Scalars['Boolean']['output'];
  /** Indica se o exame é realizado na demissão */
  dismissal: Scalars['Boolean']['output'];
  /** Exame vinculado ao programa */
  exam: TExam;
  /** Identificador único do exame no programa de saúde */
  id: Scalars['String']['output'];
  /** Indica se o exame é periódico */
  periodic: Scalars['Boolean']['output'];
  /** Faixa de periodicidade do exame */
  periodicRange?: Maybe<TPeriodicRange>;
};

export type TExamByHealthProgramChanges = {
  /** Exames a adicionar ao programa de saúde */
  toCreate: Array<TExamByHealthProgramInput>;
  /** Identificadores dos exames a remover do programa */
  toRemove: Array<Scalars['String']['input']>;
  /** Exames do programa de saúde a atualizar */
  toUpdate: Array<TExamByHealthProgramUpdate>;
};

export type TExamByHealthProgramInput = {
  /** Indica se o exame é realizado na admissão */
  admission: Scalars['Boolean']['input'];
  /** Indica se o exame é realizado no retorno ao trabalho */
  backToWork: Scalars['Boolean']['input'];
  /** Indica se o exame é realizado na mudança de função */
  changeOfFunction: Scalars['Boolean']['input'];
  /** Indica se o exame é realizado na demissão */
  dismissal: Scalars['Boolean']['input'];
  /** Identificador do exame a vincular */
  examId: Scalars['String']['input'];
  /** Indica se o exame é periódico */
  periodic: Scalars['Boolean']['input'];
  /** Identificador da faixa de periodicidade */
  periodicRangeId?: InputMaybe<Scalars['String']['input']>;
};

export type TExamByHealthProgramUpdate = {
  /** Indica se o exame é realizado na admissão */
  admission: Scalars['Boolean']['input'];
  /** Indica se o exame é realizado no retorno ao trabalho */
  backToWork: Scalars['Boolean']['input'];
  /** Indica se o exame é realizado na mudança de função */
  changeOfFunction: Scalars['Boolean']['input'];
  /** Indica se o exame é realizado na demissão */
  dismissal: Scalars['Boolean']['input'];
  /** Identificador do exame a vincular */
  examId: Scalars['String']['input'];
  /** Identificador do exame no programa a atualizar */
  id: Scalars['String']['input'];
  /** Indica se o exame é periódico */
  periodic: Scalars['Boolean']['input'];
  /** Identificador da faixa de periodicidade */
  periodicRangeId?: InputMaybe<Scalars['String']['input']>;
};

export type TExamByOccupation = {
  __typename?: 'ExamByOccupation';
  /** Exigido na admissão */
  admission: Scalars['Boolean']['output'];
  /** Exigido no retorno ao trabalho */
  backToWork: Scalars['Boolean']['output'];
  /** Exigido na mudança de função */
  changeOfFunction: Scalars['Boolean']['output'];
  /** Exigido na demissão */
  dismissal: Scalars['Boolean']['output'];
  /** Exame */
  exam: TExam;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Cargo */
  occupation: TOccupation;
  /** Exigido no periódico */
  periodic: Scalars['Boolean']['output'];
  /** Periodicidade do exame */
  periodicRange?: Maybe<TPeriodicRange>;
};

export type TExamByOccupationChanges = {
  /** Exames a criar */
  toCreate: Array<TExamByOccupationInput>;
  /** Exames a remover */
  toRemove: Array<Scalars['String']['input']>;
  /** Exames a atualizar */
  toUpdate: Array<TExamByOccupationUpdate>;
};

export type TExamByOccupationInput = {
  /** Exigido na admissão */
  admission: Scalars['Boolean']['input'];
  /** Exigido no retorno ao trabalho */
  backToWork: Scalars['Boolean']['input'];
  /** Exigido na mudança de função */
  changeOfFunction: Scalars['Boolean']['input'];
  /** Exigido na demissão */
  dismissal: Scalars['Boolean']['input'];
  /** Identificador do exame */
  examId: Scalars['String']['input'];
  /** Exigido no periódico */
  periodic: Scalars['Boolean']['input'];
  /** Identificador da periodicidade */
  periodicRangeId?: InputMaybe<Scalars['String']['input']>;
};

export type TExamByOccupationUpdate = {
  /** Exigido na admissão */
  admission: Scalars['Boolean']['input'];
  /** Exigido no retorno ao trabalho */
  backToWork: Scalars['Boolean']['input'];
  /** Exigido na mudança de função */
  changeOfFunction: Scalars['Boolean']['input'];
  /** Exigido na demissão */
  dismissal: Scalars['Boolean']['input'];
  /** Identificador do exame */
  examId: Scalars['String']['input'];
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Exigido no periódico */
  periodic: Scalars['Boolean']['input'];
  /** Identificador da periodicidade */
  periodicRangeId?: InputMaybe<Scalars['String']['input']>;
};

export type TExamByPerson = {
  __typename?: 'ExamByPerson';
  /** Descrição do exame */
  examDescription: Scalars['String']['output'];
  /** Identificador do exame */
  examId: Scalars['String']['output'];
  /** Tipo de exame */
  examType: TExamByPersonTypeEnum;
  /** Origem da necessidade */
  needSource: TExamByPersonNeedSourceEnum;
};

/** Origem da necessidade do exame */
export enum TExamByPersonNeedSourceEnum {
  /** Exame */
  Exam = 'Exam',
  /** Brigada de incêndio */
  FireBrigade = 'FireBrigade',
  /** Programa de saúde */
  HealthProgram = 'HealthProgram',
  /** Ocupação */
  Occupation = 'Occupation',
  /** Risco */
  Risk = 'Risk'
}

/** Tipo de exame por pessoa */
export enum TExamByPersonTypeEnum {
  /** Ocupacional */
  Occupational = 'Occupational',
  /** Qualidade de vida */
  QualityOfLife = 'QualityOfLife'
}

export type TExamByRisk = {
  __typename?: 'ExamByRisk';
  /** Exigido na admissão */
  admission: Scalars['Boolean']['output'];
  /** Exigido no retorno ao trabalho */
  backToWork: Scalars['Boolean']['output'];
  /** Exigido na mudança de função */
  changeOfFunction: Scalars['Boolean']['output'];
  /** Exigido na demissão */
  dismissal: Scalars['Boolean']['output'];
  /** Exame */
  exam: TExam;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Exigido no periódico */
  periodic: Scalars['Boolean']['output'];
  /** Periodicidade do exame */
  periodicRange?: Maybe<TPeriodicRange>;
  /** Risco */
  risk: TRisk;
};

export type TExamByRiskChanges = {
  /** Exames a criar */
  toCreate: Array<TExamByRiskInput>;
  /** Exames a remover */
  toRemove: Array<Scalars['String']['input']>;
  /** Exames a atualizar */
  toUpdate: Array<TExamByRiskUpdate>;
};

export type TExamByRiskInput = {
  /** Exigido na admissão */
  admission: Scalars['Boolean']['input'];
  /** Exigido no retorno ao trabalho */
  backToWork: Scalars['Boolean']['input'];
  /** Exigido na mudança de função */
  changeOfFunction: Scalars['Boolean']['input'];
  /** Exigido na demissão */
  dismissal: Scalars['Boolean']['input'];
  /** Identificador do exame */
  examId: Scalars['String']['input'];
  /** Exigido no periódico */
  periodic: Scalars['Boolean']['input'];
  /** Identificador da periodicidade */
  periodicRangeId?: InputMaybe<Scalars['String']['input']>;
};

export type TExamByRiskUpdate = {
  /** Exigido na admissão */
  admission: Scalars['Boolean']['input'];
  /** Exigido no retorno ao trabalho */
  backToWork: Scalars['Boolean']['input'];
  /** Exigido na mudança de função */
  changeOfFunction: Scalars['Boolean']['input'];
  /** Exigido na demissão */
  dismissal: Scalars['Boolean']['input'];
  /** Identificador do exame */
  examId: Scalars['String']['input'];
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Exigido no periódico */
  periodic: Scalars['Boolean']['input'];
  /** Identificador da periodicidade */
  periodicRangeId?: InputMaybe<Scalars['String']['input']>;
};

export type TExamByTag = {
  __typename?: 'ExamByTag';
  /** Descrição */
  description: Scalars['String']['output'];
  /** Identificador */
  id: Scalars['String']['output'];
  /** Data da última realização */
  lastRealizationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Data da próxima realização */
  nextRealizationDate?: Maybe<Scalars['DateTime']['output']>;
};

export type TExamDiagnosticCount = {
  __typename?: 'ExamDiagnosticCount';
  altered: Scalars['Float']['output'];
  examType: Scalars['String']['output'];
  normal: Scalars['Float']['output'];
};

export type TExamDiagnosticImage = {
  __typename?: 'ExamDiagnosticImage';
  /** Anexos */
  attachments?: Maybe<Array<TAttachment>>;
  /** Exame complementar */
  complementaryExam?: Maybe<TComplementaryExam>;
  /** Consulta */
  consultation?: Maybe<TConsultation>;
  /** CRM do médico */
  crm?: Maybe<Scalars['String']['output']>;
  /** Data do exame */
  date: Scalars['DateTime']['output'];
  /** Descrição */
  description?: Maybe<Scalars['String']['output']>;
  /** Detalhes do exame */
  details?: Maybe<Scalars['String']['output']>;
  /** Indicador diagnóstico */
  diagnosticIndicator: TExamDiagnosticIndicatorEnum;
  /** Nome do médico */
  doctor?: Maybe<Scalars['String']['output']>;
  /** Autorização do exame */
  examAuthorization: Scalars['Boolean']['output'];
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Indicador do resultado */
  indicator: TExamResultIndicatorEnum;
  /** Observações */
  observations?: Maybe<Scalars['String']['output']>;
  /** Tempo de repouso */
  restTime?: Maybe<Scalars['String']['output']>;
  /** Resultado do exame */
  result: Scalars['String']['output'];
  /** Agravamento do resultado */
  resultAggravation?: Maybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: Maybe<TExamResultAlterationEnum>;
  /** Estado do CRM */
  state?: Maybe<TState>;
};

export type TExamDiagnosticImageInput = {
  /** Identificador do exame complementar */
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da consulta */
  consultationId?: InputMaybe<Scalars['String']['input']>;
  /** CRM do médico */
  crm?: InputMaybe<Scalars['String']['input']>;
  /** Data do exame */
  date: Scalars['DateTime']['input'];
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Detalhes do exame */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Indicador diagnóstico */
  diagnosticIndicator: TExamDiagnosticIndicatorEnum;
  /** Nome do médico */
  doctor?: InputMaybe<Scalars['String']['input']>;
  /** Autorização do exame */
  examAuthorization: Scalars['Boolean']['input'];
  /** Indicador do resultado */
  indicator: TExamResultIndicatorEnum;
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** Tempo de repouso */
  restTime?: InputMaybe<Scalars['String']['input']>;
  /** Resultado do exame */
  result: Scalars['String']['input'];
  /** Agravamento do resultado */
  resultAggravation?: InputMaybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: InputMaybe<TExamResultAlterationEnum>;
  /** Estado do CRM */
  state?: InputMaybe<TState>;
};

export type TExamDiagnosticImageUpdate = {
  /** CRM do médico */
  crm?: InputMaybe<Scalars['String']['input']>;
  /** Data do exame */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Detalhes do exame */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Indicador diagnóstico */
  diagnosticIndicator?: InputMaybe<TExamDiagnosticIndicatorEnum>;
  /** Nome do médico */
  doctor?: InputMaybe<Scalars['String']['input']>;
  /** Autorização do exame */
  examAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Indicador do resultado */
  indicator?: InputMaybe<TExamResultIndicatorEnum>;
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** Tempo de repouso */
  restTime?: InputMaybe<Scalars['String']['input']>;
  /** Resultado do exame */
  result?: InputMaybe<Scalars['String']['input']>;
  /** Agravamento do resultado */
  resultAggravation?: InputMaybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: InputMaybe<TExamResultAlterationEnum>;
  /** Estado do CRM */
  state?: InputMaybe<TState>;
};

/** Indicador diagnóstico do exame */
export enum TExamDiagnosticIndicatorEnum {
  /** Alterado */
  Alternate = 'Alternate',
  /** Normal */
  Normal = 'Normal'
}

/** Gênero do exame */
export enum TExamGenderEnum {
  /** Ambos */
  Both = 'Both',
  /** Feminino */
  Female = 'Female',
  /** Masculino */
  Male = 'Male'
}

export type TExamIbmp = {
  __typename?: 'ExamIbmp';
  /** Material biológico */
  biologicalMaterial: TBiologicalMaterial;
  /** Unidade de medida */
  examMeasure: TExamMeasure;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Valor máximo permitido */
  maximumAllowed: Scalars['Float']['output'];
  /** Valor de referência */
  reference: Scalars['Float']['output'];
  /** Agente de risco */
  riskAgent: TRiskAgent;
};

export type TExamIbmpInput = {
  /** Material biológico */
  biologicalMaterial: TBiologicalMaterial;
  /** Filial */
  branch?: InputMaybe<Scalars['String']['input']>;
  /** Unidade de medida */
  examMeasure: TExamMeasure;
  /** Valor máximo permitido */
  maximumAllowed: Scalars['Float']['input'];
  /** Valor de referência */
  reference: Scalars['Float']['input'];
  /** Identificador do agente de risco */
  riskAgentId: Scalars['String']['input'];
};

export type TExamIbmpUpdate = {
  /** Material biológico */
  biologicalMaterial?: InputMaybe<TBiologicalMaterial>;
  /** Unidade de medida */
  examMeasure?: InputMaybe<TExamMeasure>;
  /** Identificador único */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Valor máximo permitido */
  maximumAllowed?: InputMaybe<Scalars['Float']['input']>;
  /** Valor de referência */
  reference?: InputMaybe<Scalars['Float']['input']>;
  /** Identificador do agente de risco */
  riskAgentId?: InputMaybe<Scalars['String']['input']>;
};

export type TExamInput = {
  /** Indica se é de admissão */
  admission: Scalars['Boolean']['input'];
  /** Indica se é retorno ao trabalho */
  backToWork: Scalars['Boolean']['input'];
  /** Indica se é mudança de função */
  changeOfFunction: Scalars['Boolean']['input'];
  /** Descrição */
  description: Scalars['String']['input'];
  /** Indica se é demissional */
  dismissal: Scalars['Boolean']['input'];
  /** Procedimento de exame */
  examinationProcedureId?: InputMaybe<Scalars['String']['input']>;
  /** Análises do grupo */
  groupAnalysis?: InputMaybe<Array<TGroupAnalysisInput>>;
  ibmp?: InputMaybe<TExamIbmpInput>;
  /** Indica se é periódico */
  periodic: Scalars['Boolean']['input'];
  /** Faixa periódica */
  periodicRangeId?: InputMaybe<Scalars['String']['input']>;
  /** Preparação */
  preparation?: InputMaybe<Scalars['String']['input']>;
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de resultado */
  resultType: TResultTypeEnum;
};

export type TExamItem = {
  __typename?: 'ExamItem';
  /** Exame complementar */
  complementaryExam?: Maybe<TComplementaryExam>;
  /** Consulta */
  consultation?: Maybe<TConsultation>;
  /** CRM do médico */
  crm?: Maybe<Scalars['String']['output']>;
  /** Data do exame */
  date: Scalars['DateTime']['output'];
  /** Detalhes do exame */
  details?: Maybe<Scalars['String']['output']>;
  /** Indicador diagnóstico */
  diagnosticIndicator: TExamDiagnosticIndicatorEnum;
  /** Nome do médico */
  doctor?: Maybe<Scalars['String']['output']>;
  /** Autorização do exame */
  examAuthorization: Scalars['Boolean']['output'];
  /** Valores dos itens */
  examItemValues: Array<TExamItemValue>;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Indicador do resultado */
  indicator: TExamResultIndicatorEnum;
  /** Observações */
  observations?: Maybe<Scalars['String']['output']>;
  /** Tempo de repouso */
  restTime?: Maybe<Scalars['String']['output']>;
  /** Resultado do exame */
  result: Scalars['String']['output'];
  /** Agravamento do resultado */
  resultAggravation?: Maybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: Maybe<TExamResultAlterationEnum>;
  /** Estado do CRM */
  state?: Maybe<TState>;
};

export type TExamItemInput = {
  /** Identificador do exame complementar */
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da consulta */
  consultationId?: InputMaybe<Scalars['String']['input']>;
  /** CRM do médico */
  crm?: InputMaybe<Scalars['String']['input']>;
  /** Data do exame */
  date: Scalars['DateTime']['input'];
  /** Detalhes do exame */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Indicador diagnóstico */
  diagnosticIndicator: TExamDiagnosticIndicatorEnum;
  /** Nome do médico */
  doctor?: InputMaybe<Scalars['String']['input']>;
  /** Autorização do exame */
  examAuthorization: Scalars['Boolean']['input'];
  /** Valores dos itens */
  examItemValues: Array<TExamItemValueInput>;
  /** Indicador do resultado */
  indicator: TExamResultIndicatorEnum;
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** Tempo de repouso */
  restTime?: InputMaybe<Scalars['String']['input']>;
  /** Resultado do exame */
  result: Scalars['String']['input'];
  /** Agravamento do resultado */
  resultAggravation?: InputMaybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: InputMaybe<TExamResultAlterationEnum>;
  /** Estado do CRM */
  state?: InputMaybe<TState>;
};

export type TExamItemUpdate = {
  /** CRM do médico */
  crm?: InputMaybe<Scalars['String']['input']>;
  /** Data do exame */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Detalhes do exame */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Indicador diagnóstico */
  diagnosticIndicator?: InputMaybe<TExamDiagnosticIndicatorEnum>;
  /** Nome do médico */
  doctor?: InputMaybe<Scalars['String']['input']>;
  /** Autorização do exame */
  examAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Valores dos itens */
  examItemValues?: InputMaybe<Array<TExamItemValueUpdate>>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Indicador do resultado */
  indicator?: InputMaybe<TExamResultIndicatorEnum>;
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** Tempo de repouso */
  restTime?: InputMaybe<Scalars['String']['input']>;
  /** Resultado do exame */
  result?: InputMaybe<Scalars['String']['input']>;
  /** Agravamento do resultado */
  resultAggravation?: InputMaybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: InputMaybe<TExamResultAlterationEnum>;
  /** Estado do CRM */
  state?: InputMaybe<TState>;
};

export type TExamItemValue = {
  __typename?: 'ExamItemValue';
  /** Análise do exame */
  analysis: TAnalysis;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Valor percentual */
  percentageValue?: Maybe<Scalars['Float']['output']>;
  /** Valor do resultado */
  value: Scalars['Float']['output'];
};

export type TExamItemValueInput = {
  /** Identificador da análise */
  analysisId: Scalars['String']['input'];
  /** Valor percentual */
  percentageValue?: InputMaybe<Scalars['Float']['input']>;
  /** Valor do resultado */
  value: Scalars['Float']['input'];
};

export type TExamItemValueUpdate = {
  /** Identificador da análise */
  analysisId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Valor percentual */
  percentageValue?: InputMaybe<Scalars['Float']['input']>;
  /** Valor do resultado */
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type TExamItemsCount = {
  __typename?: 'ExamItemsCount';
  count: Scalars['Float']['output'];
  exam: Scalars['String']['output'];
  examId: Scalars['String']['output'];
};

/** Unidade de medida do exame */
export enum TExamMeasure {
  /** Número adimensional */
  NumeroAdimensional = 'NumeroAdimensional',
  /** A/m */
  AM = 'aM',
  /** x 10³/mm³ */
  DezPorMm = 'dezPorMM',
  /** x 10^6/mm³ */
  DezSeisMm = 'dezSeisMM',
  /** μT */
  EmiT = 'emiT',
  /** fl */
  Fl = 'fl',
  /** g/dl */
  GdL = 'gdL',
  /** g/g */
  Gg = 'gg',
  /** kcal/h */
  KCalH = 'kCalH',
  /** kg */
  Kg = 'kg',
  /** kgf/cm2 */
  KgfCm2 = 'kgfCm2',
  /** l */
  L = 'l',
  /** mA */
  MA = 'mA',
  /** mT */
  MT = 'mT',
  /** mg */
  Mg = 'mg',
  /** mg/dl */
  MgDl = 'mgDl',
  /** mg/g */
  MgG = 'mgG',
  /** mg/l */
  MgL = 'mgL',
  /** milhões/mm³ */
  MilhoesMm = 'milhoesMM',
  /** milhões/μL */
  MilhoesPiL = 'milhoesPiL',
  /** ml */
  Ml = 'ml',
  /** mm³ */
  MmCubico = 'mmCubico',
  /** mm² */
  MmQuadrado = 'mmQuadrado',
  /** mppdc */
  Mppdc = 'mppdc',
  /** N/A */
  NA = 'nA',
  /** nm */
  Nm = 'nm',
  /** oC */
  OC = 'oC',
  /** % */
  Percentual = 'percentual',
  /** pg */
  Pg = 'pg',
  /** μ³ */
  PiCubico = 'piCubico',
  /** μL */
  PiL = 'piL',
  /** ppm */
  Ppm = 'ppm',
  /** ug/100ml */
  UgCemMl = 'ugCemMl',
  /** ug/g */
  UgG = 'ugG',
  /** un */
  Un = 'un'
}

export type TExamNormal = {
  __typename?: 'ExamNormal';
  /** Exame complementar */
  complementaryExam?: Maybe<TComplementaryExam>;
  /** Consulta */
  consultation: TConsultation;
  /** CRM do médico */
  crm?: Maybe<Scalars['String']['output']>;
  /** Data do exame */
  date: Scalars['DateTime']['output'];
  /** Detalhes do exame */
  details?: Maybe<Scalars['String']['output']>;
  /** Indicador diagnóstico */
  diagnosticIndicator: TExamDiagnosticIndicatorEnum;
  /** Nome do médico */
  doctor?: Maybe<Scalars['String']['output']>;
  /** Autorização do exame */
  examAuthorization: Scalars['Boolean']['output'];
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Indicador do resultado */
  indicator: TExamResultIndicatorEnum;
  /** Observações */
  observations?: Maybe<Scalars['String']['output']>;
  /** Tempo de repouso */
  restTime?: Maybe<Scalars['String']['output']>;
  /** Resultado do exame */
  result: Scalars['String']['output'];
  /** Agravamento do resultado */
  resultAggravation?: Maybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: Maybe<TExamResultAlterationEnum>;
  /** Estado do CRM */
  state?: Maybe<TState>;
};

export type TExamNormalInput = {
  /** Identificador do exame complementar */
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da consulta */
  consultationId: Scalars['String']['input'];
  /** CRM do médico */
  crm?: InputMaybe<Scalars['String']['input']>;
  /** Data do exame */
  date: Scalars['DateTime']['input'];
  /** Detalhes do exame */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Diagnóstico */
  diagnostic?: InputMaybe<TDiagnosticOptional>;
  /** Indicador diagnóstico */
  diagnosticIndicator: TExamDiagnosticIndicatorEnum;
  /** Nome do médico */
  doctor?: InputMaybe<Scalars['String']['input']>;
  /** Data de término */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Autorização do exame */
  examAuthorization: Scalars['Boolean']['input'];
  /** Indicador do resultado */
  indicator: TExamResultIndicatorEnum;
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** Tempo de repouso */
  restTime?: InputMaybe<Scalars['String']['input']>;
  /** Resultado do exame */
  result: Scalars['String']['input'];
  /** Agravamento do resultado */
  resultAggravation?: InputMaybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: InputMaybe<TExamResultAlterationEnum>;
  /** Data de início */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Estado do CRM */
  state?: InputMaybe<TState>;
};

export type TExamNormalResult = {
  __typename?: 'ExamNormalResult';
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Resultado do exame */
  result: Scalars['String']['output'];
};

export type TExamNormalUpdate = {
  /** Identificador do exame complementar */
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da consulta */
  consultationId?: InputMaybe<Scalars['String']['input']>;
  /** CRM do médico */
  crm?: InputMaybe<Scalars['String']['input']>;
  /** Data do exame */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Detalhes do exame */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Diagnóstico */
  diagnostic?: InputMaybe<TDiagnosticOptional>;
  /** Indicador diagnóstico */
  diagnosticIndicator?: InputMaybe<TExamDiagnosticIndicatorEnum>;
  /** Nome do médico */
  doctor?: InputMaybe<Scalars['String']['input']>;
  /** Data de término */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Autorização do exame */
  examAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Indicador do resultado */
  indicator?: InputMaybe<TExamResultIndicatorEnum>;
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** Tempo de repouso */
  restTime?: InputMaybe<Scalars['String']['input']>;
  /** Resultado do exame */
  result?: InputMaybe<Scalars['String']['input']>;
  /** Agravamento do resultado */
  resultAggravation?: InputMaybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: InputMaybe<TExamResultAlterationEnum>;
  /** Data de início */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Estado do CRM */
  state?: InputMaybe<TState>;
};

export type TExamOnConsultation = {
  __typename?: 'ExamOnConsultation';
  /** Credenciado */
  accredited?: Maybe<TAccredited>;
  /** Consulta de referência */
  consultationReference?: Maybe<TConsultation>;
  /** Indica se foi realizado */
  done?: Maybe<Scalars['Boolean']['output']>;
  /** Exame */
  exam: TExam;
  /** Identificador do exame */
  examId?: Maybe<Scalars['String']['output']>;
  /** Identificador único */
  id: Scalars['String']['output'];
};

export type TExamOnConsultationInput = {
  /** ID do credenciado que realiza o exame */
  accreditedId?: InputMaybe<Scalars['String']['input']>;
  /** ID do exame complementar */
  examId: Scalars['String']['input'];
  /** Identificação da repetição */
  monitoringRepetition?: InputMaybe<Scalars['Float']['input']>;
};

export type TExamOnConsultationUpdate = {
  /** Exames a criar */
  toCreate: Array<TExamOnConsultationInput>;
  /** IDs dos exames a remover */
  toRemove: Array<Scalars['String']['input']>;
};

export type TExamOtological = {
  __typename?: 'ExamOtological';
  /** Exame complementar */
  complementaryExam?: Maybe<TComplementaryExam>;
  /** Consulta */
  consultation?: Maybe<TConsultation>;
  /** CRM do médico */
  crm?: Maybe<Scalars['String']['output']>;
  /** Data do exame */
  date: Scalars['DateTime']['output'];
  /** Descrição */
  description?: Maybe<Scalars['String']['output']>;
  /** Detalhes do exame */
  details?: Maybe<Scalars['String']['output']>;
  /** Indicador diagnóstico */
  diagnosticIndicator: TExamDiagnosticIndicatorEnum;
  /** Nome do médico */
  doctor?: Maybe<Scalars['String']['output']>;
  /** Partes do ouvido examinadas */
  earParts: Array<TEarPart>;
  /** Caráter evolutivo */
  evolutionaryCharacter: TEvolutionaryCharacterEnum;
  /** Autorização do exame */
  examAuthorization: Scalars['Boolean']['output'];
  /** Local do exame */
  examLocation: Scalars['String']['output'];
  /** Tempo de exposição */
  exposureTime: Scalars['String']['output'];
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Indicador do resultado */
  indicator: TExamResultIndicatorEnum;
  /** Nexo com ruído */
  nexusNoise: Scalars['Boolean']['output'];
  /** Exposição a ruído */
  noiseExposure: TNoiseExposureEnum;
  /** Observações */
  observations?: Maybe<Scalars['String']['output']>;
  /** É ocupacional */
  occupational: Scalars['Boolean']['output'];
  /** Diagnóstico otológico */
  otologicalDiagnosis: TOtologicalDiagnosisEnum;
  /** Tempo de repouso */
  restTime?: Maybe<Scalars['String']['output']>;
  /** Resultado do exame */
  result: Scalars['String']['output'];
  /** Agravamento do resultado */
  resultAggravation?: Maybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: Maybe<TExamResultAlterationEnum>;
  /** Estado do CRM */
  state?: Maybe<TState>;
  /** Unidade de tempo */
  timeUnit: TTimeUnitEnum;
  /** Uso de protetor auricular */
  useOfIpe: TUseOfAuricularIpeEnum;
};

export type TExamOtologicalInput = {
  /** Identificador do exame complementar */
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da consulta */
  consultationId?: InputMaybe<Scalars['String']['input']>;
  /** CRM do médico */
  crm?: InputMaybe<Scalars['String']['input']>;
  /** Data do exame */
  date: Scalars['DateTime']['input'];
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Detalhes do exame */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Indicador diagnóstico */
  diagnosticIndicator: TExamDiagnosticIndicatorEnum;
  /** Nome do médico */
  doctor?: InputMaybe<Scalars['String']['input']>;
  /** Partes do ouvido examinadas */
  earParts: Array<TEarPartInput>;
  /** Caráter evolutivo */
  evolutionaryCharacter: TEvolutionaryCharacterEnum;
  /** Autorização do exame */
  examAuthorization: Scalars['Boolean']['input'];
  /** Local do exame */
  examLocation: Scalars['String']['input'];
  /** Tempo de exposição */
  exposureTime: Scalars['String']['input'];
  /** Indicador do resultado */
  indicator: TExamResultIndicatorEnum;
  /** Nexo com ruído */
  nexusNoise: Scalars['Boolean']['input'];
  /** Exposição a ruído */
  noiseExposure: TNoiseExposureEnum;
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** É ocupacional */
  occupational: Scalars['Boolean']['input'];
  /** Diagnóstico otológico */
  otologicalDiagnosis: TOtologicalDiagnosisEnum;
  /** Tempo de repouso */
  restTime?: InputMaybe<Scalars['String']['input']>;
  /** Resultado do exame */
  result: Scalars['String']['input'];
  /** Agravamento do resultado */
  resultAggravation?: InputMaybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: InputMaybe<TExamResultAlterationEnum>;
  /** Estado do CRM */
  state?: InputMaybe<TState>;
  /** Unidade de tempo */
  timeUnit: TTimeUnitEnum;
  /** Uso de protetor auricular */
  useOfIpe: TUseOfAuricularIpeEnum;
};

export type TExamOtologicalUpdate = {
  /** CRM do médico */
  crm?: InputMaybe<Scalars['String']['input']>;
  /** Data do exame */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Detalhes do exame */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Indicador diagnóstico */
  diagnosticIndicator?: InputMaybe<TExamDiagnosticIndicatorEnum>;
  /** Nome do médico */
  doctor?: InputMaybe<Scalars['String']['input']>;
  /** Partes do ouvido examinadas */
  earParts?: InputMaybe<Array<TEarPartUpdate>>;
  /** Caráter evolutivo */
  evolutionaryCharacter?: InputMaybe<TEvolutionaryCharacterEnum>;
  /** Autorização do exame */
  examAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Local do exame */
  examLocation?: InputMaybe<Scalars['String']['input']>;
  /** Tempo de exposição */
  exposureTime?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Indicador do resultado */
  indicator?: InputMaybe<TExamResultIndicatorEnum>;
  /** Nexo com ruído */
  nexusNoise?: InputMaybe<Scalars['Boolean']['input']>;
  /** Exposição a ruído */
  noiseExposure?: InputMaybe<TNoiseExposureEnum>;
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** É ocupacional */
  occupational?: InputMaybe<Scalars['Boolean']['input']>;
  /** Diagnóstico otológico */
  otologicalDiagnosis?: InputMaybe<TOtologicalDiagnosisEnum>;
  /** Tempo de repouso */
  restTime?: InputMaybe<Scalars['String']['input']>;
  /** Resultado do exame */
  result?: InputMaybe<Scalars['String']['input']>;
  /** Agravamento do resultado */
  resultAggravation?: InputMaybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: InputMaybe<TExamResultAlterationEnum>;
  /** Estado do CRM */
  state?: InputMaybe<TState>;
  /** Unidade de tempo */
  timeUnit?: InputMaybe<TTimeUnitEnum>;
  /** Uso de protetor auricular */
  useOfIpe?: InputMaybe<TUseOfAuricularIpeEnum>;
};

export type TExamPerson = {
  __typename?: 'ExamPerson';
  dayOne: Scalars['String']['output'];
  dayTwo: Scalars['String']['output'];
  description: Scalars['String']['output'];
  exams: TBiologicalExams;
  id: Scalars['String']['output'];
};

export type TExamProvider = {
  __typename?: 'ExamProvider';
  complementaryExams: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isAccredited: Scalars['Boolean']['output'];
};

export type TExamReferralReport = {
  __typename?: 'ExamReferralReport';
  admission?: Maybe<Scalars['String']['output']>;
  age: Scalars['Float']['output'];
  birthDate: Scalars['String']['output'];
  branch: Scalars['String']['output'];
  costCenter: Scalars['String']['output'];
  crm?: Maybe<Scalars['String']['output']>;
  doctorName?: Maybe<Scalars['String']['output']>;
  /** Snapshot formatado dos RQEs do médico para impressão */
  doctorRqeDisplay?: Maybe<Scalars['String']['output']>;
  employee: Scalars['String']['output'];
  examDate?: Maybe<Scalars['String']['output']>;
  examTime?: Maybe<Scalars['String']['output']>;
  footer: Scalars['String']['output'];
  header?: Maybe<Scalars['String']['output']>;
  individualRegistration: Scalars['String']['output'];
  isAdmissional: Scalars['Boolean']['output'];
  isBackToWork: Scalars['Boolean']['output'];
  isChangeOfFunction: Scalars['Boolean']['output'];
  isDismissal: Scalars['Boolean']['output'];
  isPeriodic: Scalars['Boolean']['output'];
  isSpotMonitoring: Scalars['Boolean']['output'];
  occupation: Scalars['String']['output'];
  pisCode?: Maybe<Scalars['String']['output']>;
  plannedExamsList: Array<TPlanedExam>;
  registration?: Maybe<Scalars['String']['output']>;
  supplier: Scalars['String']['output'];
  supplierAddress?: Maybe<Scalars['String']['output']>;
  supplierCity?: Maybe<Scalars['String']['output']>;
  supplierNeighborhood?: Maybe<Scalars['String']['output']>;
  supplierPhone?: Maybe<Scalars['String']['output']>;
};

export type TExamReport = {
  __typename?: 'ExamReport';
  /** Atendimento */
  attendance?: Maybe<Scalars['String']['output']>;
  /** Data do exame */
  date: Scalars['String']['output'];
  /** Descrição do exame */
  description: Scalars['String']['output'];
  /** Detalhes do resultado */
  details?: Maybe<Scalars['String']['output']>;
  /** Documento do médico responsável */
  examResponsibleDocument?: Maybe<Scalars['String']['output']>;
  /** Nome do médico responsável */
  examResponsibleName?: Maybe<Scalars['String']['output']>;
  /** Natureza */
  nature: Scalars['String']['output'];
  /** Observação */
  observation: Scalars['String']['output'];
  /** Resultado */
  result: Scalars['String']['output'];
  /** Indicação do resultado */
  resultIndication: Scalars['String']['output'];
};

/** Alteração do resultado do exame */
export enum TExamResultAlterationEnum {
  /** Agravamento */
  Aggravation = 'Aggravation',
  /** Estável */
  Stable = 'Stable'
}

/** Indicador do resultado do exame */
export enum TExamResultIndicatorEnum {
  /** Referencial */
  Referential = 'Referential',
  /** Sequencial */
  Sequential = 'Sequential'
}

export type TExamResultsByMedicalRecord = {
  __typename?: 'ExamResultsByMedicalRecord';
  examAudiometries: Scalars['Float']['output'];
  examDiagnosticImage: Scalars['Float']['output'];
  examIbmps: Scalars['Float']['output'];
  examItems: Array<TExamItemsCount>;
  examNormals: Scalars['Float']['output'];
  examOtological: Scalars['Float']['output'];
  examSpirometries: Scalars['Float']['output'];
  examToxicological: Scalars['Float']['output'];
  orthoRater: Scalars['Float']['output'];
  snellen: Scalars['Float']['output'];
  urinalysis: Scalars['Float']['output'];
};

export type TExamScheduling = {
  __typename?: 'ExamScheduling';
  exam: Scalars['String']['output'];
  examCost?: Maybe<Scalars['Float']['output']>;
  realized: Scalars['Float']['output'];
  realizedBillings?: Maybe<Scalars['Float']['output']>;
  scheduled: Scalars['Float']['output'];
  scheduledBillings?: Maybe<Scalars['Float']['output']>;
  subject: Scalars['String']['output'];
};

export type TExamSpirometry = {
  __typename?: 'ExamSpirometry';
  bronchodilator: Scalars['Boolean']['output'];
  calibrationDate: Scalars['DateTime']['output'];
  complementaryExam?: Maybe<TComplementaryExam>;
  consultation?: Maybe<TConsultation>;
  /** CRM do médico */
  crm?: Maybe<Scalars['String']['output']>;
  date: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** Detalhes do exame */
  details?: Maybe<Scalars['String']['output']>;
  diagnosticIndicator: TExamDiagnosticIndicatorEnum;
  /** Nome do médico */
  doctor?: Maybe<Scalars['String']['output']>;
  equipment: TMeasuringInstrument;
  examAuthorization: Scalars['Boolean']['output'];
  examLocation?: Maybe<Scalars['String']['output']>;
  gaugingDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  inconclusiveData: Scalars['Boolean']['output'];
  indicator: TExamResultIndicatorEnum;
  /** Observações */
  observations?: Maybe<Scalars['String']['output']>;
  posFet?: Maybe<Scalars['Float']['output']>;
  posFetPercent?: Maybe<Scalars['Float']['output']>;
  posFevFifty?: Maybe<Scalars['Float']['output']>;
  posFevFiftyPercent?: Maybe<Scalars['Float']['output']>;
  posFevSeventyFive?: Maybe<Scalars['Float']['output']>;
  posFevSeventyFivePercent?: Maybe<Scalars['Float']['output']>;
  posFevTwentyFive?: Maybe<Scalars['Float']['output']>;
  posFevTwentyFivePercent?: Maybe<Scalars['Float']['output']>;
  posFevTwentyFiveSeventyFive?: Maybe<Scalars['Float']['output']>;
  posFevTwentyFiveSeventyFivePercent?: Maybe<Scalars['Float']['output']>;
  posFifFifty?: Maybe<Scalars['Float']['output']>;
  posFifFiftyPercent?: Maybe<Scalars['Float']['output']>;
  posFifSeventyFive?: Maybe<Scalars['Float']['output']>;
  posFifSeventyFivePercent?: Maybe<Scalars['Float']['output']>;
  posFifTwentyFive?: Maybe<Scalars['Float']['output']>;
  posFifTwentyFivePercent?: Maybe<Scalars['Float']['output']>;
  posFvc?: Maybe<Scalars['Float']['output']>;
  posFvcPercent?: Maybe<Scalars['Float']['output']>;
  posPef?: Maybe<Scalars['Float']['output']>;
  posPefPercent?: Maybe<Scalars['Float']['output']>;
  posPif?: Maybe<Scalars['Float']['output']>;
  posPifPercent?: Maybe<Scalars['Float']['output']>;
  preFet?: Maybe<Scalars['Float']['output']>;
  preFetPercent?: Maybe<Scalars['Float']['output']>;
  preFevFifty?: Maybe<Scalars['Float']['output']>;
  preFevFiftyPercent?: Maybe<Scalars['Float']['output']>;
  preFevSeventyFive?: Maybe<Scalars['Float']['output']>;
  preFevSeventyFivePercent?: Maybe<Scalars['Float']['output']>;
  preFevTwentyFive?: Maybe<Scalars['Float']['output']>;
  preFevTwentyFivePercent?: Maybe<Scalars['Float']['output']>;
  preFevTwentyFiveSeventyFive?: Maybe<Scalars['Float']['output']>;
  preFevTwentyFiveSeventyFivePercent?: Maybe<Scalars['Float']['output']>;
  preFifFifty?: Maybe<Scalars['Float']['output']>;
  preFifFiftyPercent?: Maybe<Scalars['Float']['output']>;
  preFifSeventyFive?: Maybe<Scalars['Float']['output']>;
  preFifSeventyFivePercent?: Maybe<Scalars['Float']['output']>;
  preFifTwentyFive?: Maybe<Scalars['Float']['output']>;
  preFifTwentyFivePercent?: Maybe<Scalars['Float']['output']>;
  preFvc?: Maybe<Scalars['Float']['output']>;
  preFvcPercent?: Maybe<Scalars['Float']['output']>;
  prePef?: Maybe<Scalars['Float']['output']>;
  prePefPercent?: Maybe<Scalars['Float']['output']>;
  prePif?: Maybe<Scalars['Float']['output']>;
  prePifPercent?: Maybe<Scalars['Float']['output']>;
  responsibleForMeasuring: TPerson;
  /** Tempo de repouso */
  restTime?: Maybe<Scalars['String']['output']>;
  result: Scalars['String']['output'];
  /** Agravamento do resultado */
  resultAggravation?: Maybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: Maybe<TExamResultAlterationEnum>;
  smoker: Scalars['Boolean']['output'];
  /** Estado do CRM */
  state?: Maybe<TState>;
  timeBeingSmoker?: Maybe<Scalars['Float']['output']>;
};

export type TExamSpirometryInput = {
  bronchodilator: Scalars['Boolean']['input'];
  calibrationDate: Scalars['DateTime']['input'];
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  consultationId?: InputMaybe<Scalars['String']['input']>;
  /** CRM do médico */
  crm?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  /** Detalhes do exame */
  details?: InputMaybe<Scalars['String']['input']>;
  diagnosticIndicator: TExamDiagnosticIndicatorEnum;
  /** Nome do médico */
  doctor?: InputMaybe<Scalars['String']['input']>;
  equipmentId: Scalars['String']['input'];
  examAuthorization: Scalars['Boolean']['input'];
  examLocation?: InputMaybe<Scalars['String']['input']>;
  gaugingDate: Scalars['DateTime']['input'];
  inconclusiveData: Scalars['Boolean']['input'];
  indicator: TExamResultIndicatorEnum;
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  posFet?: InputMaybe<Scalars['Float']['input']>;
  posFetPercent?: InputMaybe<Scalars['Float']['input']>;
  posFevFifty?: InputMaybe<Scalars['Float']['input']>;
  posFevFiftyPercent?: InputMaybe<Scalars['Float']['input']>;
  posFevSeventyFive?: InputMaybe<Scalars['Float']['input']>;
  posFevSeventyFivePercent?: InputMaybe<Scalars['Float']['input']>;
  posFevTwentyFive?: InputMaybe<Scalars['Float']['input']>;
  posFevTwentyFivePercent?: InputMaybe<Scalars['Float']['input']>;
  posFevTwentyFiveSeventyFive?: InputMaybe<Scalars['Float']['input']>;
  posFevTwentyFiveSeventyFivePercent?: InputMaybe<Scalars['Float']['input']>;
  posFifFifty?: InputMaybe<Scalars['Float']['input']>;
  posFifFiftyPercent?: InputMaybe<Scalars['Float']['input']>;
  posFifSeventyFive?: InputMaybe<Scalars['Float']['input']>;
  posFifSeventyFivePercent?: InputMaybe<Scalars['Float']['input']>;
  posFifTwentyFive?: InputMaybe<Scalars['Float']['input']>;
  posFifTwentyFivePercent?: InputMaybe<Scalars['Float']['input']>;
  posFvc?: InputMaybe<Scalars['Float']['input']>;
  posFvcPercent?: InputMaybe<Scalars['Float']['input']>;
  posPef?: InputMaybe<Scalars['Float']['input']>;
  posPefPercent?: InputMaybe<Scalars['Float']['input']>;
  posPif?: InputMaybe<Scalars['Float']['input']>;
  posPifPercent?: InputMaybe<Scalars['Float']['input']>;
  preFet?: InputMaybe<Scalars['Float']['input']>;
  preFetPercent?: InputMaybe<Scalars['Float']['input']>;
  preFevFifty?: InputMaybe<Scalars['Float']['input']>;
  preFevFiftyPercent?: InputMaybe<Scalars['Float']['input']>;
  preFevSeventyFive?: InputMaybe<Scalars['Float']['input']>;
  preFevSeventyFivePercent?: InputMaybe<Scalars['Float']['input']>;
  preFevTwentyFive?: InputMaybe<Scalars['Float']['input']>;
  preFevTwentyFivePercent?: InputMaybe<Scalars['Float']['input']>;
  preFevTwentyFiveSeventyFive?: InputMaybe<Scalars['Float']['input']>;
  preFevTwentyFiveSeventyFivePercent?: InputMaybe<Scalars['Float']['input']>;
  preFifFifty?: InputMaybe<Scalars['Float']['input']>;
  preFifFiftyPercent?: InputMaybe<Scalars['Float']['input']>;
  preFifSeventyFive?: InputMaybe<Scalars['Float']['input']>;
  preFifSeventyFivePercent?: InputMaybe<Scalars['Float']['input']>;
  preFifTwentyFive?: InputMaybe<Scalars['Float']['input']>;
  preFifTwentyFivePercent?: InputMaybe<Scalars['Float']['input']>;
  preFvc?: InputMaybe<Scalars['Float']['input']>;
  preFvcPercent?: InputMaybe<Scalars['Float']['input']>;
  prePef?: InputMaybe<Scalars['Float']['input']>;
  prePefPercent?: InputMaybe<Scalars['Float']['input']>;
  prePif?: InputMaybe<Scalars['Float']['input']>;
  prePifPercent?: InputMaybe<Scalars['Float']['input']>;
  responsibleForMeasuringId: Scalars['String']['input'];
  /** Tempo de repouso */
  restTime?: InputMaybe<Scalars['String']['input']>;
  result: Scalars['String']['input'];
  /** Agravamento do resultado */
  resultAggravation?: InputMaybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: InputMaybe<TExamResultAlterationEnum>;
  smoker: Scalars['Boolean']['input'];
  /** Estado do CRM */
  state?: InputMaybe<TState>;
  timeBeingSmoker?: InputMaybe<Scalars['Float']['input']>;
};

export type TExamSpirometryUpdate = {
  bronchodilator?: InputMaybe<Scalars['Boolean']['input']>;
  calibrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** CRM do médico */
  crm?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Detalhes do exame */
  details?: InputMaybe<Scalars['String']['input']>;
  diagnosticIndicator?: InputMaybe<TExamDiagnosticIndicatorEnum>;
  /** Nome do médico */
  doctor?: InputMaybe<Scalars['String']['input']>;
  equipmentId?: InputMaybe<Scalars['String']['input']>;
  examAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
  examLocation?: InputMaybe<Scalars['String']['input']>;
  gaugingDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  inconclusiveData?: InputMaybe<Scalars['Boolean']['input']>;
  indicator?: InputMaybe<TExamResultIndicatorEnum>;
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  posFet?: InputMaybe<Scalars['Float']['input']>;
  posFetPercent?: InputMaybe<Scalars['Float']['input']>;
  posFevFifty?: InputMaybe<Scalars['Float']['input']>;
  posFevFiftyPercent?: InputMaybe<Scalars['Float']['input']>;
  posFevSeventyFive?: InputMaybe<Scalars['Float']['input']>;
  posFevSeventyFivePercent?: InputMaybe<Scalars['Float']['input']>;
  posFevTwentyFive?: InputMaybe<Scalars['Float']['input']>;
  posFevTwentyFivePercent?: InputMaybe<Scalars['Float']['input']>;
  posFevTwentyFiveSeventyFive?: InputMaybe<Scalars['Float']['input']>;
  posFevTwentyFiveSeventyFivePercent?: InputMaybe<Scalars['Float']['input']>;
  posFifFifty?: InputMaybe<Scalars['Float']['input']>;
  posFifFiftyPercent?: InputMaybe<Scalars['Float']['input']>;
  posFifSeventyFive?: InputMaybe<Scalars['Float']['input']>;
  posFifSeventyFivePercent?: InputMaybe<Scalars['Float']['input']>;
  posFifTwentyFive?: InputMaybe<Scalars['Float']['input']>;
  posFifTwentyFivePercent?: InputMaybe<Scalars['Float']['input']>;
  posFvc?: InputMaybe<Scalars['Float']['input']>;
  posFvcPercent?: InputMaybe<Scalars['Float']['input']>;
  posPef?: InputMaybe<Scalars['Float']['input']>;
  posPefPercent?: InputMaybe<Scalars['Float']['input']>;
  posPif?: InputMaybe<Scalars['Float']['input']>;
  posPifPercent?: InputMaybe<Scalars['Float']['input']>;
  preFet?: InputMaybe<Scalars['Float']['input']>;
  preFetPercent?: InputMaybe<Scalars['Float']['input']>;
  preFevFifty?: InputMaybe<Scalars['Float']['input']>;
  preFevFiftyPercent?: InputMaybe<Scalars['Float']['input']>;
  preFevSeventyFive?: InputMaybe<Scalars['Float']['input']>;
  preFevSeventyFivePercent?: InputMaybe<Scalars['Float']['input']>;
  preFevTwentyFive?: InputMaybe<Scalars['Float']['input']>;
  preFevTwentyFivePercent?: InputMaybe<Scalars['Float']['input']>;
  preFevTwentyFiveSeventyFive?: InputMaybe<Scalars['Float']['input']>;
  preFevTwentyFiveSeventyFivePercent?: InputMaybe<Scalars['Float']['input']>;
  preFifFifty?: InputMaybe<Scalars['Float']['input']>;
  preFifFiftyPercent?: InputMaybe<Scalars['Float']['input']>;
  preFifSeventyFive?: InputMaybe<Scalars['Float']['input']>;
  preFifSeventyFivePercent?: InputMaybe<Scalars['Float']['input']>;
  preFifTwentyFive?: InputMaybe<Scalars['Float']['input']>;
  preFifTwentyFivePercent?: InputMaybe<Scalars['Float']['input']>;
  preFvc?: InputMaybe<Scalars['Float']['input']>;
  preFvcPercent?: InputMaybe<Scalars['Float']['input']>;
  prePef?: InputMaybe<Scalars['Float']['input']>;
  prePefPercent?: InputMaybe<Scalars['Float']['input']>;
  prePif?: InputMaybe<Scalars['Float']['input']>;
  prePifPercent?: InputMaybe<Scalars['Float']['input']>;
  responsibleForMeasuringId?: InputMaybe<Scalars['String']['input']>;
  /** Tempo de repouso */
  restTime?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Scalars['String']['input']>;
  /** Agravamento do resultado */
  resultAggravation?: InputMaybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: InputMaybe<TExamResultAlterationEnum>;
  smoker?: InputMaybe<Scalars['Boolean']['input']>;
  /** Estado do CRM */
  state?: InputMaybe<TState>;
  timeBeingSmoker?: InputMaybe<Scalars['Float']['input']>;
};

/** Tipo de exame ocupacional */
export enum TExamTag {
  /** Admissional */
  Admission = 'Admission',
  /** Retorno ao trabalho */
  BackToWork = 'BackToWork',
  /** Mudança de função */
  ChangeOfFunction = 'ChangeOfFunction',
  /** Demissional */
  Dismissal = 'Dismissal',
  /** Periódico */
  Periodic = 'Periodic'
}

export type TExamTimelineEntry = {
  __typename?: 'ExamTimelineEntry';
  /** Datas de realização */
  dates: Array<Scalars['DateTime']['output']>;
  /** Tipo de exame */
  examType: Scalars['String']['output'];
};

export type TExamToxicological = {
  __typename?: 'ExamToxicological';
  /** CNPJ do laboratório */
  cnpjLab: Scalars['String']['output'];
  /** Exame complementar */
  complementaryExam?: Maybe<TComplementaryExam>;
  /** Consulta */
  consultation: TConsultation;
  /** CRM do médico */
  crm: Scalars['String']['output'];
  /** Data do exame */
  date: Scalars['DateTime']['output'];
  /** Detalhes do exame */
  details?: Maybe<Scalars['String']['output']>;
  /** Indicador diagnóstico */
  diagnosticIndicator: TExamDiagnosticIndicatorEnum;
  /** Nome do médico */
  doctor: Scalars['String']['output'];
  /** Autorização do exame */
  examAuthorization: Scalars['Boolean']['output'];
  /** Código do exame */
  examCode: Scalars['String']['output'];
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Indicador do resultado */
  indicator: TExamResultIndicatorEnum;
  /** Nome do laboratório */
  nameLab?: Maybe<Scalars['String']['output']>;
  /** Observações */
  observations?: Maybe<Scalars['String']['output']>;
  /** Tempo de repouso */
  restTime?: Maybe<Scalars['String']['output']>;
  /** Resultado do exame */
  result: Scalars['String']['output'];
  /** Estado do CRM */
  state: TState;
};

export type TExamToxicologicalInput = {
  /** CNPJ do laboratório */
  cnpjLab: Scalars['String']['input'];
  /** Identificador do exame complementar */
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da consulta */
  consultationId: Scalars['String']['input'];
  /** CRM do médico */
  crm: Scalars['String']['input'];
  /** Data do exame */
  date: Scalars['DateTime']['input'];
  /** Detalhes do exame */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Indicador diagnóstico */
  diagnosticIndicator: TExamDiagnosticIndicatorEnum;
  /** Nome do médico */
  doctor: Scalars['String']['input'];
  /** Autorização do exame */
  examAuthorization: Scalars['Boolean']['input'];
  /** Código do exame */
  examCode: Scalars['String']['input'];
  /** Indicador do resultado */
  indicator: TExamResultIndicatorEnum;
  /** Nome do laboratório */
  nameLab?: InputMaybe<Scalars['String']['input']>;
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** Tempo de repouso */
  restTime?: InputMaybe<Scalars['String']['input']>;
  /** Resultado do exame */
  result: Scalars['String']['input'];
  /** Estado do CRM */
  state: TState;
};

export type TExamToxicologicalUpdate = {
  /** CNPJ do laboratório */
  cnpjLab?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do exame complementar */
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da consulta */
  consultationId?: InputMaybe<Scalars['String']['input']>;
  /** CRM do médico */
  crm?: InputMaybe<Scalars['String']['input']>;
  /** Data do exame */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Detalhes do exame */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Indicador diagnóstico */
  diagnosticIndicator?: InputMaybe<TExamDiagnosticIndicatorEnum>;
  /** Nome do médico */
  doctor?: InputMaybe<Scalars['String']['input']>;
  /** Autorização do exame */
  examAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Código do exame */
  examCode?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Indicador do resultado */
  indicator?: InputMaybe<TExamResultIndicatorEnum>;
  /** Nome do laboratório */
  nameLab?: InputMaybe<Scalars['String']['input']>;
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** Tempo de repouso */
  restTime?: InputMaybe<Scalars['String']['input']>;
  /** Resultado do exame */
  result?: InputMaybe<Scalars['String']['input']>;
  /** Estado do CRM */
  state?: InputMaybe<TState>;
};

export type TExamUpdate = {
  /** Indica se é de admissão */
  admission?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se é retorno ao trabalho */
  backToWork?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se é mudança de função */
  changeOfFunction?: InputMaybe<Scalars['Boolean']['input']>;
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Indica se é demissional */
  dismissal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Procedimento de exame */
  examinationProcedureId?: InputMaybe<Scalars['String']['input']>;
  /** Análises do grupo */
  groupAnalysis?: InputMaybe<Array<TGroupAnalysisUpdate>>;
  /** IBMP do exame */
  ibmp?: InputMaybe<TExamIbmpUpdate>;
  /** Identificador */
  id: Scalars['String']['input'];
  /** Indica se está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se é periódico */
  periodic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Faixa periódica */
  periodicRangeId?: InputMaybe<Scalars['String']['input']>;
  /** Preparação */
  preparation?: InputMaybe<Scalars['String']['input']>;
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de resultado */
  resultType?: InputMaybe<TResultTypeEnum>;
};

export type TExams = {
  __typename?: 'Exams';
  /** Anormalidade detectada */
  abnormality?: Maybe<Scalars['String']['output']>;
  /** Tipo de alteração */
  alterationType?: Maybe<Scalars['String']['output']>;
  /** Detalhes do exame */
  details?: Maybe<Scalars['String']['output']>;
  /** Data do exame */
  examDate: Scalars['DateTime']['output'];
  /** Descrição do exame */
  examDescription: Scalars['String']['output'];
  /** Observações sobre o exame */
  examObservation?: Maybe<Scalars['String']['output']>;
  /** Atividade ocupacional relacionada */
  occupationalActivity?: Maybe<Scalars['String']['output']>;
  /** Exame referencial */
  referentialExam: Scalars['String']['output'];
  /** Resultado do exame */
  result?: Maybe<Scalars['String']['output']>;
};

export type TExamsDoneChart = {
  __typename?: 'ExamsDoneChart';
  /** Dados */
  data: Array<TPieChart>;
  /** Possui consulta */
  hasConsultation: Scalars['Boolean']['output'];
};

export type TExamsResultQuery = {
  __typename?: 'ExamsResultQuery';
  /** Agravamento */
  aggravation: Scalars['String']['output'];
  /** Alteração */
  alteration: Scalars['String']['output'];
  /** Atendimento */
  attendance: Scalars['String']['output'];
  /** Identificador do exame complementar */
  complementaryExamId: Scalars['String']['output'];
  /** Data do resultado */
  date: Scalars['String']['output'];
  /** Nome do exame */
  exam: Scalars['String']['output'];
  /** Identificador do exame */
  examId: Scalars['String']['output'];
  /** Identificador */
  id: Scalars['String']['output'];
  /** Natureza do exame */
  nature: Scalars['String']['output'];
  /** Observação */
  observation: Scalars['String']['output'];
  /** Resultado */
  result: Scalars['String']['output'];
  /** Descrição do resultado */
  resultDescription: Scalars['String']['output'];
  /** Tipo de exame */
  type: Scalars['String']['output'];
};

export type TExamsToDelete = {
  __typename?: 'ExamsToDelete';
  complementaryExamId: Scalars['String']['output'];
  consultationId: Scalars['String']['output'];
  deleteConsultation: Scalars['Boolean']['output'];
};

/** Tipo de exposição ao risco */
export enum TExhibitionType {
  /** Eventual */
  Eventual = 'Eventual',
  /** Habitual/Eventual */
  HabitualEventual = 'HabitualEventual',
  /** Habitual/Intermitente */
  HabitualIntermittent = 'HabitualIntermittent',
  /** Habitual/Permanente */
  HabitualPermanent = 'HabitualPermanent',
  /** Não habitual/Eventual */
  NoHabitualEventual = 'NoHabitualEventual',
  /** Não habitual/Intermitente */
  NoHabitualIntermittent = 'NoHabitualIntermittent',
  /** Não habitual/Permanente */
  NoHabitualPermanent = 'NoHabitualPermanent',
  /** Sem agente nocivo */
  NoHarmfulAgent = 'NoHarmfulAgent',
  /** Ocasional/Eventual */
  OccasionalEventual = 'OccasionalEventual',
  /** Ocasional/Intermitente */
  OccasionalIntermittent = 'OccasionalIntermittent',
  /** Ocasional/Permanente */
  OccasionalPermanent = 'OccasionalPermanent'
}

export type TExpectedConsultation = {
  __typename?: 'ExpectedConsultation';
  /** Filial (origem da pessoa) */
  branch?: Maybe<Scalars['String']['output']>;
  /** Tipo de consulta */
  consultationType: TConsultationType;
  /** Exames */
  exams?: Maybe<Array<TExpectedExam>>;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Identificador do prontuário médico */
  medicalRecordId?: Maybe<Scalars['String']['output']>;
  /** Identificador do paciente */
  patientId?: Maybe<Scalars['String']['output']>;
  /** Nome do paciente */
  patientName: Scalars['String']['output'];
  /** Foto do paciente */
  patientPicture?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** Data de previsão */
  previewDate?: Maybe<Scalars['DateTime']['output']>;
};

export type TExpectedExam = {
  __typename?: 'ExpectedExam';
  /** Descrição */
  description: Scalars['String']['output'];
  /** Identificador */
  id: Scalars['String']['output'];
  /** Identificador de referência */
  referenceId?: Maybe<Scalars['String']['output']>;
};

export type TExpectedExamFromQuery = {
  __typename?: 'ExpectedExamFromQuery';
  /** Tipo de consulta */
  consultationType: TConsultationType;
  /** Descrição do exame */
  examDescription: Scalars['String']['output'];
  /** Identificador do exame */
  examId: Scalars['String']['output'];
  /** Identificador */
  id: Scalars['String']['output'];
  /** Data da última realização */
  lastRealizationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Identificador do prontuário médico */
  medicalRecordId?: Maybe<Scalars['String']['output']>;
  /** Data da próxima realização */
  nextRealizationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Identificador do paciente */
  patientId?: Maybe<Scalars['String']['output']>;
  /** Nome do paciente */
  patientName: Scalars['String']['output'];
  /** Foto do paciente */
  patientPicture?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** Data de previsão */
  previewDate?: Maybe<Scalars['DateTime']['output']>;
  /** Identificador de referência */
  referenceId?: Maybe<Scalars['String']['output']>;
};

export type TExpectedGoal = {
  __typename?: 'ExpectedGoal';
  /** Plano de ação */
  actionPlan: TActionPlan;
  /** Data da meta */
  date: Scalars['DateTime']['output'];
  /** Descrição */
  description?: Maybe<Scalars['String']['output']>;
  /** Detalhes */
  details?: Maybe<Scalars['String']['output']>;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Responsável */
  responsible?: Maybe<TPerson>;
  /** Valor da meta */
  value: Scalars['Float']['output'];
};

export type TExpectedGoalInput = {
  /** Identificador do plano de ação */
  actionPlanId: Scalars['String']['input'];
  /** Data da meta */
  date: Scalars['DateTime']['input'];
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Detalhes */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do responsável */
  responsibleId?: InputMaybe<Scalars['String']['input']>;
  /** Valor da meta */
  value: Scalars['Float']['input'];
};

export type TExpectedGoalOnActionPlan = {
  __typename?: 'ExpectedGoalOnActionPlan';
  /** Data da meta */
  date: Scalars['DateTime']['output'];
  /** Descrição */
  description?: Maybe<Scalars['String']['output']>;
  /** Detalhes */
  details?: Maybe<Scalars['String']['output']>;
  /** Responsável */
  responsible?: Maybe<TPerson>;
  /** Valor da meta */
  value: Scalars['Float']['output'];
};

export type TExpense = {
  __typename?: 'Expense';
  /** Descrição da despesa */
  description: Scalars['String']['output'];
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Incidência da despesa */
  incidence: TIncidenceExpense;
  /** Indica se está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Identificador de referência */
  referenceId?: Maybe<Scalars['String']['output']>;
  /** Tipo de despesa */
  type: TExpenseType;
};

export type TExpenseInput = {
  /** Descrição da despesa */
  description: Scalars['String']['input'];
  /** Incidência da despesa */
  incidence: TIncidenceExpense;
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de despesa */
  type: TExpenseType;
};

export type TExpenseOnAccident = {
  __typename?: 'ExpenseOnAccident';
  /** Data da despesa */
  date: Scalars['DateTime']['output'];
  /** Despesa */
  expense: TExpense;
  /** Valor da despesa */
  value?: Maybe<Scalars['Float']['output']>;
};

export type TExpenseOnAccidentInput = {
  /** Data da despesa */
  date: Scalars['DateTime']['input'];
  /** Identificador da despesa */
  expenseId: Scalars['String']['input'];
  /** Valor da despesa */
  value: Scalars['Float']['input'];
};

export type TExpenseOnAccidentRemove = {
  /** Data da despesa */
  date: Scalars['DateTime']['input'];
  /** Identificador da despesa */
  expenseId: Scalars['String']['input'];
};

export type TExpenseOnAccidentUpdate = {
  /** Despesas a criar */
  toCreate: Array<TExpenseOnAccidentInput>;
  /** Despesas a remover */
  toRemove: Array<TExpenseOnAccidentRemove>;
  /** Despesas a atualizar */
  toUpdate: Array<TExpenseOnAccidentInput>;
};

/** Tipo de despesa */
export enum TExpenseType {
  /** Indenização */
  Indemnity = 'Indemnity',
  /** Material */
  Material = 'Material',
  /** Médica */
  Medical = 'Medical',
  /** Outros */
  Others = 'Others',
  /** Perda de produção */
  ProductionLoss = 'ProductionLoss'
}

export type TExpenseUpdate = {
  /** Descrição da despesa */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Incidência da despesa */
  incidence?: InputMaybe<TIncidenceExpense>;
  /** Indica se está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de despesa */
  type?: InputMaybe<TExpenseType>;
};

export type TExpensiveAccidentsChart = {
  __typename?: 'ExpensiveAccidentsChart';
  /** Dados */
  data: Array<TData>;
  /** Indica se há acidentes registrados */
  hasAccident: Scalars['Boolean']['output'];
  /** Dados por total */
  perTotal: Array<TData>;
};

export type TExportClinicalQuiz = {
  /** Data inicial */
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador do questionário */
  quiz: Scalars['String']['input'];
  /** Data final */
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TExportStatus = {
  __typename?: 'ExportStatus';
  /** Entidade que foi exportada */
  entity: Scalars['String']['output'];
  /** Mensagem de erro, se houver */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Tipo do arquivo exportado (csv, pdf, docx, xlsx, zip) */
  fileType: TExporterTypeEnum;
  /** Link para o arquivo exportado */
  link?: Maybe<Scalars['String']['output']>;
  /** Progresso da exportação (0 a 100) */
  progress?: Maybe<Scalars['Int']['output']>;
  /** Status da exportação */
  status: TExportStatusEnum;
  /** Identificador do rastreamento da exportação */
  trackId: Scalars['String']['output'];
  /** Timestamp ISO da última atualização */
  updatedAt: Scalars['String']['output'];
};

/** Status da exportação */
export enum TExportStatusEnum {
  /** Concluída */
  Completed = 'Completed',
  /** Falhou */
  Failed = 'Failed',
  /** Em andamento */
  InProgress = 'InProgress',
  /** Sem dados */
  NoData = 'NoData',
  /** Pendente */
  Pending = 'Pending'
}

/** Tipos de exportação disponíveis */
export enum TExporterTypeEnum {
  Csv = 'CSV',
  Docx = 'DOCX',
  Json = 'JSON',
  Pdf = 'PDF',
  Xlsx = 'XLSX',
  Zip = 'ZIP'
}

export type TExposureGroup = {
  __typename?: 'ExposureGroup';
  /** Identificador da filial */
  branch: Scalars['String']['output'];
  /** Referência da filial */
  branchRef: TBranch;
  /** Descrição do grupo de exposição */
  description: Scalars['String']['output'];
  /** Detalhes adicionais do grupo de exposição */
  details?: Maybe<Scalars['String']['output']>;
  /** Centros de custo vinculados ao grupo de exposição */
  exposureCostCenters: Array<TExposureGroupCostCenter>;
  /** Departamentos vinculados ao grupo de exposição */
  exposureDepartments: Array<TExposureGroupDepartment>;
  /** Cargos vinculados ao grupo de exposição */
  exposureOccupations: Array<TExposureGroupOccupation>;
  /** Pessoas vinculadas ao grupo de exposição */
  exposurePersons: Array<TExposureGroupPerson>;
  /** Tarefas vinculadas ao grupo de exposição */
  exposureTasks: Array<TExposureGroupTask>;
  /** Identificador único do grupo de exposição */
  id: Scalars['String']['output'];
  /** Indica se o grupo de exposição está ativo */
  isActive: Scalars['Boolean']['output'];
};

export type TExposureGroupCopyInput = {
  copyMeasurements?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificadores dos centros de custo a vincular */
  costCenterIds: Array<Scalars['String']['input']>;
  /** Identificadores dos departamentos a vincular */
  departmentIds: Array<Scalars['String']['input']>;
  /** Descrição do novo grupo de exposição */
  description: Scalars['String']['input'];
  /** Detalhes adicionais do novo grupo de exposição */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do grupo de exposição a ser copiado */
  id: Scalars['String']['input'];
  /** Indica se o novo grupo de exposição estará ativo */
  isActive: Scalars['Boolean']['input'];
  /** Identificadores dos cargos a vincular */
  occupationIds: Array<Scalars['String']['input']>;
  /** Identificador da filial de destino */
  targetBranch: Scalars['String']['input'];
  /** Identificadores das tarefas a vincular */
  taskIds: Array<Scalars['String']['input']>;
};

export type TExposureGroupCostCenter = {
  __typename?: 'ExposureGroupCostCenter';
  /** Filial */
  branch: Scalars['String']['output'];
  /** Centro de custo */
  costCenter: TCostCenter;
  /** Identificador do centro de custo */
  costCenterId: Scalars['String']['output'];
  /** Identificador do grupo de exposição */
  exposureGroupId: Scalars['String']['output'];
  /** Identificador único */
  id: Scalars['String']['output'];
};

export type TExposureGroupCostCenterInput = {
  /** Identificador do centro de custo */
  costCenterId: Scalars['String']['input'];
  /** Identificador do grupo de exposição */
  exposureGroupId: Scalars['String']['input'];
};

export type TExposureGroupCostCenterUpdate = {
  /** Identificador do centro de custo */
  costCenterId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do grupo de exposição */
  exposureGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
};

export type TExposureGroupDepartment = {
  __typename?: 'ExposureGroupDepartment';
  /** Filial */
  branch: Scalars['String']['output'];
  /** Departamento */
  department: TDepartment;
  /** Identificador do departamento */
  departmentId: Scalars['String']['output'];
  /** Identificador do grupo de exposição */
  exposureGroupId: Scalars['String']['output'];
  /** Identificador único */
  id: Scalars['String']['output'];
};

export type TExposureGroupDepartmentInput = {
  /** Identificador do departamento */
  departmentId: Scalars['String']['input'];
  /** Identificador do grupo de exposição */
  exposureGroupId: Scalars['String']['input'];
};

export type TExposureGroupDepartmentUpdate = {
  /** Identificador do departamento */
  departmentId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do grupo de exposição */
  exposureGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
};

export type TExposureGroupInput = {
  costCenterIds: Array<Scalars['String']['input']>;
  departmentIds: Array<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  details?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  occupationIds: Array<Scalars['String']['input']>;
  personIds: Array<Scalars['String']['input']>;
  taskIds: Array<Scalars['String']['input']>;
};

export type TExposureGroupOccupation = {
  __typename?: 'ExposureGroupOccupation';
  /** Filial */
  branch: Scalars['String']['output'];
  /** Identificador do grupo de exposição */
  exposureGroupId: Scalars['String']['output'];
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Cargo */
  occupation: TOccupation;
  /** Identificador do cargo */
  occupationId: Scalars['String']['output'];
};

export type TExposureGroupOccupationInput = {
  /** Identificador do grupo de exposição */
  exposureGroupId: Scalars['String']['input'];
  /** Identificador do cargo */
  occupationId: Scalars['String']['input'];
};

export type TExposureGroupOccupationUpdate = {
  /** Identificador do grupo de exposição */
  exposureGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Identificador do cargo */
  occupationId?: InputMaybe<Scalars['String']['input']>;
};

export type TExposureGroupPerson = {
  __typename?: 'ExposureGroupPerson';
  /** Filial */
  branch: Scalars['String']['output'];
  /** Grupo de exposição */
  exposureGroup: TExposureGroup;
  /** Identificador do grupo de exposição */
  exposureGroupId: Scalars['String']['output'];
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Pessoa */
  person: TPerson;
  /** Identificador da pessoa */
  personId: Scalars['String']['output'];
};

export type TExposureGroupPersonInput = {
  /** Identificador do grupo de exposição */
  exposureGroupId: Scalars['String']['input'];
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
};

export type TExposureGroupPersonUpdate = {
  /** Identificador do grupo de exposição */
  exposureGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Identificador da pessoa */
  personId?: InputMaybe<Scalars['String']['input']>;
};

export type TExposureGroupTask = {
  __typename?: 'ExposureGroupTask';
  /** Filial */
  branch: Scalars['String']['output'];
  /** Identificador do grupo de exposição */
  exposureGroupId: Scalars['String']['output'];
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Atividade */
  task: TTask;
  /** Identificador da atividade */
  taskId: Scalars['String']['output'];
};

export type TExposureGroupTaskInput = {
  /** Identificador do grupo de exposição */
  exposureGroupId: Scalars['String']['input'];
  /** Identificador da atividade */
  taskId: Scalars['String']['input'];
};

export type TExposureGroupTaskUpdate = {
  /** Identificador do grupo de exposição */
  exposureGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Identificador da atividade */
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type TExposureGroupUpdate = {
  costCenterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  occupationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  peopleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  taskIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Motivo da prorrogação do prazo de substituição do EPI */
export enum TExtensionReason {
  /** Aguardando reposição de estoque */
  AwaitingRestock = 'AwaitingRestock',
  /** EPI em bom estado de conservação */
  GoodCondition = 'GoodCondition',
  /** Funcionário em férias/afastamento */
  OnLeave = 'OnLeave',
  /** Outro */
  Other = 'Other',
  /** Uso esporádico do funcionário */
  SporadicUse = 'SporadicUse'
}

export type TExternalDeliveryChart = {
  __typename?: 'ExternalDeliveryChart';
  /** Entregas a pessoas externas */
  external: Scalars['Float']['output'];
  /** Indica se existem entregas de IPE */
  hasIpeDeliveries: Scalars['Boolean']['output'];
  /** Entregas a pessoas internas */
  internal: Scalars['Float']['output'];
};

export type TExternalDoctor = {
  __typename?: 'ExternalDoctor';
  crmState?: Maybe<TState>;
  doctorCrm?: Maybe<Scalars['String']['output']>;
  doctorName?: Maybe<Scalars['String']['output']>;
};

export type TExternalFields = {
  __typename?: 'ExternalFields';
  /** Valor padrão */
  default?: Maybe<Scalars['String']['output']>;
  /** ID do campo externo */
  id?: Maybe<Scalars['String']['output']>;
  /** Tipo de integração */
  integrationType?: Maybe<TErpType>;
  /** ID do campo interno */
  internalFieldId?: Maybe<Scalars['String']['output']>;
  /** ID do metadado */
  metadataId?: Maybe<Scalars['String']['output']>;
  /** Nome do campo */
  name?: Maybe<Scalars['String']['output']>;
  /** Indica se é obrigatório */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** Tipo do campo */
  type?: Maybe<TFieldType>;
};

export type TExternalOccupationalHealthCertificate = {
  __typename?: 'ExternalOccupationalHealthCertificate';
  consultation?: Maybe<TConsultation>;
  examResult?: Maybe<TExamNormal>;
  occupationalHealthCertificate?: Maybe<TOccupationalHealthCertificate>;
};

export type TExternalOccupationalHealthCertificateInput = {
  /** Dados da Consulta Médica */
  consultation: TConsultationInput;
  /** Dados do Atestado Ocupacional */
  occupationalHealthCertificate: TOccupationalHealthCertificateInput;
};

export type TExternalOccupationalHealthCertificateResponse = {
  __typename?: 'ExternalOccupationalHealthCertificateResponse';
  certificateUpdated?: Maybe<TOccupationalHealthCertificate>;
  consultationUpdated?: Maybe<TConsultation>;
  resultCreated?: Maybe<TExamNormal>;
  resultUpdated?: Maybe<TExamNormal>;
};

export type TExternalOccupationalHealthCertificateUpdate = {
  consultation?: InputMaybe<TConsultationUpdate>;
  examResultInput?: InputMaybe<TExamNormalInput>;
  examResultUpdate?: InputMaybe<TExamNormalUpdate>;
  occupationalHealthCertificate?: InputMaybe<TOccupationalHealthCertificateUpdate>;
};

export type TExtinguishingDonutChart = {
  __typename?: 'ExtinguishingDonutChart';
  entries: Array<TExtinguishingDonutEntry>;
  hasData: Scalars['Boolean']['output'];
  total: Scalars['Int']['output'];
};

export type TExtinguishingDonutEntry = {
  __typename?: 'ExtinguishingDonutEntry';
  label: Scalars['String']['output'];
  result: Scalars['Int']['output'];
};

export type TExtinguishingInspectionChart = {
  __typename?: 'ExtinguishingInspectionChart';
  entries: Array<TExtinguishingInspectionEntry>;
  hasData: Scalars['Boolean']['output'];
  totalCanceled: Scalars['Int']['output'];
  totalFinished: Scalars['Int']['output'];
  totalPending: Scalars['Int']['output'];
};

export type TExtinguishingInspectionEntry = {
  __typename?: 'ExtinguishingInspectionEntry';
  canceled: Scalars['Int']['output'];
  finished: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  pending: Scalars['Int']['output'];
};

export type TExtinguishingParetoChart = {
  __typename?: 'ExtinguishingParetoChart';
  entries: Array<TExtinguishingParetoEntry>;
  hasData: Scalars['Boolean']['output'];
  total: Scalars['Int']['output'];
};

export type TExtinguishingParetoEntry = {
  __typename?: 'ExtinguishingParetoEntry';
  cumulativePercent: Scalars['Float']['output'];
  label: Scalars['String']['output'];
  result: Scalars['Int']['output'];
};

export type TExtinguishingSystem = {
  __typename?: 'ExtinguishingSystem';
  abnt?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<TAttachment>>;
  brand?: Maybe<Scalars['String']['output']>;
  degreeOfFire?: Maybe<TDegreeOfFire>;
  description: Scalars['String']['output'];
  emptyWeight?: Maybe<Scalars['Float']['output']>;
  extinguishingCapacity?: Maybe<Scalars['String']['output']>;
  fireExtinguisherType?: Maybe<TFireExtinguisherType>;
  fullWeight?: Maybe<Scalars['Float']['output']>;
  hidraulicInspections?: Maybe<Array<THidraulicSystemInspection>>;
  id: Scalars['String']['output'];
  inspectionPeriodicity?: Maybe<Scalars['Float']['output']>;
  inspections?: Maybe<Array<TExtinguishingSystemInspection>>;
  location?: Maybe<Scalars['String']['output']>;
  maintenanceStatus?: Maybe<TExtinguishingSystemMaintenance>;
  manufacturingYear?: Maybe<Scalars['Float']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  nextMaintenance?: Maybe<Scalars['DateTime']['output']>;
  physicalEnvironment: TPhysicalEnvironment;
  physicalEnvironmentId: Scalars['String']['output'];
  purchaseDate?: Maybe<Scalars['DateTime']['output']>;
  situation: TExtinguishingSystemSituation;
  systemType: TExtinguishingSystemType;
};

export type TExtinguishingSystemDashboard = {
  __typename?: 'ExtinguishingSystemDashboard';
  extinguisherEnvironmentChart: TExtinguishingParetoChart;
  extinguisherInspectionChart: TExtinguishingInspectionChart;
  extinguisherInspectionIssuesChart: TExtinguishingParetoChart;
  extinguisherStatusChart: TExtinguishingDonutChart;
  extinguisherTypeChart: TExtinguishingDonutChart;
  hidraulicEnvironmentChart: TExtinguishingParetoChart;
  hidraulicInspectionChart: TExtinguishingInspectionChart;
  hidraulicInspectionIssuesChart: TExtinguishingParetoChart;
  hidraulicStatusChart: TExtinguishingDonutChart;
};

export type TExtinguishingSystemFilter = {
  fireExtinguisherType?: InputMaybe<Array<TFireExtinguisherType>>;
  situation?: InputMaybe<Array<TExtinguishingSystemSituation>>;
  systemType?: InputMaybe<Array<TExtinguishingSystemType>>;
};

export type TExtinguishingSystemInput = {
  abnt?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  degreeOfFire?: InputMaybe<TDegreeOfFire>;
  description: Scalars['String']['input'];
  emptyWeight?: InputMaybe<Scalars['Float']['input']>;
  extinguishingCapacity?: InputMaybe<Scalars['String']['input']>;
  fireExtinguisherType?: InputMaybe<TFireExtinguisherType>;
  fullWeight?: InputMaybe<Scalars['Float']['input']>;
  hidraulicInspections?: InputMaybe<Array<TInspectionOnHidraulicSystemInput>>;
  inspectionPeriodicity?: InputMaybe<Scalars['Float']['input']>;
  inspections?: InputMaybe<Array<TInspectionOnExtinguishingSystemInput>>;
  location?: InputMaybe<Scalars['String']['input']>;
  maintenanceStatus?: InputMaybe<TExtinguishingSystemMaintenance>;
  manufacturingYear?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  nextMaintenance?: InputMaybe<Scalars['DateTime']['input']>;
  physicalEnvironmentId: Scalars['String']['input'];
  purchaseDate?: InputMaybe<Scalars['DateTime']['input']>;
  situation: TExtinguishingSystemSituation;
  systemType: TExtinguishingSystemType;
};

export type TExtinguishingSystemInspection = {
  __typename?: 'ExtinguishingSystemInspection';
  attachments?: Maybe<Array<TAttachment>>;
  completeValve: Scalars['Boolean']['output'];
  cylindricalValve: Scalars['Boolean']['output'];
  diffuserReplacement: Scalars['Boolean']['output'];
  drillUsed: Scalars['Boolean']['output'];
  extinguishingSystem: TExtinguishingSystem;
  fireUsed: Scalars['Boolean']['output'];
  hose: Scalars['Boolean']['output'];
  hydrostaticTest: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  monometer: Scalars['Boolean']['output'];
  observation?: Maybe<Scalars['String']['output']>;
  painting: Scalars['Boolean']['output'];
  plannedDate: Scalars['DateTime']['output'];
  realDate?: Maybe<Scalars['DateTime']['output']>;
  realoaded: Scalars['Boolean']['output'];
  reloadDate?: Maybe<Scalars['DateTime']['output']>;
  responsible: TPerson;
  safetyValve: Scalars['Boolean']['output'];
  situation: TInspectionSituation;
  sundry: Scalars['Boolean']['output'];
  triggerReplacement: Scalars['Boolean']['output'];
};

export type TExtinguishingSystemInspectionInput = {
  completeValve: Scalars['Boolean']['input'];
  cylindricalValve: Scalars['Boolean']['input'];
  diffuserReplacement: Scalars['Boolean']['input'];
  drillUsed: Scalars['Boolean']['input'];
  extinguishingSystemId: Scalars['String']['input'];
  fireUsed: Scalars['Boolean']['input'];
  hose: Scalars['Boolean']['input'];
  hydrostaticTest: Scalars['Boolean']['input'];
  monometer: Scalars['Boolean']['input'];
  observation?: InputMaybe<Scalars['String']['input']>;
  painting: Scalars['Boolean']['input'];
  plannedDate: Scalars['DateTime']['input'];
  realDate?: InputMaybe<Scalars['DateTime']['input']>;
  realoaded: Scalars['Boolean']['input'];
  reloadDate?: InputMaybe<Scalars['DateTime']['input']>;
  responsibleId: Scalars['String']['input'];
  safetyValve: Scalars['Boolean']['input'];
  situation: TInspectionSituation;
  sundry: Scalars['Boolean']['input'];
  triggerReplacement: Scalars['Boolean']['input'];
};

/** Manutenção do sistema de combate a incêndio */
export enum TExtinguishingSystemMaintenance {
  /** Aguardando */
  Await = 'Await',
  /** Futura */
  Future = 'Future',
  /** Atrasada */
  Late = 'Late',
  /** Não se aplica */
  NotApplicable = 'NotApplicable'
}

/** Campos de ordenação de sistemas de extinção */
export enum TExtinguishingSystemOrderByField {
  /** Descrição */
  Description = 'Description',
  /** Manutenção */
  Maintenance = 'Maintenance'
}

export type TExtinguishingSystemOrderByInput = {
  field?: InputMaybe<TExtinguishingSystemOrderByField>;
  type?: InputMaybe<TOrderBy>;
};

export type TExtinguishingSystemQueryInput = {
  filter?: InputMaybe<TExtinguishingSystemFilter>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TExtinguishingSystemRaw = {
  __typename?: 'ExtinguishingSystemRaw';
  abnt?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  degreeOfFire?: Maybe<TDegreeOfFire>;
  description: Scalars['String']['output'];
  emptyWeight?: Maybe<Scalars['Float']['output']>;
  extinguishingCapacity?: Maybe<Scalars['String']['output']>;
  fireExtinguisherType?: Maybe<TFireExtinguisherType>;
  fullWeight?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  inspectionPeriodicity?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  maintenance: Scalars['Float']['output'];
  maintenanceStatus?: Maybe<TExtinguishingSystemMaintenance>;
  manufacturingYear?: Maybe<Scalars['Float']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  nextMaintenance?: Maybe<Scalars['DateTime']['output']>;
  physicalEnvironmentDescription: Scalars['String']['output'];
  physicalEnvironmentId: Scalars['String']['output'];
  purchaseDate?: Maybe<Scalars['DateTime']['output']>;
  situation: TExtinguishingSystemSituation;
  systemType: TExtinguishingSystemType;
};

/** Situação do sistema de combate a incêndio */
export enum TExtinguishingSystemSituation {
  /** Ativo */
  Active = 'Active',
  /** Inativo */
  Inactive = 'Inactive'
}

/** Tipo de sistema de extinção */
export enum TExtinguishingSystemType {
  /** Extintor de incêndio */
  FireExtinguisher = 'FireExtinguisher',
  /** Sistema hidráulico */
  HidraulicSystem = 'HidraulicSystem'
}

export type TExtinguishingSystemUpdate = {
  abnt?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  degreeOfFire?: InputMaybe<TDegreeOfFire>;
  description?: InputMaybe<Scalars['String']['input']>;
  emptyWeight?: InputMaybe<Scalars['Float']['input']>;
  extinguishingCapacity?: InputMaybe<Scalars['String']['input']>;
  fireExtinguisherType?: InputMaybe<TFireExtinguisherType>;
  fullWeight?: InputMaybe<Scalars['Float']['input']>;
  hidraulicInspections?: InputMaybe<TInspectionOnHidraulicSystemChanges>;
  id: Scalars['String']['input'];
  inspectionPeriodicity?: InputMaybe<Scalars['Float']['input']>;
  inspections?: InputMaybe<TInspectionOnExtinguishingSystemChanges>;
  location?: InputMaybe<Scalars['String']['input']>;
  maintenanceStatus?: InputMaybe<TExtinguishingSystemMaintenance>;
  manufacturingYear?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  nextMaintenance?: InputMaybe<Scalars['DateTime']['input']>;
  physicalEnvironmentId?: InputMaybe<Scalars['String']['input']>;
  purchaseDate?: InputMaybe<Scalars['DateTime']['input']>;
  situation?: InputMaybe<TExtinguishingSystemSituation>;
  systemType?: InputMaybe<TExtinguishingSystemType>;
};

/** Cor dos olhos */
export enum TEyeColor {
  /** Âmbar */
  Amber = 'amber',
  /** Preto */
  Black = 'black',
  /** Azul */
  Blue = 'blue',
  /** Castanho */
  Brown = 'brown',
  /** Verde escuro */
  DarkGreen = 'darkGreen',
  /** Azul esverdeado */
  GreenishBlue = 'greenishBlue',
  /** Castanho esverdeado */
  GreenishBrown = 'greenishBrown',
  /** Cinza */
  Grey = 'grey',
  /** Verde claro */
  LightGreen = 'lightGreen',
  /** Outro */
  Other = 'other',
  /** Verde amarelado */
  YellowishGreen = 'yellowishGreen'
}

export type TFaceValidations = {
  /** Indica se validação de IPE foi realizada */
  ipe: Scalars['Boolean']['input'];
  /** Indica se validação de produto foi realizada */
  product: Scalars['Boolean']['input'];
  /** Indica se validação de peças sobressalentes foi realizada */
  spareParts: Scalars['Boolean']['input'];
};

/** Item favoritado pelo usuário na sidebar */
export type TFavoriteOption = {
  __typename?: 'FavoriteOption';
  /** Chave do ícone (mapping de QuironsIconComponent) */
  iconType: Scalars['String']['output'];
  /** Identificador do favorito */
  id: Scalars['String']['output'];
  /** Rótulo exibido */
  label: Scalars['String']['output'];
  /** Rota para a qual o favorito navega */
  route: Scalars['String']['output'];
};

export type TFavoriteOptionInput = {
  /** Chave do ícone (mapping de QuironsIconComponent) */
  iconType: Scalars['String']['input'];
  /** Identificador do favorito */
  id: Scalars['String']['input'];
  /** Rótulo exibido */
  label: Scalars['String']['input'];
  /** Rota para a qual o favorito navega */
  route: Scalars['String']['input'];
};

/** Funcionalidades do sistema */
export enum TFeature {
  AiMedicalCertificateOcr = 'AiMedicalCertificateOcr',
  AuditLogs = 'AuditLogs',
  AutoIpeDelivery = 'AutoIPEDelivery',
  CheckList = 'CheckList',
  CustomIntegration = 'CustomIntegration',
  CustomizableDashboard = 'CustomizableDashboard',
  DocumentBuilder = 'DocumentBuilder',
  ESocial = 'ESocial',
  ESocialPanel = 'ESocialPanel',
  ExpectedConsultationsPerf = 'ExpectedConsultationsPerf',
  ExternalAuthentications = 'ExternalAuthentications',
  ExternalIntegrations = 'ExternalIntegrations',
  FaceRecognition = 'FaceRecognition',
  Favorites = 'Favorites',
  FirstSteps = 'FirstSteps',
  Hermes = 'Hermes',
  History = 'History',
  InboundResilient = 'InboundResilient',
  IntegrationBulkSync = 'IntegrationBulkSync',
  IntegrationConfiguration = 'IntegrationConfiguration',
  IntegrationPaginatedPull = 'IntegrationPaginatedPull',
  IntegrationSendAsync = 'IntegrationSendAsync',
  InternalStock = 'InternalStock',
  NewImportProcess = 'NewImportProcess',
  NotificationConfig = 'NotificationConfig',
  OfflineSync = 'OfflineSync',
  PreMedicalCertificate = 'PreMedicalCertificate',
  ProtheusStockIntegration = 'ProtheusStockIntegration',
  RmStockIntegration = 'RMStockIntegration',
  ReportStructure = 'ReportStructure',
  SocIntegration = 'SOCIntegration',
  SignBroker = 'SignBroker',
  TimeSession = 'TimeSession',
  WorkPermission = 'WorkPermission'
}

export enum TFeatureEnum {
  AbsenceType = 'AbsenceType',
  AccessToken = 'AccessToken',
  Accident = 'Accident',
  AccidentAttachment = 'AccidentAttachment',
  AccidentCause = 'AccidentCause',
  AccidentCauserAgent = 'AccidentCauserAgent',
  AccidentClinicInformation = 'AccidentClinicInformation',
  AccidentExpense = 'AccidentExpense',
  AccidentExpenses = 'AccidentExpenses',
  AccidentIcd = 'AccidentIcd',
  AccidentLocal = 'AccidentLocal',
  AccidentPath = 'AccidentPath',
  AccidentVictim = 'AccidentVictim',
  AccidentWitness = 'AccidentWitness',
  Accredited = 'Accredited',
  AccreditedExam = 'AccreditedExam',
  ActionPlan = 'ActionPlan',
  ActionPlanDashboard = 'ActionPlanDashboard',
  ActionPlanInvestigation = 'ActionPlanInvestigation',
  ActionPlanMicroActions = 'ActionPlanMicroActions',
  ActionPlanReport = 'ActionPlanReport',
  ActionPlanRisk = 'ActionPlanRisk',
  Agreement = 'Agreement',
  AllowanceType = 'AllowanceType',
  ApiAccess = 'ApiAccess',
  Attachment = 'Attachment',
  BiologicalMonitoring = 'BiologicalMonitoring',
  BiologicalMonitoringExam = 'BiologicalMonitoringExam',
  BiologicalMonitoringExamGroup = 'BiologicalMonitoringExamGroup',
  Biometry = 'Biometry',
  BodyPart = 'BodyPart',
  Branch = 'Branch',
  Calendar = 'Calendar',
  Candidate = 'Candidate',
  CheckTableData = 'CheckTableData',
  ClinicalQuiz = 'ClinicalQuiz',
  ComplementaryExam = 'ComplementaryExam',
  Component = 'Component',
  Consultation = 'Consultation',
  ContactRequest = 'ContactRequest',
  ControlMeasure = 'ControlMeasure',
  CostCenter = 'CostCenter',
  CronTab = 'CronTab',
  CustomOrganization = 'CustomOrganization',
  Deficiency = 'Deficiency',
  DeliverySpareParts = 'DeliverySpareParts',
  Department = 'Department',
  Diagnostic = 'Diagnostic',
  E2eTesting = 'E2eTesting',
  ElectionComission = 'ElectionComission',
  Employee = 'Employee',
  EmployeeTask = 'EmployeeTask',
  EmployeeWarning = 'EmployeeWarning',
  Endpoint = 'Endpoint',
  EnvironmentalReport = 'EnvironmentalReport',
  EquipmentByCostCenter = 'EquipmentByCostCenter',
  EquipmentByOccupation = 'EquipmentByOccupation',
  Esocial = 'Esocial',
  EsocialQueue = 'EsocialQueue',
  Exam = 'Exam',
  ExamAudiometry = 'ExamAudiometry',
  ExamByOccupation = 'ExamByOccupation',
  ExamByRisk = 'ExamByRisk',
  ExamDiagnosticImage = 'ExamDiagnosticImage',
  ExamDiagnosticImageAttachment = 'ExamDiagnosticImageAttachment',
  ExamItem = 'ExamItem',
  ExamNormal = 'ExamNormal',
  ExamOtological = 'ExamOtological',
  ExamResult = 'ExamResult',
  ExamResultIbmp = 'ExamResultIbmp',
  ExamSpirometry = 'ExamSpirometry',
  ExamToxicological = 'ExamToxicological',
  ExpectedGoal = 'ExpectedGoal',
  Expense = 'Expense',
  ExposureGroup = 'ExposureGroup',
  ExposureGroupCostCenter = 'ExposureGroupCostCenter',
  ExposureGroupDepartment = 'ExposureGroupDepartment',
  ExposureGroupOccupation = 'ExposureGroupOccupation',
  ExposureGroupPerson = 'ExposureGroupPerson',
  ExposureGroupTask = 'ExposureGroupTask',
  ExtinguishingAttachment = 'ExtinguishingAttachment',
  ExtinguishingSystem = 'ExtinguishingSystem',
  ExtinguishingSystemDashboard = 'ExtinguishingSystemDashboard',
  FireBrigade = 'FireBrigade',
  FireBrigadeComponent = 'FireBrigadeComponent',
  FireBrigadeDashboard = 'FireBrigadeDashboard',
  FireBrigadeExam = 'FireBrigadeExam',
  FireBrigadeMeeting = 'FireBrigadeMeeting',
  FireBrigadeOccurrence = 'FireBrigadeOccurrence',
  FireBrigadeTraining = 'FireBrigadeTraining',
  FirstSteps = 'FirstSteps',
  Flag = 'Flag',
  FunctionalHistory = 'FunctionalHistory',
  GeneratingSource = 'GeneratingSource',
  HealthProgram = 'HealthProgram',
  HealthProgramExam = 'HealthProgramExam',
  HealthProgramOccupation = 'HealthProgramOccupation',
  HealthProgramTraining = 'HealthProgramTraining',
  Hermes = 'Hermes',
  Historic = 'Historic',
  Indicators = 'Indicators',
  Inspection = 'Inspection',
  Inss = 'Inss',
  InventoryQueue = 'InventoryQueue',
  Investigation = 'Investigation',
  InvestigationAttachment = 'InvestigationAttachment',
  Invite = 'Invite',
  IpeBiometry = 'IpeBiometry',
  IpeDelivery = 'IpeDelivery',
  Mandate = 'Mandate',
  MandateAction = 'MandateAction',
  MandateCostCenter = 'MandateCostCenter',
  MandateDashboard = 'MandateDashboard',
  MandateDepartment = 'MandateDepartment',
  MandateEvent = 'MandateEvent',
  MandateTraining = 'MandateTraining',
  Measurement = 'Measurement',
  MeasuringInstrument = 'MeasuringInstrument',
  MedicalCertificate = 'MedicalCertificate',
  MedicalRecord = 'MedicalRecord',
  MedicalRecordDashboard = 'MedicalRecordDashboard',
  MedicalRecordHealthProgram = 'MedicalRecordHealthProgram',
  MedicalRecordVaccine = 'MedicalRecordVaccine',
  MedicalReferral = 'MedicalReferral',
  MedicalRestriction = 'MedicalRestriction',
  Medicine = 'Medicine',
  Meeting = 'Meeting',
  MeetingAction = 'MeetingAction',
  MeetingParticipant = 'MeetingParticipant',
  Notify = 'Notify',
  Occupation = 'Occupation',
  OccupationalHealthCertificate = 'OccupationalHealthCertificate',
  Organization = 'Organization',
  OrganizationOwnership = 'OrganizationOwnership',
  OrthoRater = 'OrthoRater',
  Others = 'Others',
  PasswordRecovery = 'PasswordRecovery',
  Payments = 'Payments',
  PeriodicRange = 'PeriodicRange',
  Person = 'Person',
  PersonAttachment = 'PersonAttachment',
  PersonHistoryActivate = 'PersonHistoryActivate',
  PhysicalEnvironment = 'PhysicalEnvironment',
  PolicyAgreement = 'PolicyAgreement',
  Position = 'Position',
  Ppp = 'Ppp',
  Product = 'Product',
  ProductDelivery = 'ProductDelivery',
  ProductIpeManufacturer = 'ProductIpeManufacturer',
  Quiz = 'Quiz',
  RealGoal = 'RealGoal',
  RealGoalAttachment = 'RealGoalAttachment',
  ReportSection = 'ReportSection',
  ReportStructure = 'ReportStructure',
  ResponsibleAction = 'ResponsibleAction',
  Risk = 'Risk',
  RiskAgent = 'RiskAgent',
  RiskAttachment = 'RiskAttachment',
  RiskComposition = 'RiskComposition',
  RiskControl = 'RiskControl',
  RiskControlMeasure = 'RiskControlMeasure',
  RiskDashboard = 'RiskDashboard',
  RiskErgonomic = 'RiskErgonomic',
  RiskExam = 'RiskExam',
  RiskIpe = 'RiskIpe',
  RiskMap = 'RiskMap',
  RiskMeasurement = 'RiskMeasurement',
  RiskTraining = 'RiskTraining',
  RolePermission = 'RolePermission',
  Routes = 'Routes',
  SafetyQuiz = 'SafetyQuiz',
  SafetyQuizDashboard = 'SafetyQuizDashboard',
  ScheduleRestriction = 'ScheduleRestriction',
  Session = 'Session',
  Simulation = 'Simulation',
  SimulationPlan = 'SimulationPlan',
  Sipat = 'Sipat',
  SipatAttachment = 'SipatAttachment',
  SipatEvent = 'SipatEvent',
  Snellen = 'Snellen',
  SpareParts = 'SpareParts',
  StabilityType = 'StabilityType',
  StatementResponsibility = 'StatementResponsibility',
  StockLevel = 'StockLevel',
  StockMovement = 'StockMovement',
  SuggestionBox = 'SuggestionBox',
  Task = 'Task',
  Terms = 'Terms',
  Training = 'Training',
  TrainingAttachment = 'TrainingAttachment',
  TrainingHistory = 'TrainingHistory',
  TtalkQueue = 'TtalkQueue',
  UnityOfMeasure = 'UnityOfMeasure',
  Urinalysis = 'Urinalysis',
  User = 'User',
  UserRole = 'UserRole',
  VaccinationPlanning = 'VaccinationPlanning',
  Vaccine = 'Vaccine',
  Vote = 'Vote',
  Warehouse = 'Warehouse',
  WarningAttachment = 'WarningAttachment',
  Webhook = 'Webhook',
  WebhookQueue = 'WebhookQueue',
  WorkHours = 'WorkHours',
  WorkPermission = 'WorkPermission',
  WorkPermissionDashboard = 'WorkPermissionDashboard',
  WorkShift = 'WorkShift'
}

export type TFeatureObject = {
  __typename?: 'FeatureObject';
  feature: TFeature;
  version: TFeatureVersion;
};

export type TFeatureObjectInput = {
  feature: TFeature;
  version: TFeatureVersion;
};

export type TFeaturePermission = {
  __typename?: 'FeaturePermission';
  /** Funcionalidade */
  feature: TFeatureEnum;
  /** Tipo de permissão */
  type?: Maybe<TFeaturePermissionType>;
};

export enum TFeaturePermissionType {
  Create = 'Create',
  Delete = 'Delete',
  Print = 'Print',
  Update = 'Update'
}

export type TFeatureReturn = {
  __typename?: 'FeatureReturn';
  feature: TFeature;
  version: TFeatureVersion;
};

/** Versão da funcionalidade */
export enum TFeatureVersion {
  Development = 'Development',
  FallBack = 'FallBack',
  NotAvailable = 'NotAvailable',
  Stable = 'Stable'
}

export type TFeatureVersionReturn = {
  __typename?: 'FeatureVersionReturn';
  feature: TFeature;
  flag: TFlag;
  version: TFeatureVersion;
};

/** Tipo de campo */
export enum TFieldType {
  /** Booleano */
  Boolean = 'Boolean',
  /** Data */
  Date = 'Date',
  /** Data e hora */
  DateTime = 'DateTime',
  /** Número */
  Number = 'Number',
  /** Texto */
  String = 'String',
  /** Hora */
  Time = 'Time'
}

export type TFieldsInput = {
  /** Valor padrão */
  default?: InputMaybe<Scalars['String']['input']>;
  /** ID do campo interno genérico */
  genericInternalFieldId: Scalars['String']['input'];
  /** Tipo de integração */
  integrationType: TErpType;
  /** Nome do campo */
  name: Scalars['String']['input'];
  /** Indica se é obrigatório */
  required: Scalars['Boolean']['input'];
  /** Tipo do campo */
  type: TFieldType;
};

export type TFilterPerson = {
  /** Campo */
  field: Scalars['String']['input'];
  /** Valor */
  value: Scalars['String']['input'];
};

/** Tipo de filtro */
export enum TFilterType {
  /** Intervalo de datas */
  DateRange = 'DateRange',
  /** Intervalo de data e hora */
  DateTimeRange = 'DateTimeRange',
  /** Intervalo de porcentagens */
  PercentageRange = 'PercentageRange',
  /** Valor */
  Value = 'Value',
  /** Intervalo de valores */
  ValueRange = 'ValueRange'
}

export type TFindEndpointsInput = {
  /** Nome do card de integração */
  integrationCardName?: InputMaybe<Scalars['String']['input']>;
  /** Contexto de integração */
  integrationContext?: InputMaybe<TIntegrationContext>;
  /** Linha do ERP */
  line?: InputMaybe<TErpLine>;
  /** ID da organização */
  organizationId: Scalars['String']['input'];
  /** Descrição do serviço */
  serviceDescription?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de ERP */
  type: TErpType;
};

/** Mão do dedo */
export enum TFingerHand {
  /** Ambas */
  Both = 'Both',
  /** Esquerda */
  Left = 'Left',
  /** Direita */
  Right = 'Right'
}

/** Dedos */
export enum TFingers {
  /** Todos os dedos devem ser cadastrados */
  Enroll = 'Enroll',
  /** Médio */
  Middle = 'Middle',
  /** Mínimo */
  Pinky = 'Pinky',
  /** Indicador */
  Pointer = 'Pointer',
  /** Anelar */
  Ring = 'Ring',
  /** Polegar */
  Thumb = 'Thumb'
}

export type TFireBrigade = {
  __typename?: 'FireBrigade';
  /** Descrição da brigada de incêndio */
  description: Scalars['String']['output'];
  /** Data de encerramento da brigada */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Identificador único da brigada de incêndio */
  id: Scalars['String']['output'];
  /** Data de início da brigada */
  startDate: Scalars['DateTime']['output'];
};

export type TFireBrigadeBloodTypeChart = {
  __typename?: 'FireBrigadeBloodTypeChart';
  aNegative: Scalars['Int']['output'];
  aPositive: Scalars['Int']['output'];
  abNegative: Scalars['Int']['output'];
  abPositive: Scalars['Int']['output'];
  bNegative: Scalars['Int']['output'];
  bPositive: Scalars['Int']['output'];
  hasData: Scalars['Boolean']['output'];
  na: Scalars['Int']['output'];
  oNegative: Scalars['Int']['output'];
  oPositive: Scalars['Int']['output'];
};

export type TFireBrigadeComponent = {
  __typename?: 'FireBrigadeComponent';
  /** Atribuições */
  assignments?: Maybe<Scalars['String']['output']>;
  /** Data de saída */
  exitDate?: Maybe<Scalars['DateTime']['output']>;
  /** Brigada de incêndio */
  fireBrigade: TFireBrigade;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Data de inclusão */
  inclusionDate: Scalars['DateTime']['output'];
  /** Pessoa */
  person: TPerson;
  /** Função específica */
  specificFunction: TFireBrigadeSpecificFunction;
};

export type TFireBrigadeComponentActiveStatusChart = {
  __typename?: 'FireBrigadeComponentActiveStatusChart';
  entries: Array<TComponentActiveStatusEntry>;
  hasData: Scalars['Boolean']['output'];
  totalComponents: Scalars['Int']['output'];
};

export type TFireBrigadeComponentByCostCenterChart = {
  __typename?: 'FireBrigadeComponentByCostCenterChart';
  entries: Array<TCostCenterEntry>;
  hasData: Scalars['Boolean']['output'];
  totalComponents: Scalars['Int']['output'];
};

export type TFireBrigadeComponentInput = {
  /** Atribuições */
  assignments?: InputMaybe<Scalars['String']['input']>;
  /** Data de saída */
  exitDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador da brigada de incêndio */
  fireBrigadeId: Scalars['String']['input'];
  /** Data de inclusão */
  inclusionDate: Scalars['DateTime']['input'];
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
  /** Função específica */
  specificFunction: TFireBrigadeSpecificFunction;
};

export type TFireBrigadeComponentUpdate = {
  /** Atribuições */
  assignments?: InputMaybe<Scalars['String']['input']>;
  /** Data de saída */
  exitDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Data de inclusão */
  inclusionDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Função específica */
  specificFunction?: InputMaybe<TFireBrigadeSpecificFunction>;
};

export type TFireBrigadeDashboard = {
  __typename?: 'FireBrigadeDashboard';
  bloodTypeChart: TFireBrigadeBloodTypeChart;
  componentActiveStatusChart: TFireBrigadeComponentActiveStatusChart;
  componentsByCostCenter: TFireBrigadeComponentByCostCenterChart;
  meetings: TFireBrigadeMeetingChart;
  occurrences: TFireBrigadeOccurrenceChart;
  simulationActionChart: TFireBrigadeSimulationActionChart;
  simulationsChart: TFireBrigadeSimulationsChart;
};

export type TFireBrigadeExam = {
  __typename?: 'FireBrigadeExam';
  /** Exigido na admissão */
  admission: Scalars['Boolean']['output'];
  /** Exigido no retorno ao trabalho */
  backToWork: Scalars['Boolean']['output'];
  /** Exigido na mudança de função */
  changeOfFunction: Scalars['Boolean']['output'];
  /** Exigido na demissão */
  dismissal: Scalars['Boolean']['output'];
  /** Exame */
  exam: TExam;
  /** Brigada de incêndio */
  fireBrigade: TFireBrigade;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Exigido no periódico */
  periodic: Scalars['Boolean']['output'];
  /** Periodicidade do exame */
  periodicRange?: Maybe<TPeriodicRange>;
};

export type TFireBrigadeExamInput = {
  /** Exigido na admissão */
  admission: Scalars['Boolean']['input'];
  /** Exigido no retorno ao trabalho */
  backToWork: Scalars['Boolean']['input'];
  /** Exigido na mudança de função */
  changeOfFunction: Scalars['Boolean']['input'];
  /** Exigido na demissão */
  dismissal: Scalars['Boolean']['input'];
  /** Identificador do exame */
  examId: Scalars['String']['input'];
  /** Identificador da brigada de incêndio */
  fireBrigadeId: Scalars['String']['input'];
  /** Exigido no periódico */
  periodic: Scalars['Boolean']['input'];
  /** Identificador da periodicidade */
  periodicRangeId?: InputMaybe<Scalars['String']['input']>;
};

export type TFireBrigadeExamUpdate = {
  /** Exigido na admissão */
  admission?: InputMaybe<Scalars['Boolean']['input']>;
  /** Exigido no retorno ao trabalho */
  backToWork?: InputMaybe<Scalars['Boolean']['input']>;
  /** Exigido na mudança de função */
  changeOfFunction?: InputMaybe<Scalars['Boolean']['input']>;
  /** Exigido na demissão */
  dismissal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Exigido no periódico */
  periodic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador da periodicidade */
  periodicRangeId?: InputMaybe<Scalars['String']['input']>;
};

export type TFireBrigadeInput = {
  /** Descrição da brigada de incêndio */
  description: Scalars['String']['input'];
  /** Data de encerramento da brigada */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de início da brigada */
  startDate: Scalars['DateTime']['input'];
};

export type TFireBrigadeMeeting = {
  __typename?: 'FireBrigadeMeeting';
  /** Anexos */
  attachments?: Maybe<Array<TAttachment>>;
  /** Data da reunião */
  date: Scalars['DateTime']['output'];
  /** Duração da reunião */
  duration?: Maybe<Scalars['String']['output']>;
  /** Brigada de incêndio */
  fireBrigade: TFireBrigade;
  /** Ações da reunião */
  fireBrigadeMeetingActions?: Maybe<Array<TFireBrigadeMeetingAction>>;
  /** Participantes da reunião */
  fireBrigadeMeetingParticipants?: Maybe<Array<TFireBrigadeMeetingParticipant>>;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Formato da reunião */
  meetingFormat: TMeetingFormat;
  /** Local da reunião */
  meetingLocal?: Maybe<Scalars['String']['output']>;
  /** Tipo de reunião */
  meetingType: TMeetingType;
  /** Ata da reunião */
  minutesMeeting?: Maybe<Scalars['String']['output']>;
  /** Data real da reunião */
  realDate?: Maybe<Scalars['DateTime']['output']>;
  /** Assunto da reunião */
  subject: Scalars['String']['output'];
};

export type TFireBrigadeMeetingAction = {
  __typename?: 'FireBrigadeMeetingAction';
  /** Indica se está ativo */
  active: Scalars['Boolean']['output'];
  /** Data da ação */
  dateAction: Scalars['DateTime']['output'];
  /** Descrição da ação */
  description: Scalars['String']['output'];
  /** Identificador único */
  id: Scalars['String']['output'];
};

export type TFireBrigadeMeetingActionInput = {
  /** Indica se está ativo */
  active: Scalars['Boolean']['input'];
  /** Data da ação */
  dateAction: Scalars['DateTime']['input'];
  /** Descrição da ação */
  description: Scalars['String']['input'];
  /** Identificador único */
  id?: InputMaybe<Scalars['String']['input']>;
};

export type TFireBrigadeMeetingChart = {
  __typename?: 'FireBrigadeMeetingChart';
  extraordinaryMeetings: Array<TMeetingEntry>;
  hasData: Scalars['Boolean']['output'];
  ordinaryMeetings: Array<TMeetingEntry>;
  totalExtraordinaryMeetings: Scalars['Int']['output'];
  totalOrdinaryMeetings: Scalars['Int']['output'];
};

export type TFireBrigadeMeetingInput = {
  /** Ações da reunião */
  actions?: InputMaybe<Array<TFireBrigadeMeetingActionInput>>;
  /** Data da reunião */
  date: Scalars['DateTime']['input'];
  /** Duração da reunião */
  duration?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da brigada de incêndio */
  fireBrigadeId: Scalars['String']['input'];
  /** Formato da reunião */
  meetingFormat?: InputMaybe<TMeetingFormat>;
  /** Local da reunião */
  meetingLocal?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de reunião */
  meetingType: TMeetingType;
  /** Ata da reunião */
  minutesMeeting?: InputMaybe<Scalars['String']['input']>;
  /** Participantes da reunião */
  participants?: InputMaybe<Array<TFireBrigadeMeetingParticipantInput>>;
  /** Data real da reunião */
  realDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Assunto da reunião */
  subject: Scalars['String']['input'];
};

export type TFireBrigadeMeetingParticipant = {
  __typename?: 'FireBrigadeMeetingParticipant';
  /** Indica se compareceu */
  attendance?: Maybe<Scalars['Boolean']['output']>;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Justificativa de ausência */
  justification?: Maybe<Scalars['String']['output']>;
  /** Pessoa */
  person: TPerson;
};

export type TFireBrigadeMeetingParticipantInput = {
  /** Indica se compareceu */
  attendance?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador único */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Justificativa de ausência */
  justification?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
};

export type TFireBrigadeMeetingUpdate = {
  /** Ações da reunião */
  actions?: InputMaybe<Array<TFireBrigadeMeetingActionInput>>;
  /** Data da reunião */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Duração da reunião */
  duration?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Formato da reunião */
  meetingFormat?: InputMaybe<TMeetingFormat>;
  /** Local da reunião */
  meetingLocal?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de reunião */
  meetingType?: InputMaybe<TMeetingType>;
  /** Ata da reunião */
  minutesMeeting?: InputMaybe<Scalars['String']['input']>;
  /** Participantes da reunião */
  participants?: InputMaybe<Array<TFireBrigadeMeetingParticipantInput>>;
  /** Data real da reunião */
  realDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Assunto da reunião */
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type TFireBrigadeOccurrence = {
  __typename?: 'FireBrigadeOccurrence';
  /** Anexos */
  attachments?: Maybe<Array<TAttachment>>;
  /** Data da ocorrência */
  date: Scalars['DateTime']['output'];
  /** Detalhamento da ocorrência */
  detailing: Scalars['String']['output'];
  /** Brigada de incêndio */
  fireBrigade: TFireBrigade;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Resumo da ocorrência */
  summary: Scalars['String']['output'];
};

export type TFireBrigadeOccurrenceChart = {
  __typename?: 'FireBrigadeOccurrenceChart';
  entries: Array<TOccurrenceEntry>;
  hasData: Scalars['Boolean']['output'];
  totalOccurrences: Scalars['Int']['output'];
};

export type TFireBrigadeOccurrenceInput = {
  /** Data da ocorrência */
  date: Scalars['DateTime']['input'];
  /** Detalhamento da ocorrência */
  detailing: Scalars['String']['input'];
  /** Identificador da brigada de incêndio */
  fireBrigadeId: Scalars['String']['input'];
  /** Resumo da ocorrência */
  summary: Scalars['String']['input'];
};

export type TFireBrigadeOccurrenceUpdate = {
  /** Data da ocorrência */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Detalhamento da ocorrência */
  detailing?: InputMaybe<Scalars['String']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Resumo da ocorrência */
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type TFireBrigadePeriod = {
  __typename?: 'FireBrigadePeriod';
  /** Descrição da brigada de incêndio */
  descFireBrigade: Scalars['String']['output'];
  /** Nome da pessoa */
  namePerson: Scalars['String']['output'];
  /** Composição da função específica da brigada de incêndio */
  specFuncFireBrigadeComp: Scalars['String']['output'];
};

export type TFireBrigadeSimulationActionChart = {
  __typename?: 'FireBrigadeSimulationActionChart';
  entries: Array<TSimulationActionEntry>;
  hasData: Scalars['Boolean']['output'];
  totalAccomplished: Scalars['Int']['output'];
  totalEffective: Scalars['Int']['output'];
  totalPlanned: Scalars['Int']['output'];
};

export type TFireBrigadeSimulationsChart = {
  __typename?: 'FireBrigadeSimulationsChart';
  entries: Array<TSimulationEntry>;
  hasData: Scalars['Boolean']['output'];
  totalAccomplished: Scalars['Int']['output'];
  totalPlanned: Scalars['Int']['output'];
};

/** Função específica no corpo de bombeiros */
export enum TFireBrigadeSpecificFunction {
  /** Chefe */
  Boss = 'Boss',
  /** Coordenador */
  Coordenator = 'Coordenator',
  /** Líder */
  Leader = 'Leader',
  /** Membro */
  Member = 'Member'
}

export type TFireBrigadeTraining = {
  __typename?: 'FireBrigadeTraining';
  /** Erro de integração */
  errorIntegration?: Maybe<Scalars['String']['output']>;
  /** Brigada de incêndio */
  fireBrigade: TFireBrigade;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Treinamento */
  training: TTraining;
  /** Urgência do treinamento */
  urgency: TTrainingUrgency;
};

export type TFireBrigadeTrainingInput = {
  /** Identificador da brigada de incêndio */
  fireBrigadeId: Scalars['String']['input'];
  /** Identificador do treinamento */
  trainingId: Scalars['String']['input'];
  /** Urgência do treinamento */
  urgency: TTrainingUrgency;
};

export type TFireBrigadeUpdate = {
  /** Nova descrição da brigada de incêndio */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Nova data de encerramento da brigada */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador da brigada de incêndio a atualizar */
  id: Scalars['String']['input'];
  /** Nova data de início da brigada */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Tipo de extintor de incêndio */
export enum TFireExtinguisherType {
  /** Gás carbônico (CO2) */
  CarbonDioxide = 'CarbonDioxide',
  /** Espuma química */
  ChemicalFoam = 'ChemicalFoam',
  /** Pó químico à base de bicarbonato de sódio */
  ChemicalPowder = 'ChemicalPowder',
  /** Hidrocarbonetos halogenados */
  HalogenatedHydrocarbons = 'HalogenatedHydrocarbons',
  /** Espuma mecânica */
  MechanicalFoam = 'MechanicalFoam',
  /** Pó ABC (Fosfato Monoamônico) */
  MonoammoniumPhosphate = 'MonoammoniumPhosphate',
  /** Água */
  Water = 'Water'
}

export type TFirstSteps = {
  __typename?: 'FirstSteps';
  /** Lista de grupos de passos */
  data: Array<TItemsSteps>;
  /** Percentual total de conclusão */
  percentage: Scalars['Float']['output'];
  /** Subtítulo dos primeiros passos */
  subtitle: Scalars['String']['output'];
  /** Resumo geral do progresso */
  summary: Scalars['String']['output'];
  /** Título principal dos primeiros passos */
  title: Scalars['String']['output'];
};

/** Imagens dos primeiros passos */
export enum TFirstStepsImage {
  /** Atender consulta */
  AttendConsultation = 'attendConsultation',
  /** Configurar integração RH */
  ConfigIntegrationRh = 'configIntegrationRh',
  /** Configurar integração TAF */
  ConfigIntegrationTaf = 'configIntegrationTAF',
  /** Configurar organização */
  ConfigOrganization = 'configOrganization',
  /** Criar relatório ambiental */
  CreateEnvironmentalReport = 'createEnvironmentalReport',
  /** Criar primeiro atestado médico */
  CreateFirstMedicalCertificate = 'createFirstMedicalCertificate',
  /** Criar primeiro agendamento */
  CreateFirstSchedule = 'createFirstSchedule',
  /** Criar mandato */
  CreateMandate = 'createMandate',
  /** Criar prontuário médico */
  CreateMedicalRecord = 'createMedicalRecord',
  /** Criar risco */
  CreateRisk = 'createRisk',
  /** Personalizar perfil */
  CustomizeProfile = 'customizeProfile',
  /** Definir exames necessários */
  DefineNecessaryExams = 'defineNecessaryExams',
  /** Entregar primeiro equipamento */
  DeliveryFirstEquipment = 'deliveryFirstEquipment',
  /** Registrar restrições */
  RegisterRestrictions = 'registerRestrictions',
  /** Convidar usuário */
  UserInvite = 'userInvite'
}

/** Flag do sistema */
export enum TFlag {
  /** Versão de teste com novas funcionalidades */
  Beta = 'BETA',
  /** Versão em desenvolvimento */
  Dev = 'DEV',
  /** Versão importada de outro sistema */
  Import = 'IMPORT',
  /** Versão para testes de integração */
  Integration = 'INTEGRATION',
  /** Versão de produção estável */
  Release = 'RELEASE',
  /** Versão padrão de fábrica */
  Stock = 'STOCK'
}

export type TFlagRelation = {
  __typename?: 'FlagRelation';
  flag: TFlag;
  priority: Scalars['Float']['output'];
};

export type TFlagReturn = {
  __typename?: 'FlagReturn';
  flag: TFlag;
  version: TFeatureVersion;
};

export type TFloatRange = {
  /** Valor máximo */
  max?: InputMaybe<Scalars['Float']['input']>;
  /** Valor mínimo */
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type TFrequencyIndex = {
  __typename?: 'FrequencyIndex';
  /** Descrição do período */
  description?: Maybe<Scalars['String']['output']>;
  /** Índice de frequência de acidentes */
  index: Scalars['Float']['output'];
};

export type TFuncionalHistory = {
  __typename?: 'FuncionalHistory';
  costCenter: TCostCenter;
  department?: Maybe<TDepartment>;
  id: Scalars['String']['output'];
  occupation: TOccupation;
  person: TPerson;
  position?: Maybe<TPosition>;
  realizationDate: Scalars['DateTime']['output'];
  sefip?: Maybe<Scalars['String']['output']>;
};

export type TFuncionalHistoryByPerson = {
  __typename?: 'FuncionalHistoryByPerson';
  /** Centro de custo */
  costCenter: TCostCenter;
  /** Departamento */
  department?: Maybe<TDepartment>;
  /** Identificador único de histórico funcional por pessoa */
  id: Scalars['String']['output'];
  /** Ocupação */
  occupation: TOccupation;
  /** Posição */
  position?: Maybe<TPosition>;
  /** Data de realização */
  realizationDate: Scalars['DateTime']['output'];
  /** SEFIP */
  sefip?: Maybe<Scalars['String']['output']>;
};

export type TFuncionalHistoryControlMeasure = {
  __typename?: 'FuncionalHistoryControlMeasure';
  measure: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TFuncionalHistoryExam = {
  __typename?: 'FuncionalHistoryExam';
  description: Scalars['String']['output'];
  resultType: TResultTypeEnum;
};

export type TFuncionalHistoryExamTranslated = {
  __typename?: 'FuncionalHistoryExamTranslated';
  description: Scalars['String']['output'];
  resultType: Scalars['String']['output'];
};

export type TFuncionalHistoryInput = {
  costCenterId: Scalars['String']['input'];
  departmentId?: InputMaybe<Scalars['String']['input']>;
  occupationId: Scalars['String']['input'];
  personId: Scalars['String']['input'];
  positionId?: InputMaybe<Scalars['String']['input']>;
  realizationDate: Scalars['DateTime']['input'];
  sefip?: InputMaybe<Scalars['String']['input']>;
};

export type TFuncionalHistoryIpe = {
  __typename?: 'FuncionalHistoryIpe';
  description: Scalars['String']['output'];
  protection: TIpeProtection;
};

export type TFuncionalHistoryIpeTranslated = {
  __typename?: 'FuncionalHistoryIpeTranslated';
  description: Scalars['String']['output'];
  protection: Scalars['String']['output'];
};

export type TFuncionalHistoryOnPersonInput = {
  costCenterId: Scalars['String']['input'];
  departmentId?: InputMaybe<Scalars['String']['input']>;
  erpId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  occupationId: Scalars['String']['input'];
  positionId?: InputMaybe<Scalars['String']['input']>;
  realizationDate: Scalars['DateTime']['input'];
  sefip?: InputMaybe<Scalars['String']['input']>;
};

export type TFuncionalHistoryOnPersonUpdate = {
  toCreate: Array<TFuncionalHistoryOnPersonInput>;
  toRemove: Array<Scalars['DateTime']['input']>;
  toUpdate: Array<TFuncionalHistoryOnPersonInput>;
};

export type TFuncionalHistoryPpp = {
  branchId: Scalars['String']['input'];
  costCenterId: Scalars['String']['input'];
  departmentId: Scalars['String']['input'];
  occupationId: Scalars['String']['input'];
  personId: Scalars['String']['input'];
  positionId: Scalars['String']['input'];
  realizationDate: Scalars['DateTime']['input'];
  sefip?: InputMaybe<Scalars['String']['input']>;
};

export type TFuncionalHistoryRisk = {
  __typename?: 'FuncionalHistoryRisk';
  amount: Scalars['String']['output'];
  controlMeasure: Scalars['String']['output'];
  damageCaused: Scalars['String']['output'];
  description: Scalars['String']['output'];
  generatingSource: Scalars['String']['output'];
  id: Scalars['String']['output'];
  riskDegree: TRiskDegree;
  unitMeasurement: Scalars['String']['output'];
};

export type TFuncionalHistoryRiskTranslated = {
  __typename?: 'FuncionalHistoryRiskTranslated';
  agentField: Scalars['Boolean']['output'];
  amount: Scalars['String']['output'];
  colspan: Scalars['Float']['output'];
  controlMeasure: Scalars['String']['output'];
  controlMeasuresField: Scalars['Boolean']['output'];
  damageCaused: Scalars['String']['output'];
  description: Scalars['String']['output'];
  generatingSource: Scalars['String']['output'];
  generatingSourceField: Scalars['Boolean']['output'];
  healthDamageField: Scalars['Boolean']['output'];
  quantificationField: Scalars['Boolean']['output'];
  riskDegree: Scalars['String']['output'];
  riskDegreeField: Scalars['Boolean']['output'];
};

export type TFuncionalHistoryUpdate = {
  costCenterId?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  erpId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  occupationId?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['String']['input'];
  positionId?: InputMaybe<Scalars['String']['input']>;
  realizationDate?: InputMaybe<Scalars['DateTime']['input']>;
  sefip?: InputMaybe<Scalars['String']['input']>;
};

export type TFunctionsTask = {
  __typename?: 'FunctionsTask';
  /** Nome da tarefa */
  name: Scalars['String']['output'];
  /** Descrição do cargo */
  occupationDesc: Scalars['String']['output'];
  /** Descrição da tarefa */
  taskDesc: Scalars['String']['output'];
  /** Horas trabalhadas */
  workedHours: Scalars['String']['output'];
};

/** Gênero */
export enum TGender {
  /** Feminino */
  Female = 'Female',
  /** Masculino */
  Male = 'Male'
}

/** Gênero da pessoa */
export enum TGenderEnum {
  /** Homem cisgênero */
  Man = 'Man',
  /** Gênero não informado */
  NotInformed = 'NotInformed',
  /** Outro gênero */
  Other = 'Other',
  /** Homem transgênero */
  TransMan = 'TransMan',
  /** Mulher transgênero */
  TransWoman = 'TransWoman',
  /** Mulher cisgênero */
  Woman = 'Woman'
}

export type TGeneratePasswordInput = {
  /** Data de nascimento */
  birthday: Scalars['DateTime']['input'];
  /** CPF do funcionário */
  individualRegistration: Scalars['String']['input'];
  /** Tipo de operação */
  operation: TEmployeeOperationType;
  /** Identificador da organização */
  organizationId: Scalars['String']['input'];
  /** Senha */
  password: Scalars['String']['input'];
  /** Matrícula do funcionário */
  registration: Scalars['String']['input'];
};

export type TGeneratingSource = {
  __typename?: 'GeneratingSource';
  /** Identificador único da fonte geradora */
  id: Scalars['String']['output'];
  /** Indica se a fonte geradora está ativa */
  isActive: Scalars['Boolean']['output'];
  /** Nome da fonte geradora */
  name: Scalars['String']['output'];
  /** Imagem da fonte geradora */
  sourcePicture?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** URL para upload da imagem */
  uploadUrl?: Maybe<Scalars['String']['output']>;
};

export type TGeneratingSourceInput = {
  /** Tamanho do arquivo em bytes */
  contentLength?: InputMaybe<Scalars['Float']['input']>;
  /** Tipo de conteúdo da imagem */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Nome da fonte geradora */
  name: Scalars['String']['input'];
  /** Imagem da fonte geradora */
  sourcePicture?: InputMaybe<Scalars['S3UrlCloudFront']['input']>;
  /** URL para upload da imagem */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type TGeneratingSourceUpdate = {
  /** Novo tamanho do arquivo em bytes */
  contentLength?: InputMaybe<Scalars['Float']['input']>;
  /** Novo tipo de conteúdo da imagem */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da fonte geradora a atualizar */
  id: Scalars['String']['input'];
  /** Novo status de ativação */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Novo nome da fonte geradora */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Imagem da fonte geradora */
  sourcePicture?: InputMaybe<Scalars['S3UrlCloudFront']['input']>;
  /** URL para upload da imagem */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type TGenericAccidentCause = {
  __typename?: 'GenericAccidentCause';
  /** Tipo da causa do acidente */
  causeType: Scalars['String']['output'];
  /** Descrição da causa do acidente */
  description: Scalars['String']['output'];
  /** Identificador único da causa do acidente */
  id: Scalars['String']['output'];
};

export type TGenericActivePrinciple = {
  __typename?: 'GenericActivePrinciple';
  /** Descrição do princípio ativo */
  description: Scalars['String']['output'];
  /** Identificador único do princípio ativo */
  id: Scalars['String']['output'];
};

export type TGenericAgeRange = {
  __typename?: 'GenericAgeRange';
  /** Idade inicial */
  fromAge: Scalars['Float']['output'];
  /** Identificador único da faixa etária */
  id: Scalars['String']['output'];
  /** Identificador da periodicidade */
  periodicRangeId: Scalars['String']['output'];
  /** Periodicidade em meses */
  periodicity: Scalars['Float']['output'];
  /** Idade final */
  toAge: Scalars['Float']['output'];
};

export type TGenericBiologicalMonitoringExam = {
  __typename?: 'GenericBiologicalMonitoringExam';
  /** Exame associado */
  exam: TGenericExam;
  /** Grupo de exame biológico */
  group: TGenericBiologicalMonitoringExamGroup;
  /** Identificador único do exame biológico */
  id: Scalars['String']['output'];
  /** Intervalo para o segundo exame (em dias) */
  secondExamInterval: Scalars['Float']['output'];
  /** Intervalo para o terceiro exame (em dias) */
  thirdExamInterval: Scalars['Float']['output'];
};

export type TGenericBiologicalMonitoringExamGroup = {
  __typename?: 'GenericBiologicalMonitoringExamGroup';
  /** Exames biológicos do grupo */
  biologicalExams?: Maybe<Array<TGenericBiologicalMonitoringExam>>;
  /** Descrição do grupo de exame */
  description: Scalars['String']['output'];
  /** Identificador único do grupo de exame */
  id: Scalars['String']['output'];
};

export type TGenericCostCenter = {
  __typename?: 'GenericCostCenter';
  /** Classificação do centro de custo */
  classCostCenter?: Maybe<Scalars['String']['output']>;
  /** Descrição do centro de custo */
  description: Scalars['String']['output'];
  /** Identificador único do centro de custo */
  id: Scalars['String']['output'];
};

export type TGenericExam = {
  __typename?: 'GenericExam';
  /** Descrição do exame */
  description: Scalars['String']['output'];
  /** Procedimento de exame */
  examinationProcedure?: Maybe<TGenericExaminationProcedure>;
  /** Indicador biológico de monitoramento populacional */
  ibmp?: Maybe<TGenericExamIbmp>;
  /** Identificador único do exame */
  id: Scalars['String']['output'];
  /** Tipo de resultado do exame */
  resultType: TResultTypeEnum;
  /** Sugestão de uso */
  suggestion: Scalars['String']['output'];
};

export type TGenericExamIbmp = {
  __typename?: 'GenericExamIbmp';
  /** Material biológico */
  biologicalMaterial: TBiologicalMaterial;
  /** Unidade de medida do exame */
  examMeasure: TExamMeasure;
  /** Identificador único do exame IBMP */
  id: Scalars['String']['output'];
  /** Valor máximo permitido */
  maximumAllowed: Scalars['Float']['output'];
  /** Valor de referência */
  reference: Scalars['Float']['output'];
  /** Agente de risco associado */
  riskAgent: TGenericRiskAgent;
};

export type TGenericExaminationProcedure = {
  __typename?: 'GenericExaminationProcedure';
  /** Descrição do procedimento de exame */
  description: Scalars['String']['output'];
  /** Código eSocial */
  eSocialCode: Scalars['String']['output'];
  /** Identificador único do procedimento de exame */
  id: Scalars['String']['output'];
};

export type TGenericExpense = {
  __typename?: 'GenericExpense';
  /** Descrição da despesa */
  description: Scalars['String']['output'];
  /** Identificador único da despesa */
  id: Scalars['String']['output'];
  /** Incidência da despesa */
  incidence: Scalars['String']['output'];
  /** Tipo da despesa */
  type: Scalars['String']['output'];
};

export type TGenericHealthProgram = {
  __typename?: 'GenericHealthProgram';
  /** Descrição do programa de saúde */
  description: Scalars['String']['output'];
  /** Identificador único do programa de saúde */
  id: Scalars['String']['output'];
  /** Nome do programa de saúde */
  name: Scalars['String']['output'];
  /** Tipo de programa */
  programType: TProgramType;
};

export type TGenericLaboratory = {
  __typename?: 'GenericLaboratory';
  /** Descrição do laboratório */
  description: Scalars['String']['output'];
  /** Identificador único do laboratório */
  id: Scalars['String']['output'];
};

export type TGenericMeasuringInstrument = {
  __typename?: 'GenericMeasuringInstrument';
  /** Descrição do instrumento de medição */
  description: Scalars['String']['output'];
  /** Identificador único do instrumento de medição */
  id: Scalars['String']['output'];
};

export type TGenericMedicine = {
  __typename?: 'GenericMedicine';
  /** Princípio ativo do medicamento */
  activePrinciple: TGenericActivePrinciple;
  /** Indica se é medicamento ambulatorial */
  ambulatoryMedicine: Scalars['Boolean']['output'];
  /** Descrição do medicamento */
  description: Scalars['String']['output'];
  /** Identificador único do medicamento */
  id: Scalars['String']['output'];
  /** Classificação do medicamento */
  label: TMedicineLabelEnum;
  /** Laboratório fabricante */
  laboratory: TGenericLaboratory;
  /** Apresentação do medicamento */
  presentation: Scalars['String']['output'];
  /** Sugestão de uso */
  suggestion?: Maybe<Scalars['String']['output']>;
};

export type TGenericMetadata = {
  __typename?: 'GenericMetadata';
  /** ID do metadado genérico */
  id: Scalars['String']['output'];
  /** Nome do metadado */
  name: Scalars['String']['output'];
  /** Tipo do metadado */
  type: TMetadataType;
};

export type TGenericOccupation = {
  __typename?: 'GenericOccupation';
  /** Código CBO (Classificação Brasileira de Ocupações) */
  cbo: Scalars['String']['output'];
  /** Descrição da ocupação */
  description: Scalars['String']['output'];
  /** Identificador único da ocupação */
  id: Scalars['String']['output'];
  /** Sugestão de uso */
  suggestion: Scalars['String']['output'];
};

export type TGenericPeriodicRange = {
  __typename?: 'GenericPeriodicRange';
  /** Descrição da periodicidade */
  description: Scalars['String']['output'];
  /** Gênero aplicável */
  gender: TPeriodicRangeGenderEnum;
  /** Faixas etárias */
  genericAgeRanges: Array<TGenericAgeRange>;
  /** Identificador único da periodicidade */
  id: Scalars['String']['output'];
};

export type TGenericPublicPlace = {
  __typename?: 'GenericPublicPlace';
  /** Descrição do logradouro */
  description: Scalars['String']['output'];
  /** Código eSocial */
  eSocialCode: Scalars['String']['output'];
  /** Identificador único do logradouro */
  id: Scalars['String']['output'];
};

export type TGenericQuestionGroup = {
  __typename?: 'GenericQuestionGroup';
  /** Descrição do grupo de questões */
  description: Scalars['String']['output'];
  /** Questões do grupo */
  genericQuestionsQuiz: Array<TGenericQuestionQuiz>;
  /** Identificador único do grupo de questões */
  id: Scalars['String']['output'];
};

export type TGenericQuestionQuiz = {
  __typename?: 'GenericQuestionQuiz';
  /** Opção padrão selecionada */
  defaultOption?: Maybe<Scalars['String']['output']>;
  /** Descrição da questão */
  description: Scalars['String']['output'];
  /** Gênero aplicável */
  gender: TQuestionGenderEnum;
  /** Opções de resposta */
  genericResponseOptions: Array<TGenericResponseOption>;
  /** Indica se possui campo de detalhes */
  hasDetails: Scalars['Boolean']['output'];
  /** Identificador único da questão */
  id: Scalars['String']['output'];
  /** Ordem de exibição */
  order: Scalars['Float']['output'];
  /** Tipo de resposta */
  responseType: TResponseType;
};

export type TGenericQuiz = {
  __typename?: 'GenericQuiz';
  /** Descrição do questionário */
  description: Scalars['String']['output'];
  /** Grupos de questões do questionário */
  genericQuestionsGroup: Array<TGenericQuestionGroup>;
  /** Identificador único do questionário */
  id: Scalars['String']['output'];
};

export type TGenericReportSection = {
  __typename?: 'GenericReportSection';
  /** Indica se quebra página */
  breakPage: Scalars['Boolean']['output'];
  /** Conteúdo da seção */
  content?: Maybe<Scalars['String']['output']>;
  /** Descrição da seção */
  description: Scalars['String']['output'];
  /** Identificador único da seção do relatório */
  id: Scalars['String']['output'];
  /** Ordem de exibição */
  order: Scalars['Float']['output'];
  /** Orientação da página */
  pageOrientation: TPageOrientation;
  /** Identificador da estrutura do relatório */
  reportStructureId: Scalars['String']['output'];
  /** Atalho associado */
  shortcut?: Maybe<TShortcut>;
  /** Tipo da seção */
  type: TReportSectionType;
};

export type TGenericReportStructure = {
  __typename?: 'GenericReportStructure';
  /** Descrição da estrutura */
  description: Scalars['String']['output'];
  /** Identificador único da estrutura do relatório */
  id: Scalars['String']['output'];
  /** Indica se a estrutura está ativa */
  isActive: Scalars['Boolean']['output'];
  /** Seções do relatório */
  sections?: Maybe<Array<TGenericReportSection>>;
  /** Tipo de relatório */
  type: TReportType;
};

export type TGenericResponseOption = {
  __typename?: 'GenericResponseOption';
  /** Descrição da opção de resposta */
  description: Scalars['String']['output'];
  /** Identificador único da opção de resposta */
  id: Scalars['String']['output'];
};

export type TGenericRiskAgent = {
  __typename?: 'GenericRiskAgent';
  /** Descrição do agente de risco */
  description: Scalars['String']['output'];
  /** Código eSocial */
  eSocialCode?: Maybe<Scalars['String']['output']>;
  /** Grupo do agente de risco */
  group: TAgentGroup;
  /** Identificador único do agente de risco */
  id: Scalars['String']['output'];
};

export type TGenericRolePermission = {
  __typename?: 'GenericRolePermission';
  /** Descrição da permissão de função */
  description: Scalars['String']['output'];
  /** Identificador único da permissão de função */
  id: Scalars['String']['output'];
  /** Lista de permissões */
  permission: Array<TPermission>;
};

export type TGenericStatementResponsibility = {
  __typename?: 'GenericStatementResponsibility';
  /** Descrição do termo */
  description: Scalars['String']['output'];
  /** Identificador único do termo de responsabilidade */
  id: Scalars['String']['output'];
  /** Texto do termo de responsabilidade */
  statement: Scalars['String']['output'];
};

export type TGenericTask = {
  __typename?: 'GenericTask';
  /** Descrição da tarefa */
  description: Scalars['String']['output'];
  /** Código eSocial */
  eSocialCode: Scalars['String']['output'];
  /** Identificador único da tarefa */
  id: Scalars['String']['output'];
  /** Nome da tarefa */
  name: Scalars['String']['output'];
};

export type TGenericTraining = {
  __typename?: 'GenericTraining';
  /** Descrição do treinamento */
  description: Scalars['String']['output'];
  /** Código eSocial */
  eSocialCode: Scalars['String']['output'];
  /** Identificador único do treinamento */
  id: Scalars['String']['output'];
};

export type TGenericVaccine = {
  __typename?: 'GenericVaccine';
  /** Descrição da vacina */
  description: Scalars['String']['output'];
  /** Gênero aplicável */
  gender: TVaccineGenderEnum;
  /** Identificador único da vacina */
  id: Scalars['String']['output'];
};

export type TGenericWorkShift = {
  __typename?: 'GenericWorkShift';
  /** Descrição do turno de trabalho */
  description: Scalars['String']['output'];
  /** Identificador único do turno de trabalho */
  id: Scalars['String']['output'];
  /** Horas produtivas */
  productiveHours?: Maybe<Scalars['Float']['output']>;
};

export type TGetAllSaasMetadataInput = {
  /** Tipo de ERP */
  erpType: TErpType;
  /** Grupo */
  group?: InputMaybe<Scalars['String']['input']>;
  /** Nome do card de integração */
  integrationCardName?: InputMaybe<Scalars['String']['input']>;
  /** Contexto de integração */
  integrationContext?: InputMaybe<TIntegrationContext>;
};

export type TGetDocumentsInput = {
  pagination: TPaginationInput;
  params?: InputMaybe<TGetDocumentsParamsInput>;
};

/** Campos pelos quais os documentos podem ser ordenados */
export enum TGetDocumentsOrderByField {
  CreatedAt = 'CreatedAt',
  Status = 'Status'
}

export type TGetDocumentsOrderByInput = {
  /** Campo para ordenação */
  field?: InputMaybe<TGetDocumentsOrderByField>;
  /** Tipo de ordenação */
  type?: InputMaybe<TOrderBy>;
};

export type TGetDocumentsParamsInput = {
  creationDateEnd?: InputMaybe<Scalars['String']['input']>;
  creationDateStart?: InputMaybe<Scalars['String']['input']>;
  /** Status do documento */
  documentStatus?: InputMaybe<TDocumentStatus>;
  email?: InputMaybe<Scalars['String']['input']>;
  expirationDateEnd?: InputMaybe<Scalars['String']['input']>;
  expirationDateStart?: InputMaybe<Scalars['String']['input']>;
  movementDateEnd?: InputMaybe<Scalars['String']['input']>;
  movementDateStart?: InputMaybe<Scalars['String']['input']>;
  /** Buscar em toda a empresa? Padrão: false (apenas documentos do médico) */
  searchInEntireCompany?: InputMaybe<Scalars['Boolean']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type TGetDocumentsQueryInput = {
  /** Data de criação inicial para filtro (YYYY-MM-DD) */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  /** Data de criação final para filtro (YYYY-MM-DD) */
  finishedAt?: InputMaybe<Scalars['String']['input']>;
  /** Retornar apenas registros com esse nome */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Retornar apenas registros com esse status */
  status?: InputMaybe<Array<TDocumentStatus>>;
};

export type TGetFields = {
  /** Tipo de ERP */
  erpType: TErpType;
  /** Indica se é genérico */
  isGeneric?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID do metadado */
  metadataId: Scalars['String']['input'];
};

/** Níveis de glicose */
export enum TGlycolysisEnum {
  /** 500 (30) */
  FiveHundred = 'FiveHundred',
  /** Negativo */
  Negative = 'Negative',
  /** 100 (5) */
  OneHundred = 'OneHundred',
  /** 1000 (60) */
  OneThousand = 'OneThousand',
  /** 250 (15) */
  TwoHundredFifty = 'TwoHundredFifty',
  /** 2000 (110) */
  TwoThousand = 'TwoThousand'
}

export type TGroupAnalysis = {
  __typename?: 'GroupAnalysis';
  /** Análise */
  analysis?: Maybe<Array<TAnalysis>>;
  /** Descrição */
  description: Scalars['String']['output'];
  /** Medida do exame */
  examMeasure?: Maybe<TExamMeasure>;
  /** Tem porcentagem */
  hasPercent: Scalars['Boolean']['output'];
  /** Identificador */
  id: Scalars['String']['output'];
};

export type TGroupAnalysisInput = {
  /** Análises do grupo */
  analysis?: InputMaybe<Array<TAnalysisInput>>;
  /** Descrição */
  description: Scalars['String']['input'];
  /** Medida do exame */
  examMeasure?: InputMaybe<TExamMeasure>;
  /** Indica se possui porcentagem */
  hasPercent: Scalars['Boolean']['input'];
};

export type TGroupAnalysisUpdate = {
  /** Análises do grupo */
  analysis?: InputMaybe<Array<TAnalysisUpdate>>;
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Medida do exame */
  examMeasure?: InputMaybe<TExamMeasure>;
  /** Indica se possui porcentagem */
  hasPercent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador */
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Cor do cabelo */
export enum THairColor {
  /** Preto */
  Black = 'black',
  /** Loiro */
  Blond = 'blond',
  /** Castanho */
  Brown = 'brown',
  /** Grisalho */
  Gray = 'gray',
  /** Multicolorido */
  Multicolour = 'multicolour',
  /** Outro */
  Other = 'other',
  /** Ruivo */
  Redhead = 'redhead',
  /** Branco */
  White = 'white'
}

export type THasFinishedExam = {
  __typename?: 'HasFinishedExam';
  hasAtLeastOne: Scalars['Boolean']['output'];
};

/** Possui RBC */
export enum THasRbc {
  /** Não */
  No = 'no',
  /** Não se aplica */
  NotApplicable = 'notApplicable',
  /** Sim */
  Yes = 'yes'
}

export type THealthProgram = {
  __typename?: 'HealthProgram';
  /** Descrição do programa de saúde */
  description: Scalars['String']['output'];
  /** Exames vinculados ao programa de saúde */
  exams?: Maybe<Array<TExamByHealthProgram>>;
  /** Grupo de exposição vinculado ao programa */
  exposureGroup?: Maybe<TExposureGroup>;
  /** Identificador do grupo de exposição */
  exposureGroupId?: Maybe<Scalars['String']['output']>;
  /** Identificador único do programa de saúde */
  id: Scalars['String']['output'];
  /** Indica se o programa de saúde está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Nome do programa de saúde */
  name: Scalars['String']['output'];
  /** Cargos vinculados ao programa de saúde */
  occupations?: Maybe<Array<THealthProgramOccupation>>;
  /** Tipo do programa */
  programType: TProgramType;
  /** Identificador de referência */
  referenceId?: Maybe<Scalars['String']['output']>;
  /** Treinamentos vinculados ao programa de saúde */
  trainings?: Maybe<Array<THealthProgramTraining>>;
};

export type THealthProgramChart = {
  __typename?: 'HealthProgramChart';
  /** Dados */
  data: Array<TData>;
  /** Possui programas de saúde */
  hasHealthPrograms: Scalars['Boolean']['output'];
};

export type THealthProgramInput = {
  /** Descrição do programa de saúde */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Exames a vincular ao programa de saúde */
  exams?: InputMaybe<Array<TExamByHealthProgramInput>>;
  /** Identificador do grupo de exposição */
  exposureGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Nome do programa de saúde */
  name: Scalars['String']['input'];
  /** Cargos a vincular ao programa de saúde */
  occupations?: InputMaybe<Array<THealthProgramOccupationInput>>;
  /** Tipo do programa */
  programType: TProgramType;
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Treinamentos a vincular ao programa de saúde */
  trainings?: InputMaybe<Array<THealthProgramTrainingInput>>;
};

export type THealthProgramOccupation = {
  __typename?: 'HealthProgramOccupation';
  /** Programa de saúde associado */
  healthProgram: THealthProgram;
  /** Identificador único do cargo no programa de saúde */
  id: Scalars['String']['output'];
  /** Cargo vinculado */
  occupation: TOccupation;
};

export type THealthProgramOccupationInput = {
  /** Identificador do cargo a vincular */
  occupationId: Scalars['String']['input'];
};

export type THealthProgramTraining = {
  __typename?: 'HealthProgramTraining';
  /** Erro de integração, se houver */
  errorIntegration?: Maybe<Scalars['String']['output']>;
  /** Programa de saúde associado */
  healthProgram: THealthProgram;
  /** Identificador único do treinamento no programa */
  id: Scalars['String']['output'];
  /** Treinamento vinculado */
  training: TTraining;
  /** Urgência do treinamento */
  urgency: TTrainingUrgency;
};

export type THealthProgramTrainingChanges = {
  /** Treinamentos a adicionar ao programa de saúde */
  toCreate: Array<THealthProgramTrainingInput>;
  /** Identificadores dos treinamentos a remover do programa */
  toRemove: Array<Scalars['String']['input']>;
};

export type THealthProgramTrainingInput = {
  /** Identificador do programa de saúde */
  healthProgramId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do treinamento a vincular */
  trainingId: Scalars['String']['input'];
  /** Urgência do treinamento */
  urgency: TTrainingUrgency;
};

export type THealthProgramUpdate = {
  /** Nova descrição do programa de saúde */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Alterações nos exames vinculados ao programa */
  exams?: InputMaybe<TExamByHealthProgramChanges>;
  /** Novo identificador do grupo de exposição */
  exposureGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do programa de saúde a atualizar */
  id: Scalars['String']['input'];
  /** Novo status de ativação */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Novo nome do programa de saúde */
  name: Scalars['String']['input'];
  /** Novos cargos a vincular ao programa de saúde */
  occupations?: InputMaybe<Array<THealthProgramOccupationInput>>;
  /** Novo tipo do programa */
  programType?: InputMaybe<TProgramType>;
  /** Novo identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Alterações nos treinamentos vinculados ao programa */
  trainings?: InputMaybe<THealthProgramTrainingChanges>;
};

export type THealthQuizzes = {
  __typename?: 'HealthQuizzes';
  count: Scalars['Float']['output'];
};

export type THidraulicInspectionReport = {
  __typename?: 'HidraulicInspectionReport';
  /** Endereço da empresa */
  address: Scalars['String']['output'];
  /** CNPJ da empresa */
  cnpj: Scalars['String']['output'];
  /** Nome da empresa */
  companyName: Scalars['String']['output'];
  /** Campos de tradução do relatório */
  fields: THidraulicInspectionReportFields;
  /** Rodapé do relatório */
  footer: Scalars['String']['output'];
  /** Nome do sistema hidráulico */
  hidraulicSystem: Scalars['String']['output'];
  /** Indica se mangueiras foram inspecionadas */
  hoses: Scalars['Boolean']['output'];
  /** Local da inspeção */
  local: Scalars['String']['output'];
  /** Data planejada formatada */
  plannedDate: Scalars['String']['output'];
  /** Data real formatada */
  realDate: Scalars['String']['output'];
  /** Indica se registro foi inspecionado */
  record: Scalars['Boolean']['output'];
  /** Nome do responsável */
  responsible: Scalars['String']['output'];
  /** Indica se abrigo foi inspecionado */
  shelter: Scalars['Boolean']['output'];
  /** Indica se sinalização foi inspecionada */
  signaling: Scalars['Boolean']['output'];
  /** Situação da inspeção */
  situation: Scalars['String']['output'];
  /** Indica se esguichos foram inspecionados */
  squirts: Scalars['Boolean']['output'];
  /** Indica se chave storz foi inspecionada */
  storzkey: Scalars['Boolean']['output'];
  /** Indica se há itens diversos */
  sundry: Scalars['Boolean']['output'];
  /** Telefone da empresa */
  telephone: Scalars['String']['output'];
};

export type THidraulicInspectionReportFields = {
  __typename?: 'HidraulicInspectionReportFields';
  /** Nome do campo atividades */
  activities: Scalars['String']['output'];
  /** Nome do campo simulacro utilizado */
  drillUsed: Scalars['String']['output'];
  /** Nome do campo fogo utilizado */
  fireUsed: Scalars['String']['output'];
  /** Nome do campo sistema hidráulico */
  hidraulicSystem: Scalars['String']['output'];
  /** Nome do campo mangueiras */
  hoses: Scalars['String']['output'];
  /** Nome do campo local */
  local: Scalars['String']['output'];
  /** Texto para resposta negativa */
  no: Scalars['String']['output'];
  /** Nome do campo data planejada */
  plannedDate: Scalars['String']['output'];
  /** Nome do campo data real */
  realDate: Scalars['String']['output'];
  /** Nome do campo registro */
  record: Scalars['String']['output'];
  /** Nome do campo responsável */
  responsible: Scalars['String']['output'];
  /** Nome do campo abrigo */
  shelter: Scalars['String']['output'];
  /** Nome do campo sinalização */
  signaling: Scalars['String']['output'];
  /** Nome do campo situação */
  situation: Scalars['String']['output'];
  /** Nome do campo esguichos */
  squirts: Scalars['String']['output'];
  /** Nome do campo chave storz */
  storzkey: Scalars['String']['output'];
  /** Nome do campo diversos */
  sundry: Scalars['String']['output'];
  /** Texto para resposta afirmativa */
  yes: Scalars['String']['output'];
};

export type THidraulicSystemInspection = {
  __typename?: 'HidraulicSystemInspection';
  /** Indica se o simulacro foi utilizado */
  drillUsed: Scalars['Boolean']['output'];
  /** Sistema de extinção inspecionado */
  extinguishingSystem: TExtinguishingSystem;
  /** Indica se o fogo foi utilizado */
  fireUsed: Scalars['Boolean']['output'];
  /** Indica se as mangueiras foram inspecionadas */
  hoses: Scalars['Boolean']['output'];
  /** Identificador único da inspeção */
  id: Scalars['String']['output'];
  /** Observações sobre a inspeção */
  observation?: Maybe<Scalars['String']['output']>;
  /** Data planejada da inspeção */
  plannedDate: Scalars['DateTime']['output'];
  /** Data real da inspeção */
  realDate?: Maybe<Scalars['DateTime']['output']>;
  /** Indica se o registro foi inspecionado */
  record: Scalars['Boolean']['output'];
  /** Responsável pela inspeção */
  responsible: TPerson;
  /** Indica se o abrigo foi inspecionado */
  shelter: Scalars['Boolean']['output'];
  /** Indica se a sinalização foi inspecionada */
  signaling: Scalars['Boolean']['output'];
  /** Situação da inspeção */
  situation: TInspectionSituation;
  /** Indica se os esguichos foram inspecionados */
  squirts: Scalars['Boolean']['output'];
  /** Indica se a chave storz foi inspecionada */
  storzkey: Scalars['Boolean']['output'];
  /** Indica se há itens diversos */
  sundry: Scalars['Boolean']['output'];
};

export type THidraulicSystemInspectionInput = {
  /** Indica se o simulacro foi utilizado */
  drillUsed: Scalars['Boolean']['input'];
  /** Identificador do sistema de extinção */
  extinguishingSystemId: Scalars['String']['input'];
  /** Indica se o fogo foi utilizado */
  fireUsed: Scalars['Boolean']['input'];
  /** Indica se as mangueiras foram inspecionadas */
  hoses: Scalars['Boolean']['input'];
  /** Observações sobre a inspeção */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Data planejada da inspeção */
  plannedDate: Scalars['DateTime']['input'];
  /** Data real da inspeção */
  realDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Indica se o registro foi inspecionado */
  record: Scalars['Boolean']['input'];
  /** Identificador do responsável pela inspeção */
  responsibleId: Scalars['String']['input'];
  /** Indica se o abrigo foi inspecionado */
  shelter: Scalars['Boolean']['input'];
  /** Indica se a sinalização foi inspecionada */
  signaling: Scalars['Boolean']['input'];
  /** Situação da inspeção */
  situation: TInspectionSituation;
  /** Indica se os esguichos foram inspecionados */
  squirts: Scalars['Boolean']['input'];
  /** Indica se a chave storz foi inspecionada */
  storzkey: Scalars['Boolean']['input'];
  /** Indica se há itens diversos */
  sundry: Scalars['Boolean']['input'];
};

export type THistoric = {
  __typename?: 'Historic';
  /** Histórico de consultas médicas */
  medicalConsultations?: Maybe<Array<TMedicalConsultation>>;
  /** Histórico de atestados */
  sickNotes?: Maybe<Array<TSickNote>>;
};

export type THistoricData = {
  __typename?: 'HistoricData';
  /** Centro de custo */
  costCenter: Scalars['String']['output'];
  /** Quantidade entregue */
  deliveryAmount: Scalars['String']['output'];
  /** Motivo da entrega */
  deliveryReason: Scalars['String']['output'];
  /** Descrição do IPE */
  ipeDescription: Scalars['String']['output'];
  /** Nome da pessoa */
  person: Scalars['String']['output'];
  /** Matrícula do funcionário */
  registration: Scalars['String']['output'];
};

export type TIcd = {
  __typename?: 'Icd';
  /** Tipo de classificação CID */
  classType?: Maybe<TClassIcdType>;
  /** Código do CID */
  code: Scalars['String']['output'];
  /** Indica se é causa de morte */
  deathCause: Scalars['Boolean']['output'];
  /** Descrição do CID */
  description: Scalars['String']['output'];
  /** Gênero relacionado */
  gender?: Maybe<Scalars['String']['output']>;
  /** Grupo CID */
  icdGroupRef: TIcdGroup;
  /** Identificador único do CID */
  id: Scalars['String']['output'];
  /** Sugestão de uso */
  suggestion?: Maybe<Scalars['String']['output']>;
};

export type TIcdGroup = {
  __typename?: 'IcdGroup';
  /** Tipo de classificação CID */
  classType?: Maybe<TClassIcdType>;
  /** Código do grupo CID */
  code: Scalars['String']['output'];
  /** Descrição do grupo CID */
  description: Scalars['String']['output'];
  /** Identificador único do grupo CID */
  id: Scalars['String']['output'];
  /** Sugestão de uso */
  suggestion?: Maybe<Scalars['String']['output']>;
};

/** Tipo de identificação do destinatário */
export enum TIdentificationType {
  Brazil = 'Brazil',
  InternationalId = 'InternationalId',
  None = 'None'
}

export type TImcChart = {
  __typename?: 'ImcChart';
  /** Dados */
  data: Array<Scalars['Float']['output']>;
  /** Nome */
  name: Scalars['String']['output'];
};

export type TImportStatus = {
  __typename?: 'ImportStatus';
  /** Erros do CSV */
  errorsCsv?: Maybe<Scalars['String']['output']>;
  /** ID do processo de importação */
  importId: Scalars['String']['output'];
  /** Número de linhas processadas */
  processedLines: Scalars['Float']['output'];
  /** Status da importação */
  status: TImporterStatus;
  /** Número total de linhas do arquivo */
  totalLines: Scalars['Float']['output'];
};

/** Status de importação */
export enum TImporterStatus {
  /** Importação concluída com sucesso */
  Completed = 'completed',
  /** Importação concluída com erros */
  CompletedWithErrors = 'completedWithErrors',
  /** Importação falhou */
  Failed = 'failed',
  /** Importação em processamento */
  Processing = 'processing'
}

/** Tipos de importação */
export enum TImporterType {
  /** Credenciado */
  Accredited = 'accredited',
  /** Atestado Médico */
  Certificate = 'certificate',
  /** Questionário Clínico */
  ClinicalQuiz = 'clinicalQuiz',
  /** Deficiência */
  Deficiency = 'deficiency',
  /** Prontuário Médico */
  MedicalRecord = 'medicalRecord',
  /** Certificado Ocupacional */
  OccupationalCertificate = 'occupationalCertificate',
  /** Questionário */
  Quiz = 'quiz',
  /** Riscos */
  Risk = 'risk',
  /** Vacinas */
  Vaccine = 'vaccine'
}

/** Incidência da despesa */
export enum TIncidenceExpense {
  /** Despesa direta */
  Direct = 'Direct',
  /** Despesa indireta */
  Indirect = 'Indirect'
}

export type TIndexChart = {
  __typename?: 'IndexChart';
  /** Dados */
  data: Array<TData>;
  /** Indica se há acidentes registrados */
  hasAccident: Scalars['Boolean']['output'];
  /** Total de registros */
  total?: Maybe<Scalars['Float']['output']>;
};

/** Indicação de vacinação */
export enum TIndication {
  /** Empresa */
  Company = 'company',
  /** Funcionários */
  Employees = 'employees'
}

export type TIndicator = {
  __typename?: 'Indicator';
  indicator: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type TInjuryNature = {
  __typename?: 'InjuryNature';
  /** Descrição da natureza da lesão */
  description: Scalars['String']['output'];
  /** Código eSocial */
  eSocialCode: Scalars['String']['output'];
  /** Identificador único da natureza da lesão */
  id: Scalars['String']['output'];
};

export type TInputData = {
  __typename?: 'InputData';
  /** ID */
  id: Scalars['String']['output'];
  /** Nome */
  name: Scalars['String']['output'];
};

export type TInputTaskOnTask = {
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Indica se está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Nome */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Nome do tipo */
  typename?: InputMaybe<Scalars['String']['input']>;
};

export type TInputUserCheck = {
  confirmationCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type TInputUserReplacePassword = {
  currentPassword: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type TInspectionOnExtinguishingSystem = {
  __typename?: 'InspectionOnExtinguishingSystem';
  attachments?: Maybe<Array<TAttachment>>;
  completeValve: Scalars['Boolean']['output'];
  cylindricalValve: Scalars['Boolean']['output'];
  diffuserReplacement: Scalars['Boolean']['output'];
  drillUsed: Scalars['Boolean']['output'];
  fireUsed: Scalars['Boolean']['output'];
  hose: Scalars['Boolean']['output'];
  hydrostaticTest: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  monometer: Scalars['Boolean']['output'];
  observation?: Maybe<Scalars['String']['output']>;
  painting: Scalars['Boolean']['output'];
  plannedDate: Scalars['DateTime']['output'];
  realDate?: Maybe<Scalars['DateTime']['output']>;
  realoaded: Scalars['Boolean']['output'];
  reloadDate?: Maybe<Scalars['DateTime']['output']>;
  responsible: TPerson;
  safetyValve: Scalars['Boolean']['output'];
  situation: TInspectionSituation;
  sundry: Scalars['Boolean']['output'];
  triggerReplacement: Scalars['Boolean']['output'];
};

export type TInspectionOnExtinguishingSystemChanges = {
  toCreate: Array<TInspectionOnExtinguishingSystemInput>;
  toRemove: Array<Scalars['String']['input']>;
  toUpdate: Array<TInspectionOnExtinguishingSystemUpdate>;
};

export type TInspectionOnExtinguishingSystemInput = {
  completeValve: Scalars['Boolean']['input'];
  cylindricalValve: Scalars['Boolean']['input'];
  diffuserReplacement: Scalars['Boolean']['input'];
  drillUsed: Scalars['Boolean']['input'];
  fireUsed: Scalars['Boolean']['input'];
  hose: Scalars['Boolean']['input'];
  hydrostaticTest: Scalars['Boolean']['input'];
  monometer: Scalars['Boolean']['input'];
  observation?: InputMaybe<Scalars['String']['input']>;
  painting: Scalars['Boolean']['input'];
  plannedDate: Scalars['DateTime']['input'];
  realDate?: InputMaybe<Scalars['DateTime']['input']>;
  realoaded: Scalars['Boolean']['input'];
  reloadDate?: InputMaybe<Scalars['DateTime']['input']>;
  responsibleId: Scalars['String']['input'];
  safetyValve: Scalars['Boolean']['input'];
  situation: TInspectionSituation;
  sundry: Scalars['Boolean']['input'];
  triggerReplacement: Scalars['Boolean']['input'];
};

export type TInspectionOnExtinguishingSystemUpdate = {
  completeValve: Scalars['Boolean']['input'];
  cylindricalValve: Scalars['Boolean']['input'];
  diffuserReplacement: Scalars['Boolean']['input'];
  drillUsed: Scalars['Boolean']['input'];
  fireUsed: Scalars['Boolean']['input'];
  hose: Scalars['Boolean']['input'];
  hydrostaticTest: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  monometer: Scalars['Boolean']['input'];
  observation?: InputMaybe<Scalars['String']['input']>;
  painting: Scalars['Boolean']['input'];
  plannedDate: Scalars['DateTime']['input'];
  realDate?: InputMaybe<Scalars['DateTime']['input']>;
  realoaded: Scalars['Boolean']['input'];
  reloadDate?: InputMaybe<Scalars['DateTime']['input']>;
  responsibleId: Scalars['String']['input'];
  safetyValve: Scalars['Boolean']['input'];
  situation: TInspectionSituation;
  sundry: Scalars['Boolean']['input'];
  triggerReplacement: Scalars['Boolean']['input'];
};

export type TInspectionOnHidraulicSystem = {
  __typename?: 'InspectionOnHidraulicSystem';
  /** Indica se o simulacro foi utilizado */
  drillUsed: Scalars['Boolean']['output'];
  /** Indica se o fogo foi utilizado */
  fireUsed: Scalars['Boolean']['output'];
  /** Indica se as mangueiras foram inspecionadas */
  hoses: Scalars['Boolean']['output'];
  /** Identificador único da inspeção */
  id: Scalars['String']['output'];
  /** Observações sobre a inspeção */
  observation?: Maybe<Scalars['String']['output']>;
  /** Data planejada da inspeção */
  plannedDate: Scalars['DateTime']['output'];
  /** Data real da inspeção */
  realDate?: Maybe<Scalars['DateTime']['output']>;
  /** Indica se o registro foi inspecionado */
  record: Scalars['Boolean']['output'];
  /** Responsável pela inspeção */
  responsible: TPerson;
  /** Indica se o abrigo foi inspecionado */
  shelter: Scalars['Boolean']['output'];
  /** Indica se a sinalização foi inspecionada */
  signaling: Scalars['Boolean']['output'];
  /** Situação da inspeção */
  situation: TInspectionSituation;
  /** Indica se os esguichos foram inspecionados */
  squirts: Scalars['Boolean']['output'];
  /** Indica se a chave storz foi inspecionada */
  storzkey: Scalars['Boolean']['output'];
  /** Indica se há itens diversos */
  sundry: Scalars['Boolean']['output'];
};

export type TInspectionOnHidraulicSystemChanges = {
  /** Inspeções a criar no sistema hidráulico */
  toCreate: Array<TInspectionOnHidraulicSystemInput>;
  /** Identificadores das inspeções a remover */
  toRemove: Array<Scalars['String']['input']>;
  /** Inspeções do sistema hidráulico a atualizar */
  toUpdate: Array<TInspectionOnHidraulicSystemUpdate>;
};

export type TInspectionOnHidraulicSystemInput = {
  /** Indica se o simulacro foi utilizado */
  drillUsed: Scalars['Boolean']['input'];
  /** Indica se o fogo foi utilizado */
  fireUsed: Scalars['Boolean']['input'];
  /** Indica se as mangueiras foram inspecionadas */
  hoses: Scalars['Boolean']['input'];
  /** Observações sobre a inspeção */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Data planejada da inspeção */
  plannedDate: Scalars['DateTime']['input'];
  /** Data real da inspeção */
  realDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Indica se o registro foi inspecionado */
  record: Scalars['Boolean']['input'];
  /** Identificador do responsável pela inspeção */
  responsibleId: Scalars['String']['input'];
  /** Indica se o abrigo foi inspecionado */
  shelter: Scalars['Boolean']['input'];
  /** Indica se a sinalização foi inspecionada */
  signaling: Scalars['Boolean']['input'];
  /** Situação da inspeção */
  situation: TInspectionSituation;
  /** Indica se os esguichos foram inspecionados */
  squirts: Scalars['Boolean']['input'];
  /** Indica se a chave storz foi inspecionada */
  storzkey: Scalars['Boolean']['input'];
  /** Indica se há itens diversos */
  sundry: Scalars['Boolean']['input'];
};

export type TInspectionOnHidraulicSystemUpdate = {
  /** Indica se o simulacro foi utilizado */
  drillUsed: Scalars['Boolean']['input'];
  /** Indica se o fogo foi utilizado */
  fireUsed: Scalars['Boolean']['input'];
  /** Indica se as mangueiras foram inspecionadas */
  hoses: Scalars['Boolean']['input'];
  /** Identificador da inspeção a atualizar */
  id: Scalars['String']['input'];
  /** Observações sobre a inspeção */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Data planejada da inspeção */
  plannedDate: Scalars['DateTime']['input'];
  /** Data real da inspeção */
  realDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Indica se o registro foi inspecionado */
  record: Scalars['Boolean']['input'];
  /** Identificador do responsável pela inspeção */
  responsibleId: Scalars['String']['input'];
  /** Indica se o abrigo foi inspecionado */
  shelter: Scalars['Boolean']['input'];
  /** Indica se a sinalização foi inspecionada */
  signaling: Scalars['Boolean']['input'];
  /** Situação da inspeção */
  situation: TInspectionSituation;
  /** Indica se os esguichos foram inspecionados */
  squirts: Scalars['Boolean']['input'];
  /** Indica se a chave storz foi inspecionada */
  storzkey: Scalars['Boolean']['input'];
  /** Indica se há itens diversos */
  sundry: Scalars['Boolean']['input'];
};

export type TInspectionReport = {
  __typename?: 'InspectionReport';
  address: Scalars['String']['output'];
  cnpj: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  completeValve: Scalars['Boolean']['output'];
  cylindricalValve: Scalars['Boolean']['output'];
  diffuserReplacement: Scalars['Boolean']['output'];
  drillUsed: Scalars['Boolean']['output'];
  fields: TInspectionReportFields;
  fireUsed: Scalars['Boolean']['output'];
  footer: Scalars['String']['output'];
  hidraulicSystem: Scalars['String']['output'];
  hose: Scalars['Boolean']['output'];
  hydrostaticTest: Scalars['Boolean']['output'];
  local: Scalars['String']['output'];
  monometer: Scalars['Boolean']['output'];
  painting: Scalars['Boolean']['output'];
  plannedDate: Scalars['String']['output'];
  realDate: Scalars['String']['output'];
  realoaded: Scalars['Boolean']['output'];
  responsible: Scalars['String']['output'];
  safetyValve: Scalars['Boolean']['output'];
  situation: Scalars['String']['output'];
  sundry: Scalars['Boolean']['output'];
  telephone: Scalars['String']['output'];
  triggerReplacement: Scalars['Boolean']['output'];
};

export type TInspectionReportFields = {
  __typename?: 'InspectionReportFields';
  activities: Scalars['String']['output'];
  completeValve: Scalars['String']['output'];
  cylindricalValve: Scalars['String']['output'];
  diffuserReplacement: Scalars['String']['output'];
  drillUsed: Scalars['String']['output'];
  fireUsed: Scalars['String']['output'];
  hidraulicSystem: Scalars['String']['output'];
  hose: Scalars['String']['output'];
  hydrostaticTest: Scalars['String']['output'];
  local: Scalars['String']['output'];
  monometer: Scalars['String']['output'];
  no: Scalars['String']['output'];
  painting: Scalars['String']['output'];
  plannedDate: Scalars['String']['output'];
  realDate: Scalars['String']['output'];
  reloaded: Scalars['String']['output'];
  responsible: Scalars['String']['output'];
  safetyValve: Scalars['String']['output'];
  situation: Scalars['String']['output'];
  sundry: Scalars['String']['output'];
  triggerReplacement: Scalars['String']['output'];
  yes: Scalars['String']['output'];
};

/** Situação da inspeção */
export enum TInspectionSituation {
  /** Cancelada */
  Canceled = 'Canceled',
  /** Finalizada */
  Finished = 'Finished',
  /** Pendente */
  Pending = 'Pending'
}

export type TIntegrationConfiguration = {
  __typename?: 'IntegrationConfiguration';
  /** ID da filial */
  branchId: Scalars['String']['output'];
  /** ID da configuração */
  id: Scalars['String']['output'];
  /** Opções de integração */
  options: Array<TIntegrationConfigurationOption>;
};

export type TIntegrationConfigurationInput = {
  /** ID da filial */
  branchId: Scalars['String']['input'];
  /** Opções de integração */
  options?: InputMaybe<Array<TIntegrationConfigurationOptionInput>>;
};

export type TIntegrationConfigurationOption = {
  __typename?: 'IntegrationConfigurationOption';
  /** Data de desativação */
  deactivatedAt?: Maybe<Scalars['String']['output']>;
  /** Tipo de integração */
  integration?: Maybe<TMetadataType>;
  /** Indica se está ativa */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Origem da configuração */
  origin?: Maybe<Scalars['String']['output']>;
  /** Motivo da desativação */
  reason?: Maybe<Scalars['String']['output']>;
};

export type TIntegrationConfigurationOptionInput = {
  /** Data de desativação */
  deactivatedAt?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de integração */
  integration?: InputMaybe<TMetadataType>;
  /** Indica se está ativa */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Origem da configuração */
  origin?: InputMaybe<Scalars['String']['input']>;
  /** Motivo da desativação */
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type TIntegrationConfigureInput = {
  /** Endpoints a configurar */
  endpoints: Array<TEndpointInput>;
  /** Metadados a criar */
  metadatas?: InputMaybe<Array<TCreateMetadataInput>>;
  /** Tipos de metadados */
  metadatasType?: InputMaybe<Array<TMetadataType>>;
};

/** Contexto de integração */
export enum TIntegrationContext {
  /** ERP */
  Erp = 'Erp',
  /** Inventário */
  Inventory = 'Inventory',
  /** MES */
  Mes = 'Mes',
  /** Monitoramento */
  Monitoring = 'Monitoring',
  /** SOC */
  Soc = 'SOC',
  /** TAF Middleware */
  TafMiddleware = 'TafMiddleware'
}

export type TIntegrationError = {
  __typename?: 'IntegrationError';
  /** Identificador da filial */
  branch: Scalars['String']['output'];
  /** Data de criação do registro */
  createdAt: Scalars['DateTime']['output'];
  /** Dados do erro em formato JSON */
  data: Scalars['String']['output'];
  /** Identificador no ERP */
  erpId: Scalars['String']['output'];
  /** Mensagem de erro */
  errorMessage: Scalars['String']['output'];
  /** Categoria do erro (ex.: cbo_invalid, other) */
  errorType: Scalars['String']['output'];
  /** Identificador único do erro de integração */
  id: Scalars['String']['output'];
  /** Tipo de integração */
  integrationType: TIntegrationType;
  /** Data de atualização do registro */
  updatedAt: Scalars['DateTime']['output'];
};

export type TIntegrationErrorAll = {
  __typename?: 'IntegrationErrorAll';
  /** Quantidade total de erros de integração */
  count: Scalars['Float']['output'];
  /** Dados paginados dos erros de integração */
  data: TPaginatedIntegrationError;
};

export type TIntegrationErrorSummary = {
  __typename?: 'IntegrationErrorSummary';
  /** Contagem de erros por categoria */
  byType: Array<TIntegrationErrorTypeCount>;
  /** Se a última sincronização teve erros */
  hasErrors: Scalars['Boolean']['output'];
  /** Data/hora da última sincronização */
  lastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  /** Se há uma sincronização em andamento */
  running: Scalars['Boolean']['output'];
  /** Total de registros com erro */
  totalErrors: Scalars['Float']['output'];
  /** Total processado na última execução (null no modo legacy) */
  totalProcessed?: Maybe<Scalars['Float']['output']>;
  /** Total de sucessos na última execução (null no modo legacy) */
  totalSuccess?: Maybe<Scalars['Float']['output']>;
};

export type TIntegrationErrorTypeCount = {
  __typename?: 'IntegrationErrorTypeCount';
  /** Quantidade de erros nessa categoria */
  count: Scalars['Float']['output'];
  /** Categoria do erro (error_type) */
  type: Scalars['String']['output'];
};

export type TIntegrationFlags = {
  __typename?: 'IntegrationFlags';
  /** Se true, broker enfileira recepção em mdt.ttalk_inbound_event (T1-03). Se false, fluxo legacy síncrono. */
  inboundResilient: Scalars['Boolean']['output'];
  /** Se true, services Fase 3 persistem com pending_send + publicam em ttalk-outbound-processing (T1-02 envio assíncrono). Se false, mantêm broker.dispatchRemoteCall síncrono. */
  integrationSendAsync: Scalars['Boolean']['output'];
};

/** Tipo de integração */
export enum TIntegrationType {
  /** Tipos de afastamento */
  AbsenceType = 'absenceType',
  /** Credenciados */
  Accredited = 'accredited',
  /** Tipos de abono */
  AllowanceType = 'allowanceType',
  /** Questionários clínicos */
  ClinicalQuizzes = 'clinicalQuizzes',
  /** Deficiências */
  Deficiencies = 'deficiencies',
  /** Entrega de EPI */
  IpeDelivery = 'ipeDelivery',
  /** Atestados médicos */
  MedicalCertificates = 'medicalCertificates',
  /** Prontuários médicos */
  MedicalRecords = 'medicalRecords',
  /** Atestados ocupacionais */
  OccupationalCertificates = 'occupationalCertificates',
  /** Ocupações */
  Occupations = 'occupations',
  /** Centros de custo */
  PayrollCostCenter = 'payrollCostCenter',
  /** Ocupações */
  Positions = 'positions',
  /** Questionários */
  Quizzes = 'quizzes',
  /** Relatórios */
  Reports = 'reports',
  /** Riscos */
  Risks = 'risks',
  /** Tipos de estabilidade */
  StabilityType = 'stabilityType',
  /** Treinamentos */
  Training = 'training',
  /** Vacinas */
  Vaccines = 'vaccines',
  /** Turnos de trabalho */
  WorkShift = 'workShift'
}

export type TInternalFields = {
  __typename?: 'InternalFields';
  /** Campos externos associados */
  externalFields: TExternalFields;
  /** ID do metadado genérico */
  genericMetadataId: Scalars['String']['output'];
  /** ID do campo interno */
  id: Scalars['String']['output'];
  /** Limite de caracteres */
  limit?: Maybe<Scalars['Float']['output']>;
  /** Nome do campo */
  name: Scalars['String']['output'];
  /** Indica se é obrigatório */
  required: Scalars['Boolean']['output'];
  /** Tipo do campo */
  type: TFieldType;
};

export type TInventoryQueue = {
  __typename?: 'InventoryQueue';
  /** Identificador da filial */
  branch: Scalars['String']['output'];
  /** Data de criação do registro */
  createdAt: Scalars['DateTime']['output'];
  /** Data de exclusão do registro */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Evento associado à mensagem */
  event: Scalars['String']['output'];
  /** Identificador único da fila de inventário */
  id: Scalars['String']['output'];
  /** Mensagem enviada para integração */
  messageSend: Scalars['String']['output'];
  /** Identificador do movimento de estoque */
  movementId?: Maybe<Scalars['String']['output']>;
  /** Data de envio da mensagem */
  sendDate: Scalars['DateTime']['output'];
  /** Status da mensagem */
  status: TStatusMessage;
  /** Descrição do status da mensagem */
  statusDescription?: Maybe<Scalars['String']['output']>;
  /** Movimento de estoque associado */
  stockMovementRef: TStockMovement;
  /** Tipo de inventário */
  type: TInventoryTypeMessage;
  /** Data de atualização do registro */
  updatedAt: Scalars['DateTime']['output'];
  /** Verbo da ação (criar, atualizar, deletar) */
  verb: TVerbMessage;
};

export type TInventoryQueueInput = {
  /** Evento associado à mensagem */
  event: Scalars['String']['input'];
  /** Mensagem enviada para integração */
  messageSend: Scalars['String']['input'];
  /** Identificador do movimento de estoque */
  movementId?: InputMaybe<Scalars['String']['input']>;
  /** Data de envio da mensagem */
  sendDate: Scalars['DateTime']['input'];
  /** Status da mensagem */
  status: TStatusMessage;
  /** Descrição do status da mensagem */
  statusDescription?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de inventário */
  type: TInventoryTypeMessage;
  /** Verbo da ação (criar, atualizar, deletar) */
  verb: TVerbMessage;
};

/** Tipo de mensagem de inventário */
export enum TInventoryTypeMessage {
  /** Solicitação */
  Request = 'Request',
  /** Movimentação de estoque */
  StockTurnover = 'StockTurnover'
}

export type TInvestigation = {
  __typename?: 'Investigation';
  /** Acidente investigado */
  accident: TAccident;
  /** Identificador do acidente */
  accidentId: Scalars['String']['output'];
  /** Anexos da investigação */
  attachments?: Maybe<Array<TAttachment>>;
  /** Data da investigação */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** Indica se houve equipamento defeituoso */
  defectiveEquipment?: Maybe<Scalars['Boolean']['output']>;
  /** Identificador único da investigação */
  id: Scalars['String']['output'];
  /** Indica se houve improvização */
  improvisation?: Maybe<Scalars['Boolean']['output']>;
  /** Causas identificadas na investigação */
  investigationCause?: Maybe<Array<TInvestigationCause>>;
  /** Indica se o funcionário conhecia as normas */
  knewNorms?: Maybe<Scalars['Boolean']['output']>;
  /** Identificador do mandato */
  mandateId: Scalars['String']['output'];
  /** Pessoa que realizou a investigação */
  person: TPerson;
  /** Identificador da pessoa que fez a investigação */
  personId: Scalars['String']['output'];
  /** Relatório da investigação */
  report: Scalars['String']['output'];
  /** Indica se o funcionário foi treinado */
  trained?: Maybe<Scalars['Boolean']['output']>;
  /** Indica se o EPI foi utilizado */
  wasUsedEpi?: Maybe<Scalars['Boolean']['output']>;
};

export type TInvestigationAmountChart = {
  __typename?: 'InvestigationAmountChart';
  /** Investigações concluídas */
  completed: Scalars['Float']['output'];
  /** Indica se há acidentes registrados */
  hasAccident: Scalars['Boolean']['output'];
  /** Investigações não iniciadas */
  notStarted: Scalars['Float']['output'];
};

export type TInvestigationCause = {
  __typename?: 'InvestigationCause';
  /** Causa do acidente */
  accidentCause: TAccidentCause;
  /** Identificador único da causa da investigação */
  id: Scalars['String']['output'];
  /** Investigação associada */
  investigation: TInvestigation;
};

export type TInvestigationCauseInput = {
  /** Identificador da causa do acidente */
  accidentCauseId: Scalars['String']['input'];
  /** Identificador da filial */
  branch: Scalars['String']['input'];
  /** Identificador da investigação */
  investigationId: Scalars['String']['input'];
};

export type TInvestigationCauseOnAccident = {
  __typename?: 'InvestigationCauseOnAccident';
  /** Causa do acidente */
  accidentCause: TAccidentCause;
};

export type TInvestigationCauseOnAccidentInput = {
  /** Identificador da causa do acidente */
  accidentCauseId: Scalars['String']['input'];
};

export type TInvestigationCauseOnAccidentUpdate = {
  /** Causas de acidente a criar na investigação */
  toCreate: Array<TInvestigationCauseOnAccidentInput>;
  /** Identificadores das causas de acidente a remover */
  toRemove: Array<Scalars['String']['input']>;
};

export type TInvestigationIndicatorsChart = {
  __typename?: 'InvestigationIndicatorsChart';
  /** Equipamento com defeito */
  defectiveEquipment: Scalars['Float']['output'];
  /** Indica se há acidentes registrados */
  hasAccident: Scalars['Boolean']['output'];
  /** Improvisações */
  improvisation: Scalars['Float']['output'];
  /** Desconhecimento de normas */
  notKnewNorms: Scalars['Float']['output'];
  /** Trabalhadores não treinados */
  notTrained: Scalars['Float']['output'];
  /** EPI não utilizado */
  wasNotUsedEpi: Scalars['Float']['output'];
};

export type TInvestigationInput = {
  /** Identificador do acidente */
  accidentId: Scalars['String']['input'];
  /** Data da investigação */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Indica se houve equipamento defeituoso */
  defectiveEquipment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se houve improvização */
  improvisation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Causas do acidente identificadas na investigação */
  investigationCauses?: InputMaybe<Array<TInvestigationCauseOnAccidentInput>>;
  /** Indica se o funcionário conhecia as normas */
  knewNorms?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador do mandato */
  mandateId: Scalars['String']['input'];
  /** Identificador da pessoa que fez a investigação */
  personId: Scalars['String']['input'];
  /** Relatório da investigação */
  report: Scalars['String']['input'];
  /** Indica se o funcionário foi treinado */
  trained?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se o EPI foi utilizado */
  wasUsedEpi?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TInvestigationSuggestion = {
  __typename?: 'InvestigationSuggestion';
  /** Rótulo da sugestão */
  label: Scalars['String']['output'];
  /** Valor da sugestão */
  value: Scalars['String']['output'];
};

export type TInvestigationUpdate = {
  /** Novo identificador do acidente */
  accidentId?: InputMaybe<Scalars['String']['input']>;
  /** Data da investigação */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Indica se houve equipamento defeituoso */
  defectiveEquipment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador da investigação a atualizar */
  id: Scalars['String']['input'];
  /** Indica se houve improvização */
  improvisation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Alterações nas causas do acidente */
  investigationCauses?: InputMaybe<TInvestigationCauseOnAccidentUpdate>;
  /** Indica se o funcionário conhecia as normas */
  knewNorms?: InputMaybe<Scalars['Boolean']['input']>;
  /** Novo identificador do mandato */
  mandateId?: InputMaybe<Scalars['String']['input']>;
  /** Novo identificador da pessoa */
  personId?: InputMaybe<Scalars['String']['input']>;
  /** Novo relatório da investigação */
  report?: InputMaybe<Scalars['String']['input']>;
  /** Indica se o funcionário foi treinado */
  trained?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se o EPI foi utilizado */
  wasUsedEpi?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TInvite = {
  __typename?: 'Invite';
  accessByAd?: Maybe<TAccessBy>;
  birthday: Scalars['DateTime']['output'];
  branch: TBranch;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  gender: TGender;
  individualRegistration: Scalars['String']['output'];
  linkUserPerson?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  roleId: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type TInviteInput = {
  birthday: Scalars['DateTime']['input'];
  email: Scalars['String']['input'];
  gender: TGender;
  individualRegistration: Scalars['String']['input'];
  linkUserPerson?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  roleId?: InputMaybe<Scalars['String']['input']>;
};

export type TInviteParametersMail = {
  __typename?: 'InviteParametersMail';
  currentUserName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  isPartner: Scalars['Boolean']['output'];
  organizationName: Scalars['String']['output'];
  roleId?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  user: TUser;
};

export type TInvoice = {
  __typename?: 'Invoice';
  /** URL do boleto */
  bankSlipUrl?: Maybe<Scalars['String']['output']>;
  /** URL da nota fiscal */
  invoiceUrl?: Maybe<Scalars['String']['output']>;
  /** Mensagem */
  message?: Maybe<Scalars['String']['output']>;
  /** Número da nota fiscal */
  number?: Maybe<Scalars['String']['output']>;
  /** Nossa URL */
  ourUrl?: Maybe<Scalars['String']['output']>;
};

export type TIpe = {
  __typename?: 'Ipe';
  /** Certificado de Aprovação */
  caCode?: Maybe<Scalars['String']['output']>;
  /** Validade do CA */
  caExpiration?: Maybe<Scalars['DateTime']['output']>;
  /** Dias para substituição do EPI */
  daysForReplacement?: Maybe<Scalars['Float']['output']>;
  /** Descrição do EPI */
  description: Scalars['String']['output'];
  /** Identificador único do EPI */
  id: Scalars['String']['output'];
  /** Nome do fabricante do CA */
  manufacturerName?: Maybe<Scalars['String']['output']>;
  /** Tipo de proteção do EPI */
  protection: TIpeProtection;
};

export type TIpeBiometry = {
  __typename?: 'IpeBiometry';
  /** Biometria associada */
  biometry: TBiometry;
  /** Identificador da biometria */
  biometryId: Scalars['String']['output'];
  /** Identificador único da biometria de IPE */
  id: Scalars['String']['output'];
};

export type TIpeBiometryInput = {
  /** Identificador da biometria */
  biometryId: Scalars['String']['input'];
  /** Imagem BMP */
  bmp?: InputMaybe<Scalars['String']['input']>;
  /** Dados da imagem */
  imageData: Scalars['String']['input'];
  /** DPI da imagem */
  imageDpi?: InputMaybe<Scalars['Float']['input']>;
  /** Altura da imagem */
  imageHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Qualidade da imagem */
  imageQuality?: InputMaybe<Scalars['Float']['input']>;
  /** Largura da imagem */
  imageWidth?: InputMaybe<Scalars['Float']['input']>;
  /** Fabricante do equipamento */
  manufacturer: Scalars['String']['input'];
  /** Modelo do equipamento */
  model?: InputMaybe<Scalars['String']['input']>;
  /** NFIQ (NIST Fingerprint Image Quality) */
  nfiq?: InputMaybe<Scalars['Float']['input']>;
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
  /** Número de série */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Template da biometria */
  template?: InputMaybe<Scalars['String']['input']>;
  /** Validações realizadas na biometria */
  validations?: InputMaybe<TValidations>;
  /** Imagem WSQ */
  wsqImage?: InputMaybe<Scalars['String']['input']>;
  /** Tamanho da imagem WSQ */
  wsqImageSize?: InputMaybe<Scalars['Float']['input']>;
};

export type TIpeByRequirementChart = {
  __typename?: 'IpeByRequirementChart';
  /** IPEs por centro de custo */
  byCostCenter: Scalars['Float']['output'];
  /** IPEs por cargo */
  byOccupation: Scalars['Float']['output'];
  /** IPEs por risco */
  byRisk: Scalars['Float']['output'];
  /** Indica se existem entregas de IPE */
  hasIpeDeliveries: Scalars['Boolean']['output'];
};

export type TIpeByRisk = {
  __typename?: 'IpeByRisk';
  /** Certificado de Aprovação */
  caCode?: Maybe<Scalars['String']['output']>;
  /** Lista de CA (Certificado de Aprovação) */
  caList?: Maybe<Scalars['String']['output']>;
  /** Dias para substituição do IPE */
  daysForReplacement?: Maybe<Scalars['Float']['output']>;
  /** ID da relação */
  id: Scalars['String']['output'];
  /** IPE vinculado ao risco */
  ipe: TIpe;
};

export type TIpeByRiskInput = {
  /** Certificado de Aprovação */
  caCode?: InputMaybe<Scalars['String']['input']>;
  /** Lista de CA (Certificado de Aprovação) */
  caList?: InputMaybe<Scalars['String']['input']>;
  /** Dias para substituição do IPE */
  daysForReplacement?: InputMaybe<Scalars['Float']['input']>;
  /** ID do IPE */
  ipeId: Scalars['String']['input'];
  /** ID do risco */
  riskId: Scalars['String']['input'];
};

export type TIpeDelivery = {
  __typename?: 'IpeDelivery';
  /** Quantidade devolvida */
  amountReturned?: Maybe<Scalars['Float']['output']>;
  /** Número do Certificado de Aprovação */
  ca: Scalars['String']['output'];
  /** Data de validade do CA */
  caExpirationDate: Scalars['DateTime']['output'];
  /** Custo do IPE */
  cost?: Maybe<Scalars['Float']['output']>;
  /** CRM do médico prescritor */
  crm?: Maybe<Scalars['String']['output']>;
  /** Estado de registro do CRM */
  crmState?: Maybe<TState>;
  /** Quantidade entregue */
  deliveryAmount: Scalars['Float']['output'];
  /** Data da entrega */
  deliveryDate: Scalars['DateTime']['output'];
  /** Nome do médico prescritor */
  doctorName?: Maybe<Scalars['String']['output']>;
  /** Snapshot granular das entries (UF + número + especialidade) preenchidas no formulário externo. Usado para hidratar a edição. */
  doctorRqeEntries?: Maybe<Array<TDoctorRqeEntry>>;
  /** Indica se a entrega foi efetivada */
  effective?: Maybe<Scalars['Boolean']['output']>;
  /** Funcionário que recebeu o IPE */
  employee: TPerson;
  /** Identificador no ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** Identificador único da entrega de IPE */
  id: Scalars['String']['output'];
  /** Fabricante do IPE */
  ipeManufacturer: TIpeManufacturer;
  /** Data de emissão do documento */
  issueDate?: Maybe<Scalars['DateTime']['output']>;
  /** Data da última manutenção */
  lastMaintenanceDate: Scalars['DateTime']['output'];
  /** Número do lote */
  lotNumber?: Maybe<Scalars['String']['output']>;
  /** Data da próxima manutenção */
  nextMaintenance?: Maybe<Scalars['DateTime']['output']>;
  /** Observações sobre a entrega */
  observation?: Maybe<Scalars['String']['output']>;
  /** Produto associado */
  product?: Maybe<TProduct>;
  /** Identificador do produto */
  productId?: Maybe<Scalars['String']['output']>;
  /** Motivo da entrega */
  reason: TDeliveryReason;
  /** Data de substituição */
  replacementDate?: Maybe<Scalars['DateTime']['output']>;
  /** Situação de substituição do IPE */
  replacementSituation?: Maybe<TReplacementSituation>;
  /** Data de devolução do IPE */
  returnDate?: Maybe<Scalars['DateTime']['output']>;
  /** Motivo da devolução */
  returnReason?: Maybe<TReturnReason>;
  /** Movimentos de estoque relacionados */
  stockMovement?: Maybe<Array<TStockMovement>>;
  /** Total de dias prorrogados para esta entrega */
  totalExtensionDays?: Maybe<Scalars['Float']['output']>;
  /** Depósito de origem */
  warehouse?: Maybe<TWarehouse>;
  /** Identificador do depósito */
  warehouseId?: Maybe<Scalars['String']['output']>;
};

export type TIpeDeliveryDashboard = {
  __typename?: 'IpeDeliveryDashboard';
  /** Variação anual de entregas (12m atuais vs 12m anteriores) */
  annualDeliveryVariationChart: TAnnualDeliveryVariationChart;
  /** Gráfico de CAs em uso */
  caInUseChart: TCaInUseChart;
  /** Gráfico de entregas por categoria de IPE */
  categoriesChart: TCategoriesChart;
  /** Gráfico por centro de custo */
  costCenterChart: TIpeDeliveryPerTotalChart;
  /** Gráfico de custo por fabricante */
  costPerManufacturerChart: TIpeDeliveryPieCharts;
  /** Gráfico de entregas por mês */
  deliveredPerMonthChart: TIpeDeliveryLineCharts;
  /** Gráfico de eficiência das entregas */
  efficiencyChart: TEfficiencyChart;
  /** Top 5 CAs comparando vida útil cadastrada vs real (média entre entregas) */
  epiLifespanChart: TEpiLifespanChart;
  /** Gráfico total de equipamentos entregues */
  equipmentDeliveredChart: TIpeDeliveryPerTotalChart;
  /** Gráfico de entregas a pessoas externas */
  externalDeliveryChart: TExternalDeliveryChart;
  /** Gráfico de IPEs por requisito */
  ipeByRequirementChart: TIpeByRequirementChart;
  /** Gráfico de custos com IPEs */
  ipeCostsChart: TIpeDeliveryPerTotalChart;
  /** Gráfico por cargo */
  occupationChart: TIpeDeliveryPerTotalChart;
  /** Gráfico de entregas e devoluções por dia */
  perDayChart: TPerDayChart;
  /** Gráfico de entregas por motivo */
  reasonsChart: TReasonsChart;
  /** Gráfico de devoluções por motivo */
  returnReasonsChart: TReturnReasonsChart;
  /** Gráfico de devoluções por mês */
  returnsPerMonthChart: TIpeDeliveryLineCharts;
  /** Gráfico de assinaturas */
  signatureChart: TSignatureChart;
};

export type TIpeDeliveryExtensionAuditReport = {
  __typename?: 'IpeDeliveryExtensionAuditReport';
  /** Extensões recentes */
  extensions: Array<TIpeDeliveryExtensionEntry>;
  /** Estatísticas do período */
  stats: TIpeDeliveryExtensionAuditStats;
};

export type TIpeDeliveryExtensionAuditStats = {
  __typename?: 'IpeDeliveryExtensionAuditStats';
  /** Extensões neste mês */
  countThisMonth: Scalars['Float']['output'];
  /** EPIs com 2+ extensões */
  countWithMultipleExtensions: Scalars['Float']['output'];
  /** Economia estimada em R$ */
  estimatedSavings: Scalars['Float']['output'];
};

export type TIpeDeliveryExtensionEntry = {
  __typename?: 'IpeDeliveryExtensionEntry';
  /** Número do CA */
  ca: Scalars['String']['output'];
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** Nome do responsável */
  createdByName: Scalars['String']['output'];
  /** Dias prorrogados */
  extendedDays: Scalars['Float']['output'];
  /** Identificador da extensão */
  id: Scalars['String']['output'];
  /** Identificador da entrega de IPE */
  ipeDeliveryId: Scalars['String']['output'];
  /** Nome do EPI */
  ipeName: Scalars['String']['output'];
  /** Nova data após prorrogação */
  newDate: Scalars['DateTime']['output'];
  /** Observação */
  observation?: Maybe<Scalars['String']['output']>;
  /** Data anterior à prorrogação */
  oldDate: Scalars['DateTime']['output'];
  /** Motivo da prorrogação */
  reason: TExtensionReason;
};

export type TIpeDeliveryExtensionInput = {
  /** Quantidade de dias prorrogados */
  extendedDays: Scalars['Float']['input'];
  /** Identificador da entrega de IPE a prorrogar */
  ipeDeliveryId: Scalars['String']['input'];
  /** Nova data prevista após prorrogação */
  newDate: Scalars['DateTime']['input'];
  /** Observação adicional (opcional) */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Data prevista antes da prorrogação */
  oldDate: Scalars['DateTime']['input'];
  /** Motivo da prorrogação */
  reason: TExtensionReason;
};

export type TIpeDeliveryExtensionResult = {
  __typename?: 'IpeDeliveryExtensionResult';
  /** Data de criação do registro */
  createdAt: Scalars['DateTime']['output'];
  /** Quantidade de dias prorrogados */
  extendedDays: Scalars['Float']['output'];
  /** Identificador único da prorrogação */
  id: Scalars['String']['output'];
  /** Identificador da entrega de IPE */
  ipeDeliveryId: Scalars['String']['output'];
  /** Nova data prevista após prorrogação */
  newDate: Scalars['DateTime']['output'];
  /** Observação adicional */
  observation?: Maybe<Scalars['String']['output']>;
  /** Data prevista antes da prorrogação */
  oldDate: Scalars['DateTime']['output'];
  /** Motivo da prorrogação */
  reason: TExtensionReason;
};

export type TIpeDeliveryExtensionTimeline = {
  __typename?: 'IpeDeliveryExtensionTimeline';
  /** Número do CA */
  ca: Scalars['String']['output'];
  /** Data atual de substituição */
  currentReplacementDate: Scalars['DateTime']['output'];
  /** Data da entrega */
  deliveryDate: Scalars['DateTime']['output'];
  /** Extensões da entrega */
  extensions: Array<TIpeDeliveryExtensionEntry>;
  /** Identificador da entrega de IPE */
  ipeDeliveryId: Scalars['String']['output'];
  /** Nome do EPI */
  ipeName: Scalars['String']['output'];
  /** Data original de substituição */
  originalReplacementDate: Scalars['DateTime']['output'];
  /** Total de dias prorrogados */
  totalExtensionDays: Scalars['Float']['output'];
};

export type TIpeDeliveryFace = {
  __typename?: 'IpeDeliveryFace';
  /** Quantidade devolvida */
  amountReturned?: Maybe<Scalars['Float']['output']>;
  /** Número do Certificado de Aprovação */
  ca: Scalars['String']['output'];
  /** Data de validade do CA */
  caExpirationDate: Scalars['DateTime']['output'];
  /** Custo do IPE */
  cost?: Maybe<Scalars['Float']['output']>;
  /** CRM do médico prescritor */
  crm?: Maybe<Scalars['String']['output']>;
  /** Estado de registro do CRM */
  crmState?: Maybe<TState>;
  /** Quantidade entregue */
  deliveryAmount: Scalars['Float']['output'];
  /** Data da entrega */
  deliveryDate: Scalars['DateTime']['output'];
  /** Nome do médico prescritor */
  doctorName?: Maybe<Scalars['String']['output']>;
  /** Snapshot granular das entries (UF + número + especialidade) preenchidas no formulário externo. Usado para hidratar a edição. */
  doctorRqeEntries?: Maybe<Array<TDoctorRqeEntry>>;
  /** Indica se a entrega foi efetivada */
  effective?: Maybe<Scalars['Boolean']['output']>;
  /** Funcionário que recebeu o IPE */
  employee: TPerson;
  /** Identificador no ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** Identificador único da entrega de IPE */
  id: Scalars['String']['output'];
  /** Fabricante do IPE */
  ipeManufacturer: TIpeManufacturer;
  /** Data de emissão do documento */
  issueDate?: Maybe<Scalars['DateTime']['output']>;
  /** Data da última manutenção */
  lastMaintenanceDate: Scalars['DateTime']['output'];
  /** Número do lote */
  lotNumber?: Maybe<Scalars['String']['output']>;
  /** Data da próxima manutenção */
  nextMaintenance?: Maybe<Scalars['DateTime']['output']>;
  /** Observações sobre a entrega */
  observation?: Maybe<Scalars['String']['output']>;
  /** Produto associado */
  product?: Maybe<TProduct>;
  /** Identificador do produto */
  productId?: Maybe<Scalars['String']['output']>;
  /** Motivo da entrega */
  reason: TDeliveryReason;
  /** Data de substituição */
  replacementDate?: Maybe<Scalars['DateTime']['output']>;
  /** Situação de substituição do IPE */
  replacementSituation?: Maybe<TReplacementSituation>;
  /** Data de devolução do IPE */
  returnDate?: Maybe<Scalars['DateTime']['output']>;
  /** Motivo da devolução */
  returnReason?: Maybe<TReturnReason>;
  /** Movimentos de estoque relacionados */
  stockMovement?: Maybe<Array<TStockMovement>>;
  /** Total de dias prorrogados para esta entrega */
  totalExtensionDays?: Maybe<Scalars['Float']['output']>;
  /** URL para upload do thumbnail da foto facial */
  uploadThumbnailUrl: Scalars['String']['output'];
  /** URL para upload da foto facial */
  uploadUrl: Scalars['String']['output'];
  /** Depósito de origem */
  warehouse?: Maybe<TWarehouse>;
  /** Identificador do depósito */
  warehouseId?: Maybe<Scalars['String']['output']>;
};

export type TIpeDeliveryInput = {
  /** Quantidade devolvida */
  amountReturned?: InputMaybe<Scalars['Float']['input']>;
  /** Número do Certificado de Aprovação */
  ca: Scalars['String']['input'];
  /** Data de validade do CA */
  caExpirationDate: Scalars['DateTime']['input'];
  /** Custo do IPE */
  cost?: InputMaybe<Scalars['Float']['input']>;
  /** CRM do médico prescritor */
  crm?: InputMaybe<Scalars['String']['input']>;
  /** Estado de registro do CRM */
  crmState?: InputMaybe<TState>;
  /** Quantidade entregue */
  deliveryAmount: Scalars['Float']['input'];
  /** Data da entrega */
  deliveryDate: Scalars['DateTime']['input'];
  /** Nome do médico prescritor */
  doctorName?: InputMaybe<Scalars['String']['input']>;
  /** RQEs do médico (até 2) para snapshot. Médico interno: backend busca automaticamente; médico externo: digitados no formulário. */
  doctorRqeInput?: InputMaybe<Array<TDoctorRqeEntryInput>>;
  /** Indica se a entrega foi efetivada */
  effective?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador do funcionário */
  employeeId: Scalars['String']['input'];
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Indica se é informação histórica */
  historicInfo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Data de emissão do documento */
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data da última manutenção */
  lastMaintenanceDate: Scalars['DateTime']['input'];
  /** Número do lote */
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  /** Data da próxima manutenção */
  nextMaintenance?: InputMaybe<Scalars['DateTime']['input']>;
  /** Observações sobre a entrega */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do produto */
  productId?: InputMaybe<Scalars['String']['input']>;
  /** Motivo da entrega */
  reason: TDeliveryReason;
  /** Data de devolução do IPE */
  returnDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Motivo da devolução */
  returnReason?: InputMaybe<TReturnReason>;
  /** Identificador do depósito */
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type TIpeDeliveryLineCharts = {
  __typename?: 'IpeDeliveryLineCharts';
  /** Dados */
  data: Array<TLineChart>;
  /** Indica se existem entregas de IPE */
  hasIpeDeliveries: Scalars['Boolean']['output'];
};

export type TIpeDeliveryMedicalReport = {
  __typename?: 'IpeDeliveryMedicalReport';
  /** Nome da filial */
  branch: Scalars['String']['output'];
  /** Centro de custo */
  costCenter?: Maybe<Scalars['String']['output']>;
  /** Estado de registro do CRM */
  crmState?: Maybe<TState>;
  /** Data formatada do relatório */
  date: Scalars['String']['output'];
  /** CRM do médico prescritor */
  doctorCRM: Scalars['String']['output'];
  /** Nome do médico prescritor */
  doctorName: Scalars['String']['output'];
  /** Snapshot formatado dos RQEs do médico prescritor */
  doctorRqeDisplay?: Maybe<Scalars['String']['output']>;
  /** Rodapé do relatório médico */
  footer: Scalars['String']['output'];
  /** CPF do funcionário */
  individualRegistration: Scalars['String']['output'];
  /** Lista de IPEs entregues */
  ipe: Array<TIpeInfo>;
  /** Cargo */
  occupation?: Maybe<Scalars['String']['output']>;
  /** Nome da pessoa */
  person: Scalars['String']['output'];
};

export type TIpeDeliveryParams = {
  __typename?: 'IpeDeliveryParams';
  /** Identificadores dos centros de custo para filtro */
  costCenters?: Maybe<Array<Scalars['String']['output']>>;
  /** Filtro de entregas */
  filter?: Maybe<TDeliveryFilter>;
  /** Rodapé personalizado */
  footer?: Maybe<Scalars['String']['output']>;
  /** Indica se deve incluir checkbox */
  isCheck?: Maybe<Scalars['Boolean']['output']>;
  /** Indica se o relatório será usado como documento-base para assinatura digital */
  isSignDocument?: Maybe<Scalars['Boolean']['output']>;
  /** Indica se inclui assinatura de responsabilidade */
  isSigningResponsibility?: Maybe<Scalars['Boolean']['output']>;
  /** Identificadores dos cargos para filtro */
  occupations?: Maybe<Array<Scalars['String']['output']>>;
  /** Declaração de responsabilidade */
  statementsResponsibility?: Maybe<Scalars['String']['output']>;
};

export type TIpeDeliveryPerTotalChart = {
  __typename?: 'IpeDeliveryPerTotalChart';
  /** Dados */
  data: Array<TData>;
  /** Indica se existem entregas de IPE */
  hasIpeDeliveries: Scalars['Boolean']['output'];
  /** Dados por total */
  perTotal: Array<TData>;
};

export type TIpeDeliveryPieCharts = {
  __typename?: 'IpeDeliveryPieCharts';
  /** Dados */
  data: Array<TPieChart>;
  /** Indica se existem entregas de IPE */
  hasIpeDeliveries: Scalars['Boolean']['output'];
};

export type TIpeDeliveryReport = {
  __typename?: 'IpeDeliveryReport';
  /** Endereço da empresa */
  address: Scalars['String']['output'];
  /** Data de admissão formatada */
  admission?: Maybe<Scalars['String']['output']>;
  /** CNPJ da empresa */
  cnpj: Scalars['String']['output'];
  /** Nome da empresa */
  companyName: Scalars['String']['output'];
  /** Centro de custo */
  costCenter?: Maybe<Scalars['String']['output']>;
  /** RG do funcionário */
  generalRegistration?: Maybe<Scalars['String']['output']>;
  /** CPF do funcionário */
  individualRegistration: Scalars['String']['output'];
  /** Biometria do funcionário */
  ipeBiometry?: Maybe<TIpeBiometry>;
  /** Foto facial do funcionário */
  ipeFace?: Maybe<TIpeFace>;
  /** Lista de IPEs entregues */
  ipes?: Maybe<Array<TIpeReport>>;
  /** Nome do funcionário */
  name: Scalars['String']['output'];
  /** Cargo */
  occupation?: Maybe<Scalars['String']['output']>;
  /** Função */
  position?: Maybe<Scalars['String']['output']>;
  /** Matrícula do funcionário */
  registration?: Maybe<Scalars['String']['output']>;
  /** Telefone da empresa */
  telephone: Scalars['String']['output'];
};

export type TIpeDeliveryReportParams = {
  __typename?: 'IpeDeliveryReportParams';
  /** Número de linhas vazias no relatório */
  emptyRows: Scalars['Float']['output'];
  /** Rodapé do relatório */
  footer?: Maybe<Scalars['String']['output']>;
  /** Dados da entrega de IPE */
  ipeDelivery: TIpeDeliveryReport;
  /** Entregas de produtos */
  productDeliveries?: Maybe<TProductDeliveryReport>;
  /** Declaração de responsabilidade */
  responsibilityStatement?: Maybe<Scalars['String']['output']>;
  /** Entrega de peças sobressalentes */
  sparePartsDelivery?: Maybe<TDeliverySparePartsReport>;
};

export type TIpeDeliveryUpdate = {
  /** Quantidade devolvida */
  amountReturned?: InputMaybe<Scalars['Float']['input']>;
  /** Novo número do CA */
  ca?: InputMaybe<Scalars['String']['input']>;
  /** Novo número do CA */
  caExpirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Custo do IPE */
  cost?: InputMaybe<Scalars['Float']['input']>;
  /** CRM do médico prescritor */
  crm?: InputMaybe<Scalars['String']['input']>;
  /** Estado de registro do CRM */
  crmState?: InputMaybe<TState>;
  /** Nova quantidade entregue */
  deliveryAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Nova data da entrega */
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Nome do médico prescritor */
  doctorName?: InputMaybe<Scalars['String']['input']>;
  /** RQEs do médico (até 2) para snapshot. Médico interno: backend busca automaticamente; médico externo: digitados no formulário. */
  doctorRqeInput?: InputMaybe<Array<TDoctorRqeEntryInput>>;
  /** Indica se a entrega foi efetivada */
  effective?: InputMaybe<Scalars['Boolean']['input']>;
  /** Novo identificador do funcionário */
  employeeId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da entrega de IPE a atualizar */
  id: Scalars['String']['input'];
  /** Data de emissão do documento */
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Nova data da última manutenção */
  lastMaintenanceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Número do lote */
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  /** Data da próxima manutenção */
  nextMaintenance?: InputMaybe<Scalars['DateTime']['input']>;
  /** Observações sobre a entrega */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do produto */
  productId?: InputMaybe<Scalars['String']['input']>;
  /** Novo motivo da entrega */
  reason?: InputMaybe<TDeliveryReason>;
  /** Data de devolução do IPE */
  returnDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Motivo da devolução */
  returnReason?: InputMaybe<TReturnReason>;
  /** Identificador do depósito */
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type TIpeFace = {
  __typename?: 'IpeFace';
  /** Identificador único da foto facial de IPE */
  id: Scalars['String']['output'];
  /** URL da foto facial */
  picture: Scalars['S3UrlCloudFront']['output'];
  /** Chave da foto no armazenamento S3 */
  pictureKey: Scalars['String']['output'];
};

export type TIpeFaceInput = {
  /** Tamanho do arquivo em bytes */
  contentLength: Scalars['Float']['input'];
  /** Tipo de conteúdo da foto */
  contentType: Scalars['String']['input'];
  /** Latitude da geolocalização */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** Longitude da geolocalização */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** Indica se a permissão foi concedida */
  permissionGranted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
  /** Precisão da geolocalização */
  precision?: InputMaybe<Scalars['Float']['input']>;
  /** Validações realizadas na foto facial */
  validations?: InputMaybe<TFaceValidations>;
};

export type TIpeInfo = {
  __typename?: 'IpeInfo';
  /** Número do Certificado de Aprovação */
  ca: Scalars['String']['output'];
  /** Nome do IPE */
  name: Scalars['String']['output'];
};

export type TIpeManufacturer = {
  __typename?: 'IpeManufacturer';
  /** Aprovado para laudo */
  approvedForReport: Scalars['String']['output'];
  /** Código do Certificado de Aprovação */
  caCode: Scalars['String']['output'];
  /** CNPJ do fabricante */
  cnpj: Scalars['String']['output'];
  /** Cor */
  color: Scalars['String']['output'];
  /** Razão social do laboratório */
  corporateNameLaboratory: Scalars['String']['output'];
  /** Descrição do equipamento */
  equipmentDescription: Scalars['String']['output'];
  /** Nome do equipamento */
  equipmentName: Scalars['String']['output'];
  /** Data de validade */
  expiration: Scalars['DateTime']['output'];
  /** Equipamento de Proteção Individual */
  ipe: TIpe;
  /** CNPJ do laboratório */
  laboratoryCNPJ: Scalars['String']['output'];
  /** Fabricante */
  manufacturer: TManufacturer;
  /** Marca */
  mark: Scalars['String']['output'];
  /** Norma */
  norm: Scalars['String']['output'];
  /** Observações */
  observation: Scalars['String']['output'];
  /** Número do processo */
  processNumber: Scalars['String']['output'];
  /** Referência */
  reference: Scalars['String']['output'];
  /** Número do laudo */
  reportNumber: Scalars['String']['output'];
  /** Restrições para laudo */
  restrictedForReport: Scalars['String']['output'];
  /** Situação do CA */
  situation: TCaSituation;
};

export type TIpeManufacturerSuggestion = {
  __typename?: 'IpeManufacturerSuggestion';
  /** Código do Certificado de Aprovação */
  caCode: Scalars['String']['output'];
  /** Data de validade */
  expiration: Scalars['DateTime']['output'];
  /** Equipamento de Proteção Individual */
  ipe: TIpe;
  /** Fabricante */
  manufacturer: TManufacturer;
  /** Situação do CA */
  situation: TCaSituation;
  /** Sugestão de uso */
  suggestion?: Maybe<Scalars['String']['output']>;
};

export type TIpeOccupation = {
  __typename?: 'IpeOccupation';
  /** Equipamento de Proteção Individual */
  ipe: Scalars['String']['output'];
  /** Ocupação */
  occupation: Scalars['String']['output'];
};

export type TIpeOnRiskInput = {
  /** Certificado de Aprovação */
  caCode?: InputMaybe<Scalars['String']['input']>;
  /** Lista de CA (Certificado de Aprovação) */
  caList?: InputMaybe<Scalars['String']['input']>;
  /** Dias para substituição do IPE */
  daysForReplacement?: InputMaybe<Scalars['Float']['input']>;
  /** ID do IPE */
  ipeId: Scalars['String']['input'];
};

export type TIpeOnRiskUpdate = {
  /** IPEs a serem vinculados */
  toCreate: Array<TIpeOnRiskInput>;
  /** IDs dos IPEs a serem removidos */
  toRemove: Array<Scalars['String']['input']>;
};

/** Tipo de EPI */
export enum TIpeProtection {
  /** Proteção respiratória */
  BreathProtection = 'BreathProtection',
  /** Proteção para olhos e face */
  EyeFaceProtection = 'EyeFaceProtection',
  /** Proteção contra quedas */
  FallProtection = 'FallProtection',
  /** Proteção para o corpo inteiro */
  FullBodyProtection = 'FullBodyProtection',
  /** Proteção para a cabeça */
  HeadProtection = 'HeadProtection',
  /** Proteção auditiva */
  HearingProtection = 'HearingProtection',
  /** Proteção para membros inferiores */
  LowerLimbProtection = 'LowerLimbProtection',
  /** Outro */
  Other = 'Other',
  /** Proteção para o tronco */
  TrunkProtection = 'TrunkProtection',
  /** Proteção para membros superiores */
  UpperLimbProtection = 'UpperLimbProtection'
}

export type TIpeReport = {
  __typename?: 'IpeReport';
  /** Quantidade do IPE */
  amount: Scalars['Float']['output'];
  /** Número do certificado */
  certificate: Scalars['String']['output'];
  /** Descrição do IPE */
  description: Scalars['String']['output'];
  /** Latitude da geolocalização */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Longitude da geolocalização */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Precisão da geolocalização */
  precision?: Maybe<Scalars['Float']['output']>;
  /** Data prevista formatada */
  prevDate: Scalars['String']['output'];
  /** Data de devolução formatada */
  returnDate: Scalars['String']['output'];
  /** Data de assinatura formatada */
  signDate: Scalars['String']['output'];
};

export type TIpeTask = {
  __typename?: 'IpeTask';
  /** Descrição do EPI */
  descriptionIpe: Scalars['String']['output'];
  /** Descrição da tarefa */
  descriptionTask: Scalars['String']['output'];
  /** Nome da tarefa */
  nameTask: Scalars['String']['output'];
};

export type TIpesInfo = {
  __typename?: 'IpesInfo';
  /** Quantidade entregue */
  amount: Scalars['Float']['output'];
  /** Número do certificado */
  certificate?: Maybe<Scalars['String']['output']>;
  /** Nome do centro de custo */
  costCenter: Scalars['String']['output'];
  /** Identificador do centro de custo */
  costCenterId: Scalars['String']['output'];
  /** Descrição do IPE */
  description: Scalars['String']['output'];
  /** Nome do funcionário */
  employee: Scalars['String']['output'];
  /** CPF do funcionário */
  individualRegistration: Scalars['String']['output'];
  /** Nome do cargo */
  occupation: Scalars['String']['output'];
  /** Identificador do cargo */
  occupationId: Scalars['String']['output'];
  /** Matrícula do funcionário */
  registration: Scalars['String']['output'];
};

export type TIpesInfoSorted = {
  __typename?: 'IpesInfoSorted';
  /** Quantidade entregue */
  amount: Scalars['Float']['output'];
  /** Número do certificado */
  certificate?: Maybe<Scalars['String']['output']>;
  /** Descrição do IPE */
  description: Scalars['String']['output'];
  /** Nome do funcionário */
  employee: Scalars['String']['output'];
  /** CPF do funcionário */
  individualRegistration: Scalars['String']['output'];
  /** Matrícula do funcionário */
  registration: Scalars['String']['output'];
};

export type TItem = {
  __typename?: 'Item';
  /** Lista de itens */
  items: Array<Scalars['String']['output']>;
};

export type TItemsSteps = {
  __typename?: 'ItemsSteps';
  /** Imagem ilustrativa do grupo */
  image: TFirstStepsImage;
  /** Percentual de conclusão */
  percentage: Scalars['Float']['output'];
  /** Número de passos restantes */
  remainingSteps: Scalars['Float']['output'];
  /** Lista de passos do grupo */
  steps: Array<TSteps>;
  /** Resumo do grupo de passos */
  summary: Scalars['String']['output'];
  /** Tempo total estimado em minutos */
  time: Scalars['Float']['output'];
  /** Título do grupo de passos */
  title: Scalars['String']['output'];
};

/** Níveis de cetonas na urina */
export enum TKetonesEnum {
  /** Grande (80) */
  BigEighty = 'BigEighty',
  /** Grande (160) */
  BigOneHundredSixty = 'BigOneHundredSixty',
  /** Moderado (40) */
  Moderate = 'Moderate',
  /** Negativo */
  Negative = 'Negative',
  /** Pequeno (15) */
  Small = 'Small',
  /** Traço (5) */
  Trace = 'Trace'
}

export type TLastMeasurementByRiskUpdate = {
  /** Quantidade */
  amount: Scalars['Float']['input'];
  /** Data */
  date: Scalars['DateTime']['input'];
  /** Identificador */
  id: Scalars['String']['input'];
};

/** Lateralidade */
export enum TLaterality {
  /** Ambos */
  Both = 'both',
  /** Esquerda */
  Left = 'left',
  /** Não aplicável */
  NotApplicable = 'notApplicable',
  /** Direita */
  Right = 'right'
}

/** Leucócitos */
export enum TLeukocytesEnum {
  /** Grande */
  Big = 'Big',
  /** Moderado */
  Moderate = 'Moderate',
  /** Negativo */
  Negative = 'Negative',
  /** Pequeno */
  Small = 'Small',
  /** Traços */
  Trace = 'Trace'
}

export type TLevel = {
  __typename?: 'Level';
  /** Tipo de nível do plano */
  level: TPlanLevelType;
  /** Quantidade */
  quantity: Scalars['Float']['output'];
  /** Valor total */
  total: Scalars['Float']['output'];
  /** Valor unitário */
  value: Scalars['Float']['output'];
};

export type TLevelDiscount = {
  /** Tipo de nível do plano */
  level: TPlanLevelType;
  /** Desconto percentual */
  percentualDiscount?: InputMaybe<Scalars['Float']['input']>;
};

export type TLevelInput = {
  /** Tipo de nível do plano */
  level: TPlanLevelType;
  /** Quantidade */
  quantity: Scalars['Float']['input'];
  /** Valor total */
  total: Scalars['Float']['input'];
  /** Valor unitário */
  value: Scalars['Float']['input'];
};

export type TLevelsForecast = {
  __typename?: 'LevelsForecast';
  /** Níveis contratados */
  levels: Array<TLevel>;
  /** Data do próximo pagamento */
  nextPayment?: Maybe<Scalars['DateTime']['output']>;
  /** Valor total */
  total: Scalars['Float']['output'];
};

export type TLevelsForecastInput = {
  /** Tipo de nível do plano */
  planLevelType: TPlanLevelType;
  /** Quantidade */
  quantity: Scalars['Float']['input'];
};

export type TLineChart = {
  __typename?: 'LineChart';
  /** Nome */
  name: Scalars['String']['output'];
  /** Valores */
  values: Array<TData>;
};

export type TLineCharts = {
  __typename?: 'LineCharts';
  /** Dados */
  data: Array<TLineChart>;
};

export type TLocationStructure = {
  __typename?: 'LocationStructure';
  /** Detalhamento do teto */
  ceilingDetailing?: Maybe<Scalars['String']['output']>;
  /** Natureza do teto */
  ceilingNature?: Maybe<Scalars['String']['output']>;
  /** Descrição */
  description: Scalars['String']['output'];
  /** Detalhamento da exibição */
  displayDetailing?: Maybe<Scalars['String']['output']>;
  /** Natureza da exibição */
  displayNature?: Maybe<Scalars['String']['output']>;
  /** Detalhamento da porta */
  doorDetailing?: Maybe<Scalars['String']['output']>;
  /** Natureza da porta */
  doorNature?: Maybe<Scalars['String']['output']>;
  /** Detalhamento do primeiro revestimento */
  firstCoatDetailing?: Maybe<Scalars['String']['output']>;
  /** Natureza do primeiro revestimento */
  firstCoatNature?: Maybe<Scalars['String']['output']>;
  /** Detalhamento do piso */
  floorDetailing?: Maybe<Scalars['String']['output']>;
  /** Natureza do piso */
  floorNature?: Maybe<Scalars['String']['output']>;
  /** Detalhamento da iluminação */
  lightDetailing?: Maybe<Scalars['String']['output']>;
  /** Natureza da iluminação */
  lightNature?: Maybe<Scalars['String']['output']>;
  /** Detalhamento do segundo revestimento */
  secCoatDetailing?: Maybe<Scalars['String']['output']>;
  /** Natureza do segundo revestimento */
  secCoatNature?: Maybe<Scalars['String']['output']>;
  /** Detalhamento da parede */
  wallDetailing?: Maybe<Scalars['String']['output']>;
  /** Natureza da parede */
  wallNature?: Maybe<Scalars['String']['output']>;
  /** Detalhamento da janela */
  windowDetailing?: Maybe<Scalars['String']['output']>;
  /** Natureza da janela */
  windowNature?: Maybe<Scalars['String']['output']>;
};

export type TLogin = {
  __typename?: 'Login';
  /** Dados do login */
  data: TDataLogin;
  /** Token de autenticação */
  token: Scalars['String']['output'];
};

export type TMandate = {
  __typename?: 'Mandate';
  /** Candidatos */
  candidates?: Maybe<Array<TCandidate>>;
  /** Local da comissão */
  comissionLocal?: Maybe<Scalars['String']['output']>;
  /** Centros de custo */
  costCenters?: Maybe<Array<TCostCenterOnMandate>>;
  /** Data de término */
  dateEnd: Scalars['DateTime']['output'];
  /** Data de início */
  dateStart: Scalars['DateTime']['output'];
  /** Descrição */
  description: Scalars['String']['output'];
  /** Desabilitar datas */
  disableDates?: Maybe<Scalars['Boolean']['output']>;
  /** Atividade econômica */
  economicActivity?: Maybe<TEconomicActivity>;
  /** Identificador da atividade econômica */
  economicActivityId?: Maybe<Scalars['String']['output']>;
  /** Comissões eleitorais */
  electionComissions?: Maybe<Array<TElectionComission>>;
  /** Local da eleição */
  electionLocal?: Maybe<Scalars['String']['output']>;
  /** Ocorrências da eleição */
  electionOccurences?: Maybe<Scalars['String']['output']>;
  /** Presidente da eleição */
  electionPresident?: Maybe<TPerson>;
  /** Secretário da eleição */
  electionSecretary?: Maybe<TPerson>;
  /** Hora de término da eleição */
  endElectionHour?: Maybe<Scalars['String']['output']>;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Investigações */
  investigations?: Maybe<Array<TInvestigation>>;
  /** Eventos do mandato */
  mandateEvents?: Maybe<Array<TMandateEvent>>;
  /** Máximo de dias */
  maxDays?: Maybe<Scalars['Float']['output']>;
  /** Reuniões */
  meetings?: Maybe<Array<TMeeting>>;
  /** Observações finais da gestão */
  observations?: Maybe<Scalars['String']['output']>;
  /** Presidente da sessão */
  sessionPresident?: Maybe<TPerson>;
  /** Secretário da sessão */
  sessionSecretary?: Maybe<TPerson>;
  /** SIPATs */
  sipats?: Maybe<Array<TSipat>>;
  /** Hora de início da eleição */
  startElectionHour?: Maybe<Scalars['String']['output']>;
  /** Votos */
  votes?: Maybe<Array<TVote>>;
};

export type TMandateAction = {
  __typename?: 'MandateAction';
  /** Plano de ação */
  actionPlan: TActionPlan;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Mandato */
  mandate: TMandate;
};

export type TMandateActionInput = {
  /** Identificador do plano de ação */
  actionPlanId: Scalars['String']['input'];
  /** Identificador do mandato */
  mandateId: Scalars['String']['input'];
};

export type TMandateActionStatusChart = {
  __typename?: 'MandateActionStatusChart';
  entries: Array<TMandateActionStatusEntry>;
  hasData: Scalars['Boolean']['output'];
};

export type TMandateActionStatusEntry = {
  __typename?: 'MandateActionStatusEntry';
  label: Scalars['String']['output'];
  notRealized: Scalars['Int']['output'];
  realized: Scalars['Int']['output'];
};

export type TMandateCostCenter = {
  __typename?: 'MandateCostCenter';
  /** Centro de custo */
  costCenter: TCostCenter;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Mandato */
  mandate: TMandate;
};

export type TMandateCostCenterInput = {
  /** Identificador do centro de custo */
  costCenterId: Scalars['String']['input'];
  /** Identificador do mandato */
  mandateId: Scalars['String']['input'];
};

export type TMandateDashboard = {
  __typename?: 'MandateDashboard';
  meetingActionsPerMonth: TMandateActionStatusChart;
  meetingActionsTotal: TMandateMeetingActionsTotalChart;
  meetingParticipantsTotal: TMandateMeetingParticipantsChart;
  meetingsPerMonth: TMandateMeetingsChart;
  sipatCostPerMonth: TMandateMonetaryChart;
  suggestionPerMonth: TMandateMonthlyCountChart;
  suggestionStatusPerMonth: TMandateSuggestionStatusChart;
};

export type TMandateDepartment = {
  __typename?: 'MandateDepartment';
  /** Departamento */
  department: TDepartment;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Mandato */
  mandate: TMandate;
};

export type TMandateDepartmentInput = {
  /** Identificador do departamento */
  departmentId: Scalars['String']['input'];
  /** Identificador do mandato */
  mandateId: Scalars['String']['input'];
};

export type TMandateDimension = {
  __typename?: 'MandateDimension';
  /** CNAE */
  cnae: Scalars['String']['output'];
  /** Principal */
  main: TDimension;
  /** Suplente */
  substitute: TDimension;
  /** Total */
  total: Scalars['Float']['output'];
};

export type TMandateEvent = {
  __typename?: 'MandateEvent';
  /** Data de término */
  dateEnd: Scalars['DateTime']['output'];
  /** Data de início */
  dateStart: Scalars['DateTime']['output'];
  /** Indica se foi concluído */
  done: Scalars['Boolean']['output'];
  /** Evento */
  event?: Maybe<TEvent>;
  /** Extensão */
  extension: Scalars['Float']['output'];
  /** Identificador */
  id: Scalars['String']['output'];
  /** Mandato */
  mandate: TMandate;
  /** Identificador de referência */
  referenceId: Scalars['String']['output'];
};

export type TMandateEventInfo = {
  __typename?: 'MandateEventInfo';
  /** Data de término do evento */
  dateEnd?: Maybe<Scalars['DateTime']['output']>;
  /** Data de início do evento */
  dateStart?: Maybe<Scalars['DateTime']['output']>;
};

export type TMandateEventInput = {
  /** Data de término */
  dataEnd: Scalars['DateTime']['input'];
  /** Data de início */
  dateStart: Scalars['DateTime']['input'];
  /** Identificador do mandato */
  mandateId: Scalars['String']['input'];
  /** Identificador de referência */
  referenceId: Scalars['String']['input'];
};

export type TMandateEventInputByMandate = {
  /** Data de término */
  dataEnd: Scalars['DateTime']['input'];
  /** Data de início */
  dateStart: Scalars['DateTime']['input'];
  /** Identificador de referência */
  referenceId: Scalars['String']['input'];
};

/** Tipo de evento de mandato */
export enum TMandateEventType {
  /** Candidato */
  Candidate = 'Candidate',
  /** Votação */
  Vote = 'Vote'
}

export type TMandateEventUpdate = {
  /** Data de término */
  dateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de início */
  dateStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Indica se foi concluído */
  done?: InputMaybe<Scalars['Boolean']['input']>;
  /** Extensão */
  extension?: InputMaybe<Scalars['Float']['input']>;
  /** Identificador */
  id: Scalars['String']['input'];
};

export type TMandateInput = {
  /** Local da comissão */
  comissionLocal?: InputMaybe<Scalars['String']['input']>;
  /** Centros de custo */
  costCenters?: InputMaybe<Array<TCostCenterOnMandateInput>>;
  /** Data de término */
  dateEnd: Scalars['DateTime']['input'];
  /** Data de início */
  dateStart: Scalars['DateTime']['input'];
  /** Descrição */
  description: Scalars['String']['input'];
  /** Identificador da atividade econômica */
  economicActivityId?: InputMaybe<Scalars['String']['input']>;
  /** Comissões eleitorais */
  electionComissions?: InputMaybe<Array<TElectionComissionInputByMandate>>;
  /** Local da eleição */
  electionLocal?: InputMaybe<Scalars['String']['input']>;
  /** Ocorrências da eleição */
  electionOccurences?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do presidente da eleição */
  electionPresidentId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do secretário da eleição */
  electionSecretaryId?: InputMaybe<Scalars['String']['input']>;
  /** Hora de término da eleição */
  endElectionHour?: InputMaybe<Scalars['String']['input']>;
  /** Observações finais da gestão */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do presidente da sessão */
  sessionPresidentId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do secretário da sessão */
  sessionSecretaryId?: InputMaybe<Scalars['String']['input']>;
  /** Hora de início da eleição */
  startElectionHour?: InputMaybe<Scalars['String']['input']>;
};

export type TMandateLoss = {
  __typename?: 'MandateLoss';
  /** Componente (titular) que perdeu o mandato */
  component: TComponent;
  /** Data de criação do registro */
  createdAt: Scalars['DateTime']['output'];
  /** Reunião onde ocorreu a 5ª falta injustificada */
  fifthAbsenceMeeting?: Maybe<TMeeting>;
  /** Identificador único da perda de mandato */
  id: Scalars['String']['output'];
  /** Identificador do mandato */
  mandateId: Scalars['String']['output'];
  /** Pessoa titular que perdeu o mandato */
  person: TPerson;
  /** Motivo da perda */
  reasonCode: TMandateLossReason;
  /** Componente suplente promovido a titular */
  substituteComponent?: Maybe<TComponent>;
  /** ID do suplente promovido */
  substituteComponentId?: Maybe<Scalars['String']['output']>;
};

/** Motivo da perda automática de mandato CIPA */
export enum TMandateLossReason {
  /** Mais de 4 faltas injustificadas em reuniões ordinárias */
  Nr5Absences = 'nr5Absences'
}

export type TMandateMeetingActionsTotalChart = {
  __typename?: 'MandateMeetingActionsTotalChart';
  entries: Array<TMandateMeetingActionsTotalEntry>;
  hasData: Scalars['Boolean']['output'];
};

export type TMandateMeetingActionsTotalEntry = {
  __typename?: 'MandateMeetingActionsTotalEntry';
  label: Scalars['String']['output'];
  result: Scalars['Int']['output'];
};

export type TMandateMeetingParticipantsChart = {
  __typename?: 'MandateMeetingParticipantsChart';
  entries: Array<TMandateMeetingParticipantsEntry>;
  hasData: Scalars['Boolean']['output'];
};

export type TMandateMeetingParticipantsEntry = {
  __typename?: 'MandateMeetingParticipantsEntry';
  extraordinaryTotal: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  ordinaryTotal: Scalars['Int']['output'];
};

export type TMandateMeetingsChart = {
  __typename?: 'MandateMeetingsChart';
  entries: Array<TMandateMeetingsEntry>;
  hasData: Scalars['Boolean']['output'];
};

export type TMandateMeetingsEntry = {
  __typename?: 'MandateMeetingsEntry';
  extraordinary: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  ordinary: Scalars['Int']['output'];
};

export type TMandateMonetaryChart = {
  __typename?: 'MandateMonetaryChart';
  entries: Array<TMandateMonetaryEntry>;
  hasData: Scalars['Boolean']['output'];
};

export type TMandateMonetaryEntry = {
  __typename?: 'MandateMonetaryEntry';
  label: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type TMandateMonthlyCountChart = {
  __typename?: 'MandateMonthlyCountChart';
  entries: Array<TMandateMonthlyCountEntry>;
  hasData: Scalars['Boolean']['output'];
};

export type TMandateMonthlyCountEntry = {
  __typename?: 'MandateMonthlyCountEntry';
  label: Scalars['String']['output'];
  result: Scalars['Int']['output'];
};

export type TMandateSuggestionStatusChart = {
  __typename?: 'MandateSuggestionStatusChart';
  entries: Array<TMandateSuggestionStatusEntry>;
  hasData: Scalars['Boolean']['output'];
};

export type TMandateSuggestionStatusEntry = {
  __typename?: 'MandateSuggestionStatusEntry';
  canceledCount: Scalars['Int']['output'];
  finishedCount: Scalars['Int']['output'];
  inProcessCount: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  newCount: Scalars['Int']['output'];
};

export type TMandateTraining = {
  __typename?: 'MandateTraining';
  /** Anexos */
  attachments?: Maybe<Array<TAttachment>>;
  /** Erro de integração */
  errorIntegration?: Maybe<Scalars['String']['output']>;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Mandato */
  mandate: TMandate;
  /** Treinamento */
  training: TTraining;
  /** Urgência do treinamento */
  urgency: TTrainingUrgency;
};

export type TMandateTrainingInput = {
  /** Identificador do mandato */
  mandateId: Scalars['String']['input'];
  /** Identificador do treinamento */
  trainingId: Scalars['String']['input'];
  /** Urgência do treinamento */
  urgency: TTrainingUrgency;
};

export type TMandateTrainingUpdateInput = {
  /** Identificador */
  id: Scalars['String']['input'];
  /** Identificador do mandato */
  mandateId: Scalars['String']['input'];
  /** Identificador do treinamento */
  trainingId: Scalars['String']['input'];
  /** Urgência do treinamento */
  urgency: TTrainingUrgency;
};

export type TMandateUpdate = {
  /** Local da comissão */
  comissionLocal?: InputMaybe<Scalars['String']['input']>;
  /** Data de término */
  dateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de início */
  dateStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da atividade econômica */
  economicActivityId?: InputMaybe<Scalars['String']['input']>;
  /** Local da eleição */
  electionLocal?: InputMaybe<Scalars['String']['input']>;
  /** Ocorrências da eleição */
  electionOccurences?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do presidente da eleição */
  electionPresidentId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do secretário da eleição */
  electionSecretaryId?: InputMaybe<Scalars['String']['input']>;
  /** Hora de término da eleição */
  endElectionHour?: InputMaybe<Scalars['String']['input']>;
  /** Identificador */
  id: Scalars['String']['input'];
  /** Observações finais da gestão */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do presidente da sessão */
  sessionPresidentId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do secretário da sessão */
  sessionSecretaryId?: InputMaybe<Scalars['String']['input']>;
  /** Hora de início da eleição */
  startElectionHour?: InputMaybe<Scalars['String']['input']>;
};

export type TMandateValidity = {
  __typename?: 'MandateValidity';
  /** Data de término da validade */
  dateEnd?: Maybe<Scalars['DateTime']['output']>;
  /** Data de início da validade */
  dateStart?: Maybe<Scalars['DateTime']['output']>;
};

export type TManufacturer = {
  __typename?: 'Manufacturer';
  /** CNPJ do fabricante */
  cnpj: Scalars['String']['output'];
  /** Razão social */
  corporateName: Scalars['String']['output'];
  /** Natureza jurídica */
  nature: Scalars['String']['output'];
};

export type TMapUpload = {
  __typename?: 'MapUpload';
  id: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
  url: Scalars['S3UrlCloudFront']['output'];
};

/** Tipo de material */
export enum TMaterial {
  /** Acrílico */
  Acrylic = 'Acrylic',
  /** Barita */
  Barite = 'Barite',
  /** Carpete */
  Carpet = 'Carpet',
  /** Cimento */
  Cement = 'Cement',
  /** Concreto */
  Concrete = 'Concrete',
  /** Equivalente */
  Equivalent = 'Equivalent',
  /** Fluorescente */
  Fluorescent = 'Fluorescent',
  /** Vidro */
  Glass = 'Glass',
  /** Incandescente */
  Incandescent = 'Incandescent',
  /** Ferro */
  Iron = 'Iron',
  /** Chumbo */
  Lead = 'Lead',
  /** Vidro plumbífero */
  LeadGlass = 'LeadGlass',
  /** Alvenaria */
  Masonry = 'Masonry',
  /** Metal */
  Metal = 'Metal',
  /** Misto */
  Mixed = 'Mixed',
  /** Outros */
  Others = 'Others',
  /** Papelão */
  Paperboard = 'Paperboard',
  /** Paviflex */
  Paviflex = 'Paviflex',
  /** Gesso */
  Plaster = 'Plaster',
  /** Plástico */
  Plastic = 'Plastic',
  /** Plumbífero */
  Plumbiferous = 'Plumbiferous',
  /** Cerâmica */
  Pottery = 'Pottery',
  /** Emborrachado */
  Rubberized = 'Rubberized',
  /** Manta vinílica */
  VinylBlanket = 'VinylBlanket',
  /** Madeira */
  Wood = 'Wood',
  /** Zinco */
  Zinc = 'Zinc'
}

/** Unidades de medida */
export enum TMeasure {
  /** Número adimensional */
  NumeroAdimensional = 'NumeroAdimensional',
  /** A/m */
  AM = 'aM',
  /** atm */
  Atm = 'atm',
  /** dB(A) */
  DBa = 'dBA',
  /** dB(C) */
  DBc = 'dBC',
  /** dB (linear) */
  DBLinear = 'dBLinear',
  /** Dose anual */
  DoseAnual = 'doseAnual',
  /** Dose diária */
  DoseDiaria = 'doseDiaria',
  /** Dose mensal */
  DoseMensal = 'doseMensal',
  /** Dose trimestral */
  DoseTrimestral = 'doseTrimestral',
  /** μT */
  EmiT = 'emiT',
  /** f/cm3 */
  FCm3 = 'fCm3',
  /** GHz */
  Ghz = 'ghz',
  /** Gy */
  Gy = 'gy',
  /** h */
  H = 'h',
  /** Hz */
  Hz = 'hz',
  /** J/m2 */
  JM2 = 'jM2',
  /** kcal/h */
  KCalH = 'kCalH',
  /** kHz */
  KHz = 'kHz',
  /** kgf/cm2 */
  KgfCm2 = 'kgfCm2',
  /** kV/m */
  KvM = 'kvM',
  /** lx */
  Lx = 'lx',
  /** mA */
  MA = 'mA',
  /** m/s */
  MS = 'mS',
  /** m/s2 */
  MS2 = 'mS2',
  /** m/s1,75 */
  MS175 = 'mS175',
  /** mSv */
  MSv = 'mSv',
  /** mT */
  MT = 'mT',
  /** mW */
  MW = 'mW',
  /** mg/m3 */
  MgM3 = 'mgM3',
  /** min */
  Min = 'min',
  /** mJ/cm2 */
  MjCm2 = 'mjCm2',
  /** mppdc */
  Mppdc = 'mppdc',
  /** N/A */
  NA = 'nA',
  /** nm */
  Nm = 'nm',
  /** oC */
  OC = 'oC',
  /** % */
  Percentual = 'percentual',
  /** ppm */
  Ppm = 'ppm',
  /** Sv */
  Sv = 'sv',
  /** ufc/m3 */
  UfcM3 = 'ufcM3',
  /** un */
  Un = 'un',
  /** UR (%) */
  Ur = 'ur',
  /** V/m */
  VM = 'vM',
  /** W */
  W = 'w',
  /** W/m2 */
  WM2 = 'wM2'
}

/** Tipo de medida */
export enum TMeasureType {
  /** Crescente */
  Ascending = 'Ascending',
  /** Decrescente */
  Downward = 'Downward',
  /** Não aplicável */
  Na = 'NA'
}

/** Tipo de precisão da medição */
export enum TMeasurementAccuracyType {
  /** Acima de */
  Above = 'Above',
  /** Abaixo de */
  Below = 'Below',
  /** Igual a */
  Equal = 'Equal'
}

export type TMeasurementByAgentGroupItem = {
  __typename?: 'MeasurementByAgentGroupItem';
  /** Quantidade de medições do grupo */
  count: Scalars['Int']['output'];
  /** Grupo do agente */
  group: TAgentGroup;
};

export type TMeasurementByRisk = {
  __typename?: 'MeasurementByRisk';
  /** Tipo de precisão */
  accuracyType?: Maybe<TMeasurementAccuracyType>;
  /** Quantidade */
  amount: Scalars['Float']['output'];
  /** Empresa de calibração */
  calibrationCompany?: Maybe<Scalars['String']['output']>;
  /** Data de calibração */
  calibrationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Número de certificação */
  certificationNumber?: Maybe<Scalars['String']['output']>;
  /** Data */
  date: Scalars['DateTime']['output'];
  /** Possui RBC */
  hasRbc?: Maybe<THasRbc>;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Instrumento de medição */
  measuringInstrument: TMeasuringInstrument;
};

export type TMeasurementByRiskInput = {
  /** Tipo de precisão */
  accuracyType?: InputMaybe<TMeasurementAccuracyType>;
  /** Quantidade */
  amount: Scalars['Float']['input'];
  /** Empresa de calibração */
  calibrationCompany?: InputMaybe<Scalars['String']['input']>;
  /** Data de calibração */
  calibrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Número de certificação */
  certificationNumber?: InputMaybe<Scalars['String']['input']>;
  /** Data */
  date: Scalars['DateTime']['input'];
  /** Possui RBC */
  hasRbc?: InputMaybe<THasRbc>;
  /** Identificador do instrumento de medição */
  measuringInstrumentId: Scalars['String']['input'];
  /** Identificador do risco */
  riskId: Scalars['String']['input'];
};

export type TMeasurementByRiskUpdate = {
  /** Tipo de precisão */
  accuracyType?: InputMaybe<TMeasurementAccuracyType>;
  /** Quantidade */
  amount: Scalars['Float']['input'];
  /** Empresa de calibração */
  calibrationCompany?: InputMaybe<Scalars['String']['input']>;
  /** Data de calibração */
  calibrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Número de certificação */
  certificationNumber?: InputMaybe<Scalars['String']['input']>;
  /** Data */
  date: Scalars['DateTime']['input'];
  /** Possui RBC */
  hasRbc?: InputMaybe<THasRbc>;
  /** Identificador */
  id: Scalars['String']['input'];
  /** Identificador do instrumento de medição */
  measuringInstrumentId: Scalars['String']['input'];
  /** Identificador do risco */
  riskId: Scalars['String']['input'];
};

export type TMeasurementDeviceItem = {
  __typename?: 'MeasurementDeviceItem';
  /** Medições com valor acima do limite */
  above: Scalars['Int']['output'];
  /** Descrição do aparelho */
  description: Scalars['String']['output'];
  /** ID do aparelho de medição */
  id: Scalars['String']['output'];
  /** Grupo de agente mais frequente nas medições deste aparelho */
  primaryGroup?: Maybe<TAgentGroup>;
  /** Total de medições do aparelho no período */
  total: Scalars['Int']['output'];
};

export type TMeasurementDevicesChart = {
  __typename?: 'MeasurementDevicesChart';
  /** Distribuição de medições por grupo de agente */
  byAgentGroup: Array<TMeasurementByAgentGroupItem>;
  /** Indica se existem medições no período */
  hasMeasurement: Scalars['Boolean']['output'];
  /** Top 5 aparelhos mais utilizados */
  topDevices: Array<TMeasurementDeviceItem>;
  /** Total de medições acima do limite */
  totalAbove: Scalars['Int']['output'];
  /** Quantidade distinta de aparelhos no período */
  totalDevices: Scalars['Int']['output'];
  /** Total de medições no período */
  totalMeasurements: Scalars['Int']['output'];
};

export type TMeasurementOnRiskInput = {
  /** Tipo de precisão */
  accuracyType?: InputMaybe<TMeasurementAccuracyType>;
  /** Quantidade */
  amount: Scalars['Float']['input'];
  /** Empresa de calibração */
  calibrationCompany?: InputMaybe<Scalars['String']['input']>;
  /** Data de calibração */
  calibrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Número de certificação */
  certificationNumber?: InputMaybe<Scalars['String']['input']>;
  /** Data */
  date: Scalars['DateTime']['input'];
  /** Possui RBC */
  hasRbc?: InputMaybe<THasRbc>;
  /** Identificador do instrumento de medição */
  measuringInstrumentId: Scalars['String']['input'];
};

export type TMeasurementOnRiskUpdate = {
  /** Medições a serem criadas */
  toCreate: Array<TMeasurementOnRiskInput>;
  /** Medições a serem removidas */
  toRemove: Array<Scalars['DateTime']['input']>;
  /** Medições a serem atualizadas */
  toUpdate: Array<TMeasurementByRiskUpdate>;
};

export type TMeasurements = {
  __typename?: 'Measurements';
  actionLevel: Scalars['String']['output'];
  agent: Scalars['String']['output'];
  date: Scalars['String']['output'];
  measurementUnit: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TMeasuringInstrument = {
  __typename?: 'MeasuringInstrument';
  /** Anexos */
  attachments?: Maybe<Array<TAttachment>>;
  /** Data de calibração */
  calibrationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Descrição */
  description: Scalars['String']['output'];
  /** Identificador */
  id: Scalars['String']['output'];
  /** Indica se está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Identificador de referência */
  referenceId?: Maybe<Scalars['String']['output']>;
  /** Responsável */
  responsible?: Maybe<TPerson>;
  /** Identificador do responsável */
  responsibleId?: Maybe<Scalars['String']['output']>;
  /** Data de avaliação */
  valuationDate?: Maybe<Scalars['DateTime']['output']>;
};

export type TMeasuringInstrumentInput = {
  /** Data de calibração */
  calibrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Descrição */
  description: Scalars['String']['input'];
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do responsável */
  responsibleId?: InputMaybe<Scalars['String']['input']>;
  /** Data de avaliação */
  valuationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TMeasuringInstrumentUpdate = {
  /** Data de calibração */
  calibrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Identificador */
  id: Scalars['String']['input'];
  /** Indica se está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do responsável */
  responsibleId?: InputMaybe<Scalars['String']['input']>;
  /** Data de avaliação */
  valuationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TMedConsultReport = {
  __typename?: 'MedConsultReport';
  /** Descrição do medicamento */
  description: Scalars['String']['output'];
  /** Apresentação do medicamento */
  presentation: Scalars['String']['output'];
};

export type TMedRecordHealthPrograms = {
  __typename?: 'MedRecordHealthPrograms';
  /** Data de término */
  endDate: Scalars['String']['output'];
  /** Programa de saúde */
  healthProgram: Scalars['String']['output'];
  /** Data de início */
  startDate: Scalars['String']['output'];
};

export type TMedicalCertificate = {
  __typename?: 'MedicalCertificate';
  /** Data de término do afastamento */
  absenceDateEnd?: Maybe<Scalars['DateTime']['output']>;
  /** Data de início do afastamento */
  absenceDateStart?: Maybe<Scalars['DateTime']['output']>;
  /** Tipo de afastamento */
  absenceType?: Maybe<TAbsenceType>;
  /** Acidente */
  accident?: Maybe<TAccident>;
  /** Tipo de subsídio */
  allowanceType?: Maybe<TAllowanceType>;
  /** Quantidade de dias de tratamento */
  amountOfTreatmentDays: Scalars['Float']['output'];
  /** Anexos */
  attachments?: Maybe<Array<TAttachment>>;
  /** Data de término do benefício */
  benefitEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** Número do benefício */
  benefitNumber?: Maybe<Scalars['String']['output']>;
  /** Tipo de atestado */
  certificateType: TCertificateType;
  /** Estado do registro profissional do emissor externo */
  crmState?: Maybe<TState>;
  /** Data de término */
  dateEnd?: Maybe<Scalars['DateTime']['output']>;
  /** Data de início */
  dateStart: Scalars['DateTime']['output'];
  /** Registro profissional do emissor externo */
  doctorCrm?: Maybe<Scalars['String']['output']>;
  /** Nome do médico */
  doctorName?: Maybe<Scalars['String']['output']>;
  /** Snapshot granular das entries (UF + número + especialidade) preenchidas no formulário externo. Usado para hidratar a edição. */
  doctorRqeEntries?: Maybe<Array<TDoctorRqeEntry>>;
  /** Tipo de profissional */
  doctorType: TDoctorType;
  /** Identificador no ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** Erro de integração */
  errorIntegration?: Maybe<Scalars['String']['output']>;
  /** Internação */
  hospitalization?: Maybe<Scalars['Boolean']['output']>;
  /** CID */
  icd?: Maybe<TIcd>;
  /** Grupo do CID */
  icdGroup?: Maybe<TIcdGroup>;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Local médico */
  localMedical?: Maybe<Scalars['String']['output']>;
  /** Data da avaliação médica */
  medicalEvaluationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Identificador do prontuário médico */
  medicalRecordId: Scalars['String']['output'];
  /** Observação */
  observation?: Maybe<Scalars['String']['output']>;
  /** Origem */
  origin: TCertificateOrigin;
  /** Origem da retificação */
  originRectification?: Maybe<TOriginRectification>;
  /** Número do processo */
  processNumber?: Maybe<Scalars['String']['output']>;
  /** Reavaliação */
  revaluation?: Maybe<Scalars['Boolean']['output']>;
  /** Sequência */
  sequence?: Maybe<Scalars['String']['output']>;
  /** Telemedicina */
  telemedicine?: Maybe<Scalars['Boolean']['output']>;
  /** Tipo de processo */
  typeProcess?: Maybe<TTypeProcess>;
  /** Usuário */
  user?: Maybe<TUser>;
};

export type TMedicalCertificateByIcd = {
  __typename?: 'MedicalCertificateByIcd';
  /** Descrição */
  description: Scalars['String']['output'];
  /** Total */
  total: Scalars['Float']['output'];
};

export type TMedicalCertificateInput = {
  /** Data de término do afastamento */
  absenceDateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de início do afastamento */
  absenceDateStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador do tipo de afastamento */
  absenceTypeId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do acidente */
  accidentId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do tipo de subsídio */
  allowanceTypeId?: InputMaybe<Scalars['String']['input']>;
  /** Quantidade de dias de tratamento */
  amountOfTreatmentDays: Scalars['Float']['input'];
  /** Data de término do benefício */
  benefitEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Número do benefício */
  benefitNumber?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de atestado */
  certificateType: TCertificateType;
  /** Estado do registro profissional do emissor externo */
  crmState?: InputMaybe<TState>;
  /** Data de término */
  dateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de início */
  dateStart: Scalars['DateTime']['input'];
  /** Registro profissional do emissor externo */
  doctorCrm?: InputMaybe<Scalars['String']['input']>;
  /** Nome do médico */
  doctorName?: InputMaybe<Scalars['String']['input']>;
  /** RQEs do médico (até 2) para snapshot no documento. Quando origin=external, são digitados no formulário. Quando origin=internal, o backend ignora este campo e busca automaticamente os RQEs primários do médico cadastrado. */
  doctorRqeInput?: InputMaybe<Array<TDoctorRqeEntryInput>>;
  /** Tipo de profissional */
  doctorType: TDoctorType;
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Internação */
  hospitalization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador do grupo do CID */
  icdGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do CID */
  icdId?: InputMaybe<Scalars['String']['input']>;
  /** Local médico */
  localMedical?: InputMaybe<Scalars['String']['input']>;
  /** Data da avaliação médica */
  medicalEvaluationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador do prontuário médico */
  medicalRecordId: Scalars['String']['input'];
  /** Observação */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Origem */
  origin: TCertificateOrigin;
  /** Identificador do pré-atestado médico */
  preMedicalCertificateId?: InputMaybe<Scalars['String']['input']>;
  /** Reavaliação */
  revaluation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sequência */
  sequence?: InputMaybe<Scalars['String']['input']>;
  /** Telemedicina */
  telemedicine?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TMedicalCertificateReport = {
  __typename?: 'MedicalCertificateReport';
  address: Scalars['String']['output'];
  amountOfTreatmentDays: Scalars['Float']['output'];
  cnpj: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  crmState: Scalars['String']['output'];
  description: Scalars['String']['output'];
  doctorCrm: Scalars['String']['output'];
  doctorDocumentLabel: Scalars['String']['output'];
  doctorName: Scalars['String']['output'];
  /** Snapshot formatado dos RQEs do médico para impressão */
  doctorRqeDisplay?: Maybe<Scalars['String']['output']>;
  doctorTypeLabel: Scalars['String']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  footer: Scalars['String']['output'];
  hour: Scalars['String']['output'];
  icd: Scalars['String']['output'];
  individualRegistration: Scalars['String']['output'];
  isDeclaration?: Maybe<Scalars['Boolean']['output']>;
  isRetirement?: Maybe<Scalars['Boolean']['output']>;
  patientName: Scalars['String']['output'];
  showIcd: Scalars['Boolean']['output'];
  startDate: Scalars['String']['output'];
  telephone: Scalars['String']['output'];
};

export type TMedicalCertificateUpdate = {
  /** Data de término do afastamento */
  absenceDateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de início do afastamento */
  absenceDateStart?: InputMaybe<Scalars['DateTime']['input']>;
  absenceTypeId?: InputMaybe<Scalars['String']['input']>;
  accidentId?: InputMaybe<Scalars['String']['input']>;
  allowanceTypeId?: InputMaybe<Scalars['String']['input']>;
  amountOfTreatmentDays?: InputMaybe<Scalars['Float']['input']>;
  /** Data de término do benefício */
  benefitEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Número do benefício */
  benefitNumber?: InputMaybe<Scalars['String']['input']>;
  certificateType?: InputMaybe<TCertificateType>;
  /** Estado do registro profissional do emissor externo */
  crmState?: InputMaybe<TState>;
  dateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  dateStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Registro profissional do emissor externo */
  doctorCrm?: InputMaybe<Scalars['String']['input']>;
  /** Nome do médico */
  doctorName?: InputMaybe<Scalars['String']['input']>;
  /** RQEs do médico (até 2) para snapshot no documento. Quando origin=external, são digitados no formulário. Quando origin=internal, o backend ignora este campo e busca automaticamente os RQEs primários do médico cadastrado. */
  doctorRqeInput?: InputMaybe<Array<TDoctorRqeEntryInput>>;
  doctorType?: InputMaybe<TDoctorType>;
  /** Internação */
  hospitalization?: InputMaybe<Scalars['Boolean']['input']>;
  icdGroupId?: InputMaybe<Scalars['String']['input']>;
  icdId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** Local médico */
  localMedical?: InputMaybe<Scalars['String']['input']>;
  /** Data da avaliação médica */
  medicalEvaluationDate?: InputMaybe<Scalars['DateTime']['input']>;
  medicalRecordId?: InputMaybe<Scalars['String']['input']>;
  /** Observação */
  observation?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<TCertificateOrigin>;
  originRectification?: InputMaybe<TOriginRectification>;
  processNumber?: InputMaybe<Scalars['String']['input']>;
  /** Reavaliação */
  revaluation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sequência */
  sequence?: InputMaybe<Scalars['String']['input']>;
  /** Telemedicina */
  telemedicine?: InputMaybe<Scalars['Boolean']['input']>;
  typeProcess?: InputMaybe<TTypeProcess>;
};

export type TMedicalConsultation = {
  __typename?: 'MedicalConsultation';
  /** Data de cancelamento */
  cancelDate?: Maybe<Scalars['DateTime']['output']>;
  /** Exames realizados na consulta */
  exams?: Maybe<Array<TExams>>;
  /** Data prevista da consulta */
  expectedDate: Scalars['DateTime']['output'];
  /** Data de emissão */
  issueDate?: Maybe<Scalars['DateTime']['output']>;
  /** Observações sobre a consulta */
  observation?: Maybe<Scalars['String']['output']>;
  /** Situação da consulta */
  situation?: Maybe<Scalars['String']['output']>;
  /** Tipo de consulta */
  type: Scalars['String']['output'];
};

export type TMedicalRecord = {
  __typename?: 'MedicalRecord';
  /** Idade */
  age: Scalars['Float']['output'];
  /** Etilismo */
  alcoholism: Scalars['Boolean']['output'];
  /** Frequência do etilismo */
  alcoholismFrequency?: Maybe<Scalars['String']['output']>;
  /** Período de etilismo */
  alcoholismPeriod?: Maybe<Scalars['String']['output']>;
  /** Tipo de etilismo */
  alcoholismType?: Maybe<Scalars['String']['output']>;
  /** Quantidade consumida */
  amountConsumed?: Maybe<Scalars['Float']['output']>;
  /** Tamanho do braço */
  armSize?: Maybe<Scalars['Float']['output']>;
  /** Anexos */
  attachments?: Maybe<Array<TAttachment>>;
  /** Data de nascimento */
  birthday: Scalars['DateTime']['output'];
  /** Doador de sangue */
  bloodDonator: Scalars['Boolean']['output'];
  /** Tipo sanguíneo */
  bloodType: TBloodType;
  /** Filial */
  branch: Scalars['String']['output'];
  /** Candidato */
  candidate: Scalars['Boolean']['output'];
  /** Risco cardiovascular */
  cardiovascularRisk: Scalars['Float']['output'];
  /** Portador de doenças crônicas ou em tratamento */
  chronicDiseaseOrTreatment: Scalars['Boolean']['output'];
  /** Detalhes de doenças crônicas ou tratamentos em andamento */
  chronicDiseaseOrTreatmentDetails?: Maybe<Scalars['String']['output']>;
  /** Questionários clínicos */
  clinicalQuizzes: Array<TClinicalQuiz>;
  /** Uso de medicamento controlado */
  controlledMedication: Scalars['Boolean']['output'];
  /** Detalhes do medicamento controlado */
  controlledMedicationDetails?: Maybe<Scalars['String']['output']>;
  /** Deficiências */
  deficiencies: Array<TDeficiency>;
  /** Diabetes */
  diabetes: Scalars['Boolean']['output'];
  /** Pressão diastólica */
  diastolicPressure?: Maybe<Scalars['Float']['output']>;
  /** Altura do cotovelo */
  elbowHeight?: Maybe<Scalars['Float']['output']>;
  /** Cor dos olhos */
  eyeColor?: Maybe<TEyeColor>;
  /** Altura dos olhos */
  eyeHeight?: Maybe<Scalars['Float']['output']>;
  /** Tamanho do antebraço */
  forearmSize?: Maybe<Scalars['Float']['output']>;
  /** Gênero */
  gender: TGender;
  /** Gênero */
  genderEnum?: Maybe<TGenderEnum>;
  /** Cor do cabelo */
  hairColor?: Maybe<THairColor>;
  /** Tamanho da mão */
  handSize?: Maybe<Scalars['Float']['output']>;
  /** Idade cardíaca */
  heartAge: Scalars['Float']['output'];
  /** Altura */
  height: Scalars['Float']['output'];
  /** Histórico */
  historic?: Maybe<Scalars['String']['output']>;
  /** Tratamento de hipertensão */
  hypertensionTreatment: Scalars['Boolean']['output'];
  /** Identificador */
  id: Scalars['String']['output'];
  /** Texto do IMC */
  imcText: Scalars['String']['output'];
  /** Valor do IMC */
  imcValue: Scalars['Float']['output'];
  /** Registro individual */
  individualRegistration: Scalars['String']['output'];
  /** Altura do joelho */
  kneeHeight?: Maybe<Scalars['Float']['output']>;
  /** Data do último ASO não cancelado */
  lastAsoDate?: Maybe<Scalars['DateTime']['output']>;
  /** Último atestado médico */
  lastMedicalCertificate?: Maybe<Scalars['DateTime']['output']>;
  /** Comprimento da perna */
  legLength?: Maybe<Scalars['Float']['output']>;
  /** Atestados médicos */
  medicalCertificates: Array<TMedicalCertificate>;
  /** Consultas do prontuário */
  medicalRecordConsultations: Array<TConsultation>;
  /** Programas de saúde do prontuário */
  medicalRecordHealthPrograms: Array<TMedicalRecordHealthProgram>;
  /** Vacinas do prontuário */
  medicalRecordVaccines: Array<TMedicalRecordVaccine>;
  /** Encaminhamentos médicos */
  medicalReferrals: Array<TMedicalReferral>;
  /** Restrições médicas */
  medicalRestrictions: Array<TMedicalRestriction>;
  /** Acompanhamento de saúde mental */
  mentalHealthFollowUp: Scalars['Boolean']['output'];
  /** Frequência do acompanhamento de saúde mental */
  mentalHealthFollowUpFrequency?: Maybe<Scalars['String']['output']>;
  /** Há quanto tempo realiza acompanhamento de saúde mental */
  mentalHealthFollowUpPeriod?: Maybe<Scalars['String']['output']>;
  /** Nome */
  name: Scalars['String']['output'];
  /** Linha do mamilo */
  nippleLine?: Maybe<Scalars['Float']['output']>;
  /** Atestados ocupacionais */
  occupationalCertificates: Array<TOccupationalHealthCertificate>;
  /** Pessoa */
  person?: Maybe<TPerson>;
  /** Identificador da pessoa */
  personId?: Maybe<Scalars['String']['output']>;
  /** Prática de atividade física */
  physicalActivity: Scalars['Boolean']['output'];
  /** Frequência da atividade física */
  physicalActivityFrequency?: Maybe<Scalars['String']['output']>;
  /** Atividade física mais praticada */
  physicalActivityMain?: Maybe<Scalars['String']['output']>;
  /** Altura púbica */
  pubicHeight?: Maybe<Scalars['Float']['output']>;
  /** Pulso */
  pulse?: Maybe<Scalars['Float']['output']>;
  /** Tamanho do calçado */
  shoeSize?: Maybe<Scalars['Float']['output']>;
  /** Cor da pele */
  skinColor?: Maybe<TSkinColor>;
  /** Fumante */
  smoker: Scalars['Boolean']['output'];
  /** Nome social */
  socialName?: Maybe<Scalars['String']['output']>;
  /** Sugestão */
  suggestion?: Maybe<Scalars['String']['output']>;
  /** Pressão sistólica */
  systolicPressure?: Maybe<Scalars['Float']['output']>;
  /** Período de tabagismo */
  tamagistPeriod?: Maybe<Scalars['Float']['output']>;
  /** Temperatura */
  temperature?: Maybe<Scalars['Float']['output']>;
  /** Peso */
  weight: Scalars['Float']['output'];
};

export type TMedicalRecordCertificates = {
  __typename?: 'MedicalRecordCertificates';
  /** Data de término */
  endDate: Scalars['String']['output'];
  /** CID */
  icd: Scalars['String']['output'];
  /** Data de início */
  startDate: Scalars['String']['output'];
};

export type TMedicalRecordDashboard = {
  __typename?: 'MedicalRecordDashboard';
  /** Gráfico de ausências */
  absenceChart: TChartData;
  /** Gráfico de idade */
  ageChart: Array<TAgeChart>;
  /** Gráfico de natureza de ASO */
  asoNatureChart: TAsoNatureChart;
  /** Gráfico de quantidade de ASO */
  asoQuantityChart: TAsoQuantityChart;
  /** Gráfico de situação de ASO */
  asoSituationChart: TAsoSituationChart;
  /** Gráfico de tipo sanguíneo */
  bloodTypeChart: TBloodTypeChart;
  /** Gráfico de atestados por dia */
  certificatePerDayChart: TCertificatePerDayChart;
  /** Gráfico de motivos de atestado */
  certificateReasonsChart: TChartData;
  /** Gráfico de centro de custo */
  costCenterChart: TCostCenterOccupationChart;
  /** Gráfico de deficiências por centro de custo */
  costCenterDeficienciesChart: TCostCenterOccupationDeficienciesChart;
  /** Gráfico de volume de centro de custo */
  costCenterVolumeChart: TCostCenterVolumeChart;
  /** Gráfico de dias ausentes */
  daysAbsentChart: TDaysAbsentChart;
  /** Dias perdidos em atestados com CID informado */
  daysLostWithIcdChart: TDaysLostWithIcdChart;
  /** Dias perdidos em atestados sem CID informado */
  daysLostWithoutIcdChart: TDaysLostWithoutIcdChart;
  /** Gráfico de deficiências */
  deficienciesChart: TDeficienciesChart;
  /** Gráfico de diabetes */
  diabetesChart: Array<TData>;
  /** Gráfico de empregados */
  employeeChart: TVolumeChart;
  /** Gráfico de volume de empregados */
  employeeVolumeChart: TEmployeeVolumeChart;
  /** Gráfico de exames realizados */
  examsDoneChart: TExamsDoneChart;
  /** Gráfico de programa de saúde */
  healthProgramChart: THealthProgramChart;
  /** Gráfico de IMC */
  imcChart: Array<TImcChart>;
  /** Gráfico de dias perdidos */
  lostDaysChart: TVolumeChart;
  /** Gráfico de restrições médicas */
  medicalRestrictionsChart: TMedicalRestrictionsChart;
  /** Distribuição dos top CIDs com NTEP */
  ntepDistributionChart: TNtepDistributionChart;
  /** Evolução mensal de CIDs com relação ao NTEP */
  ntepEvolutionChart: TNtepEvolutionChart;
  /** Gráfico de ocupação */
  occupationChart: TCostCenterOccupationChart;
  /** Gráfico de deficiências por ocupação */
  occupationDeficienciesChart: TCostCenterOccupationDeficienciesChart;
  /** Gráficos de questionários */
  quizzesCharts: TQuizzesCharts;
  /** Gráfico de encaminhamentos */
  referralsChart: TReferralsChart;
  /** Gráfico de quantidade de encaminhamentos */
  referralsQuantityChart: TReferralsQuantityChart;
  /** Gráfico de risco */
  riskChart: Array<TData>;
  /** Gráfico de fumantes */
  smokerChart: Array<TData>;
  /** Top 5 CIDs mais frequentes nos atestados */
  topIcdsChart: TTopIcdsChart;
  /** Gráfico de vacinas */
  vaccineChart: TVaccineChart;
  /** Gráfico de quantidade de vacinas */
  vaccineQuantityChart: TVaccineQuantityChart;
  /** Variação anual de dias perdidos (12m atuais vs 12m anteriores) */
  yearlyVariationChart: TYearlyVariationChart;
};

export type TMedicalRecordDeficiencies = {
  __typename?: 'MedicalRecordDeficiencies';
  /** Data */
  date: Scalars['String']['output'];
  /** CID */
  icd: Scalars['String']['output'];
  /** Data de recuperação */
  recoveryDate: Scalars['String']['output'];
  /** Tipo */
  type: Scalars['String']['output'];
};

export type TMedicalRecordDiagnostics = {
  __typename?: 'MedicalRecordDiagnostics';
  /** Atendimento */
  attendance: Scalars['String']['output'];
  /** Queixa */
  complaint: Scalars['String']['output'];
  /** Diagnóstico */
  diagnostic: Scalars['String']['output'];
  /** Data do diagnóstico */
  diagnosticDate: Scalars['String']['output'];
  /** Pressão diastólica */
  diastolicPressure: Scalars['String']['output'];
  /** Altura */
  height: Scalars['String']['output'];
  /** CID */
  icd: Scalars['String']['output'];
  /** Identificador */
  id: Scalars['String']['output'];
  /** Indicação */
  indication: Scalars['String']['output'];
  /** Diagnóstico médico */
  medicalDiagnostic: Scalars['String']['output'];
  /** Medicamentos */
  medicines: Array<Scalars['String']['output']>;
  /** Pressão sistólica */
  systolicPressure: Scalars['String']['output'];
  /** Peso */
  weight: Scalars['String']['output'];
};

export type TMedicalRecordExams = {
  __typename?: 'MedicalRecordExams';
  /** Data */
  date: Scalars['String']['output'];
  /** Exame */
  exam: Scalars['String']['output'];
  /** Natureza */
  nature: Scalars['String']['output'];
  /** Observação */
  observation: Scalars['String']['output'];
  /** Resultado */
  result: Scalars['String']['output'];
  /** Indicação do resultado */
  resutIndication: Scalars['String']['output'];
};

export type TMedicalRecordFilter = {
  /** Aniversários */
  birthdays?: InputMaybe<TDateRange>;
  /** Tipos sanguíneos */
  bloodTypes?: InputMaybe<Array<TBloodType>>;
  /** Centros de custo */
  costCenters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Departamentos */
  departments?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Gêneros */
  genders?: InputMaybe<Array<TGender>>;
  /** Atestados médicos */
  medicalCertificates?: InputMaybe<TDateRange>;
  /** Ocupações */
  occupations?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TMedicalRecordHealthProgram = {
  __typename?: 'MedicalRecordHealthProgram';
  /** Data de término */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Programa de saúde */
  healthProgram: THealthProgram;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Observações */
  observations?: Maybe<Scalars['String']['output']>;
  /** Data de realização */
  realizationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Identificador do responsável */
  responsibleId?: Maybe<Scalars['String']['output']>;
  /** Data de início */
  startDate: Scalars['DateTime']['output'];
};

export type TMedicalRecordHealthProgramInput = {
  /** Data de término */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador do programa de saúde */
  healthProgramId: Scalars['String']['input'];
  /** Identificador do prontuário médico */
  medicalRecordId: Scalars['String']['input'];
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** Data de realização */
  realizationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador do responsável */
  responsibleId?: InputMaybe<Scalars['String']['input']>;
  /** Data de início */
  startDate: Scalars['DateTime']['input'];
};

export type TMedicalRecordHealthProgramUpdate = {
  /** Data de término */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador do programa de saúde */
  healthProgramId: Scalars['String']['input'];
  /** Identificador */
  id: Scalars['String']['input'];
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** Data de realização */
  realizationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador do responsável */
  responsibleId?: InputMaybe<Scalars['String']['input']>;
  /** Data de início */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TMedicalRecordInput = {
  /** Etilismo */
  alcoholism?: InputMaybe<Scalars['Boolean']['input']>;
  /** Frequência do etilismo */
  alcoholismFrequency?: InputMaybe<Scalars['String']['input']>;
  /** Período de etilismo */
  alcoholismPeriod?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de etilismo */
  alcoholismType?: InputMaybe<Scalars['String']['input']>;
  /** Quantidade consumida */
  amountConsumed?: InputMaybe<Scalars['Float']['input']>;
  /** Tamanho do braço */
  armSize?: InputMaybe<Scalars['Float']['input']>;
  /** Data de nascimento */
  birthday: Scalars['DateTime']['input'];
  /** Doador de sangue */
  bloodDonator: Scalars['Boolean']['input'];
  /** Tipo sanguíneo */
  bloodType: TBloodType;
  /** Candidato */
  candidate: Scalars['Boolean']['input'];
  /** Portador de doenças crônicas ou em tratamento */
  chronicDiseaseOrTreatment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Detalhes de doenças crônicas ou tratamentos em andamento */
  chronicDiseaseOrTreatmentDetails?: InputMaybe<Scalars['String']['input']>;
  /** Uso de medicamento controlado */
  controlledMedication?: InputMaybe<Scalars['Boolean']['input']>;
  /** Detalhes do medicamento controlado */
  controlledMedicationDetails?: InputMaybe<Scalars['String']['input']>;
  /** Diabetes */
  diabetes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Pressão diastólica */
  diastolicPressure?: InputMaybe<Scalars['Float']['input']>;
  /** Altura do cotovelo */
  elbowHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Cor dos olhos */
  eyeColor?: InputMaybe<TEyeColor>;
  /** Altura dos olhos */
  eyeHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Tamanho do antebraço */
  forearmSize?: InputMaybe<Scalars['Float']['input']>;
  /** Gênero */
  gender: TGender;
  /** Gênero */
  genderEnum?: InputMaybe<TGenderEnum>;
  /** Cor do cabelo */
  hairColor?: InputMaybe<THairColor>;
  /** Tamanho da mão */
  handSize?: InputMaybe<Scalars['Float']['input']>;
  /** Altura */
  height: Scalars['Float']['input'];
  /** Histórico */
  historic?: InputMaybe<Scalars['String']['input']>;
  /** Tratamento de hipertensão */
  hypertensionTreatment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Registro individual */
  individualRegistration: Scalars['String']['input'];
  /** Altura do joelho */
  kneeHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Data do último ASO não cancelado */
  lastAsoDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Comprimento da perna */
  legLength?: InputMaybe<Scalars['Float']['input']>;
  /** Acompanhamento de saúde mental */
  mentalHealthFollowUp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Frequência do acompanhamento de saúde mental */
  mentalHealthFollowUpFrequency?: InputMaybe<Scalars['String']['input']>;
  /** Há quanto tempo realiza acompanhamento de saúde mental */
  mentalHealthFollowUpPeriod?: InputMaybe<Scalars['String']['input']>;
  /** Nome */
  name: Scalars['String']['input'];
  /** Linha do mamilo */
  nippleLine?: InputMaybe<Scalars['Float']['input']>;
  /** Identificador da pessoa */
  personId?: InputMaybe<Scalars['String']['input']>;
  /** Prática de atividade física */
  physicalActivity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Frequência da atividade física */
  physicalActivityFrequency?: InputMaybe<Scalars['String']['input']>;
  /** Atividade física mais praticada */
  physicalActivityMain?: InputMaybe<Scalars['String']['input']>;
  /** Altura púbica */
  pubicHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Pulso */
  pulse?: InputMaybe<Scalars['Float']['input']>;
  /** Tamanho do calçado */
  shoeSize?: InputMaybe<Scalars['Float']['input']>;
  /** Cor da pele */
  skinColor?: InputMaybe<TSkinColor>;
  /** Fumante */
  smoker: Scalars['Boolean']['input'];
  /** Nome social */
  socialName?: InputMaybe<Scalars['String']['input']>;
  /** Sugestão */
  suggestion?: InputMaybe<Scalars['String']['input']>;
  /** Pressão sistólica */
  systolicPressure?: InputMaybe<Scalars['Float']['input']>;
  /** Período de tabagismo */
  tamagistPeriod?: InputMaybe<Scalars['Float']['input']>;
  /** Temperatura */
  temperature?: InputMaybe<Scalars['Float']['input']>;
  /** Peso */
  weight: Scalars['Float']['input'];
};

export type TMedicalRecordName = {
  __typename?: 'MedicalRecordName';
  /** Nome */
  name: Scalars['String']['output'];
};

/** Campos para ordenação de registros médicos */
export enum TMedicalRecordOrderByFields {
  /** Nome */
  Name = 'Name',
  /** Número */
  Registration = 'Registration'
}

export type TMedicalRecordOrderByInput = {
  /** Campo */
  field?: InputMaybe<TMedicalRecordOrderByFields>;
  /** Tipo */
  type?: InputMaybe<TOrderBy>;
};

export type TMedicalRecordQueryInput = {
  /** Filtro */
  filter?: InputMaybe<TMedicalRecordFilter>;
  /** Identificador */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Apenas ativos */
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TMedicalRecordReport = {
  __typename?: 'MedicalRecordReport';
  /** Endereço */
  address: Scalars['String']['output'];
  /** Quantidade consumida */
  amountConsumed: Scalars['String']['output'];
  /** Data de nascimento */
  birthday: Scalars['String']['output'];
  /** Doador de sangue */
  bloodDonator: Scalars['String']['output'];
  /** Tipo sanguíneo */
  bloodType: Scalars['String']['output'];
  /** Deficiências */
  deficiencies?: Maybe<TMedicalRecordDeficiencies>;
  /** Diagnósticos */
  diagnostics?: Maybe<TMedicalRecordDiagnostics>;
  /** Exames */
  exams?: Maybe<TMedicalRecordExams>;
  /** Rodapé */
  footer: Scalars['String']['output'];
  /** Gênero */
  gender: Scalars['String']['output'];
  /** Programas de saúde */
  healthPrograms?: Maybe<TMedRecordHealthPrograms>;
  /** Altura */
  height: Scalars['String']['output'];
  /** Implantação */
  implantation: Scalars['String']['output'];
  /** Atestados médicos */
  medicalCertificates?: Maybe<TMedicalRecordCertificates>;
  /** Restrições médicas */
  medicalRestrictions?: Maybe<Array<TMedicalRecordRestrictions>>;
  /** Nome */
  name: Scalars['String']['output'];
  /** Bairro */
  neighborhood: Scalars['String']['output'];
  /** Fumante */
  smoker: Scalars['String']['output'];
  /** Período de tabagismo */
  tamagistPeriod: Scalars['String']['output'];
  /** Peso */
  weight: Scalars['String']['output'];
};

export type TMedicalRecordRestrictions = {
  __typename?: 'MedicalRecordRestrictions';
  /** Descrição */
  description: Scalars['String']['output'];
  /** Data de término */
  endDate: Scalars['String']['output'];
  /** Data de início */
  startDate: Scalars['String']['output'];
};

export type TMedicalRecordUpdate = {
  /** Etilismo */
  alcoholism?: InputMaybe<Scalars['Boolean']['input']>;
  /** Frequência do etilismo */
  alcoholismFrequency?: InputMaybe<Scalars['String']['input']>;
  /** Período de etilismo */
  alcoholismPeriod?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de etilismo */
  alcoholismType?: InputMaybe<Scalars['String']['input']>;
  /** Quantidade consumida */
  amountConsumed?: InputMaybe<Scalars['Float']['input']>;
  /** Tamanho do braço */
  armSize?: InputMaybe<Scalars['Float']['input']>;
  /** Anexos a serem removidos */
  attachmentsToRemove?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Data de nascimento */
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  /** Doador de sangue */
  bloodDonator?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tipo sanguíneo */
  bloodType?: InputMaybe<TBloodType>;
  /** Candidato */
  candidate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Portador de doenças crônicas ou em tratamento */
  chronicDiseaseOrTreatment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Detalhes de doenças crônicas ou tratamentos em andamento */
  chronicDiseaseOrTreatmentDetails?: InputMaybe<Scalars['String']['input']>;
  /** Uso de medicamento controlado */
  controlledMedication?: InputMaybe<Scalars['Boolean']['input']>;
  /** Detalhes do medicamento controlado */
  controlledMedicationDetails?: InputMaybe<Scalars['String']['input']>;
  /** Diabetes */
  diabetes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Pressão diastólica */
  diastolicPressure?: InputMaybe<Scalars['Float']['input']>;
  /** Altura do cotovelo */
  elbowHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Cor dos olhos */
  eyeColor?: InputMaybe<TEyeColor>;
  /** Altura dos olhos */
  eyeHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Tamanho do antebraço */
  forearmSize?: InputMaybe<Scalars['Float']['input']>;
  /** Gênero */
  gender?: InputMaybe<TGender>;
  /** Gênero */
  genderEnum?: InputMaybe<TGenderEnum>;
  /** Cor do cabelo */
  hairColor?: InputMaybe<THairColor>;
  /** Tamanho da mão */
  handSize?: InputMaybe<Scalars['Float']['input']>;
  /** Altura */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** Histórico */
  historic?: InputMaybe<Scalars['String']['input']>;
  /** Tratamento de hipertensão */
  hypertensionTreatment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador */
  id: Scalars['String']['input'];
  /** Registro individual */
  individualRegistration?: InputMaybe<Scalars['String']['input']>;
  /** Altura do joelho */
  kneeHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Data do último ASO não cancelado */
  lastAsoDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Último atestado médico */
  lastMedicalCertificate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Comprimento da perna */
  legLength?: InputMaybe<Scalars['Float']['input']>;
  /** Acompanhamento de saúde mental */
  mentalHealthFollowUp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Frequência do acompanhamento de saúde mental */
  mentalHealthFollowUpFrequency?: InputMaybe<Scalars['String']['input']>;
  /** Há quanto tempo realiza acompanhamento de saúde mental */
  mentalHealthFollowUpPeriod?: InputMaybe<Scalars['String']['input']>;
  /** Nome */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Linha do mamilo */
  nippleLine?: InputMaybe<Scalars['Float']['input']>;
  /** Identificador da pessoa */
  personId?: InputMaybe<Scalars['String']['input']>;
  /** Prática de atividade física */
  physicalActivity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Frequência da atividade física */
  physicalActivityFrequency?: InputMaybe<Scalars['String']['input']>;
  /** Atividade física mais praticada */
  physicalActivityMain?: InputMaybe<Scalars['String']['input']>;
  /** Altura púbica */
  pubicHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Pulso */
  pulse?: InputMaybe<Scalars['Float']['input']>;
  /** Tamanho do calçado */
  shoeSize?: InputMaybe<Scalars['Float']['input']>;
  /** Cor da pele */
  skinColor?: InputMaybe<TSkinColor>;
  /** Fumante */
  smoker?: InputMaybe<Scalars['Boolean']['input']>;
  /** Nome social */
  socialName?: InputMaybe<Scalars['String']['input']>;
  /** Sugestão */
  suggestion?: InputMaybe<Scalars['String']['input']>;
  /** Pressão sistólica */
  systolicPressure?: InputMaybe<Scalars['Float']['input']>;
  /** Período de tabagismo */
  tamagistPeriod?: InputMaybe<Scalars['Float']['input']>;
  /** Temperatura */
  temperature?: InputMaybe<Scalars['Float']['input']>;
  /** Peso */
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type TMedicalRecordVaccinationPlanning = {
  __typename?: 'MedicalRecordVaccinationPlanning';
  currentDose: TVaccineDoseEnum;
  date: Scalars['DateTime']['output'];
  dose: Scalars['Float']['output'];
  medicalRecordId: Scalars['String']['output'];
  personName: Scalars['String']['output'];
  vaccineId: Scalars['String']['output'];
  vaccineName: Scalars['String']['output'];
};

export type TMedicalRecordVaccinationPlanningReport = {
  __typename?: 'MedicalRecordVaccinationPlanningReport';
  branch: Scalars['String']['output'];
  currentDose: Scalars['String']['output'];
  date: Scalars['String']['output'];
  medicalRecordId: Scalars['String']['output'];
  numberOfDoses: Scalars['Float']['output'];
  personName: Scalars['String']['output'];
  registration: Scalars['String']['output'];
  status: Scalars['String']['output'];
  vaccineName: Scalars['String']['output'];
};

export type TMedicalRecordVaccine = {
  __typename?: 'MedicalRecordVaccine';
  /** Lote da vacina */
  batch?: Maybe<Scalars['String']['output']>;
  /** Biometria */
  biometry?: Maybe<TVaccineBiometry>;
  /** Dose atual */
  currentDose?: Maybe<TVaccineDoseEnum>;
  /** Data */
  date: Scalars['DateTime']['output'];
  /** Número da dose */
  dose: Scalars['Float']['output'];
  /** Identificador único de ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** Identificador único de registro médico de vacina */
  id: Scalars['String']['output'];
  /** Identificador único de registro médico */
  medicalRecordId: Scalars['String']['output'];
  /** Status da aplicação da vacina */
  status: TMedicalRecordVaccineStatus;
  /** Vacina */
  vaccine: TVaccine;
};

export type TMedicalRecordVaccineInput = {
  batch?: InputMaybe<Scalars['String']['input']>;
  currentDose?: InputMaybe<TVaccineDoseEnum>;
  date: Scalars['DateTime']['input'];
  dose: Scalars['Float']['input'];
  medicalRecordId: Scalars['String']['input'];
  status: TMedicalRecordVaccineStatus;
  vaccineId: Scalars['String']['input'];
};

export type TMedicalRecordVaccinePrint = {
  __typename?: 'MedicalRecordVaccinePrint';
  admissionDate?: Maybe<Scalars['String']['output']>;
  birthDate: Scalars['String']['output'];
  costCenter?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  dismissalDate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  occupation?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Scalars['String']['output']>;
  vaccines: Array<TVaccinePrint>;
  workshift?: Maybe<Scalars['String']['output']>;
};

/** Status da vacina no registro médico */
export enum TMedicalRecordVaccineStatus {
  /** Pendente */
  Pending = 'Pending',
  /** Realizada */
  Realized = 'Realized',
  /** Recusa */
  Refuses = 'Refuses'
}

export type TMedicalRecordVaccineUpdate = {
  batch?: InputMaybe<Scalars['String']['input']>;
  currentDose?: InputMaybe<TVaccineDoseEnum>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dose?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  status?: InputMaybe<TMedicalRecordVaccineStatus>;
  vaccineId?: InputMaybe<Scalars['String']['input']>;
};

export type TMedicalReferral = {
  __typename?: 'MedicalReferral';
  /** Data */
  date: Scalars['DateTime']['output'];
  /** Identificador */
  id: Scalars['String']['output'];
  /** Identificador do prontuário médico */
  medicalRecordId: Scalars['String']['output'];
  /** Observação */
  observation?: Maybe<Scalars['String']['output']>;
  /** Especialidade */
  specialty: TMedicalSpecialty;
  /** Usuário */
  user?: Maybe<TUser>;
};

export type TMedicalReferralDoctorBiometry = {
  __typename?: 'MedicalReferralDoctorBiometry';
  /** Biometria */
  biometry: TBiometry;
  /** Identificador */
  id: Scalars['String']['output'];
};

export type TMedicalReferralDoctorBiometryInput = {
  /** Identificador da biometria */
  biometryId: Scalars['String']['input'];
  /** Imagem BMP */
  bmp?: InputMaybe<Scalars['String']['input']>;
  /** Dados da imagem */
  imageData: Scalars['String']['input'];
  /** DPI da imagem */
  imageDpi?: InputMaybe<Scalars['Float']['input']>;
  /** Altura da imagem */
  imageHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Qualidade da imagem */
  imageQuality?: InputMaybe<Scalars['Float']['input']>;
  /** Largura da imagem */
  imageWidth?: InputMaybe<Scalars['Float']['input']>;
  /** Fabricante do equipamento */
  manufacturer: Scalars['String']['input'];
  /** Modelo do equipamento */
  model?: InputMaybe<Scalars['String']['input']>;
  /** NFIQ (NIST Fingerprint Image Quality) */
  nfiq?: InputMaybe<Scalars['Float']['input']>;
  /** Número de série */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Template da biometria */
  template?: InputMaybe<Scalars['String']['input']>;
  /** Imagem WSQ */
  wsqImage?: InputMaybe<Scalars['String']['input']>;
  /** Tamanho da imagem WSQ */
  wsqImageSize?: InputMaybe<Scalars['Float']['input']>;
};

export type TMedicalReferralInput = {
  /** Data */
  date: Scalars['DateTime']['input'];
  /** Identificador do prontuário médico */
  medicalRecordId: Scalars['String']['input'];
  /** Observação */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Especialidade */
  specialty: TMedicalSpecialty;
};

export type TMedicalReferralReport = {
  __typename?: 'MedicalReferralReport';
  /** Endereço */
  address: Scalars['String']['output'];
  /** CNPJ */
  cnpj: Scalars['String']['output'];
  /** Nome da empresa */
  companyName: Scalars['String']['output'];
  /** Estado do CRM */
  crmState: Scalars['String']['output'];
  /** Data */
  date: Scalars['String']['output'];
  /** Biometria do médico */
  doctorBiometry?: Maybe<TPrintBiometry>;
  /** CRM do médico */
  doctorCrm: Scalars['String']['output'];
  /** Nome do médico */
  doctorName: Scalars['String']['output'];
  /** Snapshot formatado dos RQEs do médico para impressão */
  doctorRqeDisplay?: Maybe<Scalars['String']['output']>;
  /** Rodapé */
  footer: Scalars['String']['output'];
  /** Registro individual */
  individualRegistration: Scalars['String']['output'];
  /** Observação */
  observation?: Maybe<Scalars['String']['output']>;
  /** Nome do paciente */
  patientName: Scalars['String']['output'];
  /** Especialidade */
  speciality: Scalars['String']['output'];
  /** Telefone */
  telephone: Scalars['String']['output'];
};

export type TMedicalReferralUpdate = {
  /** Data */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador */
  id: Scalars['String']['input'];
  /** Identificador do prontuário médico */
  medicalRecordId?: InputMaybe<Scalars['String']['input']>;
  /** Observação */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Especialidade */
  specialty?: InputMaybe<TMedicalSpecialty>;
};

export type TMedicalRestriction = {
  __typename?: 'MedicalRestriction';
  /** Descrição */
  description: Scalars['String']['output'];
  /** Data de término */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Identificador do prontuário médico */
  medicalRecordId: Scalars['String']['output'];
  /** Data de início */
  startDate: Scalars['DateTime']['output'];
  /** Parar adicional */
  stopAdditional?: Maybe<Scalars['Boolean']['output']>;
};

export type TMedicalRestrictionInput = {
  /** Descrição */
  description: Scalars['String']['input'];
  /** Data de término */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador do prontuário médico */
  medicalRecordId: Scalars['String']['input'];
  /** Data de início */
  startDate: Scalars['DateTime']['input'];
  /** Parar adicional */
  stopAdditional?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TMedicalRestrictionUpdate = {
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Data de término */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador */
  id: Scalars['String']['input'];
  /** Identificador do prontuário médico */
  medicalRecordId?: InputMaybe<Scalars['String']['input']>;
  /** Data de início */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Parar adicional */
  stopAdditional?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TMedicalRestrictionsChart = {
  __typename?: 'MedicalRestrictionsChart';
  /** Possui restrições */
  hasRestrictions: Scalars['Boolean']['output'];
  /** Resultado */
  result: Scalars['Float']['output'];
};

/** Especialidade médica (Res. CFM 2.380/2024) */
export enum TMedicalSpecialty {
  /** Acupuntura */
  Acupuncture = 'Acupuncture',
  /** Alergia e imunologia */
  AllergyImmunology = 'AllergyImmunology',
  /** Anestesiologia */
  Anesthesiology = 'Anesthesiology',
  /** Angiologia */
  Angiology = 'Angiology',
  /** Cardiologia */
  Cardiology = 'Cardiology',
  /** Cirurgia cardiovascular */
  CardiovascularSurgery = 'CardiovascularSurgery',
  /** Patologia clínica/medicina laboratorial */
  ClinicalPathology = 'ClinicalPathology',
  /** Coloproctologia */
  Coloproctology = 'Coloproctology',
  /** Dermatologia */
  Dermatology = 'Dermatology',
  /** Radiologia e diagnóstico por imagem */
  DiagnosticImaging = 'DiagnosticImaging',
  /** Nutrição e dietética */
  Dietetic = 'Dietetic',
  /** Cirurgia do aparelho digestivo */
  DigestiveSystemSurgery = 'DigestiveSystemSurgery',
  /** Medicina de emergência */
  EmergencyMedicine = 'EmergencyMedicine',
  /** Endocrinologia e metabologia */
  EndocrinologyMetabology = 'EndocrinologyMetabology',
  /** Endoscopia */
  Endoscopy = 'Endoscopy',
  /** Medicina de família e comunidade */
  FamilyCommunityMedicine = 'FamilyCommunityMedicine',
  /** Medicina legal e perícia médica */
  ForensicMedicine = 'ForensicMedicine',
  /** Gastroenterologia */
  Gastroenterology = 'Gastroenterology',
  /** Cirurgia geral */
  GeneralSurgery = 'GeneralSurgery',
  /** Geriatria */
  Geriatrics = 'Geriatrics',
  /** Ginecologia e obstetrícia */
  GynecologyObstetrics = 'GynecologyObstetrics',
  /** Cirurgia da mão */
  HandSurgery = 'HandSurgery',
  /** Cirurgia de cabeça e pescoço */
  HeadNeckSurgery = 'HeadNeckSurgery',
  /** Hematologia e hemoterapia */
  HematologyHemotherapy = 'HematologyHemotherapy',
  /** Homeopatia */
  Homeopathy = 'Homeopathy',
  /** Infectologia */
  InfectiousDisease = 'InfectiousDisease',
  /** Medicina integrativa */
  Integrative = 'Integrative',
  /** Medicina intensiva */
  IntensiveCareMedicine = 'IntensiveCareMedicine',
  /** Clínica médica */
  InternalMedicine = 'InternalMedicine',
  /** Mastologia */
  Mastology = 'Mastology',
  /** Genética médica */
  MedicalGenetics = 'MedicalGenetics',
  /** Nefrologia */
  Nephrology = 'Nephrology',
  /** Neurologia */
  Neurology = 'Neurology',
  /** Neurocirurgia */
  Neurosurgery = 'Neurosurgery',
  /** Medicina nuclear */
  NuclearMedicine = 'NuclearMedicine',
  /** Nutrologia */
  Nutrition = 'Nutrition',
  /** Obstetrícia */
  Obstetrics = 'Obstetrics',
  /** Medicina do trabalho */
  OccupationalMedicine = 'OccupationalMedicine',
  /** Cirurgia oncológica */
  OncologicSurgery = 'OncologicSurgery',
  /** Oncologia clínica */
  Oncology = 'Oncology',
  /** Oftalmologia */
  Ophthalmology = 'Ophthalmology',
  /** Ortopedia e traumatologia */
  OrthopedicsTraumatology = 'OrthopedicsTraumatology',
  /** Otorrinolaringologia */
  Otorhinolaryngology = 'Otorhinolaryngology',
  /** Patologia */
  Pathology = 'Pathology',
  /** Cirurgia pediátrica */
  PediatricSurgery = 'PediatricSurgery',
  /** Pediatria */
  Pediatrics = 'Pediatrics',
  /** Medicina física e reabilitação */
  PhysicalMedicineRehabilitation = 'PhysicalMedicineRehabilitation',
  /** Fisioterapia */
  PhysicalTherapy = 'PhysicalTherapy',
  /** Cirurgia plástica */
  PlasticSurgery = 'PlasticSurgery',
  /** Pneumologia */
  Pneumology = 'Pneumology',
  /** Medicina preventiva e social */
  PreventiveSocialMedicine = 'PreventiveSocialMedicine',
  /** Psiquiatria */
  Psychiatry = 'Psychiatry',
  /** Psicologia */
  Psychology = 'Psychology',
  /** Radiologia e diagnóstico por imagem */
  Radiology = 'Radiology',
  /** Radioterapia */
  Radiotherapy = 'Radiotherapy',
  /** Reumatologia */
  Rheumatology = 'Rheumatology',
  /** Medicina esportiva */
  SportsMedicine = 'SportsMedicine',
  /** Cirurgia torácica */
  ThoracicSurgery = 'ThoracicSurgery',
  /** Medicina do tráfego */
  TrafficMedicine = 'TrafficMedicine',
  /** Urologia */
  Urology = 'Urology',
  /** Cirurgia vascular */
  VascularSurgery = 'VascularSurgery'
}

export type TMedicine = {
  __typename?: 'Medicine';
  /** Princípio ativo */
  activePrinciple?: Maybe<TGenericActivePrinciple>;
  /** Identificador do princípio ativo */
  activePrincipleId?: Maybe<Scalars['String']['output']>;
  /** Medicamento ambulatorial */
  ambulatoryMedicine: Scalars['Boolean']['output'];
  /** Contraindicação */
  contraindication?: Maybe<Scalars['String']['output']>;
  /** Descrição */
  description: Scalars['String']['output'];
  /** Identificador */
  id: Scalars['String']['output'];
  /** Indicação */
  indication?: Maybe<Scalars['String']['output']>;
  /** Indica se está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Etiqueta */
  label?: Maybe<TMedicineLabelEnum>;
  /** Laboratório */
  laboratory?: Maybe<TGenericLaboratory>;
  /** Identificador do laboratório */
  laboratoryId?: Maybe<Scalars['String']['output']>;
  /** Apresentação */
  presentation: Scalars['String']['output'];
  /** Identificador de referência */
  referenceId?: Maybe<Scalars['String']['output']>;
  /** Sugestão */
  suggestion?: Maybe<Scalars['String']['output']>;
};

export type TMedicineInput = {
  /** Identificador do princípio ativo */
  activePrincipleId?: InputMaybe<Scalars['String']['input']>;
  /** Medicamento ambulatorial */
  ambulatoryMedicine: Scalars['Boolean']['input'];
  /** Contraindicação */
  contraindication?: InputMaybe<Scalars['String']['input']>;
  /** Descrição */
  description: Scalars['String']['input'];
  /** Indicação */
  indication?: InputMaybe<Scalars['String']['input']>;
  /** Etiqueta */
  label?: InputMaybe<TMedicineLabelEnum>;
  /** Identificador do laboratório */
  laboratoryId?: InputMaybe<Scalars['String']['input']>;
  /** Apresentação */
  presentation: Scalars['String']['input'];
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Sugestão */
  suggestion?: InputMaybe<Scalars['String']['input']>;
};

/** Classificação de tarja do medicamento */
export enum TMedicineLabelEnum {
  /** Tarja preta */
  BlackLabel = 'BlackLabel',
  /** Venda livre */
  FreeSale = 'FreeSale',
  /** Tarja vermelha */
  RedLabel = 'RedLabel',
  /** Tarja vermelha com restrição */
  RedLabelUnderRestriction = 'RedLabelUnderRestriction'
}

/** Unidades de medida de medicamentos */
export enum TMedicineMeasurementUnit {
  /** Ampola */
  Ampoule = 'Ampoule',
  /** Frasco ampola */
  AmpouleBottle = 'AmpouleBottle',
  /** Bisnaga */
  BTube = 'BTube',
  /** Bolsa */
  Bag = 'Bag',
  /** Bilhões de unidades internacionais */
  BillionInternationalUnits = 'BillionInternationalUnits',
  /** Frasco */
  Bottle = 'Bottle',
  /** Pote */
  Bowl = 'Bowl',
  /** Caixa */
  Box = 'Box',
  /** Comprimido */
  CTablet = 'CTablet',
  /** Cápsula */
  Capsule = 'Capsule',
  /** Carpule */
  Carpule = 'Carpule',
  /** Centgray */
  Centgray = 'Centgray',
  /** Centímetro */
  Centimeter = 'Centimeter',
  /** Comprimido mastigável */
  Chewabletablet = 'Chewabletablet',
  /** Dose */
  Dose = 'Dose',
  /** Drágea */
  Dragee = 'Dragee',
  /** Gotas */
  Drops = 'Drops',
  /** Comprimido efervecente */
  EffervescentTablet = 'EffervescentTablet',
  /** Óvulo */
  Egg = 'Egg',
  /** Envelope */
  Envelope = 'Envelope',
  /** Flaconete */
  Flaconete = 'Flaconete',
  /** Galão */
  Gallon = 'Gallon',
  /** Glóbulo */
  Globule = 'Globule',
  /** Grama */
  Gram = 'Gram',
  /** Gray */
  Gray = 'Gray',
  /** Unidade internacional */
  InternationalUnit = 'InternationalUnit',
  /** Quilograma */
  Kilogram = 'Kilogram',
  /** Kit */
  Kit = 'Kit',
  /** Litro */
  Liter = 'Liter',
  /** Maço */
  Mallet = 'Mallet',
  /** Metro */
  Meter = 'Meter',
  /** Microgramas */
  Micrograms = 'Micrograms',
  /** Miligrama */
  Milligram = 'Milligram',
  /** Milílitro */
  Milliliter = 'Milliliter',
  /** Milhões de unidades internacionais */
  MillionsOfInternationalUnits = 'MillionsOfInternationalUnits',
  /** Não se aplica */
  NotApplicable = 'NotApplicable',
  /** Pastilha */
  PTablet = 'PTablet',
  /** Pacote */
  Package = 'Package',
  /** Par */
  Pair = 'Pair',
  /** Pérola */
  Pearl = 'Pearl',
  /** Peça */
  Piece = 'Piece',
  /** Pílula */
  Pill = 'Pill',
  /** Tubo */
  Pipe = 'Pipe',
  /** Rolo */
  Roll = 'Roll',
  /** Sache */
  Sachet = 'Sachet',
  /** Conjunto */
  Set = 'Set',
  /** Supositório */
  Suppository = 'Suppository',
  /** Seringa */
  Syringe = 'Syringe',
  /** Tablete */
  TTablet = 'TTablet',
  /** Tubete */
  TTube = 'TTube',
  /** Lata */
  Tin = 'Tin',
  /** Adesivo transdérmico */
  TransdermalPatch = 'TransdermalPatch',
  /** Unidade */
  Unity = 'Unity'
}

export type TMedicineOnDiagnostic = {
  __typename?: 'MedicineOnDiagnostic';
  /** Quantidade */
  amount: Scalars['Float']['output'];
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Unidade de medida */
  measurementUnit?: Maybe<TMedicineMeasurementUnit>;
  /** Medicamento */
  medicine: TMedicine;
  /** Posologia */
  posology?: Maybe<Scalars['String']['output']>;
  /** Indica se exibe na prescrição */
  showsInPrescription: Scalars['Boolean']['output'];
};

export type TMedicineOnDiagnosticChanges = {
  /** Medicamentos a criar */
  toCreate: Array<TMedicineOnDiagnosticInput>;
  /** IDs dos medicamentos a remover */
  toRemove: Array<Scalars['String']['input']>;
  /** Medicamentos a atualizar */
  toUpdate: Array<TMedicineOnDiagnosticUpdate>;
};

export type TMedicineOnDiagnosticInput = {
  /** Quantidade */
  amount: Scalars['Float']['input'];
  /** Unidade de medida */
  measurementUnit?: InputMaybe<TMedicineMeasurementUnit>;
  /** Identificador do medicamento */
  medicineId: Scalars['String']['input'];
  /** Posologia */
  posology?: InputMaybe<Scalars['String']['input']>;
  /** Indica se exibe na prescrição */
  showsInPrescription: Scalars['Boolean']['input'];
};

export type TMedicineOnDiagnosticUpdate = {
  /** Quantidade */
  amount: Scalars['Float']['input'];
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Unidade de medida */
  measurementUnit?: InputMaybe<TMedicineMeasurementUnit>;
  /** Identificador do medicamento */
  medicineId: Scalars['String']['input'];
  /** Posologia */
  posology?: InputMaybe<Scalars['String']['input']>;
  /** Indica se exibe na prescrição */
  showsInPrescription: Scalars['Boolean']['input'];
};

export type TMedicineUpdate = {
  /** Identificador do princípio ativo */
  activePrincipleId?: InputMaybe<Scalars['String']['input']>;
  /** Medicamento ambulatorial */
  ambulatoryMedicine?: InputMaybe<Scalars['Boolean']['input']>;
  /** Contraindicação */
  contraindication?: InputMaybe<Scalars['String']['input']>;
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Identificador */
  id: Scalars['String']['input'];
  /** Indicação */
  indication?: InputMaybe<Scalars['String']['input']>;
  /** Indica se está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Etiqueta */
  label?: InputMaybe<TMedicineLabelEnum>;
  /** Identificador do laboratório */
  laboratoryId?: InputMaybe<Scalars['String']['input']>;
  /** Apresentação */
  presentation?: InputMaybe<Scalars['String']['input']>;
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Sugestão */
  suggestion?: InputMaybe<Scalars['String']['input']>;
};

export type TMedicinesPrescription = {
  __typename?: 'MedicinesPrescription';
  /** Quantidade */
  amount: Scalars['Float']['output'];
  /** Descrição do medicamento */
  description: Scalars['String']['output'];
  /** Indicação */
  indication: Scalars['String']['output'];
  /** Unidade de medida */
  measurementUnit: Scalars['String']['output'];
  /** Posologia */
  posology: Scalars['String']['output'];
  /** Apresentação */
  presentation: Scalars['String']['output'];
};

export type TMeeting = {
  __typename?: 'Meeting';
  /** Anexos */
  attachments?: Maybe<Array<TAttachment>>;
  /** Data */
  date: Scalars['DateTime']['output'];
  /** Duração */
  duration?: Maybe<Scalars['String']['output']>;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Mandato */
  mandate: TMandate;
  /** Ações da reunião */
  meetingActions?: Maybe<Array<TActionOnMeeting>>;
  /** Formato da reunião */
  meetingFormat: TMeetingFormat;
  /** Local da reunião */
  meetingLocal?: Maybe<Scalars['String']['output']>;
  /** Participantes da reunião */
  meetingParticipants?: Maybe<Array<TParticipantOnMeeting>>;
  /** Tipo de reunião */
  meetingType: TMeetingType;
  /** Ata da reunião */
  minutesMeeting?: Maybe<Scalars['String']['output']>;
  /** Data real */
  realDate?: Maybe<Scalars['DateTime']['output']>;
  /** Assunto */
  subject: Scalars['String']['output'];
};

export type TMeetingAction = {
  __typename?: 'MeetingAction';
  /** Indica se está ativo */
  active: Scalars['Boolean']['output'];
  /** Data da ação */
  dateAction: Scalars['DateTime']['output'];
  /** Descrição */
  description: Scalars['String']['output'];
  /** Identificador */
  id: Scalars['String']['output'];
  /** Reunião */
  meeting: TMeeting;
};

export type TMeetingActionInput = {
  /** Indica se está ativo */
  active: Scalars['Boolean']['input'];
  /** Data da ação */
  dateAction: Scalars['DateTime']['input'];
  /** Descrição */
  description: Scalars['String']['input'];
  /** Identificador da reunião */
  meetingId: Scalars['String']['input'];
};

export type TMeetingActionUpdate = {
  /** Indica se está ativo */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Data da ação */
  dateAction?: InputMaybe<Scalars['DateTime']['input']>;
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Identificador */
  id: Scalars['String']['input'];
  /** ID da reunião */
  meetingId?: InputMaybe<Scalars['String']['input']>;
};

export type TMeetingEntry = {
  __typename?: 'MeetingEntry';
  label: Scalars['String']['output'];
  result: Scalars['Int']['output'];
};

/** Formato da reunião */
export enum TMeetingFormat {
  /** Reunião totalmente digital (chamada por vídeo) */
  Digital = 'Digital',
  /** Reunião híbrida (parte presencial, parte digital) */
  Hybrid = 'Hybrid',
  /** Reunião presencial (ata pode ser manuscrita ou escaneada) */
  InPerson = 'InPerson'
}

export type TMeetingInput = {
  /** Ações */
  actions?: InputMaybe<Array<TActionOnMeetingInput>>;
  /** Data */
  date: Scalars['DateTime']['input'];
  /** Duração */
  duration?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do mandato */
  mandateId: Scalars['String']['input'];
  /** Formato da reunião */
  meetingFormat?: InputMaybe<TMeetingFormat>;
  /** Local da reunião */
  meetingLocal?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de reunião */
  meetingType: TMeetingType;
  /** Ata da reunião */
  minutesMeeting?: InputMaybe<Scalars['String']['input']>;
  /** Participantes */
  participants?: InputMaybe<Array<TParticipantOnMeetingInput>>;
  /** Data real */
  realDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Assunto */
  subject: Scalars['String']['input'];
};

export type TMeetingParticipant = {
  __typename?: 'MeetingParticipant';
  /** Comparecimento */
  attendance?: Maybe<Scalars['Boolean']['output']>;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Justificativa */
  justification?: Maybe<Scalars['String']['output']>;
  /** Reunião */
  meeting: TMeeting;
  /** Pessoa */
  person: TPerson;
};

export type TMeetingParticipantInput = {
  /** Comparecimento */
  attendance?: InputMaybe<Scalars['Boolean']['input']>;
  /** Justificativa */
  justification?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da reunião */
  meetingId: Scalars['String']['input'];
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
};

export type TMeetingParticipantUpdate = {
  /** Comparecimento */
  attendance?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador */
  id: Scalars['String']['input'];
  /** Justificativa */
  justification?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da reunião */
  meetingId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da pessoa */
  personId?: InputMaybe<Scalars['String']['input']>;
};

/** Tipo de reunião */
export enum TMeetingType {
  /** Reunião extraordinária */
  Extraordinary = 'extraordinary',
  /** Reunião ordinária */
  Ordinary = 'ordinary'
}

export type TMeetingUpdate = {
  /** Ações */
  actions?: InputMaybe<TActionOnMeetingUpdate>;
  /** Data */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Duração */
  duration?: InputMaybe<Scalars['String']['input']>;
  /** Identificador */
  id: Scalars['String']['input'];
  /** Formato da reunião */
  meetingFormat?: InputMaybe<TMeetingFormat>;
  /** Local da reunião */
  meetingLocal?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de reunião */
  meetingType?: InputMaybe<TMeetingType>;
  /** Ata da reunião */
  minutesMeeting?: InputMaybe<Scalars['String']['input']>;
  /** Participantes */
  participants?: InputMaybe<TParticipantOnMeetingUpdate>;
  /** Data real */
  realDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Assunto */
  subject?: InputMaybe<Scalars['String']['input']>;
};

/** Tipos de metadados */
export enum TMetadataType {
  /** Tipo de ausência */
  AbsenceType = 'AbsenceType',
  /** Adicional */
  Additional = 'Additional',
  /** Adicional */
  Allowance = 'Allowance',
  /** Tipo de adicional */
  AllowanceType = 'AllowanceType',
  /** Teste base */
  BaseTest = 'BaseTest',
  /** Centro de custo */
  CostCenter = 'CostCenter',
  /** Departamento */
  Department = 'Department',
  /** Dependente */
  Dependant = 'Dependant',
  /** Funcionário */
  Employee = 'Employee',
  /** Histórico funcional */
  FunctionalHistory = 'FunctionalHistory',
  /** Deficiências de informação */
  InformationDeficiencies = 'InformationDeficiencies',
  /** Item */
  Item = 'Item',
  /** Licença de ausência */
  LeaveOfAbscence = 'LeaveOfAbscence',
  /** Consulta médica */
  MedicalConsultation = 'MedicalConsultation',
  /** Ocupação */
  Occupation = 'Occupation',
  /** Pessoa */
  Person = 'Person',
  /** Cargo */
  Position = 'Position',
  /** Requisição de compra */
  PurchaseRequisition = 'PurchaseRequisition',
  /** Atestado médico */
  SickNote = 'SickNote',
  /** Aposentadoria especial */
  SpecialRetirement = 'SpecialRetirement',
  /** Estabilidade */
  Stability = 'Stability',
  /** Tipo de estabilidade */
  StabilityType = 'StabilityType',
  /** Nível de estoque */
  StockLevel = 'StockLevel',
  /** Giro de estoque */
  StockTurnOver = 'StockTurnOver',
  /** Treinamento */
  Training = 'Training',
  /** Histórico de treinamento */
  TrainingHistory = 'TrainingHistory',
  /** Necessidade de treinamento */
  TrainingNecessity = 'TrainingNecessity',
  /** Unidade de medida */
  UnitOfMeasure = 'UnitOfMeasure',
  /** Armazém */
  Warehouse = 'Warehouse',
  /** Turno de trabalho */
  WorkShift = 'WorkShift'
}

/** Status da micro ação */
export enum TMicroActionStatus {
  /** Cancelada */
  Cancel = 'Cancel',
  /** Fechada */
  Closed = 'Closed',
  /** Aberta */
  Open = 'Open'
}

export type TMicroActionStatusChart = {
  __typename?: 'MicroActionStatusChart';
  entries: Array<TMicroActionStatusEntry>;
  hasData: Scalars['Boolean']['output'];
};

export type TMicroActionStatusEntry = {
  __typename?: 'MicroActionStatusEntry';
  canceled: Scalars['Int']['output'];
  closed: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  open: Scalars['Int']['output'];
};

export type TModuleDefaultRecipientsDto = {
  __typename?: 'ModuleDefaultRecipientsDto';
  /** Se true, destinatários são resolvidos no momento do evento e não é possível listá-los previamente */
  dynamic: Scalars['Boolean']['output'];
  /** Nome do módulo */
  module: Scalars['String']['output'];
  /** Nota explicativa sobre como os destinatários são resolvidos quando dynamic=true */
  note?: Maybe<Scalars['String']['output']>;
  /** Usuários que receberão por padrão (vazio se dynamic=true) */
  users: Array<TDefaultRecipientUserDto>;
};

export type TMutation = {
  __typename?: 'Mutation';
  _clearSessionAndDeleteOrganizationData: Scalars['Boolean']['output'];
  _createAdmin: TUser;
  _createAndVerifyUser: TUser;
  _createDoctor: TUser;
  _createPersonWithUser: TPerson;
  _createVerifyDoctorAndAcceptPolicyAndLogin: TSession;
  _createVerifyUserAndAcceptPolicyAndLogin: TSession;
  _deleteBranchData: Scalars['Boolean']['output'];
  _deleteOrganizationData: Scalars['Boolean']['output'];
  _inviteAndCreateUser: TUser;
  _triggerCaepi: Scalars['Boolean']['output'];
  _updateQueueStatus: Scalars['Boolean']['output'];
  acknowledgeEmptyCipaMinute: Scalars['Boolean']['output'];
  acknowledgeEmptyFireBrigadeMinute: Scalars['Boolean']['output'];
  acknowledgeInconsistency: TTtalkInboundSemanticInconsistency;
  addOwnership: TOrganizationOwnership;
  batchMessages: Scalars['String']['output'];
  blockRole: TRole;
  blockRoles: Array<TRole>;
  cancelDocument: Scalars['Boolean']['output'];
  changePreMedicalCertificateStatus: TPreMedicalCertificate;
  clearFilterPreference: Scalars['Boolean']['output'];
  configureAdIntegrate: Scalars['Boolean']['output'];
  confirmImport: TConfirmImport;
  copyExposureGroup: TExposureGroup;
  copyProductsToBranches: Scalars['Boolean']['output'];
  copySuggestion: Array<TSuggestionBox>;
  createAbsenceType: TAbsenceType;
  createAbsenceTypeByGeneric: TAbsenceType;
  createAccessToken: TAccessToken;
  createAccident: TAccident;
  createAccidentAttachment: Array<TAttachment>;
  createAccidentCause: TAccidentCause;
  createAccidentCauseByGeneric: TAccidentCause;
  createAccredited: TAccredited;
  createAccreditedAsServiceProvider: TAccredited;
  createActionPlan: TActionPlan;
  createActionPlanAttachment: Array<TAttachment>;
  createActionPlanInvestigation: TActionPlanReport;
  createActionPlanMicroAction: TActionPlanMicroAction;
  createAgreement: TAgreement;
  createAllowanceType: TAllowanceType;
  createApiAccess: TApiAccess;
  createBiologicalMonitoring: TAccident;
  createBiologicalMonitoringExamGroup: TBiologicalMonitoringExamGroup;
  createBiologicalMonitoringExamGroupByGeneric: TBiologicalMonitoringExamGroup;
  createBiometry: Array<TBiometry>;
  createBranch: TBranch;
  createCalendar: TCalendar;
  createCandidate: TCandidate;
  createClinicalQuiz: TClinicalQuiz;
  createComponent: TComponent;
  createConsultation: TConsultation;
  createContactRequest: TContactRequest;
  createControlMeasure: TControlMeasure;
  createCostCenter: TCostCenter;
  createCostCenterByGeneric: TCostCenter;
  createDeficiency: TDeficiency;
  createDeficiencyAttachment: Array<TAttachment>;
  createDeliverySpareParts: Array<TDeliverySpareParts>;
  createDepartment: TDepartment;
  createDevOrganization: TUserFromCreation;
  createDiagnostic: TDiagnostic;
  createElectionComission: TElectionComission;
  createEmployeeTask: TEmployeeTask;
  createEmployeeWarning: TWarningByPerson;
  createEnvironmentalReport: TEnvironmentalReport;
  createEnvironmentalReportAttachment: Array<TAttachment>;
  createEnvironmentalReportBiometry: TEnvironmentalReportBiometry;
  createEnvironmentalReportFace: TEnvironmentalReportFace;
  createEquipmentByCostCenter: TEquipmentByCostCenter;
  createEquipmentByOccupation: TEquipmentByOccupation;
  createExam: TExam;
  createExamAudiometry: TExamAudiometry;
  createExamByGeneric: TExam;
  createExamDiagnosticImage: TExamDiagnosticImage;
  createExamDiagnosticImageAttachment: Array<TAttachment>;
  createExamItem: TExamItem;
  createExamNormal: TExamNormal;
  createExamOtological: TExamOtological;
  createExamSpirometry: TExamSpirometry;
  createExamToxicological: TExamToxicological;
  createExpectedGoal: TExpectedGoal;
  createExpense: TExpense;
  createExpenseByGeneric: TExpense;
  createExposureGroup: TExposureGroup;
  createExposureGroupCostCenter: TExposureGroupCostCenter;
  createExposureGroupDepartment: TExposureGroupDepartment;
  createExposureGroupOccupation: TExposureGroupOccupation;
  createExposureGroupPerson: TExposureGroupPerson;
  createExposureGroupTask: TExposureGroupTask;
  /** Criação de Atestado de Saúde Ocupacional por atendimento externo */
  createExternalOccupationalHealthCertificate: TExternalOccupationalHealthCertificate;
  createExtinguishingAttachment: Array<TAttachment>;
  createExtinguishingInspectionAttachment: Array<TAttachment>;
  createExtinguishingSystem: TExtinguishingSystem;
  createFireBrigade: TFireBrigade;
  createFireBrigadeComponent: TFireBrigadeComponent;
  createFireBrigadeExam: TFireBrigadeExam;
  createFireBrigadeMeeting: TFireBrigadeMeeting;
  createFireBrigadeMeetingAttachment: Array<TAttachment>;
  createFireBrigadeOccurrence: TFireBrigadeOccurrence;
  createFireBrigadeOccurrenceAttachment: Array<TAttachment>;
  createFireBrigadeTraining: TFireBrigadeTraining;
  createGeneratingSource: TGeneratingSource;
  createHealthProgram: THealthProgram;
  createHealthProgramByGeneric: THealthProgram;
  createHealthProgramTraining: THealthProgramTraining;
  createInvestigation: TInvestigation;
  createInvestigationAttachment: Array<TAttachment>;
  createInvite: TInvite;
  createIpeDelivery: Array<TIpeDelivery>;
  createIpeDeliveryExtension: TIpeDeliveryExtensionResult;
  createIpeIpeBiometry: Array<TIpeBiometry>;
  createMandate: TMandate;
  createMandateAction: TMandateAction;
  createMandateCostCenter: TMandateCostCenter;
  createMandateDepartment: TMandateDepartment;
  createMandateTraining: TMandateTraining;
  createManyOrdinaryFireBrigadeMeeting: Array<TFireBrigadeMeeting>;
  createManyOrdinaryMeeting: Array<TMeeting>;
  createMeasuringInstrument: TMeasuringInstrument;
  createMeasuringInstrumentAttachment: Array<TAttachment>;
  createMeasuringInstrumentByGeneric: TMeasuringInstrument;
  createMedicalCertificate: TMedicalCertificate;
  createMedicalCertificateAttachment: Array<TAttachment>;
  /** Cria um novo prontuário médico */
  createMedicalRecord: TMedicalRecord;
  createMedicalRecordAttachment: Array<TAttachment>;
  createMedicalRecordHealthProgram: TMedicalRecordHealthProgram;
  createMedicalRecordVaccine: TMedicalRecordVaccine;
  createMedicalRecordVaccinePlanning: Array<TMedicalRecordVaccine>;
  createMedicalReferral: TMedicalReferral;
  createMedicalReferralDoctorBiometry: TMedicalReferralDoctorBiometry;
  createMedicalRestriction: TMedicalRestriction;
  createMedicine: TMedicine;
  createMedicineByGeneric: TMedicine;
  createMeeting: TMeeting;
  createMeetingAttachment: Array<TAttachment>;
  createOccupation: TOccupation;
  createOccupationByGeneric: TOccupation;
  createOccupationalHealthCertificate: TOccupationalHealthCertificate;
  createOccupationalHealthCertificateAttachment: Array<TAttachment>;
  createOccupationalHealthOccupationalHealthBiometry: Array<TOccupationalHealthBiometry>;
  createOrganization: TOrganizationWithBranches;
  createOrthoRater: TOrthoRater;
  createPeriodicRange: TPeriodicRange;
  createPeriodicRangeByGeneric: TPeriodicRange;
  /** Cria uma nova pessoa */
  createPerson: TPerson;
  createPersonAttachment: Array<TAttachment>;
  createPhysicalEnvironment: TPhysicalEnvironment;
  createPhysicalEnvironmentAttachment: Array<TAttachment>;
  createPolicyAgreement: Array<TPolicyAgreement>;
  createPolicyTerm: TPolicyTerms;
  createPosition: TPosition;
  createProduct: TProduct;
  createProductDelivery: Array<TProductDelivery>;
  createProductIpeManufacturer: TProductIpeManufacturer;
  createQuiz: TQuiz;
  createQuizAttachment: Array<TAttachment>;
  createQuizByGeneric: TQuiz;
  createRealGoal: TRealGoal;
  createRealGoalAttachment: Array<TAttachment>;
  createReportAttachment: Array<TAttachment>;
  createReportSection: TReportSection;
  createReportStructure: TReportStructure;
  createResponsibleAction: TResponsibleAction;
  createResultExamIbmp: TResultExamIbmp;
  createRisk: TRisk;
  createRiskAgent: TRiskAgent;
  createRiskAgentByGeneric: TRiskAgent;
  createRiskAttachment: Array<TAttachment>;
  createRolePermission: TRolePermission;
  createSafetyQuiz: TSafetyQuiz;
  createScheduleRestriction: TScheduleRestriction;
  /** Cria uma nova sessão de usuário. */
  createSession: TSession;
  createSessionByAd: TSession;
  createSessionForBranch: TSession;
  createSignCredentials: TSignCredentialsOutput;
  createSignDocumentEnvironmentalReport: TBaseDocumentResponse;
  createSignDocumentIpeDelivery: TBaseDocumentResponse;
  createSignDocumentMedicalCertificate: TBaseDocumentResponse;
  createSignDocumentOHC: TBaseDocumentResponse;
  createSignDocumentSecurityWorkOrder: TBaseDocumentResponse;
  createSimulation: TSimulation;
  createSimulationPlan: TSimulationPlan;
  createSipat: TSipat;
  createSipatAttachment: Array<TAttachment>;
  createSnellen: TSnellen;
  createSpareParts: TSpareParts;
  createStabilityType: TStabilityType;
  createStatementResponsibility: TStatementResponsibility;
  createStatementResponsibilityByGeneric: TStatementResponsibility;
  createStockLevel: TStockLevel;
  createStockMovement: Array<TStockMovement>;
  createSuggestionBox: TSuggestionBox;
  createTask: TTask;
  createThumbnail: Scalars['String']['output'];
  createTraining: TTraining;
  createTrainingAttachment: Array<TAttachment>;
  createTrainingByGeneric: TTraining;
  createTrainingHistory: TTrainingHistory;
  createTrainingHistoryAttachment: Array<TAttachment>;
  createTrainingHistoryBatch: TTrainingHistoryBatchResult;
  createUnityOfMeasure: TUnityOfMeasure;
  createUrinalysis: TUrinalysis;
  createUser: TUserFromCreation;
  createUserSpecialty: TUserSpecialty;
  createVaccine: TVaccine;
  createVaccineByGeneric: TVaccine;
  createVote: TVote;
  createWarehouse: TWarehouse;
  createWarningAttachment: Array<TAttachment>;
  createWebhook: TWebhook;
  createWebhookQueue: TWebhookQueue;
  createWorkPermission: TWorkPermission;
  createWorkShift: TWorkShift;
  createWorkShiftByGeneric: TWorkShift;
  csvAccredited: Scalars['Boolean']['output'];
  csvClinicalQuiz: Scalars['Boolean']['output'];
  csvDeficiency: Scalars['Boolean']['output'];
  csvMedicalCertificate: Scalars['Boolean']['output'];
  csvMedicalRecord: Scalars['Boolean']['output'];
  csvMedicalRecordVaccine: Scalars['Boolean']['output'];
  csvOccupationalHealthCertificate: Scalars['Boolean']['output'];
  csvQuiz: Scalars['Boolean']['output'];
  csvRisk: Scalars['Boolean']['output'];
  deleteEnvironmentalReportVersion: Scalars['Boolean']['output'];
  deletePolicyAgreement: Scalars['Boolean']['output'];
  deletePolicyTerm: Scalars['Boolean']['output'];
  eSocialCreateFieldsValidation: Array<Scalars['String']['output']>;
  eSocialUpdateFieldsValidation: Array<Scalars['String']['output']>;
  employeeAnswerClinicalQuiz: TClinicalQuiz;
  employeeAnswerSafetyQuiz: TSafetyQuiz;
  employeeCandidate: TCandidate;
  employeeLoginByAd: TLogin;
  employeeLoginMutation: TLogin;
  employeeVote: TVote;
  forceUserUpdatePassword: TUserBasicInfo;
  /** Cria uma customização para a organização do usuário corrente a partir do default declarado em código. UNIQUE garante 1 por (org, tipo). */
  forkDocumentFromDefault: TCustomDocument;
  generateEnvironmentalReportSignAttachment: Scalars['Boolean']['output'];
  generatePassword: TPerson;
  hermesCreateBranch: Scalars['Boolean']['output'];
  hermesCreateMetadata: TSaasMetadata;
  hermesCreateOrganization: Scalars['Boolean']['output'];
  hermesDeleteBranch: Scalars['Boolean']['output'];
  hermesDeleteMetadata: TSaasMetadata;
  hermesDeleteOrganization: Scalars['Boolean']['output'];
  hermesIntegrationConfigure: Scalars['Boolean']['output'];
  hermesUpdateBranch: Scalars['Boolean']['output'];
  hermesUpdateMetadata: TSaasMetadata;
  hermesUpdateOrganization: Scalars['Boolean']['output'];
  importSSTOptions: Scalars['Boolean']['output'];
  initialIntegrationConfigByBranch: TIntegrationConfiguration;
  insertFeatureFlag: TFlag;
  insertOrganizationFlag: TBaseFlagReturn;
  insertUserFlag: TBaseFlagReturn;
  inviteByCsv: Scalars['Boolean']['output'];
  manageCustomOrganization: Array<TCustomOrganization>;
  migrateDataToHermes: Scalars['Boolean']['output'];
  organizationCancelContract: TOrganization;
  organizationContract: TOrganization;
  organizationReactiveContract: TOrganization;
  preValidate: TPreValidate;
  purgeFeature: TBaseFeatureReturn;
  purgeFlag: TBaseFlagReturn;
  reactivateBranch: TBranch;
  reactivateRole: TRole;
  recognizeMedicalCertificate: TRecognizedMedicalCertificateData;
  registerFeatureFlag: TFlag;
  releaseConsultationResults: Scalars['Boolean']['output'];
  removeAbsenceType: TAbsenceType;
  removeAccident: TAccident;
  removeAccidentAttachment: Scalars['Boolean']['output'];
  removeAccidentCause: TAccidentCause;
  removeAccredited: TAccredited;
  removeActionPlan: TActionPlan;
  removeActionPlanAttachment: Scalars['Boolean']['output'];
  removeActionPlanMicroAction: TActionPlanMicroAction;
  removeAdIntegrate: Scalars['Boolean']['output'];
  removeAllBiometries: Array<TBiometry>;
  removeAllTrialOrganizationUsers: Scalars['Boolean']['output'];
  removeAllowanceType: TAllowanceType;
  removeApiAccess: TApiAccess;
  removeBiologicalMonitoringExamGroup: TBiologicalMonitoringExamGroup;
  removeBiometry: TBiometry;
  removeBranch: TBranch;
  removeCalendar: TCalendar;
  removeCandidate: TCandidate;
  removeClinicalQuiz: TClinicalQuiz;
  removeComplementaryExam: TComplementaryExam;
  removeComponent: TComponent;
  removeConsultation: TConsultation;
  removeControlMeasure: TControlMeasure;
  removeCostCenter: TCostCenter;
  removeDeficiency: TDeficiency;
  removeDeficiencyAttachment: Scalars['Boolean']['output'];
  removeDeliverySpareParts: TDeliverySpareParts;
  removeDepartment: TDepartment;
  removeDiagnostic: TDiagnostic;
  removeDocument: Scalars['Boolean']['output'];
  removeElectionComission: TElectionComission;
  removeEmployeeTask: TEmployeeTask;
  removeEmployeeWarning: TWarningByPerson;
  removeEnvironmentalReport: TEnvironmentalReport;
  removeEnvironmentalReportAttachment: Scalars['Boolean']['output'];
  removeEnvironmentalReportBiometry: TEnvironmentalReportBiometry;
  removeEquipmentByCostCenter: TEquipmentByCostCenter;
  removeEquipmentByOccupation: TEquipmentByOccupation;
  removeExam: TExam;
  removeExamDiagnosticImage: TExamDiagnosticImage;
  removeExamDiagnosticImageAttachment: Scalars['Boolean']['output'];
  removeExamNormal: TExamNormal;
  removeExamOtological: TExamOtological;
  removeExamToxicological: TExamToxicological;
  removeExpectedGoal: TExpectedGoal;
  removeExpense: TExpense;
  removeExposureGroup: TExposureGroup;
  removeExposureGroupCostCenter: TExposureGroupCostCenter;
  removeExposureGroupDepartment: TExposureGroupDepartment;
  removeExposureGroupOccupation: TExposureGroupOccupation;
  removeExposureGroupPerson: TExposureGroupPerson;
  removeExposureGroupTask: TExposureGroupTask;
  removeExtinguishingAttachment: Scalars['Boolean']['output'];
  removeExtinguishingInspectionAttachment: Scalars['Boolean']['output'];
  removeExtinguishingSystem: TExtinguishingSystem;
  removeFireBrigade: TFireBrigade;
  removeFireBrigadeComponent: TFireBrigadeComponent;
  removeFireBrigadeExam: TFireBrigadeExam;
  removeFireBrigadeMeeting: TFireBrigadeMeeting;
  removeFireBrigadeMeetingAttachment: Scalars['Boolean']['output'];
  removeFireBrigadeOccurrence: TFireBrigadeOccurrence;
  removeFireBrigadeOccurrenceAttachment: Scalars['Boolean']['output'];
  removeFireBrigadeTraining: TFireBrigadeTraining;
  removeGeneratingSource: TGeneratingSource;
  removeHealthProgram: THealthProgram;
  removeHealthProgramTraining: THealthProgramTraining;
  removeInvestigation: TInvestigation;
  removeInvestigationAttachment: Scalars['Boolean']['output'];
  removeInvite: TInvite;
  removeIpeBiometry: TIpeBiometry;
  removeIpeDelivery: TIpeDelivery;
  removeIpeDeliveryExtension: Scalars['String']['output'];
  removeMandate: TMandate;
  removeMandateAction: TMandateAction;
  removeMandateCostCenter: TMandateCostCenter;
  removeMandateDepartment: TMandateDepartment;
  removeMandateTraining: TMandateTraining;
  removeMeasuringInstrument: TMeasuringInstrument;
  removeMeasuringInstrumentAttachment: Scalars['Boolean']['output'];
  removeMedicalCertificate: TMedicalCertificate;
  removeMedicalCertificateAttachment: Scalars['Boolean']['output'];
  removeMedicalRecord: TMedicalRecord;
  removeMedicalRecordAttachment: Scalars['Boolean']['output'];
  removeMedicalRecordHealthProgram: TMedicalRecordHealthProgram;
  removeMedicalRecordVaccine: TMedicalRecordVaccine;
  removeMedicalReferral: TMedicalReferral;
  removeMedicalReferralDoctorBiometry: TMedicalReferralDoctorBiometry;
  removeMedicalRestriction: TMedicalRestriction;
  removeMedicine: TMedicine;
  removeMeeting: TMeeting;
  removeMeetingAttachment: Scalars['Boolean']['output'];
  removeOccupation: TOccupation;
  removeOccupationalHealthBiometry: TOccupationalHealthBiometry;
  removeOccupationalHealthCertificate: TOccupationalHealthCertificate;
  removeOccupationalHealthCertificateAttachment: Scalars['Boolean']['output'];
  removeOrganization: TOrganizationWithBranches;
  removeOrthoRater: TOrthoRater;
  removeOwnership: TOrganizationOwnership;
  removePeriodicRange: TPeriodicRange;
  removePerson: TPerson;
  removePersonAttachment: Scalars['Boolean']['output'];
  removePhysicalEnvironment: TPhysicalEnvironment;
  removePhysicalEnvironmentAttachment: Scalars['Boolean']['output'];
  removePosition: TPosition;
  removeProduct: TProduct;
  removeProductDelivery: TProductDelivery;
  removeProductIpeManufacturer: TProductIpeManufacturer;
  removeQuiz: TQuiz;
  removeQuizAttachment: Scalars['Boolean']['output'];
  removeRealGoal: TRealGoal;
  removeRealGoalAttachment: Scalars['Boolean']['output'];
  removeReportAttachment: Scalars['Boolean']['output'];
  removeReportStructure: TReportStructure;
  removeResponsibleAction: TResponsibleAction;
  removeResultExamIbmp: TResultExamIbmp;
  removeRisk: TRisk;
  removeRiskAgent: TRiskAgent;
  removeRiskAttachment: Scalars['Boolean']['output'];
  removeRole: TRole;
  removeRolePermission: TRolePermission;
  removeRoles: Array<TRole>;
  removeSafetyQuiz: TSafetyQuiz;
  removeScheduleRestriction: TScheduleRestriction;
  removeService: Array<Scalars['String']['output']>;
  removeSession: TSession;
  removeSignCredentials: Scalars['Boolean']['output'];
  removeSimulation: TSimulation;
  removeSimulationPlan: TSimulationPlan;
  removeSipat: TSipat;
  removeSipatAttachment: Scalars['Boolean']['output'];
  removeSnellen: TSnellen;
  removeSpareParts: TSpareParts;
  removeStabilityType: TStabilityType;
  removeStatementResponsibility: TStatementResponsibility;
  removeStockLevel: TStockLevel;
  removeSuggestionBox: TSuggestionBox;
  removeTask: TTask;
  removeTraining: TTraining;
  removeTrainingAttachment: Scalars['Boolean']['output'];
  removeTrainingHistory: TTrainingHistory;
  removeTrainingHistoryAttachment: Scalars['Boolean']['output'];
  removeTrialOrganizationUser: TUser;
  removeUnityOfMeasure: TUnityOfMeasure;
  removeUrinalysis: TUrinalysis;
  removeUserSpecialty: TUserSpecialty;
  removeVaccine: TVaccine;
  removeWarehouse: TWarehouse;
  removeWarningAttachment: Scalars['Boolean']['output'];
  removeWebhook: TWebhook;
  removeWebhookQueue: TWebhookQueue;
  removeWorkPermission: TWorkPermission;
  removeWorkShift: TWorkShift;
  replacementIpeDelivery: Array<TIpeDelivery>;
  replacementProductDelivery: Array<TProductDelivery>;
  reprocessTtalkInboundEvent: TTtalkInboundEvent;
  /** Agenda exportação de logs — entrega por email ao solicitante */
  requestAuditLogExport: TAuditLogExportRequest;
  requestMapUrl: TMapUpload;
  requestPasswordReset: Scalars['Boolean']['output'];
  resendBatch: Scalars['Boolean']['output'];
  resendInvite: Scalars['Boolean']['output'];
  resendInviteVerification: Scalars['Boolean']['output'];
  resendQueue: TESocialQueue;
  resendUserEmailVerification: Scalars['Boolean']['output'];
  resendWebhookEvent: TWebhookQueue;
  /** Volta o tipo ao template default (soft-delete da customização). Próxima leitura via `effectiveDocumentTemplate` cai no default declarado em código. Retorna false se não havia customização. */
  resetCustomDocumentToDefault: Scalars['Boolean']['output'];
  resetPassword: Scalars['Boolean']['output'];
  resolveRiskSync: Scalars['Boolean']['output'];
  retryTTalkQueue: TTTalkQueue;
  retryTTalkQueueBatch: Scalars['Float']['output'];
  saveEnvironmentalReportVersion: Scalars['Boolean']['output'];
  saveOHCDoctorFace: TOccupationalHealthFace;
  saveOHCFace: TOccupationalHealthFace;
  saveRiskComposition: Array<TRiskComposition>;
  scheduleExpectedConsultations: Array<TConsultation>;
  sendFirstESocialLoad: TBranch;
  sendLoadByPeriod: TBranch;
  sendPendingMessages: Scalars['Boolean']['output'];
  setBranchLogo: Scalars['String']['output'];
  setBranches: Array<TRole>;
  setEmployeeProfilePicture: Scalars['String']['output'];
  setOrganizationPicture: Scalars['String']['output'];
  setSendNotify: TCustomOrganization;
  setUserProfilePicture: Scalars['String']['output'];
  socResendQueue?: Maybe<TQueueDto>;
  socRunSync: Scalars['Boolean']['output'];
  subscriptionLevelDiscount: Scalars['Boolean']['output'];
  syncAllOrganization: TBulkSyncRun;
  syncByOrganization: Array<TCronTab>;
  syncCron: TCronTab;
  syncMessage: TESocialQueue;
  syncMessages: Scalars['Boolean']['output'];
  syncStockLevels: Array<TStockLevelSyncResult>;
  transferConsultations: TTransferConsultationsResult;
  unblockRole: TRole;
  unblockRoles: Array<TRole>;
  unsetBranchLogo: Scalars['Boolean']['output'];
  unsetEmployeeProfilePicture: Scalars['Boolean']['output'];
  unsetOrganizationPicture: Scalars['Boolean']['output'];
  unsetUserProfilePicture: Scalars['Boolean']['output'];
  updateAbsenceType: TAbsenceType;
  updateAccident: TAccident;
  updateAccidentCause: TAccidentCause;
  updateAccredited: TAccredited;
  updateAccreditedAsServiceProvider: TAccredited;
  updateActionPlan: TActionPlan;
  updateActionPlanMicroAction: TActionPlanMicroAction;
  updateAllowanceType: TAllowanceType;
  updateBiologicalMonitoring: TAccident;
  updateBiologicalMonitoringExamGroup: TBiologicalMonitoringExamGroup;
  updateBiometry: Array<TBiometry>;
  updateBranch: TBranch;
  updateCalendar: TCalendar;
  updateCandidate: TCandidate;
  updateClinicalQuiz: TClinicalQuiz;
  updateComponent: TComponent;
  updateConsultation: TConsultation;
  updateControlMeasure: TControlMeasure;
  updateCostCenter: TCostCenter;
  updateCronTab: TCronTab;
  /** Atualiza uma customização existente da organização do contexto. Stale write protection via `expectedUpdatedAt`. */
  updateCustomDocument: TCustomDocument;
  updateCustomer: TCustomer;
  updateDeficiency: TDeficiency;
  updateDeliverySpareParts: TDeliverySpareParts;
  updateDeliveryStatusJob: Scalars['Boolean']['output'];
  updateDepartment: TDepartment;
  updateDiagnostic: TDiagnostic;
  updateEmployeeNickname: TEmployee;
  updateEmployeePreferences: Scalars['Boolean']['output'];
  updateEmployeeTask: TEmployeeTask;
  updateEmployeeWarning: TWarningByPerson;
  updateEndpoint: Array<TEndpoint>;
  updateEnvironmentalReport: TEnvironmentalReport;
  updateExam: TExam;
  updateExamAudiometry: TExamAudiometry;
  updateExamDiagnosticImage: TExamDiagnosticImage;
  updateExamItem: TExamItem;
  updateExamNormal: TExamNormal;
  updateExamOtological: TExamOtological;
  updateExamSpirometry: TExamSpirometry;
  updateExamToxicological: TExamToxicological;
  updateExpense: TExpense;
  updateExposureGroup: TExposureGroup;
  updateExposureGroupCostCenter: TExposureGroupCostCenter;
  updateExposureGroupDepartment: TExposureGroupDepartment;
  updateExposureGroupOccupation: TExposureGroupOccupation;
  updateExposureGroupPerson: TExposureGroupPerson;
  updateExposureGroupTask: TExposureGroupTask;
  updateExternalOccupationalHealthCertificate: TExternalOccupationalHealthCertificate;
  updateExtinguishingSystem: TExtinguishingSystem;
  updateFeatureFlag: TFlag;
  updateFeatureVersion: TFeatureVersionReturn;
  updateFireBrigade: TFireBrigade;
  updateFireBrigadeComponent: TFireBrigadeComponent;
  updateFireBrigadeExam: TFireBrigadeExam;
  updateFireBrigadeMeeting: TFireBrigadeMeeting;
  updateFireBrigadeOccurrence: TFireBrigadeOccurrence;
  updateGeneratingSource: TGeneratingSource;
  updateHealthProgram: THealthProgram;
  updateIntegrationConfigOption: TIntegrationConfiguration;
  updateInvestigation: TInvestigation;
  updateIpeDelivery: TIpeDelivery;
  updateMandate: TMandate;
  updateMandateEvent: TMandateEvent;
  updateMandateTraining: TMandateTraining;
  updateMeasuringInstrument: TMeasuringInstrument;
  updateMedicalCertificate: TMedicalCertificate;
  updateMedicalRecord: TMedicalRecord;
  updateMedicalRecordHealthProgram: TMedicalRecordHealthProgram;
  updateMedicalRecordVaccine: TMedicalRecordVaccine;
  updateMedicalReferral: TMedicalReferral;
  updateMedicalRestriction: TMedicalRestriction;
  updateMedicine: TMedicine;
  updateMeeting: TMeeting;
  updateOccupation: TOccupation;
  updateOccupationalHealthCertificate: TOccupationalHealthCertificate;
  updateOrganization: TOrganizationWithBranches;
  updateOrganizationFlag: TBaseFlagReturn;
  updateOrthoRater: TOrthoRater;
  updatePeriodicRange: TPeriodicRange;
  updatePerson: TPerson;
  updatePhysicalEnvironment: TPhysicalEnvironment;
  updatePosition: TPosition;
  updatePreferences: Scalars['Boolean']['output'];
  updateProduct: TProduct;
  updateProductDelivery: TProductDelivery;
  updateProductIpeManufacturer: TProductIpeManufacturer;
  updateQueue: TESocialQueue;
  updateQuiz: TQuiz;
  updateReportSection: TReportSection;
  updateReportStructure: TReportStructure;
  updateResultExamIbmp: TResultExamIbmp;
  updateRisk: TRisk;
  updateRiskAgent: TRiskAgent;
  updateRisks: Array<TRisk>;
  updateRole: TRole;
  updateRolePermission: TRolePermission;
  updateRoles: Array<TRole>;
  updateSafetyQuiz: TSafetyQuiz;
  updateScheduleRestriction: TScheduleRestriction;
  /** Define a duração padrão da consulta. Escopo: allBranches grava no nível da organização; branchIds grava em cada filial informada; sem escopo, na filial atual. null limpa o valor. */
  updateSchedulingSettings: TSchedulingSettings;
  updateSignCredentials: TSignCredentialsOutput;
  updateSilenceThreshold: TTtalkInboundSilenceThreshold;
  updateSimulation: TSimulation;
  updateSimulationPlan: TSimulationPlan;
  updateSipat: TSipat;
  updateSnellen: TSnellen;
  updateSpareParts: TSpareParts;
  updateStabilityType: TStabilityType;
  updateStatementResponsibility: TStatementResponsibility;
  updateStockLevel: TStockLevel;
  updateSuggestionBox: TSuggestionBox;
  updateTask: TTask;
  updateTraining: TTraining;
  updateTrainingHistory: TTrainingHistory;
  updateUnityOfMeasure: TUnityOfMeasure;
  updateUrinalysis: TUrinalysis;
  updateUser: TUserBasicInfo;
  updateUserFlag: TBaseFlagReturn;
  updateUserRoleMdt: Array<TUserRoleMdt>;
  updateUserSpecialty: TUserSpecialty;
  updateVaccine: TVaccine;
  updateWarehouse: TWarehouse;
  updateWebhook: TWebhook;
  updateWebhookQueue: TWebhookQueue;
  updateWorkPermission: TWorkPermission;
  updateWorkShift: TWorkShift;
  uploadEnvironmentalReportContent: TEnvironmentalReport;
  upsertFilterPreference: TUserFilterPreferenceResult;
  /** Cria ou atualiza a configuração de uma notificação */
  upsertNotificationConfig: TNotificationConfigDto;
  validateIpeDelivery: Array<TIpeDelivery>;
  validateIpeFace: Array<TIpeDeliveryFace>;
  validateMedicalRecordVaccineBiometry: TVaccineBiometry;
  validateOHCertificateBiometry: TOccupationalHealthBiometry;
  verifyUser: TUserBasicInfo;
};


export type TMutation_ClearSessionAndDeleteOrganizationDataArgs = {
  token: Scalars['String']['input'];
};


export type TMutation_CreateAdminArgs = {
  user: TUserCreationInput;
};


export type TMutation_CreateAndVerifyUserArgs = {
  user: TUserCreationInput;
};


export type TMutation_CreateDoctorArgs = {
  user: TUserCreationInput;
};


export type TMutation_CreatePersonWithUserArgs = {
  person: TPersonInput;
};


export type TMutation_CreateVerifyDoctorAndAcceptPolicyAndLoginArgs = {
  user: T_UserCreationInput;
};


export type TMutation_CreateVerifyUserAndAcceptPolicyAndLoginArgs = {
  user: T_UserCreationInput;
};


export type TMutation_InviteAndCreateUserArgs = {
  invite: T_InviteInput;
};


export type TMutationAcknowledgeEmptyCipaMinuteArgs = {
  meetingId: Scalars['String']['input'];
};


export type TMutationAcknowledgeEmptyFireBrigadeMinuteArgs = {
  meetingId: Scalars['String']['input'];
};


export type TMutationAcknowledgeInconsistencyArgs = {
  id: Scalars['String']['input'];
};


export type TMutationAddOwnershipArgs = {
  fields: TOrganizationOwnershipInput;
};


export type TMutationBatchMessagesArgs = {
  branches?: InputMaybe<Array<Scalars['String']['input']>>;
  maxDate: Scalars['DateTime']['input'];
  minDate: Scalars['DateTime']['input'];
};


export type TMutationBlockRoleArgs = {
  userId: Scalars['String']['input'];
};


export type TMutationBlockRolesArgs = {
  userId: Scalars['String']['input'];
};


export type TMutationCancelDocumentArgs = {
  documentId: Scalars['Float']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type TMutationChangePreMedicalCertificateStatusArgs = {
  input: TChangeStatusPreMedicalCertificateInput;
};


export type TMutationClearFilterPreferenceArgs = {
  module: Scalars['String']['input'];
};


export type TMutationConfigureAdIntegrateArgs = {
  accessBy: TAccessBy;
  identifiers: Scalars['String']['input'];
  metadataUrl?: InputMaybe<Scalars['String']['input']>;
  metadataXml?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationConfirmImportArgs = {
  rowsFile: TBaseAttachmentArgs;
  type: TImporterType;
};


export type TMutationCopyExposureGroupArgs = {
  exposure: TExposureGroupCopyInput;
};


export type TMutationCopyProductsToBranchesArgs = {
  input: TProductCopyInput;
};


export type TMutationCopySuggestionArgs = {
  id: Scalars['String']['input'];
};


export type TMutationCreateAbsenceTypeArgs = {
  absenceType: TAbsenceTypeInput;
};


export type TMutationCreateAbsenceTypeByGenericArgs = {
  referenceId: Scalars['String']['input'];
};


export type TMutationCreateAccessTokenArgs = {
  fields: TAccessTokenInput;
};


export type TMutationCreateAccidentArgs = {
  accident: TAccidentInput;
};


export type TMutationCreateAccidentAttachmentArgs = {
  accidentId: Scalars['String']['input'];
  attachment: TBaseAttachmentArgs;
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationCreateAccidentCauseArgs = {
  accidentCause: TAccidentCauseInput;
};


export type TMutationCreateAccidentCauseByGenericArgs = {
  referenceId: Scalars['String']['input'];
};


export type TMutationCreateAccreditedArgs = {
  accredited: TAccreditedInput;
};


export type TMutationCreateAccreditedAsServiceProviderArgs = {
  input: TServiceProviderInput;
};


export type TMutationCreateActionPlanArgs = {
  actionPlan: TActionPlanInput;
};


export type TMutationCreateActionPlanAttachmentArgs = {
  actionPlanId: Scalars['String']['input'];
  attachment: TBaseAttachmentArgs;
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationCreateActionPlanInvestigationArgs = {
  actionPlanReport: TActionPlanReportInput;
};


export type TMutationCreateActionPlanMicroActionArgs = {
  actionPlanMicroAction: TActionPlanMicroActionInput;
};


export type TMutationCreateAgreementArgs = {
  signature: Scalars['String']['input'];
};


export type TMutationCreateAllowanceTypeArgs = {
  allowanceType: TAllowanceTypeInput;
};


export type TMutationCreateApiAccessArgs = {
  name: Scalars['String']['input'];
};


export type TMutationCreateBiologicalMonitoringArgs = {
  biologicalMonitoring: TBiologicalMonitoringInput;
};


export type TMutationCreateBiologicalMonitoringExamGroupArgs = {
  biologicalMonitoringExamGroup: TBiologicalMonitoringExamGroupInput;
};


export type TMutationCreateBiologicalMonitoringExamGroupByGenericArgs = {
  referenceId: Scalars['String']['input'];
};


export type TMutationCreateBiometryArgs = {
  biometry: Array<TBiometryInput>;
  personId: Scalars['String']['input'];
};


export type TMutationCreateBranchArgs = {
  branch: TBranchInput;
};


export type TMutationCreateCalendarArgs = {
  fields: TCalendarInput;
};


export type TMutationCreateCandidateArgs = {
  candidate: TCandidateInput;
};


export type TMutationCreateClinicalQuizArgs = {
  quiz: TClinicalQuizInput;
};


export type TMutationCreateComponentArgs = {
  component: TComponentInput;
};


export type TMutationCreateConsultationArgs = {
  consultation: TConsultationInput;
  unscheduled: Scalars['Boolean']['input'];
};


export type TMutationCreateContactRequestArgs = {
  fields: TContactRequestInput;
};


export type TMutationCreateControlMeasureArgs = {
  controlMeasure: TControlMeasureInput;
};


export type TMutationCreateCostCenterArgs = {
  costCenter: TCostCenterInput;
};


export type TMutationCreateCostCenterByGenericArgs = {
  referenceId: Scalars['String']['input'];
};


export type TMutationCreateDeficiencyArgs = {
  deficiency: TDeficiencyInput;
};


export type TMutationCreateDeficiencyAttachmentArgs = {
  attachment: TBaseAttachmentArgs;
  deficiencyId: Scalars['String']['input'];
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationCreateDeliverySparePartsArgs = {
  deliverySparePart: Array<TDeliverySparePartsInput>;
};


export type TMutationCreateDepartmentArgs = {
  department: TDepartmentInput;
};


export type TMutationCreateDevOrganizationArgs = {
  userOrgInfo: TUserCreationInput;
};


export type TMutationCreateDiagnosticArgs = {
  completeConsultation?: InputMaybe<Scalars['Boolean']['input']>;
  diagnostic: TDiagnosticInput;
  medicalRecordId: Scalars['String']['input'];
  realizationDate: Scalars['DateTime']['input'];
};


export type TMutationCreateElectionComissionArgs = {
  electionComission: TElectionComissionInput;
};


export type TMutationCreateEmployeeTaskArgs = {
  employeeTask: TEmployeeTaskInput;
};


export type TMutationCreateEmployeeWarningArgs = {
  employeeWarning: TEmployeeWarningOnPersonInput;
  personId: Scalars['String']['input'];
};


export type TMutationCreateEnvironmentalReportArgs = {
  environmentalReport: TEnvironmentalReportInput;
};


export type TMutationCreateEnvironmentalReportAttachmentArgs = {
  attachment: TBaseAttachmentArgs;
  environmentalReportId: Scalars['String']['input'];
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationCreateEnvironmentalReportBiometryArgs = {
  biometry: TEnvironmentalReportBiometryInput;
  environmentalReportId: Scalars['String']['input'];
};


export type TMutationCreateEnvironmentalReportFaceArgs = {
  environmentalReportId: Scalars['String']['input'];
  face: TEnvironmentalReportFaceInput;
};


export type TMutationCreateEquipmentByCostCenterArgs = {
  equipmentByCostCenter: TEquipmentByCostCenterInput;
};


export type TMutationCreateEquipmentByOccupationArgs = {
  equipmentByOccupation: TEquipmentByOccupationInput;
};


export type TMutationCreateExamArgs = {
  exam: TExamInput;
};


export type TMutationCreateExamAudiometryArgs = {
  examAudiometry: TExamAudiometryInput;
  realizationDate: Scalars['DateTime']['input'];
  shouldHideConsultation: Scalars['Boolean']['input'];
};


export type TMutationCreateExamByGenericArgs = {
  referenceId: Scalars['String']['input'];
};


export type TMutationCreateExamDiagnosticImageArgs = {
  examDiagnosticImage: TExamDiagnosticImageInput;
  realizationDate: Scalars['DateTime']['input'];
  shouldHideConsultation: Scalars['Boolean']['input'];
};


export type TMutationCreateExamDiagnosticImageAttachmentArgs = {
  attachment: TBaseAttachmentArgs;
  diagnosticImageId: Scalars['String']['input'];
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationCreateExamItemArgs = {
  examItem: TExamItemInput;
  realizationDate: Scalars['DateTime']['input'];
  shouldHideConsultation: Scalars['Boolean']['input'];
};


export type TMutationCreateExamNormalArgs = {
  examNormal: TExamNormalInput;
  shouldHideConsultation: Scalars['Boolean']['input'];
};


export type TMutationCreateExamOtologicalArgs = {
  examOtological: TExamOtologicalInput;
  realizationDate: Scalars['DateTime']['input'];
  shouldHideConsultation: Scalars['Boolean']['input'];
};


export type TMutationCreateExamSpirometryArgs = {
  examSpirometry: TExamSpirometryInput;
  realizationDate: Scalars['DateTime']['input'];
  shouldHideConsultation: Scalars['Boolean']['input'];
};


export type TMutationCreateExamToxicologicalArgs = {
  examToxicological: TExamToxicologicalInput;
  realizationDate: Scalars['DateTime']['input'];
  shouldHideConsultation: Scalars['Boolean']['input'];
};


export type TMutationCreateExpectedGoalArgs = {
  expectedGoal: TExpectedGoalInput;
};


export type TMutationCreateExpenseArgs = {
  expense: TExpenseInput;
};


export type TMutationCreateExpenseByGenericArgs = {
  referenceId: Scalars['String']['input'];
};


export type TMutationCreateExposureGroupArgs = {
  exposureGroup: TExposureGroupInput;
};


export type TMutationCreateExposureGroupCostCenterArgs = {
  exposureGroupCostCenter: TExposureGroupCostCenterInput;
};


export type TMutationCreateExposureGroupDepartmentArgs = {
  exposureGroupDepartment: TExposureGroupDepartmentInput;
};


export type TMutationCreateExposureGroupOccupationArgs = {
  exposureGroupOccupation: TExposureGroupOccupationInput;
};


export type TMutationCreateExposureGroupPersonArgs = {
  exposureGroupPerson: TExposureGroupPersonInput;
};


export type TMutationCreateExposureGroupTaskArgs = {
  exposureGroupTask: TExposureGroupTaskInput;
};


export type TMutationCreateExternalOccupationalHealthCertificateArgs = {
  occupationalHealthCertificate: TExternalOccupationalHealthCertificateInput;
};


export type TMutationCreateExtinguishingAttachmentArgs = {
  attachment: TBaseAttachmentArgs;
  extinguishingSystemId: Scalars['String']['input'];
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationCreateExtinguishingInspectionAttachmentArgs = {
  attachment: TBaseAttachmentArgs;
  inspectionId: Scalars['String']['input'];
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationCreateExtinguishingSystemArgs = {
  extinguishingSystem: TExtinguishingSystemInput;
};


export type TMutationCreateFireBrigadeArgs = {
  fireBrigade: TFireBrigadeInput;
};


export type TMutationCreateFireBrigadeComponentArgs = {
  fireBrigadeComponent: TFireBrigadeComponentInput;
};


export type TMutationCreateFireBrigadeExamArgs = {
  fireBrigadeExam: TFireBrigadeExamInput;
};


export type TMutationCreateFireBrigadeMeetingArgs = {
  fireBrigadeMeeting: TFireBrigadeMeetingInput;
};


export type TMutationCreateFireBrigadeMeetingAttachmentArgs = {
  attachment: TBaseAttachmentArgs;
  meetingId: Scalars['String']['input'];
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationCreateFireBrigadeOccurrenceArgs = {
  fireBrigadeOccurrence: TFireBrigadeOccurrenceInput;
};


export type TMutationCreateFireBrigadeOccurrenceAttachmentArgs = {
  attachment: TBaseAttachmentArgs;
  occurrenceId: Scalars['String']['input'];
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationCreateFireBrigadeTrainingArgs = {
  fireBrigadeTraining: TFireBrigadeTrainingInput;
};


export type TMutationCreateGeneratingSourceArgs = {
  generatingSource: TGeneratingSourceInput;
};


export type TMutationCreateHealthProgramArgs = {
  healthProgram: THealthProgramInput;
};


export type TMutationCreateHealthProgramByGenericArgs = {
  referenceId: Scalars['String']['input'];
};


export type TMutationCreateHealthProgramTrainingArgs = {
  healthProgramTraining: THealthProgramTrainingInput;
};


export type TMutationCreateInvestigationArgs = {
  investigation: TInvestigationInput;
};


export type TMutationCreateInvestigationAttachmentArgs = {
  attachment: TBaseAttachmentArgs;
  investigationId: Scalars['String']['input'];
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationCreateInviteArgs = {
  invite: TInviteInput;
};


export type TMutationCreateIpeDeliveryArgs = {
  ipeDelivery: Array<TIpeDeliveryInput>;
};


export type TMutationCreateIpeDeliveryExtensionArgs = {
  input: TIpeDeliveryExtensionInput;
};


export type TMutationCreateIpeIpeBiometryArgs = {
  biometry: TIpeBiometryInput;
  deliveries: Array<Scalars['String']['input']>;
};


export type TMutationCreateMandateArgs = {
  mandate: TMandateInput;
};


export type TMutationCreateMandateActionArgs = {
  mandateAction: TMandateActionInput;
};


export type TMutationCreateMandateCostCenterArgs = {
  mandateCostCenter: TMandateCostCenterInput;
};


export type TMutationCreateMandateDepartmentArgs = {
  mandateDepartment: TMandateDepartmentInput;
};


export type TMutationCreateMandateTrainingArgs = {
  mandateTraining: TMandateTrainingInput;
};


export type TMutationCreateManyOrdinaryFireBrigadeMeetingArgs = {
  date: Scalars['DateTime']['input'];
  fireBrigadeId: Scalars['String']['input'];
};


export type TMutationCreateManyOrdinaryMeetingArgs = {
  date: Scalars['DateTime']['input'];
  mandateId: Scalars['String']['input'];
};


export type TMutationCreateMeasuringInstrumentArgs = {
  measuringInstrument: TMeasuringInstrumentInput;
};


export type TMutationCreateMeasuringInstrumentAttachmentArgs = {
  attachment: TBaseAttachmentArgs;
  measuringInstrumentId: Scalars['String']['input'];
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationCreateMeasuringInstrumentByGenericArgs = {
  referenceId: Scalars['String']['input'];
};


export type TMutationCreateMedicalCertificateArgs = {
  medicalCertificate: TMedicalCertificateInput;
};


export type TMutationCreateMedicalCertificateAttachmentArgs = {
  attachment: TBaseAttachmentArgs;
  medicalCertificateId: Scalars['String']['input'];
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationCreateMedicalRecordArgs = {
  medicalRecord: TMedicalRecordInput;
};


export type TMutationCreateMedicalRecordAttachmentArgs = {
  attachment: TBaseAttachmentArgs;
  medicalRecordId: Scalars['String']['input'];
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationCreateMedicalRecordHealthProgramArgs = {
  medicalRecordHealthProgram: TMedicalRecordHealthProgramInput;
};


export type TMutationCreateMedicalRecordVaccineArgs = {
  medicalRecordVaccine: TMedicalRecordVaccineInput;
};


export type TMutationCreateMedicalRecordVaccinePlanningArgs = {
  medicalRecordsVaccinePlan: Array<TMedicalRecordVaccineInput>;
};


export type TMutationCreateMedicalReferralArgs = {
  medicalReferral: TMedicalReferralInput;
};


export type TMutationCreateMedicalReferralDoctorBiometryArgs = {
  biometry: TMedicalReferralDoctorBiometryInput;
  doctorId: Scalars['String']['input'];
  medicalReferralId: Scalars['String']['input'];
};


export type TMutationCreateMedicalRestrictionArgs = {
  medicalRestriction: TMedicalRestrictionInput;
};


export type TMutationCreateMedicineArgs = {
  medicine: TMedicineInput;
};


export type TMutationCreateMedicineByGenericArgs = {
  referenceId: Scalars['String']['input'];
};


export type TMutationCreateMeetingArgs = {
  meeting: TMeetingInput;
};


export type TMutationCreateMeetingAttachmentArgs = {
  attachment: TBaseAttachmentArgs;
  meetingId: Scalars['String']['input'];
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationCreateOccupationArgs = {
  occupation: TOccupationInput;
};


export type TMutationCreateOccupationByGenericArgs = {
  referenceId: Scalars['String']['input'];
};


export type TMutationCreateOccupationalHealthCertificateArgs = {
  occupationalHealthCertificate: TOccupationalHealthCertificateInput;
};


export type TMutationCreateOccupationalHealthCertificateAttachmentArgs = {
  attachment: TBaseAttachmentArgs;
  occupationalHealthCertificateId: Scalars['String']['input'];
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationCreateOccupationalHealthOccupationalHealthBiometryArgs = {
  biometry: TOccupationalHealthBiometryInput;
  occupationalHealthCertificateId: Scalars['String']['input'];
};


export type TMutationCreateOrganizationArgs = {
  organization: TOrganizationInput;
};


export type TMutationCreateOrthoRaterArgs = {
  orthoRater: TOrthoRaterInput;
  realizationDate: Scalars['DateTime']['input'];
  shouldHideConsultation: Scalars['Boolean']['input'];
};


export type TMutationCreatePeriodicRangeArgs = {
  fields: TPeriodicRangeInput;
};


export type TMutationCreatePeriodicRangeByGenericArgs = {
  referenceId: Scalars['String']['input'];
};


export type TMutationCreatePersonArgs = {
  person: TPersonInput;
};


export type TMutationCreatePersonAttachmentArgs = {
  attachment: TBaseAttachmentArgs;
  personId: Scalars['String']['input'];
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationCreatePhysicalEnvironmentArgs = {
  physicalEnvironment: TPhysicalEnvironmentInput;
};


export type TMutationCreatePhysicalEnvironmentAttachmentArgs = {
  attachment: TBaseAttachmentArgs;
  physicalEnvironmentId: Scalars['String']['input'];
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationCreatePolicyAgreementArgs = {
  type: TPrivacyType;
};


export type TMutationCreatePolicyTermArgs = {
  term: TPolicyTermsInput;
};


export type TMutationCreatePositionArgs = {
  position: TPositionInput;
};


export type TMutationCreateProductArgs = {
  product: TProductInput;
};


export type TMutationCreateProductDeliveryArgs = {
  productDelivery: Array<TProductDeliveryInput>;
};


export type TMutationCreateProductIpeManufacturerArgs = {
  productIpeManufacturer: TProductIpeManufacturerInput;
};


export type TMutationCreateQuizArgs = {
  quiz: TQuizInput;
};


export type TMutationCreateQuizAttachmentArgs = {
  attachment: TBaseAttachmentArgs;
  quizId: Scalars['String']['input'];
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationCreateQuizByGenericArgs = {
  referenceId: Scalars['String']['input'];
};


export type TMutationCreateRealGoalArgs = {
  realGoal: TRealGoalInput;
};


export type TMutationCreateRealGoalAttachmentArgs = {
  actionPlanId: Scalars['String']['input'];
  attachment: TBaseAttachmentArgs;
  realGoalId: Scalars['String']['input'];
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationCreateReportAttachmentArgs = {
  attachment: TBaseAttachmentArgs;
  environmentalReportId: Scalars['String']['input'];
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationCreateReportSectionArgs = {
  reportSection: TReportSectionInput;
};


export type TMutationCreateReportStructureArgs = {
  reportStructure: TReportStructureInput;
};


export type TMutationCreateResponsibleActionArgs = {
  responsibleAction: TResponsibleActionInput;
};


export type TMutationCreateResultExamIbmpArgs = {
  examIbmp: TResultExamIbmpInput;
  realizationDate: Scalars['DateTime']['input'];
  shouldHideConsultation: Scalars['Boolean']['input'];
};


export type TMutationCreateRiskArgs = {
  risk: TRiskInput;
};


export type TMutationCreateRiskAgentArgs = {
  riskAgent: TRiskAgentInput;
};


export type TMutationCreateRiskAgentByGenericArgs = {
  referenceId: Scalars['String']['input'];
};


export type TMutationCreateRiskAttachmentArgs = {
  attachment: TBaseAttachmentArgs;
  riskId: Scalars['String']['input'];
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationCreateRolePermissionArgs = {
  rolePermission: TRolePermissionInput;
};


export type TMutationCreateSafetyQuizArgs = {
  quiz: TSafetyQuizInput;
};


export type TMutationCreateScheduleRestrictionArgs = {
  scheduleRestriction: TScheduleRestrictionInput;
};


export type TMutationCreateSessionArgs = {
  input: TSessionInput;
};


export type TMutationCreateSessionByAdArgs = {
  input: TSessionInputAd;
};


export type TMutationCreateSessionForBranchArgs = {
  branchId: Scalars['String']['input'];
};


export type TMutationCreateSignCredentialsArgs = {
  input: TSignCredentialsInput;
};


export type TMutationCreateSignDocumentEnvironmentalReportArgs = {
  environmentalReportId: Scalars['String']['input'];
  input: TRecipientInput;
};


export type TMutationCreateSignDocumentIpeDeliveryArgs = {
  input: TRecipientInput;
  sourceId: Scalars['String']['input'];
};


export type TMutationCreateSignDocumentMedicalCertificateArgs = {
  certificateId: Scalars['String']['input'];
  input: TRecipientInput;
};


export type TMutationCreateSignDocumentOhcArgs = {
  certificateId: Scalars['String']['input'];
  input: TRecipientInput;
};


export type TMutationCreateSignDocumentSecurityWorkOrderArgs = {
  input: TRecipientInput;
  sourceId: Scalars['String']['input'];
};


export type TMutationCreateSimulationArgs = {
  simulation: TSimulationInput;
};


export type TMutationCreateSimulationPlanArgs = {
  simulationPlan: TSimulationPlanInput;
};


export type TMutationCreateSipatArgs = {
  sipat: TSipatInput;
};


export type TMutationCreateSipatAttachmentArgs = {
  attachment: TBaseAttachmentArgs;
  sipatId: Scalars['String']['input'];
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationCreateSnellenArgs = {
  realizationDate: Scalars['DateTime']['input'];
  shouldHideConsultation: Scalars['Boolean']['input'];
  snellen: TSnellenInput;
};


export type TMutationCreateSparePartsArgs = {
  sparePart: TSparePartsInput;
};


export type TMutationCreateStabilityTypeArgs = {
  StabilityType: TStabilityTypeInput;
};


export type TMutationCreateStatementResponsibilityArgs = {
  statement: TStatementResponsibilityInput;
};


export type TMutationCreateStatementResponsibilityByGenericArgs = {
  referenceId: Scalars['String']['input'];
};


export type TMutationCreateStockLevelArgs = {
  stockLevel: TStockLevelInput;
};


export type TMutationCreateStockMovementArgs = {
  stockMovement: TStockMovementInput;
};


export type TMutationCreateSuggestionBoxArgs = {
  suggestionBox: TSuggestionBoxInput;
};


export type TMutationCreateTaskArgs = {
  task: TTaskInput;
};


export type TMutationCreateThumbnailArgs = {
  attachment: TBaseAttachmentArgs;
  urlOrigin: Scalars['String']['input'];
};


export type TMutationCreateTrainingArgs = {
  training: TTrainingInput;
};


export type TMutationCreateTrainingAttachmentArgs = {
  attachment: TBaseAttachmentArgs;
  mandateTrainingId: Scalars['String']['input'];
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
  trainingId: Scalars['String']['input'];
};


export type TMutationCreateTrainingByGenericArgs = {
  referenceId: Scalars['String']['input'];
};


export type TMutationCreateTrainingHistoryArgs = {
  input: TTrainingHistoryInput;
};


export type TMutationCreateTrainingHistoryAttachmentArgs = {
  attachment: TBaseAttachmentArgs;
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
  trainingHistoryId: Scalars['String']['input'];
};


export type TMutationCreateTrainingHistoryBatchArgs = {
  input: TTrainingHistoryBatchInput;
};


export type TMutationCreateUnityOfMeasureArgs = {
  unityOfMeasure: TUnityOfMeasureInput;
};


export type TMutationCreateUrinalysisArgs = {
  realizationDate: Scalars['DateTime']['input'];
  shouldHideConsultation: Scalars['Boolean']['input'];
  urinalysis: TUrinalysisInput;
};


export type TMutationCreateUserArgs = {
  user: TUserCreationInput;
};


export type TMutationCreateUserSpecialtyArgs = {
  userId: Scalars['String']['input'];
  userSpecialty: TUserSpecialtyInput;
};


export type TMutationCreateVaccineArgs = {
  vaccine: TVaccineInput;
};


export type TMutationCreateVaccineByGenericArgs = {
  referenceId: Scalars['String']['input'];
};


export type TMutationCreateVoteArgs = {
  vote: TVoteInput;
};


export type TMutationCreateWarehouseArgs = {
  warehouse: TWarehouseInput;
};


export type TMutationCreateWarningAttachmentArgs = {
  attachment: TBaseAttachmentArgs;
  employeeWarningId: Scalars['String']['input'];
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationCreateWebhookArgs = {
  webhook: TWebHookCreateInput;
};


export type TMutationCreateWebhookQueueArgs = {
  webhookQueue: TWebhookQueueCreateInput;
};


export type TMutationCreateWorkPermissionArgs = {
  workPermission: TWorkPermissionInput;
};


export type TMutationCreateWorkShiftArgs = {
  workShift: TWorkShiftInput;
};


export type TMutationCreateWorkShiftByGenericArgs = {
  referenceId: Scalars['String']['input'];
};


export type TMutationCsvAccreditedArgs = {
  attachment: TBaseAttachmentArgs;
};


export type TMutationCsvClinicalQuizArgs = {
  attachment: TBaseAttachmentArgs;
};


export type TMutationCsvDeficiencyArgs = {
  attachment: TBaseAttachmentArgs;
};


export type TMutationCsvMedicalCertificateArgs = {
  attachment: TBaseAttachmentArgs;
};


export type TMutationCsvMedicalRecordArgs = {
  attachment: TBaseAttachmentArgs;
};


export type TMutationCsvMedicalRecordVaccineArgs = {
  attachment: TBaseAttachmentArgs;
};


export type TMutationCsvOccupationalHealthCertificateArgs = {
  attachment: TBaseAttachmentArgs;
};


export type TMutationCsvQuizArgs = {
  attachment: TBaseAttachmentArgs;
};


export type TMutationCsvRiskArgs = {
  attachment: TBaseAttachmentArgs;
};


export type TMutationDeleteEnvironmentalReportVersionArgs = {
  id: Scalars['String']['input'];
};


export type TMutationDeletePolicyAgreementArgs = {
  id: Scalars['String']['input'];
};


export type TMutationDeletePolicyTermArgs = {
  id: Scalars['String']['input'];
};


export type TMutationESocialCreateFieldsValidationArgs = {
  accident?: InputMaybe<TAccidentInput>;
};


export type TMutationESocialUpdateFieldsValidationArgs = {
  accident?: InputMaybe<TAccidentUpdate>;
};


export type TMutationEmployeeAnswerClinicalQuizArgs = {
  input: TEmployeeAnswerClinicalQuizInput;
};


export type TMutationEmployeeAnswerSafetyQuizArgs = {
  input: TEmployeeAnswerSafetyQuizInput;
};


export type TMutationEmployeeCandidateArgs = {
  candidate: TEmployeeByMandateIdInput;
};


export type TMutationEmployeeLoginByAdArgs = {
  input: TSessionInputAd;
};


export type TMutationEmployeeLoginMutationArgs = {
  generate: TBaseInput;
};


export type TMutationEmployeeVoteArgs = {
  vote: TEmployeeVoteInput;
};


export type TMutationForceUserUpdatePasswordArgs = {
  fields: TInputUserReplacePassword;
};


export type TMutationForkDocumentFromDefaultArgs = {
  subType?: InputMaybe<TCustomDocumentSubType>;
  type: TDocumentType;
};


export type TMutationGenerateEnvironmentalReportSignAttachmentArgs = {
  environmentalReportId: Scalars['String']['input'];
};


export type TMutationGeneratePasswordArgs = {
  generate: TGeneratePasswordInput;
};


export type TMutationHermesCreateMetadataArgs = {
  input: TCreateMetadataInput;
};


export type TMutationHermesDeleteMetadataArgs = {
  metadataId: Scalars['String']['input'];
};


export type TMutationHermesIntegrationConfigureArgs = {
  input: TIntegrationConfigureInput;
};


export type TMutationHermesUpdateBranchArgs = {
  name: Scalars['String']['input'];
};


export type TMutationHermesUpdateMetadataArgs = {
  input: TUpdateMetadataInput;
};


export type TMutationHermesUpdateOrganizationArgs = {
  socialName: Scalars['String']['input'];
};


export type TMutationImportSstOptionsArgs = {
  options: TSstMigratorValues;
};


export type TMutationInitialIntegrationConfigByBranchArgs = {
  integrationConfiguration: TIntegrationConfigurationInput;
};


export type TMutationInsertFeatureFlagArgs = {
  features: Array<TFeatureObjectInput>;
  flag: TFlag;
  priority: Scalars['Float']['input'];
};


export type TMutationInsertOrganizationFlagArgs = {
  flag: Array<TFlag>;
  organizationId: Scalars['String']['input'];
};


export type TMutationInsertUserFlagArgs = {
  flag: Array<TFlag>;
  userId: Scalars['String']['input'];
};


export type TMutationInviteByCsvArgs = {
  attachment: TBaseAttachmentArgs;
};


export type TMutationManageCustomOrganizationArgs = {
  customOrganization: Array<TCustomOrganizationInput>;
};


export type TMutationMigrateDataToHermesArgs = {
  orgId?: InputMaybe<Scalars['String']['input']>;
};


export type TMutationOrganizationCancelContractArgs = {
  cancelContract: TOrganizationCancelContractInput;
};


export type TMutationOrganizationContractArgs = {
  contract: TOrganizationContractInput;
};


export type TMutationOrganizationReactiveContractArgs = {
  contract: TOrganizationContractInput;
};


export type TMutationPreValidateArgs = {
  attachment: TBaseAttachmentArgs;
  type: TImporterType;
};


export type TMutationPurgeFeatureArgs = {
  feature: TFeature;
};


export type TMutationPurgeFlagArgs = {
  flag: TFlag;
};


export type TMutationReactivateBranchArgs = {
  branchId: Scalars['String']['input'];
};


export type TMutationReactivateRoleArgs = {
  userId: Scalars['String']['input'];
};


export type TMutationRecognizeMedicalCertificateArgs = {
  input: TRecognizeMedicalCertificateInput;
};


export type TMutationRegisterFeatureFlagArgs = {
  features: Array<TFeatureObjectInput>;
  flag: TFlag;
  priority: Scalars['Float']['input'];
};


export type TMutationReleaseConsultationResultsArgs = {
  input: TReleaseConsultationResultsInput;
};


export type TMutationRemoveAbsenceTypeArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveAccidentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveAccidentAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveAccidentCauseArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveAccreditedArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveActionPlanArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveActionPlanAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveActionPlanMicroActionArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveAllBiometriesArgs = {
  personId: Scalars['String']['input'];
};


export type TMutationRemoveAllowanceTypeArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveApiAccessArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveBiologicalMonitoringExamGroupArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveBiometryArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveBranchArgs = {
  branchId: Scalars['String']['input'];
};


export type TMutationRemoveCalendarArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveCandidateArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveClinicalQuizArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveComplementaryExamArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveComponentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveConsultationArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveControlMeasureArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveCostCenterArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveDeficiencyArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveDeficiencyAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveDeliverySparePartsArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveDepartmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveDiagnosticArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveDocumentArgs = {
  documentId: Scalars['Float']['input'];
};


export type TMutationRemoveElectionComissionArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveEmployeeTaskArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveEmployeeWarningArgs = {
  id: Scalars['String']['input'];
  personId: Scalars['String']['input'];
};


export type TMutationRemoveEnvironmentalReportArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveEnvironmentalReportAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveEnvironmentalReportBiometryArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveEquipmentByCostCenterArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveEquipmentByOccupationArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveExamArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveExamDiagnosticImageArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveExamDiagnosticImageAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveExamNormalArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveExamOtologicalArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveExamToxicologicalArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveExpectedGoalArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveExpenseArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveExposureGroupArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveExposureGroupCostCenterArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveExposureGroupDepartmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveExposureGroupOccupationArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveExposureGroupPersonArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveExposureGroupTaskArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveExtinguishingAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveExtinguishingInspectionAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveExtinguishingSystemArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveFireBrigadeArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveFireBrigadeComponentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveFireBrigadeExamArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveFireBrigadeMeetingArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveFireBrigadeMeetingAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveFireBrigadeOccurrenceArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveFireBrigadeOccurrenceAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveFireBrigadeTrainingArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveGeneratingSourceArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveHealthProgramArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveHealthProgramTrainingArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveInvestigationArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveInvestigationAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveInviteArgs = {
  email: Scalars['String']['input'];
};


export type TMutationRemoveIpeBiometryArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveIpeDeliveryArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveIpeDeliveryExtensionArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveMandateArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveMandateActionArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveMandateCostCenterArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveMandateDepartmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveMandateTrainingArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveMeasuringInstrumentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveMeasuringInstrumentAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveMedicalCertificateArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveMedicalCertificateAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveMedicalRecordArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveMedicalRecordAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveMedicalRecordHealthProgramArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveMedicalRecordVaccineArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveMedicalReferralArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveMedicalReferralDoctorBiometryArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveMedicalRestrictionArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveMedicineArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveMeetingArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveMeetingAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveOccupationArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveOccupationalHealthBiometryArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveOccupationalHealthCertificateArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveOccupationalHealthCertificateAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveOrthoRaterArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveOwnershipArgs = {
  fields: TOrganizationOwnershipInput;
};


export type TMutationRemovePeriodicRangeArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemovePersonArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemovePersonAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemovePhysicalEnvironmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemovePhysicalEnvironmentAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemovePositionArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveProductArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveProductDeliveryArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveProductIpeManufacturerArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveQuizArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveQuizAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveRealGoalArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveRealGoalAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveReportAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveReportStructureArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveResponsibleActionArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveResultExamIbmpArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveRiskArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveRiskAgentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveRiskAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveRoleArgs = {
  userId: Scalars['String']['input'];
};


export type TMutationRemoveRolePermissionArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveRolesArgs = {
  userId: Scalars['String']['input'];
};


export type TMutationRemoveSafetyQuizArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveScheduleRestrictionArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveServiceArgs = {
  line?: InputMaybe<TErpLine>;
  organizationId: Scalars['String']['input'];
  serviceDescription?: InputMaybe<Scalars['String']['input']>;
  type: TErpType;
};


export type TMutationRemoveSessionArgs = {
  token: Scalars['String']['input'];
};


export type TMutationRemoveSimulationArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveSimulationPlanArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveSipatArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveSipatAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveSnellenArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveSparePartsArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveStabilityTypeArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveStatementResponsibilityArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveStockLevelArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveSuggestionBoxArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveTaskArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveTrainingArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveTrainingAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveTrainingHistoryArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveTrainingHistoryAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveTrialOrganizationUserArgs = {
  userId: Scalars['String']['input'];
};


export type TMutationRemoveUnityOfMeasureArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveUrinalysisArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveUserSpecialtyArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveVaccineArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveWarehouseArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveWarningAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveWebhookArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveWebhookQueueArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveWorkPermissionArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRemoveWorkShiftArgs = {
  id: Scalars['String']['input'];
};


export type TMutationReplacementIpeDeliveryArgs = {
  ipeDeliveryInput: TIpeDeliveryInput;
  ipeDeliveryUpdate: TIpeDeliveryUpdate;
};


export type TMutationReplacementProductDeliveryArgs = {
  productDeliveryInput: TProductDeliveryInput;
  productDeliveryUpdate: TProductDeliveryUpdate;
};


export type TMutationReprocessTtalkInboundEventArgs = {
  id: Scalars['String']['input'];
};


export type TMutationRequestAuditLogExportArgs = {
  format: TAuditExportFormat;
  pagination?: InputMaybe<TPagination>;
  query: TAuditLogQueryInput;
};


export type TMutationRequestMapUrlArgs = {
  attachment: TBaseAttachmentArgs;
  thumbnail?: InputMaybe<TBaseAttachmentArgs>;
};


export type TMutationRequestPasswordResetArgs = {
  email: Scalars['String']['input'];
};


export type TMutationResendBatchArgs = {
  dates: TWebhookQueueBatchInput;
};


export type TMutationResendInviteArgs = {
  email: Scalars['String']['input'];
};


export type TMutationResendInviteVerificationArgs = {
  email: Scalars['String']['input'];
};


export type TMutationResendQueueArgs = {
  id: Scalars['String']['input'];
};


export type TMutationResendUserEmailVerificationArgs = {
  email: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};


export type TMutationResendWebhookEventArgs = {
  id: Scalars['String']['input'];
};


export type TMutationResetCustomDocumentToDefaultArgs = {
  subType?: InputMaybe<TCustomDocumentSubType>;
  type: TDocumentType;
};


export type TMutationResetPasswordArgs = {
  confirmationCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type TMutationResolveRiskSyncArgs = {
  branchId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type TMutationRetryTTalkQueueArgs = {
  id: Scalars['ID']['input'];
};


export type TMutationRetryTTalkQueueBatchArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type TMutationSaveEnvironmentalReportVersionArgs = {
  input: TSaveEnvironmentalReportVersionInput;
};


export type TMutationSaveOhcDoctorFaceArgs = {
  face: TOccupationalHealthFaceInput;
  id: Scalars['String']['input'];
};


export type TMutationSaveOhcFaceArgs = {
  face: TOccupationalHealthFaceInput;
  id: Scalars['String']['input'];
};


export type TMutationSaveRiskCompositionArgs = {
  compositions: TRiskCompositionSave;
};


export type TMutationScheduleExpectedConsultationsArgs = {
  input: TUnscheduledInput;
};


export type TMutationSendFirstESocialLoadArgs = {
  branch: TESocialFirstLoadInput;
};


export type TMutationSendLoadByPeriodArgs = {
  branch: TESocialFirstLoadInput;
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type TMutationSendPendingMessagesArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  queueId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type TMutationSetBranchLogoArgs = {
  branchId: Scalars['String']['input'];
  contentLength: Scalars['Float']['input'];
  contentType: Scalars['String']['input'];
};


export type TMutationSetBranchesArgs = {
  anonymize?: InputMaybe<Scalars['Boolean']['input']>;
  branches: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type TMutationSetEmployeeProfilePictureArgs = {
  contentLength: Scalars['Float']['input'];
  contentType: Scalars['String']['input'];
};


export type TMutationSetOrganizationPictureArgs = {
  contentLength: Scalars['Float']['input'];
  contentType: Scalars['String']['input'];
};


export type TMutationSetSendNotifyArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type TMutationSetUserProfilePictureArgs = {
  contentLength: Scalars['Float']['input'];
  contentType: Scalars['String']['input'];
};


export type TMutationSocResendQueueArgs = {
  queueId: Scalars['String']['input'];
};


export type TMutationSocRunSyncArgs = {
  syncId: Scalars['String']['input'];
};


export type TMutationSubscriptionLevelDiscountArgs = {
  discounts: TSubscriptionLevelDiscount;
};


export type TMutationSyncAllOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type TMutationSyncByOrganizationArgs = {
  businessEntity: TBusinessEntity;
};


export type TMutationSyncCronArgs = {
  branchId: Scalars['String']['input'];
  businessEntity: TBusinessEntity;
};


export type TMutationSyncMessageArgs = {
  id: Scalars['String']['input'];
};


export type TMutationSyncMessagesArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  queueId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type TMutationSyncStockLevelsArgs = {
  productIds: Array<Scalars['String']['input']>;
};


export type TMutationTransferConsultationsArgs = {
  input: TTransferConsultationsInput;
};


export type TMutationUnblockRoleArgs = {
  userId: Scalars['String']['input'];
};


export type TMutationUnblockRolesArgs = {
  userId: Scalars['String']['input'];
};


export type TMutationUnsetBranchLogoArgs = {
  branchId: Scalars['String']['input'];
};


export type TMutationUpdateAbsenceTypeArgs = {
  absenceType: TAbsenceTypeUpdate;
};


export type TMutationUpdateAccidentArgs = {
  accident: TAccidentUpdate;
};


export type TMutationUpdateAccidentCauseArgs = {
  accidentCause: TAccidentCauseUpdate;
};


export type TMutationUpdateAccreditedArgs = {
  accredited: TAccreditedUpdate;
};


export type TMutationUpdateAccreditedAsServiceProviderArgs = {
  accredited: TServiceProviderUpdate;
};


export type TMutationUpdateActionPlanArgs = {
  actionPlan: TActionPlanUpdate;
};


export type TMutationUpdateActionPlanMicroActionArgs = {
  actionPlanMicroAction: TActionPlanMicroActionUpdate;
};


export type TMutationUpdateAllowanceTypeArgs = {
  allowanceType: TAllowanceTypeUpdate;
};


export type TMutationUpdateBiologicalMonitoringArgs = {
  biologicalMonitoring: TBiologicalMonitoringUpdate;
};


export type TMutationUpdateBiologicalMonitoringExamGroupArgs = {
  biologicalMonitoringExamGroup: TBiologicalMonitoringExamGroupUpdate;
};


export type TMutationUpdateBiometryArgs = {
  biometry: Array<TBiometryInput>;
  personId: Scalars['String']['input'];
};


export type TMutationUpdateBranchArgs = {
  fields: TBranchUpdateInput;
};


export type TMutationUpdateCalendarArgs = {
  fields: TCalendarUpdate;
};


export type TMutationUpdateCandidateArgs = {
  candidate: TCandidateUpdate;
};


export type TMutationUpdateClinicalQuizArgs = {
  quiz: TClinicalQuizUpdate;
};


export type TMutationUpdateComponentArgs = {
  component: TComponentUpdate;
};


export type TMutationUpdateConsultationArgs = {
  consultation: TConsultationUpdate;
};


export type TMutationUpdateControlMeasureArgs = {
  controlMeasure: TControlMeasureUpdate;
};


export type TMutationUpdateCostCenterArgs = {
  costCenter: TCostCenterUpdate;
};


export type TMutationUpdateCronTabArgs = {
  cron: TCronTabInput;
};


export type TMutationUpdateCustomDocumentArgs = {
  id: Scalars['ID']['input'];
  input: TUpdateCustomDocumentInput;
};


export type TMutationUpdateCustomerArgs = {
  customer: TCustomerInput;
};


export type TMutationUpdateDeficiencyArgs = {
  deficiency: TDeficiencyUpdate;
};


export type TMutationUpdateDeliverySparePartsArgs = {
  sparePart: TDeliverySparePartsUpdate;
};


export type TMutationUpdateDepartmentArgs = {
  department: TDepartmentUpdate;
};


export type TMutationUpdateDiagnosticArgs = {
  completeConsultation?: InputMaybe<Scalars['Boolean']['input']>;
  diagnostic: TDiagnosticUpdate;
  medicalRecordId: Scalars['String']['input'];
};


export type TMutationUpdateEmployeeNicknameArgs = {
  data: TEmployeeNicknameInput;
};


export type TMutationUpdateEmployeePreferencesArgs = {
  preferences: TEmployeePreferencesInput;
};


export type TMutationUpdateEmployeeTaskArgs = {
  employeeTask: TEmployeeTaskUpdate;
};


export type TMutationUpdateEmployeeWarningArgs = {
  employeeWarning: TEmployeeWarningOnPersonInput;
};


export type TMutationUpdateEndpointArgs = {
  endpoints: Array<TEndpointInput>;
};


export type TMutationUpdateEnvironmentalReportArgs = {
  environmentalReport: TEnvironmentalReportUpdate;
};


export type TMutationUpdateExamArgs = {
  exam: TExamUpdate;
};


export type TMutationUpdateExamAudiometryArgs = {
  examAudiometry: TExamAudiometryUpdate;
};


export type TMutationUpdateExamDiagnosticImageArgs = {
  examDiagnosticImage: TExamDiagnosticImageUpdate;
};


export type TMutationUpdateExamItemArgs = {
  examItem: TExamItemUpdate;
};


export type TMutationUpdateExamNormalArgs = {
  examNormal: TExamNormalUpdate;
};


export type TMutationUpdateExamOtologicalArgs = {
  examOtological: TExamOtologicalUpdate;
};


export type TMutationUpdateExamSpirometryArgs = {
  examSpirometry: TExamSpirometryUpdate;
};


export type TMutationUpdateExamToxicologicalArgs = {
  examToxicological: TExamToxicologicalUpdate;
};


export type TMutationUpdateExpenseArgs = {
  expense: TExpenseUpdate;
};


export type TMutationUpdateExposureGroupArgs = {
  exposureGroup: TExposureGroupUpdate;
};


export type TMutationUpdateExposureGroupCostCenterArgs = {
  exposureGroupCostCenter: TExposureGroupCostCenterUpdate;
};


export type TMutationUpdateExposureGroupDepartmentArgs = {
  exposureGroupDepartment: TExposureGroupDepartmentUpdate;
};


export type TMutationUpdateExposureGroupOccupationArgs = {
  exposureGroupOccupation: TExposureGroupOccupationUpdate;
};


export type TMutationUpdateExposureGroupPersonArgs = {
  exposureGroupPerson: TExposureGroupPersonUpdate;
};


export type TMutationUpdateExposureGroupTaskArgs = {
  exposureGroupTask: TExposureGroupTaskUpdate;
};


export type TMutationUpdateExternalOccupationalHealthCertificateArgs = {
  occupationalHealthCertificate: TExternalOccupationalHealthCertificateUpdate;
};


export type TMutationUpdateExtinguishingSystemArgs = {
  extinguishingSystem: TExtinguishingSystemUpdate;
};


export type TMutationUpdateFeatureFlagArgs = {
  features: Array<TFeatureObjectInput>;
  flag: TFlag;
  priority: Scalars['Float']['input'];
};


export type TMutationUpdateFeatureVersionArgs = {
  feature: TFeature;
  flag: TFlag;
  version: TFeatureVersion;
};


export type TMutationUpdateFireBrigadeArgs = {
  fireBrigade: TFireBrigadeUpdate;
};


export type TMutationUpdateFireBrigadeComponentArgs = {
  fireBrigadeComponent: TFireBrigadeComponentUpdate;
};


export type TMutationUpdateFireBrigadeExamArgs = {
  fireBrigadeExam: TFireBrigadeExamUpdate;
};


export type TMutationUpdateFireBrigadeMeetingArgs = {
  fireBrigadeMeeting: TFireBrigadeMeetingUpdate;
};


export type TMutationUpdateFireBrigadeOccurrenceArgs = {
  fireBrigadeOccurrence: TFireBrigadeOccurrenceUpdate;
};


export type TMutationUpdateGeneratingSourceArgs = {
  generatingSource: TGeneratingSourceUpdate;
};


export type TMutationUpdateHealthProgramArgs = {
  healthProgram: THealthProgramUpdate;
};


export type TMutationUpdateIntegrationConfigOptionArgs = {
  integrationId: Scalars['String']['input'];
  option: TIntegrationConfigurationOptionInput;
};


export type TMutationUpdateInvestigationArgs = {
  investigation: TInvestigationUpdate;
};


export type TMutationUpdateIpeDeliveryArgs = {
  ipeDelivery: TIpeDeliveryUpdate;
};


export type TMutationUpdateMandateArgs = {
  mandate: TMandateUpdate;
};


export type TMutationUpdateMandateEventArgs = {
  mandateEvent: TMandateEventUpdate;
};


export type TMutationUpdateMandateTrainingArgs = {
  mandateTraining: TMandateTrainingUpdateInput;
};


export type TMutationUpdateMeasuringInstrumentArgs = {
  measuringInstrument: TMeasuringInstrumentUpdate;
};


export type TMutationUpdateMedicalCertificateArgs = {
  medicalCertificate: TMedicalCertificateUpdate;
};


export type TMutationUpdateMedicalRecordArgs = {
  medicalRecord: TMedicalRecordUpdate;
};


export type TMutationUpdateMedicalRecordHealthProgramArgs = {
  medicalRecordHealthProgram: TMedicalRecordHealthProgramUpdate;
};


export type TMutationUpdateMedicalRecordVaccineArgs = {
  medicalRecordVaccine: TMedicalRecordVaccineUpdate;
};


export type TMutationUpdateMedicalReferralArgs = {
  medicalReferral: TMedicalReferralUpdate;
};


export type TMutationUpdateMedicalRestrictionArgs = {
  medicalRestriction: TMedicalRestrictionUpdate;
};


export type TMutationUpdateMedicineArgs = {
  medicine: TMedicineUpdate;
};


export type TMutationUpdateMeetingArgs = {
  meeting: TMeetingUpdate;
};


export type TMutationUpdateOccupationArgs = {
  occupation: TOccupationUpdate;
};


export type TMutationUpdateOccupationalHealthCertificateArgs = {
  occupationalHealthCertificate: TOccupationalHealthCertificateUpdate;
};


export type TMutationUpdateOrganizationArgs = {
  fields: TOrganizationUpdateInput;
};


export type TMutationUpdateOrganizationFlagArgs = {
  flag: Array<TFlag>;
  organizationId: Scalars['String']['input'];
};


export type TMutationUpdateOrthoRaterArgs = {
  orthoRater: TOrthoRaterUpdate;
};


export type TMutationUpdatePeriodicRangeArgs = {
  fields: TPeriodicRangeUpdate;
};


export type TMutationUpdatePersonArgs = {
  person: TPersonUpdate;
};


export type TMutationUpdatePhysicalEnvironmentArgs = {
  physicalEnvironment: TPhysicalEnvironmentUpdate;
};


export type TMutationUpdatePositionArgs = {
  position: TPositionUpdate;
};


export type TMutationUpdatePreferencesArgs = {
  preferences: TUserPreferencesInput;
};


export type TMutationUpdateProductArgs = {
  product: TProductUpdate;
};


export type TMutationUpdateProductDeliveryArgs = {
  productDelivery: TProductDeliveryUpdate;
};


export type TMutationUpdateProductIpeManufacturerArgs = {
  productIpeManufacturer: TProductIpeManufacturerUpdate;
};


export type TMutationUpdateQueueArgs = {
  queue: TESocialQueueUpdate;
};


export type TMutationUpdateQuizArgs = {
  quiz: TQuizUpdate;
};


export type TMutationUpdateReportSectionArgs = {
  reportSection: TReportSectionUpdate;
};


export type TMutationUpdateReportStructureArgs = {
  reportStructure: TReportStructureUpdate;
};


export type TMutationUpdateResultExamIbmpArgs = {
  examIbmp: TResultExamIbmpUpdate;
};


export type TMutationUpdateRiskArgs = {
  risk: TRiskUpdate;
};


export type TMutationUpdateRiskAgentArgs = {
  riskAgent: TRiskAgentUpdate;
};


export type TMutationUpdateRisksArgs = {
  risks: Array<TRiskUpdate>;
};


export type TMutationUpdateRoleArgs = {
  update: TRoleUpdate;
};


export type TMutationUpdateRolePermissionArgs = {
  rolePermission: TRolePermissionUpdate;
};


export type TMutationUpdateRolesArgs = {
  update: TRoleUpdate;
};


export type TMutationUpdateSafetyQuizArgs = {
  quiz: TSafetyQuizUpdate;
};


export type TMutationUpdateScheduleRestrictionArgs = {
  scheduleRestriction: TScheduleRestrictionUpdate;
};


export type TMutationUpdateSchedulingSettingsArgs = {
  allBranches?: InputMaybe<Scalars['Boolean']['input']>;
  branchIds?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultConsultationMinutes?: InputMaybe<Scalars['Int']['input']>;
};


export type TMutationUpdateSignCredentialsArgs = {
  input: TSignCredentialsInput;
};


export type TMutationUpdateSilenceThresholdArgs = {
  input: TTtalkInboundSilenceThresholdInput;
};


export type TMutationUpdateSimulationArgs = {
  simulation: TSimulationUpdate;
};


export type TMutationUpdateSimulationPlanArgs = {
  simulationPlan: TSimulationPlanUpdate;
};


export type TMutationUpdateSipatArgs = {
  sipat: TSipatUpdate;
};


export type TMutationUpdateSnellenArgs = {
  snellen: TSnellenUpdate;
};


export type TMutationUpdateSparePartsArgs = {
  sparePart: TSparePartsUpdate;
};


export type TMutationUpdateStabilityTypeArgs = {
  StabilityType: TStabilityTypeUpdate;
};


export type TMutationUpdateStatementResponsibilityArgs = {
  statement: TStatementResponsibilityUpdate;
};


export type TMutationUpdateStockLevelArgs = {
  stockLevel: TStockLevelUpdate;
};


export type TMutationUpdateSuggestionBoxArgs = {
  suggestionBox: TSuggestionBoxUpdate;
};


export type TMutationUpdateTaskArgs = {
  task: TTaskUpdate;
};


export type TMutationUpdateTrainingArgs = {
  training: TTrainingUpdate;
};


export type TMutationUpdateTrainingHistoryArgs = {
  input: TTrainingHistoryUpdate;
};


export type TMutationUpdateUnityOfMeasureArgs = {
  unityOfMeasure: TUnityOfMeasureUpdate;
};


export type TMutationUpdateUrinalysisArgs = {
  urinalysis: TUrinalysisUpdate;
};


export type TMutationUpdateUserArgs = {
  fields: TUserUpdateInput;
};


export type TMutationUpdateUserFlagArgs = {
  flag: Array<TFlag>;
  userId: Scalars['String']['input'];
};


export type TMutationUpdateUserRoleMdtArgs = {
  roles: Array<TUserRoleUpdate>;
  userId: Scalars['String']['input'];
};


export type TMutationUpdateUserSpecialtyArgs = {
  userSpecialty: TUserSpecialtyUpdate;
};


export type TMutationUpdateVaccineArgs = {
  vaccine: TVaccineUpdate;
};


export type TMutationUpdateWarehouseArgs = {
  warehouse: TWarehouseUpdate;
};


export type TMutationUpdateWebhookArgs = {
  webhook: TWebHookUpdateInput;
};


export type TMutationUpdateWebhookQueueArgs = {
  webhookQueue: TWebHookUpdateInput;
};


export type TMutationUpdateWorkPermissionArgs = {
  workPermission: TWorkPermissionUpdate;
};


export type TMutationUpdateWorkShiftArgs = {
  workShift: TWorkShiftUpdate;
};


export type TMutationUploadEnvironmentalReportContentArgs = {
  attachment: TBaseAttachmentArgs;
  environmentalReportId: Scalars['String']['input'];
};


export type TMutationUpsertFilterPreferenceArgs = {
  filtersJson: Scalars['String']['input'];
  module: Scalars['String']['input'];
};


export type TMutationUpsertNotificationConfigArgs = {
  input: TNotificationConfigUpsertInput;
};


export type TMutationValidateIpeDeliveryArgs = {
  biometry: TIpeBiometryInput;
};


export type TMutationValidateIpeFaceArgs = {
  face: TIpeFaceInput;
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  verifyIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type TMutationValidateMedicalRecordVaccineBiometryArgs = {
  biometry: TVaccineBiometryInput;
  id: Scalars['String']['input'];
};


export type TMutationValidateOhCertificateBiometryArgs = {
  biometry: TOccupationalHealthBiometryInput;
  doctorId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type TMutationVerifyUserArgs = {
  user: TInputUserCheck;
};

/** Natureza do atestado */
export enum TNature {
  /** Admissional */
  Admission = 'Admission',
  /** Retorno ao trabalho */
  BackToWork = 'BackToWork',
  /** Mudança de função */
  ChangeOfFunction = 'ChangeOfFunction',
  /** Demissional */
  Dismissal = 'Dismissal',
  /** Periódico */
  Periodic = 'Periodic',
  /** Monitoramento pontual */
  SpotMonitoring = 'SpotMonitoring'
}

/** Enumeração de nitritos */
export enum TNitritesEnum {
  /** Negativo */
  Negative = 'Negative',
  /** Positivo - maior */
  PositiveMajor = 'PositiveMajor',
  /** Positivo - menor */
  PositiveMinor = 'PositiveMinor'
}

/** Exposição ao ruído */
export enum TNoiseExposureEnum {
  /** Constante */
  Constant = 'Constant',
  /** Eventual */
  Eventual = 'Eventual',
  /** Não exposto */
  NotExposed = 'NotExposed'
}

export type TNoiseRisk = {
  __typename?: 'NoiseRisk';
  actionLevelTN0: Scalars['Float']['output'];
  amountTN0: Scalars['Float']['output'];
  descriptionCTT: Scalars['String']['output'];
  descriptionSRJ: Scalars['String']['output'];
  exposureTimeTN0: Scalars['DateTime']['output'];
  nameTN7: Scalars['String']['output'];
};

export type TNotification = {
  __typename?: 'Notification';
  appId: Scalars['String']['output'];
  tags: TNotificationTags;
};

export type TNotificationConfigDto = {
  __typename?: 'NotificationConfigDto';
  /** Cargos MDT adicionais configurados pelo admin (além do padrão do módulo) */
  additionalRoles: Array<Scalars['String']['output']>;
  /** Cargos MDT padrão desta notificação, alinhados aos destinatários do envio */
  defaultRoles: Array<Scalars['String']['output']>;
  /** Notificação habilitada */
  enabled: Scalars['Boolean']['output'];
  /** E-mails removidos dos destinatários padrão (vindos da regra de cargo) */
  excludedRecipients: Array<Scalars['String']['output']>;
  /** Cargos MDT padrão do módulo que o admin desativou para esta notificação */
  excludedRoles: Array<Scalars['String']['output']>;
  /** ID da configuração */
  id: Scalars['String']['output'];
  /** Descrição legível da notificação */
  label: Scalars['String']['output'];
  /** Módulo da notificação */
  module: Scalars['String']['output'];
  /** Dias em que a notificação deve ser enviada antes da consulta */
  periodicityDays: Array<Scalars['Int']['output']>;
  /** Destinatários extras configurados */
  recipients: Array<Scalars['String']['output']>;
  /** Nome do template */
  templateName: Scalars['String']['output'];
};

export type TNotificationConfigUpsertInput = {
  /** Cargos MDT adicionais a incluir nesta notificação */
  additionalRoles: Array<Scalars['String']['input']>;
  /** Notificação habilitada */
  enabled: Scalars['Boolean']['input'];
  /** E-mails a excluir dos destinatários padrão */
  excludedRecipients: Array<Scalars['String']['input']>;
  /** Cargos MDT padrão do módulo a excluir desta notificação */
  excludedRoles: Array<Scalars['String']['input']>;
  /** Dias em que a notificação deve ser enviada antes da consulta */
  periodicityDays?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Destinatários extras */
  recipients: Array<Scalars['String']['input']>;
  /** Nome do template */
  templateName: Scalars['String']['input'];
};

export type TNotificationTags = {
  __typename?: 'NotificationTags';
  branchId: Scalars['String']['output'];
  doctor?: Maybe<Scalars['Boolean']['output']>;
  engineer?: Maybe<Scalars['Boolean']['output']>;
  humanresource?: Maybe<Scalars['Boolean']['output']>;
  nourse?: Maybe<Scalars['Boolean']['output']>;
  nurse?: Maybe<Scalars['Boolean']['output']>;
  organizationId: Scalars['String']['output'];
  personId?: Maybe<Scalars['String']['output']>;
  secretary?: Maybe<Scalars['Boolean']['output']>;
  storekeeper?: Maybe<Scalars['Boolean']['output']>;
  technician?: Maybe<Scalars['Boolean']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type TNtepDistributionChart = {
  __typename?: 'NtepDistributionChart';
  /** Distribuição (top 4 + Outros) */
  data: Array<TNtepPieEntry>;
  /** Possui atestados com NTEP no período */
  hasNtep: Scalars['Boolean']['output'];
};

export type TNtepEvolutionChart = {
  __typename?: 'NtepEvolutionChart';
  /** Possui atestados com NTEP no período */
  hasNtep: Scalars['Boolean']['output'];
  /** Séries por CID (top 4 + Outros) */
  series: Array<TNtepSeries>;
};

export type TNtepPieEntry = {
  __typename?: 'NtepPieEntry';
  /** Código do CID/grupo CID */
  code: Scalars['String']['output'];
  /** Descrição completa do CID/grupo CID */
  description: Scalars['String']['output'];
  /** Nome curto (código + descrição abreviada) */
  name: Scalars['String']['output'];
  /** Quantidade absoluta */
  value: Scalars['Float']['output'];
};

export type TNtepSeries = {
  __typename?: 'NtepSeries';
  /** Código do CID/grupo CID */
  code: Scalars['String']['output'];
  /** Descrição completa do CID/grupo CID */
  description: Scalars['String']['output'];
  /** Nome da série (CID com descrição abreviada) */
  name: Scalars['String']['output'];
  /** Valores mensais */
  values: Array<TData>;
};

export type TObserversItemInput = {
  documentSendType?: InputMaybe<TSendType>;
  email: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TOccupation = {
  __typename?: 'Occupation';
  /** Detalhes da atividade */
  activityDetails?: Maybe<Scalars['String']['output']>;
  /** CBO */
  cbo?: Maybe<Scalars['String']['output']>;
  /** Descrição */
  description: Scalars['String']['output'];
  /** Equipamentos */
  equipments?: Maybe<Array<TEquipmentByOccupation>>;
  /** Identificador no ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** Exames */
  exams?: Maybe<Array<TExamByOccupation>>;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Indica se está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Necessita equipamento */
  needEquipment?: Maybe<Scalars['Boolean']['output']>;
  /** Identificador de referência */
  referenceId?: Maybe<Scalars['String']['output']>;
  /** Responsabilidades da ocupação */
  responsibilities?: Maybe<Scalars['String']['output']>;
  /** Restrições da ocupação */
  restrictions?: Maybe<Scalars['String']['output']>;
  /** Sugestão */
  suggestion?: Maybe<Scalars['String']['output']>;
};

export type TOccupationByRisk = {
  __typename?: 'OccupationByRisk';
  /** ID da relação */
  id: Scalars['String']['output'];
  /** Ocupação vinculada ao risco */
  occupation: TOccupation;
};

export type TOccupationByRiskInput = {
  /** ID da ocupação */
  occupationId: Scalars['String']['input'];
  /** ID do risco */
  riskId: Scalars['String']['input'];
};

export type TOccupationInput = {
  /** Detalhes da atividade */
  activityDetails?: InputMaybe<Scalars['String']['input']>;
  /** CBO */
  cbo?: InputMaybe<Scalars['String']['input']>;
  /** Descrição */
  description: Scalars['String']['input'];
  /** Equipamentos */
  equipments?: InputMaybe<Array<TEquipmentOnOccupationInput>>;
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Exames */
  exams?: InputMaybe<Array<TExamByOccupationInput>>;
  /** Necessita equipamento */
  needEquipment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Responsabilidades da ocupação */
  responsibilities?: InputMaybe<Scalars['String']['input']>;
  /** Restrições da ocupação */
  restrictions?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da filial de destino */
  targetBranchId?: InputMaybe<Scalars['String']['input']>;
};

export type TOccupationIntegration = {
  /** Detalhes da atividade */
  activityDetails?: InputMaybe<Scalars['String']['input']>;
  /** Filial */
  branch: Scalars['String']['input'];
  /** CBO */
  cbo?: InputMaybe<Scalars['String']['input']>;
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Descrição detalhada da atividade */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Necessita equipamento */
  needEquipment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Responsabilidades da ocupação */
  responsibilities?: InputMaybe<Scalars['String']['input']>;
  /** Restrições da ocupação */
  restrictions?: InputMaybe<Scalars['String']['input']>;
};

export type TOccupationOnRiskInput = {
  /** ID da ocupação */
  occupationId: Scalars['String']['input'];
};

export type TOccupationOnVaccine = {
  __typename?: 'OccupationOnVaccine';
  /** ID da associação vacina-cargo */
  id: Scalars['String']['output'];
  /** Cargo associado à vacina */
  occupation: TOccupation;
};

export type TOccupationOnVaccineInput = {
  /** ID do cargo */
  occupationId: Scalars['String']['input'];
};

export type TOccupationUpdate = {
  /** Detalhes da atividade */
  activityDetails?: InputMaybe<Scalars['String']['input']>;
  /** CBO */
  cbo?: InputMaybe<Scalars['String']['input']>;
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Equipamentos */
  equipments?: InputMaybe<TEquipmentOnOccupationUpdate>;
  /** Exames */
  exams?: InputMaybe<TExamByOccupationChanges>;
  /** Identificador */
  id: Scalars['String']['input'];
  /** Indica se está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Necessita equipamento */
  needEquipment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Responsabilidades da ocupação */
  responsibilities?: InputMaybe<Scalars['String']['input']>;
  /** Restrições da ocupação */
  restrictions?: InputMaybe<Scalars['String']['input']>;
};

export type TOccupationalCertificateParameters = {
  __typename?: 'OccupationalCertificateParameters';
  fromDate: Scalars['String']['output'];
  toDate: Scalars['String']['output'];
};

export type TOccupationalDiseaseAnalysis = {
  __typename?: 'OccupationalDiseaseAnalysis';
  annual_number_of_diseases: Scalars['String']['output'];
  cost_center: Scalars['String']['output'];
  icd: Scalars['String']['output'];
  persistence: Scalars['String']['output'];
  prevalence: Scalars['String']['output'];
};

export type TOccupationalHealthBiometry = {
  __typename?: 'OccupationalHealthBiometry';
  /** Biometria */
  biometry: TBiometry;
  /** Identificador */
  id: Scalars['String']['output'];
};

export type TOccupationalHealthBiometryInput = {
  /** Identificador da biometria */
  biometryId: Scalars['String']['input'];
  /** Imagem BMP */
  bmp?: InputMaybe<Scalars['String']['input']>;
  /** Dados da imagem */
  imageData: Scalars['String']['input'];
  /** DPI da imagem */
  imageDpi?: InputMaybe<Scalars['Float']['input']>;
  /** Altura da imagem */
  imageHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Qualidade da imagem */
  imageQuality?: InputMaybe<Scalars['Float']['input']>;
  /** Largura da imagem */
  imageWidth?: InputMaybe<Scalars['Float']['input']>;
  /** Fabricante do equipamento */
  manufacturer: Scalars['String']['input'];
  /** Modelo do equipamento */
  model?: InputMaybe<Scalars['String']['input']>;
  /** NFIQ (NIST Fingerprint Image Quality) */
  nfiq?: InputMaybe<Scalars['Float']['input']>;
  /** Número de série */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Template da biometria */
  template?: InputMaybe<Scalars['String']['input']>;
  /** Imagem WSQ */
  wsqImage?: InputMaybe<Scalars['String']['input']>;
  /** Tamanho da imagem WSQ */
  wsqImageSize?: InputMaybe<Scalars['Float']['input']>;
};

export type TOccupationalHealthCertificate = {
  __typename?: 'OccupationalHealthCertificate';
  /** Anexos do Atestado de Saíde Ocupacional */
  attachments?: Maybe<Array<TAttachment>>;
  /** Biometria do colaborador */
  biometry?: Maybe<TOccupationalHealthBiometry>;
  /** ID da Filial */
  branch: Scalars['String']['output'];
  /** Data de cancelamento do ASO */
  cancelDate?: Maybe<Scalars['DateTime']['output']>;
  /** Indica se o colaborador possui permissão específica para trabalho com manutenção civil */
  civilMaintenance?: Maybe<Scalars['Boolean']['output']>;
  /** Indica se o colaborador possui permissão específica para trabalho a frio */
  cold?: Maybe<Scalars['Boolean']['output']>;
  /** Indica se o colaborador possui permissão específica para trabalho confinado */
  confined?: Maybe<Scalars['Boolean']['output']>;
  /** Consulta Médica */
  consultation?: Maybe<TConsultation>;
  /** Centro de Custo */
  costCenter?: Maybe<TCostCenter>;
  /** Em caso de mudança de risco, informar o ID do novo centro de custo */
  costCenterId?: Maybe<Scalars['String']['output']>;
  /** Departamento do colaborador */
  department?: Maybe<TDepartment>;
  /** Em caso de mudança de risco, informar o ID do novo departamento */
  departmentId?: Maybe<Scalars['String']['output']>;
  /** Biometria do médico */
  doctorBiometry?: Maybe<TOccupationalHealthBiometry>;
  /** Assinatura facial do médico */
  doctorFace?: Maybe<TOccupationalHealthFace>;
  /** Indica se o colaborador possui permissão específica para trabalho com eletricidade */
  electricity?: Maybe<Scalars['Boolean']['output']>;
  /** Data de emissão do ASO */
  emissionDate?: Maybe<Scalars['DateTime']['output']>;
  /** Chave externa do ASO */
  erpId?: Maybe<Scalars['String']['output']>;
  /** Indica se o colaborador possui permissão específica para trabalho em escavação */
  excavation?: Maybe<Scalars['Boolean']['output']>;
  /** Indica se o colaborador possui permissão específica para trabalho com explosivos */
  explosives?: Maybe<Scalars['Boolean']['output']>;
  /** Indica se o atendimento é externo */
  external?: Maybe<Scalars['Boolean']['output']>;
  /** Assinatura facial do funcionário */
  face?: Maybe<TOccupationalHealthFace>;
  /** Indica se o colaborador possui permissão específica para trabalho em altura */
  height?: Maybe<Scalars['Boolean']['output']>;
  /** ID do Atestado de Saúde Ocupacional */
  id: Scalars['String']['output'];
  /** Indica se o colaborador possui permissão específica para trabalho com transporte e movimentação de cargas */
  loadHandling?: Maybe<Scalars['Boolean']['output']>;
  /** ID do Prontuário Médico */
  medicalRecordId: Scalars['String']['output'];
  /** Natureza do Atestado Ocupacional. (Admission - Admissional; Periodic - Periódico; BackToWork - Retorno ao Trabalho; ChangeOfFunction - Mudanção de Risco; Dismissal - Demissional; SpotMonitoring - Monitoramento Pontual) */
  nature: TNature;
  /** Observações do ASO */
  observation?: Maybe<Scalars['String']['output']>;
  /** Função do colaborador */
  occupation?: Maybe<TOccupation>;
  /** Em caso de mudança de risco, informar o ID da nova função */
  occupationId?: Maybe<Scalars['String']['output']>;
  /** Indica se o colaborador possui permissão específica para trabalho em plataforma */
  plataform?: Maybe<Scalars['Boolean']['output']>;
  /** Indica se o colaborador possui permissão específica para trabalho em pressão */
  pressure?: Maybe<Scalars['Boolean']['output']>;
  /** Indica se o colaborador possui permissão específica para trabalho com radiação */
  radiation?: Maybe<Scalars['Boolean']['output']>;
  /** Parecer do ASO (Able - Apto; Unable - Inapto; AbleWithRestrictions - Apto com Restrições) */
  recommendation?: Maybe<TRecommendation>;
  /** Data de Agendamento */
  scheduleDate: Scalars['DateTime']['output'];
  /** Tarefa do colaborador */
  task?: Maybe<TTask>;
  /** Em caso de mudança de risco, informar o ID da nova tarefa */
  taskId?: Maybe<Scalars['String']['output']>;
  /** Indica se o colaborador possui permissão específica para trabalho com solda */
  welding?: Maybe<Scalars['Boolean']['output']>;
};

export type TOccupationalHealthCertificateByDate = {
  __typename?: 'OccupationalHealthCertificateByDate';
  month: Scalars['String']['output'];
  nature: TNature;
  total: Scalars['Float']['output'];
};

export type TOccupationalHealthCertificateInput = {
  /** Data de cancelamento do ASO */
  cancelDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Indica se o colaborador possui permissão específica para trabalho com manutenção civil */
  civilMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se o colaborador possui permissão específica para trabalho a frio */
  cold?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se o colaborador possui permissão específica para trabalho confinado */
  confined?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID da Consulta Médica */
  consultationId?: InputMaybe<Scalars['String']['input']>;
  /** Em caso de mudança de risco, informar o ID do novo centro de custo */
  costCenterId?: InputMaybe<Scalars['String']['input']>;
  /** Em caso de mudança de risco, informar o ID do novo departamento */
  departmentId?: InputMaybe<Scalars['String']['input']>;
  /** Indica se o colaborador possui permissão específica para trabalho com eletricidade */
  electricity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Data de emissão do ASO */
  emissionDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Chave externa do ASO */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Indica se o colaborador possui permissão específica para trabalho em escavação */
  excavation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se o colaborador possui permissão específica para trabalho com explosivos */
  explosives?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se o atendimento é externo */
  external?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se o colaborador possui permissão específica para trabalho em altura */
  height?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se o colaborador possui permissão específica para trabalho com transporte e movimentação de cargas */
  loadHandling?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID do Prontuário Médico */
  medicalRecordId: Scalars['String']['input'];
  /** Natureza do Atestado Ocupacional. (Admission - Admissional; Periodic - Periódico; BackToWork - Retorno ao Trabalho; ChangeOfFunction - Mudanção de Risco; Dismissal - Demissional; SpotMonitoring - Monitoramento Pontual) */
  nature: TNature;
  /** Observações do ASO */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Em caso de mudança de risco, informar o ID da nova função */
  occupationId?: InputMaybe<Scalars['String']['input']>;
  /** Indica se o colaborador possui permissão específica para trabalho em plataforma */
  plataform?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se o colaborador possui permissão específica para trabalho em pressão */
  pressure?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se o colaborador possui permissão específica para trabalho com radiação */
  radiation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parecer do ASO (Able - Apto; Unable - Inapto; AbleWithRestrictions - Apto com Restrições) */
  recommendation?: InputMaybe<TRecommendation>;
  /** Data de Agendamento */
  scheduleDate: Scalars['DateTime']['input'];
  /** Em caso de mudança de risco, informar o ID da nova tarefa */
  taskId?: InputMaybe<Scalars['String']['input']>;
  /** Indica se o colaborador possui permissão específica para trabalho com solda */
  welding?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TOccupationalHealthCertificateTotal = {
  __typename?: 'OccupationalHealthCertificateTotal';
  nature: TNature;
  total: Scalars['Float']['output'];
};

export type TOccupationalHealthCertificateUpdate = {
  /** Data de cancelamento do ASO */
  cancelDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Indica se o colaborador possui permissão específica para trabalho com manutenção civil */
  civilMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se o colaborador possui permissão específica para trabalho a frio */
  cold?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se o colaborador possui permissão específica para trabalho confinado */
  confined?: InputMaybe<Scalars['Boolean']['input']>;
  /** Em caso de mudança de risco, informar o ID do novo centro de custo */
  costCenterId?: InputMaybe<Scalars['String']['input']>;
  /** Em caso de mudança de risco, informar o ID do novo departamento */
  departmentId?: InputMaybe<Scalars['String']['input']>;
  /** Indica se o colaborador possui permissão específica para trabalho com eletricidade */
  electricity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Data de emissão do ASO */
  emissionDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Chave externa do ASO */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Indica se o colaborador possui permissão específica para trabalho em escavação */
  excavation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se o colaborador possui permissão específica para trabalho com explosivos */
  explosives?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se o atendimento é externo */
  external?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se o colaborador possui permissão específica para trabalho em altura */
  height?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  /** Indica se o colaborador possui permissão específica para trabalho com transporte e movimentação de cargas */
  loadHandling?: InputMaybe<Scalars['Boolean']['input']>;
  medicalRecordId?: InputMaybe<Scalars['String']['input']>;
  nature?: InputMaybe<TNature>;
  /** Observações do ASO */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Em caso de mudança de risco, informar o ID da nova função */
  occupationId?: InputMaybe<Scalars['String']['input']>;
  /** Indica se o colaborador possui permissão específica para trabalho em plataforma */
  plataform?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se o colaborador possui permissão específica para trabalho em pressão */
  pressure?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se o colaborador possui permissão específica para trabalho com radiação */
  radiation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parecer do ASO (Able - Apto; Unable - Inapto; AbleWithRestrictions - Apto com Restrições) */
  recommendation?: InputMaybe<TRecommendation>;
  scheduleDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Em caso de mudança de risco, informar o ID da nova tarefa */
  taskId?: InputMaybe<Scalars['String']['input']>;
  /** Indica se o colaborador possui permissão específica para trabalho com solda */
  welding?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TOccupationalHealthFace = {
  __typename?: 'OccupationalHealthFace';
  /** Identificador */
  id: Scalars['String']['output'];
  /** Imagem facial em base64 */
  picture: Scalars['String']['output'];
};

export type TOccupationalHealthFaceInput = {
  /** Imagem facial em base64 (data URL JPEG) */
  picture: Scalars['String']['input'];
};

export type TOccupationsGroup = {
  __typename?: 'OccupationsGroup';
  /** Descrição do cargo */
  description: Scalars['String']['output'];
  /** Identificador do cargo */
  id: Scalars['String']['output'];
  /** IPEs entregues para este cargo */
  ipes?: Maybe<Array<TIpesInfoSorted>>;
};

/** Percurso da ocorrência */
export enum TOccurencePath {
  /** Viagem de deslocamento */
  DeslocTrip = 'deslocTrip',
  /** Almoço para o trabalho */
  LunchToWork = 'lunchToWork',
  /** Residência para o trabalho */
  ResidenceToWork = 'residenceToWork',
  /** Trabalho para o almoço */
  WorkToLunch = 'workToLunch',
  /** Trabalho para a residência */
  WorkToResidence = 'workToResidence'
}

export type TOccurrenceEntry = {
  __typename?: 'OccurrenceEntry';
  label: Scalars['String']['output'];
  result: Scalars['Int']['output'];
};

/** Agravamento oftalmológico */
export enum TOphthalmologicAggravationEnum {
  /** Assistencial */
  Assistencial = 'Assistencial',
  /** Não se aplica */
  DoesNotApply = 'DoesNotApply',
  /** Ocupacional */
  Occupational = 'Occupational'
}

/** Enumeração de correção oftalmológica */
export enum TOphthalmologicCorrectionEnum {
  /** Ambos */
  Both = 'Both',
  /** Perto */
  Close = 'Close',
  /** Nenhum */
  DoesNotApply = 'DoesNotApply',
  /** Longe */
  Far = 'Far'
}

/** Direção da ordenação */
export enum TOrderBy {
  /** Ascendente */
  Ascending = 'Ascending',
  /** Descendente */
  Descending = 'Descending'
}

/** Material orgânico */
export enum TOrganicMaterial {
  /** Líquido amniótico */
  AmnioticFluid = 'AmnioticFluid',
  /** Líquido ascítico */
  AsciticFluid = 'AsciticFluid',
  /** Sangue */
  Blood = 'Blood',
  /** Líquido cefalorraquidiano */
  CerebrospinalFluid = 'CerebrospinalFluid',
  /** Fluido com sangue */
  FluidWithBlood = 'FluidWithBlood',
  /** Outros */
  Others = 'Others',
  /** Líquido pleural */
  PleuralFluid = 'PleuralFluid',
  /** Soro/Plasma */
  SerumPlasma = 'SerumPlasma'
}

export type TOrganization = {
  __typename?: 'Organization';
  /** Forma de acesso */
  accessBy?: Maybe<TAccessBy>;
  /** Chave de acesso */
  accessKey?: Maybe<Scalars['String']['output']>;
  /** Segredo de acesso */
  accessSecret?: Maybe<Scalars['String']['output']>;
  /** Identificadores do Cognito */
  cognitoIdentifiers?: Maybe<Scalars['String']['output']>;
  /** URL dos metadados do Cognito */
  cognitoMetadataUrl?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** Customizações da organização */
  customs?: Maybe<Array<TCustomOrganization>>;
  /** Data de início do eSocial */
  eSocialStart?: Maybe<Scalars['DateTime']['output']>;
  /** Status do eSocial */
  eSocialStatus?: Maybe<TESocialStatus>;
  /** Versão do eSocial */
  eSocialVersion?: Maybe<TESocialVersion>;
  /** Empresa no ERP */
  erpCompany?: Maybe<Scalars['String']['output']>;
  /** ID interno do ERP */
  erpInternalId?: Maybe<Scalars['String']['output']>;
  /** Data de expiração da assinatura */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID da organização */
  id: Scalars['String']['output'];
  /** Indica se é parceiro */
  isPartner: Scalars['Boolean']['output'];
  /** Indica se está reenviando mensagens */
  isResendingMessages?: Maybe<Scalars['Boolean']['output']>;
  /** Indica se é prestador de serviço */
  isServiceProvider: Scalars['Boolean']['output'];
  /** Indica se é Totvs */
  isTotvs: Scalars['Boolean']['output'];
  /** Nome da organização */
  name: Scalars['String']['output'];
  /** Logo da organização */
  organizationPicture?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** Status do plano */
  planStatus?: Maybe<TPlanStatus>;
  /** Cor primária */
  primaryColor?: Maybe<Scalars['String']['output']>;
  /** Cor secundária */
  secondaryColor?: Maybe<Scalars['String']['output']>;
  /** Configurações da organização */
  settings?: Maybe<TSettings>;
  /** Razão social */
  socialName?: Maybe<Scalars['String']['output']>;
  /** ID do tenant TPD */
  tpdTenantId?: Maybe<Scalars['String']['output']>;
  /** Dados de UTM */
  utmData?: Maybe<TUtmData>;
};

export type TOrganizationCancelContractInput = {
  /** Motivo do cancelamento */
  motivation: Scalars['String']['input'];
};

export type TOrganizationContractInput = {
  /** Endereço */
  address: Scalars['String']['input'];
  /** Número do endereço */
  addressNumber: Scalars['String']['input'];
  /** Forma de pagamento */
  billingType: TBillingMethod;
  /** Dados do cartão de crédito */
  creditCard?: InputMaybe<TAsaasCreditCardTokenInput>;
  /** Número do documento */
  documentNumber: Scalars['String']['input'];
  /** ID externo */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Nome */
  name: Scalars['String']['input'];
  /** Bairro */
  neighborhood: Scalars['String']['input'];
  /** Telefone */
  phone: Scalars['String']['input'];
  /** CEP */
  postalCode: Scalars['String']['input'];
};

export type TOrganizationInput = {
  /** Forma de acesso */
  accessBy?: InputMaybe<TAccessBy>;
  /** Chave de acesso */
  accessKey?: InputMaybe<Scalars['String']['input']>;
  /** Segredo de acesso */
  accessSecret?: InputMaybe<Scalars['String']['input']>;
  /** Dados da filial principal */
  branch: TBranchInput;
  /** Identificadores do Cognito */
  cognitoIdentifiers?: InputMaybe<Scalars['String']['input']>;
  /** URL dos metadados do Cognito */
  cognitoMetadataUrl?: InputMaybe<Scalars['S3UrlCloudFront']['input']>;
  /** Data de início do eSocial */
  eSocialStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Status do eSocial */
  eSocialStatus?: InputMaybe<TESocialStatus>;
  /** Versão do eSocial */
  eSocialVersion?: InputMaybe<TESocialVersion>;
  /** Empresa no ERP */
  erpCompany?: InputMaybe<Scalars['String']['input']>;
  /** ID interno do ERP */
  erpInternalId?: InputMaybe<Scalars['String']['input']>;
  /** Indica se está reenviando mensagens */
  isResendingMessages?: InputMaybe<Scalars['Boolean']['input']>;
  /** Nome da organização */
  name: Scalars['String']['input'];
  /** Cor primária */
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  /** Cor secundária */
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  /** Configurações da organização */
  settings?: InputMaybe<TSettingsInput>;
  /** Razão social */
  socialName?: InputMaybe<Scalars['String']['input']>;
  /** Dados de UTM */
  utmData?: InputMaybe<TUtmDataInput>;
};

export type TOrganizationOwnership = {
  __typename?: 'OrganizationOwnership';
  organizationId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type TOrganizationOwnershipInput = {
  organizationId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type TOrganizationUpdateInput = {
  /** Forma de acesso */
  accessBy?: InputMaybe<TAccessBy>;
  /** Chave de acesso */
  accessKey?: InputMaybe<Scalars['String']['input']>;
  /** Segredo de acesso */
  accessSecret?: InputMaybe<Scalars['String']['input']>;
  /** Identificadores do Cognito */
  cognitoIdentifiers?: InputMaybe<Scalars['String']['input']>;
  /** URL dos metadados do Cognito */
  cognitoMetadataUrl?: InputMaybe<Scalars['S3UrlCloudFront']['input']>;
  /** Data de início do eSocial */
  eSocialStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Status do eSocial */
  eSocialStatus?: InputMaybe<TESocialStatus>;
  /** Versão do eSocial */
  eSocialVersion?: InputMaybe<TESocialVersion>;
  /** Empresa no ERP */
  erpCompany?: InputMaybe<Scalars['String']['input']>;
  /** Indica se está reenviando mensagens */
  isResendingMessages?: InputMaybe<Scalars['Boolean']['input']>;
  /** Nome da organização */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Status do plano */
  planStatus?: InputMaybe<TPlanStatus>;
  /** Cor primária */
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  /** Cor secundária */
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  /** Configurações da organização */
  settings?: InputMaybe<TSettingsInput>;
  /** Razão social */
  socialName?: InputMaybe<Scalars['String']['input']>;
  /** ID do tenant TPD */
  tpdTenantId?: InputMaybe<Scalars['String']['input']>;
};

export type TOrganizationWithBranches = {
  __typename?: 'OrganizationWithBranches';
  /** Forma de acesso */
  accessBy?: Maybe<TAccessBy>;
  /** Chave de acesso */
  accessKey?: Maybe<Scalars['String']['output']>;
  /** Segredo de acesso */
  accessSecret?: Maybe<Scalars['String']['output']>;
  /** Filiais da organização */
  branches: Array<TBranch>;
  /** Identificadores do Cognito */
  cognitoIdentifiers?: Maybe<Scalars['String']['output']>;
  /** URL dos metadados do Cognito */
  cognitoMetadataUrl?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** Customizações da organização */
  customs?: Maybe<Array<TCustomOrganization>>;
  /** Data de início do eSocial */
  eSocialStart?: Maybe<Scalars['DateTime']['output']>;
  /** Status do eSocial */
  eSocialStatus?: Maybe<TESocialStatus>;
  /** Versão do eSocial */
  eSocialVersion?: Maybe<TESocialVersion>;
  /** Empresa no ERP */
  erpCompany?: Maybe<Scalars['String']['output']>;
  /** ID interno do ERP */
  erpInternalId?: Maybe<Scalars['String']['output']>;
  /** Data de expiração da assinatura */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID da organização */
  id: Scalars['String']['output'];
  /** Indica se é parceiro */
  isPartner: Scalars['Boolean']['output'];
  /** Indica se está reenviando mensagens */
  isResendingMessages?: Maybe<Scalars['Boolean']['output']>;
  /** Indica se é prestador de serviço */
  isServiceProvider: Scalars['Boolean']['output'];
  /** Indica se é Totvs */
  isTotvs: Scalars['Boolean']['output'];
  /** Nome da organização */
  name: Scalars['String']['output'];
  /** Logo da organização */
  organizationPicture?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** Status do plano */
  planStatus?: Maybe<TPlanStatus>;
  /** Cor primária */
  primaryColor?: Maybe<Scalars['String']['output']>;
  /** Cor secundária */
  secondaryColor?: Maybe<Scalars['String']['output']>;
  /** Configurações da organização */
  settings?: Maybe<TSettings>;
  /** Razão social */
  socialName?: Maybe<Scalars['String']['output']>;
  /** ID do tenant TPD */
  tpdTenantId?: Maybe<Scalars['String']['output']>;
  /** Dados de UTM */
  utmData?: Maybe<TUtmData>;
};

/** Origem da mensagem */
export enum TOriginMessage {
  /** Acidente */
  Accident = 'Accident',
  /** Empresa */
  Company = 'Company',
  /** Exclusão */
  Exclusion = 'Exclusion',
  /** Atestado ocupacional */
  OccupationalCertificate = 'OccupationalCertificate',
  /** Risco */
  Risk = 'Risk',
  /** Exame toxicológico */
  ToxicologicalExam = 'ToxicologicalExam'
}

/** Enumeração de origem da retificação */
export enum TOriginRectification {
  /** Revisão administrativa */
  AdministrativeReview = 'AdministrativeReview',
  /** Empregador */
  Employeer = 'Employeer',
  /** Determinação judicial */
  JudicialDetermination = 'JudicialDetermination'
}

export type TOrthoRater = {
  __typename?: 'OrthoRater';
  /** Agravamento */
  aggravation: TOphthalmologicAggravationEnum;
  /** Data de calibração */
  calibrationDate: Scalars['DateTime']['output'];
  /** Ambos os olhos de perto */
  closeBothEyes: TOrthoRaterValueEnum;
  /** Fusão de perto */
  closeFusion?: Maybe<Scalars['String']['output']>;
  /** Resposta de fusão de perto */
  closeFusionResponse: TOrthoRaterResponseEnum;
  /** Foria lateral de perto */
  closeLateralPhoria: TPhoriaEnum;
  /** Olho esquerdo de perto */
  closeLeftEye: TOrthoRaterValueEnum;
  /** Olho direito de perto */
  closeRightEye: TOrthoRaterValueEnum;
  /** Estereopsis de perto */
  closeStereopsis?: Maybe<Scalars['String']['output']>;
  /** Resposta de estereopsis de perto */
  closeStereopsisResponse: TOrthoRaterResponseEnum;
  /** Foria vertical de perto */
  closeVerticalPhoria: TPhoriaEnum;
  /** Com correção de perto */
  closeWithCorrection: Scalars['Boolean']['output'];
  /** Exame complementar */
  complementaryExam?: Maybe<TComplementaryExam>;
  /** Consulta */
  consultation?: Maybe<TConsultation>;
  /** Correção */
  correction: TOphthalmologicCorrectionEnum;
  /** CRM do médico */
  crm?: Maybe<Scalars['String']['output']>;
  /** Data */
  date: Scalars['DateTime']['output'];
  /** Detalhes do exame */
  details?: Maybe<Scalars['String']['output']>;
  /** Indicador diagnóstico */
  diagnosticIndicator: TExamDiagnosticIndicatorEnum;
  /** Nome do médico */
  doctor?: Maybe<Scalars['String']['output']>;
  /** Equipamento */
  equipment: TMeasuringInstrument;
  /** Autorização do exame */
  examAuthorization: Scalars['Boolean']['output'];
  /** Ambos os olhos de longe */
  farBothEyes: TOrthoRaterValueEnum;
  /** Fusão de longe */
  farFusion?: Maybe<Scalars['String']['output']>;
  /** Resposta de fusão de longe */
  farFusionResponse: TOrthoRaterResponseEnum;
  /** Foria lateral de longe */
  farLateralPhoria: TPhoriaEnum;
  /** Olho esquerdo de longe */
  farLeftEye: TOrthoRaterValueEnum;
  /** Olho direito de longe */
  farRightEye: TOrthoRaterValueEnum;
  /** Estereopsis de longe */
  farStereopsis?: Maybe<Scalars['String']['output']>;
  /** Resposta de estereopsis de longe */
  farStereopsisResponse: TOrthoRaterResponseEnum;
  /** Foria vertical de longe */
  farVerticalPhoria: TPhoriaEnum;
  /** Com correção de longe */
  farWithCorrection: Scalars['Boolean']['output'];
  /** Data de aferição */
  gaugingDate: Scalars['DateTime']['output'];
  /** Identificador */
  id: Scalars['String']['output'];
  /** Indicador */
  indicator: TExamResultIndicatorEnum;
  /** Observações */
  observations?: Maybe<Scalars['String']['output']>;
  /** Responsável pela medição */
  responsibleForMeasuring: TPerson;
  /** Tempo de repouso */
  restTime?: Maybe<Scalars['String']['output']>;
  /** Resultado */
  result: Scalars['String']['output'];
  /** Agravamento do resultado */
  resultAggravation?: Maybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: Maybe<TExamResultAlterationEnum>;
  /** Enxerga 2/3 */
  sees23: Scalars['Boolean']['output'];
  /** Enxerga 3/2 */
  sees32: Scalars['Boolean']['output'];
  /** Enxerga 5/6 */
  sees56: Scalars['Boolean']['output'];
  /** Enxerga 6/3 */
  sees63: Scalars['Boolean']['output'];
  /** Enxerga 7/9 */
  sees79: Scalars['Boolean']['output'];
  /** Enxerga 9/2 */
  sees92: Scalars['Boolean']['output'];
  /** Estado do CRM */
  state?: Maybe<TState>;
  /** Campo visual olho esquerdo */
  visualFieldLeftEye: TVisualFieldEnum;
  /** Campo visual olho direito */
  visualFieldRightEye: TVisualFieldEnum;
};

export type TOrthoRaterInput = {
  /** Agravamento */
  aggravation: TOphthalmologicAggravationEnum;
  /** Data de calibração */
  calibrationDate: Scalars['DateTime']['input'];
  /** Ambos os olhos de perto */
  closeBothEyes: TOrthoRaterValueEnum;
  /** Fusão de perto */
  closeFusion?: InputMaybe<Scalars['String']['input']>;
  /** Resposta de fusão de perto */
  closeFusionResponse: TOrthoRaterResponseEnum;
  /** Foria lateral de perto */
  closeLateralPhoria: TPhoriaEnum;
  /** Olho esquerdo de perto */
  closeLeftEye: TOrthoRaterValueEnum;
  /** Olho direito de perto */
  closeRightEye: TOrthoRaterValueEnum;
  /** Estereopsis de perto */
  closeStereopsis?: InputMaybe<Scalars['String']['input']>;
  /** Resposta de estereopsis de perto */
  closeStereopsisResponse: TOrthoRaterResponseEnum;
  /** Foria vertical de perto */
  closeVerticalPhoria: TPhoriaEnum;
  /** Com correção de perto */
  closeWithCorrection: Scalars['Boolean']['input'];
  /** Identificador do exame complementar */
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da consulta */
  consultationId?: InputMaybe<Scalars['String']['input']>;
  /** Correção */
  correction: TOphthalmologicCorrectionEnum;
  /** CRM do médico */
  crm?: InputMaybe<Scalars['String']['input']>;
  /** Data */
  date: Scalars['DateTime']['input'];
  /** Detalhes do exame */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Indicador diagnóstico */
  diagnosticIndicator: TExamDiagnosticIndicatorEnum;
  /** Nome do médico */
  doctor?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do equipamento */
  equipmentId: Scalars['String']['input'];
  /** Autorização do exame */
  examAuthorization: Scalars['Boolean']['input'];
  /** Ambos os olhos de longe */
  farBothEyes: TOrthoRaterValueEnum;
  /** Fusão de longe */
  farFusion?: InputMaybe<Scalars['String']['input']>;
  /** Resposta de fusão de longe */
  farFusionResponse: TOrthoRaterResponseEnum;
  /** Foria lateral de longe */
  farLateralPhoria: TPhoriaEnum;
  /** Olho esquerdo de longe */
  farLeftEye: TOrthoRaterValueEnum;
  /** Olho direito de longe */
  farRightEye: TOrthoRaterValueEnum;
  /** Estereopsis de longe */
  farStereopsis?: InputMaybe<Scalars['String']['input']>;
  /** Resposta de estereopsis de longe */
  farStereopsisResponse: TOrthoRaterResponseEnum;
  /** Foria vertical de longe */
  farVerticalPhoria: TPhoriaEnum;
  /** Com correção de longe */
  farWithCorrection: Scalars['Boolean']['input'];
  /** Data de aferição */
  gaugingDate: Scalars['DateTime']['input'];
  /** Indicador */
  indicator: TExamResultIndicatorEnum;
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do responsável pela medição */
  responsibleForMeasuringId: Scalars['String']['input'];
  /** Tempo de repouso */
  restTime?: InputMaybe<Scalars['String']['input']>;
  /** Resultado */
  result: Scalars['String']['input'];
  /** Agravamento do resultado */
  resultAggravation?: InputMaybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: InputMaybe<TExamResultAlterationEnum>;
  /** Enxerga 2/3 */
  sees23: Scalars['Boolean']['input'];
  /** Enxerga 3/2 */
  sees32: Scalars['Boolean']['input'];
  /** Enxerga 5/6 */
  sees56: Scalars['Boolean']['input'];
  /** Enxerga 6/3 */
  sees63: Scalars['Boolean']['input'];
  /** Enxerga 7/9 */
  sees79: Scalars['Boolean']['input'];
  /** Enxerga 9/2 */
  sees92: Scalars['Boolean']['input'];
  /** Estado do CRM */
  state?: InputMaybe<TState>;
  /** Campo visual olho esquerdo */
  visualFieldLeftEye: TVisualFieldEnum;
  /** Campo visual olho direito */
  visualFieldRightEye: TVisualFieldEnum;
};

/** Enumeração de resposta do Ortho Rater */
export enum TOrthoRaterResponseEnum {
  /** Aceitável */
  Acceptable = 'Acceptable',
  /** Reprovado */
  Disapproved = 'Disapproved',
  /** Normal */
  Normal = 'Normal'
}

export type TOrthoRaterUpdate = {
  /** Agravamento */
  aggravation?: InputMaybe<TOphthalmologicAggravationEnum>;
  /** Data de calibração */
  calibrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Ambos os olhos de perto */
  closeBothEyes?: InputMaybe<TOrthoRaterValueEnum>;
  /** Fusão de perto */
  closeFusion?: InputMaybe<Scalars['String']['input']>;
  /** Resposta de fusão de perto */
  closeFusionResponse?: InputMaybe<TOrthoRaterResponseEnum>;
  /** Foria lateral de perto */
  closeLateralPhoria?: InputMaybe<TPhoriaEnum>;
  /** Olho esquerdo de perto */
  closeLeftEye?: InputMaybe<TOrthoRaterValueEnum>;
  /** Olho direito de perto */
  closeRightEye?: InputMaybe<TOrthoRaterValueEnum>;
  /** Estereopsis de perto */
  closeStereopsis?: InputMaybe<Scalars['String']['input']>;
  /** Resposta de estereopsis de perto */
  closeStereopsisResponse?: InputMaybe<TOrthoRaterResponseEnum>;
  /** Foria vertical de perto */
  closeVerticalPhoria?: InputMaybe<TPhoriaEnum>;
  /** Com correção de perto */
  closeWithCorrection?: InputMaybe<Scalars['Boolean']['input']>;
  /** Correção */
  correction?: InputMaybe<TOphthalmologicCorrectionEnum>;
  /** CRM do médico */
  crm?: InputMaybe<Scalars['String']['input']>;
  /** Data */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Detalhes do exame */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Indicador diagnóstico */
  diagnosticIndicator?: InputMaybe<TExamDiagnosticIndicatorEnum>;
  /** Nome do médico */
  doctor?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do equipamento */
  equipmentId?: InputMaybe<Scalars['String']['input']>;
  /** Autorização do exame */
  examAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ambos os olhos de longe */
  farBothEyes?: InputMaybe<TOrthoRaterValueEnum>;
  /** Fusão de longe */
  farFusion?: InputMaybe<Scalars['String']['input']>;
  /** Resposta de fusão de longe */
  farFusionResponse?: InputMaybe<TOrthoRaterResponseEnum>;
  /** Foria lateral de longe */
  farLateralPhoria?: InputMaybe<TPhoriaEnum>;
  /** Olho esquerdo de longe */
  farLeftEye?: InputMaybe<TOrthoRaterValueEnum>;
  /** Olho direito de longe */
  farRightEye?: InputMaybe<TOrthoRaterValueEnum>;
  /** Estereopsis de longe */
  farStereopsis?: InputMaybe<Scalars['String']['input']>;
  /** Resposta de estereopsis de longe */
  farStereopsisResponse?: InputMaybe<TOrthoRaterResponseEnum>;
  /** Foria vertical de longe */
  farVerticalPhoria?: InputMaybe<TPhoriaEnum>;
  /** Com correção de longe */
  farWithCorrection?: InputMaybe<Scalars['Boolean']['input']>;
  /** Data de aferição */
  gaugingDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador */
  id: Scalars['String']['input'];
  /** Indicador */
  indicator?: InputMaybe<TExamResultIndicatorEnum>;
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do responsável pela medição */
  responsibleForMeasuringId?: InputMaybe<Scalars['String']['input']>;
  /** Tempo de repouso */
  restTime?: InputMaybe<Scalars['String']['input']>;
  /** Resultado */
  result?: InputMaybe<Scalars['String']['input']>;
  /** Agravamento do resultado */
  resultAggravation?: InputMaybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: InputMaybe<TExamResultAlterationEnum>;
  /** Enxerga 2/3 */
  sees23?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enxerga 3/2 */
  sees32?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enxerga 5/6 */
  sees56?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enxerga 6/3 */
  sees63?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enxerga 7/9 */
  sees79?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enxerga 9/2 */
  sees92?: InputMaybe<Scalars['Boolean']['input']>;
  /** Estado do CRM */
  state?: InputMaybe<TState>;
  /** Campo visual olho esquerdo */
  visualFieldLeftEye?: InputMaybe<TVisualFieldEnum>;
  /** Campo visual olho direito */
  visualFieldRightEye?: InputMaybe<TVisualFieldEnum>;
};

/** Enumeração de valores do Ortho Rater */
export enum TOrthoRaterValueEnum {
  /** 80 */
  Eighty = 'Eighty',
  /** 50 */
  Fifty = 'Fifty',
  /** 40 */
  Fourty = 'Fourty',
  /** 90 */
  Ninety = 'Ninety',
  /** 100 */
  OnHundred = 'OnHundred',
  /** 70 */
  Seventy = 'Seventy',
  /** 60 */
  Sixty = 'Sixty',
  /** 10 */
  Ten = 'Ten',
  /** 30 */
  Thirty = 'Thirty',
  /** 20 */
  Twenty = 'Twenty'
}

/** Outras entidades do sistema */
export enum TOthers {
  /** Credenciado */
  Accredited = 'Accredited',
  /** Monitoramento biológico */
  BiologicalMonitoring = 'BiologicalMonitoring',
  /** Calendário */
  Calendar = 'Calendar',
  /** Agente causador */
  CauserAgent = 'CauserAgent',
  /** Medidas de controle */
  ControlMeasures = 'ControlMeasures',
  /** Centro de custo */
  CostCenter = 'CostCenter',
  /** Departamento */
  Department = 'Department',
  /** Estrutura de documento */
  DocumentStructure = 'DocumentStructure',
  /** Exames */
  Exams = 'Exams',
  /** Despesas */
  Expenses = 'Expenses',
  /** Grupo de exposição */
  ExposureGroup = 'ExposureGroup',
  /** Fonte geradora */
  GeneratingSource = 'GeneratingSource',
  /** Programas de saúde */
  HealthPrograms = 'HealthPrograms',
  /** Materiais */
  Materials = 'Materials',
  /** Instrumentos de medição */
  MeasuringInstruments = 'MeasuringInstruments',
  /** Medicamentos */
  Medications = 'Medications',
  /** Ocupação */
  Occupation = 'Occupation',
  /** Pessoas */
  People = 'People',
  /** Faixas periódicas */
  PeriodicRanges = 'PeriodicRanges',
  /** Ambiente físico */
  PhysicalEnvironment = 'PhysicalEnvironment',
  /** Questionário */
  Quiz = 'Quiz',
  /** Termos de responsabilidade */
  ResponsibilityTerms = 'ResponsibilityTerms',
  /** Agente de risco */
  RiskAgent = 'RiskAgent',
  /** Tarefas */
  Tasks = 'Tasks',
  /** Treinamento */
  Training = 'Training',
  /** Unidades de medida */
  UnitsOfMeasure = 'UnitsOfMeasure',
  /** Vacinas */
  Vaccines = 'Vaccines',
  /** Almoxarifado */
  Warehouse = 'Warehouse',
  /** Turnos de trabalho */
  WorkShifts = 'WorkShifts'
}

/** Diagnóstico Otológico */
export enum TOtologicalDiagnosisEnum {
  /** Perda Condutiva */
  ConductiveLoss = 'ConductiveLoss',
  /** Perda Mista */
  MixedLoss = 'MixedLoss',
  /** Normal */
  Normal = 'Normal'
}

export type TPprEmployees = {
  __typename?: 'PPREmployees';
  /** Centro de custo */
  costCenter: Scalars['String']['output'];
  /** CPF */
  cpf: Scalars['Float']['output'];
  /** Nome */
  name: Scalars['String']['output'];
  /** Ocupação */
  occupation: Scalars['String']['output'];
};

/** Orientação da página */
export enum TPageOrientation {
  /** Paisagem */
  Landscape = 'Landscape',
  /** Retrato */
  Portrait = 'Portrait'
}

export type TPaginatedAbsenceType = {
  __typename?: 'PaginatedAbsenceType';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TAbsenceType>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedAccident = {
  __typename?: 'PaginatedAccident';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TAccident>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedAccidentCause = {
  __typename?: 'PaginatedAccidentCause';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TAccidentCause>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedAccidentCode = {
  __typename?: 'PaginatedAccidentCode';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TAccidentCode>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedAccidentObject = {
  __typename?: 'PaginatedAccidentObject';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TAccidentObject>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedAccidentType = {
  __typename?: 'PaginatedAccidentType';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TAccidentDescription>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedAccredited = {
  __typename?: 'PaginatedAccredited';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TAccredited>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedAccreditedConsultations = {
  __typename?: 'PaginatedAccreditedConsultations';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TAccreditedConsultation>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedActionPlan = {
  __typename?: 'PaginatedActionPlan';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TActionPlan>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedActivityGroup = {
  __typename?: 'PaginatedActivityGroup';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TActivityGroup>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedActivityIcd = {
  __typename?: 'PaginatedActivityIcd';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TActivityIcd>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedAllowanceType = {
  __typename?: 'PaginatedAllowanceType';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TAllowanceType>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedAttachment = {
  __typename?: 'PaginatedAttachment';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TAttachmentDto>;
  /** Total de itens disponíveis */
  total: Scalars['Float']['output'];
};

export type TPaginatedAuditLogs = {
  __typename?: 'PaginatedAuditLogs';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TAuditLogEntry>;
  /** Total de itens disponíveis */
  total: Scalars['Float']['output'];
};

export type TPaginatedBiologicalMonitoringExam = {
  __typename?: 'PaginatedBiologicalMonitoringExam';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TBiologicalMonitoringExam>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedBiologicalMonitoringExamGroup = {
  __typename?: 'PaginatedBiologicalMonitoringExamGroup';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TBiologicalMonitoringExamGroup>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedBodyPart = {
  __typename?: 'PaginatedBodyPart';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TBodyPart>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedBranch = {
  __typename?: 'PaginatedBranch';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TBranch>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedCalendar = {
  __typename?: 'PaginatedCalendar';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TCalendar>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedConsultation = {
  __typename?: 'PaginatedConsultation';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TConsultation>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedConsultationMinimal = {
  __typename?: 'PaginatedConsultationMinimal';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TConsultationMinimal>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedConsultationReason = {
  __typename?: 'PaginatedConsultationReason';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TConsultationReason>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedControlMeasure = {
  __typename?: 'PaginatedControlMeasure';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TControlMeasure>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedCostCenter = {
  __typename?: 'PaginatedCostCenter';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TCostCenter>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedCrontabExecutionDetails = {
  __typename?: 'PaginatedCrontabExecutionDetails';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TCrontabExecutionDetail>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedCrontabExecutions = {
  __typename?: 'PaginatedCrontabExecutions';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TCrontabExecution>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedDeliverySpareParts = {
  __typename?: 'PaginatedDeliverySpareParts';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TDeliverySpareParts>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedDepartment = {
  __typename?: 'PaginatedDepartment';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TDepartment>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedESocialQueue = {
  __typename?: 'PaginatedESocialQueue';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TESocialQueue>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedEconomicActivity = {
  __typename?: 'PaginatedEconomicActivity';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TEconomicActivity>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedEmployeeIpeDelivery = {
  __typename?: 'PaginatedEmployeeIpeDelivery';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TEmployeeIpeDelivery>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedEnvironmentalReport = {
  __typename?: 'PaginatedEnvironmentalReport';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TEnvironmentalReport>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedEnvironmentalReportSuggestion = {
  __typename?: 'PaginatedEnvironmentalReportSuggestion';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TEnvironmentalReportSuggestion>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedEvent = {
  __typename?: 'PaginatedEvent';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TEvent>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedExam = {
  __typename?: 'PaginatedExam';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TExam>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedExamNormalResult = {
  __typename?: 'PaginatedExamNormalResult';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TExamNormalResult>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedExpectedConsultations = {
  __typename?: 'PaginatedExpectedConsultations';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TExpectedConsultation>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedExpense = {
  __typename?: 'PaginatedExpense';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TExpense>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedExposureGroup = {
  __typename?: 'PaginatedExposureGroup';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TExposureGroup>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedExtinguishingSystem = {
  __typename?: 'PaginatedExtinguishingSystem';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TExtinguishingSystem>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedFireBrigade = {
  __typename?: 'PaginatedFireBrigade';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TFireBrigade>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGeneratingSource = {
  __typename?: 'PaginatedGeneratingSource';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGeneratingSource>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericAccidentCause = {
  __typename?: 'PaginatedGenericAccidentCause';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericAccidentCause>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericActivePrinciple = {
  __typename?: 'PaginatedGenericActivePrinciple';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericActivePrinciple>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericBiologicalMonitoringExam = {
  __typename?: 'PaginatedGenericBiologicalMonitoringExam';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericBiologicalMonitoringExam>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericBiologicalMonitoringExamGroup = {
  __typename?: 'PaginatedGenericBiologicalMonitoringExamGroup';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericBiologicalMonitoringExamGroup>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericCostCenter = {
  __typename?: 'PaginatedGenericCostCenter';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericCostCenter>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericExam = {
  __typename?: 'PaginatedGenericExam';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericExam>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericExaminationProcedure = {
  __typename?: 'PaginatedGenericExaminationProcedure';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericExaminationProcedure>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericExpense = {
  __typename?: 'PaginatedGenericExpense';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericExpense>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericHealthProgram = {
  __typename?: 'PaginatedGenericHealthProgram';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericHealthProgram>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericLaboratory = {
  __typename?: 'PaginatedGenericLaboratory';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericLaboratory>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericMeasuringInstrument = {
  __typename?: 'PaginatedGenericMeasuringInstrument';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericMeasuringInstrument>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericMedicine = {
  __typename?: 'PaginatedGenericMedicine';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericMedicine>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericOccupation = {
  __typename?: 'PaginatedGenericOccupation';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericOccupation>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericPeriodicRange = {
  __typename?: 'PaginatedGenericPeriodicRange';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericPeriodicRange>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericPublicPlace = {
  __typename?: 'PaginatedGenericPublicPlace';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericPublicPlace>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericQuestionGroup = {
  __typename?: 'PaginatedGenericQuestionGroup';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericQuestionGroup>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericQuestionQuiz = {
  __typename?: 'PaginatedGenericQuestionQuiz';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericQuestionQuiz>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericQuiz = {
  __typename?: 'PaginatedGenericQuiz';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericQuiz>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericReportStructure = {
  __typename?: 'PaginatedGenericReportStructure';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericReportStructure>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericResponseOption = {
  __typename?: 'PaginatedGenericResponseOption';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericResponseOption>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericRiskAgent = {
  __typename?: 'PaginatedGenericRiskAgent';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericRiskAgent>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericStatementResponsibility = {
  __typename?: 'PaginatedGenericStatementResponsibility';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericStatementResponsibility>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericTask = {
  __typename?: 'PaginatedGenericTask';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericTask>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericTraining = {
  __typename?: 'PaginatedGenericTraining';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericTraining>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericVaccine = {
  __typename?: 'PaginatedGenericVaccine';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericVaccine>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGenericWorkShift = {
  __typename?: 'PaginatedGenericWorkShift';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TGenericWorkShift>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedGetDocuments = {
  __typename?: 'PaginatedGetDocuments';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TSignBrokerGetDocumentsAndUpdateState>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedHealthProgram = {
  __typename?: 'PaginatedHealthProgram';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<THealthProgram>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedIcdGroups = {
  __typename?: 'PaginatedIcdGroups';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TIcdGroup>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedIcds = {
  __typename?: 'PaginatedIcds';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TIcd>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedInjuryNature = {
  __typename?: 'PaginatedInjuryNature';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TInjuryNature>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedIntegrationError = {
  __typename?: 'PaginatedIntegrationError';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TIntegrationError>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedInventoryQueue = {
  __typename?: 'PaginatedInventoryQueue';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TInventoryQueue>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedInvestigationSuggestion = {
  __typename?: 'PaginatedInvestigationSuggestion';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TInvestigationSuggestion>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedIpe = {
  __typename?: 'PaginatedIpe';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TIpe>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedIpeManufacturer = {
  __typename?: 'PaginatedIpeManufacturer';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TIpeManufacturerSuggestion>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedMandate = {
  __typename?: 'PaginatedMandate';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TMandate>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedManufacturer = {
  __typename?: 'PaginatedManufacturer';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TManufacturer>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedMeasuringInstrument = {
  __typename?: 'PaginatedMeasuringInstrument';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TMeasuringInstrument>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedMedicalRecords = {
  __typename?: 'PaginatedMedicalRecords';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TMedicalRecord>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedMedicine = {
  __typename?: 'PaginatedMedicine';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TMedicine>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedOccupation = {
  __typename?: 'PaginatedOccupation';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TOccupation>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedPeopleOnBrowse = {
  __typename?: 'PaginatedPeopleOnBrowse';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TPersonOnBrowse>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedPeopleOnBrowseInput = {
  /** Filtro */
  filter?: InputMaybe<TPersonFilter>;
  /** Identificador */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Somente ativos */
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TPaginatedPeriodicRange = {
  __typename?: 'PaginatedPeriodicRange';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TPeriodicRange>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedPerson = {
  __typename?: 'PaginatedPerson';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TPerson>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedPersonIpeList = {
  __typename?: 'PaginatedPersonIpeList';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TPersonIpeList>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedPersonNeedIpe = {
  __typename?: 'PaginatedPersonNeedIpe';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TPersonNeedIpe>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedPhysicalEnvironment = {
  __typename?: 'PaginatedPhysicalEnvironment';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TPhysicalEnvironment>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedPosition = {
  __typename?: 'PaginatedPosition';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TPosition>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedPreMedicalCertificates = {
  __typename?: 'PaginatedPreMedicalCertificates';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TPreMedicalCertificate>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedProduct = {
  __typename?: 'PaginatedProduct';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TProduct>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedProductDelivery = {
  __typename?: 'PaginatedProductDelivery';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TProductDelivery>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedProductIpeManufacturer = {
  __typename?: 'PaginatedProductIpeManufacturer';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TProductIpeManufacturer>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedQueue = {
  __typename?: 'PaginatedQueue';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TQueueDto>;
  /** Total de itens disponíveis */
  total: Scalars['Float']['output'];
};

export type TPaginatedQuiz = {
  __typename?: 'PaginatedQuiz';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TQuiz>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedReportStructure = {
  __typename?: 'PaginatedReportStructure';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TReportStructure>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedRisk = {
  __typename?: 'PaginatedRisk';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TRisk>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedRiskAgent = {
  __typename?: 'PaginatedRiskAgent';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TRiskAgent>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedRiskSuggestion = {
  __typename?: 'PaginatedRiskSuggestion';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TRiskSuggestion>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedRolePermission = {
  __typename?: 'PaginatedRolePermission';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TRolePermission>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedScheduleRestriction = {
  __typename?: 'PaginatedScheduleRestriction';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TScheduleRestriction>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedSpareParts = {
  __typename?: 'PaginatedSpareParts';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TSpareParts>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedStabilityType = {
  __typename?: 'PaginatedStabilityType';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TStabilityType>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedStatementResponsibility = {
  __typename?: 'PaginatedStatementResponsibility';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TStatementResponsibility>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedSync = {
  __typename?: 'PaginatedSync';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TSyncDto>;
  /** Total de itens disponíveis */
  total: Scalars['Float']['output'];
};

export type TPaginatedTTalkQueue = {
  __typename?: 'PaginatedTTalkQueue';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TTTalkQueue>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedTask = {
  __typename?: 'PaginatedTask';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TTask>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedTraining = {
  __typename?: 'PaginatedTraining';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TTraining>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedTrainingHistory = {
  __typename?: 'PaginatedTrainingHistory';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TTrainingHistory>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedTtalkInboundEvent = {
  __typename?: 'PaginatedTtalkInboundEvent';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TTtalkInboundEvent>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedTtalkInboundSemanticInconsistency = {
  __typename?: 'PaginatedTtalkInboundSemanticInconsistency';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TTtalkInboundSemanticInconsistency>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedUnityMeasure = {
  __typename?: 'PaginatedUnityMeasure';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TUnityOfMeasure>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedVaccine = {
  __typename?: 'PaginatedVaccine';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TVaccine>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedWarehouse = {
  __typename?: 'PaginatedWarehouse';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TWarehouse>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedWebhookQueue = {
  __typename?: 'PaginatedWebhookQueue';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TWebhookQueue>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedWorkPermission = {
  __typename?: 'PaginatedWorkPermission';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TWorkPermission>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPaginatedWorkShift = {
  __typename?: 'PaginatedWorkShift';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TWorkShift>;
  /** Total de itens disponíveis */
  total?: Maybe<Scalars['Float']['output']>;
};

export type TPagination = {
  /** Número de itens a serem retornados */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Número de itens a pular */
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type TPaginationAbsenceQueryInput = {
  /** Identificador único */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Filtrar apenas ativos */
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  useAccident?: InputMaybe<Scalars['Boolean']['input']>;
  useCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  useMaternity?: InputMaybe<Scalars['Boolean']['input']>;
  useRetirement?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TPaginationDefaultQueryInput = {
  /** Identificador único */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Filtrar apenas ativos */
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TPaginationInput = {
  /** Ordem ascendente? Padrão: false (descendente) */
  ascendingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  /** Página atual. Padrão: 1 */
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  /** Quantidade de itens por página. Padrão: 10 */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /** Coluna de ordenação (índice ou código). Padrão: 2 */
  sorting?: InputMaybe<Scalars['Int']['input']>;
};

export type TPaginationPersonQueryInput = {
  /** Todas as filiais */
  allBranches?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtro */
  filter?: InputMaybe<TFilterPerson>;
  isEsocial?: InputMaybe<Scalars['Boolean']['input']>;
  /** Somente ativos */
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TPaginationProductIpeManufacturerInput = {
  /** Identificador */
  identifier?: InputMaybe<Scalars['String']['input']>;
};

export type TParticipantOnMeeting = {
  __typename?: 'ParticipantOnMeeting';
  /** Comparecimento */
  attendance?: Maybe<Scalars['Boolean']['output']>;
  /** Justificativa */
  justification?: Maybe<Scalars['String']['output']>;
  /** Pessoa */
  person: TPerson;
};

export type TParticipantOnMeetingInput = {
  /** Comparecimento */
  attendance?: InputMaybe<Scalars['Boolean']['input']>;
  /** Justificativa */
  justification?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
};

export type TParticipantOnMeetingUpdate = {
  /** Participantes a serem criados */
  toCreate: Array<TParticipantOnMeetingInput>;
  /** Participantes a serem removidos */
  toRemove: Array<Scalars['String']['input']>;
  /** Participantes a serem atualizados */
  toUpdate: Array<TParticipantOnMeetingInput>;
};

export enum TPaymentStatus {
  Captured = 'Captured',
  Created = 'Created',
  Denied = 'Denied',
  Expired = 'Expired',
  PartiallyCaptured = 'PartiallyCaptured',
  Pending = 'Pending',
  Voided = 'Voided'
}

export type TPayments = {
  __typename?: 'Payments';
  /** Forma de pagamento */
  billingType?: Maybe<TBillingMethod>;
  /** Detalhes */
  details: Scalars['String']['output'];
  /** Data de vencimento */
  dueDate: Scalars['DateTime']['output'];
  /** Fim do período */
  endPeriod: Scalars['DateTime']['output'];
  /** Dados da nota fiscal */
  invoice: TInvoice;
  /** Níveis contratados */
  levels?: Maybe<Array<TLevel>>;
  /** Data do pagamento */
  paymentDate?: Maybe<Scalars['DateTime']['output']>;
  /** Início do período */
  startPeriod: Scalars['DateTime']['output'];
  /** Status do pagamento */
  status: TPaymentStatus;
  /** Valor */
  value: Scalars['Float']['output'];
};

export type TPcmsoReportData = {
  __typename?: 'PcmsoReportData';
  abnormalityAnalysis: Array<TAbnormalityAnalysis>;
  accidentAnalysis: Array<TAccidentAnalysis>;
  cnae?: Maybe<Scalars['String']['output']>;
  doctorAddress?: Maybe<Scalars['String']['output']>;
  doctorCrm?: Maybe<Scalars['String']['output']>;
  doctorName: Scalars['String']['output'];
  /** Snapshot formatado dos RQEs do médico responsável */
  doctorRqeDisplay?: Maybe<Scalars['String']['output']>;
  doctorTelephone?: Maybe<Scalars['String']['output']>;
  examAnalysis: Array<TExamAnalysis>;
  expirationDate: Scalars['String']['output'];
  occupationalDiseaseAnalysis: Array<TOccupationalDiseaseAnalysis>;
  orgAddress?: Maybe<Scalars['String']['output']>;
  orgDoc?: Maybe<Scalars['String']['output']>;
  orgImage?: Maybe<Scalars['String']['output']>;
  orgName: Scalars['String']['output'];
  period: Scalars['String']['output'];
};

export type TPerDayChart = {
  __typename?: 'PerDayChart';
  /** Valores de entregas por dia */
  deliveryValues: Array<Scalars['Float']['output']>;
  /** Indica se existem entregas de IPE */
  hasIpeDeliveries: Scalars['Boolean']['output'];
  /** Valor máximo dos dados */
  maxDataValue: Scalars['Float']['output'];
  /** Valores de devoluções por dia */
  returnValues: Array<Scalars['Float']['output']>;
};

export type TPerTotalCharts = {
  __typename?: 'PerTotalCharts';
  /** Dados */
  data: Array<TData>;
  /** Dados por total */
  perTotal: Array<TData>;
};

export type TPeriodicRange = {
  __typename?: 'PeriodicRange';
  /** Faixas etárias */
  ageRanges: Array<TAgeRange>;
  /** Descrição */
  description: Scalars['String']['output'];
  /** Gênero */
  gender: TPeriodicRangeGenderEnum;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Indica se está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Pós-admissão */
  postAdmission?: Maybe<Scalars['Float']['output']>;
  /** Identificador de referência */
  referenceId?: Maybe<Scalars['String']['output']>;
};

/** Gênero para faixa periódica */
export enum TPeriodicRangeGenderEnum {
  /** Ambos */
  Both = 'Both',
  /** Feminino */
  Female = 'Female',
  /** Masculino */
  Male = 'Male'
}

export type TPeriodicRangeInput = {
  /** Faixas etárias */
  ageRanges: Array<TAgeRangeInput>;
  /** Descrição */
  description: Scalars['String']['input'];
  /** Gênero */
  gender: TPeriodicRangeGenderEnum;
  /** Pós-admissão */
  postAdmission?: InputMaybe<Scalars['Float']['input']>;
};

export type TPeriodicRangeUpdate = {
  /** Faixas etárias */
  ageRanges?: InputMaybe<Array<TAgeRangeInput>>;
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Gênero */
  gender?: InputMaybe<TPeriodicRangeGenderEnum>;
  /** Identificador */
  id: Scalars['String']['input'];
  /** Indica se está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Pós-admissão */
  postAdmission?: InputMaybe<Scalars['Float']['input']>;
};

export type TPermission = {
  __typename?: 'Permission';
  /** Permissão para criar */
  canCreate: Scalars['Boolean']['output'];
  /** Permissão para deletar */
  canDelete: Scalars['Boolean']['output'];
  /** Permissão para imprimir */
  canPrint: Scalars['Boolean']['output'];
  /** Permissão para atualizar */
  canUpdate: Scalars['Boolean']['output'];
  /** Permissões filhas */
  children?: Maybe<Array<TPermission>>;
  /** Descrição da permissão */
  description: Scalars['String']['output'];
};

export type TPermissionInput = {
  /** Permite criar */
  canCreate: Scalars['Boolean']['input'];
  /** Permite deletar */
  canDelete: Scalars['Boolean']['input'];
  /** Permite imprimir */
  canPrint: Scalars['Boolean']['input'];
  /** Permite atualizar */
  canUpdate: Scalars['Boolean']['input'];
  /** Permissões filhas */
  children?: InputMaybe<Array<TPermissionInput>>;
  /** Descrição da permissão */
  description: Scalars['String']['input'];
};

export type TPerson = {
  __typename?: 'Person';
  /** Endereço */
  address?: Maybe<Scalars['String']['output']>;
  /** Data de admissão */
  admissionDate?: Maybe<Scalars['DateTime']['output']>;
  /** Idade */
  age: Scalars['Float']['output'];
  /** Anexos */
  attachments?: Maybe<Array<TAttachment>>;
  /** Data de nascimento */
  birthday: Scalars['DateTime']['output'];
  /** Filial */
  branch?: Maybe<Scalars['String']['output']>;
  /** Cidade */
  city?: Maybe<Scalars['String']['output']>;
  /** Estado civil */
  civilStatus?: Maybe<TCivilStatus>;
  /** Centro de custo */
  costCenter?: Maybe<TCostCenter>;
  /** CTPS */
  ctps?: Maybe<Scalars['String']['output']>;
  /** Departamento */
  department?: Maybe<TDepartment>;
  /** Data de demissão */
  dismissalDate?: Maybe<Scalars['DateTime']['output']>;
  /** Categoria eSocial */
  eSocialCategory?: Maybe<Scalars['String']['output']>;
  /** Status do protocolo do evento RH (S-2190/S-2200) no eSocial */
  eSocialRhEventStatus?: Maybe<TESocialRhEventStatus>;
  /** Nível de escolaridade */
  educationLevel?: Maybe<TEducationLevel>;
  /** Email */
  email?: Maybe<Scalars['String']['output']>;
  /** Situação do funcionário */
  employeeSituation?: Maybe<TEmployeeSituation>;
  /** Tarefas do funcionário */
  employeeTasks?: Maybe<Array<TTaskByPerson>>;
  /** Advertências do funcionário */
  employeeWarnings?: Maybe<Array<TWarningByPerson>>;
  /** Identificador no ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** É externo */
  external?: Maybe<Scalars['Boolean']['output']>;
  /** Históricos funcionais */
  funcionalHistories?: Maybe<Array<TFuncionalHistoryByPerson>>;
  /** Gênero */
  gender: TGender;
  /** RG */
  generalRegistration?: Maybe<Scalars['String']['output']>;
  /** Identificador */
  id: Scalars['String']['output'];
  /** CPF */
  individualRegistration: Scalars['String']['output'];
  /** Entregas de EPI */
  ipeDeliveries?: Maybe<Array<TIpeDelivery>>;
  /** Está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Último exame */
  lastExam?: Maybe<Scalars['DateTime']['output']>;
  /** Gestor/superior imediato */
  manager?: Maybe<TPerson>;
  /** Identificador do gestor/superior imediato */
  managerId?: Maybe<Scalars['String']['output']>;
  /** Nome da mãe */
  mothersName?: Maybe<Scalars['String']['output']>;
  /** Nome */
  name: Scalars['String']['output'];
  /** Bairro */
  neighborhood?: Maybe<Scalars['String']['output']>;
  /** Próxima troca */
  nextChange?: Maybe<Scalars['DateTime']['output']>;
  /** Apelido */
  nickname?: Maybe<Scalars['String']['output']>;
  /** Número do endereço */
  numberAddress?: Maybe<Scalars['String']['output']>;
  /** Ocupação */
  occupation?: Maybe<TOccupation>;
  /** Foto da organização */
  organizationPicture?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** Código PIS */
  pisCode?: Maybe<Scalars['String']['output']>;
  /** Cargo */
  position?: Maybe<TPosition>;
  /** Foto de perfil */
  profilePicture?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** RAIS */
  rais?: Maybe<Scalars['String']['output']>;
  /** Matrícula */
  registration?: Maybe<Scalars['String']['output']>;
  /** Situação de substituição */
  replacementSituation?: Maybe<TReplacementSituation>;
  /** Quantidade de riscos ativos a que a pessoa está exposta */
  riskCount?: Maybe<Scalars['Int']['output']>;
  /** SEFIP */
  sefip?: Maybe<Scalars['String']['output']>;
  /** Identificador do vendedor */
  sellerId?: Maybe<Scalars['String']['output']>;
  /** Nome social */
  socialName?: Maybe<Scalars['String']['output']>;
  /** Estado */
  state?: Maybe<Scalars['String']['output']>;
  /** Sugestão */
  suggestion?: Maybe<Scalars['String']['output']>;
  /** Telefone */
  telephone?: Maybe<Scalars['String']['output']>;
  /** Históricos de treinamento */
  trainingHistories?: Maybe<Array<TTrainingHistoryByPerson>>;
  /** Identificador único eSocial */
  unicESocialId?: Maybe<Scalars['String']['output']>;
  /** URL de upload */
  uploadUrl?: Maybe<Scalars['String']['output']>;
  /** Usuário */
  user?: Maybe<Scalars['String']['output']>;
  /** Referência do usuário */
  userRef?: Maybe<TUser>;
  /** Turno de trabalho */
  workShift?: Maybe<TWorkShift>;
  /** CEP */
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type TPersonByGender = {
  __typename?: 'PersonByGender';
  /** Feminino */
  female: Scalars['Float']['output'];
  /** Masculino */
  male: Scalars['Float']['output'];
};

export type TPersonByGenderAndCc = {
  __typename?: 'PersonByGenderAndCC';
  /** Descrição */
  description: Scalars['String']['output'];
  /** Feminino */
  female: Scalars['Float']['output'];
  /** Masculino */
  male: Scalars['Float']['output'];
  /** Pessoas */
  people: Scalars['Float']['output'];
};

export type TPersonByMandate = {
  __typename?: 'PersonByMandate';
  /** Data de nascimento */
  birthday: Scalars['DateTime']['output'];
  /** Gênero */
  gender: Scalars['String']['output'];
  /** Identificador único da pessoa */
  id: Scalars['String']['output'];
  /** CPF */
  individualRegistration: Scalars['String']['output'];
  /** Indica se está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Nome da pessoa */
  name: Scalars['String']['output'];
  /** Apelido */
  nickname?: Maybe<Scalars['String']['output']>;
  /** Foto de perfil */
  profilePicture?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** Matrícula */
  registration?: Maybe<Scalars['String']['output']>;
  /** Nome social da pessoa */
  socialName?: Maybe<Scalars['String']['output']>;
  /** Sugestão de uso */
  suggestion?: Maybe<Scalars['String']['output']>;
};

export type TPersonByRisk = {
  __typename?: 'PersonByRisk';
  /** ID da relação */
  id: Scalars['String']['output'];
  /** Pessoa vinculada ao risco */
  person: TPerson;
};

export type TPersonByRiskInput = {
  /** ID da pessoa */
  personId: Scalars['String']['input'];
  /** ID do risco */
  riskId: Scalars['String']['input'];
};

export type TPersonByTask = {
  __typename?: 'PersonByTask';
  /** Data de término */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Pessoa */
  person: TPerson;
  /** Data de início */
  startDate: Scalars['DateTime']['output'];
};

export type TPersonChart = {
  __typename?: 'PersonChart';
  /** Dados de contagem de riscos */
  riskCountData: Array<TData>;
  /** Riscos por total */
  riskPerTotal: Array<TData>;
};

export type TPersonFilter = {
  /** Centros de custo */
  costCenters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Departamentos */
  departments?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Gêneros */
  gender?: InputMaybe<Array<TGender>>;
  /** Ocupações */
  occupation?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Situações */
  situation?: InputMaybe<Array<TEmployeeSituation>>;
  /** Status */
  status?: InputMaybe<Array<TStockMovementStatus>>;
  /** Tarefas */
  tasks?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TPersonFilterQueryInput = {
  /** Identificador da filial */
  branchId?: InputMaybe<Scalars['String']['input']>;
  /** Filtro */
  filter?: InputMaybe<TPersonFilter>;
  /** Identificador */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Somente ativos */
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TPersonForExposure = {
  /** Identificador do centro de custo */
  costCenterId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do departamento */
  departmentId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador */
  id: Scalars['String']['input'];
  /** Identificador da ocupação */
  occupationId?: InputMaybe<Scalars['String']['input']>;
  /** Tarefas */
  tasks?: InputMaybe<Array<TEmployeeTaskOnPerson>>;
};

export type TPersonHistory = {
  __typename?: 'PersonHistory';
  history: Array<TShortcutHistory>;
  person: Scalars['String']['output'];
};

export type TPersonHistoryActivate = {
  __typename?: 'PersonHistoryActivate';
  /** Data de ativação */
  activateDate: Scalars['DateTime']['output'];
  /** Data de desativação */
  deactivateDate?: Maybe<Scalars['DateTime']['output']>;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Pessoa */
  person: TPerson;
};

export type TPersonHistoryActivateInput = {
  /** Data de ativação */
  activateDate: Scalars['DateTime']['input'];
  /** Data de desativação */
  deactivateDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
};

export type TPersonHistoryActivateUpdate = {
  /** Data de desativação */
  deactivateDate: Scalars['DateTime']['input'];
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
};

export type TPersonInput = {
  /** Endereço */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Data de admissão */
  admissionDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de nascimento */
  birthday: Scalars['DateTime']['input'];
  /** Cidade */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Estado civil */
  civilStatus?: InputMaybe<TCivilStatus>;
  /** Tamanho do conteúdo */
  contentLength?: InputMaybe<Scalars['Float']['input']>;
  /** Tipo de conteúdo */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do centro de custo */
  costCenterId?: InputMaybe<Scalars['String']['input']>;
  /** CTPS */
  ctps?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do departamento */
  departmentId?: InputMaybe<Scalars['String']['input']>;
  /** Dependentes */
  dependents?: InputMaybe<TDependentOnPersonInput>;
  /** Data de demissão */
  dismissalDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Categoria eSocial */
  eSocialCategory?: InputMaybe<Scalars['String']['input']>;
  /** Status do protocolo do evento RH (S-2190/S-2200) no eSocial */
  eSocialRhEventStatus?: InputMaybe<TESocialRhEventStatus>;
  /** Nível de escolaridade */
  educationLevel?: InputMaybe<TEducationLevel>;
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Situação do funcionário */
  employeeSituation?: InputMaybe<TEmployeeSituation>;
  /** Advertências do funcionário */
  employeeWarnings?: InputMaybe<Array<TEmployeeWarningOnPersonInput>>;
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** É externo */
  external?: InputMaybe<Scalars['Boolean']['input']>;
  /** Históricos funcionais */
  funcionalHistories?: InputMaybe<TFuncionalHistoryOnPersonInput>;
  /** Gênero */
  gender: TGender;
  /** RG */
  generalRegistration?: InputMaybe<Scalars['String']['input']>;
  /** CPF */
  individualRegistration: Scalars['String']['input'];
  /** Está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Último exame */
  lastExam?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador do gestor/superior imediato */
  managerId?: InputMaybe<Scalars['String']['input']>;
  /** Nome da mãe */
  mothersName?: InputMaybe<Scalars['String']['input']>;
  /** Nome */
  name: Scalars['String']['input'];
  /** Bairro */
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  /** Próxima troca */
  nextChange?: InputMaybe<Scalars['DateTime']['input']>;
  /** Apelido */
  nickname?: InputMaybe<Scalars['String']['input']>;
  /** Número do endereço */
  numberAddress?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da ocupação */
  occupationId?: InputMaybe<Scalars['String']['input']>;
  /** Foto da organização */
  organizationPicture?: InputMaybe<Scalars['S3UrlCloudFront']['input']>;
  /** Código PIS */
  pisCode?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do cargo */
  positionId?: InputMaybe<Scalars['String']['input']>;
  /** Foto de perfil */
  profilePicture?: InputMaybe<Scalars['S3UrlCloudFront']['input']>;
  /** RAIS */
  rais?: InputMaybe<Scalars['String']['input']>;
  /** Matrícula */
  registration?: InputMaybe<Scalars['String']['input']>;
  /** Situação de substituição */
  replacementSituation?: InputMaybe<TReplacementSituation>;
  /** SEFIP */
  sefip?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do vendedor */
  sellerId?: InputMaybe<Scalars['String']['input']>;
  /** Nome social */
  socialName?: InputMaybe<Scalars['String']['input']>;
  /** Estado */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Sugestão */
  suggestion?: InputMaybe<Scalars['String']['input']>;
  /** Tarefas */
  tasks?: InputMaybe<Array<TEmployeeTaskOnPersonInput>>;
  /** Telefone */
  telephone?: InputMaybe<Scalars['String']['input']>;
  /** Históricos de treinamento */
  trainingHistories?: InputMaybe<TTrainingHistoryOnPersonInput>;
  /** Identificador único eSocial */
  unicESocialId?: InputMaybe<Scalars['String']['input']>;
  /** URL de upload */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
  /** Usuário */
  user?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do turno de trabalho */
  workShiftId?: InputMaybe<Scalars['String']['input']>;
  /** CEP */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type TPersonIpeList = {
  __typename?: 'PersonIpeList';
  /** Centro de custo */
  costCenter?: Maybe<Scalars['String']['output']>;
  /** Identificador do centro de custo */
  costCenterId?: Maybe<Scalars['String']['output']>;
  /** Situação do funcionário */
  employeeSituation?: Maybe<TEmployeeSituation>;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Nome */
  name: Scalars['String']['output'];
  /** Próxima troca */
  nextChange?: Maybe<Scalars['DateTime']['output']>;
  /** Ocupação */
  occupation?: Maybe<Scalars['String']['output']>;
  /** Identificador da ocupação */
  occupationId?: Maybe<Scalars['String']['output']>;
  /** Foto de perfil */
  profilePicture?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** Situação de substituição */
  replacementSituation?: Maybe<TReplacementSituation>;
};

export type TPersonNeedIpe = {
  __typename?: 'PersonNeedIpe';
  /** Código CA */
  caCode?: Maybe<Scalars['String']['output']>;
  /** Dias para substituição */
  daysForReplacement?: Maybe<Scalars['Float']['output']>;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Identificador do EPI */
  ipeId: Scalars['String']['output'];
  /** Nome do EPI */
  ipeName?: Maybe<Scalars['String']['output']>;
  /** Tipo de proteção do EPI */
  ipeProtection?: Maybe<TIpeProtection>;
};

export type TPersonOnBrowse = {
  __typename?: 'PersonOnBrowse';
  /** Identificador */
  id: Scalars['String']['output'];
  /** CPF */
  individualRegistration: Scalars['String']['output'];
  /** Está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Nome */
  name: Scalars['String']['output'];
  /** Ocupação */
  occupation?: Maybe<Scalars['String']['output']>;
  /** Matrícula */
  registration?: Maybe<Scalars['String']['output']>;
};

export type TPersonOnRiskInput = {
  /** ID da pessoa */
  personId: Scalars['String']['input'];
};

export type TPersonOnTaskInput = {
  /** Data de término */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
  /** Data de início */
  startDate: Scalars['DateTime']['input'];
};

export type TPersonOnTaskRemove = {
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
  /** Data de início */
  startDate: Scalars['DateTime']['input'];
};

export type TPersonOnTaskUpdate = {
  /** Pessoas a criar */
  toCreate: Array<TPersonOnTaskInput>;
  /** Pessoas a remover */
  toRemove: Array<TPersonOnTaskRemove>;
  /** Pessoas a atualizar */
  toUpdate: Array<TPersonOnTaskInput>;
};

/** Campos para ordenação de pessoas */
export enum TPersonOrderByFields {
  /** Nome */
  Name = 'Name',
  /** Matrícula */
  Registration = 'Registration'
}

export type TPersonOrderByInput = {
  /** Campo */
  field?: InputMaybe<TPersonOrderByFields>;
  /** Tipo */
  type?: InputMaybe<TOrderBy>;
};

export type TPersonRequiredTraining = {
  __typename?: 'PersonRequiredTraining';
  /** Última realização foi aprovada */
  approved?: Maybe<Scalars['Boolean']['output']>;
  /** Data de validade da última realização */
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Data da última realização */
  lastCompletionDate?: Maybe<Scalars['DateTime']['output']>;
  /** Origens que geram a necessidade deste treinamento */
  origins: Array<TTrainingNecessityOrigin>;
  /** Status calculado da realização do treinamento */
  status: TTrainingEligibleStatus;
  /** Descrição do treinamento */
  trainingDescription: Scalars['String']['output'];
  /** ID do treinamento */
  trainingId: Scalars['String']['output'];
};

export type TPersonUpdate = {
  /** Endereço */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Data de admissão */
  admissionDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de nascimento */
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  /** Cidade */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Estado civil */
  civilStatus?: InputMaybe<TCivilStatus>;
  /** Tamanho do conteúdo */
  contentLength?: InputMaybe<Scalars['Float']['input']>;
  /** Tipo de conteúdo */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do centro de custo */
  costCenterId?: InputMaybe<Scalars['String']['input']>;
  /** CTPS */
  ctps?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do departamento */
  departmentId?: InputMaybe<Scalars['String']['input']>;
  /** Dependentes */
  dependents?: InputMaybe<TDependentOnPersonUpdate>;
  /** Data de demissão */
  dismissalDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Categoria eSocial */
  eSocialCategory?: InputMaybe<Scalars['String']['input']>;
  /** Status do protocolo do evento RH (S-2190/S-2200) no eSocial */
  eSocialRhEventStatus?: InputMaybe<TESocialRhEventStatus>;
  /** Nível de escolaridade */
  educationLevel?: InputMaybe<TEducationLevel>;
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Situação do funcionário */
  employeeSituation?: InputMaybe<TEmployeeSituation>;
  /** Advertências do funcionário */
  employeeWarnings?: InputMaybe<Array<TEmployeeWarningOnPersonInput>>;
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** É externo */
  external?: InputMaybe<Scalars['Boolean']['input']>;
  /** Históricos funcionais */
  funcionalHistories?: InputMaybe<TFuncionalHistoryOnPersonUpdate>;
  /** Gênero */
  gender?: InputMaybe<TGender>;
  /** RG */
  generalRegistration?: InputMaybe<Scalars['String']['input']>;
  /** Identificador */
  id: Scalars['String']['input'];
  /** CPF */
  individualRegistration?: InputMaybe<Scalars['String']['input']>;
  /** Está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Último exame */
  lastExam?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador do gestor/superior imediato */
  managerId?: InputMaybe<Scalars['String']['input']>;
  /** Nome da mãe */
  mothersName?: InputMaybe<Scalars['String']['input']>;
  /** Nome */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Bairro */
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  /** Próxima troca */
  nextChange?: InputMaybe<Scalars['DateTime']['input']>;
  /** Apelido */
  nickname?: InputMaybe<Scalars['String']['input']>;
  /** Número do endereço */
  numberAddress?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da ocupação */
  occupationId?: InputMaybe<Scalars['String']['input']>;
  /** Foto da organização */
  organizationPicture?: InputMaybe<Scalars['S3UrlCloudFront']['input']>;
  /** Código PIS */
  pisCode?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do cargo */
  positionId?: InputMaybe<Scalars['String']['input']>;
  /** Foto de perfil */
  profilePicture?: InputMaybe<Scalars['S3UrlCloudFront']['input']>;
  /** RAIS */
  rais?: InputMaybe<Scalars['String']['input']>;
  /** Matrícula */
  registration?: InputMaybe<Scalars['String']['input']>;
  /** Situação de substituição */
  replacementSituation?: InputMaybe<TReplacementSituation>;
  /** SEFIP */
  sefip?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do vendedor */
  sellerId?: InputMaybe<Scalars['String']['input']>;
  /** Nome social */
  socialName?: InputMaybe<Scalars['String']['input']>;
  /** Estado */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Sugestão */
  suggestion?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da tarefa */
  taskId?: InputMaybe<Scalars['String']['input']>;
  /** Tarefas */
  tasks?: InputMaybe<TEmployeeTaskOnPersonUpdate>;
  /** Telefone */
  telephone?: InputMaybe<Scalars['String']['input']>;
  /** Históricos de treinamento */
  trainingHistories?: InputMaybe<TTrainingHistoryOnPersonUpdate>;
  /** Identificador único eSocial */
  unicESocialId?: InputMaybe<Scalars['String']['input']>;
  /** URL de upload */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
  /** Usuário */
  user?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do turno de trabalho */
  workShiftId?: InputMaybe<Scalars['String']['input']>;
  /** CEP */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Níveis de pH */
export enum TPhEnum {
  /** 8.0 */
  Eight = 'Eight',
  /** 8.5 */
  EightPointFive = 'EightPointFive',
  /** 5.0 */
  Five = 'Five',
  /** 7.0 */
  Seven = 'Seven',
  /** 7.5 */
  SevenPointFive = 'SevenPointFive',
  /** 6.0 */
  Six = 'Six',
  /** 6.5 */
  SixPoitFive = 'SixPoitFive'
}

/** Medida de foria */
export enum TPhoriaEnum {
  /** 8 */
  Eight = 'Eight',
  /** 8.5 */
  EightPoitFive = 'EightPoitFive',
  /** 5 */
  Five = 'Five',
  /** 5.5 */
  FivePointFive = 'FivePointFive',
  /** 4 */
  Four = 'Four',
  /** 4.5 */
  FourPoitFive = 'FourPoitFive',
  /** 9 */
  Nine = 'Nine',
  /** 1 */
  One = 'One',
  /** 1.5 */
  OnePointFive = 'OnePointFive',
  /** 7 */
  Seven = 'Seven',
  /** 7.5 */
  SevenPointFive = 'SevenPointFive',
  /** 6 */
  Six = 'Six',
  /** 6.5 */
  SixPoitFive = 'SixPoitFive',
  /** 3 */
  Tree = 'Tree',
  /** 3.5 */
  TreePointFive = 'TreePointFive',
  /** 2 */
  Two = 'Two',
  /** 2.5 */
  TwoPoitFive = 'TwoPoitFive',
  /** 0 */
  Zero = 'Zero',
  /** 0.5 */
  ZeroPoitFive = 'ZeroPoitFive'
}

export type TPhysicalEnvironment = {
  __typename?: 'PhysicalEnvironment';
  /** Anexos */
  attachments?: Maybe<Array<TAttachment>>;
  /** Detalhamento do teto */
  ceilingDetailing?: Maybe<Scalars['String']['output']>;
  /** Material do teto */
  ceilingMaterial?: Maybe<TMaterial>;
  /** Descrição */
  description: Scalars['String']['output'];
  /** Detalhamento da exibição */
  displayDetailing?: Maybe<Scalars['String']['output']>;
  /** Tipo de exibição */
  displayType?: Maybe<TMaterial>;
  /** Número do documento */
  documentNumber?: Maybe<Scalars['String']['output']>;
  /** Detalhamento da porta */
  doorDetailing?: Maybe<Scalars['String']['output']>;
  /** Material da porta */
  doorMaterial?: Maybe<TMaterial>;
  /** Tipo de ambiente */
  environmentType?: Maybe<TEnvironmentType>;
  /** Detalhamento do primeiro revestimento */
  firstCoatDetailing?: Maybe<Scalars['String']['output']>;
  /** Material do primeiro revestimento */
  firstCoatMaterial?: Maybe<TMaterial>;
  /** Detalhamento do piso */
  floorDetailing?: Maybe<Scalars['String']['output']>;
  /** Material do piso */
  floorMaterial?: Maybe<TMaterial>;
  /** Altura do teto */
  heightCeiling?: Maybe<Scalars['Float']['output']>;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Está ativo */
  isActive: Scalars['Boolean']['output'];
  /** É fechado */
  isClosed?: Maybe<Scalars['Boolean']['output']>;
  /** Detalhamento da iluminação */
  lightingDetailing?: Maybe<Scalars['String']['output']>;
  /** Material da iluminação */
  lightingMaterial?: Maybe<TMaterial>;
  /** Maquinário */
  machinery?: Maybe<Scalars['String']['output']>;
  /** Imagem do mapa de risco */
  riskMapPicture?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** Detalhamento do segundo revestimento */
  secondCoatDetailing?: Maybe<Scalars['String']['output']>;
  /** Material do segundo revestimento */
  secondCoatMaterial?: Maybe<TMaterial>;
  /** URL de upload */
  uploadUrl?: Maybe<Scalars['String']['output']>;
  /** Detalhamento da parede */
  wallDetailing?: Maybe<Scalars['String']['output']>;
  /** Material da parede */
  wallMaterial?: Maybe<TMaterial>;
  /** Detalhamento da janela */
  windowDetailing?: Maybe<Scalars['String']['output']>;
  /** Material da janela */
  windowMaterial?: Maybe<TMaterial>;
};

export type TPhysicalEnvironmentInput = {
  /** Detalhamento do teto */
  ceilingDetailing?: InputMaybe<Scalars['String']['input']>;
  /** Material do teto */
  ceilingMaterial?: InputMaybe<TMaterial>;
  /** Descrição */
  description: Scalars['String']['input'];
  /** Detalhamento da exibição */
  displayDetailing?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de exibição */
  displayType?: InputMaybe<TMaterial>;
  /** Número do documento */
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  /** Detalhamento da porta */
  doorDetailing?: InputMaybe<Scalars['String']['input']>;
  /** Material da porta */
  doorMaterial?: InputMaybe<TMaterial>;
  /** Tipo de ambiente */
  environmentType?: InputMaybe<TEnvironmentType>;
  /** Detalhamento do primeiro revestimento */
  firstCoatDetailing?: InputMaybe<Scalars['String']['input']>;
  /** Material do primeiro revestimento */
  firstCoatMaterial?: InputMaybe<TMaterial>;
  /** Detalhamento do piso */
  floorDetailing?: InputMaybe<Scalars['String']['input']>;
  /** Material do piso */
  floorMaterial?: InputMaybe<TMaterial>;
  /** Altura do teto */
  heightCeiling?: InputMaybe<Scalars['Float']['input']>;
  /** É fechado */
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Detalhamento da iluminação */
  lightingDetailing?: InputMaybe<Scalars['String']['input']>;
  /** Material da iluminação */
  lightingMaterial?: InputMaybe<TMaterial>;
  /** Maquinário */
  machinery?: InputMaybe<Scalars['String']['input']>;
  /** Imagem do mapa de risco */
  riskMapPicture?: InputMaybe<Scalars['S3UrlCloudFront']['input']>;
  /** Detalhamento do segundo revestimento */
  secondCoatDetailing?: InputMaybe<Scalars['String']['input']>;
  /** Material do segundo revestimento */
  secondCoatMaterial?: InputMaybe<TMaterial>;
  /** URL de upload */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
  /** Detalhamento da parede */
  wallDetailing?: InputMaybe<Scalars['String']['input']>;
  /** Material da parede */
  wallMaterial?: InputMaybe<TMaterial>;
  /** Detalhamento da janela */
  windowDetailing?: InputMaybe<Scalars['String']['input']>;
  /** Material da janela */
  windowMaterial?: InputMaybe<TMaterial>;
};

export type TPhysicalEnvironmentUpdate = {
  /** Detalhamento do teto */
  ceilingDetailing?: InputMaybe<Scalars['String']['input']>;
  /** Material do teto */
  ceilingMaterial?: InputMaybe<TMaterial>;
  /** Tamanho do conteúdo */
  contentLength?: InputMaybe<Scalars['Float']['input']>;
  /** Tipo de conteúdo */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Detalhamento da exibição */
  displayDetailing?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de exibição */
  displayType?: InputMaybe<TMaterial>;
  /** Número do documento */
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  /** Detalhamento da porta */
  doorDetailing?: InputMaybe<Scalars['String']['input']>;
  /** Material da porta */
  doorMaterial?: InputMaybe<TMaterial>;
  /** Tipo de ambiente */
  environmentType?: InputMaybe<TEnvironmentType>;
  /** Detalhamento do primeiro revestimento */
  firstCoatDetailing?: InputMaybe<Scalars['String']['input']>;
  /** Material do primeiro revestimento */
  firstCoatMaterial?: InputMaybe<TMaterial>;
  /** Detalhamento do piso */
  floorDetailing?: InputMaybe<Scalars['String']['input']>;
  /** Material do piso */
  floorMaterial?: InputMaybe<TMaterial>;
  /** Altura do teto */
  heightCeiling?: InputMaybe<Scalars['Float']['input']>;
  /** Identificador */
  id: Scalars['String']['input'];
  /** Está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** É fechado */
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Detalhamento da iluminação */
  lightingDetailing?: InputMaybe<Scalars['String']['input']>;
  /** Material da iluminação */
  lightingMaterial?: InputMaybe<TMaterial>;
  /** Maquinário */
  machinery?: InputMaybe<Scalars['String']['input']>;
  /** Imagem do mapa de risco */
  riskMapPicture?: InputMaybe<Scalars['S3UrlCloudFront']['input']>;
  /** Detalhamento do segundo revestimento */
  secondCoatDetailing?: InputMaybe<Scalars['String']['input']>;
  /** Material do segundo revestimento */
  secondCoatMaterial?: InputMaybe<TMaterial>;
  /** URL de upload */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
  /** Detalhamento da parede */
  wallDetailing?: InputMaybe<Scalars['String']['input']>;
  /** Material da parede */
  wallMaterial?: InputMaybe<TMaterial>;
  /** Detalhamento da janela */
  windowDetailing?: InputMaybe<Scalars['String']['input']>;
  /** Material da janela */
  windowMaterial?: InputMaybe<TMaterial>;
};

export type TPieChart = {
  __typename?: 'PieChart';
  /** Nome */
  name: Scalars['String']['output'];
  /** Valor */
  value: Scalars['Float']['output'];
};

export type TPieCharts = {
  __typename?: 'PieCharts';
  /** Dados */
  data: Array<TPieChart>;
};

/** Enumeração de nível do plano */
export enum TPlanLevelType {
  /** Quinto */
  Fifth = 'Fifth',
  /** Primeiro */
  First = 'First',
  /** Quarto */
  Fourth = 'Fourth',
  /** Segundo */
  Second = 'Second',
  /** Sexto */
  Sixth = 'Sixth',
  /** Terceiro */
  Third = 'Third'
}

/** Status do plano */
export enum TPlanStatus {
  /** Cancelado */
  Cancelled = 'Cancelled',
  /** Pago */
  Paid = 'Paid',
  /** Período de teste */
  Trial = 'Trial'
}

export type TPlanedExam = {
  __typename?: 'PlanedExam';
  name: Scalars['String']['output'];
  preparation?: Maybe<Scalars['String']['output']>;
};

export type TPolicyAgreement = {
  __typename?: 'PolicyAgreement';
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** ID do acordo */
  id: Scalars['String']['output'];
  /** Endereço IP */
  ipAddress: Scalars['String']['output'];
  /** ID do termo */
  termId: Scalars['String']['output'];
  /** Identificação do navegador */
  userAgent: Scalars['String']['output'];
  /** ID do usuário */
  userId: Scalars['String']['output'];
};

export type TPolicyTerms = {
  __typename?: 'PolicyTerms';
  /** Conteúdo do termo */
  content: Scalars['String']['output'];
  /** Data de criação */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Identificador único do termo */
  id: Scalars['String']['output'];
  /** Indica se é uma versão futura */
  isFuture: Scalars['Boolean']['output'];
  /** Data de início de vigência */
  startedAt: Scalars['DateTime']['output'];
  /** Tipo de política de privacidade */
  type: TPrivacyType;
  /** Versão do termo */
  version: Scalars['String']['output'];
};

export type TPolicyTermsInput = {
  /** Conteúdo do termo */
  content: Scalars['String']['input'];
  /** Data de criação */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de início de vigência */
  startedAt: Scalars['DateTime']['input'];
  /** Tipo de política de privacidade */
  type: TPrivacyType;
  /** Versão do termo */
  version: Scalars['String']['input'];
};

export type TPosition = {
  __typename?: 'Position';
  /** Descrição */
  description: Scalars['String']['output'];
  /** Identificador no ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Está ativo */
  isActive: Scalars['Boolean']['output'];
};

export type TPositionInput = {
  /** Descrição */
  description: Scalars['String']['input'];
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
};

export type TPositionIntegration = {
  /** Filial */
  branch: Scalars['String']['input'];
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador */
  id?: InputMaybe<Scalars['String']['input']>;
};

export type TPositionUpdate = {
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Identificador */
  id: Scalars['String']['input'];
  /** Está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TPppParameters = {
  considerTasks?: InputMaybe<Scalars['Boolean']['input']>;
  epc?: InputMaybe<Scalars['Boolean']['input']>;
  epi?: InputMaybe<Scalars['Boolean']['input']>;
  expiration?: InputMaybe<Scalars['Boolean']['input']>;
  itemSeventeen?: InputMaybe<Scalars['Boolean']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  periodicity?: InputMaybe<Scalars['Boolean']['input']>;
  representativeId?: InputMaybe<Scalars['String']['input']>;
  sanitation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TPppReport = {
  __typename?: 'PppReport';
  cnpj: Scalars['String']['output'];
};

export type TPreMedicalCertificate = {
  __typename?: 'PreMedicalCertificate';
  /** Anexos */
  attachments?: Maybe<Array<TAttachment>>;
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** Data de término */
  endDate: Scalars['DateTime']['output'];
  /** Identificador no ERP */
  erpId: Scalars['String']['output'];
  /** Acompanhamentos */
  followUps: Array<TPreMedicalCertificateFollowUp>;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Prontuário médico */
  medicalRecord: TMedicalRecord;
  /** Identificador do prontuário médico */
  medicalRecordId: Scalars['String']['output'];
  /** Observação */
  observation?: Maybe<Scalars['String']['output']>;
  /** Detalhes da rejeição */
  rejectionDetails?: Maybe<Scalars['String']['output']>;
  /** Motivo da rejeição */
  rejectionReason?: Maybe<Scalars['String']['output']>;
  /** Data de início */
  startDate: Scalars['DateTime']['output'];
  /** Situação */
  status: TPreMedicalCertificateStatus;
  /** Data de atualização */
  updatedAt: Scalars['DateTime']['output'];
};

export type TPreMedicalCertificateCountByStatus = {
  __typename?: 'PreMedicalCertificateCountByStatus';
  /** Quantidade */
  count: Scalars['Float']['output'];
  /** Situação */
  status: TPreMedicalCertificateStatus;
};

export type TPreMedicalCertificateFollowUp = {
  __typename?: 'PreMedicalCertificateFollowUp';
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** Identificador */
  id: Scalars['String']['output'];
  /** Situação */
  status: TPreMedicalCertificateStatus;
};

export type TPreMedicalCertificateInput = {
  /** Data de término */
  endDate: Scalars['DateTime']['input'];
  /** Identificador no ERP */
  erpId: Scalars['String']['input'];
  /** Identificador do prontuário médico */
  medicalRecordId: Scalars['String']['input'];
  /** Observação */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Detalhes da rejeição */
  rejectionDetails?: InputMaybe<Scalars['String']['input']>;
  /** Motivo da rejeição */
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  /** Data de início */
  startDate: Scalars['DateTime']['input'];
  /** Situação */
  status: TPreMedicalCertificateStatus;
};

export type TPreMedicalCertificateQueryInput = {
  /** Identificador do prontuário */
  medicalRecordId?: InputMaybe<Scalars['String']['input']>;
  /** Filtrar por situação */
  status?: InputMaybe<TPreMedicalCertificateStatus>;
};

/** Enumeração de status do atestado pré-médico */
export enum TPreMedicalCertificateStatus {
  /** Aprovado */
  Approved = 'Approved',
  /** Pendente */
  Pending = 'Pending',
  /** Rejeitado */
  Rejected = 'Rejected'
}

export type TPreMedicalCertificateUpdate = {
  /** Data de término */
  endDate: Scalars['DateTime']['input'];
  /** Identificador no ERP */
  erpId: Scalars['String']['input'];
  /** Identificador */
  id: Scalars['String']['input'];
  /** Identificador do prontuário médico */
  medicalRecordId: Scalars['String']['input'];
  /** Observação */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Detalhes da rejeição */
  rejectionDetails?: InputMaybe<Scalars['String']['input']>;
  /** Motivo da rejeição */
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  /** Data de início */
  startDate: Scalars['DateTime']['input'];
  /** Situação */
  status: TPreMedicalCertificateStatus;
};

export type TPreValidate = {
  __typename?: 'PreValidate';
  /** Linhas inválidas do arquivo */
  invalidLines: Scalars['Float']['output'];
  /** Linhas do arquivo importado */
  rows: Array<TRowsInfo>;
  /** Total de linhas do arquivo */
  totalLines: Scalars['Float']['output'];
  /** Linhas válidas do arquivo */
  validLines: Scalars['Float']['output'];
};

export type TPrintBiometry = {
  __typename?: 'PrintBiometry';
  biometryId?: Maybe<Scalars['String']['output']>;
  bmp?: Maybe<Scalars['String']['output']>;
  imageData?: Maybe<Scalars['String']['output']>;
};

/** Prioridade */
export enum TPriority {
  /** Alta */
  High = 'high',
  /** Baixa */
  Low = 'low',
  /** Média */
  Medium = 'medium'
}

/** Tipos de privacidade */
export enum TPrivacyType {
  /** Política de Privacidade */
  Policy = 'Policy',
  /** Termos de Uso */
  Use = 'Use'
}

export enum TProcessingStep {
  BuildingExpectedExams = 'BUILDING_EXPECTED_EXAMS',
  CreatingCandidate = 'CREATING_CANDIDATE',
  CreatingComponent = 'CREATING_COMPONENT',
  CreatingEsocialMessage = 'CREATING_ESOCIAL_MESSAGE',
  CreatingMedicalCertificate = 'CREATING_MEDICAL_CERTIFICATE',
  CreatingOhc = 'CREATING_OHC',
  FetchingExpectedResults = 'FETCHING_EXPECTED_RESULTS',
  InfoSearch = 'INFO_SEARCH',
  MatchingPersons = 'MATCHING_PERSONS',
  PreparingExamData = 'PREPARING_EXAM_DATA',
  RemovingAccident = 'REMOVING_ACCIDENT',
  RemovingCandidate = 'REMOVING_CANDIDATE',
  RemovingComponent = 'REMOVING_COMPONENT',
  RemovingHealthPrograms = 'REMOVING_HEALTH_PROGRAMS',
  RemovingMedicalCertificate = 'REMOVING_MEDICAL_CERTIFICATE',
  RemovingOhc = 'REMOVING_OHC',
  RemovingStabilityHr = 'REMOVING_STABILITY_HR',
  RemovingTrainingHr = 'REMOVING_TRAINING_HR',
  SearchingBranches = 'SEARCHING_BRANCHES',
  SendingAbsenceExclusionHr = 'SENDING_ABSENCE_EXCLUSION_HR',
  SendingAbsenceInclusionHr = 'SENDING_ABSENCE_INCLUSION_HR',
  SendingAllowanceExclusionHr = 'SENDING_ALLOWANCE_EXCLUSION_HR',
  SendingAllowanceInclusionHr = 'SENDING_ALLOWANCE_INCLUSION_HR',
  SendingStabilityHr = 'SENDING_STABILITY_HR',
  SendingToEsocial = 'SENDING_TO_ESOCIAL',
  SendingTrainingHr = 'SENDING_TRAINING_HR',
  UpdatingAccident = 'UPDATING_ACCIDENT',
  UpdatingCandidate = 'UPDATING_CANDIDATE',
  UpdatingComponent = 'UPDATING_COMPONENT',
  UpdatingHealthPrograms = 'UPDATING_HEALTH_PROGRAMS',
  UpdatingMedicalCertificate = 'UPDATING_MEDICAL_CERTIFICATE',
  UpdatingOhc = 'UPDATING_OHC',
  UpdatingStabilityHr = 'UPDATING_STABILITY_HR',
  ValidatingBranches = 'VALIDATING_BRANCHES',
  ValidatingIntegrationType = 'VALIDATING_INTEGRATION_TYPE',
  ValidatingUrlPortAuthType = 'VALIDATING_URL_PORT_AUTH_TYPE',
  ValidatingUserPassword = 'VALIDATING_USER_PASSWORD'
}

export type TProduct = {
  __typename?: 'Product';
  /** É perigoso */
  dangerous: Scalars['Boolean']['output'];
  /** Dias para reposição */
  daysForReplacement?: Maybe<Scalars['Float']['output']>;
  /** Descrição */
  description: Scalars['String']['output'];
  /** Identificador no ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** Identificador */
  id: Scalars['String']['output'];
  /** EPIs */
  ipes?: Maybe<TProductIpeManufacturer>;
  /** Está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Níveis de estoque */
  stockLevels?: Maybe<Array<TStockLevel>>;
  /** Sugestão */
  suggestion?: Maybe<Scalars['String']['output']>;
  /** Custo unitário */
  unitaryCost: Scalars['Float']['output'];
  /** Identificador da unidade de medida */
  unityOfMeasureId: Scalars['String']['output'];
  /** Referência da unidade de medida */
  unityOfMeasureRef?: Maybe<TUnityOfMeasure>;
  /** Identificador do armazém */
  warehouseId?: Maybe<Scalars['String']['output']>;
};

export type TProductCopyInput = {
  ids: Array<Scalars['String']['input']>;
  targetBranchIds: Array<Scalars['String']['input']>;
};

export type TProductDelivery = {
  __typename?: 'ProductDelivery';
  /** Quantidade */
  amount: Scalars['Float']['output'];
  /** Quantidade devolvida */
  amountReturned?: Maybe<Scalars['Float']['output']>;
  /** Filial */
  branch: Scalars['String']['output'];
  /** Custo */
  cost?: Maybe<Scalars['Float']['output']>;
  /** Data de entrega */
  deliveryDate: Scalars['DateTime']['output'];
  /** Status da entrega (other, near, late) */
  deliveryStatus?: Maybe<Scalars['String']['output']>;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Data de emissão */
  issueDate?: Maybe<Scalars['DateTime']['output']>;
  /** Número do lote */
  lotNumber?: Maybe<Scalars['String']['output']>;
  /** Próxima data de entrega */
  nextDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  /** Observação */
  observation?: Maybe<Scalars['String']['output']>;
  /** Pessoa */
  person: TPerson;
  /** Identificador da pessoa */
  personId: Scalars['String']['output'];
  /** Produto */
  product: TProduct;
  /** Identificador do produto */
  productId: Scalars['String']['output'];
  /** Data de devolução */
  returnedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Número do lote devolvido */
  returnedLotNumber?: Maybe<Scalars['String']['output']>;
  /** Produto devolvido */
  returnedProduct: TProduct;
  /** Identificador do produto devolvido */
  returnedProductId?: Maybe<Scalars['String']['output']>;
  /** Armazém de devolução */
  returnedWarehouse: TWarehouse;
  /** Identificador do armazém de devolução */
  returnedWarehouseId?: Maybe<Scalars['String']['output']>;
  /** Movimentação de estoque */
  stockMovement?: Maybe<Array<TStockMovement>>;
  /** Armazém */
  warehouse: TWarehouse;
  /** Identificador do armazém */
  warehouseId: Scalars['String']['output'];
};

export type TProductDeliveryInput = {
  /** Quantidade */
  amount: Scalars['Float']['input'];
  /** Quantidade devolvida */
  amountReturned?: InputMaybe<Scalars['Float']['input']>;
  /** Custo */
  cost?: InputMaybe<Scalars['Float']['input']>;
  /** Data de entrega */
  deliveryDate: Scalars['DateTime']['input'];
  /** Data de emissão */
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Número do lote */
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  /** Observação */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
  /** Identificador do produto */
  productId: Scalars['String']['input'];
  /** Data de devolução */
  returnedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Número do lote devolvido */
  returnedLotNumber?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do produto devolvido */
  returnedProductId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do armazém de devolução */
  returnedWarehouseId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do armazém */
  warehouseId: Scalars['String']['input'];
};

export type TProductDeliveryParams = {
  __typename?: 'ProductDeliveryParams';
  /** Filtro */
  filter?: Maybe<TDeliveryFilter>;
  /** É verificação */
  isCheck?: Maybe<Scalars['Boolean']['output']>;
  /** Declaração de responsabilidade */
  statementsResponsibility?: Maybe<Scalars['String']['output']>;
};

export type TProductDeliveryReport = {
  __typename?: 'ProductDeliveryReport';
  /** Endereço */
  address: Scalars['String']['output'];
  /** Data de admissão */
  admission?: Maybe<Scalars['String']['output']>;
  /** CNPJ */
  cnpj: Scalars['String']['output'];
  /** Nome da empresa */
  companyName: Scalars['String']['output'];
  /** Centro de custo */
  costCenter?: Maybe<Scalars['String']['output']>;
  /** RG */
  generalRegistration?: Maybe<Scalars['String']['output']>;
  /** CPF */
  individualRegistration: Scalars['String']['output'];
  /** Nome */
  name: Scalars['String']['output'];
  /** Ocupação */
  occupation?: Maybe<Scalars['String']['output']>;
  /** Cargo */
  position?: Maybe<Scalars['String']['output']>;
  /** Biometria do produto */
  productBiometry?: Maybe<TIpeBiometry>;
  /** Face do produto */
  productFace?: Maybe<TIpeFace>;
  /** Produtos */
  products: Array<TProductReport>;
  /** Matrícula */
  registration?: Maybe<Scalars['String']['output']>;
  /** Telefone */
  telephone: Scalars['String']['output'];
};

export type TProductDeliveryUpdate = {
  /** Quantidade */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Quantidade devolvida */
  amountReturned?: InputMaybe<Scalars['Float']['input']>;
  /** Custo */
  cost?: InputMaybe<Scalars['Float']['input']>;
  /** Data de entrega */
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador */
  id: Scalars['String']['input'];
  /** Data de emissão */
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Número do lote */
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  /** Observação */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da pessoa */
  personId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do produto */
  productId?: InputMaybe<Scalars['String']['input']>;
  /** Data de devolução */
  returnedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Número do lote devolvido */
  returnedLotNumber?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do produto devolvido */
  returnedProductId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do armazém de devolução */
  returnedWarehouseId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do armazém */
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type TProductInput = {
  /** É perigoso */
  dangerous: Scalars['Boolean']['input'];
  /** Dias para reposição */
  daysForReplacement?: InputMaybe<Scalars['Float']['input']>;
  /** Descrição */
  description: Scalars['String']['input'];
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Está ativo */
  isActive: Scalars['Boolean']['input'];
  /** Custo unitário */
  unitaryCost: Scalars['Float']['input'];
  /** Identificador da unidade de medida */
  unityOfMeasureId: Scalars['String']['input'];
  /** Identificador do armazém */
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type TProductIntegration = {
  /** Filial */
  branch: Scalars['String']['input'];
  /** É perigoso */
  dangerous?: InputMaybe<Scalars['Boolean']['input']>;
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Quantidade */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  /** Níveis de estoque */
  stockLevels?: InputMaybe<Array<TStockLevelReference>>;
  /** Custo unitário */
  unitaryCost?: InputMaybe<Scalars['Float']['input']>;
  /** Identificador da unidade de medida */
  unityOfMeasureId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do armazém */
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type TProductIpeManufacturer = {
  __typename?: 'ProductIpeManufacturer';
  /** Identificador */
  id: Scalars['String']['output'];
  /** Identificador do fabricante de EPI */
  ipeManufacturerId: Scalars['String']['output'];
  /** Referência do fabricante de EPI */
  ipeManufacturerRef?: Maybe<TIpeManufacturer>;
  /** Identificador do produto */
  productId: Scalars['String']['output'];
};

export type TProductIpeManufacturerInput = {
  /** Identificador do fabricante de EPI */
  ipeManufacturerId: Scalars['String']['input'];
  /** Identificador do produto */
  productId: Scalars['String']['input'];
};

export type TProductIpeManufacturerUpdate = {
  /** Identificador */
  id: Scalars['String']['input'];
  /** Identificador do fabricante de EPI */
  ipeManufacturerId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do produto */
  productId?: InputMaybe<Scalars['String']['input']>;
};

export type TProductReport = {
  __typename?: 'ProductReport';
  /** Quantidade */
  amount: Scalars['Float']['output'];
  /** Descrição */
  description: Scalars['String']['output'];
  /** Data prevista */
  prevDate: Scalars['String']['output'];
  /** Data de devolução */
  returnDate: Scalars['String']['output'];
  /** Data de assinatura */
  signDate: Scalars['String']['output'];
};

export type TProductUpdate = {
  /** É perigoso */
  dangerous?: InputMaybe<Scalars['Boolean']['input']>;
  /** Dias para reposição */
  daysForReplacement?: InputMaybe<Scalars['Float']['input']>;
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Identificador no ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador */
  id: Scalars['String']['input'];
  /** Está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Custo unitário */
  unitaryCost?: InputMaybe<Scalars['Float']['input']>;
  /** Identificador da unidade de medida */
  unityOfMeasureId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do armazém */
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

/** Frequência de horas produtivas */
export enum TProductiveHoursFrequency {
  /** Diária */
  Daily = 'Daily',
  /** Mensal */
  Monthly = 'Monthly',
  /** Semanal */
  Weekly = 'Weekly'
}

export type TProductsParameters = {
  __typename?: 'ProductsParameters';
  /** Filiais */
  branches: Array<Scalars['String']['output']>;
  /** Data inicial */
  fromDate: Scalars['String']['output'];
  /** Data final */
  toDate: Scalars['String']['output'];
};

/** Tipos de programa */
export enum TProgramType {
  /** Monitoramento */
  Monitoring = 'monitoring',
  /** Ocupacional */
  Occupational = 'occupational',
  /** Qualidade de vida */
  QualityOfLife = 'qualityOfLife'
}

/** Níveis de proteína */
export enum TProteinsEnum {
  /** Negativo */
  Negative = 'Negative',
  /** 100 (0.1) */
  OneHundred = 'OneHundred',
  /** 30 (0.3) */
  Tirty = 'Tirty',
  /** Traços */
  Trace = 'Trace',
  /** 300 (3.0) */
  TreeHundred = 'TreeHundred',
  /** >2000 (>20) */
  TwoThousand = 'TwoThousand'
}

export type TPubSubPayload = {
  __typename?: 'PubSubPayload';
  userId: Scalars['String']['output'];
};

export type TPublishingOptionsInput = {
  allowDocumentRejection?: InputMaybe<Scalars['Boolean']['input']>;
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  messageBody?: InputMaybe<Scalars['String']['input']>;
  messageSubject?: InputMaybe<Scalars['String']['input']>;
  reminderInterval?: InputMaybe<Scalars['String']['input']>;
  requestHandwrittenSignature?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TQuery = {
  __typename?: 'Query';
  AllowanceType: TAllowanceType;
  MeetingParticipant: TMeetingParticipant;
  MeetingParticipantPresent: TMeetingParticipant;
  MeetingParticipants: Array<TMeetingParticipant>;
  _getCsv: Scalars['String']['output'];
  _invites: Array<T_Invite>;
  _passwordRecoveries: Array<T_PasswordRecovery>;
  _terms: Array<T_Terms>;
  absenceType: TAbsenceType;
  absenceTypes: TPaginatedAbsenceType;
  accident: TAccident;
  accidentAbsence: Array<TAccidentAbsence>;
  accidentAmount: Array<TAccidentAmount>;
  accidentBySummary: Array<TAccident>;
  accidentCause: TAccidentCause;
  accidentCauses: TPaginatedAccidentCause;
  accidentDeathAccident: Array<TAccidentVictim>;
  accidentExpenseAmount: Array<TAccidentExpenseAmount>;
  accidentLastAccident: Scalars['Float']['output'];
  accidentMaxDaysWithout: Scalars['Float']['output'];
  accidentSummary: TSummary;
  accidentWithVictim: Array<TAccidentVictim>;
  accidentWithoutVictim: Array<TAccidentVictim>;
  /** Lista de Acidentes. */
  accidents: TPaginatedAccident;
  accidentsDashboard: TAccidentDashboard;
  accidentsWithInvestigation: Array<TAccidentWithInvestigation>;
  accidentsWithoutInvestigation: Array<TAccident>;
  accredited: TAccredited;
  accreditedByName?: Maybe<TAccredited>;
  accreditedUnscheduledConsultations: TPaginatedAccreditedConsultations;
  actionPlan: TActionPlan;
  actionPlanCount: TActionPlanCount;
  actionPlanDashboard: TActionPlanDashboard;
  actionPlanInvestigationsByPlan: Array<TActionPlanInvestigationSuggestion>;
  actionPlanMicroActionsByPlan: Array<TActionPlanMicroAction>;
  actionPlanReportsByPlan: Array<TActionPlanReportSuggestion>;
  actionPlanRisksByPlan: Array<TRiskSuggestion>;
  actionPlanSummary: TSummary;
  actionPlans: TPaginatedActionPlan;
  actionPlansBySituation: Array<TActionPlan>;
  activeBulkSyncRun?: Maybe<TBulkSyncRun>;
  actualMandate: Array<TMandate>;
  allAccredited: TPaginatedAccredited;
  allExposureGroupByPerson: Array<TExposureGroup>;
  allowanceTypes: TPaginatedAllowanceType;
  asoEvolutionByMedicalRecord: Array<TAsoEvolutionEntry>;
  audiometryDashboard: TAudiometryDashboard;
  /** Busca um log específico pelo id */
  auditLog?: Maybe<TAuditLogEntry>;
  /** Lista logs de auditoria com filtros e paginação */
  auditLogs: TPaginatedAuditLogs;
  availableBranches: Array<TBranch>;
  biologicalMonitoring: TBiologicalMonitoring;
  biologicalMonitoringByMedicalRecord: Array<TBiologicalMonitoring>;
  biologicalMonitoringExamGroup: TBiologicalMonitoringExamGroup;
  biologicalMonitoringExamGroups: TPaginatedBiologicalMonitoringExamGroup;
  biometries: Array<TBiometry>;
  biometry: TOccupationalHealthBiometry;
  branchHasTtalkEndpoint: Scalars['Boolean']['output'];
  branchIsBlockedToIntegration: Scalars['Boolean']['output'];
  /** Lista de Filiais por Organização. */
  branchesByOrganization: TPaginatedBranch;
  branchesWithTtalk: Array<TBranchTtalkInfo>;
  branchesWithoutInventoryByOrganization: TPaginatedBranch;
  bulkSyncRun?: Maybe<TBulkSyncRun>;
  calendar: TCalendar;
  calendars: TPaginatedCalendar;
  candidate: TCandidate;
  candidateByMandate: Array<TCandidateByMandate>;
  candidateByName: Array<TCandidate>;
  candidates: Array<TCandidate>;
  categorizedBranches: Array<TCategorizedInputData>;
  certificatesRankingDashboard: TCertificatesRankingDashboard;
  checkTableData: Array<TCheckTableData>;
  checkTotvsWebHookConfig: TSignBrokerResponse;
  clinicalQuiz: TClinicalQuiz;
  clinicalQuizzes: Array<TClinicalQuiz>;
  comparativeResultsDashboard: TComparativeResultsDashboard;
  component: TComponent;
  components: Array<TComponent>;
  consultation: TConsultation;
  consultationByCrm: TExternalDoctor;
  consultationByDoctorName: TExternalDoctor;
  consultationByOccupationalHealthCertificate?: Maybe<TExternalOccupationalHealthCertificate>;
  consultationByOriginPerson: TConsultationBiologicalMonitoring;
  consultationReasons: TPaginatedConsultationReason;
  consultationReleasableResults: Array<TReleasableResult>;
  consultationsByDate: Array<TConsultationMinimal>;
  consultationsByDoctor: Array<TConsultationMinimal>;
  consultationsByMedicalRecord: Array<TConsultation>;
  consultationsForTransfer: Array<TConsultationMinimal>;
  controlMeasure: TControlMeasure;
  controlMeasures: TPaginatedControlMeasure;
  controlsByRisk: Array<TControlMeasureByRisk>;
  costCenter: TCostCenter;
  costCenters: TPaginatedCostCenter;
  costCentersFilterByBranch: Array<TCostCenter>;
  crons: Array<TCronTab>;
  crontabExecutionDetails: TPaginatedCrontabExecutionDetails;
  crontabExecutions: TPaginatedCrontabExecutions;
  /** Sessão atual de usuário. */
  currentSession: TSession;
  currentUser: TUser;
  /** Lista as variantes disponíveis para um `DocumentType`. Lista vazia = tipo não tem variantes (apenas default). */
  customDocumentVariants: Array<TCustomDocumentSubType>;
  /** Lista as customizações da organização do usuário corrente. */
  customDocuments: Array<TCustomDocument>;
  customOrganizations: Array<TCustomOrganization>;
  customType?: Maybe<TCustomOrganization>;
  deficiencies: Array<TDeficiency>;
  deficienciesByMedicalRecord: Array<TDeficiency>;
  /** Search in all branches this Employee deficiencies */
  deficiencisByRegistration: Array<TDeficiency>;
  deficiency: TDeficiency;
  deliverySpareParts: TDeliverySpareParts;
  deliverySparePartsByIpe: Array<TDeliverySpareParts>;
  deliverySparePartsByIpeDelivery: Array<TDeliverySpareParts>;
  deliverySparePartsByPerson: Array<TDeliverySpareParts>;
  deliverySparePartsByProduct: Array<TDeliverySpareParts>;
  department: TDepartment;
  departments: TPaginatedDepartment;
  departmentsFilterByBranch: Array<TDepartment>;
  diagnostic: TDiagnostic;
  diagnosticByConsultation: TDiagnostic;
  doctorSuggestions: TPaginatedPerson;
  downloadSignedDocuments: TSignBrokerUrlDownloadResponse;
  eSocialIndicators: TESocialQueueIndicators;
  economicActivity: TEconomicActivity;
  /** Retorna o template efetivo para (org do contexto, tipo): customização da org se existir; caso contrário o default declarado em código (D13). Consumido pelo editor para popular o canvas. */
  effectiveDocumentTemplate: TEffectiveDocumentTemplate;
  elaboratorDocument: TElaboratorDocument;
  electionComission: TElectionComission;
  electionComissionByMandate: Array<TElectionComission>;
  electionComissionByPerson: Array<TElectionComission>;
  employeeAnamneses: Array<TEmployeeAnamnesis>;
  employeeAnamnesisQuiz: TQuiz;
  employeeConsultationResults: Array<TReleasableResult>;
  employeeConsultations: Array<TEmployeeConsultation>;
  employeeHasCandidate?: Maybe<TCandidate>;
  employeeHasVote?: Maybe<TVote>;
  employeeInfo?: Maybe<TEmployee>;
  /** @deprecated Refatored in another query */
  employeeIpeDeliveries: TPaginatedEmployeeIpeDelivery;
  employeeIpes: Array<TEmployeeIpes>;
  employeeLogin: TLogin;
  employeeMandates: Array<TEmployeeMandateEvent>;
  employeeQuiz: TQuiz;
  employeeQuizzes: Array<TEmployeeQuiz>;
  employeeRisks: Array<TEmployeeRisk>;
  employeeRisksDashboard: TEmployeeRiskDashboard;
  employeeTask: TEmployeeTask;
  endElectionPeriod: Scalars['DateTime']['output'];
  envReportSuggestions: TPaginatedEnvironmentalReportSuggestion;
  environmentalReport: TEnvironmentalReport;
  environmentalReportBiometry?: Maybe<TEnvironmentalReportBiometry>;
  environmentalReportFace?: Maybe<TEnvironmentalReportFace>;
  environmentalReportSummary: TSummary;
  environmentalReportVersionDownloadUrl: Scalars['String']['output'];
  environmentalReportVersions: Array<TEnvironmentalReportVersion>;
  environmentalReports: TPaginatedEnvironmentalReport;
  equipmentByCostCenter: TEquipmentByCostCenter;
  equipmentByCostCenterByCostCenter: Array<TEquipmentByCostCenter>;
  equipmentByOccupation: TEquipmentByOccupation;
  equipmentByOccupationByOccupation: Array<TEquipmentByOccupation>;
  esocialSyncingBranches: Array<TBranch>;
  exam: TExam;
  examAlterationTrendByMedicalRecord: Array<TExamAlterationTrend>;
  examAudiometryByConsultation?: Maybe<TExamAudiometry>;
  examDiagnosticCountByMedicalRecord: Array<TExamDiagnosticCount>;
  examDiagnosticImage: TExamDiagnosticImage;
  examDiagnosticImageByConsultation?: Maybe<TExamDiagnosticImage>;
  examItemByConsultation: TExamItem;
  examNormalByConsultation?: Maybe<TExamNormal>;
  examNormalResults: TPaginatedExamNormalResult;
  examOtological: TExamOtological;
  examOtologicalByConsultation?: Maybe<TExamOtological>;
  examResultsByMedicalRecord: TExamResultsByMedicalRecord;
  examSpirometryByConsultation?: Maybe<TExamSpirometry>;
  examTimelineByMedicalRecord: Array<TExamTimelineEntry>;
  examToxicologicalByConsultation?: Maybe<TExamToxicological>;
  exams: TPaginatedExam;
  examsAudiometryByMedicalRecord: Array<TExamAudiometry>;
  examsAudiometryByMedicalRecordForComparative: Array<TExamAudiometry>;
  examsByPerson: Array<TExamByPerson>;
  examsByRisk: Array<TExamByRisk>;
  examsByTag: Array<TExamByTag>;
  examsDiagnosticImageByMedicalRecord: Array<TExamDiagnosticImage>;
  examsExamItemsByMedicalRecord: Array<TExamItem>;
  examsForContract: TPaginatedExam;
  examsIbmpByMedicalRecord: Array<TResultExamIbmp>;
  examsIbmpByMedicalRecordForComparative: Array<TResultExamIbmpGroup>;
  examsItemByMedicalRecordForComparative: Array<TResultExamItemGroup>;
  examsNormalByMedicalRecord: Array<TExamNormal>;
  examsOrthoRaterByMedicalRecord: Array<TOrthoRater>;
  examsOrthoRaterByMedicalRecordForComparative: Array<TResultExamOrthoRaterForComparative>;
  examsOtologicalByMedicalRecord: Array<TExamOtological>;
  examsSnellenByMedicalRecord: Array<TSnellen>;
  examsSnellenByMedicalRecordForComparative: Array<TResultExamSnellenForComparative>;
  examsSpirometryByMedicalRecord: Array<TExamSpirometry>;
  examsSpirometryByMedicalRecordForComparative: Array<TResultExamSpirometryGroup>;
  examsToxicologicalByMedicalRecord: Array<TExamToxicological>;
  expectedGoal: TExpectedGoal;
  expense: TExpense;
  expenses: TPaginatedExpense;
  exportDashboard: TDashboardExport;
  exposureGroup: TExposureGroup;
  exposureGroupCostCenter: TExposureGroupCostCenter;
  exposureGroupCostCentersByCostCenter: Array<TExposureGroupCostCenter>;
  exposureGroupCostCentersByExposureGroup: Array<TExposureGroupCostCenter>;
  exposureGroupDepartment: TExposureGroupDepartment;
  exposureGroupDepartmentByDepartment: Array<TExposureGroupDepartment>;
  exposureGroupDepartmentByExposureGroup: Array<TExposureGroupDepartment>;
  exposureGroupOccupation: TExposureGroupOccupation;
  exposureGroupOccupationByExposureGroup: Array<TExposureGroupOccupation>;
  exposureGroupOccupationByOccupation: Array<TExposureGroupOccupation>;
  exposureGroupPerson: TExposureGroupPerson;
  exposureGroupPersonByExposureGroup: Array<TExposureGroupPerson>;
  exposureGroupPersonByPerson: Array<TExposureGroupPerson>;
  exposureGroupTask: TExposureGroupTask;
  exposureGroupTaskByExposureGroup: Array<TExposureGroupTask>;
  exposureGroupTaskByTask: Array<TExposureGroupTask>;
  exposureGroups: TPaginatedExposureGroup;
  extinguishingSystem: TExtinguishingSystem;
  extinguishingSystemDashboard: TExtinguishingSystemDashboard;
  extinguishingSystemSummary: TSummary;
  extinguishingSystems: TPaginatedExtinguishingSystem;
  featureAccess: TValidationReturn;
  filterPreference?: Maybe<TUserFilterPreferenceResult>;
  findAdUrl: Scalars['String']['output'];
  findAllApiAccess: Array<TApiAccess>;
  findAllIntegrationConfigurationByBranch: TIntegrationConfiguration;
  findAnyFeatureCollision: Array<TCollisionReturn>;
  findBlockedConfigsByIntegration: Array<Scalars['String']['output']>;
  findDoctorsWithAccredited: Array<TCategorizedInputData>;
  findEndpoints: Array<TEndpoint>;
  findExpectedExams: TPaginatedExpectedConsultations;
  findExpectedExamsByMedicalRecord: TExpectedConsultation;
  findFeaturesRelatedToFlag: Array<TFeatureReturn>;
  findFlagsRelatedToFeature: Array<TFlagReturn>;
  findFloatingFeatures: Array<TFeature>;
  findFloatingFlags: Array<TFlag>;
  findIntegrationCards: Array<TEndpoint>;
  findLastTerms: Array<TPolicyTerms>;
  findLogoutAdUrl: Scalars['String']['output'];
  findPolicyTermById: TPolicyTerms;
  findProductsByCA: Array<TProduct>;
  findProductsByEquipment: Array<TProduct>;
  findUserNeedAgree: Array<TPolicyTerms>;
  findWebhook: TWebhook;
  findWebhookQueue: TWebhookQueue;
  findWebhookQueues: TPaginatedWebhookQueue;
  findWebhooks: Array<TWebhook>;
  fireBrigade: TFireBrigade;
  fireBrigadeComponent: TFireBrigadeComponent;
  fireBrigadeComponentsByFireBrigade: Array<TFireBrigadeComponent>;
  fireBrigadeDashboard: TFireBrigadeDashboard;
  fireBrigadeExam: TFireBrigadeExam;
  fireBrigadeExamByFireBrigade: Array<TFireBrigadeExam>;
  fireBrigadeMeeting: TFireBrigadeMeeting;
  fireBrigadeMeetingByActive: Array<TFireBrigadeMeeting>;
  fireBrigadeMeetingByDate: Array<TFireBrigadeMeeting>;
  fireBrigadeMeetingBySubject: Array<TFireBrigadeMeeting>;
  fireBrigadeMeetings: Array<TFireBrigadeMeeting>;
  fireBrigadeMeetingsByFireBrigade: Array<TFireBrigadeMeeting>;
  fireBrigadeOccurrence: TFireBrigadeOccurrence;
  fireBrigadeOccurrences: Array<TFireBrigadeOccurrence>;
  fireBrigadeTraining: TFireBrigadeTraining;
  fireBrigadeTrainingsByFireBrigade: Array<TFireBrigadeTraining>;
  fireBrigades: TPaginatedFireBrigade;
  firstSteps: TFirstSteps;
  frequencyIndex: Array<TFrequencyIndex>;
  gAccidentCauses: TPaginatedGenericAccidentCause;
  gAccidentCodes: TPaginatedAccidentCode;
  gAccidentObjects: TPaginatedAccidentObject;
  gAccidentTypes: TPaginatedAccidentType;
  gActivePrinciples: TPaginatedGenericActivePrinciple;
  gActivitiesGroups: TPaginatedActivityGroup;
  gActivitiesIcds: TPaginatedActivityIcd;
  gBiologicalMonitoringExamGroups: TPaginatedGenericBiologicalMonitoringExamGroup;
  gBodiesParts: TPaginatedBodyPart;
  gCostCenters: TPaginatedGenericCostCenter;
  gEconomicActivities: TPaginatedEconomicActivity;
  gEvents: TPaginatedEvent;
  gExaminationProcedures: TPaginatedGenericExaminationProcedure;
  gExams: TPaginatedGenericExam;
  gExpenses: TPaginatedGenericExpense;
  gHealthPrograms: TPaginatedGenericHealthProgram;
  gIcdGroups: TPaginatedIcdGroups;
  gIcds: TPaginatedIcds;
  gInjuriesNatures: TPaginatedInjuryNature;
  gIpe: TIpe;
  gIpeManufacturer: TIpeManufacturer;
  gIpes: TPaginatedIpe;
  gIpesByCaCode: TPaginatedIpeManufacturer;
  gIpesManufacturerByCaCode: TPaginatedIpeManufacturer;
  gIpesManufacturerByCaCodeWithoutEquipment: TPaginatedIpeManufacturer;
  gIpesManufacturerByProduct: TPaginatedIpeManufacturer;
  gLaboratories: TPaginatedGenericLaboratory;
  gManufacturer: TManufacturer;
  gManufactureres: TPaginatedManufacturer;
  gMeasuringInstruments: TPaginatedGenericMeasuringInstrument;
  gMedicines: TPaginatedGenericMedicine;
  gOccupations: TPaginatedGenericOccupation;
  gPeriodicRanges: TPaginatedGenericPeriodicRange;
  gPublicPlaces: TPaginatedGenericPublicPlace;
  gQuestionsGroups: TPaginatedGenericQuestionGroup;
  gQuestionsQuizzes: TPaginatedGenericQuestionQuiz;
  gQuiz: TGenericQuiz;
  gQuizzes: TPaginatedGenericQuiz;
  gReportStructure: TGenericReportStructure;
  gReportStructures: TPaginatedGenericReportStructure;
  gResponsesOptions: TPaginatedGenericResponseOption;
  gRiskAgent: TGenericRiskAgent;
  gRiskAgents: TPaginatedGenericRiskAgent;
  gRolePermission: TGenericRolePermission;
  gRolePermissions: Array<TGenericRolePermission>;
  gStatements: TPaginatedGenericStatementResponsibility;
  gTasks: TPaginatedGenericTask;
  gTrainings: TPaginatedGenericTraining;
  gVaccines: TPaginatedGenericVaccine;
  gWorkShifts: TPaginatedGenericWorkShift;
  generateShortcut: TShortcutGenerated;
  generateShortcutsByTitles: Array<TShortcutGenerated>;
  generateWebhookToken: Scalars['String']['output'];
  generatingSource: TGeneratingSource;
  generatingSources: TPaginatedGeneratingSource;
  getDocument: Array<TSignBrokerGetDocument>;
  getDocuments: Array<TSignBrokerGetDocuments>;
  getDocumentsAndUpdateState: TPaginatedGetDocuments;
  getPatientName: TMedicalRecordName;
  getReportData: TPppReport;
  getRequiredIpes: Array<TIpe>;
  getSignCredentials?: Maybe<TSignCredentialsOutput>;
  getSignedThumbUrl: Scalars['String']['output'];
  getTablesToDownload: Array<TTableProperties>;
  getXMLRiskMessage: Scalars['Boolean']['output'];
  hasBlockedIntegrationConfigsByOrganization: Array<TIntegrationConfiguration>;
  hasInvite: TEmailHasInvite;
  hasRiskMapInBranch: Scalars['Boolean']['output'];
  headOffice: TBranchWithOrganization;
  healthProgram: THealthProgram;
  healthProgramTraining: THealthProgramTraining;
  healthProgramTrainingsByHealthProgram: Array<THealthProgramTraining>;
  healthPrograms: TPaginatedHealthProgram;
  healthQuizzes: THealthQuizzes;
  hermesGetAllFields: Array<TInternalFields>;
  hermesGetAllGenericMetadata: Array<TGenericMetadata>;
  hermesGetAllSaasMetadata: Array<TSaasFullMetadata>;
  hermesGetErpType: Array<TErpType>;
  importStatus: TImportStatus;
  indicators: Array<TIndicator>;
  integrationErrorSummary: TIntegrationErrorSummary;
  integrationErrors: TIntegrationErrorAll;
  integrationFlags: TIntegrationFlags;
  inventoryQueues: TPaginatedInventoryQueue;
  investigation: TInvestigation;
  investigationByCause: Array<TAccidentCauses>;
  investigationIndicators: TCauses;
  investigationSuggestion: TPaginatedInvestigationSuggestion;
  invite: TInvite;
  ipeDeliveries: Array<TIpeDelivery>;
  ipeDeliveriesByPerson: Array<TIpeDelivery>;
  ipeDeliveriesDashboard: TIpeDeliveryDashboard;
  ipeDelivery: TIpeDelivery;
  ipeDeliveryExtensionAuditReport: TIpeDeliveryExtensionAuditReport;
  ipeDeliveryExtensions: Array<TIpeDeliveryExtensionEntry>;
  ipeDeliveryExtensionsByPerson: Array<TIpeDeliveryExtensionTimeline>;
  ipesByRisk: Array<TIpeByRisk>;
  isAccredited: TIsAccreditedResult;
  isFirstIpeDelivery: Scalars['Boolean']['output'];
  isOwner: Scalars['Boolean']['output'];
  lackVoteByMandate: Array<TEmployeeVotes>;
  lastDeliveryByPerson: TIpeDelivery;
  mandate: TMandate;
  mandateAction: TMandateAction;
  mandateActions: Array<TMandateAction>;
  mandateCostCenter: TMandateCostCenter;
  mandateCostCenterByMandate: Array<TMandateCostCenter>;
  mandateDashboard: TMandateDashboard;
  mandateDepartment: TMandateDepartment;
  mandateDepartmentByMandate: Array<TMandateDepartment>;
  mandateDimension: TMandateDimension;
  mandateEvent: TMandateEvent;
  mandateEventByEvent: TMandateEvent;
  mandateEventByMandate: Array<TMandateEvent>;
  mandateEventByMessage: Array<TMandateEvent>;
  mandateEventByTypeToday: Array<TMandateEvent>;
  mandateEvents: Array<TMandateEvent>;
  mandateEventsToday: Array<TMandateEvent>;
  mandateLosses: Array<TMandateLoss>;
  mandateTraining: TMandateTraining;
  mandateTrainingByMandate: Array<TMandateTraining>;
  mandateTrainingByTraining: Array<TMandateTraining>;
  mandates: TPaginatedMandate;
  mandatesByAction: Array<TMandateAction>;
  mandatesByDescription: Array<TMandate>;
  measurementsByRisk: Array<TMeasurementByRisk>;
  measuringInstrument: TMeasuringInstrument;
  measuringInstruments: TPaginatedMeasuringInstrument;
  medicalCertificate: TMedicalCertificate;
  medicalCertificateByCrm: TExternalDoctor;
  medicalCertificateByDoctorName: TExternalDoctor;
  medicalCertificates: Array<TMedicalCertificate>;
  medicalCertificatesByIcd: Array<TMedicalCertificateByIcd>;
  /** Lista de Atestados Médicos de um Prontuário */
  medicalCertificatesByMedicalRecord: Array<TMedicalCertificate>;
  medicalHistory: THistoric;
  medicalRecord: TMedicalRecord;
  medicalRecordByUserId: TMedicalRecord;
  medicalRecordHealthProgram: TMedicalRecordHealthProgram;
  medicalRecordHealthProgramByMedicalRecord: Array<TMedicalRecordHealthProgram>;
  medicalRecordHealthPrograms: Array<TMedicalRecordHealthProgram>;
  medicalRecordSummary: TSummary;
  medicalRecordVaccinationPlanning: Array<TMedicalRecordVaccinationPlanning>;
  medicalRecordVaccine: TMedicalRecordVaccine;
  medicalRecordVaccines: Array<TMedicalRecordVaccine>;
  medicalRecordVaccinesByMedicalRecord: Array<TMedicalRecordVaccine>;
  /** Lista de Prontuários Médicos paginados */
  medicalRecords: TPaginatedMedicalRecords;
  medicalRecordsDashboard: TMedicalRecordDashboard;
  medicalReferral: TMedicalReferral;
  medicalReferralDoctorBiometry?: Maybe<TMedicalReferralDoctorBiometry>;
  medicalReferrals: Array<TMedicalReferral>;
  medicalReferralsByMedicalRecord: Array<TMedicalReferral>;
  medicalRestriction: TMedicalRestriction;
  medicalRestrictions: Array<TMedicalRestriction>;
  medicalRestrictionsByMedicalRecord: Array<TMedicalRestriction>;
  medicine: TMedicine;
  medicines: TPaginatedMedicine;
  meeting: TMeeting;
  meetingAction: TMeetingAction;
  meetingActionByDescription: Array<TMeetingAction>;
  meetingActionPendent: Array<TMeetingAction>;
  meetingActions: Array<TMeetingAction>;
  meetingByActive: Array<TMeeting>;
  meetingByDate: Array<TMeeting>;
  meetingBySubject: Array<TMeeting>;
  meetings: Array<TMeeting>;
  /** Lista todas as configurações de notificação da organização */
  notificationConfigs: Array<TNotificationConfigDto>;
  /** Retorna os destinatários padrão (por cargo) de um módulo de notificação */
  notificationModuleRecipients: TModuleDefaultRecipientsDto;
  /** Retorna usuários da filial atual para a lista de cargos informada */
  notificationUsersByRoles: Array<TDefaultRecipientUserDto>;
  occupation: TOccupation;
  occupationalHealthCertificate: TOccupationalHealthCertificate;
  occupationalHealthCertificates: Array<TOccupationalHealthCertificate>;
  occupationalHealthCertificatesByDate: Array<TOccupationalHealthCertificateByDate>;
  occupationalHealthCertificatesByMedicalRecord: Array<TOccupationalHealthCertificate>;
  occupationalHealthCertificatesByNature: Array<TOccupationalHealthCertificateTotal>;
  /** Search in all branches this Employees certificates */
  occupationalHealthCertificatesByRegistration: Array<TOccupationalHealthCertificate>;
  occupations: TPaginatedOccupation;
  occupationsFilterByBranch: Array<TOccupation>;
  oneSignalHello: Scalars['Boolean']['output'];
  oneSignalTest: Scalars['Boolean']['output'];
  organization: TOrganizationWithBranches;
  organizationCustomer: TCustomer;
  organizationLevelForecast: TLevelsForecast;
  organizationPayments: Array<TPayments>;
  orthoRater: TOrthoRater;
  orthoRaterByConsultation: TOrthoRater;
  people: TPaginatedPerson;
  peopleActives: Array<TPersonHistoryActivate>;
  peopleByOriginDeliveries: Array<TPerson>;
  peopleByRisk: Array<TPerson>;
  peopleNeedIpe: TPaginatedPersonNeedIpe;
  peopleOnBrowse: TPaginatedPeopleOnBrowse;
  peopleSuggestions: TPaginatedPerson;
  periodicRange: TPeriodicRange;
  periodicRanges: TPaginatedPeriodicRange;
  person: TPerson;
  personByIndividualRegistration: TPerson;
  personDoctor?: Maybe<TPerson>;
  personFilterIpeDeliveries: TPaginatedPersonIpeList;
  /** Treinamentos que esta pessoa precisa fazer, agregando as 4 origens (Risco/CIPA/Brigada/Programa de Saúde) com a última realização e status calculado. */
  personRequiredTrainings: Array<TPersonRequiredTraining>;
  personSummary: TSummary;
  personToIpeDelivery: TPerson;
  physicalEnvironment: TPhysicalEnvironment;
  physicalEnvironments: TPaginatedPhysicalEnvironment;
  position: TPosition;
  positions: TPaginatedPosition;
  preMedicalCertificate: TPreMedicalCertificate;
  preMedicalCertificateCountByStatus: TPreMedicalCertificateCountByStatus;
  preMedicalCertificates: TPaginatedPreMedicalCertificates;
  previewDocumentByCertificate: Array<TBaseDocumentResponse>;
  previewDocumentByEnvironmentalReport: Array<TEnvironmentalReportDocumentResponse>;
  previewDocumentByIpeDelivery: Array<TBaseDocumentResponse>;
  previewDocumentBySecurityWorkOrder: Array<TBaseDocumentResponse>;
  previewMedicalCertificateDocumentByCertificate: Array<TBaseDocumentResponse>;
  product: TProduct;
  productDelivery: TProductDelivery;
  productDeliveryByPerson: Array<TProductDelivery>;
  productDeliveryByProduct: Array<TProductDelivery>;
  productDeliverys: TPaginatedProductDelivery;
  productIpeManufacturer: TProductIpeManufacturer;
  productIpeManufacturers: Array<TProductIpeManufacturer>;
  products: TPaginatedProduct;
  productsWithoutCA: TPaginatedProduct;
  quantityLifesActive: Scalars['Float']['output'];
  queue: TESocialQueue;
  queues: TESocialQueueAll;
  queuesByOrganization: TESocialQueueAll;
  quiz: TQuiz;
  quizzes: TPaginatedQuiz;
  realGoal: TRealGoal;
  relativeIndex: Array<TRelativeIndex>;
  reportSection: TReportSection;
  reportStructure: TReportStructure;
  reportStructures: TPaginatedReportStructure;
  resendPendingEmail: TSignBrokerResponse;
  responsibleAction: TResponsibleAction;
  responsibleActionByPerson: Array<TResponsibleAction>;
  responsiblesAction: Array<TResponsibleAction>;
  resultExamIbmp: TResultExamIbmp;
  resultExamIbmpByConsultation?: Maybe<TResultExamIbmp>;
  risk: TRisk;
  riskAgent: TRiskAgent;
  riskAgents: TPaginatedRiskAgent;
  riskComposition: TRiskComposition;
  riskCompositions: Array<TRiskComposition>;
  riskCompositionsByEnvironment: Array<TRiskComposition>;
  riskCount: TRiskCount;
  riskSuggestion: TPaginatedRiskSuggestion;
  riskSummary: TSummary;
  risks: TPaginatedRisk;
  risksByEnvironment: Array<TRisk>;
  risksByExposeByPerson: Array<TRisk>;
  risksDashboard: TRiskDashboard;
  risksForIntegration: Array<TRisk>;
  rolePermission: TRolePermission;
  rolePermissions: TPaginatedRolePermission;
  routes: Array<TRoutes>;
  safetyQuiz: TSafetyQuiz;
  safetyQuizDashboard: TSafetyQuizDashboard;
  safetyQuizzes: Array<TSafetyQuiz>;
  scheduleRestriction: TScheduleRestriction;
  scheduleRestrictions: TPaginatedScheduleRestriction;
  scheduleRestrictionsByDate: Array<TScheduleRestriction>;
  scheduleRestrictionsByDoctor: TPaginatedScheduleRestriction;
  /** Configurações de agenda da filial atual (duração padrão da consulta) */
  schedulingSettings: TSchedulingSettings;
  semanticInconsistencies: TPaginatedTtalkInboundSemanticInconsistency;
  sendToSoc: Scalars['String']['output'];
  sessions: Array<TSession>;
  severityIndex: Array<TSeverityIndex>;
  silenceMonitors: Array<TTtalkInboundSilenceMonitor>;
  silenceThresholds: Array<TTtalkInboundSilenceThreshold>;
  simulation: TSimulation;
  simulationPlan: TSimulationPlan;
  simulationPlans: Array<TSimulationPlan>;
  simulations: Array<TSimulation>;
  sipat: TSipat;
  sipatByDate: Array<TSipat>;
  sipatByDescription: Array<TSipat>;
  sipatEvent: TSipatEvent;
  sipatEventByDate: Array<TSipatEvent>;
  sipatEventByDescription: Array<TSipatEvent>;
  sipatEventByPerson: Array<TSipatEvent>;
  sipats: Array<TSipat>;
  snellen: TSnellen;
  snellenByConsultation?: Maybe<TSnellen>;
  socAttachment: TPaginatedAttachment;
  socQueue: TPaginatedQueue;
  socSync: TPaginatedSync;
  sparePart: TSpareParts;
  spareParts: TPaginatedSpareParts;
  sparePartsByProduct: Array<TSpareParts>;
  stabilityType: TStabilityType;
  stabilityTypes: TPaginatedStabilityType;
  statementResponsibility: TStatementResponsibility;
  statementsResponsibility: TPaginatedStatementResponsibility;
  stockLevel: TStockLevel;
  stockLevels: Array<TStockLevel>;
  stockLevelsByProduct: Array<TStockLevel>;
  stockLevelsByWarehouse: Array<TStockLevel>;
  stockLevelsLotNumbers: Array<Scalars['String']['output']>;
  stockMovement: TStockMovement;
  stockMovements: Array<TStockMovement>;
  stockMovementsByProduct: Array<TStockMovement>;
  suggestion: TSuggestionBox;
  suggestionAmount: Array<TSuggestionAmount>;
  suggestionBoxByDescription: Array<TSuggestionBox>;
  suggestionBoxByPriority: Array<TSuggestionBox>;
  suggestionBoxByStatus: Array<TSuggestionBox>;
  suggestionBoxListReport: Array<TSuggestionBoxListReport>;
  suggestions: Array<TSuggestionBox>;
  task: TTask;
  taskByName?: Maybe<TTask>;
  tasks: TPaginatedTask;
  tasksFilterByBranch: Array<TTask>;
  terms: TTerms;
  training: TTraining;
  /** Funcionários ativos que precisam do treinamento, agregando as 4 origens (Risco/CIPA/Brigada/Programa de Saúde) com a última realização e status calculado. */
  trainingEligiblePersons: TTrainingEligiblePersonsResult;
  trainingHistory: TPaginatedTrainingHistory;
  trainings: TPaginatedTraining;
  trainingsByRisk: Array<TTrainingByRisk>;
  ttalkInFlightSources: Array<Scalars['ID']['output']>;
  ttalkInboundDlqEvents: TPaginatedTtalkInboundEvent;
  ttalkInboundEvents: TPaginatedTtalkInboundEvent;
  ttalkOutboundSummary: TTTalkQueueSummary;
  ttalkQueueByEntity: Array<TTTalkQueue>;
  ttalkQueues: TTTalkQueueAll;
  unitiesOfMeasure: TPaginatedUnityMeasure;
  unityOfMeasure: TUnityOfMeasure;
  urinalysis: TUrinalysis;
  urinalysisByConsultation?: Maybe<TUrinalysis>;
  urinalysisByMedicalRecord: Array<TUrinalysis>;
  urinalysisByMedicalRecordForComparative: Array<TResultUrinalysisGroup>;
  user: TUserBasicInfo;
  userRoutes: TUserRoutes;
  userSpecialties: Array<TUserSpecialty>;
  users: Array<TUserOrganizationListing>;
  vaccine: TVaccine;
  vaccines: TPaginatedVaccine;
  victimSuggestions: TPaginatedPerson;
  voteByMandate: Array<TEmployeeVotes>;
  voteProgress: Array<TVotationProgress>;
  voteSummary: TVoteStatus;
  warehouse: TWarehouse;
  warehouses: TPaginatedWarehouse;
  warehousesByProduct: Array<TWarehouse>;
  workHoursByDoctor: TWorkHours;
  workPermission: TWorkPermission;
  workPermissionDashboard: TWorkPermissionDashboard;
  workPermissionQuiz: TWorkPermissionQuiz;
  workPermissions: TPaginatedWorkPermission;
  workShift: TWorkShift;
  workShifts: TPaginatedWorkShift;
};


export type TQueryAllowanceTypeArgs = {
  id: Scalars['String']['input'];
};


export type TQueryMeetingParticipantArgs = {
  id: Scalars['String']['input'];
};


export type TQueryMeetingParticipantPresentArgs = {
  id: Scalars['String']['input'];
};


export type TQueryMeetingParticipantsArgs = {
  meetingId: Scalars['String']['input'];
};


export type TQuery_GetCsvArgs = {
  entity?: InputMaybe<Scalars['String']['input']>;
};


export type TQueryAbsenceTypeArgs = {
  id: Scalars['String']['input'];
};


export type TQueryAbsenceTypesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationAbsenceQueryInput;
};


export type TQueryAccidentArgs = {
  id: Scalars['String']['input'];
};


export type TQueryAccidentAbsenceArgs = {
  dateEnd: Scalars['DateTime']['input'];
  dateStart: Scalars['DateTime']['input'];
};


export type TQueryAccidentAmountArgs = {
  dateEnd: Scalars['DateTime']['input'];
  dateStart: Scalars['DateTime']['input'];
};


export type TQueryAccidentBySummaryArgs = {
  summary: Scalars['String']['input'];
};


export type TQueryAccidentCauseArgs = {
  id: Scalars['String']['input'];
};


export type TQueryAccidentCausesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryAccidentExpenseAmountArgs = {
  dateEnd: Scalars['DateTime']['input'];
  dateStart: Scalars['DateTime']['input'];
};


export type TQueryAccidentSummaryArgs = {
  getCounter: Scalars['Boolean']['input'];
  query: TAccidentQueryInput;
};


export type TQueryAccidentsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<TAccidentOrderByInput>;
  pagination?: InputMaybe<TPagination>;
  query: TAccidentQueryInput;
};


export type TQueryAccidentsDashboardArgs = {
  filter: TAccidentFilter;
  identifier: Scalars['String']['input'];
};


export type TQueryAccidentsWithInvestigationArgs = {
  mandateId: Scalars['String']['input'];
};


export type TQueryAccidentsWithoutInvestigationArgs = {
  mandateId: Scalars['String']['input'];
};


export type TQueryAccreditedArgs = {
  id: Scalars['String']['input'];
};


export type TQueryAccreditedByNameArgs = {
  name: Scalars['String']['input'];
};


export type TQueryAccreditedUnscheduledConsultationsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryActionPlanArgs = {
  id: Scalars['String']['input'];
};


export type TQueryActionPlanDashboardArgs = {
  identifier?: InputMaybe<Scalars['String']['input']>;
};


export type TQueryActionPlanInvestigationsByPlanArgs = {
  actionPlanId: Scalars['String']['input'];
};


export type TQueryActionPlanMicroActionsByPlanArgs = {
  actionPlanId: Scalars['String']['input'];
};


export type TQueryActionPlanReportsByPlanArgs = {
  actionPlanId: Scalars['String']['input'];
};


export type TQueryActionPlanRisksByPlanArgs = {
  actionPlanId: Scalars['String']['input'];
};


export type TQueryActionPlanSummaryArgs = {
  getCounter: Scalars['Boolean']['input'];
  query: TActionPlanQueryInput;
};


export type TQueryActionPlansArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<TActionPlanOrderByInput>;
  pagination?: InputMaybe<TPagination>;
  query: TActionPlanQueryInput;
};


export type TQueryActionPlansBySituationArgs = {
  situation: TSituation;
};


export type TQueryAllAccreditedArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryAllExposureGroupByPersonArgs = {
  person: TPersonForExposure;
};


export type TQueryAllowanceTypesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryAsoEvolutionByMedicalRecordArgs = {
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryAuditLogArgs = {
  id: Scalars['String']['input'];
};


export type TQueryAuditLogsArgs = {
  pagination?: InputMaybe<TPagination>;
  query: TAuditLogQueryInput;
};


export type TQueryBiologicalMonitoringArgs = {
  id: Scalars['String']['input'];
};


export type TQueryBiologicalMonitoringByMedicalRecordArgs = {
  personId: Scalars['String']['input'];
};


export type TQueryBiologicalMonitoringExamGroupArgs = {
  id: Scalars['String']['input'];
};


export type TQueryBiologicalMonitoringExamGroupsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryBiometriesArgs = {
  checkId: Scalars['String']['input'];
  type?: InputMaybe<TBiometryCheck>;
};


export type TQueryBiometryArgs = {
  id: Scalars['String']['input'];
};


export type TQueryBranchHasTtalkEndpointArgs = {
  branchId: Scalars['ID']['input'];
};


export type TQueryBranchIsBlockedToIntegrationArgs = {
  branchId: Scalars['String']['input'];
  integration: TMetadataType;
};


export type TQueryBranchesByOrganizationArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryBranchesWithoutInventoryByOrganizationArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryBulkSyncRunArgs = {
  runId: Scalars['ID']['input'];
};


export type TQueryCalendarArgs = {
  id: Scalars['String']['input'];
};


export type TQueryCalendarsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryCandidateArgs = {
  id: Scalars['String']['input'];
};


export type TQueryCandidateByMandateArgs = {
  mandateId: Scalars['String']['input'];
};


export type TQueryCandidateByNameArgs = {
  name: Scalars['String']['input'];
};


export type TQueryCertificatesRankingDashboardArgs = {
  filter: TMedicalRecordFilter;
  fromDate: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
};


export type TQueryCheckTotvsWebHookConfigArgs = {
  input: TSignCredentialsInput;
};


export type TQueryClinicalQuizArgs = {
  id: Scalars['String']['input'];
};


export type TQueryClinicalQuizzesArgs = {
  medicalRecord: Scalars['String']['input'];
};


export type TQueryComparativeResultsDashboardArgs = {
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryComponentArgs = {
  id: Scalars['String']['input'];
};


export type TQueryComponentsArgs = {
  mandateId: Scalars['String']['input'];
};


export type TQueryConsultationArgs = {
  id: Scalars['String']['input'];
};


export type TQueryConsultationByCrmArgs = {
  doctorCrm?: InputMaybe<Scalars['String']['input']>;
};


export type TQueryConsultationByDoctorNameArgs = {
  doctorName?: InputMaybe<Scalars['String']['input']>;
};


export type TQueryConsultationByOccupationalHealthCertificateArgs = {
  id: Scalars['String']['input'];
};


export type TQueryConsultationByOriginPersonArgs = {
  monitoringExamGroupId: Scalars['String']['input'];
  originPersonId: Scalars['String']['input'];
};


export type TQueryConsultationReasonsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type TQueryConsultationReleasableResultsArgs = {
  consultationId: Scalars['String']['input'];
};


export type TQueryConsultationsByDateArgs = {
  allBranches?: InputMaybe<Scalars['Boolean']['input']>;
  branchIds?: InputMaybe<Array<Scalars['String']['input']>>;
  doctorId: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  responsibleUserId?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
};


export type TQueryConsultationsByDoctorArgs = {
  allBranches?: InputMaybe<Scalars['Boolean']['input']>;
  branchIds?: InputMaybe<Array<Scalars['String']['input']>>;
  doctorId: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  responsibleUserId?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
};


export type TQueryConsultationsByMedicalRecordArgs = {
  medicalRecord: Scalars['String']['input'];
};


export type TQueryConsultationsForTransferArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type TQueryControlMeasureArgs = {
  id: Scalars['String']['input'];
};


export type TQueryControlMeasuresArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryControlsByRiskArgs = {
  riskId: Scalars['String']['input'];
};


export type TQueryCostCenterArgs = {
  id: Scalars['String']['input'];
};


export type TQueryCostCentersArgs = {
  branchId?: InputMaybe<Scalars['String']['input']>;
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryCostCentersFilterByBranchArgs = {
  branchId: Scalars['String']['input'];
  costCenters: Array<Scalars['String']['input']>;
};


export type TQueryCrontabExecutionDetailsArgs = {
  action?: InputMaybe<TCrontabExecutionAction>;
  executionId: Scalars['String']['input'];
  pagination?: InputMaybe<TPagination>;
  query?: InputMaybe<TPaginationDefaultQueryInput>;
};


export type TQueryCrontabExecutionsArgs = {
  crontabId: Scalars['String']['input'];
  pagination?: InputMaybe<TPagination>;
  query?: InputMaybe<TPaginationDefaultQueryInput>;
  startedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  startedTo?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<TCrontabExecutionStatus>>;
};


export type TQueryCustomDocumentVariantsArgs = {
  type: TDocumentType;
};


export type TQueryCustomTypeArgs = {
  type: TCustomType;
};


export type TQueryDeficienciesByMedicalRecordArgs = {
  medicalRecord: Scalars['String']['input'];
};


export type TQueryDeficiencisByRegistrationArgs = {
  erpId: Scalars['String']['input'];
  individualRegistration: Scalars['String']['input'];
};


export type TQueryDeficiencyArgs = {
  id: Scalars['String']['input'];
};


export type TQueryDeliverySparePartsArgs = {
  id: Scalars['String']['input'];
};


export type TQueryDeliverySparePartsByIpeArgs = {
  ca: Scalars['String']['input'];
  personId: Scalars['String']['input'];
};


export type TQueryDeliverySparePartsByIpeDeliveryArgs = {
  ipeDeliveryId: Scalars['String']['input'];
};


export type TQueryDeliverySparePartsByPersonArgs = {
  personId: Scalars['String']['input'];
};


export type TQueryDeliverySparePartsByProductArgs = {
  productId: Scalars['String']['input'];
};


export type TQueryDepartmentArgs = {
  id: Scalars['String']['input'];
};


export type TQueryDepartmentsArgs = {
  branchId?: InputMaybe<Scalars['String']['input']>;
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryDepartmentsFilterByBranchArgs = {
  branchId: Scalars['String']['input'];
  departments: Array<Scalars['String']['input']>;
};


export type TQueryDiagnosticArgs = {
  id: Scalars['String']['input'];
};


export type TQueryDiagnosticByConsultationArgs = {
  consultationId: Scalars['String']['input'];
};


export type TQueryDoctorSuggestionsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationPersonQueryInput;
};


export type TQueryDownloadSignedDocumentsArgs = {
  input: TDownloadSignedDocumentInput;
};


export type TQueryESocialIndicatorsArgs = {
  branchId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TESocialQueueFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TQueryEconomicActivityArgs = {
  id: Scalars['String']['input'];
};


export type TQueryEffectiveDocumentTemplateArgs = {
  subType?: InputMaybe<TCustomDocumentSubType>;
  type: TDocumentType;
};


export type TQueryElaboratorDocumentArgs = {
  personId: Scalars['String']['input'];
  roleType: Array<Scalars['String']['input']>;
};


export type TQueryElectionComissionArgs = {
  id: Scalars['String']['input'];
};


export type TQueryElectionComissionByMandateArgs = {
  mandate: Scalars['String']['input'];
};


export type TQueryElectionComissionByPersonArgs = {
  person: Scalars['String']['input'];
};


export type TQueryEmployeeAnamnesisQuizArgs = {
  consultationId: Scalars['String']['input'];
};


export type TQueryEmployeeConsultationResultsArgs = {
  consultationId: Scalars['String']['input'];
};


export type TQueryEmployeeHasCandidateArgs = {
  mandate: TEmployeeByMandateIdInput;
};


export type TQueryEmployeeHasVoteArgs = {
  mandate: TEmployeeByMandateIdInput;
};


export type TQueryEmployeeIpeDeliveriesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationPersonQueryInput;
};


export type TQueryEmployeeLoginArgs = {
  generate: TBaseInput;
};


export type TQueryEmployeeMandatesArgs = {
  eventType: TEmployeeByEventTypeInput;
};


export type TQueryEmployeeQuizArgs = {
  quizId: Scalars['String']['input'];
};


export type TQueryEmployeeRisksDashboardArgs = {
  filter: TRiskFilter;
  identifier: Scalars['String']['input'];
};


export type TQueryEmployeeTaskArgs = {
  id: Scalars['String']['input'];
};


export type TQueryEndElectionPeriodArgs = {
  mandateId: Scalars['String']['input'];
};


export type TQueryEnvReportSuggestionsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryEnvironmentalReportArgs = {
  id: Scalars['String']['input'];
};


export type TQueryEnvironmentalReportBiometryArgs = {
  environmentalReportId: Scalars['String']['input'];
};


export type TQueryEnvironmentalReportFaceArgs = {
  environmentalReportId: Scalars['String']['input'];
};


export type TQueryEnvironmentalReportSummaryArgs = {
  getCounter: Scalars['Boolean']['input'];
  query: TEnvironmentalReportQueryInput;
};


export type TQueryEnvironmentalReportVersionDownloadUrlArgs = {
  id: Scalars['String']['input'];
};


export type TQueryEnvironmentalReportVersionsArgs = {
  environmentalReportId: Scalars['String']['input'];
};


export type TQueryEnvironmentalReportsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<TEnvironmentalReportOrderByInput>;
  pagination?: InputMaybe<TPagination>;
  query: TEnvironmentalReportQueryInput;
};


export type TQueryEquipmentByCostCenterArgs = {
  id: Scalars['String']['input'];
};


export type TQueryEquipmentByCostCenterByCostCenterArgs = {
  costCenter: Scalars['String']['input'];
};


export type TQueryEquipmentByOccupationArgs = {
  id: Scalars['String']['input'];
};


export type TQueryEquipmentByOccupationByOccupationArgs = {
  occupation: Scalars['String']['input'];
};


export type TQueryExamArgs = {
  id: Scalars['String']['input'];
};


export type TQueryExamAlterationTrendByMedicalRecordArgs = {
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryExamAudiometryByConsultationArgs = {
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  consultationId: Scalars['String']['input'];
};


export type TQueryExamDiagnosticCountByMedicalRecordArgs = {
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryExamDiagnosticImageArgs = {
  id: Scalars['String']['input'];
};


export type TQueryExamDiagnosticImageByConsultationArgs = {
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  consultationId: Scalars['String']['input'];
};


export type TQueryExamItemByConsultationArgs = {
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  consultationId: Scalars['String']['input'];
};


export type TQueryExamNormalByConsultationArgs = {
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  consultationId: Scalars['String']['input'];
};


export type TQueryExamNormalResultsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type TQueryExamOtologicalArgs = {
  id: Scalars['String']['input'];
};


export type TQueryExamOtologicalByConsultationArgs = {
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  consultationId: Scalars['String']['input'];
};


export type TQueryExamResultsByMedicalRecordArgs = {
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryExamSpirometryByConsultationArgs = {
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  consultationId: Scalars['String']['input'];
};


export type TQueryExamTimelineByMedicalRecordArgs = {
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryExamToxicologicalByConsultationArgs = {
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  consultationId: Scalars['String']['input'];
};


export type TQueryExamsArgs = {
  accreditedId?: InputMaybe<Scalars['String']['input']>;
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
  type?: InputMaybe<TResultTypeEnum>;
};


export type TQueryExamsAudiometryByMedicalRecordArgs = {
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryExamsAudiometryByMedicalRecordForComparativeArgs = {
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryExamsByPersonArgs = {
  personId: Scalars['String']['input'];
};


export type TQueryExamsByRiskArgs = {
  riskId: Scalars['String']['input'];
};


export type TQueryExamsByTagArgs = {
  accreditedId?: InputMaybe<Scalars['String']['input']>;
  costCenterId?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  estimatedDate: Scalars['DateTime']['input'];
  medicalRecordId?: InputMaybe<Scalars['String']['input']>;
  occupationId?: InputMaybe<Scalars['String']['input']>;
  tag: TExamTag;
  taskId?: InputMaybe<Scalars['String']['input']>;
  type: TConsultationType;
};


export type TQueryExamsDiagnosticImageByMedicalRecordArgs = {
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryExamsExamItemsByMedicalRecordArgs = {
  examId: Scalars['String']['input'];
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryExamsForContractArgs = {
  contractorId?: InputMaybe<Scalars['String']['input']>;
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryExamsIbmpByMedicalRecordArgs = {
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryExamsIbmpByMedicalRecordForComparativeArgs = {
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryExamsItemByMedicalRecordForComparativeArgs = {
  examId: Scalars['String']['input'];
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryExamsNormalByMedicalRecordArgs = {
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryExamsOrthoRaterByMedicalRecordArgs = {
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryExamsOrthoRaterByMedicalRecordForComparativeArgs = {
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryExamsOtologicalByMedicalRecordArgs = {
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryExamsSnellenByMedicalRecordArgs = {
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryExamsSnellenByMedicalRecordForComparativeArgs = {
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryExamsSpirometryByMedicalRecordArgs = {
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryExamsSpirometryByMedicalRecordForComparativeArgs = {
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryExamsToxicologicalByMedicalRecordArgs = {
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryExpectedGoalArgs = {
  id: Scalars['String']['input'];
};


export type TQueryExpenseArgs = {
  id: Scalars['String']['input'];
};


export type TQueryExpensesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryExposureGroupArgs = {
  id: Scalars['String']['input'];
};


export type TQueryExposureGroupCostCenterArgs = {
  id: Scalars['String']['input'];
};


export type TQueryExposureGroupCostCentersByCostCenterArgs = {
  costCenterId: Scalars['String']['input'];
};


export type TQueryExposureGroupCostCentersByExposureGroupArgs = {
  exposureGroupId: Scalars['String']['input'];
};


export type TQueryExposureGroupDepartmentArgs = {
  id: Scalars['String']['input'];
};


export type TQueryExposureGroupDepartmentByDepartmentArgs = {
  departmentId: Scalars['String']['input'];
};


export type TQueryExposureGroupDepartmentByExposureGroupArgs = {
  exposureGroupId: Scalars['String']['input'];
};


export type TQueryExposureGroupOccupationArgs = {
  id: Scalars['String']['input'];
};


export type TQueryExposureGroupOccupationByExposureGroupArgs = {
  exposureGroupId: Scalars['String']['input'];
};


export type TQueryExposureGroupOccupationByOccupationArgs = {
  occupationId: Scalars['String']['input'];
};


export type TQueryExposureGroupPersonArgs = {
  id: Scalars['String']['input'];
};


export type TQueryExposureGroupPersonByExposureGroupArgs = {
  exposureGroupId: Scalars['String']['input'];
};


export type TQueryExposureGroupPersonByPersonArgs = {
  personId: Scalars['String']['input'];
};


export type TQueryExposureGroupTaskArgs = {
  id: Scalars['String']['input'];
};


export type TQueryExposureGroupTaskByExposureGroupArgs = {
  exposureGroupId: Scalars['String']['input'];
};


export type TQueryExposureGroupTaskByTaskArgs = {
  taskId: Scalars['String']['input'];
};


export type TQueryExposureGroupsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryExtinguishingSystemArgs = {
  id: Scalars['String']['input'];
};


export type TQueryExtinguishingSystemDashboardArgs = {
  filter?: InputMaybe<TExtinguishingSystemFilter>;
  identifier?: InputMaybe<Scalars['String']['input']>;
};


export type TQueryExtinguishingSystemSummaryArgs = {
  getCounter: Scalars['Boolean']['input'];
  query: TExtinguishingSystemQueryInput;
};


export type TQueryExtinguishingSystemsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<TExtinguishingSystemOrderByInput>;
  pagination?: InputMaybe<TPagination>;
  query: TExtinguishingSystemQueryInput;
};


export type TQueryFeatureAccessArgs = {
  feature: TFeature;
};


export type TQueryFilterPreferenceArgs = {
  module: Scalars['String']['input'];
};


export type TQueryFindAdUrlArgs = {
  accessBy?: InputMaybe<TAccessBy>;
  email: Scalars['String']['input'];
  isPortal?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TQueryFindAllIntegrationConfigurationByBranchArgs = {
  branchId: Scalars['String']['input'];
};


export type TQueryFindBlockedConfigsByIntegrationArgs = {
  integration: TMetadataType;
};


export type TQueryFindDoctorsWithAccreditedArgs = {
  allBranches?: InputMaybe<Scalars['Boolean']['input']>;
  branchIds?: InputMaybe<Array<Scalars['String']['input']>>;
  getNurses?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TQueryFindEndpointsArgs = {
  input: TFindEndpointsInput;
};


export type TQueryFindExpectedExamsArgs = {
  allBranches?: InputMaybe<Scalars['Boolean']['input']>;
  branchIds?: InputMaybe<Array<Scalars['String']['input']>>;
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryFindExpectedExamsByMedicalRecordArgs = {
  consultationType: TConsultationType;
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryFindFeaturesRelatedToFlagArgs = {
  flag: TFlag;
};


export type TQueryFindFlagsRelatedToFeatureArgs = {
  feature: TFeature;
};


export type TQueryFindIntegrationCardsArgs = {
  integrationContext: TIntegrationContext;
  organizationId: Scalars['String']['input'];
  type: TErpType;
};


export type TQueryFindLogoutAdUrlArgs = {
  isPortal?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TQueryFindPolicyTermByIdArgs = {
  id: Scalars['String']['input'];
};


export type TQueryFindProductsByCaArgs = {
  ipeManufacturerId: Scalars['String']['input'];
};


export type TQueryFindProductsByEquipmentArgs = {
  caCode?: InputMaybe<Scalars['String']['input']>;
  equipmentName: Scalars['String']['input'];
};


export type TQueryFindWebhookArgs = {
  id: Scalars['String']['input'];
};


export type TQueryFindWebhookQueueArgs = {
  id: Scalars['String']['input'];
};


export type TQueryFindWebhookQueuesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryFireBrigadeArgs = {
  id: Scalars['String']['input'];
};


export type TQueryFireBrigadeComponentArgs = {
  id: Scalars['String']['input'];
};


export type TQueryFireBrigadeComponentsByFireBrigadeArgs = {
  fireBrigade: Scalars['String']['input'];
};


export type TQueryFireBrigadeDashboardArgs = {
  identifier?: InputMaybe<Scalars['String']['input']>;
};


export type TQueryFireBrigadeExamArgs = {
  id: Scalars['String']['input'];
};


export type TQueryFireBrigadeExamByFireBrigadeArgs = {
  fireBrigade: Scalars['String']['input'];
};


export type TQueryFireBrigadeMeetingArgs = {
  id: Scalars['String']['input'];
};


export type TQueryFireBrigadeMeetingByActiveArgs = {
  fireBrigadeId: Scalars['String']['input'];
};


export type TQueryFireBrigadeMeetingByDateArgs = {
  date: Scalars['DateTime']['input'];
  fireBrigadeId: Scalars['String']['input'];
};


export type TQueryFireBrigadeMeetingBySubjectArgs = {
  fireBrigadeId: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};


export type TQueryFireBrigadeMeetingsArgs = {
  fireBrigadeId: Scalars['String']['input'];
};


export type TQueryFireBrigadeMeetingsByFireBrigadeArgs = {
  fireBrigade: Scalars['String']['input'];
};


export type TQueryFireBrigadeOccurrenceArgs = {
  id: Scalars['String']['input'];
};


export type TQueryFireBrigadeOccurrencesArgs = {
  fireBrigadeId: Scalars['String']['input'];
};


export type TQueryFireBrigadeTrainingArgs = {
  id: Scalars['String']['input'];
};


export type TQueryFireBrigadeTrainingsByFireBrigadeArgs = {
  fireBrigade: Scalars['String']['input'];
};


export type TQueryFireBrigadesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGAccidentCausesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGAccidentCodesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGAccidentObjectsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGAccidentTypesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
  type: TAccidentTypeEnum;
};


export type TQueryGActivePrinciplesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGActivitiesGroupsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGActivitiesIcdsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGBiologicalMonitoringExamGroupsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGBodiesPartsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGCostCentersArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGEconomicActivitiesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGEventsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGExaminationProceduresArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGExamsArgs = {
  accreditedId?: InputMaybe<Scalars['String']['input']>;
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
  type?: InputMaybe<TResultTypeEnum>;
};


export type TQueryGExpensesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGHealthProgramsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGIcdGroupsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGIcdsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGInjuriesNaturesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGIpeArgs = {
  id: Scalars['String']['input'];
};


export type TQueryGIpeManufacturerArgs = {
  caCode: Scalars['String']['input'];
};


export type TQueryGIpesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGIpesByCaCodeArgs = {
  caCode?: InputMaybe<Scalars['String']['input']>;
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGIpesManufacturerByCaCodeArgs = {
  equipmentName?: InputMaybe<Scalars['String']['input']>;
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGIpesManufacturerByCaCodeWithoutEquipmentArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGIpesManufacturerByProductArgs = {
  equipmentName: Scalars['String']['input'];
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  productId: Scalars['String']['input'];
  query: TPaginationDefaultQueryInput;
};


export type TQueryGLaboratoriesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGManufacturerArgs = {
  cnpj: Scalars['String']['input'];
};


export type TQueryGManufactureresArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGMeasuringInstrumentsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGMedicinesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGOccupationsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGPeriodicRangesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGPublicPlacesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGQuestionsGroupsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGQuestionsQuizzesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGQuizArgs = {
  id: Scalars['String']['input'];
};


export type TQueryGQuizzesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGReportStructureArgs = {
  id: Scalars['String']['input'];
};


export type TQueryGReportStructuresArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
  type?: InputMaybe<TReportType>;
};


export type TQueryGResponsesOptionsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGRiskAgentArgs = {
  id: Scalars['String']['input'];
};


export type TQueryGRiskAgentsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<TAgentGroup>;
  omitCreated?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGRolePermissionArgs = {
  description: Scalars['String']['input'];
};


export type TQueryGRolePermissionsArgs = {
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type TQueryGStatementsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGTasksArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGTrainingsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGVaccinesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGWorkShiftsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGenerateShortcutArgs = {
  reportParams: TEnvironmentalReportParams;
  shortcut: TShortcut;
};


export type TQueryGenerateShortcutsByTitlesArgs = {
  reportParams: TEnvironmentalReportParams;
  shortcutTitles: Array<Scalars['String']['input']>;
};


export type TQueryGeneratingSourceArgs = {
  id: Scalars['String']['input'];
};


export type TQueryGeneratingSourcesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryGetDocumentArgs = {
  documentId: Scalars['Float']['input'];
};


export type TQueryGetDocumentsArgs = {
  input: TGetDocumentsInput;
};


export type TQueryGetDocumentsAndUpdateStateArgs = {
  documentId?: InputMaybe<Scalars['Float']['input']>;
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<TGetDocumentsOrderByInput>;
  pagination?: InputMaybe<TPagination>;
  query: TGetDocumentsQueryInput;
};


export type TQueryGetPatientNameArgs = {
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryGetReportDataArgs = {
  id: Scalars['String']['input'];
  params: TPppParameters;
};


export type TQueryGetRequiredIpesArgs = {
  origin: Scalars['String']['input'];
  originId: Scalars['String']['input'];
};


export type TQueryGetSignedThumbUrlArgs = {
  url: Scalars['String']['input'];
};


export type TQueryGetXmlRiskMessageArgs = {
  params: TESocialParams;
};


export type TQueryHasInviteArgs = {
  email: Scalars['String']['input'];
};


export type TQueryHealthProgramArgs = {
  id: Scalars['String']['input'];
};


export type TQueryHealthProgramTrainingArgs = {
  id: Scalars['String']['input'];
};


export type TQueryHealthProgramTrainingsByHealthProgramArgs = {
  healthProgram: Scalars['String']['input'];
};


export type TQueryHealthProgramsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryHermesGetAllFieldsArgs = {
  input: TGetFields;
};


export type TQueryHermesGetAllGenericMetadataArgs = {
  integrationContext?: InputMaybe<TIntegrationContext>;
};


export type TQueryHermesGetAllSaasMetadataArgs = {
  input: TGetAllSaasMetadataInput;
};


export type TQueryHermesGetErpTypeArgs = {
  metadata: TMetadataType;
};


export type TQueryImportStatusArgs = {
  importId: Scalars['String']['input'];
};


export type TQueryIntegrationErrorSummaryArgs = {
  branchId?: InputMaybe<Scalars['String']['input']>;
  businessEntity: TBusinessEntity;
};


export type TQueryIntegrationErrorsArgs = {
  branchId?: InputMaybe<Scalars['String']['input']>;
  errorType?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<TIntegrationType>;
  pagination?: InputMaybe<TPagination>;
};


export type TQueryInventoryQueuesArgs = {
  branchId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<TPagination>;
  query?: InputMaybe<TPaginationDefaultQueryInput>;
};


export type TQueryInvestigationArgs = {
  id: Scalars['String']['input'];
};


export type TQueryInvestigationSuggestionArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryInviteArgs = {
  token: Scalars['String']['input'];
};


export type TQueryIpeDeliveriesByPersonArgs = {
  personId: Scalars['String']['input'];
};


export type TQueryIpeDeliveriesDashboardArgs = {
  filter?: InputMaybe<TPersonFilter>;
  identifier: Scalars['String']['input'];
  onlyActive: Scalars['Boolean']['input'];
};


export type TQueryIpeDeliveryArgs = {
  id: Scalars['String']['input'];
};


export type TQueryIpeDeliveryExtensionAuditReportArgs = {
  personId?: InputMaybe<Scalars['String']['input']>;
};


export type TQueryIpeDeliveryExtensionsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type TQueryIpeDeliveryExtensionsByPersonArgs = {
  personId: Scalars['String']['input'];
};


export type TQueryIpesByRiskArgs = {
  riskId: Scalars['String']['input'];
};


export type TQueryIsAccreditedArgs = {
  id: Scalars['String']['input'];
};


export type TQueryIsFirstIpeDeliveryArgs = {
  personId: Scalars['String']['input'];
};


export type TQueryLackVoteByMandateArgs = {
  mandateId: Scalars['String']['input'];
  pagination: TPagination;
};


export type TQueryLastDeliveryByPersonArgs = {
  personId: Scalars['String']['input'];
};


export type TQueryMandateArgs = {
  id: Scalars['String']['input'];
};


export type TQueryMandateActionArgs = {
  id: Scalars['String']['input'];
};


export type TQueryMandateActionsArgs = {
  mandateId: Scalars['String']['input'];
};


export type TQueryMandateCostCenterArgs = {
  id: Scalars['String']['input'];
};


export type TQueryMandateCostCenterByMandateArgs = {
  mandate: Scalars['String']['input'];
};


export type TQueryMandateDashboardArgs = {
  identifier?: InputMaybe<Scalars['String']['input']>;
};


export type TQueryMandateDepartmentArgs = {
  id: Scalars['String']['input'];
};


export type TQueryMandateDepartmentByMandateArgs = {
  mandate: Scalars['String']['input'];
};


export type TQueryMandateDimensionArgs = {
  mandateId: Scalars['String']['input'];
};


export type TQueryMandateEventArgs = {
  id: Scalars['String']['input'];
};


export type TQueryMandateEventByEventArgs = {
  event: Scalars['String']['input'];
  mandateId: Scalars['String']['input'];
};


export type TQueryMandateEventByMandateArgs = {
  mandate: Scalars['String']['input'];
};


export type TQueryMandateEventByMessageArgs = {
  message: Scalars['String']['input'];
};


export type TQueryMandateEventByTypeTodayArgs = {
  type: Scalars['String']['input'];
};


export type TQueryMandateLossesArgs = {
  mandateId: Scalars['String']['input'];
};


export type TQueryMandateTrainingArgs = {
  id: Scalars['String']['input'];
};


export type TQueryMandateTrainingByMandateArgs = {
  mandate: Scalars['String']['input'];
};


export type TQueryMandateTrainingByTrainingArgs = {
  training: Scalars['String']['input'];
};


export type TQueryMandatesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryMandatesByActionArgs = {
  actionPlanId: Scalars['String']['input'];
};


export type TQueryMandatesByDescriptionArgs = {
  description: Scalars['String']['input'];
};


export type TQueryMeasurementsByRiskArgs = {
  riskId: Scalars['String']['input'];
};


export type TQueryMeasuringInstrumentArgs = {
  id: Scalars['String']['input'];
};


export type TQueryMeasuringInstrumentsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryMedicalCertificateArgs = {
  id: Scalars['String']['input'];
};


export type TQueryMedicalCertificateByCrmArgs = {
  doctorCrm?: InputMaybe<Scalars['String']['input']>;
  doctorType?: InputMaybe<TDoctorType>;
};


export type TQueryMedicalCertificateByDoctorNameArgs = {
  doctorName?: InputMaybe<Scalars['String']['input']>;
  doctorType?: InputMaybe<TDoctorType>;
};


export type TQueryMedicalCertificatesByMedicalRecordArgs = {
  certificateStart?: InputMaybe<Scalars['DateTime']['input']>;
  fromFetch?: InputMaybe<Scalars['Boolean']['input']>;
  medicalRecord: Scalars['String']['input'];
  updatedId?: InputMaybe<Scalars['String']['input']>;
};


export type TQueryMedicalHistoryArgs = {
  personId: Scalars['String']['input'];
};


export type TQueryMedicalRecordArgs = {
  id: Scalars['String']['input'];
};


export type TQueryMedicalRecordByUserIdArgs = {
  id: Scalars['String']['input'];
};


export type TQueryMedicalRecordHealthProgramArgs = {
  id: Scalars['String']['input'];
};


export type TQueryMedicalRecordHealthProgramByMedicalRecordArgs = {
  medicalRecord: Scalars['String']['input'];
};


export type TQueryMedicalRecordSummaryArgs = {
  getCounter: Scalars['Boolean']['input'];
  query: TMedicalRecordQueryInput;
};


export type TQueryMedicalRecordVaccinationPlanningArgs = {
  vaccineId: Scalars['String']['input'];
};


export type TQueryMedicalRecordVaccineArgs = {
  id: Scalars['String']['input'];
};


export type TQueryMedicalRecordVaccinesByMedicalRecordArgs = {
  medicalRecord: Scalars['String']['input'];
};


export type TQueryMedicalRecordsArgs = {
  allBranches?: InputMaybe<Scalars['Boolean']['input']>;
  branchId?: InputMaybe<Scalars['String']['input']>;
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<TMedicalRecordOrderByInput>;
  pagination?: InputMaybe<TPagination>;
  query: TMedicalRecordQueryInput;
};


export type TQueryMedicalRecordsDashboardArgs = {
  filter: TMedicalRecordFilter;
  identifier: Scalars['String']['input'];
};


export type TQueryMedicalReferralArgs = {
  id: Scalars['String']['input'];
};


export type TQueryMedicalReferralDoctorBiometryArgs = {
  medicalReferralId: Scalars['String']['input'];
};


export type TQueryMedicalReferralsByMedicalRecordArgs = {
  medicalRecord: Scalars['String']['input'];
};


export type TQueryMedicalRestrictionArgs = {
  id: Scalars['String']['input'];
};


export type TQueryMedicalRestrictionsByMedicalRecordArgs = {
  medicalRecord: Scalars['String']['input'];
};


export type TQueryMedicineArgs = {
  id: Scalars['String']['input'];
};


export type TQueryMedicinesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryMeetingArgs = {
  id: Scalars['String']['input'];
};


export type TQueryMeetingActionArgs = {
  id: Scalars['String']['input'];
};


export type TQueryMeetingActionByDescriptionArgs = {
  description: Scalars['String']['input'];
  meetingId: Scalars['String']['input'];
};


export type TQueryMeetingActionPendentArgs = {
  meetingId: Scalars['String']['input'];
};


export type TQueryMeetingActionsArgs = {
  meetingId: Scalars['String']['input'];
};


export type TQueryMeetingByActiveArgs = {
  mandateId: Scalars['String']['input'];
};


export type TQueryMeetingByDateArgs = {
  date: Scalars['DateTime']['input'];
  mandateId: Scalars['String']['input'];
};


export type TQueryMeetingBySubjectArgs = {
  mandateId: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};


export type TQueryMeetingsArgs = {
  mandateId: Scalars['String']['input'];
};


export type TQueryNotificationModuleRecipientsArgs = {
  module: Scalars['String']['input'];
};


export type TQueryNotificationUsersByRolesArgs = {
  roles: Array<Scalars['String']['input']>;
};


export type TQueryOccupationArgs = {
  id: Scalars['String']['input'];
};


export type TQueryOccupationalHealthCertificateArgs = {
  id: Scalars['String']['input'];
};


export type TQueryOccupationalHealthCertificatesByMedicalRecordArgs = {
  includeDoctor?: InputMaybe<Scalars['Boolean']['input']>;
  medicalRecord: Scalars['String']['input'];
};


export type TQueryOccupationalHealthCertificatesByRegistrationArgs = {
  erpId: Scalars['String']['input'];
  individualRegistration: Scalars['String']['input'];
};


export type TQueryOccupationsArgs = {
  branchId?: InputMaybe<Scalars['String']['input']>;
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryOccupationsFilterByBranchArgs = {
  branchId: Scalars['String']['input'];
  occupations: Array<Scalars['String']['input']>;
};


export type TQueryOrthoRaterArgs = {
  id: Scalars['String']['input'];
};


export type TQueryOrthoRaterByConsultationArgs = {
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  consultationId: Scalars['String']['input'];
};


export type TQueryPeopleArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationPersonQueryInput;
};


export type TQueryPeopleByOriginDeliveriesArgs = {
  employeeSituations?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
};


export type TQueryPeopleByRiskArgs = {
  employeeSituations?: InputMaybe<Array<Scalars['String']['input']>>;
  riskId: Scalars['String']['input'];
};


export type TQueryPeopleNeedIpeArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPersonFilterQueryInput;
};


export type TQueryPeopleOnBrowseArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginatedPeopleOnBrowseInput;
};


export type TQueryPeopleSuggestionsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationPersonQueryInput;
};


export type TQueryPeriodicRangeArgs = {
  id: Scalars['String']['input'];
};


export type TQueryPeriodicRangesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryPersonArgs = {
  id: Scalars['String']['input'];
};


export type TQueryPersonByIndividualRegistrationArgs = {
  individualRegistration: Scalars['String']['input'];
};


export type TQueryPersonFilterIpeDeliveriesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<TPersonOrderByInput>;
  pagination?: InputMaybe<TPagination>;
  query: TPersonFilterQueryInput;
};


export type TQueryPersonRequiredTrainingsArgs = {
  personId: Scalars['String']['input'];
};


export type TQueryPersonSummaryArgs = {
  getCounter: Scalars['Boolean']['input'];
  query: TPersonFilterQueryInput;
};


export type TQueryPersonToIpeDeliveryArgs = {
  id: Scalars['String']['input'];
};


export type TQueryPhysicalEnvironmentArgs = {
  id: Scalars['String']['input'];
};


export type TQueryPhysicalEnvironmentsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryPositionArgs = {
  id: Scalars['String']['input'];
};


export type TQueryPositionsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryPreMedicalCertificateArgs = {
  id: Scalars['String']['input'];
};


export type TQueryPreMedicalCertificateCountByStatusArgs = {
  status: TPreMedicalCertificateStatus;
};


export type TQueryPreMedicalCertificatesArgs = {
  pagination?: InputMaybe<TPagination>;
  query?: InputMaybe<TPreMedicalCertificateQueryInput>;
};


export type TQueryPreviewDocumentByCertificateArgs = {
  certificatesId: Array<Scalars['String']['input']>;
};


export type TQueryPreviewDocumentByEnvironmentalReportArgs = {
  environmentalReportsId: Array<Scalars['String']['input']>;
};


export type TQueryPreviewDocumentByIpeDeliveryArgs = {
  sourceIds: Array<Scalars['String']['input']>;
};


export type TQueryPreviewDocumentBySecurityWorkOrderArgs = {
  sourceIds: Array<Scalars['String']['input']>;
};


export type TQueryPreviewMedicalCertificateDocumentByCertificateArgs = {
  certificatesId: Array<Scalars['String']['input']>;
};


export type TQueryProductArgs = {
  id: Scalars['String']['input'];
};


export type TQueryProductDeliveryArgs = {
  id: Scalars['String']['input'];
};


export type TQueryProductDeliveryByPersonArgs = {
  personId: Scalars['String']['input'];
};


export type TQueryProductDeliveryByProductArgs = {
  productId: Scalars['String']['input'];
};


export type TQueryProductDeliverysArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryProductIpeManufacturerArgs = {
  id: Scalars['String']['input'];
};


export type TQueryProductIpeManufacturersArgs = {
  productId: Scalars['String']['input'];
};


export type TQueryProductsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryProductsWithoutCaArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryQueueArgs = {
  id: Scalars['String']['input'];
};


export type TQueryQueuesArgs = {
  branchId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TESocialQueueFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TQueryQueuesByOrganizationArgs = {
  branchId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TESocialQueueFilter>;
  pagination?: InputMaybe<TPagination>;
};


export type TQueryQuizArgs = {
  id: Scalars['String']['input'];
};


export type TQueryQuizzesArgs = {
  allRecords?: InputMaybe<Scalars['Boolean']['input']>;
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  medicalRecordId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
  quizRelation?: InputMaybe<TQuizRelationEnum>;
  quizType?: InputMaybe<TQuizTypeEnum>;
};


export type TQueryRealGoalArgs = {
  id: Scalars['String']['input'];
};


export type TQueryReportSectionArgs = {
  id: Scalars['String']['input'];
};


export type TQueryReportStructureArgs = {
  id: Scalars['String']['input'];
};


export type TQueryReportStructuresArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
  type?: InputMaybe<TReportType>;
};


export type TQueryResendPendingEmailArgs = {
  documentId: Array<Scalars['Float']['input']>;
};


export type TQueryResponsibleActionArgs = {
  id: Scalars['String']['input'];
};


export type TQueryResponsibleActionByPersonArgs = {
  person: Scalars['String']['input'];
};


export type TQueryResponsiblesActionArgs = {
  actionPlanId: Scalars['String']['input'];
};


export type TQueryResultExamIbmpArgs = {
  id: Scalars['String']['input'];
};


export type TQueryResultExamIbmpByConsultationArgs = {
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  consultationId: Scalars['String']['input'];
};


export type TQueryRiskArgs = {
  id: Scalars['String']['input'];
};


export type TQueryRiskAgentArgs = {
  id: Scalars['String']['input'];
};


export type TQueryRiskAgentsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<TAgentGroup>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryRiskCompositionArgs = {
  id: Scalars['String']['input'];
};


export type TQueryRiskCompositionsByEnvironmentArgs = {
  environment: Scalars['String']['input'];
};


export type TQueryRiskSuggestionArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryRiskSummaryArgs = {
  getCounter: Scalars['Boolean']['input'];
  query: TRiskQueryInput;
};


export type TQueryRisksArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<TRiskOrderByInput>;
  pagination?: InputMaybe<TPagination>;
  query: TRiskQueryInput;
};


export type TQueryRisksByEnvironmentArgs = {
  input: TRiskByEnvironmentInput;
};


export type TQueryRisksByExposeByPersonArgs = {
  personId: Scalars['String']['input'];
};


export type TQueryRisksDashboardArgs = {
  filter: TRiskFilter;
  identifier: Scalars['String']['input'];
};


export type TQueryRisksForIntegrationArgs = {
  environmentId: Scalars['String']['input'];
  group: Scalars['String']['input'];
  riskDegree: Scalars['String']['input'];
};


export type TQueryRolePermissionArgs = {
  id: Scalars['String']['input'];
};


export type TQueryRolePermissionsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
  roleMdt?: InputMaybe<Scalars['String']['input']>;
};


export type TQueryRoutesArgs = {
  isMobile?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TQuerySafetyQuizArgs = {
  id: Scalars['String']['input'];
};


export type TQuerySafetyQuizDashboardArgs = {
  identifier?: InputMaybe<Scalars['String']['input']>;
};


export type TQuerySafetyQuizzesArgs = {
  quizId: Scalars['String']['input'];
};


export type TQueryScheduleRestrictionArgs = {
  id: Scalars['String']['input'];
};


export type TQueryScheduleRestrictionsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryScheduleRestrictionsByDateArgs = {
  allBranches?: InputMaybe<Scalars['Boolean']['input']>;
  branchId?: InputMaybe<Scalars['String']['input']>;
  doctorId?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type TQueryScheduleRestrictionsByDoctorArgs = {
  doctorId: Scalars['String']['input'];
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQuerySemanticInconsistenciesArgs = {
  flaggedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  flaggedTo?: InputMaybe<Scalars['DateTime']['input']>;
  pagination?: InputMaybe<TPagination>;
  rules?: InputMaybe<Array<Scalars['String']['input']>>;
  unackOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TQuerySilenceThresholdsArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type TQuerySimulationArgs = {
  id: Scalars['String']['input'];
};


export type TQuerySimulationPlanArgs = {
  id: Scalars['String']['input'];
};


export type TQuerySimulationPlansArgs = {
  brigadeId: Scalars['String']['input'];
};


export type TQuerySimulationsArgs = {
  brigadeId: Scalars['String']['input'];
};


export type TQuerySipatArgs = {
  id: Scalars['String']['input'];
};


export type TQuerySipatByDateArgs = {
  date: Scalars['DateTime']['input'];
  mandateId: Scalars['String']['input'];
};


export type TQuerySipatByDescriptionArgs = {
  description: Scalars['String']['input'];
  mandateId: Scalars['String']['input'];
};


export type TQuerySipatEventArgs = {
  id: Scalars['String']['input'];
};


export type TQuerySipatEventByDateArgs = {
  date: Scalars['DateTime']['input'];
  sipatId: Scalars['String']['input'];
};


export type TQuerySipatEventByDescriptionArgs = {
  sipatId: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};


export type TQuerySipatEventByPersonArgs = {
  personId: Scalars['String']['input'];
  sipatId: Scalars['String']['input'];
};


export type TQuerySipatsArgs = {
  mandateId: Scalars['String']['input'];
};


export type TQuerySnellenArgs = {
  id: Scalars['String']['input'];
};


export type TQuerySnellenByConsultationArgs = {
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  consultationId: Scalars['String']['input'];
};


export type TQuerySocAttachmentArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQuerySocQueueArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQuerySocSyncArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQuerySparePartArgs = {
  id: Scalars['String']['input'];
};


export type TQuerySparePartsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQuerySparePartsByProductArgs = {
  productId: Scalars['String']['input'];
};


export type TQueryStabilityTypeArgs = {
  id: Scalars['String']['input'];
};


export type TQueryStabilityTypesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryStatementResponsibilityArgs = {
  id: Scalars['String']['input'];
};


export type TQueryStatementsResponsibilityArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryStockLevelArgs = {
  id: Scalars['String']['input'];
};


export type TQueryStockLevelsByProductArgs = {
  productId: Scalars['String']['input'];
};


export type TQueryStockLevelsByWarehouseArgs = {
  warehouseId: Scalars['String']['input'];
};


export type TQueryStockLevelsLotNumbersArgs = {
  productId: Scalars['String']['input'];
  warehouseId: Scalars['String']['input'];
};


export type TQueryStockMovementArgs = {
  id: Scalars['String']['input'];
};


export type TQueryStockMovementsByProductArgs = {
  productId: Scalars['String']['input'];
};


export type TQuerySuggestionArgs = {
  id: Scalars['String']['input'];
};


export type TQuerySuggestionAmountArgs = {
  dateEnd: Scalars['DateTime']['input'];
  dateStart: Scalars['DateTime']['input'];
};


export type TQuerySuggestionBoxByDescriptionArgs = {
  description: Scalars['String']['input'];
  mandateId: Scalars['String']['input'];
};


export type TQuerySuggestionBoxByPriorityArgs = {
  mandateId: Scalars['String']['input'];
  priority: Scalars['String']['input'];
};


export type TQuerySuggestionBoxByStatusArgs = {
  mandateId: Scalars['String']['input'];
  status: Scalars['String']['input'];
};


export type TQuerySuggestionBoxListReportArgs = {
  mandateId: Scalars['String']['input'];
};


export type TQuerySuggestionsArgs = {
  mandateId: Scalars['String']['input'];
};


export type TQueryTaskArgs = {
  id: Scalars['String']['input'];
};


export type TQueryTaskByNameArgs = {
  name: Scalars['String']['input'];
};


export type TQueryTasksArgs = {
  branchId?: InputMaybe<Scalars['String']['input']>;
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryTasksFilterByBranchArgs = {
  branchId: Scalars['String']['input'];
  tasks: Array<Scalars['String']['input']>;
};


export type TQueryTrainingArgs = {
  id: Scalars['String']['input'];
};


export type TQueryTrainingEligiblePersonsArgs = {
  filters?: InputMaybe<TTrainingEligiblePersonsFilters>;
  pagination?: InputMaybe<TPagination>;
  trainingId: Scalars['String']['input'];
};


export type TQueryTrainingHistoryArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  personId: Scalars['String']['input'];
  query: TPaginationDefaultQueryInput;
};


export type TQueryTrainingsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryTrainingsByRiskArgs = {
  riskId: Scalars['String']['input'];
};


export type TQueryTtalkInFlightSourcesArgs = {
  ids: Array<Scalars['ID']['input']>;
  sourceType: Scalars['String']['input'];
};


export type TQueryTtalkInboundDlqEventsArgs = {
  filter?: InputMaybe<TTtalkInboundEventFilterInput>;
  pagination?: InputMaybe<TPagination>;
  query?: InputMaybe<TPaginationDefaultQueryInput>;
};


export type TQueryTtalkInboundEventsArgs = {
  filter?: InputMaybe<TTtalkInboundEventFilterInput>;
  pagination?: InputMaybe<TPagination>;
  query?: InputMaybe<TPaginationDefaultQueryInput>;
};


export type TQueryTtalkOutboundSummaryArgs = {
  branchId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TTTalkQueueFilterInput>;
  pagination?: InputMaybe<TPagination>;
  query?: InputMaybe<TPaginationDefaultQueryInput>;
};


export type TQueryTtalkQueueByEntityArgs = {
  person: Scalars['String']['input'];
  type: TTypeMessage;
};


export type TQueryTtalkQueuesArgs = {
  branchId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TTTalkQueueFilterInput>;
  pagination?: InputMaybe<TPagination>;
  query?: InputMaybe<TPaginationDefaultQueryInput>;
};


export type TQueryUnitiesOfMeasureArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryUnityOfMeasureArgs = {
  id: Scalars['String']['input'];
};


export type TQueryUrinalysisArgs = {
  id: Scalars['String']['input'];
};


export type TQueryUrinalysisByConsultationArgs = {
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  consultationId: Scalars['String']['input'];
};


export type TQueryUrinalysisByMedicalRecordArgs = {
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryUrinalysisByMedicalRecordForComparativeArgs = {
  medicalRecordId: Scalars['String']['input'];
};


export type TQueryUserArgs = {
  id: Scalars['String']['input'];
};


export type TQueryUserRoutesArgs = {
  isMobile?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TQueryUserSpecialtiesArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  onlyPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
};


export type TQueryVaccineArgs = {
  id: Scalars['String']['input'];
};


export type TQueryVaccinesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryVictimSuggestionsArgs = {
  costCenterId?: InputMaybe<Scalars['String']['input']>;
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryVoteByMandateArgs = {
  mandateId: Scalars['String']['input'];
  pagination: TPagination;
};


export type TQueryVoteProgressArgs = {
  mandateId: Scalars['String']['input'];
};


export type TQueryVoteSummaryArgs = {
  mandateId: Scalars['String']['input'];
};


export type TQueryWarehouseArgs = {
  id: Scalars['String']['input'];
};


export type TQueryWarehousesArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryWarehousesByProductArgs = {
  productId: Scalars['String']['input'];
};


export type TQueryWorkHoursByDoctorArgs = {
  doctorId: Scalars['String']['input'];
};


export type TQueryWorkPermissionArgs = {
  id: Scalars['String']['input'];
};


export type TQueryWorkPermissionDashboardArgs = {
  identifier?: InputMaybe<Scalars['String']['input']>;
};


export type TQueryWorkPermissionQuizArgs = {
  workPermissionId: Scalars['String']['input'];
};


export type TQueryWorkPermissionsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};


export type TQueryWorkShiftArgs = {
  id: Scalars['String']['input'];
};


export type TQueryWorkShiftsArgs = {
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<TPagination>;
  query: TPaginationDefaultQueryInput;
};

/** Pergunta de gênero */
export enum TQuestionGenderEnum {
  /** Ambos */
  Both = 'Both',
  /** Feminino */
  Female = 'Female',
  /** Masculino */
  Male = 'Male'
}

export type TQuestionGroupOnQuestion = {
  __typename?: 'QuestionGroupOnQuestion';
  /** Descrição */
  description: Scalars['String']['output'];
  /** Identificador */
  id: Scalars['String']['output'];
  /** Ordem */
  order?: Maybe<Scalars['Float']['output']>;
};

export type TQuestions = {
  __typename?: 'Questions';
  /** Opção padrão */
  defaultOption?: Maybe<Scalars['String']['output']>;
  /** Descrição */
  description: Scalars['String']['output'];
  /** Pergunta de gênero */
  gender: TQuestionGenderEnum;
  /** Indica se possui detalhes */
  hasDetails: Scalars['Boolean']['output'];
  /** Identificador */
  id: Scalars['String']['output'];
  /** Ordem */
  order: Scalars['Float']['output'];
  /** Grupo de perguntas em questão */
  questionGroup: TQuestionGroupOnQuestion;
  /** Indica se é obrigatório */
  required: Scalars['Boolean']['output'];
  /** Opções de resposta */
  responseOptions?: Maybe<Array<TResponseOptions>>;
  /** Tipo de pergunta */
  responseType: TResponseType;
};

export type TQuestionsDashboard = {
  __typename?: 'QuestionsDashboard';
  /** Pergunta */
  question: Scalars['String']['output'];
  /** Respostas */
  responses: Array<TPieChart>;
};

export type TQuestionsGroup = {
  __typename?: 'QuestionsGroup';
  /** Descrição */
  description: Scalars['String']['output'];
  /** Identificador */
  id: Scalars['String']['output'];
  /** Ordem */
  order?: Maybe<Scalars['Float']['output']>;
  /** Perguntas do questionário */
  questionsQuiz?: Maybe<Array<TQuestions>>;
};

export type TQuestionsGroupInput = {
  description: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Float']['input']>;
  questionsQuiz?: InputMaybe<Array<TQuestionsInput>>;
};

export type TQuestionsGroupUpdate = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  questionsQuiz?: InputMaybe<Array<TQuestionsUpdate>>;
};

export type TQuestionsInput = {
  defaultOption?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  gender: TQuestionGenderEnum;
  hasDetails: Scalars['Boolean']['input'];
  order: Scalars['Float']['input'];
  required: Scalars['Boolean']['input'];
  responseOptions?: InputMaybe<Array<TResponseOptionsInput>>;
  responseType: TResponseType;
};

export type TQuestionsUpdate = {
  defaultOption?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<TQuestionGenderEnum>;
  hasDetails?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  responseOptions?: InputMaybe<Array<TResponseOptionsUpdate>>;
  responseType?: InputMaybe<TResponseType>;
};

export type TQueueDto = {
  __typename?: 'QueueDTO';
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** Mensagem de erro */
  error?: Maybe<Scalars['String']['output']>;
  /** ID da fila */
  id: Scalars['String']['output'];
  /** Chave identificadora */
  key: Scalars['String']['output'];
  /** Mensagem */
  message: Scalars['String']['output'];
  /** Status do processamento */
  status: TStatus;
  /** Data de atualização */
  updatedAt: Scalars['DateTime']['output'];
};

export type TQuiz = {
  __typename?: 'Quiz';
  /** Questionários clínicos (anamneses) */
  clinicalQuizzes?: Maybe<Array<TClinicalQuiz>>;
  /** Questionários de centro de custo */
  costCenters?: Maybe<Array<TQuizCostCenter>>;
  /** Questionários de departamento */
  departments?: Maybe<Array<TQuizDepartment>>;
  /** Descrição */
  description: Scalars['String']['output'];
  /** Identificador do ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** Questionários de fonte geradora */
  generatingSources?: Maybe<Array<TQuizGeneratingSource>>;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Indica se está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Indica se é padrão */
  isDefault: Scalars['Boolean']['output'];
  /** Questionários de ocupação */
  occupations?: Maybe<Array<TQuizOccupation>>;
  /** Questionários de pessoa */
  people?: Maybe<Array<TQuizPerson>>;
  /** Periocidade */
  periodicity?: Maybe<Scalars['Float']['output']>;
  /** Questionários de ambiente físico */
  physicalEnvironments?: Maybe<Array<TQuizPhysicalEnvironment>>;
  /** Grupos de perguntas */
  questionsGroup?: Maybe<Array<TQuestionsGroup>>;
  /** Anexos do questionário */
  quizAttachments?: Maybe<Array<TAttachment>>;
  /** Tipo de questionário */
  quizType?: Maybe<TQuizTypeEnum>;
  /** Indica se é somente para leitura */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** Questionários de segurança */
  safetyQuizzes?: Maybe<Array<TSafetyQuiz>>;
};

export type TQuizCostCenter = {
  __typename?: 'QuizCostCenter';
  /** Centro de custo */
  costCenter: TCostCenter;
  /** Identificador do centro de custo */
  costCenterId: Scalars['String']['output'];
};

export type TQuizCostCenterInput = {
  /** Identificador do centro de custo */
  costCenterId: Scalars['String']['input'];
};

export type TQuizDepartment = {
  __typename?: 'QuizDepartment';
  /** Departamento */
  department: TDepartment;
  /** Identificador do departamento */
  departmentId: Scalars['String']['output'];
};

export type TQuizDepartmentInput = {
  /** Identificador do departamento */
  departmentId: Scalars['String']['input'];
};

export type TQuizGeneratingSource = {
  __typename?: 'QuizGeneratingSource';
  /** Fonte geradora */
  generatingSource: TGeneratingSource;
  /** Identificador da fonte geradora */
  generatingSourceId: Scalars['String']['output'];
};

export type TQuizGeneratingSourceInput = {
  /** Identificador da fonte geradora */
  generatingSourceId: Scalars['String']['input'];
};

export type TQuizInput = {
  costCenters?: InputMaybe<Array<TQuizCostCenterInput>>;
  departments?: InputMaybe<Array<TQuizDepartmentInput>>;
  description: Scalars['String']['input'];
  erpId?: InputMaybe<Scalars['String']['input']>;
  generatingSources?: InputMaybe<Array<TQuizGeneratingSourceInput>>;
  isDefault: Scalars['Boolean']['input'];
  occupations?: InputMaybe<Array<TQuizOccupationInput>>;
  people?: InputMaybe<Array<TQuizPersonInput>>;
  periodicity?: InputMaybe<Scalars['Float']['input']>;
  physicalEnvironments?: InputMaybe<Array<TQuizPhysicalEnvironmentInput>>;
  questionsGroup?: InputMaybe<Array<TQuestionsGroupInput>>;
  quizType?: InputMaybe<TQuizTypeEnum>;
};

export type TQuizOccupation = {
  __typename?: 'QuizOccupation';
  /** Ocupação */
  occupation: TOccupation;
  /** Identificador de ocupação */
  occupationId: Scalars['String']['output'];
};

export type TQuizOccupationInput = {
  /** Identificador de ocupação */
  occupationId: Scalars['String']['input'];
};

export type TQuizPerson = {
  __typename?: 'QuizPerson';
  /** Pessoa */
  person: TPerson;
  /** Identificador da pessoa */
  personId: Scalars['String']['output'];
};

export type TQuizPersonInput = {
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
};

export type TQuizPhysicalEnvironment = {
  __typename?: 'QuizPhysicalEnvironment';
  /** Ambiente físico */
  physicalEnvironment: TPhysicalEnvironment;
  /** Identificador de ambiente físico */
  physicalEnvironmentId: Scalars['String']['output'];
};

export type TQuizPhysicalEnvironmentInput = {
  /** Identificador de ambiente físico */
  physicalEnvironmentId: Scalars['String']['input'];
};

/** Questionário de relação */
export enum TQuizRelationEnum {
  /** Todos */
  All = 'All',
  /** Centros de custo */
  CostCenters = 'CostCenters',
  /** Departamentos */
  Departments = 'Departments',
  /** Fontes geradoras */
  GeneratingSources = 'GeneratingSources',
  /** Cargos */
  Occupations = 'Occupations',
  /** Pessoas */
  People = 'People',
  /** Ambientes físicos */
  PhysicalEnvironments = 'PhysicalEnvironments'
}

/** Tipo de questionário */
export enum TQuizTypeEnum {
  /** Ambos */
  Both = 'Both',
  /** Saúde */
  Health = 'Health',
  /** Segurança */
  Safety = 'Safety'
}

export type TQuizUpdate = {
  costCenters?: InputMaybe<Array<TQuizCostCenterInput>>;
  departments?: InputMaybe<Array<TQuizDepartmentInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  generatingSources?: InputMaybe<Array<TQuizGeneratingSourceInput>>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  occupations?: InputMaybe<Array<TQuizOccupationInput>>;
  people?: InputMaybe<Array<TQuizPersonInput>>;
  periodicity?: InputMaybe<Scalars['Float']['input']>;
  physicalEnvironments?: InputMaybe<Array<TQuizPhysicalEnvironmentInput>>;
  questionsGroup?: InputMaybe<Array<TQuestionsGroupUpdate>>;
  quizType?: InputMaybe<TQuizTypeEnum>;
};

export type TQuizzesCharts = {
  __typename?: 'QuizzesCharts';
  /** Possui questionários */
  hasQuizzes: Scalars['Boolean']['output'];
  /** Perguntas */
  questions: Array<TQuestionsDashboard>;
};

export type TRadarCharts = {
  __typename?: 'RadarCharts';
  /** Dados */
  data: Array<Scalars['Float']['output']>;
  /** Valor máximo dos dados */
  maxDataValue: Scalars['Float']['output'];
};

export type TRanking = {
  __typename?: 'Ranking';
  /** Média */
  average: Scalars['Float']['output'];
  /** Atestados */
  certificates: Scalars['Float']['output'];
  /** Dias */
  days: Scalars['Float']['output'];
  /** Identificador */
  id: Scalars['String']['output'];
  /** Nome */
  name: Scalars['String']['output'];
};

export type TRealGoal = {
  __typename?: 'RealGoal';
  /** Plano de ação vinculado */
  actionPlan: TActionPlan;
  /** Data da meta */
  date: Scalars['DateTime']['output'];
  /** Descrição */
  description?: Maybe<Scalars['String']['output']>;
  /** Detalhes */
  details?: Maybe<Scalars['String']['output']>;
  /** ID da meta realizada */
  id: Scalars['String']['output'];
  /** Responsável */
  responsible?: Maybe<TPerson>;
  /** Valor alcançado na meta */
  value: Scalars['Float']['output'];
};

export type TRealGoalInput = {
  /** ID do plano de ação */
  actionPlanId: Scalars['String']['input'];
  /** Data da meta */
  date: Scalars['DateTime']['input'];
  /** Descrição */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Detalhes */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do responsável */
  responsibleId?: InputMaybe<Scalars['String']['input']>;
  /** Valor alcançado na meta */
  value: Scalars['Float']['input'];
};

export type TRealGoalOnActionPlan = {
  __typename?: 'RealGoalOnActionPlan';
  /** Anexos relacionados ao planejado */
  attachments?: Maybe<Array<TAttachment>>;
  /** Data da meta */
  date: Scalars['DateTime']['output'];
  /** Descrição */
  description?: Maybe<Scalars['String']['output']>;
  /** Detalhes */
  details?: Maybe<Scalars['String']['output']>;
  /** Identificador */
  id?: Maybe<Scalars['String']['output']>;
  /** Responsável */
  responsible?: Maybe<TPerson>;
  /** Valor alcançado na meta */
  value: Scalars['Float']['output'];
};

export type TReasonsChart = {
  __typename?: 'ReasonsChart';
  /** Entregas admissionais */
  admissional: Scalars['Float']['output'];
  /** Entregas por dano */
  damage: Scalars['Float']['output'];
  /** Entregas por defeito */
  defect: Scalars['Float']['output'];
  /** Entregas demissionais */
  demissional: Scalars['Float']['output'];
  /** Entregas por teste dielétrico */
  dielectricTest: Scalars['Float']['output'];
  /** Entregas por mudança de função */
  functionChange: Scalars['Float']['output'];
  /** Indica se existem entregas de IPE */
  hasIpeDeliveries: Scalars['Boolean']['output'];
  /** Entregas por perda */
  loss: Scalars['Float']['output'];
  /** Entregas por prescrição médica */
  medicalPrescription: Scalars['Float']['output'];
  /** Outros motivos */
  other: Scalars['Float']['output'];
  /** Entregas por higienização */
  sanitation: Scalars['Float']['output'];
  /** Entregas por roubo */
  theft: Scalars['Float']['output'];
  /** Entregas por desgaste */
  wear: Scalars['Float']['output'];
};

export type TRecipientInput = {
  documentId?: InputMaybe<Scalars['Int']['input']>;
  observers?: InputMaybe<Array<TObserversItemInput>>;
  publishingOptions: TPublishingOptionsInput;
  recipient: Array<TRecipientItemInput>;
  useWorkflow?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TRecipientItemInput = {
  action: TSignPublicationAction;
  authenticationType: TAuthTypeTotvsSign;
  codeSendType?: InputMaybe<TSendType>;
  documentSendType?: InputMaybe<TSendType>;
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  identification?: InputMaybe<Scalars['String']['input']>;
  identificationType?: InputMaybe<TIdentificationType>;
  isPrimary: Scalars['Boolean']['input'];
  notifySending?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  signerRole?: InputMaybe<Scalars['String']['input']>;
  workflow?: InputMaybe<Scalars['String']['input']>;
};

export type TRecipientListInput = {
  documentId: Scalars['Int']['input'];
  recipients: Array<TRecipientListItemInput>;
};

export type TRecipientListItemInput = {
  action?: InputMaybe<TSignPublicationAction>;
  authenticationType?: InputMaybe<TAuthTypeTotvsSign>;
  codeSendType?: InputMaybe<TSendType>;
  documentSendType?: InputMaybe<TSendType>;
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  identification?: InputMaybe<Scalars['String']['input']>;
  identificationType?: InputMaybe<TIdentificationType>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  signerRole?: InputMaybe<Scalars['String']['input']>;
  workflow?: InputMaybe<Scalars['String']['input']>;
};

export type TRecognizeMedicalCertificateInput = {
  fileName: Scalars['String']['input'];
  imageBase64: Scalars['String']['input'];
};

export type TRecognizedIcdInfo = {
  __typename?: 'RecognizedIcdInfo';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type TRecognizedMedicalCertificateData = {
  __typename?: 'RecognizedMedicalCertificateData';
  amountOfTreatmentDays?: Maybe<Scalars['Int']['output']>;
  certificateType?: Maybe<TCertificateType>;
  crmState?: Maybe<TState>;
  dateStart?: Maybe<Scalars['DateTime']['output']>;
  derivedDisabilityRetirement?: Maybe<Scalars['Boolean']['output']>;
  doctorCrm?: Maybe<Scalars['String']['output']>;
  doctorName?: Maybe<Scalars['String']['output']>;
  doctorType?: Maybe<TDoctorType>;
  filledFields: Array<Scalars['String']['output']>;
  icd?: Maybe<TRecognizedIcdInfo>;
  icdGroup?: Maybe<TRecognizedIcdInfo>;
  origin?: Maybe<TCertificateOrigin>;
  telemedicine?: Maybe<Scalars['Boolean']['output']>;
};

/** Recomendação */
export enum TRecommendation {
  /** Apto */
  Able = 'Able',
  /** Apto com restrições */
  AbleWithRestrictions = 'AbleWithRestrictions',
  /** Inapto */
  Unable = 'Unable'
}

/** Hemácias */
export enum TRedCellsEnum {
  /** Grande */
  Big = 'Big',
  /** Hemolisado */
  Hemolized = 'Hemolized',
  /** Moderado */
  Moderate = 'Moderate',
  /** Negativo */
  Negative = 'Negative',
  /** Não hemolisado */
  NotHemolized = 'NotHemolized',
  /** Pequeno */
  Small = 'Small'
}

export type TReferences = {
  __typename?: 'References';
  /** Gênero */
  gender: TExamGenderEnum;
  /** Identificador */
  id: Scalars['String']['output'];
  /** Idade máxima */
  maxAge: Scalars['Float']['output'];
  /** Percentual máximo */
  maxPercent?: Maybe<Scalars['Float']['output']>;
  /** Valor máximo */
  maxValue: Scalars['Float']['output'];
  /** Idade mínima */
  minAge: Scalars['Float']['output'];
  /** Percentual mínimo */
  minPercent?: Maybe<Scalars['Float']['output']>;
  /** Valor mínimo */
  minValue: Scalars['Float']['output'];
};

export type TReferencesInput = {
  /** Gênero do exame */
  gender: TExamGenderEnum;
  /** Idade máxima */
  maxAge: Scalars['Float']['input'];
  /** Porcentagem máxima */
  maxPercent?: InputMaybe<Scalars['Float']['input']>;
  /** Valor máximo */
  maxValue: Scalars['Float']['input'];
  /** Idade mínima */
  minAge: Scalars['Float']['input'];
  /** Porcentagem mínima */
  minPercent?: InputMaybe<Scalars['Float']['input']>;
  /** Valor mínimo */
  minValue: Scalars['Float']['input'];
};

export type TReferencesUpdate = {
  /** Gênero do exame */
  gender?: InputMaybe<TExamGenderEnum>;
  /** Identificador */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Idade máxima */
  maxAge?: InputMaybe<Scalars['Float']['input']>;
  /** Porcentagem máxima */
  maxPercent?: InputMaybe<Scalars['Float']['input']>;
  /** Valor máximo */
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  /** Idade mínima */
  minAge?: InputMaybe<Scalars['Float']['input']>;
  /** Porcentagem mínima */
  minPercent?: InputMaybe<Scalars['Float']['input']>;
  /** Valor mínimo */
  minValue?: InputMaybe<Scalars['Float']['input']>;
};

export type TReferralsChart = {
  __typename?: 'ReferralsChart';
  /** Dados */
  data: Array<TData>;
  /** Possui encaminhamentos */
  hasReferrals: Scalars['Boolean']['output'];
};

export type TReferralsQuantityChart = {
  __typename?: 'ReferralsQuantityChart';
  /** Possui encaminhamentos */
  hasReferrals: Scalars['Boolean']['output'];
  /** Contador de encaminhamentos */
  referralsCounter: Array<TData>;
  /** Percentual total de encaminhamentos */
  totalReferralPercentage: Array<TData>;
};

export type TRelativeIndex = {
  __typename?: 'RelativeIndex';
  /** Descrição do período */
  description?: Maybe<Scalars['String']['output']>;
  /** Índice relativo de acidentes */
  index: Scalars['Float']['output'];
};

export type TReleasableResult = {
  __typename?: 'ReleasableResult';
  /** Identificador do exame complementar (nulo = resultado geral da consulta) */
  complementaryExamId?: Maybe<Scalars['String']['output']>;
  /** Identificador da consulta */
  consultationId: Scalars['String']['output'];
  /** Data do resultado */
  date?: Maybe<Scalars['String']['output']>;
  /** Nome do exame */
  examName: Scalars['String']['output'];
  /** Nome do responsável pelo resultado */
  examResponsibleName?: Maybe<Scalars['String']['output']>;
  /** Indica se o resultado já foi liberado para o colaborador */
  released: Scalars['Boolean']['output'];
  /** Data de solicitação do exame */
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Descrição do resultado */
  resultDescription?: Maybe<Scalars['String']['output']>;
  /** Tipo de resultado do exame */
  resultType?: Maybe<TResultTypeEnum>;
};

export type TReleaseConsultationResultsInput = {
  /** Exames complementares que devem ficar liberados; os ausentes ficam ocultos */
  complementaryExamIds: Array<Scalars['String']['input']>;
  /** Identificador da consulta */
  consultationId: Scalars['String']['input'];
  /** Liberar (true) ou ocultar (false) o resultado geral da consulta */
  releaseGeneralResult: Scalars['Boolean']['input'];
};

export type TRemoveRecipientInput = {
  documentId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** Situação da reposição */
export enum TReplacementSituation {
  /** Inativo */
  Inactive = 'inactive',
  /** Atrasado */
  Late = 'late',
  /** Próximo */
  Near = 'near',
  /** Seguinte */
  Next = 'next',
  /** Outro */
  Other = 'other'
}

/** Finalidade do laudo */
export enum TReportFinality {
  /** Periculosidade */
  Dangerousness = 'Dangerousness',
  /** Outros */
  Others = 'Others',
  /** Insalubridade */
  Unhealthiness = 'Unhealthiness'
}

export type TReportMapaData = {
  __typename?: 'ReportMapaData';
  biologicalLarge: Scalars['String']['output'];
  biologicalMedium: Scalars['String']['output'];
  biologicalSmall: Scalars['String']['output'];
  chemicalLarge: Scalars['String']['output'];
  chemicalMedium: Scalars['String']['output'];
  chemicalSmall: Scalars['String']['output'];
  cipaManagementPeriod?: Maybe<Scalars['String']['output']>;
  compositions: Scalars['String']['output'];
  controlMeasure: Array<TRiskControlMeasure>;
  environment: Scalars['String']['output'];
  ergonomicLarge: Scalars['String']['output'];
  ergonomicMedium: Scalars['String']['output'];
  ergonomicSmall: Scalars['String']['output'];
  fields: TReportMapaFields;
  footer: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  mechanicalLarge: Scalars['String']['output'];
  mechanicalMedium: Scalars['String']['output'];
  mechanicalSmall: Scalars['String']['output'];
  physicalLarge: Scalars['String']['output'];
  physicalMedium: Scalars['String']['output'];
  physicalSmall: Scalars['String']['output'];
};

export type TReportMapaFields = {
  __typename?: 'ReportMapaFields';
  biological: Scalars['String']['output'];
  chemical: Scalars['String']['output'];
  cipaManagement: Scalars['String']['output'];
  environmentalRisks: Scalars['String']['output'];
  ergonomic: Scalars['String']['output'];
  intensityOfRisk: Scalars['String']['output'];
  large: Scalars['String']['output'];
  mechanical: Scalars['String']['output'];
  medium: Scalars['String']['output'];
  physical: Scalars['String']['output'];
  riskControl: Scalars['String']['output'];
  small: Scalars['String']['output'];
};

export type TReportPrescription = {
  __typename?: 'ReportPrescription';
  /** Endereço da empresa */
  address?: Maybe<Scalars['String']['output']>;
  /** Endereço do paciente */
  addressPatient: Scalars['String']['output'];
  /** Idade */
  age: Scalars['Float']['output'];
  /** CNPJ */
  cnpj?: Maybe<Scalars['String']['output']>;
  /** Nome da empresa */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Centro de custo */
  costCenter?: Maybe<TCostCenter>;
  /** Estado do CRM */
  crmState?: Maybe<TState>;
  /** Data */
  date: Scalars['String']['output'];
  /** Nome do médico */
  doctor: Scalars['String']['output'];
  /** CRM do médico */
  doctorCrm?: Maybe<Scalars['String']['output']>;
  /** Snapshot formatado dos RQEs do médico para impressão */
  doctorRqeDisplay?: Maybe<Scalars['String']['output']>;
  /** Número do documento */
  documentNumber?: Maybe<Scalars['String']['output']>;
  /** Rodapé */
  footer: Scalars['String']['output'];
  /** Gênero */
  gender: Scalars['String']['output'];
  /** Medicamentos */
  medicines: Array<TMedicinesPrescription>;
  /** Nome do paciente */
  name: Scalars['String']['output'];
  /** Imagem da organização */
  organizationPicture?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** Quantidade de impressões */
  printAmounts?: Maybe<Scalars['Float']['output']>;
  /** Mostrar endereço do paciente */
  showAddressPatient: Scalars['Boolean']['output'];
  /** Telefone */
  telephone?: Maybe<Scalars['String']['output']>;
};

export type TReportSection = {
  __typename?: 'ReportSection';
  /** Anexo da seção */
  attachment?: Maybe<TAttachment>;
  /** Indica se deve quebrar página */
  breakPage: Scalars['Boolean']['output'];
  /** Conteúdo da seção */
  content?: Maybe<Scalars['String']['output']>;
  /** Descrição da seção */
  description: Scalars['String']['output'];
  /** ID da seção do relatório */
  id: Scalars['String']['output'];
  /** Filtrar apenas ocupações vinculadas */
  onlyLinkedOccupations?: Maybe<Scalars['Boolean']['output']>;
  /** Ordem da seção */
  order: Scalars['Float']['output'];
  /** Orientação da página */
  pageOrientation: TPageOrientation;
  /** ID da seção pai (hierarquia) */
  parentId?: Maybe<Scalars['String']['output']>;
  /** ID da estrutura do relatório */
  reportStructureId: Scalars['String']['output'];
  /** Atalho associado */
  shortcut?: Maybe<TShortcut>;
  /** Tipo da seção */
  type: TReportSectionType;
};

export type TReportSectionBaseInput = {
  /** ID da seção */
  id: Scalars['String']['input'];
  /** Ordem da seção */
  order: Scalars['Float']['input'];
  /** ID da seção pai (hierarquia) */
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type TReportSectionInput = {
  /** Indica se deve quebrar página */
  breakPage: Scalars['Boolean']['input'];
  /** Conteúdo da seção */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Tamanho do conteúdo */
  contentLength?: InputMaybe<Scalars['Float']['input']>;
  /** Tipo do conteúdo */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Descrição da seção */
  description: Scalars['String']['input'];
  /** Nome do arquivo */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** Filtrar apenas ocupações vinculadas */
  onlyLinkedOccupations?: InputMaybe<Scalars['Boolean']['input']>;
  /** Orientação da página */
  pageOrientation: TPageOrientation;
  /** ID da seção pai (hierarquia) */
  parentId?: InputMaybe<Scalars['String']['input']>;
  /** ID da estrutura do relatório */
  reportStructureId: Scalars['String']['input'];
  /** Atalho associado */
  shortcut?: InputMaybe<TShortcut>;
  /** Tipo da seção */
  type: TReportSectionType;
};

/** Tipo de seção de relatório */
export enum TReportSectionType {
  /** Imagem */
  Image = 'Image',
  /** PDF */
  Pdf = 'PDF',
  /** Atalho */
  Shortcut = 'Shortcut',
  /** Texto */
  Text = 'Text'
}

export type TReportSectionUpdate = {
  /** Indica se deve quebrar página */
  breakPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Conteúdo da seção */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Tamanho do conteúdo */
  contentLength?: InputMaybe<Scalars['Float']['input']>;
  /** Tipo do conteúdo */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Descrição da seção */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Nome do arquivo */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** ID da seção */
  id: Scalars['String']['input'];
  /** Filtrar apenas ocupações vinculadas */
  onlyLinkedOccupations?: InputMaybe<Scalars['Boolean']['input']>;
  /** Orientação da página */
  pageOrientation?: InputMaybe<TPageOrientation>;
  /** ID da seção pai (hierarquia) */
  parentId?: InputMaybe<Scalars['String']['input']>;
  /** ID da estrutura do relatório */
  reportStructureId?: InputMaybe<Scalars['String']['input']>;
  /** Atalho associado */
  shortcut?: InputMaybe<TShortcut>;
  /** Tipo da seção */
  type?: InputMaybe<TReportSectionType>;
};

export type TReportStructure = {
  __typename?: 'ReportStructure';
  /** Descrição da estrutura */
  description: Scalars['String']['output'];
  /** ID da estrutura do relatório */
  id: Scalars['String']['output'];
  /** Indica se está ativa */
  isActive: Scalars['Boolean']['output'];
  /** Seções do relatório */
  sections?: Maybe<Array<TReportSection>>;
  /** Tipo do relatório */
  type: TReportType;
};

export type TReportStructureInput = {
  /** Descrição da estrutura */
  description: Scalars['String']['input'];
  /** Indica se está ativa */
  isActive: Scalars['Boolean']['input'];
  /** Tipo do relatório */
  type: TReportType;
};

export type TReportStructureUpdate = {
  /** Descrição da estrutura */
  description: Scalars['String']['input'];
  /** ID da estrutura */
  id: Scalars['String']['input'];
  /** Indica se está ativa */
  isActive: Scalars['Boolean']['input'];
  /** Seções do relatório */
  sections: Array<TReportSectionBaseInput>;
  /** Tipo do relatório */
  type: TReportType;
};

/** Tipo de relatório/laudo */
export enum TReportType {
  /** Análise Ergonômica do Trabalho */
  Aet = 'AET',
  /** Análise Preliminar de Risco */
  Apr = 'APR',
  /** Laudo Técnico das Condições Ambientais do Trabalho */
  Ltcat = 'LTCAT',
  /** Laudo Técnico das Condições Ambientais do Trabalho - Expert */
  LtExpert = 'LTExpert',
  /** Programa de Avaliação Ergonômica */
  Pae = 'PAE',
  Pca = 'PCA',
  /** Programa de Condições e Meio Ambiente de Trabalho na Indústria da Construção */
  Pcmat = 'PCMAT',
  /** Programa de Controle Médico de Saúde Ocupacional */
  Pcmso = 'PCMSO',
  /** Programa de Gerenciamento de Riscos */
  Pgr = 'PGR',
  /** Programa de Gerenciamento de Riscos - Transporte Rodoviário */
  Pgrtr = 'PGRTR',
  /** Programa de Proteção Respiratória */
  Ppr = 'PPR',
  /** Programa de Prevenção de Riscos Ambientais */
  Ppra = 'PPRA'
}

export type TResponseClinicalQuizInput = {
  /** Identificador único */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da questão */
  questionId: Scalars['String']['input'];
  /** Resposta textual */
  response?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da opção de resposta */
  responseOptionId?: InputMaybe<Scalars['String']['input']>;
};

export type TResponseClinicalQuizUpdate = {
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Identificador da questão */
  questionId: Scalars['String']['input'];
  /** Resposta textual */
  response?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da opção de resposta */
  responseOptionId?: InputMaybe<Scalars['String']['input']>;
};

export type TResponseOptions = {
  __typename?: 'ResponseOptions';
  /** Descrição */
  description: Scalars['String']['output'];
  /** Identificador */
  id: Scalars['String']['output'];
};

export type TResponseOptionsInput = {
  description: Scalars['String']['input'];
};

export type TResponseOptionsUpdate = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type TResponseSafetyQuizInput = {
  /** ID da resposta */
  id?: InputMaybe<Scalars['String']['input']>;
  /** ID da questão */
  questionId: Scalars['String']['input'];
  /** Resposta em texto livre */
  response?: InputMaybe<Scalars['String']['input']>;
  /** ID da opção de resposta */
  responseOptionId?: InputMaybe<Scalars['String']['input']>;
};

export type TResponseSafetyQuizUpdate = {
  /** ID da resposta */
  id: Scalars['String']['input'];
  /** ID da questão */
  questionId: Scalars['String']['input'];
  /** Resposta em texto livre */
  response?: InputMaybe<Scalars['String']['input']>;
  /** ID da opção de resposta */
  responseOptionId?: InputMaybe<Scalars['String']['input']>;
};

/** Tipos de resposta */
export enum TResponseType {
  /** Binária */
  Binary = 'Binary',
  /** Descritiva */
  Descritive = 'Descritive',
  /** Múltipla */
  Multiple = 'Multiple',
  /** Única */
  Only = 'Only'
}

export type TResponseWorkPermissionQuiz = {
  __typename?: 'ResponseWorkPermissionQuiz';
  /** ID da resposta */
  id: Scalars['String']['output'];
  /** Questão respondida */
  question: TQuestions;
  /** Resposta em texto livre */
  response?: Maybe<Scalars['String']['output']>;
  /** Opção de resposta selecionada */
  responseOption?: Maybe<TResponseOptions>;
};

export type TResponseWorkPermissionQuizInput = {
  /** ID da resposta (para atualização) */
  id?: InputMaybe<Scalars['String']['input']>;
  /** ID da questão */
  questionId: Scalars['String']['input'];
  /** Resposta em texto livre */
  response?: InputMaybe<Scalars['String']['input']>;
  /** ID da opção de resposta selecionada */
  responseOptionId?: InputMaybe<Scalars['String']['input']>;
};

export type TResponseWorkPermissionQuizUpdate = {
  /** ID da resposta */
  id: Scalars['String']['input'];
  /** ID da questão */
  questionId: Scalars['String']['input'];
  /** Resposta em texto livre */
  response?: InputMaybe<Scalars['String']['input']>;
  /** ID da opção de resposta selecionada */
  responseOptionId?: InputMaybe<Scalars['String']['input']>;
};

export type TResponsesClinicalQuiz = {
  __typename?: 'ResponsesClinicalQuiz';
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Questão */
  question: TQuestions;
  /** Resposta textual */
  response?: Maybe<Scalars['String']['output']>;
  /** Opção de resposta */
  responseOption?: Maybe<TResponseOptions>;
};

export type TResponsesSafetyQuiz = {
  __typename?: 'ResponsesSafetyQuiz';
  /** ID da resposta */
  id: Scalars['String']['output'];
  /** Questão respondida */
  question: TQuestions;
  /** Resposta em texto livre */
  response?: Maybe<Scalars['String']['output']>;
  /** Opção de resposta selecionada */
  responseOption?: Maybe<TResponseOptions>;
};

export type TResponsibleAction = {
  __typename?: 'ResponsibleAction';
  /** Plano de ação vinculado */
  actionPlan: TActionPlan;
  /** ID da relação */
  id: Scalars['String']['output'];
  /** Pessoa responsável */
  person: TPerson;
};

export type TResponsibleActionInput = {
  /** ID do plano de ação */
  actionPlanId: Scalars['String']['input'];
  /** ID da pessoa responsável */
  personId: Scalars['String']['input'];
};

export type TResponsibleOnActionPlan = {
  __typename?: 'ResponsibleOnActionPlan';
  /** Pessoa responsável */
  person: TPerson;
};

/** Tipos de restrição */
export enum TRestrictionType {
  /** Bloqueado */
  Blocked = 'Blocked',
  /** Reservado */
  Reserved = 'Reserved'
}

export type TResultExamIbmp = {
  __typename?: 'ResultExamIbmp';
  /** Exame complementar */
  complementaryExam?: Maybe<TComplementaryExam>;
  /** Consulta */
  consultation?: Maybe<TConsultation>;
  /** CRM do médico */
  crm?: Maybe<Scalars['String']['output']>;
  /** Data do exame */
  date: Scalars['DateTime']['output'];
  /** Detalhes do exame */
  details?: Maybe<Scalars['String']['output']>;
  /** Indicador diagnóstico */
  diagnosticIndicator: TExamDiagnosticIndicatorEnum;
  /** Nome do médico */
  doctor?: Maybe<Scalars['String']['output']>;
  /** Autorização do exame */
  examAuthorization: Scalars['Boolean']['output'];
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Indicador do resultado */
  indicator: TExamResultIndicatorEnum;
  /** Observações */
  observations?: Maybe<Scalars['String']['output']>;
  /** Quantidade encontrada */
  quantityFound: Scalars['Float']['output'];
  /** Tempo de repouso */
  restTime?: Maybe<Scalars['String']['output']>;
  /** Resultado do exame */
  result: Scalars['String']['output'];
  /** Agravamento do resultado */
  resultAggravation?: Maybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: Maybe<TExamResultAlterationEnum>;
  /** Estado do CRM */
  state?: Maybe<TState>;
};

export type TResultExamIbmpForComparative = {
  __typename?: 'ResultExamIbmpForComparative';
  /** Data do exame */
  date: Scalars['DateTime']['output'];
  /** Quantidade encontrada */
  quantityFound: Scalars['Float']['output'];
};

export type TResultExamIbmpGroup = {
  __typename?: 'ResultExamIbmpGroup';
  /** Material biológico */
  biologicalMaterial: TBiologicalMaterial;
  /** Unidade de medida */
  examMeasure: Scalars['String']['output'];
  /** Resultados dos exames */
  results: Array<TResultExamIbmpForComparative>;
  /** Agente de risco */
  riskAgent: Scalars['String']['output'];
};

export type TResultExamIbmpInput = {
  /** Identificador do exame complementar */
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da consulta */
  consultationId?: InputMaybe<Scalars['String']['input']>;
  /** CRM do médico */
  crm?: InputMaybe<Scalars['String']['input']>;
  /** Data do exame */
  date: Scalars['DateTime']['input'];
  /** Detalhes do exame */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Indicador diagnóstico */
  diagnosticIndicator: TExamDiagnosticIndicatorEnum;
  /** Nome do médico */
  doctor?: InputMaybe<Scalars['String']['input']>;
  /** Autorização do exame */
  examAuthorization: Scalars['Boolean']['input'];
  /** Indicador do resultado */
  indicator: TExamResultIndicatorEnum;
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** Quantidade encontrada */
  quantityFound: Scalars['Float']['input'];
  /** Tempo de repouso */
  restTime?: InputMaybe<Scalars['String']['input']>;
  /** Resultado do exame */
  result: Scalars['String']['input'];
  /** Agravamento do resultado */
  resultAggravation?: InputMaybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: InputMaybe<TExamResultAlterationEnum>;
  /** Estado do CRM */
  state?: InputMaybe<TState>;
};

export type TResultExamIbmpUpdate = {
  /** CRM do médico */
  crm?: InputMaybe<Scalars['String']['input']>;
  /** Data do exame */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Detalhes do exame */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Indicador diagnóstico */
  diagnosticIndicator?: InputMaybe<TExamDiagnosticIndicatorEnum>;
  /** Nome do médico */
  doctor?: InputMaybe<Scalars['String']['input']>;
  /** Autorização do exame */
  examAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identificador único */
  id: Scalars['String']['input'];
  /** Indicador do resultado */
  indicator?: InputMaybe<TExamResultIndicatorEnum>;
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** Quantidade encontrada */
  quantityFound?: InputMaybe<Scalars['Float']['input']>;
  /** Tempo de repouso */
  restTime?: InputMaybe<Scalars['String']['input']>;
  /** Resultado do exame */
  result?: InputMaybe<Scalars['String']['input']>;
  /** Agravamento do resultado */
  resultAggravation?: InputMaybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: InputMaybe<TExamResultAlterationEnum>;
  /** Estado do CRM */
  state?: InputMaybe<TState>;
};

export type TResultExamItemForComparative = {
  __typename?: 'ResultExamItemForComparative';
  /** Data do exame */
  date: Scalars['DateTime']['output'];
  /** Valor */
  value: Scalars['Float']['output'];
};

export type TResultExamItemGroup = {
  __typename?: 'ResultExamItemGroup';
  /** Nome da análise */
  analysis: Scalars['String']['output'];
  /** Identificador da análise */
  analysisId: Scalars['String']['output'];
  /** Unidade de medida */
  examMeasure?: Maybe<Scalars['String']['output']>;
  /** Resultados dos exames */
  results: Array<TResultExamItemForComparative>;
};

export type TResultExamOrthoRaterForComparative = {
  __typename?: 'ResultExamOrthoRaterForComparative';
  /** Ambos os olhos de perto */
  closeBothEyes?: Maybe<TOrthoRaterValueEnum>;
  /** Foria lateral de perto */
  closeLateralPhoria?: Maybe<TPhoriaEnum>;
  /** Olho esquerdo de perto */
  closeLeftEye?: Maybe<TOrthoRaterValueEnum>;
  /** Olho direito de perto */
  closeRightEye?: Maybe<TOrthoRaterValueEnum>;
  /** Foria vertical de perto */
  closeVerticalPhoria?: Maybe<TPhoriaEnum>;
  /** Data */
  date: Scalars['DateTime']['output'];
  /** Ambos os olhos de longe */
  farBothEyes?: Maybe<TOrthoRaterValueEnum>;
  /** Foria lateral de longe */
  farLateralPhoria?: Maybe<TPhoriaEnum>;
  /** Olho esquerdo de longe */
  farLeftEye?: Maybe<TOrthoRaterValueEnum>;
  /** Olho direito de longe */
  farRightEye?: Maybe<TOrthoRaterValueEnum>;
  /** Foria vertical de longe */
  farVerticalPhoria?: Maybe<TPhoriaEnum>;
};

export type TResultExamSnellenForComparative = {
  __typename?: 'ResultExamSnellenForComparative';
  /** Valor da acuidade visual de ambos os olhos */
  bothEyes?: Maybe<TSnellenValue>;
  /** Data do exame */
  date: Scalars['DateTime']['output'];
  /** Valor da acuidade visual do olho esquerdo */
  leftEye?: Maybe<TSnellenValue>;
  /** Valor da acuidade visual do olho direito */
  rightEye?: Maybe<TSnellenValue>;
};

export type TResultExamSpirometryForComparative = {
  __typename?: 'ResultExamSpirometryForComparative';
  /** Data do exame */
  date: Scalars['DateTime']['output'];
  /** Valor medido */
  value: Scalars['Float']['output'];
};

export type TResultExamSpirometryGroup = {
  __typename?: 'ResultExamSpirometryGroup';
  /** Identificador do grupo/métrica */
  identifier: Scalars['String']['output'];
  /** Série temporal de valores */
  results: Array<TResultExamSpirometryForComparative>;
};

/** Tipo de resultado de exame */
export enum TResultTypeEnum {
  /** Audiométrico */
  Audiometric = 'Audiometric',
  /** Itens de exame */
  ExamItems = 'ExamItems',
  /** IBMP */
  Ibmp = 'IBMP',
  /** Normal */
  Normal = 'Normal',
  /** OrthoRater */
  OrthoRater = 'OrthoRater',
  /** Otológico */
  Otological = 'Otological',
  /** Snellen */
  Snellen = 'Snellen',
  /** Espirometria */
  Spirometry = 'Spirometry',
  /** Toxicológico */
  Toxicological = 'Toxicological',
  /** Urinálise */
  Urinalysis = 'Urinalysis',
  /** Raio-X */
  XRay = 'XRay'
}

export type TResultUrinalysisForComparative = {
  __typename?: 'ResultUrinalysisForComparative';
  /** Data do exame */
  date: Scalars['DateTime']['output'];
  /** Rótulo do resultado */
  label: Scalars['String']['output'];
  /** Valor do resultado */
  value: Scalars['Float']['output'];
};

export type TResultUrinalysisGroup = {
  __typename?: 'ResultUrinalysisGroup';
  /** Identificador do grupo */
  identifier: Scalars['String']['output'];
  /** Resultados do grupo */
  results: Array<TResultUrinalysisForComparative>;
};

/** Motivo de retorno */
export enum TReturnReason {
  /** Demissão */
  Dismissal = 'Dismissal',
  /** Mudança de função */
  FunctionChange = 'FunctionChange',
  /** Restrição médica */
  MedicalRestriction = 'MedicalRestriction',
  /** Afastamento previdenciário */
  SocialSecurityLeave = 'SocialSecurityLeave',
  /** Temporário */
  Temporary = 'Temporary'
}

export type TReturnReasonsChart = {
  __typename?: 'ReturnReasonsChart';
  /** Devoluções por demissão */
  dismissal: Scalars['Float']['output'];
  /** Devoluções por mudança de função */
  functionChange: Scalars['Float']['output'];
  /** Indica se existem entregas de IPE */
  hasIpeDeliveries: Scalars['Boolean']['output'];
  /** Devoluções por restrição médica */
  medicalRestriction: Scalars['Float']['output'];
  /** Devoluções por afastamento previdenciário */
  socialSecurityLeave: Scalars['Float']['output'];
  /** Devoluções temporárias */
  temporary: Scalars['Float']['output'];
};

export type TRisk = {
  __typename?: 'Risk';
  actionLevel?: Maybe<Scalars['Float']['output']>;
  agent: TRiskAgent;
  attachments?: Maybe<Array<TAttachment>>;
  category?: Maybe<TRiskCategory>;
  classification?: Maybe<TRiskClassification>;
  composition?: Maybe<TRiskComposition>;
  consider?: Maybe<TConsiderPrint>;
  controlMeasures?: Maybe<Array<TControlMeasureByRisk>>;
  costCenters?: Maybe<Array<TCostCenterByRisk>>;
  createdAt: Scalars['DateTime']['output'];
  damageCaused?: Maybe<Scalars['String']['output']>;
  dangerousEvent?: Maybe<Scalars['String']['output']>;
  departments?: Maybe<Array<TDepartmentByRisk>>;
  desiredSituation?: Maybe<Scalars['String']['output']>;
  elimination?: Maybe<TRiskElimination>;
  eliminationDate?: Maybe<Scalars['DateTime']['output']>;
  environment: TPhysicalEnvironment;
  ergonomicStatus?: Maybe<TErgonomicStatus>;
  erpId?: Maybe<Scalars['String']['output']>;
  errorIntegration?: Maybe<Scalars['String']['output']>;
  exams?: Maybe<Array<TExamByRisk>>;
  exchangePeriodicity?: Maybe<Scalars['Boolean']['output']>;
  exhibitionType?: Maybe<TExhibitionType>;
  expirationDate?: Maybe<Scalars['Boolean']['output']>;
  exposureGroup?: Maybe<TExposureGroup>;
  exposureGroupId?: Maybe<Scalars['String']['output']>;
  exposureTime?: Maybe<Scalars['String']['output']>;
  generatingSource: TGeneratingSource;
  id: Scalars['String']['output'];
  intensity?: Maybe<TRiskIntensity>;
  interval?: Maybe<Scalars['String']['output']>;
  ipes?: Maybe<Array<TIpeByRisk>>;
  isQualitative?: Maybe<Scalars['Boolean']['output']>;
  justification?: Maybe<Scalars['String']['output']>;
  lastMeasurement?: Maybe<TMeasurementByRisk>;
  legalFramework?: Maybe<Scalars['String']['output']>;
  levelControl?: Maybe<Scalars['Float']['output']>;
  maxExposureTime?: Maybe<Scalars['String']['output']>;
  measureType?: Maybe<TRiskMeasureType>;
  measurements?: Maybe<Array<TMeasurementByRisk>>;
  methodology?: Maybe<Scalars['String']['output']>;
  needCpe?: Maybe<Scalars['Boolean']['output']>;
  needIpe?: Maybe<Scalars['Boolean']['output']>;
  occupations?: Maybe<Array<TOccupationByRisk>>;
  organizationalControl?: Maybe<TRiskOrganizationalControl>;
  persons?: Maybe<Array<TPersonByRisk>>;
  printSWO?: Maybe<Scalars['Boolean']['output']>;
  probability?: Maybe<TRiskProbability>;
  processNumber?: Maybe<Scalars['String']['output']>;
  protectionMeasure?: Maybe<Scalars['Boolean']['output']>;
  recognitionDate: Scalars['DateTime']['output'];
  repetition?: Maybe<Scalars['String']['output']>;
  riskDegree?: Maybe<TRiskDegree>;
  riskMap?: Maybe<TRiskMap>;
  sanitation?: Maybe<Scalars['Boolean']['output']>;
  severity?: Maybe<TRiskSeverity>;
  situationFound?: Maybe<Scalars['String']['output']>;
  specialRetirement?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<Array<TTaskByRisk>>;
  techniqueUsed?: Maybe<Scalars['String']['output']>;
  tecnicalControl?: Maybe<TRiskTecnicalControl>;
  trainings?: Maybe<Array<TTrainingByRisk>>;
  uninterruptedUse?: Maybe<Scalars['Boolean']['output']>;
  unitMeasurement?: Maybe<TRiskMeasure>;
  updatedAt: Scalars['DateTime']['output'];
  usesExposureGroup: Scalars['Boolean']['output'];
  workingCondition?: Maybe<Scalars['Boolean']['output']>;
};

export type TRiskAgent = {
  __typename?: 'RiskAgent';
  /** Nível de ação */
  actionLevel?: Maybe<Scalars['Float']['output']>;
  /** Substância Ativa */
  activeSubstance?: Maybe<Scalars['String']['output']>;
  /** Agente bônus */
  bonus?: Maybe<TAgentBonus>;
  /** Classificação do agente */
  classification?: Maybe<TAgentClassification>;
  /** Considerar no PCA */
  considerInPca?: Maybe<Scalars['Boolean']['output']>;
  /** Descrição do agente */
  description: Scalars['String']['output'];
  /** Resistência */
  endurance?: Maybe<Scalars['String']['output']>;
  /** Entrada */
  entrance?: Maybe<Scalars['String']['output']>;
  /** Avaliação do agente */
  evaluation: TAgentEvaluation;
  /** Grupo do agente */
  group: TAgentGroup;
  /** ID do agente de risco */
  id: Scalars['String']['output'];
  /** Indica se está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Patogenicidade */
  pathogenicity?: Maybe<Scalars['String']['output']>;
  /** Propagação */
  propagation?: Maybe<Scalars['String']['output']>;
  /** Agente de risco genérico vinculado */
  riskAgent?: Maybe<TGenericRiskAgent>;
  /** Fonte */
  source?: Maybe<Scalars['String']['output']>;
  /** Estudo */
  study?: Maybe<Scalars['String']['output']>;
  /** Sugestão para o agente */
  suggestion: Scalars['String']['output'];
  /** Sintomatologia */
  symptomatology?: Maybe<Scalars['String']['output']>;
  /** Transmissibilidade */
  transmissibility?: Maybe<Scalars['String']['output']>;
  /** Formas de transmissão */
  transmissionWays?: Maybe<Scalars['String']['output']>;
  /** Virulênca */
  virulence?: Maybe<Scalars['String']['output']>;
};

export type TRiskAgentInput = {
  /** Nível de ação */
  actionLevel?: InputMaybe<Scalars['Float']['input']>;
  /** Substância Ativa */
  activeSubstance?: InputMaybe<Scalars['String']['input']>;
  /** Agente bônus */
  bonus?: InputMaybe<TAgentBonus>;
  /** Classificação do agente */
  classification?: InputMaybe<TAgentClassification>;
  /** Considerar no PCA */
  considerInPca?: InputMaybe<Scalars['Boolean']['input']>;
  /** Descrição do agente */
  description: Scalars['String']['input'];
  /** Resistência */
  endurance?: InputMaybe<Scalars['String']['input']>;
  /** Entrada */
  entrance?: InputMaybe<Scalars['String']['input']>;
  /** Avaliação do agente */
  evaluation: TAgentEvaluation;
  /** Grupo do agente */
  group: TAgentGroup;
  /** Patogenicidade */
  pathogenicity?: InputMaybe<Scalars['String']['input']>;
  /** Propagação */
  propagation?: InputMaybe<Scalars['String']['input']>;
  /** ID de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Fonte */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Estudo */
  study?: InputMaybe<Scalars['String']['input']>;
  /** Sugestão */
  suggestion?: InputMaybe<Scalars['String']['input']>;
  /** Sintomatologia */
  symptomatology?: InputMaybe<Scalars['String']['input']>;
  /** Transmissibilidade */
  transmissibility?: InputMaybe<Scalars['String']['input']>;
  /** Formas de transmissão */
  transmissionWays?: InputMaybe<Scalars['String']['input']>;
  /** Virulênca */
  virulence?: InputMaybe<Scalars['String']['input']>;
};

export type TRiskAgentUpdate = {
  /** Nível de ação */
  actionLevel?: InputMaybe<Scalars['Float']['input']>;
  /** Substância Ativa */
  activeSubstance?: InputMaybe<Scalars['String']['input']>;
  /** Agente bônus */
  bonus?: InputMaybe<TAgentBonus>;
  /** Classificação do agente */
  classification?: InputMaybe<TAgentClassification>;
  /** Considerar no PCA */
  considerInPca?: InputMaybe<Scalars['Boolean']['input']>;
  /** Descrição do agente */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Resistência */
  endurance?: InputMaybe<Scalars['String']['input']>;
  /** Entrada */
  entrance?: InputMaybe<Scalars['String']['input']>;
  /** Avaliação do agente */
  evaluation?: InputMaybe<TAgentEvaluation>;
  /** Grupo do agente */
  group?: InputMaybe<TAgentGroup>;
  /** ID do agente */
  id: Scalars['String']['input'];
  /** Indica se está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Patogenicidade */
  pathogenicity?: InputMaybe<Scalars['String']['input']>;
  /** Propagação */
  propagation?: InputMaybe<Scalars['String']['input']>;
  /** ID de referência */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Fonte */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Estudo */
  study?: InputMaybe<Scalars['String']['input']>;
  /** Sugestão */
  suggestion?: InputMaybe<Scalars['String']['input']>;
  /** Sintomatologia */
  symptomatology?: InputMaybe<Scalars['String']['input']>;
  /** Transmissibilidade */
  transmissibility?: InputMaybe<Scalars['String']['input']>;
  /** Formas de transmissão */
  transmissionWays?: InputMaybe<Scalars['String']['input']>;
  /** Virulênca */
  virulence?: InputMaybe<Scalars['String']['input']>;
};

export type TRiskByEnvironmentInput = {
  agentGroup?: InputMaybe<TAgentGroup>;
  environmentId: Scalars['String']['input'];
  riskDegree?: InputMaybe<TRiskDegree>;
};

/** Categoria de risco */
export enum TRiskCategory {
  /** Atenção */
  Attention = 'Attention',
  /** Crítico */
  Critical = 'Critical',
  /** Intolerável */
  Intolerable = 'Intolerable',
  /** Irrelevante */
  Irrelevant = 'Irrelevant'
}

export type TRiskCharacterization = {
  __typename?: 'RiskCharacterization';
  costCenters: Array<Scalars['String']['output']>;
  departments: Array<Scalars['String']['output']>;
  emptyGHE: Scalars['Boolean']['output'];
  occupations: Array<Scalars['String']['output']>;
  people: Array<Scalars['String']['output']>;
  tasks: Array<Scalars['String']['output']>;
};

export type TRiskChart = {
  __typename?: 'RiskChart';
  /** Indica se existem riscos */
  hasRisk: Scalars['Boolean']['output'];
  /** Dados de contagem de riscos */
  riskCountData: Array<TData>;
  /** Riscos por total */
  riskPerTotal: Array<TData>;
};

/** Classificação do risco */
export enum TRiskClassification {
  /** Intolerável */
  Intolerable = 'Intolerable',
  /** Moderado */
  Moderate = 'Moderate',
  /** Substancial */
  Substantial = 'Substantial',
  /** Tolerável */
  Tolerable = 'Tolerable',
  /** Trivial */
  Trivial = 'Trivial'
}

export type TRiskClassificationTable = {
  __typename?: 'RiskClassificationTable';
  /** Quantidade de riscos intoleráveis */
  intolerable: Scalars['Float']['output'];
  /** Quantidade de riscos moderados */
  moderate: Scalars['Float']['output'];
  /** Quantidade de riscos substanciais */
  substantial: Scalars['Float']['output'];
  /** Quantidade de riscos toleráveis */
  tolerable: Scalars['Float']['output'];
  /** Quantidade de riscos triviais */
  trivial: Scalars['Float']['output'];
};

export type TRiskComposition = {
  __typename?: 'RiskComposition';
  /** Coordenada X no mapa */
  coordinateX: Scalars['Float']['output'];
  /** Coordenada Y no mapa */
  coordinateY: Scalars['Float']['output'];
  /** ID da composição de riscos */
  id: Scalars['String']['output'];
  /** Lista de riscos da composição */
  risks: Array<TRisk>;
};

export type TRiskCompositionInput = {
  /** Coordenada X no mapa */
  coordinateX: Scalars['Float']['input'];
  /** Coordenada Y no mapa */
  coordinateY: Scalars['Float']['input'];
  /** ID da composição */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Grau de risco da composição */
  riskDegree: TRiskDegree;
  /** IDs dos riscos da composição */
  riskIds: Array<Scalars['String']['input']>;
};

export type TRiskCompositionSave = {
  /** Lista de composições de risco */
  compositions: Array<TRiskCompositionInput>;
  /** ID do ambiente físico */
  environmentId: Scalars['String']['input'];
};

export type TRiskControlMeasure = {
  __typename?: 'RiskControlMeasure';
  riskAgent: Scalars['String']['output'];
  riskControl: Scalars['String']['output'];
};

export type TRiskCostCenterOccupation = {
  __typename?: 'RiskCostCenterOccupation';
  /** Descrição do centro de custo */
  costCenterDescription: Scalars['String']['output'];
  /** Descrição da ocupação */
  occupationDescription: Scalars['String']['output'];
  /** Informações dos riscos */
  risksInfo?: Maybe<Array<TRisksInfo>>;
};

export type TRiskCostCenterOccupationIds = {
  __typename?: 'RiskCostCenterOccupationIds';
  /** ID do centro de custo */
  costCenterId: Scalars['String']['output'];
  /** ID da ocupação */
  occupationId: Scalars['String']['output'];
};

export type TRiskCount = {
  __typename?: 'RiskCount';
  active: Scalars['Float']['output'];
  eliminated: Scalars['Float']['output'];
};

export type TRiskDashboard = {
  __typename?: 'RiskDashboard';
  /** Matriz pura de classificação */
  classificationPure: TClassificationPure;
  /** Gráfico de medidas de controle aplicadas */
  controlMeasuresAppliedChart: TRiskPieChart;
  /** Gráfico de medidas de controle */
  controlMeasuresChart: TControlMeasuresChart;
  /** Gráfico de riscos por centro de custo */
  costCenterChart: TRiskChart;
  /** Gráfico de riscos por departamento */
  departmentChart: TRiskChart;
  /** Incidência de riscos com necessidade de EPC */
  epcIncidenceChart: TEpcIncidenceChart;
  /** Gráfico de IPEs */
  ipesChart: TRiskPieChart;
  /** Aparelhos de medição mais utilizados */
  measurementDevicesChart: TMeasurementDevicesChart;
  /** Gráfico de riscos por ocupação */
  occupationChart: TRiskChart;
  /** Tabela de classificação de riscos */
  riskClassification: TRiskClassificationTable;
  /** Tabela de probabilidade de riscos */
  riskProbability: TRiskProbabilityTable;
  /** Tabela de severidade de riscos */
  riskSeverity: TRiskSeverityTable;
  /** Gráfico de riscos por agente */
  risksAgentChart: TRiskPieChart;
  /** Gráfico de riscos por tipo de agente */
  risksAgentTypeChart: TAgentGroupChart;
  /** Gráfico de riscos por ambiente */
  risksPerEnvironmentChart: TRisksPerEnvironmentChart;
  /** Gráfico de riscos por tarefa */
  taskChart: TRiskChart;
};

/** Grau de risco */
export enum TRiskDegree {
  /** Grande */
  Large = 'Large',
  /** Médio */
  Medium = 'Medium',
  /** Pequeno */
  Small = 'Small'
}

/** Eliminação do risco */
export enum TRiskElimination {
  /** Não */
  No = 'No',
  /** Não se aplica */
  NotApplicable = 'NotApplicable',
  /** Sim */
  Yes = 'Yes'
}

export type TRiskEnvironment = {
  __typename?: 'RiskEnvironment';
  descriptionPE: Scalars['String']['output'];
  descriptionRA: Scalars['String']['output'];
};

export type TRiskFilter = {
  agentTypes?: InputMaybe<Array<TAgentGroup>>;
  agents?: InputMaybe<Array<Scalars['String']['input']>>;
  consider?: InputMaybe<Array<TConsiderPrint>>;
  costCenters?: InputMaybe<Array<Scalars['String']['input']>>;
  departments?: InputMaybe<Array<Scalars['String']['input']>>;
  eliminationDates?: InputMaybe<TDateRange>;
  environments?: InputMaybe<Array<Scalars['String']['input']>>;
  exposureGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  indicator?: InputMaybe<Array<TRiskIndicator>>;
  measurements?: InputMaybe<TDateRange>;
  occupations?: InputMaybe<Array<Scalars['String']['input']>>;
  recognitionDates?: InputMaybe<TDateRange>;
  riskDegrees?: InputMaybe<Array<TRiskDegree>>;
};

/** Indicador de risco */
export enum TRiskIndicator {
  /** Ativo */
  Active = 'Active',
  /** Eliminado */
  Eliminated = 'Eliminated'
}

export type TRiskInput = {
  actionLevel?: InputMaybe<Scalars['Float']['input']>;
  /** ID do agente de risco */
  agentId: Scalars['String']['input'];
  category?: InputMaybe<TRiskCategory>;
  classification?: InputMaybe<TRiskClassification>;
  consider?: InputMaybe<TConsiderPrint>;
  controlMeasures?: InputMaybe<Array<TControlMeasureOnRiskInput>>;
  costCenters?: InputMaybe<Array<TCostCenterOnRiskInput>>;
  damageCaused?: InputMaybe<Scalars['String']['input']>;
  dangerousEvent?: InputMaybe<Scalars['String']['input']>;
  departments?: InputMaybe<Array<TDepartmentOnRiskInput>>;
  desiredSituation?: InputMaybe<Scalars['String']['input']>;
  elimination?: InputMaybe<TRiskElimination>;
  eliminationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID do ambiente físico */
  environmentId: Scalars['String']['input'];
  ergonomicStatus?: InputMaybe<TErgonomicStatus>;
  erpId?: InputMaybe<Scalars['String']['input']>;
  exams?: InputMaybe<Array<TExamByRiskInput>>;
  exchangePeriodicity?: InputMaybe<Scalars['Boolean']['input']>;
  exhibitionType?: InputMaybe<TExhibitionType>;
  expirationDate?: InputMaybe<Scalars['Boolean']['input']>;
  exposureGroupId?: InputMaybe<Scalars['String']['input']>;
  exposureTime?: InputMaybe<Scalars['String']['input']>;
  /** ID da fonte geradora */
  generatingSourceId: Scalars['String']['input'];
  intensity?: InputMaybe<TRiskIntensity>;
  interval?: InputMaybe<Scalars['String']['input']>;
  ipes?: InputMaybe<Array<TIpeOnRiskInput>>;
  isQualitative?: InputMaybe<Scalars['Boolean']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  legalFramework?: InputMaybe<Scalars['String']['input']>;
  levelControl?: InputMaybe<Scalars['Float']['input']>;
  maxExposureTime?: InputMaybe<Scalars['String']['input']>;
  measureType?: InputMaybe<TRiskMeasureType>;
  measurements?: InputMaybe<Array<TMeasurementOnRiskInput>>;
  methodology?: InputMaybe<Scalars['String']['input']>;
  needCpe?: InputMaybe<Scalars['Boolean']['input']>;
  needIpe?: InputMaybe<Scalars['Boolean']['input']>;
  occupations?: InputMaybe<Array<TOccupationOnRiskInput>>;
  organizationalControl?: InputMaybe<TRiskOrganizationalControl>;
  persons?: InputMaybe<Array<TPersonOnRiskInput>>;
  printSWO?: InputMaybe<Scalars['Boolean']['input']>;
  probability?: InputMaybe<TRiskProbability>;
  processNumber?: InputMaybe<Scalars['String']['input']>;
  protectionMeasure?: InputMaybe<Scalars['Boolean']['input']>;
  /** Data de reconhecimento do risco */
  recognitionDate: Scalars['DateTime']['input'];
  repetition?: InputMaybe<Scalars['String']['input']>;
  riskDegree?: InputMaybe<TRiskDegree>;
  riskMap?: InputMaybe<TRiskMap>;
  sanitation?: InputMaybe<Scalars['Boolean']['input']>;
  severity?: InputMaybe<TRiskSeverity>;
  situationFound?: InputMaybe<Scalars['String']['input']>;
  specialRetirement?: InputMaybe<Scalars['Boolean']['input']>;
  tasks?: InputMaybe<Array<TTaskOnRiskInput>>;
  techniqueUsed?: InputMaybe<Scalars['String']['input']>;
  tecnicalControl?: InputMaybe<TRiskTecnicalControl>;
  trainings?: InputMaybe<Array<TTrainingOnRiskInput>>;
  uninterruptedUse?: InputMaybe<Scalars['Boolean']['input']>;
  unitMeasurement?: InputMaybe<TRiskMeasure>;
  usesExposureGroup: Scalars['Boolean']['input'];
  workingCondition?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Intensidade do risco */
export enum TRiskIntensity {
  /** 40% */
  Forty = 'Forty',
  /** Não se aplica */
  NotTypify = 'NotTypify',
  /** 10% */
  Ten = 'Ten',
  /** 30% */
  Thirty = 'Thirty',
  /** 20% */
  Twenty = 'Twenty'
}

/** Mapa de risco */
export enum TRiskMap {
  /** Ambos */
  Both = 'Both',
  /** CIPA */
  Cipa = 'CIPA',
  /** SESMT */
  Sesmt = 'SESMT'
}

/** Unidade de medida do risco */
export enum TRiskMeasure {
  /** Número adimensional */
  NumeroAdimensional = 'NumeroAdimensional',
  /** A/m */
  AM = 'aM',
  /** atm */
  Atm = 'atm',
  /** dB(A) */
  DBa = 'dBA',
  /** dB(C) */
  DBc = 'dBC',
  /** dB (linear) */
  DBLinear = 'dBLinear',
  /** Dose anual */
  DoseAnual = 'doseAnual',
  /** Dose diária */
  DoseDiaria = 'doseDiaria',
  /** Dose mensal */
  DoseMensal = 'doseMensal',
  /** Dose trimestral */
  DoseTrimestral = 'doseTrimestral',
  /** μT */
  EmiT = 'emiT',
  /** f/cm3 */
  FCm3 = 'fCm3',
  /** GHz */
  Ghz = 'ghz',
  /** Gy */
  Gy = 'gy',
  /** h */
  H = 'h',
  /** Hz */
  Hz = 'hz',
  /** J/m2 */
  JM2 = 'jM2',
  /** kcal/h */
  KCalH = 'kCalH',
  /** kHz */
  KHz = 'kHz',
  /** kgf/cm2 */
  KgfCm2 = 'kgfCm2',
  /** kV/m */
  KvM = 'kvM',
  /** lx */
  Lx = 'lx',
  /** mA */
  MA = 'mA',
  /** m/s */
  MS = 'mS',
  /** m/s2 */
  MS2 = 'mS2',
  /** m/s1,75 */
  MS175 = 'mS175',
  /** mSv */
  MSv = 'mSv',
  /** mT */
  MT = 'mT',
  /** mW */
  MW = 'mW',
  /** mg/m3 */
  MgM3 = 'mgM3',
  /** min */
  Min = 'min',
  /** mJ/cm2 */
  MjCm2 = 'mjCm2',
  /** mppdc */
  Mppdc = 'mppdc',
  /** N/A */
  NA = 'nA',
  /** nm */
  Nm = 'nm',
  /** oC */
  OC = 'oC',
  /** % */
  Percentual = 'percentual',
  /** ppm */
  Ppm = 'ppm',
  /** Sv */
  Sv = 'sv',
  /** ufc/m3 */
  UfcM3 = 'ufcM3',
  /** UR (%) */
  Ur = 'ur',
  /** V/m */
  VM = 'vM',
  /** W */
  W = 'w',
  /** W/m2 */
  WM2 = 'wM2'
}

/** Tipo de comparação da medição do risco */
export enum TRiskMeasureType {
  /** Acima */
  Above = 'above',
  /** Acima ou igual */
  AboveOrEqual = 'aboveOrEqual',
  /** Abaixo */
  Below = 'below',
  /** Abaixo ou igual */
  BelowOrEqual = 'belowOrEqual',
  /** Igual */
  Equal = 'equal',
  /** Não se aplica */
  Na = 'na'
}

export type TRiskMeasurement = {
  __typename?: 'RiskMeasurement';
  /** Nome do agente */
  agent: Scalars['String']['output'];
  /** Situação desejada */
  desiredSituation: Scalars['String']['output'];
  /** Status ergonômico */
  ergonomicStatus: TErgonomicStatus;
  /** Nome da medida */
  nameMeasure: Scalars['String']['output'];
  /** Situação encontrada */
  situationFound: Scalars['String']['output'];
};

export type TRiskMeasurements = {
  __typename?: 'RiskMeasurements';
  description: Scalars['String']['output'];
  measurements: Array<TMeasurements>;
};

/** Campos de ordenação de riscos */
export enum TRiskOrderByFields {
  /** Agente */
  Agent = 'Agent',
  /** Tipo de agente */
  AgentType = 'AgentType',
  /** Centro de custo */
  CostCenter = 'CostCenter',
  /** Departamento */
  Department = 'Department',
  /** Data de eliminação */
  EliminationDate = 'EliminationDate',
  /** Medição */
  Measurement = 'Measurement',
  /** Ocupação */
  Occupation = 'Occupation',
  /** Ambiente físico */
  PhysicalEnvironment = 'PhysicalEnvironment',
  /** Data de reconhecimento */
  RecognitionDate = 'RecognitionDate',
  /** Data de atualização */
  UpdatedDate = 'UpdatedDate'
}

export type TRiskOrderByInput = {
  field?: InputMaybe<TRiskOrderByFields>;
  type?: InputMaybe<TOrderBy>;
};

/** Controle organizacional do risco */
export enum TRiskOrganizationalControl {
  /** Não */
  No = 'No',
  /** Não se aplica */
  NotApplicable = 'NotApplicable',
  /** Sim */
  Yes = 'Yes'
}

export type TRiskPieChart = {
  __typename?: 'RiskPieChart';
  /** Dados */
  data: Array<TPieChart>;
  /** Indica se existem riscos */
  hasRisk: Scalars['Boolean']['output'];
};

/** Probabilidade do risco */
export enum TRiskProbability {
  /** Alta */
  High = 'High',
  /** Intermediária */
  Intermediate = 'Intermediate',
  /** Baixa */
  Low = 'Low',
  /** Mediana */
  Medium = 'Medium',
  /** Altíssima */
  VeryHigh = 'VeryHigh'
}

export type TRiskProbabilityTable = {
  __typename?: 'RiskProbabilityTable';
  /** Quantidade de riscos de probabilidade alta */
  high: Scalars['Float']['output'];
  /** Quantidade de riscos de probabilidade intermediária */
  intermediate: Scalars['Float']['output'];
  /** Quantidade de riscos de probabilidade baixa */
  low: Scalars['Float']['output'];
  /** Quantidade de riscos de probabilidade média */
  medium: Scalars['Float']['output'];
  /** Quantidade de riscos de probabilidade muito alta */
  veryHigh: Scalars['Float']['output'];
};

export type TRiskQueryInput = {
  filter?: InputMaybe<TRiskFilter>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TRiskReviewReportFields = {
  __typename?: 'RiskReviewReportFields';
  environment: Scalars['String']['output'];
  hazard: Scalars['String']['output'];
  lastAssessment: Scalars['String']['output'];
  noData: Scalars['String']['output'];
  recognitionDate: Scalars['String']['output'];
  sourceGenerator: Scalars['String']['output'];
};

/** Gravidade do risco */
export enum TRiskSeverity {
  /** Intermediária */
  Intermediate = 'Intermediate',
  /** Leve */
  Mild = 'Mild',
  /** Moderado */
  Moderate = 'Moderate',
  /** Grave */
  Severe = 'Severe',
  /** Gravíssima */
  VerySevere = 'VerySevere'
}

export type TRiskSeverityTable = {
  __typename?: 'RiskSeverityTable';
  /** Quantidade de riscos de severidade intermediária */
  intermediate: Scalars['Float']['output'];
  /** Quantidade de riscos de severidade leve */
  mild: Scalars['Float']['output'];
  /** Quantidade de riscos de severidade moderada */
  moderate: Scalars['Float']['output'];
  /** Quantidade de riscos de severidade severa */
  severe: Scalars['Float']['output'];
  /** Quantidade de riscos de severidade muito severa */
  verySevere: Scalars['Float']['output'];
};

export type TRiskSuggestion = {
  __typename?: 'RiskSuggestion';
  /** Rótulo da sugestão */
  label: Scalars['String']['output'];
  /** Valor da sugestão */
  value: Scalars['String']['output'];
};

/** Controle técnico de risco */
export enum TRiskTecnicalControl {
  /** Não */
  No = 'No',
  /** Não aplicável */
  NotApplicable = 'NotApplicable',
  /** Sim */
  Yes = 'Yes'
}

export type TRiskToReview = {
  __typename?: 'RiskToReview';
  agent: Scalars['String']['output'];
  environment: Scalars['String']['output'];
  lastMeasurement?: Maybe<Scalars['String']['output']>;
  recognitionDate: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type TRiskToReviewReport = {
  __typename?: 'RiskToReviewReport';
  address: Scalars['String']['output'];
  cnpj: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  fields: TRiskReviewReportFields;
  footer: Scalars['String']['output'];
  risks: Array<TRiskToReview>;
  telephone: Scalars['String']['output'];
};

export type TRiskTrainings = {
  __typename?: 'RiskTrainings';
  training: Scalars['String']['output'];
};

export type TRiskUpdate = {
  actionLevel?: InputMaybe<Scalars['Float']['input']>;
  /** ID do agente de risco */
  agentId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<TRiskCategory>;
  classification?: InputMaybe<TRiskClassification>;
  /** ID da composição */
  compositionId?: InputMaybe<Scalars['String']['input']>;
  consider?: InputMaybe<TConsiderPrint>;
  controlMeasures?: InputMaybe<TControlMeasureOnRiskUpdate>;
  costCenters?: InputMaybe<Array<TCostCenterOnRiskInput>>;
  damageCaused?: InputMaybe<Scalars['String']['input']>;
  dangerousEvent?: InputMaybe<Scalars['String']['input']>;
  departments?: InputMaybe<Array<TDepartmentOnRiskInput>>;
  desiredSituation?: InputMaybe<Scalars['String']['input']>;
  elimination?: InputMaybe<TRiskElimination>;
  eliminationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID do ambiente físico */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  ergonomicStatus?: InputMaybe<TErgonomicStatus>;
  exams?: InputMaybe<TExamByRiskChanges>;
  exchangePeriodicity?: InputMaybe<Scalars['Boolean']['input']>;
  exhibitionType?: InputMaybe<TExhibitionType>;
  expirationDate?: InputMaybe<Scalars['Boolean']['input']>;
  exposureGroupId?: InputMaybe<Scalars['String']['input']>;
  exposureTime?: InputMaybe<Scalars['String']['input']>;
  /** ID da fonte geradora */
  generatingSourceId?: InputMaybe<Scalars['String']['input']>;
  /** ID do risco */
  id: Scalars['String']['input'];
  intensity?: InputMaybe<TRiskIntensity>;
  interval?: InputMaybe<Scalars['String']['input']>;
  ipes?: InputMaybe<TIpeOnRiskUpdate>;
  isQualitative?: InputMaybe<Scalars['Boolean']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  /** Última medição do risco */
  lastMeasurement?: InputMaybe<TLastMeasurementByRiskUpdate>;
  legalFramework?: InputMaybe<Scalars['String']['input']>;
  levelControl?: InputMaybe<Scalars['Float']['input']>;
  maxExposureTime?: InputMaybe<Scalars['String']['input']>;
  measureType?: InputMaybe<TRiskMeasureType>;
  measurements?: InputMaybe<TMeasurementOnRiskUpdate>;
  methodology?: InputMaybe<Scalars['String']['input']>;
  needCpe?: InputMaybe<Scalars['Boolean']['input']>;
  needIpe?: InputMaybe<Scalars['Boolean']['input']>;
  occupations?: InputMaybe<Array<TOccupationOnRiskInput>>;
  organizationalControl?: InputMaybe<TRiskOrganizationalControl>;
  persons?: InputMaybe<Array<TPersonOnRiskInput>>;
  printSWO?: InputMaybe<Scalars['Boolean']['input']>;
  probability?: InputMaybe<TRiskProbability>;
  processNumber?: InputMaybe<Scalars['String']['input']>;
  protectionMeasure?: InputMaybe<Scalars['Boolean']['input']>;
  /** Data de reconhecimento do risco */
  recognitionDate?: InputMaybe<Scalars['DateTime']['input']>;
  repetition?: InputMaybe<Scalars['String']['input']>;
  riskDegree?: InputMaybe<TRiskDegree>;
  riskMap?: InputMaybe<TRiskMap>;
  sanitation?: InputMaybe<Scalars['Boolean']['input']>;
  severity?: InputMaybe<TRiskSeverity>;
  situationFound?: InputMaybe<Scalars['String']['input']>;
  specialRetirement?: InputMaybe<Scalars['Boolean']['input']>;
  tasks?: InputMaybe<Array<TTaskOnRiskInput>>;
  techniqueUsed?: InputMaybe<Scalars['String']['input']>;
  tecnicalControl?: InputMaybe<TRiskTecnicalControl>;
  trainings?: InputMaybe<TTrainingOnRiskUpdate>;
  uninterruptedUse?: InputMaybe<Scalars['Boolean']['input']>;
  unitMeasurement?: InputMaybe<TRiskMeasure>;
  usesExposureGroup?: InputMaybe<Scalars['Boolean']['input']>;
  workingCondition?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TRisksExam = {
  __typename?: 'RisksExam';
  /** Exame de admissão */
  admission: Scalars['String']['output'];
  /** Exame de retorno ao trabalho */
  backToWork: Scalars['String']['output'];
  /** Exame de mudança de função */
  changeOfFunction: Scalars['String']['output'];
  /** Exame demissional */
  dismissal: Scalars['String']['output'];
  /** Descrição do exame */
  examDescription: Scalars['String']['output'];
  /** Periodicidade do exame */
  periodicity: Scalars['String']['output'];
  /** Dias pós-admissão */
  postAdmission: Scalars['Float']['output'];
};

export type TRisksInfo = {
  __typename?: 'RisksInfo';
  /** Descrição do agente */
  agentDescription: Scalars['String']['output'];
  /** Grupo do agente de risco */
  agentGroup: Scalars['String']['output'];
  /** Medidas de controle */
  controlMesures?: Maybe<Scalars['String']['output']>;
  /** Exames relacionados ao risco */
  risksExams?: Maybe<Array<TRisksExam>>;
};

export type TRisksPerEnvironmentChart = {
  __typename?: 'RisksPerEnvironmentChart';
  /** Riscos por associação por ambiente */
  association: Array<TData>;
  /** Riscos biológicos por ambiente */
  biological: Array<TData>;
  /** Riscos químicos por ambiente */
  chemical: Array<TData>;
  /** Riscos perigosos por ambiente */
  dangerous: Array<TData>;
  /** Ambientes por total */
  enviromentsPerTotal: Array<TData>;
  /** Riscos ergonômicos por ambiente */
  ergonomic: Array<TData>;
  /** Indica se existem riscos */
  hasRisk: Scalars['Boolean']['output'];
  /** Riscos mecânicos por ambiente */
  mechanical: Array<TData>;
  /** Outros riscos por ambiente */
  other: Array<TData>;
  /** Riscos físicos por ambiente */
  physical: Array<TData>;
};

export type TRole = {
  __typename?: 'Role';
  /** Filial */
  branch: TBranch;
  /** ID da filial */
  branchId: Scalars['String']['output'];
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** ID do perfil */
  roleId: Scalars['String']['output'];
  /** ID do usuário */
  userId: Scalars['String']['output'];
};

export type TRolePermission = {
  __typename?: 'RolePermission';
  /** Descrição da permissão do cargo */
  description: Scalars['String']['output'];
  /** Hora de término */
  endHour?: Maybe<Scalars['String']['output']>;
  /** ID da permissão do cargo */
  id: Scalars['String']['output'];
  /** Lista de permissões */
  permission: Array<TPermission>;
  /** Permissão genérica de referência */
  reference: TGenericRolePermission;
  /** ID de referência */
  referenceId: Scalars['String']['output'];
  /** Hora de início */
  startHour?: Maybe<Scalars['String']['output']>;
};

export type TRolePermissionInput = {
  /** Descrição da permissão do cargo */
  description: Scalars['String']['input'];
  /** Hora de término */
  endHour?: InputMaybe<Scalars['String']['input']>;
  /** Lista de permissões */
  permission: Array<TPermissionInput>;
  /** ID de referência */
  referenceId: Scalars['String']['input'];
  /** Hora de início */
  startHour?: InputMaybe<Scalars['String']['input']>;
};

export type TRolePermissionUpdate = {
  /** Descrição da permissão do cargo */
  description: Scalars['String']['input'];
  /** Hora de término */
  endHour?: InputMaybe<Scalars['String']['input']>;
  /** ID da permissão do cargo */
  id: Scalars['String']['input'];
  /** Lista de permissões */
  permission: Array<TPermissionInput>;
  /** ID de referência */
  referenceId: Scalars['String']['input'];
  /** Hora de início */
  startHour?: InputMaybe<Scalars['String']['input']>;
};

export type TRoleUpdate = {
  /** ID do perfil */
  roleId: Scalars['String']['input'];
  /** ID do usuário */
  userId: Scalars['String']['input'];
};

export enum TRouteEnum {
  Accident = 'Accident',
  Accredited = 'Accredited',
  ActionPlan = 'ActionPlan',
  AuditLogs = 'AuditLogs',
  BiologicalMonitoring = 'BiologicalMonitoring',
  Brigades = 'Brigades',
  Calendar = 'Calendar',
  CauserAgent = 'CauserAgent',
  Contracts = 'Contracts',
  ControlMeasures = 'ControlMeasures',
  CostCenter = 'CostCenter',
  Department = 'Department',
  DocumentBuilder = 'DocumentBuilder',
  DocumentStructure = 'DocumentStructure',
  Esocial = 'Esocial',
  ExamResult = 'ExamResult',
  Exams = 'Exams',
  Expenses = 'Expenses',
  ExposureGroup = 'ExposureGroup',
  ExtinguishingSystem = 'ExtinguishingSystem',
  FirstSteps = 'FirstSteps',
  GeneratingSource = 'GeneratingSource',
  HealthPrograms = 'HealthPrograms',
  Home = 'Home',
  Integration = 'Integration',
  IpeDelivery = 'IpeDelivery',
  Mandates = 'Mandates',
  Materials = 'Materials',
  MeasuringInstruments = 'MeasuringInstruments',
  MedicalRecord = 'MedicalRecord',
  Medications = 'Medications',
  NotificationConfig = 'NotificationConfig',
  Occupation = 'Occupation',
  Organization = 'Organization',
  Others = 'Others',
  People = 'People',
  PeriodicRanges = 'PeriodicRanges',
  PhysicalEnvironment = 'PhysicalEnvironment',
  Profile = 'Profile',
  Profiling = 'Profiling',
  Quiz = 'Quiz',
  Registrations = 'Registrations',
  Reports = 'Reports',
  ResponsibilityTerms = 'ResponsibilityTerms',
  RiskAgent = 'RiskAgent',
  Risks = 'Risks',
  SafetyQuiz = 'SafetyQuiz',
  Schedule = 'Schedule',
  Tasks = 'Tasks',
  Training = 'Training',
  UnitsOfMeasure = 'UnitsOfMeasure',
  Users = 'Users',
  Vaccines = 'Vaccines',
  Warehouse = 'Warehouse',
  WorkPermission = 'WorkPermission',
  WorkShifts = 'WorkShifts'
}

export type TRouteFeature = {
  __typename?: 'RouteFeature';
  /** Funcionalidade associada */
  feature: TFeatureEnum;
  /** Rota */
  route: TRouteEnum;
};

/** Rotas */
export enum TRoutes {
  /** Acidentes */
  Accident = 'Accident',
  /** Plano de ação */
  ActionPlan = 'ActionPlan',
  /** Logs de Auditoria */
  AuditLogs = 'AuditLogs',
  /** Brigadas */
  Brigades = 'Brigades',
  /** Contratos */
  Contracts = 'Contracts',
  /** Construtor de documentos */
  DocumentBuilder = 'DocumentBuilder',
  /** eSocial */
  Esocial = 'Esocial',
  /** Resultado de exames */
  ExamResult = 'ExamResult',
  /** Exames */
  Exams = 'Exams',
  /** Sistema de extinção */
  ExtinguishingSystem = 'ExtinguishingSystem',
  /** Primeiros passos */
  FirstSteps = 'FirstSteps',
  /** Início */
  Home = 'Home',
  /** Integração */
  Integration = 'Integration',
  /** Entrega de EPI */
  IpeDelivery = 'IpeDelivery',
  /** Mandatos */
  Mandates = 'Mandates',
  /** Prontuário médico */
  MedicalRecord = 'MedicalRecord',
  /** Configuração de notificações */
  NotificationConfig = 'NotificationConfig',
  /** Organização */
  Organization = 'Organization',
  /** Outros */
  Others = 'Others',
  /** Pessoas */
  People = 'People',
  /** Perfil */
  Profile = 'Profile',
  /** Perfilamento */
  Profiling = 'Profiling',
  /** Cadastros */
  Registrations = 'Registrations',
  /** Relatórios */
  Reports = 'Reports',
  /** Riscos */
  Risks = 'Risks',
  /** Questionário de segurança */
  SafetyQuiz = 'SafetyQuiz',
  /** Agenda */
  Schedule = 'Schedule',
  /** Usuários */
  Users = 'Users',
  /** Permissão de trabalho */
  WorkPermission = 'WorkPermission'
}

export type TRowsInfo = {
  __typename?: 'RowsInfo';
  /** Dados da linha */
  data: Scalars['String']['output'];
  /** Mensagem de erro, caso a linha seja inválida */
  errors?: Maybe<Array<TValidationError>>;
  /** Número da linhas */
  lineNumber: Scalars['Float']['output'];
  /** Valor original da linha */
  originalLine: Scalars['String']['output'];
  /** Validade da linha */
  valid: Scalars['Boolean']['output'];
};

export type TRowsInput = {
  /** Dados da linha */
  data: Scalars['String']['input'];
  /** Número da linhas */
  lineNumber: Scalars['Float']['input'];
  /** Valor original da linha */
  originalLine: Scalars['String']['input'];
};

export type TSstMigratorValues = {
  /** Importar credenciados */
  accredited: Scalars['Boolean']['input'];
  /** Importar anamneses */
  clinicalQuizzes: Scalars['Boolean']['input'];
  /** Importar deficiências */
  deficiencies: Scalars['Boolean']['input'];
  /** Importar entregas de EPI */
  ipeDelivery: Scalars['Boolean']['input'];
  /** Importar atestados médicos */
  medicalCertificates: Scalars['Boolean']['input'];
  /** Importar prontuários médicos */
  medicalRecords: Scalars['Boolean']['input'];
  /** Importar ASOs */
  occupationalCertificates: Scalars['Boolean']['input'];
  /** Importar cargos */
  occupations: Scalars['Boolean']['input'];
  /** Importar questionários */
  quizzes: Scalars['Boolean']['input'];
  /** Importar laudos */
  reports: Scalars['Boolean']['input'];
  /** Importar riscos */
  risks: Scalars['Boolean']['input'];
  /** Importar vacinas */
  vaccines: Scalars['Boolean']['input'];
};

export type TSaasFullMetadata = {
  __typename?: 'SaasFullMetadata';
  /** Campos internos */
  fields: Array<TInternalFields>;
  /** Metadado genérico associado */
  genericMetadata?: Maybe<TGenericMetadata>;
  /** ID do metadado genérico */
  genericMetadataId: Scalars['String']['output'];
  /** ID do metadado completo */
  id: Scalars['String']['output'];
  /** Tipo de integração */
  integrationType: TErpType;
  /** Indica se está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Indica se é customizável */
  isCustomizable: Scalars['Boolean']['output'];
  /** Nome do metadado */
  name: Scalars['String']['output'];
  /** Versão */
  version: Scalars['Float']['output'];
};

export type TSaasMetadata = {
  __typename?: 'SaasMetadata';
  /** Metadado genérico associado */
  genericMetadata?: Maybe<TGenericMetadata>;
  /** ID do metadado genérico */
  genericMetadataId: Scalars['String']['output'];
  /** ID do metadado SaaS */
  id: Scalars['String']['output'];
  /** Tipo de integração */
  integrationType: TErpType;
  /** Indica se está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Indica se é customizável */
  isCustomizable: Scalars['Boolean']['output'];
  /** Nome do metadado */
  name: Scalars['String']['output'];
  /** Versão */
  version: Scalars['Float']['output'];
};

export type TSafetyQuiz = {
  __typename?: 'SafetyQuiz';
  /** ID do quiz de segurança */
  id: Scalars['String']['output'];
  /** Identificador da pessoa (funcionário) que respondeu em autoatendimento; nulo quando respondido por um responsável */
  personId?: Maybe<Scalars['String']['output']>;
  /** Quiz vinculado */
  quiz: TQuiz;
  /** Data de realização do quiz */
  realizationDate: Scalars['DateTime']['output'];
  /** Respostas do quiz */
  responses: Array<TResponsesSafetyQuiz>;
};

export type TSafetyQuizConformityChart = {
  __typename?: 'SafetyQuizConformityChart';
  entries: Array<TSafetyQuizConformityEntry>;
  hasData: Scalars['Boolean']['output'];
  total: Scalars['Int']['output'];
};

export type TSafetyQuizConformityEntry = {
  __typename?: 'SafetyQuizConformityEntry';
  label: Scalars['String']['output'];
  result: Scalars['Int']['output'];
};

export type TSafetyQuizDashboard = {
  __typename?: 'SafetyQuizDashboard';
  conformity: TSafetyQuizConformityChart;
  deviationsByCostCenter: TSafetyQuizParetoChart;
  deviationsByDepartment: TSafetyQuizParetoChart;
  deviationsByEnvironment: TSafetyQuizParetoChart;
  deviationsByGeneratingSource: TSafetyQuizParetoChart;
  deviationsByOccupation: TSafetyQuizParetoChart;
  deviationsByPerson: TSafetyQuizParetoChart;
  inspections: TSafetyQuizInspectionChart;
};

export type TSafetyQuizInput = {
  /** ID do quiz */
  quizId: Scalars['String']['input'];
  /** Data de realização do quiz */
  realizationDate: Scalars['DateTime']['input'];
  /** Respostas do quiz */
  responses?: InputMaybe<Array<TResponseSafetyQuizInput>>;
};

export type TSafetyQuizInspectionChart = {
  __typename?: 'SafetyQuizInspectionChart';
  entries: Array<TSafetyQuizInspectionEntry>;
  hasData: Scalars['Boolean']['output'];
  totalPlanned: Scalars['Int']['output'];
  totalRealized: Scalars['Int']['output'];
};

export type TSafetyQuizInspectionEntry = {
  __typename?: 'SafetyQuizInspectionEntry';
  label: Scalars['String']['output'];
  planned: Scalars['Int']['output'];
  realized: Scalars['Int']['output'];
};

export type TSafetyQuizParetoChart = {
  __typename?: 'SafetyQuizParetoChart';
  entries: Array<TSafetyQuizParetoEntry>;
  hasData: Scalars['Boolean']['output'];
  total: Scalars['Int']['output'];
};

export type TSafetyQuizParetoEntry = {
  __typename?: 'SafetyQuizParetoEntry';
  cumulativePercent: Scalars['Float']['output'];
  label: Scalars['String']['output'];
  result: Scalars['Int']['output'];
};

export type TSafetyQuizUpdate = {
  /** ID do quiz */
  id: Scalars['String']['input'];
  /** ID do quiz */
  quizId?: InputMaybe<Scalars['String']['input']>;
  /** Data de realização do quiz */
  realizationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Respostas a serem atualizadas */
  responses: Array<TResponseSafetyQuizUpdate>;
};

export type TSaveEnvironmentalReportVersionInput = {
  /** ID do laudo ambiental ao qual a versão pertence */
  environmentalReportId: Scalars['String']['input'];
  /** Estratégia em caso de colisão de revisão */
  onConflict?: InputMaybe<TSaveVersionConflictStrategy>;
  /** Identificador da revisão (string livre, ≤50) */
  revision: Scalars['String']['input'];
};

/** Estratégia ao detectar revisão duplicada em "Salvar versão" */
export enum TSaveVersionConflictStrategy {
  /** Falha com REVISION_CONFLICT quando já existe revisão ativa */
  Fail = 'Fail',
  /** Insere a nova mantendo a revisão existente (duplicata) */
  KeepBoth = 'KeepBoth',
  /** Soft-remove a revisão ativa existente e insere a nova */
  Overwrite = 'Overwrite'
}

export type TScheduleRestriction = {
  __typename?: 'ScheduleRestriction';
  /** Data de término da restrição */
  dateEnd: Scalars['DateTime']['output'];
  /** Data de início da restrição */
  dateStart: Scalars['DateTime']['output'];
  /** Médico com restrição */
  doctor: TPerson;
  /** ID da restrição de agenda */
  id: Scalars['String']['output'];
  /** Observação sobre a restrição */
  observation?: Maybe<Scalars['String']['output']>;
  /** Tipo da restrição */
  type: TRestrictionType;
};

export type TScheduleRestrictionInput = {
  /** Data de término da restrição */
  dateEnd: Scalars['DateTime']['input'];
  /** Data de início da restrição */
  dateStart: Scalars['DateTime']['input'];
  /** ID do médico */
  doctorId: Scalars['String']['input'];
  /** Observação sobre a restrição */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Tipo da restrição */
  type: TRestrictionType;
};

export type TScheduleRestrictionUpdate = {
  /** Data de término da restrição */
  dateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de início da restrição */
  dateStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID do médico */
  doctorId?: InputMaybe<Scalars['String']['input']>;
  /** ID da restrição */
  id: Scalars['String']['input'];
  /** Observação sobre a restrição */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Tipo da restrição */
  type?: InputMaybe<TRestrictionType>;
};

export type TScheduledConsultation = {
  __typename?: 'ScheduledConsultation';
  admissionDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  /** Diagnóstico */
  diagnostic?: Maybe<Scalars['String']['output']>;
  /** Data do diagnóstico */
  diagnosticDate?: Maybe<Scalars['DateTime']['output']>;
  dismissalDate?: Maybe<Scalars['DateTime']['output']>;
  doctor?: Maybe<Scalars['String']['output']>;
  /** Data de término */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Data estimada */
  estimatedDate: Scalars['DateTime']['output'];
  /** CID */
  icd?: Maybe<Scalars['String']['output']>;
  /** Descrição do CID */
  icdDescription?: Maybe<Scalars['String']['output']>;
  /** Matrícula individual */
  individualRegistration?: Maybe<Scalars['String']['output']>;
  /** Prontuário médico */
  medicalRecord: Scalars['String']['output'];
  /** Natureza da consulta */
  nature: TConsultationNature;
  nurse?: Maybe<Scalars['String']['output']>;
  /** Ocupação */
  occupation?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  /** Matrícula */
  registration?: Maybe<Scalars['String']['output']>;
  screeningDate?: Maybe<Scalars['DateTime']['output']>;
  /** Data de início */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Tipo de consulta */
  type: TConsultationType;
};

export type TScheduledConsultationByBranch = {
  __typename?: 'ScheduledConsultationByBranch';
  accredited?: Maybe<Scalars['String']['output']>;
  admissionDate?: Maybe<Scalars['DateTime']['output']>;
  branch?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  /** Diagnóstico */
  diagnostic?: Maybe<Scalars['String']['output']>;
  /** Data do diagnóstico */
  diagnosticDate?: Maybe<Scalars['DateTime']['output']>;
  dismissalDate?: Maybe<Scalars['DateTime']['output']>;
  doctor?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  /** Data de término */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  erpBranch?: Maybe<Scalars['String']['output']>;
  /** Data estimada */
  estimatedDate: Scalars['DateTime']['output'];
  /** CID */
  icd?: Maybe<Scalars['String']['output']>;
  /** Descrição do CID */
  icdDescription?: Maybe<Scalars['String']['output']>;
  /** Matrícula individual */
  individualRegistration?: Maybe<Scalars['String']['output']>;
  /** Prontuário médico */
  medicalRecord: Scalars['String']['output'];
  /** Natureza da consulta */
  nature: TConsultationNature;
  nurse?: Maybe<Scalars['String']['output']>;
  /** Ocupação */
  occupation?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  /** Matrícula */
  registration?: Maybe<Scalars['String']['output']>;
  screeningDate?: Maybe<Scalars['DateTime']['output']>;
  /** Data de início */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Tipo de consulta */
  type: TConsultationType;
};

export type TScheduledConsultationToPrint = {
  __typename?: 'ScheduledConsultationToPrint';
  admissionDate?: Maybe<Scalars['String']['output']>;
  /** Centro de custo */
  costCenter?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  /** Diagnóstico */
  diagnostic: Scalars['String']['output'];
  /** Data do diagnóstico */
  diagnosticDate: Scalars['String']['output'];
  dismissalDate?: Maybe<Scalars['String']['output']>;
  /** Categoria eSocial */
  eSocialCategory?: Maybe<Scalars['String']['output']>;
  /** Data de término */
  endDate: Scalars['String']['output'];
  /** Data estimada */
  estimatedDate: Scalars['String']['output'];
  /** CID */
  icd: Scalars['String']['output'];
  /** Matrícula individual */
  individualRegistration?: Maybe<Scalars['String']['output']>;
  /** Prontuário médico */
  medicalRecord: Scalars['String']['output'];
  /** Natureza da consulta */
  nature: Scalars['String']['output'];
  nurse?: Maybe<Scalars['String']['output']>;
  /** Ocupação */
  occupation?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  /** Matrícula */
  registration?: Maybe<Scalars['String']['output']>;
  screeningBy?: Maybe<Scalars['String']['output']>;
  screeningDate?: Maybe<Scalars['String']['output']>;
  /** Data de início */
  startDate: Scalars['String']['output'];
  /** Status */
  status: Scalars['String']['output'];
  /** Tipo de consulta */
  type: Scalars['String']['output'];
};

export type TScheduledExam = {
  __typename?: 'ScheduledExam';
  /** Data de término */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Data estimada */
  estimatedDate: Scalars['DateTime']['output'];
  /** Nome do exame */
  exam: Scalars['String']['output'];
  /** Prontuário médico */
  medicalRecord: Scalars['String']['output'];
  /** Natureza da consulta */
  nature: TConsultationNature;
  /** Resultado */
  result?: Maybe<Scalars['String']['output']>;
  /** Data de início */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Tipo de consulta */
  type: TConsultationType;
};

export type TScheduledExamByBranch = {
  __typename?: 'ScheduledExamByBranch';
  accredited?: Maybe<Scalars['String']['output']>;
  branch?: Maybe<Scalars['String']['output']>;
  doctor?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  eSocialCategory?: Maybe<Scalars['String']['output']>;
  /** Data de término */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  erpBranch?: Maybe<Scalars['String']['output']>;
  /** Data estimada */
  estimatedDate: Scalars['DateTime']['output'];
  /** Nome do exame */
  exam: Scalars['String']['output'];
  individualRegistration?: Maybe<Scalars['String']['output']>;
  /** Prontuário médico */
  medicalRecord: Scalars['String']['output'];
  /** Natureza da consulta */
  nature: TConsultationNature;
  occupation?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Scalars['String']['output']>;
  /** Resultado */
  result?: Maybe<Scalars['String']['output']>;
  /** Data de início */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Tipo de consulta */
  type: TConsultationType;
};

export type TScheduledExamToPrint = {
  __typename?: 'ScheduledExamToPrint';
  /** Centro de custo */
  costCenter?: Maybe<Scalars['String']['output']>;
  /** Categoria eSocial */
  eSocialCategory?: Maybe<Scalars['String']['output']>;
  /** Data de término */
  endDate: Scalars['String']['output'];
  /** Data estimada */
  estimatedDate: Scalars['String']['output'];
  /** Nome do exame */
  exam: Scalars['String']['output'];
  /** Matrícula individual */
  individualRegistration?: Maybe<Scalars['String']['output']>;
  /** Prontuário médico */
  medicalRecord: Scalars['String']['output'];
  /** Natureza da consulta */
  nature: Scalars['String']['output'];
  /** Ocupação */
  occupation?: Maybe<Scalars['String']['output']>;
  /** Matrícula */
  registration?: Maybe<Scalars['String']['output']>;
  /** Resultado */
  result: Scalars['String']['output'];
  /** Data de início */
  startDate: Scalars['String']['output'];
  /** Status */
  status: Scalars['String']['output'];
  /** Tipo de consulta */
  type: Scalars['String']['output'];
};

export type TSchedulingByAccredited = {
  __typename?: 'SchedulingByAccredited';
  accredited: Scalars['String']['output'];
  branch: Scalars['String']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  exam: Scalars['String']['output'];
  individualRegistration?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  occupation?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Scalars['String']['output']>;
};

export type TSchedulingParameters = {
  __typename?: 'SchedulingParameters';
  costCenters?: Maybe<Array<Scalars['String']['output']>>;
  exams?: Maybe<Array<Scalars['String']['output']>>;
  fromDate: Scalars['DateTime']['output'];
  natures?: Maybe<Array<TConsultationNature>>;
  occupations?: Maybe<Array<Scalars['String']['output']>>;
  showsLate: Scalars['Boolean']['output'];
  showsNonRealized: Scalars['Boolean']['output'];
  showsRealized: Scalars['Boolean']['output'];
  situations?: Maybe<Array<TEmployeeSituation>>;
  toDate: Scalars['DateTime']['output'];
};

export type TSchedulingReport = {
  __typename?: 'SchedulingReport';
  consultations?: Maybe<Array<TConsultationByBranchToPrint>>;
  exams?: Maybe<Array<TExamByBranchToPrint>>;
};

export type TSchedulingReportByDoctor = {
  __typename?: 'SchedulingReportByDoctor';
  consultations?: Maybe<Array<TScheduledConsultationToPrint>>;
  exams?: Maybe<Array<TScheduledExamToPrint>>;
};

export type TSchedulingSettings = {
  __typename?: 'SchedulingSettings';
  /** Override da filial, nulo quando herda da organização */
  branchDefaultConsultationMinutes?: Maybe<Scalars['Int']['output']>;
  /** Duração padrão da consulta em minutos efetivamente aplicada (filial > organização > 30) */
  defaultConsultationMinutes: Scalars['Int']['output'];
  /** Padrão da organização, nulo quando não configurado */
  organizationDefaultConsultationMinutes?: Maybe<Scalars['Int']['output']>;
};

export type TSecurityPyramid = {
  __typename?: 'SecurityPyramid';
  /** Acidentes com óbito */
  death: Scalars['Float']['output'];
  /** Indica se há acidentes registrados */
  hasAccident: Scalars['Boolean']['output'];
  /** Incidentes */
  incident: Scalars['Float']['output'];
  /** Acidentes com afastamento */
  lostDays: Scalars['Float']['output'];
  /** Acidentes sem afastamento */
  noLostDays: Scalars['Float']['output'];
};

export type TSecurityWorkOrder = {
  __typename?: 'SecurityWorkOrder';
  activity: Scalars['String']['output'];
  controlMeasures?: Maybe<Array<TFuncionalHistoryControlMeasure>>;
  emergency?: Maybe<Scalars['String']['output']>;
  historyStart?: Maybe<Scalars['String']['output']>;
  personAdmissionDate: Scalars['String']['output'];
  personBirthday: Scalars['String']['output'];
  personCostCenter: Scalars['String']['output'];
  personCtps: Scalars['String']['output'];
  personDepartment?: Maybe<Scalars['String']['output']>;
  personExam: Array<TFuncionalHistoryExamTranslated>;
  personIpe: Array<TFuncionalHistoryIpeTranslated>;
  personName: Scalars['String']['output'];
  personOccupation: Scalars['String']['output'];
  personRegistration: Scalars['String']['output'];
  personRisk: Array<TFuncionalHistoryRiskTranslated>;
  responsibilities?: Maybe<Scalars['String']['output']>;
  restrictions?: Maybe<Scalars['String']['output']>;
  term: Scalars['String']['output'];
  trainings?: Maybe<Array<TRiskTrainings>>;
};

export type TSecurityWorkOrderParameters = {
  __typename?: 'SecurityWorkOrderParameters';
  costCenters?: Maybe<Array<Scalars['String']['output']>>;
  departments?: Maybe<Array<Scalars['String']['output']>>;
  epi?: Maybe<Scalars['Boolean']['output']>;
  exams?: Maybe<Scalars['Boolean']['output']>;
  fromDate: Scalars['DateTime']['output'];
  observations?: Maybe<Scalars['String']['output']>;
  occupations?: Maybe<Array<Scalars['String']['output']>>;
  risks?: Maybe<Scalars['Boolean']['output']>;
  statementsResponsibility: Scalars['String']['output'];
  toDate: Scalars['DateTime']['output'];
};

/** Tipo de envio de documento */
export enum TSendType {
  Email = 'Email',
  Sms = 'Sms',
  WhatsApp = 'WhatsApp'
}

/** Área de atendimento */
export enum TServiceArea {
  /** Rural */
  Rural = 'rural',
  /** Urbano */
  Urban = 'urban'
}

export type TServiceProviderExamInput = {
  /** Data de término do contrato */
  contractEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de início do contrato */
  contractStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identificador do exame */
  examId: Scalars['String']['input'];
  /** Identificador único */
  id?: InputMaybe<Scalars['String']['input']>;
};

export type TServiceProviderInput = {
  /** Endereço */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Filial */
  branch?: InputMaybe<Scalars['String']['input']>;
  /** Cidade */
  city?: InputMaybe<Scalars['String']['input']>;
  /** CNPJ */
  cnpj?: InputMaybe<Scalars['String']['input']>;
  /** Data de término do contrato */
  contractEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de início do contrato */
  contractStart: Scalars['DateTime']['input'];
  /** Exames do prestador */
  exams?: InputMaybe<Array<TServiceProviderExamInput>>;
  /** Nome do prestador de serviço */
  name: Scalars['String']['input'];
  /** Bairro */
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  /** Filial do prestador */
  providerBranch?: InputMaybe<Scalars['String']['input']>;
  /** Telefone */
  telephone?: InputMaybe<Scalars['String']['input']>;
};

export type TServiceProviderUpdate = {
  /** Endereço */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Filial */
  branch?: InputMaybe<Scalars['String']['input']>;
  /** Cidade */
  city?: InputMaybe<Scalars['String']['input']>;
  /** CNPJ */
  cnpj?: InputMaybe<Scalars['String']['input']>;
  /** Data de término do contrato */
  contractEnd?: InputMaybe<Scalars['DateTime']['input']>;
  contractStart?: InputMaybe<Scalars['DateTime']['input']>;
  exams?: InputMaybe<Array<TServiceProviderExamInput>>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Bairro */
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  /** Filial do prestador */
  providerBranch?: InputMaybe<Scalars['String']['input']>;
  /** Telefone */
  telephone?: InputMaybe<Scalars['String']['input']>;
};

export type TSesmtRoles = {
  __typename?: 'SesmtRoles';
  /** Quantidade necessária */
  amount: Scalars['Float']['output'];
  /** Nome do cargo SESMT */
  role: Scalars['String']['output'];
};

export type TSession = {
  __typename?: 'Session';
  /** Filial selecionada */
  branch?: Maybe<TBranchWithOrganization>;
  /** Dados da sessão */
  data: TSessionData;
  /** Serial da sessão */
  serial: Scalars['String']['output'];
  /** Fuso horário */
  timeZone?: Maybe<Scalars['String']['output']>;
  /** Token de autenticação */
  token: Scalars['String']['output'];
  /** Usuário autenticado */
  user: TUser;
  /** Indica se a assinatura é válida */
  validSubscription: Scalars['Boolean']['output'];
};

export type TSessionData = {
  __typename?: 'SessionData';
  /** Identificação do navegador */
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type TSessionInput = {
  /** E-mail do usuário */
  email: Scalars['String']['input'];
  /** Senha */
  password: Scalars['String']['input'];
  /** Fuso horário */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  /** Dados de UTM */
  utm?: InputMaybe<TUtmInput>;
};

export type TSessionInputAd = {
  /** Forma de acesso */
  accessBy: TAccessBy;
  /** Código de autenticação */
  code: Scalars['String']['input'];
  /** Indica se é acesso mobile */
  isMobile?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TSettings = {
  __typename?: 'Settings';
  /** Duração padrão da consulta em minutos */
  defaultConsultationMinutes?: Maybe<Scalars['Int']['output']>;
};

export type TSettingsInput = {
  /** Duração padrão da consulta em minutos */
  defaultConsultationMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type TSeverityIndex = {
  __typename?: 'SeverityIndex';
  /** Descrição do período */
  description?: Maybe<Scalars['String']['output']>;
  /** Índice de gravidade de acidentes */
  index: Scalars['Float']['output'];
};

/** Atalhos */
export enum TShortcut {
  /** Quadro de agentes */
  AgentBoard = 'AgentBoard',
  /** Agente x Medida */
  AgentMeasure = 'AgentMeasure',
  /** Anexo-A */
  AnnexA = 'AnnexA',
  /** Anexo-B */
  AnnexB = 'AnnexB',
  /** Anexo-B x GHE */
  AnnexBByGhe = 'AnnexBByGhe',
  /** Referências e assinaturas APR */
  AprRiskSignatures = 'AprRiskSignatures',
  /** Tabela de análise de risco */
  AprRiskTable = 'AprRiskTable',
  /** Tarefa */
  Assignment = 'Assignment',
  /** Responsabilidades das brigadas */
  BrigadeResponsibilities = 'BrigadeResponsibilities',
  /** Risco-Químico */
  ChemicalRisk = 'ChemicalRisk',
  /** Identificação de cliente */
  ClientIdentification = 'ClientIdentification',
  /** Risco-Frio */
  ColdRisk = 'ColdRisk',
  /** Identificação da empresa */
  CompanyIdentification = 'CompanyIdentification',
  /** Controle */
  Control = 'Control',
  /** Quadro medida controle */
  ControlMeasureFrame = 'ControlMeasureFrame',
  /** Capa */
  Cover = 'Cover',
  /** Dosimetria por atividade */
  DosimetryActivity = 'DosimetryActivity',
  /** Dosimetria por centro de custo */
  DosimetryCostCenter = 'DosimetryCostCenter',
  /** Dosimetria por funcionário */
  DosimetryEmployee = 'DosimetryEmployee',
  /** Dosimetria por função */
  DosimetryFunction = 'DosimetryFunction',
  /** Dosimetria por ambiente físico */
  DosimetryPhysicalEnvironment = 'DosimetryPhysicalEnvironment',
  /** Brigadas emergenciais */
  EmergencyBrigades = 'EmergencyBrigades',
  EmployeeExposureRate = 'EmployeeExposureRate',
  /** Funcionário x Função */
  EmployeeOccupation = 'EmployeeOccupation',
  EnvironmentActivities = 'EnvironmentActivities',
  /** EPI x Atividades */
  EpiActivities = 'EpiActivities',
  /** Equipamento */
  Equipment = 'Equipment',
  /** Exames */
  Exams = 'Exams',
  /** Grupos de exposição */
  ExposureGroups = 'ExposureGroups',
  /** Funções x Tarefa */
  FunctionsTask = 'FunctionsTask',
  /** Histórico */
  Historic = 'Historic',
  /** EPI */
  Ipe = 'Ipe',
  /** EPI x Função */
  IpeOccupation = 'IpeOccupation',
  /** Local */
  Local = 'Local',
  MeasureByOccupation = 'MeasureByOccupation',
  NoiseLevels = 'NoiseLevels',
  /** PPR - Funcionários */
  PprEmployees = 'PPREmployees',
  PeopleExpose = 'PeopleExpose',
  /** Risco-Físico */
  PhysicalRisk = 'PhysicalRisk',
  /** Quadro EPI */
  PictureIpe = 'PictureIpe',
  /** Plano ou plano de ação */
  PlanOrActionPlan = 'PlanOrActionPlan',
  /** Programa */
  Program = 'Program',
  /** Equipamentos radioativos */
  RadioactiveEquipment = 'RadioactiveEquipment',
  /** Informações do responsável */
  ResponsibleInformation = 'ResponsibleInformation',
  /** Quadro de toques */
  Ringtone = 'Ringtone',
  /** Risco */
  Risk = 'Risk',
  /** Risco x GHE */
  RiskByGhe = 'RiskByGhe',
  /** Risco-Ocupacao */
  RiskByOccupation = 'RiskByOccupation',
  /** Risco-Epc */
  RiskCpe = 'RiskCpe',
  /** Risco-Ambiente */
  RiskEnvironment = 'RiskEnvironment',
  /** Risco-Calor */
  RiskHeat = 'RiskHeat',
  RiskInventory = 'RiskInventory',
  /** Risco-Umidade */
  RiskMoisture = 'RiskMoisture',
  /** Risco-Ruído */
  RiskNoise = 'RiskNoise',
  /** Cronograma */
  Schedule = 'Schedule',
  /** Cronograma resumido */
  ScheduleSummary = 'ScheduleSummary',
  /** Sesmt */
  Sesmt = 'Sesmt',
  /** Turnos */
  Shifts = 'Shifts',
  /** Quadro funcionários por centro de custo */
  StaffCostCenter = 'StaffCostCenter',
  /** Quadro funcionários */
  StaffTable = 'StaffTable',
  /** Estrutura locais */
  StructureLocations = 'StructureLocations',
  /** Sumário */
  Summary = 'Summary',
  /** Introdução técnica */
  TechnicalIntroduction = 'TechnicalIntroduction',
  /** Limites de tolerância db(A) */
  ToleranceLimits = 'ToleranceLimits',
  /** Programação vacinas */
  VaccinesSchedule = 'VaccinesSchedule'
}

export type TShortcutGenerated = {
  __typename?: 'ShortcutGenerated';
  attachment?: Maybe<TAttachment>;
  html: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TShortcutHistory = {
  __typename?: 'ShortcutHistory';
  cbo: Scalars['String']['output'];
  occupation: Scalars['String']['output'];
  period: Scalars['String']['output'];
};

export type TShortcutHistoryId = {
  __typename?: 'ShortcutHistoryId';
  occupationId: Scalars['String']['output'];
  period: Scalars['String']['output'];
  realizationDate: Scalars['DateTime']['output'];
};

export type TSickNote = {
  __typename?: 'SickNote';
  /** Data de término da ausência */
  absenceEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** Data de início da ausência */
  absenceStartDate?: Maybe<Scalars['DateTime']['output']>;
  /** Identificador do acidente */
  accident?: Maybe<Scalars['String']['output']>;
  /** Data de término do benefício */
  allowanceEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** Data de início do benefício */
  allowanceStartDate?: Maybe<Scalars['DateTime']['output']>;
  /** Código de registro da classe da entidade */
  classEntityRegistrationCode?: Maybe<Scalars['String']['output']>;
  /** Estado da classe da entidade */
  classEntityState?: Maybe<Scalars['String']['output']>;
  /** Data do atestado */
  date: Scalars['DateTime']['output'];
  /** Nome do médico */
  doctorName?: Maybe<Scalars['String']['output']>;
  /** Data prevista de término */
  expectedEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** Classificação Internacional de Doenças (CID) */
  internationalDiseaseClassification?: Maybe<Scalars['String']['output']>;
  /** Duração em dias */
  length: Scalars['Float']['output'];
  /** Número do benefício */
  numberOfBenefit?: Maybe<Scalars['String']['output']>;
  /** Observações sobre o atestado */
  observation?: Maybe<Scalars['String']['output']>;
  /** Origem do atestado */
  origin?: Maybe<Scalars['String']['output']>;
  /** Data da revisão */
  reviewDate?: Maybe<Scalars['DateTime']['output']>;
  /** Tipo do atestado */
  type: Scalars['String']['output'];
  /** Tipo de ausência */
  typeOfAbsence?: Maybe<Scalars['String']['output']>;
  /** Tipo de benefício */
  typeOfAllowance?: Maybe<Scalars['String']['output']>;
};

export type TSignBrokerGetDocument = {
  __typename?: 'SignBrokerGetDocument';
  documentId: Scalars['Int']['output'];
  fileName: Scalars['String']['output'];
  originalFileUrl?: Maybe<Scalars['String']['output']>;
  pending: Array<TDocumentPendingSigner>;
  status: TDocumentStatus;
};

export type TSignBrokerGetDocuments = {
  __typename?: 'SignBrokerGetDocuments';
  createdAt: Scalars['String']['output'];
  documentId: Scalars['Int']['output'];
  expirationAt?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  folder?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['String']['output']>;
  observers: Array<TDocumentObserver>;
  pending: Array<TDocumentPendingSigner>;
  permissions: TDocumentPermissions;
  signers: Array<TDocumentSigner>;
  status: TDocumentStatus;
  user: TDocumentUser;
};

export type TSignBrokerGetDocumentsAndUpdateState = {
  __typename?: 'SignBrokerGetDocumentsAndUpdateState';
  createdAt?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['Int']['output'];
  entity: Scalars['String']['output'];
  pendings: Array<TDocumentPendingSigner>;
  signers: Array<TDocumentSigner>;
  status: TDocumentStatus;
};

export type TSignBrokerResponse = {
  __typename?: 'SignBrokerResponse';
  data?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<TErrorResponse>;
  success: Scalars['Boolean']['output'];
};

export type TSignBrokerUrlDownloadResponse = {
  __typename?: 'SignBrokerUrlDownloadResponse';
  certifiedFileUrl?: Maybe<Scalars['String']['output']>;
  originalFileUrl: Scalars['String']['output'];
  signedFileUrl?: Maybe<Scalars['String']['output']>;
  zipUrl?: Maybe<Scalars['String']['output']>;
};

export type TSignCredentialsInput = {
  password: Scalars['String']['input'];
  signIntegration: TSignIntegrations;
  userName: Scalars['String']['input'];
};

export type TSignCredentialsOutput = {
  __typename?: 'SignCredentialsOutput';
  id: Scalars['String']['output'];
  signIntegration: TSignIntegrations;
  userName: Scalars['String']['output'];
};

export enum TSignIntegrations {
  DocuSign = 'DocuSign',
  TotvsSign = 'TotvsSign'
}

/** Ações de publicação para assinatura de documentos */
export enum TSignPublicationAction {
  CertificateSign = 'CertificateSign',
  Eletronic = 'Eletronic',
  Validate = 'Validate',
  Witness = 'Witness'
}

export type TSignatureChart = {
  __typename?: 'SignatureChart';
  /** Indica se existem entregas de IPE */
  hasIpeDeliveries: Scalars['Boolean']['output'];
  /** Quantidade de entregas assinadas */
  signed: Scalars['Float']['output'];
  /** Quantidade de entregas não assinadas */
  unsigned: Scalars['Float']['output'];
};

export type TSigningInput = {
  documentId: Scalars['Int']['input'];
  geoLocation?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipAddressV6?: InputMaybe<Scalars['String']['input']>;
  signatureType?: InputMaybe<TSigningType>;
  signerRole?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

/** Tipo de assinatura do destinatário */
export enum TSigningType {
  Electronic = 'Electronic',
  Reject = 'Reject',
  Validator = 'Validator',
  WithCertificate = 'WithCertificate',
  Witness = 'Witness'
}

export type TSimpleComplementaryResults = {
  __typename?: 'SimpleComplementaryResults';
  result: Scalars['Float']['output'];
};

export type TSimulation = {
  __typename?: 'Simulation';
  /** Filial da simulação */
  branch: Scalars['String']['output'];
  /** ID da brigada */
  brigadeId: Scalars['String']['output'];
  /** Data da simulação */
  date: Scalars['DateTime']['output'];
  /** Brigada de incêndio */
  fireBrigade: TFireBrigade;
  /** ID da simulação */
  id: Scalars['String']['output'];
  /** Plano de simulação */
  plan: TSimulationPlan;
  /** ID do plano */
  planId: Scalars['String']['output'];
  /** Ações executadas na simulação */
  simulationActions: Array<TSimulationAction>;
};

export type TSimulationAction = {
  __typename?: 'SimulationAction';
  /** Indica se foi realizada */
  accomplished: Scalars['Boolean']['output'];
  /** Filial */
  branch: Scalars['String']['output'];
  /** Indica se foi efetiva */
  effective: Scalars['Boolean']['output'];
  /** ID da ação de simulação */
  id: Scalars['String']['output'];
  /** Observação sobre a ação */
  observation: Scalars['String']['output'];
  /** Simulação vinculada */
  simulation: TSimulation;
  /** ID da simulação */
  simulationId: Scalars['String']['output'];
  /** Ação do plano de simulação */
  simulationPlanAction: TSimulationPlanAction;
  /** ID da ação do plano de simulação */
  simulationPlanActionId: Scalars['String']['output'];
};

export type TSimulationActionEntry = {
  __typename?: 'SimulationActionEntry';
  accomplished: Scalars['Int']['output'];
  effective: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  planned: Scalars['Int']['output'];
};

export type TSimulationActionInput = {
  /** Indica se foi realizada */
  accomplished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se foi efetiva */
  effective?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID da ação */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Observação sobre a ação */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** ID da ação do plano de simulação */
  simulationPlanActionId?: InputMaybe<Scalars['String']['input']>;
};

export type TSimulationEntry = {
  __typename?: 'SimulationEntry';
  accomplished: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  planned: Scalars['Int']['output'];
};

export type TSimulationInput = {
  /** ID da brigada */
  brigadeId: Scalars['String']['input'];
  /** Data da simulação */
  date: Scalars['DateTime']['input'];
  /** ID do plano */
  planId: Scalars['String']['input'];
  /** Ações da simulação */
  simulationActions: Array<TSimulationActionInput>;
};

export type TSimulationPlan = {
  __typename?: 'SimulationPlan';
  /** Filial */
  branch: Scalars['String']['output'];
  /** ID da brigada */
  brigadeId: Scalars['String']['output'];
  /** Descrição do plano */
  description: Scalars['String']['output'];
  /** Brigada de incêndio */
  fireBrigade: TFireBrigade;
  /** ID do plano de simulação */
  id: Scalars['String']['output'];
  /** Periodicidade em dias */
  periodicity: Scalars['Float']['output'];
  /** Ações do plano de simulação */
  simulationPlanActions: Array<TSimulationPlanAction>;
  /** Simulações realizadas */
  simulations: Array<TSimulation>;
};

export type TSimulationPlanAction = {
  __typename?: 'SimulationPlanAction';
  /** Filial */
  branch: Scalars['String']['output'];
  /** Descrição da ação */
  description: Scalars['String']['output'];
  /** ID da ação do plano */
  id: Scalars['String']['output'];
  /** ID do plano de simulação */
  planId: Scalars['String']['output'];
  /** Ações de simulação vinculadas */
  simulationActions?: Maybe<Array<TSimulationAction>>;
};

export type TSimulationPlanActionInput = {
  /** Descrição da ação */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID da ação */
  id?: InputMaybe<Scalars['String']['input']>;
  /** ID do plano */
  planId?: InputMaybe<Scalars['String']['input']>;
};

export type TSimulationPlanInput = {
  /** ID da brigada */
  brigadeId: Scalars['String']['input'];
  /** Descrição do plano */
  description: Scalars['String']['input'];
  /** Periodicidade em dias */
  periodicity: Scalars['Float']['input'];
  /** Ações do plano de simulação */
  simulationPlanActions: Array<TSimulationPlanActionInput>;
};

export type TSimulationPlanUpdate = {
  /** Descrição do plano */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID do plano */
  id: Scalars['String']['input'];
  /** Periodicidade em dias */
  periodicity?: InputMaybe<Scalars['Float']['input']>;
  /** Ações do plano de simulação */
  simulationPlanActions: Array<TSimulationPlanActionInput>;
};

export type TSimulationUpdate = {
  /** Data da simulação */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID da simulação */
  id: Scalars['String']['input'];
  /** Ações da simulação */
  simulationActions: Array<TSimulationActionInput>;
};

export type TSipat = {
  __typename?: 'Sipat';
  /** Anexos relacionados à SIPAT */
  attachments?: Maybe<Array<TAttachment>>;
  /** Comentários adicionais sobre a SIPAT */
  comments?: Maybe<Scalars['String']['output']>;
  /** Data de término da SIPAT */
  dateEnd: Scalars['DateTime']['output'];
  /** Data de início da SIPAT */
  dateStart: Scalars['DateTime']['output'];
  /** Descrição da SIPAT */
  description: Scalars['String']['output'];
  /** ID da SIPAT */
  id: Scalars['String']['output'];
  /** Mandato da CIPA associado à SIPAT */
  mandate?: Maybe<TMandate>;
  /** Eventos realizados durante a SIPAT */
  sipatEvents?: Maybe<Array<TSipatEvent>>;
};

export type TSipatEvent = {
  __typename?: 'SipatEvent';
  /** Comentários adicionais sobre o evento */
  comments?: Maybe<Scalars['String']['output']>;
  /** Custo do evento */
  cost?: Maybe<Scalars['Float']['output']>;
  /** Data de término do evento */
  dateEnd: Scalars['DateTime']['output'];
  /** Data de início do evento */
  dateStart: Scalars['DateTime']['output'];
  /** ID do evento da SIPAT */
  id: Scalars['String']['output'];
  /** Local onde o evento será realizado */
  localEvent: Scalars['String']['output'];
  /** Pessoa responsável pelo evento */
  person: TPerson;
  /** SIPAT à qual o evento pertence */
  sipat: TSipat;
  /** Assunto do evento da SIPAT */
  subject: Scalars['String']['output'];
};

export type TSipatEventInput = {
  /** Comentários adicionais sobre o evento */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Custo do evento */
  cost?: InputMaybe<Scalars['Float']['input']>;
  /** Data de término do evento */
  dateEnd: Scalars['DateTime']['input'];
  /** Data de início do evento */
  dateStart: Scalars['DateTime']['input'];
  /** Local onde o evento será realizado */
  localEvent: Scalars['String']['input'];
  /** ID da pessoa responsável pelo evento */
  personId: Scalars['String']['input'];
  /** ID da SIPAT */
  sipatId: Scalars['String']['input'];
  /** Assunto do evento da SIPAT */
  subject: Scalars['String']['input'];
};

export type TSipatEventUpdate = {
  /** Comentários adicionais sobre o evento */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Custo do evento */
  cost?: InputMaybe<Scalars['Float']['input']>;
  /** Data de término do evento */
  dateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de início do evento */
  dateStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID do evento da SIPAT */
  id: Scalars['String']['input'];
  /** Local onde o evento será realizado */
  localEvent?: InputMaybe<Scalars['String']['input']>;
  /** ID da pessoa responsável pelo evento */
  personId?: InputMaybe<Scalars['String']['input']>;
  /** Assunto do evento */
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type TSipatInput = {
  /** Comentários adicionais sobre a SIPAT */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Data de término da SIPAT */
  dateEnd: Scalars['DateTime']['input'];
  /** Data de início da SIPAT */
  dateStart: Scalars['DateTime']['input'];
  /** Descrição da SIPAT */
  description: Scalars['String']['input'];
  /** ID do mandato da CIPA */
  mandateId: Scalars['String']['input'];
  /** Eventos a serem criados para a SIPAT */
  sipatEvents?: InputMaybe<Array<TEventOnSipatInput>>;
};

export type TSipatUpdate = {
  /** Comentários adicionais sobre a SIPAT */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Data de término da SIPAT */
  dateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de início da SIPAT */
  dateStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Descrição da SIPAT */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID da SIPAT */
  id: Scalars['String']['input'];
  /** Eventos a serem criados, atualizados ou removidos */
  sipatEvents?: InputMaybe<TEventOnSipatUpdate>;
};

/** Situação */
export enum TSituation {
  /** Cancelado */
  Cancel = 'Cancel',
  /** Fechado */
  Close = 'Close',
  /** Aberto */
  Open = 'Open'
}

export type TSituationCount = {
  __typename?: 'SituationCount';
  percentage: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

/** Cor da pele */
export enum TSkinColor {
  /** Preta */
  Black = 'black',
  /** Parda */
  Brown = 'brown',
  /** Indígena */
  Indigenous = 'indigenous',
  /** Branca */
  White = 'white',
  /** Amarela */
  Yellow = 'yellow'
}

export type TSnellen = {
  __typename?: 'Snellen';
  /** Tipo de agravamento oftalmológico */
  aggravation: TOphthalmologicAggravationEnum;
  /** Valor da acuidade visual de ambos os olhos */
  bothEyes: TSnellenValue;
  /** Data de calibração do equipamento */
  calibrationDate: Scalars['DateTime']['output'];
  /** Exame complementar associado */
  complementaryExam?: Maybe<TComplementaryExam>;
  /** Consulta associada ao exame */
  consultation?: Maybe<TConsultation>;
  /** Tipo de correção oftalmológica */
  correction: TOphthalmologicCorrectionEnum;
  /** CRM do médico */
  crm?: Maybe<Scalars['String']['output']>;
  /** Data de realização do exame */
  date: Scalars['DateTime']['output'];
  /** Detalhes do exame */
  details?: Maybe<Scalars['String']['output']>;
  /** Indicador diagnóstico do exame */
  diagnosticIndicator: TExamDiagnosticIndicatorEnum;
  /** Nome do médico */
  doctor?: Maybe<Scalars['String']['output']>;
  /** Equipamento utilizado para a medição */
  equipment: TMeasuringInstrument;
  /** Autorização para realização do exame */
  examAuthorization: Scalars['Boolean']['output'];
  /** Data de aferição do equipamento */
  gaugingDate: Scalars['DateTime']['output'];
  /** ID do exame de Snellen */
  id: Scalars['String']['output'];
  /** Indicador do resultado do exame */
  indicator: TExamResultIndicatorEnum;
  /** Valor da acuidade visual do olho esquerdo */
  leftEye: TSnellenValue;
  /** Observações */
  observations?: Maybe<Scalars['String']['output']>;
  /** Pessoa responsável pela medição */
  responsibleForMeasuring: TPerson;
  /** Tempo de repouso */
  restTime?: Maybe<Scalars['String']['output']>;
  /** Resultado do exame */
  result: Scalars['String']['output'];
  /** Agravamento do resultado */
  resultAggravation?: Maybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: Maybe<TExamResultAlterationEnum>;
  /** Valor da acuidade visual do olho direito */
  rightEye: TSnellenValue;
  /** Estado do CRM */
  state?: Maybe<TState>;
  /** Indica se o exame foi realizado com correção */
  withCorrection: Scalars['Boolean']['output'];
};

export type TSnellenInput = {
  /** Tipo de agravamento oftalmológico */
  aggravation: TOphthalmologicAggravationEnum;
  /** Valor da acuidade visual de ambos os olhos */
  bothEyes: TSnellenValue;
  /** Data de calibração do equipamento */
  calibrationDate: Scalars['DateTime']['input'];
  /** ID do exame complementar associado */
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  /** ID da consulta associada */
  consultationId?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de correção oftalmológica */
  correction: TOphthalmologicCorrectionEnum;
  /** CRM do médico */
  crm?: InputMaybe<Scalars['String']['input']>;
  /** Data de realização do exame */
  date: Scalars['DateTime']['input'];
  /** Detalhes do exame */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Indicador diagnóstico do exame */
  diagnosticIndicator: TExamDiagnosticIndicatorEnum;
  /** Nome do médico */
  doctor?: InputMaybe<Scalars['String']['input']>;
  /** ID do equipamento utilizado */
  equipmentId: Scalars['String']['input'];
  /** Autorização para realização do exame */
  examAuthorization: Scalars['Boolean']['input'];
  /** Data de aferição do equipamento */
  gaugingDate: Scalars['DateTime']['input'];
  /** Indicador do resultado do exame */
  indicator: TExamResultIndicatorEnum;
  /** Valor da acuidade visual do olho esquerdo */
  leftEye: TSnellenValue;
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** ID da pessoa responsável pela medição */
  responsibleForMeasuringId: Scalars['String']['input'];
  /** Tempo de repouso */
  restTime?: InputMaybe<Scalars['String']['input']>;
  /** Resultado do exame */
  result: Scalars['String']['input'];
  /** Agravamento do resultado */
  resultAggravation?: InputMaybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: InputMaybe<TExamResultAlterationEnum>;
  /** Valor da acuidade visual do olho direito */
  rightEye: TSnellenValue;
  /** Estado do CRM */
  state?: InputMaybe<TState>;
  /** Indica se o exame foi realizado com correção */
  withCorrection: Scalars['Boolean']['input'];
};

export type TSnellenUpdate = {
  /** Tipo de agravamento oftalmológico */
  aggravation?: InputMaybe<TOphthalmologicAggravationEnum>;
  /** Valor da acuidade visual de ambos os olhos */
  bothEyes?: InputMaybe<TSnellenValue>;
  /** Data de calibração do equipamento */
  calibrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Tipo de correção oftalmológica */
  correction?: InputMaybe<TOphthalmologicCorrectionEnum>;
  /** CRM do médico */
  crm?: InputMaybe<Scalars['String']['input']>;
  /** Data de realização do exame */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Detalhes do exame */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Indicador diagnóstico do exame */
  diagnosticIndicator?: InputMaybe<TExamDiagnosticIndicatorEnum>;
  /** Nome do médico */
  doctor?: InputMaybe<Scalars['String']['input']>;
  /** ID do equipamento utilizado */
  equipmentId?: InputMaybe<Scalars['String']['input']>;
  /** Autorização para realização do exame */
  examAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Data de aferição do equipamento */
  gaugingDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID do exame de Snellen */
  id: Scalars['String']['input'];
  /** Indicador do resultado do exame */
  indicator?: InputMaybe<TExamResultIndicatorEnum>;
  /** Valor da acuidade visual do olho esquerdo */
  leftEye?: InputMaybe<TSnellenValue>;
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** ID da pessoa responsável pela medição */
  responsibleForMeasuringId?: InputMaybe<Scalars['String']['input']>;
  /** Tempo de repouso */
  restTime?: InputMaybe<Scalars['String']['input']>;
  /** Resultado do exame */
  result?: InputMaybe<Scalars['String']['input']>;
  /** Agravamento do resultado */
  resultAggravation?: InputMaybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: InputMaybe<TExamResultAlterationEnum>;
  /** Valor da acuidade visual do olho direito */
  rightEye?: InputMaybe<TSnellenValue>;
  /** Estado do CRM */
  state?: InputMaybe<TState>;
  /** Indica se o exame foi realizado com correção */
  withCorrection?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Valores Snellen */
export enum TSnellenValue {
  /** 50 */
  Fifty = 'fifty',
  /** 40 */
  Forty = 'forty',
  /** 100 */
  OneHundred = 'oneHundred',
  /** 70 */
  Seventy = 'seventy',
  /** 30 */
  Thirty = 'thirty',
  /** 20 */
  Twenty = 'twenty',
  /** 25 */
  TwentyFive = 'twentyFive',
  /** 200 */
  TwoHundred = 'twoHundred'
}

/** Filiação ao seguro social */
export enum TSocialSecurityAffiliation {
  /** Empregado */
  Employee = 'employee',
  /** Médico residente */
  ResidentDoctor = 'residentDoctor',
  /** Trabalhador avulso */
  SingleWorker = 'singleWorker',
  /** Segurado especial */
  SpecialSequence = 'specialSequence'
}

export type TSpareParts = {
  __typename?: 'SpareParts';
  /** Filial onde a peça está disponível */
  branch: Scalars['String']['output'];
  /** Dias necessários para reposição */
  daysForReplacement: Scalars['Float']['output'];
  /** ID da peça de reposição */
  id: Scalars['String']['output'];
  /** Produto principal */
  product: TProduct;
  /** ID do produto principal */
  productId: Scalars['String']['output'];
  /** Produto que serve como peça de reposição */
  sparePart: TProduct;
  /** ID da peça de reposição */
  sparePartId: Scalars['String']['output'];
};

export type TSparePartsInput = {
  /** Dias necessários para reposição */
  daysForReplacement: Scalars['Float']['input'];
  /** ID do produto principal */
  productId: Scalars['String']['input'];
  /** ID da peça de reposição */
  sparePartId: Scalars['String']['input'];
};

export type TSparePartsReport = {
  __typename?: 'SparePartsReport';
  amount: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  prevDate: Scalars['String']['output'];
  signDate: Scalars['String']['output'];
};

export type TSparePartsUpdate = {
  /** Dias necessários para reposição */
  daysForReplacement?: InputMaybe<Scalars['Float']['input']>;
  /** ID da peça de reposição */
  id: Scalars['String']['input'];
  /** ID do produto principal */
  productId?: InputMaybe<Scalars['String']['input']>;
  /** ID da peça de reposição */
  sparePartId?: InputMaybe<Scalars['String']['input']>;
};

/** Função específica na CIPA */
export enum TSpecificFunction {
  /** Coordenador(a) */
  Coordinator = 'coordinator',
  /** Membro */
  Member = 'member',
  /** Presidente */
  President = 'president',
  /** Representante */
  Representative = 'representative',
  /** Secretário(a) */
  Secretary = 'secretary',
  /** Secretário(a) Substituto(a) */
  SubstituteSecretary = 'substituteSecretary',
  /** Vice Presidente */
  VicePresident = 'vicePresident'
}

export type TStabilityType = {
  __typename?: 'StabilityType';
  /** Descrição do tipo de estabilidade */
  description: Scalars['String']['output'];
  /** ID do tipo de estabilidade */
  id: Scalars['String']['output'];
};

export type TStabilityTypeInput = {
  /** Descrição do tipo de estabilidade */
  description: Scalars['String']['input'];
  /** ID de referência externo */
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type TStabilityTypeIntegration = {
  /** Filial */
  branch: Scalars['String']['input'];
  /** Descrição do tipo de estabilidade */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID no sistema ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** ID do tipo de estabilidade */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TStabilityTypeUpdate = {
  /** Descrição do tipo de estabilidade */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID do tipo de estabilidade */
  id: Scalars['String']['input'];
  /** ID de referência externo */
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

/** Unidades Federativas do Brasil */
export enum TState {
  /** AC */
  Acre = 'Acre',
  /** AL */
  Alagoas = 'Alagoas',
  /** AP */
  Amapa = 'Amapa',
  /** AM */
  Amazonas = 'Amazonas',
  /** BA */
  Bahia = 'Bahia',
  /** CE */
  Ceara = 'Ceara',
  /** DF */
  DistritoFederal = 'DistritoFederal',
  /** ES */
  EspiritoSanto = 'EspiritoSanto',
  /** GO */
  Goias = 'Goias',
  /** MA */
  Maranhao = 'Maranhao',
  /** MT */
  MatoGrosso = 'MatoGrosso',
  /** MS */
  MatoGrossoDoSul = 'MatoGrossoDoSul',
  /** MG */
  MinasGerais = 'MinasGerais',
  /** PA */
  Para = 'Para',
  /** PB */
  Paraiba = 'Paraiba',
  /** PR */
  Parana = 'Parana',
  /** PE */
  Pernambuco = 'Pernambuco',
  /** PI */
  Piaui = 'Piaui',
  /** RJ */
  RioDeJaneiro = 'RioDeJaneiro',
  /** RN */
  RioGrandeDoNorte = 'RioGrandeDoNorte',
  /** RS */
  RioGrandeDoSul = 'RioGrandeDoSul',
  /** RO */
  Rondonia = 'Rondonia',
  /** RR */
  Roraima = 'Roraima',
  /** SC */
  SantaCatarina = 'SantaCatarina',
  /** SP */
  SaoPaulo = 'SaoPaulo',
  /** SE */
  Sergipe = 'Sergipe',
  /** TO */
  Tocantins = 'Tocantins'
}

export type TStatementResponsibility = {
  __typename?: 'StatementResponsibility';
  /** Descrição do termo de responsabilidade */
  description: Scalars['String']['output'];
  /** ID do termo de responsabilidade */
  id: Scalars['String']['output'];
  /** Indica se o termo está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Texto do termo de responsabilidade */
  statement: Scalars['String']['output'];
};

export type TStatementResponsibilityInput = {
  /** Descrição do termo de responsabilidade */
  description: Scalars['String']['input'];
  /** Texto do termo de responsabilidade */
  statement: Scalars['String']['input'];
};

export type TStatementResponsibilityUpdate = {
  /** Descrição do termo de responsabilidade */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID do termo de responsabilidade */
  id: Scalars['String']['input'];
  /** Indica se o termo está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Texto do termo de responsabilidade */
  statement?: InputMaybe<Scalars['String']['input']>;
};

/** Status */
export enum TStatus {
  /** Cancelado */
  Cancel = 'Cancel',
  /** Concluído */
  Completed = 'Completed',
  /** Falhou */
  Failed = 'Failed',
  /** Em progresso */
  InProgress = 'InProgress',
  /** Pendente */
  Pending = 'Pending'
}

/** Status da mensagem */
export enum TStatusMessage {
  /** Erro */
  Error = 'Error',
  /** Processado */
  Processed = 'Processed',
  /** Enviado */
  Send = 'Send'
}

/** Status da sugestão */
export enum TStatusSuggestion {
  /** Cancelada */
  Canceled = 'canceled',
  /** Finalizada */
  Finished = 'finished',
  /** Em processo */
  InProcess = 'inProcess',
  /** Nova */
  New = 'new'
}

export type TStepMessage = {
  __typename?: 'StepMessage';
  step: TProcessingStep;
  userId: Scalars['String']['output'];
};

export type TSteps = {
  __typename?: 'Steps';
  /** Indica se o passo foi concluído */
  done: Scalars['Boolean']['output'];
  /** Query GraphQL associada ao passo */
  query: Scalars['String']['output'];
  /** Tempo estimado para conclusão em minutos */
  time: Scalars['Float']['output'];
  /** Título do passo */
  title: Scalars['String']['output'];
  /** URL do recurso associado */
  url: Scalars['S3UrlCloudFront']['output'];
};

export type TStockLevel = {
  __typename?: 'StockLevel';
  /** Quantidade reservada */
  amountBooked: Scalars['Float']['output'];
  /** ID no sistema ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** ID do nível de estoque */
  id: Scalars['String']['output'];
  /** Número do lote */
  lotNumber?: Maybe<Scalars['String']['output']>;
  /** Nível de estoque mínimo */
  minimumBalance?: Maybe<Scalars['Float']['output']>;
  /** Saldo físico em estoque */
  physicalBalance: Scalars['Float']['output'];
  /** ID do produto */
  productId: Scalars['String']['output'];
  /** Referência ao produto */
  productRef?: Maybe<TProduct>;
  /** ID do armazém */
  warehouseId: Scalars['String']['output'];
  /** Referência ao armazém */
  warehouseRef?: Maybe<TWarehouse>;
};

export type TStockLevelInput = {
  /** Quantidade reservada */
  amountBooked: Scalars['Float']['input'];
  /** ID no sistema ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Número do lote */
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  /** Nível de estoque mínimo */
  minimumBalance?: InputMaybe<Scalars['Float']['input']>;
  /** Saldo físico em estoque */
  physicalBalance: Scalars['Float']['input'];
  /** ID do produto */
  productId: Scalars['String']['input'];
  /** ID do armazém */
  warehouseId: Scalars['String']['input'];
};

export type TStockLevelReference = {
  /** Quantidade reservada */
  amountBooked: Scalars['Float']['input'];
  /** Filial */
  branch: Scalars['String']['input'];
  /** ID no sistema ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Número do lote */
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  /** Nível de estoque mínimo */
  minimumBalance?: InputMaybe<Scalars['Float']['input']>;
  /** Saldo físico em estoque */
  physicalBalance: Scalars['Float']['input'];
  /** ID do armazém */
  warehouseId: Scalars['String']['input'];
};

export type TStockLevelSyncResult = {
  __typename?: 'StockLevelSyncResult';
  /** Mensagem de erro em caso de falha */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Indica se há saldo disponível para o produto após a sincronização */
  hasStock: Scalars['Boolean']['output'];
  /** ID do produto solicitado */
  productId: Scalars['String']['output'];
  /** Indica se a sincronização concluiu com sucesso */
  success: Scalars['Boolean']['output'];
  /** Momento em que a sincronização foi concluída */
  syncedAt: Scalars['DateTime']['output'];
};

export type TStockLevelUpdate = {
  /** Quantidade reservada */
  amountBooked?: InputMaybe<Scalars['Float']['input']>;
  /** ID no sistema ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** ID do nível de estoque */
  id: Scalars['String']['input'];
  /** Número do lote */
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  /** Nível de estoque mínimo */
  minimumBalance?: InputMaybe<Scalars['Float']['input']>;
  /** Saldo físico em estoque */
  physicalBalance?: InputMaybe<Scalars['Float']['input']>;
  /** ID do produto */
  productId?: InputMaybe<Scalars['String']['input']>;
  /** ID do armazém */
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type TStockMovement = {
  __typename?: 'StockMovement';
  /** Quantidade movimentada */
  amount: Scalars['Float']['output'];
  /** Quantidade confirmada */
  amountConfirmed: Scalars['Float']['output'];
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** ID da entrega de peça de reposição */
  deliverySparePartId?: Maybe<Scalars['String']['output']>;
  /** ID no sistema ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** Indica se é uma informação histórica */
  historicInfo?: Maybe<Scalars['Boolean']['output']>;
  /** ID da movimentação de estoque */
  id: Scalars['String']['output'];
  /** ID da entrega de EPI */
  ipeDeliveryId?: Maybe<Scalars['String']['output']>;
  /** Número do lote */
  lotNumber?: Maybe<Scalars['String']['output']>;
  /** Observações sobre a movimentação */
  observation: Scalars['String']['output'];
  /** ID da entrega de produto */
  productDeliveryId?: Maybe<Scalars['String']['output']>;
  /** ID do produto */
  productId: Scalars['String']['output'];
  /** Status da movimentação */
  status: TStockMovementStatus;
  /** Tipo de movimentação de estoque */
  type: TStockMovementType;
  /** Data de atualização */
  updatedAt: Scalars['DateTime']['output'];
  /** ID do armazém */
  warehouseId: Scalars['String']['output'];
  /** Referência ao armazém */
  warehouseRef?: Maybe<TWarehouse>;
};

export type TStockMovementInput = {
  /** Quantidade movimentada */
  amount: Scalars['Float']['input'];
  /** Quantidade confirmada */
  amountConfirmed: Scalars['Float']['input'];
  /** ID da entrega de peça de reposição */
  deliverySparePartId?: InputMaybe<Scalars['String']['input']>;
  /** ID no sistema ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Indica se é uma informação histórica */
  historicInfo?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID da entrega de EPI */
  ipeDeliveryId?: InputMaybe<Scalars['String']['input']>;
  /** Número do lote */
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  /** Observações sobre a movimentação */
  observation: Scalars['String']['input'];
  /** ID da entrega de produto */
  productDeliveryId?: InputMaybe<Scalars['String']['input']>;
  /** ID do produto */
  productId: Scalars['String']['input'];
  /** Status da movimentação */
  status?: InputMaybe<TStockMovementStatus>;
  /** Tipo de movimentação de estoque */
  type: TStockMovementType;
  /** ID do armazém */
  warehouseId: Scalars['String']['input'];
};

/** Status da movimentação de estoque */
export enum TStockMovementStatus {
  /** Concluído */
  Done = 'Done',
  /** Parcial */
  Partial = 'Partial',
  /** Pendente */
  Pending = 'Pending'
}

/** Tipo de movimento de estoque */
export enum TStockMovementType {
  /** Entrada */
  In = 'In',
  /** Saída */
  Out = 'Out'
}

export type TStockMovementUpdate = {
  /** Quantidade movimentada */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Quantidade confirmada */
  amountConfirmed?: InputMaybe<Scalars['Float']['input']>;
  /** ID da entrega de peça de reposição */
  deliverySparePartId?: InputMaybe<Scalars['String']['input']>;
  /** ID no sistema ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Indica se é uma informação histórica */
  historicInfo?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID da movimentação de estoque */
  id: Scalars['String']['input'];
  /** ID da entrega de EPI */
  ipeDeliveryId?: InputMaybe<Scalars['String']['input']>;
  /** Número do lote */
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  /** Observações sobre a movimentação */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** ID da entrega de produto */
  productDeliveryId?: InputMaybe<Scalars['String']['input']>;
  /** ID do produto */
  productId?: InputMaybe<Scalars['String']['input']>;
  /** Status da movimentação */
  status?: InputMaybe<TStockMovementStatus>;
  /** Tipo de movimentação de estoque */
  type?: InputMaybe<TStockMovementType>;
  /** ID do armazém */
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type TSubscription = {
  __typename?: 'Subscription';
  accidentMessage: TStepMessage;
  candidateMessage: TStepMessage;
  componentMessage: TStepMessage;
  expectedExamsMessage: TStepMessage;
  integrationMessage: TStepMessage;
  medicalCertificateMessage: TStepMessage;
  ohcMessage: TStepMessage;
};

export type TSubscriptionLevelDiscount = {
  /** Descontos por nível */
  values: Array<TLevelDiscount>;
};

export type TSuggestionAmount = {
  __typename?: 'SuggestionAmount';
  /** Quantidade de sugestões */
  amount: Scalars['Float']['output'];
  /** Mês */
  month: Scalars['Float']['output'];
  /** Ano */
  year: Scalars['Float']['output'];
};

export type TSuggestionBox = {
  __typename?: 'SuggestionBox';
  /** Comentários adicionais sobre a sugestão */
  comments?: Maybe<Scalars['String']['output']>;
  /** Descrição da sugestão */
  description: Scalars['String']['output'];
  /** ID da sugestão */
  id: Scalars['String']['output'];
  /** Local onde a sugestão foi feita */
  localSuggestion: Scalars['String']['output'];
  /** Mandato da CIPA associado à sugestão */
  mandate?: Maybe<TMandate>;
  /** Pessoa que fez a sugestão */
  person?: Maybe<TPerson>;
  /** Prioridade da sugestão */
  priority: TPriority;
  /** Status da sugestão */
  status: TStatusSuggestion;
};

export type TSuggestionBoxInput = {
  /** Comentários adicionais sobre a sugestão */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Descrição da sugestão */
  description: Scalars['String']['input'];
  /** Local onde a sugestão foi feita */
  localSuggestion: Scalars['String']['input'];
  /** ID do mandato da CIPA */
  mandateId: Scalars['String']['input'];
  /** ID da pessoa que fez a sugestão */
  personId?: InputMaybe<Scalars['String']['input']>;
  /** Prioridade da sugestão */
  priority: TPriority;
  /** Status da sugestão */
  status: TStatusSuggestion;
};

export type TSuggestionBoxListReport = {
  __typename?: 'SuggestionBoxListReport';
  /** Filial */
  branch: Scalars['String']['output'];
  /** Comentários sobre a sugestão */
  comment: Scalars['String']['output'];
  /** Data de criação */
  createdAt: Scalars['String']['output'];
  /** Descrição da sugestão */
  description: Scalars['String']['output'];
  /** Nome do funcionário */
  employee?: Maybe<Scalars['String']['output']>;
  /** Local onde a sugestão foi feita */
  localSuggestion: Scalars['String']['output'];
  /** Mandato da CIPA */
  mandate: Scalars['String']['output'];
  /** Prioridade da sugestão */
  priority: Scalars['String']['output'];
  /** Matrícula do funcionário */
  registration?: Maybe<Scalars['String']['output']>;
  /** Status da sugestão */
  status: Scalars['String']['output'];
};

export type TSuggestionBoxUpdate = {
  /** Comentários adicionais sobre a sugestão */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Descrição da sugestão */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID da sugestão */
  id: Scalars['String']['input'];
  /** Local onde a sugestão foi feita */
  localSuggestion?: InputMaybe<Scalars['String']['input']>;
  /** ID da pessoa que fez a sugestão */
  personId?: InputMaybe<Scalars['String']['input']>;
  /** Prioridade da sugestão */
  priority?: InputMaybe<TPriority>;
  /** Status da sugestão */
  status?: InputMaybe<TStatusSuggestion>;
};

export type TSummary = {
  __typename?: 'Summary';
  /** Entradas do sumário */
  entries: Array<TSummaryEntry>;
  /** Quantidade total de registros */
  totalAmount: Scalars['Int']['output'];
};

export type TSummaryEntry = {
  __typename?: 'SummaryEntry';
  /** Nome do filtro */
  name: Scalars['String']['output'];
  /** Opções disponíveis */
  options: Array<TSummaryOption>;
  /** Título do filtro */
  title: Scalars['String']['output'];
  /** Tipo de filtro */
  type: TFilterType;
};

export type TSummaryOption = {
  __typename?: 'SummaryOption';
  /** Quantidade */
  amount?: Maybe<Scalars['Int']['output']>;
  /** Descrição da opção */
  description: Scalars['String']['output'];
  /** ID da opção */
  id: Scalars['String']['output'];
};

export type TSyncDto = {
  __typename?: 'SyncDTO';
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** ID da sincronização */
  id: Scalars['String']['output'];
  /** Mês */
  month: Scalars['Float']['output'];
  /** Status da sincronização */
  status: TStatus;
  /** Data de atualização */
  updatedAt: Scalars['DateTime']['output'];
  /** Ano */
  year: Scalars['Float']['output'];
};

export type TTTalkQueue = {
  __typename?: 'TTalkQueue';
  /** Número de tentativas de envio executadas */
  attempts: Scalars['Int']['output'];
  /** Filial */
  branch: Scalars['String']['output'];
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** Data de exclusão */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Evento que gerou a mensagem */
  event: Scalars['String']['output'];
  /** ID da mensagem na fila */
  id: Scalars['String']['output'];
  /** Timestamp do último erro registrado */
  lastErrorAt?: Maybe<Scalars['DateTime']['output']>;
  /** Conteúdo da mensagem enviada */
  messageSend: Scalars['String']['output'];
  /** Agendamento da próxima retentativa (quando em retry) */
  nextAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID da pessoa relacionada */
  person: Scalars['String']['output'];
  /** Referência à pessoa */
  personRef: TPerson;
  /** Data de envio da mensagem */
  sendDate: Scalars['DateTime']['output'];
  /** Estado de envio Fase 3 (5 valores explícitos) */
  status: TTtalkQueueStatus;
  /** Descrição do status da mensagem */
  statusDescription?: Maybe<Scalars['String']['output']>;
  /** Momento em que ERP confirmou recebimento */
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Tipo da mensagem */
  type: TTypeMessage;
  /** Data de atualização */
  updatedAt: Scalars['DateTime']['output'];
  /** Verbo HTTP da mensagem */
  verb: TVerbMessage;
};

export type TTTalkQueueAll = {
  __typename?: 'TTalkQueueAll';
  /** Contagem total de mensagens */
  count: Scalars['Float']['output'];
  /** Dados paginados das mensagens */
  data: TPaginatedTTalkQueue;
};

export type TTTalkQueueFilterInput = {
  /** true = lista só o card "Falhas de eventos legados" (registros criados antes de 12/06/2026 e não enviados); false/omitido = não restringe (a separação async × legado já vem no status efetivo). Critério é a DATA de criação, não o event. */
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fim do período (last_error_at) para filtragem */
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Início do período (last_error_at) para filtragem */
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtra por estados (multi-select); padrão da aba Fase 3 = [send_failed] */
  statuses?: InputMaybe<Array<TTtalkQueueStatus>>;
  /** Filtra por tipos de mensagem (multi-select) */
  types?: InputMaybe<Array<TTypeMessage>>;
};

export type TTTalkQueueInput = {
  /** Tentativas executadas (1 no caminho síncrono legacy quando há dispatch real; 0 no caminho async pré-dispatch) */
  attempts?: InputMaybe<Scalars['Int']['input']>;
  /** Evento que gerou a mensagem */
  event: Scalars['String']['input'];
  /** Conteúdo da mensagem enviada */
  messageSend: Scalars['String']['input'];
  /** ID da pessoa relacionada */
  person: Scalars['String']['input'];
  /** Data de envio da mensagem */
  sendDate: Scalars['DateTime']['input'];
  /** ID da entidade de origem (ex.: atestado) */
  sourceId?: InputMaybe<Scalars['String']['input']>;
  /** Tipo da entidade de origem (ex.: medical_certificate) */
  sourceType?: InputMaybe<Scalars['String']['input']>;
  /** Estado de envio Fase 3 */
  status: TTtalkQueueStatus;
  /** Descrição do status da mensagem */
  statusDescription?: InputMaybe<Scalars['String']['input']>;
  /** Data de confirmação de recebimento pelo ERP */
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Tipo da mensagem */
  type: TTypeMessage;
  /** Verbo HTTP da mensagem */
  verb: TVerbMessage;
};

export type TTTalkQueueSummary = {
  __typename?: 'TTalkQueueSummary';
  /** Erro transitório (retentando) */
  error: Scalars['Int']['output'];
  /** Falhas de eventos legados (criados antes de 12/06/2026 e não enviados) — não reprocessáveis */
  legacyFailed: Scalars['Int']['output'];
  /** Aguardando primeira tentativa */
  pendingSend: Scalars['Int']['output'];
  /** ERP confirmou recebimento */
  processed: Scalars['Int']['output'];
  /** Tentativa de envio em curso */
  send: Scalars['Int']['output'];
  /** Esgotou tentativas (fluxo async, criado a partir do corte) — requer ação */
  sendFailed: Scalars['Int']['output'];
  /** Total de envios no filtro corrente */
  total: Scalars['Int']['output'];
};

export type TTableProperties = {
  __typename?: 'TableProperties';
  /** Nome da tabela */
  name: Scalars['String']['output'];
  /** Apelido da tabela */
  nickName?: Maybe<Scalars['String']['output']>;
};

export type TTask = {
  __typename?: 'Task';
  /** Descrição da tarefa */
  description?: Maybe<Scalars['String']['output']>;
  /** Nível de esforço físico da tarefa */
  effort?: Maybe<TEffort>;
  /** Funcionários vinculados à tarefa */
  employeeTasks?: Maybe<Array<TPersonByTask>>;
  /** ID da tarefa */
  id: Scalars['String']['output'];
  /** Indica se a tarefa está ativa */
  isActive: Scalars['Boolean']['output'];
  /** Nome da tarefa */
  name: Scalars['String']['output'];
  /** Identificador da filial de destino */
  targetBranchId?: Maybe<Scalars['String']['output']>;
  /** Horas trabalhadas na tarefa */
  workedHours?: Maybe<Scalars['String']['output']>;
};

export type TTaskByPerson = {
  __typename?: 'TaskByPerson';
  /** Data de término */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Data de início */
  startDate: Scalars['DateTime']['output'];
  /** Atividade */
  task: TTask;
};

export type TTaskByRisk = {
  __typename?: 'TaskByRisk';
  /** ID da relação */
  id: Scalars['String']['output'];
  /** Tarefa vinculada ao risco */
  task: TTask;
};

export type TTaskByRiskInput = {
  /** ID do risco */
  riskId: Scalars['String']['input'];
  /** ID da tarefa */
  taskId: Scalars['String']['input'];
};

export type TTaskInput = {
  /** Descrição da tarefa */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Nível de esforço físico da tarefa */
  effort?: InputMaybe<TEffort>;
  /** Funcionários a vincular à tarefa */
  employees?: InputMaybe<Array<TPersonOnTaskInput>>;
  /** Nome da tarefa */
  name: Scalars['String']['input'];
  /** Identificador da filial de destino */
  targetBranchId?: InputMaybe<Scalars['String']['input']>;
  /** Horas trabalhadas na tarefa */
  workedHours?: InputMaybe<Scalars['String']['input']>;
};

export type TTaskOnRiskInput = {
  /** ID da tarefa */
  taskId: Scalars['String']['input'];
};

export type TTaskUpdate = {
  /** Descrição da tarefa */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Nível de esforço físico da tarefa */
  effort?: InputMaybe<TEffort>;
  /** Funcionários a vincular/desvincular da tarefa */
  employees?: InputMaybe<TPersonOnTaskUpdate>;
  /** ID da tarefa */
  id: Scalars['String']['input'];
  /** Indica se a tarefa está ativa */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Nome da tarefa */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Identificador da filial de destino */
  targetBranchId?: InputMaybe<Scalars['String']['input']>;
  /** Horas trabalhadas na tarefa */
  workedHours?: InputMaybe<Scalars['String']['input']>;
};

export type TTerms = {
  __typename?: 'Terms';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
};

export type TThumbnailUpload = {
  contentLength: Scalars['Float']['input'];
  contentThumbLength?: InputMaybe<Scalars['Float']['input']>;
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  isTable?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnailUpload: Scalars['Upload']['input'];
};

export type TTimePoint = {
  __typename?: 'TimePoint';
  day: TDayOfWeek;
  hour: Scalars['String']['output'];
};

export type TTimePointInput = {
  day: TDayOfWeek;
  hour: Scalars['String']['input'];
};

/** Unidade de tempo */
export enum TTimeUnitEnum {
  /** Dia */
  Day = 'Day',
  /** Hora */
  Hour = 'Hour',
  /** Mês */
  Month = 'Month',
  /** Ano */
  Year = 'Year'
}

export type TTopIcdItem = {
  __typename?: 'TopIcdItem';
  /** Código do CID/grupo (3 primeiros caracteres) */
  code: Scalars['String']['output'];
  /** Quantidade de atestados */
  count: Scalars['Float']['output'];
  /** Descrição do grupo de CID */
  description: Scalars['String']['output'];
};

export type TTopIcdsChart = {
  __typename?: 'TopIcdsChart';
  /** Top 5 CIDs/grupos no período */
  data: Array<TTopIcdItem>;
  /** Indica se há atestados com CID no período */
  hasCertificate: Scalars['Boolean']['output'];
};

/** Tipo de acidente de trânsito */
export enum TTrafficAccidentType {
  /** Colisão */
  Collision = 'collision',
  /** Outro tipo de acidente */
  Other = 'other',
  /** Atropelamento */
  Trampling = 'trampling'
}

export type TTraining = {
  __typename?: 'Training';
  /** Descrição do treinamento */
  description: Scalars['String']['output'];
  /** ID no sistema ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** ID do treinamento */
  id: Scalars['String']['output'];
  /** Indica se o treinamento está ativo */
  isActive: Scalars['Boolean']['output'];
  /** ID de referência externo */
  referenceId?: Maybe<Scalars['String']['output']>;
};

export type TTrainingByRisk = {
  __typename?: 'TrainingByRisk';
  /** Erro de integração, se houver */
  errorIntegration?: Maybe<Scalars['String']['output']>;
  /** ID da relação */
  id: Scalars['String']['output'];
  /** Treinamento vinculado ao risco */
  training: TTraining;
  /** Urgência do treinamento */
  urgency: TTrainingUrgency;
};

export type TTrainingByRiskInput = {
  /** ID do risco */
  riskId: Scalars['String']['input'];
  /** ID do treinamento */
  trainingId: Scalars['String']['input'];
  /** Urgência do treinamento */
  urgency: TTrainingUrgency;
};

export type TTrainingEligiblePerson = {
  __typename?: 'TrainingEligiblePerson';
  /** Última realização foi aprovada */
  approved?: Maybe<Scalars['Boolean']['output']>;
  /** ID do centro de custo */
  costCenterId?: Maybe<Scalars['String']['output']>;
  /** CPF (registro individual) */
  cpf?: Maybe<Scalars['String']['output']>;
  /** ID do departamento */
  departmentId?: Maybe<Scalars['String']['output']>;
  /** Data de validade da última realização */
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Data da última realização */
  lastCompletionDate?: Maybe<Scalars['DateTime']['output']>;
  /** Nome (ou nome social, se houver) */
  name: Scalars['String']['output'];
  /** ID da ocupação */
  occupationId?: Maybe<Scalars['String']['output']>;
  /** Origens que geram a necessidade deste treinamento */
  origins: Array<TTrainingNecessityOrigin>;
  /** ID da pessoa */
  personId: Scalars['String']['output'];
  /** Matrícula */
  registration?: Maybe<Scalars['String']['output']>;
  /** Status calculado da realização do treinamento */
  status: TTrainingEligibleStatus;
};

export type TTrainingEligiblePersonsFilters = {
  /** Filtra por centro de custo */
  costCenterId?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por departamento */
  departmentId?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por ocupação */
  occupationId?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por origem da necessidade */
  origins?: InputMaybe<Array<TTrainingNecessityOrigin>>;
  /** Busca por nome ou CPF */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por status */
  statuses?: InputMaybe<Array<TTrainingEligibleStatus>>;
};

export type TTrainingEligiblePersonsResult = {
  __typename?: 'TrainingEligiblePersonsResult';
  /** Indica se há mais itens disponíveis */
  hasMore: Scalars['Boolean']['output'];
  /** Lista de itens da página */
  items: Array<TTrainingEligiblePerson>;
  /** Total de itens disponíveis */
  total: Scalars['Float']['output'];
};

/** Status da realização do treinamento por pessoa */
export enum TTrainingEligibleStatus {
  Expired = 'Expired',
  Expiring = 'Expiring',
  Never = 'Never',
  Ok = 'Ok'
}

export type TTrainingHistory = {
  __typename?: 'TrainingHistory';
  /** Indica se o treinamento foi aprovado */
  approved?: Maybe<Scalars['Boolean']['output']>;
  /** Anexos do histórico de treinamento */
  attachments?: Maybe<Array<TAttachment>>;
  /** Data de conclusão do treinamento */
  completionDate?: Maybe<Scalars['DateTime']['output']>;
  /** ID no sistema ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** Data prevista para o treinamento */
  expectedDate: Scalars['DateTime']['output'];
  /** Data de expiração do treinamento */
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** ID do histórico de treinamento */
  id: Scalars['String']['output'];
  /** Pessoa que realizou o treinamento */
  person: TPerson;
  /** Treinamento realizado */
  training: TTraining;
};

export type TTrainingHistoryBatchInput = {
  /** Indica se o treinamento foi aprovado */
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Data de conclusão do treinamento */
  completionDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data prevista para o treinamento */
  expectedDate: Scalars['DateTime']['input'];
  /** Data de expiração do treinamento */
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtros usados para resolver o conjunto quando selectAll=true */
  filters?: InputMaybe<TTrainingEligiblePersonsFilters>;
  /** IDs das pessoas que receberão o histórico de treinamento */
  personIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Quando true, ignora personIds e lança para todos os elegíveis que correspondem ao filtro atual */
  selectAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID do treinamento */
  trainingId: Scalars['String']['input'];
};

export type TTrainingHistoryBatchResult = {
  __typename?: 'TrainingHistoryBatchResult';
  /** IDs de pessoas que já tinham realização para esta data (conflito de unicidade — não foram recriadas) */
  conflicts: Array<Scalars['String']['output']>;
  /** Quantidade de históricos criados */
  created: Scalars['Int']['output'];
  /** IDs de pessoas que falharam por erro inesperado */
  errors: Array<Scalars['String']['output']>;
};

export type TTrainingHistoryByPerson = {
  __typename?: 'TrainingHistoryByPerson';
  /** Indica se o treinamento foi aprovado */
  approved?: Maybe<Scalars['Boolean']['output']>;
  /** Anexos do histórico de treinamento */
  attachments?: Maybe<Array<TAttachment>>;
  /** Data de conclusão do treinamento */
  completionDate?: Maybe<Scalars['DateTime']['output']>;
  /** ID no sistema ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** Data prevista para o treinamento */
  expectedDate: Scalars['DateTime']['output'];
  /** Data de expiração do treinamento */
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** ID do histórico de treinamento */
  id: Scalars['String']['output'];
  /** Treinamento realizado */
  training: TTraining;
};

export type TTrainingHistoryInput = {
  /** Indica se o treinamento foi aprovado */
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Data de conclusão do treinamento */
  completionDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID no sistema ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Data prevista para o treinamento */
  expectedDate: Scalars['DateTime']['input'];
  /** Data de expiração do treinamento */
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID da pessoa */
  personId: Scalars['String']['input'];
  /** ID do treinamento */
  trainingId: Scalars['String']['input'];
};

export type TTrainingHistoryOnPersonInput = {
  /** Indica se o treinamento foi aprovado */
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Data de conclusão do treinamento */
  completionDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID no sistema ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Data prevista para o treinamento */
  expectedDate: Scalars['DateTime']['input'];
  /** Data de expiração do treinamento */
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID do histórico de treinamento */
  id?: InputMaybe<Scalars['String']['input']>;
  /** ID do treinamento */
  trainingId: Scalars['String']['input'];
};

export type TTrainingHistoryOnPersonRemove = {
  /** Data prevista para o treinamento */
  expectedDate: Scalars['DateTime']['input'];
  /** ID do treinamento */
  trainingId: Scalars['String']['input'];
};

export type TTrainingHistoryOnPersonUpdate = {
  /** Históricos de treinamento a serem criados */
  toCreate: Array<TTrainingHistoryOnPersonInput>;
  /** Históricos de treinamento a serem removidos */
  toRemove: Array<TTrainingHistoryOnPersonRemove>;
  /** Históricos de treinamento a serem atualizados */
  toUpdate: Array<TTrainingHistoryOnPersonInput>;
};

export type TTrainingHistoryUpdate = {
  /** Indica se o treinamento foi aprovado */
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Data de conclusão do treinamento */
  completionDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID no sistema ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Data prevista para o treinamento */
  expectedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Data de expiração do treinamento */
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID do histórico de treinamento */
  id: Scalars['String']['input'];
  /** ID da pessoa */
  personId: Scalars['String']['input'];
  /** ID do treinamento */
  trainingId?: InputMaybe<Scalars['String']['input']>;
};

export type TTrainingInput = {
  /** Descrição do treinamento */
  description: Scalars['String']['input'];
  /** ID no sistema ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** ID de referência externo */
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type TTrainingIntegration = {
  /** Filial */
  branch: Scalars['String']['input'];
  /** Descrição do treinamento */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID no sistema ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** ID do treinamento */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID de referência externo */
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

/** Origem da necessidade de treinamento */
export enum TTrainingNecessityOrigin {
  Cipa = 'Cipa',
  FireBrigade = 'FireBrigade',
  HealthProgram = 'HealthProgram',
  Risk = 'Risk'
}

export type TTrainingOnRiskInput = {
  /** ID do treinamento */
  trainingId: Scalars['String']['input'];
  /** Urgência do treinamento */
  urgency: TTrainingUrgency;
};

export type TTrainingOnRiskUpdate = {
  /** Treinamentos a serem vinculados */
  toCreate: Array<TTrainingOnRiskInput>;
  /** IDs dos treinamentos a serem removidos */
  toRemove: Array<Scalars['String']['input']>;
};

export type TTrainingUpdate = {
  /** Descrição do treinamento */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID do treinamento */
  id: Scalars['String']['input'];
  /** Indica se o treinamento está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID de referência externo */
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

/** Urgência do treinamento */
export enum TTrainingUrgency {
  /** Desejado */
  Desired = 'Desired',
  /** Indispensável */
  Indispensable = 'Indispensable',
  /** Recomendado */
  Recommended = 'Recommended'
}

export type TTransferBlockedItem = {
  __typename?: 'TransferBlockedItem';
  /** ID da consulta bloqueada */
  id: Scalars['String']['output'];
  /** Motivo do bloqueio */
  reason: Scalars['String']['output'];
};

export type TTransferConsultationsInput = {
  /** IDs das consultas a transferir */
  ids: Array<Scalars['String']['input']>;
  /** ID do novo credenciado */
  newAccreditedId?: InputMaybe<Scalars['String']['input']>;
  /** ID do novo médico interno */
  newDoctorId?: InputMaybe<Scalars['String']['input']>;
  /** Nova data estimada (opcional, para reposicionar na agenda) */
  newEstimatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Nome do médico externo */
  newExternalDoctor?: InputMaybe<Scalars['String']['input']>;
  /** ID do novo enfermeiro */
  newNurseId?: InputMaybe<Scalars['String']['input']>;
};

export type TTransferConsultationsResult = {
  __typename?: 'TransferConsultationsResult';
  /** Consultas que não puderam ser transferidas */
  blocked: Array<TTransferBlockedItem>;
  /** IDs transferidos com sucesso */
  transferred: Array<Scalars['String']['output']>;
};

export type TTtalkInboundEvent = {
  __typename?: 'TtalkInboundEvent';
  /** Tentativas de processamento */
  attempts: Scalars['Float']['output'];
  /** ID da filial */
  branch: Scalars['String']['output'];
  /** Tipo da entidade (ex: employee, dependant) */
  entityType: Scalars['String']['output'];
  /** ID externo do evento (TTalk) */
  eventIdExternal: Scalars['String']['output'];
  /** ID do evento na fila inbound */
  id: Scalars['String']['output'];
  /** Última mensagem de erro */
  lastError?: Maybe<Scalars['String']['output']>;
  /** Quando ocorreu o último erro */
  lastErrorAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID da organização */
  organizationId: Scalars['String']['output'];
  /** Payload recebido em formato JSON (string) */
  payload: Scalars['String']['output'];
  /** Quando foi processado com sucesso */
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Quando foi recebido */
  receivedAt: Scalars['DateTime']['output'];
  /** Status atual do processamento */
  status: TTtalkInboundEventStatus;
};

export type TTtalkInboundEventFilterInput = {
  /** Filtrar por um ou mais tipos de entidade */
  entityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtrar por organização */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Recebido a partir desta data */
  receivedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Recebido até esta data (inclusive) */
  receivedTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtrar por um ou mais status */
  statuses?: InputMaybe<Array<TTtalkInboundEventStatus>>;
};

/** Estado de um evento recebido via Fase 2 (push TTalk) — usado pelo painel admin de recepção para filtrar fila/DLQ/inconsistências */
export enum TTtalkInboundEventStatus {
  /** Falhou >= 3 vezes (DLQ). Requer reprocessamento manual. */
  DeadLetter = 'DeadLetter',
  /** Processado, mas violou regra semântica. Painel admin lista os flagados para SESMT/admin reconhecer. */
  Inconsistent = 'Inconsistent',
  /** Aplicado com sucesso na entidade local */
  Processed = 'Processed',
  /** Subscriber pegou o evento e está processando */
  Processing = 'Processing',
  /** Aguardando processamento na fila inbound */
  Queued = 'Queued'
}

export type TTtalkInboundSemanticInconsistency = {
  __typename?: 'TtalkInboundSemanticInconsistency';
  /** Quando foi reconhecida */
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User que reconheceu a inconsistência */
  acknowledgedBy?: Maybe<Scalars['String']['output']>;
  /** Descrição contextual da violação */
  description?: Maybe<Scalars['String']['output']>;
  /** Quando foi detectada */
  flaggedAt: Scalars['DateTime']['output'];
  /** ID da inconsistência */
  id: Scalars['String']['output'];
  /** ID do evento inbound relacionado */
  inboundEventId: Scalars['String']['output'];
  /** ID da organização */
  organizationId: Scalars['String']['output'];
  /** Payload do evento inbound relacionado (JSON string) */
  payload?: Maybe<Scalars['String']['output']>;
  /** Regra violada (ex: V-04, V-05, V-07) */
  ruleViolated: Scalars['String']['output'];
};

export type TTtalkInboundSilenceMonitor = {
  __typename?: 'TtalkInboundSilenceMonitor';
  /** ID da filial */
  branchId: Scalars['String']['output'];
  /** Nome da filial */
  branchName: Scalars['String']['output'];
  /** Se o monitor (org+entidade) está habilitado */
  enabled: Scalars['Boolean']['output'];
  /** Tipo de entidade monitorada */
  entityType: Scalars['String']['output'];
  /** ID do registro de estado */
  id: Scalars['String']['output'];
  /** Último alerta disparado para este par */
  lastAlertAt?: Maybe<Scalars['DateTime']['output']>;
  /** Último evento recebido nesta filial+entidade */
  lastEventAt?: Maybe<Scalars['DateTime']['output']>;
  /** Destinatários (vêm da config da org) */
  notificationRecipients?: Maybe<Array<Scalars['String']['output']>>;
  /** ID da organização */
  organizationId: Scalars['String']['output'];
  /** Threshold em horas (config da organização) */
  thresholdHours: Scalars['Float']['output'];
};

export type TTtalkInboundSilenceThreshold = {
  __typename?: 'TtalkInboundSilenceThreshold';
  /** Habilitado */
  enabled: Scalars['Boolean']['output'];
  /** Tipo de entidade */
  entityType: Scalars['String']['output'];
  /** ID do threshold */
  id: Scalars['String']['output'];
  /** Destinatários (e-mails) */
  notificationRecipients?: Maybe<Array<Scalars['String']['output']>>;
  /** ID da organização */
  organizationId: Scalars['String']['output'];
  /** Threshold em horas */
  thresholdHours: Scalars['Float']['output'];
};

export type TTtalkInboundSilenceThresholdInput = {
  /** Habilitar */
  enabled: Scalars['Boolean']['input'];
  /** Tipo de entidade (employee, dependant, ...) */
  entityType: Scalars['String']['input'];
  /** Destinatários (e-mails) */
  notificationRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ID da organização */
  organizationId: Scalars['String']['input'];
  /** Threshold em horas */
  thresholdHours: Scalars['Float']['input'];
};

/** Estado de envio Fase 3 (mdt.ttalk_queue) */
export enum TTtalkQueueStatus {
  /** Erro transitório (retentativa em andamento) */
  Error = 'Error',
  /** Salvo localmente, aguardando primeira tentativa */
  PendingSend = 'PendingSend',
  /** ERP confirmou recebimento */
  Processed = 'Processed',
  /** Tentativa de envio em curso */
  Send = 'Send',
  /** Esgotou tentativas — requer ação do gestor */
  SendFailed = 'SendFailed'
}

export type TTypeChart = {
  __typename?: 'TypeChart';
  /** Indica se há acidentes registrados */
  hasAccident: Scalars['Boolean']['output'];
  /** Incidentes */
  incident: Scalars['Float']['output'];
  /** Acidentes de trajeto */
  onWay: Scalars['Float']['output'];
  /** Acidentes típicos */
  typical: Scalars['Float']['output'];
  /** Doenças ocupacionais */
  workDisease: Scalars['Float']['output'];
};

export type TTypeCostCenterChart = {
  __typename?: 'TypeCostCenterChart';
  /** Centros de custo por total de acidentes */
  costCenterPerTotal: Array<TData>;
  /** Indica se há acidentes registrados */
  hasAccident: Scalars['Boolean']['output'];
  /** Incidentes por centro de custo */
  incident: Array<TData>;
  /** Acidentes de trajeto por centro de custo */
  onWay: Array<TData>;
  /** Acidentes típicos por centro de custo */
  typical: Array<TData>;
  /** Doenças ocupacionais por centro de custo */
  workDisease: Array<TData>;
};

/** Tipo de deficiência intelectual */
export enum TTypeIntellectualDeficiency {
  /** Habilidades acadêmicas */
  AcademicSkills = 'AcademicSkills',
  /** Comunicação */
  Communication = 'Communication',
  /** Saúde e segurança */
  HealthAndSafety = 'HealthAndSafety',
  /** Lazer */
  Leisure = 'Leisure',
  /** Cuidados pessoais */
  PersonalCare = 'PersonalCare',
  /** Habilidades sociais */
  SocialSkills = 'SocialSkills',
  /** Uso de recursos comunitários */
  UseOfCommunityResources = 'UseOfCommunityResources',
  /** Trabalho */
  Work = 'Work'
}

/** Tipo de mensagem */
export enum TTypeMessage {
  /** Mensagem adicional */
  Additional = 'Additional',
  /** Mensagem de subsídio */
  Allowance = 'Allowance',
  /** Mensagem de deficiências de informação */
  InformationDeficiencies = 'InformationDeficiencies',
  /** Mensagem de afastamento */
  LeaveOfAbscence = 'LeaveOfAbscence',
  /** Mensagem de aposentadoria especial */
  SpecialRetirement = 'SpecialRetirement',
  /** Mensagem de estabilidade */
  Stability = 'Stability',
  /** Mensagem de necessidade de treinamento */
  TrainingNecessity = 'TrainingNecessity'
}

/** Tipo de deficiência física */
export enum TTypePhysicalDeficiency {
  /** Amputação ou ausência de membro */
  AmputationOrMissingLimb = 'AmputationOrMissingLimb',
  /** Paralisia cerebral */
  CerebralPalsy = 'CerebralPalsy',
  /** Nanismo */
  Dwarfism = 'Dwarfism',
  /** Hemiparesia */
  Hemiparesis = 'Hemiparesis',
  /** Hemiplegia */
  Hemiplegia = 'Hemiplegia',
  /** Deformidade congênita ou adquirida de membros */
  LimbsCongenitalOrAcquiredDeformity = 'LimbsCongenitalOrAcquiredDeformity',
  /** Monoparesia */
  Monoparesis = 'Monoparesis',
  /** Monoplegia */
  Monoplegia = 'Monoplegia',
  /** Ostomia */
  Ostomy = 'Ostomy',
  /** Paraparesia */
  Paraparesis = 'Paraparesis',
  /** Paraplegia */
  Paraplegia = 'Paraplegia',
  /** Tetraparesia */
  Tetraparesis = 'Tetraparesis',
  /** Tetraplegia */
  Tetraplegia = 'Tetraplegia',
  /** Triparesia */
  Triparesia = 'Triparesia',
  /** Triplegia */
  Triplegia = 'Triplegia'
}

/** Tipo de processo */
export enum TTypeProcess {
  /** Administrativo */
  Administrative = 'Administrative',
  /** Número de benefício */
  BenefitNumber = 'BenefitNumber',
  /** Judicial */
  Judicial = 'Judicial'
}

/** Tipo de deficiência visual */
export enum TTypeVisualDeficiency {
  /** Biocular */
  Biocular = 'Biocular',
  /** Monocular */
  Monocular = 'Monocular'
}

export type TUtmInput = {
  /** Campanha UTM */
  campaign?: InputMaybe<Scalars['String']['input']>;
  /** Conteúdo UTM */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Meio UTM */
  medium: Scalars['String']['input'];
  /** Fonte UTM */
  source: Scalars['String']['input'];
  /** Termo UTM */
  term?: InputMaybe<Scalars['String']['input']>;
};

export type TUnityOfMeasure = {
  __typename?: 'UnityOfMeasure';
  /** Sigla da unidade de medida */
  acronym: Scalars['String']['output'];
  /** ID no sistema ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** ID da unidade de medida */
  id: Scalars['String']['output'];
  /** Indica se a unidade de medida está ativa */
  isActive: Scalars['Boolean']['output'];
  /** Nome da unidade de medida */
  name: Scalars['String']['output'];
};

export type TUnityOfMeasureInput = {
  /** Sigla da unidade de medida */
  acronym: Scalars['String']['input'];
  /** ID no sistema ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Indica se a unidade de medida está ativa */
  isActive: Scalars['Boolean']['input'];
  /** Nome da unidade de medida */
  name: Scalars['String']['input'];
};

export type TUnityOfMeasureIntegration = {
  /** Sigla da unidade de medida */
  acronym?: InputMaybe<Scalars['String']['input']>;
  /** Filial */
  branch: Scalars['String']['input'];
  /** ID no sistema ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** ID da unidade de medida */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Indica se a unidade de medida está ativa */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Nome da unidade de medida */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TUnityOfMeasureUpdate = {
  /** Sigla da unidade de medida */
  acronym?: InputMaybe<Scalars['String']['input']>;
  /** ID no sistema ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** ID da unidade de medida */
  id: Scalars['String']['input'];
  /** Indica se a unidade de medida está ativa */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Nome da unidade de medida */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TUnscheduledConsultation = {
  /** Exames complementares */
  complementaryExams?: InputMaybe<Array<TExamOnConsultationInput>>;
  /** Identificador da consulta */
  consultationId?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de consulta */
  consultationType: TConsultationType;
  /** Identificador do médico */
  doctorId?: InputMaybe<Scalars['String']['input']>;
  /** Tempo estimado em minutos */
  estimatedTime: Scalars['Float']['input'];
  /** Identificador do questionário de anamnese esperado para esta consulta */
  expectedClinicalQuizId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do enfermeiro */
  nurseId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador do paciente */
  patientId: Scalars['String']['input'];
};

export type TUnscheduledInput = {
  /** Forçar agendamento */
  forceSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  /** Obter próximo horário disponível */
  getNextAvailableTime?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retornar erro em caso de conflito */
  returnOnConflictError?: InputMaybe<Scalars['Boolean']['input']>;
  /** Data e hora de início */
  startDateTime: Scalars['DateTime']['input'];
  /** Consultas para agendar */
  toSchedule: Array<TUnscheduledConsultation>;
};

/** Payload para atualizar uma customização. `expectedUpdatedAt` deve casar com o updatedAt atual no banco — caso contrário a mutation falha (stale write). */
export type TUpdateCustomDocumentInput = {
  /** JSON canônico atualizado. Validação superficial no service (Phase 1A.10); codec io-ts completo após 1A.2. */
  definition?: InputMaybe<Scalars['JSON']['input']>;
  /** Timestamp do updatedAt visto pelo cliente. Resolver compara contra o do banco — diff = StaleWriteError → 409. */
  expectedUpdatedAt: Scalars['DateTime']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TUpdateMetadataInput = {
  /** Campos */
  fields?: InputMaybe<Array<TFieldsInput>>;
  /** Tipo de integração */
  integrationType?: InputMaybe<TErpType>;
  /** Indica se é customizável */
  isCustomizable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Nome do metadado */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID do metadado SaaS */
  saasMetadataId: Scalars['String']['input'];
  /** Versão */
  version?: InputMaybe<Scalars['Float']['input']>;
};

export type TUrinalysis = {
  __typename?: 'Urinalysis';
  /** Presença de bilirrubina */
  bilirubin: TBilirubinEnum;
  /** Exame complementar associado */
  complementaryExam?: Maybe<TComplementaryExam>;
  /** Consulta associada ao exame */
  consultation?: Maybe<TConsultation>;
  /** CRM do médico */
  crm?: Maybe<Scalars['String']['output']>;
  /** Data de realização do exame */
  date: Scalars['DateTime']['output'];
  /** Densidade da urina */
  density: TDensityEnum;
  /** Detalhes do exame */
  details?: Maybe<Scalars['String']['output']>;
  /** Indicador diagnóstico do exame */
  diagnosticIndicator: TExamDiagnosticIndicatorEnum;
  /** Nome do médico */
  doctor?: Maybe<Scalars['String']['output']>;
  /** Autorização para realização do exame */
  examAuthorization: Scalars['Boolean']['output'];
  /** Nível de glicose */
  glycolysis: TGlycolysisEnum;
  /** ID do exame de urinálise */
  id: Scalars['String']['output'];
  /** Indicador do resultado do exame */
  indicator: TExamResultIndicatorEnum;
  /** Presença de cetonas */
  ketones: TKetonesEnum;
  /** Nível de leucócitos */
  leukocytes: TLeukocytesEnum;
  /** Presença de nitritos */
  nitrites: TNitritesEnum;
  /** Observações */
  observations?: Maybe<Scalars['String']['output']>;
  /** Nível de pH */
  ph: TPhEnum;
  /** Presença de proteínas */
  proteins: TProteinsEnum;
  /** Presença de hemácias */
  redCells: TRedCellsEnum;
  /** Tempo de repouso */
  restTime?: Maybe<Scalars['String']['output']>;
  /** Resultado do exame */
  result: Scalars['String']['output'];
  /** Agravamento do resultado */
  resultAggravation?: Maybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: Maybe<TExamResultAlterationEnum>;
  /** Estado do CRM */
  state?: Maybe<TState>;
  /** Nível de urobilinogênio */
  urobilinogen: TUrobilinogenEnum;
};

export type TUrinalysisInput = {
  /** Presença de bilirrubina */
  bilirubin: TBilirubinEnum;
  /** ID do exame complementar associado */
  complementaryExamId?: InputMaybe<Scalars['String']['input']>;
  /** ID da consulta associada */
  consultationId?: InputMaybe<Scalars['String']['input']>;
  /** CRM do médico */
  crm?: InputMaybe<Scalars['String']['input']>;
  /** Data de realização do exame */
  date: Scalars['DateTime']['input'];
  /** Densidade da urina */
  density: TDensityEnum;
  /** Detalhes do exame */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Indicador diagnóstico do exame */
  diagnosticIndicator: TExamDiagnosticIndicatorEnum;
  /** Nome do médico */
  doctor?: InputMaybe<Scalars['String']['input']>;
  /** Autorização para realização do exame */
  examAuthorization: Scalars['Boolean']['input'];
  /** Nível de glicose */
  glycolysis: TGlycolysisEnum;
  /** Indicador do resultado do exame */
  indicator: TExamResultIndicatorEnum;
  /** Presença de cetonas */
  ketones: TKetonesEnum;
  /** Nível de leucócitos */
  leukocytes: TLeukocytesEnum;
  /** Presença de nitritos */
  nitrites: TNitritesEnum;
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** Nível de pH */
  ph: TPhEnum;
  /** Presença de proteínas */
  proteins: TProteinsEnum;
  /** Presença de hemácias */
  redCells: TRedCellsEnum;
  /** Tempo de repouso */
  restTime?: InputMaybe<Scalars['String']['input']>;
  /** Resultado do exame */
  result: Scalars['String']['input'];
  /** Agravamento do resultado */
  resultAggravation?: InputMaybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: InputMaybe<TExamResultAlterationEnum>;
  /** Estado do CRM */
  state?: InputMaybe<TState>;
  /** Nível de urobilinogênio */
  urobilinogen: TUrobilinogenEnum;
};

export type TUrinalysisUpdate = {
  /** Presença de bilirrubina */
  bilirubin?: InputMaybe<TBilirubinEnum>;
  /** CRM do médico */
  crm?: InputMaybe<Scalars['String']['input']>;
  /** Data de realização do exame */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Densidade da urina */
  density?: InputMaybe<TDensityEnum>;
  /** Detalhes do exame */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Indicador diagnóstico do exame */
  diagnosticIndicator?: InputMaybe<TExamDiagnosticIndicatorEnum>;
  /** Nome do médico */
  doctor?: InputMaybe<Scalars['String']['input']>;
  /** Autorização para realização do exame */
  examAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Nível de glicose */
  glycolysis?: InputMaybe<TGlycolysisEnum>;
  /** ID do exame de urinálise */
  id: Scalars['String']['input'];
  /** Indicador do resultado do exame */
  indicator?: InputMaybe<TExamResultIndicatorEnum>;
  /** Presença de cetonas */
  ketones?: InputMaybe<TKetonesEnum>;
  /** Nível de leucócitos */
  leukocytes?: InputMaybe<TLeukocytesEnum>;
  /** Presença de nitritos */
  nitrites?: InputMaybe<TNitritesEnum>;
  /** Observações */
  observations?: InputMaybe<Scalars['String']['input']>;
  /** Nível de pH */
  ph?: InputMaybe<TPhEnum>;
  /** Presença de proteínas */
  proteins?: InputMaybe<TProteinsEnum>;
  /** Presença de hemácias */
  redCells?: InputMaybe<TRedCellsEnum>;
  /** Tempo de repouso */
  restTime?: InputMaybe<Scalars['String']['input']>;
  /** Resultado do exame */
  result?: InputMaybe<Scalars['String']['input']>;
  /** Agravamento do resultado */
  resultAggravation?: InputMaybe<TExamAggravationEnum>;
  /** Alteração do resultado */
  resultAlteration?: InputMaybe<TExamResultAlterationEnum>;
  /** Estado do CRM */
  state?: InputMaybe<TState>;
  /** Nível de urobilinogênio */
  urobilinogen?: InputMaybe<TUrobilinogenEnum>;
};

/** Níveis de urobilinogênio na urina */
export enum TUrobilinogenEnum {
  /** 8(128) */
  Eight = 'Eight',
  /** 4(64) */
  Four = 'Four',
  /** 1(16) */
  One = 'One',
  /** 2(32) */
  Two = 'Two',
  /** 0.2(3.2) */
  ZeroPointTwo = 'ZeroPointTwo'
}

/** Uso de EPI auricular */
export enum TUseOfAuricularIpeEnum {
  /** Ambos */
  Both = 'Both',
  /** Ambos alternados */
  BothAlternate = 'BothAlternate',
  /** Não utiliza */
  DoesNotUtilize = 'DoesNotUtilize',
  /** Protetor auricular de inserção */
  EarPlug = 'EarPlug',
  /** Protetor auricular tipo concha */
  Earmuff = 'Earmuff',
  /** Outros */
  Others = 'Others'
}

export type TUser = {
  __typename?: 'User';
  /** Indica a forma de acesso ao sistema */
  accessBy: TAccessBy;
  /** Endereço do usuário */
  address?: Maybe<Scalars['String']['output']>;
  /** Data de nascimento do usuário */
  birthDate?: Maybe<Scalars['String']['output']>;
  /** Número do documento do usuário */
  documentNumber?: Maybe<Scalars['String']['output']>;
  /** Grau de escolaridade */
  educationLevel?: Maybe<TEducationLevel>;
  /** Email do usuário */
  email: Scalars['String']['output'];
  /** Gênero do usuário */
  gender?: Maybe<TUserGender>;
  /** Identificador único de usuário */
  id: Scalars['ID']['output'];
  /** Indica se é um médico */
  isDoctor: Scalars['Boolean']['output'];
  /** Indica se é um agendador */
  isScheduler: Scalars['Boolean']['output'];
  /** Nome do usuário */
  name: Scalars['String']['output'];
  /** Acordos de políticas aceitos pelo usuário */
  policiesAgreement?: Maybe<Array<TPolicyAgreement>>;
  /** Preferências do usuário (layout, sidebar, favoritos) */
  preferences?: Maybe<TUserPreferences>;
  /** Foto de perfil do usuário */
  profilePicture?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** Papel do usuário */
  roles: Array<TRole>;
  /** Papel Mdt do usuário */
  rolesMdt: Array<TUserRoleMdt>;
  /** Email verificado do usuário */
  verifiedEmail?: Maybe<Scalars['String']['output']>;
};

export type TUserBasicInfo = {
  __typename?: 'UserBasicInfo';
  /** Indica a forma de acesso ao sistema */
  accessBy: TAccessBy;
  /** Endereço do usuário */
  address?: Maybe<Scalars['String']['output']>;
  /** Data de nascimento do usuário */
  birthDate?: Maybe<Scalars['String']['output']>;
  /** Número do documento do usuário */
  documentNumber?: Maybe<Scalars['String']['output']>;
  /** Grau de escolaridade */
  educationLevel?: Maybe<TEducationLevel>;
  /** Email do usuário */
  email: Scalars['String']['output'];
  /** Gênero do usuário */
  gender?: Maybe<TUserGender>;
  /** Identificador único de usuário */
  id: Scalars['ID']['output'];
  /** Indica se é um médico */
  isDoctor: Scalars['Boolean']['output'];
  /** Indica se é um agendador */
  isScheduler: Scalars['Boolean']['output'];
  /** Nome do usuário */
  name: Scalars['String']['output'];
  /** Acordos de políticas aceitos pelo usuário */
  policiesAgreement?: Maybe<Array<TPolicyAgreement>>;
  /** Preferências do usuário (layout, sidebar, favoritos) */
  preferences?: Maybe<TUserPreferences>;
  /** Foto de perfil do usuário */
  profilePicture?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** Email verificado do usuário */
  verifiedEmail?: Maybe<Scalars['String']['output']>;
};

export type TUserCreationInput = {
  accessBy?: InputMaybe<TAccessBy>;
  /** Endereço do usuário */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Data de nascimento do usuário */
  birthDate?: InputMaybe<Scalars['String']['input']>;
  /** Número do documento do usuário */
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  /** Grau de escolaridade */
  educationLevel?: InputMaybe<TEducationLevel>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Gênero do usuário */
  gender?: InputMaybe<TUserGender>;
  inviteToken?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<TOrganizationInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  utm?: InputMaybe<TUtmInput>;
};

export type TUserFilterPreferenceResult = {
  __typename?: 'UserFilterPreferenceResult';
  filtersJson: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  module: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TUserFromCreation = {
  __typename?: 'UserFromCreation';
  /** Indica a forma de acesso ao sistema */
  accessBy: TAccessBy;
  /** Endereço do usuário */
  address?: Maybe<Scalars['String']['output']>;
  /** Data de nascimento do usuário */
  birthDate?: Maybe<Scalars['String']['output']>;
  /** Número do documento do usuário */
  documentNumber?: Maybe<Scalars['String']['output']>;
  /** Grau de escolaridade */
  educationLevel?: Maybe<TEducationLevel>;
  /** Email do usuário */
  email: Scalars['String']['output'];
  /** Gênero do usuário */
  gender?: Maybe<TUserGender>;
  /** Identificador único de usuário */
  id: Scalars['ID']['output'];
  /** Indica se é um médico */
  isDoctor: Scalars['Boolean']['output'];
  /** Indica se é um agendador */
  isScheduler: Scalars['Boolean']['output'];
  /** Nome do usuário */
  name: Scalars['String']['output'];
  organization?: Maybe<TOrganizationWithBranches>;
  /** Acordos de políticas aceitos pelo usuário */
  policiesAgreement?: Maybe<Array<TPolicyAgreement>>;
  /** Preferências do usuário (layout, sidebar, favoritos) */
  preferences?: Maybe<TUserPreferences>;
  /** Foto de perfil do usuário */
  profilePicture?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  /** Email verificado do usuário */
  verifiedEmail?: Maybe<Scalars['String']['output']>;
};

/** Gênero do usuário */
export enum TUserGender {
  /** Feminino */
  Female = 'Female',
  /** Masculino */
  Male = 'Male'
}

export type TUserOrganizationListing = {
  __typename?: 'UserOrganizationListing';
  accessBy?: Maybe<TAccessBy>;
  branches: Array<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['S3UrlCloudFront']['output']>;
  roleId: Scalars['String']['output'];
  rolesMdt: Array<TUserRoleMdt>;
  status: Scalars['String']['output'];
};

/** Preferências de usuário (layout, sidebar, favoritos) */
export type TUserPreferences = {
  __typename?: 'UserPreferences';
  /** Versão do layout escolhida pelo usuário */
  designVersion?: Maybe<TDesignVersion>;
  /** Sidebar expandida (true) ou colapsada (false) */
  expandedSidebar?: Maybe<Scalars['Boolean']['output']>;
  /** Lista de itens favoritados na sidebar */
  favorites?: Maybe<Array<TFavoriteOption>>;
  /** Lista de Favoritos expandida sob o cabeçalho na sidebar V2 */
  favoritesListOpen?: Maybe<Scalars['Boolean']['output']>;
  /** Bloco de Favoritos aberto na sidebar V2 */
  favoritesOpen?: Maybe<Scalars['Boolean']['output']>;
};

export type TUserPreferencesInput = {
  /** Versão do layout escolhida pelo usuário */
  designVersion?: InputMaybe<TDesignVersion>;
  /** Sidebar expandida (true) ou colapsada (false) */
  expandedSidebar?: InputMaybe<Scalars['Boolean']['input']>;
  /** Lista de itens favoritados na sidebar */
  favorites?: InputMaybe<Array<TFavoriteOptionInput>>;
  /** Lista de Favoritos expandida sob o cabeçalho na sidebar V2 */
  favoritesListOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Bloco de Favoritos aberto na sidebar V2 */
  favoritesOpen?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TUserRoleInput = {
  /** Documento do usuário */
  document?: InputMaybe<Scalars['String']['input']>;
  /** ID do papel */
  roleId: Scalars['String']['input'];
  /** ID do papel de permissão */
  rolePermissionId?: InputMaybe<Scalars['String']['input']>;
  /** Estado */
  state?: InputMaybe<TState>;
  /** ID do usuário */
  userId: Scalars['String']['input'];
};

export type TUserRoleMdt = {
  __typename?: 'UserRoleMdt';
  /** Documento do usuário */
  document?: Maybe<Scalars['String']['output']>;
  /** ID do papel de usuário */
  id: Scalars['String']['output'];
  /** Indica se o usuário está bloqueado */
  isBlocked: Scalars['Boolean']['output'];
  /** ID do papel */
  roleId: Scalars['String']['output'];
  /** Permissão do papel */
  rolePermission?: Maybe<TRolePermission>;
  /** ID do papel de permissão */
  rolePermissionId?: Maybe<Scalars['String']['output']>;
  /** Estado */
  state?: Maybe<TState>;
  /** ID do usuário */
  userId: Scalars['String']['output'];
};

export type TUserRoleUpdate = {
  /** Documento do usuário */
  document?: InputMaybe<Scalars['String']['input']>;
  /** ID do papel de usuário */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Indica se o usuário está bloqueado */
  isBlocked: Scalars['Boolean']['input'];
  /** ID do papel */
  roleId: Scalars['String']['input'];
  /** ID do papel de permissão */
  rolePermissionId?: InputMaybe<Scalars['String']['input']>;
  /** Estado */
  state?: InputMaybe<TState>;
};

export type TUserRoutes = {
  __typename?: 'UserRoutes';
  /** Outras rotas disponíveis */
  others: Array<TOthers>;
  /** Rotas do menu lateral */
  sidebar: Array<TRoutes>;
};

export type TUserSpecialty = {
  __typename?: 'UserSpecialty';
  /** UF do conselho onde o RQE foi registrado */
  councilState: TState;
  createdAt: Scalars['DateTime']['output'];
  /** Identificador */
  id: Scalars['String']['output'];
  /** Indica se o RQE está ativo (médico ainda exerce a especialidade) */
  isActive: Scalars['Boolean']['output'];
  /** Indica se o RQE é anunciável em laudo (máximo 2 por médico, Decreto-Lei 4.113/1942) */
  isPrimary: Scalars['Boolean']['output'];
  /** Número do RQE */
  rqeNumber: Scalars['String']['output'];
  /** Especialidade vinculada ao RQE */
  specialty: TMedicalSpecialty;
  updatedAt: Scalars['DateTime']['output'];
  /** Identificador do usuário (médico) */
  userId: Scalars['String']['output'];
};

export type TUserSpecialtyInput = {
  /** UF do conselho onde o RQE foi registrado */
  councilState: TState;
  /** Indica se o RQE está ativo. Default: true */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se o RQE é anunciável em laudo. Default: false. Máximo 2 por médico (Decreto-Lei 4.113/1942). */
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Número do RQE (apenas dígitos) */
  rqeNumber: Scalars['String']['input'];
  /** Especialidade vinculada ao RQE */
  specialty: TMedicalSpecialty;
};

export type TUserSpecialtyUpdate = {
  councilState?: InputMaybe<TState>;
  /** Identificador */
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  rqeNumber?: InputMaybe<Scalars['String']['input']>;
  specialty?: InputMaybe<TMedicalSpecialty>;
};

export type TUserUpdateInput = {
  accessBy?: InputMaybe<TAccessBy>;
  /** Endereço do usuário */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Data de nascimento do usuário */
  birthDate?: InputMaybe<Scalars['String']['input']>;
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  /** Número do documento do usuário */
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  /** Grau de escolaridade */
  educationLevel?: InputMaybe<TEducationLevel>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<TUserGender>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type TUtmData = {
  __typename?: 'UtmData';
  /** Referenciador */
  referrer?: Maybe<Scalars['String']['output']>;
  /** Campanha UTM */
  utmCampaign?: Maybe<Scalars['String']['output']>;
  /** Conteúdo UTM */
  utmContent?: Maybe<Scalars['String']['output']>;
  /** Meio UTM */
  utmMedium?: Maybe<Scalars['String']['output']>;
  /** Fonte UTM */
  utmSource?: Maybe<Scalars['String']['output']>;
  /** Termo UTM */
  utmTerm?: Maybe<Scalars['String']['output']>;
};

export type TUtmDataInput = {
  /** Referenciador */
  referrer?: InputMaybe<Scalars['String']['input']>;
  /** Campanha UTM */
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  /** Conteúdo UTM */
  utmContent?: InputMaybe<Scalars['String']['input']>;
  /** Meio UTM */
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  /** Fonte UTM */
  utmSource?: InputMaybe<Scalars['String']['input']>;
  /** Termo UTM */
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};

export type TVaccine = {
  __typename?: 'Vaccine';
  /** Vantagens da vacina */
  advantages?: Maybe<Scalars['String']['output']>;
  /** Descrição da vacina */
  description: Scalars['String']['output'];
  /** Efeitos colaterais da vacina */
  effects?: Maybe<Scalars['String']['output']>;
  /** Idade mínima para aplicação (em meses) */
  fromAge: Scalars['Float']['output'];
  /** Gênero para aplicação da vacina */
  gender: TVaccineGenderEnum;
  /** ID da vacina */
  id: Scalars['String']['output'];
  /** Indica se a vacina está ativa */
  isActive: Scalars['Boolean']['output'];
  /** Recomendações para aplicação da vacina */
  recommendations?: Maybe<Scalars['String']['output']>;
  /** ID de referência externo */
  referenceId?: Maybe<Scalars['String']['output']>;
  /** Tipo de reforço da vacina */
  reinforcement: TVaccineReinforcementEnum;
  /** Intervalo em dias para o reforço */
  reinforcementInterval?: Maybe<Scalars['Float']['output']>;
  /** Intervalo em dias para a segunda dose */
  secondDoseInterval?: Maybe<Scalars['Float']['output']>;
  /** Intervalo em dias para a terceira dose */
  thirdDoseInterval?: Maybe<Scalars['Float']['output']>;
  /** Idade máxima para aplicação (em meses) */
  toAge: Scalars['Float']['output'];
  /** Centros de custo associados à vacina */
  vaccineCostCenter?: Maybe<Array<TCostCenterOnVaccine>>;
  /** Cargos associados à vacina */
  vaccineOccupation?: Maybe<Array<TOccupationOnVaccine>>;
};

export type TVaccineBiometry = {
  __typename?: 'VaccineBiometry';
  /** Biometria associada */
  biometry: TBiometry;
  /** Identificador da biometria */
  biometryId: Scalars['String']['output'];
  /** Identificador único */
  id: Scalars['String']['output'];
};

export type TVaccineBiometryInput = {
  /** Identificador da biometria */
  biometryId: Scalars['String']['input'];
  /** Imagem BMP */
  bmp?: InputMaybe<Scalars['String']['input']>;
  /** Dados da imagem */
  imageData: Scalars['String']['input'];
  /** DPI da imagem */
  imageDpi?: InputMaybe<Scalars['Float']['input']>;
  /** Altura da imagem */
  imageHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Qualidade da imagem */
  imageQuality?: InputMaybe<Scalars['Float']['input']>;
  /** Largura da imagem */
  imageWidth?: InputMaybe<Scalars['Float']['input']>;
  /** Fabricante do equipamento */
  manufacturer: Scalars['String']['input'];
  /** Modelo do equipamento */
  model?: InputMaybe<Scalars['String']['input']>;
  /** NFIQ (NIST Fingerprint Image Quality) */
  nfiq?: InputMaybe<Scalars['Float']['input']>;
  /** Número de série */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Template da biometria */
  template?: InputMaybe<Scalars['String']['input']>;
  /** Imagem WSQ */
  wsqImage?: InputMaybe<Scalars['String']['input']>;
  /** Tamanho da imagem WSQ */
  wsqImageSize?: InputMaybe<Scalars['Float']['input']>;
};

export type TVaccineChart = {
  __typename?: 'VaccineChart';
  /** Esperado */
  expected: Array<TData>;
  /** Possui vacinas */
  hasVaccines: Scalars['Boolean']['output'];
  /** Realizado */
  realized: Array<TData>;
};

export type TVaccineCostCenterInput = {
  /** ID do centro de custo */
  costCenterId: Scalars['String']['input'];
  /** ID da vacina */
  vaccineId: Scalars['String']['input'];
};

/** Dose da vacina */
export enum TVaccineDoseEnum {
  /** Primeira */
  First = 'First',
  /** Reforço */
  Reinforcement = 'Reinforcement',
  /** Segunda */
  Second = 'Second',
  /** Terceira */
  Third = 'Third'
}

/** Gênero para vacinação */
export enum TVaccineGenderEnum {
  /** Ambos */
  Both = 'Both',
  /** Feminino */
  Female = 'Female',
  /** Masculino */
  Male = 'Male'
}

export type TVaccineInput = {
  /** Vantagens da vacina */
  advantages?: InputMaybe<Scalars['String']['input']>;
  /** Descrição da vacina */
  description: Scalars['String']['input'];
  /** Efeitos colaterais da vacina */
  effects?: InputMaybe<Scalars['String']['input']>;
  /** Idade mínima para aplicação (em meses) */
  fromAge: Scalars['Float']['input'];
  /** Gênero para aplicação da vacina */
  gender: TVaccineGenderEnum;
  /** Recomendações para aplicação da vacina */
  recommendations?: InputMaybe<Scalars['String']['input']>;
  /** ID de referência externo */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de reforço da vacina */
  reinforcement: TVaccineReinforcementEnum;
  /** Intervalo em dias para o reforço */
  reinforcementInterval?: InputMaybe<Scalars['Float']['input']>;
  /** Intervalo em dias para a segunda dose */
  secondDoseInterval?: InputMaybe<Scalars['Float']['input']>;
  /** Intervalo em dias para a terceira dose */
  thirdDoseInterval?: InputMaybe<Scalars['Float']['input']>;
  /** Idade máxima para aplicação (em meses) */
  toAge: Scalars['Float']['input'];
  /** Centros de custo a serem associados à vacina */
  vaccineCostCenter?: InputMaybe<Array<TCostCenterOnVaccineInput>>;
  /** Cargos a serem associados à vacina */
  vaccineOccupation?: InputMaybe<Array<TOccupationOnVaccineInput>>;
};

export type TVaccineOccupationInput = {
  /** ID do cargo */
  occupationId: Scalars['String']['input'];
  /** ID da vacina */
  vaccineId: Scalars['String']['input'];
};

export type TVaccinePlanningParameters = {
  __typename?: 'VaccinePlanningParameters';
  fromDate: Scalars['String']['output'];
  toDate: Scalars['String']['output'];
};

export type TVaccinePrint = {
  __typename?: 'VaccinePrint';
  date: Scalars['String']['output'];
  dose: Scalars['String']['output'];
  signature?: Maybe<Scalars['String']['output']>;
  vaccine: Scalars['String']['output'];
};

export type TVaccineQuantityChart = {
  __typename?: 'VaccineQuantityChart';
  /** Dados */
  data: Array<TPieChart>;
  /** Possui vacinas */
  hasVaccines: Scalars['Boolean']['output'];
};

/** Reforço da vacina */
export enum TVaccineReinforcementEnum {
  /** Sem reforço */
  NoReinforcement = 'NoReinforcement',
  /** Periódico */
  Periodic = 'Periodic',
  /** Único */
  Unique = 'Unique'
}

export type TVaccineUpdate = {
  /** Vantagens da vacina */
  advantages?: InputMaybe<Scalars['String']['input']>;
  /** Descrição da vacina */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Efeitos colaterais da vacina */
  effects?: InputMaybe<Scalars['String']['input']>;
  /** Idade mínima para aplicação (em meses) */
  fromAge?: InputMaybe<Scalars['Float']['input']>;
  /** Gênero para aplicação da vacina */
  gender?: InputMaybe<TVaccineGenderEnum>;
  /** ID da vacina */
  id: Scalars['String']['input'];
  /** Indica se a vacina está ativa */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Recomendações para aplicação da vacina */
  recommendations?: InputMaybe<Scalars['String']['input']>;
  /** ID de referência externo */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de reforço da vacina */
  reinforcement?: InputMaybe<TVaccineReinforcementEnum>;
  /** Intervalo em dias para o reforço */
  reinforcementInterval?: InputMaybe<Scalars['Float']['input']>;
  /** Intervalo em dias para a segunda dose */
  secondDoseInterval?: InputMaybe<Scalars['Float']['input']>;
  /** Intervalo em dias para a terceira dose */
  thirdDoseInterval?: InputMaybe<Scalars['Float']['input']>;
  /** Idade máxima para aplicação (em meses) */
  toAge?: InputMaybe<Scalars['Float']['input']>;
  /** Centros de custo a serem associados à vacina */
  vaccineCostCenter?: InputMaybe<Array<TCostCenterOnVaccineInput>>;
  /** Cargos a serem associados à vacina */
  vaccineOccupation?: InputMaybe<Array<TOccupationOnVaccineInput>>;
};

export type TValidationError = {
  __typename?: 'ValidationError';
  /** Campo com erro de validação */
  field: Scalars['String']['output'];
  /** Mensagem de erro */
  message: Scalars['String']['output'];
};

export type TValidationReturn = {
  __typename?: 'ValidationReturn';
  available: Scalars['Boolean']['output'];
  version: TFeatureVersion;
};

export type TValidations = {
  /** Indica se validação de IPE foi realizada */
  ipe: Scalars['Boolean']['input'];
  /** Indica se validação de produto foi realizada */
  product: Scalars['Boolean']['input'];
  /** Indica se validação de peças sobressalentes foi realizada */
  spareParts: Scalars['Boolean']['input'];
};

/** Verbo HTTP da mensagem */
export enum TVerbMessage {
  /** DELETE */
  Delete = 'Delete',
  /** GET */
  Get = 'Get',
  /** POST */
  Post = 'Post',
  /** PUT */
  Put = 'Put'
}

/** Especificação da deficiência visual */
export enum TVisualDeficiencySpecification {
  /** Cegueira */
  Blindness = 'Blindness',
  /** Baixa visão */
  LowVision = 'LowVision',
  /** Baixo campo visual */
  LowVisualField = 'LowVisualField'
}

/** Campo visual */
export enum TVisualFieldEnum {
  /** Nasal */
  Nasal = 'Nasal',
  /** Temporal */
  Temporal = 'Temporal'
}

export type TVolumeChart = {
  __typename?: 'VolumeChart';
  /** Entre 20 e 30 */
  between20and30: Array<Scalars['Float']['output']>;
  /** Entre 30 e 40 */
  between30and40: Array<Scalars['Float']['output']>;
  /** Entre 40 e 50 */
  between40and50: Array<Scalars['Float']['output']>;
  /** Possui atestado */
  hasCertificate: Scalars['Boolean']['output'];
  /** Acima de 50 */
  over50: Array<Scalars['Float']['output']>;
  /** Até 20 */
  upTo20: Array<Scalars['Float']['output']>;
};

export type TVotationProgress = {
  __typename?: 'VotationProgress';
  /** Candidato votado */
  candidate?: Maybe<TCandidate>;
  /** Quantidade de votos */
  count: Scalars['Float']['output'];
  /** Indica se é voto nulo */
  nullVote?: Maybe<Scalars['Boolean']['output']>;
  /** Percentual de votos */
  percentage: Scalars['Float']['output'];
  /** Indica se é voto em branco */
  whiteVote?: Maybe<Scalars['Boolean']['output']>;
};

export type TVote = {
  __typename?: 'Vote';
  /** ID do candidato votado */
  candidateId?: Maybe<Scalars['String']['output']>;
  /** Identificador cifrado do usuário votante */
  cypherUser: Scalars['String']['output'];
  /** ID do voto */
  id: Scalars['String']['output'];
  /** ID do mandato da CIPA */
  mandateId: Scalars['String']['output'];
  /** Indica se é um voto nulo */
  nullVote?: Maybe<Scalars['Boolean']['output']>;
  /** Indica se é um voto em branco */
  whiteVote?: Maybe<Scalars['Boolean']['output']>;
};

export type TVoteInput = {
  /** ID do candidato votado */
  candidateId?: InputMaybe<Scalars['String']['input']>;
  /** ID do mandato da CIPA */
  mandateId: Scalars['String']['input'];
  /** Indica se é um voto nulo */
  nullVote?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indica se é um voto em branco */
  whiteVote?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TVoteStatus = {
  __typename?: 'VoteStatus';
  /** Percentual de não votantes */
  percentageNotVoted: Scalars['Float']['output'];
  /** Percentual de votantes */
  percentageVoted: Scalars['Float']['output'];
  /** Total de eleitores */
  total: Scalars['Float']['output'];
  /** Total de não votantes */
  totalNotVoted: Scalars['Float']['output'];
  /** Total de votantes */
  totalVoted: Scalars['Float']['output'];
};

export type TWarehouse = {
  __typename?: 'Warehouse';
  /** Descrição do armazém */
  description: Scalars['String']['output'];
  /** ID no sistema ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** ID do armazém */
  id: Scalars['String']['output'];
  /** Indica se o armazém está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Níveis de estoque associados ao armazém */
  stockLevels?: Maybe<Array<TStockLevel>>;
  /** Sugestão para o armazém */
  suggestion?: Maybe<Scalars['String']['output']>;
};

export type TWarehouseInput = {
  /** Descrição do armazém */
  description: Scalars['String']['input'];
  /** ID no sistema ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Indica se o armazém está ativo */
  isActive: Scalars['Boolean']['input'];
};

export type TWarehouseIntegration = {
  /** Filial */
  branch: Scalars['String']['input'];
  /** Descrição do armazém */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID no sistema ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** ID do armazém */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Indica se o armazém está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TWarehouseUpdate = {
  /** Descrição do armazém */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID no sistema ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** ID do armazém */
  id: Scalars['String']['input'];
  /** Indica se o armazém está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TWarningByPerson = {
  __typename?: 'WarningByPerson';
  /** Anexos */
  attachments?: Maybe<Array<TAttachment>>;
  /** Data da advertência */
  date: Scalars['DateTime']['output'];
  /** Detalhes */
  details?: Maybe<Scalars['String']['output']>;
  /** Identificador único */
  id: Scalars['String']['output'];
  /** Motivo da advertência */
  reason: TWarningReason;
  /** Tipo de advertência */
  type: TWarningType;
  /** Indica se foi assinada */
  wasSignature: Scalars['Boolean']['output'];
};

/** Motivo da advertência */
export enum TWarningReason {
  /** Ausência em treinamento */
  AbsenceInTraining = 'AbsenceInTraining',
  /** Má postura */
  BadPosture = 'BadPosture',
  /** Ausência em reunião da CIPA */
  CipaReunionAbsence = 'CipaReunionAbsence',
  /** Desobediência aos superiores */
  DisobedienceSuperiors = 'DisobedienceSuperiors',
  /** Desrespeito às regras */
  DisrespectTheRules = 'DisrespectTheRules',
  /** Atrasos frequentes */
  FrequentDelays = 'FrequentDelays',
  /** Procedimentos de higiene */
  HygieneProcedures = 'HygieneProcedures',
  /** Violações morais ou legais */
  MoralOrLegalViolations = 'MoralOrLegalViolations',
  /** Não uso de EPI */
  NonUseIpe = 'NonUseIpe',
  /** Outros */
  Others = 'Others',
  /** Faltas injustificadas */
  UnjustifiedAbsences = 'UnjustifiedAbsences'
}

/** Tipo de advertência */
export enum TWarningType {
  /** Demissão */
  Dismissal = 'Dismissal',
  /** Suspensão */
  Suspension = 'Suspension',
  /** Verbal */
  Verbal = 'Verbal',
  /** Escrita */
  Writing = 'Writing'
}

export type TWebHookCreateInput = {
  /** Chave de API */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  /** Evento que dispara o webhook */
  event: TWebhookEvent;
  /** Tipo de webhook */
  type: TWebhookType;
  /** URL do webhook */
  url: Scalars['String']['input'];
};

export type TWebHookUpdateInput = {
  /** Chave de API */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  /** Evento que dispara o webhook */
  event?: InputMaybe<TWebhookEvent>;
  /** ID do webhook */
  id: Scalars['String']['input'];
  /** Tipo de webhook */
  type?: InputMaybe<TWebhookType>;
  /** URL do webhook */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type TWebhook = {
  __typename?: 'Webhook';
  /** Chave de API */
  apiKey?: Maybe<Scalars['String']['output']>;
  /** Evento que dispara o webhook */
  event: TWebhookEvent;
  /** ID do webhook */
  id: Scalars['String']['output'];
  /** ID da organização */
  organization: Scalars['String']['output'];
  /** Tipo de webhook */
  type: TWebhookType;
  /** URL do webhook */
  url: Scalars['String']['output'];
};

/** Evento de webhook */
export enum TWebhookEvent {
  /** Emissão de ASO */
  AsoEmission = 'AsoEmission'
}

export type TWebhookQueue = {
  __typename?: 'WebhookQueue';
  /** ID da filial */
  branch: Scalars['String']['output'];
  /** Dados da filial */
  branchRef: TBranch;
  /** Mensagem de erro */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** ID da fila de webhook */
  id: Scalars['String']['output'];
  /** Mensagem a ser enviada */
  message: Scalars['String']['output'];
  /** ID da organização */
  organization: Scalars['String']['output'];
  /** Dados da pessoa */
  person: TPerson;
  /** ID da pessoa */
  personId: Scalars['String']['output'];
  /** Status do envio */
  status: TWebhookStatus;
  /** Tipo de webhook */
  type: TWebhookType;
};

export type TWebhookQueueBatchInput = {
  /** Data inicial */
  fromDate: Scalars['DateTime']['input'];
  /** Data final */
  untilDate: Scalars['DateTime']['input'];
};

export type TWebhookQueueCreateInput = {
  /** Mensagem de erro */
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** Mensagem a ser enviada */
  message: Scalars['String']['input'];
  /** ID da pessoa */
  personId: Scalars['String']['input'];
  /** Status do envio */
  status: TWebhookStatus;
  /** Tipo de webhook */
  type: TWebhookType;
};

export type TWebhookQueueUpdateInput = {
  /** Mensagem de erro */
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** ID da fila de webhook */
  id: Scalars['String']['input'];
  /** Mensagem a ser enviada */
  message?: InputMaybe<Scalars['String']['input']>;
  /** ID da pessoa */
  personId?: InputMaybe<Scalars['String']['input']>;
  /** Status do envio */
  status?: InputMaybe<TWebhookStatus>;
  /** Tipo de webhook */
  type?: InputMaybe<TWebhookType>;
};

/** Status do webhook */
export enum TWebhookStatus {
  /** Entregue */
  Delivery = 'Delivery',
  /** Erro */
  Error = 'Error',
  /** Pendente */
  Pending = 'Pending'
}

/** Tipo de webhook */
export enum TWebhookType {
  /** Integração com Gupy */
  Gupy = 'Gupy'
}

export type TWitnessOnAccident = {
  __typename?: 'WitnessOnAccident';
  /** Pessoa testemunha */
  person: TPerson;
  /** Depoimento da testemunha */
  testimony?: Maybe<Scalars['String']['output']>;
};

export type TWitnessOnAccidentInput = {
  /** Identificador da pessoa */
  personId: Scalars['String']['input'];
  /** Depoimento da testemunha */
  testimony?: InputMaybe<Scalars['String']['input']>;
};

export type TWitnessOnAccidentUpdate = {
  /** Testemunhas a criar */
  toCreate: Array<TWitnessOnAccidentInput>;
  /** Testemunhas a remover */
  toRemove: Array<Scalars['String']['input']>;
};

export type TWorkHour = {
  __typename?: 'WorkHour';
  /** Horário de término */
  end: TTimePoint;
  /** Horário de início */
  start: TTimePoint;
};

export type TWorkHours = {
  __typename?: 'WorkHours';
  /** ID do médico */
  doctorId: Scalars['String']['output'];
  /** Horários de trabalho na sexta */
  friday: Array<TWorkHour>;
  /** Horários de trabalho na segunda */
  monday: Array<TWorkHour>;
  /** Horários de trabalho no sábado */
  saturday: Array<TWorkHour>;
  /** Horários de trabalho no domingo */
  sunday: Array<TWorkHour>;
  /** Horários de trabalho na quinta */
  thursday: Array<TWorkHour>;
  /** Horários de trabalho na terça */
  tuesday: Array<TWorkHour>;
  /** Horários de trabalho na quarta */
  wednesday: Array<TWorkHour>;
};

export type TWorkPermission = {
  __typename?: 'WorkPermission';
  /** Data de criação */
  createdAt: Scalars['DateTime']['output'];
  /** Descrição da permissão de trabalho */
  description: Scalars['String']['output'];
  /** Data de término da permissão */
  endDate: Scalars['DateTime']['output'];
  /** Ambiente físico da permissão */
  environment: TPhysicalEnvironment;
  /** Grupo de exposição */
  exposureGroup?: Maybe<TExposureGroup>;
  /** ID do grupo de exposição */
  exposureGroupId?: Maybe<Scalars['String']['output']>;
  /** ID da permissão de trabalho */
  id: Scalars['String']['output'];
  /** Observações sobre a permissão */
  observation?: Maybe<Scalars['String']['output']>;
  /** Pessoas associadas à permissão */
  people?: Maybe<Array<TWorkPermissionPerson>>;
  /** Pessoa solicitante */
  requester: TPerson;
  /** Pessoa responsável */
  responsible: TPerson;
  /** Data de início da permissão */
  startDate: Scalars['DateTime']['output'];
  /** Supervisor da permissão */
  supervisor: TPerson;
  /** Etiqueta de identificação */
  tag?: Maybe<Scalars['String']['output']>;
  /** Data de atualização */
  updatedAt: Scalars['DateTime']['output'];
  /** Indica se usa grupo de exposição */
  useExposureGroup: Scalars['Boolean']['output'];
  /** Vigia da permissão */
  watchman: TPerson;
  /** Questionários da permissão */
  workPermissionQuizzes?: Maybe<Array<TWorkPermissionQuiz>>;
  /** Tipo de permissão de trabalho */
  workPermissionType: TWorkPermissionType;
};

export type TWorkPermissionDashboard = {
  __typename?: 'WorkPermissionDashboard';
  permissionsByEnvironment: TWorkPermissionParetoChart;
  permissionsByRequester: TWorkPermissionParetoChart;
  permissionsByTag: TWorkPermissionParetoChart;
};

export type TWorkPermissionInput = {
  /** Descrição da permissão de trabalho */
  description: Scalars['String']['input'];
  /** Data de término da permissão */
  endDate: Scalars['DateTime']['input'];
  /** ID do ambiente físico */
  environmentId: Scalars['String']['input'];
  /** ID do grupo de exposição */
  exposureGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Observações sobre a permissão */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Pessoas a serem associadas à permissão */
  people?: InputMaybe<Array<TWorkPermissionPersonInput>>;
  /** Questionário da permissão */
  quiz?: InputMaybe<TWorkPermissionQuizInput>;
  /** ID da pessoa solicitante */
  requesterId: Scalars['String']['input'];
  /** ID da pessoa responsável */
  responsibleId: Scalars['String']['input'];
  /** Data de início da permissão */
  startDate: Scalars['DateTime']['input'];
  /** ID do supervisor */
  supervisorId: Scalars['String']['input'];
  /** Etiqueta de identificação */
  tag?: InputMaybe<Scalars['String']['input']>;
  /** Indica se usa grupo de exposição */
  useExposureGroup: Scalars['Boolean']['input'];
  /** ID do vigia */
  watchmanId: Scalars['String']['input'];
  /** Tipo de permissão de trabalho */
  workPermissionType: TWorkPermissionType;
};

export type TWorkPermissionParetoChart = {
  __typename?: 'WorkPermissionParetoChart';
  entries: Array<TWorkPermissionParetoEntry>;
  hasData: Scalars['Boolean']['output'];
  total: Scalars['Int']['output'];
};

export type TWorkPermissionParetoEntry = {
  __typename?: 'WorkPermissionParetoEntry';
  cumulativePercent: Scalars['Float']['output'];
  label: Scalars['String']['output'];
  result: Scalars['Int']['output'];
};

export type TWorkPermissionPerson = {
  __typename?: 'WorkPermissionPerson';
  /** ID da associação pessoa-permissão */
  id: Scalars['String']['output'];
  /** Pessoa associada à permissão */
  person: TPerson;
};

export type TWorkPermissionPersonInput = {
  /** ID da pessoa a ser associada */
  personId: Scalars['String']['input'];
};

export type TWorkPermissionQuiz = {
  __typename?: 'WorkPermissionQuiz';
  /** ID do questionário de permissão */
  id: Scalars['String']['output'];
  /** Questionário aplicado */
  quiz: TQuiz;
  /** Data de realização do questionário */
  realizationDate: Scalars['DateTime']['output'];
  /** Respostas do questionário */
  responses: Array<TResponseWorkPermissionQuiz>;
};

export type TWorkPermissionQuizInput = {
  /** ID do questionário (para atualização) */
  id?: InputMaybe<Scalars['String']['input']>;
  /** ID do questionário */
  quizId: Scalars['String']['input'];
  /** Data de realização do questionário */
  realizationDate: Scalars['DateTime']['input'];
  /** Respostas do questionário */
  responses?: InputMaybe<Array<TResponseWorkPermissionQuizInput>>;
  /** ID da permissão de trabalho */
  workPermissionId?: InputMaybe<Scalars['String']['input']>;
};

export type TWorkPermissionQuizUpdate = {
  /** ID do questionário */
  id: Scalars['String']['input'];
  /** ID do questionário */
  quizId?: InputMaybe<Scalars['String']['input']>;
  /** Respostas atualizadas do questionário */
  responses: Array<TResponseWorkPermissionQuizUpdate>;
  /** ID da permissão de trabalho */
  workPermissionId?: InputMaybe<Scalars['String']['input']>;
};

/** Tipo de permissão de trabalho */
export enum TWorkPermissionType {
  /** Externo */
  External = 'External',
  /** Interno */
  Internal = 'Internal'
}

export type TWorkPermissionUpdate = {
  /** Descrição da permissão de trabalho */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Data de término da permissão */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID do ambiente físico */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** ID do grupo de exposição */
  exposureGroupId?: InputMaybe<Scalars['String']['input']>;
  /** ID da permissão de trabalho */
  id: Scalars['String']['input'];
  /** Observações sobre a permissão */
  observation?: InputMaybe<Scalars['String']['input']>;
  /** Pessoas a serem associadas à permissão */
  people?: InputMaybe<Array<TWorkPermissionPersonInput>>;
  /** Questionário da permissão */
  quiz?: InputMaybe<TWorkPermissionQuizInput>;
  /** ID da pessoa solicitante */
  requesterId?: InputMaybe<Scalars['String']['input']>;
  /** ID da pessoa responsável */
  responsibleId?: InputMaybe<Scalars['String']['input']>;
  /** Data de início da permissão */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID do supervisor */
  supervisorId?: InputMaybe<Scalars['String']['input']>;
  /** Etiqueta de identificação */
  tag?: InputMaybe<Scalars['String']['input']>;
  /** Indica se usa grupo de exposição */
  useExposureGroup: Scalars['Boolean']['input'];
  /** ID do vigia */
  watchmanId?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de permissão de trabalho */
  workPermissionType?: InputMaybe<TWorkPermissionType>;
};

export type TWorkShift = {
  __typename?: 'WorkShift';
  /** Descrição do turno de trabalho */
  description: Scalars['String']['output'];
  /** ID no sistema ERP */
  erpId?: Maybe<Scalars['String']['output']>;
  /** Frequência das horas produtivas */
  frequency?: Maybe<TProductiveHoursFrequency>;
  /** ID do turno de trabalho */
  id: Scalars['String']['output'];
  /** Indica se o turno está ativo */
  isActive: Scalars['Boolean']['output'];
  /** Horas produtivas do turno */
  productiveHours?: Maybe<Scalars['Float']['output']>;
  /** ID de referência externo */
  referenceId?: Maybe<Scalars['String']['output']>;
  /** Esquema de revezamento */
  relayScheme?: Maybe<Scalars['String']['output']>;
};

export type TWorkShiftInput = {
  /** Descrição do turno de trabalho */
  description: Scalars['String']['input'];
  /** ID no sistema ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Frequência das horas produtivas */
  frequency?: InputMaybe<TProductiveHoursFrequency>;
  /** Horas produtivas do turno */
  productiveHours?: InputMaybe<Scalars['Float']['input']>;
  /** ID de referência externo */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Esquema de revezamento */
  relayScheme?: InputMaybe<Scalars['String']['input']>;
};

export type TWorkShiftIntegration = {
  /** Filial */
  branch: Scalars['String']['input'];
  /** Descrição do turno de trabalho */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID no sistema ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** ID do turno de trabalho */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Horas produtivas do turno */
  productiveHours?: InputMaybe<Scalars['Float']['input']>;
  /** Esquema de revezamento */
  relayScheme?: InputMaybe<Scalars['String']['input']>;
};

export type TWorkShiftUpdate = {
  /** Descrição do turno de trabalho */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID no sistema ERP */
  erpId?: InputMaybe<Scalars['String']['input']>;
  /** Frequência das horas produtivas */
  frequency?: InputMaybe<TProductiveHoursFrequency>;
  /** ID do turno de trabalho */
  id: Scalars['String']['input'];
  /** Indica se o turno está ativo */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Horas produtivas do turno */
  productiveHours?: InputMaybe<Scalars['Float']['input']>;
  /** ID de referência externo */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Esquema de revezamento */
  relayScheme?: InputMaybe<Scalars['String']['input']>;
};

export type TYearlyVariationChart = {
  __typename?: 'YearlyVariationChart';
  /** Dias perdidos nos últimos 12 meses */
  currentDays: Scalars['Float']['output'];
  /** Indica se há dados no período anterior */
  hasPrevious: Scalars['Boolean']['output'];
  /** Dias perdidos nos 12 meses imediatamente anteriores */
  previousDays: Scalars['Float']['output'];
  /** Variação percentual; nulo quando não há base de comparação */
  variationPct?: Maybe<Scalars['Float']['output']>;
};

export type T_Invite = {
  __typename?: '_Invite';
  branch?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type T_InviteInput = {
  accessBy: TAccessBy;
  birthday: Scalars['DateTime']['input'];
  email: Scalars['String']['input'];
  gender: TGender;
  individualRegistration: Scalars['String']['input'];
  name: Scalars['String']['input'];
  roleId: Scalars['String']['input'];
};

export type T_PasswordRecovery = {
  __typename?: '_PasswordRecovery';
  createdAt?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type T_Terms = {
  __typename?: '_Terms';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
};

export type T_UserCreationInput = {
  accessBy?: InputMaybe<TAccessBy>;
  /** Endereço do usuário */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Data de nascimento do usuário */
  birthDate?: InputMaybe<Scalars['String']['input']>;
  /** Número do documento do usuário */
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  /** Grau de escolaridade */
  educationLevel?: InputMaybe<TEducationLevel>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Gênero do usuário */
  gender?: InputMaybe<TUserGender>;
  inviteToken?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<TOrganizationInput>;
  password: Scalars['String']['input'];
  utm?: InputMaybe<TUtmInput>;
};

export type TESocialParams = {
  branchId: Scalars['String']['input'];
  originId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type TIsAccreditedResult = {
  __typename?: 'isAccreditedResult';
  isAccredited: Scalars['Boolean']['output'];
};

export type WithIndex<TObject> = TObject & Record<string, any>;
export type ResolversObject<TObject> = WithIndex<TObject>;

export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = Record<PropertyKey, never>, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;





/** Mapping between all available schema types and the resolvers types */
export type TResolversTypes = ResolversObject<{
  AbnormalityAnalysis: ResolverTypeWrapper<TAbnormalityAnalysis>;
  AbsenceType: ResolverTypeWrapper<TAbsenceType>;
  AbsenceTypeInput: TAbsenceTypeInput;
  AbsenceTypeIntegration: TAbsenceTypeIntegration;
  AbsenceTypeUpdate: TAbsenceTypeUpdate;
  AccessBy: TAccessBy;
  AccessToken: ResolverTypeWrapper<TAccessToken>;
  AccessTokenInput: TAccessTokenInput;
  Accident: ResolverTypeWrapper<TAccident>;
  AccidentAbsence: ResolverTypeWrapper<TAccidentAbsence>;
  AccidentAmount: ResolverTypeWrapper<TAccidentAmount>;
  AccidentAnalysis: ResolverTypeWrapper<TAccidentAnalysis>;
  AccidentBodyPart: ResolverTypeWrapper<TAccidentBodyPart>;
  AccidentBodyPartInput: TAccidentBodyPartInput;
  AccidentBodyPartInputBranch: TAccidentBodyPartInputBranch;
  AccidentCause: ResolverTypeWrapper<TAccidentCause>;
  AccidentCauseInput: TAccidentCauseInput;
  AccidentCauseUpdate: TAccidentCauseUpdate;
  AccidentCauses: ResolverTypeWrapper<TAccidentCauses>;
  AccidentCharts: ResolverTypeWrapper<TAccidentCharts>;
  AccidentCircumstance: TAccidentCircumstance;
  AccidentCode: ResolverTypeWrapper<TAccidentCode>;
  AccidentConduction: TAccidentConduction;
  AccidentDashboard: ResolverTypeWrapper<TAccidentDashboard>;
  AccidentDescription: ResolverTypeWrapper<TAccidentDescription>;
  AccidentExpenseAmount: ResolverTypeWrapper<TAccidentExpenseAmount>;
  AccidentExpenseInput: TAccidentExpenseInput;
  AccidentExpenseType: TAccidentExpenseType;
  AccidentExpenseUpdate: TAccidentExpenseUpdate;
  AccidentExposureType: TAccidentExposureType;
  AccidentFilter: TAccidentFilter;
  AccidentInput: TAccidentInput;
  AccidentLocation: TAccidentLocation;
  AccidentObject: ResolverTypeWrapper<TAccidentObject>;
  AccidentOrderByFields: TAccidentOrderByFields;
  AccidentOrderByInput: TAccidentOrderByInput;
  AccidentPotentialEnum: TAccidentPotentialEnum;
  AccidentQueryInput: TAccidentQueryInput;
  AccidentType: ResolverTypeWrapper<TAccidentType>;
  AccidentTypeEnum: TAccidentTypeEnum;
  AccidentUpdate: TAccidentUpdate;
  AccidentVictim: ResolverTypeWrapper<TAccidentVictim>;
  AccidentWithInvestigation: ResolverTypeWrapper<TAccidentWithInvestigation>;
  AccidentWitness: ResolverTypeWrapper<TAccidentWitness>;
  AccidentWitnessInput: TAccidentWitnessInput;
  AccidentsPerDayChart: ResolverTypeWrapper<TAccidentsPerDayChart>;
  AccidentsPerMonthChart: ResolverTypeWrapper<TAccidentsPerMonthChart>;
  AccidentsTimeChart: ResolverTypeWrapper<TAccidentsTimeChart>;
  Accredited: ResolverTypeWrapper<TAccredited>;
  AccreditedBilling: ResolverTypeWrapper<TAccreditedBilling>;
  AccreditedConsultation: ResolverTypeWrapper<TAccreditedConsultation>;
  AccreditedCreator: TAccreditedCreator;
  AccreditedExam: ResolverTypeWrapper<TAccreditedExam>;
  AccreditedExamInput: TAccreditedExamInput;
  AccreditedInput: TAccreditedInput;
  AccreditedReportsParameters: ResolverTypeWrapper<TAccreditedReportsParameters>;
  AccreditedUpdate: TAccreditedUpdate;
  AcknowledgmentFormReport: ResolverTypeWrapper<TAcknowledgmentFormReport>;
  ActionOnMeeting: ResolverTypeWrapper<TActionOnMeeting>;
  ActionOnMeetingInput: TActionOnMeetingInput;
  ActionOnMeetingRemove: TActionOnMeetingRemove;
  ActionOnMeetingUpdate: TActionOnMeetingUpdate;
  ActionPlan: ResolverTypeWrapper<TActionPlan>;
  ActionPlanConclusionChart: ResolverTypeWrapper<TActionPlanConclusionChart>;
  ActionPlanConclusionEntry: ResolverTypeWrapper<TActionPlanConclusionEntry>;
  ActionPlanCount: ResolverTypeWrapper<TActionPlanCount>;
  ActionPlanDashboard: ResolverTypeWrapper<TActionPlanDashboard>;
  ActionPlanExpectedGoalInput: TActionPlanExpectedGoalInput;
  ActionPlanExpectedGoalUpdate: TActionPlanExpectedGoalUpdate;
  ActionPlanFilter: TActionPlanFilter;
  ActionPlanInput: TActionPlanInput;
  ActionPlanInvestigation: ResolverTypeWrapper<TActionPlanInvestigation>;
  ActionPlanInvestigationInput: TActionPlanInvestigationInput;
  ActionPlanInvestigationSuggestion: ResolverTypeWrapper<TActionPlanInvestigationSuggestion>;
  ActionPlanInvestigationUpdate: TActionPlanInvestigationUpdate;
  ActionPlanMeasurementEntry: ResolverTypeWrapper<TActionPlanMeasurementEntry>;
  ActionPlanMeasurementsChart: ResolverTypeWrapper<TActionPlanMeasurementsChart>;
  ActionPlanMicroAction: ResolverTypeWrapper<TActionPlanMicroAction>;
  ActionPlanMicroActionInput: TActionPlanMicroActionInput;
  ActionPlanMicroActionUpdate: TActionPlanMicroActionUpdate;
  ActionPlanOrderByFields: TActionPlanOrderByFields;
  ActionPlanOrderByInput: TActionPlanOrderByInput;
  ActionPlanParetoChart: ResolverTypeWrapper<TActionPlanParetoChart>;
  ActionPlanParetoEntry: ResolverTypeWrapper<TActionPlanParetoEntry>;
  ActionPlanPriorityChart: ResolverTypeWrapper<TActionPlanPriorityChart>;
  ActionPlanPriorityEntry: ResolverTypeWrapper<TActionPlanPriorityEntry>;
  ActionPlanQueryInput: TActionPlanQueryInput;
  ActionPlanRealGoalInput: TActionPlanRealGoalInput;
  ActionPlanRealGoalUpdate: TActionPlanRealGoalUpdate;
  ActionPlanReport: ResolverTypeWrapper<TActionPlanReport>;
  ActionPlanReportInput: TActionPlanReportInput;
  ActionPlanReportSuggestion: ResolverTypeWrapper<TActionPlanReportSuggestion>;
  ActionPlanReportUpdate: TActionPlanReportUpdate;
  ActionPlanResponsibleInput: TActionPlanResponsibleInput;
  ActionPlanResponsibleUpdate: TActionPlanResponsibleUpdate;
  ActionPlanSchedule: ResolverTypeWrapper<TActionPlanSchedule>;
  ActionPlanStatusChart: ResolverTypeWrapper<TActionPlanStatusChart>;
  ActionPlanStatusEntry: ResolverTypeWrapper<TActionPlanStatusEntry>;
  ActionPlanUpdate: TActionPlanUpdate;
  ActivityGroup: ResolverTypeWrapper<TActivityGroup>;
  ActivityIcd: ResolverTypeWrapper<TActivityIcd>;
  ActivityType: TActivityType;
  AdditionalData: ResolverTypeWrapper<TAdditionalData>;
  AdditionalDataInput: TAdditionalDataInput;
  AgeAccidentChart: ResolverTypeWrapper<TAgeAccidentChart>;
  AgeChart: ResolverTypeWrapper<TAgeChart>;
  AgeRange: ResolverTypeWrapper<TAgeRange>;
  AgeRangeEntry: ResolverTypeWrapper<TAgeRangeEntry>;
  AgeRangeInput: TAgeRangeInput;
  AgentBonus: TAgentBonus;
  AgentBonusChart: ResolverTypeWrapper<TAgentBonusChart>;
  AgentClassification: TAgentClassification;
  AgentEvaluation: TAgentEvaluation;
  AgentGroup: TAgentGroup;
  AgentGroupChart: ResolverTypeWrapper<TAgentGroupChart>;
  Agreement: ResolverTypeWrapper<TAgreement>;
  AllowanceType: ResolverTypeWrapper<TAllowanceType>;
  AllowanceTypeInput: TAllowanceTypeInput;
  AllowanceTypeIntegration: TAllowanceTypeIntegration;
  AllowanceTypeUpdate: TAllowanceTypeUpdate;
  Analysis: ResolverTypeWrapper<TAnalysis>;
  AnalysisInput: TAnalysisInput;
  AnalysisUpdate: TAnalysisUpdate;
  AnnualDeliveryVariationChart: ResolverTypeWrapper<TAnnualDeliveryVariationChart>;
  ApiAccess: ResolverTypeWrapper<TApiAccess>;
  AsaasCreditCardToken: ResolverTypeWrapper<TAsaasCreditCardToken>;
  AsaasCreditCardTokenInput: TAsaasCreditCardTokenInput;
  AsoEvolutionEntry: ResolverTypeWrapper<TAsoEvolutionEntry>;
  AsoNatureChart: ResolverTypeWrapper<TAsoNatureChart>;
  AsoQuantityChart: ResolverTypeWrapper<TAsoQuantityChart>;
  AsoSituationChart: ResolverTypeWrapper<TAsoSituationChart>;
  Attachment: ResolverTypeWrapper<TAttachment>;
  AttachmentAndThumbnailUpload: TAttachmentAndThumbnailUpload;
  AttachmentDTO: ResolverTypeWrapper<TAttachmentDto>;
  AudiometryClassificationChart: ResolverTypeWrapper<TAudiometryClassificationChart>;
  AudiometryClinicalEnum: TAudiometryClinicalEnum;
  AudiometryCostCenterChart: ResolverTypeWrapper<TAudiometryCostCenterChart>;
  AudiometryDashboard: ResolverTypeWrapper<TAudiometryDashboard>;
  AudiometryEvolutionChart: ResolverTypeWrapper<TAudiometryEvolutionChart>;
  AudiometryInssEnum: TAudiometryInssEnum;
  AudiometryLossTypeEnum: TAudiometryLossTypeEnum;
  AudiometryOrdinanceEnum: TAudiometryOrdinanceEnum;
  AudiometryPcaChart: ResolverTypeWrapper<TAudiometryPcaChart>;
  AudiometryYearComparisonChart: ResolverTypeWrapper<TAudiometryYearComparisonChart>;
  AuditAction: TAuditAction;
  AuditExportFormat: TAuditExportFormat;
  AuditExportStatus: TAuditExportStatus;
  AuditLogChange: ResolverTypeWrapper<TAuditLogChange>;
  AuditLogDetailsDto: ResolverTypeWrapper<TAuditLogDetailsDto>;
  AuditLogEntry: ResolverTypeWrapper<TAuditLogEntry>;
  AuditLogExportRequest: ResolverTypeWrapper<TAuditLogExportRequest>;
  AuditLogQueryInput: TAuditLogQueryInput;
  AuthType: TAuthType;
  AuthTypeTotvsSign: TAuthTypeTotvsSign;
  AvailabilityChart: ResolverTypeWrapper<TAvailabilityChart>;
  BaseAttachmentArgs: TBaseAttachmentArgs;
  BaseAttachmentToUploadArgs: TBaseAttachmentToUploadArgs;
  BaseDocumentResponse: ResolverTypeWrapper<TBaseDocumentResponse>;
  BaseFeatureReturn: ResolverTypeWrapper<TBaseFeatureReturn>;
  BaseFlagReturn: ResolverTypeWrapper<TBaseFlagReturn>;
  BaseInput: TBaseInput;
  BilirubinEnum: TBilirubinEnum;
  BillingMethod: TBillingMethod;
  BiologicMonitoring: ResolverTypeWrapper<TBiologicMonitoring>;
  BiologicalExams: ResolverTypeWrapper<TBiologicalExams>;
  BiologicalMaterial: TBiologicalMaterial;
  BiologicalMonitoring: ResolverTypeWrapper<TBiologicalMonitoring>;
  BiologicalMonitoringAgent: TBiologicalMonitoringAgent;
  BiologicalMonitoringCommon: ResolverTypeWrapper<TBiologicalMonitoringCommon>;
  BiologicalMonitoringExam: ResolverTypeWrapper<TBiologicalMonitoringExam>;
  BiologicalMonitoringExamGroup: ResolverTypeWrapper<TBiologicalMonitoringExamGroup>;
  BiologicalMonitoringExamGroupInput: TBiologicalMonitoringExamGroupInput;
  BiologicalMonitoringExamGroupUpdate: TBiologicalMonitoringExamGroupUpdate;
  BiologicalMonitoringExamInput: TBiologicalMonitoringExamInput;
  BiologicalMonitoringInput: TBiologicalMonitoringInput;
  BiologicalMonitoringProtocol: ResolverTypeWrapper<TBiologicalMonitoringProtocol>;
  BiologicalMonitoringProtocolExams: ResolverTypeWrapper<TBiologicalMonitoringProtocolExams>;
  BiologicalMonitoringProtocolParams: ResolverTypeWrapper<TBiologicalMonitoringProtocolParams>;
  BiologicalMonitoringReport: ResolverTypeWrapper<TBiologicalMonitoringReport>;
  BiologicalMonitoringUpdate: TBiologicalMonitoringUpdate;
  BiologicalProtocol: ResolverTypeWrapper<TBiologicalProtocol>;
  BiologicalRelease: ResolverTypeWrapper<TBiologicalRelease>;
  Biometry: ResolverTypeWrapper<TBiometry>;
  BiometryCheck: TBiometryCheck;
  BiometryEquipment: TBiometryEquipment;
  BiometryInput: TBiometryInput;
  BiometryUpdate: TBiometryUpdate;
  BloodType: TBloodType;
  BloodTypeChart: ResolverTypeWrapper<TBloodTypeChart>;
  BodyPart: ResolverTypeWrapper<TBodyPart>;
  BodyPartOnAccident: ResolverTypeWrapper<TBodyPartOnAccident>;
  BodyPartOnAccidentInput: TBodyPartOnAccidentInput;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  Branch: ResolverTypeWrapper<TBranch>;
  BranchCreationInput: TBranchCreationInput;
  BranchInput: TBranchInput;
  BranchTtalkInfo: ResolverTypeWrapper<TBranchTtalkInfo>;
  BranchUpdateInput: TBranchUpdateInput;
  BranchWithOptionalOrganization: ResolverTypeWrapper<TBranchWithOptionalOrganization>;
  BranchWithOrganization: ResolverTypeWrapper<TBranchWithOrganization>;
  BulkSyncRun: ResolverTypeWrapper<TBulkSyncRun>;
  BulkSyncRunStatus: TBulkSyncRunStatus;
  BusinessEntity: TBusinessEntity;
  CaInUseChart: ResolverTypeWrapper<TCaInUseChart>;
  CaSituation: TCaSituation;
  Calendar: ResolverTypeWrapper<TCalendar>;
  CalendarInput: TCalendarInput;
  CalendarUpdate: TCalendarUpdate;
  CalendarWorkShift: ResolverTypeWrapper<TCalendarWorkShift>;
  CalendarWorkShiftEntry: ResolverTypeWrapper<TCalendarWorkShiftEntry>;
  CalendarWorkShiftInput: TCalendarWorkShiftInput;
  Candidate: ResolverTypeWrapper<TCandidate>;
  CandidateByMandate: ResolverTypeWrapper<TCandidateByMandate>;
  CandidateInput: TCandidateInput;
  CandidateUpdate: TCandidateUpdate;
  CategoriesChart: ResolverTypeWrapper<TCategoriesChart>;
  CategorizedInputData: ResolverTypeWrapper<TCategorizedInputData>;
  CauseType: TCauseType;
  CauserAgent: ResolverTypeWrapper<TCauserAgent>;
  CauserAgentInput: TCauserAgentInput;
  CauserAgentOnAccident: ResolverTypeWrapper<TCauserAgentOnAccident>;
  CauserAgentOnAccidentInput: TCauserAgentOnAccidentInput;
  CauserAgentOnAccidentUpdate: TCauserAgentOnAccidentUpdate;
  Causes: ResolverTypeWrapper<TCauses>;
  CertificateOrigin: TCertificateOrigin;
  CertificatePerDayChart: ResolverTypeWrapper<TCertificatePerDayChart>;
  CertificateType: TCertificateType;
  CertificatesRankingDashboard: ResolverTypeWrapper<TCertificatesRankingDashboard>;
  ChangeStatusPreMedicalCertificateInput: TChangeStatusPreMedicalCertificateInput;
  ChartData: ResolverTypeWrapper<TChartData>;
  CheckTableData: ResolverTypeWrapper<TCheckTableData>;
  Checklist: ResolverTypeWrapper<TChecklist>;
  ChecklistInput: TChecklistInput;
  ChemicalRisk: ResolverTypeWrapper<TChemicalRisk>;
  CivilStatus: TCivilStatus;
  ClassICDType: TClassIcdType;
  ClassificationPure: ResolverTypeWrapper<TClassificationPure>;
  ClinicalQuiz: ResolverTypeWrapper<TClinicalQuiz>;
  ClinicalQuizInput: TClinicalQuizInput;
  ClinicalQuizUpdate: TClinicalQuizUpdate;
  CollisionReturn: ResolverTypeWrapper<TCollisionReturn>;
  ComparativeResultsDashboard: ResolverTypeWrapper<TComparativeResultsDashboard>;
  ComplementaryExam: ResolverTypeWrapper<TComplementaryExam>;
  ComplementaryExamInput: TComplementaryExamInput;
  ComplementaryExams: ResolverTypeWrapper<TComplementaryExams>;
  ComplementaryIcd: ResolverTypeWrapper<TComplementaryIcd>;
  ComplementaryIcdInput: TComplementaryIcdInput;
  ComplementaryIcdOnAccident: ResolverTypeWrapper<TComplementaryIcdOnAccident>;
  ComplementaryIcdOnAccidentInput: TComplementaryIcdOnAccidentInput;
  ComplementaryIcdOnAccidentUpdate: TComplementaryIcdOnAccidentUpdate;
  ComplementaryIcdOnDiagnostic: ResolverTypeWrapper<TComplementaryIcdOnDiagnostic>;
  ComplementaryIcdOnDiagnosticInput: TComplementaryIcdOnDiagnosticInput;
  ComplementaryIcdOnDiagnosticUpdate: TComplementaryIcdOnDiagnosticUpdate;
  Component: ResolverTypeWrapper<TComponent>;
  ComponentActiveStatusEntry: ResolverTypeWrapper<TComponentActiveStatusEntry>;
  ComponentInput: TComponentInput;
  ComponentType: TComponentType;
  ComponentUpdate: TComponentUpdate;
  ComunicationType: TComunicationType;
  ConfirmImport: ResolverTypeWrapper<TConfirmImport>;
  ConsiderPrint: TConsiderPrint;
  ConsultReport: ResolverTypeWrapper<TConsultReport>;
  Consultation: ResolverTypeWrapper<TConsultation>;
  ConsultationBiologicalMonitoring: ResolverTypeWrapper<TConsultationBiologicalMonitoring>;
  ConsultationByBranchToPrint: ResolverTypeWrapper<TConsultationByBranchToPrint>;
  ConsultationByDoctorToPrint: ResolverTypeWrapper<TConsultationByDoctorToPrint>;
  ConsultationExamsResult: ResolverTypeWrapper<TConsultationExamsResult>;
  ConsultationInput: TConsultationInput;
  ConsultationMinimal: ResolverTypeWrapper<TConsultationMinimal>;
  ConsultationNature: TConsultationNature;
  ConsultationReason: ResolverTypeWrapper<TConsultationReason>;
  ConsultationType: TConsultationType;
  ConsultationUpdate: TConsultationUpdate;
  ContactRequest: ResolverTypeWrapper<TContactRequest>;
  ContactRequestInput: TContactRequestInput;
  ControlMeasure: ResolverTypeWrapper<TControlMeasure>;
  ControlMeasureByRisk: ResolverTypeWrapper<TControlMeasureByRisk>;
  ControlMeasureByRiskInput: TControlMeasureByRiskInput;
  ControlMeasureFrame: ResolverTypeWrapper<TControlMeasureFrame>;
  ControlMeasureInput: TControlMeasureInput;
  ControlMeasureOnRiskInput: TControlMeasureOnRiskInput;
  ControlMeasureOnRiskUpdate: TControlMeasureOnRiskUpdate;
  ControlMeasureUpdate: TControlMeasureUpdate;
  ControlMeasuresChart: ResolverTypeWrapper<TControlMeasuresChart>;
  ControlType: TControlType;
  CostCenter: ResolverTypeWrapper<TCostCenter>;
  CostCenterByRisk: ResolverTypeWrapper<TCostCenterByRisk>;
  CostCenterByRiskInput: TCostCenterByRiskInput;
  CostCenterEntry: ResolverTypeWrapper<TCostCenterEntry>;
  CostCenterGroup: ResolverTypeWrapper<TCostCenterGroup>;
  CostCenterInput: TCostCenterInput;
  CostCenterIntegration: TCostCenterIntegration;
  CostCenterOccupationChart: ResolverTypeWrapper<TCostCenterOccupationChart>;
  CostCenterOccupationDeficienciesChart: ResolverTypeWrapper<TCostCenterOccupationDeficienciesChart>;
  CostCenterOnMandate: ResolverTypeWrapper<TCostCenterOnMandate>;
  CostCenterOnMandateInput: TCostCenterOnMandateInput;
  CostCenterOnRiskInput: TCostCenterOnRiskInput;
  CostCenterOnVaccine: ResolverTypeWrapper<TCostCenterOnVaccine>;
  CostCenterOnVaccineInput: TCostCenterOnVaccineInput;
  CostCenterStock: TCostCenterStock;
  CostCenterUpdate: TCostCenterUpdate;
  CostCenterVolumeChart: ResolverTypeWrapper<TCostCenterVolumeChart>;
  CostPerTypeChart: ResolverTypeWrapper<TCostPerTypeChart>;
  CreateMetadataInput: TCreateMetadataInput;
  CreditCard: ResolverTypeWrapper<TCreditCard>;
  CronTab: ResolverTypeWrapper<TCronTab>;
  CronTabInput: TCronTabInput;
  CrontabExecution: ResolverTypeWrapper<TCrontabExecution>;
  CrontabExecutionAction: TCrontabExecutionAction;
  CrontabExecutionDetail: ResolverTypeWrapper<TCrontabExecutionDetail>;
  CrontabExecutionStatus: TCrontabExecutionStatus;
  CsvImports: TCsvImports;
  CustomDocument: ResolverTypeWrapper<TCustomDocument>;
  CustomDocumentSubType: TCustomDocumentSubType;
  CustomOrganization: ResolverTypeWrapper<TCustomOrganization>;
  CustomOrganizationInput: TCustomOrganizationInput;
  CustomType: TCustomType;
  Customer: ResolverTypeWrapper<TCustomer>;
  CustomerInput: TCustomerInput;
  DashboardExport: ResolverTypeWrapper<TDashboardExport>;
  Data: ResolverTypeWrapper<TData>;
  DataCharts: ResolverTypeWrapper<TDataCharts>;
  DataLogin: ResolverTypeWrapper<TDataLogin>;
  DateRange: TDateRange;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  DayOfWeek: TDayOfWeek;
  DaysAbsentChart: ResolverTypeWrapper<TDaysAbsentChart>;
  DaysLostWithIcdChart: ResolverTypeWrapper<TDaysLostWithIcdChart>;
  DaysLostWithoutIcdChart: ResolverTypeWrapper<TDaysLostWithoutIcdChart>;
  DaysWithoutAccidentChart: ResolverTypeWrapper<TDaysWithoutAccidentChart>;
  DefaultRecipientUserDto: ResolverTypeWrapper<TDefaultRecipientUserDto>;
  DeficienciesChart: ResolverTypeWrapper<TDeficienciesChart>;
  Deficiency: ResolverTypeWrapper<TDeficiency>;
  DeficiencyInput: TDeficiencyInput;
  DeficiencyOrigin: TDeficiencyOrigin;
  DeficiencyType: TDeficiencyType;
  DeficiencyUpdate: TDeficiencyUpdate;
  DegreeOfFire: TDegreeOfFire;
  DeliveredIpesParams: ResolverTypeWrapper<TDeliveredIpesParams>;
  DeliveredIpesReport: ResolverTypeWrapper<TDeliveredIpesReport>;
  DeliveredProductsParams: ResolverTypeWrapper<TDeliveredProductsParams>;
  DeliveredSparePartsParams: ResolverTypeWrapper<TDeliveredSparePartsParams>;
  DeliveryFilter: TDeliveryFilter;
  DeliveryReason: TDeliveryReason;
  DeliverySpareParts: ResolverTypeWrapper<TDeliverySpareParts>;
  DeliverySparePartsInput: TDeliverySparePartsInput;
  DeliverySparePartsParams: ResolverTypeWrapper<TDeliverySparePartsParams>;
  DeliverySparePartsReport: ResolverTypeWrapper<TDeliverySparePartsReport>;
  DeliverySparePartsUpdate: TDeliverySparePartsUpdate;
  DensityEnum: TDensityEnum;
  Department: ResolverTypeWrapper<TDepartment>;
  DepartmentByRisk: ResolverTypeWrapper<TDepartmentByRisk>;
  DepartmentByRiskInput: TDepartmentByRiskInput;
  DepartmentInput: TDepartmentInput;
  DepartmentIntegration: TDepartmentIntegration;
  DepartmentOnMandate: ResolverTypeWrapper<TDepartmentOnMandate>;
  DepartmentOnMandateInput: TDepartmentOnMandateInput;
  DepartmentOnRiskInput: TDepartmentOnRiskInput;
  DepartmentUpdate: TDepartmentUpdate;
  Dependent: ResolverTypeWrapper<TDependent>;
  DependentByPerson: ResolverTypeWrapper<TDependentByPerson>;
  DependentInput: TDependentInput;
  DependentOnPersonInput: TDependentOnPersonInput;
  DependentOnPersonRemove: TDependentOnPersonRemove;
  DependentOnPersonUpdate: TDependentOnPersonUpdate;
  DependentUpdate: TDependentUpdate;
  DesignVersion: TDesignVersion;
  Diagnostic: ResolverTypeWrapper<TDiagnostic>;
  DiagnosticComplementaryIcd: ResolverTypeWrapper<TDiagnosticComplementaryIcd>;
  DiagnosticComplementaryIcdInput: TDiagnosticComplementaryIcdInput;
  DiagnosticInput: TDiagnosticInput;
  DiagnosticMedicine: ResolverTypeWrapper<TDiagnosticMedicine>;
  DiagnosticMedicineInput: TDiagnosticMedicineInput;
  DiagnosticOptional: TDiagnosticOptional;
  DiagnosticUpdate: TDiagnosticUpdate;
  Dimension: ResolverTypeWrapper<TDimension>;
  DivergingStackedBarChart: ResolverTypeWrapper<TDivergingStackedBarChart>;
  Doctor: ResolverTypeWrapper<TDoctor>;
  DoctorRqeEntry: ResolverTypeWrapper<TDoctorRqeEntry>;
  DoctorRqeEntryInput: TDoctorRqeEntryInput;
  DoctorType: TDoctorType;
  DocumentClass: TDocumentClass;
  DocumentFromEntityResponse: ResolverTypeWrapper<TDocumentFromEntityResponse>;
  DocumentObserver: ResolverTypeWrapper<TDocumentObserver>;
  DocumentPending: ResolverTypeWrapper<TDocumentPending>;
  DocumentPendingSigner: ResolverTypeWrapper<TDocumentPendingSigner>;
  DocumentPermissions: ResolverTypeWrapper<TDocumentPermissions>;
  DocumentSigner: ResolverTypeWrapper<TDocumentSigner>;
  DocumentSignerDB: ResolverTypeWrapper<TDocumentSignerDb>;
  DocumentStatus: TDocumentStatus;
  DocumentType: TDocumentType;
  DocumentUser: ResolverTypeWrapper<TDocumentUser>;
  DownloadSignedDocumentInput: TDownloadSignedDocumentInput;
  DownloadType: TDownloadType;
  ESocialDeliveriesParameters: ResolverTypeWrapper<TESocialDeliveriesParameters>;
  ESocialDeliveriesPeriod: ResolverTypeWrapper<TESocialDeliveriesPeriod>;
  ESocialFirstLoadInput: TESocialFirstLoadInput;
  ESocialQueue: ResolverTypeWrapper<TESocialQueue>;
  ESocialQueueAll: ResolverTypeWrapper<TESocialQueueAll>;
  ESocialQueueError: ResolverTypeWrapper<TESocialQueueError>;
  ESocialQueueErrorInput: TESocialQueueErrorInput;
  ESocialQueueFilter: TESocialQueueFilter;
  ESocialQueueHistory: ResolverTypeWrapper<TESocialQueueHistory>;
  ESocialQueueIndicators: ResolverTypeWrapper<TESocialQueueIndicators>;
  ESocialQueueInput: TESocialQueueInput;
  ESocialQueueUpdate: TESocialQueueUpdate;
  ESocialResendMessages: TESocialResendMessages;
  ESocialRhEventStatus: TESocialRhEventStatus;
  ESocialStatus: TESocialStatus;
  ESocialVersion: TESocialVersion;
  EarPart: ResolverTypeWrapper<TEarPart>;
  EarPartEnum: TEarPartEnum;
  EarPartInput: TEarPartInput;
  EarPartUpdate: TEarPartUpdate;
  EconomicActivity: ResolverTypeWrapper<TEconomicActivity>;
  EducationLevel: TEducationLevel;
  EffectiveDocumentTemplate: ResolverTypeWrapper<TEffectiveDocumentTemplate>;
  EfficiencyChart: ResolverTypeWrapper<TEfficiencyChart>;
  Effort: TEffort;
  ElaboratorDocument: ResolverTypeWrapper<TElaboratorDocument>;
  ElectionComission: ResolverTypeWrapper<TElectionComission>;
  ElectionComissionInput: TElectionComissionInput;
  ElectionComissionInputByMandate: TElectionComissionInputByMandate;
  Email: ResolverTypeWrapper<TEmail>;
  EmailHasInvite: ResolverTypeWrapper<TEmailHasInvite>;
  EmailInput: TEmailInput;
  Emitter: TEmitter;
  Employee: ResolverTypeWrapper<TEmployee>;
  EmployeeAgentGroupChart: ResolverTypeWrapper<TEmployeeAgentGroupChart>;
  EmployeeAnamnesis: ResolverTypeWrapper<TEmployeeAnamnesis>;
  EmployeeAnswerClinicalQuizInput: TEmployeeAnswerClinicalQuizInput;
  EmployeeAnswerSafetyQuizInput: TEmployeeAnswerSafetyQuizInput;
  EmployeeByEventTypeInput: TEmployeeByEventTypeInput;
  EmployeeByMandateIdInput: TEmployeeByMandateIdInput;
  EmployeeByOccupation: ResolverTypeWrapper<TEmployeeByOccupation>;
  EmployeeCandidate: ResolverTypeWrapper<TEmployeeCandidate>;
  EmployeeConsultation: ResolverTypeWrapper<TEmployeeConsultation>;
  EmployeeControlMeasure: ResolverTypeWrapper<TEmployeeControlMeasure>;
  EmployeeExam: ResolverTypeWrapper<TEmployeeExam>;
  EmployeeFavoriteOption: ResolverTypeWrapper<TEmployeeFavoriteOption>;
  EmployeeFavoriteOptionInput: TEmployeeFavoriteOptionInput;
  EmployeeIpeDelivery: ResolverTypeWrapper<TEmployeeIpeDelivery>;
  EmployeeIpes: ResolverTypeWrapper<TEmployeeIpes>;
  EmployeeMandateEvent: ResolverTypeWrapper<TEmployeeMandateEvent>;
  EmployeeNicknameInput: TEmployeeNicknameInput;
  EmployeeOperationType: TEmployeeOperationType;
  EmployeePerson: ResolverTypeWrapper<TEmployeePerson>;
  EmployeePreferences: ResolverTypeWrapper<TEmployeePreferences>;
  EmployeePreferencesInput: TEmployeePreferencesInput;
  EmployeeQuiz: ResolverTypeWrapper<TEmployeeQuiz>;
  EmployeeQuizStatusEnum: TEmployeeQuizStatusEnum;
  EmployeeRisk: ResolverTypeWrapper<TEmployeeRisk>;
  EmployeeRiskDashboard: ResolverTypeWrapper<TEmployeeRiskDashboard>;
  EmployeeRiskIpe: ResolverTypeWrapper<TEmployeeRiskIpe>;
  EmployeeSituation: TEmployeeSituation;
  EmployeeTask: ResolverTypeWrapper<TEmployeeTask>;
  EmployeeTaskInput: TEmployeeTaskInput;
  EmployeeTaskOnPerson: TEmployeeTaskOnPerson;
  EmployeeTaskOnPersonInput: TEmployeeTaskOnPersonInput;
  EmployeeTaskOnPersonRemove: TEmployeeTaskOnPersonRemove;
  EmployeeTaskOnPersonUpdate: TEmployeeTaskOnPersonUpdate;
  EmployeeTaskUpdate: TEmployeeTaskUpdate;
  EmployeeVolumeChart: ResolverTypeWrapper<TEmployeeVolumeChart>;
  EmployeeVoteInput: TEmployeeVoteInput;
  EmployeeVotes: ResolverTypeWrapper<TEmployeeVotes>;
  EmployeeWarningOnPersonInput: TEmployeeWarningOnPersonInput;
  EmployeeWarningReport: ResolverTypeWrapper<TEmployeeWarningReport>;
  Endpoint: ResolverTypeWrapper<TEndpoint>;
  EndpointInput: TEndpointInput;
  Entities: TEntities;
  EnvironmentType: TEnvironmentType;
  EnvironmentalReport: ResolverTypeWrapper<TEnvironmentalReport>;
  EnvironmentalReportAttachment: ResolverTypeWrapper<TEnvironmentalReportAttachment>;
  EnvironmentalReportAttachmentInput: TEnvironmentalReportAttachmentInput;
  EnvironmentalReportBiometry: ResolverTypeWrapper<TEnvironmentalReportBiometry>;
  EnvironmentalReportBiometryInput: TEnvironmentalReportBiometryInput;
  EnvironmentalReportCostCenter: ResolverTypeWrapper<TEnvironmentalReportCostCenter>;
  EnvironmentalReportCostCenterInput: TEnvironmentalReportCostCenterInput;
  EnvironmentalReportDocumentResponse: ResolverTypeWrapper<TEnvironmentalReportDocumentResponse>;
  EnvironmentalReportFace: ResolverTypeWrapper<TEnvironmentalReportFace>;
  EnvironmentalReportFaceInput: TEnvironmentalReportFaceInput;
  EnvironmentalReportFilter: TEnvironmentalReportFilter;
  EnvironmentalReportInput: TEnvironmentalReportInput;
  EnvironmentalReportOrderByField: TEnvironmentalReportOrderByField;
  EnvironmentalReportOrderByInput: TEnvironmentalReportOrderByInput;
  EnvironmentalReportParams: TEnvironmentalReportParams;
  EnvironmentalReportQueryInput: TEnvironmentalReportQueryInput;
  EnvironmentalReportSuggestion: ResolverTypeWrapper<TEnvironmentalReportSuggestion>;
  EnvironmentalReportUpdate: TEnvironmentalReportUpdate;
  EnvironmentalReportVersion: ResolverTypeWrapper<TEnvironmentalReportVersion>;
  EpcByAgentGroupItem: ResolverTypeWrapper<TEpcByAgentGroupItem>;
  EpcIncidenceChart: ResolverTypeWrapper<TEpcIncidenceChart>;
  EpiLifespanChart: ResolverTypeWrapper<TEpiLifespanChart>;
  EpiLifespanItem: ResolverTypeWrapper<TEpiLifespanItem>;
  EquipmentByCostCenter: ResolverTypeWrapper<TEquipmentByCostCenter>;
  EquipmentByCostCenterInput: TEquipmentByCostCenterInput;
  EquipmentByOccupation: ResolverTypeWrapper<TEquipmentByOccupation>;
  EquipmentByOccupationInput: TEquipmentByOccupationInput;
  EquipmentOnCostCenterInput: TEquipmentOnCostCenterInput;
  EquipmentOnCostCenterUpdate: TEquipmentOnCostCenterUpdate;
  EquipmentOnOccupationInput: TEquipmentOnOccupationInput;
  EquipmentOnOccupationUpdate: TEquipmentOnOccupationUpdate;
  ErgonomicStatus: TErgonomicStatus;
  ErpLine: TErpLine;
  ErpType: TErpType;
  ErrorResponse: ResolverTypeWrapper<TErrorResponse>;
  Event: ResolverTypeWrapper<TEvent>;
  EventOnSipatInput: TEventOnSipatInput;
  EventOnSipatRemove: TEventOnSipatRemove;
  EventOnSipatUpdate: TEventOnSipatUpdate;
  EvolutionaryCharacterEnum: TEvolutionaryCharacterEnum;
  Exam: ResolverTypeWrapper<TExam>;
  ExamAggravationEnum: TExamAggravationEnum;
  ExamAlterationTrend: ResolverTypeWrapper<TExamAlterationTrend>;
  ExamAnalysis: ResolverTypeWrapper<TExamAnalysis>;
  ExamAudiometry: ResolverTypeWrapper<TExamAudiometry>;
  ExamAudiometryInput: TExamAudiometryInput;
  ExamAudiometryUpdate: TExamAudiometryUpdate;
  ExamByBranchToPrint: ResolverTypeWrapper<TExamByBranchToPrint>;
  ExamByHealthProgram: ResolverTypeWrapper<TExamByHealthProgram>;
  ExamByHealthProgramChanges: TExamByHealthProgramChanges;
  ExamByHealthProgramInput: TExamByHealthProgramInput;
  ExamByHealthProgramUpdate: TExamByHealthProgramUpdate;
  ExamByOccupation: ResolverTypeWrapper<TExamByOccupation>;
  ExamByOccupationChanges: TExamByOccupationChanges;
  ExamByOccupationInput: TExamByOccupationInput;
  ExamByOccupationUpdate: TExamByOccupationUpdate;
  ExamByPerson: ResolverTypeWrapper<TExamByPerson>;
  ExamByPersonNeedSourceEnum: TExamByPersonNeedSourceEnum;
  ExamByPersonTypeEnum: TExamByPersonTypeEnum;
  ExamByRisk: ResolverTypeWrapper<TExamByRisk>;
  ExamByRiskChanges: TExamByRiskChanges;
  ExamByRiskInput: TExamByRiskInput;
  ExamByRiskUpdate: TExamByRiskUpdate;
  ExamByTag: ResolverTypeWrapper<TExamByTag>;
  ExamDiagnosticCount: ResolverTypeWrapper<TExamDiagnosticCount>;
  ExamDiagnosticImage: ResolverTypeWrapper<TExamDiagnosticImage>;
  ExamDiagnosticImageInput: TExamDiagnosticImageInput;
  ExamDiagnosticImageUpdate: TExamDiagnosticImageUpdate;
  ExamDiagnosticIndicatorEnum: TExamDiagnosticIndicatorEnum;
  ExamGenderEnum: TExamGenderEnum;
  ExamIbmp: ResolverTypeWrapper<TExamIbmp>;
  ExamIbmpInput: TExamIbmpInput;
  ExamIbmpUpdate: TExamIbmpUpdate;
  ExamInput: TExamInput;
  ExamItem: ResolverTypeWrapper<TExamItem>;
  ExamItemInput: TExamItemInput;
  ExamItemUpdate: TExamItemUpdate;
  ExamItemValue: ResolverTypeWrapper<TExamItemValue>;
  ExamItemValueInput: TExamItemValueInput;
  ExamItemValueUpdate: TExamItemValueUpdate;
  ExamItemsCount: ResolverTypeWrapper<TExamItemsCount>;
  ExamMeasure: TExamMeasure;
  ExamNormal: ResolverTypeWrapper<TExamNormal>;
  ExamNormalInput: TExamNormalInput;
  ExamNormalResult: ResolverTypeWrapper<TExamNormalResult>;
  ExamNormalUpdate: TExamNormalUpdate;
  ExamOnConsultation: ResolverTypeWrapper<TExamOnConsultation>;
  ExamOnConsultationInput: TExamOnConsultationInput;
  ExamOnConsultationUpdate: TExamOnConsultationUpdate;
  ExamOtological: ResolverTypeWrapper<TExamOtological>;
  ExamOtologicalInput: TExamOtologicalInput;
  ExamOtologicalUpdate: TExamOtologicalUpdate;
  ExamPerson: ResolverTypeWrapper<TExamPerson>;
  ExamProvider: ResolverTypeWrapper<TExamProvider>;
  ExamReferralReport: ResolverTypeWrapper<TExamReferralReport>;
  ExamReport: ResolverTypeWrapper<TExamReport>;
  ExamResultAlterationEnum: TExamResultAlterationEnum;
  ExamResultIndicatorEnum: TExamResultIndicatorEnum;
  ExamResultsByMedicalRecord: ResolverTypeWrapper<TExamResultsByMedicalRecord>;
  ExamScheduling: ResolverTypeWrapper<TExamScheduling>;
  ExamSpirometry: ResolverTypeWrapper<TExamSpirometry>;
  ExamSpirometryInput: TExamSpirometryInput;
  ExamSpirometryUpdate: TExamSpirometryUpdate;
  ExamTag: TExamTag;
  ExamTimelineEntry: ResolverTypeWrapper<TExamTimelineEntry>;
  ExamToxicological: ResolverTypeWrapper<TExamToxicological>;
  ExamToxicologicalInput: TExamToxicologicalInput;
  ExamToxicologicalUpdate: TExamToxicologicalUpdate;
  ExamUpdate: TExamUpdate;
  Exams: ResolverTypeWrapper<TExams>;
  ExamsDoneChart: ResolverTypeWrapper<TExamsDoneChart>;
  ExamsResultQuery: ResolverTypeWrapper<TExamsResultQuery>;
  ExamsToDelete: ResolverTypeWrapper<TExamsToDelete>;
  ExhibitionType: TExhibitionType;
  ExpectedConsultation: ResolverTypeWrapper<TExpectedConsultation>;
  ExpectedExam: ResolverTypeWrapper<TExpectedExam>;
  ExpectedExamFromQuery: ResolverTypeWrapper<TExpectedExamFromQuery>;
  ExpectedGoal: ResolverTypeWrapper<TExpectedGoal>;
  ExpectedGoalInput: TExpectedGoalInput;
  ExpectedGoalOnActionPlan: ResolverTypeWrapper<TExpectedGoalOnActionPlan>;
  Expense: ResolverTypeWrapper<TExpense>;
  ExpenseInput: TExpenseInput;
  ExpenseOnAccident: ResolverTypeWrapper<TExpenseOnAccident>;
  ExpenseOnAccidentInput: TExpenseOnAccidentInput;
  ExpenseOnAccidentRemove: TExpenseOnAccidentRemove;
  ExpenseOnAccidentUpdate: TExpenseOnAccidentUpdate;
  ExpenseType: TExpenseType;
  ExpenseUpdate: TExpenseUpdate;
  ExpensiveAccidentsChart: ResolverTypeWrapper<TExpensiveAccidentsChart>;
  ExportClinicalQuiz: TExportClinicalQuiz;
  ExportStatus: ResolverTypeWrapper<TExportStatus>;
  ExportStatusEnum: TExportStatusEnum;
  ExporterTypeEnum: TExporterTypeEnum;
  ExposureGroup: ResolverTypeWrapper<TExposureGroup>;
  ExposureGroupCopyInput: TExposureGroupCopyInput;
  ExposureGroupCostCenter: ResolverTypeWrapper<TExposureGroupCostCenter>;
  ExposureGroupCostCenterInput: TExposureGroupCostCenterInput;
  ExposureGroupCostCenterUpdate: TExposureGroupCostCenterUpdate;
  ExposureGroupDepartment: ResolverTypeWrapper<TExposureGroupDepartment>;
  ExposureGroupDepartmentInput: TExposureGroupDepartmentInput;
  ExposureGroupDepartmentUpdate: TExposureGroupDepartmentUpdate;
  ExposureGroupInput: TExposureGroupInput;
  ExposureGroupOccupation: ResolverTypeWrapper<TExposureGroupOccupation>;
  ExposureGroupOccupationInput: TExposureGroupOccupationInput;
  ExposureGroupOccupationUpdate: TExposureGroupOccupationUpdate;
  ExposureGroupPerson: ResolverTypeWrapper<TExposureGroupPerson>;
  ExposureGroupPersonInput: TExposureGroupPersonInput;
  ExposureGroupPersonUpdate: TExposureGroupPersonUpdate;
  ExposureGroupTask: ResolverTypeWrapper<TExposureGroupTask>;
  ExposureGroupTaskInput: TExposureGroupTaskInput;
  ExposureGroupTaskUpdate: TExposureGroupTaskUpdate;
  ExposureGroupUpdate: TExposureGroupUpdate;
  ExtensionReason: TExtensionReason;
  ExternalDeliveryChart: ResolverTypeWrapper<TExternalDeliveryChart>;
  ExternalDoctor: ResolverTypeWrapper<TExternalDoctor>;
  ExternalFields: ResolverTypeWrapper<TExternalFields>;
  ExternalOccupationalHealthCertificate: ResolverTypeWrapper<TExternalOccupationalHealthCertificate>;
  ExternalOccupationalHealthCertificateInput: TExternalOccupationalHealthCertificateInput;
  ExternalOccupationalHealthCertificateResponse: ResolverTypeWrapper<TExternalOccupationalHealthCertificateResponse>;
  ExternalOccupationalHealthCertificateUpdate: TExternalOccupationalHealthCertificateUpdate;
  ExtinguishingDonutChart: ResolverTypeWrapper<TExtinguishingDonutChart>;
  ExtinguishingDonutEntry: ResolverTypeWrapper<TExtinguishingDonutEntry>;
  ExtinguishingInspectionChart: ResolverTypeWrapper<TExtinguishingInspectionChart>;
  ExtinguishingInspectionEntry: ResolverTypeWrapper<TExtinguishingInspectionEntry>;
  ExtinguishingParetoChart: ResolverTypeWrapper<TExtinguishingParetoChart>;
  ExtinguishingParetoEntry: ResolverTypeWrapper<TExtinguishingParetoEntry>;
  ExtinguishingSystem: ResolverTypeWrapper<TExtinguishingSystem>;
  ExtinguishingSystemDashboard: ResolverTypeWrapper<TExtinguishingSystemDashboard>;
  ExtinguishingSystemFilter: TExtinguishingSystemFilter;
  ExtinguishingSystemInput: TExtinguishingSystemInput;
  ExtinguishingSystemInspection: ResolverTypeWrapper<TExtinguishingSystemInspection>;
  ExtinguishingSystemInspectionInput: TExtinguishingSystemInspectionInput;
  ExtinguishingSystemMaintenance: TExtinguishingSystemMaintenance;
  ExtinguishingSystemOrderByField: TExtinguishingSystemOrderByField;
  ExtinguishingSystemOrderByInput: TExtinguishingSystemOrderByInput;
  ExtinguishingSystemQueryInput: TExtinguishingSystemQueryInput;
  ExtinguishingSystemRaw: ResolverTypeWrapper<TExtinguishingSystemRaw>;
  ExtinguishingSystemSituation: TExtinguishingSystemSituation;
  ExtinguishingSystemType: TExtinguishingSystemType;
  ExtinguishingSystemUpdate: TExtinguishingSystemUpdate;
  EyeColor: TEyeColor;
  FaceValidations: TFaceValidations;
  FavoriteOption: ResolverTypeWrapper<TFavoriteOption>;
  FavoriteOptionInput: TFavoriteOptionInput;
  Feature: TFeature;
  FeatureEnum: TFeatureEnum;
  FeatureObject: ResolverTypeWrapper<TFeatureObject>;
  FeatureObjectInput: TFeatureObjectInput;
  FeaturePermission: ResolverTypeWrapper<TFeaturePermission>;
  FeaturePermissionType: TFeaturePermissionType;
  FeatureReturn: ResolverTypeWrapper<TFeatureReturn>;
  FeatureVersion: TFeatureVersion;
  FeatureVersionReturn: ResolverTypeWrapper<TFeatureVersionReturn>;
  FieldType: TFieldType;
  FieldsInput: TFieldsInput;
  FilterPerson: TFilterPerson;
  FilterType: TFilterType;
  FindEndpointsInput: TFindEndpointsInput;
  FingerHand: TFingerHand;
  Fingers: TFingers;
  FireBrigade: ResolverTypeWrapper<TFireBrigade>;
  FireBrigadeBloodTypeChart: ResolverTypeWrapper<TFireBrigadeBloodTypeChart>;
  FireBrigadeComponent: ResolverTypeWrapper<TFireBrigadeComponent>;
  FireBrigadeComponentActiveStatusChart: ResolverTypeWrapper<TFireBrigadeComponentActiveStatusChart>;
  FireBrigadeComponentByCostCenterChart: ResolverTypeWrapper<TFireBrigadeComponentByCostCenterChart>;
  FireBrigadeComponentInput: TFireBrigadeComponentInput;
  FireBrigadeComponentUpdate: TFireBrigadeComponentUpdate;
  FireBrigadeDashboard: ResolverTypeWrapper<TFireBrigadeDashboard>;
  FireBrigadeExam: ResolverTypeWrapper<TFireBrigadeExam>;
  FireBrigadeExamInput: TFireBrigadeExamInput;
  FireBrigadeExamUpdate: TFireBrigadeExamUpdate;
  FireBrigadeInput: TFireBrigadeInput;
  FireBrigadeMeeting: ResolverTypeWrapper<TFireBrigadeMeeting>;
  FireBrigadeMeetingAction: ResolverTypeWrapper<TFireBrigadeMeetingAction>;
  FireBrigadeMeetingActionInput: TFireBrigadeMeetingActionInput;
  FireBrigadeMeetingChart: ResolverTypeWrapper<TFireBrigadeMeetingChart>;
  FireBrigadeMeetingInput: TFireBrigadeMeetingInput;
  FireBrigadeMeetingParticipant: ResolverTypeWrapper<TFireBrigadeMeetingParticipant>;
  FireBrigadeMeetingParticipantInput: TFireBrigadeMeetingParticipantInput;
  FireBrigadeMeetingUpdate: TFireBrigadeMeetingUpdate;
  FireBrigadeOccurrence: ResolverTypeWrapper<TFireBrigadeOccurrence>;
  FireBrigadeOccurrenceChart: ResolverTypeWrapper<TFireBrigadeOccurrenceChart>;
  FireBrigadeOccurrenceInput: TFireBrigadeOccurrenceInput;
  FireBrigadeOccurrenceUpdate: TFireBrigadeOccurrenceUpdate;
  FireBrigadePeriod: ResolverTypeWrapper<TFireBrigadePeriod>;
  FireBrigadeSimulationActionChart: ResolverTypeWrapper<TFireBrigadeSimulationActionChart>;
  FireBrigadeSimulationsChart: ResolverTypeWrapper<TFireBrigadeSimulationsChart>;
  FireBrigadeSpecificFunction: TFireBrigadeSpecificFunction;
  FireBrigadeTraining: ResolverTypeWrapper<TFireBrigadeTraining>;
  FireBrigadeTrainingInput: TFireBrigadeTrainingInput;
  FireBrigadeUpdate: TFireBrigadeUpdate;
  FireExtinguisherType: TFireExtinguisherType;
  FirstSteps: ResolverTypeWrapper<TFirstSteps>;
  FirstStepsImage: TFirstStepsImage;
  Flag: TFlag;
  FlagRelation: ResolverTypeWrapper<TFlagRelation>;
  FlagReturn: ResolverTypeWrapper<TFlagReturn>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  FloatRange: TFloatRange;
  FrequencyIndex: ResolverTypeWrapper<TFrequencyIndex>;
  FuncionalHistory: ResolverTypeWrapper<TFuncionalHistory>;
  FuncionalHistoryByPerson: ResolverTypeWrapper<TFuncionalHistoryByPerson>;
  FuncionalHistoryControlMeasure: ResolverTypeWrapper<TFuncionalHistoryControlMeasure>;
  FuncionalHistoryExam: ResolverTypeWrapper<TFuncionalHistoryExam>;
  FuncionalHistoryExamTranslated: ResolverTypeWrapper<TFuncionalHistoryExamTranslated>;
  FuncionalHistoryInput: TFuncionalHistoryInput;
  FuncionalHistoryIpe: ResolverTypeWrapper<TFuncionalHistoryIpe>;
  FuncionalHistoryIpeTranslated: ResolverTypeWrapper<TFuncionalHistoryIpeTranslated>;
  FuncionalHistoryOnPersonInput: TFuncionalHistoryOnPersonInput;
  FuncionalHistoryOnPersonUpdate: TFuncionalHistoryOnPersonUpdate;
  FuncionalHistoryPpp: TFuncionalHistoryPpp;
  FuncionalHistoryRisk: ResolverTypeWrapper<TFuncionalHistoryRisk>;
  FuncionalHistoryRiskTranslated: ResolverTypeWrapper<TFuncionalHistoryRiskTranslated>;
  FuncionalHistoryUpdate: TFuncionalHistoryUpdate;
  FunctionsTask: ResolverTypeWrapper<TFunctionsTask>;
  Gender: TGender;
  GenderEnum: TGenderEnum;
  GeneratePasswordInput: TGeneratePasswordInput;
  GeneratingSource: ResolverTypeWrapper<TGeneratingSource>;
  GeneratingSourceInput: TGeneratingSourceInput;
  GeneratingSourceUpdate: TGeneratingSourceUpdate;
  GenericAccidentCause: ResolverTypeWrapper<TGenericAccidentCause>;
  GenericActivePrinciple: ResolverTypeWrapper<TGenericActivePrinciple>;
  GenericAgeRange: ResolverTypeWrapper<TGenericAgeRange>;
  GenericBiologicalMonitoringExam: ResolverTypeWrapper<TGenericBiologicalMonitoringExam>;
  GenericBiologicalMonitoringExamGroup: ResolverTypeWrapper<TGenericBiologicalMonitoringExamGroup>;
  GenericCostCenter: ResolverTypeWrapper<TGenericCostCenter>;
  GenericExam: ResolverTypeWrapper<TGenericExam>;
  GenericExamIbmp: ResolverTypeWrapper<TGenericExamIbmp>;
  GenericExaminationProcedure: ResolverTypeWrapper<TGenericExaminationProcedure>;
  GenericExpense: ResolverTypeWrapper<TGenericExpense>;
  GenericHealthProgram: ResolverTypeWrapper<TGenericHealthProgram>;
  GenericLaboratory: ResolverTypeWrapper<TGenericLaboratory>;
  GenericMeasuringInstrument: ResolverTypeWrapper<TGenericMeasuringInstrument>;
  GenericMedicine: ResolverTypeWrapper<TGenericMedicine>;
  GenericMetadata: ResolverTypeWrapper<TGenericMetadata>;
  GenericOccupation: ResolverTypeWrapper<TGenericOccupation>;
  GenericPeriodicRange: ResolverTypeWrapper<TGenericPeriodicRange>;
  GenericPublicPlace: ResolverTypeWrapper<TGenericPublicPlace>;
  GenericQuestionGroup: ResolverTypeWrapper<TGenericQuestionGroup>;
  GenericQuestionQuiz: ResolverTypeWrapper<TGenericQuestionQuiz>;
  GenericQuiz: ResolverTypeWrapper<TGenericQuiz>;
  GenericReportSection: ResolverTypeWrapper<TGenericReportSection>;
  GenericReportStructure: ResolverTypeWrapper<TGenericReportStructure>;
  GenericResponseOption: ResolverTypeWrapper<TGenericResponseOption>;
  GenericRiskAgent: ResolverTypeWrapper<TGenericRiskAgent>;
  GenericRolePermission: ResolverTypeWrapper<TGenericRolePermission>;
  GenericStatementResponsibility: ResolverTypeWrapper<TGenericStatementResponsibility>;
  GenericTask: ResolverTypeWrapper<TGenericTask>;
  GenericTraining: ResolverTypeWrapper<TGenericTraining>;
  GenericVaccine: ResolverTypeWrapper<TGenericVaccine>;
  GenericWorkShift: ResolverTypeWrapper<TGenericWorkShift>;
  GetAllSaasMetadataInput: TGetAllSaasMetadataInput;
  GetDocumentsInput: TGetDocumentsInput;
  GetDocumentsOrderByField: TGetDocumentsOrderByField;
  GetDocumentsOrderByInput: TGetDocumentsOrderByInput;
  GetDocumentsParamsInput: TGetDocumentsParamsInput;
  GetDocumentsQueryInput: TGetDocumentsQueryInput;
  GetFields: TGetFields;
  GlycolysisEnum: TGlycolysisEnum;
  GroupAnalysis: ResolverTypeWrapper<TGroupAnalysis>;
  GroupAnalysisInput: TGroupAnalysisInput;
  GroupAnalysisUpdate: TGroupAnalysisUpdate;
  HairColor: THairColor;
  HasFinishedExam: ResolverTypeWrapper<THasFinishedExam>;
  HasRbc: THasRbc;
  HealthProgram: ResolverTypeWrapper<THealthProgram>;
  HealthProgramChart: ResolverTypeWrapper<THealthProgramChart>;
  HealthProgramInput: THealthProgramInput;
  HealthProgramOccupation: ResolverTypeWrapper<THealthProgramOccupation>;
  HealthProgramOccupationInput: THealthProgramOccupationInput;
  HealthProgramTraining: ResolverTypeWrapper<THealthProgramTraining>;
  HealthProgramTrainingChanges: THealthProgramTrainingChanges;
  HealthProgramTrainingInput: THealthProgramTrainingInput;
  HealthProgramUpdate: THealthProgramUpdate;
  HealthQuizzes: ResolverTypeWrapper<THealthQuizzes>;
  HidraulicInspectionReport: ResolverTypeWrapper<THidraulicInspectionReport>;
  HidraulicInspectionReportFields: ResolverTypeWrapper<THidraulicInspectionReportFields>;
  HidraulicSystemInspection: ResolverTypeWrapper<THidraulicSystemInspection>;
  HidraulicSystemInspectionInput: THidraulicSystemInspectionInput;
  Historic: ResolverTypeWrapper<THistoric>;
  HistoricData: ResolverTypeWrapper<THistoricData>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  Icd: ResolverTypeWrapper<TIcd>;
  IcdGroup: ResolverTypeWrapper<TIcdGroup>;
  IdentificationType: TIdentificationType;
  ImcChart: ResolverTypeWrapper<TImcChart>;
  ImportStatus: ResolverTypeWrapper<TImportStatus>;
  ImporterStatus: TImporterStatus;
  ImporterType: TImporterType;
  IncidenceExpense: TIncidenceExpense;
  IndexChart: ResolverTypeWrapper<TIndexChart>;
  Indication: TIndication;
  Indicator: ResolverTypeWrapper<TIndicator>;
  InjuryNature: ResolverTypeWrapper<TInjuryNature>;
  InputData: ResolverTypeWrapper<TInputData>;
  InputTaskOnTask: TInputTaskOnTask;
  InputUserCheck: TInputUserCheck;
  InputUserReplacePassword: TInputUserReplacePassword;
  InspectionOnExtinguishingSystem: ResolverTypeWrapper<TInspectionOnExtinguishingSystem>;
  InspectionOnExtinguishingSystemChanges: TInspectionOnExtinguishingSystemChanges;
  InspectionOnExtinguishingSystemInput: TInspectionOnExtinguishingSystemInput;
  InspectionOnExtinguishingSystemUpdate: TInspectionOnExtinguishingSystemUpdate;
  InspectionOnHidraulicSystem: ResolverTypeWrapper<TInspectionOnHidraulicSystem>;
  InspectionOnHidraulicSystemChanges: TInspectionOnHidraulicSystemChanges;
  InspectionOnHidraulicSystemInput: TInspectionOnHidraulicSystemInput;
  InspectionOnHidraulicSystemUpdate: TInspectionOnHidraulicSystemUpdate;
  InspectionReport: ResolverTypeWrapper<TInspectionReport>;
  InspectionReportFields: ResolverTypeWrapper<TInspectionReportFields>;
  InspectionSituation: TInspectionSituation;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  IntegrationConfiguration: ResolverTypeWrapper<TIntegrationConfiguration>;
  IntegrationConfigurationInput: TIntegrationConfigurationInput;
  IntegrationConfigurationOption: ResolverTypeWrapper<TIntegrationConfigurationOption>;
  IntegrationConfigurationOptionInput: TIntegrationConfigurationOptionInput;
  IntegrationConfigureInput: TIntegrationConfigureInput;
  IntegrationContext: TIntegrationContext;
  IntegrationError: ResolverTypeWrapper<TIntegrationError>;
  IntegrationErrorAll: ResolverTypeWrapper<TIntegrationErrorAll>;
  IntegrationErrorSummary: ResolverTypeWrapper<TIntegrationErrorSummary>;
  IntegrationErrorTypeCount: ResolverTypeWrapper<TIntegrationErrorTypeCount>;
  IntegrationFlags: ResolverTypeWrapper<TIntegrationFlags>;
  IntegrationType: TIntegrationType;
  InternalFields: ResolverTypeWrapper<TInternalFields>;
  InventoryQueue: ResolverTypeWrapper<TInventoryQueue>;
  InventoryQueueInput: TInventoryQueueInput;
  InventoryTypeMessage: TInventoryTypeMessage;
  Investigation: ResolverTypeWrapper<TInvestigation>;
  InvestigationAmountChart: ResolverTypeWrapper<TInvestigationAmountChart>;
  InvestigationCause: ResolverTypeWrapper<TInvestigationCause>;
  InvestigationCauseInput: TInvestigationCauseInput;
  InvestigationCauseOnAccident: ResolverTypeWrapper<TInvestigationCauseOnAccident>;
  InvestigationCauseOnAccidentInput: TInvestigationCauseOnAccidentInput;
  InvestigationCauseOnAccidentUpdate: TInvestigationCauseOnAccidentUpdate;
  InvestigationIndicatorsChart: ResolverTypeWrapper<TInvestigationIndicatorsChart>;
  InvestigationInput: TInvestigationInput;
  InvestigationSuggestion: ResolverTypeWrapper<TInvestigationSuggestion>;
  InvestigationUpdate: TInvestigationUpdate;
  Invite: ResolverTypeWrapper<TInvite>;
  InviteInput: TInviteInput;
  InviteParametersMail: ResolverTypeWrapper<TInviteParametersMail>;
  Invoice: ResolverTypeWrapper<TInvoice>;
  Ipe: ResolverTypeWrapper<TIpe>;
  IpeBiometry: ResolverTypeWrapper<TIpeBiometry>;
  IpeBiometryInput: TIpeBiometryInput;
  IpeByRequirementChart: ResolverTypeWrapper<TIpeByRequirementChart>;
  IpeByRisk: ResolverTypeWrapper<TIpeByRisk>;
  IpeByRiskInput: TIpeByRiskInput;
  IpeDelivery: ResolverTypeWrapper<TIpeDelivery>;
  IpeDeliveryDashboard: ResolverTypeWrapper<TIpeDeliveryDashboard>;
  IpeDeliveryExtensionAuditReport: ResolverTypeWrapper<TIpeDeliveryExtensionAuditReport>;
  IpeDeliveryExtensionAuditStats: ResolverTypeWrapper<TIpeDeliveryExtensionAuditStats>;
  IpeDeliveryExtensionEntry: ResolverTypeWrapper<TIpeDeliveryExtensionEntry>;
  IpeDeliveryExtensionInput: TIpeDeliveryExtensionInput;
  IpeDeliveryExtensionResult: ResolverTypeWrapper<TIpeDeliveryExtensionResult>;
  IpeDeliveryExtensionTimeline: ResolverTypeWrapper<TIpeDeliveryExtensionTimeline>;
  IpeDeliveryFace: ResolverTypeWrapper<TIpeDeliveryFace>;
  IpeDeliveryInput: TIpeDeliveryInput;
  IpeDeliveryLineCharts: ResolverTypeWrapper<TIpeDeliveryLineCharts>;
  IpeDeliveryMedicalReport: ResolverTypeWrapper<TIpeDeliveryMedicalReport>;
  IpeDeliveryParams: ResolverTypeWrapper<TIpeDeliveryParams>;
  IpeDeliveryPerTotalChart: ResolverTypeWrapper<TIpeDeliveryPerTotalChart>;
  IpeDeliveryPieCharts: ResolverTypeWrapper<TIpeDeliveryPieCharts>;
  IpeDeliveryReport: ResolverTypeWrapper<TIpeDeliveryReport>;
  IpeDeliveryReportParams: ResolverTypeWrapper<TIpeDeliveryReportParams>;
  IpeDeliveryUpdate: TIpeDeliveryUpdate;
  IpeFace: ResolverTypeWrapper<TIpeFace>;
  IpeFaceInput: TIpeFaceInput;
  IpeInfo: ResolverTypeWrapper<TIpeInfo>;
  IpeManufacturer: ResolverTypeWrapper<TIpeManufacturer>;
  IpeManufacturerSuggestion: ResolverTypeWrapper<TIpeManufacturerSuggestion>;
  IpeOccupation: ResolverTypeWrapper<TIpeOccupation>;
  IpeOnRiskInput: TIpeOnRiskInput;
  IpeOnRiskUpdate: TIpeOnRiskUpdate;
  IpeProtection: TIpeProtection;
  IpeReport: ResolverTypeWrapper<TIpeReport>;
  IpeTask: ResolverTypeWrapper<TIpeTask>;
  IpesInfo: ResolverTypeWrapper<TIpesInfo>;
  IpesInfoSorted: ResolverTypeWrapper<TIpesInfoSorted>;
  Item: ResolverTypeWrapper<TItem>;
  ItemsSteps: ResolverTypeWrapper<TItemsSteps>;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  KetonesEnum: TKetonesEnum;
  LastMeasurementByRiskUpdate: TLastMeasurementByRiskUpdate;
  Laterality: TLaterality;
  LeukocytesEnum: TLeukocytesEnum;
  Level: ResolverTypeWrapper<TLevel>;
  LevelDiscount: TLevelDiscount;
  LevelInput: TLevelInput;
  LevelsForecast: ResolverTypeWrapper<TLevelsForecast>;
  LevelsForecastInput: TLevelsForecastInput;
  LineChart: ResolverTypeWrapper<TLineChart>;
  LineCharts: ResolverTypeWrapper<TLineCharts>;
  LocationStructure: ResolverTypeWrapper<TLocationStructure>;
  Login: ResolverTypeWrapper<TLogin>;
  Mandate: ResolverTypeWrapper<TMandate>;
  MandateAction: ResolverTypeWrapper<TMandateAction>;
  MandateActionInput: TMandateActionInput;
  MandateActionStatusChart: ResolverTypeWrapper<TMandateActionStatusChart>;
  MandateActionStatusEntry: ResolverTypeWrapper<TMandateActionStatusEntry>;
  MandateCostCenter: ResolverTypeWrapper<TMandateCostCenter>;
  MandateCostCenterInput: TMandateCostCenterInput;
  MandateDashboard: ResolverTypeWrapper<TMandateDashboard>;
  MandateDepartment: ResolverTypeWrapper<TMandateDepartment>;
  MandateDepartmentInput: TMandateDepartmentInput;
  MandateDimension: ResolverTypeWrapper<TMandateDimension>;
  MandateEvent: ResolverTypeWrapper<TMandateEvent>;
  MandateEventInfo: ResolverTypeWrapper<TMandateEventInfo>;
  MandateEventInput: TMandateEventInput;
  MandateEventInputByMandate: TMandateEventInputByMandate;
  MandateEventType: TMandateEventType;
  MandateEventUpdate: TMandateEventUpdate;
  MandateInput: TMandateInput;
  MandateLoss: ResolverTypeWrapper<TMandateLoss>;
  MandateLossReason: TMandateLossReason;
  MandateMeetingActionsTotalChart: ResolverTypeWrapper<TMandateMeetingActionsTotalChart>;
  MandateMeetingActionsTotalEntry: ResolverTypeWrapper<TMandateMeetingActionsTotalEntry>;
  MandateMeetingParticipantsChart: ResolverTypeWrapper<TMandateMeetingParticipantsChart>;
  MandateMeetingParticipantsEntry: ResolverTypeWrapper<TMandateMeetingParticipantsEntry>;
  MandateMeetingsChart: ResolverTypeWrapper<TMandateMeetingsChart>;
  MandateMeetingsEntry: ResolverTypeWrapper<TMandateMeetingsEntry>;
  MandateMonetaryChart: ResolverTypeWrapper<TMandateMonetaryChart>;
  MandateMonetaryEntry: ResolverTypeWrapper<TMandateMonetaryEntry>;
  MandateMonthlyCountChart: ResolverTypeWrapper<TMandateMonthlyCountChart>;
  MandateMonthlyCountEntry: ResolverTypeWrapper<TMandateMonthlyCountEntry>;
  MandateSuggestionStatusChart: ResolverTypeWrapper<TMandateSuggestionStatusChart>;
  MandateSuggestionStatusEntry: ResolverTypeWrapper<TMandateSuggestionStatusEntry>;
  MandateTraining: ResolverTypeWrapper<TMandateTraining>;
  MandateTrainingInput: TMandateTrainingInput;
  MandateTrainingUpdateInput: TMandateTrainingUpdateInput;
  MandateUpdate: TMandateUpdate;
  MandateValidity: ResolverTypeWrapper<TMandateValidity>;
  Manufacturer: ResolverTypeWrapper<TManufacturer>;
  MapUpload: ResolverTypeWrapper<TMapUpload>;
  Material: TMaterial;
  Measure: TMeasure;
  MeasureType: TMeasureType;
  MeasurementAccuracyType: TMeasurementAccuracyType;
  MeasurementByAgentGroupItem: ResolverTypeWrapper<TMeasurementByAgentGroupItem>;
  MeasurementByRisk: ResolverTypeWrapper<TMeasurementByRisk>;
  MeasurementByRiskInput: TMeasurementByRiskInput;
  MeasurementByRiskUpdate: TMeasurementByRiskUpdate;
  MeasurementDeviceItem: ResolverTypeWrapper<TMeasurementDeviceItem>;
  MeasurementDevicesChart: ResolverTypeWrapper<TMeasurementDevicesChart>;
  MeasurementOnRiskInput: TMeasurementOnRiskInput;
  MeasurementOnRiskUpdate: TMeasurementOnRiskUpdate;
  Measurements: ResolverTypeWrapper<TMeasurements>;
  MeasuringInstrument: ResolverTypeWrapper<TMeasuringInstrument>;
  MeasuringInstrumentInput: TMeasuringInstrumentInput;
  MeasuringInstrumentUpdate: TMeasuringInstrumentUpdate;
  MedConsultReport: ResolverTypeWrapper<TMedConsultReport>;
  MedRecordHealthPrograms: ResolverTypeWrapper<TMedRecordHealthPrograms>;
  MedicalCertificate: ResolverTypeWrapper<TMedicalCertificate>;
  MedicalCertificateByIcd: ResolverTypeWrapper<TMedicalCertificateByIcd>;
  MedicalCertificateInput: TMedicalCertificateInput;
  MedicalCertificateReport: ResolverTypeWrapper<TMedicalCertificateReport>;
  MedicalCertificateUpdate: TMedicalCertificateUpdate;
  MedicalConsultation: ResolverTypeWrapper<TMedicalConsultation>;
  MedicalRecord: ResolverTypeWrapper<TMedicalRecord>;
  MedicalRecordCertificates: ResolverTypeWrapper<TMedicalRecordCertificates>;
  MedicalRecordDashboard: ResolverTypeWrapper<TMedicalRecordDashboard>;
  MedicalRecordDeficiencies: ResolverTypeWrapper<TMedicalRecordDeficiencies>;
  MedicalRecordDiagnostics: ResolverTypeWrapper<TMedicalRecordDiagnostics>;
  MedicalRecordExams: ResolverTypeWrapper<TMedicalRecordExams>;
  MedicalRecordFilter: TMedicalRecordFilter;
  MedicalRecordHealthProgram: ResolverTypeWrapper<TMedicalRecordHealthProgram>;
  MedicalRecordHealthProgramInput: TMedicalRecordHealthProgramInput;
  MedicalRecordHealthProgramUpdate: TMedicalRecordHealthProgramUpdate;
  MedicalRecordInput: TMedicalRecordInput;
  MedicalRecordName: ResolverTypeWrapper<TMedicalRecordName>;
  MedicalRecordOrderByFields: TMedicalRecordOrderByFields;
  MedicalRecordOrderByInput: TMedicalRecordOrderByInput;
  MedicalRecordQueryInput: TMedicalRecordQueryInput;
  MedicalRecordReport: ResolverTypeWrapper<TMedicalRecordReport>;
  MedicalRecordRestrictions: ResolverTypeWrapper<TMedicalRecordRestrictions>;
  MedicalRecordUpdate: TMedicalRecordUpdate;
  MedicalRecordVaccinationPlanning: ResolverTypeWrapper<TMedicalRecordVaccinationPlanning>;
  MedicalRecordVaccinationPlanningReport: ResolverTypeWrapper<TMedicalRecordVaccinationPlanningReport>;
  MedicalRecordVaccine: ResolverTypeWrapper<TMedicalRecordVaccine>;
  MedicalRecordVaccineInput: TMedicalRecordVaccineInput;
  MedicalRecordVaccinePrint: ResolverTypeWrapper<TMedicalRecordVaccinePrint>;
  MedicalRecordVaccineStatus: TMedicalRecordVaccineStatus;
  MedicalRecordVaccineUpdate: TMedicalRecordVaccineUpdate;
  MedicalReferral: ResolverTypeWrapper<TMedicalReferral>;
  MedicalReferralDoctorBiometry: ResolverTypeWrapper<TMedicalReferralDoctorBiometry>;
  MedicalReferralDoctorBiometryInput: TMedicalReferralDoctorBiometryInput;
  MedicalReferralInput: TMedicalReferralInput;
  MedicalReferralReport: ResolverTypeWrapper<TMedicalReferralReport>;
  MedicalReferralUpdate: TMedicalReferralUpdate;
  MedicalRestriction: ResolverTypeWrapper<TMedicalRestriction>;
  MedicalRestrictionInput: TMedicalRestrictionInput;
  MedicalRestrictionUpdate: TMedicalRestrictionUpdate;
  MedicalRestrictionsChart: ResolverTypeWrapper<TMedicalRestrictionsChart>;
  MedicalSpecialty: TMedicalSpecialty;
  Medicine: ResolverTypeWrapper<TMedicine>;
  MedicineInput: TMedicineInput;
  MedicineLabelEnum: TMedicineLabelEnum;
  MedicineMeasurementUnit: TMedicineMeasurementUnit;
  MedicineOnDiagnostic: ResolverTypeWrapper<TMedicineOnDiagnostic>;
  MedicineOnDiagnosticChanges: TMedicineOnDiagnosticChanges;
  MedicineOnDiagnosticInput: TMedicineOnDiagnosticInput;
  MedicineOnDiagnosticUpdate: TMedicineOnDiagnosticUpdate;
  MedicineUpdate: TMedicineUpdate;
  MedicinesPrescription: ResolverTypeWrapper<TMedicinesPrescription>;
  Meeting: ResolverTypeWrapper<TMeeting>;
  MeetingAction: ResolverTypeWrapper<TMeetingAction>;
  MeetingActionInput: TMeetingActionInput;
  MeetingActionUpdate: TMeetingActionUpdate;
  MeetingEntry: ResolverTypeWrapper<TMeetingEntry>;
  MeetingFormat: TMeetingFormat;
  MeetingInput: TMeetingInput;
  MeetingParticipant: ResolverTypeWrapper<TMeetingParticipant>;
  MeetingParticipantInput: TMeetingParticipantInput;
  MeetingParticipantUpdate: TMeetingParticipantUpdate;
  MeetingType: TMeetingType;
  MeetingUpdate: TMeetingUpdate;
  MetadataType: TMetadataType;
  MicroActionStatus: TMicroActionStatus;
  MicroActionStatusChart: ResolverTypeWrapper<TMicroActionStatusChart>;
  MicroActionStatusEntry: ResolverTypeWrapper<TMicroActionStatusEntry>;
  ModuleDefaultRecipientsDto: ResolverTypeWrapper<TModuleDefaultRecipientsDto>;
  Mutation: ResolverTypeWrapper<Record<PropertyKey, never>>;
  Nature: TNature;
  NitritesEnum: TNitritesEnum;
  NoiseExposureEnum: TNoiseExposureEnum;
  NoiseRisk: ResolverTypeWrapper<TNoiseRisk>;
  Notification: ResolverTypeWrapper<TNotification>;
  NotificationConfigDto: ResolverTypeWrapper<TNotificationConfigDto>;
  NotificationConfigUpsertInput: TNotificationConfigUpsertInput;
  NotificationTags: ResolverTypeWrapper<TNotificationTags>;
  NtepDistributionChart: ResolverTypeWrapper<TNtepDistributionChart>;
  NtepEvolutionChart: ResolverTypeWrapper<TNtepEvolutionChart>;
  NtepPieEntry: ResolverTypeWrapper<TNtepPieEntry>;
  NtepSeries: ResolverTypeWrapper<TNtepSeries>;
  ObserversItemInput: TObserversItemInput;
  Occupation: ResolverTypeWrapper<TOccupation>;
  OccupationByRisk: ResolverTypeWrapper<TOccupationByRisk>;
  OccupationByRiskInput: TOccupationByRiskInput;
  OccupationInput: TOccupationInput;
  OccupationIntegration: TOccupationIntegration;
  OccupationOnRiskInput: TOccupationOnRiskInput;
  OccupationOnVaccine: ResolverTypeWrapper<TOccupationOnVaccine>;
  OccupationOnVaccineInput: TOccupationOnVaccineInput;
  OccupationUpdate: TOccupationUpdate;
  OccupationalCertificateParameters: ResolverTypeWrapper<TOccupationalCertificateParameters>;
  OccupationalDiseaseAnalysis: ResolverTypeWrapper<TOccupationalDiseaseAnalysis>;
  OccupationalHealthBiometry: ResolverTypeWrapper<TOccupationalHealthBiometry>;
  OccupationalHealthBiometryInput: TOccupationalHealthBiometryInput;
  OccupationalHealthCertificate: ResolverTypeWrapper<TOccupationalHealthCertificate>;
  OccupationalHealthCertificateByDate: ResolverTypeWrapper<TOccupationalHealthCertificateByDate>;
  OccupationalHealthCertificateInput: TOccupationalHealthCertificateInput;
  OccupationalHealthCertificateTotal: ResolverTypeWrapper<TOccupationalHealthCertificateTotal>;
  OccupationalHealthCertificateUpdate: TOccupationalHealthCertificateUpdate;
  OccupationalHealthFace: ResolverTypeWrapper<TOccupationalHealthFace>;
  OccupationalHealthFaceInput: TOccupationalHealthFaceInput;
  OccupationsGroup: ResolverTypeWrapper<TOccupationsGroup>;
  OccurencePath: TOccurencePath;
  OccurrenceEntry: ResolverTypeWrapper<TOccurrenceEntry>;
  OphthalmologicAggravationEnum: TOphthalmologicAggravationEnum;
  OphthalmologicCorrectionEnum: TOphthalmologicCorrectionEnum;
  OrderBy: TOrderBy;
  OrganicMaterial: TOrganicMaterial;
  Organization: ResolverTypeWrapper<TOrganization>;
  OrganizationCancelContractInput: TOrganizationCancelContractInput;
  OrganizationContractInput: TOrganizationContractInput;
  OrganizationInput: TOrganizationInput;
  OrganizationOwnership: ResolverTypeWrapper<TOrganizationOwnership>;
  OrganizationOwnershipInput: TOrganizationOwnershipInput;
  OrganizationUpdateInput: TOrganizationUpdateInput;
  OrganizationWithBranches: ResolverTypeWrapper<TOrganizationWithBranches>;
  OriginMessage: TOriginMessage;
  OriginRectification: TOriginRectification;
  OrthoRater: ResolverTypeWrapper<TOrthoRater>;
  OrthoRaterInput: TOrthoRaterInput;
  OrthoRaterResponseEnum: TOrthoRaterResponseEnum;
  OrthoRaterUpdate: TOrthoRaterUpdate;
  OrthoRaterValueEnum: TOrthoRaterValueEnum;
  Others: TOthers;
  OtologicalDiagnosisEnum: TOtologicalDiagnosisEnum;
  PPREmployees: ResolverTypeWrapper<TPprEmployees>;
  PageOrientation: TPageOrientation;
  PaginatedAbsenceType: ResolverTypeWrapper<TPaginatedAbsenceType>;
  PaginatedAccident: ResolverTypeWrapper<TPaginatedAccident>;
  PaginatedAccidentCause: ResolverTypeWrapper<TPaginatedAccidentCause>;
  PaginatedAccidentCode: ResolverTypeWrapper<TPaginatedAccidentCode>;
  PaginatedAccidentObject: ResolverTypeWrapper<TPaginatedAccidentObject>;
  PaginatedAccidentType: ResolverTypeWrapper<TPaginatedAccidentType>;
  PaginatedAccredited: ResolverTypeWrapper<TPaginatedAccredited>;
  PaginatedAccreditedConsultations: ResolverTypeWrapper<TPaginatedAccreditedConsultations>;
  PaginatedActionPlan: ResolverTypeWrapper<TPaginatedActionPlan>;
  PaginatedActivityGroup: ResolverTypeWrapper<TPaginatedActivityGroup>;
  PaginatedActivityIcd: ResolverTypeWrapper<TPaginatedActivityIcd>;
  PaginatedAllowanceType: ResolverTypeWrapper<TPaginatedAllowanceType>;
  PaginatedAttachment: ResolverTypeWrapper<TPaginatedAttachment>;
  PaginatedAuditLogs: ResolverTypeWrapper<TPaginatedAuditLogs>;
  PaginatedBiologicalMonitoringExam: ResolverTypeWrapper<TPaginatedBiologicalMonitoringExam>;
  PaginatedBiologicalMonitoringExamGroup: ResolverTypeWrapper<TPaginatedBiologicalMonitoringExamGroup>;
  PaginatedBodyPart: ResolverTypeWrapper<TPaginatedBodyPart>;
  PaginatedBranch: ResolverTypeWrapper<TPaginatedBranch>;
  PaginatedCalendar: ResolverTypeWrapper<TPaginatedCalendar>;
  PaginatedConsultation: ResolverTypeWrapper<TPaginatedConsultation>;
  PaginatedConsultationMinimal: ResolverTypeWrapper<TPaginatedConsultationMinimal>;
  PaginatedConsultationReason: ResolverTypeWrapper<TPaginatedConsultationReason>;
  PaginatedControlMeasure: ResolverTypeWrapper<TPaginatedControlMeasure>;
  PaginatedCostCenter: ResolverTypeWrapper<TPaginatedCostCenter>;
  PaginatedCrontabExecutionDetails: ResolverTypeWrapper<TPaginatedCrontabExecutionDetails>;
  PaginatedCrontabExecutions: ResolverTypeWrapper<TPaginatedCrontabExecutions>;
  PaginatedDeliverySpareParts: ResolverTypeWrapper<TPaginatedDeliverySpareParts>;
  PaginatedDepartment: ResolverTypeWrapper<TPaginatedDepartment>;
  PaginatedESocialQueue: ResolverTypeWrapper<TPaginatedESocialQueue>;
  PaginatedEconomicActivity: ResolverTypeWrapper<TPaginatedEconomicActivity>;
  PaginatedEmployeeIpeDelivery: ResolverTypeWrapper<TPaginatedEmployeeIpeDelivery>;
  PaginatedEnvironmentalReport: ResolverTypeWrapper<TPaginatedEnvironmentalReport>;
  PaginatedEnvironmentalReportSuggestion: ResolverTypeWrapper<TPaginatedEnvironmentalReportSuggestion>;
  PaginatedEvent: ResolverTypeWrapper<TPaginatedEvent>;
  PaginatedExam: ResolverTypeWrapper<TPaginatedExam>;
  PaginatedExamNormalResult: ResolverTypeWrapper<TPaginatedExamNormalResult>;
  PaginatedExpectedConsultations: ResolverTypeWrapper<TPaginatedExpectedConsultations>;
  PaginatedExpense: ResolverTypeWrapper<TPaginatedExpense>;
  PaginatedExposureGroup: ResolverTypeWrapper<TPaginatedExposureGroup>;
  PaginatedExtinguishingSystem: ResolverTypeWrapper<TPaginatedExtinguishingSystem>;
  PaginatedFireBrigade: ResolverTypeWrapper<TPaginatedFireBrigade>;
  PaginatedGeneratingSource: ResolverTypeWrapper<TPaginatedGeneratingSource>;
  PaginatedGenericAccidentCause: ResolverTypeWrapper<TPaginatedGenericAccidentCause>;
  PaginatedGenericActivePrinciple: ResolverTypeWrapper<TPaginatedGenericActivePrinciple>;
  PaginatedGenericBiologicalMonitoringExam: ResolverTypeWrapper<TPaginatedGenericBiologicalMonitoringExam>;
  PaginatedGenericBiologicalMonitoringExamGroup: ResolverTypeWrapper<TPaginatedGenericBiologicalMonitoringExamGroup>;
  PaginatedGenericCostCenter: ResolverTypeWrapper<TPaginatedGenericCostCenter>;
  PaginatedGenericExam: ResolverTypeWrapper<TPaginatedGenericExam>;
  PaginatedGenericExaminationProcedure: ResolverTypeWrapper<TPaginatedGenericExaminationProcedure>;
  PaginatedGenericExpense: ResolverTypeWrapper<TPaginatedGenericExpense>;
  PaginatedGenericHealthProgram: ResolverTypeWrapper<TPaginatedGenericHealthProgram>;
  PaginatedGenericLaboratory: ResolverTypeWrapper<TPaginatedGenericLaboratory>;
  PaginatedGenericMeasuringInstrument: ResolverTypeWrapper<TPaginatedGenericMeasuringInstrument>;
  PaginatedGenericMedicine: ResolverTypeWrapper<TPaginatedGenericMedicine>;
  PaginatedGenericOccupation: ResolverTypeWrapper<TPaginatedGenericOccupation>;
  PaginatedGenericPeriodicRange: ResolverTypeWrapper<TPaginatedGenericPeriodicRange>;
  PaginatedGenericPublicPlace: ResolverTypeWrapper<TPaginatedGenericPublicPlace>;
  PaginatedGenericQuestionGroup: ResolverTypeWrapper<TPaginatedGenericQuestionGroup>;
  PaginatedGenericQuestionQuiz: ResolverTypeWrapper<TPaginatedGenericQuestionQuiz>;
  PaginatedGenericQuiz: ResolverTypeWrapper<TPaginatedGenericQuiz>;
  PaginatedGenericReportStructure: ResolverTypeWrapper<TPaginatedGenericReportStructure>;
  PaginatedGenericResponseOption: ResolverTypeWrapper<TPaginatedGenericResponseOption>;
  PaginatedGenericRiskAgent: ResolverTypeWrapper<TPaginatedGenericRiskAgent>;
  PaginatedGenericStatementResponsibility: ResolverTypeWrapper<TPaginatedGenericStatementResponsibility>;
  PaginatedGenericTask: ResolverTypeWrapper<TPaginatedGenericTask>;
  PaginatedGenericTraining: ResolverTypeWrapper<TPaginatedGenericTraining>;
  PaginatedGenericVaccine: ResolverTypeWrapper<TPaginatedGenericVaccine>;
  PaginatedGenericWorkShift: ResolverTypeWrapper<TPaginatedGenericWorkShift>;
  PaginatedGetDocuments: ResolverTypeWrapper<TPaginatedGetDocuments>;
  PaginatedHealthProgram: ResolverTypeWrapper<TPaginatedHealthProgram>;
  PaginatedIcdGroups: ResolverTypeWrapper<TPaginatedIcdGroups>;
  PaginatedIcds: ResolverTypeWrapper<TPaginatedIcds>;
  PaginatedInjuryNature: ResolverTypeWrapper<TPaginatedInjuryNature>;
  PaginatedIntegrationError: ResolverTypeWrapper<TPaginatedIntegrationError>;
  PaginatedInventoryQueue: ResolverTypeWrapper<TPaginatedInventoryQueue>;
  PaginatedInvestigationSuggestion: ResolverTypeWrapper<TPaginatedInvestigationSuggestion>;
  PaginatedIpe: ResolverTypeWrapper<TPaginatedIpe>;
  PaginatedIpeManufacturer: ResolverTypeWrapper<TPaginatedIpeManufacturer>;
  PaginatedMandate: ResolverTypeWrapper<TPaginatedMandate>;
  PaginatedManufacturer: ResolverTypeWrapper<TPaginatedManufacturer>;
  PaginatedMeasuringInstrument: ResolverTypeWrapper<TPaginatedMeasuringInstrument>;
  PaginatedMedicalRecords: ResolverTypeWrapper<TPaginatedMedicalRecords>;
  PaginatedMedicine: ResolverTypeWrapper<TPaginatedMedicine>;
  PaginatedOccupation: ResolverTypeWrapper<TPaginatedOccupation>;
  PaginatedPeopleOnBrowse: ResolverTypeWrapper<TPaginatedPeopleOnBrowse>;
  PaginatedPeopleOnBrowseInput: TPaginatedPeopleOnBrowseInput;
  PaginatedPeriodicRange: ResolverTypeWrapper<TPaginatedPeriodicRange>;
  PaginatedPerson: ResolverTypeWrapper<TPaginatedPerson>;
  PaginatedPersonIpeList: ResolverTypeWrapper<TPaginatedPersonIpeList>;
  PaginatedPersonNeedIpe: ResolverTypeWrapper<TPaginatedPersonNeedIpe>;
  PaginatedPhysicalEnvironment: ResolverTypeWrapper<TPaginatedPhysicalEnvironment>;
  PaginatedPosition: ResolverTypeWrapper<TPaginatedPosition>;
  PaginatedPreMedicalCertificates: ResolverTypeWrapper<TPaginatedPreMedicalCertificates>;
  PaginatedProduct: ResolverTypeWrapper<TPaginatedProduct>;
  PaginatedProductDelivery: ResolverTypeWrapper<TPaginatedProductDelivery>;
  PaginatedProductIpeManufacturer: ResolverTypeWrapper<TPaginatedProductIpeManufacturer>;
  PaginatedQueue: ResolverTypeWrapper<TPaginatedQueue>;
  PaginatedQuiz: ResolverTypeWrapper<TPaginatedQuiz>;
  PaginatedReportStructure: ResolverTypeWrapper<TPaginatedReportStructure>;
  PaginatedRisk: ResolverTypeWrapper<TPaginatedRisk>;
  PaginatedRiskAgent: ResolverTypeWrapper<TPaginatedRiskAgent>;
  PaginatedRiskSuggestion: ResolverTypeWrapper<TPaginatedRiskSuggestion>;
  PaginatedRolePermission: ResolverTypeWrapper<TPaginatedRolePermission>;
  PaginatedScheduleRestriction: ResolverTypeWrapper<TPaginatedScheduleRestriction>;
  PaginatedSpareParts: ResolverTypeWrapper<TPaginatedSpareParts>;
  PaginatedStabilityType: ResolverTypeWrapper<TPaginatedStabilityType>;
  PaginatedStatementResponsibility: ResolverTypeWrapper<TPaginatedStatementResponsibility>;
  PaginatedSync: ResolverTypeWrapper<TPaginatedSync>;
  PaginatedTTalkQueue: ResolverTypeWrapper<TPaginatedTTalkQueue>;
  PaginatedTask: ResolverTypeWrapper<TPaginatedTask>;
  PaginatedTraining: ResolverTypeWrapper<TPaginatedTraining>;
  PaginatedTrainingHistory: ResolverTypeWrapper<TPaginatedTrainingHistory>;
  PaginatedTtalkInboundEvent: ResolverTypeWrapper<TPaginatedTtalkInboundEvent>;
  PaginatedTtalkInboundSemanticInconsistency: ResolverTypeWrapper<TPaginatedTtalkInboundSemanticInconsistency>;
  PaginatedUnityMeasure: ResolverTypeWrapper<TPaginatedUnityMeasure>;
  PaginatedVaccine: ResolverTypeWrapper<TPaginatedVaccine>;
  PaginatedWarehouse: ResolverTypeWrapper<TPaginatedWarehouse>;
  PaginatedWebhookQueue: ResolverTypeWrapper<TPaginatedWebhookQueue>;
  PaginatedWorkPermission: ResolverTypeWrapper<TPaginatedWorkPermission>;
  PaginatedWorkShift: ResolverTypeWrapper<TPaginatedWorkShift>;
  Pagination: TPagination;
  PaginationAbsenceQueryInput: TPaginationAbsenceQueryInput;
  PaginationDefaultQueryInput: TPaginationDefaultQueryInput;
  PaginationInput: TPaginationInput;
  PaginationPersonQueryInput: TPaginationPersonQueryInput;
  PaginationProductIpeManufacturerInput: TPaginationProductIpeManufacturerInput;
  ParticipantOnMeeting: ResolverTypeWrapper<TParticipantOnMeeting>;
  ParticipantOnMeetingInput: TParticipantOnMeetingInput;
  ParticipantOnMeetingUpdate: TParticipantOnMeetingUpdate;
  PaymentStatus: TPaymentStatus;
  Payments: ResolverTypeWrapper<TPayments>;
  PcmsoReportData: ResolverTypeWrapper<TPcmsoReportData>;
  PerDayChart: ResolverTypeWrapper<TPerDayChart>;
  PerTotalCharts: ResolverTypeWrapper<TPerTotalCharts>;
  PeriodicRange: ResolverTypeWrapper<TPeriodicRange>;
  PeriodicRangeGenderEnum: TPeriodicRangeGenderEnum;
  PeriodicRangeInput: TPeriodicRangeInput;
  PeriodicRangeUpdate: TPeriodicRangeUpdate;
  Permission: ResolverTypeWrapper<TPermission>;
  PermissionInput: TPermissionInput;
  Person: ResolverTypeWrapper<TPerson>;
  PersonByGender: ResolverTypeWrapper<TPersonByGender>;
  PersonByGenderAndCC: ResolverTypeWrapper<TPersonByGenderAndCc>;
  PersonByMandate: ResolverTypeWrapper<TPersonByMandate>;
  PersonByRisk: ResolverTypeWrapper<TPersonByRisk>;
  PersonByRiskInput: TPersonByRiskInput;
  PersonByTask: ResolverTypeWrapper<TPersonByTask>;
  PersonChart: ResolverTypeWrapper<TPersonChart>;
  PersonFilter: TPersonFilter;
  PersonFilterQueryInput: TPersonFilterQueryInput;
  PersonForExposure: TPersonForExposure;
  PersonHistory: ResolverTypeWrapper<TPersonHistory>;
  PersonHistoryActivate: ResolverTypeWrapper<TPersonHistoryActivate>;
  PersonHistoryActivateInput: TPersonHistoryActivateInput;
  PersonHistoryActivateUpdate: TPersonHistoryActivateUpdate;
  PersonInput: TPersonInput;
  PersonIpeList: ResolverTypeWrapper<TPersonIpeList>;
  PersonNeedIpe: ResolverTypeWrapper<TPersonNeedIpe>;
  PersonOnBrowse: ResolverTypeWrapper<TPersonOnBrowse>;
  PersonOnRiskInput: TPersonOnRiskInput;
  PersonOnTaskInput: TPersonOnTaskInput;
  PersonOnTaskRemove: TPersonOnTaskRemove;
  PersonOnTaskUpdate: TPersonOnTaskUpdate;
  PersonOrderByFields: TPersonOrderByFields;
  PersonOrderByInput: TPersonOrderByInput;
  PersonRequiredTraining: ResolverTypeWrapper<TPersonRequiredTraining>;
  PersonUpdate: TPersonUpdate;
  PhEnum: TPhEnum;
  PhoriaEnum: TPhoriaEnum;
  PhysicalEnvironment: ResolverTypeWrapper<TPhysicalEnvironment>;
  PhysicalEnvironmentInput: TPhysicalEnvironmentInput;
  PhysicalEnvironmentUpdate: TPhysicalEnvironmentUpdate;
  PieChart: ResolverTypeWrapper<TPieChart>;
  PieCharts: ResolverTypeWrapper<TPieCharts>;
  PlanLevelType: TPlanLevelType;
  PlanStatus: TPlanStatus;
  PlanedExam: ResolverTypeWrapper<TPlanedExam>;
  PolicyAgreement: ResolverTypeWrapper<TPolicyAgreement>;
  PolicyTerms: ResolverTypeWrapper<TPolicyTerms>;
  PolicyTermsInput: TPolicyTermsInput;
  Position: ResolverTypeWrapper<TPosition>;
  PositionInput: TPositionInput;
  PositionIntegration: TPositionIntegration;
  PositionUpdate: TPositionUpdate;
  PppParameters: TPppParameters;
  PppReport: ResolverTypeWrapper<TPppReport>;
  PreMedicalCertificate: ResolverTypeWrapper<TPreMedicalCertificate>;
  PreMedicalCertificateCountByStatus: ResolverTypeWrapper<TPreMedicalCertificateCountByStatus>;
  PreMedicalCertificateFollowUp: ResolverTypeWrapper<TPreMedicalCertificateFollowUp>;
  PreMedicalCertificateInput: TPreMedicalCertificateInput;
  PreMedicalCertificateQueryInput: TPreMedicalCertificateQueryInput;
  PreMedicalCertificateStatus: TPreMedicalCertificateStatus;
  PreMedicalCertificateUpdate: TPreMedicalCertificateUpdate;
  PreValidate: ResolverTypeWrapper<TPreValidate>;
  PrintBiometry: ResolverTypeWrapper<TPrintBiometry>;
  Priority: TPriority;
  PrivacyType: TPrivacyType;
  ProcessingStep: TProcessingStep;
  Product: ResolverTypeWrapper<TProduct>;
  ProductCopyInput: TProductCopyInput;
  ProductDelivery: ResolverTypeWrapper<TProductDelivery>;
  ProductDeliveryInput: TProductDeliveryInput;
  ProductDeliveryParams: ResolverTypeWrapper<TProductDeliveryParams>;
  ProductDeliveryReport: ResolverTypeWrapper<TProductDeliveryReport>;
  ProductDeliveryUpdate: TProductDeliveryUpdate;
  ProductInput: TProductInput;
  ProductIntegration: TProductIntegration;
  ProductIpeManufacturer: ResolverTypeWrapper<TProductIpeManufacturer>;
  ProductIpeManufacturerInput: TProductIpeManufacturerInput;
  ProductIpeManufacturerUpdate: TProductIpeManufacturerUpdate;
  ProductReport: ResolverTypeWrapper<TProductReport>;
  ProductUpdate: TProductUpdate;
  ProductiveHoursFrequency: TProductiveHoursFrequency;
  ProductsParameters: ResolverTypeWrapper<TProductsParameters>;
  ProgramType: TProgramType;
  ProteinsEnum: TProteinsEnum;
  PubSubPayload: ResolverTypeWrapper<TPubSubPayload>;
  PublishingOptionsInput: TPublishingOptionsInput;
  Query: ResolverTypeWrapper<Record<PropertyKey, never>>;
  QuestionGenderEnum: TQuestionGenderEnum;
  QuestionGroupOnQuestion: ResolverTypeWrapper<TQuestionGroupOnQuestion>;
  Questions: ResolverTypeWrapper<TQuestions>;
  QuestionsDashboard: ResolverTypeWrapper<TQuestionsDashboard>;
  QuestionsGroup: ResolverTypeWrapper<TQuestionsGroup>;
  QuestionsGroupInput: TQuestionsGroupInput;
  QuestionsGroupUpdate: TQuestionsGroupUpdate;
  QuestionsInput: TQuestionsInput;
  QuestionsUpdate: TQuestionsUpdate;
  QueueDTO: ResolverTypeWrapper<TQueueDto>;
  Quiz: ResolverTypeWrapper<TQuiz>;
  QuizCostCenter: ResolverTypeWrapper<TQuizCostCenter>;
  QuizCostCenterInput: TQuizCostCenterInput;
  QuizDepartment: ResolverTypeWrapper<TQuizDepartment>;
  QuizDepartmentInput: TQuizDepartmentInput;
  QuizGeneratingSource: ResolverTypeWrapper<TQuizGeneratingSource>;
  QuizGeneratingSourceInput: TQuizGeneratingSourceInput;
  QuizInput: TQuizInput;
  QuizOccupation: ResolverTypeWrapper<TQuizOccupation>;
  QuizOccupationInput: TQuizOccupationInput;
  QuizPerson: ResolverTypeWrapper<TQuizPerson>;
  QuizPersonInput: TQuizPersonInput;
  QuizPhysicalEnvironment: ResolverTypeWrapper<TQuizPhysicalEnvironment>;
  QuizPhysicalEnvironmentInput: TQuizPhysicalEnvironmentInput;
  QuizRelationEnum: TQuizRelationEnum;
  QuizTypeEnum: TQuizTypeEnum;
  QuizUpdate: TQuizUpdate;
  QuizzesCharts: ResolverTypeWrapper<TQuizzesCharts>;
  RadarCharts: ResolverTypeWrapper<TRadarCharts>;
  Ranking: ResolverTypeWrapper<TRanking>;
  RealGoal: ResolverTypeWrapper<TRealGoal>;
  RealGoalInput: TRealGoalInput;
  RealGoalOnActionPlan: ResolverTypeWrapper<TRealGoalOnActionPlan>;
  ReasonsChart: ResolverTypeWrapper<TReasonsChart>;
  RecipientInput: TRecipientInput;
  RecipientItemInput: TRecipientItemInput;
  RecipientListInput: TRecipientListInput;
  RecipientListItemInput: TRecipientListItemInput;
  RecognizeMedicalCertificateInput: TRecognizeMedicalCertificateInput;
  RecognizedIcdInfo: ResolverTypeWrapper<TRecognizedIcdInfo>;
  RecognizedMedicalCertificateData: ResolverTypeWrapper<TRecognizedMedicalCertificateData>;
  Recommendation: TRecommendation;
  RedCellsEnum: TRedCellsEnum;
  References: ResolverTypeWrapper<TReferences>;
  ReferencesInput: TReferencesInput;
  ReferencesUpdate: TReferencesUpdate;
  ReferralsChart: ResolverTypeWrapper<TReferralsChart>;
  ReferralsQuantityChart: ResolverTypeWrapper<TReferralsQuantityChart>;
  RelativeIndex: ResolverTypeWrapper<TRelativeIndex>;
  ReleasableResult: ResolverTypeWrapper<TReleasableResult>;
  ReleaseConsultationResultsInput: TReleaseConsultationResultsInput;
  RemoveRecipientInput: TRemoveRecipientInput;
  ReplacementSituation: TReplacementSituation;
  ReportFinality: TReportFinality;
  ReportMapaData: ResolverTypeWrapper<TReportMapaData>;
  ReportMapaFields: ResolverTypeWrapper<TReportMapaFields>;
  ReportPrescription: ResolverTypeWrapper<TReportPrescription>;
  ReportSection: ResolverTypeWrapper<TReportSection>;
  ReportSectionBaseInput: TReportSectionBaseInput;
  ReportSectionInput: TReportSectionInput;
  ReportSectionType: TReportSectionType;
  ReportSectionUpdate: TReportSectionUpdate;
  ReportStructure: ResolverTypeWrapper<TReportStructure>;
  ReportStructureInput: TReportStructureInput;
  ReportStructureUpdate: TReportStructureUpdate;
  ReportType: TReportType;
  ResponseClinicalQuizInput: TResponseClinicalQuizInput;
  ResponseClinicalQuizUpdate: TResponseClinicalQuizUpdate;
  ResponseOptions: ResolverTypeWrapper<TResponseOptions>;
  ResponseOptionsInput: TResponseOptionsInput;
  ResponseOptionsUpdate: TResponseOptionsUpdate;
  ResponseSafetyQuizInput: TResponseSafetyQuizInput;
  ResponseSafetyQuizUpdate: TResponseSafetyQuizUpdate;
  ResponseType: TResponseType;
  ResponseWorkPermissionQuiz: ResolverTypeWrapper<TResponseWorkPermissionQuiz>;
  ResponseWorkPermissionQuizInput: TResponseWorkPermissionQuizInput;
  ResponseWorkPermissionQuizUpdate: TResponseWorkPermissionQuizUpdate;
  ResponsesClinicalQuiz: ResolverTypeWrapper<TResponsesClinicalQuiz>;
  ResponsesSafetyQuiz: ResolverTypeWrapper<TResponsesSafetyQuiz>;
  ResponsibleAction: ResolverTypeWrapper<TResponsibleAction>;
  ResponsibleActionInput: TResponsibleActionInput;
  ResponsibleOnActionPlan: ResolverTypeWrapper<TResponsibleOnActionPlan>;
  RestrictionType: TRestrictionType;
  ResultExamIbmp: ResolverTypeWrapper<TResultExamIbmp>;
  ResultExamIbmpForComparative: ResolverTypeWrapper<TResultExamIbmpForComparative>;
  ResultExamIbmpGroup: ResolverTypeWrapper<TResultExamIbmpGroup>;
  ResultExamIbmpInput: TResultExamIbmpInput;
  ResultExamIbmpUpdate: TResultExamIbmpUpdate;
  ResultExamItemForComparative: ResolverTypeWrapper<TResultExamItemForComparative>;
  ResultExamItemGroup: ResolverTypeWrapper<TResultExamItemGroup>;
  ResultExamOrthoRaterForComparative: ResolverTypeWrapper<TResultExamOrthoRaterForComparative>;
  ResultExamSnellenForComparative: ResolverTypeWrapper<TResultExamSnellenForComparative>;
  ResultExamSpirometryForComparative: ResolverTypeWrapper<TResultExamSpirometryForComparative>;
  ResultExamSpirometryGroup: ResolverTypeWrapper<TResultExamSpirometryGroup>;
  ResultTypeEnum: TResultTypeEnum;
  ResultUrinalysisForComparative: ResolverTypeWrapper<TResultUrinalysisForComparative>;
  ResultUrinalysisGroup: ResolverTypeWrapper<TResultUrinalysisGroup>;
  ReturnReason: TReturnReason;
  ReturnReasonsChart: ResolverTypeWrapper<TReturnReasonsChart>;
  Risk: ResolverTypeWrapper<TRisk>;
  RiskAgent: ResolverTypeWrapper<TRiskAgent>;
  RiskAgentInput: TRiskAgentInput;
  RiskAgentUpdate: TRiskAgentUpdate;
  RiskByEnvironmentInput: TRiskByEnvironmentInput;
  RiskCategory: TRiskCategory;
  RiskCharacterization: ResolverTypeWrapper<TRiskCharacterization>;
  RiskChart: ResolverTypeWrapper<TRiskChart>;
  RiskClassification: TRiskClassification;
  RiskClassificationTable: ResolverTypeWrapper<TRiskClassificationTable>;
  RiskComposition: ResolverTypeWrapper<TRiskComposition>;
  RiskCompositionInput: TRiskCompositionInput;
  RiskCompositionSave: TRiskCompositionSave;
  RiskControlMeasure: ResolverTypeWrapper<TRiskControlMeasure>;
  RiskCostCenterOccupation: ResolverTypeWrapper<TRiskCostCenterOccupation>;
  RiskCostCenterOccupationIds: ResolverTypeWrapper<TRiskCostCenterOccupationIds>;
  RiskCount: ResolverTypeWrapper<TRiskCount>;
  RiskDashboard: ResolverTypeWrapper<TRiskDashboard>;
  RiskDegree: TRiskDegree;
  RiskElimination: TRiskElimination;
  RiskEnvironment: ResolverTypeWrapper<TRiskEnvironment>;
  RiskFilter: TRiskFilter;
  RiskIndicator: TRiskIndicator;
  RiskInput: TRiskInput;
  RiskIntensity: TRiskIntensity;
  RiskMap: TRiskMap;
  RiskMeasure: TRiskMeasure;
  RiskMeasureType: TRiskMeasureType;
  RiskMeasurement: ResolverTypeWrapper<TRiskMeasurement>;
  RiskMeasurements: ResolverTypeWrapper<TRiskMeasurements>;
  RiskOrderByFields: TRiskOrderByFields;
  RiskOrderByInput: TRiskOrderByInput;
  RiskOrganizationalControl: TRiskOrganizationalControl;
  RiskPieChart: ResolverTypeWrapper<TRiskPieChart>;
  RiskProbability: TRiskProbability;
  RiskProbabilityTable: ResolverTypeWrapper<TRiskProbabilityTable>;
  RiskQueryInput: TRiskQueryInput;
  RiskReviewReportFields: ResolverTypeWrapper<TRiskReviewReportFields>;
  RiskSeverity: TRiskSeverity;
  RiskSeverityTable: ResolverTypeWrapper<TRiskSeverityTable>;
  RiskSuggestion: ResolverTypeWrapper<TRiskSuggestion>;
  RiskTecnicalControl: TRiskTecnicalControl;
  RiskToReview: ResolverTypeWrapper<TRiskToReview>;
  RiskToReviewReport: ResolverTypeWrapper<TRiskToReviewReport>;
  RiskTrainings: ResolverTypeWrapper<TRiskTrainings>;
  RiskUpdate: TRiskUpdate;
  RisksExam: ResolverTypeWrapper<TRisksExam>;
  RisksInfo: ResolverTypeWrapper<TRisksInfo>;
  RisksPerEnvironmentChart: ResolverTypeWrapper<TRisksPerEnvironmentChart>;
  Role: ResolverTypeWrapper<TRole>;
  RolePermission: ResolverTypeWrapper<TRolePermission>;
  RolePermissionInput: TRolePermissionInput;
  RolePermissionUpdate: TRolePermissionUpdate;
  RoleUpdate: TRoleUpdate;
  RouteEnum: TRouteEnum;
  RouteFeature: ResolverTypeWrapper<TRouteFeature>;
  Routes: TRoutes;
  RowsInfo: ResolverTypeWrapper<TRowsInfo>;
  RowsInput: TRowsInput;
  S3UrlCloudFront: ResolverTypeWrapper<Scalars['S3UrlCloudFront']['output']>;
  SSTMigratorValues: TSstMigratorValues;
  SaasFullMetadata: ResolverTypeWrapper<TSaasFullMetadata>;
  SaasMetadata: ResolverTypeWrapper<TSaasMetadata>;
  SafetyQuiz: ResolverTypeWrapper<TSafetyQuiz>;
  SafetyQuizConformityChart: ResolverTypeWrapper<TSafetyQuizConformityChart>;
  SafetyQuizConformityEntry: ResolverTypeWrapper<TSafetyQuizConformityEntry>;
  SafetyQuizDashboard: ResolverTypeWrapper<TSafetyQuizDashboard>;
  SafetyQuizInput: TSafetyQuizInput;
  SafetyQuizInspectionChart: ResolverTypeWrapper<TSafetyQuizInspectionChart>;
  SafetyQuizInspectionEntry: ResolverTypeWrapper<TSafetyQuizInspectionEntry>;
  SafetyQuizParetoChart: ResolverTypeWrapper<TSafetyQuizParetoChart>;
  SafetyQuizParetoEntry: ResolverTypeWrapper<TSafetyQuizParetoEntry>;
  SafetyQuizUpdate: TSafetyQuizUpdate;
  SaveEnvironmentalReportVersionInput: TSaveEnvironmentalReportVersionInput;
  SaveVersionConflictStrategy: TSaveVersionConflictStrategy;
  ScheduleRestriction: ResolverTypeWrapper<TScheduleRestriction>;
  ScheduleRestrictionInput: TScheduleRestrictionInput;
  ScheduleRestrictionUpdate: TScheduleRestrictionUpdate;
  ScheduledConsultation: ResolverTypeWrapper<TScheduledConsultation>;
  ScheduledConsultationByBranch: ResolverTypeWrapper<TScheduledConsultationByBranch>;
  ScheduledConsultationToPrint: ResolverTypeWrapper<TScheduledConsultationToPrint>;
  ScheduledExam: ResolverTypeWrapper<TScheduledExam>;
  ScheduledExamByBranch: ResolverTypeWrapper<TScheduledExamByBranch>;
  ScheduledExamToPrint: ResolverTypeWrapper<TScheduledExamToPrint>;
  SchedulingByAccredited: ResolverTypeWrapper<TSchedulingByAccredited>;
  SchedulingParameters: ResolverTypeWrapper<TSchedulingParameters>;
  SchedulingReport: ResolverTypeWrapper<TSchedulingReport>;
  SchedulingReportByDoctor: ResolverTypeWrapper<TSchedulingReportByDoctor>;
  SchedulingSettings: ResolverTypeWrapper<TSchedulingSettings>;
  SecurityPyramid: ResolverTypeWrapper<TSecurityPyramid>;
  SecurityWorkOrder: ResolverTypeWrapper<TSecurityWorkOrder>;
  SecurityWorkOrderParameters: ResolverTypeWrapper<TSecurityWorkOrderParameters>;
  SendType: TSendType;
  ServiceArea: TServiceArea;
  ServiceProviderExamInput: TServiceProviderExamInput;
  ServiceProviderInput: TServiceProviderInput;
  ServiceProviderUpdate: TServiceProviderUpdate;
  SesmtRoles: ResolverTypeWrapper<TSesmtRoles>;
  Session: ResolverTypeWrapper<TSession>;
  SessionData: ResolverTypeWrapper<TSessionData>;
  SessionInput: TSessionInput;
  SessionInputAd: TSessionInputAd;
  Settings: ResolverTypeWrapper<TSettings>;
  SettingsInput: TSettingsInput;
  SeverityIndex: ResolverTypeWrapper<TSeverityIndex>;
  Shortcut: TShortcut;
  ShortcutGenerated: ResolverTypeWrapper<TShortcutGenerated>;
  ShortcutHistory: ResolverTypeWrapper<TShortcutHistory>;
  ShortcutHistoryId: ResolverTypeWrapper<TShortcutHistoryId>;
  SickNote: ResolverTypeWrapper<TSickNote>;
  SignBrokerGetDocument: ResolverTypeWrapper<TSignBrokerGetDocument>;
  SignBrokerGetDocuments: ResolverTypeWrapper<TSignBrokerGetDocuments>;
  SignBrokerGetDocumentsAndUpdateState: ResolverTypeWrapper<TSignBrokerGetDocumentsAndUpdateState>;
  SignBrokerResponse: ResolverTypeWrapper<TSignBrokerResponse>;
  SignBrokerUrlDownloadResponse: ResolverTypeWrapper<TSignBrokerUrlDownloadResponse>;
  SignCredentialsInput: TSignCredentialsInput;
  SignCredentialsOutput: ResolverTypeWrapper<TSignCredentialsOutput>;
  SignIntegrations: TSignIntegrations;
  SignPublicationAction: TSignPublicationAction;
  SignatureChart: ResolverTypeWrapper<TSignatureChart>;
  SigningInput: TSigningInput;
  SigningType: TSigningType;
  SimpleComplementaryResults: ResolverTypeWrapper<TSimpleComplementaryResults>;
  Simulation: ResolverTypeWrapper<TSimulation>;
  SimulationAction: ResolverTypeWrapper<TSimulationAction>;
  SimulationActionEntry: ResolverTypeWrapper<TSimulationActionEntry>;
  SimulationActionInput: TSimulationActionInput;
  SimulationEntry: ResolverTypeWrapper<TSimulationEntry>;
  SimulationInput: TSimulationInput;
  SimulationPlan: ResolverTypeWrapper<TSimulationPlan>;
  SimulationPlanAction: ResolverTypeWrapper<TSimulationPlanAction>;
  SimulationPlanActionInput: TSimulationPlanActionInput;
  SimulationPlanInput: TSimulationPlanInput;
  SimulationPlanUpdate: TSimulationPlanUpdate;
  SimulationUpdate: TSimulationUpdate;
  Sipat: ResolverTypeWrapper<TSipat>;
  SipatEvent: ResolverTypeWrapper<TSipatEvent>;
  SipatEventInput: TSipatEventInput;
  SipatEventUpdate: TSipatEventUpdate;
  SipatInput: TSipatInput;
  SipatUpdate: TSipatUpdate;
  Situation: TSituation;
  SituationCount: ResolverTypeWrapper<TSituationCount>;
  SkinColor: TSkinColor;
  Snellen: ResolverTypeWrapper<TSnellen>;
  SnellenInput: TSnellenInput;
  SnellenUpdate: TSnellenUpdate;
  SnellenValue: TSnellenValue;
  SocialSecurityAffiliation: TSocialSecurityAffiliation;
  SpareParts: ResolverTypeWrapper<TSpareParts>;
  SparePartsInput: TSparePartsInput;
  SparePartsReport: ResolverTypeWrapper<TSparePartsReport>;
  SparePartsUpdate: TSparePartsUpdate;
  SpecificFunction: TSpecificFunction;
  StabilityType: ResolverTypeWrapper<TStabilityType>;
  StabilityTypeInput: TStabilityTypeInput;
  StabilityTypeIntegration: TStabilityTypeIntegration;
  StabilityTypeUpdate: TStabilityTypeUpdate;
  State: TState;
  StatementResponsibility: ResolverTypeWrapper<TStatementResponsibility>;
  StatementResponsibilityInput: TStatementResponsibilityInput;
  StatementResponsibilityUpdate: TStatementResponsibilityUpdate;
  Status: TStatus;
  StatusMessage: TStatusMessage;
  StatusSuggestion: TStatusSuggestion;
  StepMessage: ResolverTypeWrapper<TStepMessage>;
  Steps: ResolverTypeWrapper<TSteps>;
  StockLevel: ResolverTypeWrapper<TStockLevel>;
  StockLevelInput: TStockLevelInput;
  StockLevelReference: TStockLevelReference;
  StockLevelSyncResult: ResolverTypeWrapper<TStockLevelSyncResult>;
  StockLevelUpdate: TStockLevelUpdate;
  StockMovement: ResolverTypeWrapper<TStockMovement>;
  StockMovementInput: TStockMovementInput;
  StockMovementStatus: TStockMovementStatus;
  StockMovementType: TStockMovementType;
  StockMovementUpdate: TStockMovementUpdate;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  Subscription: ResolverTypeWrapper<Record<PropertyKey, never>>;
  SubscriptionLevelDiscount: TSubscriptionLevelDiscount;
  SuggestionAmount: ResolverTypeWrapper<TSuggestionAmount>;
  SuggestionBox: ResolverTypeWrapper<TSuggestionBox>;
  SuggestionBoxInput: TSuggestionBoxInput;
  SuggestionBoxListReport: ResolverTypeWrapper<TSuggestionBoxListReport>;
  SuggestionBoxUpdate: TSuggestionBoxUpdate;
  Summary: ResolverTypeWrapper<TSummary>;
  SummaryEntry: ResolverTypeWrapper<TSummaryEntry>;
  SummaryOption: ResolverTypeWrapper<TSummaryOption>;
  SyncDTO: ResolverTypeWrapper<TSyncDto>;
  TTalkQueue: ResolverTypeWrapper<TTTalkQueue>;
  TTalkQueueAll: ResolverTypeWrapper<TTTalkQueueAll>;
  TTalkQueueFilterInput: TTTalkQueueFilterInput;
  TTalkQueueInput: TTTalkQueueInput;
  TTalkQueueSummary: ResolverTypeWrapper<TTTalkQueueSummary>;
  TableProperties: ResolverTypeWrapper<TTableProperties>;
  Task: ResolverTypeWrapper<TTask>;
  TaskByPerson: ResolverTypeWrapper<TTaskByPerson>;
  TaskByRisk: ResolverTypeWrapper<TTaskByRisk>;
  TaskByRiskInput: TTaskByRiskInput;
  TaskInput: TTaskInput;
  TaskOnRiskInput: TTaskOnRiskInput;
  TaskUpdate: TTaskUpdate;
  Terms: ResolverTypeWrapper<TTerms>;
  ThumbnailUpload: TThumbnailUpload;
  TimePoint: ResolverTypeWrapper<TTimePoint>;
  TimePointInput: TTimePointInput;
  TimeUnitEnum: TTimeUnitEnum;
  TopIcdItem: ResolverTypeWrapper<TTopIcdItem>;
  TopIcdsChart: ResolverTypeWrapper<TTopIcdsChart>;
  TrafficAccidentType: TTrafficAccidentType;
  Training: ResolverTypeWrapper<TTraining>;
  TrainingByRisk: ResolverTypeWrapper<TTrainingByRisk>;
  TrainingByRiskInput: TTrainingByRiskInput;
  TrainingEligiblePerson: ResolverTypeWrapper<TTrainingEligiblePerson>;
  TrainingEligiblePersonsFilters: TTrainingEligiblePersonsFilters;
  TrainingEligiblePersonsResult: ResolverTypeWrapper<TTrainingEligiblePersonsResult>;
  TrainingEligibleStatus: TTrainingEligibleStatus;
  TrainingHistory: ResolverTypeWrapper<TTrainingHistory>;
  TrainingHistoryBatchInput: TTrainingHistoryBatchInput;
  TrainingHistoryBatchResult: ResolverTypeWrapper<TTrainingHistoryBatchResult>;
  TrainingHistoryByPerson: ResolverTypeWrapper<TTrainingHistoryByPerson>;
  TrainingHistoryInput: TTrainingHistoryInput;
  TrainingHistoryOnPersonInput: TTrainingHistoryOnPersonInput;
  TrainingHistoryOnPersonRemove: TTrainingHistoryOnPersonRemove;
  TrainingHistoryOnPersonUpdate: TTrainingHistoryOnPersonUpdate;
  TrainingHistoryUpdate: TTrainingHistoryUpdate;
  TrainingInput: TTrainingInput;
  TrainingIntegration: TTrainingIntegration;
  TrainingNecessityOrigin: TTrainingNecessityOrigin;
  TrainingOnRiskInput: TTrainingOnRiskInput;
  TrainingOnRiskUpdate: TTrainingOnRiskUpdate;
  TrainingUpdate: TTrainingUpdate;
  TrainingUrgency: TTrainingUrgency;
  TransferBlockedItem: ResolverTypeWrapper<TTransferBlockedItem>;
  TransferConsultationsInput: TTransferConsultationsInput;
  TransferConsultationsResult: ResolverTypeWrapper<TTransferConsultationsResult>;
  TtalkInboundEvent: ResolverTypeWrapper<TTtalkInboundEvent>;
  TtalkInboundEventFilterInput: TTtalkInboundEventFilterInput;
  TtalkInboundEventStatus: TTtalkInboundEventStatus;
  TtalkInboundSemanticInconsistency: ResolverTypeWrapper<TTtalkInboundSemanticInconsistency>;
  TtalkInboundSilenceMonitor: ResolverTypeWrapper<TTtalkInboundSilenceMonitor>;
  TtalkInboundSilenceThreshold: ResolverTypeWrapper<TTtalkInboundSilenceThreshold>;
  TtalkInboundSilenceThresholdInput: TTtalkInboundSilenceThresholdInput;
  TtalkQueueStatus: TTtalkQueueStatus;
  TypeChart: ResolverTypeWrapper<TTypeChart>;
  TypeCostCenterChart: ResolverTypeWrapper<TTypeCostCenterChart>;
  TypeIntellectualDeficiency: TTypeIntellectualDeficiency;
  TypeMessage: TTypeMessage;
  TypePhysicalDeficiency: TTypePhysicalDeficiency;
  TypeProcess: TTypeProcess;
  TypeVisualDeficiency: TTypeVisualDeficiency;
  UTMInput: TUtmInput;
  UnityOfMeasure: ResolverTypeWrapper<TUnityOfMeasure>;
  UnityOfMeasureInput: TUnityOfMeasureInput;
  UnityOfMeasureIntegration: TUnityOfMeasureIntegration;
  UnityOfMeasureUpdate: TUnityOfMeasureUpdate;
  UnscheduledConsultation: TUnscheduledConsultation;
  UnscheduledInput: TUnscheduledInput;
  UpdateCustomDocumentInput: TUpdateCustomDocumentInput;
  UpdateMetadataInput: TUpdateMetadataInput;
  Upload: ResolverTypeWrapper<Scalars['Upload']['output']>;
  Urinalysis: ResolverTypeWrapper<TUrinalysis>;
  UrinalysisInput: TUrinalysisInput;
  UrinalysisUpdate: TUrinalysisUpdate;
  UrobilinogenEnum: TUrobilinogenEnum;
  UseOfAuricularIpeEnum: TUseOfAuricularIpeEnum;
  User: ResolverTypeWrapper<TUser>;
  UserBasicInfo: ResolverTypeWrapper<TUserBasicInfo>;
  UserCreationInput: TUserCreationInput;
  UserFilterPreferenceResult: ResolverTypeWrapper<TUserFilterPreferenceResult>;
  UserFromCreation: ResolverTypeWrapper<TUserFromCreation>;
  UserGender: TUserGender;
  UserOrganizationListing: ResolverTypeWrapper<TUserOrganizationListing>;
  UserPreferences: ResolverTypeWrapper<TUserPreferences>;
  UserPreferencesInput: TUserPreferencesInput;
  UserRoleInput: TUserRoleInput;
  UserRoleMdt: ResolverTypeWrapper<TUserRoleMdt>;
  UserRoleUpdate: TUserRoleUpdate;
  UserRoutes: ResolverTypeWrapper<TUserRoutes>;
  UserSpecialty: ResolverTypeWrapper<TUserSpecialty>;
  UserSpecialtyInput: TUserSpecialtyInput;
  UserSpecialtyUpdate: TUserSpecialtyUpdate;
  UserUpdateInput: TUserUpdateInput;
  UtmData: ResolverTypeWrapper<TUtmData>;
  UtmDataInput: TUtmDataInput;
  Vaccine: ResolverTypeWrapper<TVaccine>;
  VaccineBiometry: ResolverTypeWrapper<TVaccineBiometry>;
  VaccineBiometryInput: TVaccineBiometryInput;
  VaccineChart: ResolverTypeWrapper<TVaccineChart>;
  VaccineCostCenterInput: TVaccineCostCenterInput;
  VaccineDoseEnum: TVaccineDoseEnum;
  VaccineGenderEnum: TVaccineGenderEnum;
  VaccineInput: TVaccineInput;
  VaccineOccupationInput: TVaccineOccupationInput;
  VaccinePlanningParameters: ResolverTypeWrapper<TVaccinePlanningParameters>;
  VaccinePrint: ResolverTypeWrapper<TVaccinePrint>;
  VaccineQuantityChart: ResolverTypeWrapper<TVaccineQuantityChart>;
  VaccineReinforcementEnum: TVaccineReinforcementEnum;
  VaccineUpdate: TVaccineUpdate;
  ValidationError: ResolverTypeWrapper<TValidationError>;
  ValidationReturn: ResolverTypeWrapper<TValidationReturn>;
  Validations: TValidations;
  VerbMessage: TVerbMessage;
  VisualDeficiencySpecification: TVisualDeficiencySpecification;
  VisualFieldEnum: TVisualFieldEnum;
  VolumeChart: ResolverTypeWrapper<TVolumeChart>;
  VotationProgress: ResolverTypeWrapper<TVotationProgress>;
  Vote: ResolverTypeWrapper<TVote>;
  VoteInput: TVoteInput;
  VoteStatus: ResolverTypeWrapper<TVoteStatus>;
  Warehouse: ResolverTypeWrapper<TWarehouse>;
  WarehouseInput: TWarehouseInput;
  WarehouseIntegration: TWarehouseIntegration;
  WarehouseUpdate: TWarehouseUpdate;
  WarningByPerson: ResolverTypeWrapper<TWarningByPerson>;
  WarningReason: TWarningReason;
  WarningType: TWarningType;
  WebHookCreateInput: TWebHookCreateInput;
  WebHookUpdateInput: TWebHookUpdateInput;
  Webhook: ResolverTypeWrapper<TWebhook>;
  WebhookEvent: TWebhookEvent;
  WebhookQueue: ResolverTypeWrapper<TWebhookQueue>;
  WebhookQueueBatchInput: TWebhookQueueBatchInput;
  WebhookQueueCreateInput: TWebhookQueueCreateInput;
  WebhookQueueUpdateInput: TWebhookQueueUpdateInput;
  WebhookStatus: TWebhookStatus;
  WebhookType: TWebhookType;
  WitnessOnAccident: ResolverTypeWrapper<TWitnessOnAccident>;
  WitnessOnAccidentInput: TWitnessOnAccidentInput;
  WitnessOnAccidentUpdate: TWitnessOnAccidentUpdate;
  WorkHour: ResolverTypeWrapper<TWorkHour>;
  WorkHours: ResolverTypeWrapper<TWorkHours>;
  WorkPermission: ResolverTypeWrapper<TWorkPermission>;
  WorkPermissionDashboard: ResolverTypeWrapper<TWorkPermissionDashboard>;
  WorkPermissionInput: TWorkPermissionInput;
  WorkPermissionParetoChart: ResolverTypeWrapper<TWorkPermissionParetoChart>;
  WorkPermissionParetoEntry: ResolverTypeWrapper<TWorkPermissionParetoEntry>;
  WorkPermissionPerson: ResolverTypeWrapper<TWorkPermissionPerson>;
  WorkPermissionPersonInput: TWorkPermissionPersonInput;
  WorkPermissionQuiz: ResolverTypeWrapper<TWorkPermissionQuiz>;
  WorkPermissionQuizInput: TWorkPermissionQuizInput;
  WorkPermissionQuizUpdate: TWorkPermissionQuizUpdate;
  WorkPermissionType: TWorkPermissionType;
  WorkPermissionUpdate: TWorkPermissionUpdate;
  WorkShift: ResolverTypeWrapper<TWorkShift>;
  WorkShiftInput: TWorkShiftInput;
  WorkShiftIntegration: TWorkShiftIntegration;
  WorkShiftUpdate: TWorkShiftUpdate;
  YearlyVariationChart: ResolverTypeWrapper<TYearlyVariationChart>;
  _Invite: ResolverTypeWrapper<T_Invite>;
  _InviteInput: T_InviteInput;
  _PasswordRecovery: ResolverTypeWrapper<T_PasswordRecovery>;
  _Terms: ResolverTypeWrapper<T_Terms>;
  _UserCreationInput: T_UserCreationInput;
  eSocialParams: TESocialParams;
  isAccreditedResult: ResolverTypeWrapper<TIsAccreditedResult>;
}>;

/** Mapping between all available schema types and the resolvers parents */
export type TResolversParentTypes = ResolversObject<{
  AbnormalityAnalysis: TAbnormalityAnalysis;
  AbsenceType: TAbsenceType;
  AbsenceTypeInput: TAbsenceTypeInput;
  AbsenceTypeIntegration: TAbsenceTypeIntegration;
  AbsenceTypeUpdate: TAbsenceTypeUpdate;
  AccessToken: TAccessToken;
  AccessTokenInput: TAccessTokenInput;
  Accident: TAccident;
  AccidentAbsence: TAccidentAbsence;
  AccidentAmount: TAccidentAmount;
  AccidentAnalysis: TAccidentAnalysis;
  AccidentBodyPart: TAccidentBodyPart;
  AccidentBodyPartInput: TAccidentBodyPartInput;
  AccidentBodyPartInputBranch: TAccidentBodyPartInputBranch;
  AccidentCause: TAccidentCause;
  AccidentCauseInput: TAccidentCauseInput;
  AccidentCauseUpdate: TAccidentCauseUpdate;
  AccidentCauses: TAccidentCauses;
  AccidentCharts: TAccidentCharts;
  AccidentCode: TAccidentCode;
  AccidentDashboard: TAccidentDashboard;
  AccidentDescription: TAccidentDescription;
  AccidentExpenseAmount: TAccidentExpenseAmount;
  AccidentExpenseInput: TAccidentExpenseInput;
  AccidentExpenseUpdate: TAccidentExpenseUpdate;
  AccidentFilter: TAccidentFilter;
  AccidentInput: TAccidentInput;
  AccidentObject: TAccidentObject;
  AccidentOrderByInput: TAccidentOrderByInput;
  AccidentQueryInput: TAccidentQueryInput;
  AccidentType: TAccidentType;
  AccidentUpdate: TAccidentUpdate;
  AccidentVictim: TAccidentVictim;
  AccidentWithInvestigation: TAccidentWithInvestigation;
  AccidentWitness: TAccidentWitness;
  AccidentWitnessInput: TAccidentWitnessInput;
  AccidentsPerDayChart: TAccidentsPerDayChart;
  AccidentsPerMonthChart: TAccidentsPerMonthChart;
  AccidentsTimeChart: TAccidentsTimeChart;
  Accredited: TAccredited;
  AccreditedBilling: TAccreditedBilling;
  AccreditedConsultation: TAccreditedConsultation;
  AccreditedExam: TAccreditedExam;
  AccreditedExamInput: TAccreditedExamInput;
  AccreditedInput: TAccreditedInput;
  AccreditedReportsParameters: TAccreditedReportsParameters;
  AccreditedUpdate: TAccreditedUpdate;
  AcknowledgmentFormReport: TAcknowledgmentFormReport;
  ActionOnMeeting: TActionOnMeeting;
  ActionOnMeetingInput: TActionOnMeetingInput;
  ActionOnMeetingRemove: TActionOnMeetingRemove;
  ActionOnMeetingUpdate: TActionOnMeetingUpdate;
  ActionPlan: TActionPlan;
  ActionPlanConclusionChart: TActionPlanConclusionChart;
  ActionPlanConclusionEntry: TActionPlanConclusionEntry;
  ActionPlanCount: TActionPlanCount;
  ActionPlanDashboard: TActionPlanDashboard;
  ActionPlanExpectedGoalInput: TActionPlanExpectedGoalInput;
  ActionPlanExpectedGoalUpdate: TActionPlanExpectedGoalUpdate;
  ActionPlanFilter: TActionPlanFilter;
  ActionPlanInput: TActionPlanInput;
  ActionPlanInvestigation: TActionPlanInvestigation;
  ActionPlanInvestigationInput: TActionPlanInvestigationInput;
  ActionPlanInvestigationSuggestion: TActionPlanInvestigationSuggestion;
  ActionPlanInvestigationUpdate: TActionPlanInvestigationUpdate;
  ActionPlanMeasurementEntry: TActionPlanMeasurementEntry;
  ActionPlanMeasurementsChart: TActionPlanMeasurementsChart;
  ActionPlanMicroAction: TActionPlanMicroAction;
  ActionPlanMicroActionInput: TActionPlanMicroActionInput;
  ActionPlanMicroActionUpdate: TActionPlanMicroActionUpdate;
  ActionPlanOrderByInput: TActionPlanOrderByInput;
  ActionPlanParetoChart: TActionPlanParetoChart;
  ActionPlanParetoEntry: TActionPlanParetoEntry;
  ActionPlanPriorityChart: TActionPlanPriorityChart;
  ActionPlanPriorityEntry: TActionPlanPriorityEntry;
  ActionPlanQueryInput: TActionPlanQueryInput;
  ActionPlanRealGoalInput: TActionPlanRealGoalInput;
  ActionPlanRealGoalUpdate: TActionPlanRealGoalUpdate;
  ActionPlanReport: TActionPlanReport;
  ActionPlanReportInput: TActionPlanReportInput;
  ActionPlanReportSuggestion: TActionPlanReportSuggestion;
  ActionPlanReportUpdate: TActionPlanReportUpdate;
  ActionPlanResponsibleInput: TActionPlanResponsibleInput;
  ActionPlanResponsibleUpdate: TActionPlanResponsibleUpdate;
  ActionPlanSchedule: TActionPlanSchedule;
  ActionPlanStatusChart: TActionPlanStatusChart;
  ActionPlanStatusEntry: TActionPlanStatusEntry;
  ActionPlanUpdate: TActionPlanUpdate;
  ActivityGroup: TActivityGroup;
  ActivityIcd: TActivityIcd;
  AdditionalData: TAdditionalData;
  AdditionalDataInput: TAdditionalDataInput;
  AgeAccidentChart: TAgeAccidentChart;
  AgeChart: TAgeChart;
  AgeRange: TAgeRange;
  AgeRangeEntry: TAgeRangeEntry;
  AgeRangeInput: TAgeRangeInput;
  AgentBonusChart: TAgentBonusChart;
  AgentGroupChart: TAgentGroupChart;
  Agreement: TAgreement;
  AllowanceType: TAllowanceType;
  AllowanceTypeInput: TAllowanceTypeInput;
  AllowanceTypeIntegration: TAllowanceTypeIntegration;
  AllowanceTypeUpdate: TAllowanceTypeUpdate;
  Analysis: TAnalysis;
  AnalysisInput: TAnalysisInput;
  AnalysisUpdate: TAnalysisUpdate;
  AnnualDeliveryVariationChart: TAnnualDeliveryVariationChart;
  ApiAccess: TApiAccess;
  AsaasCreditCardToken: TAsaasCreditCardToken;
  AsaasCreditCardTokenInput: TAsaasCreditCardTokenInput;
  AsoEvolutionEntry: TAsoEvolutionEntry;
  AsoNatureChart: TAsoNatureChart;
  AsoQuantityChart: TAsoQuantityChart;
  AsoSituationChart: TAsoSituationChart;
  Attachment: TAttachment;
  AttachmentAndThumbnailUpload: TAttachmentAndThumbnailUpload;
  AttachmentDTO: TAttachmentDto;
  AudiometryClassificationChart: TAudiometryClassificationChart;
  AudiometryCostCenterChart: TAudiometryCostCenterChart;
  AudiometryDashboard: TAudiometryDashboard;
  AudiometryEvolutionChart: TAudiometryEvolutionChart;
  AudiometryPcaChart: TAudiometryPcaChart;
  AudiometryYearComparisonChart: TAudiometryYearComparisonChart;
  AuditLogChange: TAuditLogChange;
  AuditLogDetailsDto: TAuditLogDetailsDto;
  AuditLogEntry: TAuditLogEntry;
  AuditLogExportRequest: TAuditLogExportRequest;
  AuditLogQueryInput: TAuditLogQueryInput;
  AvailabilityChart: TAvailabilityChart;
  BaseAttachmentArgs: TBaseAttachmentArgs;
  BaseAttachmentToUploadArgs: TBaseAttachmentToUploadArgs;
  BaseDocumentResponse: TBaseDocumentResponse;
  BaseFeatureReturn: TBaseFeatureReturn;
  BaseFlagReturn: TBaseFlagReturn;
  BaseInput: TBaseInput;
  BiologicMonitoring: TBiologicMonitoring;
  BiologicalExams: TBiologicalExams;
  BiologicalMonitoring: TBiologicalMonitoring;
  BiologicalMonitoringCommon: TBiologicalMonitoringCommon;
  BiologicalMonitoringExam: TBiologicalMonitoringExam;
  BiologicalMonitoringExamGroup: TBiologicalMonitoringExamGroup;
  BiologicalMonitoringExamGroupInput: TBiologicalMonitoringExamGroupInput;
  BiologicalMonitoringExamGroupUpdate: TBiologicalMonitoringExamGroupUpdate;
  BiologicalMonitoringExamInput: TBiologicalMonitoringExamInput;
  BiologicalMonitoringInput: TBiologicalMonitoringInput;
  BiologicalMonitoringProtocol: TBiologicalMonitoringProtocol;
  BiologicalMonitoringProtocolExams: TBiologicalMonitoringProtocolExams;
  BiologicalMonitoringProtocolParams: TBiologicalMonitoringProtocolParams;
  BiologicalMonitoringReport: TBiologicalMonitoringReport;
  BiologicalMonitoringUpdate: TBiologicalMonitoringUpdate;
  BiologicalProtocol: TBiologicalProtocol;
  BiologicalRelease: TBiologicalRelease;
  Biometry: TBiometry;
  BiometryInput: TBiometryInput;
  BiometryUpdate: TBiometryUpdate;
  BloodTypeChart: TBloodTypeChart;
  BodyPart: TBodyPart;
  BodyPartOnAccident: TBodyPartOnAccident;
  BodyPartOnAccidentInput: TBodyPartOnAccidentInput;
  Boolean: Scalars['Boolean']['output'];
  Branch: TBranch;
  BranchCreationInput: TBranchCreationInput;
  BranchInput: TBranchInput;
  BranchTtalkInfo: TBranchTtalkInfo;
  BranchUpdateInput: TBranchUpdateInput;
  BranchWithOptionalOrganization: TBranchWithOptionalOrganization;
  BranchWithOrganization: TBranchWithOrganization;
  BulkSyncRun: TBulkSyncRun;
  CaInUseChart: TCaInUseChart;
  Calendar: TCalendar;
  CalendarInput: TCalendarInput;
  CalendarUpdate: TCalendarUpdate;
  CalendarWorkShift: TCalendarWorkShift;
  CalendarWorkShiftEntry: TCalendarWorkShiftEntry;
  CalendarWorkShiftInput: TCalendarWorkShiftInput;
  Candidate: TCandidate;
  CandidateByMandate: TCandidateByMandate;
  CandidateInput: TCandidateInput;
  CandidateUpdate: TCandidateUpdate;
  CategoriesChart: TCategoriesChart;
  CategorizedInputData: TCategorizedInputData;
  CauserAgent: TCauserAgent;
  CauserAgentInput: TCauserAgentInput;
  CauserAgentOnAccident: TCauserAgentOnAccident;
  CauserAgentOnAccidentInput: TCauserAgentOnAccidentInput;
  CauserAgentOnAccidentUpdate: TCauserAgentOnAccidentUpdate;
  Causes: TCauses;
  CertificatePerDayChart: TCertificatePerDayChart;
  CertificatesRankingDashboard: TCertificatesRankingDashboard;
  ChangeStatusPreMedicalCertificateInput: TChangeStatusPreMedicalCertificateInput;
  ChartData: TChartData;
  CheckTableData: TCheckTableData;
  Checklist: TChecklist;
  ChecklistInput: TChecklistInput;
  ChemicalRisk: TChemicalRisk;
  ClassificationPure: TClassificationPure;
  ClinicalQuiz: TClinicalQuiz;
  ClinicalQuizInput: TClinicalQuizInput;
  ClinicalQuizUpdate: TClinicalQuizUpdate;
  CollisionReturn: TCollisionReturn;
  ComparativeResultsDashboard: TComparativeResultsDashboard;
  ComplementaryExam: TComplementaryExam;
  ComplementaryExamInput: TComplementaryExamInput;
  ComplementaryExams: TComplementaryExams;
  ComplementaryIcd: TComplementaryIcd;
  ComplementaryIcdInput: TComplementaryIcdInput;
  ComplementaryIcdOnAccident: TComplementaryIcdOnAccident;
  ComplementaryIcdOnAccidentInput: TComplementaryIcdOnAccidentInput;
  ComplementaryIcdOnAccidentUpdate: TComplementaryIcdOnAccidentUpdate;
  ComplementaryIcdOnDiagnostic: TComplementaryIcdOnDiagnostic;
  ComplementaryIcdOnDiagnosticInput: TComplementaryIcdOnDiagnosticInput;
  ComplementaryIcdOnDiagnosticUpdate: TComplementaryIcdOnDiagnosticUpdate;
  Component: TComponent;
  ComponentActiveStatusEntry: TComponentActiveStatusEntry;
  ComponentInput: TComponentInput;
  ComponentUpdate: TComponentUpdate;
  ConfirmImport: TConfirmImport;
  ConsultReport: TConsultReport;
  Consultation: TConsultation;
  ConsultationBiologicalMonitoring: TConsultationBiologicalMonitoring;
  ConsultationByBranchToPrint: TConsultationByBranchToPrint;
  ConsultationByDoctorToPrint: TConsultationByDoctorToPrint;
  ConsultationExamsResult: TConsultationExamsResult;
  ConsultationInput: TConsultationInput;
  ConsultationMinimal: TConsultationMinimal;
  ConsultationReason: TConsultationReason;
  ConsultationUpdate: TConsultationUpdate;
  ContactRequest: TContactRequest;
  ContactRequestInput: TContactRequestInput;
  ControlMeasure: TControlMeasure;
  ControlMeasureByRisk: TControlMeasureByRisk;
  ControlMeasureByRiskInput: TControlMeasureByRiskInput;
  ControlMeasureFrame: TControlMeasureFrame;
  ControlMeasureInput: TControlMeasureInput;
  ControlMeasureOnRiskInput: TControlMeasureOnRiskInput;
  ControlMeasureOnRiskUpdate: TControlMeasureOnRiskUpdate;
  ControlMeasureUpdate: TControlMeasureUpdate;
  ControlMeasuresChart: TControlMeasuresChart;
  CostCenter: TCostCenter;
  CostCenterByRisk: TCostCenterByRisk;
  CostCenterByRiskInput: TCostCenterByRiskInput;
  CostCenterEntry: TCostCenterEntry;
  CostCenterGroup: TCostCenterGroup;
  CostCenterInput: TCostCenterInput;
  CostCenterIntegration: TCostCenterIntegration;
  CostCenterOccupationChart: TCostCenterOccupationChart;
  CostCenterOccupationDeficienciesChart: TCostCenterOccupationDeficienciesChart;
  CostCenterOnMandate: TCostCenterOnMandate;
  CostCenterOnMandateInput: TCostCenterOnMandateInput;
  CostCenterOnRiskInput: TCostCenterOnRiskInput;
  CostCenterOnVaccine: TCostCenterOnVaccine;
  CostCenterOnVaccineInput: TCostCenterOnVaccineInput;
  CostCenterStock: TCostCenterStock;
  CostCenterUpdate: TCostCenterUpdate;
  CostCenterVolumeChart: TCostCenterVolumeChart;
  CostPerTypeChart: TCostPerTypeChart;
  CreateMetadataInput: TCreateMetadataInput;
  CreditCard: TCreditCard;
  CronTab: TCronTab;
  CronTabInput: TCronTabInput;
  CrontabExecution: TCrontabExecution;
  CrontabExecutionDetail: TCrontabExecutionDetail;
  CustomDocument: TCustomDocument;
  CustomOrganization: TCustomOrganization;
  CustomOrganizationInput: TCustomOrganizationInput;
  Customer: TCustomer;
  CustomerInput: TCustomerInput;
  DashboardExport: TDashboardExport;
  Data: TData;
  DataCharts: TDataCharts;
  DataLogin: TDataLogin;
  DateRange: TDateRange;
  DateTime: Scalars['DateTime']['output'];
  DaysAbsentChart: TDaysAbsentChart;
  DaysLostWithIcdChart: TDaysLostWithIcdChart;
  DaysLostWithoutIcdChart: TDaysLostWithoutIcdChart;
  DaysWithoutAccidentChart: TDaysWithoutAccidentChart;
  DefaultRecipientUserDto: TDefaultRecipientUserDto;
  DeficienciesChart: TDeficienciesChart;
  Deficiency: TDeficiency;
  DeficiencyInput: TDeficiencyInput;
  DeficiencyUpdate: TDeficiencyUpdate;
  DeliveredIpesParams: TDeliveredIpesParams;
  DeliveredIpesReport: TDeliveredIpesReport;
  DeliveredProductsParams: TDeliveredProductsParams;
  DeliveredSparePartsParams: TDeliveredSparePartsParams;
  DeliverySpareParts: TDeliverySpareParts;
  DeliverySparePartsInput: TDeliverySparePartsInput;
  DeliverySparePartsParams: TDeliverySparePartsParams;
  DeliverySparePartsReport: TDeliverySparePartsReport;
  DeliverySparePartsUpdate: TDeliverySparePartsUpdate;
  Department: TDepartment;
  DepartmentByRisk: TDepartmentByRisk;
  DepartmentByRiskInput: TDepartmentByRiskInput;
  DepartmentInput: TDepartmentInput;
  DepartmentIntegration: TDepartmentIntegration;
  DepartmentOnMandate: TDepartmentOnMandate;
  DepartmentOnMandateInput: TDepartmentOnMandateInput;
  DepartmentOnRiskInput: TDepartmentOnRiskInput;
  DepartmentUpdate: TDepartmentUpdate;
  Dependent: TDependent;
  DependentByPerson: TDependentByPerson;
  DependentInput: TDependentInput;
  DependentOnPersonInput: TDependentOnPersonInput;
  DependentOnPersonRemove: TDependentOnPersonRemove;
  DependentOnPersonUpdate: TDependentOnPersonUpdate;
  DependentUpdate: TDependentUpdate;
  Diagnostic: TDiagnostic;
  DiagnosticComplementaryIcd: TDiagnosticComplementaryIcd;
  DiagnosticComplementaryIcdInput: TDiagnosticComplementaryIcdInput;
  DiagnosticInput: TDiagnosticInput;
  DiagnosticMedicine: TDiagnosticMedicine;
  DiagnosticMedicineInput: TDiagnosticMedicineInput;
  DiagnosticOptional: TDiagnosticOptional;
  DiagnosticUpdate: TDiagnosticUpdate;
  Dimension: TDimension;
  DivergingStackedBarChart: TDivergingStackedBarChart;
  Doctor: TDoctor;
  DoctorRqeEntry: TDoctorRqeEntry;
  DoctorRqeEntryInput: TDoctorRqeEntryInput;
  DocumentFromEntityResponse: TDocumentFromEntityResponse;
  DocumentObserver: TDocumentObserver;
  DocumentPending: TDocumentPending;
  DocumentPendingSigner: TDocumentPendingSigner;
  DocumentPermissions: TDocumentPermissions;
  DocumentSigner: TDocumentSigner;
  DocumentSignerDB: TDocumentSignerDb;
  DocumentUser: TDocumentUser;
  DownloadSignedDocumentInput: TDownloadSignedDocumentInput;
  ESocialDeliveriesParameters: TESocialDeliveriesParameters;
  ESocialDeliveriesPeriod: TESocialDeliveriesPeriod;
  ESocialFirstLoadInput: TESocialFirstLoadInput;
  ESocialQueue: TESocialQueue;
  ESocialQueueAll: TESocialQueueAll;
  ESocialQueueError: TESocialQueueError;
  ESocialQueueErrorInput: TESocialQueueErrorInput;
  ESocialQueueFilter: TESocialQueueFilter;
  ESocialQueueHistory: TESocialQueueHistory;
  ESocialQueueIndicators: TESocialQueueIndicators;
  ESocialQueueInput: TESocialQueueInput;
  ESocialQueueUpdate: TESocialQueueUpdate;
  ESocialResendMessages: TESocialResendMessages;
  EarPart: TEarPart;
  EarPartInput: TEarPartInput;
  EarPartUpdate: TEarPartUpdate;
  EconomicActivity: TEconomicActivity;
  EffectiveDocumentTemplate: TEffectiveDocumentTemplate;
  EfficiencyChart: TEfficiencyChart;
  ElaboratorDocument: TElaboratorDocument;
  ElectionComission: TElectionComission;
  ElectionComissionInput: TElectionComissionInput;
  ElectionComissionInputByMandate: TElectionComissionInputByMandate;
  Email: TEmail;
  EmailHasInvite: TEmailHasInvite;
  EmailInput: TEmailInput;
  Employee: TEmployee;
  EmployeeAgentGroupChart: TEmployeeAgentGroupChart;
  EmployeeAnamnesis: TEmployeeAnamnesis;
  EmployeeAnswerClinicalQuizInput: TEmployeeAnswerClinicalQuizInput;
  EmployeeAnswerSafetyQuizInput: TEmployeeAnswerSafetyQuizInput;
  EmployeeByEventTypeInput: TEmployeeByEventTypeInput;
  EmployeeByMandateIdInput: TEmployeeByMandateIdInput;
  EmployeeByOccupation: TEmployeeByOccupation;
  EmployeeCandidate: TEmployeeCandidate;
  EmployeeConsultation: TEmployeeConsultation;
  EmployeeControlMeasure: TEmployeeControlMeasure;
  EmployeeExam: TEmployeeExam;
  EmployeeFavoriteOption: TEmployeeFavoriteOption;
  EmployeeFavoriteOptionInput: TEmployeeFavoriteOptionInput;
  EmployeeIpeDelivery: TEmployeeIpeDelivery;
  EmployeeIpes: TEmployeeIpes;
  EmployeeMandateEvent: TEmployeeMandateEvent;
  EmployeeNicknameInput: TEmployeeNicknameInput;
  EmployeePerson: TEmployeePerson;
  EmployeePreferences: TEmployeePreferences;
  EmployeePreferencesInput: TEmployeePreferencesInput;
  EmployeeQuiz: TEmployeeQuiz;
  EmployeeRisk: TEmployeeRisk;
  EmployeeRiskDashboard: TEmployeeRiskDashboard;
  EmployeeRiskIpe: TEmployeeRiskIpe;
  EmployeeTask: TEmployeeTask;
  EmployeeTaskInput: TEmployeeTaskInput;
  EmployeeTaskOnPerson: TEmployeeTaskOnPerson;
  EmployeeTaskOnPersonInput: TEmployeeTaskOnPersonInput;
  EmployeeTaskOnPersonRemove: TEmployeeTaskOnPersonRemove;
  EmployeeTaskOnPersonUpdate: TEmployeeTaskOnPersonUpdate;
  EmployeeTaskUpdate: TEmployeeTaskUpdate;
  EmployeeVolumeChart: TEmployeeVolumeChart;
  EmployeeVoteInput: TEmployeeVoteInput;
  EmployeeVotes: TEmployeeVotes;
  EmployeeWarningOnPersonInput: TEmployeeWarningOnPersonInput;
  EmployeeWarningReport: TEmployeeWarningReport;
  Endpoint: TEndpoint;
  EndpointInput: TEndpointInput;
  EnvironmentalReport: TEnvironmentalReport;
  EnvironmentalReportAttachment: TEnvironmentalReportAttachment;
  EnvironmentalReportAttachmentInput: TEnvironmentalReportAttachmentInput;
  EnvironmentalReportBiometry: TEnvironmentalReportBiometry;
  EnvironmentalReportBiometryInput: TEnvironmentalReportBiometryInput;
  EnvironmentalReportCostCenter: TEnvironmentalReportCostCenter;
  EnvironmentalReportCostCenterInput: TEnvironmentalReportCostCenterInput;
  EnvironmentalReportDocumentResponse: TEnvironmentalReportDocumentResponse;
  EnvironmentalReportFace: TEnvironmentalReportFace;
  EnvironmentalReportFaceInput: TEnvironmentalReportFaceInput;
  EnvironmentalReportFilter: TEnvironmentalReportFilter;
  EnvironmentalReportInput: TEnvironmentalReportInput;
  EnvironmentalReportOrderByInput: TEnvironmentalReportOrderByInput;
  EnvironmentalReportParams: TEnvironmentalReportParams;
  EnvironmentalReportQueryInput: TEnvironmentalReportQueryInput;
  EnvironmentalReportSuggestion: TEnvironmentalReportSuggestion;
  EnvironmentalReportUpdate: TEnvironmentalReportUpdate;
  EnvironmentalReportVersion: TEnvironmentalReportVersion;
  EpcByAgentGroupItem: TEpcByAgentGroupItem;
  EpcIncidenceChart: TEpcIncidenceChart;
  EpiLifespanChart: TEpiLifespanChart;
  EpiLifespanItem: TEpiLifespanItem;
  EquipmentByCostCenter: TEquipmentByCostCenter;
  EquipmentByCostCenterInput: TEquipmentByCostCenterInput;
  EquipmentByOccupation: TEquipmentByOccupation;
  EquipmentByOccupationInput: TEquipmentByOccupationInput;
  EquipmentOnCostCenterInput: TEquipmentOnCostCenterInput;
  EquipmentOnCostCenterUpdate: TEquipmentOnCostCenterUpdate;
  EquipmentOnOccupationInput: TEquipmentOnOccupationInput;
  EquipmentOnOccupationUpdate: TEquipmentOnOccupationUpdate;
  ErrorResponse: TErrorResponse;
  Event: TEvent;
  EventOnSipatInput: TEventOnSipatInput;
  EventOnSipatRemove: TEventOnSipatRemove;
  EventOnSipatUpdate: TEventOnSipatUpdate;
  Exam: TExam;
  ExamAlterationTrend: TExamAlterationTrend;
  ExamAnalysis: TExamAnalysis;
  ExamAudiometry: TExamAudiometry;
  ExamAudiometryInput: TExamAudiometryInput;
  ExamAudiometryUpdate: TExamAudiometryUpdate;
  ExamByBranchToPrint: TExamByBranchToPrint;
  ExamByHealthProgram: TExamByHealthProgram;
  ExamByHealthProgramChanges: TExamByHealthProgramChanges;
  ExamByHealthProgramInput: TExamByHealthProgramInput;
  ExamByHealthProgramUpdate: TExamByHealthProgramUpdate;
  ExamByOccupation: TExamByOccupation;
  ExamByOccupationChanges: TExamByOccupationChanges;
  ExamByOccupationInput: TExamByOccupationInput;
  ExamByOccupationUpdate: TExamByOccupationUpdate;
  ExamByPerson: TExamByPerson;
  ExamByRisk: TExamByRisk;
  ExamByRiskChanges: TExamByRiskChanges;
  ExamByRiskInput: TExamByRiskInput;
  ExamByRiskUpdate: TExamByRiskUpdate;
  ExamByTag: TExamByTag;
  ExamDiagnosticCount: TExamDiagnosticCount;
  ExamDiagnosticImage: TExamDiagnosticImage;
  ExamDiagnosticImageInput: TExamDiagnosticImageInput;
  ExamDiagnosticImageUpdate: TExamDiagnosticImageUpdate;
  ExamIbmp: TExamIbmp;
  ExamIbmpInput: TExamIbmpInput;
  ExamIbmpUpdate: TExamIbmpUpdate;
  ExamInput: TExamInput;
  ExamItem: TExamItem;
  ExamItemInput: TExamItemInput;
  ExamItemUpdate: TExamItemUpdate;
  ExamItemValue: TExamItemValue;
  ExamItemValueInput: TExamItemValueInput;
  ExamItemValueUpdate: TExamItemValueUpdate;
  ExamItemsCount: TExamItemsCount;
  ExamNormal: TExamNormal;
  ExamNormalInput: TExamNormalInput;
  ExamNormalResult: TExamNormalResult;
  ExamNormalUpdate: TExamNormalUpdate;
  ExamOnConsultation: TExamOnConsultation;
  ExamOnConsultationInput: TExamOnConsultationInput;
  ExamOnConsultationUpdate: TExamOnConsultationUpdate;
  ExamOtological: TExamOtological;
  ExamOtologicalInput: TExamOtologicalInput;
  ExamOtologicalUpdate: TExamOtologicalUpdate;
  ExamPerson: TExamPerson;
  ExamProvider: TExamProvider;
  ExamReferralReport: TExamReferralReport;
  ExamReport: TExamReport;
  ExamResultsByMedicalRecord: TExamResultsByMedicalRecord;
  ExamScheduling: TExamScheduling;
  ExamSpirometry: TExamSpirometry;
  ExamSpirometryInput: TExamSpirometryInput;
  ExamSpirometryUpdate: TExamSpirometryUpdate;
  ExamTimelineEntry: TExamTimelineEntry;
  ExamToxicological: TExamToxicological;
  ExamToxicologicalInput: TExamToxicologicalInput;
  ExamToxicologicalUpdate: TExamToxicologicalUpdate;
  ExamUpdate: TExamUpdate;
  Exams: TExams;
  ExamsDoneChart: TExamsDoneChart;
  ExamsResultQuery: TExamsResultQuery;
  ExamsToDelete: TExamsToDelete;
  ExpectedConsultation: TExpectedConsultation;
  ExpectedExam: TExpectedExam;
  ExpectedExamFromQuery: TExpectedExamFromQuery;
  ExpectedGoal: TExpectedGoal;
  ExpectedGoalInput: TExpectedGoalInput;
  ExpectedGoalOnActionPlan: TExpectedGoalOnActionPlan;
  Expense: TExpense;
  ExpenseInput: TExpenseInput;
  ExpenseOnAccident: TExpenseOnAccident;
  ExpenseOnAccidentInput: TExpenseOnAccidentInput;
  ExpenseOnAccidentRemove: TExpenseOnAccidentRemove;
  ExpenseOnAccidentUpdate: TExpenseOnAccidentUpdate;
  ExpenseUpdate: TExpenseUpdate;
  ExpensiveAccidentsChart: TExpensiveAccidentsChart;
  ExportClinicalQuiz: TExportClinicalQuiz;
  ExportStatus: TExportStatus;
  ExposureGroup: TExposureGroup;
  ExposureGroupCopyInput: TExposureGroupCopyInput;
  ExposureGroupCostCenter: TExposureGroupCostCenter;
  ExposureGroupCostCenterInput: TExposureGroupCostCenterInput;
  ExposureGroupCostCenterUpdate: TExposureGroupCostCenterUpdate;
  ExposureGroupDepartment: TExposureGroupDepartment;
  ExposureGroupDepartmentInput: TExposureGroupDepartmentInput;
  ExposureGroupDepartmentUpdate: TExposureGroupDepartmentUpdate;
  ExposureGroupInput: TExposureGroupInput;
  ExposureGroupOccupation: TExposureGroupOccupation;
  ExposureGroupOccupationInput: TExposureGroupOccupationInput;
  ExposureGroupOccupationUpdate: TExposureGroupOccupationUpdate;
  ExposureGroupPerson: TExposureGroupPerson;
  ExposureGroupPersonInput: TExposureGroupPersonInput;
  ExposureGroupPersonUpdate: TExposureGroupPersonUpdate;
  ExposureGroupTask: TExposureGroupTask;
  ExposureGroupTaskInput: TExposureGroupTaskInput;
  ExposureGroupTaskUpdate: TExposureGroupTaskUpdate;
  ExposureGroupUpdate: TExposureGroupUpdate;
  ExternalDeliveryChart: TExternalDeliveryChart;
  ExternalDoctor: TExternalDoctor;
  ExternalFields: TExternalFields;
  ExternalOccupationalHealthCertificate: TExternalOccupationalHealthCertificate;
  ExternalOccupationalHealthCertificateInput: TExternalOccupationalHealthCertificateInput;
  ExternalOccupationalHealthCertificateResponse: TExternalOccupationalHealthCertificateResponse;
  ExternalOccupationalHealthCertificateUpdate: TExternalOccupationalHealthCertificateUpdate;
  ExtinguishingDonutChart: TExtinguishingDonutChart;
  ExtinguishingDonutEntry: TExtinguishingDonutEntry;
  ExtinguishingInspectionChart: TExtinguishingInspectionChart;
  ExtinguishingInspectionEntry: TExtinguishingInspectionEntry;
  ExtinguishingParetoChart: TExtinguishingParetoChart;
  ExtinguishingParetoEntry: TExtinguishingParetoEntry;
  ExtinguishingSystem: TExtinguishingSystem;
  ExtinguishingSystemDashboard: TExtinguishingSystemDashboard;
  ExtinguishingSystemFilter: TExtinguishingSystemFilter;
  ExtinguishingSystemInput: TExtinguishingSystemInput;
  ExtinguishingSystemInspection: TExtinguishingSystemInspection;
  ExtinguishingSystemInspectionInput: TExtinguishingSystemInspectionInput;
  ExtinguishingSystemOrderByInput: TExtinguishingSystemOrderByInput;
  ExtinguishingSystemQueryInput: TExtinguishingSystemQueryInput;
  ExtinguishingSystemRaw: TExtinguishingSystemRaw;
  ExtinguishingSystemUpdate: TExtinguishingSystemUpdate;
  FaceValidations: TFaceValidations;
  FavoriteOption: TFavoriteOption;
  FavoriteOptionInput: TFavoriteOptionInput;
  FeatureObject: TFeatureObject;
  FeatureObjectInput: TFeatureObjectInput;
  FeaturePermission: TFeaturePermission;
  FeatureReturn: TFeatureReturn;
  FeatureVersionReturn: TFeatureVersionReturn;
  FieldsInput: TFieldsInput;
  FilterPerson: TFilterPerson;
  FindEndpointsInput: TFindEndpointsInput;
  FireBrigade: TFireBrigade;
  FireBrigadeBloodTypeChart: TFireBrigadeBloodTypeChart;
  FireBrigadeComponent: TFireBrigadeComponent;
  FireBrigadeComponentActiveStatusChart: TFireBrigadeComponentActiveStatusChart;
  FireBrigadeComponentByCostCenterChart: TFireBrigadeComponentByCostCenterChart;
  FireBrigadeComponentInput: TFireBrigadeComponentInput;
  FireBrigadeComponentUpdate: TFireBrigadeComponentUpdate;
  FireBrigadeDashboard: TFireBrigadeDashboard;
  FireBrigadeExam: TFireBrigadeExam;
  FireBrigadeExamInput: TFireBrigadeExamInput;
  FireBrigadeExamUpdate: TFireBrigadeExamUpdate;
  FireBrigadeInput: TFireBrigadeInput;
  FireBrigadeMeeting: TFireBrigadeMeeting;
  FireBrigadeMeetingAction: TFireBrigadeMeetingAction;
  FireBrigadeMeetingActionInput: TFireBrigadeMeetingActionInput;
  FireBrigadeMeetingChart: TFireBrigadeMeetingChart;
  FireBrigadeMeetingInput: TFireBrigadeMeetingInput;
  FireBrigadeMeetingParticipant: TFireBrigadeMeetingParticipant;
  FireBrigadeMeetingParticipantInput: TFireBrigadeMeetingParticipantInput;
  FireBrigadeMeetingUpdate: TFireBrigadeMeetingUpdate;
  FireBrigadeOccurrence: TFireBrigadeOccurrence;
  FireBrigadeOccurrenceChart: TFireBrigadeOccurrenceChart;
  FireBrigadeOccurrenceInput: TFireBrigadeOccurrenceInput;
  FireBrigadeOccurrenceUpdate: TFireBrigadeOccurrenceUpdate;
  FireBrigadePeriod: TFireBrigadePeriod;
  FireBrigadeSimulationActionChart: TFireBrigadeSimulationActionChart;
  FireBrigadeSimulationsChart: TFireBrigadeSimulationsChart;
  FireBrigadeTraining: TFireBrigadeTraining;
  FireBrigadeTrainingInput: TFireBrigadeTrainingInput;
  FireBrigadeUpdate: TFireBrigadeUpdate;
  FirstSteps: TFirstSteps;
  FlagRelation: TFlagRelation;
  FlagReturn: TFlagReturn;
  Float: Scalars['Float']['output'];
  FloatRange: TFloatRange;
  FrequencyIndex: TFrequencyIndex;
  FuncionalHistory: TFuncionalHistory;
  FuncionalHistoryByPerson: TFuncionalHistoryByPerson;
  FuncionalHistoryControlMeasure: TFuncionalHistoryControlMeasure;
  FuncionalHistoryExam: TFuncionalHistoryExam;
  FuncionalHistoryExamTranslated: TFuncionalHistoryExamTranslated;
  FuncionalHistoryInput: TFuncionalHistoryInput;
  FuncionalHistoryIpe: TFuncionalHistoryIpe;
  FuncionalHistoryIpeTranslated: TFuncionalHistoryIpeTranslated;
  FuncionalHistoryOnPersonInput: TFuncionalHistoryOnPersonInput;
  FuncionalHistoryOnPersonUpdate: TFuncionalHistoryOnPersonUpdate;
  FuncionalHistoryPpp: TFuncionalHistoryPpp;
  FuncionalHistoryRisk: TFuncionalHistoryRisk;
  FuncionalHistoryRiskTranslated: TFuncionalHistoryRiskTranslated;
  FuncionalHistoryUpdate: TFuncionalHistoryUpdate;
  FunctionsTask: TFunctionsTask;
  GeneratePasswordInput: TGeneratePasswordInput;
  GeneratingSource: TGeneratingSource;
  GeneratingSourceInput: TGeneratingSourceInput;
  GeneratingSourceUpdate: TGeneratingSourceUpdate;
  GenericAccidentCause: TGenericAccidentCause;
  GenericActivePrinciple: TGenericActivePrinciple;
  GenericAgeRange: TGenericAgeRange;
  GenericBiologicalMonitoringExam: TGenericBiologicalMonitoringExam;
  GenericBiologicalMonitoringExamGroup: TGenericBiologicalMonitoringExamGroup;
  GenericCostCenter: TGenericCostCenter;
  GenericExam: TGenericExam;
  GenericExamIbmp: TGenericExamIbmp;
  GenericExaminationProcedure: TGenericExaminationProcedure;
  GenericExpense: TGenericExpense;
  GenericHealthProgram: TGenericHealthProgram;
  GenericLaboratory: TGenericLaboratory;
  GenericMeasuringInstrument: TGenericMeasuringInstrument;
  GenericMedicine: TGenericMedicine;
  GenericMetadata: TGenericMetadata;
  GenericOccupation: TGenericOccupation;
  GenericPeriodicRange: TGenericPeriodicRange;
  GenericPublicPlace: TGenericPublicPlace;
  GenericQuestionGroup: TGenericQuestionGroup;
  GenericQuestionQuiz: TGenericQuestionQuiz;
  GenericQuiz: TGenericQuiz;
  GenericReportSection: TGenericReportSection;
  GenericReportStructure: TGenericReportStructure;
  GenericResponseOption: TGenericResponseOption;
  GenericRiskAgent: TGenericRiskAgent;
  GenericRolePermission: TGenericRolePermission;
  GenericStatementResponsibility: TGenericStatementResponsibility;
  GenericTask: TGenericTask;
  GenericTraining: TGenericTraining;
  GenericVaccine: TGenericVaccine;
  GenericWorkShift: TGenericWorkShift;
  GetAllSaasMetadataInput: TGetAllSaasMetadataInput;
  GetDocumentsInput: TGetDocumentsInput;
  GetDocumentsOrderByInput: TGetDocumentsOrderByInput;
  GetDocumentsParamsInput: TGetDocumentsParamsInput;
  GetDocumentsQueryInput: TGetDocumentsQueryInput;
  GetFields: TGetFields;
  GroupAnalysis: TGroupAnalysis;
  GroupAnalysisInput: TGroupAnalysisInput;
  GroupAnalysisUpdate: TGroupAnalysisUpdate;
  HasFinishedExam: THasFinishedExam;
  HealthProgram: THealthProgram;
  HealthProgramChart: THealthProgramChart;
  HealthProgramInput: THealthProgramInput;
  HealthProgramOccupation: THealthProgramOccupation;
  HealthProgramOccupationInput: THealthProgramOccupationInput;
  HealthProgramTraining: THealthProgramTraining;
  HealthProgramTrainingChanges: THealthProgramTrainingChanges;
  HealthProgramTrainingInput: THealthProgramTrainingInput;
  HealthProgramUpdate: THealthProgramUpdate;
  HealthQuizzes: THealthQuizzes;
  HidraulicInspectionReport: THidraulicInspectionReport;
  HidraulicInspectionReportFields: THidraulicInspectionReportFields;
  HidraulicSystemInspection: THidraulicSystemInspection;
  HidraulicSystemInspectionInput: THidraulicSystemInspectionInput;
  Historic: THistoric;
  HistoricData: THistoricData;
  ID: Scalars['ID']['output'];
  Icd: TIcd;
  IcdGroup: TIcdGroup;
  ImcChart: TImcChart;
  ImportStatus: TImportStatus;
  IndexChart: TIndexChart;
  Indicator: TIndicator;
  InjuryNature: TInjuryNature;
  InputData: TInputData;
  InputTaskOnTask: TInputTaskOnTask;
  InputUserCheck: TInputUserCheck;
  InputUserReplacePassword: TInputUserReplacePassword;
  InspectionOnExtinguishingSystem: TInspectionOnExtinguishingSystem;
  InspectionOnExtinguishingSystemChanges: TInspectionOnExtinguishingSystemChanges;
  InspectionOnExtinguishingSystemInput: TInspectionOnExtinguishingSystemInput;
  InspectionOnExtinguishingSystemUpdate: TInspectionOnExtinguishingSystemUpdate;
  InspectionOnHidraulicSystem: TInspectionOnHidraulicSystem;
  InspectionOnHidraulicSystemChanges: TInspectionOnHidraulicSystemChanges;
  InspectionOnHidraulicSystemInput: TInspectionOnHidraulicSystemInput;
  InspectionOnHidraulicSystemUpdate: TInspectionOnHidraulicSystemUpdate;
  InspectionReport: TInspectionReport;
  InspectionReportFields: TInspectionReportFields;
  Int: Scalars['Int']['output'];
  IntegrationConfiguration: TIntegrationConfiguration;
  IntegrationConfigurationInput: TIntegrationConfigurationInput;
  IntegrationConfigurationOption: TIntegrationConfigurationOption;
  IntegrationConfigurationOptionInput: TIntegrationConfigurationOptionInput;
  IntegrationConfigureInput: TIntegrationConfigureInput;
  IntegrationError: TIntegrationError;
  IntegrationErrorAll: TIntegrationErrorAll;
  IntegrationErrorSummary: TIntegrationErrorSummary;
  IntegrationErrorTypeCount: TIntegrationErrorTypeCount;
  IntegrationFlags: TIntegrationFlags;
  InternalFields: TInternalFields;
  InventoryQueue: TInventoryQueue;
  InventoryQueueInput: TInventoryQueueInput;
  Investigation: TInvestigation;
  InvestigationAmountChart: TInvestigationAmountChart;
  InvestigationCause: TInvestigationCause;
  InvestigationCauseInput: TInvestigationCauseInput;
  InvestigationCauseOnAccident: TInvestigationCauseOnAccident;
  InvestigationCauseOnAccidentInput: TInvestigationCauseOnAccidentInput;
  InvestigationCauseOnAccidentUpdate: TInvestigationCauseOnAccidentUpdate;
  InvestigationIndicatorsChart: TInvestigationIndicatorsChart;
  InvestigationInput: TInvestigationInput;
  InvestigationSuggestion: TInvestigationSuggestion;
  InvestigationUpdate: TInvestigationUpdate;
  Invite: TInvite;
  InviteInput: TInviteInput;
  InviteParametersMail: TInviteParametersMail;
  Invoice: TInvoice;
  Ipe: TIpe;
  IpeBiometry: TIpeBiometry;
  IpeBiometryInput: TIpeBiometryInput;
  IpeByRequirementChart: TIpeByRequirementChart;
  IpeByRisk: TIpeByRisk;
  IpeByRiskInput: TIpeByRiskInput;
  IpeDelivery: TIpeDelivery;
  IpeDeliveryDashboard: TIpeDeliveryDashboard;
  IpeDeliveryExtensionAuditReport: TIpeDeliveryExtensionAuditReport;
  IpeDeliveryExtensionAuditStats: TIpeDeliveryExtensionAuditStats;
  IpeDeliveryExtensionEntry: TIpeDeliveryExtensionEntry;
  IpeDeliveryExtensionInput: TIpeDeliveryExtensionInput;
  IpeDeliveryExtensionResult: TIpeDeliveryExtensionResult;
  IpeDeliveryExtensionTimeline: TIpeDeliveryExtensionTimeline;
  IpeDeliveryFace: TIpeDeliveryFace;
  IpeDeliveryInput: TIpeDeliveryInput;
  IpeDeliveryLineCharts: TIpeDeliveryLineCharts;
  IpeDeliveryMedicalReport: TIpeDeliveryMedicalReport;
  IpeDeliveryParams: TIpeDeliveryParams;
  IpeDeliveryPerTotalChart: TIpeDeliveryPerTotalChart;
  IpeDeliveryPieCharts: TIpeDeliveryPieCharts;
  IpeDeliveryReport: TIpeDeliveryReport;
  IpeDeliveryReportParams: TIpeDeliveryReportParams;
  IpeDeliveryUpdate: TIpeDeliveryUpdate;
  IpeFace: TIpeFace;
  IpeFaceInput: TIpeFaceInput;
  IpeInfo: TIpeInfo;
  IpeManufacturer: TIpeManufacturer;
  IpeManufacturerSuggestion: TIpeManufacturerSuggestion;
  IpeOccupation: TIpeOccupation;
  IpeOnRiskInput: TIpeOnRiskInput;
  IpeOnRiskUpdate: TIpeOnRiskUpdate;
  IpeReport: TIpeReport;
  IpeTask: TIpeTask;
  IpesInfo: TIpesInfo;
  IpesInfoSorted: TIpesInfoSorted;
  Item: TItem;
  ItemsSteps: TItemsSteps;
  JSON: Scalars['JSON']['output'];
  LastMeasurementByRiskUpdate: TLastMeasurementByRiskUpdate;
  Level: TLevel;
  LevelDiscount: TLevelDiscount;
  LevelInput: TLevelInput;
  LevelsForecast: TLevelsForecast;
  LevelsForecastInput: TLevelsForecastInput;
  LineChart: TLineChart;
  LineCharts: TLineCharts;
  LocationStructure: TLocationStructure;
  Login: TLogin;
  Mandate: TMandate;
  MandateAction: TMandateAction;
  MandateActionInput: TMandateActionInput;
  MandateActionStatusChart: TMandateActionStatusChart;
  MandateActionStatusEntry: TMandateActionStatusEntry;
  MandateCostCenter: TMandateCostCenter;
  MandateCostCenterInput: TMandateCostCenterInput;
  MandateDashboard: TMandateDashboard;
  MandateDepartment: TMandateDepartment;
  MandateDepartmentInput: TMandateDepartmentInput;
  MandateDimension: TMandateDimension;
  MandateEvent: TMandateEvent;
  MandateEventInfo: TMandateEventInfo;
  MandateEventInput: TMandateEventInput;
  MandateEventInputByMandate: TMandateEventInputByMandate;
  MandateEventUpdate: TMandateEventUpdate;
  MandateInput: TMandateInput;
  MandateLoss: TMandateLoss;
  MandateMeetingActionsTotalChart: TMandateMeetingActionsTotalChart;
  MandateMeetingActionsTotalEntry: TMandateMeetingActionsTotalEntry;
  MandateMeetingParticipantsChart: TMandateMeetingParticipantsChart;
  MandateMeetingParticipantsEntry: TMandateMeetingParticipantsEntry;
  MandateMeetingsChart: TMandateMeetingsChart;
  MandateMeetingsEntry: TMandateMeetingsEntry;
  MandateMonetaryChart: TMandateMonetaryChart;
  MandateMonetaryEntry: TMandateMonetaryEntry;
  MandateMonthlyCountChart: TMandateMonthlyCountChart;
  MandateMonthlyCountEntry: TMandateMonthlyCountEntry;
  MandateSuggestionStatusChart: TMandateSuggestionStatusChart;
  MandateSuggestionStatusEntry: TMandateSuggestionStatusEntry;
  MandateTraining: TMandateTraining;
  MandateTrainingInput: TMandateTrainingInput;
  MandateTrainingUpdateInput: TMandateTrainingUpdateInput;
  MandateUpdate: TMandateUpdate;
  MandateValidity: TMandateValidity;
  Manufacturer: TManufacturer;
  MapUpload: TMapUpload;
  MeasurementByAgentGroupItem: TMeasurementByAgentGroupItem;
  MeasurementByRisk: TMeasurementByRisk;
  MeasurementByRiskInput: TMeasurementByRiskInput;
  MeasurementByRiskUpdate: TMeasurementByRiskUpdate;
  MeasurementDeviceItem: TMeasurementDeviceItem;
  MeasurementDevicesChart: TMeasurementDevicesChart;
  MeasurementOnRiskInput: TMeasurementOnRiskInput;
  MeasurementOnRiskUpdate: TMeasurementOnRiskUpdate;
  Measurements: TMeasurements;
  MeasuringInstrument: TMeasuringInstrument;
  MeasuringInstrumentInput: TMeasuringInstrumentInput;
  MeasuringInstrumentUpdate: TMeasuringInstrumentUpdate;
  MedConsultReport: TMedConsultReport;
  MedRecordHealthPrograms: TMedRecordHealthPrograms;
  MedicalCertificate: TMedicalCertificate;
  MedicalCertificateByIcd: TMedicalCertificateByIcd;
  MedicalCertificateInput: TMedicalCertificateInput;
  MedicalCertificateReport: TMedicalCertificateReport;
  MedicalCertificateUpdate: TMedicalCertificateUpdate;
  MedicalConsultation: TMedicalConsultation;
  MedicalRecord: TMedicalRecord;
  MedicalRecordCertificates: TMedicalRecordCertificates;
  MedicalRecordDashboard: TMedicalRecordDashboard;
  MedicalRecordDeficiencies: TMedicalRecordDeficiencies;
  MedicalRecordDiagnostics: TMedicalRecordDiagnostics;
  MedicalRecordExams: TMedicalRecordExams;
  MedicalRecordFilter: TMedicalRecordFilter;
  MedicalRecordHealthProgram: TMedicalRecordHealthProgram;
  MedicalRecordHealthProgramInput: TMedicalRecordHealthProgramInput;
  MedicalRecordHealthProgramUpdate: TMedicalRecordHealthProgramUpdate;
  MedicalRecordInput: TMedicalRecordInput;
  MedicalRecordName: TMedicalRecordName;
  MedicalRecordOrderByInput: TMedicalRecordOrderByInput;
  MedicalRecordQueryInput: TMedicalRecordQueryInput;
  MedicalRecordReport: TMedicalRecordReport;
  MedicalRecordRestrictions: TMedicalRecordRestrictions;
  MedicalRecordUpdate: TMedicalRecordUpdate;
  MedicalRecordVaccinationPlanning: TMedicalRecordVaccinationPlanning;
  MedicalRecordVaccinationPlanningReport: TMedicalRecordVaccinationPlanningReport;
  MedicalRecordVaccine: TMedicalRecordVaccine;
  MedicalRecordVaccineInput: TMedicalRecordVaccineInput;
  MedicalRecordVaccinePrint: TMedicalRecordVaccinePrint;
  MedicalRecordVaccineUpdate: TMedicalRecordVaccineUpdate;
  MedicalReferral: TMedicalReferral;
  MedicalReferralDoctorBiometry: TMedicalReferralDoctorBiometry;
  MedicalReferralDoctorBiometryInput: TMedicalReferralDoctorBiometryInput;
  MedicalReferralInput: TMedicalReferralInput;
  MedicalReferralReport: TMedicalReferralReport;
  MedicalReferralUpdate: TMedicalReferralUpdate;
  MedicalRestriction: TMedicalRestriction;
  MedicalRestrictionInput: TMedicalRestrictionInput;
  MedicalRestrictionUpdate: TMedicalRestrictionUpdate;
  MedicalRestrictionsChart: TMedicalRestrictionsChart;
  Medicine: TMedicine;
  MedicineInput: TMedicineInput;
  MedicineOnDiagnostic: TMedicineOnDiagnostic;
  MedicineOnDiagnosticChanges: TMedicineOnDiagnosticChanges;
  MedicineOnDiagnosticInput: TMedicineOnDiagnosticInput;
  MedicineOnDiagnosticUpdate: TMedicineOnDiagnosticUpdate;
  MedicineUpdate: TMedicineUpdate;
  MedicinesPrescription: TMedicinesPrescription;
  Meeting: TMeeting;
  MeetingAction: TMeetingAction;
  MeetingActionInput: TMeetingActionInput;
  MeetingActionUpdate: TMeetingActionUpdate;
  MeetingEntry: TMeetingEntry;
  MeetingInput: TMeetingInput;
  MeetingParticipant: TMeetingParticipant;
  MeetingParticipantInput: TMeetingParticipantInput;
  MeetingParticipantUpdate: TMeetingParticipantUpdate;
  MeetingUpdate: TMeetingUpdate;
  MicroActionStatusChart: TMicroActionStatusChart;
  MicroActionStatusEntry: TMicroActionStatusEntry;
  ModuleDefaultRecipientsDto: TModuleDefaultRecipientsDto;
  Mutation: Record<PropertyKey, never>;
  NoiseRisk: TNoiseRisk;
  Notification: TNotification;
  NotificationConfigDto: TNotificationConfigDto;
  NotificationConfigUpsertInput: TNotificationConfigUpsertInput;
  NotificationTags: TNotificationTags;
  NtepDistributionChart: TNtepDistributionChart;
  NtepEvolutionChart: TNtepEvolutionChart;
  NtepPieEntry: TNtepPieEntry;
  NtepSeries: TNtepSeries;
  ObserversItemInput: TObserversItemInput;
  Occupation: TOccupation;
  OccupationByRisk: TOccupationByRisk;
  OccupationByRiskInput: TOccupationByRiskInput;
  OccupationInput: TOccupationInput;
  OccupationIntegration: TOccupationIntegration;
  OccupationOnRiskInput: TOccupationOnRiskInput;
  OccupationOnVaccine: TOccupationOnVaccine;
  OccupationOnVaccineInput: TOccupationOnVaccineInput;
  OccupationUpdate: TOccupationUpdate;
  OccupationalCertificateParameters: TOccupationalCertificateParameters;
  OccupationalDiseaseAnalysis: TOccupationalDiseaseAnalysis;
  OccupationalHealthBiometry: TOccupationalHealthBiometry;
  OccupationalHealthBiometryInput: TOccupationalHealthBiometryInput;
  OccupationalHealthCertificate: TOccupationalHealthCertificate;
  OccupationalHealthCertificateByDate: TOccupationalHealthCertificateByDate;
  OccupationalHealthCertificateInput: TOccupationalHealthCertificateInput;
  OccupationalHealthCertificateTotal: TOccupationalHealthCertificateTotal;
  OccupationalHealthCertificateUpdate: TOccupationalHealthCertificateUpdate;
  OccupationalHealthFace: TOccupationalHealthFace;
  OccupationalHealthFaceInput: TOccupationalHealthFaceInput;
  OccupationsGroup: TOccupationsGroup;
  OccurrenceEntry: TOccurrenceEntry;
  Organization: TOrganization;
  OrganizationCancelContractInput: TOrganizationCancelContractInput;
  OrganizationContractInput: TOrganizationContractInput;
  OrganizationInput: TOrganizationInput;
  OrganizationOwnership: TOrganizationOwnership;
  OrganizationOwnershipInput: TOrganizationOwnershipInput;
  OrganizationUpdateInput: TOrganizationUpdateInput;
  OrganizationWithBranches: TOrganizationWithBranches;
  OrthoRater: TOrthoRater;
  OrthoRaterInput: TOrthoRaterInput;
  OrthoRaterUpdate: TOrthoRaterUpdate;
  PPREmployees: TPprEmployees;
  PaginatedAbsenceType: TPaginatedAbsenceType;
  PaginatedAccident: TPaginatedAccident;
  PaginatedAccidentCause: TPaginatedAccidentCause;
  PaginatedAccidentCode: TPaginatedAccidentCode;
  PaginatedAccidentObject: TPaginatedAccidentObject;
  PaginatedAccidentType: TPaginatedAccidentType;
  PaginatedAccredited: TPaginatedAccredited;
  PaginatedAccreditedConsultations: TPaginatedAccreditedConsultations;
  PaginatedActionPlan: TPaginatedActionPlan;
  PaginatedActivityGroup: TPaginatedActivityGroup;
  PaginatedActivityIcd: TPaginatedActivityIcd;
  PaginatedAllowanceType: TPaginatedAllowanceType;
  PaginatedAttachment: TPaginatedAttachment;
  PaginatedAuditLogs: TPaginatedAuditLogs;
  PaginatedBiologicalMonitoringExam: TPaginatedBiologicalMonitoringExam;
  PaginatedBiologicalMonitoringExamGroup: TPaginatedBiologicalMonitoringExamGroup;
  PaginatedBodyPart: TPaginatedBodyPart;
  PaginatedBranch: TPaginatedBranch;
  PaginatedCalendar: TPaginatedCalendar;
  PaginatedConsultation: TPaginatedConsultation;
  PaginatedConsultationMinimal: TPaginatedConsultationMinimal;
  PaginatedConsultationReason: TPaginatedConsultationReason;
  PaginatedControlMeasure: TPaginatedControlMeasure;
  PaginatedCostCenter: TPaginatedCostCenter;
  PaginatedCrontabExecutionDetails: TPaginatedCrontabExecutionDetails;
  PaginatedCrontabExecutions: TPaginatedCrontabExecutions;
  PaginatedDeliverySpareParts: TPaginatedDeliverySpareParts;
  PaginatedDepartment: TPaginatedDepartment;
  PaginatedESocialQueue: TPaginatedESocialQueue;
  PaginatedEconomicActivity: TPaginatedEconomicActivity;
  PaginatedEmployeeIpeDelivery: TPaginatedEmployeeIpeDelivery;
  PaginatedEnvironmentalReport: TPaginatedEnvironmentalReport;
  PaginatedEnvironmentalReportSuggestion: TPaginatedEnvironmentalReportSuggestion;
  PaginatedEvent: TPaginatedEvent;
  PaginatedExam: TPaginatedExam;
  PaginatedExamNormalResult: TPaginatedExamNormalResult;
  PaginatedExpectedConsultations: TPaginatedExpectedConsultations;
  PaginatedExpense: TPaginatedExpense;
  PaginatedExposureGroup: TPaginatedExposureGroup;
  PaginatedExtinguishingSystem: TPaginatedExtinguishingSystem;
  PaginatedFireBrigade: TPaginatedFireBrigade;
  PaginatedGeneratingSource: TPaginatedGeneratingSource;
  PaginatedGenericAccidentCause: TPaginatedGenericAccidentCause;
  PaginatedGenericActivePrinciple: TPaginatedGenericActivePrinciple;
  PaginatedGenericBiologicalMonitoringExam: TPaginatedGenericBiologicalMonitoringExam;
  PaginatedGenericBiologicalMonitoringExamGroup: TPaginatedGenericBiologicalMonitoringExamGroup;
  PaginatedGenericCostCenter: TPaginatedGenericCostCenter;
  PaginatedGenericExam: TPaginatedGenericExam;
  PaginatedGenericExaminationProcedure: TPaginatedGenericExaminationProcedure;
  PaginatedGenericExpense: TPaginatedGenericExpense;
  PaginatedGenericHealthProgram: TPaginatedGenericHealthProgram;
  PaginatedGenericLaboratory: TPaginatedGenericLaboratory;
  PaginatedGenericMeasuringInstrument: TPaginatedGenericMeasuringInstrument;
  PaginatedGenericMedicine: TPaginatedGenericMedicine;
  PaginatedGenericOccupation: TPaginatedGenericOccupation;
  PaginatedGenericPeriodicRange: TPaginatedGenericPeriodicRange;
  PaginatedGenericPublicPlace: TPaginatedGenericPublicPlace;
  PaginatedGenericQuestionGroup: TPaginatedGenericQuestionGroup;
  PaginatedGenericQuestionQuiz: TPaginatedGenericQuestionQuiz;
  PaginatedGenericQuiz: TPaginatedGenericQuiz;
  PaginatedGenericReportStructure: TPaginatedGenericReportStructure;
  PaginatedGenericResponseOption: TPaginatedGenericResponseOption;
  PaginatedGenericRiskAgent: TPaginatedGenericRiskAgent;
  PaginatedGenericStatementResponsibility: TPaginatedGenericStatementResponsibility;
  PaginatedGenericTask: TPaginatedGenericTask;
  PaginatedGenericTraining: TPaginatedGenericTraining;
  PaginatedGenericVaccine: TPaginatedGenericVaccine;
  PaginatedGenericWorkShift: TPaginatedGenericWorkShift;
  PaginatedGetDocuments: TPaginatedGetDocuments;
  PaginatedHealthProgram: TPaginatedHealthProgram;
  PaginatedIcdGroups: TPaginatedIcdGroups;
  PaginatedIcds: TPaginatedIcds;
  PaginatedInjuryNature: TPaginatedInjuryNature;
  PaginatedIntegrationError: TPaginatedIntegrationError;
  PaginatedInventoryQueue: TPaginatedInventoryQueue;
  PaginatedInvestigationSuggestion: TPaginatedInvestigationSuggestion;
  PaginatedIpe: TPaginatedIpe;
  PaginatedIpeManufacturer: TPaginatedIpeManufacturer;
  PaginatedMandate: TPaginatedMandate;
  PaginatedManufacturer: TPaginatedManufacturer;
  PaginatedMeasuringInstrument: TPaginatedMeasuringInstrument;
  PaginatedMedicalRecords: TPaginatedMedicalRecords;
  PaginatedMedicine: TPaginatedMedicine;
  PaginatedOccupation: TPaginatedOccupation;
  PaginatedPeopleOnBrowse: TPaginatedPeopleOnBrowse;
  PaginatedPeopleOnBrowseInput: TPaginatedPeopleOnBrowseInput;
  PaginatedPeriodicRange: TPaginatedPeriodicRange;
  PaginatedPerson: TPaginatedPerson;
  PaginatedPersonIpeList: TPaginatedPersonIpeList;
  PaginatedPersonNeedIpe: TPaginatedPersonNeedIpe;
  PaginatedPhysicalEnvironment: TPaginatedPhysicalEnvironment;
  PaginatedPosition: TPaginatedPosition;
  PaginatedPreMedicalCertificates: TPaginatedPreMedicalCertificates;
  PaginatedProduct: TPaginatedProduct;
  PaginatedProductDelivery: TPaginatedProductDelivery;
  PaginatedProductIpeManufacturer: TPaginatedProductIpeManufacturer;
  PaginatedQueue: TPaginatedQueue;
  PaginatedQuiz: TPaginatedQuiz;
  PaginatedReportStructure: TPaginatedReportStructure;
  PaginatedRisk: TPaginatedRisk;
  PaginatedRiskAgent: TPaginatedRiskAgent;
  PaginatedRiskSuggestion: TPaginatedRiskSuggestion;
  PaginatedRolePermission: TPaginatedRolePermission;
  PaginatedScheduleRestriction: TPaginatedScheduleRestriction;
  PaginatedSpareParts: TPaginatedSpareParts;
  PaginatedStabilityType: TPaginatedStabilityType;
  PaginatedStatementResponsibility: TPaginatedStatementResponsibility;
  PaginatedSync: TPaginatedSync;
  PaginatedTTalkQueue: TPaginatedTTalkQueue;
  PaginatedTask: TPaginatedTask;
  PaginatedTraining: TPaginatedTraining;
  PaginatedTrainingHistory: TPaginatedTrainingHistory;
  PaginatedTtalkInboundEvent: TPaginatedTtalkInboundEvent;
  PaginatedTtalkInboundSemanticInconsistency: TPaginatedTtalkInboundSemanticInconsistency;
  PaginatedUnityMeasure: TPaginatedUnityMeasure;
  PaginatedVaccine: TPaginatedVaccine;
  PaginatedWarehouse: TPaginatedWarehouse;
  PaginatedWebhookQueue: TPaginatedWebhookQueue;
  PaginatedWorkPermission: TPaginatedWorkPermission;
  PaginatedWorkShift: TPaginatedWorkShift;
  Pagination: TPagination;
  PaginationAbsenceQueryInput: TPaginationAbsenceQueryInput;
  PaginationDefaultQueryInput: TPaginationDefaultQueryInput;
  PaginationInput: TPaginationInput;
  PaginationPersonQueryInput: TPaginationPersonQueryInput;
  PaginationProductIpeManufacturerInput: TPaginationProductIpeManufacturerInput;
  ParticipantOnMeeting: TParticipantOnMeeting;
  ParticipantOnMeetingInput: TParticipantOnMeetingInput;
  ParticipantOnMeetingUpdate: TParticipantOnMeetingUpdate;
  Payments: TPayments;
  PcmsoReportData: TPcmsoReportData;
  PerDayChart: TPerDayChart;
  PerTotalCharts: TPerTotalCharts;
  PeriodicRange: TPeriodicRange;
  PeriodicRangeInput: TPeriodicRangeInput;
  PeriodicRangeUpdate: TPeriodicRangeUpdate;
  Permission: TPermission;
  PermissionInput: TPermissionInput;
  Person: TPerson;
  PersonByGender: TPersonByGender;
  PersonByGenderAndCC: TPersonByGenderAndCc;
  PersonByMandate: TPersonByMandate;
  PersonByRisk: TPersonByRisk;
  PersonByRiskInput: TPersonByRiskInput;
  PersonByTask: TPersonByTask;
  PersonChart: TPersonChart;
  PersonFilter: TPersonFilter;
  PersonFilterQueryInput: TPersonFilterQueryInput;
  PersonForExposure: TPersonForExposure;
  PersonHistory: TPersonHistory;
  PersonHistoryActivate: TPersonHistoryActivate;
  PersonHistoryActivateInput: TPersonHistoryActivateInput;
  PersonHistoryActivateUpdate: TPersonHistoryActivateUpdate;
  PersonInput: TPersonInput;
  PersonIpeList: TPersonIpeList;
  PersonNeedIpe: TPersonNeedIpe;
  PersonOnBrowse: TPersonOnBrowse;
  PersonOnRiskInput: TPersonOnRiskInput;
  PersonOnTaskInput: TPersonOnTaskInput;
  PersonOnTaskRemove: TPersonOnTaskRemove;
  PersonOnTaskUpdate: TPersonOnTaskUpdate;
  PersonOrderByInput: TPersonOrderByInput;
  PersonRequiredTraining: TPersonRequiredTraining;
  PersonUpdate: TPersonUpdate;
  PhysicalEnvironment: TPhysicalEnvironment;
  PhysicalEnvironmentInput: TPhysicalEnvironmentInput;
  PhysicalEnvironmentUpdate: TPhysicalEnvironmentUpdate;
  PieChart: TPieChart;
  PieCharts: TPieCharts;
  PlanedExam: TPlanedExam;
  PolicyAgreement: TPolicyAgreement;
  PolicyTerms: TPolicyTerms;
  PolicyTermsInput: TPolicyTermsInput;
  Position: TPosition;
  PositionInput: TPositionInput;
  PositionIntegration: TPositionIntegration;
  PositionUpdate: TPositionUpdate;
  PppParameters: TPppParameters;
  PppReport: TPppReport;
  PreMedicalCertificate: TPreMedicalCertificate;
  PreMedicalCertificateCountByStatus: TPreMedicalCertificateCountByStatus;
  PreMedicalCertificateFollowUp: TPreMedicalCertificateFollowUp;
  PreMedicalCertificateInput: TPreMedicalCertificateInput;
  PreMedicalCertificateQueryInput: TPreMedicalCertificateQueryInput;
  PreMedicalCertificateUpdate: TPreMedicalCertificateUpdate;
  PreValidate: TPreValidate;
  PrintBiometry: TPrintBiometry;
  Product: TProduct;
  ProductCopyInput: TProductCopyInput;
  ProductDelivery: TProductDelivery;
  ProductDeliveryInput: TProductDeliveryInput;
  ProductDeliveryParams: TProductDeliveryParams;
  ProductDeliveryReport: TProductDeliveryReport;
  ProductDeliveryUpdate: TProductDeliveryUpdate;
  ProductInput: TProductInput;
  ProductIntegration: TProductIntegration;
  ProductIpeManufacturer: TProductIpeManufacturer;
  ProductIpeManufacturerInput: TProductIpeManufacturerInput;
  ProductIpeManufacturerUpdate: TProductIpeManufacturerUpdate;
  ProductReport: TProductReport;
  ProductUpdate: TProductUpdate;
  ProductsParameters: TProductsParameters;
  PubSubPayload: TPubSubPayload;
  PublishingOptionsInput: TPublishingOptionsInput;
  Query: Record<PropertyKey, never>;
  QuestionGroupOnQuestion: TQuestionGroupOnQuestion;
  Questions: TQuestions;
  QuestionsDashboard: TQuestionsDashboard;
  QuestionsGroup: TQuestionsGroup;
  QuestionsGroupInput: TQuestionsGroupInput;
  QuestionsGroupUpdate: TQuestionsGroupUpdate;
  QuestionsInput: TQuestionsInput;
  QuestionsUpdate: TQuestionsUpdate;
  QueueDTO: TQueueDto;
  Quiz: TQuiz;
  QuizCostCenter: TQuizCostCenter;
  QuizCostCenterInput: TQuizCostCenterInput;
  QuizDepartment: TQuizDepartment;
  QuizDepartmentInput: TQuizDepartmentInput;
  QuizGeneratingSource: TQuizGeneratingSource;
  QuizGeneratingSourceInput: TQuizGeneratingSourceInput;
  QuizInput: TQuizInput;
  QuizOccupation: TQuizOccupation;
  QuizOccupationInput: TQuizOccupationInput;
  QuizPerson: TQuizPerson;
  QuizPersonInput: TQuizPersonInput;
  QuizPhysicalEnvironment: TQuizPhysicalEnvironment;
  QuizPhysicalEnvironmentInput: TQuizPhysicalEnvironmentInput;
  QuizUpdate: TQuizUpdate;
  QuizzesCharts: TQuizzesCharts;
  RadarCharts: TRadarCharts;
  Ranking: TRanking;
  RealGoal: TRealGoal;
  RealGoalInput: TRealGoalInput;
  RealGoalOnActionPlan: TRealGoalOnActionPlan;
  ReasonsChart: TReasonsChart;
  RecipientInput: TRecipientInput;
  RecipientItemInput: TRecipientItemInput;
  RecipientListInput: TRecipientListInput;
  RecipientListItemInput: TRecipientListItemInput;
  RecognizeMedicalCertificateInput: TRecognizeMedicalCertificateInput;
  RecognizedIcdInfo: TRecognizedIcdInfo;
  RecognizedMedicalCertificateData: TRecognizedMedicalCertificateData;
  References: TReferences;
  ReferencesInput: TReferencesInput;
  ReferencesUpdate: TReferencesUpdate;
  ReferralsChart: TReferralsChart;
  ReferralsQuantityChart: TReferralsQuantityChart;
  RelativeIndex: TRelativeIndex;
  ReleasableResult: TReleasableResult;
  ReleaseConsultationResultsInput: TReleaseConsultationResultsInput;
  RemoveRecipientInput: TRemoveRecipientInput;
  ReportMapaData: TReportMapaData;
  ReportMapaFields: TReportMapaFields;
  ReportPrescription: TReportPrescription;
  ReportSection: TReportSection;
  ReportSectionBaseInput: TReportSectionBaseInput;
  ReportSectionInput: TReportSectionInput;
  ReportSectionUpdate: TReportSectionUpdate;
  ReportStructure: TReportStructure;
  ReportStructureInput: TReportStructureInput;
  ReportStructureUpdate: TReportStructureUpdate;
  ResponseClinicalQuizInput: TResponseClinicalQuizInput;
  ResponseClinicalQuizUpdate: TResponseClinicalQuizUpdate;
  ResponseOptions: TResponseOptions;
  ResponseOptionsInput: TResponseOptionsInput;
  ResponseOptionsUpdate: TResponseOptionsUpdate;
  ResponseSafetyQuizInput: TResponseSafetyQuizInput;
  ResponseSafetyQuizUpdate: TResponseSafetyQuizUpdate;
  ResponseWorkPermissionQuiz: TResponseWorkPermissionQuiz;
  ResponseWorkPermissionQuizInput: TResponseWorkPermissionQuizInput;
  ResponseWorkPermissionQuizUpdate: TResponseWorkPermissionQuizUpdate;
  ResponsesClinicalQuiz: TResponsesClinicalQuiz;
  ResponsesSafetyQuiz: TResponsesSafetyQuiz;
  ResponsibleAction: TResponsibleAction;
  ResponsibleActionInput: TResponsibleActionInput;
  ResponsibleOnActionPlan: TResponsibleOnActionPlan;
  ResultExamIbmp: TResultExamIbmp;
  ResultExamIbmpForComparative: TResultExamIbmpForComparative;
  ResultExamIbmpGroup: TResultExamIbmpGroup;
  ResultExamIbmpInput: TResultExamIbmpInput;
  ResultExamIbmpUpdate: TResultExamIbmpUpdate;
  ResultExamItemForComparative: TResultExamItemForComparative;
  ResultExamItemGroup: TResultExamItemGroup;
  ResultExamOrthoRaterForComparative: TResultExamOrthoRaterForComparative;
  ResultExamSnellenForComparative: TResultExamSnellenForComparative;
  ResultExamSpirometryForComparative: TResultExamSpirometryForComparative;
  ResultExamSpirometryGroup: TResultExamSpirometryGroup;
  ResultUrinalysisForComparative: TResultUrinalysisForComparative;
  ResultUrinalysisGroup: TResultUrinalysisGroup;
  ReturnReasonsChart: TReturnReasonsChart;
  Risk: TRisk;
  RiskAgent: TRiskAgent;
  RiskAgentInput: TRiskAgentInput;
  RiskAgentUpdate: TRiskAgentUpdate;
  RiskByEnvironmentInput: TRiskByEnvironmentInput;
  RiskCharacterization: TRiskCharacterization;
  RiskChart: TRiskChart;
  RiskClassificationTable: TRiskClassificationTable;
  RiskComposition: TRiskComposition;
  RiskCompositionInput: TRiskCompositionInput;
  RiskCompositionSave: TRiskCompositionSave;
  RiskControlMeasure: TRiskControlMeasure;
  RiskCostCenterOccupation: TRiskCostCenterOccupation;
  RiskCostCenterOccupationIds: TRiskCostCenterOccupationIds;
  RiskCount: TRiskCount;
  RiskDashboard: TRiskDashboard;
  RiskEnvironment: TRiskEnvironment;
  RiskFilter: TRiskFilter;
  RiskInput: TRiskInput;
  RiskMeasurement: TRiskMeasurement;
  RiskMeasurements: TRiskMeasurements;
  RiskOrderByInput: TRiskOrderByInput;
  RiskPieChart: TRiskPieChart;
  RiskProbabilityTable: TRiskProbabilityTable;
  RiskQueryInput: TRiskQueryInput;
  RiskReviewReportFields: TRiskReviewReportFields;
  RiskSeverityTable: TRiskSeverityTable;
  RiskSuggestion: TRiskSuggestion;
  RiskToReview: TRiskToReview;
  RiskToReviewReport: TRiskToReviewReport;
  RiskTrainings: TRiskTrainings;
  RiskUpdate: TRiskUpdate;
  RisksExam: TRisksExam;
  RisksInfo: TRisksInfo;
  RisksPerEnvironmentChart: TRisksPerEnvironmentChart;
  Role: TRole;
  RolePermission: TRolePermission;
  RolePermissionInput: TRolePermissionInput;
  RolePermissionUpdate: TRolePermissionUpdate;
  RoleUpdate: TRoleUpdate;
  RouteFeature: TRouteFeature;
  RowsInfo: TRowsInfo;
  RowsInput: TRowsInput;
  S3UrlCloudFront: Scalars['S3UrlCloudFront']['output'];
  SSTMigratorValues: TSstMigratorValues;
  SaasFullMetadata: TSaasFullMetadata;
  SaasMetadata: TSaasMetadata;
  SafetyQuiz: TSafetyQuiz;
  SafetyQuizConformityChart: TSafetyQuizConformityChart;
  SafetyQuizConformityEntry: TSafetyQuizConformityEntry;
  SafetyQuizDashboard: TSafetyQuizDashboard;
  SafetyQuizInput: TSafetyQuizInput;
  SafetyQuizInspectionChart: TSafetyQuizInspectionChart;
  SafetyQuizInspectionEntry: TSafetyQuizInspectionEntry;
  SafetyQuizParetoChart: TSafetyQuizParetoChart;
  SafetyQuizParetoEntry: TSafetyQuizParetoEntry;
  SafetyQuizUpdate: TSafetyQuizUpdate;
  SaveEnvironmentalReportVersionInput: TSaveEnvironmentalReportVersionInput;
  ScheduleRestriction: TScheduleRestriction;
  ScheduleRestrictionInput: TScheduleRestrictionInput;
  ScheduleRestrictionUpdate: TScheduleRestrictionUpdate;
  ScheduledConsultation: TScheduledConsultation;
  ScheduledConsultationByBranch: TScheduledConsultationByBranch;
  ScheduledConsultationToPrint: TScheduledConsultationToPrint;
  ScheduledExam: TScheduledExam;
  ScheduledExamByBranch: TScheduledExamByBranch;
  ScheduledExamToPrint: TScheduledExamToPrint;
  SchedulingByAccredited: TSchedulingByAccredited;
  SchedulingParameters: TSchedulingParameters;
  SchedulingReport: TSchedulingReport;
  SchedulingReportByDoctor: TSchedulingReportByDoctor;
  SchedulingSettings: TSchedulingSettings;
  SecurityPyramid: TSecurityPyramid;
  SecurityWorkOrder: TSecurityWorkOrder;
  SecurityWorkOrderParameters: TSecurityWorkOrderParameters;
  ServiceProviderExamInput: TServiceProviderExamInput;
  ServiceProviderInput: TServiceProviderInput;
  ServiceProviderUpdate: TServiceProviderUpdate;
  SesmtRoles: TSesmtRoles;
  Session: TSession;
  SessionData: TSessionData;
  SessionInput: TSessionInput;
  SessionInputAd: TSessionInputAd;
  Settings: TSettings;
  SettingsInput: TSettingsInput;
  SeverityIndex: TSeverityIndex;
  ShortcutGenerated: TShortcutGenerated;
  ShortcutHistory: TShortcutHistory;
  ShortcutHistoryId: TShortcutHistoryId;
  SickNote: TSickNote;
  SignBrokerGetDocument: TSignBrokerGetDocument;
  SignBrokerGetDocuments: TSignBrokerGetDocuments;
  SignBrokerGetDocumentsAndUpdateState: TSignBrokerGetDocumentsAndUpdateState;
  SignBrokerResponse: TSignBrokerResponse;
  SignBrokerUrlDownloadResponse: TSignBrokerUrlDownloadResponse;
  SignCredentialsInput: TSignCredentialsInput;
  SignCredentialsOutput: TSignCredentialsOutput;
  SignatureChart: TSignatureChart;
  SigningInput: TSigningInput;
  SimpleComplementaryResults: TSimpleComplementaryResults;
  Simulation: TSimulation;
  SimulationAction: TSimulationAction;
  SimulationActionEntry: TSimulationActionEntry;
  SimulationActionInput: TSimulationActionInput;
  SimulationEntry: TSimulationEntry;
  SimulationInput: TSimulationInput;
  SimulationPlan: TSimulationPlan;
  SimulationPlanAction: TSimulationPlanAction;
  SimulationPlanActionInput: TSimulationPlanActionInput;
  SimulationPlanInput: TSimulationPlanInput;
  SimulationPlanUpdate: TSimulationPlanUpdate;
  SimulationUpdate: TSimulationUpdate;
  Sipat: TSipat;
  SipatEvent: TSipatEvent;
  SipatEventInput: TSipatEventInput;
  SipatEventUpdate: TSipatEventUpdate;
  SipatInput: TSipatInput;
  SipatUpdate: TSipatUpdate;
  SituationCount: TSituationCount;
  Snellen: TSnellen;
  SnellenInput: TSnellenInput;
  SnellenUpdate: TSnellenUpdate;
  SpareParts: TSpareParts;
  SparePartsInput: TSparePartsInput;
  SparePartsReport: TSparePartsReport;
  SparePartsUpdate: TSparePartsUpdate;
  StabilityType: TStabilityType;
  StabilityTypeInput: TStabilityTypeInput;
  StabilityTypeIntegration: TStabilityTypeIntegration;
  StabilityTypeUpdate: TStabilityTypeUpdate;
  StatementResponsibility: TStatementResponsibility;
  StatementResponsibilityInput: TStatementResponsibilityInput;
  StatementResponsibilityUpdate: TStatementResponsibilityUpdate;
  StepMessage: TStepMessage;
  Steps: TSteps;
  StockLevel: TStockLevel;
  StockLevelInput: TStockLevelInput;
  StockLevelReference: TStockLevelReference;
  StockLevelSyncResult: TStockLevelSyncResult;
  StockLevelUpdate: TStockLevelUpdate;
  StockMovement: TStockMovement;
  StockMovementInput: TStockMovementInput;
  StockMovementUpdate: TStockMovementUpdate;
  String: Scalars['String']['output'];
  Subscription: Record<PropertyKey, never>;
  SubscriptionLevelDiscount: TSubscriptionLevelDiscount;
  SuggestionAmount: TSuggestionAmount;
  SuggestionBox: TSuggestionBox;
  SuggestionBoxInput: TSuggestionBoxInput;
  SuggestionBoxListReport: TSuggestionBoxListReport;
  SuggestionBoxUpdate: TSuggestionBoxUpdate;
  Summary: TSummary;
  SummaryEntry: TSummaryEntry;
  SummaryOption: TSummaryOption;
  SyncDTO: TSyncDto;
  TTalkQueue: TTTalkQueue;
  TTalkQueueAll: TTTalkQueueAll;
  TTalkQueueFilterInput: TTTalkQueueFilterInput;
  TTalkQueueInput: TTTalkQueueInput;
  TTalkQueueSummary: TTTalkQueueSummary;
  TableProperties: TTableProperties;
  Task: TTask;
  TaskByPerson: TTaskByPerson;
  TaskByRisk: TTaskByRisk;
  TaskByRiskInput: TTaskByRiskInput;
  TaskInput: TTaskInput;
  TaskOnRiskInput: TTaskOnRiskInput;
  TaskUpdate: TTaskUpdate;
  Terms: TTerms;
  ThumbnailUpload: TThumbnailUpload;
  TimePoint: TTimePoint;
  TimePointInput: TTimePointInput;
  TopIcdItem: TTopIcdItem;
  TopIcdsChart: TTopIcdsChart;
  Training: TTraining;
  TrainingByRisk: TTrainingByRisk;
  TrainingByRiskInput: TTrainingByRiskInput;
  TrainingEligiblePerson: TTrainingEligiblePerson;
  TrainingEligiblePersonsFilters: TTrainingEligiblePersonsFilters;
  TrainingEligiblePersonsResult: TTrainingEligiblePersonsResult;
  TrainingHistory: TTrainingHistory;
  TrainingHistoryBatchInput: TTrainingHistoryBatchInput;
  TrainingHistoryBatchResult: TTrainingHistoryBatchResult;
  TrainingHistoryByPerson: TTrainingHistoryByPerson;
  TrainingHistoryInput: TTrainingHistoryInput;
  TrainingHistoryOnPersonInput: TTrainingHistoryOnPersonInput;
  TrainingHistoryOnPersonRemove: TTrainingHistoryOnPersonRemove;
  TrainingHistoryOnPersonUpdate: TTrainingHistoryOnPersonUpdate;
  TrainingHistoryUpdate: TTrainingHistoryUpdate;
  TrainingInput: TTrainingInput;
  TrainingIntegration: TTrainingIntegration;
  TrainingOnRiskInput: TTrainingOnRiskInput;
  TrainingOnRiskUpdate: TTrainingOnRiskUpdate;
  TrainingUpdate: TTrainingUpdate;
  TransferBlockedItem: TTransferBlockedItem;
  TransferConsultationsInput: TTransferConsultationsInput;
  TransferConsultationsResult: TTransferConsultationsResult;
  TtalkInboundEvent: TTtalkInboundEvent;
  TtalkInboundEventFilterInput: TTtalkInboundEventFilterInput;
  TtalkInboundSemanticInconsistency: TTtalkInboundSemanticInconsistency;
  TtalkInboundSilenceMonitor: TTtalkInboundSilenceMonitor;
  TtalkInboundSilenceThreshold: TTtalkInboundSilenceThreshold;
  TtalkInboundSilenceThresholdInput: TTtalkInboundSilenceThresholdInput;
  TypeChart: TTypeChart;
  TypeCostCenterChart: TTypeCostCenterChart;
  UTMInput: TUtmInput;
  UnityOfMeasure: TUnityOfMeasure;
  UnityOfMeasureInput: TUnityOfMeasureInput;
  UnityOfMeasureIntegration: TUnityOfMeasureIntegration;
  UnityOfMeasureUpdate: TUnityOfMeasureUpdate;
  UnscheduledConsultation: TUnscheduledConsultation;
  UnscheduledInput: TUnscheduledInput;
  UpdateCustomDocumentInput: TUpdateCustomDocumentInput;
  UpdateMetadataInput: TUpdateMetadataInput;
  Upload: Scalars['Upload']['output'];
  Urinalysis: TUrinalysis;
  UrinalysisInput: TUrinalysisInput;
  UrinalysisUpdate: TUrinalysisUpdate;
  User: TUser;
  UserBasicInfo: TUserBasicInfo;
  UserCreationInput: TUserCreationInput;
  UserFilterPreferenceResult: TUserFilterPreferenceResult;
  UserFromCreation: TUserFromCreation;
  UserOrganizationListing: TUserOrganizationListing;
  UserPreferences: TUserPreferences;
  UserPreferencesInput: TUserPreferencesInput;
  UserRoleInput: TUserRoleInput;
  UserRoleMdt: TUserRoleMdt;
  UserRoleUpdate: TUserRoleUpdate;
  UserRoutes: TUserRoutes;
  UserSpecialty: TUserSpecialty;
  UserSpecialtyInput: TUserSpecialtyInput;
  UserSpecialtyUpdate: TUserSpecialtyUpdate;
  UserUpdateInput: TUserUpdateInput;
  UtmData: TUtmData;
  UtmDataInput: TUtmDataInput;
  Vaccine: TVaccine;
  VaccineBiometry: TVaccineBiometry;
  VaccineBiometryInput: TVaccineBiometryInput;
  VaccineChart: TVaccineChart;
  VaccineCostCenterInput: TVaccineCostCenterInput;
  VaccineInput: TVaccineInput;
  VaccineOccupationInput: TVaccineOccupationInput;
  VaccinePlanningParameters: TVaccinePlanningParameters;
  VaccinePrint: TVaccinePrint;
  VaccineQuantityChart: TVaccineQuantityChart;
  VaccineUpdate: TVaccineUpdate;
  ValidationError: TValidationError;
  ValidationReturn: TValidationReturn;
  Validations: TValidations;
  VolumeChart: TVolumeChart;
  VotationProgress: TVotationProgress;
  Vote: TVote;
  VoteInput: TVoteInput;
  VoteStatus: TVoteStatus;
  Warehouse: TWarehouse;
  WarehouseInput: TWarehouseInput;
  WarehouseIntegration: TWarehouseIntegration;
  WarehouseUpdate: TWarehouseUpdate;
  WarningByPerson: TWarningByPerson;
  WebHookCreateInput: TWebHookCreateInput;
  WebHookUpdateInput: TWebHookUpdateInput;
  Webhook: TWebhook;
  WebhookQueue: TWebhookQueue;
  WebhookQueueBatchInput: TWebhookQueueBatchInput;
  WebhookQueueCreateInput: TWebhookQueueCreateInput;
  WebhookQueueUpdateInput: TWebhookQueueUpdateInput;
  WitnessOnAccident: TWitnessOnAccident;
  WitnessOnAccidentInput: TWitnessOnAccidentInput;
  WitnessOnAccidentUpdate: TWitnessOnAccidentUpdate;
  WorkHour: TWorkHour;
  WorkHours: TWorkHours;
  WorkPermission: TWorkPermission;
  WorkPermissionDashboard: TWorkPermissionDashboard;
  WorkPermissionInput: TWorkPermissionInput;
  WorkPermissionParetoChart: TWorkPermissionParetoChart;
  WorkPermissionParetoEntry: TWorkPermissionParetoEntry;
  WorkPermissionPerson: TWorkPermissionPerson;
  WorkPermissionPersonInput: TWorkPermissionPersonInput;
  WorkPermissionQuiz: TWorkPermissionQuiz;
  WorkPermissionQuizInput: TWorkPermissionQuizInput;
  WorkPermissionQuizUpdate: TWorkPermissionQuizUpdate;
  WorkPermissionUpdate: TWorkPermissionUpdate;
  WorkShift: TWorkShift;
  WorkShiftInput: TWorkShiftInput;
  WorkShiftIntegration: TWorkShiftIntegration;
  WorkShiftUpdate: TWorkShiftUpdate;
  YearlyVariationChart: TYearlyVariationChart;
  _Invite: T_Invite;
  _InviteInput: T_InviteInput;
  _PasswordRecovery: T_PasswordRecovery;
  _Terms: T_Terms;
  _UserCreationInput: T_UserCreationInput;
  eSocialParams: TESocialParams;
  isAccreditedResult: TIsAccreditedResult;
}>;

export type TAbnormalityAnalysisResolvers<ContextType = any, ParentType extends TResolversParentTypes['AbnormalityAnalysis'] = TResolversParentTypes['AbnormalityAnalysis']> = ResolversObject<{
  annual_number_of_exams_performed?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  cost_center?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nature?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  number_of_abnormal_results?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  ratio_of_abnormal_results_by_total_number_of_exams?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  total_exams_next_year?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TAbsenceTypeResolvers<ContextType = any, ParentType extends TResolversParentTypes['AbsenceType'] = TResolversParentTypes['AbsenceType']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  referenceId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  suggestion?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TAccessTokenResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccessToken'] = TResolversParentTypes['AccessToken']> = ResolversObject<{
  apiAccessId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  token?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TAccidentResolvers<ContextType = any, ParentType extends TResolversParentTypes['Accident'] = TResolversParentTypes['Accident']> = ResolversObject<{
  accept?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  accidentBodyParts?: Resolver<Maybe<Array<TResolversTypes['AccidentBodyPart']>>, ParentType, ContextType>;
  accidentCode?: Resolver<Maybe<TResolversTypes['AccidentCode']>, ParentType, ContextType>;
  accidentExpenses?: Resolver<Maybe<Array<TResolversTypes['ExpenseOnAccident']>>, ParentType, ContextType>;
  accidentLocation?: Resolver<Maybe<TResolversTypes['AccidentLocation']>, ParentType, ContextType>;
  accidentPotential?: Resolver<Maybe<TResolversTypes['AccidentPotentialEnum']>, ParentType, ContextType>;
  accidentType?: Resolver<Maybe<TResolversTypes['AccidentType']>, ParentType, ContextType>;
  accidentTypeEnum?: Resolver<TResolversTypes['AccidentTypeEnum'], ParentType, ContextType>;
  accidentWitness?: Resolver<Maybe<Array<TResolversTypes['AccidentWitness']>>, ParentType, ContextType>;
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  bodyParts?: Resolver<Maybe<Array<TResolversTypes['BodyPartOnAccident']>>, ParentType, ContextType>;
  causerAgent?: Resolver<Maybe<Array<TResolversTypes['CauserAgentOnAccident']>>, ParentType, ContextType>;
  causerAgents?: Resolver<Maybe<Array<TResolversTypes['CauserAgentOnAccident']>>, ParentType, ContextType>;
  city?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  companyRegistration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  comunicationType?: Resolver<Maybe<TResolversTypes['ComunicationType']>, ParentType, ContextType>;
  conclusion?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  costCenter?: Resolver<Maybe<TResolversTypes['CostCenter']>, ParentType, ContextType>;
  country?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  daysLost?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  deathDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  distance?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  emissionDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  emitter?: Resolver<Maybe<TResolversTypes['Emitter']>, ParentType, ContextType>;
  emitterEmail?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  exitHour?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  expenseType?: Resolver<Maybe<TResolversTypes['AccidentExpenseType']>, ParentType, ContextType>;
  expenses?: Resolver<Maybe<Array<TResolversTypes['ExpenseOnAccident']>>, ParentType, ContextType>;
  hadPathChange?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  hasAbsence?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  icd?: Resolver<Maybe<TResolversTypes['Icd']>, ParentType, ContextType>;
  icdGroup?: Resolver<Maybe<TResolversTypes['IcdGroup']>, ParentType, ContextType>;
  icdGroupId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  icds?: Resolver<Maybe<Array<TResolversTypes['ComplementaryIcdOnAccident']>>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  injuryNature?: Resolver<Maybe<TResolversTypes['InjuryNature']>, ParentType, ContextType>;
  lastDayWork?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  locationDescription?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  locomotion?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  occurencePath?: Resolver<Maybe<TResolversTypes['OccurencePath']>, ParentType, ContextType>;
  originDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  originNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  otherOccupation?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  person?: Resolver<Maybe<TResolversTypes['Person']>, ParentType, ContextType>;
  policeRecord?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  publicPlace?: Resolver<Maybe<TResolversTypes['GenericPublicPlace']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  retired?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  serviceArea?: Resolver<Maybe<TResolversTypes['ServiceArea']>, ParentType, ContextType>;
  socialSecurityAffiliation?: Resolver<Maybe<TResolversTypes['SocialSecurityAffiliation']>, ParentType, ContextType>;
  socialSecurityCode?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  standarTime?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  streetNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  suggestion?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  summary?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  tag?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  timeWorked?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  trafficAccidentType?: Resolver<Maybe<TResolversTypes['TrafficAccidentType']>, ParentType, ContextType>;
  usualPath?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  willTransferSector?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  witnesses?: Resolver<Maybe<Array<TResolversTypes['WitnessOnAccident']>>, ParentType, ContextType>;
  workedHours?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  zipCode?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TAccidentAbsenceResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccidentAbsence'] = TResolversParentTypes['AccidentAbsence']> = ResolversObject<{
  absence?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  month?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  year?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TAccidentAmountResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccidentAmount'] = TResolversParentTypes['AccidentAmount']> = ResolversObject<{
  amount?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  month?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  year?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TAccidentAnalysisResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccidentAnalysis'] = TResolversParentTypes['AccidentAnalysis']> = ResolversObject<{
  cost_center?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  icd?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  total?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TAccidentBodyPartResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccidentBodyPart'] = TResolversParentTypes['AccidentBodyPart']> = ResolversObject<{
  bodyPart?: Resolver<TResolversTypes['BodyPart'], ParentType, ContextType>;
  isMain?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  laterality?: Resolver<Maybe<TResolversTypes['Laterality']>, ParentType, ContextType>;
}>;

export type TAccidentCauseResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccidentCause'] = TResolversParentTypes['AccidentCause']> = ResolversObject<{
  causeType?: Resolver<TResolversTypes['CauseType'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  referenceId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TAccidentCausesResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccidentCauses'] = TResolversParentTypes['AccidentCauses']> = ResolversObject<{
  causeType?: Resolver<TResolversTypes['CauseType'], ParentType, ContextType>;
  total?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TAccidentChartsResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccidentCharts'] = TResolversParentTypes['AccidentCharts']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  hasAccident?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  perTotal?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
}>;

export type TAccidentCodeResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccidentCode'] = TResolversParentTypes['AccidentCode']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  eSocialCode?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  suggestion?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TAccidentDashboardResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccidentDashboard'] = TResolversParentTypes['AccidentDashboard']> = ResolversObject<{
  accidentsESocialTypeChart?: Resolver<TResolversTypes['AccidentCharts'], ParentType, ContextType>;
  accidentsPerDayChart?: Resolver<TResolversTypes['AccidentsPerDayChart'], ParentType, ContextType>;
  accidentsPerMonthChart?: Resolver<TResolversTypes['AccidentsPerMonthChart'], ParentType, ContextType>;
  accidentsTagChart?: Resolver<TResolversTypes['AccidentCharts'], ParentType, ContextType>;
  accidentsTimeChart?: Resolver<TResolversTypes['AccidentsTimeChart'], ParentType, ContextType>;
  ageChart?: Resolver<TResolversTypes['AgeAccidentChart'], ParentType, ContextType>;
  bodyPartsChart?: Resolver<TResolversTypes['IndexChart'], ParentType, ContextType>;
  costPerTypeChart?: Resolver<TResolversTypes['CostPerTypeChart'], ParentType, ContextType>;
  daysWithoutAccidentChart?: Resolver<TResolversTypes['DaysWithoutAccidentChart'], ParentType, ContextType>;
  deathAccidentChart?: Resolver<TResolversTypes['IndexChart'], ParentType, ContextType>;
  expensiveAccidentsChart?: Resolver<TResolversTypes['ExpensiveAccidentsChart'], ParentType, ContextType>;
  frequencyIndexChart?: Resolver<TResolversTypes['IndexChart'], ParentType, ContextType>;
  injuryNatureChart?: Resolver<TResolversTypes['AccidentCharts'], ParentType, ContextType>;
  investigationAmountChart?: Resolver<TResolversTypes['InvestigationAmountChart'], ParentType, ContextType>;
  investigationIndicatorsChart?: Resolver<TResolversTypes['InvestigationIndicatorsChart'], ParentType, ContextType>;
  lostDaysCostCenterChart?: Resolver<TResolversTypes['AccidentCharts'], ParentType, ContextType>;
  lostIndexChart?: Resolver<TResolversTypes['IndexChart'], ParentType, ContextType>;
  relativeIndexChart?: Resolver<TResolversTypes['IndexChart'], ParentType, ContextType>;
  securityPyramid?: Resolver<TResolversTypes['SecurityPyramid'], ParentType, ContextType>;
  severityIndexChart?: Resolver<TResolversTypes['IndexChart'], ParentType, ContextType>;
  typeChart?: Resolver<TResolversTypes['TypeChart'], ParentType, ContextType>;
  typeCostCenterChart?: Resolver<TResolversTypes['TypeCostCenterChart'], ParentType, ContextType>;
}>;

export type TAccidentDescriptionResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccidentDescription'] = TResolversParentTypes['AccidentDescription']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  suggestion?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TAccidentExpenseAmountResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccidentExpenseAmount'] = TResolversParentTypes['AccidentExpenseAmount']> = ResolversObject<{
  amount?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  month?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  year?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TAccidentObjectResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccidentObject'] = TResolversParentTypes['AccidentObject']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  eSocialCode?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TAccidentTypeResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccidentType'] = TResolversParentTypes['AccidentType']> = ResolversObject<{
  eSocialCode?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupationalDesease?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  occupationalDeseaseDescription?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  suggestion?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  workAccident?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  workAccidentDescription?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TAccidentVictimResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccidentVictim'] = TResolversParentTypes['AccidentVictim']> = ResolversObject<{
  amount?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TAccidentWithInvestigationResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccidentWithInvestigation'] = TResolversParentTypes['AccidentWithInvestigation']> = ResolversObject<{
  accidentId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  accidentSuggestion?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  accidentTypeEnum?: Resolver<TResolversTypes['AccidentTypeEnum'], ParentType, ContextType>;
  date?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  dateAccident?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  dateInvestigation?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  defectiveEquipment?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  improvisation?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  investigationId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  knewNorms?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  personId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  personSuggestion?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  profilePicture?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  report?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  summary?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  trained?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  wasUsedEpi?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type TAccidentWitnessResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccidentWitness'] = TResolversParentTypes['AccidentWitness']> = ResolversObject<{
  accident?: Resolver<TResolversTypes['Accident'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  testimony?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TAccidentsPerDayChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccidentsPerDayChart'] = TResolversParentTypes['AccidentsPerDayChart']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['Float']>, ParentType, ContextType>;
  hasAccident?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  maxDataValue?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TAccidentsPerMonthChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccidentsPerMonthChart'] = TResolversParentTypes['AccidentsPerMonthChart']> = ResolversObject<{
  death?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  hasAccident?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  lessThanFifteen?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  moreThanFifteen?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  noVictim?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
}>;

export type TAccidentsTimeChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccidentsTimeChart'] = TResolversParentTypes['AccidentsTimeChart']> = ResolversObject<{
  afternoon?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  earlyMorning?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  evening?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  hasAccident?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  morning?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
}>;

export type TAccreditedResolvers<ContextType = any, ParentType extends TResolversParentTypes['Accredited'] = TResolversParentTypes['Accredited']> = ResolversObject<{
  address?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  branch?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  branchRef?: Resolver<Maybe<TResolversTypes['BranchWithOptionalOrganization']>, ParentType, ContextType>;
  city?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  cnpj?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  contractEnd?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  contractStart?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<TResolversTypes['AccreditedCreator'], ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  exams?: Resolver<Maybe<Array<TResolversTypes['AccreditedExam']>>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  neighborhood?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  providerBranch?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  providerBranchRef?: Resolver<Maybe<TResolversTypes['BranchWithOptionalOrganization']>, ParentType, ContextType>;
  telephone?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TAccreditedBillingResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccreditedBilling'] = TResolversParentTypes['AccreditedBilling']> = ResolversObject<{
  exam?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  examCost?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  realized?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  realizedBillings?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  scheduled?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  scheduledBillings?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  subject?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TAccreditedConsultationResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccreditedConsultation'] = TResolversParentTypes['AccreditedConsultation']> = ResolversObject<{
  consultationType?: Resolver<TResolversTypes['ConsultationType'], ParentType, ContextType>;
  examDescription?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  examId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  medicalRecordId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  patientId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  patientName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  patientPicture?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  previewDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
}>;

export type TAccreditedExamResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccreditedExam'] = TResolversParentTypes['AccreditedExam']> = ResolversObject<{
  contractEnd?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  contractStart?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  exam?: Resolver<TResolversTypes['Exam'], ParentType, ContextType>;
  examId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TAccreditedReportsParametersResolvers<ContextType = any, ParentType extends TResolversParentTypes['AccreditedReportsParameters'] = TResolversParentTypes['AccreditedReportsParameters']> = ResolversObject<{
  accreditedId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  branches?: Resolver<Maybe<Array<TResolversTypes['String']>>, ParentType, ContextType>;
  costCenters?: Resolver<Maybe<Array<TResolversTypes['String']>>, ParentType, ContextType>;
  exams?: Resolver<Maybe<Array<TResolversTypes['String']>>, ParentType, ContextType>;
  fromDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  natures?: Resolver<Maybe<Array<TResolversTypes['ConsultationNature']>>, ParentType, ContextType>;
  occupations?: Resolver<Maybe<Array<TResolversTypes['String']>>, ParentType, ContextType>;
  showsLate?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  showsNonRealized?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  showsRealized?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  situations?: Resolver<Maybe<Array<TResolversTypes['EmployeeSituation']>>, ParentType, ContextType>;
  toDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TAcknowledgmentFormReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['AcknowledgmentFormReport'] = TResolversParentTypes['AcknowledgmentFormReport']> = ResolversObject<{
  costCenter?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  deliveryAmount?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  deliveryReason?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  footer?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipeDescription?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  registration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TActionOnMeetingResolvers<ContextType = any, ParentType extends TResolversParentTypes['ActionOnMeeting'] = TResolversParentTypes['ActionOnMeeting']> = ResolversObject<{
  active?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  dateAction?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TActionPlanResolvers<ContextType = any, ParentType extends TResolversParentTypes['ActionPlan'] = TResolversParentTypes['ActionPlan']> = ResolversObject<{
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  currentValue?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  dateEnd?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  dateStart?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  detection?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  expectedCost?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  expectedGoals?: Resolver<Maybe<Array<TResolversTypes['ExpectedGoalOnActionPlan']>>, ParentType, ContextType>;
  goal?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  how?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  measure?: Resolver<TResolversTypes['Measure'], ParentType, ContextType>;
  measureType?: Resolver<TResolversTypes['MeasureType'], ParentType, ContextType>;
  microActions?: Resolver<Maybe<Array<TResolversTypes['ActionPlanMicroAction']>>, ParentType, ContextType>;
  observation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  probability?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  realCost?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  realGoals?: Resolver<Maybe<Array<TResolversTypes['RealGoalOnActionPlan']>>, ParentType, ContextType>;
  responsiblesAction?: Resolver<Maybe<Array<TResolversTypes['ResponsibleOnActionPlan']>>, ParentType, ContextType>;
  rpn?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  severity?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  situation?: Resolver<TResolversTypes['Situation'], ParentType, ContextType>;
  what?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  where?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  why?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TActionPlanConclusionChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['ActionPlanConclusionChart'] = TResolversParentTypes['ActionPlanConclusionChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['ActionPlanConclusionEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TActionPlanConclusionEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['ActionPlanConclusionEntry'] = TResolversParentTypes['ActionPlanConclusionEntry']> = ResolversObject<{
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TActionPlanCountResolvers<ContextType = any, ParentType extends TResolversParentTypes['ActionPlanCount'] = TResolversParentTypes['ActionPlanCount']> = ResolversObject<{
  situationA?: Resolver<TResolversTypes['SituationCount'], ParentType, ContextType>;
  situationB?: Resolver<TResolversTypes['SituationCount'], ParentType, ContextType>;
  situationC?: Resolver<TResolversTypes['SituationCount'], ParentType, ContextType>;
  situationD?: Resolver<TResolversTypes['SituationCount'], ParentType, ContextType>;
}>;

export type TActionPlanDashboardResolvers<ContextType = any, ParentType extends TResolversParentTypes['ActionPlanDashboard'] = TResolversParentTypes['ActionPlanDashboard']> = ResolversObject<{
  actionStatus?: Resolver<TResolversTypes['ActionPlanStatusChart'], ParentType, ContextType>;
  conclusion?: Resolver<TResolversTypes['ActionPlanConclusionChart'], ParentType, ContextType>;
  measurements?: Resolver<TResolversTypes['ActionPlanMeasurementsChart'], ParentType, ContextType>;
  microActionsByResponsible?: Resolver<TResolversTypes['ActionPlanParetoChart'], ParentType, ContextType>;
  microActionsByStatus?: Resolver<TResolversTypes['MicroActionStatusChart'], ParentType, ContextType>;
  plansByPriority?: Resolver<TResolversTypes['ActionPlanPriorityChart'], ParentType, ContextType>;
  plansByResponsible?: Resolver<TResolversTypes['ActionPlanParetoChart'], ParentType, ContextType>;
}>;

export type TActionPlanInvestigationResolvers<ContextType = any, ParentType extends TResolversParentTypes['ActionPlanInvestigation'] = TResolversParentTypes['ActionPlanInvestigation']> = ResolversObject<{
  actionPlanId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  investigationId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TActionPlanInvestigationSuggestionResolvers<ContextType = any, ParentType extends TResolversParentTypes['ActionPlanInvestigationSuggestion'] = TResolversParentTypes['ActionPlanInvestigationSuggestion']> = ResolversObject<{
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TActionPlanMeasurementEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['ActionPlanMeasurementEntry'] = TResolversParentTypes['ActionPlanMeasurementEntry']> = ResolversObject<{
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  planned?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  realized?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TActionPlanMeasurementsChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['ActionPlanMeasurementsChart'] = TResolversParentTypes['ActionPlanMeasurementsChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['ActionPlanMeasurementEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TActionPlanMicroActionResolvers<ContextType = any, ParentType extends TResolversParentTypes['ActionPlanMicroAction'] = TResolversParentTypes['ActionPlanMicroAction']> = ResolversObject<{
  actionPlanId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  dateEnd?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  percent?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  personRef?: Resolver<Maybe<TResolversTypes['Person']>, ParentType, ContextType>;
  responsibleId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<TResolversTypes['MicroActionStatus'], ParentType, ContextType>;
}>;

export type TActionPlanParetoChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['ActionPlanParetoChart'] = TResolversParentTypes['ActionPlanParetoChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['ActionPlanParetoEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TActionPlanParetoEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['ActionPlanParetoEntry'] = TResolversParentTypes['ActionPlanParetoEntry']> = ResolversObject<{
  cumulativePercent?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TActionPlanPriorityChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['ActionPlanPriorityChart'] = TResolversParentTypes['ActionPlanPriorityChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['ActionPlanPriorityEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TActionPlanPriorityEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['ActionPlanPriorityEntry'] = TResolversParentTypes['ActionPlanPriorityEntry']> = ResolversObject<{
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TActionPlanReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['ActionPlanReport'] = TResolversParentTypes['ActionPlanReport']> = ResolversObject<{
  actionPlanId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  environmentalReportId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TActionPlanReportSuggestionResolvers<ContextType = any, ParentType extends TResolversParentTypes['ActionPlanReportSuggestion'] = TResolversParentTypes['ActionPlanReportSuggestion']> = ResolversObject<{
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TActionPlanScheduleResolvers<ContextType = any, ParentType extends TResolversParentTypes['ActionPlanSchedule'] = TResolversParentTypes['ActionPlanSchedule']> = ResolversObject<{
  executed?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  planned?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  what?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TActionPlanStatusChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['ActionPlanStatusChart'] = TResolversParentTypes['ActionPlanStatusChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['ActionPlanStatusEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TActionPlanStatusEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['ActionPlanStatusEntry'] = TResolversParentTypes['ActionPlanStatusEntry']> = ResolversObject<{
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TActivityGroupResolvers<ContextType = any, ParentType extends TResolversParentTypes['ActivityGroup'] = TResolversParentTypes['ActivityGroup']> = ResolversObject<{
  cipaCode?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  code?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  riskDegree?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TActivityIcdResolvers<ContextType = any, ParentType extends TResolversParentTypes['ActivityIcd'] = TResolversParentTypes['ActivityIcd']> = ResolversObject<{
  economicActivity?: Resolver<TResolversTypes['EconomicActivity'], ParentType, ContextType>;
  icdGroupEnd?: Resolver<TResolversTypes['IcdGroup'], ParentType, ContextType>;
  icdGroupStart?: Resolver<TResolversTypes['IcdGroup'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TAdditionalDataResolvers<ContextType = any, ParentType extends TResolversParentTypes['AdditionalData'] = TResolversParentTypes['AdditionalData']> = ResolversObject<{
  field?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TAgeAccidentChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['AgeAccidentChart'] = TResolversParentTypes['AgeAccidentChart']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['DivergingStackedBarChart']>, ParentType, ContextType>;
  hasAccident?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TAgeChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['AgeChart'] = TResolversParentTypes['AgeChart']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TAgeRangeResolvers<ContextType = any, ParentType extends TResolversParentTypes['AgeRange'] = TResolversParentTypes['AgeRange']> = ResolversObject<{
  fromAge?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  periodicRangeId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  periodicity?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  toAge?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TAgeRangeEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['AgeRangeEntry'] = TResolversParentTypes['AgeRangeEntry']> = ResolversObject<{
  fromAge?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  periodicity?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  toAge?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TAgentBonusChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['AgentBonusChart'] = TResolversParentTypes['AgentBonusChart']> = ResolversObject<{
  forty?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  hasRisk?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  notExposed?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  notTypify?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  ten?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  thirty?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  twenty?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TAgentGroupChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['AgentGroupChart'] = TResolversParentTypes['AgentGroupChart']> = ResolversObject<{
  association?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  biological?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  chemical?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  dangerous?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  ergonomic?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  hasRisk?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  mechanical?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  other?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  physical?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TAgreementResolvers<ContextType = any, ParentType extends TResolversParentTypes['Agreement'] = TResolversParentTypes['Agreement']> = ResolversObject<{
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  ipAddress?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  terms?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  userAgent?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TAllowanceTypeResolvers<ContextType = any, ParentType extends TResolversParentTypes['AllowanceType'] = TResolversParentTypes['AllowanceType']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  suggestion?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TAnalysisResolvers<ContextType = any, ParentType extends TResolversParentTypes['Analysis'] = TResolversParentTypes['Analysis']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  examMeasure?: Resolver<Maybe<TResolversTypes['ExamMeasure']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  references?: Resolver<Maybe<Array<TResolversTypes['References']>>, ParentType, ContextType>;
}>;

export type TAnnualDeliveryVariationChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['AnnualDeliveryVariationChart'] = TResolversParentTypes['AnnualDeliveryVariationChart']> = ResolversObject<{
  currentDeliveries?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  currentPeople?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  hasPrevious?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  previousDeliveries?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  previousPeople?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  variationPct?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TApiAccessResolvers<ContextType = any, ParentType extends TResolversParentTypes['ApiAccess'] = TResolversParentTypes['ApiAccess']> = ResolversObject<{
  accessKey?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  accessSecret?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TAsaasCreditCardTokenResolvers<ContextType = any, ParentType extends TResolversParentTypes['AsaasCreditCardToken'] = TResolversParentTypes['AsaasCreditCardToken']> = ResolversObject<{
  ccv?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  expiryMonth?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  expiryYear?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  holderName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  number?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TAsoEvolutionEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['AsoEvolutionEntry'] = TResolversParentTypes['AsoEvolutionEntry']> = ResolversObject<{
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  nature?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  recommendation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TAsoNatureChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['AsoNatureChart'] = TResolversParentTypes['AsoNatureChart']> = ResolversObject<{
  admission?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  backToWork?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  changeOfFunction?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  dismissal?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  hasOccupational?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  periodic?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  spotMonitoring?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TAsoQuantityChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['AsoQuantityChart'] = TResolversParentTypes['AsoQuantityChart']> = ResolversObject<{
  expected?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  hasOccupational?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  realized?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
}>;

export type TAsoSituationChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['AsoSituationChart'] = TResolversParentTypes['AsoSituationChart']> = ResolversObject<{
  hasConsultation?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  late?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  toExpire?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  upToDate?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TAttachmentResolvers<ContextType = any, ParentType extends TResolversParentTypes['Attachment'] = TResolversParentTypes['Attachment']> = ResolversObject<{
  contentLength?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  contentType?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  filename?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isSignDocument?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  uploadUrl?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  uploadedBy?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<TResolversTypes['S3UrlCloudFront'], ParentType, ContextType>;
}>;

export type TAttachmentDtoResolvers<ContextType = any, ParentType extends TResolversParentTypes['AttachmentDTO'] = TResolversParentTypes['AttachmentDTO']> = ResolversObject<{
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  error?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  key?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  queueId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['Status'], ParentType, ContextType>;
  updatedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type TAudiometryClassificationChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['AudiometryClassificationChart'] = TResolversParentTypes['AudiometryClassificationChart']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['PieChart']>, ParentType, ContextType>;
}>;

export type TAudiometryCostCenterChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['AudiometryCostCenterChart'] = TResolversParentTypes['AudiometryCostCenterChart']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
}>;

export type TAudiometryDashboardResolvers<ContextType = any, ParentType extends TResolversParentTypes['AudiometryDashboard'] = TResolversParentTypes['AudiometryDashboard']> = ResolversObject<{
  classificationChart?: Resolver<TResolversTypes['AudiometryClassificationChart'], ParentType, ContextType>;
  costCenterChart?: Resolver<TResolversTypes['AudiometryCostCenterChart'], ParentType, ContextType>;
  evolutionChart?: Resolver<TResolversTypes['AudiometryEvolutionChart'], ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  pcaChart?: Resolver<TResolversTypes['AudiometryPcaChart'], ParentType, ContextType>;
  yearComparisonChart?: Resolver<TResolversTypes['AudiometryYearComparisonChart'], ParentType, ContextType>;
}>;

export type TAudiometryEvolutionChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['AudiometryEvolutionChart'] = TResolversParentTypes['AudiometryEvolutionChart']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['LineChart']>, ParentType, ContextType>;
}>;

export type TAudiometryPcaChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['AudiometryPcaChart'] = TResolversParentTypes['AudiometryPcaChart']> = ResolversObject<{
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  inPca?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  outPca?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TAudiometryYearComparisonChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['AudiometryYearComparisonChart'] = TResolversParentTypes['AudiometryYearComparisonChart']> = ResolversObject<{
  categories?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  currentYear?: Resolver<Array<TResolversTypes['Float']>, ParentType, ContextType>;
  currentYearLabel?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  previousYear?: Resolver<Array<TResolversTypes['Float']>, ParentType, ContextType>;
  previousYearLabel?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TAuditLogChangeResolvers<ContextType = any, ParentType extends TResolversParentTypes['AuditLogChange'] = TResolversParentTypes['AuditLogChange']> = ResolversObject<{
  field?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  from?: Resolver<Maybe<TResolversTypes['JSON']>, ParentType, ContextType>;
  masked?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  to?: Resolver<Maybe<TResolversTypes['JSON']>, ParentType, ContextType>;
}>;

export type TAuditLogDetailsDtoResolvers<ContextType = any, ParentType extends TResolversParentTypes['AuditLogDetailsDto'] = TResolversParentTypes['AuditLogDetailsDto']> = ResolversObject<{
  changes?: Resolver<Maybe<Array<TResolversTypes['AuditLogChange']>>, ParentType, ContextType>;
  metadata?: Resolver<Maybe<TResolversTypes['JSON']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  snapshot?: Resolver<Maybe<TResolversTypes['JSON']>, ParentType, ContextType>;
  softDelete?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type TAuditLogEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['AuditLogEntry'] = TResolversParentTypes['AuditLogEntry']> = ResolversObject<{
  action?: Resolver<TResolversTypes['AuditAction'], ParentType, ContextType>;
  branch?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  cascadeParentId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  details?: Resolver<Maybe<TResolversTypes['AuditLogDetailsDto']>, ParentType, ContextType>;
  entityId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  entityType?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipAddress?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  userAgent?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TAuditLogExportRequestResolvers<ContextType = any, ParentType extends TResolversParentTypes['AuditLogExportRequest'] = TResolversParentTypes['AuditLogExportRequest']> = ResolversObject<{
  format?: Resolver<TResolversTypes['AuditExportFormat'], ParentType, ContextType>;
  recipientEmail?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  requestedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['AuditExportStatus'], ParentType, ContextType>;
}>;

export type TAvailabilityChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['AvailabilityChart'] = TResolversParentTypes['AvailabilityChart']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  hasIpeDeliveries?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TBaseDocumentResponseResolvers<ContextType = any, ParentType extends TResolversParentTypes['BaseDocumentResponse'] = TResolversParentTypes['BaseDocumentResponse']> = ResolversObject<{
  attachmentId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  certificateId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  documentId?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  isEmbedded?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  pending?: Resolver<Maybe<Array<TResolversTypes['DocumentPending']>>, ParentType, ContextType>;
  status?: Resolver<Maybe<TResolversTypes['DocumentStatus']>, ParentType, ContextType>;
}>;

export type TBaseFeatureReturnResolvers<ContextType = any, ParentType extends TResolversParentTypes['BaseFeatureReturn'] = TResolversParentTypes['BaseFeatureReturn']> = ResolversObject<{
  removedFlags?: Resolver<Array<TResolversTypes['Flag']>, ParentType, ContextType>;
  updatedFlags?: Resolver<Array<TResolversTypes['Flag']>, ParentType, ContextType>;
}>;

export type TBaseFlagReturnResolvers<ContextType = any, ParentType extends TResolversParentTypes['BaseFlagReturn'] = TResolversParentTypes['BaseFlagReturn']> = ResolversObject<{
  flags?: Resolver<Array<TResolversTypes['Flag']>, ParentType, ContextType>;
}>;

export type TBiologicMonitoringResolvers<ContextType = any, ParentType extends TResolversParentTypes['BiologicMonitoring'] = TResolversParentTypes['BiologicMonitoring']> = ResolversObject<{
  accidentDate?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  addressCodePerson?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  addressPerson?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  age?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  agent?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  apron?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  birthDate?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  boot?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  cepPerson?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  circumstance?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  cityAccident?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  cityPerson?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  codeLocal?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  colorRace?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  companyAddress?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  companyCity?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  companyCnae?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  companyDistrict?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  companyIbge?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  companyInfo?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  companyName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  companyNeighborhood?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  companyNumber?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  companyReference?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  companyTelephone?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  companyUf?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  complementPerson?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  conductAZT3TC?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  conductAZT3TCIndinavir?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  conductAZT3TCNelfinavir?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  conductImunoglobulin?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  conductNotIndication?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  conductOther?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  conductOtherDescription?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  conductRefuse?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  conductVaccine?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  countryPerson?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  deathDate?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  districtPerson?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  documentNumber?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  educationLevel?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  evolution?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  examAntiHBc?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  examAntiHCV?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  examAntiHIV?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  examHbsAg?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  expositionComplement?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  expositionIntactSkin?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  expositionMucosa?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  expositionNonIntactSkin?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  expositionOther?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  expositionPercutaneous?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  facialProtection?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  gender?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  geographicZonePerson?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  geographicZonePersonTwo?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  glasses?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  gloves?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  hasCat?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ibgeAccident?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  ibgePerson?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  icdCode?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  localMedical?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  mask?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  materialComplement?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  materialType?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  mothersName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  neighborhoodPerson?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  notificationDate?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  numberPerson?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupationCode?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  personName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  pregnant?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  referencePerson?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  source?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  sourceExamAntiHBc?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  sourceExamAntiHCV?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  sourceExamAntiHIV?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  sourceExamHbsAg?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  susNumber?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  telephonePerson?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  timeWork?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  ufAccident?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  ufPerson?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  vaccine?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  zone?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TBiologicalExamsResolvers<ContextType = any, ParentType extends TResolversParentTypes['BiologicalExams'] = TResolversParentTypes['BiologicalExams']> = ResolversObject<{
  firstConsultation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  secondConsultation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  zeroDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TBiologicalMonitoringResolvers<ContextType = any, ParentType extends TResolversParentTypes['BiologicalMonitoring'] = TResolversParentTypes['BiologicalMonitoring']> = ResolversObject<{
  accident?: Resolver<TResolversTypes['Accident'], ParentType, ContextType>;
  accredited?: Resolver<Maybe<TResolversTypes['Accredited']>, ParentType, ContextType>;
  biologicalMonitoringAgent?: Resolver<Maybe<TResolversTypes['BiologicalMonitoringAgent']>, ParentType, ContextType>;
  circumstance?: Resolver<Maybe<TResolversTypes['AccidentCircumstance']>, ParentType, ContextType>;
  complementaryConduction?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  complementaryMaterial?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  complementaryType?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  conduction?: Resolver<Maybe<TResolversTypes['AccidentConduction']>, ParentType, ContextType>;
  exposureType?: Resolver<Maybe<TResolversTypes['AccidentExposureType']>, ParentType, ContextType>;
  hasFinishedExam?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  monitoringExamGroup?: Resolver<Maybe<TResolversTypes['BiologicalMonitoringExamGroup']>, ParentType, ContextType>;
  organicMaterial?: Resolver<Maybe<TResolversTypes['OrganicMaterial']>, ParentType, ContextType>;
  originPerson?: Resolver<Maybe<TResolversTypes['Person']>, ParentType, ContextType>;
  responsibleDoctor?: Resolver<Maybe<TResolversTypes['Person']>, ParentType, ContextType>;
}>;

export type TBiologicalMonitoringCommonResolvers<ContextType = any, ParentType extends TResolversParentTypes['BiologicalMonitoringCommon'] = TResolversParentTypes['BiologicalMonitoringCommon']> = ResolversObject<{
  accidentDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  costCenter?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  expositionType?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  workShift?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TBiologicalMonitoringExamResolvers<ContextType = any, ParentType extends TResolversParentTypes['BiologicalMonitoringExam'] = TResolversParentTypes['BiologicalMonitoringExam']> = ResolversObject<{
  exam?: Resolver<TResolversTypes['Exam'], ParentType, ContextType>;
  group?: Resolver<TResolversTypes['BiologicalMonitoringExamGroup'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  referenceId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  secondExamInterval?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  thirdExamInterval?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TBiologicalMonitoringExamGroupResolvers<ContextType = any, ParentType extends TResolversParentTypes['BiologicalMonitoringExamGroup'] = TResolversParentTypes['BiologicalMonitoringExamGroup']> = ResolversObject<{
  biologicalExams?: Resolver<Maybe<Array<TResolversTypes['BiologicalMonitoringExam']>>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  referenceId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TBiologicalMonitoringProtocolResolvers<ContextType = any, ParentType extends TResolversParentTypes['BiologicalMonitoringProtocol'] = TResolversParentTypes['BiologicalMonitoringProtocol']> = ResolversObject<{
  accidentDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  costCenter?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  exams?: Resolver<Maybe<Array<TResolversTypes['BiologicalMonitoringProtocolExams']>>, ParentType, ContextType>;
  expositionType?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  workShift?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TBiologicalMonitoringProtocolExamsResolvers<ContextType = any, ParentType extends TResolversParentTypes['BiologicalMonitoringProtocolExams'] = TResolversParentTypes['BiologicalMonitoringProtocolExams']> = ResolversObject<{
  exam?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TBiologicalMonitoringProtocolParamsResolvers<ContextType = any, ParentType extends TResolversParentTypes['BiologicalMonitoringProtocolParams'] = TResolversParentTypes['BiologicalMonitoringProtocolParams']> = ResolversObject<{
  statementsResponsibility?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TBiologicalMonitoringReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['BiologicalMonitoringReport'] = TResolversParentTypes['BiologicalMonitoringReport']> = ResolversObject<{
  accidentDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  costCenter?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  examDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  examName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  expositionType?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  workShift?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TBiologicalProtocolResolvers<ContextType = any, ParentType extends TResolversParentTypes['BiologicalProtocol'] = TResolversParentTypes['BiologicalProtocol']> = ResolversObject<{
  complement?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  costCenter?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  exams?: Resolver<Array<TResolversTypes['ExamPerson']>, ParentType, ContextType>;
  exposition?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  individualRegistration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occurrenceDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  registration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  source?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  workShift?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TBiologicalReleaseResolvers<ContextType = any, ParentType extends TResolversParentTypes['BiologicalRelease'] = TResolversParentTypes['BiologicalRelease']> = ResolversObject<{
  accidentDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  crm?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  doctorName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  individualRegistration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  releaseDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TBiometryResolvers<ContextType = any, ParentType extends TResolversParentTypes['Biometry'] = TResolversParentTypes['Biometry']> = ResolversObject<{
  bmp?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  finger?: Resolver<TResolversTypes['Fingers'], ParentType, ContextType>;
  fingerHand?: Resolver<TResolversTypes['FingerHand'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  imageData?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  imageDpi?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  imageHeight?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  imageQuality?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  imageWidth?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  manufacturer?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  model?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  nfiq?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  serialNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  template?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  wsqImage?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  wsqImageSize?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TBloodTypeChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['BloodTypeChart'] = TResolversParentTypes['BloodTypeChart']> = ResolversObject<{
  aNegative?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  aPositive?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  abNegative?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  abPositive?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  bNegative?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  bPositive?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  na?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  oNegative?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  oPositive?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TBodyPartResolvers<ContextType = any, ParentType extends TResolversParentTypes['BodyPart'] = TResolversParentTypes['BodyPart']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  eSocialCode?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TBodyPartOnAccidentResolvers<ContextType = any, ParentType extends TResolversParentTypes['BodyPartOnAccident'] = TResolversParentTypes['BodyPartOnAccident']> = ResolversObject<{
  eSocialCode?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  isMain?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  laterality?: Resolver<Maybe<TResolversTypes['Laterality']>, ParentType, ContextType>;
}>;

export type TBranchResolvers<ContextType = any, ParentType extends TResolversParentTypes['Branch'] = TResolversParentTypes['Branch']> = ResolversObject<{
  activityType?: Resolver<Maybe<TResolversTypes['ActivityType']>, ParentType, ContextType>;
  biometryEquipment?: Resolver<Maybe<TResolversTypes['BiometryEquipment']>, ParentType, ContextType>;
  city?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  crons?: Resolver<Maybe<Array<TResolversTypes['CronTab']>>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  documentNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  economicActivity?: Resolver<Maybe<TResolversTypes['EconomicActivity']>, ParentType, ContextType>;
  economicActivityId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  endpoints?: Resolver<Array<TResolversTypes['Endpoint']>, ParentType, ContextType>;
  environmentDocument?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  esocialSendDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  esocialSendDateEnd?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  neighborhood?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  settings?: Resolver<Maybe<TResolversTypes['Settings']>, ParentType, ContextType>;
  state?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  timeZone?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  zipCode?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TBranchTtalkInfoResolvers<ContextType = any, ParentType extends TResolversParentTypes['BranchTtalkInfo'] = TResolversParentTypes['BranchTtalkInfo']> = ResolversObject<{
  branchId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  branchName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  hasActiveTtalkEndpoint?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TBranchWithOptionalOrganizationResolvers<ContextType = any, ParentType extends TResolversParentTypes['BranchWithOptionalOrganization'] = TResolversParentTypes['BranchWithOptionalOrganization']> = ResolversObject<{
  activityType?: Resolver<Maybe<TResolversTypes['ActivityType']>, ParentType, ContextType>;
  biometryEquipment?: Resolver<Maybe<TResolversTypes['BiometryEquipment']>, ParentType, ContextType>;
  city?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  crons?: Resolver<Maybe<Array<TResolversTypes['CronTab']>>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  documentNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  economicActivity?: Resolver<Maybe<TResolversTypes['EconomicActivity']>, ParentType, ContextType>;
  economicActivityId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  endpoints?: Resolver<Array<TResolversTypes['Endpoint']>, ParentType, ContextType>;
  environmentDocument?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  esocialSendDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  esocialSendDateEnd?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  neighborhood?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  organization?: Resolver<Maybe<TResolversTypes['Organization']>, ParentType, ContextType>;
  organizationId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  settings?: Resolver<Maybe<TResolversTypes['Settings']>, ParentType, ContextType>;
  state?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  timeZone?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  zipCode?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TBranchWithOrganizationResolvers<ContextType = any, ParentType extends TResolversParentTypes['BranchWithOrganization'] = TResolversParentTypes['BranchWithOrganization']> = ResolversObject<{
  activityType?: Resolver<Maybe<TResolversTypes['ActivityType']>, ParentType, ContextType>;
  biometryEquipment?: Resolver<Maybe<TResolversTypes['BiometryEquipment']>, ParentType, ContextType>;
  city?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  crons?: Resolver<Maybe<Array<TResolversTypes['CronTab']>>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  documentNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  economicActivity?: Resolver<Maybe<TResolversTypes['EconomicActivity']>, ParentType, ContextType>;
  economicActivityId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  endpoints?: Resolver<Array<TResolversTypes['Endpoint']>, ParentType, ContextType>;
  environmentDocument?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  esocialSendDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  esocialSendDateEnd?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  neighborhood?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  organization?: Resolver<TResolversTypes['Organization'], ParentType, ContextType>;
  organizationId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  settings?: Resolver<Maybe<TResolversTypes['Settings']>, ParentType, ContextType>;
  state?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  timeZone?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  zipCode?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TBulkSyncRunResolvers<ContextType = any, ParentType extends TResolversParentTypes['BulkSyncRun'] = TResolversParentTypes['BulkSyncRun']> = ResolversObject<{
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  finishedAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  lastHeartbeatAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  organization?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  startedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  startedByUser?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['BulkSyncRunStatus'], ParentType, ContextType>;
  summary?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  totalBranches?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  totalEntities?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type TCaInUseChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['CaInUseChart'] = TResolversParentTypes['CaInUseChart']> = ResolversObject<{
  hasIpeDeliveries?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  overdue?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  toExpire?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  valid?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TCalendarResolvers<ContextType = any, ParentType extends TResolversParentTypes['Calendar'] = TResolversParentTypes['Calendar']> = ResolversObject<{
  calendarWorkShifts?: Resolver<Array<TResolversTypes['CalendarWorkShift']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TCalendarWorkShiftResolvers<ContextType = any, ParentType extends TResolversParentTypes['CalendarWorkShift'] = TResolversParentTypes['CalendarWorkShift']> = ResolversObject<{
  calendarId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  end?: Resolver<TResolversTypes['TimePoint'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  start?: Resolver<TResolversTypes['TimePoint'], ParentType, ContextType>;
}>;

export type TCalendarWorkShiftEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['CalendarWorkShiftEntry'] = TResolversParentTypes['CalendarWorkShiftEntry']> = ResolversObject<{
  end?: Resolver<TResolversTypes['TimePoint'], ParentType, ContextType>;
  start?: Resolver<TResolversTypes['TimePoint'], ParentType, ContextType>;
}>;

export type TCandidateResolvers<ContextType = any, ParentType extends TResolversParentTypes['Candidate'] = TResolversParentTypes['Candidate']> = ResolversObject<{
  errorIntegration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  mandate?: Resolver<TResolversTypes['Mandate'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  reason?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  stabilityType?: Resolver<Maybe<TResolversTypes['StabilityType']>, ParentType, ContextType>;
}>;

export type TCandidateByMandateResolvers<ContextType = any, ParentType extends TResolversParentTypes['CandidateByMandate'] = TResolversParentTypes['CandidateByMandate']> = ResolversObject<{
  errorIntegration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  mandateId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['PersonByMandate'], ParentType, ContextType>;
  reason?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  stabilityType?: Resolver<Maybe<TResolversTypes['StabilityType']>, ParentType, ContextType>;
  votes?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TCategoriesChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['CategoriesChart'] = TResolversParentTypes['CategoriesChart']> = ResolversObject<{
  breathProtection?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  eyeFaceProtection?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  fallProtection?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  fullBodyProtection?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  hasIpeDeliveries?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  headProtection?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  hearingProtection?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  lowerLimbProtection?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  other?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  trunkProtection?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  upperLimbProtection?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TCategorizedInputDataResolvers<ContextType = any, ParentType extends TResolversParentTypes['CategorizedInputData'] = TResolversParentTypes['CategorizedInputData']> = ResolversObject<{
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  options?: Resolver<Array<TResolversTypes['InputData']>, ParentType, ContextType>;
}>;

export type TCauserAgentResolvers<ContextType = any, ParentType extends TResolversParentTypes['CauserAgent'] = TResolversParentTypes['CauserAgent']> = ResolversObject<{
  accident?: Resolver<TResolversTypes['Accident'], ParentType, ContextType>;
  accidentObject?: Resolver<TResolversTypes['AccidentObject'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TCauserAgentOnAccidentResolvers<ContextType = any, ParentType extends TResolversParentTypes['CauserAgentOnAccident'] = TResolversParentTypes['CauserAgentOnAccident']> = ResolversObject<{
  accidentObject?: Resolver<TResolversTypes['AccidentObject'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isMain?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type TCausesResolvers<ContextType = any, ParentType extends TResolversParentTypes['Causes'] = TResolversParentTypes['Causes']> = ResolversObject<{
  defectiveEquipment?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  improvisation?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  knewNorms?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  trained?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  wasUsedEpi?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TCertificatePerDayChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['CertificatePerDayChart'] = TResolversParentTypes['CertificatePerDayChart']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['Float']>, ParentType, ContextType>;
  hasCertificate?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  maxDataValue?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TCertificatesRankingDashboardResolvers<ContextType = any, ParentType extends TResolversParentTypes['CertificatesRankingDashboard'] = TResolversParentTypes['CertificatesRankingDashboard']> = ResolversObject<{
  employeeRanking?: Resolver<Array<TResolversTypes['Ranking']>, ParentType, ContextType>;
  occupationRanking?: Resolver<Array<TResolversTypes['Ranking']>, ParentType, ContextType>;
}>;

export type TChartDataResolvers<ContextType = any, ParentType extends TResolversParentTypes['ChartData'] = TResolversParentTypes['ChartData']> = ResolversObject<{
  certificateCountData?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  daysPerHC?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  hasCertificate?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  lostDayData?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  peopleCountData?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
}>;

export type TCheckTableDataResolvers<ContextType = any, ParentType extends TResolversParentTypes['CheckTableData'] = TResolversParentTypes['CheckTableData']> = ResolversObject<{
  entity?: Resolver<TResolversTypes['CsvImports'], ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TChecklistResolvers<ContextType = any, ParentType extends TResolversParentTypes['Checklist'] = TResolversParentTypes['Checklist']> = ResolversObject<{
  clinicalQuizzes?: Resolver<Maybe<Array<TResolversTypes['ClinicalQuiz']>>, ParentType, ContextType>;
  costCenters?: Resolver<Maybe<Array<TResolversTypes['QuizCostCenter']>>, ParentType, ContextType>;
  departments?: Resolver<Maybe<Array<TResolversTypes['QuizDepartment']>>, ParentType, ContextType>;
  generatingSources?: Resolver<Maybe<Array<TResolversTypes['QuizGeneratingSource']>>, ParentType, ContextType>;
  occupations?: Resolver<Maybe<Array<TResolversTypes['QuizOccupation']>>, ParentType, ContextType>;
  people?: Resolver<Maybe<Array<TResolversTypes['QuizPerson']>>, ParentType, ContextType>;
  physicalEnvironments?: Resolver<Maybe<Array<TResolversTypes['QuizPhysicalEnvironment']>>, ParentType, ContextType>;
  safetyQuizzes?: Resolver<Maybe<Array<TResolversTypes['SafetyQuiz']>>, ParentType, ContextType>;
}>;

export type TChemicalRiskResolvers<ContextType = any, ParentType extends TResolversParentTypes['ChemicalRisk'] = TResolversParentTypes['ChemicalRisk']> = ResolversObject<{
  descriptionCC?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  descriptionOcup?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  descriptionRA?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TClassificationPureResolvers<ContextType = any, ParentType extends TResolversParentTypes['ClassificationPure'] = TResolversParentTypes['ClassificationPure']> = ResolversObject<{
  data?: Resolver<Array<Array<TResolversTypes['Int']>>, ParentType, ContextType>;
  hasRisk?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TClinicalQuizResolvers<ContextType = any, ParentType extends TResolversParentTypes['ClinicalQuiz'] = TResolversParentTypes['ClinicalQuiz']> = ResolversObject<{
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  medicalRecord?: Resolver<TResolversTypes['MedicalRecord'], ParentType, ContextType>;
  personId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  quiz?: Resolver<TResolversTypes['Quiz'], ParentType, ContextType>;
  realizationDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  responses?: Resolver<Array<TResolversTypes['ResponsesClinicalQuiz']>, ParentType, ContextType>;
}>;

export type TCollisionReturnResolvers<ContextType = any, ParentType extends TResolversParentTypes['CollisionReturn'] = TResolversParentTypes['CollisionReturn']> = ResolversObject<{
  feature?: Resolver<TResolversTypes['Feature'], ParentType, ContextType>;
  flags?: Resolver<Array<TResolversTypes['FlagRelation']>, ParentType, ContextType>;
}>;

export type TComparativeResultsDashboardResolvers<ContextType = any, ParentType extends TResolversParentTypes['ComparativeResultsDashboard'] = TResolversParentTypes['ComparativeResultsDashboard']> = ResolversObject<{
  asoEvolution?: Resolver<Array<TResolversTypes['AsoEvolutionEntry']>, ParentType, ContextType>;
  examAlterationTrend?: Resolver<Array<TResolversTypes['ExamAlterationTrend']>, ParentType, ContextType>;
  examDiagnosticCount?: Resolver<Array<TResolversTypes['ExamDiagnosticCount']>, ParentType, ContextType>;
  examTimeline?: Resolver<Array<TResolversTypes['ExamTimelineEntry']>, ParentType, ContextType>;
}>;

export type TComplementaryExamResolvers<ContextType = any, ParentType extends TResolversParentTypes['ComplementaryExam'] = TResolversParentTypes['ComplementaryExam']> = ResolversObject<{
  accredited?: Resolver<Maybe<TResolversTypes['Accredited']>, ParentType, ContextType>;
  consultation?: Resolver<TResolversTypes['Consultation'], ParentType, ContextType>;
  exam?: Resolver<TResolversTypes['Exam'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  monitoringRepetition?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TComplementaryExamsResolvers<ContextType = any, ParentType extends TResolversParentTypes['ComplementaryExams'] = TResolversParentTypes['ComplementaryExams']> = ResolversObject<{
  date?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  exam?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TComplementaryIcdResolvers<ContextType = any, ParentType extends TResolversParentTypes['ComplementaryIcd'] = TResolversParentTypes['ComplementaryIcd']> = ResolversObject<{
  accident?: Resolver<TResolversTypes['Accident'], ParentType, ContextType>;
  icd?: Resolver<TResolversTypes['Icd'], ParentType, ContextType>;
  icdGroup?: Resolver<TResolversTypes['IcdGroup'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TComplementaryIcdOnAccidentResolvers<ContextType = any, ParentType extends TResolversParentTypes['ComplementaryIcdOnAccident'] = TResolversParentTypes['ComplementaryIcdOnAccident']> = ResolversObject<{
  icd?: Resolver<Maybe<TResolversTypes['Icd']>, ParentType, ContextType>;
  icdGroup?: Resolver<Maybe<TResolversTypes['IcdGroup']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TComplementaryIcdOnDiagnosticResolvers<ContextType = any, ParentType extends TResolversParentTypes['ComplementaryIcdOnDiagnostic'] = TResolversParentTypes['ComplementaryIcdOnDiagnostic']> = ResolversObject<{
  icd?: Resolver<Maybe<TResolversTypes['Icd']>, ParentType, ContextType>;
  icdGroup?: Resolver<Maybe<TResolversTypes['IcdGroup']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TComponentResolvers<ContextType = any, ParentType extends TResolversParentTypes['Component'] = TResolversParentTypes['Component']> = ResolversObject<{
  active?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  componentType?: Resolver<TResolversTypes['ComponentType'], ParentType, ContextType>;
  errorIntegration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  indication?: Resolver<TResolversTypes['Indication'], ParentType, ContextType>;
  mandate?: Resolver<TResolversTypes['Mandate'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  reason?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  specificFunction?: Resolver<TResolversTypes['SpecificFunction'], ParentType, ContextType>;
  stabilityType?: Resolver<Maybe<TResolversTypes['StabilityType']>, ParentType, ContextType>;
  unjustifiedAbsenceCount?: Resolver<Maybe<TResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type TComponentActiveStatusEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['ComponentActiveStatusEntry'] = TResolversParentTypes['ComponentActiveStatusEntry']> = ResolversObject<{
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TConfirmImportResolvers<ContextType = any, ParentType extends TResolversParentTypes['ConfirmImport'] = TResolversParentTypes['ConfirmImport']> = ResolversObject<{
  importId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  totalRows?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TConsultReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['ConsultReport'] = TResolversParentTypes['ConsultReport']> = ResolversObject<{
  address?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  alcoholism?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  alcoholismDetails?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  amountConsumed?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  attendance?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  attendanceBr?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  birthday?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  bloodDonator?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  bloodType?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  chronicDiseaseOrTreatment?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  chronicDiseaseOrTreatmentDetails?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  complaint?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  complementaryICD?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  consultationHeight?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  consultationType?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  consultationWeight?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  controlledMedication?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  controlledMedicationDetails?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  diagnostic?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  diagnosticBr?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  diastolicPressure?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  doctorCRM?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctorName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctorRqeDisplay?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  exams?: Resolver<Array<TResolversTypes['ExamReport']>, ParentType, ContextType>;
  footer?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  gender?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  height?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  icd?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  icdName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  implantation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  meds?: Resolver<Array<TResolversTypes['MedConsultReport']>, ParentType, ContextType>;
  mentalHealthFollowUp?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  mentalHealthFollowUpDetails?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  neighborhood?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupational?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  physicalActivity?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  physicalActivityDetails?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  smoker?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  systolicPressure?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  tamagistPeriod?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  triageResponsibleDocument?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  triageResponsibleName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  weight?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TConsultationResolvers<ContextType = any, ParentType extends TResolversParentTypes['Consultation'] = TResolversParentTypes['Consultation']> = ResolversObject<{
  accident?: Resolver<Maybe<TResolversTypes['Accident']>, ParentType, ContextType>;
  accredited?: Resolver<Maybe<TResolversTypes['Accredited']>, ParentType, ContextType>;
  attended?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  cExmRefId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  clinicalQuiz?: Resolver<Maybe<TResolversTypes['ClinicalQuiz']>, ParentType, ContextType>;
  clinicalQuizId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  complementaryExams?: Resolver<Maybe<Array<TResolversTypes['ExamOnConsultation']>>, ParentType, ContextType>;
  costCenter?: Resolver<Maybe<TResolversTypes['CostCenter']>, ParentType, ContextType>;
  costCenterId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  crm?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  departmentId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  diagnostics?: Resolver<Maybe<TResolversTypes['Diagnostic']>, ParentType, ContextType>;
  doctor?: Resolver<Maybe<TResolversTypes['Person']>, ParentType, ContextType>;
  doctorId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctorRqeEntries?: Resolver<Maybe<Array<TResolversTypes['DoctorRqeEntry']>>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  estimatedDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  estimatedTime?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  exam?: Resolver<Maybe<TResolversTypes['Exam']>, ParentType, ContextType>;
  expectedClinicalQuiz?: Resolver<Maybe<TResolversTypes['Quiz']>, ParentType, ContextType>;
  expectedClinicalQuizId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  externalDoctor?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  forceSchedule?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  getNextAvailableTime?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ignoreOccupationalValidation?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  medicalRecord?: Resolver<TResolversTypes['MedicalRecord'], ParentType, ContextType>;
  nature?: Resolver<Maybe<TResolversTypes['ConsultationNature']>, ParentType, ContextType>;
  nurse?: Resolver<Maybe<TResolversTypes['Person']>, ParentType, ContextType>;
  nurseId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  observation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  occupation?: Resolver<Maybe<TResolversTypes['Occupation']>, ParentType, ContextType>;
  occupationId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  occupationalCertificate?: Resolver<Maybe<TResolversTypes['OccupationalHealthCertificate']>, ParentType, ContextType>;
  reason?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  returnOnConflictError?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  screeningDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  state?: Resolver<Maybe<TResolversTypes['State']>, ParentType, ContextType>;
  taskId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<TResolversTypes['ConsultationType'], ParentType, ContextType>;
}>;

export type TConsultationBiologicalMonitoringResolvers<ContextType = any, ParentType extends TResolversParentTypes['ConsultationBiologicalMonitoring'] = TResolversParentTypes['ConsultationBiologicalMonitoring']> = ResolversObject<{
  cExm?: Resolver<Maybe<Array<TResolversTypes['ExamOnConsultation']>>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TConsultationByBranchToPrintResolvers<ContextType = any, ParentType extends TResolversParentTypes['ConsultationByBranchToPrint'] = TResolversParentTypes['ConsultationByBranchToPrint']> = ResolversObject<{
  accredited?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  admissionDate?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  branch?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  costCenter?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  department?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  diagnostic?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  diagnosticDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  dismissalDate?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctor?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  document?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  eSocialCategory?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  erpBranch?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  estimatedDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  icd?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  individualRegistration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  medicalRecord?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nature?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nurse?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  occupation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  organization?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  registration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  screeningBy?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  screeningDate?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TConsultationByDoctorToPrintResolvers<ContextType = any, ParentType extends TResolversParentTypes['ConsultationByDoctorToPrint'] = TResolversParentTypes['ConsultationByDoctorToPrint']> = ResolversObject<{
  accredited?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  admissionDate?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  branch?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  costCenter?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  department?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  diagnostic?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  diagnosticDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  dismissalDate?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  eSocialCategory?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  estimatedDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  icd?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  individualRegistration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  medicalRecord?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nature?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nurse?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  occupation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  registration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  screeningBy?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  screeningDate?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TConsultationExamsResultResolvers<ContextType = any, ParentType extends TResolversParentTypes['ConsultationExamsResult'] = TResolversParentTypes['ConsultationExamsResult']> = ResolversObject<{
  complementaryExamId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  consultationId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  details?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  exam?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  examResponsibleDocument?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  examResponsibleName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  observations?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  resultDescription?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TConsultationMinimalResolvers<ContextType = any, ParentType extends TResolversParentTypes['ConsultationMinimal'] = TResolversParentTypes['ConsultationMinimal']> = ResolversObject<{
  accredited?: Resolver<Maybe<TResolversTypes['Accredited']>, ParentType, ContextType>;
  attended?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  cExmRefId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  costCenter?: Resolver<Maybe<TResolversTypes['CostCenter']>, ParentType, ContextType>;
  costCenterId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  crm?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  departmentId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctor?: Resolver<Maybe<TResolversTypes['Person']>, ParentType, ContextType>;
  doctorId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  estimatedDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  estimatedTime?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  exam?: Resolver<Maybe<TResolversTypes['Exam']>, ParentType, ContextType>;
  expectedClinicalQuizId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  externalDoctor?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  forceSchedule?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  getNextAvailableTime?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ignoreOccupationalValidation?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  medicalRecord?: Resolver<TResolversTypes['MedicalRecord'], ParentType, ContextType>;
  nature?: Resolver<Maybe<TResolversTypes['ConsultationNature']>, ParentType, ContextType>;
  nurse?: Resolver<Maybe<TResolversTypes['Person']>, ParentType, ContextType>;
  nurseId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  observation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  occupation?: Resolver<Maybe<TResolversTypes['Occupation']>, ParentType, ContextType>;
  occupationId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  occupationalCertificate?: Resolver<Maybe<TResolversTypes['OccupationalHealthCertificate']>, ParentType, ContextType>;
  reason?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  returnOnConflictError?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  screeningDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  state?: Resolver<Maybe<TResolversTypes['State']>, ParentType, ContextType>;
  taskId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<TResolversTypes['ConsultationType'], ParentType, ContextType>;
}>;

export type TConsultationReasonResolvers<ContextType = any, ParentType extends TResolversParentTypes['ConsultationReason'] = TResolversParentTypes['ConsultationReason']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  reason?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TContactRequestResolvers<ContextType = any, ParentType extends TResolversParentTypes['ContactRequest'] = TResolversParentTypes['ContactRequest']> = ResolversObject<{
  comment?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  email?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  phone?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type TControlMeasureResolvers<ContextType = any, ParentType extends TResolversParentTypes['ControlMeasure'] = TResolversParentTypes['ControlMeasure']> = ResolversObject<{
  controlType?: Resolver<TResolversTypes['ControlType'], ParentType, ContextType>;
  description?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TControlMeasureByRiskResolvers<ContextType = any, ParentType extends TResolversParentTypes['ControlMeasureByRisk'] = TResolversParentTypes['ControlMeasureByRisk']> = ResolversObject<{
  controlMeasure?: Resolver<TResolversTypes['ControlMeasure'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isEffective?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type TControlMeasureFrameResolvers<ContextType = any, ParentType extends TResolversParentTypes['ControlMeasureFrame'] = TResolversParentTypes['ControlMeasureFrame']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TControlMeasuresChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['ControlMeasuresChart'] = TResolversParentTypes['ControlMeasuresChart']> = ResolversObject<{
  effective?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  hasRisk?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  noEffective?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TCostCenterResolvers<ContextType = any, ParentType extends TResolversParentTypes['CostCenter'] = TResolversParentTypes['CostCenter']> = ResolversObject<{
  classCostCenter?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  equipments?: Resolver<Maybe<Array<TResolversTypes['EquipmentByCostCenter']>>, ParentType, ContextType>;
  erpCode?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  needEquipment?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  referenceId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  stockErpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  suggestion?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  targetBranchId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TCostCenterByRiskResolvers<ContextType = any, ParentType extends TResolversParentTypes['CostCenterByRisk'] = TResolversParentTypes['CostCenterByRisk']> = ResolversObject<{
  costCenter?: Resolver<TResolversTypes['CostCenter'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TCostCenterEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['CostCenterEntry'] = TResolversParentTypes['CostCenterEntry']> = ResolversObject<{
  cumulativePercent?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TCostCenterGroupResolvers<ContextType = any, ParentType extends TResolversParentTypes['CostCenterGroup'] = TResolversParentTypes['CostCenterGroup']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupations?: Resolver<Array<TResolversTypes['OccupationsGroup']>, ParentType, ContextType>;
}>;

export type TCostCenterOccupationChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['CostCenterOccupationChart'] = TResolversParentTypes['CostCenterOccupationChart']> = ResolversObject<{
  certificateCountData?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  certificatePerHC?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  hasCertificate?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TCostCenterOccupationDeficienciesChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['CostCenterOccupationDeficienciesChart'] = TResolversParentTypes['CostCenterOccupationDeficienciesChart']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  hasDeficiencies?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TCostCenterOnMandateResolvers<ContextType = any, ParentType extends TResolversParentTypes['CostCenterOnMandate'] = TResolversParentTypes['CostCenterOnMandate']> = ResolversObject<{
  costCenter?: Resolver<TResolversTypes['CostCenter'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TCostCenterOnVaccineResolvers<ContextType = any, ParentType extends TResolversParentTypes['CostCenterOnVaccine'] = TResolversParentTypes['CostCenterOnVaccine']> = ResolversObject<{
  costCenter?: Resolver<TResolversTypes['CostCenter'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TCostCenterVolumeChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['CostCenterVolumeChart'] = TResolversParentTypes['CostCenterVolumeChart']> = ResolversObject<{
  daysPerHC?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  hasCertificate?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  lostDayData?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  peopleCountData?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
}>;

export type TCostPerTypeChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['CostPerTypeChart'] = TResolversParentTypes['CostPerTypeChart']> = ResolversObject<{
  hasAccident?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  indemnity?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  material?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  medical?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  others?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  productionLoss?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TCreditCardResolvers<ContextType = any, ParentType extends TResolversParentTypes['CreditCard'] = TResolversParentTypes['CreditCard']> = ResolversObject<{
  brand?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  number?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TCronTabResolvers<ContextType = any, ParentType extends TResolversParentTypes['CronTab'] = TResolversParentTypes['CronTab']> = ResolversObject<{
  branchId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  businessEntity?: Resolver<TResolversTypes['BusinessEntity'], ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  erpType?: Resolver<TResolversTypes['ErpType'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  lastHttpCode?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  lastHttpState?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  periodicity?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  updatedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type TCrontabExecutionResolvers<ContextType = any, ParentType extends TResolversParentTypes['CrontabExecution'] = TResolversParentTypes['CrontabExecution']> = ResolversObject<{
  crontabId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  errorDetail?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  finishedAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  lastCheckpointPage?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  startedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['CrontabExecutionStatus'], ParentType, ContextType>;
  totalCreated?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  totalErrors?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  totalIgnored?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  totalPages?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  totalReceived?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  totalUpdated?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TCrontabExecutionDetailResolvers<ContextType = any, ParentType extends TResolversParentTypes['CrontabExecutionDetail'] = TResolversParentTypes['CrontabExecutionDetail']> = ResolversObject<{
  action?: Resolver<TResolversTypes['CrontabExecutionAction'], ParentType, ContextType>;
  entityErpId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  entityName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  errorDetail?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  executionId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  pageNumber?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  processedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type TCustomDocumentResolvers<ContextType = any, ParentType extends TResolversParentTypes['CustomDocument'] = TResolversParentTypes['CustomDocument']> = ResolversObject<{
  basedOnSchemaVersion?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<TResolversTypes['ID']>, ParentType, ContextType>;
  definition?: Resolver<TResolversTypes['JSON'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  organization?: Resolver<TResolversTypes['ID'], ParentType, ContextType>;
  schemaVersion?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  subType?: Resolver<Maybe<TResolversTypes['CustomDocumentSubType']>, ParentType, ContextType>;
  type?: Resolver<TResolversTypes['DocumentType'], ParentType, ContextType>;
  updatedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<TResolversTypes['ID']>, ParentType, ContextType>;
}>;

export type TCustomOrganizationResolvers<ContextType = any, ParentType extends TResolversParentTypes['CustomOrganization'] = TResolversParentTypes['CustomOrganization']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<TResolversTypes['CustomType'], ParentType, ContextType>;
  value?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TCustomerResolvers<ContextType = any, ParentType extends TResolversParentTypes['Customer'] = TResolversParentTypes['Customer']> = ResolversObject<{
  address?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  addressNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  billingType?: Resolver<Maybe<TResolversTypes['BillingMethod']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  creditCard?: Resolver<Maybe<TResolversTypes['CreditCard']>, ParentType, ContextType>;
  documentNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  emails?: Resolver<Array<TResolversTypes['Email']>, ParentType, ContextType>;
  name?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  neighborhood?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  socialName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TDashboardExportResolvers<ContextType = any, ParentType extends TResolversParentTypes['DashboardExport'] = TResolversParentTypes['DashboardExport']> = ResolversObject<{
  items?: Resolver<Array<TResolversTypes['ExportStatus']>, ParentType, ContextType>;
  total?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TDataResolvers<ContextType = any, ParentType extends TResolversParentTypes['Data'] = TResolversParentTypes['Data']> = ResolversObject<{
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TDataChartsResolvers<ContextType = any, ParentType extends TResolversParentTypes['DataCharts'] = TResolversParentTypes['DataCharts']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
}>;

export type TDataLoginResolvers<ContextType = any, ParentType extends TResolversParentTypes['DataLogin'] = TResolversParentTypes['DataLogin']> = ResolversObject<{
  person?: Resolver<TResolversTypes['Employee'], ParentType, ContextType>;
}>;

export interface TDateTimeScalarConfig extends GraphQLScalarTypeConfig<TResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type TDaysAbsentChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['DaysAbsentChart'] = TResolversParentTypes['DaysAbsentChart']> = ResolversObject<{
  averageDayData?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  hasCertificate?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  lostTime?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  peopleCountData?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
}>;

export type TDaysLostWithIcdChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['DaysLostWithIcdChart'] = TResolversParentTypes['DaysLostWithIcdChart']> = ResolversObject<{
  certificateCount?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  hasCertificate?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  totalDays?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TDaysLostWithoutIcdChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['DaysLostWithoutIcdChart'] = TResolversParentTypes['DaysLostWithoutIcdChart']> = ResolversObject<{
  certificateCount?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  hasCertificate?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  totalDays?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TDaysWithoutAccidentChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['DaysWithoutAccidentChart'] = TResolversParentTypes['DaysWithoutAccidentChart']> = ResolversObject<{
  lastAccident?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  percentual?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  record?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TDefaultRecipientUserDtoResolvers<ContextType = any, ParentType extends TResolversParentTypes['DefaultRecipientUserDto'] = TResolversParentTypes['DefaultRecipientUserDto']> = ResolversObject<{
  email?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  roleId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  roleLabel?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TDeficienciesChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['DeficienciesChart'] = TResolversParentTypes['DeficienciesChart']> = ResolversObject<{
  hasDeficiencies?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  hearing?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  intellectual?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  mental?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  physical?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  psychosocial?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  rehabilitated?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  speech?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  visual?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TDeficiencyResolvers<ContextType = any, ParentType extends TResolversParentTypes['Deficiency'] = TResolversParentTypes['Deficiency']> = ResolversObject<{
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  deficiencyOrigin?: Resolver<Maybe<TResolversTypes['DeficiencyOrigin']>, ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  icd?: Resolver<Maybe<TResolversTypes['Icd']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  impediments?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  limitations?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  medicalRecordId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  observation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  recoveryDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<TResolversTypes['DeficiencyType'], ParentType, ContextType>;
  typeIntellectualDeficiency?: Resolver<Maybe<TResolversTypes['TypeIntellectualDeficiency']>, ParentType, ContextType>;
  typePhysicalDeficiency?: Resolver<Maybe<TResolversTypes['TypePhysicalDeficiency']>, ParentType, ContextType>;
  typeVisualDeficiency?: Resolver<Maybe<TResolversTypes['TypeVisualDeficiency']>, ParentType, ContextType>;
  visualDeficiencySpecification?: Resolver<Maybe<TResolversTypes['VisualDeficiencySpecification']>, ParentType, ContextType>;
}>;

export type TDeliveredIpesParamsResolvers<ContextType = any, ParentType extends TResolversParentTypes['DeliveredIpesParams'] = TResolversParentTypes['DeliveredIpesParams']> = ResolversObject<{
  costCenterId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  footer?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  fromDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  occupationId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  toDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type TDeliveredIpesReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['DeliveredIpesReport'] = TResolversParentTypes['DeliveredIpesReport']> = ResolversObject<{
  address?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  cnpj?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  companyName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  costCenters?: Resolver<Array<TResolversTypes['CostCenterGroup']>, ParentType, ContextType>;
  footer?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  telephone?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TDeliveredProductsParamsResolvers<ContextType = any, ParentType extends TResolversParentTypes['DeliveredProductsParams'] = TResolversParentTypes['DeliveredProductsParams']> = ResolversObject<{
  costCenterId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  fromDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  occupationId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  toDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type TDeliveredSparePartsParamsResolvers<ContextType = any, ParentType extends TResolversParentTypes['DeliveredSparePartsParams'] = TResolversParentTypes['DeliveredSparePartsParams']> = ResolversObject<{
  costCenterId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  fromDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  occupationId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  toDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type TDeliverySparePartsResolvers<ContextType = any, ParentType extends TResolversParentTypes['DeliverySpareParts'] = TResolversParentTypes['DeliverySpareParts']> = ResolversObject<{
  amount?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  amountReturned?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  deliveryDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipeDelivery?: Resolver<TResolversTypes['IpeDelivery'], ParentType, ContextType>;
  ipeDeliveryId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isDiscarted?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  issueDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  lotNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  product?: Resolver<TResolversTypes['Product'], ParentType, ContextType>;
  productId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  returnedLotNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  returnedProductId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  returnedWarehouseId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  stockMovement?: Resolver<Maybe<Array<TResolversTypes['StockMovement']>>, ParentType, ContextType>;
  warehouse?: Resolver<TResolversTypes['Warehouse'], ParentType, ContextType>;
  warehouseId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TDeliverySparePartsParamsResolvers<ContextType = any, ParentType extends TResolversParentTypes['DeliverySparePartsParams'] = TResolversParentTypes['DeliverySparePartsParams']> = ResolversObject<{
  filter?: Resolver<Maybe<TResolversTypes['DeliveryFilter']>, ParentType, ContextType>;
  isCheck?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  statementsResponsibility?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TDeliverySparePartsReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['DeliverySparePartsReport'] = TResolversParentTypes['DeliverySparePartsReport']> = ResolversObject<{
  address?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  admission?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  cnpj?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  companyName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  costCenter?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  footer?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  generalRegistration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  individualRegistration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  registration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  sparePartBiometry?: Resolver<Maybe<TResolversTypes['IpeBiometry']>, ParentType, ContextType>;
  sparePartFace?: Resolver<Maybe<TResolversTypes['IpeFace']>, ParentType, ContextType>;
  spareParts?: Resolver<Array<TResolversTypes['SparePartsReport']>, ParentType, ContextType>;
  statement?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  telephone?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TDepartmentResolvers<ContextType = any, ParentType extends TResolversParentTypes['Department'] = TResolversParentTypes['Department']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  suggestion?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TDepartmentByRiskResolvers<ContextType = any, ParentType extends TResolversParentTypes['DepartmentByRisk'] = TResolversParentTypes['DepartmentByRisk']> = ResolversObject<{
  department?: Resolver<TResolversTypes['Department'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TDepartmentOnMandateResolvers<ContextType = any, ParentType extends TResolversParentTypes['DepartmentOnMandate'] = TResolversParentTypes['DepartmentOnMandate']> = ResolversObject<{
  department?: Resolver<TResolversTypes['Department'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TDependentResolvers<ContextType = any, ParentType extends TResolversParentTypes['Dependent'] = TResolversParentTypes['Dependent']> = ResolversObject<{
  birthday?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  gender?: Resolver<TResolversTypes['Gender'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  individualRegistration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
}>;

export type TDependentByPersonResolvers<ContextType = any, ParentType extends TResolversParentTypes['DependentByPerson'] = TResolversParentTypes['DependentByPerson']> = ResolversObject<{
  birthday?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  gender?: Resolver<TResolversTypes['Gender'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  individualRegistration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TDiagnosticResolvers<ContextType = any, ParentType extends TResolversParentTypes['Diagnostic'] = TResolversParentTypes['Diagnostic']> = ResolversObject<{
  alcoholism?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  alcoholismFrequency?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  alcoholismPeriod?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  alcoholismType?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  amountConsumed?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  attendance?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  chronicDiseaseOrTreatment?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  chronicDiseaseOrTreatmentDetails?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  complaint?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  consultation?: Resolver<TResolversTypes['Consultation'], ParentType, ContextType>;
  controlledMedication?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  controlledMedicationDetails?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  diabetes?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  diagnostic?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  diagnosticDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  diagnosticMedicine?: Resolver<Maybe<Array<TResolversTypes['MedicineOnDiagnostic']>>, ParentType, ContextType>;
  diastolicPressure?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  height?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  hypertensionTreatment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  icd?: Resolver<Maybe<TResolversTypes['Icd']>, ParentType, ContextType>;
  icdGroup?: Resolver<Maybe<TResolversTypes['IcdGroup']>, ParentType, ContextType>;
  icdGroupId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  icdId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  icds?: Resolver<Maybe<Array<TResolversTypes['ComplementaryIcdOnDiagnostic']>>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  mentalHealthFollowUp?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  mentalHealthFollowUpFrequency?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  mentalHealthFollowUpPeriod?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  physicalActivity?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  physicalActivityFrequency?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  physicalActivityMain?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  pulse?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  smoker?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  systolicPressure?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  tamagistPeriod?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  temperature?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  weight?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TDiagnosticComplementaryIcdResolvers<ContextType = any, ParentType extends TResolversParentTypes['DiagnosticComplementaryIcd'] = TResolversParentTypes['DiagnosticComplementaryIcd']> = ResolversObject<{
  diagnostic?: Resolver<TResolversTypes['Diagnostic'], ParentType, ContextType>;
  icd?: Resolver<TResolversTypes['Icd'], ParentType, ContextType>;
  icdGroup?: Resolver<TResolversTypes['IcdGroup'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TDiagnosticMedicineResolvers<ContextType = any, ParentType extends TResolversParentTypes['DiagnosticMedicine'] = TResolversParentTypes['DiagnosticMedicine']> = ResolversObject<{
  amount?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  diagnostic?: Resolver<TResolversTypes['Diagnostic'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  measurementUnit?: Resolver<Maybe<TResolversTypes['MedicineMeasurementUnit']>, ParentType, ContextType>;
  medicine?: Resolver<TResolversTypes['Medicine'], ParentType, ContextType>;
  posology?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  showsInPrescription?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TDimensionResolvers<ContextType = any, ParentType extends TResolversParentTypes['Dimension'] = TResolversParentTypes['Dimension']> = ResolversObject<{
  actual?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  extra?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  miss?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  total?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TDivergingStackedBarChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['DivergingStackedBarChart'] = TResolversParentTypes['DivergingStackedBarChart']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TDoctorResolvers<ContextType = any, ParentType extends TResolversParentTypes['Doctor'] = TResolversParentTypes['Doctor']> = ResolversObject<{
  document?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TDoctorRqeEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['DoctorRqeEntry'] = TResolversParentTypes['DoctorRqeEntry']> = ResolversObject<{
  councilState?: Resolver<Maybe<TResolversTypes['State']>, ParentType, ContextType>;
  isPrimary?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  rqeNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  specialty?: Resolver<Maybe<TResolversTypes['MedicalSpecialty']>, ParentType, ContextType>;
}>;

export type TDocumentFromEntityResponseResolvers<ContextType = any, ParentType extends TResolversParentTypes['DocumentFromEntityResponse'] = TResolversParentTypes['DocumentFromEntityResponse']> = ResolversObject<{
  entity?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  externalId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  signedBy?: Resolver<Maybe<Array<TResolversTypes['String']>>, ParentType, ContextType>;
  signers?: Resolver<Maybe<Array<TResolversTypes['String']>>, ParentType, ContextType>;
  signinType?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<TResolversTypes['DocumentStatus'], ParentType, ContextType>;
}>;

export type TDocumentObserverResolvers<ContextType = any, ParentType extends TResolversParentTypes['DocumentObserver'] = TResolversParentTypes['DocumentObserver']> = ResolversObject<{
  email?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TDocumentPendingResolvers<ContextType = any, ParentType extends TResolversParentTypes['DocumentPending'] = TResolversParentTypes['DocumentPending']> = ResolversObject<{
  email?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isSigned?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TDocumentPendingSignerResolvers<ContextType = any, ParentType extends TResolversParentTypes['DocumentPendingSigner'] = TResolversParentTypes['DocumentPendingSigner']> = ResolversObject<{
  action?: Resolver<TResolversTypes['SignPublicationAction'], ParentType, ContextType>;
  email?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isEmbedded?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  isPending?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TDocumentPermissionsResolvers<ContextType = any, ParentType extends TResolversParentTypes['DocumentPermissions'] = TResolversParentTypes['DocumentPermissions']> = ResolversObject<{
  canCancel?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  canDelete?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  canDownloadDigital?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  canDownloadManifest?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  canDownloadOriginal?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  canResendEmails?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  canSign?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TDocumentSignerResolvers<ContextType = any, ParentType extends TResolversParentTypes['DocumentSigner'] = TResolversParentTypes['DocumentSigner']> = ResolversObject<{
  data?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isPrimary?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TDocumentSignerDbResolvers<ContextType = any, ParentType extends TResolversParentTypes['DocumentSignerDB'] = TResolversParentTypes['DocumentSignerDB']> = ResolversObject<{
  data?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isPrimary?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TDocumentUserResolvers<ContextType = any, ParentType extends TResolversParentTypes['DocumentUser'] = TResolversParentTypes['DocumentUser']> = ResolversObject<{
  email?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TESocialDeliveriesParametersResolvers<ContextType = any, ParentType extends TResolversParentTypes['ESocialDeliveriesParameters'] = TResolversParentTypes['ESocialDeliveriesParameters']> = ResolversObject<{
  periods?: Resolver<Array<TResolversTypes['ESocialDeliveriesPeriod']>, ParentType, ContextType>;
}>;

export type TESocialDeliveriesPeriodResolvers<ContextType = any, ParentType extends TResolversParentTypes['ESocialDeliveriesPeriod'] = TResolversParentTypes['ESocialDeliveriesPeriod']> = ResolversObject<{
  fromDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  toDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TESocialQueueResolvers<ContextType = any, ParentType extends TResolversParentTypes['ESocialQueue'] = TResolversParentTypes['ESocialQueue']> = ResolversObject<{
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  errors?: Resolver<Maybe<Array<TResolversTypes['ESocialQueueError']>>, ParentType, ContextType>;
  histories?: Resolver<Maybe<Array<TResolversTypes['ESocialQueueHistory']>>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isResendingMessages?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  message?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  origin?: Resolver<TResolversTypes['OriginMessage'], ParentType, ContextType>;
  originId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  person?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  receiptNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  send?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['StatusMessage'], ParentType, ContextType>;
  statusDescription?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  tafBatch?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type TESocialQueueAllResolvers<ContextType = any, ParentType extends TResolversParentTypes['ESocialQueueAll'] = TResolversParentTypes['ESocialQueueAll']> = ResolversObject<{
  count?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  data?: Resolver<TResolversTypes['PaginatedESocialQueue'], ParentType, ContextType>;
  isResendingMessages?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
}>;

export type TESocialQueueErrorResolvers<ContextType = any, ParentType extends TResolversParentTypes['ESocialQueueError'] = TResolversParentTypes['ESocialQueueError']> = ResolversObject<{
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  errorCode?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  errorDescription?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  errorDetails?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TESocialQueueHistoryResolvers<ContextType = any, ParentType extends TResolversParentTypes['ESocialQueueHistory'] = TResolversParentTypes['ESocialQueueHistory']> = ResolversObject<{
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TESocialQueueIndicatorsResolvers<ContextType = any, ParentType extends TResolversParentTypes['ESocialQueueIndicators'] = TResolversParentTypes['ESocialQueueIndicators']> = ResolversObject<{
  awaitingSend?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  completed?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  error?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  processed?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  send?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TEarPartResolvers<ContextType = any, ParentType extends TResolversParentTypes['EarPart'] = TResolversParentTypes['EarPart']> = ResolversObject<{
  abnormality?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  description?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  earPart?: Resolver<TResolversTypes['EarPartEnum'], ParentType, ContextType>;
  examOtological?: Resolver<TResolversTypes['ExamOtological'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TEconomicActivityResolvers<ContextType = any, ParentType extends TResolversParentTypes['EconomicActivity'] = TResolversParentTypes['EconomicActivity']> = ResolversObject<{
  activityGroup?: Resolver<TResolversTypes['ActivityGroup'], ParentType, ContextType>;
  code?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  groupId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  suggestion?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TEffectiveDocumentTemplateResolvers<ContextType = any, ParentType extends TResolversParentTypes['EffectiveDocumentTemplate'] = TResolversParentTypes['EffectiveDocumentTemplate']> = ResolversObject<{
  definition?: Resolver<TResolversTypes['JSON'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['ID'], ParentType, ContextType>;
  isCustom?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  sampleData?: Resolver<Maybe<TResolversTypes['JSON']>, ParentType, ContextType>;
  schemaVersion?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  subType?: Resolver<Maybe<TResolversTypes['CustomDocumentSubType']>, ParentType, ContextType>;
  type?: Resolver<TResolversTypes['DocumentType'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
}>;

export type TEfficiencyChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['EfficiencyChart'] = TResolversParentTypes['EfficiencyChart']> = ResolversObject<{
  breath?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  eyeFace?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  fall?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  fullBody?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  hasIpeDeliveries?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  head?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  hearing?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  lowerLimb?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  other?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  trunk?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  upperLimb?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TElaboratorDocumentResolvers<ContextType = any, ParentType extends TResolversParentTypes['ElaboratorDocument'] = TResolversParentTypes['ElaboratorDocument']> = ResolversObject<{
  documentNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  documentState?: Resolver<Maybe<TResolversTypes['State']>, ParentType, ContextType>;
}>;

export type TElectionComissionResolvers<ContextType = any, ParentType extends TResolversParentTypes['ElectionComission'] = TResolversParentTypes['ElectionComission']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  mandate?: Resolver<TResolversTypes['Mandate'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
}>;

export type TEmailResolvers<ContextType = any, ParentType extends TResolversParentTypes['Email'] = TResolversParentTypes['Email']> = ResolversObject<{
  email?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isMain?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type TEmailHasInviteResolvers<ContextType = any, ParentType extends TResolversParentTypes['EmailHasInvite'] = TResolversParentTypes['EmailHasInvite']> = ResolversObject<{
  hasInvite?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  organizationName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TEmployeeResolvers<ContextType = any, ParentType extends TResolversParentTypes['Employee'] = TResolversParentTypes['Employee']> = ResolversObject<{
  address?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  admissionDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  birthday?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  branchName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  civilStatus?: Resolver<Maybe<TResolversTypes['CivilStatus']>, ParentType, ContextType>;
  costCenter?: Resolver<Maybe<TResolversTypes['CostCenter']>, ParentType, ContextType>;
  ctps?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  department?: Resolver<Maybe<TResolversTypes['Department']>, ParentType, ContextType>;
  dismissalDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  eSocialCategory?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  eSocialRhEventStatus?: Resolver<Maybe<TResolversTypes['ESocialRhEventStatus']>, ParentType, ContextType>;
  educationLevel?: Resolver<Maybe<TResolversTypes['EducationLevel']>, ParentType, ContextType>;
  email?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  employeeSituation?: Resolver<Maybe<TResolversTypes['EmployeeSituation']>, ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  external?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  gender?: Resolver<TResolversTypes['Gender'], ParentType, ContextType>;
  generalRegistration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  individualRegistration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  lastExam?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  managerId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  mothersName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  neighborhood?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  nextChange?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  nickname?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  numberAddress?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  occupation?: Resolver<Maybe<TResolversTypes['Occupation']>, ParentType, ContextType>;
  organizationPicture?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  pisCode?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<TResolversTypes['Position']>, ParentType, ContextType>;
  preferences?: Resolver<Maybe<TResolversTypes['EmployeePreferences']>, ParentType, ContextType>;
  profilePicture?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  rais?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  registration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  replacementSituation?: Resolver<Maybe<TResolversTypes['ReplacementSituation']>, ParentType, ContextType>;
  sefip?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  sellerId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  socialName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  suggestion?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  telephone?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  unicESocialId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  uploadUrl?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  workShift?: Resolver<Maybe<TResolversTypes['WorkShift']>, ParentType, ContextType>;
  zipCode?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TEmployeeAgentGroupChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['EmployeeAgentGroupChart'] = TResolversParentTypes['EmployeeAgentGroupChart']> = ResolversObject<{
  association?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  biological?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  chemical?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  dangerous?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  ergonomic?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  mechanical?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  other?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  physical?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TEmployeeAnamnesisResolvers<ContextType = any, ParentType extends TResolversParentTypes['EmployeeAnamnesis'] = TResolversParentTypes['EmployeeAnamnesis']> = ResolversObject<{
  consultationId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  estimatedDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  nature?: Resolver<Maybe<TResolversTypes['ConsultationNature']>, ParentType, ContextType>;
  quizId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  realizationDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  responsibleName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<TResolversTypes['EmployeeQuizStatusEnum'], ParentType, ContextType>;
}>;

export type TEmployeeByOccupationResolvers<ContextType = any, ParentType extends TResolversParentTypes['EmployeeByOccupation'] = TResolversParentTypes['EmployeeByOccupation']> = ResolversObject<{
  amount?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  details?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TEmployeeCandidateResolvers<ContextType = any, ParentType extends TResolversParentTypes['EmployeeCandidate'] = TResolversParentTypes['EmployeeCandidate']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['EmployeePerson'], ParentType, ContextType>;
}>;

export type TEmployeeConsultationResolvers<ContextType = any, ParentType extends TResolversParentTypes['EmployeeConsultation'] = TResolversParentTypes['EmployeeConsultation']> = ResolversObject<{
  accreditedName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  clinicalQuizId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctorCrm?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctorName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctorPhotoUrl?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  doctorSpecialty?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  estimatedDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  estimatedTime?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  exams?: Resolver<Array<TResolversTypes['EmployeeExam']>, ParentType, ContextType>;
  expectedClinicalQuizId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  generalResultReleasedToEmployee?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nature?: Resolver<Maybe<TResolversTypes['ConsultationNature']>, ParentType, ContextType>;
  occupationalHealthCertificateId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  startDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<TResolversTypes['ConsultationType'], ParentType, ContextType>;
}>;

export type TEmployeeControlMeasureResolvers<ContextType = any, ParentType extends TResolversParentTypes['EmployeeControlMeasure'] = TResolversParentTypes['EmployeeControlMeasure']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  effective?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type TEmployeeExamResolvers<ContextType = any, ParentType extends TResolversParentTypes['EmployeeExam'] = TResolversParentTypes['EmployeeExam']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  releasedToEmployee?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  resultType?: Resolver<Maybe<TResolversTypes['ResultTypeEnum']>, ParentType, ContextType>;
}>;

export type TEmployeeFavoriteOptionResolvers<ContextType = any, ParentType extends TResolversParentTypes['EmployeeFavoriteOption'] = TResolversParentTypes['EmployeeFavoriteOption']> = ResolversObject<{
  iconType?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  route?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TEmployeeIpeDeliveryResolvers<ContextType = any, ParentType extends TResolversParentTypes['EmployeeIpeDelivery'] = TResolversParentTypes['EmployeeIpeDelivery']> = ResolversObject<{
  costCenter?: Resolver<Maybe<TResolversTypes['CostCenter']>, ParentType, ContextType>;
  employeeSituation?: Resolver<Maybe<TResolversTypes['EmployeeSituation']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipeDeliveries?: Resolver<Array<TResolversTypes['IpeDelivery']>, ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<Maybe<TResolversTypes['Occupation']>, ParentType, ContextType>;
  profilePicture?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  requiredIpes?: Resolver<Array<TResolversTypes['Ipe']>, ParentType, ContextType>;
}>;

export type TEmployeeIpesResolvers<ContextType = any, ParentType extends TResolversParentTypes['EmployeeIpes'] = TResolversParentTypes['EmployeeIpes']> = ResolversObject<{
  amount?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  caCode?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  effective?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  equipmentDescription?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  equipmentId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  issueDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  lastMaintenance?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  nextChange?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  observation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<TResolversTypes['DeliveryReason']>, ParentType, ContextType>;
}>;

export type TEmployeeMandateEventResolvers<ContextType = any, ParentType extends TResolversParentTypes['EmployeeMandateEvent'] = TResolversParentTypes['EmployeeMandateEvent']> = ResolversObject<{
  candidates?: Resolver<Maybe<Array<TResolversTypes['EmployeeCandidate']>>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  event?: Resolver<TResolversTypes['MandateEventInfo'], ParentType, ContextType>;
  mandateId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  validity?: Resolver<TResolversTypes['MandateValidity'], ParentType, ContextType>;
}>;

export type TEmployeePersonResolvers<ContextType = any, ParentType extends TResolversParentTypes['EmployeePerson'] = TResolversParentTypes['EmployeePerson']> = ResolversObject<{
  costCenterId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  costCenterName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nickname?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  profilePicture?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  registration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  riskCount?: Resolver<Maybe<TResolversTypes['Int']>, ParentType, ContextType>;
  socialName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  suggestion?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TEmployeePreferencesResolvers<ContextType = any, ParentType extends TResolversParentTypes['EmployeePreferences'] = TResolversParentTypes['EmployeePreferences']> = ResolversObject<{
  designVersion?: Resolver<Maybe<TResolversTypes['DesignVersion']>, ParentType, ContextType>;
  expandedSidebar?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  favorites?: Resolver<Maybe<Array<TResolversTypes['EmployeeFavoriteOption']>>, ParentType, ContextType>;
  favoritesOpen?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type TEmployeeQuizResolvers<ContextType = any, ParentType extends TResolversParentTypes['EmployeeQuiz'] = TResolversParentTypes['EmployeeQuiz']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  lastAnsweredAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  nextDueDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  periodicity?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  quizType?: Resolver<TResolversTypes['QuizTypeEnum'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['EmployeeQuizStatusEnum'], ParentType, ContextType>;
}>;

export type TEmployeeRiskResolvers<ContextType = any, ParentType extends TResolversParentTypes['EmployeeRisk'] = TResolversParentTypes['EmployeeRisk']> = ResolversObject<{
  actionLevel?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  category?: Resolver<Maybe<TResolversTypes['RiskCategory']>, ParentType, ContextType>;
  classification?: Resolver<Maybe<TResolversTypes['RiskClassification']>, ParentType, ContextType>;
  controlMeasures?: Resolver<Array<TResolversTypes['EmployeeControlMeasure']>, ParentType, ContextType>;
  exchangePeriodicity?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  expirationDate?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  exposureTime?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  generationSource?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  interval?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  ipes?: Resolver<Array<TResolversTypes['EmployeeRiskIpe']>, ParentType, ContextType>;
  measureType?: Resolver<Maybe<TResolversTypes['RiskMeasureType']>, ParentType, ContextType>;
  needCpe?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  needIpe?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  physicalEnvironment?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  probability?: Resolver<Maybe<TResolversTypes['RiskProbability']>, ParentType, ContextType>;
  protectionMeasure?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  recognitionDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  repetition?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  riskAgent?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  riskDegree?: Resolver<Maybe<TResolversTypes['RiskDegree']>, ParentType, ContextType>;
  riskGroup?: Resolver<TResolversTypes['AgentGroup'], ParentType, ContextType>;
  riskMap?: Resolver<Maybe<TResolversTypes['RiskMap']>, ParentType, ContextType>;
  sanitation?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  severity?: Resolver<Maybe<TResolversTypes['RiskSeverity']>, ParentType, ContextType>;
  uninterruptedUse?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  unitMeasurement?: Resolver<Maybe<TResolversTypes['RiskMeasure']>, ParentType, ContextType>;
  workingCondition?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TEmployeeRiskDashboardResolvers<ContextType = any, ParentType extends TResolversParentTypes['EmployeeRiskDashboard'] = TResolversParentTypes['EmployeeRiskDashboard']> = ResolversObject<{
  agentBonusChart?: Resolver<TResolversTypes['AgentBonusChart'], ParentType, ContextType>;
  employeesAgentChart?: Resolver<Array<TResolversTypes['PieChart']>, ParentType, ContextType>;
  employeesAgentTypeChart?: Resolver<TResolversTypes['EmployeeAgentGroupChart'], ParentType, ContextType>;
  personChart?: Resolver<TResolversTypes['PersonChart'], ParentType, ContextType>;
  risksPerEmployeeChart?: Resolver<TResolversTypes['PersonChart'], ParentType, ContextType>;
}>;

export type TEmployeeRiskIpeResolvers<ContextType = any, ParentType extends TResolversParentTypes['EmployeeRiskIpe'] = TResolversParentTypes['EmployeeRiskIpe']> = ResolversObject<{
  change?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TEmployeeTaskResolvers<ContextType = any, ParentType extends TResolversParentTypes['EmployeeTask'] = TResolversParentTypes['EmployeeTask']> = ResolversObject<{
  endDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  startDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  task?: Resolver<TResolversTypes['Task'], ParentType, ContextType>;
}>;

export type TEmployeeVolumeChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['EmployeeVolumeChart'] = TResolversParentTypes['EmployeeVolumeChart']> = ResolversObject<{
  hasCertificate?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  high?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  low?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  medium?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TEmployeeVotesResolvers<ContextType = any, ParentType extends TResolversParentTypes['EmployeeVotes'] = TResolversParentTypes['EmployeeVotes']> = ResolversObject<{
  id?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  individualRegistration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  picture?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  registration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  socialName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TEmployeeWarningReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['EmployeeWarningReport'] = TResolversParentTypes['EmployeeWarningReport']> = ResolversObject<{
  address?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  cnpj?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  companyName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  details?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  footer?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  individualRegistration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  reason?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  telephone?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TEndpointResolvers<ContextType = any, ParentType extends TResolversParentTypes['Endpoint'] = TResolversParentTypes['Endpoint']> = ResolversObject<{
  additionalData?: Resolver<Maybe<Array<TResolversTypes['AdditionalData']>>, ParentType, ContextType>;
  authType?: Resolver<Maybe<TResolversTypes['AuthType']>, ParentType, ContextType>;
  branch?: Resolver<TResolversTypes['Branch'], ParentType, ContextType>;
  branchId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  clientId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  clientSecret?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  erpBranch?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  erpCompany?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  erpLine?: Resolver<Maybe<TResolversTypes['ErpLine']>, ParentType, ContextType>;
  erpType?: Resolver<TResolversTypes['ErpType'], ParentType, ContextType>;
  id?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  integrationCardName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  integrationContext?: Resolver<Maybe<TResolversTypes['IntegrationContext']>, ParentType, ContextType>;
  password?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  port?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  serviceDescription?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  urlCertificate?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  urlTSS?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TEnvironmentalReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['EnvironmentalReport'] = TResolversParentTypes['EnvironmentalReport']> = ResolversObject<{
  attachments?: Resolver<Maybe<Array<TResolversTypes['EnvironmentalReportAttachment']>>, ParentType, ContextType>;
  content?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  costCenter?: Resolver<Maybe<TResolversTypes['CostCenter']>, ParentType, ContextType>;
  documentClass?: Resolver<Maybe<TResolversTypes['DocumentClass']>, ParentType, ContextType>;
  documentDescription?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  documentNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  documentRqeEntries?: Resolver<Maybe<Array<TResolversTypes['DoctorRqeEntry']>>, ParentType, ContextType>;
  documentState?: Resolver<Maybe<TResolversTypes['State']>, ParentType, ContextType>;
  elaborator?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  endDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  environmentalReportCostCenter?: Resolver<Maybe<Array<TResolversTypes['EnvironmentalReportCostCenter']>>, ParentType, ContextType>;
  expirationDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  finality?: Resolver<Maybe<TResolversTypes['ReportFinality']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  initialDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  objective?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  physicalEnvironment?: Resolver<Maybe<TResolversTypes['PhysicalEnvironment']>, ParentType, ContextType>;
  reportAttachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  reportStructure?: Resolver<Maybe<TResolversTypes['ReportStructure']>, ParentType, ContextType>;
  reportStructureId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  review?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  statementResponsibility?: Resolver<Maybe<TResolversTypes['StatementResponsibility']>, ParentType, ContextType>;
  type?: Resolver<TResolversTypes['ReportType'], ParentType, ContextType>;
}>;

export type TEnvironmentalReportAttachmentResolvers<ContextType = any, ParentType extends TResolversParentTypes['EnvironmentalReportAttachment'] = TResolversParentTypes['EnvironmentalReportAttachment']> = ResolversObject<{
  contentLength?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  contentType?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  filename?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isSignDocument?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  isTable?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  uploadUrl?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  uploadedBy?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<TResolversTypes['S3UrlCloudFront'], ParentType, ContextType>;
}>;

export type TEnvironmentalReportBiometryResolvers<ContextType = any, ParentType extends TResolversParentTypes['EnvironmentalReportBiometry'] = TResolversParentTypes['EnvironmentalReportBiometry']> = ResolversObject<{
  biometry?: Resolver<TResolversTypes['Biometry'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TEnvironmentalReportCostCenterResolvers<ContextType = any, ParentType extends TResolversParentTypes['EnvironmentalReportCostCenter'] = TResolversParentTypes['EnvironmentalReportCostCenter']> = ResolversObject<{
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  costCenter?: Resolver<Maybe<TResolversTypes['CostCenter']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TEnvironmentalReportDocumentResponseResolvers<ContextType = any, ParentType extends TResolversParentTypes['EnvironmentalReportDocumentResponse'] = TResolversParentTypes['EnvironmentalReportDocumentResponse']> = ResolversObject<{
  attachmentId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  certificateId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  documentId?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  environmentalReportId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isEmbedded?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  pending?: Resolver<Maybe<Array<TResolversTypes['DocumentPending']>>, ParentType, ContextType>;
  status?: Resolver<Maybe<TResolversTypes['DocumentStatus']>, ParentType, ContextType>;
}>;

export type TEnvironmentalReportFaceResolvers<ContextType = any, ParentType extends TResolversParentTypes['EnvironmentalReportFace'] = TResolversParentTypes['EnvironmentalReportFace']> = ResolversObject<{
  environmentalReportId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  uploadThumbnailUrl?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  uploadUrl?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TEnvironmentalReportSuggestionResolvers<ContextType = any, ParentType extends TResolversParentTypes['EnvironmentalReportSuggestion'] = TResolversParentTypes['EnvironmentalReportSuggestion']> = ResolversObject<{
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TEnvironmentalReportVersionResolvers<ContextType = any, ParentType extends TResolversParentTypes['EnvironmentalReportVersion'] = TResolversParentTypes['EnvironmentalReportVersion']> = ResolversObject<{
  contentLength?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  contentType?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  environmentalReportId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  filename?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isSignDocument?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  revision?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  uploadUrl?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  uploadedBy?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<TResolversTypes['S3UrlCloudFront'], ParentType, ContextType>;
}>;

export type TEpcByAgentGroupItemResolvers<ContextType = any, ParentType extends TResolversParentTypes['EpcByAgentGroupItem'] = TResolversParentTypes['EpcByAgentGroupItem']> = ResolversObject<{
  count?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  group?: Resolver<TResolversTypes['AgentGroup'], ParentType, ContextType>;
}>;

export type TEpcIncidenceChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['EpcIncidenceChart'] = TResolversParentTypes['EpcIncidenceChart']> = ResolversObject<{
  byAgentGroup?: Resolver<Array<TResolversTypes['EpcByAgentGroupItem']>, ParentType, ContextType>;
  hasEpc?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  totalRisks?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  withEpc?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TEpiLifespanChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['EpiLifespanChart'] = TResolversParentTypes['EpiLifespanChart']> = ResolversObject<{
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['EpiLifespanItem']>, ParentType, ContextType>;
}>;

export type TEpiLifespanItemResolvers<ContextType = any, ParentType extends TResolversParentTypes['EpiLifespanItem'] = TResolversParentTypes['EpiLifespanItem']> = ResolversObject<{
  adherencePct?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  caCode?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  deliveries?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  distinctPeople?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  real?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  registered?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TEquipmentByCostCenterResolvers<ContextType = any, ParentType extends TResolversParentTypes['EquipmentByCostCenter'] = TResolversParentTypes['EquipmentByCostCenter']> = ResolversObject<{
  caCode?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  costCenter?: Resolver<TResolversTypes['CostCenter'], ParentType, ContextType>;
  daysForReplacement?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipe?: Resolver<TResolversTypes['Ipe'], ParentType, ContextType>;
}>;

export type TEquipmentByOccupationResolvers<ContextType = any, ParentType extends TResolversParentTypes['EquipmentByOccupation'] = TResolversParentTypes['EquipmentByOccupation']> = ResolversObject<{
  caCode?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  daysForReplacement?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipe?: Resolver<TResolversTypes['Ipe'], ParentType, ContextType>;
  occupation?: Resolver<TResolversTypes['Occupation'], ParentType, ContextType>;
}>;

export type TErrorResponseResolvers<ContextType = any, ParentType extends TResolversParentTypes['ErrorResponse'] = TResolversParentTypes['ErrorResponse']> = ResolversObject<{
  code?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TEventResolvers<ContextType = any, ParentType extends TResolversParentTypes['Event'] = TResolversParentTypes['Event']> = ResolversObject<{
  dateReference?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  message?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  subDaysEnd?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  subDaysStart?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TExamResolvers<ContextType = any, ParentType extends TResolversParentTypes['Exam'] = TResolversParentTypes['Exam']> = ResolversObject<{
  admission?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  backToWork?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  changeOfFunction?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  dismissal?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  examinationProcedure?: Resolver<Maybe<TResolversTypes['GenericExaminationProcedure']>, ParentType, ContextType>;
  groupAnalysis?: Resolver<Maybe<Array<TResolversTypes['GroupAnalysis']>>, ParentType, ContextType>;
  ibmp?: Resolver<Maybe<TResolversTypes['ExamIbmp']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  periodic?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  periodicRange?: Resolver<Maybe<TResolversTypes['PeriodicRange']>, ParentType, ContextType>;
  preparation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  referenceId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  resultType?: Resolver<TResolversTypes['ResultTypeEnum'], ParentType, ContextType>;
  suggestion?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TExamAlterationTrendResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamAlterationTrend'] = TResolversParentTypes['ExamAlterationTrend']> = ResolversObject<{
  altered?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  normal?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  period?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TExamAnalysisResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamAnalysis'] = TResolversParentTypes['ExamAnalysis']> = ResolversObject<{
  annual_number_of_exams_performed?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  exam?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  number_of_abnormal_results?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  percentage_of_abnormal_results?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TExamAudiometryResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamAudiometry'] = TResolversParentTypes['ExamAudiometry']> = ResolversObject<{
  calibrationDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  complementaryExam?: Resolver<Maybe<TResolversTypes['ComplementaryExam']>, ParentType, ContextType>;
  consultation?: Resolver<Maybe<TResolversTypes['Consultation']>, ParentType, ContextType>;
  crm?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  details?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  diagnosticIndicator?: Resolver<TResolversTypes['ExamDiagnosticIndicatorEnum'], ParentType, ContextType>;
  doctor?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  equipment?: Resolver<TResolversTypes['MeasuringInstrument'], ParentType, ContextType>;
  examAuthorization?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  gaugingDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  indicator?: Resolver<TResolversTypes['ExamResultIndicatorEnum'], ParentType, ContextType>;
  observations?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  odAirEight?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odAirFour?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odAirHigherAvg?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odAirLowerAvg?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odAirMaskEight?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odAirMaskFour?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odAirMaskMarkedEight?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  odAirMaskMarkedFour?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  odAirMaskMarkedOne?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  odAirMaskMarkedPointFive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  odAirMaskMarkedPointTwentyFive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  odAirMaskMarkedSix?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  odAirMaskMarkedThree?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  odAirMaskMarkedTwo?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  odAirMaskMax?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odAirMaskMin?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odAirMaskOne?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odAirMaskPointFive?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odAirMaskPointTwentyFive?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odAirMaskSix?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odAirMaskThree?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odAirMaskTwo?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odAirOne?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odAirPointFive?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odAirPointTwentyFive?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odAirSix?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odAirThree?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odAirTwo?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odBoneFour?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odBoneMaskFour?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odBoneMaskMarkedFour?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  odBoneMaskMarkedOne?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  odBoneMaskMarkedPointFive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  odBoneMaskMarkedThree?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  odBoneMaskMarkedTwo?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  odBoneMaskMax?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odBoneMaskMin?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odBoneMaskOne?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odBoneMaskPointFive?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odBoneMaskThree?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odBoneMaskTwo?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odBoneOne?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odBonePointFive?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odBoneThree?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odBoneTwo?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odClinicalResult?: Resolver<TResolversTypes['AudiometryClinicalEnum'], ParentType, ContextType>;
  odInssResult?: Resolver<TResolversTypes['AudiometryInssEnum'], ParentType, ContextType>;
  odIrfMasking?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odIrfMonosyllables?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odIrfSyllables?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odLossTypeResult?: Resolver<Maybe<TResolversTypes['AudiometryLossTypeEnum']>, ParentType, ContextType>;
  odMeatoscopy?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  odOrdinanceResult?: Resolver<TResolversTypes['AudiometryOrdinanceEnum'], ParentType, ContextType>;
  odSdtIndex?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odSrtIndex?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  odSrtMasking?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeAirEight?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeAirFour?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeAirHigherAvg?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeAirLowerAvg?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeAirMaskEight?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeAirMaskFour?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeAirMaskMarkedEight?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  oeAirMaskMarkedFour?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  oeAirMaskMarkedOne?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  oeAirMaskMarkedPointFive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  oeAirMaskMarkedPointTwentyFive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  oeAirMaskMarkedSix?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  oeAirMaskMarkedThree?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  oeAirMaskMarkedTwo?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  oeAirMaskMax?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeAirMaskMin?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeAirMaskOne?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeAirMaskPointFive?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeAirMaskPointTwentyFive?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeAirMaskSix?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeAirMaskThree?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeAirMaskTwo?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeAirOne?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeAirPointFive?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeAirPointTwentyFive?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeAirSix?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeAirThree?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeAirTwo?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeBoneFour?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeBoneMaskFour?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeBoneMaskMarkedFour?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  oeBoneMaskMarkedOne?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  oeBoneMaskMarkedPointFive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  oeBoneMaskMarkedThree?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  oeBoneMaskMarkedTwo?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  oeBoneMaskMax?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeBoneMaskMin?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeBoneMaskOne?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeBoneMaskPointFive?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeBoneMaskThree?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeBoneMaskTwo?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeBoneOne?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeBonePointFive?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeBoneThree?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeBoneTwo?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeClinicalResult?: Resolver<TResolversTypes['AudiometryClinicalEnum'], ParentType, ContextType>;
  oeInssResult?: Resolver<TResolversTypes['AudiometryInssEnum'], ParentType, ContextType>;
  oeIrfMasking?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeIrfMonosyllables?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeIrfSyllables?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeLossTypeResult?: Resolver<Maybe<TResolversTypes['AudiometryLossTypeEnum']>, ParentType, ContextType>;
  oeMeatoscopy?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  oeOrdinanceResult?: Resolver<TResolversTypes['AudiometryOrdinanceEnum'], ParentType, ContextType>;
  oeSdtIndex?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeSrtIndex?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  oeSrtMasking?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  responsibleForMeasuring?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  restTime?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  resultAggravation?: Resolver<Maybe<TResolversTypes['ExamAggravationEnum']>, ParentType, ContextType>;
  resultAlteration?: Resolver<Maybe<TResolversTypes['ExamResultAlterationEnum']>, ParentType, ContextType>;
  state?: Resolver<Maybe<TResolversTypes['State']>, ParentType, ContextType>;
}>;

export type TExamByBranchToPrintResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamByBranchToPrint'] = TResolversParentTypes['ExamByBranchToPrint']> = ResolversObject<{
  accredited?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  branch?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  costCenter?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctor?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  document?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  eSocialCategory?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  erpBranch?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  estimatedDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  exam?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  individualRegistration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  medicalRecord?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nature?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  organization?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  registration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  startDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TExamByHealthProgramResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamByHealthProgram'] = TResolversParentTypes['ExamByHealthProgram']> = ResolversObject<{
  admission?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  backToWork?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  changeOfFunction?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  dismissal?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  exam?: Resolver<TResolversTypes['Exam'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  periodic?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  periodicRange?: Resolver<Maybe<TResolversTypes['PeriodicRange']>, ParentType, ContextType>;
}>;

export type TExamByOccupationResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamByOccupation'] = TResolversParentTypes['ExamByOccupation']> = ResolversObject<{
  admission?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  backToWork?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  changeOfFunction?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  dismissal?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  exam?: Resolver<TResolversTypes['Exam'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<TResolversTypes['Occupation'], ParentType, ContextType>;
  periodic?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  periodicRange?: Resolver<Maybe<TResolversTypes['PeriodicRange']>, ParentType, ContextType>;
}>;

export type TExamByPersonResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamByPerson'] = TResolversParentTypes['ExamByPerson']> = ResolversObject<{
  examDescription?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  examId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  examType?: Resolver<TResolversTypes['ExamByPersonTypeEnum'], ParentType, ContextType>;
  needSource?: Resolver<TResolversTypes['ExamByPersonNeedSourceEnum'], ParentType, ContextType>;
}>;

export type TExamByRiskResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamByRisk'] = TResolversParentTypes['ExamByRisk']> = ResolversObject<{
  admission?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  backToWork?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  changeOfFunction?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  dismissal?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  exam?: Resolver<TResolversTypes['Exam'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  periodic?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  periodicRange?: Resolver<Maybe<TResolversTypes['PeriodicRange']>, ParentType, ContextType>;
  risk?: Resolver<TResolversTypes['Risk'], ParentType, ContextType>;
}>;

export type TExamByTagResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamByTag'] = TResolversParentTypes['ExamByTag']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  lastRealizationDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  nextRealizationDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
}>;

export type TExamDiagnosticCountResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamDiagnosticCount'] = TResolversParentTypes['ExamDiagnosticCount']> = ResolversObject<{
  altered?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  examType?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  normal?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TExamDiagnosticImageResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamDiagnosticImage'] = TResolversParentTypes['ExamDiagnosticImage']> = ResolversObject<{
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  complementaryExam?: Resolver<Maybe<TResolversTypes['ComplementaryExam']>, ParentType, ContextType>;
  consultation?: Resolver<Maybe<TResolversTypes['Consultation']>, ParentType, ContextType>;
  crm?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  details?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  diagnosticIndicator?: Resolver<TResolversTypes['ExamDiagnosticIndicatorEnum'], ParentType, ContextType>;
  doctor?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  examAuthorization?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  indicator?: Resolver<TResolversTypes['ExamResultIndicatorEnum'], ParentType, ContextType>;
  observations?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  restTime?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  resultAggravation?: Resolver<Maybe<TResolversTypes['ExamAggravationEnum']>, ParentType, ContextType>;
  resultAlteration?: Resolver<Maybe<TResolversTypes['ExamResultAlterationEnum']>, ParentType, ContextType>;
  state?: Resolver<Maybe<TResolversTypes['State']>, ParentType, ContextType>;
}>;

export type TExamIbmpResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamIbmp'] = TResolversParentTypes['ExamIbmp']> = ResolversObject<{
  biologicalMaterial?: Resolver<TResolversTypes['BiologicalMaterial'], ParentType, ContextType>;
  examMeasure?: Resolver<TResolversTypes['ExamMeasure'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  maximumAllowed?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  reference?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  riskAgent?: Resolver<TResolversTypes['RiskAgent'], ParentType, ContextType>;
}>;

export type TExamItemResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamItem'] = TResolversParentTypes['ExamItem']> = ResolversObject<{
  complementaryExam?: Resolver<Maybe<TResolversTypes['ComplementaryExam']>, ParentType, ContextType>;
  consultation?: Resolver<Maybe<TResolversTypes['Consultation']>, ParentType, ContextType>;
  crm?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  details?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  diagnosticIndicator?: Resolver<TResolversTypes['ExamDiagnosticIndicatorEnum'], ParentType, ContextType>;
  doctor?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  examAuthorization?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  examItemValues?: Resolver<Array<TResolversTypes['ExamItemValue']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  indicator?: Resolver<TResolversTypes['ExamResultIndicatorEnum'], ParentType, ContextType>;
  observations?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  restTime?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  resultAggravation?: Resolver<Maybe<TResolversTypes['ExamAggravationEnum']>, ParentType, ContextType>;
  resultAlteration?: Resolver<Maybe<TResolversTypes['ExamResultAlterationEnum']>, ParentType, ContextType>;
  state?: Resolver<Maybe<TResolversTypes['State']>, ParentType, ContextType>;
}>;

export type TExamItemValueResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamItemValue'] = TResolversParentTypes['ExamItemValue']> = ResolversObject<{
  analysis?: Resolver<TResolversTypes['Analysis'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  percentageValue?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TExamItemsCountResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamItemsCount'] = TResolversParentTypes['ExamItemsCount']> = ResolversObject<{
  count?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  exam?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  examId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TExamNormalResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamNormal'] = TResolversParentTypes['ExamNormal']> = ResolversObject<{
  complementaryExam?: Resolver<Maybe<TResolversTypes['ComplementaryExam']>, ParentType, ContextType>;
  consultation?: Resolver<TResolversTypes['Consultation'], ParentType, ContextType>;
  crm?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  details?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  diagnosticIndicator?: Resolver<TResolversTypes['ExamDiagnosticIndicatorEnum'], ParentType, ContextType>;
  doctor?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  examAuthorization?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  indicator?: Resolver<TResolversTypes['ExamResultIndicatorEnum'], ParentType, ContextType>;
  observations?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  restTime?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  resultAggravation?: Resolver<Maybe<TResolversTypes['ExamAggravationEnum']>, ParentType, ContextType>;
  resultAlteration?: Resolver<Maybe<TResolversTypes['ExamResultAlterationEnum']>, ParentType, ContextType>;
  state?: Resolver<Maybe<TResolversTypes['State']>, ParentType, ContextType>;
}>;

export type TExamNormalResultResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamNormalResult'] = TResolversParentTypes['ExamNormalResult']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TExamOnConsultationResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamOnConsultation'] = TResolversParentTypes['ExamOnConsultation']> = ResolversObject<{
  accredited?: Resolver<Maybe<TResolversTypes['Accredited']>, ParentType, ContextType>;
  consultationReference?: Resolver<Maybe<TResolversTypes['Consultation']>, ParentType, ContextType>;
  done?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  exam?: Resolver<TResolversTypes['Exam'], ParentType, ContextType>;
  examId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TExamOtologicalResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamOtological'] = TResolversParentTypes['ExamOtological']> = ResolversObject<{
  complementaryExam?: Resolver<Maybe<TResolversTypes['ComplementaryExam']>, ParentType, ContextType>;
  consultation?: Resolver<Maybe<TResolversTypes['Consultation']>, ParentType, ContextType>;
  crm?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  details?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  diagnosticIndicator?: Resolver<TResolversTypes['ExamDiagnosticIndicatorEnum'], ParentType, ContextType>;
  doctor?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  earParts?: Resolver<Array<TResolversTypes['EarPart']>, ParentType, ContextType>;
  evolutionaryCharacter?: Resolver<TResolversTypes['EvolutionaryCharacterEnum'], ParentType, ContextType>;
  examAuthorization?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  examLocation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  exposureTime?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  indicator?: Resolver<TResolversTypes['ExamResultIndicatorEnum'], ParentType, ContextType>;
  nexusNoise?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  noiseExposure?: Resolver<TResolversTypes['NoiseExposureEnum'], ParentType, ContextType>;
  observations?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  occupational?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  otologicalDiagnosis?: Resolver<TResolversTypes['OtologicalDiagnosisEnum'], ParentType, ContextType>;
  restTime?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  resultAggravation?: Resolver<Maybe<TResolversTypes['ExamAggravationEnum']>, ParentType, ContextType>;
  resultAlteration?: Resolver<Maybe<TResolversTypes['ExamResultAlterationEnum']>, ParentType, ContextType>;
  state?: Resolver<Maybe<TResolversTypes['State']>, ParentType, ContextType>;
  timeUnit?: Resolver<TResolversTypes['TimeUnitEnum'], ParentType, ContextType>;
  useOfIpe?: Resolver<TResolversTypes['UseOfAuricularIpeEnum'], ParentType, ContextType>;
}>;

export type TExamPersonResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamPerson'] = TResolversParentTypes['ExamPerson']> = ResolversObject<{
  dayOne?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  dayTwo?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  exams?: Resolver<TResolversTypes['BiologicalExams'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TExamProviderResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamProvider'] = TResolversParentTypes['ExamProvider']> = ResolversObject<{
  complementaryExams?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isAccredited?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TExamReferralReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamReferralReport'] = TResolversParentTypes['ExamReferralReport']> = ResolversObject<{
  admission?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  age?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  birthDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  costCenter?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  crm?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctorName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctorRqeDisplay?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  employee?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  examDate?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  examTime?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  footer?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  header?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  individualRegistration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isAdmissional?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  isBackToWork?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  isChangeOfFunction?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  isDismissal?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  isPeriodic?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  isSpotMonitoring?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  occupation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  pisCode?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  plannedExamsList?: Resolver<Array<TResolversTypes['PlanedExam']>, ParentType, ContextType>;
  registration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  supplier?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  supplierAddress?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  supplierCity?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  supplierNeighborhood?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  supplierPhone?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TExamReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamReport'] = TResolversParentTypes['ExamReport']> = ResolversObject<{
  attendance?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  details?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  examResponsibleDocument?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  examResponsibleName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  nature?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  observation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  resultIndication?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TExamResultsByMedicalRecordResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamResultsByMedicalRecord'] = TResolversParentTypes['ExamResultsByMedicalRecord']> = ResolversObject<{
  examAudiometries?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  examDiagnosticImage?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  examIbmps?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  examItems?: Resolver<Array<TResolversTypes['ExamItemsCount']>, ParentType, ContextType>;
  examNormals?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  examOtological?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  examSpirometries?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  examToxicological?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  orthoRater?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  snellen?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  urinalysis?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TExamSchedulingResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamScheduling'] = TResolversParentTypes['ExamScheduling']> = ResolversObject<{
  exam?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  examCost?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  realized?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  realizedBillings?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  scheduled?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  scheduledBillings?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  subject?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TExamSpirometryResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamSpirometry'] = TResolversParentTypes['ExamSpirometry']> = ResolversObject<{
  bronchodilator?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  calibrationDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  complementaryExam?: Resolver<Maybe<TResolversTypes['ComplementaryExam']>, ParentType, ContextType>;
  consultation?: Resolver<Maybe<TResolversTypes['Consultation']>, ParentType, ContextType>;
  crm?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  details?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  diagnosticIndicator?: Resolver<TResolversTypes['ExamDiagnosticIndicatorEnum'], ParentType, ContextType>;
  doctor?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  equipment?: Resolver<TResolversTypes['MeasuringInstrument'], ParentType, ContextType>;
  examAuthorization?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  examLocation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  gaugingDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  inconclusiveData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  indicator?: Resolver<TResolversTypes['ExamResultIndicatorEnum'], ParentType, ContextType>;
  observations?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  posFet?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  posFetPercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  posFevFifty?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  posFevFiftyPercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  posFevSeventyFive?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  posFevSeventyFivePercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  posFevTwentyFive?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  posFevTwentyFivePercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  posFevTwentyFiveSeventyFive?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  posFevTwentyFiveSeventyFivePercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  posFifFifty?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  posFifFiftyPercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  posFifSeventyFive?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  posFifSeventyFivePercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  posFifTwentyFive?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  posFifTwentyFivePercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  posFvc?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  posFvcPercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  posPef?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  posPefPercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  posPif?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  posPifPercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  preFet?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  preFetPercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  preFevFifty?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  preFevFiftyPercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  preFevSeventyFive?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  preFevSeventyFivePercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  preFevTwentyFive?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  preFevTwentyFivePercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  preFevTwentyFiveSeventyFive?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  preFevTwentyFiveSeventyFivePercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  preFifFifty?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  preFifFiftyPercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  preFifSeventyFive?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  preFifSeventyFivePercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  preFifTwentyFive?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  preFifTwentyFivePercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  preFvc?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  preFvcPercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  prePef?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  prePefPercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  prePif?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  prePifPercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  responsibleForMeasuring?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  restTime?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  resultAggravation?: Resolver<Maybe<TResolversTypes['ExamAggravationEnum']>, ParentType, ContextType>;
  resultAlteration?: Resolver<Maybe<TResolversTypes['ExamResultAlterationEnum']>, ParentType, ContextType>;
  smoker?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  state?: Resolver<Maybe<TResolversTypes['State']>, ParentType, ContextType>;
  timeBeingSmoker?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TExamTimelineEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamTimelineEntry'] = TResolversParentTypes['ExamTimelineEntry']> = ResolversObject<{
  dates?: Resolver<Array<TResolversTypes['DateTime']>, ParentType, ContextType>;
  examType?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TExamToxicologicalResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamToxicological'] = TResolversParentTypes['ExamToxicological']> = ResolversObject<{
  cnpjLab?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  complementaryExam?: Resolver<Maybe<TResolversTypes['ComplementaryExam']>, ParentType, ContextType>;
  consultation?: Resolver<TResolversTypes['Consultation'], ParentType, ContextType>;
  crm?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  details?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  diagnosticIndicator?: Resolver<TResolversTypes['ExamDiagnosticIndicatorEnum'], ParentType, ContextType>;
  doctor?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  examAuthorization?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  examCode?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  indicator?: Resolver<TResolversTypes['ExamResultIndicatorEnum'], ParentType, ContextType>;
  nameLab?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  observations?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  restTime?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<TResolversTypes['State'], ParentType, ContextType>;
}>;

export type TExamsResolvers<ContextType = any, ParentType extends TResolversParentTypes['Exams'] = TResolversParentTypes['Exams']> = ResolversObject<{
  abnormality?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  alterationType?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  details?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  examDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  examDescription?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  examObservation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  occupationalActivity?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  referentialExam?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TExamsDoneChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamsDoneChart'] = TResolversParentTypes['ExamsDoneChart']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['PieChart']>, ParentType, ContextType>;
  hasConsultation?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TExamsResultQueryResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamsResultQuery'] = TResolversParentTypes['ExamsResultQuery']> = ResolversObject<{
  aggravation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  alteration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  attendance?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  complementaryExamId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  exam?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  examId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nature?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  observation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  resultDescription?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TExamsToDeleteResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExamsToDelete'] = TResolversParentTypes['ExamsToDelete']> = ResolversObject<{
  complementaryExamId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  consultationId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  deleteConsultation?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TExpectedConsultationResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExpectedConsultation'] = TResolversParentTypes['ExpectedConsultation']> = ResolversObject<{
  branch?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  consultationType?: Resolver<TResolversTypes['ConsultationType'], ParentType, ContextType>;
  exams?: Resolver<Maybe<Array<TResolversTypes['ExpectedExam']>>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  medicalRecordId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  patientId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  patientName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  patientPicture?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  previewDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
}>;

export type TExpectedExamResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExpectedExam'] = TResolversParentTypes['ExpectedExam']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  referenceId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TExpectedExamFromQueryResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExpectedExamFromQuery'] = TResolversParentTypes['ExpectedExamFromQuery']> = ResolversObject<{
  consultationType?: Resolver<TResolversTypes['ConsultationType'], ParentType, ContextType>;
  examDescription?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  examId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  lastRealizationDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  medicalRecordId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  nextRealizationDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  patientId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  patientName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  patientPicture?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  previewDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  referenceId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TExpectedGoalResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExpectedGoal'] = TResolversParentTypes['ExpectedGoal']> = ResolversObject<{
  actionPlan?: Resolver<TResolversTypes['ActionPlan'], ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  details?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  responsible?: Resolver<Maybe<TResolversTypes['Person']>, ParentType, ContextType>;
  value?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TExpectedGoalOnActionPlanResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExpectedGoalOnActionPlan'] = TResolversParentTypes['ExpectedGoalOnActionPlan']> = ResolversObject<{
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  details?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  responsible?: Resolver<Maybe<TResolversTypes['Person']>, ParentType, ContextType>;
  value?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TExpenseResolvers<ContextType = any, ParentType extends TResolversParentTypes['Expense'] = TResolversParentTypes['Expense']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  incidence?: Resolver<TResolversTypes['IncidenceExpense'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  referenceId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<TResolversTypes['ExpenseType'], ParentType, ContextType>;
}>;

export type TExpenseOnAccidentResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExpenseOnAccident'] = TResolversParentTypes['ExpenseOnAccident']> = ResolversObject<{
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  expense?: Resolver<TResolversTypes['Expense'], ParentType, ContextType>;
  value?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TExpensiveAccidentsChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExpensiveAccidentsChart'] = TResolversParentTypes['ExpensiveAccidentsChart']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  hasAccident?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  perTotal?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
}>;

export type TExportStatusResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExportStatus'] = TResolversParentTypes['ExportStatus']> = ResolversObject<{
  entity?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  fileType?: Resolver<TResolversTypes['ExporterTypeEnum'], ParentType, ContextType>;
  link?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  progress?: Resolver<Maybe<TResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<TResolversTypes['ExportStatusEnum'], ParentType, ContextType>;
  trackId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TExposureGroupResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExposureGroup'] = TResolversParentTypes['ExposureGroup']> = ResolversObject<{
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  branchRef?: Resolver<TResolversTypes['Branch'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  details?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  exposureCostCenters?: Resolver<Array<TResolversTypes['ExposureGroupCostCenter']>, ParentType, ContextType>;
  exposureDepartments?: Resolver<Array<TResolversTypes['ExposureGroupDepartment']>, ParentType, ContextType>;
  exposureOccupations?: Resolver<Array<TResolversTypes['ExposureGroupOccupation']>, ParentType, ContextType>;
  exposurePersons?: Resolver<Array<TResolversTypes['ExposureGroupPerson']>, ParentType, ContextType>;
  exposureTasks?: Resolver<Array<TResolversTypes['ExposureGroupTask']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TExposureGroupCostCenterResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExposureGroupCostCenter'] = TResolversParentTypes['ExposureGroupCostCenter']> = ResolversObject<{
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  costCenter?: Resolver<TResolversTypes['CostCenter'], ParentType, ContextType>;
  costCenterId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  exposureGroupId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TExposureGroupDepartmentResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExposureGroupDepartment'] = TResolversParentTypes['ExposureGroupDepartment']> = ResolversObject<{
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  department?: Resolver<TResolversTypes['Department'], ParentType, ContextType>;
  departmentId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  exposureGroupId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TExposureGroupOccupationResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExposureGroupOccupation'] = TResolversParentTypes['ExposureGroupOccupation']> = ResolversObject<{
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  exposureGroupId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<TResolversTypes['Occupation'], ParentType, ContextType>;
  occupationId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TExposureGroupPersonResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExposureGroupPerson'] = TResolversParentTypes['ExposureGroupPerson']> = ResolversObject<{
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  exposureGroup?: Resolver<TResolversTypes['ExposureGroup'], ParentType, ContextType>;
  exposureGroupId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  personId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TExposureGroupTaskResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExposureGroupTask'] = TResolversParentTypes['ExposureGroupTask']> = ResolversObject<{
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  exposureGroupId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  task?: Resolver<TResolversTypes['Task'], ParentType, ContextType>;
  taskId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TExternalDeliveryChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExternalDeliveryChart'] = TResolversParentTypes['ExternalDeliveryChart']> = ResolversObject<{
  external?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  hasIpeDeliveries?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  internal?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TExternalDoctorResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExternalDoctor'] = TResolversParentTypes['ExternalDoctor']> = ResolversObject<{
  crmState?: Resolver<Maybe<TResolversTypes['State']>, ParentType, ContextType>;
  doctorCrm?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctorName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TExternalFieldsResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExternalFields'] = TResolversParentTypes['ExternalFields']> = ResolversObject<{
  default?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  integrationType?: Resolver<Maybe<TResolversTypes['ErpType']>, ParentType, ContextType>;
  internalFieldId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  metadataId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  required?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<TResolversTypes['FieldType']>, ParentType, ContextType>;
}>;

export type TExternalOccupationalHealthCertificateResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExternalOccupationalHealthCertificate'] = TResolversParentTypes['ExternalOccupationalHealthCertificate']> = ResolversObject<{
  consultation?: Resolver<Maybe<TResolversTypes['Consultation']>, ParentType, ContextType>;
  examResult?: Resolver<Maybe<TResolversTypes['ExamNormal']>, ParentType, ContextType>;
  occupationalHealthCertificate?: Resolver<Maybe<TResolversTypes['OccupationalHealthCertificate']>, ParentType, ContextType>;
}>;

export type TExternalOccupationalHealthCertificateResponseResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExternalOccupationalHealthCertificateResponse'] = TResolversParentTypes['ExternalOccupationalHealthCertificateResponse']> = ResolversObject<{
  certificateUpdated?: Resolver<Maybe<TResolversTypes['OccupationalHealthCertificate']>, ParentType, ContextType>;
  consultationUpdated?: Resolver<Maybe<TResolversTypes['Consultation']>, ParentType, ContextType>;
  resultCreated?: Resolver<Maybe<TResolversTypes['ExamNormal']>, ParentType, ContextType>;
  resultUpdated?: Resolver<Maybe<TResolversTypes['ExamNormal']>, ParentType, ContextType>;
}>;

export type TExtinguishingDonutChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExtinguishingDonutChart'] = TResolversParentTypes['ExtinguishingDonutChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['ExtinguishingDonutEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  total?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TExtinguishingDonutEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExtinguishingDonutEntry'] = TResolversParentTypes['ExtinguishingDonutEntry']> = ResolversObject<{
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TExtinguishingInspectionChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExtinguishingInspectionChart'] = TResolversParentTypes['ExtinguishingInspectionChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['ExtinguishingInspectionEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  totalCanceled?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  totalFinished?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  totalPending?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TExtinguishingInspectionEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExtinguishingInspectionEntry'] = TResolversParentTypes['ExtinguishingInspectionEntry']> = ResolversObject<{
  canceled?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  finished?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  pending?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TExtinguishingParetoChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExtinguishingParetoChart'] = TResolversParentTypes['ExtinguishingParetoChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['ExtinguishingParetoEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  total?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TExtinguishingParetoEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExtinguishingParetoEntry'] = TResolversParentTypes['ExtinguishingParetoEntry']> = ResolversObject<{
  cumulativePercent?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TExtinguishingSystemResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExtinguishingSystem'] = TResolversParentTypes['ExtinguishingSystem']> = ResolversObject<{
  abnt?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  brand?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  degreeOfFire?: Resolver<Maybe<TResolversTypes['DegreeOfFire']>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  emptyWeight?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  extinguishingCapacity?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  fireExtinguisherType?: Resolver<Maybe<TResolversTypes['FireExtinguisherType']>, ParentType, ContextType>;
  fullWeight?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  hidraulicInspections?: Resolver<Maybe<Array<TResolversTypes['HidraulicSystemInspection']>>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  inspectionPeriodicity?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  inspections?: Resolver<Maybe<Array<TResolversTypes['ExtinguishingSystemInspection']>>, ParentType, ContextType>;
  location?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  maintenanceStatus?: Resolver<Maybe<TResolversTypes['ExtinguishingSystemMaintenance']>, ParentType, ContextType>;
  manufacturingYear?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  model?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  nextMaintenance?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  physicalEnvironment?: Resolver<TResolversTypes['PhysicalEnvironment'], ParentType, ContextType>;
  physicalEnvironmentId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  purchaseDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  situation?: Resolver<TResolversTypes['ExtinguishingSystemSituation'], ParentType, ContextType>;
  systemType?: Resolver<TResolversTypes['ExtinguishingSystemType'], ParentType, ContextType>;
}>;

export type TExtinguishingSystemDashboardResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExtinguishingSystemDashboard'] = TResolversParentTypes['ExtinguishingSystemDashboard']> = ResolversObject<{
  extinguisherEnvironmentChart?: Resolver<TResolversTypes['ExtinguishingParetoChart'], ParentType, ContextType>;
  extinguisherInspectionChart?: Resolver<TResolversTypes['ExtinguishingInspectionChart'], ParentType, ContextType>;
  extinguisherInspectionIssuesChart?: Resolver<TResolversTypes['ExtinguishingParetoChart'], ParentType, ContextType>;
  extinguisherStatusChart?: Resolver<TResolversTypes['ExtinguishingDonutChart'], ParentType, ContextType>;
  extinguisherTypeChart?: Resolver<TResolversTypes['ExtinguishingDonutChart'], ParentType, ContextType>;
  hidraulicEnvironmentChart?: Resolver<TResolversTypes['ExtinguishingParetoChart'], ParentType, ContextType>;
  hidraulicInspectionChart?: Resolver<TResolversTypes['ExtinguishingInspectionChart'], ParentType, ContextType>;
  hidraulicInspectionIssuesChart?: Resolver<TResolversTypes['ExtinguishingParetoChart'], ParentType, ContextType>;
  hidraulicStatusChart?: Resolver<TResolversTypes['ExtinguishingDonutChart'], ParentType, ContextType>;
}>;

export type TExtinguishingSystemInspectionResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExtinguishingSystemInspection'] = TResolversParentTypes['ExtinguishingSystemInspection']> = ResolversObject<{
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  completeValve?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  cylindricalValve?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  diffuserReplacement?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  drillUsed?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  extinguishingSystem?: Resolver<TResolversTypes['ExtinguishingSystem'], ParentType, ContextType>;
  fireUsed?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  hose?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  hydrostaticTest?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  monometer?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  observation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  painting?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  plannedDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  realDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  realoaded?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  reloadDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  responsible?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  safetyValve?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  situation?: Resolver<TResolversTypes['InspectionSituation'], ParentType, ContextType>;
  sundry?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  triggerReplacement?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TExtinguishingSystemRawResolvers<ContextType = any, ParentType extends TResolversParentTypes['ExtinguishingSystemRaw'] = TResolversParentTypes['ExtinguishingSystemRaw']> = ResolversObject<{
  abnt?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  brand?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  degreeOfFire?: Resolver<Maybe<TResolversTypes['DegreeOfFire']>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  emptyWeight?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  extinguishingCapacity?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  fireExtinguisherType?: Resolver<Maybe<TResolversTypes['FireExtinguisherType']>, ParentType, ContextType>;
  fullWeight?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  inspectionPeriodicity?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  location?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  maintenance?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  maintenanceStatus?: Resolver<Maybe<TResolversTypes['ExtinguishingSystemMaintenance']>, ParentType, ContextType>;
  manufacturingYear?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  model?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  nextMaintenance?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  physicalEnvironmentDescription?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  physicalEnvironmentId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  purchaseDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  situation?: Resolver<TResolversTypes['ExtinguishingSystemSituation'], ParentType, ContextType>;
  systemType?: Resolver<TResolversTypes['ExtinguishingSystemType'], ParentType, ContextType>;
}>;

export type TFavoriteOptionResolvers<ContextType = any, ParentType extends TResolversParentTypes['FavoriteOption'] = TResolversParentTypes['FavoriteOption']> = ResolversObject<{
  iconType?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  route?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TFeatureObjectResolvers<ContextType = any, ParentType extends TResolversParentTypes['FeatureObject'] = TResolversParentTypes['FeatureObject']> = ResolversObject<{
  feature?: Resolver<TResolversTypes['Feature'], ParentType, ContextType>;
  version?: Resolver<TResolversTypes['FeatureVersion'], ParentType, ContextType>;
}>;

export type TFeaturePermissionResolvers<ContextType = any, ParentType extends TResolversParentTypes['FeaturePermission'] = TResolversParentTypes['FeaturePermission']> = ResolversObject<{
  feature?: Resolver<TResolversTypes['FeatureEnum'], ParentType, ContextType>;
  type?: Resolver<Maybe<TResolversTypes['FeaturePermissionType']>, ParentType, ContextType>;
}>;

export type TFeatureReturnResolvers<ContextType = any, ParentType extends TResolversParentTypes['FeatureReturn'] = TResolversParentTypes['FeatureReturn']> = ResolversObject<{
  feature?: Resolver<TResolversTypes['Feature'], ParentType, ContextType>;
  version?: Resolver<TResolversTypes['FeatureVersion'], ParentType, ContextType>;
}>;

export type TFeatureVersionReturnResolvers<ContextType = any, ParentType extends TResolversParentTypes['FeatureVersionReturn'] = TResolversParentTypes['FeatureVersionReturn']> = ResolversObject<{
  feature?: Resolver<TResolversTypes['Feature'], ParentType, ContextType>;
  flag?: Resolver<TResolversTypes['Flag'], ParentType, ContextType>;
  version?: Resolver<TResolversTypes['FeatureVersion'], ParentType, ContextType>;
}>;

export type TFireBrigadeResolvers<ContextType = any, ParentType extends TResolversParentTypes['FireBrigade'] = TResolversParentTypes['FireBrigade']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  endDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  startDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type TFireBrigadeBloodTypeChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['FireBrigadeBloodTypeChart'] = TResolversParentTypes['FireBrigadeBloodTypeChart']> = ResolversObject<{
  aNegative?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  aPositive?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  abNegative?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  abPositive?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  bNegative?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  bPositive?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  na?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  oNegative?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  oPositive?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TFireBrigadeComponentResolvers<ContextType = any, ParentType extends TResolversParentTypes['FireBrigadeComponent'] = TResolversParentTypes['FireBrigadeComponent']> = ResolversObject<{
  assignments?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  exitDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  fireBrigade?: Resolver<TResolversTypes['FireBrigade'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  inclusionDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  specificFunction?: Resolver<TResolversTypes['FireBrigadeSpecificFunction'], ParentType, ContextType>;
}>;

export type TFireBrigadeComponentActiveStatusChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['FireBrigadeComponentActiveStatusChart'] = TResolversParentTypes['FireBrigadeComponentActiveStatusChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['ComponentActiveStatusEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  totalComponents?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TFireBrigadeComponentByCostCenterChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['FireBrigadeComponentByCostCenterChart'] = TResolversParentTypes['FireBrigadeComponentByCostCenterChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['CostCenterEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  totalComponents?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TFireBrigadeDashboardResolvers<ContextType = any, ParentType extends TResolversParentTypes['FireBrigadeDashboard'] = TResolversParentTypes['FireBrigadeDashboard']> = ResolversObject<{
  bloodTypeChart?: Resolver<TResolversTypes['FireBrigadeBloodTypeChart'], ParentType, ContextType>;
  componentActiveStatusChart?: Resolver<TResolversTypes['FireBrigadeComponentActiveStatusChart'], ParentType, ContextType>;
  componentsByCostCenter?: Resolver<TResolversTypes['FireBrigadeComponentByCostCenterChart'], ParentType, ContextType>;
  meetings?: Resolver<TResolversTypes['FireBrigadeMeetingChart'], ParentType, ContextType>;
  occurrences?: Resolver<TResolversTypes['FireBrigadeOccurrenceChart'], ParentType, ContextType>;
  simulationActionChart?: Resolver<TResolversTypes['FireBrigadeSimulationActionChart'], ParentType, ContextType>;
  simulationsChart?: Resolver<TResolversTypes['FireBrigadeSimulationsChart'], ParentType, ContextType>;
}>;

export type TFireBrigadeExamResolvers<ContextType = any, ParentType extends TResolversParentTypes['FireBrigadeExam'] = TResolversParentTypes['FireBrigadeExam']> = ResolversObject<{
  admission?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  backToWork?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  changeOfFunction?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  dismissal?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  exam?: Resolver<TResolversTypes['Exam'], ParentType, ContextType>;
  fireBrigade?: Resolver<TResolversTypes['FireBrigade'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  periodic?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  periodicRange?: Resolver<Maybe<TResolversTypes['PeriodicRange']>, ParentType, ContextType>;
}>;

export type TFireBrigadeMeetingResolvers<ContextType = any, ParentType extends TResolversParentTypes['FireBrigadeMeeting'] = TResolversParentTypes['FireBrigadeMeeting']> = ResolversObject<{
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  duration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  fireBrigade?: Resolver<TResolversTypes['FireBrigade'], ParentType, ContextType>;
  fireBrigadeMeetingActions?: Resolver<Maybe<Array<TResolversTypes['FireBrigadeMeetingAction']>>, ParentType, ContextType>;
  fireBrigadeMeetingParticipants?: Resolver<Maybe<Array<TResolversTypes['FireBrigadeMeetingParticipant']>>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  meetingFormat?: Resolver<TResolversTypes['MeetingFormat'], ParentType, ContextType>;
  meetingLocal?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  meetingType?: Resolver<TResolversTypes['MeetingType'], ParentType, ContextType>;
  minutesMeeting?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  realDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  subject?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TFireBrigadeMeetingActionResolvers<ContextType = any, ParentType extends TResolversParentTypes['FireBrigadeMeetingAction'] = TResolversParentTypes['FireBrigadeMeetingAction']> = ResolversObject<{
  active?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  dateAction?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TFireBrigadeMeetingChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['FireBrigadeMeetingChart'] = TResolversParentTypes['FireBrigadeMeetingChart']> = ResolversObject<{
  extraordinaryMeetings?: Resolver<Array<TResolversTypes['MeetingEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  ordinaryMeetings?: Resolver<Array<TResolversTypes['MeetingEntry']>, ParentType, ContextType>;
  totalExtraordinaryMeetings?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  totalOrdinaryMeetings?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TFireBrigadeMeetingParticipantResolvers<ContextType = any, ParentType extends TResolversParentTypes['FireBrigadeMeetingParticipant'] = TResolversParentTypes['FireBrigadeMeetingParticipant']> = ResolversObject<{
  attendance?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  justification?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
}>;

export type TFireBrigadeOccurrenceResolvers<ContextType = any, ParentType extends TResolversParentTypes['FireBrigadeOccurrence'] = TResolversParentTypes['FireBrigadeOccurrence']> = ResolversObject<{
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  detailing?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  fireBrigade?: Resolver<TResolversTypes['FireBrigade'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  summary?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TFireBrigadeOccurrenceChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['FireBrigadeOccurrenceChart'] = TResolversParentTypes['FireBrigadeOccurrenceChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['OccurrenceEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  totalOccurrences?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TFireBrigadePeriodResolvers<ContextType = any, ParentType extends TResolversParentTypes['FireBrigadePeriod'] = TResolversParentTypes['FireBrigadePeriod']> = ResolversObject<{
  descFireBrigade?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  namePerson?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  specFuncFireBrigadeComp?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TFireBrigadeSimulationActionChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['FireBrigadeSimulationActionChart'] = TResolversParentTypes['FireBrigadeSimulationActionChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['SimulationActionEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  totalAccomplished?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  totalEffective?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  totalPlanned?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TFireBrigadeSimulationsChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['FireBrigadeSimulationsChart'] = TResolversParentTypes['FireBrigadeSimulationsChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['SimulationEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  totalAccomplished?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  totalPlanned?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TFireBrigadeTrainingResolvers<ContextType = any, ParentType extends TResolversParentTypes['FireBrigadeTraining'] = TResolversParentTypes['FireBrigadeTraining']> = ResolversObject<{
  errorIntegration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  fireBrigade?: Resolver<TResolversTypes['FireBrigade'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  training?: Resolver<TResolversTypes['Training'], ParentType, ContextType>;
  urgency?: Resolver<TResolversTypes['TrainingUrgency'], ParentType, ContextType>;
}>;

export type TFirstStepsResolvers<ContextType = any, ParentType extends TResolversParentTypes['FirstSteps'] = TResolversParentTypes['FirstSteps']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['ItemsSteps']>, ParentType, ContextType>;
  percentage?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  subtitle?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  summary?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TFlagRelationResolvers<ContextType = any, ParentType extends TResolversParentTypes['FlagRelation'] = TResolversParentTypes['FlagRelation']> = ResolversObject<{
  flag?: Resolver<TResolversTypes['Flag'], ParentType, ContextType>;
  priority?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TFlagReturnResolvers<ContextType = any, ParentType extends TResolversParentTypes['FlagReturn'] = TResolversParentTypes['FlagReturn']> = ResolversObject<{
  flag?: Resolver<TResolversTypes['Flag'], ParentType, ContextType>;
  version?: Resolver<TResolversTypes['FeatureVersion'], ParentType, ContextType>;
}>;

export type TFrequencyIndexResolvers<ContextType = any, ParentType extends TResolversParentTypes['FrequencyIndex'] = TResolversParentTypes['FrequencyIndex']> = ResolversObject<{
  description?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  index?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TFuncionalHistoryResolvers<ContextType = any, ParentType extends TResolversParentTypes['FuncionalHistory'] = TResolversParentTypes['FuncionalHistory']> = ResolversObject<{
  costCenter?: Resolver<TResolversTypes['CostCenter'], ParentType, ContextType>;
  department?: Resolver<Maybe<TResolversTypes['Department']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<TResolversTypes['Occupation'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  position?: Resolver<Maybe<TResolversTypes['Position']>, ParentType, ContextType>;
  realizationDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  sefip?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TFuncionalHistoryByPersonResolvers<ContextType = any, ParentType extends TResolversParentTypes['FuncionalHistoryByPerson'] = TResolversParentTypes['FuncionalHistoryByPerson']> = ResolversObject<{
  costCenter?: Resolver<TResolversTypes['CostCenter'], ParentType, ContextType>;
  department?: Resolver<Maybe<TResolversTypes['Department']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<TResolversTypes['Occupation'], ParentType, ContextType>;
  position?: Resolver<Maybe<TResolversTypes['Position']>, ParentType, ContextType>;
  realizationDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  sefip?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TFuncionalHistoryControlMeasureResolvers<ContextType = any, ParentType extends TResolversParentTypes['FuncionalHistoryControlMeasure'] = TResolversParentTypes['FuncionalHistoryControlMeasure']> = ResolversObject<{
  measure?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TFuncionalHistoryExamResolvers<ContextType = any, ParentType extends TResolversParentTypes['FuncionalHistoryExam'] = TResolversParentTypes['FuncionalHistoryExam']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  resultType?: Resolver<TResolversTypes['ResultTypeEnum'], ParentType, ContextType>;
}>;

export type TFuncionalHistoryExamTranslatedResolvers<ContextType = any, ParentType extends TResolversParentTypes['FuncionalHistoryExamTranslated'] = TResolversParentTypes['FuncionalHistoryExamTranslated']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  resultType?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TFuncionalHistoryIpeResolvers<ContextType = any, ParentType extends TResolversParentTypes['FuncionalHistoryIpe'] = TResolversParentTypes['FuncionalHistoryIpe']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  protection?: Resolver<TResolversTypes['IpeProtection'], ParentType, ContextType>;
}>;

export type TFuncionalHistoryIpeTranslatedResolvers<ContextType = any, ParentType extends TResolversParentTypes['FuncionalHistoryIpeTranslated'] = TResolversParentTypes['FuncionalHistoryIpeTranslated']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  protection?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TFuncionalHistoryRiskResolvers<ContextType = any, ParentType extends TResolversParentTypes['FuncionalHistoryRisk'] = TResolversParentTypes['FuncionalHistoryRisk']> = ResolversObject<{
  amount?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  controlMeasure?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  damageCaused?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  generatingSource?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  riskDegree?: Resolver<TResolversTypes['RiskDegree'], ParentType, ContextType>;
  unitMeasurement?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TFuncionalHistoryRiskTranslatedResolvers<ContextType = any, ParentType extends TResolversParentTypes['FuncionalHistoryRiskTranslated'] = TResolversParentTypes['FuncionalHistoryRiskTranslated']> = ResolversObject<{
  agentField?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  amount?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  colspan?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  controlMeasure?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  controlMeasuresField?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  damageCaused?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  generatingSource?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  generatingSourceField?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  healthDamageField?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  quantificationField?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  riskDegree?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  riskDegreeField?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TFunctionsTaskResolvers<ContextType = any, ParentType extends TResolversParentTypes['FunctionsTask'] = TResolversParentTypes['FunctionsTask']> = ResolversObject<{
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupationDesc?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  taskDesc?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  workedHours?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TGeneratingSourceResolvers<ContextType = any, ParentType extends TResolversParentTypes['GeneratingSource'] = TResolversParentTypes['GeneratingSource']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  sourcePicture?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  uploadUrl?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TGenericAccidentCauseResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericAccidentCause'] = TResolversParentTypes['GenericAccidentCause']> = ResolversObject<{
  causeType?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TGenericActivePrincipleResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericActivePrinciple'] = TResolversParentTypes['GenericActivePrinciple']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TGenericAgeRangeResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericAgeRange'] = TResolversParentTypes['GenericAgeRange']> = ResolversObject<{
  fromAge?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  periodicRangeId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  periodicity?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  toAge?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TGenericBiologicalMonitoringExamResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericBiologicalMonitoringExam'] = TResolversParentTypes['GenericBiologicalMonitoringExam']> = ResolversObject<{
  exam?: Resolver<TResolversTypes['GenericExam'], ParentType, ContextType>;
  group?: Resolver<TResolversTypes['GenericBiologicalMonitoringExamGroup'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  secondExamInterval?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  thirdExamInterval?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TGenericBiologicalMonitoringExamGroupResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericBiologicalMonitoringExamGroup'] = TResolversParentTypes['GenericBiologicalMonitoringExamGroup']> = ResolversObject<{
  biologicalExams?: Resolver<Maybe<Array<TResolversTypes['GenericBiologicalMonitoringExam']>>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TGenericCostCenterResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericCostCenter'] = TResolversParentTypes['GenericCostCenter']> = ResolversObject<{
  classCostCenter?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TGenericExamResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericExam'] = TResolversParentTypes['GenericExam']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  examinationProcedure?: Resolver<Maybe<TResolversTypes['GenericExaminationProcedure']>, ParentType, ContextType>;
  ibmp?: Resolver<Maybe<TResolversTypes['GenericExamIbmp']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  resultType?: Resolver<TResolversTypes['ResultTypeEnum'], ParentType, ContextType>;
  suggestion?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TGenericExamIbmpResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericExamIbmp'] = TResolversParentTypes['GenericExamIbmp']> = ResolversObject<{
  biologicalMaterial?: Resolver<TResolversTypes['BiologicalMaterial'], ParentType, ContextType>;
  examMeasure?: Resolver<TResolversTypes['ExamMeasure'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  maximumAllowed?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  reference?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  riskAgent?: Resolver<TResolversTypes['GenericRiskAgent'], ParentType, ContextType>;
}>;

export type TGenericExaminationProcedureResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericExaminationProcedure'] = TResolversParentTypes['GenericExaminationProcedure']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  eSocialCode?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TGenericExpenseResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericExpense'] = TResolversParentTypes['GenericExpense']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  incidence?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TGenericHealthProgramResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericHealthProgram'] = TResolversParentTypes['GenericHealthProgram']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  programType?: Resolver<TResolversTypes['ProgramType'], ParentType, ContextType>;
}>;

export type TGenericLaboratoryResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericLaboratory'] = TResolversParentTypes['GenericLaboratory']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TGenericMeasuringInstrumentResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericMeasuringInstrument'] = TResolversParentTypes['GenericMeasuringInstrument']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TGenericMedicineResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericMedicine'] = TResolversParentTypes['GenericMedicine']> = ResolversObject<{
  activePrinciple?: Resolver<TResolversTypes['GenericActivePrinciple'], ParentType, ContextType>;
  ambulatoryMedicine?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<TResolversTypes['MedicineLabelEnum'], ParentType, ContextType>;
  laboratory?: Resolver<TResolversTypes['GenericLaboratory'], ParentType, ContextType>;
  presentation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  suggestion?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TGenericMetadataResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericMetadata'] = TResolversParentTypes['GenericMetadata']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<TResolversTypes['MetadataType'], ParentType, ContextType>;
}>;

export type TGenericOccupationResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericOccupation'] = TResolversParentTypes['GenericOccupation']> = ResolversObject<{
  cbo?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  suggestion?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TGenericPeriodicRangeResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericPeriodicRange'] = TResolversParentTypes['GenericPeriodicRange']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  gender?: Resolver<TResolversTypes['PeriodicRangeGenderEnum'], ParentType, ContextType>;
  genericAgeRanges?: Resolver<Array<TResolversTypes['GenericAgeRange']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TGenericPublicPlaceResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericPublicPlace'] = TResolversParentTypes['GenericPublicPlace']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  eSocialCode?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TGenericQuestionGroupResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericQuestionGroup'] = TResolversParentTypes['GenericQuestionGroup']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  genericQuestionsQuiz?: Resolver<Array<TResolversTypes['GenericQuestionQuiz']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TGenericQuestionQuizResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericQuestionQuiz'] = TResolversParentTypes['GenericQuestionQuiz']> = ResolversObject<{
  defaultOption?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  gender?: Resolver<TResolversTypes['QuestionGenderEnum'], ParentType, ContextType>;
  genericResponseOptions?: Resolver<Array<TResolversTypes['GenericResponseOption']>, ParentType, ContextType>;
  hasDetails?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  order?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  responseType?: Resolver<TResolversTypes['ResponseType'], ParentType, ContextType>;
}>;

export type TGenericQuizResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericQuiz'] = TResolversParentTypes['GenericQuiz']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  genericQuestionsGroup?: Resolver<Array<TResolversTypes['GenericQuestionGroup']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TGenericReportSectionResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericReportSection'] = TResolversParentTypes['GenericReportSection']> = ResolversObject<{
  breakPage?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  content?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  order?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  pageOrientation?: Resolver<TResolversTypes['PageOrientation'], ParentType, ContextType>;
  reportStructureId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  shortcut?: Resolver<Maybe<TResolversTypes['Shortcut']>, ParentType, ContextType>;
  type?: Resolver<TResolversTypes['ReportSectionType'], ParentType, ContextType>;
}>;

export type TGenericReportStructureResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericReportStructure'] = TResolversParentTypes['GenericReportStructure']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  sections?: Resolver<Maybe<Array<TResolversTypes['GenericReportSection']>>, ParentType, ContextType>;
  type?: Resolver<TResolversTypes['ReportType'], ParentType, ContextType>;
}>;

export type TGenericResponseOptionResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericResponseOption'] = TResolversParentTypes['GenericResponseOption']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TGenericRiskAgentResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericRiskAgent'] = TResolversParentTypes['GenericRiskAgent']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  eSocialCode?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  group?: Resolver<TResolversTypes['AgentGroup'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TGenericRolePermissionResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericRolePermission'] = TResolversParentTypes['GenericRolePermission']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  permission?: Resolver<Array<TResolversTypes['Permission']>, ParentType, ContextType>;
}>;

export type TGenericStatementResponsibilityResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericStatementResponsibility'] = TResolversParentTypes['GenericStatementResponsibility']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  statement?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TGenericTaskResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericTask'] = TResolversParentTypes['GenericTask']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  eSocialCode?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TGenericTrainingResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericTraining'] = TResolversParentTypes['GenericTraining']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  eSocialCode?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TGenericVaccineResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericVaccine'] = TResolversParentTypes['GenericVaccine']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  gender?: Resolver<TResolversTypes['VaccineGenderEnum'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TGenericWorkShiftResolvers<ContextType = any, ParentType extends TResolversParentTypes['GenericWorkShift'] = TResolversParentTypes['GenericWorkShift']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  productiveHours?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TGroupAnalysisResolvers<ContextType = any, ParentType extends TResolversParentTypes['GroupAnalysis'] = TResolversParentTypes['GroupAnalysis']> = ResolversObject<{
  analysis?: Resolver<Maybe<Array<TResolversTypes['Analysis']>>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  examMeasure?: Resolver<Maybe<TResolversTypes['ExamMeasure']>, ParentType, ContextType>;
  hasPercent?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type THasFinishedExamResolvers<ContextType = any, ParentType extends TResolversParentTypes['HasFinishedExam'] = TResolversParentTypes['HasFinishedExam']> = ResolversObject<{
  hasAtLeastOne?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type THealthProgramResolvers<ContextType = any, ParentType extends TResolversParentTypes['HealthProgram'] = TResolversParentTypes['HealthProgram']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  exams?: Resolver<Maybe<Array<TResolversTypes['ExamByHealthProgram']>>, ParentType, ContextType>;
  exposureGroup?: Resolver<Maybe<TResolversTypes['ExposureGroup']>, ParentType, ContextType>;
  exposureGroupId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupations?: Resolver<Maybe<Array<TResolversTypes['HealthProgramOccupation']>>, ParentType, ContextType>;
  programType?: Resolver<TResolversTypes['ProgramType'], ParentType, ContextType>;
  referenceId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  trainings?: Resolver<Maybe<Array<TResolversTypes['HealthProgramTraining']>>, ParentType, ContextType>;
}>;

export type THealthProgramChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['HealthProgramChart'] = TResolversParentTypes['HealthProgramChart']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  hasHealthPrograms?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type THealthProgramOccupationResolvers<ContextType = any, ParentType extends TResolversParentTypes['HealthProgramOccupation'] = TResolversParentTypes['HealthProgramOccupation']> = ResolversObject<{
  healthProgram?: Resolver<TResolversTypes['HealthProgram'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<TResolversTypes['Occupation'], ParentType, ContextType>;
}>;

export type THealthProgramTrainingResolvers<ContextType = any, ParentType extends TResolversParentTypes['HealthProgramTraining'] = TResolversParentTypes['HealthProgramTraining']> = ResolversObject<{
  errorIntegration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  healthProgram?: Resolver<TResolversTypes['HealthProgram'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  training?: Resolver<TResolversTypes['Training'], ParentType, ContextType>;
  urgency?: Resolver<TResolversTypes['TrainingUrgency'], ParentType, ContextType>;
}>;

export type THealthQuizzesResolvers<ContextType = any, ParentType extends TResolversParentTypes['HealthQuizzes'] = TResolversParentTypes['HealthQuizzes']> = ResolversObject<{
  count?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type THidraulicInspectionReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['HidraulicInspectionReport'] = TResolversParentTypes['HidraulicInspectionReport']> = ResolversObject<{
  address?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  cnpj?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  companyName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  fields?: Resolver<TResolversTypes['HidraulicInspectionReportFields'], ParentType, ContextType>;
  footer?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  hidraulicSystem?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  hoses?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  local?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  plannedDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  realDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  record?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  responsible?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  shelter?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  signaling?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  situation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  squirts?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  storzkey?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  sundry?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  telephone?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type THidraulicInspectionReportFieldsResolvers<ContextType = any, ParentType extends TResolversParentTypes['HidraulicInspectionReportFields'] = TResolversParentTypes['HidraulicInspectionReportFields']> = ResolversObject<{
  activities?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  drillUsed?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  fireUsed?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  hidraulicSystem?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  hoses?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  local?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  no?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  plannedDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  realDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  record?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  responsible?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  shelter?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  signaling?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  situation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  squirts?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  storzkey?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  sundry?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  yes?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type THidraulicSystemInspectionResolvers<ContextType = any, ParentType extends TResolversParentTypes['HidraulicSystemInspection'] = TResolversParentTypes['HidraulicSystemInspection']> = ResolversObject<{
  drillUsed?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  extinguishingSystem?: Resolver<TResolversTypes['ExtinguishingSystem'], ParentType, ContextType>;
  fireUsed?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  hoses?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  observation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  plannedDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  realDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  record?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  responsible?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  shelter?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  signaling?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  situation?: Resolver<TResolversTypes['InspectionSituation'], ParentType, ContextType>;
  squirts?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  storzkey?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  sundry?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type THistoricResolvers<ContextType = any, ParentType extends TResolversParentTypes['Historic'] = TResolversParentTypes['Historic']> = ResolversObject<{
  medicalConsultations?: Resolver<Maybe<Array<TResolversTypes['MedicalConsultation']>>, ParentType, ContextType>;
  sickNotes?: Resolver<Maybe<Array<TResolversTypes['SickNote']>>, ParentType, ContextType>;
}>;

export type THistoricDataResolvers<ContextType = any, ParentType extends TResolversParentTypes['HistoricData'] = TResolversParentTypes['HistoricData']> = ResolversObject<{
  costCenter?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  deliveryAmount?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  deliveryReason?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipeDescription?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  registration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TIcdResolvers<ContextType = any, ParentType extends TResolversParentTypes['Icd'] = TResolversParentTypes['Icd']> = ResolversObject<{
  classType?: Resolver<Maybe<TResolversTypes['ClassICDType']>, ParentType, ContextType>;
  code?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  deathCause?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  gender?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  icdGroupRef?: Resolver<TResolversTypes['IcdGroup'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  suggestion?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TIcdGroupResolvers<ContextType = any, ParentType extends TResolversParentTypes['IcdGroup'] = TResolversParentTypes['IcdGroup']> = ResolversObject<{
  classType?: Resolver<Maybe<TResolversTypes['ClassICDType']>, ParentType, ContextType>;
  code?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  suggestion?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TImcChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['ImcChart'] = TResolversParentTypes['ImcChart']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TImportStatusResolvers<ContextType = any, ParentType extends TResolversParentTypes['ImportStatus'] = TResolversParentTypes['ImportStatus']> = ResolversObject<{
  errorsCsv?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  importId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  processedLines?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['ImporterStatus'], ParentType, ContextType>;
  totalLines?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TIndexChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['IndexChart'] = TResolversParentTypes['IndexChart']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  hasAccident?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TIndicatorResolvers<ContextType = any, ParentType extends TResolversParentTypes['Indicator'] = TResolversParentTypes['Indicator']> = ResolversObject<{
  indicator?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TInjuryNatureResolvers<ContextType = any, ParentType extends TResolversParentTypes['InjuryNature'] = TResolversParentTypes['InjuryNature']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  eSocialCode?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TInputDataResolvers<ContextType = any, ParentType extends TResolversParentTypes['InputData'] = TResolversParentTypes['InputData']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TInspectionOnExtinguishingSystemResolvers<ContextType = any, ParentType extends TResolversParentTypes['InspectionOnExtinguishingSystem'] = TResolversParentTypes['InspectionOnExtinguishingSystem']> = ResolversObject<{
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  completeValve?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  cylindricalValve?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  diffuserReplacement?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  drillUsed?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  fireUsed?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  hose?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  hydrostaticTest?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  monometer?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  observation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  painting?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  plannedDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  realDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  realoaded?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  reloadDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  responsible?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  safetyValve?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  situation?: Resolver<TResolversTypes['InspectionSituation'], ParentType, ContextType>;
  sundry?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  triggerReplacement?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TInspectionOnHidraulicSystemResolvers<ContextType = any, ParentType extends TResolversParentTypes['InspectionOnHidraulicSystem'] = TResolversParentTypes['InspectionOnHidraulicSystem']> = ResolversObject<{
  drillUsed?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  fireUsed?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  hoses?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  observation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  plannedDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  realDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  record?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  responsible?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  shelter?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  signaling?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  situation?: Resolver<TResolversTypes['InspectionSituation'], ParentType, ContextType>;
  squirts?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  storzkey?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  sundry?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TInspectionReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['InspectionReport'] = TResolversParentTypes['InspectionReport']> = ResolversObject<{
  address?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  cnpj?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  companyName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  completeValve?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  cylindricalValve?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  diffuserReplacement?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  drillUsed?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  fields?: Resolver<TResolversTypes['InspectionReportFields'], ParentType, ContextType>;
  fireUsed?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  footer?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  hidraulicSystem?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  hose?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  hydrostaticTest?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  local?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  monometer?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  painting?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  plannedDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  realDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  realoaded?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  responsible?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  safetyValve?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  situation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  sundry?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  telephone?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  triggerReplacement?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TInspectionReportFieldsResolvers<ContextType = any, ParentType extends TResolversParentTypes['InspectionReportFields'] = TResolversParentTypes['InspectionReportFields']> = ResolversObject<{
  activities?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  completeValve?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  cylindricalValve?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  diffuserReplacement?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  drillUsed?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  fireUsed?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  hidraulicSystem?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  hose?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  hydrostaticTest?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  local?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  monometer?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  no?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  painting?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  plannedDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  realDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  reloaded?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  responsible?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  safetyValve?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  situation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  sundry?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  triggerReplacement?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  yes?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TIntegrationConfigurationResolvers<ContextType = any, ParentType extends TResolversParentTypes['IntegrationConfiguration'] = TResolversParentTypes['IntegrationConfiguration']> = ResolversObject<{
  branchId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  options?: Resolver<Array<TResolversTypes['IntegrationConfigurationOption']>, ParentType, ContextType>;
}>;

export type TIntegrationConfigurationOptionResolvers<ContextType = any, ParentType extends TResolversParentTypes['IntegrationConfigurationOption'] = TResolversParentTypes['IntegrationConfigurationOption']> = ResolversObject<{
  deactivatedAt?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  integration?: Resolver<Maybe<TResolversTypes['MetadataType']>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  origin?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TIntegrationErrorResolvers<ContextType = any, ParentType extends TResolversParentTypes['IntegrationError'] = TResolversParentTypes['IntegrationError']> = ResolversObject<{
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  data?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  erpId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  errorMessage?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  errorType?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  integrationType?: Resolver<TResolversTypes['IntegrationType'], ParentType, ContextType>;
  updatedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type TIntegrationErrorAllResolvers<ContextType = any, ParentType extends TResolversParentTypes['IntegrationErrorAll'] = TResolversParentTypes['IntegrationErrorAll']> = ResolversObject<{
  count?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  data?: Resolver<TResolversTypes['PaginatedIntegrationError'], ParentType, ContextType>;
}>;

export type TIntegrationErrorSummaryResolvers<ContextType = any, ParentType extends TResolversParentTypes['IntegrationErrorSummary'] = TResolversParentTypes['IntegrationErrorSummary']> = ResolversObject<{
  byType?: Resolver<Array<TResolversTypes['IntegrationErrorTypeCount']>, ParentType, ContextType>;
  hasErrors?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  lastSyncAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  running?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  totalErrors?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  totalProcessed?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  totalSuccess?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TIntegrationErrorTypeCountResolvers<ContextType = any, ParentType extends TResolversParentTypes['IntegrationErrorTypeCount'] = TResolversParentTypes['IntegrationErrorTypeCount']> = ResolversObject<{
  count?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TIntegrationFlagsResolvers<ContextType = any, ParentType extends TResolversParentTypes['IntegrationFlags'] = TResolversParentTypes['IntegrationFlags']> = ResolversObject<{
  inboundResilient?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  integrationSendAsync?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TInternalFieldsResolvers<ContextType = any, ParentType extends TResolversParentTypes['InternalFields'] = TResolversParentTypes['InternalFields']> = ResolversObject<{
  externalFields?: Resolver<TResolversTypes['ExternalFields'], ParentType, ContextType>;
  genericMetadataId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  limit?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  required?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<TResolversTypes['FieldType'], ParentType, ContextType>;
}>;

export type TInventoryQueueResolvers<ContextType = any, ParentType extends TResolversParentTypes['InventoryQueue'] = TResolversParentTypes['InventoryQueue']> = ResolversObject<{
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  event?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  messageSend?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  movementId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  sendDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['StatusMessage'], ParentType, ContextType>;
  statusDescription?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  stockMovementRef?: Resolver<TResolversTypes['StockMovement'], ParentType, ContextType>;
  type?: Resolver<TResolversTypes['InventoryTypeMessage'], ParentType, ContextType>;
  updatedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  verb?: Resolver<TResolversTypes['VerbMessage'], ParentType, ContextType>;
}>;

export type TInvestigationResolvers<ContextType = any, ParentType extends TResolversParentTypes['Investigation'] = TResolversParentTypes['Investigation']> = ResolversObject<{
  accident?: Resolver<TResolversTypes['Accident'], ParentType, ContextType>;
  accidentId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  date?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  defectiveEquipment?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  improvisation?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  investigationCause?: Resolver<Maybe<Array<TResolversTypes['InvestigationCause']>>, ParentType, ContextType>;
  knewNorms?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  mandateId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  personId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  report?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  trained?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  wasUsedEpi?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type TInvestigationAmountChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['InvestigationAmountChart'] = TResolversParentTypes['InvestigationAmountChart']> = ResolversObject<{
  completed?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  hasAccident?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  notStarted?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TInvestigationCauseResolvers<ContextType = any, ParentType extends TResolversParentTypes['InvestigationCause'] = TResolversParentTypes['InvestigationCause']> = ResolversObject<{
  accidentCause?: Resolver<TResolversTypes['AccidentCause'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  investigation?: Resolver<TResolversTypes['Investigation'], ParentType, ContextType>;
}>;

export type TInvestigationCauseOnAccidentResolvers<ContextType = any, ParentType extends TResolversParentTypes['InvestigationCauseOnAccident'] = TResolversParentTypes['InvestigationCauseOnAccident']> = ResolversObject<{
  accidentCause?: Resolver<TResolversTypes['AccidentCause'], ParentType, ContextType>;
}>;

export type TInvestigationIndicatorsChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['InvestigationIndicatorsChart'] = TResolversParentTypes['InvestigationIndicatorsChart']> = ResolversObject<{
  defectiveEquipment?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  hasAccident?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  improvisation?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  notKnewNorms?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  notTrained?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  wasNotUsedEpi?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TInvestigationSuggestionResolvers<ContextType = any, ParentType extends TResolversParentTypes['InvestigationSuggestion'] = TResolversParentTypes['InvestigationSuggestion']> = ResolversObject<{
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TInviteResolvers<ContextType = any, ParentType extends TResolversParentTypes['Invite'] = TResolversParentTypes['Invite']> = ResolversObject<{
  accessByAd?: Resolver<Maybe<TResolversTypes['AccessBy']>, ParentType, ContextType>;
  birthday?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  branch?: Resolver<TResolversTypes['Branch'], ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  email?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  gender?: Resolver<TResolversTypes['Gender'], ParentType, ContextType>;
  individualRegistration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  linkUserPerson?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  roleId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  token?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TInviteParametersMailResolvers<ContextType = any, ParentType extends TResolversParentTypes['InviteParametersMail'] = TResolversParentTypes['InviteParametersMail']> = ResolversObject<{
  currentUserName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isPartner?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  organizationName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  roleId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<TResolversTypes['User'], ParentType, ContextType>;
}>;

export type TInvoiceResolvers<ContextType = any, ParentType extends TResolversParentTypes['Invoice'] = TResolversParentTypes['Invoice']> = ResolversObject<{
  bankSlipUrl?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  invoiceUrl?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  ourUrl?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TIpeResolvers<ContextType = any, ParentType extends TResolversParentTypes['Ipe'] = TResolversParentTypes['Ipe']> = ResolversObject<{
  caCode?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  caExpiration?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  daysForReplacement?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  manufacturerName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  protection?: Resolver<TResolversTypes['IpeProtection'], ParentType, ContextType>;
}>;

export type TIpeBiometryResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeBiometry'] = TResolversParentTypes['IpeBiometry']> = ResolversObject<{
  biometry?: Resolver<TResolversTypes['Biometry'], ParentType, ContextType>;
  biometryId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TIpeByRequirementChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeByRequirementChart'] = TResolversParentTypes['IpeByRequirementChart']> = ResolversObject<{
  byCostCenter?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  byOccupation?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  byRisk?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  hasIpeDeliveries?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TIpeByRiskResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeByRisk'] = TResolversParentTypes['IpeByRisk']> = ResolversObject<{
  caCode?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  caList?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  daysForReplacement?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipe?: Resolver<TResolversTypes['Ipe'], ParentType, ContextType>;
}>;

export type TIpeDeliveryResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeDelivery'] = TResolversParentTypes['IpeDelivery']> = ResolversObject<{
  amountReturned?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  ca?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  caExpirationDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  cost?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  crm?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  crmState?: Resolver<Maybe<TResolversTypes['State']>, ParentType, ContextType>;
  deliveryAmount?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  deliveryDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  doctorName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctorRqeEntries?: Resolver<Maybe<Array<TResolversTypes['DoctorRqeEntry']>>, ParentType, ContextType>;
  effective?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  employee?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipeManufacturer?: Resolver<TResolversTypes['IpeManufacturer'], ParentType, ContextType>;
  issueDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  lastMaintenanceDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  lotNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  nextMaintenance?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  observation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  product?: Resolver<Maybe<TResolversTypes['Product']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<TResolversTypes['DeliveryReason'], ParentType, ContextType>;
  replacementDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  replacementSituation?: Resolver<Maybe<TResolversTypes['ReplacementSituation']>, ParentType, ContextType>;
  returnDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  returnReason?: Resolver<Maybe<TResolversTypes['ReturnReason']>, ParentType, ContextType>;
  stockMovement?: Resolver<Maybe<Array<TResolversTypes['StockMovement']>>, ParentType, ContextType>;
  totalExtensionDays?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  warehouse?: Resolver<Maybe<TResolversTypes['Warehouse']>, ParentType, ContextType>;
  warehouseId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TIpeDeliveryDashboardResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeDeliveryDashboard'] = TResolversParentTypes['IpeDeliveryDashboard']> = ResolversObject<{
  annualDeliveryVariationChart?: Resolver<TResolversTypes['AnnualDeliveryVariationChart'], ParentType, ContextType>;
  caInUseChart?: Resolver<TResolversTypes['CaInUseChart'], ParentType, ContextType>;
  categoriesChart?: Resolver<TResolversTypes['CategoriesChart'], ParentType, ContextType>;
  costCenterChart?: Resolver<TResolversTypes['IpeDeliveryPerTotalChart'], ParentType, ContextType>;
  costPerManufacturerChart?: Resolver<TResolversTypes['IpeDeliveryPieCharts'], ParentType, ContextType>;
  deliveredPerMonthChart?: Resolver<TResolversTypes['IpeDeliveryLineCharts'], ParentType, ContextType>;
  efficiencyChart?: Resolver<TResolversTypes['EfficiencyChart'], ParentType, ContextType>;
  epiLifespanChart?: Resolver<TResolversTypes['EpiLifespanChart'], ParentType, ContextType>;
  equipmentDeliveredChart?: Resolver<TResolversTypes['IpeDeliveryPerTotalChart'], ParentType, ContextType>;
  externalDeliveryChart?: Resolver<TResolversTypes['ExternalDeliveryChart'], ParentType, ContextType>;
  ipeByRequirementChart?: Resolver<TResolversTypes['IpeByRequirementChart'], ParentType, ContextType>;
  ipeCostsChart?: Resolver<TResolversTypes['IpeDeliveryPerTotalChart'], ParentType, ContextType>;
  occupationChart?: Resolver<TResolversTypes['IpeDeliveryPerTotalChart'], ParentType, ContextType>;
  perDayChart?: Resolver<TResolversTypes['PerDayChart'], ParentType, ContextType>;
  reasonsChart?: Resolver<TResolversTypes['ReasonsChart'], ParentType, ContextType>;
  returnReasonsChart?: Resolver<TResolversTypes['ReturnReasonsChart'], ParentType, ContextType>;
  returnsPerMonthChart?: Resolver<TResolversTypes['IpeDeliveryLineCharts'], ParentType, ContextType>;
  signatureChart?: Resolver<TResolversTypes['SignatureChart'], ParentType, ContextType>;
}>;

export type TIpeDeliveryExtensionAuditReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeDeliveryExtensionAuditReport'] = TResolversParentTypes['IpeDeliveryExtensionAuditReport']> = ResolversObject<{
  extensions?: Resolver<Array<TResolversTypes['IpeDeliveryExtensionEntry']>, ParentType, ContextType>;
  stats?: Resolver<TResolversTypes['IpeDeliveryExtensionAuditStats'], ParentType, ContextType>;
}>;

export type TIpeDeliveryExtensionAuditStatsResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeDeliveryExtensionAuditStats'] = TResolversParentTypes['IpeDeliveryExtensionAuditStats']> = ResolversObject<{
  countThisMonth?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  countWithMultipleExtensions?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  estimatedSavings?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TIpeDeliveryExtensionEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeDeliveryExtensionEntry'] = TResolversParentTypes['IpeDeliveryExtensionEntry']> = ResolversObject<{
  ca?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  createdByName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  extendedDays?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipeDeliveryId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipeName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  newDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  observation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  oldDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  reason?: Resolver<TResolversTypes['ExtensionReason'], ParentType, ContextType>;
}>;

export type TIpeDeliveryExtensionResultResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeDeliveryExtensionResult'] = TResolversParentTypes['IpeDeliveryExtensionResult']> = ResolversObject<{
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  extendedDays?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipeDeliveryId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  newDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  observation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  oldDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  reason?: Resolver<TResolversTypes['ExtensionReason'], ParentType, ContextType>;
}>;

export type TIpeDeliveryExtensionTimelineResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeDeliveryExtensionTimeline'] = TResolversParentTypes['IpeDeliveryExtensionTimeline']> = ResolversObject<{
  ca?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  currentReplacementDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  deliveryDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  extensions?: Resolver<Array<TResolversTypes['IpeDeliveryExtensionEntry']>, ParentType, ContextType>;
  ipeDeliveryId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipeName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  originalReplacementDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  totalExtensionDays?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TIpeDeliveryFaceResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeDeliveryFace'] = TResolversParentTypes['IpeDeliveryFace']> = ResolversObject<{
  amountReturned?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  ca?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  caExpirationDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  cost?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  crm?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  crmState?: Resolver<Maybe<TResolversTypes['State']>, ParentType, ContextType>;
  deliveryAmount?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  deliveryDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  doctorName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctorRqeEntries?: Resolver<Maybe<Array<TResolversTypes['DoctorRqeEntry']>>, ParentType, ContextType>;
  effective?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  employee?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipeManufacturer?: Resolver<TResolversTypes['IpeManufacturer'], ParentType, ContextType>;
  issueDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  lastMaintenanceDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  lotNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  nextMaintenance?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  observation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  product?: Resolver<Maybe<TResolversTypes['Product']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<TResolversTypes['DeliveryReason'], ParentType, ContextType>;
  replacementDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  replacementSituation?: Resolver<Maybe<TResolversTypes['ReplacementSituation']>, ParentType, ContextType>;
  returnDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  returnReason?: Resolver<Maybe<TResolversTypes['ReturnReason']>, ParentType, ContextType>;
  stockMovement?: Resolver<Maybe<Array<TResolversTypes['StockMovement']>>, ParentType, ContextType>;
  totalExtensionDays?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  uploadThumbnailUrl?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  uploadUrl?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  warehouse?: Resolver<Maybe<TResolversTypes['Warehouse']>, ParentType, ContextType>;
  warehouseId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TIpeDeliveryLineChartsResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeDeliveryLineCharts'] = TResolversParentTypes['IpeDeliveryLineCharts']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['LineChart']>, ParentType, ContextType>;
  hasIpeDeliveries?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TIpeDeliveryMedicalReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeDeliveryMedicalReport'] = TResolversParentTypes['IpeDeliveryMedicalReport']> = ResolversObject<{
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  costCenter?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  crmState?: Resolver<Maybe<TResolversTypes['State']>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  doctorCRM?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  doctorName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  doctorRqeDisplay?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  footer?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  individualRegistration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipe?: Resolver<Array<TResolversTypes['IpeInfo']>, ParentType, ContextType>;
  occupation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  person?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TIpeDeliveryParamsResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeDeliveryParams'] = TResolversParentTypes['IpeDeliveryParams']> = ResolversObject<{
  costCenters?: Resolver<Maybe<Array<TResolversTypes['String']>>, ParentType, ContextType>;
  filter?: Resolver<Maybe<TResolversTypes['DeliveryFilter']>, ParentType, ContextType>;
  footer?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  isCheck?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  isSignDocument?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  isSigningResponsibility?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  occupations?: Resolver<Maybe<Array<TResolversTypes['String']>>, ParentType, ContextType>;
  statementsResponsibility?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TIpeDeliveryPerTotalChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeDeliveryPerTotalChart'] = TResolversParentTypes['IpeDeliveryPerTotalChart']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  hasIpeDeliveries?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  perTotal?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
}>;

export type TIpeDeliveryPieChartsResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeDeliveryPieCharts'] = TResolversParentTypes['IpeDeliveryPieCharts']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['PieChart']>, ParentType, ContextType>;
  hasIpeDeliveries?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TIpeDeliveryReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeDeliveryReport'] = TResolversParentTypes['IpeDeliveryReport']> = ResolversObject<{
  address?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  admission?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  cnpj?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  companyName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  costCenter?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  generalRegistration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  individualRegistration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipeBiometry?: Resolver<Maybe<TResolversTypes['IpeBiometry']>, ParentType, ContextType>;
  ipeFace?: Resolver<Maybe<TResolversTypes['IpeFace']>, ParentType, ContextType>;
  ipes?: Resolver<Maybe<Array<TResolversTypes['IpeReport']>>, ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  registration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  telephone?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TIpeDeliveryReportParamsResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeDeliveryReportParams'] = TResolversParentTypes['IpeDeliveryReportParams']> = ResolversObject<{
  emptyRows?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  footer?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  ipeDelivery?: Resolver<TResolversTypes['IpeDeliveryReport'], ParentType, ContextType>;
  productDeliveries?: Resolver<Maybe<TResolversTypes['ProductDeliveryReport']>, ParentType, ContextType>;
  responsibilityStatement?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  sparePartsDelivery?: Resolver<Maybe<TResolversTypes['DeliverySparePartsReport']>, ParentType, ContextType>;
}>;

export type TIpeFaceResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeFace'] = TResolversParentTypes['IpeFace']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  picture?: Resolver<TResolversTypes['S3UrlCloudFront'], ParentType, ContextType>;
  pictureKey?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TIpeInfoResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeInfo'] = TResolversParentTypes['IpeInfo']> = ResolversObject<{
  ca?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TIpeManufacturerResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeManufacturer'] = TResolversParentTypes['IpeManufacturer']> = ResolversObject<{
  approvedForReport?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  caCode?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  cnpj?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  color?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  corporateNameLaboratory?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  equipmentDescription?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  equipmentName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  expiration?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  ipe?: Resolver<TResolversTypes['Ipe'], ParentType, ContextType>;
  laboratoryCNPJ?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  manufacturer?: Resolver<TResolversTypes['Manufacturer'], ParentType, ContextType>;
  mark?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  norm?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  observation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  processNumber?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  reportNumber?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  restrictedForReport?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  situation?: Resolver<TResolversTypes['CaSituation'], ParentType, ContextType>;
}>;

export type TIpeManufacturerSuggestionResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeManufacturerSuggestion'] = TResolversParentTypes['IpeManufacturerSuggestion']> = ResolversObject<{
  caCode?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  expiration?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  ipe?: Resolver<TResolversTypes['Ipe'], ParentType, ContextType>;
  manufacturer?: Resolver<TResolversTypes['Manufacturer'], ParentType, ContextType>;
  situation?: Resolver<TResolversTypes['CaSituation'], ParentType, ContextType>;
  suggestion?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TIpeOccupationResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeOccupation'] = TResolversParentTypes['IpeOccupation']> = ResolversObject<{
  ipe?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TIpeReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeReport'] = TResolversParentTypes['IpeReport']> = ResolversObject<{
  amount?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  certificate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  latitude?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  precision?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  prevDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  returnDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  signDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TIpeTaskResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpeTask'] = TResolversParentTypes['IpeTask']> = ResolversObject<{
  descriptionIpe?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  descriptionTask?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nameTask?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TIpesInfoResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpesInfo'] = TResolversParentTypes['IpesInfo']> = ResolversObject<{
  amount?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  certificate?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  costCenter?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  costCenterId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  employee?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  individualRegistration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupationId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  registration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TIpesInfoSortedResolvers<ContextType = any, ParentType extends TResolversParentTypes['IpesInfoSorted'] = TResolversParentTypes['IpesInfoSorted']> = ResolversObject<{
  amount?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  certificate?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  employee?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  individualRegistration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  registration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TItemResolvers<ContextType = any, ParentType extends TResolversParentTypes['Item'] = TResolversParentTypes['Item']> = ResolversObject<{
  items?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TItemsStepsResolvers<ContextType = any, ParentType extends TResolversParentTypes['ItemsSteps'] = TResolversParentTypes['ItemsSteps']> = ResolversObject<{
  image?: Resolver<TResolversTypes['FirstStepsImage'], ParentType, ContextType>;
  percentage?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  remainingSteps?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  steps?: Resolver<Array<TResolversTypes['Steps']>, ParentType, ContextType>;
  summary?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  time?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  title?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export interface TJsonScalarConfig extends GraphQLScalarTypeConfig<TResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type TLevelResolvers<ContextType = any, ParentType extends TResolversParentTypes['Level'] = TResolversParentTypes['Level']> = ResolversObject<{
  level?: Resolver<TResolversTypes['PlanLevelType'], ParentType, ContextType>;
  quantity?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  total?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  value?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TLevelsForecastResolvers<ContextType = any, ParentType extends TResolversParentTypes['LevelsForecast'] = TResolversParentTypes['LevelsForecast']> = ResolversObject<{
  levels?: Resolver<Array<TResolversTypes['Level']>, ParentType, ContextType>;
  nextPayment?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  total?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TLineChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['LineChart'] = TResolversParentTypes['LineChart']> = ResolversObject<{
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
}>;

export type TLineChartsResolvers<ContextType = any, ParentType extends TResolversParentTypes['LineCharts'] = TResolversParentTypes['LineCharts']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['LineChart']>, ParentType, ContextType>;
}>;

export type TLocationStructureResolvers<ContextType = any, ParentType extends TResolversParentTypes['LocationStructure'] = TResolversParentTypes['LocationStructure']> = ResolversObject<{
  ceilingDetailing?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  ceilingNature?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  displayDetailing?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  displayNature?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doorDetailing?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doorNature?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  firstCoatDetailing?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  firstCoatNature?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  floorDetailing?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  floorNature?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  lightDetailing?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  lightNature?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  secCoatDetailing?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  secCoatNature?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  wallDetailing?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  wallNature?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  windowDetailing?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  windowNature?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TLoginResolvers<ContextType = any, ParentType extends TResolversParentTypes['Login'] = TResolversParentTypes['Login']> = ResolversObject<{
  data?: Resolver<TResolversTypes['DataLogin'], ParentType, ContextType>;
  token?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TMandateResolvers<ContextType = any, ParentType extends TResolversParentTypes['Mandate'] = TResolversParentTypes['Mandate']> = ResolversObject<{
  candidates?: Resolver<Maybe<Array<TResolversTypes['Candidate']>>, ParentType, ContextType>;
  comissionLocal?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  costCenters?: Resolver<Maybe<Array<TResolversTypes['CostCenterOnMandate']>>, ParentType, ContextType>;
  dateEnd?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  dateStart?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  disableDates?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  economicActivity?: Resolver<Maybe<TResolversTypes['EconomicActivity']>, ParentType, ContextType>;
  economicActivityId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  electionComissions?: Resolver<Maybe<Array<TResolversTypes['ElectionComission']>>, ParentType, ContextType>;
  electionLocal?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  electionOccurences?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  electionPresident?: Resolver<Maybe<TResolversTypes['Person']>, ParentType, ContextType>;
  electionSecretary?: Resolver<Maybe<TResolversTypes['Person']>, ParentType, ContextType>;
  endElectionHour?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  investigations?: Resolver<Maybe<Array<TResolversTypes['Investigation']>>, ParentType, ContextType>;
  mandateEvents?: Resolver<Maybe<Array<TResolversTypes['MandateEvent']>>, ParentType, ContextType>;
  maxDays?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  meetings?: Resolver<Maybe<Array<TResolversTypes['Meeting']>>, ParentType, ContextType>;
  observations?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  sessionPresident?: Resolver<Maybe<TResolversTypes['Person']>, ParentType, ContextType>;
  sessionSecretary?: Resolver<Maybe<TResolversTypes['Person']>, ParentType, ContextType>;
  sipats?: Resolver<Maybe<Array<TResolversTypes['Sipat']>>, ParentType, ContextType>;
  startElectionHour?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  votes?: Resolver<Maybe<Array<TResolversTypes['Vote']>>, ParentType, ContextType>;
}>;

export type TMandateActionResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateAction'] = TResolversParentTypes['MandateAction']> = ResolversObject<{
  actionPlan?: Resolver<TResolversTypes['ActionPlan'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  mandate?: Resolver<TResolversTypes['Mandate'], ParentType, ContextType>;
}>;

export type TMandateActionStatusChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateActionStatusChart'] = TResolversParentTypes['MandateActionStatusChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['MandateActionStatusEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TMandateActionStatusEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateActionStatusEntry'] = TResolversParentTypes['MandateActionStatusEntry']> = ResolversObject<{
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  notRealized?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  realized?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TMandateCostCenterResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateCostCenter'] = TResolversParentTypes['MandateCostCenter']> = ResolversObject<{
  costCenter?: Resolver<TResolversTypes['CostCenter'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  mandate?: Resolver<TResolversTypes['Mandate'], ParentType, ContextType>;
}>;

export type TMandateDashboardResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateDashboard'] = TResolversParentTypes['MandateDashboard']> = ResolversObject<{
  meetingActionsPerMonth?: Resolver<TResolversTypes['MandateActionStatusChart'], ParentType, ContextType>;
  meetingActionsTotal?: Resolver<TResolversTypes['MandateMeetingActionsTotalChart'], ParentType, ContextType>;
  meetingParticipantsTotal?: Resolver<TResolversTypes['MandateMeetingParticipantsChart'], ParentType, ContextType>;
  meetingsPerMonth?: Resolver<TResolversTypes['MandateMeetingsChart'], ParentType, ContextType>;
  sipatCostPerMonth?: Resolver<TResolversTypes['MandateMonetaryChart'], ParentType, ContextType>;
  suggestionPerMonth?: Resolver<TResolversTypes['MandateMonthlyCountChart'], ParentType, ContextType>;
  suggestionStatusPerMonth?: Resolver<TResolversTypes['MandateSuggestionStatusChart'], ParentType, ContextType>;
}>;

export type TMandateDepartmentResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateDepartment'] = TResolversParentTypes['MandateDepartment']> = ResolversObject<{
  department?: Resolver<TResolversTypes['Department'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  mandate?: Resolver<TResolversTypes['Mandate'], ParentType, ContextType>;
}>;

export type TMandateDimensionResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateDimension'] = TResolversParentTypes['MandateDimension']> = ResolversObject<{
  cnae?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  main?: Resolver<TResolversTypes['Dimension'], ParentType, ContextType>;
  substitute?: Resolver<TResolversTypes['Dimension'], ParentType, ContextType>;
  total?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TMandateEventResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateEvent'] = TResolversParentTypes['MandateEvent']> = ResolversObject<{
  dateEnd?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  dateStart?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  done?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  event?: Resolver<Maybe<TResolversTypes['Event']>, ParentType, ContextType>;
  extension?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  mandate?: Resolver<TResolversTypes['Mandate'], ParentType, ContextType>;
  referenceId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TMandateEventInfoResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateEventInfo'] = TResolversParentTypes['MandateEventInfo']> = ResolversObject<{
  dateEnd?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  dateStart?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
}>;

export type TMandateLossResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateLoss'] = TResolversParentTypes['MandateLoss']> = ResolversObject<{
  component?: Resolver<TResolversTypes['Component'], ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  fifthAbsenceMeeting?: Resolver<Maybe<TResolversTypes['Meeting']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  mandateId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  reasonCode?: Resolver<TResolversTypes['MandateLossReason'], ParentType, ContextType>;
  substituteComponent?: Resolver<Maybe<TResolversTypes['Component']>, ParentType, ContextType>;
  substituteComponentId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TMandateMeetingActionsTotalChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateMeetingActionsTotalChart'] = TResolversParentTypes['MandateMeetingActionsTotalChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['MandateMeetingActionsTotalEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TMandateMeetingActionsTotalEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateMeetingActionsTotalEntry'] = TResolversParentTypes['MandateMeetingActionsTotalEntry']> = ResolversObject<{
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TMandateMeetingParticipantsChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateMeetingParticipantsChart'] = TResolversParentTypes['MandateMeetingParticipantsChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['MandateMeetingParticipantsEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TMandateMeetingParticipantsEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateMeetingParticipantsEntry'] = TResolversParentTypes['MandateMeetingParticipantsEntry']> = ResolversObject<{
  extraordinaryTotal?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ordinaryTotal?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TMandateMeetingsChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateMeetingsChart'] = TResolversParentTypes['MandateMeetingsChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['MandateMeetingsEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TMandateMeetingsEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateMeetingsEntry'] = TResolversParentTypes['MandateMeetingsEntry']> = ResolversObject<{
  extraordinary?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ordinary?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TMandateMonetaryChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateMonetaryChart'] = TResolversParentTypes['MandateMonetaryChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['MandateMonetaryEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TMandateMonetaryEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateMonetaryEntry'] = TResolversParentTypes['MandateMonetaryEntry']> = ResolversObject<{
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TMandateMonthlyCountChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateMonthlyCountChart'] = TResolversParentTypes['MandateMonthlyCountChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['MandateMonthlyCountEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TMandateMonthlyCountEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateMonthlyCountEntry'] = TResolversParentTypes['MandateMonthlyCountEntry']> = ResolversObject<{
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TMandateSuggestionStatusChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateSuggestionStatusChart'] = TResolversParentTypes['MandateSuggestionStatusChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['MandateSuggestionStatusEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TMandateSuggestionStatusEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateSuggestionStatusEntry'] = TResolversParentTypes['MandateSuggestionStatusEntry']> = ResolversObject<{
  canceledCount?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  finishedCount?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  inProcessCount?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  newCount?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TMandateTrainingResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateTraining'] = TResolversParentTypes['MandateTraining']> = ResolversObject<{
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  errorIntegration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  mandate?: Resolver<TResolversTypes['Mandate'], ParentType, ContextType>;
  training?: Resolver<TResolversTypes['Training'], ParentType, ContextType>;
  urgency?: Resolver<TResolversTypes['TrainingUrgency'], ParentType, ContextType>;
}>;

export type TMandateValidityResolvers<ContextType = any, ParentType extends TResolversParentTypes['MandateValidity'] = TResolversParentTypes['MandateValidity']> = ResolversObject<{
  dateEnd?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  dateStart?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
}>;

export type TManufacturerResolvers<ContextType = any, ParentType extends TResolversParentTypes['Manufacturer'] = TResolversParentTypes['Manufacturer']> = ResolversObject<{
  cnpj?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  corporateName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nature?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TMapUploadResolvers<ContextType = any, ParentType extends TResolversParentTypes['MapUpload'] = TResolversParentTypes['MapUpload']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  uploadUrl?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<TResolversTypes['S3UrlCloudFront'], ParentType, ContextType>;
}>;

export type TMeasurementByAgentGroupItemResolvers<ContextType = any, ParentType extends TResolversParentTypes['MeasurementByAgentGroupItem'] = TResolversParentTypes['MeasurementByAgentGroupItem']> = ResolversObject<{
  count?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  group?: Resolver<TResolversTypes['AgentGroup'], ParentType, ContextType>;
}>;

export type TMeasurementByRiskResolvers<ContextType = any, ParentType extends TResolversParentTypes['MeasurementByRisk'] = TResolversParentTypes['MeasurementByRisk']> = ResolversObject<{
  accuracyType?: Resolver<Maybe<TResolversTypes['MeasurementAccuracyType']>, ParentType, ContextType>;
  amount?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  calibrationCompany?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  calibrationDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  certificationNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  hasRbc?: Resolver<Maybe<TResolversTypes['HasRbc']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  measuringInstrument?: Resolver<TResolversTypes['MeasuringInstrument'], ParentType, ContextType>;
}>;

export type TMeasurementDeviceItemResolvers<ContextType = any, ParentType extends TResolversParentTypes['MeasurementDeviceItem'] = TResolversParentTypes['MeasurementDeviceItem']> = ResolversObject<{
  above?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  primaryGroup?: Resolver<Maybe<TResolversTypes['AgentGroup']>, ParentType, ContextType>;
  total?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TMeasurementDevicesChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['MeasurementDevicesChart'] = TResolversParentTypes['MeasurementDevicesChart']> = ResolversObject<{
  byAgentGroup?: Resolver<Array<TResolversTypes['MeasurementByAgentGroupItem']>, ParentType, ContextType>;
  hasMeasurement?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  topDevices?: Resolver<Array<TResolversTypes['MeasurementDeviceItem']>, ParentType, ContextType>;
  totalAbove?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  totalDevices?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  totalMeasurements?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TMeasurementsResolvers<ContextType = any, ParentType extends TResolversParentTypes['Measurements'] = TResolversParentTypes['Measurements']> = ResolversObject<{
  actionLevel?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  agent?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  measurementUnit?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TMeasuringInstrumentResolvers<ContextType = any, ParentType extends TResolversParentTypes['MeasuringInstrument'] = TResolversParentTypes['MeasuringInstrument']> = ResolversObject<{
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  calibrationDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  referenceId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  responsible?: Resolver<Maybe<TResolversTypes['Person']>, ParentType, ContextType>;
  responsibleId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  valuationDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
}>;

export type TMedConsultReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedConsultReport'] = TResolversParentTypes['MedConsultReport']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  presentation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TMedRecordHealthProgramsResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedRecordHealthPrograms'] = TResolversParentTypes['MedRecordHealthPrograms']> = ResolversObject<{
  endDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  healthProgram?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  startDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TMedicalCertificateResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicalCertificate'] = TResolversParentTypes['MedicalCertificate']> = ResolversObject<{
  absenceDateEnd?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  absenceDateStart?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  absenceType?: Resolver<Maybe<TResolversTypes['AbsenceType']>, ParentType, ContextType>;
  accident?: Resolver<Maybe<TResolversTypes['Accident']>, ParentType, ContextType>;
  allowanceType?: Resolver<Maybe<TResolversTypes['AllowanceType']>, ParentType, ContextType>;
  amountOfTreatmentDays?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  benefitEndDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  benefitNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  certificateType?: Resolver<TResolversTypes['CertificateType'], ParentType, ContextType>;
  crmState?: Resolver<Maybe<TResolversTypes['State']>, ParentType, ContextType>;
  dateEnd?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  dateStart?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  doctorCrm?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctorName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctorRqeEntries?: Resolver<Maybe<Array<TResolversTypes['DoctorRqeEntry']>>, ParentType, ContextType>;
  doctorType?: Resolver<TResolversTypes['DoctorType'], ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  errorIntegration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  hospitalization?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  icd?: Resolver<Maybe<TResolversTypes['Icd']>, ParentType, ContextType>;
  icdGroup?: Resolver<Maybe<TResolversTypes['IcdGroup']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  localMedical?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  medicalEvaluationDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  medicalRecordId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  observation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  origin?: Resolver<TResolversTypes['CertificateOrigin'], ParentType, ContextType>;
  originRectification?: Resolver<Maybe<TResolversTypes['OriginRectification']>, ParentType, ContextType>;
  processNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  revaluation?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  sequence?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  telemedicine?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  typeProcess?: Resolver<Maybe<TResolversTypes['TypeProcess']>, ParentType, ContextType>;
  user?: Resolver<Maybe<TResolversTypes['User']>, ParentType, ContextType>;
}>;

export type TMedicalCertificateByIcdResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicalCertificateByIcd'] = TResolversParentTypes['MedicalCertificateByIcd']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  total?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TMedicalCertificateReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicalCertificateReport'] = TResolversParentTypes['MedicalCertificateReport']> = ResolversObject<{
  address?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  amountOfTreatmentDays?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  cnpj?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  companyName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  crmState?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  doctorCrm?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  doctorDocumentLabel?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  doctorName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  doctorRqeDisplay?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctorTypeLabel?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  endDate?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  endTime?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  footer?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  hour?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  icd?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  individualRegistration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isDeclaration?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  isRetirement?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  patientName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  showIcd?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  startDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  telephone?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TMedicalConsultationResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicalConsultation'] = TResolversParentTypes['MedicalConsultation']> = ResolversObject<{
  cancelDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  exams?: Resolver<Maybe<Array<TResolversTypes['Exams']>>, ParentType, ContextType>;
  expectedDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  issueDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  observation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  situation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TMedicalRecordResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicalRecord'] = TResolversParentTypes['MedicalRecord']> = ResolversObject<{
  age?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  alcoholism?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  alcoholismFrequency?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  alcoholismPeriod?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  alcoholismType?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  amountConsumed?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  armSize?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  birthday?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  bloodDonator?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  bloodType?: Resolver<TResolversTypes['BloodType'], ParentType, ContextType>;
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  candidate?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  cardiovascularRisk?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  chronicDiseaseOrTreatment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  chronicDiseaseOrTreatmentDetails?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  clinicalQuizzes?: Resolver<Array<TResolversTypes['ClinicalQuiz']>, ParentType, ContextType>;
  controlledMedication?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  controlledMedicationDetails?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  deficiencies?: Resolver<Array<TResolversTypes['Deficiency']>, ParentType, ContextType>;
  diabetes?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  diastolicPressure?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  elbowHeight?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  eyeColor?: Resolver<Maybe<TResolversTypes['EyeColor']>, ParentType, ContextType>;
  eyeHeight?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  forearmSize?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  gender?: Resolver<TResolversTypes['Gender'], ParentType, ContextType>;
  genderEnum?: Resolver<Maybe<TResolversTypes['GenderEnum']>, ParentType, ContextType>;
  hairColor?: Resolver<Maybe<TResolversTypes['HairColor']>, ParentType, ContextType>;
  handSize?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  heartAge?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  height?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  historic?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  hypertensionTreatment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  imcText?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  imcValue?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  individualRegistration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  kneeHeight?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  lastAsoDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  lastMedicalCertificate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  legLength?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  medicalCertificates?: Resolver<Array<TResolversTypes['MedicalCertificate']>, ParentType, ContextType>;
  medicalRecordConsultations?: Resolver<Array<TResolversTypes['Consultation']>, ParentType, ContextType>;
  medicalRecordHealthPrograms?: Resolver<Array<TResolversTypes['MedicalRecordHealthProgram']>, ParentType, ContextType>;
  medicalRecordVaccines?: Resolver<Array<TResolversTypes['MedicalRecordVaccine']>, ParentType, ContextType>;
  medicalReferrals?: Resolver<Array<TResolversTypes['MedicalReferral']>, ParentType, ContextType>;
  medicalRestrictions?: Resolver<Array<TResolversTypes['MedicalRestriction']>, ParentType, ContextType>;
  mentalHealthFollowUp?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  mentalHealthFollowUpFrequency?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  mentalHealthFollowUpPeriod?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nippleLine?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  occupationalCertificates?: Resolver<Array<TResolversTypes['OccupationalHealthCertificate']>, ParentType, ContextType>;
  person?: Resolver<Maybe<TResolversTypes['Person']>, ParentType, ContextType>;
  personId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  physicalActivity?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  physicalActivityFrequency?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  physicalActivityMain?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  pubicHeight?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  pulse?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  shoeSize?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  skinColor?: Resolver<Maybe<TResolversTypes['SkinColor']>, ParentType, ContextType>;
  smoker?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  socialName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  suggestion?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  systolicPressure?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  tamagistPeriod?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  temperature?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  weight?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TMedicalRecordCertificatesResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicalRecordCertificates'] = TResolversParentTypes['MedicalRecordCertificates']> = ResolversObject<{
  endDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  icd?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  startDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TMedicalRecordDashboardResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicalRecordDashboard'] = TResolversParentTypes['MedicalRecordDashboard']> = ResolversObject<{
  absenceChart?: Resolver<TResolversTypes['ChartData'], ParentType, ContextType>;
  ageChart?: Resolver<Array<TResolversTypes['AgeChart']>, ParentType, ContextType>;
  asoNatureChart?: Resolver<TResolversTypes['AsoNatureChart'], ParentType, ContextType>;
  asoQuantityChart?: Resolver<TResolversTypes['AsoQuantityChart'], ParentType, ContextType>;
  asoSituationChart?: Resolver<TResolversTypes['AsoSituationChart'], ParentType, ContextType>;
  bloodTypeChart?: Resolver<TResolversTypes['BloodTypeChart'], ParentType, ContextType>;
  certificatePerDayChart?: Resolver<TResolversTypes['CertificatePerDayChart'], ParentType, ContextType>;
  certificateReasonsChart?: Resolver<TResolversTypes['ChartData'], ParentType, ContextType>;
  costCenterChart?: Resolver<TResolversTypes['CostCenterOccupationChart'], ParentType, ContextType>;
  costCenterDeficienciesChart?: Resolver<TResolversTypes['CostCenterOccupationDeficienciesChart'], ParentType, ContextType>;
  costCenterVolumeChart?: Resolver<TResolversTypes['CostCenterVolumeChart'], ParentType, ContextType>;
  daysAbsentChart?: Resolver<TResolversTypes['DaysAbsentChart'], ParentType, ContextType>;
  daysLostWithIcdChart?: Resolver<TResolversTypes['DaysLostWithIcdChart'], ParentType, ContextType>;
  daysLostWithoutIcdChart?: Resolver<TResolversTypes['DaysLostWithoutIcdChart'], ParentType, ContextType>;
  deficienciesChart?: Resolver<TResolversTypes['DeficienciesChart'], ParentType, ContextType>;
  diabetesChart?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  employeeChart?: Resolver<TResolversTypes['VolumeChart'], ParentType, ContextType>;
  employeeVolumeChart?: Resolver<TResolversTypes['EmployeeVolumeChart'], ParentType, ContextType>;
  examsDoneChart?: Resolver<TResolversTypes['ExamsDoneChart'], ParentType, ContextType>;
  healthProgramChart?: Resolver<TResolversTypes['HealthProgramChart'], ParentType, ContextType>;
  imcChart?: Resolver<Array<TResolversTypes['ImcChart']>, ParentType, ContextType>;
  lostDaysChart?: Resolver<TResolversTypes['VolumeChart'], ParentType, ContextType>;
  medicalRestrictionsChart?: Resolver<TResolversTypes['MedicalRestrictionsChart'], ParentType, ContextType>;
  ntepDistributionChart?: Resolver<TResolversTypes['NtepDistributionChart'], ParentType, ContextType>;
  ntepEvolutionChart?: Resolver<TResolversTypes['NtepEvolutionChart'], ParentType, ContextType>;
  occupationChart?: Resolver<TResolversTypes['CostCenterOccupationChart'], ParentType, ContextType>;
  occupationDeficienciesChart?: Resolver<TResolversTypes['CostCenterOccupationDeficienciesChart'], ParentType, ContextType>;
  quizzesCharts?: Resolver<TResolversTypes['QuizzesCharts'], ParentType, ContextType>;
  referralsChart?: Resolver<TResolversTypes['ReferralsChart'], ParentType, ContextType>;
  referralsQuantityChart?: Resolver<TResolversTypes['ReferralsQuantityChart'], ParentType, ContextType>;
  riskChart?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  smokerChart?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  topIcdsChart?: Resolver<TResolversTypes['TopIcdsChart'], ParentType, ContextType>;
  vaccineChart?: Resolver<TResolversTypes['VaccineChart'], ParentType, ContextType>;
  vaccineQuantityChart?: Resolver<TResolversTypes['VaccineQuantityChart'], ParentType, ContextType>;
  yearlyVariationChart?: Resolver<TResolversTypes['YearlyVariationChart'], ParentType, ContextType>;
}>;

export type TMedicalRecordDeficienciesResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicalRecordDeficiencies'] = TResolversParentTypes['MedicalRecordDeficiencies']> = ResolversObject<{
  date?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  icd?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  recoveryDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TMedicalRecordDiagnosticsResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicalRecordDiagnostics'] = TResolversParentTypes['MedicalRecordDiagnostics']> = ResolversObject<{
  attendance?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  complaint?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  diagnostic?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  diagnosticDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  diastolicPressure?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  height?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  icd?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  indication?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  medicalDiagnostic?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  medicines?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  systolicPressure?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  weight?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TMedicalRecordExamsResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicalRecordExams'] = TResolversParentTypes['MedicalRecordExams']> = ResolversObject<{
  date?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  exam?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nature?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  observation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  resutIndication?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TMedicalRecordHealthProgramResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicalRecordHealthProgram'] = TResolversParentTypes['MedicalRecordHealthProgram']> = ResolversObject<{
  endDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  healthProgram?: Resolver<TResolversTypes['HealthProgram'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  observations?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  realizationDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  responsibleId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type TMedicalRecordNameResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicalRecordName'] = TResolversParentTypes['MedicalRecordName']> = ResolversObject<{
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TMedicalRecordReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicalRecordReport'] = TResolversParentTypes['MedicalRecordReport']> = ResolversObject<{
  address?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  amountConsumed?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  birthday?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  bloodDonator?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  bloodType?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  deficiencies?: Resolver<Maybe<TResolversTypes['MedicalRecordDeficiencies']>, ParentType, ContextType>;
  diagnostics?: Resolver<Maybe<TResolversTypes['MedicalRecordDiagnostics']>, ParentType, ContextType>;
  exams?: Resolver<Maybe<TResolversTypes['MedicalRecordExams']>, ParentType, ContextType>;
  footer?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  gender?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  healthPrograms?: Resolver<Maybe<TResolversTypes['MedRecordHealthPrograms']>, ParentType, ContextType>;
  height?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  implantation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  medicalCertificates?: Resolver<Maybe<TResolversTypes['MedicalRecordCertificates']>, ParentType, ContextType>;
  medicalRestrictions?: Resolver<Maybe<Array<TResolversTypes['MedicalRecordRestrictions']>>, ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  neighborhood?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  smoker?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  tamagistPeriod?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  weight?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TMedicalRecordRestrictionsResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicalRecordRestrictions'] = TResolversParentTypes['MedicalRecordRestrictions']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  endDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  startDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TMedicalRecordVaccinationPlanningResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicalRecordVaccinationPlanning'] = TResolversParentTypes['MedicalRecordVaccinationPlanning']> = ResolversObject<{
  currentDose?: Resolver<TResolversTypes['VaccineDoseEnum'], ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  dose?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  medicalRecordId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  personName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  vaccineId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  vaccineName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TMedicalRecordVaccinationPlanningReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicalRecordVaccinationPlanningReport'] = TResolversParentTypes['MedicalRecordVaccinationPlanningReport']> = ResolversObject<{
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  currentDose?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  medicalRecordId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  numberOfDoses?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  personName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  registration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  vaccineName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TMedicalRecordVaccineResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicalRecordVaccine'] = TResolversParentTypes['MedicalRecordVaccine']> = ResolversObject<{
  batch?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  biometry?: Resolver<Maybe<TResolversTypes['VaccineBiometry']>, ParentType, ContextType>;
  currentDose?: Resolver<Maybe<TResolversTypes['VaccineDoseEnum']>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  dose?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  medicalRecordId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['MedicalRecordVaccineStatus'], ParentType, ContextType>;
  vaccine?: Resolver<TResolversTypes['Vaccine'], ParentType, ContextType>;
}>;

export type TMedicalRecordVaccinePrintResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicalRecordVaccinePrint'] = TResolversParentTypes['MedicalRecordVaccinePrint']> = ResolversObject<{
  admissionDate?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  birthDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  costCenter?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  department?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  dismissalDate?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  registration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  vaccines?: Resolver<Array<TResolversTypes['VaccinePrint']>, ParentType, ContextType>;
  workshift?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TMedicalReferralResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicalReferral'] = TResolversParentTypes['MedicalReferral']> = ResolversObject<{
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  medicalRecordId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  observation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  specialty?: Resolver<TResolversTypes['MedicalSpecialty'], ParentType, ContextType>;
  user?: Resolver<Maybe<TResolversTypes['User']>, ParentType, ContextType>;
}>;

export type TMedicalReferralDoctorBiometryResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicalReferralDoctorBiometry'] = TResolversParentTypes['MedicalReferralDoctorBiometry']> = ResolversObject<{
  biometry?: Resolver<TResolversTypes['Biometry'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TMedicalReferralReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicalReferralReport'] = TResolversParentTypes['MedicalReferralReport']> = ResolversObject<{
  address?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  cnpj?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  companyName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  crmState?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  doctorBiometry?: Resolver<Maybe<TResolversTypes['PrintBiometry']>, ParentType, ContextType>;
  doctorCrm?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  doctorName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  doctorRqeDisplay?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  footer?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  individualRegistration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  observation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  patientName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  speciality?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  telephone?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TMedicalRestrictionResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicalRestriction'] = TResolversParentTypes['MedicalRestriction']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  endDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  medicalRecordId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  startDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  stopAdditional?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type TMedicalRestrictionsChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicalRestrictionsChart'] = TResolversParentTypes['MedicalRestrictionsChart']> = ResolversObject<{
  hasRestrictions?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TMedicineResolvers<ContextType = any, ParentType extends TResolversParentTypes['Medicine'] = TResolversParentTypes['Medicine']> = ResolversObject<{
  activePrinciple?: Resolver<Maybe<TResolversTypes['GenericActivePrinciple']>, ParentType, ContextType>;
  activePrincipleId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  ambulatoryMedicine?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  contraindication?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  indication?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  label?: Resolver<Maybe<TResolversTypes['MedicineLabelEnum']>, ParentType, ContextType>;
  laboratory?: Resolver<Maybe<TResolversTypes['GenericLaboratory']>, ParentType, ContextType>;
  laboratoryId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  presentation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  referenceId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  suggestion?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TMedicineOnDiagnosticResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicineOnDiagnostic'] = TResolversParentTypes['MedicineOnDiagnostic']> = ResolversObject<{
  amount?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  measurementUnit?: Resolver<Maybe<TResolversTypes['MedicineMeasurementUnit']>, ParentType, ContextType>;
  medicine?: Resolver<TResolversTypes['Medicine'], ParentType, ContextType>;
  posology?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  showsInPrescription?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TMedicinesPrescriptionResolvers<ContextType = any, ParentType extends TResolversParentTypes['MedicinesPrescription'] = TResolversParentTypes['MedicinesPrescription']> = ResolversObject<{
  amount?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  indication?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  measurementUnit?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  posology?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  presentation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TMeetingResolvers<ContextType = any, ParentType extends TResolversParentTypes['Meeting'] = TResolversParentTypes['Meeting']> = ResolversObject<{
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  duration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  mandate?: Resolver<TResolversTypes['Mandate'], ParentType, ContextType>;
  meetingActions?: Resolver<Maybe<Array<TResolversTypes['ActionOnMeeting']>>, ParentType, ContextType>;
  meetingFormat?: Resolver<TResolversTypes['MeetingFormat'], ParentType, ContextType>;
  meetingLocal?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  meetingParticipants?: Resolver<Maybe<Array<TResolversTypes['ParticipantOnMeeting']>>, ParentType, ContextType>;
  meetingType?: Resolver<TResolversTypes['MeetingType'], ParentType, ContextType>;
  minutesMeeting?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  realDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  subject?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TMeetingActionResolvers<ContextType = any, ParentType extends TResolversParentTypes['MeetingAction'] = TResolversParentTypes['MeetingAction']> = ResolversObject<{
  active?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  dateAction?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  meeting?: Resolver<TResolversTypes['Meeting'], ParentType, ContextType>;
}>;

export type TMeetingEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['MeetingEntry'] = TResolversParentTypes['MeetingEntry']> = ResolversObject<{
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TMeetingParticipantResolvers<ContextType = any, ParentType extends TResolversParentTypes['MeetingParticipant'] = TResolversParentTypes['MeetingParticipant']> = ResolversObject<{
  attendance?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  justification?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  meeting?: Resolver<TResolversTypes['Meeting'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
}>;

export type TMicroActionStatusChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['MicroActionStatusChart'] = TResolversParentTypes['MicroActionStatusChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['MicroActionStatusEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TMicroActionStatusEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['MicroActionStatusEntry'] = TResolversParentTypes['MicroActionStatusEntry']> = ResolversObject<{
  canceled?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  closed?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  open?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TModuleDefaultRecipientsDtoResolvers<ContextType = any, ParentType extends TResolversParentTypes['ModuleDefaultRecipientsDto'] = TResolversParentTypes['ModuleDefaultRecipientsDto']> = ResolversObject<{
  dynamic?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  module?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  note?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  users?: Resolver<Array<TResolversTypes['DefaultRecipientUserDto']>, ParentType, ContextType>;
}>;

export type TMutationResolvers<ContextType = any, ParentType extends TResolversParentTypes['Mutation'] = TResolversParentTypes['Mutation']> = ResolversObject<{
  _clearSessionAndDeleteOrganizationData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutation_ClearSessionAndDeleteOrganizationDataArgs, 'token'>>;
  _createAdmin?: Resolver<TResolversTypes['User'], ParentType, ContextType, RequireFields<TMutation_CreateAdminArgs, 'user'>>;
  _createAndVerifyUser?: Resolver<TResolversTypes['User'], ParentType, ContextType, RequireFields<TMutation_CreateAndVerifyUserArgs, 'user'>>;
  _createDoctor?: Resolver<TResolversTypes['User'], ParentType, ContextType, RequireFields<TMutation_CreateDoctorArgs, 'user'>>;
  _createPersonWithUser?: Resolver<TResolversTypes['Person'], ParentType, ContextType, RequireFields<TMutation_CreatePersonWithUserArgs, 'person'>>;
  _createVerifyDoctorAndAcceptPolicyAndLogin?: Resolver<TResolversTypes['Session'], ParentType, ContextType, RequireFields<TMutation_CreateVerifyDoctorAndAcceptPolicyAndLoginArgs, 'user'>>;
  _createVerifyUserAndAcceptPolicyAndLogin?: Resolver<TResolversTypes['Session'], ParentType, ContextType, RequireFields<TMutation_CreateVerifyUserAndAcceptPolicyAndLoginArgs, 'user'>>;
  _deleteBranchData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  _deleteOrganizationData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  _inviteAndCreateUser?: Resolver<TResolversTypes['User'], ParentType, ContextType, RequireFields<TMutation_InviteAndCreateUserArgs, 'invite'>>;
  _triggerCaepi?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  _updateQueueStatus?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  acknowledgeEmptyCipaMinute?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationAcknowledgeEmptyCipaMinuteArgs, 'meetingId'>>;
  acknowledgeEmptyFireBrigadeMinute?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationAcknowledgeEmptyFireBrigadeMinuteArgs, 'meetingId'>>;
  acknowledgeInconsistency?: Resolver<TResolversTypes['TtalkInboundSemanticInconsistency'], ParentType, ContextType, RequireFields<TMutationAcknowledgeInconsistencyArgs, 'id'>>;
  addOwnership?: Resolver<TResolversTypes['OrganizationOwnership'], ParentType, ContextType, RequireFields<TMutationAddOwnershipArgs, 'fields'>>;
  batchMessages?: Resolver<TResolversTypes['String'], ParentType, ContextType, RequireFields<TMutationBatchMessagesArgs, 'maxDate' | 'minDate'>>;
  blockRole?: Resolver<TResolversTypes['Role'], ParentType, ContextType, RequireFields<TMutationBlockRoleArgs, 'userId'>>;
  blockRoles?: Resolver<Array<TResolversTypes['Role']>, ParentType, ContextType, RequireFields<TMutationBlockRolesArgs, 'userId'>>;
  cancelDocument?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationCancelDocumentArgs, 'documentId'>>;
  changePreMedicalCertificateStatus?: Resolver<TResolversTypes['PreMedicalCertificate'], ParentType, ContextType, RequireFields<TMutationChangePreMedicalCertificateStatusArgs, 'input'>>;
  clearFilterPreference?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationClearFilterPreferenceArgs, 'module'>>;
  configureAdIntegrate?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationConfigureAdIntegrateArgs, 'accessBy' | 'identifiers'>>;
  confirmImport?: Resolver<TResolversTypes['ConfirmImport'], ParentType, ContextType, RequireFields<TMutationConfirmImportArgs, 'rowsFile' | 'type'>>;
  copyExposureGroup?: Resolver<TResolversTypes['ExposureGroup'], ParentType, ContextType, RequireFields<TMutationCopyExposureGroupArgs, 'exposure'>>;
  copyProductsToBranches?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationCopyProductsToBranchesArgs, 'input'>>;
  copySuggestion?: Resolver<Array<TResolversTypes['SuggestionBox']>, ParentType, ContextType, RequireFields<TMutationCopySuggestionArgs, 'id'>>;
  createAbsenceType?: Resolver<TResolversTypes['AbsenceType'], ParentType, ContextType, RequireFields<TMutationCreateAbsenceTypeArgs, 'absenceType'>>;
  createAbsenceTypeByGeneric?: Resolver<TResolversTypes['AbsenceType'], ParentType, ContextType, RequireFields<TMutationCreateAbsenceTypeByGenericArgs, 'referenceId'>>;
  createAccessToken?: Resolver<TResolversTypes['AccessToken'], ParentType, ContextType, RequireFields<TMutationCreateAccessTokenArgs, 'fields'>>;
  createAccident?: Resolver<TResolversTypes['Accident'], ParentType, ContextType, RequireFields<TMutationCreateAccidentArgs, 'accident'>>;
  createAccidentAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreateAccidentAttachmentArgs, 'accidentId' | 'attachment'>>;
  createAccidentCause?: Resolver<TResolversTypes['AccidentCause'], ParentType, ContextType, RequireFields<TMutationCreateAccidentCauseArgs, 'accidentCause'>>;
  createAccidentCauseByGeneric?: Resolver<TResolversTypes['AccidentCause'], ParentType, ContextType, RequireFields<TMutationCreateAccidentCauseByGenericArgs, 'referenceId'>>;
  createAccredited?: Resolver<TResolversTypes['Accredited'], ParentType, ContextType, RequireFields<TMutationCreateAccreditedArgs, 'accredited'>>;
  createAccreditedAsServiceProvider?: Resolver<TResolversTypes['Accredited'], ParentType, ContextType, RequireFields<TMutationCreateAccreditedAsServiceProviderArgs, 'input'>>;
  createActionPlan?: Resolver<TResolversTypes['ActionPlan'], ParentType, ContextType, RequireFields<TMutationCreateActionPlanArgs, 'actionPlan'>>;
  createActionPlanAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreateActionPlanAttachmentArgs, 'actionPlanId' | 'attachment'>>;
  createActionPlanInvestigation?: Resolver<TResolversTypes['ActionPlanReport'], ParentType, ContextType, RequireFields<TMutationCreateActionPlanInvestigationArgs, 'actionPlanReport'>>;
  createActionPlanMicroAction?: Resolver<TResolversTypes['ActionPlanMicroAction'], ParentType, ContextType, RequireFields<TMutationCreateActionPlanMicroActionArgs, 'actionPlanMicroAction'>>;
  createAgreement?: Resolver<TResolversTypes['Agreement'], ParentType, ContextType, RequireFields<TMutationCreateAgreementArgs, 'signature'>>;
  createAllowanceType?: Resolver<TResolversTypes['AllowanceType'], ParentType, ContextType, RequireFields<TMutationCreateAllowanceTypeArgs, 'allowanceType'>>;
  createApiAccess?: Resolver<TResolversTypes['ApiAccess'], ParentType, ContextType, RequireFields<TMutationCreateApiAccessArgs, 'name'>>;
  createBiologicalMonitoring?: Resolver<TResolversTypes['Accident'], ParentType, ContextType, RequireFields<TMutationCreateBiologicalMonitoringArgs, 'biologicalMonitoring'>>;
  createBiologicalMonitoringExamGroup?: Resolver<TResolversTypes['BiologicalMonitoringExamGroup'], ParentType, ContextType, RequireFields<TMutationCreateBiologicalMonitoringExamGroupArgs, 'biologicalMonitoringExamGroup'>>;
  createBiologicalMonitoringExamGroupByGeneric?: Resolver<TResolversTypes['BiologicalMonitoringExamGroup'], ParentType, ContextType, RequireFields<TMutationCreateBiologicalMonitoringExamGroupByGenericArgs, 'referenceId'>>;
  createBiometry?: Resolver<Array<TResolversTypes['Biometry']>, ParentType, ContextType, RequireFields<TMutationCreateBiometryArgs, 'biometry' | 'personId'>>;
  createBranch?: Resolver<TResolversTypes['Branch'], ParentType, ContextType, RequireFields<TMutationCreateBranchArgs, 'branch'>>;
  createCalendar?: Resolver<TResolversTypes['Calendar'], ParentType, ContextType, RequireFields<TMutationCreateCalendarArgs, 'fields'>>;
  createCandidate?: Resolver<TResolversTypes['Candidate'], ParentType, ContextType, RequireFields<TMutationCreateCandidateArgs, 'candidate'>>;
  createClinicalQuiz?: Resolver<TResolversTypes['ClinicalQuiz'], ParentType, ContextType, RequireFields<TMutationCreateClinicalQuizArgs, 'quiz'>>;
  createComponent?: Resolver<TResolversTypes['Component'], ParentType, ContextType, RequireFields<TMutationCreateComponentArgs, 'component'>>;
  createConsultation?: Resolver<TResolversTypes['Consultation'], ParentType, ContextType, RequireFields<TMutationCreateConsultationArgs, 'consultation' | 'unscheduled'>>;
  createContactRequest?: Resolver<TResolversTypes['ContactRequest'], ParentType, ContextType, RequireFields<TMutationCreateContactRequestArgs, 'fields'>>;
  createControlMeasure?: Resolver<TResolversTypes['ControlMeasure'], ParentType, ContextType, RequireFields<TMutationCreateControlMeasureArgs, 'controlMeasure'>>;
  createCostCenter?: Resolver<TResolversTypes['CostCenter'], ParentType, ContextType, RequireFields<TMutationCreateCostCenterArgs, 'costCenter'>>;
  createCostCenterByGeneric?: Resolver<TResolversTypes['CostCenter'], ParentType, ContextType, RequireFields<TMutationCreateCostCenterByGenericArgs, 'referenceId'>>;
  createDeficiency?: Resolver<TResolversTypes['Deficiency'], ParentType, ContextType, RequireFields<TMutationCreateDeficiencyArgs, 'deficiency'>>;
  createDeficiencyAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreateDeficiencyAttachmentArgs, 'attachment' | 'deficiencyId'>>;
  createDeliverySpareParts?: Resolver<Array<TResolversTypes['DeliverySpareParts']>, ParentType, ContextType, RequireFields<TMutationCreateDeliverySparePartsArgs, 'deliverySparePart'>>;
  createDepartment?: Resolver<TResolversTypes['Department'], ParentType, ContextType, RequireFields<TMutationCreateDepartmentArgs, 'department'>>;
  createDevOrganization?: Resolver<TResolversTypes['UserFromCreation'], ParentType, ContextType, RequireFields<TMutationCreateDevOrganizationArgs, 'userOrgInfo'>>;
  createDiagnostic?: Resolver<TResolversTypes['Diagnostic'], ParentType, ContextType, RequireFields<TMutationCreateDiagnosticArgs, 'diagnostic' | 'medicalRecordId' | 'realizationDate'>>;
  createElectionComission?: Resolver<TResolversTypes['ElectionComission'], ParentType, ContextType, RequireFields<TMutationCreateElectionComissionArgs, 'electionComission'>>;
  createEmployeeTask?: Resolver<TResolversTypes['EmployeeTask'], ParentType, ContextType, RequireFields<TMutationCreateEmployeeTaskArgs, 'employeeTask'>>;
  createEmployeeWarning?: Resolver<TResolversTypes['WarningByPerson'], ParentType, ContextType, RequireFields<TMutationCreateEmployeeWarningArgs, 'employeeWarning' | 'personId'>>;
  createEnvironmentalReport?: Resolver<TResolversTypes['EnvironmentalReport'], ParentType, ContextType, RequireFields<TMutationCreateEnvironmentalReportArgs, 'environmentalReport'>>;
  createEnvironmentalReportAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreateEnvironmentalReportAttachmentArgs, 'attachment' | 'environmentalReportId'>>;
  createEnvironmentalReportBiometry?: Resolver<TResolversTypes['EnvironmentalReportBiometry'], ParentType, ContextType, RequireFields<TMutationCreateEnvironmentalReportBiometryArgs, 'biometry' | 'environmentalReportId'>>;
  createEnvironmentalReportFace?: Resolver<TResolversTypes['EnvironmentalReportFace'], ParentType, ContextType, RequireFields<TMutationCreateEnvironmentalReportFaceArgs, 'environmentalReportId' | 'face'>>;
  createEquipmentByCostCenter?: Resolver<TResolversTypes['EquipmentByCostCenter'], ParentType, ContextType, RequireFields<TMutationCreateEquipmentByCostCenterArgs, 'equipmentByCostCenter'>>;
  createEquipmentByOccupation?: Resolver<TResolversTypes['EquipmentByOccupation'], ParentType, ContextType, RequireFields<TMutationCreateEquipmentByOccupationArgs, 'equipmentByOccupation'>>;
  createExam?: Resolver<TResolversTypes['Exam'], ParentType, ContextType, RequireFields<TMutationCreateExamArgs, 'exam'>>;
  createExamAudiometry?: Resolver<TResolversTypes['ExamAudiometry'], ParentType, ContextType, RequireFields<TMutationCreateExamAudiometryArgs, 'examAudiometry' | 'realizationDate' | 'shouldHideConsultation'>>;
  createExamByGeneric?: Resolver<TResolversTypes['Exam'], ParentType, ContextType, RequireFields<TMutationCreateExamByGenericArgs, 'referenceId'>>;
  createExamDiagnosticImage?: Resolver<TResolversTypes['ExamDiagnosticImage'], ParentType, ContextType, RequireFields<TMutationCreateExamDiagnosticImageArgs, 'examDiagnosticImage' | 'realizationDate' | 'shouldHideConsultation'>>;
  createExamDiagnosticImageAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreateExamDiagnosticImageAttachmentArgs, 'attachment' | 'diagnosticImageId'>>;
  createExamItem?: Resolver<TResolversTypes['ExamItem'], ParentType, ContextType, RequireFields<TMutationCreateExamItemArgs, 'examItem' | 'realizationDate' | 'shouldHideConsultation'>>;
  createExamNormal?: Resolver<TResolversTypes['ExamNormal'], ParentType, ContextType, RequireFields<TMutationCreateExamNormalArgs, 'examNormal' | 'shouldHideConsultation'>>;
  createExamOtological?: Resolver<TResolversTypes['ExamOtological'], ParentType, ContextType, RequireFields<TMutationCreateExamOtologicalArgs, 'examOtological' | 'realizationDate' | 'shouldHideConsultation'>>;
  createExamSpirometry?: Resolver<TResolversTypes['ExamSpirometry'], ParentType, ContextType, RequireFields<TMutationCreateExamSpirometryArgs, 'examSpirometry' | 'realizationDate' | 'shouldHideConsultation'>>;
  createExamToxicological?: Resolver<TResolversTypes['ExamToxicological'], ParentType, ContextType, RequireFields<TMutationCreateExamToxicologicalArgs, 'examToxicological' | 'realizationDate' | 'shouldHideConsultation'>>;
  createExpectedGoal?: Resolver<TResolversTypes['ExpectedGoal'], ParentType, ContextType, RequireFields<TMutationCreateExpectedGoalArgs, 'expectedGoal'>>;
  createExpense?: Resolver<TResolversTypes['Expense'], ParentType, ContextType, RequireFields<TMutationCreateExpenseArgs, 'expense'>>;
  createExpenseByGeneric?: Resolver<TResolversTypes['Expense'], ParentType, ContextType, RequireFields<TMutationCreateExpenseByGenericArgs, 'referenceId'>>;
  createExposureGroup?: Resolver<TResolversTypes['ExposureGroup'], ParentType, ContextType, RequireFields<TMutationCreateExposureGroupArgs, 'exposureGroup'>>;
  createExposureGroupCostCenter?: Resolver<TResolversTypes['ExposureGroupCostCenter'], ParentType, ContextType, RequireFields<TMutationCreateExposureGroupCostCenterArgs, 'exposureGroupCostCenter'>>;
  createExposureGroupDepartment?: Resolver<TResolversTypes['ExposureGroupDepartment'], ParentType, ContextType, RequireFields<TMutationCreateExposureGroupDepartmentArgs, 'exposureGroupDepartment'>>;
  createExposureGroupOccupation?: Resolver<TResolversTypes['ExposureGroupOccupation'], ParentType, ContextType, RequireFields<TMutationCreateExposureGroupOccupationArgs, 'exposureGroupOccupation'>>;
  createExposureGroupPerson?: Resolver<TResolversTypes['ExposureGroupPerson'], ParentType, ContextType, RequireFields<TMutationCreateExposureGroupPersonArgs, 'exposureGroupPerson'>>;
  createExposureGroupTask?: Resolver<TResolversTypes['ExposureGroupTask'], ParentType, ContextType, RequireFields<TMutationCreateExposureGroupTaskArgs, 'exposureGroupTask'>>;
  createExternalOccupationalHealthCertificate?: Resolver<TResolversTypes['ExternalOccupationalHealthCertificate'], ParentType, ContextType, RequireFields<TMutationCreateExternalOccupationalHealthCertificateArgs, 'occupationalHealthCertificate'>>;
  createExtinguishingAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreateExtinguishingAttachmentArgs, 'attachment' | 'extinguishingSystemId'>>;
  createExtinguishingInspectionAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreateExtinguishingInspectionAttachmentArgs, 'attachment' | 'inspectionId'>>;
  createExtinguishingSystem?: Resolver<TResolversTypes['ExtinguishingSystem'], ParentType, ContextType, RequireFields<TMutationCreateExtinguishingSystemArgs, 'extinguishingSystem'>>;
  createFireBrigade?: Resolver<TResolversTypes['FireBrigade'], ParentType, ContextType, RequireFields<TMutationCreateFireBrigadeArgs, 'fireBrigade'>>;
  createFireBrigadeComponent?: Resolver<TResolversTypes['FireBrigadeComponent'], ParentType, ContextType, RequireFields<TMutationCreateFireBrigadeComponentArgs, 'fireBrigadeComponent'>>;
  createFireBrigadeExam?: Resolver<TResolversTypes['FireBrigadeExam'], ParentType, ContextType, RequireFields<TMutationCreateFireBrigadeExamArgs, 'fireBrigadeExam'>>;
  createFireBrigadeMeeting?: Resolver<TResolversTypes['FireBrigadeMeeting'], ParentType, ContextType, RequireFields<TMutationCreateFireBrigadeMeetingArgs, 'fireBrigadeMeeting'>>;
  createFireBrigadeMeetingAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreateFireBrigadeMeetingAttachmentArgs, 'attachment' | 'meetingId'>>;
  createFireBrigadeOccurrence?: Resolver<TResolversTypes['FireBrigadeOccurrence'], ParentType, ContextType, RequireFields<TMutationCreateFireBrigadeOccurrenceArgs, 'fireBrigadeOccurrence'>>;
  createFireBrigadeOccurrenceAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreateFireBrigadeOccurrenceAttachmentArgs, 'attachment' | 'occurrenceId'>>;
  createFireBrigadeTraining?: Resolver<TResolversTypes['FireBrigadeTraining'], ParentType, ContextType, RequireFields<TMutationCreateFireBrigadeTrainingArgs, 'fireBrigadeTraining'>>;
  createGeneratingSource?: Resolver<TResolversTypes['GeneratingSource'], ParentType, ContextType, RequireFields<TMutationCreateGeneratingSourceArgs, 'generatingSource'>>;
  createHealthProgram?: Resolver<TResolversTypes['HealthProgram'], ParentType, ContextType, RequireFields<TMutationCreateHealthProgramArgs, 'healthProgram'>>;
  createHealthProgramByGeneric?: Resolver<TResolversTypes['HealthProgram'], ParentType, ContextType, RequireFields<TMutationCreateHealthProgramByGenericArgs, 'referenceId'>>;
  createHealthProgramTraining?: Resolver<TResolversTypes['HealthProgramTraining'], ParentType, ContextType, RequireFields<TMutationCreateHealthProgramTrainingArgs, 'healthProgramTraining'>>;
  createInvestigation?: Resolver<TResolversTypes['Investigation'], ParentType, ContextType, RequireFields<TMutationCreateInvestigationArgs, 'investigation'>>;
  createInvestigationAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreateInvestigationAttachmentArgs, 'attachment' | 'investigationId'>>;
  createInvite?: Resolver<TResolversTypes['Invite'], ParentType, ContextType, RequireFields<TMutationCreateInviteArgs, 'invite'>>;
  createIpeDelivery?: Resolver<Array<TResolversTypes['IpeDelivery']>, ParentType, ContextType, RequireFields<TMutationCreateIpeDeliveryArgs, 'ipeDelivery'>>;
  createIpeDeliveryExtension?: Resolver<TResolversTypes['IpeDeliveryExtensionResult'], ParentType, ContextType, RequireFields<TMutationCreateIpeDeliveryExtensionArgs, 'input'>>;
  createIpeIpeBiometry?: Resolver<Array<TResolversTypes['IpeBiometry']>, ParentType, ContextType, RequireFields<TMutationCreateIpeIpeBiometryArgs, 'biometry' | 'deliveries'>>;
  createMandate?: Resolver<TResolversTypes['Mandate'], ParentType, ContextType, RequireFields<TMutationCreateMandateArgs, 'mandate'>>;
  createMandateAction?: Resolver<TResolversTypes['MandateAction'], ParentType, ContextType, RequireFields<TMutationCreateMandateActionArgs, 'mandateAction'>>;
  createMandateCostCenter?: Resolver<TResolversTypes['MandateCostCenter'], ParentType, ContextType, RequireFields<TMutationCreateMandateCostCenterArgs, 'mandateCostCenter'>>;
  createMandateDepartment?: Resolver<TResolversTypes['MandateDepartment'], ParentType, ContextType, RequireFields<TMutationCreateMandateDepartmentArgs, 'mandateDepartment'>>;
  createMandateTraining?: Resolver<TResolversTypes['MandateTraining'], ParentType, ContextType, RequireFields<TMutationCreateMandateTrainingArgs, 'mandateTraining'>>;
  createManyOrdinaryFireBrigadeMeeting?: Resolver<Array<TResolversTypes['FireBrigadeMeeting']>, ParentType, ContextType, RequireFields<TMutationCreateManyOrdinaryFireBrigadeMeetingArgs, 'date' | 'fireBrigadeId'>>;
  createManyOrdinaryMeeting?: Resolver<Array<TResolversTypes['Meeting']>, ParentType, ContextType, RequireFields<TMutationCreateManyOrdinaryMeetingArgs, 'date' | 'mandateId'>>;
  createMeasuringInstrument?: Resolver<TResolversTypes['MeasuringInstrument'], ParentType, ContextType, RequireFields<TMutationCreateMeasuringInstrumentArgs, 'measuringInstrument'>>;
  createMeasuringInstrumentAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreateMeasuringInstrumentAttachmentArgs, 'attachment' | 'measuringInstrumentId'>>;
  createMeasuringInstrumentByGeneric?: Resolver<TResolversTypes['MeasuringInstrument'], ParentType, ContextType, RequireFields<TMutationCreateMeasuringInstrumentByGenericArgs, 'referenceId'>>;
  createMedicalCertificate?: Resolver<TResolversTypes['MedicalCertificate'], ParentType, ContextType, RequireFields<TMutationCreateMedicalCertificateArgs, 'medicalCertificate'>>;
  createMedicalCertificateAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreateMedicalCertificateAttachmentArgs, 'attachment' | 'medicalCertificateId'>>;
  createMedicalRecord?: Resolver<TResolversTypes['MedicalRecord'], ParentType, ContextType, RequireFields<TMutationCreateMedicalRecordArgs, 'medicalRecord'>>;
  createMedicalRecordAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreateMedicalRecordAttachmentArgs, 'attachment' | 'medicalRecordId'>>;
  createMedicalRecordHealthProgram?: Resolver<TResolversTypes['MedicalRecordHealthProgram'], ParentType, ContextType, RequireFields<TMutationCreateMedicalRecordHealthProgramArgs, 'medicalRecordHealthProgram'>>;
  createMedicalRecordVaccine?: Resolver<TResolversTypes['MedicalRecordVaccine'], ParentType, ContextType, RequireFields<TMutationCreateMedicalRecordVaccineArgs, 'medicalRecordVaccine'>>;
  createMedicalRecordVaccinePlanning?: Resolver<Array<TResolversTypes['MedicalRecordVaccine']>, ParentType, ContextType, RequireFields<TMutationCreateMedicalRecordVaccinePlanningArgs, 'medicalRecordsVaccinePlan'>>;
  createMedicalReferral?: Resolver<TResolversTypes['MedicalReferral'], ParentType, ContextType, RequireFields<TMutationCreateMedicalReferralArgs, 'medicalReferral'>>;
  createMedicalReferralDoctorBiometry?: Resolver<TResolversTypes['MedicalReferralDoctorBiometry'], ParentType, ContextType, RequireFields<TMutationCreateMedicalReferralDoctorBiometryArgs, 'biometry' | 'doctorId' | 'medicalReferralId'>>;
  createMedicalRestriction?: Resolver<TResolversTypes['MedicalRestriction'], ParentType, ContextType, RequireFields<TMutationCreateMedicalRestrictionArgs, 'medicalRestriction'>>;
  createMedicine?: Resolver<TResolversTypes['Medicine'], ParentType, ContextType, RequireFields<TMutationCreateMedicineArgs, 'medicine'>>;
  createMedicineByGeneric?: Resolver<TResolversTypes['Medicine'], ParentType, ContextType, RequireFields<TMutationCreateMedicineByGenericArgs, 'referenceId'>>;
  createMeeting?: Resolver<TResolversTypes['Meeting'], ParentType, ContextType, RequireFields<TMutationCreateMeetingArgs, 'meeting'>>;
  createMeetingAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreateMeetingAttachmentArgs, 'attachment' | 'meetingId'>>;
  createOccupation?: Resolver<TResolversTypes['Occupation'], ParentType, ContextType, RequireFields<TMutationCreateOccupationArgs, 'occupation'>>;
  createOccupationByGeneric?: Resolver<TResolversTypes['Occupation'], ParentType, ContextType, RequireFields<TMutationCreateOccupationByGenericArgs, 'referenceId'>>;
  createOccupationalHealthCertificate?: Resolver<TResolversTypes['OccupationalHealthCertificate'], ParentType, ContextType, RequireFields<TMutationCreateOccupationalHealthCertificateArgs, 'occupationalHealthCertificate'>>;
  createOccupationalHealthCertificateAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreateOccupationalHealthCertificateAttachmentArgs, 'attachment' | 'occupationalHealthCertificateId'>>;
  createOccupationalHealthOccupationalHealthBiometry?: Resolver<Array<TResolversTypes['OccupationalHealthBiometry']>, ParentType, ContextType, RequireFields<TMutationCreateOccupationalHealthOccupationalHealthBiometryArgs, 'biometry' | 'occupationalHealthCertificateId'>>;
  createOrganization?: Resolver<TResolversTypes['OrganizationWithBranches'], ParentType, ContextType, RequireFields<TMutationCreateOrganizationArgs, 'organization'>>;
  createOrthoRater?: Resolver<TResolversTypes['OrthoRater'], ParentType, ContextType, RequireFields<TMutationCreateOrthoRaterArgs, 'orthoRater' | 'realizationDate' | 'shouldHideConsultation'>>;
  createPeriodicRange?: Resolver<TResolversTypes['PeriodicRange'], ParentType, ContextType, RequireFields<TMutationCreatePeriodicRangeArgs, 'fields'>>;
  createPeriodicRangeByGeneric?: Resolver<TResolversTypes['PeriodicRange'], ParentType, ContextType, RequireFields<TMutationCreatePeriodicRangeByGenericArgs, 'referenceId'>>;
  createPerson?: Resolver<TResolversTypes['Person'], ParentType, ContextType, RequireFields<TMutationCreatePersonArgs, 'person'>>;
  createPersonAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreatePersonAttachmentArgs, 'attachment' | 'personId'>>;
  createPhysicalEnvironment?: Resolver<TResolversTypes['PhysicalEnvironment'], ParentType, ContextType, RequireFields<TMutationCreatePhysicalEnvironmentArgs, 'physicalEnvironment'>>;
  createPhysicalEnvironmentAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreatePhysicalEnvironmentAttachmentArgs, 'attachment' | 'physicalEnvironmentId'>>;
  createPolicyAgreement?: Resolver<Array<TResolversTypes['PolicyAgreement']>, ParentType, ContextType, RequireFields<TMutationCreatePolicyAgreementArgs, 'type'>>;
  createPolicyTerm?: Resolver<TResolversTypes['PolicyTerms'], ParentType, ContextType, RequireFields<TMutationCreatePolicyTermArgs, 'term'>>;
  createPosition?: Resolver<TResolversTypes['Position'], ParentType, ContextType, RequireFields<TMutationCreatePositionArgs, 'position'>>;
  createProduct?: Resolver<TResolversTypes['Product'], ParentType, ContextType, RequireFields<TMutationCreateProductArgs, 'product'>>;
  createProductDelivery?: Resolver<Array<TResolversTypes['ProductDelivery']>, ParentType, ContextType, RequireFields<TMutationCreateProductDeliveryArgs, 'productDelivery'>>;
  createProductIpeManufacturer?: Resolver<TResolversTypes['ProductIpeManufacturer'], ParentType, ContextType, RequireFields<TMutationCreateProductIpeManufacturerArgs, 'productIpeManufacturer'>>;
  createQuiz?: Resolver<TResolversTypes['Quiz'], ParentType, ContextType, RequireFields<TMutationCreateQuizArgs, 'quiz'>>;
  createQuizAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreateQuizAttachmentArgs, 'attachment' | 'quizId'>>;
  createQuizByGeneric?: Resolver<TResolversTypes['Quiz'], ParentType, ContextType, RequireFields<TMutationCreateQuizByGenericArgs, 'referenceId'>>;
  createRealGoal?: Resolver<TResolversTypes['RealGoal'], ParentType, ContextType, RequireFields<TMutationCreateRealGoalArgs, 'realGoal'>>;
  createRealGoalAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreateRealGoalAttachmentArgs, 'actionPlanId' | 'attachment' | 'realGoalId'>>;
  createReportAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreateReportAttachmentArgs, 'attachment' | 'environmentalReportId'>>;
  createReportSection?: Resolver<TResolversTypes['ReportSection'], ParentType, ContextType, RequireFields<TMutationCreateReportSectionArgs, 'reportSection'>>;
  createReportStructure?: Resolver<TResolversTypes['ReportStructure'], ParentType, ContextType, RequireFields<TMutationCreateReportStructureArgs, 'reportStructure'>>;
  createResponsibleAction?: Resolver<TResolversTypes['ResponsibleAction'], ParentType, ContextType, RequireFields<TMutationCreateResponsibleActionArgs, 'responsibleAction'>>;
  createResultExamIbmp?: Resolver<TResolversTypes['ResultExamIbmp'], ParentType, ContextType, RequireFields<TMutationCreateResultExamIbmpArgs, 'examIbmp' | 'realizationDate' | 'shouldHideConsultation'>>;
  createRisk?: Resolver<TResolversTypes['Risk'], ParentType, ContextType, RequireFields<TMutationCreateRiskArgs, 'risk'>>;
  createRiskAgent?: Resolver<TResolversTypes['RiskAgent'], ParentType, ContextType, RequireFields<TMutationCreateRiskAgentArgs, 'riskAgent'>>;
  createRiskAgentByGeneric?: Resolver<TResolversTypes['RiskAgent'], ParentType, ContextType, RequireFields<TMutationCreateRiskAgentByGenericArgs, 'referenceId'>>;
  createRiskAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreateRiskAttachmentArgs, 'attachment' | 'riskId'>>;
  createRolePermission?: Resolver<TResolversTypes['RolePermission'], ParentType, ContextType, RequireFields<TMutationCreateRolePermissionArgs, 'rolePermission'>>;
  createSafetyQuiz?: Resolver<TResolversTypes['SafetyQuiz'], ParentType, ContextType, RequireFields<TMutationCreateSafetyQuizArgs, 'quiz'>>;
  createScheduleRestriction?: Resolver<TResolversTypes['ScheduleRestriction'], ParentType, ContextType, RequireFields<TMutationCreateScheduleRestrictionArgs, 'scheduleRestriction'>>;
  createSession?: Resolver<TResolversTypes['Session'], ParentType, ContextType, RequireFields<TMutationCreateSessionArgs, 'input'>>;
  createSessionByAd?: Resolver<TResolversTypes['Session'], ParentType, ContextType, RequireFields<TMutationCreateSessionByAdArgs, 'input'>>;
  createSessionForBranch?: Resolver<TResolversTypes['Session'], ParentType, ContextType, RequireFields<TMutationCreateSessionForBranchArgs, 'branchId'>>;
  createSignCredentials?: Resolver<TResolversTypes['SignCredentialsOutput'], ParentType, ContextType, RequireFields<TMutationCreateSignCredentialsArgs, 'input'>>;
  createSignDocumentEnvironmentalReport?: Resolver<TResolversTypes['BaseDocumentResponse'], ParentType, ContextType, RequireFields<TMutationCreateSignDocumentEnvironmentalReportArgs, 'environmentalReportId' | 'input'>>;
  createSignDocumentIpeDelivery?: Resolver<TResolversTypes['BaseDocumentResponse'], ParentType, ContextType, RequireFields<TMutationCreateSignDocumentIpeDeliveryArgs, 'input' | 'sourceId'>>;
  createSignDocumentMedicalCertificate?: Resolver<TResolversTypes['BaseDocumentResponse'], ParentType, ContextType, RequireFields<TMutationCreateSignDocumentMedicalCertificateArgs, 'certificateId' | 'input'>>;
  createSignDocumentOHC?: Resolver<TResolversTypes['BaseDocumentResponse'], ParentType, ContextType, RequireFields<TMutationCreateSignDocumentOhcArgs, 'certificateId' | 'input'>>;
  createSignDocumentSecurityWorkOrder?: Resolver<TResolversTypes['BaseDocumentResponse'], ParentType, ContextType, RequireFields<TMutationCreateSignDocumentSecurityWorkOrderArgs, 'input' | 'sourceId'>>;
  createSimulation?: Resolver<TResolversTypes['Simulation'], ParentType, ContextType, RequireFields<TMutationCreateSimulationArgs, 'simulation'>>;
  createSimulationPlan?: Resolver<TResolversTypes['SimulationPlan'], ParentType, ContextType, RequireFields<TMutationCreateSimulationPlanArgs, 'simulationPlan'>>;
  createSipat?: Resolver<TResolversTypes['Sipat'], ParentType, ContextType, RequireFields<TMutationCreateSipatArgs, 'sipat'>>;
  createSipatAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreateSipatAttachmentArgs, 'attachment' | 'sipatId'>>;
  createSnellen?: Resolver<TResolversTypes['Snellen'], ParentType, ContextType, RequireFields<TMutationCreateSnellenArgs, 'realizationDate' | 'shouldHideConsultation' | 'snellen'>>;
  createSpareParts?: Resolver<TResolversTypes['SpareParts'], ParentType, ContextType, RequireFields<TMutationCreateSparePartsArgs, 'sparePart'>>;
  createStabilityType?: Resolver<TResolversTypes['StabilityType'], ParentType, ContextType, RequireFields<TMutationCreateStabilityTypeArgs, 'StabilityType'>>;
  createStatementResponsibility?: Resolver<TResolversTypes['StatementResponsibility'], ParentType, ContextType, RequireFields<TMutationCreateStatementResponsibilityArgs, 'statement'>>;
  createStatementResponsibilityByGeneric?: Resolver<TResolversTypes['StatementResponsibility'], ParentType, ContextType, RequireFields<TMutationCreateStatementResponsibilityByGenericArgs, 'referenceId'>>;
  createStockLevel?: Resolver<TResolversTypes['StockLevel'], ParentType, ContextType, RequireFields<TMutationCreateStockLevelArgs, 'stockLevel'>>;
  createStockMovement?: Resolver<Array<TResolversTypes['StockMovement']>, ParentType, ContextType, RequireFields<TMutationCreateStockMovementArgs, 'stockMovement'>>;
  createSuggestionBox?: Resolver<TResolversTypes['SuggestionBox'], ParentType, ContextType, RequireFields<TMutationCreateSuggestionBoxArgs, 'suggestionBox'>>;
  createTask?: Resolver<TResolversTypes['Task'], ParentType, ContextType, RequireFields<TMutationCreateTaskArgs, 'task'>>;
  createThumbnail?: Resolver<TResolversTypes['String'], ParentType, ContextType, RequireFields<TMutationCreateThumbnailArgs, 'attachment' | 'urlOrigin'>>;
  createTraining?: Resolver<TResolversTypes['Training'], ParentType, ContextType, RequireFields<TMutationCreateTrainingArgs, 'training'>>;
  createTrainingAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreateTrainingAttachmentArgs, 'attachment' | 'mandateTrainingId' | 'trainingId'>>;
  createTrainingByGeneric?: Resolver<TResolversTypes['Training'], ParentType, ContextType, RequireFields<TMutationCreateTrainingByGenericArgs, 'referenceId'>>;
  createTrainingHistory?: Resolver<TResolversTypes['TrainingHistory'], ParentType, ContextType, RequireFields<TMutationCreateTrainingHistoryArgs, 'input'>>;
  createTrainingHistoryAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreateTrainingHistoryAttachmentArgs, 'attachment' | 'trainingHistoryId'>>;
  createTrainingHistoryBatch?: Resolver<TResolversTypes['TrainingHistoryBatchResult'], ParentType, ContextType, RequireFields<TMutationCreateTrainingHistoryBatchArgs, 'input'>>;
  createUnityOfMeasure?: Resolver<TResolversTypes['UnityOfMeasure'], ParentType, ContextType, RequireFields<TMutationCreateUnityOfMeasureArgs, 'unityOfMeasure'>>;
  createUrinalysis?: Resolver<TResolversTypes['Urinalysis'], ParentType, ContextType, RequireFields<TMutationCreateUrinalysisArgs, 'realizationDate' | 'shouldHideConsultation' | 'urinalysis'>>;
  createUser?: Resolver<TResolversTypes['UserFromCreation'], ParentType, ContextType, RequireFields<TMutationCreateUserArgs, 'user'>>;
  createUserSpecialty?: Resolver<TResolversTypes['UserSpecialty'], ParentType, ContextType, RequireFields<TMutationCreateUserSpecialtyArgs, 'userId' | 'userSpecialty'>>;
  createVaccine?: Resolver<TResolversTypes['Vaccine'], ParentType, ContextType, RequireFields<TMutationCreateVaccineArgs, 'vaccine'>>;
  createVaccineByGeneric?: Resolver<TResolversTypes['Vaccine'], ParentType, ContextType, RequireFields<TMutationCreateVaccineByGenericArgs, 'referenceId'>>;
  createVote?: Resolver<TResolversTypes['Vote'], ParentType, ContextType, RequireFields<TMutationCreateVoteArgs, 'vote'>>;
  createWarehouse?: Resolver<TResolversTypes['Warehouse'], ParentType, ContextType, RequireFields<TMutationCreateWarehouseArgs, 'warehouse'>>;
  createWarningAttachment?: Resolver<Array<TResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<TMutationCreateWarningAttachmentArgs, 'attachment' | 'employeeWarningId'>>;
  createWebhook?: Resolver<TResolversTypes['Webhook'], ParentType, ContextType, RequireFields<TMutationCreateWebhookArgs, 'webhook'>>;
  createWebhookQueue?: Resolver<TResolversTypes['WebhookQueue'], ParentType, ContextType, RequireFields<TMutationCreateWebhookQueueArgs, 'webhookQueue'>>;
  createWorkPermission?: Resolver<TResolversTypes['WorkPermission'], ParentType, ContextType, RequireFields<TMutationCreateWorkPermissionArgs, 'workPermission'>>;
  createWorkShift?: Resolver<TResolversTypes['WorkShift'], ParentType, ContextType, RequireFields<TMutationCreateWorkShiftArgs, 'workShift'>>;
  createWorkShiftByGeneric?: Resolver<TResolversTypes['WorkShift'], ParentType, ContextType, RequireFields<TMutationCreateWorkShiftByGenericArgs, 'referenceId'>>;
  csvAccredited?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationCsvAccreditedArgs, 'attachment'>>;
  csvClinicalQuiz?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationCsvClinicalQuizArgs, 'attachment'>>;
  csvDeficiency?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationCsvDeficiencyArgs, 'attachment'>>;
  csvMedicalCertificate?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationCsvMedicalCertificateArgs, 'attachment'>>;
  csvMedicalRecord?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationCsvMedicalRecordArgs, 'attachment'>>;
  csvMedicalRecordVaccine?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationCsvMedicalRecordVaccineArgs, 'attachment'>>;
  csvOccupationalHealthCertificate?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationCsvOccupationalHealthCertificateArgs, 'attachment'>>;
  csvQuiz?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationCsvQuizArgs, 'attachment'>>;
  csvRisk?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationCsvRiskArgs, 'attachment'>>;
  deleteEnvironmentalReportVersion?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationDeleteEnvironmentalReportVersionArgs, 'id'>>;
  deletePolicyAgreement?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationDeletePolicyAgreementArgs, 'id'>>;
  deletePolicyTerm?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationDeletePolicyTermArgs, 'id'>>;
  eSocialCreateFieldsValidation?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType, Partial<TMutationESocialCreateFieldsValidationArgs>>;
  eSocialUpdateFieldsValidation?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType, Partial<TMutationESocialUpdateFieldsValidationArgs>>;
  employeeAnswerClinicalQuiz?: Resolver<TResolversTypes['ClinicalQuiz'], ParentType, ContextType, RequireFields<TMutationEmployeeAnswerClinicalQuizArgs, 'input'>>;
  employeeAnswerSafetyQuiz?: Resolver<TResolversTypes['SafetyQuiz'], ParentType, ContextType, RequireFields<TMutationEmployeeAnswerSafetyQuizArgs, 'input'>>;
  employeeCandidate?: Resolver<TResolversTypes['Candidate'], ParentType, ContextType, RequireFields<TMutationEmployeeCandidateArgs, 'candidate'>>;
  employeeLoginByAd?: Resolver<TResolversTypes['Login'], ParentType, ContextType, RequireFields<TMutationEmployeeLoginByAdArgs, 'input'>>;
  employeeLoginMutation?: Resolver<TResolversTypes['Login'], ParentType, ContextType, RequireFields<TMutationEmployeeLoginMutationArgs, 'generate'>>;
  employeeVote?: Resolver<TResolversTypes['Vote'], ParentType, ContextType, RequireFields<TMutationEmployeeVoteArgs, 'vote'>>;
  forceUserUpdatePassword?: Resolver<TResolversTypes['UserBasicInfo'], ParentType, ContextType, RequireFields<TMutationForceUserUpdatePasswordArgs, 'fields'>>;
  forkDocumentFromDefault?: Resolver<TResolversTypes['CustomDocument'], ParentType, ContextType, RequireFields<TMutationForkDocumentFromDefaultArgs, 'type'>>;
  generateEnvironmentalReportSignAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationGenerateEnvironmentalReportSignAttachmentArgs, 'environmentalReportId'>>;
  generatePassword?: Resolver<TResolversTypes['Person'], ParentType, ContextType, RequireFields<TMutationGeneratePasswordArgs, 'generate'>>;
  hermesCreateBranch?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  hermesCreateMetadata?: Resolver<TResolversTypes['SaasMetadata'], ParentType, ContextType, RequireFields<TMutationHermesCreateMetadataArgs, 'input'>>;
  hermesCreateOrganization?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  hermesDeleteBranch?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  hermesDeleteMetadata?: Resolver<TResolversTypes['SaasMetadata'], ParentType, ContextType, RequireFields<TMutationHermesDeleteMetadataArgs, 'metadataId'>>;
  hermesDeleteOrganization?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  hermesIntegrationConfigure?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationHermesIntegrationConfigureArgs, 'input'>>;
  hermesUpdateBranch?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationHermesUpdateBranchArgs, 'name'>>;
  hermesUpdateMetadata?: Resolver<TResolversTypes['SaasMetadata'], ParentType, ContextType, RequireFields<TMutationHermesUpdateMetadataArgs, 'input'>>;
  hermesUpdateOrganization?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationHermesUpdateOrganizationArgs, 'socialName'>>;
  importSSTOptions?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationImportSstOptionsArgs, 'options'>>;
  initialIntegrationConfigByBranch?: Resolver<TResolversTypes['IntegrationConfiguration'], ParentType, ContextType, RequireFields<TMutationInitialIntegrationConfigByBranchArgs, 'integrationConfiguration'>>;
  insertFeatureFlag?: Resolver<TResolversTypes['Flag'], ParentType, ContextType, RequireFields<TMutationInsertFeatureFlagArgs, 'features' | 'flag' | 'priority'>>;
  insertOrganizationFlag?: Resolver<TResolversTypes['BaseFlagReturn'], ParentType, ContextType, RequireFields<TMutationInsertOrganizationFlagArgs, 'flag' | 'organizationId'>>;
  insertUserFlag?: Resolver<TResolversTypes['BaseFlagReturn'], ParentType, ContextType, RequireFields<TMutationInsertUserFlagArgs, 'flag' | 'userId'>>;
  inviteByCsv?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationInviteByCsvArgs, 'attachment'>>;
  manageCustomOrganization?: Resolver<Array<TResolversTypes['CustomOrganization']>, ParentType, ContextType, RequireFields<TMutationManageCustomOrganizationArgs, 'customOrganization'>>;
  migrateDataToHermes?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, Partial<TMutationMigrateDataToHermesArgs>>;
  organizationCancelContract?: Resolver<TResolversTypes['Organization'], ParentType, ContextType, RequireFields<TMutationOrganizationCancelContractArgs, 'cancelContract'>>;
  organizationContract?: Resolver<TResolversTypes['Organization'], ParentType, ContextType, RequireFields<TMutationOrganizationContractArgs, 'contract'>>;
  organizationReactiveContract?: Resolver<TResolversTypes['Organization'], ParentType, ContextType, RequireFields<TMutationOrganizationReactiveContractArgs, 'contract'>>;
  preValidate?: Resolver<TResolversTypes['PreValidate'], ParentType, ContextType, RequireFields<TMutationPreValidateArgs, 'attachment' | 'type'>>;
  purgeFeature?: Resolver<TResolversTypes['BaseFeatureReturn'], ParentType, ContextType, RequireFields<TMutationPurgeFeatureArgs, 'feature'>>;
  purgeFlag?: Resolver<TResolversTypes['BaseFlagReturn'], ParentType, ContextType, RequireFields<TMutationPurgeFlagArgs, 'flag'>>;
  reactivateBranch?: Resolver<TResolversTypes['Branch'], ParentType, ContextType, RequireFields<TMutationReactivateBranchArgs, 'branchId'>>;
  reactivateRole?: Resolver<TResolversTypes['Role'], ParentType, ContextType, RequireFields<TMutationReactivateRoleArgs, 'userId'>>;
  recognizeMedicalCertificate?: Resolver<TResolversTypes['RecognizedMedicalCertificateData'], ParentType, ContextType, RequireFields<TMutationRecognizeMedicalCertificateArgs, 'input'>>;
  registerFeatureFlag?: Resolver<TResolversTypes['Flag'], ParentType, ContextType, RequireFields<TMutationRegisterFeatureFlagArgs, 'features' | 'flag' | 'priority'>>;
  releaseConsultationResults?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationReleaseConsultationResultsArgs, 'input'>>;
  removeAbsenceType?: Resolver<TResolversTypes['AbsenceType'], ParentType, ContextType, RequireFields<TMutationRemoveAbsenceTypeArgs, 'id'>>;
  removeAccident?: Resolver<TResolversTypes['Accident'], ParentType, ContextType, RequireFields<TMutationRemoveAccidentArgs, 'id'>>;
  removeAccidentAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveAccidentAttachmentArgs, 'id'>>;
  removeAccidentCause?: Resolver<TResolversTypes['AccidentCause'], ParentType, ContextType, RequireFields<TMutationRemoveAccidentCauseArgs, 'id'>>;
  removeAccredited?: Resolver<TResolversTypes['Accredited'], ParentType, ContextType, RequireFields<TMutationRemoveAccreditedArgs, 'id'>>;
  removeActionPlan?: Resolver<TResolversTypes['ActionPlan'], ParentType, ContextType, RequireFields<TMutationRemoveActionPlanArgs, 'id'>>;
  removeActionPlanAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveActionPlanAttachmentArgs, 'id'>>;
  removeActionPlanMicroAction?: Resolver<TResolversTypes['ActionPlanMicroAction'], ParentType, ContextType, RequireFields<TMutationRemoveActionPlanMicroActionArgs, 'id'>>;
  removeAdIntegrate?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  removeAllBiometries?: Resolver<Array<TResolversTypes['Biometry']>, ParentType, ContextType, RequireFields<TMutationRemoveAllBiometriesArgs, 'personId'>>;
  removeAllTrialOrganizationUsers?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  removeAllowanceType?: Resolver<TResolversTypes['AllowanceType'], ParentType, ContextType, RequireFields<TMutationRemoveAllowanceTypeArgs, 'id'>>;
  removeApiAccess?: Resolver<TResolversTypes['ApiAccess'], ParentType, ContextType, RequireFields<TMutationRemoveApiAccessArgs, 'id'>>;
  removeBiologicalMonitoringExamGroup?: Resolver<TResolversTypes['BiologicalMonitoringExamGroup'], ParentType, ContextType, RequireFields<TMutationRemoveBiologicalMonitoringExamGroupArgs, 'id'>>;
  removeBiometry?: Resolver<TResolversTypes['Biometry'], ParentType, ContextType, RequireFields<TMutationRemoveBiometryArgs, 'id'>>;
  removeBranch?: Resolver<TResolversTypes['Branch'], ParentType, ContextType, RequireFields<TMutationRemoveBranchArgs, 'branchId'>>;
  removeCalendar?: Resolver<TResolversTypes['Calendar'], ParentType, ContextType, RequireFields<TMutationRemoveCalendarArgs, 'id'>>;
  removeCandidate?: Resolver<TResolversTypes['Candidate'], ParentType, ContextType, RequireFields<TMutationRemoveCandidateArgs, 'id'>>;
  removeClinicalQuiz?: Resolver<TResolversTypes['ClinicalQuiz'], ParentType, ContextType, RequireFields<TMutationRemoveClinicalQuizArgs, 'id'>>;
  removeComplementaryExam?: Resolver<TResolversTypes['ComplementaryExam'], ParentType, ContextType, RequireFields<TMutationRemoveComplementaryExamArgs, 'id'>>;
  removeComponent?: Resolver<TResolversTypes['Component'], ParentType, ContextType, RequireFields<TMutationRemoveComponentArgs, 'id'>>;
  removeConsultation?: Resolver<TResolversTypes['Consultation'], ParentType, ContextType, RequireFields<TMutationRemoveConsultationArgs, 'id'>>;
  removeControlMeasure?: Resolver<TResolversTypes['ControlMeasure'], ParentType, ContextType, RequireFields<TMutationRemoveControlMeasureArgs, 'id'>>;
  removeCostCenter?: Resolver<TResolversTypes['CostCenter'], ParentType, ContextType, RequireFields<TMutationRemoveCostCenterArgs, 'id'>>;
  removeDeficiency?: Resolver<TResolversTypes['Deficiency'], ParentType, ContextType, RequireFields<TMutationRemoveDeficiencyArgs, 'id'>>;
  removeDeficiencyAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveDeficiencyAttachmentArgs, 'id'>>;
  removeDeliverySpareParts?: Resolver<TResolversTypes['DeliverySpareParts'], ParentType, ContextType, RequireFields<TMutationRemoveDeliverySparePartsArgs, 'id'>>;
  removeDepartment?: Resolver<TResolversTypes['Department'], ParentType, ContextType, RequireFields<TMutationRemoveDepartmentArgs, 'id'>>;
  removeDiagnostic?: Resolver<TResolversTypes['Diagnostic'], ParentType, ContextType, RequireFields<TMutationRemoveDiagnosticArgs, 'id'>>;
  removeDocument?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveDocumentArgs, 'documentId'>>;
  removeElectionComission?: Resolver<TResolversTypes['ElectionComission'], ParentType, ContextType, RequireFields<TMutationRemoveElectionComissionArgs, 'id'>>;
  removeEmployeeTask?: Resolver<TResolversTypes['EmployeeTask'], ParentType, ContextType, RequireFields<TMutationRemoveEmployeeTaskArgs, 'id'>>;
  removeEmployeeWarning?: Resolver<TResolversTypes['WarningByPerson'], ParentType, ContextType, RequireFields<TMutationRemoveEmployeeWarningArgs, 'id' | 'personId'>>;
  removeEnvironmentalReport?: Resolver<TResolversTypes['EnvironmentalReport'], ParentType, ContextType, RequireFields<TMutationRemoveEnvironmentalReportArgs, 'id'>>;
  removeEnvironmentalReportAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveEnvironmentalReportAttachmentArgs, 'id'>>;
  removeEnvironmentalReportBiometry?: Resolver<TResolversTypes['EnvironmentalReportBiometry'], ParentType, ContextType, RequireFields<TMutationRemoveEnvironmentalReportBiometryArgs, 'id'>>;
  removeEquipmentByCostCenter?: Resolver<TResolversTypes['EquipmentByCostCenter'], ParentType, ContextType, RequireFields<TMutationRemoveEquipmentByCostCenterArgs, 'id'>>;
  removeEquipmentByOccupation?: Resolver<TResolversTypes['EquipmentByOccupation'], ParentType, ContextType, RequireFields<TMutationRemoveEquipmentByOccupationArgs, 'id'>>;
  removeExam?: Resolver<TResolversTypes['Exam'], ParentType, ContextType, RequireFields<TMutationRemoveExamArgs, 'id'>>;
  removeExamDiagnosticImage?: Resolver<TResolversTypes['ExamDiagnosticImage'], ParentType, ContextType, RequireFields<TMutationRemoveExamDiagnosticImageArgs, 'id'>>;
  removeExamDiagnosticImageAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveExamDiagnosticImageAttachmentArgs, 'id'>>;
  removeExamNormal?: Resolver<TResolversTypes['ExamNormal'], ParentType, ContextType, RequireFields<TMutationRemoveExamNormalArgs, 'id'>>;
  removeExamOtological?: Resolver<TResolversTypes['ExamOtological'], ParentType, ContextType, RequireFields<TMutationRemoveExamOtologicalArgs, 'id'>>;
  removeExamToxicological?: Resolver<TResolversTypes['ExamToxicological'], ParentType, ContextType, RequireFields<TMutationRemoveExamToxicologicalArgs, 'id'>>;
  removeExpectedGoal?: Resolver<TResolversTypes['ExpectedGoal'], ParentType, ContextType, RequireFields<TMutationRemoveExpectedGoalArgs, 'id'>>;
  removeExpense?: Resolver<TResolversTypes['Expense'], ParentType, ContextType, RequireFields<TMutationRemoveExpenseArgs, 'id'>>;
  removeExposureGroup?: Resolver<TResolversTypes['ExposureGroup'], ParentType, ContextType, RequireFields<TMutationRemoveExposureGroupArgs, 'id'>>;
  removeExposureGroupCostCenter?: Resolver<TResolversTypes['ExposureGroupCostCenter'], ParentType, ContextType, RequireFields<TMutationRemoveExposureGroupCostCenterArgs, 'id'>>;
  removeExposureGroupDepartment?: Resolver<TResolversTypes['ExposureGroupDepartment'], ParentType, ContextType, RequireFields<TMutationRemoveExposureGroupDepartmentArgs, 'id'>>;
  removeExposureGroupOccupation?: Resolver<TResolversTypes['ExposureGroupOccupation'], ParentType, ContextType, RequireFields<TMutationRemoveExposureGroupOccupationArgs, 'id'>>;
  removeExposureGroupPerson?: Resolver<TResolversTypes['ExposureGroupPerson'], ParentType, ContextType, RequireFields<TMutationRemoveExposureGroupPersonArgs, 'id'>>;
  removeExposureGroupTask?: Resolver<TResolversTypes['ExposureGroupTask'], ParentType, ContextType, RequireFields<TMutationRemoveExposureGroupTaskArgs, 'id'>>;
  removeExtinguishingAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveExtinguishingAttachmentArgs, 'id'>>;
  removeExtinguishingInspectionAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveExtinguishingInspectionAttachmentArgs, 'id'>>;
  removeExtinguishingSystem?: Resolver<TResolversTypes['ExtinguishingSystem'], ParentType, ContextType, RequireFields<TMutationRemoveExtinguishingSystemArgs, 'id'>>;
  removeFireBrigade?: Resolver<TResolversTypes['FireBrigade'], ParentType, ContextType, RequireFields<TMutationRemoveFireBrigadeArgs, 'id'>>;
  removeFireBrigadeComponent?: Resolver<TResolversTypes['FireBrigadeComponent'], ParentType, ContextType, RequireFields<TMutationRemoveFireBrigadeComponentArgs, 'id'>>;
  removeFireBrigadeExam?: Resolver<TResolversTypes['FireBrigadeExam'], ParentType, ContextType, RequireFields<TMutationRemoveFireBrigadeExamArgs, 'id'>>;
  removeFireBrigadeMeeting?: Resolver<TResolversTypes['FireBrigadeMeeting'], ParentType, ContextType, RequireFields<TMutationRemoveFireBrigadeMeetingArgs, 'id'>>;
  removeFireBrigadeMeetingAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveFireBrigadeMeetingAttachmentArgs, 'id'>>;
  removeFireBrigadeOccurrence?: Resolver<TResolversTypes['FireBrigadeOccurrence'], ParentType, ContextType, RequireFields<TMutationRemoveFireBrigadeOccurrenceArgs, 'id'>>;
  removeFireBrigadeOccurrenceAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveFireBrigadeOccurrenceAttachmentArgs, 'id'>>;
  removeFireBrigadeTraining?: Resolver<TResolversTypes['FireBrigadeTraining'], ParentType, ContextType, RequireFields<TMutationRemoveFireBrigadeTrainingArgs, 'id'>>;
  removeGeneratingSource?: Resolver<TResolversTypes['GeneratingSource'], ParentType, ContextType, RequireFields<TMutationRemoveGeneratingSourceArgs, 'id'>>;
  removeHealthProgram?: Resolver<TResolversTypes['HealthProgram'], ParentType, ContextType, RequireFields<TMutationRemoveHealthProgramArgs, 'id'>>;
  removeHealthProgramTraining?: Resolver<TResolversTypes['HealthProgramTraining'], ParentType, ContextType, RequireFields<TMutationRemoveHealthProgramTrainingArgs, 'id'>>;
  removeInvestigation?: Resolver<TResolversTypes['Investigation'], ParentType, ContextType, RequireFields<TMutationRemoveInvestigationArgs, 'id'>>;
  removeInvestigationAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveInvestigationAttachmentArgs, 'id'>>;
  removeInvite?: Resolver<TResolversTypes['Invite'], ParentType, ContextType, RequireFields<TMutationRemoveInviteArgs, 'email'>>;
  removeIpeBiometry?: Resolver<TResolversTypes['IpeBiometry'], ParentType, ContextType, RequireFields<TMutationRemoveIpeBiometryArgs, 'id'>>;
  removeIpeDelivery?: Resolver<TResolversTypes['IpeDelivery'], ParentType, ContextType, RequireFields<TMutationRemoveIpeDeliveryArgs, 'id'>>;
  removeIpeDeliveryExtension?: Resolver<TResolversTypes['String'], ParentType, ContextType, RequireFields<TMutationRemoveIpeDeliveryExtensionArgs, 'id'>>;
  removeMandate?: Resolver<TResolversTypes['Mandate'], ParentType, ContextType, RequireFields<TMutationRemoveMandateArgs, 'id'>>;
  removeMandateAction?: Resolver<TResolversTypes['MandateAction'], ParentType, ContextType, RequireFields<TMutationRemoveMandateActionArgs, 'id'>>;
  removeMandateCostCenter?: Resolver<TResolversTypes['MandateCostCenter'], ParentType, ContextType, RequireFields<TMutationRemoveMandateCostCenterArgs, 'id'>>;
  removeMandateDepartment?: Resolver<TResolversTypes['MandateDepartment'], ParentType, ContextType, RequireFields<TMutationRemoveMandateDepartmentArgs, 'id'>>;
  removeMandateTraining?: Resolver<TResolversTypes['MandateTraining'], ParentType, ContextType, RequireFields<TMutationRemoveMandateTrainingArgs, 'id'>>;
  removeMeasuringInstrument?: Resolver<TResolversTypes['MeasuringInstrument'], ParentType, ContextType, RequireFields<TMutationRemoveMeasuringInstrumentArgs, 'id'>>;
  removeMeasuringInstrumentAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveMeasuringInstrumentAttachmentArgs, 'id'>>;
  removeMedicalCertificate?: Resolver<TResolversTypes['MedicalCertificate'], ParentType, ContextType, RequireFields<TMutationRemoveMedicalCertificateArgs, 'id'>>;
  removeMedicalCertificateAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveMedicalCertificateAttachmentArgs, 'id'>>;
  removeMedicalRecord?: Resolver<TResolversTypes['MedicalRecord'], ParentType, ContextType, RequireFields<TMutationRemoveMedicalRecordArgs, 'id'>>;
  removeMedicalRecordAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveMedicalRecordAttachmentArgs, 'id'>>;
  removeMedicalRecordHealthProgram?: Resolver<TResolversTypes['MedicalRecordHealthProgram'], ParentType, ContextType, RequireFields<TMutationRemoveMedicalRecordHealthProgramArgs, 'id'>>;
  removeMedicalRecordVaccine?: Resolver<TResolversTypes['MedicalRecordVaccine'], ParentType, ContextType, RequireFields<TMutationRemoveMedicalRecordVaccineArgs, 'id'>>;
  removeMedicalReferral?: Resolver<TResolversTypes['MedicalReferral'], ParentType, ContextType, RequireFields<TMutationRemoveMedicalReferralArgs, 'id'>>;
  removeMedicalReferralDoctorBiometry?: Resolver<TResolversTypes['MedicalReferralDoctorBiometry'], ParentType, ContextType, RequireFields<TMutationRemoveMedicalReferralDoctorBiometryArgs, 'id'>>;
  removeMedicalRestriction?: Resolver<TResolversTypes['MedicalRestriction'], ParentType, ContextType, RequireFields<TMutationRemoveMedicalRestrictionArgs, 'id'>>;
  removeMedicine?: Resolver<TResolversTypes['Medicine'], ParentType, ContextType, RequireFields<TMutationRemoveMedicineArgs, 'id'>>;
  removeMeeting?: Resolver<TResolversTypes['Meeting'], ParentType, ContextType, RequireFields<TMutationRemoveMeetingArgs, 'id'>>;
  removeMeetingAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveMeetingAttachmentArgs, 'id'>>;
  removeOccupation?: Resolver<TResolversTypes['Occupation'], ParentType, ContextType, RequireFields<TMutationRemoveOccupationArgs, 'id'>>;
  removeOccupationalHealthBiometry?: Resolver<TResolversTypes['OccupationalHealthBiometry'], ParentType, ContextType, RequireFields<TMutationRemoveOccupationalHealthBiometryArgs, 'id'>>;
  removeOccupationalHealthCertificate?: Resolver<TResolversTypes['OccupationalHealthCertificate'], ParentType, ContextType, RequireFields<TMutationRemoveOccupationalHealthCertificateArgs, 'id'>>;
  removeOccupationalHealthCertificateAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveOccupationalHealthCertificateAttachmentArgs, 'id'>>;
  removeOrganization?: Resolver<TResolversTypes['OrganizationWithBranches'], ParentType, ContextType>;
  removeOrthoRater?: Resolver<TResolversTypes['OrthoRater'], ParentType, ContextType, RequireFields<TMutationRemoveOrthoRaterArgs, 'id'>>;
  removeOwnership?: Resolver<TResolversTypes['OrganizationOwnership'], ParentType, ContextType, RequireFields<TMutationRemoveOwnershipArgs, 'fields'>>;
  removePeriodicRange?: Resolver<TResolversTypes['PeriodicRange'], ParentType, ContextType, RequireFields<TMutationRemovePeriodicRangeArgs, 'id'>>;
  removePerson?: Resolver<TResolversTypes['Person'], ParentType, ContextType, RequireFields<TMutationRemovePersonArgs, 'id'>>;
  removePersonAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemovePersonAttachmentArgs, 'id'>>;
  removePhysicalEnvironment?: Resolver<TResolversTypes['PhysicalEnvironment'], ParentType, ContextType, RequireFields<TMutationRemovePhysicalEnvironmentArgs, 'id'>>;
  removePhysicalEnvironmentAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemovePhysicalEnvironmentAttachmentArgs, 'id'>>;
  removePosition?: Resolver<TResolversTypes['Position'], ParentType, ContextType, RequireFields<TMutationRemovePositionArgs, 'id'>>;
  removeProduct?: Resolver<TResolversTypes['Product'], ParentType, ContextType, RequireFields<TMutationRemoveProductArgs, 'id'>>;
  removeProductDelivery?: Resolver<TResolversTypes['ProductDelivery'], ParentType, ContextType, RequireFields<TMutationRemoveProductDeliveryArgs, 'id'>>;
  removeProductIpeManufacturer?: Resolver<TResolversTypes['ProductIpeManufacturer'], ParentType, ContextType, RequireFields<TMutationRemoveProductIpeManufacturerArgs, 'id'>>;
  removeQuiz?: Resolver<TResolversTypes['Quiz'], ParentType, ContextType, RequireFields<TMutationRemoveQuizArgs, 'id'>>;
  removeQuizAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveQuizAttachmentArgs, 'id'>>;
  removeRealGoal?: Resolver<TResolversTypes['RealGoal'], ParentType, ContextType, RequireFields<TMutationRemoveRealGoalArgs, 'id'>>;
  removeRealGoalAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveRealGoalAttachmentArgs, 'id'>>;
  removeReportAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveReportAttachmentArgs, 'id'>>;
  removeReportStructure?: Resolver<TResolversTypes['ReportStructure'], ParentType, ContextType, RequireFields<TMutationRemoveReportStructureArgs, 'id'>>;
  removeResponsibleAction?: Resolver<TResolversTypes['ResponsibleAction'], ParentType, ContextType, RequireFields<TMutationRemoveResponsibleActionArgs, 'id'>>;
  removeResultExamIbmp?: Resolver<TResolversTypes['ResultExamIbmp'], ParentType, ContextType, RequireFields<TMutationRemoveResultExamIbmpArgs, 'id'>>;
  removeRisk?: Resolver<TResolversTypes['Risk'], ParentType, ContextType, RequireFields<TMutationRemoveRiskArgs, 'id'>>;
  removeRiskAgent?: Resolver<TResolversTypes['RiskAgent'], ParentType, ContextType, RequireFields<TMutationRemoveRiskAgentArgs, 'id'>>;
  removeRiskAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveRiskAttachmentArgs, 'id'>>;
  removeRole?: Resolver<TResolversTypes['Role'], ParentType, ContextType, RequireFields<TMutationRemoveRoleArgs, 'userId'>>;
  removeRolePermission?: Resolver<TResolversTypes['RolePermission'], ParentType, ContextType, RequireFields<TMutationRemoveRolePermissionArgs, 'id'>>;
  removeRoles?: Resolver<Array<TResolversTypes['Role']>, ParentType, ContextType, RequireFields<TMutationRemoveRolesArgs, 'userId'>>;
  removeSafetyQuiz?: Resolver<TResolversTypes['SafetyQuiz'], ParentType, ContextType, RequireFields<TMutationRemoveSafetyQuizArgs, 'id'>>;
  removeScheduleRestriction?: Resolver<TResolversTypes['ScheduleRestriction'], ParentType, ContextType, RequireFields<TMutationRemoveScheduleRestrictionArgs, 'id'>>;
  removeService?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType, RequireFields<TMutationRemoveServiceArgs, 'organizationId' | 'type'>>;
  removeSession?: Resolver<TResolversTypes['Session'], ParentType, ContextType, RequireFields<TMutationRemoveSessionArgs, 'token'>>;
  removeSignCredentials?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  removeSimulation?: Resolver<TResolversTypes['Simulation'], ParentType, ContextType, RequireFields<TMutationRemoveSimulationArgs, 'id'>>;
  removeSimulationPlan?: Resolver<TResolversTypes['SimulationPlan'], ParentType, ContextType, RequireFields<TMutationRemoveSimulationPlanArgs, 'id'>>;
  removeSipat?: Resolver<TResolversTypes['Sipat'], ParentType, ContextType, RequireFields<TMutationRemoveSipatArgs, 'id'>>;
  removeSipatAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveSipatAttachmentArgs, 'id'>>;
  removeSnellen?: Resolver<TResolversTypes['Snellen'], ParentType, ContextType, RequireFields<TMutationRemoveSnellenArgs, 'id'>>;
  removeSpareParts?: Resolver<TResolversTypes['SpareParts'], ParentType, ContextType, RequireFields<TMutationRemoveSparePartsArgs, 'id'>>;
  removeStabilityType?: Resolver<TResolversTypes['StabilityType'], ParentType, ContextType, RequireFields<TMutationRemoveStabilityTypeArgs, 'id'>>;
  removeStatementResponsibility?: Resolver<TResolversTypes['StatementResponsibility'], ParentType, ContextType, RequireFields<TMutationRemoveStatementResponsibilityArgs, 'id'>>;
  removeStockLevel?: Resolver<TResolversTypes['StockLevel'], ParentType, ContextType, RequireFields<TMutationRemoveStockLevelArgs, 'id'>>;
  removeSuggestionBox?: Resolver<TResolversTypes['SuggestionBox'], ParentType, ContextType, RequireFields<TMutationRemoveSuggestionBoxArgs, 'id'>>;
  removeTask?: Resolver<TResolversTypes['Task'], ParentType, ContextType, RequireFields<TMutationRemoveTaskArgs, 'id'>>;
  removeTraining?: Resolver<TResolversTypes['Training'], ParentType, ContextType, RequireFields<TMutationRemoveTrainingArgs, 'id'>>;
  removeTrainingAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveTrainingAttachmentArgs, 'id'>>;
  removeTrainingHistory?: Resolver<TResolversTypes['TrainingHistory'], ParentType, ContextType, RequireFields<TMutationRemoveTrainingHistoryArgs, 'id'>>;
  removeTrainingHistoryAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveTrainingHistoryAttachmentArgs, 'id'>>;
  removeTrialOrganizationUser?: Resolver<TResolversTypes['User'], ParentType, ContextType, RequireFields<TMutationRemoveTrialOrganizationUserArgs, 'userId'>>;
  removeUnityOfMeasure?: Resolver<TResolversTypes['UnityOfMeasure'], ParentType, ContextType, RequireFields<TMutationRemoveUnityOfMeasureArgs, 'id'>>;
  removeUrinalysis?: Resolver<TResolversTypes['Urinalysis'], ParentType, ContextType, RequireFields<TMutationRemoveUrinalysisArgs, 'id'>>;
  removeUserSpecialty?: Resolver<TResolversTypes['UserSpecialty'], ParentType, ContextType, RequireFields<TMutationRemoveUserSpecialtyArgs, 'id'>>;
  removeVaccine?: Resolver<TResolversTypes['Vaccine'], ParentType, ContextType, RequireFields<TMutationRemoveVaccineArgs, 'id'>>;
  removeWarehouse?: Resolver<TResolversTypes['Warehouse'], ParentType, ContextType, RequireFields<TMutationRemoveWarehouseArgs, 'id'>>;
  removeWarningAttachment?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRemoveWarningAttachmentArgs, 'id'>>;
  removeWebhook?: Resolver<TResolversTypes['Webhook'], ParentType, ContextType, RequireFields<TMutationRemoveWebhookArgs, 'id'>>;
  removeWebhookQueue?: Resolver<TResolversTypes['WebhookQueue'], ParentType, ContextType, RequireFields<TMutationRemoveWebhookQueueArgs, 'id'>>;
  removeWorkPermission?: Resolver<TResolversTypes['WorkPermission'], ParentType, ContextType, RequireFields<TMutationRemoveWorkPermissionArgs, 'id'>>;
  removeWorkShift?: Resolver<TResolversTypes['WorkShift'], ParentType, ContextType, RequireFields<TMutationRemoveWorkShiftArgs, 'id'>>;
  replacementIpeDelivery?: Resolver<Array<TResolversTypes['IpeDelivery']>, ParentType, ContextType, RequireFields<TMutationReplacementIpeDeliveryArgs, 'ipeDeliveryInput' | 'ipeDeliveryUpdate'>>;
  replacementProductDelivery?: Resolver<Array<TResolversTypes['ProductDelivery']>, ParentType, ContextType, RequireFields<TMutationReplacementProductDeliveryArgs, 'productDeliveryInput' | 'productDeliveryUpdate'>>;
  reprocessTtalkInboundEvent?: Resolver<TResolversTypes['TtalkInboundEvent'], ParentType, ContextType, RequireFields<TMutationReprocessTtalkInboundEventArgs, 'id'>>;
  requestAuditLogExport?: Resolver<TResolversTypes['AuditLogExportRequest'], ParentType, ContextType, RequireFields<TMutationRequestAuditLogExportArgs, 'format' | 'query'>>;
  requestMapUrl?: Resolver<TResolversTypes['MapUpload'], ParentType, ContextType, RequireFields<TMutationRequestMapUrlArgs, 'attachment'>>;
  requestPasswordReset?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationRequestPasswordResetArgs, 'email'>>;
  resendBatch?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationResendBatchArgs, 'dates'>>;
  resendInvite?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationResendInviteArgs, 'email'>>;
  resendInviteVerification?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationResendInviteVerificationArgs, 'email'>>;
  resendQueue?: Resolver<TResolversTypes['ESocialQueue'], ParentType, ContextType, RequireFields<TMutationResendQueueArgs, 'id'>>;
  resendUserEmailVerification?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationResendUserEmailVerificationArgs, 'email'>>;
  resendWebhookEvent?: Resolver<TResolversTypes['WebhookQueue'], ParentType, ContextType, RequireFields<TMutationResendWebhookEventArgs, 'id'>>;
  resetCustomDocumentToDefault?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationResetCustomDocumentToDefaultArgs, 'type'>>;
  resetPassword?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationResetPasswordArgs, 'confirmationCode' | 'email' | 'password'>>;
  resolveRiskSync?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationResolveRiskSyncArgs, 'branchId' | 'organizationId'>>;
  retryTTalkQueue?: Resolver<TResolversTypes['TTalkQueue'], ParentType, ContextType, RequireFields<TMutationRetryTTalkQueueArgs, 'id'>>;
  retryTTalkQueueBatch?: Resolver<TResolversTypes['Float'], ParentType, ContextType, RequireFields<TMutationRetryTTalkQueueBatchArgs, 'ids'>>;
  saveEnvironmentalReportVersion?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationSaveEnvironmentalReportVersionArgs, 'input'>>;
  saveOHCDoctorFace?: Resolver<TResolversTypes['OccupationalHealthFace'], ParentType, ContextType, RequireFields<TMutationSaveOhcDoctorFaceArgs, 'face' | 'id'>>;
  saveOHCFace?: Resolver<TResolversTypes['OccupationalHealthFace'], ParentType, ContextType, RequireFields<TMutationSaveOhcFaceArgs, 'face' | 'id'>>;
  saveRiskComposition?: Resolver<Array<TResolversTypes['RiskComposition']>, ParentType, ContextType, RequireFields<TMutationSaveRiskCompositionArgs, 'compositions'>>;
  scheduleExpectedConsultations?: Resolver<Array<TResolversTypes['Consultation']>, ParentType, ContextType, RequireFields<TMutationScheduleExpectedConsultationsArgs, 'input'>>;
  sendFirstESocialLoad?: Resolver<TResolversTypes['Branch'], ParentType, ContextType, RequireFields<TMutationSendFirstESocialLoadArgs, 'branch'>>;
  sendLoadByPeriod?: Resolver<TResolversTypes['Branch'], ParentType, ContextType, RequireFields<TMutationSendLoadByPeriodArgs, 'branch' | 'endDate' | 'startDate'>>;
  sendPendingMessages?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, Partial<TMutationSendPendingMessagesArgs>>;
  setBranchLogo?: Resolver<TResolversTypes['String'], ParentType, ContextType, RequireFields<TMutationSetBranchLogoArgs, 'branchId' | 'contentLength' | 'contentType'>>;
  setBranches?: Resolver<Array<TResolversTypes['Role']>, ParentType, ContextType, RequireFields<TMutationSetBranchesArgs, 'branches' | 'userId'>>;
  setEmployeeProfilePicture?: Resolver<TResolversTypes['String'], ParentType, ContextType, RequireFields<TMutationSetEmployeeProfilePictureArgs, 'contentLength' | 'contentType'>>;
  setOrganizationPicture?: Resolver<TResolversTypes['String'], ParentType, ContextType, RequireFields<TMutationSetOrganizationPictureArgs, 'contentLength' | 'contentType'>>;
  setSendNotify?: Resolver<TResolversTypes['CustomOrganization'], ParentType, ContextType, RequireFields<TMutationSetSendNotifyArgs, 'enabled'>>;
  setUserProfilePicture?: Resolver<TResolversTypes['String'], ParentType, ContextType, RequireFields<TMutationSetUserProfilePictureArgs, 'contentLength' | 'contentType'>>;
  socResendQueue?: Resolver<Maybe<TResolversTypes['QueueDTO']>, ParentType, ContextType, RequireFields<TMutationSocResendQueueArgs, 'queueId'>>;
  socRunSync?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationSocRunSyncArgs, 'syncId'>>;
  subscriptionLevelDiscount?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationSubscriptionLevelDiscountArgs, 'discounts'>>;
  syncAllOrganization?: Resolver<TResolversTypes['BulkSyncRun'], ParentType, ContextType, RequireFields<TMutationSyncAllOrganizationArgs, 'organizationId'>>;
  syncByOrganization?: Resolver<Array<TResolversTypes['CronTab']>, ParentType, ContextType, RequireFields<TMutationSyncByOrganizationArgs, 'businessEntity'>>;
  syncCron?: Resolver<TResolversTypes['CronTab'], ParentType, ContextType, RequireFields<TMutationSyncCronArgs, 'branchId' | 'businessEntity'>>;
  syncMessage?: Resolver<TResolversTypes['ESocialQueue'], ParentType, ContextType, RequireFields<TMutationSyncMessageArgs, 'id'>>;
  syncMessages?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, Partial<TMutationSyncMessagesArgs>>;
  syncStockLevels?: Resolver<Array<TResolversTypes['StockLevelSyncResult']>, ParentType, ContextType, RequireFields<TMutationSyncStockLevelsArgs, 'productIds'>>;
  transferConsultations?: Resolver<TResolversTypes['TransferConsultationsResult'], ParentType, ContextType, RequireFields<TMutationTransferConsultationsArgs, 'input'>>;
  unblockRole?: Resolver<TResolversTypes['Role'], ParentType, ContextType, RequireFields<TMutationUnblockRoleArgs, 'userId'>>;
  unblockRoles?: Resolver<Array<TResolversTypes['Role']>, ParentType, ContextType, RequireFields<TMutationUnblockRolesArgs, 'userId'>>;
  unsetBranchLogo?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationUnsetBranchLogoArgs, 'branchId'>>;
  unsetEmployeeProfilePicture?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  unsetOrganizationPicture?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  unsetUserProfilePicture?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  updateAbsenceType?: Resolver<TResolversTypes['AbsenceType'], ParentType, ContextType, RequireFields<TMutationUpdateAbsenceTypeArgs, 'absenceType'>>;
  updateAccident?: Resolver<TResolversTypes['Accident'], ParentType, ContextType, RequireFields<TMutationUpdateAccidentArgs, 'accident'>>;
  updateAccidentCause?: Resolver<TResolversTypes['AccidentCause'], ParentType, ContextType, RequireFields<TMutationUpdateAccidentCauseArgs, 'accidentCause'>>;
  updateAccredited?: Resolver<TResolversTypes['Accredited'], ParentType, ContextType, RequireFields<TMutationUpdateAccreditedArgs, 'accredited'>>;
  updateAccreditedAsServiceProvider?: Resolver<TResolversTypes['Accredited'], ParentType, ContextType, RequireFields<TMutationUpdateAccreditedAsServiceProviderArgs, 'accredited'>>;
  updateActionPlan?: Resolver<TResolversTypes['ActionPlan'], ParentType, ContextType, RequireFields<TMutationUpdateActionPlanArgs, 'actionPlan'>>;
  updateActionPlanMicroAction?: Resolver<TResolversTypes['ActionPlanMicroAction'], ParentType, ContextType, RequireFields<TMutationUpdateActionPlanMicroActionArgs, 'actionPlanMicroAction'>>;
  updateAllowanceType?: Resolver<TResolversTypes['AllowanceType'], ParentType, ContextType, RequireFields<TMutationUpdateAllowanceTypeArgs, 'allowanceType'>>;
  updateBiologicalMonitoring?: Resolver<TResolversTypes['Accident'], ParentType, ContextType, RequireFields<TMutationUpdateBiologicalMonitoringArgs, 'biologicalMonitoring'>>;
  updateBiologicalMonitoringExamGroup?: Resolver<TResolversTypes['BiologicalMonitoringExamGroup'], ParentType, ContextType, RequireFields<TMutationUpdateBiologicalMonitoringExamGroupArgs, 'biologicalMonitoringExamGroup'>>;
  updateBiometry?: Resolver<Array<TResolversTypes['Biometry']>, ParentType, ContextType, RequireFields<TMutationUpdateBiometryArgs, 'biometry' | 'personId'>>;
  updateBranch?: Resolver<TResolversTypes['Branch'], ParentType, ContextType, RequireFields<TMutationUpdateBranchArgs, 'fields'>>;
  updateCalendar?: Resolver<TResolversTypes['Calendar'], ParentType, ContextType, RequireFields<TMutationUpdateCalendarArgs, 'fields'>>;
  updateCandidate?: Resolver<TResolversTypes['Candidate'], ParentType, ContextType, RequireFields<TMutationUpdateCandidateArgs, 'candidate'>>;
  updateClinicalQuiz?: Resolver<TResolversTypes['ClinicalQuiz'], ParentType, ContextType, RequireFields<TMutationUpdateClinicalQuizArgs, 'quiz'>>;
  updateComponent?: Resolver<TResolversTypes['Component'], ParentType, ContextType, RequireFields<TMutationUpdateComponentArgs, 'component'>>;
  updateConsultation?: Resolver<TResolversTypes['Consultation'], ParentType, ContextType, RequireFields<TMutationUpdateConsultationArgs, 'consultation'>>;
  updateControlMeasure?: Resolver<TResolversTypes['ControlMeasure'], ParentType, ContextType, RequireFields<TMutationUpdateControlMeasureArgs, 'controlMeasure'>>;
  updateCostCenter?: Resolver<TResolversTypes['CostCenter'], ParentType, ContextType, RequireFields<TMutationUpdateCostCenterArgs, 'costCenter'>>;
  updateCronTab?: Resolver<TResolversTypes['CronTab'], ParentType, ContextType, RequireFields<TMutationUpdateCronTabArgs, 'cron'>>;
  updateCustomDocument?: Resolver<TResolversTypes['CustomDocument'], ParentType, ContextType, RequireFields<TMutationUpdateCustomDocumentArgs, 'id' | 'input'>>;
  updateCustomer?: Resolver<TResolversTypes['Customer'], ParentType, ContextType, RequireFields<TMutationUpdateCustomerArgs, 'customer'>>;
  updateDeficiency?: Resolver<TResolversTypes['Deficiency'], ParentType, ContextType, RequireFields<TMutationUpdateDeficiencyArgs, 'deficiency'>>;
  updateDeliverySpareParts?: Resolver<TResolversTypes['DeliverySpareParts'], ParentType, ContextType, RequireFields<TMutationUpdateDeliverySparePartsArgs, 'sparePart'>>;
  updateDeliveryStatusJob?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  updateDepartment?: Resolver<TResolversTypes['Department'], ParentType, ContextType, RequireFields<TMutationUpdateDepartmentArgs, 'department'>>;
  updateDiagnostic?: Resolver<TResolversTypes['Diagnostic'], ParentType, ContextType, RequireFields<TMutationUpdateDiagnosticArgs, 'diagnostic' | 'medicalRecordId'>>;
  updateEmployeeNickname?: Resolver<TResolversTypes['Employee'], ParentType, ContextType, RequireFields<TMutationUpdateEmployeeNicknameArgs, 'data'>>;
  updateEmployeePreferences?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationUpdateEmployeePreferencesArgs, 'preferences'>>;
  updateEmployeeTask?: Resolver<TResolversTypes['EmployeeTask'], ParentType, ContextType, RequireFields<TMutationUpdateEmployeeTaskArgs, 'employeeTask'>>;
  updateEmployeeWarning?: Resolver<TResolversTypes['WarningByPerson'], ParentType, ContextType, RequireFields<TMutationUpdateEmployeeWarningArgs, 'employeeWarning'>>;
  updateEndpoint?: Resolver<Array<TResolversTypes['Endpoint']>, ParentType, ContextType, RequireFields<TMutationUpdateEndpointArgs, 'endpoints'>>;
  updateEnvironmentalReport?: Resolver<TResolversTypes['EnvironmentalReport'], ParentType, ContextType, RequireFields<TMutationUpdateEnvironmentalReportArgs, 'environmentalReport'>>;
  updateExam?: Resolver<TResolversTypes['Exam'], ParentType, ContextType, RequireFields<TMutationUpdateExamArgs, 'exam'>>;
  updateExamAudiometry?: Resolver<TResolversTypes['ExamAudiometry'], ParentType, ContextType, RequireFields<TMutationUpdateExamAudiometryArgs, 'examAudiometry'>>;
  updateExamDiagnosticImage?: Resolver<TResolversTypes['ExamDiagnosticImage'], ParentType, ContextType, RequireFields<TMutationUpdateExamDiagnosticImageArgs, 'examDiagnosticImage'>>;
  updateExamItem?: Resolver<TResolversTypes['ExamItem'], ParentType, ContextType, RequireFields<TMutationUpdateExamItemArgs, 'examItem'>>;
  updateExamNormal?: Resolver<TResolversTypes['ExamNormal'], ParentType, ContextType, RequireFields<TMutationUpdateExamNormalArgs, 'examNormal'>>;
  updateExamOtological?: Resolver<TResolversTypes['ExamOtological'], ParentType, ContextType, RequireFields<TMutationUpdateExamOtologicalArgs, 'examOtological'>>;
  updateExamSpirometry?: Resolver<TResolversTypes['ExamSpirometry'], ParentType, ContextType, RequireFields<TMutationUpdateExamSpirometryArgs, 'examSpirometry'>>;
  updateExamToxicological?: Resolver<TResolversTypes['ExamToxicological'], ParentType, ContextType, RequireFields<TMutationUpdateExamToxicologicalArgs, 'examToxicological'>>;
  updateExpense?: Resolver<TResolversTypes['Expense'], ParentType, ContextType, RequireFields<TMutationUpdateExpenseArgs, 'expense'>>;
  updateExposureGroup?: Resolver<TResolversTypes['ExposureGroup'], ParentType, ContextType, RequireFields<TMutationUpdateExposureGroupArgs, 'exposureGroup'>>;
  updateExposureGroupCostCenter?: Resolver<TResolversTypes['ExposureGroupCostCenter'], ParentType, ContextType, RequireFields<TMutationUpdateExposureGroupCostCenterArgs, 'exposureGroupCostCenter'>>;
  updateExposureGroupDepartment?: Resolver<TResolversTypes['ExposureGroupDepartment'], ParentType, ContextType, RequireFields<TMutationUpdateExposureGroupDepartmentArgs, 'exposureGroupDepartment'>>;
  updateExposureGroupOccupation?: Resolver<TResolversTypes['ExposureGroupOccupation'], ParentType, ContextType, RequireFields<TMutationUpdateExposureGroupOccupationArgs, 'exposureGroupOccupation'>>;
  updateExposureGroupPerson?: Resolver<TResolversTypes['ExposureGroupPerson'], ParentType, ContextType, RequireFields<TMutationUpdateExposureGroupPersonArgs, 'exposureGroupPerson'>>;
  updateExposureGroupTask?: Resolver<TResolversTypes['ExposureGroupTask'], ParentType, ContextType, RequireFields<TMutationUpdateExposureGroupTaskArgs, 'exposureGroupTask'>>;
  updateExternalOccupationalHealthCertificate?: Resolver<TResolversTypes['ExternalOccupationalHealthCertificate'], ParentType, ContextType, RequireFields<TMutationUpdateExternalOccupationalHealthCertificateArgs, 'occupationalHealthCertificate'>>;
  updateExtinguishingSystem?: Resolver<TResolversTypes['ExtinguishingSystem'], ParentType, ContextType, RequireFields<TMutationUpdateExtinguishingSystemArgs, 'extinguishingSystem'>>;
  updateFeatureFlag?: Resolver<TResolversTypes['Flag'], ParentType, ContextType, RequireFields<TMutationUpdateFeatureFlagArgs, 'features' | 'flag' | 'priority'>>;
  updateFeatureVersion?: Resolver<TResolversTypes['FeatureVersionReturn'], ParentType, ContextType, RequireFields<TMutationUpdateFeatureVersionArgs, 'feature' | 'flag' | 'version'>>;
  updateFireBrigade?: Resolver<TResolversTypes['FireBrigade'], ParentType, ContextType, RequireFields<TMutationUpdateFireBrigadeArgs, 'fireBrigade'>>;
  updateFireBrigadeComponent?: Resolver<TResolversTypes['FireBrigadeComponent'], ParentType, ContextType, RequireFields<TMutationUpdateFireBrigadeComponentArgs, 'fireBrigadeComponent'>>;
  updateFireBrigadeExam?: Resolver<TResolversTypes['FireBrigadeExam'], ParentType, ContextType, RequireFields<TMutationUpdateFireBrigadeExamArgs, 'fireBrigadeExam'>>;
  updateFireBrigadeMeeting?: Resolver<TResolversTypes['FireBrigadeMeeting'], ParentType, ContextType, RequireFields<TMutationUpdateFireBrigadeMeetingArgs, 'fireBrigadeMeeting'>>;
  updateFireBrigadeOccurrence?: Resolver<TResolversTypes['FireBrigadeOccurrence'], ParentType, ContextType, RequireFields<TMutationUpdateFireBrigadeOccurrenceArgs, 'fireBrigadeOccurrence'>>;
  updateGeneratingSource?: Resolver<TResolversTypes['GeneratingSource'], ParentType, ContextType, RequireFields<TMutationUpdateGeneratingSourceArgs, 'generatingSource'>>;
  updateHealthProgram?: Resolver<TResolversTypes['HealthProgram'], ParentType, ContextType, RequireFields<TMutationUpdateHealthProgramArgs, 'healthProgram'>>;
  updateIntegrationConfigOption?: Resolver<TResolversTypes['IntegrationConfiguration'], ParentType, ContextType, RequireFields<TMutationUpdateIntegrationConfigOptionArgs, 'integrationId' | 'option'>>;
  updateInvestigation?: Resolver<TResolversTypes['Investigation'], ParentType, ContextType, RequireFields<TMutationUpdateInvestigationArgs, 'investigation'>>;
  updateIpeDelivery?: Resolver<TResolversTypes['IpeDelivery'], ParentType, ContextType, RequireFields<TMutationUpdateIpeDeliveryArgs, 'ipeDelivery'>>;
  updateMandate?: Resolver<TResolversTypes['Mandate'], ParentType, ContextType, RequireFields<TMutationUpdateMandateArgs, 'mandate'>>;
  updateMandateEvent?: Resolver<TResolversTypes['MandateEvent'], ParentType, ContextType, RequireFields<TMutationUpdateMandateEventArgs, 'mandateEvent'>>;
  updateMandateTraining?: Resolver<TResolversTypes['MandateTraining'], ParentType, ContextType, RequireFields<TMutationUpdateMandateTrainingArgs, 'mandateTraining'>>;
  updateMeasuringInstrument?: Resolver<TResolversTypes['MeasuringInstrument'], ParentType, ContextType, RequireFields<TMutationUpdateMeasuringInstrumentArgs, 'measuringInstrument'>>;
  updateMedicalCertificate?: Resolver<TResolversTypes['MedicalCertificate'], ParentType, ContextType, RequireFields<TMutationUpdateMedicalCertificateArgs, 'medicalCertificate'>>;
  updateMedicalRecord?: Resolver<TResolversTypes['MedicalRecord'], ParentType, ContextType, RequireFields<TMutationUpdateMedicalRecordArgs, 'medicalRecord'>>;
  updateMedicalRecordHealthProgram?: Resolver<TResolversTypes['MedicalRecordHealthProgram'], ParentType, ContextType, RequireFields<TMutationUpdateMedicalRecordHealthProgramArgs, 'medicalRecordHealthProgram'>>;
  updateMedicalRecordVaccine?: Resolver<TResolversTypes['MedicalRecordVaccine'], ParentType, ContextType, RequireFields<TMutationUpdateMedicalRecordVaccineArgs, 'medicalRecordVaccine'>>;
  updateMedicalReferral?: Resolver<TResolversTypes['MedicalReferral'], ParentType, ContextType, RequireFields<TMutationUpdateMedicalReferralArgs, 'medicalReferral'>>;
  updateMedicalRestriction?: Resolver<TResolversTypes['MedicalRestriction'], ParentType, ContextType, RequireFields<TMutationUpdateMedicalRestrictionArgs, 'medicalRestriction'>>;
  updateMedicine?: Resolver<TResolversTypes['Medicine'], ParentType, ContextType, RequireFields<TMutationUpdateMedicineArgs, 'medicine'>>;
  updateMeeting?: Resolver<TResolversTypes['Meeting'], ParentType, ContextType, RequireFields<TMutationUpdateMeetingArgs, 'meeting'>>;
  updateOccupation?: Resolver<TResolversTypes['Occupation'], ParentType, ContextType, RequireFields<TMutationUpdateOccupationArgs, 'occupation'>>;
  updateOccupationalHealthCertificate?: Resolver<TResolversTypes['OccupationalHealthCertificate'], ParentType, ContextType, RequireFields<TMutationUpdateOccupationalHealthCertificateArgs, 'occupationalHealthCertificate'>>;
  updateOrganization?: Resolver<TResolversTypes['OrganizationWithBranches'], ParentType, ContextType, RequireFields<TMutationUpdateOrganizationArgs, 'fields'>>;
  updateOrganizationFlag?: Resolver<TResolversTypes['BaseFlagReturn'], ParentType, ContextType, RequireFields<TMutationUpdateOrganizationFlagArgs, 'flag' | 'organizationId'>>;
  updateOrthoRater?: Resolver<TResolversTypes['OrthoRater'], ParentType, ContextType, RequireFields<TMutationUpdateOrthoRaterArgs, 'orthoRater'>>;
  updatePeriodicRange?: Resolver<TResolversTypes['PeriodicRange'], ParentType, ContextType, RequireFields<TMutationUpdatePeriodicRangeArgs, 'fields'>>;
  updatePerson?: Resolver<TResolversTypes['Person'], ParentType, ContextType, RequireFields<TMutationUpdatePersonArgs, 'person'>>;
  updatePhysicalEnvironment?: Resolver<TResolversTypes['PhysicalEnvironment'], ParentType, ContextType, RequireFields<TMutationUpdatePhysicalEnvironmentArgs, 'physicalEnvironment'>>;
  updatePosition?: Resolver<TResolversTypes['Position'], ParentType, ContextType, RequireFields<TMutationUpdatePositionArgs, 'position'>>;
  updatePreferences?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TMutationUpdatePreferencesArgs, 'preferences'>>;
  updateProduct?: Resolver<TResolversTypes['Product'], ParentType, ContextType, RequireFields<TMutationUpdateProductArgs, 'product'>>;
  updateProductDelivery?: Resolver<TResolversTypes['ProductDelivery'], ParentType, ContextType, RequireFields<TMutationUpdateProductDeliveryArgs, 'productDelivery'>>;
  updateProductIpeManufacturer?: Resolver<TResolversTypes['ProductIpeManufacturer'], ParentType, ContextType, RequireFields<TMutationUpdateProductIpeManufacturerArgs, 'productIpeManufacturer'>>;
  updateQueue?: Resolver<TResolversTypes['ESocialQueue'], ParentType, ContextType, RequireFields<TMutationUpdateQueueArgs, 'queue'>>;
  updateQuiz?: Resolver<TResolversTypes['Quiz'], ParentType, ContextType, RequireFields<TMutationUpdateQuizArgs, 'quiz'>>;
  updateReportSection?: Resolver<TResolversTypes['ReportSection'], ParentType, ContextType, RequireFields<TMutationUpdateReportSectionArgs, 'reportSection'>>;
  updateReportStructure?: Resolver<TResolversTypes['ReportStructure'], ParentType, ContextType, RequireFields<TMutationUpdateReportStructureArgs, 'reportStructure'>>;
  updateResultExamIbmp?: Resolver<TResolversTypes['ResultExamIbmp'], ParentType, ContextType, RequireFields<TMutationUpdateResultExamIbmpArgs, 'examIbmp'>>;
  updateRisk?: Resolver<TResolversTypes['Risk'], ParentType, ContextType, RequireFields<TMutationUpdateRiskArgs, 'risk'>>;
  updateRiskAgent?: Resolver<TResolversTypes['RiskAgent'], ParentType, ContextType, RequireFields<TMutationUpdateRiskAgentArgs, 'riskAgent'>>;
  updateRisks?: Resolver<Array<TResolversTypes['Risk']>, ParentType, ContextType, RequireFields<TMutationUpdateRisksArgs, 'risks'>>;
  updateRole?: Resolver<TResolversTypes['Role'], ParentType, ContextType, RequireFields<TMutationUpdateRoleArgs, 'update'>>;
  updateRolePermission?: Resolver<TResolversTypes['RolePermission'], ParentType, ContextType, RequireFields<TMutationUpdateRolePermissionArgs, 'rolePermission'>>;
  updateRoles?: Resolver<Array<TResolversTypes['Role']>, ParentType, ContextType, RequireFields<TMutationUpdateRolesArgs, 'update'>>;
  updateSafetyQuiz?: Resolver<TResolversTypes['SafetyQuiz'], ParentType, ContextType, RequireFields<TMutationUpdateSafetyQuizArgs, 'quiz'>>;
  updateScheduleRestriction?: Resolver<TResolversTypes['ScheduleRestriction'], ParentType, ContextType, RequireFields<TMutationUpdateScheduleRestrictionArgs, 'scheduleRestriction'>>;
  updateSchedulingSettings?: Resolver<TResolversTypes['SchedulingSettings'], ParentType, ContextType, Partial<TMutationUpdateSchedulingSettingsArgs>>;
  updateSignCredentials?: Resolver<TResolversTypes['SignCredentialsOutput'], ParentType, ContextType, RequireFields<TMutationUpdateSignCredentialsArgs, 'input'>>;
  updateSilenceThreshold?: Resolver<TResolversTypes['TtalkInboundSilenceThreshold'], ParentType, ContextType, RequireFields<TMutationUpdateSilenceThresholdArgs, 'input'>>;
  updateSimulation?: Resolver<TResolversTypes['Simulation'], ParentType, ContextType, RequireFields<TMutationUpdateSimulationArgs, 'simulation'>>;
  updateSimulationPlan?: Resolver<TResolversTypes['SimulationPlan'], ParentType, ContextType, RequireFields<TMutationUpdateSimulationPlanArgs, 'simulationPlan'>>;
  updateSipat?: Resolver<TResolversTypes['Sipat'], ParentType, ContextType, RequireFields<TMutationUpdateSipatArgs, 'sipat'>>;
  updateSnellen?: Resolver<TResolversTypes['Snellen'], ParentType, ContextType, RequireFields<TMutationUpdateSnellenArgs, 'snellen'>>;
  updateSpareParts?: Resolver<TResolversTypes['SpareParts'], ParentType, ContextType, RequireFields<TMutationUpdateSparePartsArgs, 'sparePart'>>;
  updateStabilityType?: Resolver<TResolversTypes['StabilityType'], ParentType, ContextType, RequireFields<TMutationUpdateStabilityTypeArgs, 'StabilityType'>>;
  updateStatementResponsibility?: Resolver<TResolversTypes['StatementResponsibility'], ParentType, ContextType, RequireFields<TMutationUpdateStatementResponsibilityArgs, 'statement'>>;
  updateStockLevel?: Resolver<TResolversTypes['StockLevel'], ParentType, ContextType, RequireFields<TMutationUpdateStockLevelArgs, 'stockLevel'>>;
  updateSuggestionBox?: Resolver<TResolversTypes['SuggestionBox'], ParentType, ContextType, RequireFields<TMutationUpdateSuggestionBoxArgs, 'suggestionBox'>>;
  updateTask?: Resolver<TResolversTypes['Task'], ParentType, ContextType, RequireFields<TMutationUpdateTaskArgs, 'task'>>;
  updateTraining?: Resolver<TResolversTypes['Training'], ParentType, ContextType, RequireFields<TMutationUpdateTrainingArgs, 'training'>>;
  updateTrainingHistory?: Resolver<TResolversTypes['TrainingHistory'], ParentType, ContextType, RequireFields<TMutationUpdateTrainingHistoryArgs, 'input'>>;
  updateUnityOfMeasure?: Resolver<TResolversTypes['UnityOfMeasure'], ParentType, ContextType, RequireFields<TMutationUpdateUnityOfMeasureArgs, 'unityOfMeasure'>>;
  updateUrinalysis?: Resolver<TResolversTypes['Urinalysis'], ParentType, ContextType, RequireFields<TMutationUpdateUrinalysisArgs, 'urinalysis'>>;
  updateUser?: Resolver<TResolversTypes['UserBasicInfo'], ParentType, ContextType, RequireFields<TMutationUpdateUserArgs, 'fields'>>;
  updateUserFlag?: Resolver<TResolversTypes['BaseFlagReturn'], ParentType, ContextType, RequireFields<TMutationUpdateUserFlagArgs, 'flag' | 'userId'>>;
  updateUserRoleMdt?: Resolver<Array<TResolversTypes['UserRoleMdt']>, ParentType, ContextType, RequireFields<TMutationUpdateUserRoleMdtArgs, 'roles' | 'userId'>>;
  updateUserSpecialty?: Resolver<TResolversTypes['UserSpecialty'], ParentType, ContextType, RequireFields<TMutationUpdateUserSpecialtyArgs, 'userSpecialty'>>;
  updateVaccine?: Resolver<TResolversTypes['Vaccine'], ParentType, ContextType, RequireFields<TMutationUpdateVaccineArgs, 'vaccine'>>;
  updateWarehouse?: Resolver<TResolversTypes['Warehouse'], ParentType, ContextType, RequireFields<TMutationUpdateWarehouseArgs, 'warehouse'>>;
  updateWebhook?: Resolver<TResolversTypes['Webhook'], ParentType, ContextType, RequireFields<TMutationUpdateWebhookArgs, 'webhook'>>;
  updateWebhookQueue?: Resolver<TResolversTypes['WebhookQueue'], ParentType, ContextType, RequireFields<TMutationUpdateWebhookQueueArgs, 'webhookQueue'>>;
  updateWorkPermission?: Resolver<TResolversTypes['WorkPermission'], ParentType, ContextType, RequireFields<TMutationUpdateWorkPermissionArgs, 'workPermission'>>;
  updateWorkShift?: Resolver<TResolversTypes['WorkShift'], ParentType, ContextType, RequireFields<TMutationUpdateWorkShiftArgs, 'workShift'>>;
  uploadEnvironmentalReportContent?: Resolver<TResolversTypes['EnvironmentalReport'], ParentType, ContextType, RequireFields<TMutationUploadEnvironmentalReportContentArgs, 'attachment' | 'environmentalReportId'>>;
  upsertFilterPreference?: Resolver<TResolversTypes['UserFilterPreferenceResult'], ParentType, ContextType, RequireFields<TMutationUpsertFilterPreferenceArgs, 'filtersJson' | 'module'>>;
  upsertNotificationConfig?: Resolver<TResolversTypes['NotificationConfigDto'], ParentType, ContextType, RequireFields<TMutationUpsertNotificationConfigArgs, 'input'>>;
  validateIpeDelivery?: Resolver<Array<TResolversTypes['IpeDelivery']>, ParentType, ContextType, RequireFields<TMutationValidateIpeDeliveryArgs, 'biometry'>>;
  validateIpeFace?: Resolver<Array<TResolversTypes['IpeDeliveryFace']>, ParentType, ContextType, RequireFields<TMutationValidateIpeFaceArgs, 'face'>>;
  validateMedicalRecordVaccineBiometry?: Resolver<TResolversTypes['VaccineBiometry'], ParentType, ContextType, RequireFields<TMutationValidateMedicalRecordVaccineBiometryArgs, 'biometry' | 'id'>>;
  validateOHCertificateBiometry?: Resolver<TResolversTypes['OccupationalHealthBiometry'], ParentType, ContextType, RequireFields<TMutationValidateOhCertificateBiometryArgs, 'biometry' | 'id'>>;
  verifyUser?: Resolver<TResolversTypes['UserBasicInfo'], ParentType, ContextType, RequireFields<TMutationVerifyUserArgs, 'user'>>;
}>;

export type TNoiseRiskResolvers<ContextType = any, ParentType extends TResolversParentTypes['NoiseRisk'] = TResolversParentTypes['NoiseRisk']> = ResolversObject<{
  actionLevelTN0?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  amountTN0?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  descriptionCTT?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  descriptionSRJ?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  exposureTimeTN0?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  nameTN7?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TNotificationResolvers<ContextType = any, ParentType extends TResolversParentTypes['Notification'] = TResolversParentTypes['Notification']> = ResolversObject<{
  appId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  tags?: Resolver<TResolversTypes['NotificationTags'], ParentType, ContextType>;
}>;

export type TNotificationConfigDtoResolvers<ContextType = any, ParentType extends TResolversParentTypes['NotificationConfigDto'] = TResolversParentTypes['NotificationConfigDto']> = ResolversObject<{
  additionalRoles?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  defaultRoles?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  enabled?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  excludedRecipients?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  excludedRoles?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  module?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  periodicityDays?: Resolver<Array<TResolversTypes['Int']>, ParentType, ContextType>;
  recipients?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  templateName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TNotificationTagsResolvers<ContextType = any, ParentType extends TResolversParentTypes['NotificationTags'] = TResolversParentTypes['NotificationTags']> = ResolversObject<{
  branchId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  doctor?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  engineer?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  humanresource?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  nourse?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  nurse?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  organizationId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  personId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  secretary?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  storekeeper?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  technician?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TNtepDistributionChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['NtepDistributionChart'] = TResolversParentTypes['NtepDistributionChart']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['NtepPieEntry']>, ParentType, ContextType>;
  hasNtep?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TNtepEvolutionChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['NtepEvolutionChart'] = TResolversParentTypes['NtepEvolutionChart']> = ResolversObject<{
  hasNtep?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  series?: Resolver<Array<TResolversTypes['NtepSeries']>, ParentType, ContextType>;
}>;

export type TNtepPieEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['NtepPieEntry'] = TResolversParentTypes['NtepPieEntry']> = ResolversObject<{
  code?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TNtepSeriesResolvers<ContextType = any, ParentType extends TResolversParentTypes['NtepSeries'] = TResolversParentTypes['NtepSeries']> = ResolversObject<{
  code?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
}>;

export type TOccupationResolvers<ContextType = any, ParentType extends TResolversParentTypes['Occupation'] = TResolversParentTypes['Occupation']> = ResolversObject<{
  activityDetails?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  cbo?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  equipments?: Resolver<Maybe<Array<TResolversTypes['EquipmentByOccupation']>>, ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  exams?: Resolver<Maybe<Array<TResolversTypes['ExamByOccupation']>>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  needEquipment?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  referenceId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  responsibilities?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  restrictions?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  suggestion?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TOccupationByRiskResolvers<ContextType = any, ParentType extends TResolversParentTypes['OccupationByRisk'] = TResolversParentTypes['OccupationByRisk']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<TResolversTypes['Occupation'], ParentType, ContextType>;
}>;

export type TOccupationOnVaccineResolvers<ContextType = any, ParentType extends TResolversParentTypes['OccupationOnVaccine'] = TResolversParentTypes['OccupationOnVaccine']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<TResolversTypes['Occupation'], ParentType, ContextType>;
}>;

export type TOccupationalCertificateParametersResolvers<ContextType = any, ParentType extends TResolversParentTypes['OccupationalCertificateParameters'] = TResolversParentTypes['OccupationalCertificateParameters']> = ResolversObject<{
  fromDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  toDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TOccupationalDiseaseAnalysisResolvers<ContextType = any, ParentType extends TResolversParentTypes['OccupationalDiseaseAnalysis'] = TResolversParentTypes['OccupationalDiseaseAnalysis']> = ResolversObject<{
  annual_number_of_diseases?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  cost_center?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  icd?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  persistence?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  prevalence?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TOccupationalHealthBiometryResolvers<ContextType = any, ParentType extends TResolversParentTypes['OccupationalHealthBiometry'] = TResolversParentTypes['OccupationalHealthBiometry']> = ResolversObject<{
  biometry?: Resolver<TResolversTypes['Biometry'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TOccupationalHealthCertificateResolvers<ContextType = any, ParentType extends TResolversParentTypes['OccupationalHealthCertificate'] = TResolversParentTypes['OccupationalHealthCertificate']> = ResolversObject<{
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  biometry?: Resolver<Maybe<TResolversTypes['OccupationalHealthBiometry']>, ParentType, ContextType>;
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  cancelDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  civilMaintenance?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  cold?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  confined?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  consultation?: Resolver<Maybe<TResolversTypes['Consultation']>, ParentType, ContextType>;
  costCenter?: Resolver<Maybe<TResolversTypes['CostCenter']>, ParentType, ContextType>;
  costCenterId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  department?: Resolver<Maybe<TResolversTypes['Department']>, ParentType, ContextType>;
  departmentId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctorBiometry?: Resolver<Maybe<TResolversTypes['OccupationalHealthBiometry']>, ParentType, ContextType>;
  doctorFace?: Resolver<Maybe<TResolversTypes['OccupationalHealthFace']>, ParentType, ContextType>;
  electricity?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  emissionDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  excavation?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  explosives?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  external?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  face?: Resolver<Maybe<TResolversTypes['OccupationalHealthFace']>, ParentType, ContextType>;
  height?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  loadHandling?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  medicalRecordId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nature?: Resolver<TResolversTypes['Nature'], ParentType, ContextType>;
  observation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  occupation?: Resolver<Maybe<TResolversTypes['Occupation']>, ParentType, ContextType>;
  occupationId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  plataform?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  pressure?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  radiation?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  recommendation?: Resolver<Maybe<TResolversTypes['Recommendation']>, ParentType, ContextType>;
  scheduleDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  task?: Resolver<Maybe<TResolversTypes['Task']>, ParentType, ContextType>;
  taskId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  welding?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type TOccupationalHealthCertificateByDateResolvers<ContextType = any, ParentType extends TResolversParentTypes['OccupationalHealthCertificateByDate'] = TResolversParentTypes['OccupationalHealthCertificateByDate']> = ResolversObject<{
  month?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nature?: Resolver<TResolversTypes['Nature'], ParentType, ContextType>;
  total?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TOccupationalHealthCertificateTotalResolvers<ContextType = any, ParentType extends TResolversParentTypes['OccupationalHealthCertificateTotal'] = TResolversParentTypes['OccupationalHealthCertificateTotal']> = ResolversObject<{
  nature?: Resolver<TResolversTypes['Nature'], ParentType, ContextType>;
  total?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TOccupationalHealthFaceResolvers<ContextType = any, ParentType extends TResolversParentTypes['OccupationalHealthFace'] = TResolversParentTypes['OccupationalHealthFace']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  picture?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TOccupationsGroupResolvers<ContextType = any, ParentType extends TResolversParentTypes['OccupationsGroup'] = TResolversParentTypes['OccupationsGroup']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipes?: Resolver<Maybe<Array<TResolversTypes['IpesInfoSorted']>>, ParentType, ContextType>;
}>;

export type TOccurrenceEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['OccurrenceEntry'] = TResolversParentTypes['OccurrenceEntry']> = ResolversObject<{
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TOrganizationResolvers<ContextType = any, ParentType extends TResolversParentTypes['Organization'] = TResolversParentTypes['Organization']> = ResolversObject<{
  accessBy?: Resolver<Maybe<TResolversTypes['AccessBy']>, ParentType, ContextType>;
  accessKey?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  accessSecret?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  cognitoIdentifiers?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  cognitoMetadataUrl?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  customs?: Resolver<Maybe<Array<TResolversTypes['CustomOrganization']>>, ParentType, ContextType>;
  eSocialStart?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  eSocialStatus?: Resolver<Maybe<TResolversTypes['ESocialStatus']>, ParentType, ContextType>;
  eSocialVersion?: Resolver<Maybe<TResolversTypes['ESocialVersion']>, ParentType, ContextType>;
  erpCompany?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  erpInternalId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isPartner?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  isResendingMessages?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  isServiceProvider?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  isTotvs?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  organizationPicture?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  planStatus?: Resolver<Maybe<TResolversTypes['PlanStatus']>, ParentType, ContextType>;
  primaryColor?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  secondaryColor?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  settings?: Resolver<Maybe<TResolversTypes['Settings']>, ParentType, ContextType>;
  socialName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  tpdTenantId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  utmData?: Resolver<Maybe<TResolversTypes['UtmData']>, ParentType, ContextType>;
}>;

export type TOrganizationOwnershipResolvers<ContextType = any, ParentType extends TResolversParentTypes['OrganizationOwnership'] = TResolversParentTypes['OrganizationOwnership']> = ResolversObject<{
  organizationId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TOrganizationWithBranchesResolvers<ContextType = any, ParentType extends TResolversParentTypes['OrganizationWithBranches'] = TResolversParentTypes['OrganizationWithBranches']> = ResolversObject<{
  accessBy?: Resolver<Maybe<TResolversTypes['AccessBy']>, ParentType, ContextType>;
  accessKey?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  accessSecret?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  branches?: Resolver<Array<TResolversTypes['Branch']>, ParentType, ContextType>;
  cognitoIdentifiers?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  cognitoMetadataUrl?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  customs?: Resolver<Maybe<Array<TResolversTypes['CustomOrganization']>>, ParentType, ContextType>;
  eSocialStart?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  eSocialStatus?: Resolver<Maybe<TResolversTypes['ESocialStatus']>, ParentType, ContextType>;
  eSocialVersion?: Resolver<Maybe<TResolversTypes['ESocialVersion']>, ParentType, ContextType>;
  erpCompany?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  erpInternalId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isPartner?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  isResendingMessages?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  isServiceProvider?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  isTotvs?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  organizationPicture?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  planStatus?: Resolver<Maybe<TResolversTypes['PlanStatus']>, ParentType, ContextType>;
  primaryColor?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  secondaryColor?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  settings?: Resolver<Maybe<TResolversTypes['Settings']>, ParentType, ContextType>;
  socialName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  tpdTenantId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  utmData?: Resolver<Maybe<TResolversTypes['UtmData']>, ParentType, ContextType>;
}>;

export type TOrthoRaterResolvers<ContextType = any, ParentType extends TResolversParentTypes['OrthoRater'] = TResolversParentTypes['OrthoRater']> = ResolversObject<{
  aggravation?: Resolver<TResolversTypes['OphthalmologicAggravationEnum'], ParentType, ContextType>;
  calibrationDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  closeBothEyes?: Resolver<TResolversTypes['OrthoRaterValueEnum'], ParentType, ContextType>;
  closeFusion?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  closeFusionResponse?: Resolver<TResolversTypes['OrthoRaterResponseEnum'], ParentType, ContextType>;
  closeLateralPhoria?: Resolver<TResolversTypes['PhoriaEnum'], ParentType, ContextType>;
  closeLeftEye?: Resolver<TResolversTypes['OrthoRaterValueEnum'], ParentType, ContextType>;
  closeRightEye?: Resolver<TResolversTypes['OrthoRaterValueEnum'], ParentType, ContextType>;
  closeStereopsis?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  closeStereopsisResponse?: Resolver<TResolversTypes['OrthoRaterResponseEnum'], ParentType, ContextType>;
  closeVerticalPhoria?: Resolver<TResolversTypes['PhoriaEnum'], ParentType, ContextType>;
  closeWithCorrection?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  complementaryExam?: Resolver<Maybe<TResolversTypes['ComplementaryExam']>, ParentType, ContextType>;
  consultation?: Resolver<Maybe<TResolversTypes['Consultation']>, ParentType, ContextType>;
  correction?: Resolver<TResolversTypes['OphthalmologicCorrectionEnum'], ParentType, ContextType>;
  crm?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  details?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  diagnosticIndicator?: Resolver<TResolversTypes['ExamDiagnosticIndicatorEnum'], ParentType, ContextType>;
  doctor?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  equipment?: Resolver<TResolversTypes['MeasuringInstrument'], ParentType, ContextType>;
  examAuthorization?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  farBothEyes?: Resolver<TResolversTypes['OrthoRaterValueEnum'], ParentType, ContextType>;
  farFusion?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  farFusionResponse?: Resolver<TResolversTypes['OrthoRaterResponseEnum'], ParentType, ContextType>;
  farLateralPhoria?: Resolver<TResolversTypes['PhoriaEnum'], ParentType, ContextType>;
  farLeftEye?: Resolver<TResolversTypes['OrthoRaterValueEnum'], ParentType, ContextType>;
  farRightEye?: Resolver<TResolversTypes['OrthoRaterValueEnum'], ParentType, ContextType>;
  farStereopsis?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  farStereopsisResponse?: Resolver<TResolversTypes['OrthoRaterResponseEnum'], ParentType, ContextType>;
  farVerticalPhoria?: Resolver<TResolversTypes['PhoriaEnum'], ParentType, ContextType>;
  farWithCorrection?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  gaugingDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  indicator?: Resolver<TResolversTypes['ExamResultIndicatorEnum'], ParentType, ContextType>;
  observations?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  responsibleForMeasuring?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  restTime?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  resultAggravation?: Resolver<Maybe<TResolversTypes['ExamAggravationEnum']>, ParentType, ContextType>;
  resultAlteration?: Resolver<Maybe<TResolversTypes['ExamResultAlterationEnum']>, ParentType, ContextType>;
  sees23?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  sees32?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  sees56?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  sees63?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  sees79?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  sees92?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  state?: Resolver<Maybe<TResolversTypes['State']>, ParentType, ContextType>;
  visualFieldLeftEye?: Resolver<TResolversTypes['VisualFieldEnum'], ParentType, ContextType>;
  visualFieldRightEye?: Resolver<TResolversTypes['VisualFieldEnum'], ParentType, ContextType>;
}>;

export type TPprEmployeesResolvers<ContextType = any, ParentType extends TResolversParentTypes['PPREmployees'] = TResolversParentTypes['PPREmployees']> = ResolversObject<{
  costCenter?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  cpf?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TPaginatedAbsenceTypeResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedAbsenceType'] = TResolversParentTypes['PaginatedAbsenceType']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['AbsenceType']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedAccidentResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedAccident'] = TResolversParentTypes['PaginatedAccident']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Accident']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedAccidentCauseResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedAccidentCause'] = TResolversParentTypes['PaginatedAccidentCause']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['AccidentCause']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedAccidentCodeResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedAccidentCode'] = TResolversParentTypes['PaginatedAccidentCode']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['AccidentCode']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedAccidentObjectResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedAccidentObject'] = TResolversParentTypes['PaginatedAccidentObject']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['AccidentObject']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedAccidentTypeResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedAccidentType'] = TResolversParentTypes['PaginatedAccidentType']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['AccidentDescription']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedAccreditedResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedAccredited'] = TResolversParentTypes['PaginatedAccredited']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Accredited']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedAccreditedConsultationsResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedAccreditedConsultations'] = TResolversParentTypes['PaginatedAccreditedConsultations']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['AccreditedConsultation']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedActionPlanResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedActionPlan'] = TResolversParentTypes['PaginatedActionPlan']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['ActionPlan']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedActivityGroupResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedActivityGroup'] = TResolversParentTypes['PaginatedActivityGroup']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['ActivityGroup']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedActivityIcdResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedActivityIcd'] = TResolversParentTypes['PaginatedActivityIcd']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['ActivityIcd']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedAllowanceTypeResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedAllowanceType'] = TResolversParentTypes['PaginatedAllowanceType']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['AllowanceType']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedAttachmentResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedAttachment'] = TResolversParentTypes['PaginatedAttachment']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['AttachmentDTO']>, ParentType, ContextType>;
  total?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TPaginatedAuditLogsResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedAuditLogs'] = TResolversParentTypes['PaginatedAuditLogs']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['AuditLogEntry']>, ParentType, ContextType>;
  total?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TPaginatedBiologicalMonitoringExamResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedBiologicalMonitoringExam'] = TResolversParentTypes['PaginatedBiologicalMonitoringExam']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['BiologicalMonitoringExam']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedBiologicalMonitoringExamGroupResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedBiologicalMonitoringExamGroup'] = TResolversParentTypes['PaginatedBiologicalMonitoringExamGroup']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['BiologicalMonitoringExamGroup']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedBodyPartResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedBodyPart'] = TResolversParentTypes['PaginatedBodyPart']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['BodyPart']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedBranchResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedBranch'] = TResolversParentTypes['PaginatedBranch']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Branch']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedCalendarResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedCalendar'] = TResolversParentTypes['PaginatedCalendar']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Calendar']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedConsultationResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedConsultation'] = TResolversParentTypes['PaginatedConsultation']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Consultation']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedConsultationMinimalResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedConsultationMinimal'] = TResolversParentTypes['PaginatedConsultationMinimal']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['ConsultationMinimal']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedConsultationReasonResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedConsultationReason'] = TResolversParentTypes['PaginatedConsultationReason']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['ConsultationReason']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedControlMeasureResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedControlMeasure'] = TResolversParentTypes['PaginatedControlMeasure']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['ControlMeasure']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedCostCenterResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedCostCenter'] = TResolversParentTypes['PaginatedCostCenter']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['CostCenter']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedCrontabExecutionDetailsResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedCrontabExecutionDetails'] = TResolversParentTypes['PaginatedCrontabExecutionDetails']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['CrontabExecutionDetail']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedCrontabExecutionsResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedCrontabExecutions'] = TResolversParentTypes['PaginatedCrontabExecutions']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['CrontabExecution']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedDeliverySparePartsResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedDeliverySpareParts'] = TResolversParentTypes['PaginatedDeliverySpareParts']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['DeliverySpareParts']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedDepartmentResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedDepartment'] = TResolversParentTypes['PaginatedDepartment']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Department']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedESocialQueueResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedESocialQueue'] = TResolversParentTypes['PaginatedESocialQueue']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['ESocialQueue']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedEconomicActivityResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedEconomicActivity'] = TResolversParentTypes['PaginatedEconomicActivity']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['EconomicActivity']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedEmployeeIpeDeliveryResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedEmployeeIpeDelivery'] = TResolversParentTypes['PaginatedEmployeeIpeDelivery']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['EmployeeIpeDelivery']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedEnvironmentalReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedEnvironmentalReport'] = TResolversParentTypes['PaginatedEnvironmentalReport']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['EnvironmentalReport']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedEnvironmentalReportSuggestionResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedEnvironmentalReportSuggestion'] = TResolversParentTypes['PaginatedEnvironmentalReportSuggestion']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['EnvironmentalReportSuggestion']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedEventResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedEvent'] = TResolversParentTypes['PaginatedEvent']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Event']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedExamResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedExam'] = TResolversParentTypes['PaginatedExam']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Exam']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedExamNormalResultResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedExamNormalResult'] = TResolversParentTypes['PaginatedExamNormalResult']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['ExamNormalResult']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedExpectedConsultationsResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedExpectedConsultations'] = TResolversParentTypes['PaginatedExpectedConsultations']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['ExpectedConsultation']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedExpenseResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedExpense'] = TResolversParentTypes['PaginatedExpense']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Expense']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedExposureGroupResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedExposureGroup'] = TResolversParentTypes['PaginatedExposureGroup']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['ExposureGroup']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedExtinguishingSystemResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedExtinguishingSystem'] = TResolversParentTypes['PaginatedExtinguishingSystem']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['ExtinguishingSystem']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedFireBrigadeResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedFireBrigade'] = TResolversParentTypes['PaginatedFireBrigade']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['FireBrigade']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGeneratingSourceResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGeneratingSource'] = TResolversParentTypes['PaginatedGeneratingSource']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GeneratingSource']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericAccidentCauseResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericAccidentCause'] = TResolversParentTypes['PaginatedGenericAccidentCause']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericAccidentCause']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericActivePrincipleResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericActivePrinciple'] = TResolversParentTypes['PaginatedGenericActivePrinciple']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericActivePrinciple']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericBiologicalMonitoringExamResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericBiologicalMonitoringExam'] = TResolversParentTypes['PaginatedGenericBiologicalMonitoringExam']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericBiologicalMonitoringExam']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericBiologicalMonitoringExamGroupResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericBiologicalMonitoringExamGroup'] = TResolversParentTypes['PaginatedGenericBiologicalMonitoringExamGroup']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericBiologicalMonitoringExamGroup']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericCostCenterResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericCostCenter'] = TResolversParentTypes['PaginatedGenericCostCenter']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericCostCenter']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericExamResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericExam'] = TResolversParentTypes['PaginatedGenericExam']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericExam']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericExaminationProcedureResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericExaminationProcedure'] = TResolversParentTypes['PaginatedGenericExaminationProcedure']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericExaminationProcedure']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericExpenseResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericExpense'] = TResolversParentTypes['PaginatedGenericExpense']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericExpense']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericHealthProgramResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericHealthProgram'] = TResolversParentTypes['PaginatedGenericHealthProgram']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericHealthProgram']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericLaboratoryResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericLaboratory'] = TResolversParentTypes['PaginatedGenericLaboratory']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericLaboratory']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericMeasuringInstrumentResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericMeasuringInstrument'] = TResolversParentTypes['PaginatedGenericMeasuringInstrument']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericMeasuringInstrument']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericMedicineResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericMedicine'] = TResolversParentTypes['PaginatedGenericMedicine']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericMedicine']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericOccupationResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericOccupation'] = TResolversParentTypes['PaginatedGenericOccupation']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericOccupation']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericPeriodicRangeResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericPeriodicRange'] = TResolversParentTypes['PaginatedGenericPeriodicRange']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericPeriodicRange']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericPublicPlaceResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericPublicPlace'] = TResolversParentTypes['PaginatedGenericPublicPlace']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericPublicPlace']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericQuestionGroupResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericQuestionGroup'] = TResolversParentTypes['PaginatedGenericQuestionGroup']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericQuestionGroup']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericQuestionQuizResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericQuestionQuiz'] = TResolversParentTypes['PaginatedGenericQuestionQuiz']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericQuestionQuiz']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericQuizResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericQuiz'] = TResolversParentTypes['PaginatedGenericQuiz']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericQuiz']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericReportStructureResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericReportStructure'] = TResolversParentTypes['PaginatedGenericReportStructure']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericReportStructure']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericResponseOptionResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericResponseOption'] = TResolversParentTypes['PaginatedGenericResponseOption']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericResponseOption']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericRiskAgentResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericRiskAgent'] = TResolversParentTypes['PaginatedGenericRiskAgent']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericRiskAgent']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericStatementResponsibilityResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericStatementResponsibility'] = TResolversParentTypes['PaginatedGenericStatementResponsibility']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericStatementResponsibility']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericTaskResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericTask'] = TResolversParentTypes['PaginatedGenericTask']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericTask']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericTrainingResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericTraining'] = TResolversParentTypes['PaginatedGenericTraining']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericTraining']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericVaccineResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericVaccine'] = TResolversParentTypes['PaginatedGenericVaccine']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericVaccine']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGenericWorkShiftResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGenericWorkShift'] = TResolversParentTypes['PaginatedGenericWorkShift']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['GenericWorkShift']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedGetDocumentsResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedGetDocuments'] = TResolversParentTypes['PaginatedGetDocuments']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['SignBrokerGetDocumentsAndUpdateState']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedHealthProgramResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedHealthProgram'] = TResolversParentTypes['PaginatedHealthProgram']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['HealthProgram']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedIcdGroupsResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedIcdGroups'] = TResolversParentTypes['PaginatedIcdGroups']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['IcdGroup']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedIcdsResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedIcds'] = TResolversParentTypes['PaginatedIcds']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Icd']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedInjuryNatureResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedInjuryNature'] = TResolversParentTypes['PaginatedInjuryNature']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['InjuryNature']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedIntegrationErrorResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedIntegrationError'] = TResolversParentTypes['PaginatedIntegrationError']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['IntegrationError']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedInventoryQueueResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedInventoryQueue'] = TResolversParentTypes['PaginatedInventoryQueue']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['InventoryQueue']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedInvestigationSuggestionResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedInvestigationSuggestion'] = TResolversParentTypes['PaginatedInvestigationSuggestion']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['InvestigationSuggestion']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedIpeResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedIpe'] = TResolversParentTypes['PaginatedIpe']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Ipe']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedIpeManufacturerResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedIpeManufacturer'] = TResolversParentTypes['PaginatedIpeManufacturer']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['IpeManufacturerSuggestion']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedMandateResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedMandate'] = TResolversParentTypes['PaginatedMandate']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Mandate']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedManufacturerResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedManufacturer'] = TResolversParentTypes['PaginatedManufacturer']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Manufacturer']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedMeasuringInstrumentResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedMeasuringInstrument'] = TResolversParentTypes['PaginatedMeasuringInstrument']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['MeasuringInstrument']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedMedicalRecordsResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedMedicalRecords'] = TResolversParentTypes['PaginatedMedicalRecords']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['MedicalRecord']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedMedicineResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedMedicine'] = TResolversParentTypes['PaginatedMedicine']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Medicine']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedOccupationResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedOccupation'] = TResolversParentTypes['PaginatedOccupation']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Occupation']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedPeopleOnBrowseResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedPeopleOnBrowse'] = TResolversParentTypes['PaginatedPeopleOnBrowse']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['PersonOnBrowse']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedPeriodicRangeResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedPeriodicRange'] = TResolversParentTypes['PaginatedPeriodicRange']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['PeriodicRange']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedPersonResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedPerson'] = TResolversParentTypes['PaginatedPerson']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Person']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedPersonIpeListResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedPersonIpeList'] = TResolversParentTypes['PaginatedPersonIpeList']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['PersonIpeList']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedPersonNeedIpeResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedPersonNeedIpe'] = TResolversParentTypes['PaginatedPersonNeedIpe']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['PersonNeedIpe']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedPhysicalEnvironmentResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedPhysicalEnvironment'] = TResolversParentTypes['PaginatedPhysicalEnvironment']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['PhysicalEnvironment']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedPositionResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedPosition'] = TResolversParentTypes['PaginatedPosition']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Position']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedPreMedicalCertificatesResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedPreMedicalCertificates'] = TResolversParentTypes['PaginatedPreMedicalCertificates']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['PreMedicalCertificate']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedProductResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedProduct'] = TResolversParentTypes['PaginatedProduct']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Product']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedProductDeliveryResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedProductDelivery'] = TResolversParentTypes['PaginatedProductDelivery']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['ProductDelivery']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedProductIpeManufacturerResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedProductIpeManufacturer'] = TResolversParentTypes['PaginatedProductIpeManufacturer']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['ProductIpeManufacturer']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedQueueResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedQueue'] = TResolversParentTypes['PaginatedQueue']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['QueueDTO']>, ParentType, ContextType>;
  total?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TPaginatedQuizResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedQuiz'] = TResolversParentTypes['PaginatedQuiz']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Quiz']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedReportStructureResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedReportStructure'] = TResolversParentTypes['PaginatedReportStructure']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['ReportStructure']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedRiskResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedRisk'] = TResolversParentTypes['PaginatedRisk']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Risk']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedRiskAgentResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedRiskAgent'] = TResolversParentTypes['PaginatedRiskAgent']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['RiskAgent']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedRiskSuggestionResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedRiskSuggestion'] = TResolversParentTypes['PaginatedRiskSuggestion']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['RiskSuggestion']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedRolePermissionResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedRolePermission'] = TResolversParentTypes['PaginatedRolePermission']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['RolePermission']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedScheduleRestrictionResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedScheduleRestriction'] = TResolversParentTypes['PaginatedScheduleRestriction']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['ScheduleRestriction']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedSparePartsResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedSpareParts'] = TResolversParentTypes['PaginatedSpareParts']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['SpareParts']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedStabilityTypeResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedStabilityType'] = TResolversParentTypes['PaginatedStabilityType']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['StabilityType']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedStatementResponsibilityResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedStatementResponsibility'] = TResolversParentTypes['PaginatedStatementResponsibility']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['StatementResponsibility']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedSyncResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedSync'] = TResolversParentTypes['PaginatedSync']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['SyncDTO']>, ParentType, ContextType>;
  total?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TPaginatedTTalkQueueResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedTTalkQueue'] = TResolversParentTypes['PaginatedTTalkQueue']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['TTalkQueue']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedTaskResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedTask'] = TResolversParentTypes['PaginatedTask']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Task']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedTrainingResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedTraining'] = TResolversParentTypes['PaginatedTraining']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Training']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedTrainingHistoryResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedTrainingHistory'] = TResolversParentTypes['PaginatedTrainingHistory']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['TrainingHistory']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedTtalkInboundEventResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedTtalkInboundEvent'] = TResolversParentTypes['PaginatedTtalkInboundEvent']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['TtalkInboundEvent']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedTtalkInboundSemanticInconsistencyResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedTtalkInboundSemanticInconsistency'] = TResolversParentTypes['PaginatedTtalkInboundSemanticInconsistency']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['TtalkInboundSemanticInconsistency']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedUnityMeasureResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedUnityMeasure'] = TResolversParentTypes['PaginatedUnityMeasure']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['UnityOfMeasure']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedVaccineResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedVaccine'] = TResolversParentTypes['PaginatedVaccine']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Vaccine']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedWarehouseResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedWarehouse'] = TResolversParentTypes['PaginatedWarehouse']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['Warehouse']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedWebhookQueueResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedWebhookQueue'] = TResolversParentTypes['PaginatedWebhookQueue']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['WebhookQueue']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedWorkPermissionResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedWorkPermission'] = TResolversParentTypes['PaginatedWorkPermission']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['WorkPermission']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPaginatedWorkShiftResolvers<ContextType = any, ParentType extends TResolversParentTypes['PaginatedWorkShift'] = TResolversParentTypes['PaginatedWorkShift']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['WorkShift']>, ParentType, ContextType>;
  total?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TParticipantOnMeetingResolvers<ContextType = any, ParentType extends TResolversParentTypes['ParticipantOnMeeting'] = TResolversParentTypes['ParticipantOnMeeting']> = ResolversObject<{
  attendance?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  justification?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
}>;

export type TPaymentsResolvers<ContextType = any, ParentType extends TResolversParentTypes['Payments'] = TResolversParentTypes['Payments']> = ResolversObject<{
  billingType?: Resolver<Maybe<TResolversTypes['BillingMethod']>, ParentType, ContextType>;
  details?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  dueDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  endPeriod?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  invoice?: Resolver<TResolversTypes['Invoice'], ParentType, ContextType>;
  levels?: Resolver<Maybe<Array<TResolversTypes['Level']>>, ParentType, ContextType>;
  paymentDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  startPeriod?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['PaymentStatus'], ParentType, ContextType>;
  value?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TPcmsoReportDataResolvers<ContextType = any, ParentType extends TResolversParentTypes['PcmsoReportData'] = TResolversParentTypes['PcmsoReportData']> = ResolversObject<{
  abnormalityAnalysis?: Resolver<Array<TResolversTypes['AbnormalityAnalysis']>, ParentType, ContextType>;
  accidentAnalysis?: Resolver<Array<TResolversTypes['AccidentAnalysis']>, ParentType, ContextType>;
  cnae?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctorAddress?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctorCrm?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctorName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  doctorRqeDisplay?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctorTelephone?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  examAnalysis?: Resolver<Array<TResolversTypes['ExamAnalysis']>, ParentType, ContextType>;
  expirationDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupationalDiseaseAnalysis?: Resolver<Array<TResolversTypes['OccupationalDiseaseAnalysis']>, ParentType, ContextType>;
  orgAddress?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  orgDoc?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  orgImage?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  orgName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  period?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TPerDayChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['PerDayChart'] = TResolversParentTypes['PerDayChart']> = ResolversObject<{
  deliveryValues?: Resolver<Array<TResolversTypes['Float']>, ParentType, ContextType>;
  hasIpeDeliveries?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  maxDataValue?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  returnValues?: Resolver<Array<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TPerTotalChartsResolvers<ContextType = any, ParentType extends TResolversParentTypes['PerTotalCharts'] = TResolversParentTypes['PerTotalCharts']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  perTotal?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
}>;

export type TPeriodicRangeResolvers<ContextType = any, ParentType extends TResolversParentTypes['PeriodicRange'] = TResolversParentTypes['PeriodicRange']> = ResolversObject<{
  ageRanges?: Resolver<Array<TResolversTypes['AgeRange']>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  gender?: Resolver<TResolversTypes['PeriodicRangeGenderEnum'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  postAdmission?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  referenceId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TPermissionResolvers<ContextType = any, ParentType extends TResolversParentTypes['Permission'] = TResolversParentTypes['Permission']> = ResolversObject<{
  canCreate?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  canDelete?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  canPrint?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  canUpdate?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  children?: Resolver<Maybe<Array<TResolversTypes['Permission']>>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TPersonResolvers<ContextType = any, ParentType extends TResolversParentTypes['Person'] = TResolversParentTypes['Person']> = ResolversObject<{
  address?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  admissionDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  age?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  birthday?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  branch?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  civilStatus?: Resolver<Maybe<TResolversTypes['CivilStatus']>, ParentType, ContextType>;
  costCenter?: Resolver<Maybe<TResolversTypes['CostCenter']>, ParentType, ContextType>;
  ctps?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  department?: Resolver<Maybe<TResolversTypes['Department']>, ParentType, ContextType>;
  dismissalDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  eSocialCategory?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  eSocialRhEventStatus?: Resolver<Maybe<TResolversTypes['ESocialRhEventStatus']>, ParentType, ContextType>;
  educationLevel?: Resolver<Maybe<TResolversTypes['EducationLevel']>, ParentType, ContextType>;
  email?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  employeeSituation?: Resolver<Maybe<TResolversTypes['EmployeeSituation']>, ParentType, ContextType>;
  employeeTasks?: Resolver<Maybe<Array<TResolversTypes['TaskByPerson']>>, ParentType, ContextType>;
  employeeWarnings?: Resolver<Maybe<Array<TResolversTypes['WarningByPerson']>>, ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  external?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  funcionalHistories?: Resolver<Maybe<Array<TResolversTypes['FuncionalHistoryByPerson']>>, ParentType, ContextType>;
  gender?: Resolver<TResolversTypes['Gender'], ParentType, ContextType>;
  generalRegistration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  individualRegistration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipeDeliveries?: Resolver<Maybe<Array<TResolversTypes['IpeDelivery']>>, ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  lastExam?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  manager?: Resolver<Maybe<TResolversTypes['Person']>, ParentType, ContextType>;
  managerId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  mothersName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  neighborhood?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  nextChange?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  nickname?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  numberAddress?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  occupation?: Resolver<Maybe<TResolversTypes['Occupation']>, ParentType, ContextType>;
  organizationPicture?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  pisCode?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<TResolversTypes['Position']>, ParentType, ContextType>;
  profilePicture?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  rais?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  registration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  replacementSituation?: Resolver<Maybe<TResolversTypes['ReplacementSituation']>, ParentType, ContextType>;
  riskCount?: Resolver<Maybe<TResolversTypes['Int']>, ParentType, ContextType>;
  sefip?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  sellerId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  socialName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  suggestion?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  telephone?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  trainingHistories?: Resolver<Maybe<Array<TResolversTypes['TrainingHistoryByPerson']>>, ParentType, ContextType>;
  unicESocialId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  uploadUrl?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  userRef?: Resolver<Maybe<TResolversTypes['User']>, ParentType, ContextType>;
  workShift?: Resolver<Maybe<TResolversTypes['WorkShift']>, ParentType, ContextType>;
  zipCode?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TPersonByGenderResolvers<ContextType = any, ParentType extends TResolversParentTypes['PersonByGender'] = TResolversParentTypes['PersonByGender']> = ResolversObject<{
  female?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  male?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TPersonByGenderAndCcResolvers<ContextType = any, ParentType extends TResolversParentTypes['PersonByGenderAndCC'] = TResolversParentTypes['PersonByGenderAndCC']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  female?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  male?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  people?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TPersonByMandateResolvers<ContextType = any, ParentType extends TResolversParentTypes['PersonByMandate'] = TResolversParentTypes['PersonByMandate']> = ResolversObject<{
  birthday?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  gender?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  individualRegistration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nickname?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  profilePicture?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  registration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  socialName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  suggestion?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TPersonByRiskResolvers<ContextType = any, ParentType extends TResolversParentTypes['PersonByRisk'] = TResolversParentTypes['PersonByRisk']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
}>;

export type TPersonByTaskResolvers<ContextType = any, ParentType extends TResolversParentTypes['PersonByTask'] = TResolversParentTypes['PersonByTask']> = ResolversObject<{
  endDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  startDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type TPersonChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['PersonChart'] = TResolversParentTypes['PersonChart']> = ResolversObject<{
  riskCountData?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  riskPerTotal?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
}>;

export type TPersonHistoryResolvers<ContextType = any, ParentType extends TResolversParentTypes['PersonHistory'] = TResolversParentTypes['PersonHistory']> = ResolversObject<{
  history?: Resolver<Array<TResolversTypes['ShortcutHistory']>, ParentType, ContextType>;
  person?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TPersonHistoryActivateResolvers<ContextType = any, ParentType extends TResolversParentTypes['PersonHistoryActivate'] = TResolversParentTypes['PersonHistoryActivate']> = ResolversObject<{
  activateDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  deactivateDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
}>;

export type TPersonIpeListResolvers<ContextType = any, ParentType extends TResolversParentTypes['PersonIpeList'] = TResolversParentTypes['PersonIpeList']> = ResolversObject<{
  costCenter?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  costCenterId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  employeeSituation?: Resolver<Maybe<TResolversTypes['EmployeeSituation']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nextChange?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  occupation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  occupationId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  profilePicture?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  replacementSituation?: Resolver<Maybe<TResolversTypes['ReplacementSituation']>, ParentType, ContextType>;
}>;

export type TPersonNeedIpeResolvers<ContextType = any, ParentType extends TResolversParentTypes['PersonNeedIpe'] = TResolversParentTypes['PersonNeedIpe']> = ResolversObject<{
  caCode?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  daysForReplacement?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipeId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipeName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  ipeProtection?: Resolver<Maybe<TResolversTypes['IpeProtection']>, ParentType, ContextType>;
}>;

export type TPersonOnBrowseResolvers<ContextType = any, ParentType extends TResolversParentTypes['PersonOnBrowse'] = TResolversParentTypes['PersonOnBrowse']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  individualRegistration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  registration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TPersonRequiredTrainingResolvers<ContextType = any, ParentType extends TResolversParentTypes['PersonRequiredTraining'] = TResolversParentTypes['PersonRequiredTraining']> = ResolversObject<{
  approved?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  expirationDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  lastCompletionDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  origins?: Resolver<Array<TResolversTypes['TrainingNecessityOrigin']>, ParentType, ContextType>;
  status?: Resolver<TResolversTypes['TrainingEligibleStatus'], ParentType, ContextType>;
  trainingDescription?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  trainingId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TPhysicalEnvironmentResolvers<ContextType = any, ParentType extends TResolversParentTypes['PhysicalEnvironment'] = TResolversParentTypes['PhysicalEnvironment']> = ResolversObject<{
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  ceilingDetailing?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  ceilingMaterial?: Resolver<Maybe<TResolversTypes['Material']>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  displayDetailing?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  displayType?: Resolver<Maybe<TResolversTypes['Material']>, ParentType, ContextType>;
  documentNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doorDetailing?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doorMaterial?: Resolver<Maybe<TResolversTypes['Material']>, ParentType, ContextType>;
  environmentType?: Resolver<Maybe<TResolversTypes['EnvironmentType']>, ParentType, ContextType>;
  firstCoatDetailing?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  firstCoatMaterial?: Resolver<Maybe<TResolversTypes['Material']>, ParentType, ContextType>;
  floorDetailing?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  floorMaterial?: Resolver<Maybe<TResolversTypes['Material']>, ParentType, ContextType>;
  heightCeiling?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  isClosed?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  lightingDetailing?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  lightingMaterial?: Resolver<Maybe<TResolversTypes['Material']>, ParentType, ContextType>;
  machinery?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  riskMapPicture?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  secondCoatDetailing?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  secondCoatMaterial?: Resolver<Maybe<TResolversTypes['Material']>, ParentType, ContextType>;
  uploadUrl?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  wallDetailing?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  wallMaterial?: Resolver<Maybe<TResolversTypes['Material']>, ParentType, ContextType>;
  windowDetailing?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  windowMaterial?: Resolver<Maybe<TResolversTypes['Material']>, ParentType, ContextType>;
}>;

export type TPieChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['PieChart'] = TResolversParentTypes['PieChart']> = ResolversObject<{
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TPieChartsResolvers<ContextType = any, ParentType extends TResolversParentTypes['PieCharts'] = TResolversParentTypes['PieCharts']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['PieChart']>, ParentType, ContextType>;
}>;

export type TPlanedExamResolvers<ContextType = any, ParentType extends TResolversParentTypes['PlanedExam'] = TResolversParentTypes['PlanedExam']> = ResolversObject<{
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  preparation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TPolicyAgreementResolvers<ContextType = any, ParentType extends TResolversParentTypes['PolicyAgreement'] = TResolversParentTypes['PolicyAgreement']> = ResolversObject<{
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipAddress?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  termId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  userAgent?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TPolicyTermsResolvers<ContextType = any, ParentType extends TResolversParentTypes['PolicyTerms'] = TResolversParentTypes['PolicyTerms']> = ResolversObject<{
  content?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isFuture?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  startedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  type?: Resolver<TResolversTypes['PrivacyType'], ParentType, ContextType>;
  version?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TPositionResolvers<ContextType = any, ParentType extends TResolversParentTypes['Position'] = TResolversParentTypes['Position']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TPppReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['PppReport'] = TResolversParentTypes['PppReport']> = ResolversObject<{
  cnpj?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TPreMedicalCertificateResolvers<ContextType = any, ParentType extends TResolversParentTypes['PreMedicalCertificate'] = TResolversParentTypes['PreMedicalCertificate']> = ResolversObject<{
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  endDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  erpId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  followUps?: Resolver<Array<TResolversTypes['PreMedicalCertificateFollowUp']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  medicalRecord?: Resolver<TResolversTypes['MedicalRecord'], ParentType, ContextType>;
  medicalRecordId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  observation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  rejectionDetails?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  rejectionReason?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['PreMedicalCertificateStatus'], ParentType, ContextType>;
  updatedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type TPreMedicalCertificateCountByStatusResolvers<ContextType = any, ParentType extends TResolversParentTypes['PreMedicalCertificateCountByStatus'] = TResolversParentTypes['PreMedicalCertificateCountByStatus']> = ResolversObject<{
  count?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['PreMedicalCertificateStatus'], ParentType, ContextType>;
}>;

export type TPreMedicalCertificateFollowUpResolvers<ContextType = any, ParentType extends TResolversParentTypes['PreMedicalCertificateFollowUp'] = TResolversParentTypes['PreMedicalCertificateFollowUp']> = ResolversObject<{
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['PreMedicalCertificateStatus'], ParentType, ContextType>;
}>;

export type TPreValidateResolvers<ContextType = any, ParentType extends TResolversParentTypes['PreValidate'] = TResolversParentTypes['PreValidate']> = ResolversObject<{
  invalidLines?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  rows?: Resolver<Array<TResolversTypes['RowsInfo']>, ParentType, ContextType>;
  totalLines?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  validLines?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TPrintBiometryResolvers<ContextType = any, ParentType extends TResolversParentTypes['PrintBiometry'] = TResolversParentTypes['PrintBiometry']> = ResolversObject<{
  biometryId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  bmp?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  imageData?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TProductResolvers<ContextType = any, ParentType extends TResolversParentTypes['Product'] = TResolversParentTypes['Product']> = ResolversObject<{
  dangerous?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  daysForReplacement?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipes?: Resolver<Maybe<TResolversTypes['ProductIpeManufacturer']>, ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  stockLevels?: Resolver<Maybe<Array<TResolversTypes['StockLevel']>>, ParentType, ContextType>;
  suggestion?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  unitaryCost?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  unityOfMeasureId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  unityOfMeasureRef?: Resolver<Maybe<TResolversTypes['UnityOfMeasure']>, ParentType, ContextType>;
  warehouseId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TProductDeliveryResolvers<ContextType = any, ParentType extends TResolversParentTypes['ProductDelivery'] = TResolversParentTypes['ProductDelivery']> = ResolversObject<{
  amount?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  amountReturned?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  cost?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  deliveryDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  deliveryStatus?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  issueDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  lotNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  nextDeliveryDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  observation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  personId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  product?: Resolver<TResolversTypes['Product'], ParentType, ContextType>;
  productId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  returnedDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  returnedLotNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  returnedProduct?: Resolver<TResolversTypes['Product'], ParentType, ContextType>;
  returnedProductId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  returnedWarehouse?: Resolver<TResolversTypes['Warehouse'], ParentType, ContextType>;
  returnedWarehouseId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  stockMovement?: Resolver<Maybe<Array<TResolversTypes['StockMovement']>>, ParentType, ContextType>;
  warehouse?: Resolver<TResolversTypes['Warehouse'], ParentType, ContextType>;
  warehouseId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TProductDeliveryParamsResolvers<ContextType = any, ParentType extends TResolversParentTypes['ProductDeliveryParams'] = TResolversParentTypes['ProductDeliveryParams']> = ResolversObject<{
  filter?: Resolver<Maybe<TResolversTypes['DeliveryFilter']>, ParentType, ContextType>;
  isCheck?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  statementsResponsibility?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TProductDeliveryReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['ProductDeliveryReport'] = TResolversParentTypes['ProductDeliveryReport']> = ResolversObject<{
  address?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  admission?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  cnpj?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  companyName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  costCenter?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  generalRegistration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  individualRegistration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  productBiometry?: Resolver<Maybe<TResolversTypes['IpeBiometry']>, ParentType, ContextType>;
  productFace?: Resolver<Maybe<TResolversTypes['IpeFace']>, ParentType, ContextType>;
  products?: Resolver<Array<TResolversTypes['ProductReport']>, ParentType, ContextType>;
  registration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  telephone?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TProductIpeManufacturerResolvers<ContextType = any, ParentType extends TResolversParentTypes['ProductIpeManufacturer'] = TResolversParentTypes['ProductIpeManufacturer']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipeManufacturerId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipeManufacturerRef?: Resolver<Maybe<TResolversTypes['IpeManufacturer']>, ParentType, ContextType>;
  productId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TProductReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['ProductReport'] = TResolversParentTypes['ProductReport']> = ResolversObject<{
  amount?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  prevDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  returnDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  signDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TProductsParametersResolvers<ContextType = any, ParentType extends TResolversParentTypes['ProductsParameters'] = TResolversParentTypes['ProductsParameters']> = ResolversObject<{
  branches?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  fromDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  toDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TPubSubPayloadResolvers<ContextType = any, ParentType extends TResolversParentTypes['PubSubPayload'] = TResolversParentTypes['PubSubPayload']> = ResolversObject<{
  userId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TQueryResolvers<ContextType = any, ParentType extends TResolversParentTypes['Query'] = TResolversParentTypes['Query']> = ResolversObject<{
  AllowanceType?: Resolver<TResolversTypes['AllowanceType'], ParentType, ContextType, RequireFields<TQueryAllowanceTypeArgs, 'id'>>;
  MeetingParticipant?: Resolver<TResolversTypes['MeetingParticipant'], ParentType, ContextType, RequireFields<TQueryMeetingParticipantArgs, 'id'>>;
  MeetingParticipantPresent?: Resolver<TResolversTypes['MeetingParticipant'], ParentType, ContextType, RequireFields<TQueryMeetingParticipantPresentArgs, 'id'>>;
  MeetingParticipants?: Resolver<Array<TResolversTypes['MeetingParticipant']>, ParentType, ContextType, RequireFields<TQueryMeetingParticipantsArgs, 'meetingId'>>;
  _getCsv?: Resolver<TResolversTypes['String'], ParentType, ContextType, Partial<TQuery_GetCsvArgs>>;
  _invites?: Resolver<Array<TResolversTypes['_Invite']>, ParentType, ContextType>;
  _passwordRecoveries?: Resolver<Array<TResolversTypes['_PasswordRecovery']>, ParentType, ContextType>;
  _terms?: Resolver<Array<TResolversTypes['_Terms']>, ParentType, ContextType>;
  absenceType?: Resolver<TResolversTypes['AbsenceType'], ParentType, ContextType, RequireFields<TQueryAbsenceTypeArgs, 'id'>>;
  absenceTypes?: Resolver<TResolversTypes['PaginatedAbsenceType'], ParentType, ContextType, RequireFields<TQueryAbsenceTypesArgs, 'query'>>;
  accident?: Resolver<TResolversTypes['Accident'], ParentType, ContextType, RequireFields<TQueryAccidentArgs, 'id'>>;
  accidentAbsence?: Resolver<Array<TResolversTypes['AccidentAbsence']>, ParentType, ContextType, RequireFields<TQueryAccidentAbsenceArgs, 'dateEnd' | 'dateStart'>>;
  accidentAmount?: Resolver<Array<TResolversTypes['AccidentAmount']>, ParentType, ContextType, RequireFields<TQueryAccidentAmountArgs, 'dateEnd' | 'dateStart'>>;
  accidentBySummary?: Resolver<Array<TResolversTypes['Accident']>, ParentType, ContextType, RequireFields<TQueryAccidentBySummaryArgs, 'summary'>>;
  accidentCause?: Resolver<TResolversTypes['AccidentCause'], ParentType, ContextType, RequireFields<TQueryAccidentCauseArgs, 'id'>>;
  accidentCauses?: Resolver<TResolversTypes['PaginatedAccidentCause'], ParentType, ContextType, RequireFields<TQueryAccidentCausesArgs, 'query'>>;
  accidentDeathAccident?: Resolver<Array<TResolversTypes['AccidentVictim']>, ParentType, ContextType>;
  accidentExpenseAmount?: Resolver<Array<TResolversTypes['AccidentExpenseAmount']>, ParentType, ContextType, RequireFields<TQueryAccidentExpenseAmountArgs, 'dateEnd' | 'dateStart'>>;
  accidentLastAccident?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  accidentMaxDaysWithout?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  accidentSummary?: Resolver<TResolversTypes['Summary'], ParentType, ContextType, RequireFields<TQueryAccidentSummaryArgs, 'getCounter' | 'query'>>;
  accidentWithVictim?: Resolver<Array<TResolversTypes['AccidentVictim']>, ParentType, ContextType>;
  accidentWithoutVictim?: Resolver<Array<TResolversTypes['AccidentVictim']>, ParentType, ContextType>;
  accidents?: Resolver<TResolversTypes['PaginatedAccident'], ParentType, ContextType, RequireFields<TQueryAccidentsArgs, 'orderBy' | 'query'>>;
  accidentsDashboard?: Resolver<TResolversTypes['AccidentDashboard'], ParentType, ContextType, RequireFields<TQueryAccidentsDashboardArgs, 'filter' | 'identifier'>>;
  accidentsWithInvestigation?: Resolver<Array<TResolversTypes['AccidentWithInvestigation']>, ParentType, ContextType, RequireFields<TQueryAccidentsWithInvestigationArgs, 'mandateId'>>;
  accidentsWithoutInvestigation?: Resolver<Array<TResolversTypes['Accident']>, ParentType, ContextType, RequireFields<TQueryAccidentsWithoutInvestigationArgs, 'mandateId'>>;
  accredited?: Resolver<TResolversTypes['Accredited'], ParentType, ContextType, RequireFields<TQueryAccreditedArgs, 'id'>>;
  accreditedByName?: Resolver<Maybe<TResolversTypes['Accredited']>, ParentType, ContextType, RequireFields<TQueryAccreditedByNameArgs, 'name'>>;
  accreditedUnscheduledConsultations?: Resolver<TResolversTypes['PaginatedAccreditedConsultations'], ParentType, ContextType, RequireFields<TQueryAccreditedUnscheduledConsultationsArgs, 'query'>>;
  actionPlan?: Resolver<TResolversTypes['ActionPlan'], ParentType, ContextType, RequireFields<TQueryActionPlanArgs, 'id'>>;
  actionPlanCount?: Resolver<TResolversTypes['ActionPlanCount'], ParentType, ContextType>;
  actionPlanDashboard?: Resolver<TResolversTypes['ActionPlanDashboard'], ParentType, ContextType, Partial<TQueryActionPlanDashboardArgs>>;
  actionPlanInvestigationsByPlan?: Resolver<Array<TResolversTypes['ActionPlanInvestigationSuggestion']>, ParentType, ContextType, RequireFields<TQueryActionPlanInvestigationsByPlanArgs, 'actionPlanId'>>;
  actionPlanMicroActionsByPlan?: Resolver<Array<TResolversTypes['ActionPlanMicroAction']>, ParentType, ContextType, RequireFields<TQueryActionPlanMicroActionsByPlanArgs, 'actionPlanId'>>;
  actionPlanReportsByPlan?: Resolver<Array<TResolversTypes['ActionPlanReportSuggestion']>, ParentType, ContextType, RequireFields<TQueryActionPlanReportsByPlanArgs, 'actionPlanId'>>;
  actionPlanRisksByPlan?: Resolver<Array<TResolversTypes['RiskSuggestion']>, ParentType, ContextType, RequireFields<TQueryActionPlanRisksByPlanArgs, 'actionPlanId'>>;
  actionPlanSummary?: Resolver<TResolversTypes['Summary'], ParentType, ContextType, RequireFields<TQueryActionPlanSummaryArgs, 'getCounter' | 'query'>>;
  actionPlans?: Resolver<TResolversTypes['PaginatedActionPlan'], ParentType, ContextType, RequireFields<TQueryActionPlansArgs, 'orderBy' | 'query'>>;
  actionPlansBySituation?: Resolver<Array<TResolversTypes['ActionPlan']>, ParentType, ContextType, RequireFields<TQueryActionPlansBySituationArgs, 'situation'>>;
  activeBulkSyncRun?: Resolver<Maybe<TResolversTypes['BulkSyncRun']>, ParentType, ContextType>;
  actualMandate?: Resolver<Array<TResolversTypes['Mandate']>, ParentType, ContextType>;
  allAccredited?: Resolver<TResolversTypes['PaginatedAccredited'], ParentType, ContextType, RequireFields<TQueryAllAccreditedArgs, 'query'>>;
  allExposureGroupByPerson?: Resolver<Array<TResolversTypes['ExposureGroup']>, ParentType, ContextType, RequireFields<TQueryAllExposureGroupByPersonArgs, 'person'>>;
  allowanceTypes?: Resolver<TResolversTypes['PaginatedAllowanceType'], ParentType, ContextType, RequireFields<TQueryAllowanceTypesArgs, 'query'>>;
  asoEvolutionByMedicalRecord?: Resolver<Array<TResolversTypes['AsoEvolutionEntry']>, ParentType, ContextType, RequireFields<TQueryAsoEvolutionByMedicalRecordArgs, 'medicalRecordId'>>;
  audiometryDashboard?: Resolver<TResolversTypes['AudiometryDashboard'], ParentType, ContextType>;
  auditLog?: Resolver<Maybe<TResolversTypes['AuditLogEntry']>, ParentType, ContextType, RequireFields<TQueryAuditLogArgs, 'id'>>;
  auditLogs?: Resolver<TResolversTypes['PaginatedAuditLogs'], ParentType, ContextType, RequireFields<TQueryAuditLogsArgs, 'query'>>;
  availableBranches?: Resolver<Array<TResolversTypes['Branch']>, ParentType, ContextType>;
  biologicalMonitoring?: Resolver<TResolversTypes['BiologicalMonitoring'], ParentType, ContextType, RequireFields<TQueryBiologicalMonitoringArgs, 'id'>>;
  biologicalMonitoringByMedicalRecord?: Resolver<Array<TResolversTypes['BiologicalMonitoring']>, ParentType, ContextType, RequireFields<TQueryBiologicalMonitoringByMedicalRecordArgs, 'personId'>>;
  biologicalMonitoringExamGroup?: Resolver<TResolversTypes['BiologicalMonitoringExamGroup'], ParentType, ContextType, RequireFields<TQueryBiologicalMonitoringExamGroupArgs, 'id'>>;
  biologicalMonitoringExamGroups?: Resolver<TResolversTypes['PaginatedBiologicalMonitoringExamGroup'], ParentType, ContextType, RequireFields<TQueryBiologicalMonitoringExamGroupsArgs, 'query'>>;
  biometries?: Resolver<Array<TResolversTypes['Biometry']>, ParentType, ContextType, RequireFields<TQueryBiometriesArgs, 'checkId'>>;
  biometry?: Resolver<TResolversTypes['OccupationalHealthBiometry'], ParentType, ContextType, RequireFields<TQueryBiometryArgs, 'id'>>;
  branchHasTtalkEndpoint?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TQueryBranchHasTtalkEndpointArgs, 'branchId'>>;
  branchIsBlockedToIntegration?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TQueryBranchIsBlockedToIntegrationArgs, 'branchId' | 'integration'>>;
  branchesByOrganization?: Resolver<TResolversTypes['PaginatedBranch'], ParentType, ContextType, RequireFields<TQueryBranchesByOrganizationArgs, 'query'>>;
  branchesWithTtalk?: Resolver<Array<TResolversTypes['BranchTtalkInfo']>, ParentType, ContextType>;
  branchesWithoutInventoryByOrganization?: Resolver<TResolversTypes['PaginatedBranch'], ParentType, ContextType, RequireFields<TQueryBranchesWithoutInventoryByOrganizationArgs, 'query'>>;
  bulkSyncRun?: Resolver<Maybe<TResolversTypes['BulkSyncRun']>, ParentType, ContextType, RequireFields<TQueryBulkSyncRunArgs, 'runId'>>;
  calendar?: Resolver<TResolversTypes['Calendar'], ParentType, ContextType, RequireFields<TQueryCalendarArgs, 'id'>>;
  calendars?: Resolver<TResolversTypes['PaginatedCalendar'], ParentType, ContextType, RequireFields<TQueryCalendarsArgs, 'query'>>;
  candidate?: Resolver<TResolversTypes['Candidate'], ParentType, ContextType, RequireFields<TQueryCandidateArgs, 'id'>>;
  candidateByMandate?: Resolver<Array<TResolversTypes['CandidateByMandate']>, ParentType, ContextType, RequireFields<TQueryCandidateByMandateArgs, 'mandateId'>>;
  candidateByName?: Resolver<Array<TResolversTypes['Candidate']>, ParentType, ContextType, RequireFields<TQueryCandidateByNameArgs, 'name'>>;
  candidates?: Resolver<Array<TResolversTypes['Candidate']>, ParentType, ContextType>;
  categorizedBranches?: Resolver<Array<TResolversTypes['CategorizedInputData']>, ParentType, ContextType>;
  certificatesRankingDashboard?: Resolver<TResolversTypes['CertificatesRankingDashboard'], ParentType, ContextType, RequireFields<TQueryCertificatesRankingDashboardArgs, 'filter' | 'fromDate' | 'identifier' | 'toDate'>>;
  checkTableData?: Resolver<Array<TResolversTypes['CheckTableData']>, ParentType, ContextType>;
  checkTotvsWebHookConfig?: Resolver<TResolversTypes['SignBrokerResponse'], ParentType, ContextType, RequireFields<TQueryCheckTotvsWebHookConfigArgs, 'input'>>;
  clinicalQuiz?: Resolver<TResolversTypes['ClinicalQuiz'], ParentType, ContextType, RequireFields<TQueryClinicalQuizArgs, 'id'>>;
  clinicalQuizzes?: Resolver<Array<TResolversTypes['ClinicalQuiz']>, ParentType, ContextType, RequireFields<TQueryClinicalQuizzesArgs, 'medicalRecord'>>;
  comparativeResultsDashboard?: Resolver<TResolversTypes['ComparativeResultsDashboard'], ParentType, ContextType, RequireFields<TQueryComparativeResultsDashboardArgs, 'medicalRecordId'>>;
  component?: Resolver<TResolversTypes['Component'], ParentType, ContextType, RequireFields<TQueryComponentArgs, 'id'>>;
  components?: Resolver<Array<TResolversTypes['Component']>, ParentType, ContextType, RequireFields<TQueryComponentsArgs, 'mandateId'>>;
  consultation?: Resolver<TResolversTypes['Consultation'], ParentType, ContextType, RequireFields<TQueryConsultationArgs, 'id'>>;
  consultationByCrm?: Resolver<TResolversTypes['ExternalDoctor'], ParentType, ContextType, Partial<TQueryConsultationByCrmArgs>>;
  consultationByDoctorName?: Resolver<TResolversTypes['ExternalDoctor'], ParentType, ContextType, Partial<TQueryConsultationByDoctorNameArgs>>;
  consultationByOccupationalHealthCertificate?: Resolver<Maybe<TResolversTypes['ExternalOccupationalHealthCertificate']>, ParentType, ContextType, RequireFields<TQueryConsultationByOccupationalHealthCertificateArgs, 'id'>>;
  consultationByOriginPerson?: Resolver<TResolversTypes['ConsultationBiologicalMonitoring'], ParentType, ContextType, RequireFields<TQueryConsultationByOriginPersonArgs, 'monitoringExamGroupId' | 'originPersonId'>>;
  consultationReasons?: Resolver<TResolversTypes['PaginatedConsultationReason'], ParentType, ContextType, Partial<TQueryConsultationReasonsArgs>>;
  consultationReleasableResults?: Resolver<Array<TResolversTypes['ReleasableResult']>, ParentType, ContextType, RequireFields<TQueryConsultationReleasableResultsArgs, 'consultationId'>>;
  consultationsByDate?: Resolver<Array<TResolversTypes['ConsultationMinimal']>, ParentType, ContextType, RequireFields<TQueryConsultationsByDateArgs, 'doctorId' | 'endDate' | 'startDate'>>;
  consultationsByDoctor?: Resolver<Array<TResolversTypes['ConsultationMinimal']>, ParentType, ContextType, RequireFields<TQueryConsultationsByDoctorArgs, 'doctorId' | 'endDate' | 'startDate'>>;
  consultationsByMedicalRecord?: Resolver<Array<TResolversTypes['Consultation']>, ParentType, ContextType, RequireFields<TQueryConsultationsByMedicalRecordArgs, 'medicalRecord'>>;
  consultationsForTransfer?: Resolver<Array<TResolversTypes['ConsultationMinimal']>, ParentType, ContextType, RequireFields<TQueryConsultationsForTransferArgs, 'endDate' | 'startDate'>>;
  controlMeasure?: Resolver<TResolversTypes['ControlMeasure'], ParentType, ContextType, RequireFields<TQueryControlMeasureArgs, 'id'>>;
  controlMeasures?: Resolver<TResolversTypes['PaginatedControlMeasure'], ParentType, ContextType, RequireFields<TQueryControlMeasuresArgs, 'query'>>;
  controlsByRisk?: Resolver<Array<TResolversTypes['ControlMeasureByRisk']>, ParentType, ContextType, RequireFields<TQueryControlsByRiskArgs, 'riskId'>>;
  costCenter?: Resolver<TResolversTypes['CostCenter'], ParentType, ContextType, RequireFields<TQueryCostCenterArgs, 'id'>>;
  costCenters?: Resolver<TResolversTypes['PaginatedCostCenter'], ParentType, ContextType, RequireFields<TQueryCostCentersArgs, 'query'>>;
  costCentersFilterByBranch?: Resolver<Array<TResolversTypes['CostCenter']>, ParentType, ContextType, RequireFields<TQueryCostCentersFilterByBranchArgs, 'branchId' | 'costCenters'>>;
  crons?: Resolver<Array<TResolversTypes['CronTab']>, ParentType, ContextType>;
  crontabExecutionDetails?: Resolver<TResolversTypes['PaginatedCrontabExecutionDetails'], ParentType, ContextType, RequireFields<TQueryCrontabExecutionDetailsArgs, 'executionId'>>;
  crontabExecutions?: Resolver<TResolversTypes['PaginatedCrontabExecutions'], ParentType, ContextType, RequireFields<TQueryCrontabExecutionsArgs, 'crontabId'>>;
  currentSession?: Resolver<TResolversTypes['Session'], ParentType, ContextType>;
  currentUser?: Resolver<TResolversTypes['User'], ParentType, ContextType>;
  customDocumentVariants?: Resolver<Array<TResolversTypes['CustomDocumentSubType']>, ParentType, ContextType, RequireFields<TQueryCustomDocumentVariantsArgs, 'type'>>;
  customDocuments?: Resolver<Array<TResolversTypes['CustomDocument']>, ParentType, ContextType>;
  customOrganizations?: Resolver<Array<TResolversTypes['CustomOrganization']>, ParentType, ContextType>;
  customType?: Resolver<Maybe<TResolversTypes['CustomOrganization']>, ParentType, ContextType, RequireFields<TQueryCustomTypeArgs, 'type'>>;
  deficiencies?: Resolver<Array<TResolversTypes['Deficiency']>, ParentType, ContextType>;
  deficienciesByMedicalRecord?: Resolver<Array<TResolversTypes['Deficiency']>, ParentType, ContextType, RequireFields<TQueryDeficienciesByMedicalRecordArgs, 'medicalRecord'>>;
  deficiencisByRegistration?: Resolver<Array<TResolversTypes['Deficiency']>, ParentType, ContextType, RequireFields<TQueryDeficiencisByRegistrationArgs, 'erpId' | 'individualRegistration'>>;
  deficiency?: Resolver<TResolversTypes['Deficiency'], ParentType, ContextType, RequireFields<TQueryDeficiencyArgs, 'id'>>;
  deliverySpareParts?: Resolver<TResolversTypes['DeliverySpareParts'], ParentType, ContextType, RequireFields<TQueryDeliverySparePartsArgs, 'id'>>;
  deliverySparePartsByIpe?: Resolver<Array<TResolversTypes['DeliverySpareParts']>, ParentType, ContextType, RequireFields<TQueryDeliverySparePartsByIpeArgs, 'ca' | 'personId'>>;
  deliverySparePartsByIpeDelivery?: Resolver<Array<TResolversTypes['DeliverySpareParts']>, ParentType, ContextType, RequireFields<TQueryDeliverySparePartsByIpeDeliveryArgs, 'ipeDeliveryId'>>;
  deliverySparePartsByPerson?: Resolver<Array<TResolversTypes['DeliverySpareParts']>, ParentType, ContextType, RequireFields<TQueryDeliverySparePartsByPersonArgs, 'personId'>>;
  deliverySparePartsByProduct?: Resolver<Array<TResolversTypes['DeliverySpareParts']>, ParentType, ContextType, RequireFields<TQueryDeliverySparePartsByProductArgs, 'productId'>>;
  department?: Resolver<TResolversTypes['Department'], ParentType, ContextType, RequireFields<TQueryDepartmentArgs, 'id'>>;
  departments?: Resolver<TResolversTypes['PaginatedDepartment'], ParentType, ContextType, RequireFields<TQueryDepartmentsArgs, 'query'>>;
  departmentsFilterByBranch?: Resolver<Array<TResolversTypes['Department']>, ParentType, ContextType, RequireFields<TQueryDepartmentsFilterByBranchArgs, 'branchId' | 'departments'>>;
  diagnostic?: Resolver<TResolversTypes['Diagnostic'], ParentType, ContextType, RequireFields<TQueryDiagnosticArgs, 'id'>>;
  diagnosticByConsultation?: Resolver<TResolversTypes['Diagnostic'], ParentType, ContextType, RequireFields<TQueryDiagnosticByConsultationArgs, 'consultationId'>>;
  doctorSuggestions?: Resolver<TResolversTypes['PaginatedPerson'], ParentType, ContextType, RequireFields<TQueryDoctorSuggestionsArgs, 'query'>>;
  downloadSignedDocuments?: Resolver<TResolversTypes['SignBrokerUrlDownloadResponse'], ParentType, ContextType, RequireFields<TQueryDownloadSignedDocumentsArgs, 'input'>>;
  eSocialIndicators?: Resolver<TResolversTypes['ESocialQueueIndicators'], ParentType, ContextType, Partial<TQueryESocialIndicatorsArgs>>;
  economicActivity?: Resolver<TResolversTypes['EconomicActivity'], ParentType, ContextType, RequireFields<TQueryEconomicActivityArgs, 'id'>>;
  effectiveDocumentTemplate?: Resolver<TResolversTypes['EffectiveDocumentTemplate'], ParentType, ContextType, RequireFields<TQueryEffectiveDocumentTemplateArgs, 'type'>>;
  elaboratorDocument?: Resolver<TResolversTypes['ElaboratorDocument'], ParentType, ContextType, RequireFields<TQueryElaboratorDocumentArgs, 'personId' | 'roleType'>>;
  electionComission?: Resolver<TResolversTypes['ElectionComission'], ParentType, ContextType, RequireFields<TQueryElectionComissionArgs, 'id'>>;
  electionComissionByMandate?: Resolver<Array<TResolversTypes['ElectionComission']>, ParentType, ContextType, RequireFields<TQueryElectionComissionByMandateArgs, 'mandate'>>;
  electionComissionByPerson?: Resolver<Array<TResolversTypes['ElectionComission']>, ParentType, ContextType, RequireFields<TQueryElectionComissionByPersonArgs, 'person'>>;
  employeeAnamneses?: Resolver<Array<TResolversTypes['EmployeeAnamnesis']>, ParentType, ContextType>;
  employeeAnamnesisQuiz?: Resolver<TResolversTypes['Quiz'], ParentType, ContextType, RequireFields<TQueryEmployeeAnamnesisQuizArgs, 'consultationId'>>;
  employeeConsultationResults?: Resolver<Array<TResolversTypes['ReleasableResult']>, ParentType, ContextType, RequireFields<TQueryEmployeeConsultationResultsArgs, 'consultationId'>>;
  employeeConsultations?: Resolver<Array<TResolversTypes['EmployeeConsultation']>, ParentType, ContextType>;
  employeeHasCandidate?: Resolver<Maybe<TResolversTypes['Candidate']>, ParentType, ContextType, RequireFields<TQueryEmployeeHasCandidateArgs, 'mandate'>>;
  employeeHasVote?: Resolver<Maybe<TResolversTypes['Vote']>, ParentType, ContextType, RequireFields<TQueryEmployeeHasVoteArgs, 'mandate'>>;
  employeeInfo?: Resolver<Maybe<TResolversTypes['Employee']>, ParentType, ContextType>;
  employeeIpeDeliveries?: Resolver<TResolversTypes['PaginatedEmployeeIpeDelivery'], ParentType, ContextType, RequireFields<TQueryEmployeeIpeDeliveriesArgs, 'query'>>;
  employeeIpes?: Resolver<Array<TResolversTypes['EmployeeIpes']>, ParentType, ContextType>;
  employeeLogin?: Resolver<TResolversTypes['Login'], ParentType, ContextType, RequireFields<TQueryEmployeeLoginArgs, 'generate'>>;
  employeeMandates?: Resolver<Array<TResolversTypes['EmployeeMandateEvent']>, ParentType, ContextType, RequireFields<TQueryEmployeeMandatesArgs, 'eventType'>>;
  employeeQuiz?: Resolver<TResolversTypes['Quiz'], ParentType, ContextType, RequireFields<TQueryEmployeeQuizArgs, 'quizId'>>;
  employeeQuizzes?: Resolver<Array<TResolversTypes['EmployeeQuiz']>, ParentType, ContextType>;
  employeeRisks?: Resolver<Array<TResolversTypes['EmployeeRisk']>, ParentType, ContextType>;
  employeeRisksDashboard?: Resolver<TResolversTypes['EmployeeRiskDashboard'], ParentType, ContextType, RequireFields<TQueryEmployeeRisksDashboardArgs, 'filter' | 'identifier'>>;
  employeeTask?: Resolver<TResolversTypes['EmployeeTask'], ParentType, ContextType, RequireFields<TQueryEmployeeTaskArgs, 'id'>>;
  endElectionPeriod?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType, RequireFields<TQueryEndElectionPeriodArgs, 'mandateId'>>;
  envReportSuggestions?: Resolver<TResolversTypes['PaginatedEnvironmentalReportSuggestion'], ParentType, ContextType, RequireFields<TQueryEnvReportSuggestionsArgs, 'query'>>;
  environmentalReport?: Resolver<TResolversTypes['EnvironmentalReport'], ParentType, ContextType, RequireFields<TQueryEnvironmentalReportArgs, 'id'>>;
  environmentalReportBiometry?: Resolver<Maybe<TResolversTypes['EnvironmentalReportBiometry']>, ParentType, ContextType, RequireFields<TQueryEnvironmentalReportBiometryArgs, 'environmentalReportId'>>;
  environmentalReportFace?: Resolver<Maybe<TResolversTypes['EnvironmentalReportFace']>, ParentType, ContextType, RequireFields<TQueryEnvironmentalReportFaceArgs, 'environmentalReportId'>>;
  environmentalReportSummary?: Resolver<TResolversTypes['Summary'], ParentType, ContextType, RequireFields<TQueryEnvironmentalReportSummaryArgs, 'getCounter' | 'query'>>;
  environmentalReportVersionDownloadUrl?: Resolver<TResolversTypes['String'], ParentType, ContextType, RequireFields<TQueryEnvironmentalReportVersionDownloadUrlArgs, 'id'>>;
  environmentalReportVersions?: Resolver<Array<TResolversTypes['EnvironmentalReportVersion']>, ParentType, ContextType, RequireFields<TQueryEnvironmentalReportVersionsArgs, 'environmentalReportId'>>;
  environmentalReports?: Resolver<TResolversTypes['PaginatedEnvironmentalReport'], ParentType, ContextType, RequireFields<TQueryEnvironmentalReportsArgs, 'orderBy' | 'query'>>;
  equipmentByCostCenter?: Resolver<TResolversTypes['EquipmentByCostCenter'], ParentType, ContextType, RequireFields<TQueryEquipmentByCostCenterArgs, 'id'>>;
  equipmentByCostCenterByCostCenter?: Resolver<Array<TResolversTypes['EquipmentByCostCenter']>, ParentType, ContextType, RequireFields<TQueryEquipmentByCostCenterByCostCenterArgs, 'costCenter'>>;
  equipmentByOccupation?: Resolver<TResolversTypes['EquipmentByOccupation'], ParentType, ContextType, RequireFields<TQueryEquipmentByOccupationArgs, 'id'>>;
  equipmentByOccupationByOccupation?: Resolver<Array<TResolversTypes['EquipmentByOccupation']>, ParentType, ContextType, RequireFields<TQueryEquipmentByOccupationByOccupationArgs, 'occupation'>>;
  esocialSyncingBranches?: Resolver<Array<TResolversTypes['Branch']>, ParentType, ContextType>;
  exam?: Resolver<TResolversTypes['Exam'], ParentType, ContextType, RequireFields<TQueryExamArgs, 'id'>>;
  examAlterationTrendByMedicalRecord?: Resolver<Array<TResolversTypes['ExamAlterationTrend']>, ParentType, ContextType, RequireFields<TQueryExamAlterationTrendByMedicalRecordArgs, 'medicalRecordId'>>;
  examAudiometryByConsultation?: Resolver<Maybe<TResolversTypes['ExamAudiometry']>, ParentType, ContextType, RequireFields<TQueryExamAudiometryByConsultationArgs, 'consultationId'>>;
  examDiagnosticCountByMedicalRecord?: Resolver<Array<TResolversTypes['ExamDiagnosticCount']>, ParentType, ContextType, RequireFields<TQueryExamDiagnosticCountByMedicalRecordArgs, 'medicalRecordId'>>;
  examDiagnosticImage?: Resolver<TResolversTypes['ExamDiagnosticImage'], ParentType, ContextType, RequireFields<TQueryExamDiagnosticImageArgs, 'id'>>;
  examDiagnosticImageByConsultation?: Resolver<Maybe<TResolversTypes['ExamDiagnosticImage']>, ParentType, ContextType, RequireFields<TQueryExamDiagnosticImageByConsultationArgs, 'consultationId'>>;
  examItemByConsultation?: Resolver<TResolversTypes['ExamItem'], ParentType, ContextType, RequireFields<TQueryExamItemByConsultationArgs, 'consultationId'>>;
  examNormalByConsultation?: Resolver<Maybe<TResolversTypes['ExamNormal']>, ParentType, ContextType, RequireFields<TQueryExamNormalByConsultationArgs, 'consultationId'>>;
  examNormalResults?: Resolver<TResolversTypes['PaginatedExamNormalResult'], ParentType, ContextType, Partial<TQueryExamNormalResultsArgs>>;
  examOtological?: Resolver<TResolversTypes['ExamOtological'], ParentType, ContextType, RequireFields<TQueryExamOtologicalArgs, 'id'>>;
  examOtologicalByConsultation?: Resolver<Maybe<TResolversTypes['ExamOtological']>, ParentType, ContextType, RequireFields<TQueryExamOtologicalByConsultationArgs, 'consultationId'>>;
  examResultsByMedicalRecord?: Resolver<TResolversTypes['ExamResultsByMedicalRecord'], ParentType, ContextType, RequireFields<TQueryExamResultsByMedicalRecordArgs, 'medicalRecordId'>>;
  examSpirometryByConsultation?: Resolver<Maybe<TResolversTypes['ExamSpirometry']>, ParentType, ContextType, RequireFields<TQueryExamSpirometryByConsultationArgs, 'consultationId'>>;
  examTimelineByMedicalRecord?: Resolver<Array<TResolversTypes['ExamTimelineEntry']>, ParentType, ContextType, RequireFields<TQueryExamTimelineByMedicalRecordArgs, 'medicalRecordId'>>;
  examToxicologicalByConsultation?: Resolver<Maybe<TResolversTypes['ExamToxicological']>, ParentType, ContextType, RequireFields<TQueryExamToxicologicalByConsultationArgs, 'consultationId'>>;
  exams?: Resolver<TResolversTypes['PaginatedExam'], ParentType, ContextType, RequireFields<TQueryExamsArgs, 'query'>>;
  examsAudiometryByMedicalRecord?: Resolver<Array<TResolversTypes['ExamAudiometry']>, ParentType, ContextType, RequireFields<TQueryExamsAudiometryByMedicalRecordArgs, 'medicalRecordId'>>;
  examsAudiometryByMedicalRecordForComparative?: Resolver<Array<TResolversTypes['ExamAudiometry']>, ParentType, ContextType, RequireFields<TQueryExamsAudiometryByMedicalRecordForComparativeArgs, 'medicalRecordId'>>;
  examsByPerson?: Resolver<Array<TResolversTypes['ExamByPerson']>, ParentType, ContextType, RequireFields<TQueryExamsByPersonArgs, 'personId'>>;
  examsByRisk?: Resolver<Array<TResolversTypes['ExamByRisk']>, ParentType, ContextType, RequireFields<TQueryExamsByRiskArgs, 'riskId'>>;
  examsByTag?: Resolver<Array<TResolversTypes['ExamByTag']>, ParentType, ContextType, RequireFields<TQueryExamsByTagArgs, 'estimatedDate' | 'tag' | 'type'>>;
  examsDiagnosticImageByMedicalRecord?: Resolver<Array<TResolversTypes['ExamDiagnosticImage']>, ParentType, ContextType, RequireFields<TQueryExamsDiagnosticImageByMedicalRecordArgs, 'medicalRecordId'>>;
  examsExamItemsByMedicalRecord?: Resolver<Array<TResolversTypes['ExamItem']>, ParentType, ContextType, RequireFields<TQueryExamsExamItemsByMedicalRecordArgs, 'examId' | 'medicalRecordId'>>;
  examsForContract?: Resolver<TResolversTypes['PaginatedExam'], ParentType, ContextType, RequireFields<TQueryExamsForContractArgs, 'query'>>;
  examsIbmpByMedicalRecord?: Resolver<Array<TResolversTypes['ResultExamIbmp']>, ParentType, ContextType, RequireFields<TQueryExamsIbmpByMedicalRecordArgs, 'medicalRecordId'>>;
  examsIbmpByMedicalRecordForComparative?: Resolver<Array<TResolversTypes['ResultExamIbmpGroup']>, ParentType, ContextType, RequireFields<TQueryExamsIbmpByMedicalRecordForComparativeArgs, 'medicalRecordId'>>;
  examsItemByMedicalRecordForComparative?: Resolver<Array<TResolversTypes['ResultExamItemGroup']>, ParentType, ContextType, RequireFields<TQueryExamsItemByMedicalRecordForComparativeArgs, 'examId' | 'medicalRecordId'>>;
  examsNormalByMedicalRecord?: Resolver<Array<TResolversTypes['ExamNormal']>, ParentType, ContextType, RequireFields<TQueryExamsNormalByMedicalRecordArgs, 'medicalRecordId'>>;
  examsOrthoRaterByMedicalRecord?: Resolver<Array<TResolversTypes['OrthoRater']>, ParentType, ContextType, RequireFields<TQueryExamsOrthoRaterByMedicalRecordArgs, 'medicalRecordId'>>;
  examsOrthoRaterByMedicalRecordForComparative?: Resolver<Array<TResolversTypes['ResultExamOrthoRaterForComparative']>, ParentType, ContextType, RequireFields<TQueryExamsOrthoRaterByMedicalRecordForComparativeArgs, 'medicalRecordId'>>;
  examsOtologicalByMedicalRecord?: Resolver<Array<TResolversTypes['ExamOtological']>, ParentType, ContextType, RequireFields<TQueryExamsOtologicalByMedicalRecordArgs, 'medicalRecordId'>>;
  examsSnellenByMedicalRecord?: Resolver<Array<TResolversTypes['Snellen']>, ParentType, ContextType, RequireFields<TQueryExamsSnellenByMedicalRecordArgs, 'medicalRecordId'>>;
  examsSnellenByMedicalRecordForComparative?: Resolver<Array<TResolversTypes['ResultExamSnellenForComparative']>, ParentType, ContextType, RequireFields<TQueryExamsSnellenByMedicalRecordForComparativeArgs, 'medicalRecordId'>>;
  examsSpirometryByMedicalRecord?: Resolver<Array<TResolversTypes['ExamSpirometry']>, ParentType, ContextType, RequireFields<TQueryExamsSpirometryByMedicalRecordArgs, 'medicalRecordId'>>;
  examsSpirometryByMedicalRecordForComparative?: Resolver<Array<TResolversTypes['ResultExamSpirometryGroup']>, ParentType, ContextType, RequireFields<TQueryExamsSpirometryByMedicalRecordForComparativeArgs, 'medicalRecordId'>>;
  examsToxicologicalByMedicalRecord?: Resolver<Array<TResolversTypes['ExamToxicological']>, ParentType, ContextType, RequireFields<TQueryExamsToxicologicalByMedicalRecordArgs, 'medicalRecordId'>>;
  expectedGoal?: Resolver<TResolversTypes['ExpectedGoal'], ParentType, ContextType, RequireFields<TQueryExpectedGoalArgs, 'id'>>;
  expense?: Resolver<TResolversTypes['Expense'], ParentType, ContextType, RequireFields<TQueryExpenseArgs, 'id'>>;
  expenses?: Resolver<TResolversTypes['PaginatedExpense'], ParentType, ContextType, RequireFields<TQueryExpensesArgs, 'query'>>;
  exportDashboard?: Resolver<TResolversTypes['DashboardExport'], ParentType, ContextType>;
  exposureGroup?: Resolver<TResolversTypes['ExposureGroup'], ParentType, ContextType, RequireFields<TQueryExposureGroupArgs, 'id'>>;
  exposureGroupCostCenter?: Resolver<TResolversTypes['ExposureGroupCostCenter'], ParentType, ContextType, RequireFields<TQueryExposureGroupCostCenterArgs, 'id'>>;
  exposureGroupCostCentersByCostCenter?: Resolver<Array<TResolversTypes['ExposureGroupCostCenter']>, ParentType, ContextType, RequireFields<TQueryExposureGroupCostCentersByCostCenterArgs, 'costCenterId'>>;
  exposureGroupCostCentersByExposureGroup?: Resolver<Array<TResolversTypes['ExposureGroupCostCenter']>, ParentType, ContextType, RequireFields<TQueryExposureGroupCostCentersByExposureGroupArgs, 'exposureGroupId'>>;
  exposureGroupDepartment?: Resolver<TResolversTypes['ExposureGroupDepartment'], ParentType, ContextType, RequireFields<TQueryExposureGroupDepartmentArgs, 'id'>>;
  exposureGroupDepartmentByDepartment?: Resolver<Array<TResolversTypes['ExposureGroupDepartment']>, ParentType, ContextType, RequireFields<TQueryExposureGroupDepartmentByDepartmentArgs, 'departmentId'>>;
  exposureGroupDepartmentByExposureGroup?: Resolver<Array<TResolversTypes['ExposureGroupDepartment']>, ParentType, ContextType, RequireFields<TQueryExposureGroupDepartmentByExposureGroupArgs, 'exposureGroupId'>>;
  exposureGroupOccupation?: Resolver<TResolversTypes['ExposureGroupOccupation'], ParentType, ContextType, RequireFields<TQueryExposureGroupOccupationArgs, 'id'>>;
  exposureGroupOccupationByExposureGroup?: Resolver<Array<TResolversTypes['ExposureGroupOccupation']>, ParentType, ContextType, RequireFields<TQueryExposureGroupOccupationByExposureGroupArgs, 'exposureGroupId'>>;
  exposureGroupOccupationByOccupation?: Resolver<Array<TResolversTypes['ExposureGroupOccupation']>, ParentType, ContextType, RequireFields<TQueryExposureGroupOccupationByOccupationArgs, 'occupationId'>>;
  exposureGroupPerson?: Resolver<TResolversTypes['ExposureGroupPerson'], ParentType, ContextType, RequireFields<TQueryExposureGroupPersonArgs, 'id'>>;
  exposureGroupPersonByExposureGroup?: Resolver<Array<TResolversTypes['ExposureGroupPerson']>, ParentType, ContextType, RequireFields<TQueryExposureGroupPersonByExposureGroupArgs, 'exposureGroupId'>>;
  exposureGroupPersonByPerson?: Resolver<Array<TResolversTypes['ExposureGroupPerson']>, ParentType, ContextType, RequireFields<TQueryExposureGroupPersonByPersonArgs, 'personId'>>;
  exposureGroupTask?: Resolver<TResolversTypes['ExposureGroupTask'], ParentType, ContextType, RequireFields<TQueryExposureGroupTaskArgs, 'id'>>;
  exposureGroupTaskByExposureGroup?: Resolver<Array<TResolversTypes['ExposureGroupTask']>, ParentType, ContextType, RequireFields<TQueryExposureGroupTaskByExposureGroupArgs, 'exposureGroupId'>>;
  exposureGroupTaskByTask?: Resolver<Array<TResolversTypes['ExposureGroupTask']>, ParentType, ContextType, RequireFields<TQueryExposureGroupTaskByTaskArgs, 'taskId'>>;
  exposureGroups?: Resolver<TResolversTypes['PaginatedExposureGroup'], ParentType, ContextType, RequireFields<TQueryExposureGroupsArgs, 'query'>>;
  extinguishingSystem?: Resolver<TResolversTypes['ExtinguishingSystem'], ParentType, ContextType, RequireFields<TQueryExtinguishingSystemArgs, 'id'>>;
  extinguishingSystemDashboard?: Resolver<TResolversTypes['ExtinguishingSystemDashboard'], ParentType, ContextType, RequireFields<TQueryExtinguishingSystemDashboardArgs, 'filter' | 'identifier'>>;
  extinguishingSystemSummary?: Resolver<TResolversTypes['Summary'], ParentType, ContextType, RequireFields<TQueryExtinguishingSystemSummaryArgs, 'getCounter' | 'query'>>;
  extinguishingSystems?: Resolver<TResolversTypes['PaginatedExtinguishingSystem'], ParentType, ContextType, RequireFields<TQueryExtinguishingSystemsArgs, 'orderBy' | 'query'>>;
  featureAccess?: Resolver<TResolversTypes['ValidationReturn'], ParentType, ContextType, RequireFields<TQueryFeatureAccessArgs, 'feature'>>;
  filterPreference?: Resolver<Maybe<TResolversTypes['UserFilterPreferenceResult']>, ParentType, ContextType, RequireFields<TQueryFilterPreferenceArgs, 'module'>>;
  findAdUrl?: Resolver<TResolversTypes['String'], ParentType, ContextType, RequireFields<TQueryFindAdUrlArgs, 'email'>>;
  findAllApiAccess?: Resolver<Array<TResolversTypes['ApiAccess']>, ParentType, ContextType>;
  findAllIntegrationConfigurationByBranch?: Resolver<TResolversTypes['IntegrationConfiguration'], ParentType, ContextType, RequireFields<TQueryFindAllIntegrationConfigurationByBranchArgs, 'branchId'>>;
  findAnyFeatureCollision?: Resolver<Array<TResolversTypes['CollisionReturn']>, ParentType, ContextType>;
  findBlockedConfigsByIntegration?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType, RequireFields<TQueryFindBlockedConfigsByIntegrationArgs, 'integration'>>;
  findDoctorsWithAccredited?: Resolver<Array<TResolversTypes['CategorizedInputData']>, ParentType, ContextType, Partial<TQueryFindDoctorsWithAccreditedArgs>>;
  findEndpoints?: Resolver<Array<TResolversTypes['Endpoint']>, ParentType, ContextType, RequireFields<TQueryFindEndpointsArgs, 'input'>>;
  findExpectedExams?: Resolver<TResolversTypes['PaginatedExpectedConsultations'], ParentType, ContextType, RequireFields<TQueryFindExpectedExamsArgs, 'query'>>;
  findExpectedExamsByMedicalRecord?: Resolver<TResolversTypes['ExpectedConsultation'], ParentType, ContextType, RequireFields<TQueryFindExpectedExamsByMedicalRecordArgs, 'consultationType' | 'medicalRecordId'>>;
  findFeaturesRelatedToFlag?: Resolver<Array<TResolversTypes['FeatureReturn']>, ParentType, ContextType, RequireFields<TQueryFindFeaturesRelatedToFlagArgs, 'flag'>>;
  findFlagsRelatedToFeature?: Resolver<Array<TResolversTypes['FlagReturn']>, ParentType, ContextType, RequireFields<TQueryFindFlagsRelatedToFeatureArgs, 'feature'>>;
  findFloatingFeatures?: Resolver<Array<TResolversTypes['Feature']>, ParentType, ContextType>;
  findFloatingFlags?: Resolver<Array<TResolversTypes['Flag']>, ParentType, ContextType>;
  findIntegrationCards?: Resolver<Array<TResolversTypes['Endpoint']>, ParentType, ContextType, RequireFields<TQueryFindIntegrationCardsArgs, 'integrationContext' | 'organizationId' | 'type'>>;
  findLastTerms?: Resolver<Array<TResolversTypes['PolicyTerms']>, ParentType, ContextType>;
  findLogoutAdUrl?: Resolver<TResolversTypes['String'], ParentType, ContextType, Partial<TQueryFindLogoutAdUrlArgs>>;
  findPolicyTermById?: Resolver<TResolversTypes['PolicyTerms'], ParentType, ContextType, RequireFields<TQueryFindPolicyTermByIdArgs, 'id'>>;
  findProductsByCA?: Resolver<Array<TResolversTypes['Product']>, ParentType, ContextType, RequireFields<TQueryFindProductsByCaArgs, 'ipeManufacturerId'>>;
  findProductsByEquipment?: Resolver<Array<TResolversTypes['Product']>, ParentType, ContextType, RequireFields<TQueryFindProductsByEquipmentArgs, 'equipmentName'>>;
  findUserNeedAgree?: Resolver<Array<TResolversTypes['PolicyTerms']>, ParentType, ContextType>;
  findWebhook?: Resolver<TResolversTypes['Webhook'], ParentType, ContextType, RequireFields<TQueryFindWebhookArgs, 'id'>>;
  findWebhookQueue?: Resolver<TResolversTypes['WebhookQueue'], ParentType, ContextType, RequireFields<TQueryFindWebhookQueueArgs, 'id'>>;
  findWebhookQueues?: Resolver<TResolversTypes['PaginatedWebhookQueue'], ParentType, ContextType, RequireFields<TQueryFindWebhookQueuesArgs, 'query'>>;
  findWebhooks?: Resolver<Array<TResolversTypes['Webhook']>, ParentType, ContextType>;
  fireBrigade?: Resolver<TResolversTypes['FireBrigade'], ParentType, ContextType, RequireFields<TQueryFireBrigadeArgs, 'id'>>;
  fireBrigadeComponent?: Resolver<TResolversTypes['FireBrigadeComponent'], ParentType, ContextType, RequireFields<TQueryFireBrigadeComponentArgs, 'id'>>;
  fireBrigadeComponentsByFireBrigade?: Resolver<Array<TResolversTypes['FireBrigadeComponent']>, ParentType, ContextType, RequireFields<TQueryFireBrigadeComponentsByFireBrigadeArgs, 'fireBrigade'>>;
  fireBrigadeDashboard?: Resolver<TResolversTypes['FireBrigadeDashboard'], ParentType, ContextType, Partial<TQueryFireBrigadeDashboardArgs>>;
  fireBrigadeExam?: Resolver<TResolversTypes['FireBrigadeExam'], ParentType, ContextType, RequireFields<TQueryFireBrigadeExamArgs, 'id'>>;
  fireBrigadeExamByFireBrigade?: Resolver<Array<TResolversTypes['FireBrigadeExam']>, ParentType, ContextType, RequireFields<TQueryFireBrigadeExamByFireBrigadeArgs, 'fireBrigade'>>;
  fireBrigadeMeeting?: Resolver<TResolversTypes['FireBrigadeMeeting'], ParentType, ContextType, RequireFields<TQueryFireBrigadeMeetingArgs, 'id'>>;
  fireBrigadeMeetingByActive?: Resolver<Array<TResolversTypes['FireBrigadeMeeting']>, ParentType, ContextType, RequireFields<TQueryFireBrigadeMeetingByActiveArgs, 'fireBrigadeId'>>;
  fireBrigadeMeetingByDate?: Resolver<Array<TResolversTypes['FireBrigadeMeeting']>, ParentType, ContextType, RequireFields<TQueryFireBrigadeMeetingByDateArgs, 'date' | 'fireBrigadeId'>>;
  fireBrigadeMeetingBySubject?: Resolver<Array<TResolversTypes['FireBrigadeMeeting']>, ParentType, ContextType, RequireFields<TQueryFireBrigadeMeetingBySubjectArgs, 'fireBrigadeId' | 'subject'>>;
  fireBrigadeMeetings?: Resolver<Array<TResolversTypes['FireBrigadeMeeting']>, ParentType, ContextType, RequireFields<TQueryFireBrigadeMeetingsArgs, 'fireBrigadeId'>>;
  fireBrigadeMeetingsByFireBrigade?: Resolver<Array<TResolversTypes['FireBrigadeMeeting']>, ParentType, ContextType, RequireFields<TQueryFireBrigadeMeetingsByFireBrigadeArgs, 'fireBrigade'>>;
  fireBrigadeOccurrence?: Resolver<TResolversTypes['FireBrigadeOccurrence'], ParentType, ContextType, RequireFields<TQueryFireBrigadeOccurrenceArgs, 'id'>>;
  fireBrigadeOccurrences?: Resolver<Array<TResolversTypes['FireBrigadeOccurrence']>, ParentType, ContextType, RequireFields<TQueryFireBrigadeOccurrencesArgs, 'fireBrigadeId'>>;
  fireBrigadeTraining?: Resolver<TResolversTypes['FireBrigadeTraining'], ParentType, ContextType, RequireFields<TQueryFireBrigadeTrainingArgs, 'id'>>;
  fireBrigadeTrainingsByFireBrigade?: Resolver<Array<TResolversTypes['FireBrigadeTraining']>, ParentType, ContextType, RequireFields<TQueryFireBrigadeTrainingsByFireBrigadeArgs, 'fireBrigade'>>;
  fireBrigades?: Resolver<TResolversTypes['PaginatedFireBrigade'], ParentType, ContextType, RequireFields<TQueryFireBrigadesArgs, 'query'>>;
  firstSteps?: Resolver<TResolversTypes['FirstSteps'], ParentType, ContextType>;
  frequencyIndex?: Resolver<Array<TResolversTypes['FrequencyIndex']>, ParentType, ContextType>;
  gAccidentCauses?: Resolver<TResolversTypes['PaginatedGenericAccidentCause'], ParentType, ContextType, RequireFields<TQueryGAccidentCausesArgs, 'query'>>;
  gAccidentCodes?: Resolver<TResolversTypes['PaginatedAccidentCode'], ParentType, ContextType, RequireFields<TQueryGAccidentCodesArgs, 'query'>>;
  gAccidentObjects?: Resolver<TResolversTypes['PaginatedAccidentObject'], ParentType, ContextType, RequireFields<TQueryGAccidentObjectsArgs, 'query'>>;
  gAccidentTypes?: Resolver<TResolversTypes['PaginatedAccidentType'], ParentType, ContextType, RequireFields<TQueryGAccidentTypesArgs, 'query' | 'type'>>;
  gActivePrinciples?: Resolver<TResolversTypes['PaginatedGenericActivePrinciple'], ParentType, ContextType, RequireFields<TQueryGActivePrinciplesArgs, 'query'>>;
  gActivitiesGroups?: Resolver<TResolversTypes['PaginatedActivityGroup'], ParentType, ContextType, RequireFields<TQueryGActivitiesGroupsArgs, 'query'>>;
  gActivitiesIcds?: Resolver<TResolversTypes['PaginatedActivityIcd'], ParentType, ContextType, RequireFields<TQueryGActivitiesIcdsArgs, 'query'>>;
  gBiologicalMonitoringExamGroups?: Resolver<TResolversTypes['PaginatedGenericBiologicalMonitoringExamGroup'], ParentType, ContextType, RequireFields<TQueryGBiologicalMonitoringExamGroupsArgs, 'query'>>;
  gBodiesParts?: Resolver<TResolversTypes['PaginatedBodyPart'], ParentType, ContextType, RequireFields<TQueryGBodiesPartsArgs, 'query'>>;
  gCostCenters?: Resolver<TResolversTypes['PaginatedGenericCostCenter'], ParentType, ContextType, RequireFields<TQueryGCostCentersArgs, 'query'>>;
  gEconomicActivities?: Resolver<TResolversTypes['PaginatedEconomicActivity'], ParentType, ContextType, RequireFields<TQueryGEconomicActivitiesArgs, 'query'>>;
  gEvents?: Resolver<TResolversTypes['PaginatedEvent'], ParentType, ContextType, RequireFields<TQueryGEventsArgs, 'query'>>;
  gExaminationProcedures?: Resolver<TResolversTypes['PaginatedGenericExaminationProcedure'], ParentType, ContextType, RequireFields<TQueryGExaminationProceduresArgs, 'query'>>;
  gExams?: Resolver<TResolversTypes['PaginatedGenericExam'], ParentType, ContextType, RequireFields<TQueryGExamsArgs, 'query'>>;
  gExpenses?: Resolver<TResolversTypes['PaginatedGenericExpense'], ParentType, ContextType, RequireFields<TQueryGExpensesArgs, 'query'>>;
  gHealthPrograms?: Resolver<TResolversTypes['PaginatedGenericHealthProgram'], ParentType, ContextType, RequireFields<TQueryGHealthProgramsArgs, 'query'>>;
  gIcdGroups?: Resolver<TResolversTypes['PaginatedIcdGroups'], ParentType, ContextType, RequireFields<TQueryGIcdGroupsArgs, 'query'>>;
  gIcds?: Resolver<TResolversTypes['PaginatedIcds'], ParentType, ContextType, RequireFields<TQueryGIcdsArgs, 'query'>>;
  gInjuriesNatures?: Resolver<TResolversTypes['PaginatedInjuryNature'], ParentType, ContextType, RequireFields<TQueryGInjuriesNaturesArgs, 'query'>>;
  gIpe?: Resolver<TResolversTypes['Ipe'], ParentType, ContextType, RequireFields<TQueryGIpeArgs, 'id'>>;
  gIpeManufacturer?: Resolver<TResolversTypes['IpeManufacturer'], ParentType, ContextType, RequireFields<TQueryGIpeManufacturerArgs, 'caCode'>>;
  gIpes?: Resolver<TResolversTypes['PaginatedIpe'], ParentType, ContextType, RequireFields<TQueryGIpesArgs, 'query'>>;
  gIpesByCaCode?: Resolver<TResolversTypes['PaginatedIpeManufacturer'], ParentType, ContextType, RequireFields<TQueryGIpesByCaCodeArgs, 'query'>>;
  gIpesManufacturerByCaCode?: Resolver<TResolversTypes['PaginatedIpeManufacturer'], ParentType, ContextType, RequireFields<TQueryGIpesManufacturerByCaCodeArgs, 'query'>>;
  gIpesManufacturerByCaCodeWithoutEquipment?: Resolver<TResolversTypes['PaginatedIpeManufacturer'], ParentType, ContextType, RequireFields<TQueryGIpesManufacturerByCaCodeWithoutEquipmentArgs, 'query'>>;
  gIpesManufacturerByProduct?: Resolver<TResolversTypes['PaginatedIpeManufacturer'], ParentType, ContextType, RequireFields<TQueryGIpesManufacturerByProductArgs, 'equipmentName' | 'productId' | 'query'>>;
  gLaboratories?: Resolver<TResolversTypes['PaginatedGenericLaboratory'], ParentType, ContextType, RequireFields<TQueryGLaboratoriesArgs, 'query'>>;
  gManufacturer?: Resolver<TResolversTypes['Manufacturer'], ParentType, ContextType, RequireFields<TQueryGManufacturerArgs, 'cnpj'>>;
  gManufactureres?: Resolver<TResolversTypes['PaginatedManufacturer'], ParentType, ContextType, RequireFields<TQueryGManufactureresArgs, 'query'>>;
  gMeasuringInstruments?: Resolver<TResolversTypes['PaginatedGenericMeasuringInstrument'], ParentType, ContextType, RequireFields<TQueryGMeasuringInstrumentsArgs, 'query'>>;
  gMedicines?: Resolver<TResolversTypes['PaginatedGenericMedicine'], ParentType, ContextType, RequireFields<TQueryGMedicinesArgs, 'query'>>;
  gOccupations?: Resolver<TResolversTypes['PaginatedGenericOccupation'], ParentType, ContextType, RequireFields<TQueryGOccupationsArgs, 'query'>>;
  gPeriodicRanges?: Resolver<TResolversTypes['PaginatedGenericPeriodicRange'], ParentType, ContextType, RequireFields<TQueryGPeriodicRangesArgs, 'query'>>;
  gPublicPlaces?: Resolver<TResolversTypes['PaginatedGenericPublicPlace'], ParentType, ContextType, RequireFields<TQueryGPublicPlacesArgs, 'query'>>;
  gQuestionsGroups?: Resolver<TResolversTypes['PaginatedGenericQuestionGroup'], ParentType, ContextType, RequireFields<TQueryGQuestionsGroupsArgs, 'query'>>;
  gQuestionsQuizzes?: Resolver<TResolversTypes['PaginatedGenericQuestionQuiz'], ParentType, ContextType, RequireFields<TQueryGQuestionsQuizzesArgs, 'query'>>;
  gQuiz?: Resolver<TResolversTypes['GenericQuiz'], ParentType, ContextType, RequireFields<TQueryGQuizArgs, 'id'>>;
  gQuizzes?: Resolver<TResolversTypes['PaginatedGenericQuiz'], ParentType, ContextType, RequireFields<TQueryGQuizzesArgs, 'query'>>;
  gReportStructure?: Resolver<TResolversTypes['GenericReportStructure'], ParentType, ContextType, RequireFields<TQueryGReportStructureArgs, 'id'>>;
  gReportStructures?: Resolver<TResolversTypes['PaginatedGenericReportStructure'], ParentType, ContextType, RequireFields<TQueryGReportStructuresArgs, 'query'>>;
  gResponsesOptions?: Resolver<TResolversTypes['PaginatedGenericResponseOption'], ParentType, ContextType, RequireFields<TQueryGResponsesOptionsArgs, 'query'>>;
  gRiskAgent?: Resolver<TResolversTypes['GenericRiskAgent'], ParentType, ContextType, RequireFields<TQueryGRiskAgentArgs, 'id'>>;
  gRiskAgents?: Resolver<TResolversTypes['PaginatedGenericRiskAgent'], ParentType, ContextType, RequireFields<TQueryGRiskAgentsArgs, 'query'>>;
  gRolePermission?: Resolver<TResolversTypes['GenericRolePermission'], ParentType, ContextType, RequireFields<TQueryGRolePermissionArgs, 'description'>>;
  gRolePermissions?: Resolver<Array<TResolversTypes['GenericRolePermission']>, ParentType, ContextType, Partial<TQueryGRolePermissionsArgs>>;
  gStatements?: Resolver<TResolversTypes['PaginatedGenericStatementResponsibility'], ParentType, ContextType, RequireFields<TQueryGStatementsArgs, 'query'>>;
  gTasks?: Resolver<TResolversTypes['PaginatedGenericTask'], ParentType, ContextType, RequireFields<TQueryGTasksArgs, 'query'>>;
  gTrainings?: Resolver<TResolversTypes['PaginatedGenericTraining'], ParentType, ContextType, RequireFields<TQueryGTrainingsArgs, 'query'>>;
  gVaccines?: Resolver<TResolversTypes['PaginatedGenericVaccine'], ParentType, ContextType, RequireFields<TQueryGVaccinesArgs, 'query'>>;
  gWorkShifts?: Resolver<TResolversTypes['PaginatedGenericWorkShift'], ParentType, ContextType, RequireFields<TQueryGWorkShiftsArgs, 'query'>>;
  generateShortcut?: Resolver<TResolversTypes['ShortcutGenerated'], ParentType, ContextType, RequireFields<TQueryGenerateShortcutArgs, 'reportParams' | 'shortcut'>>;
  generateShortcutsByTitles?: Resolver<Array<TResolversTypes['ShortcutGenerated']>, ParentType, ContextType, RequireFields<TQueryGenerateShortcutsByTitlesArgs, 'reportParams' | 'shortcutTitles'>>;
  generateWebhookToken?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  generatingSource?: Resolver<TResolversTypes['GeneratingSource'], ParentType, ContextType, RequireFields<TQueryGeneratingSourceArgs, 'id'>>;
  generatingSources?: Resolver<TResolversTypes['PaginatedGeneratingSource'], ParentType, ContextType, RequireFields<TQueryGeneratingSourcesArgs, 'query'>>;
  getDocument?: Resolver<Array<TResolversTypes['SignBrokerGetDocument']>, ParentType, ContextType, RequireFields<TQueryGetDocumentArgs, 'documentId'>>;
  getDocuments?: Resolver<Array<TResolversTypes['SignBrokerGetDocuments']>, ParentType, ContextType, RequireFields<TQueryGetDocumentsArgs, 'input'>>;
  getDocumentsAndUpdateState?: Resolver<TResolversTypes['PaginatedGetDocuments'], ParentType, ContextType, RequireFields<TQueryGetDocumentsAndUpdateStateArgs, 'orderBy' | 'query'>>;
  getPatientName?: Resolver<TResolversTypes['MedicalRecordName'], ParentType, ContextType, RequireFields<TQueryGetPatientNameArgs, 'medicalRecordId'>>;
  getReportData?: Resolver<TResolversTypes['PppReport'], ParentType, ContextType, RequireFields<TQueryGetReportDataArgs, 'id' | 'params'>>;
  getRequiredIpes?: Resolver<Array<TResolversTypes['Ipe']>, ParentType, ContextType, RequireFields<TQueryGetRequiredIpesArgs, 'origin' | 'originId'>>;
  getSignCredentials?: Resolver<Maybe<TResolversTypes['SignCredentialsOutput']>, ParentType, ContextType>;
  getSignedThumbUrl?: Resolver<TResolversTypes['String'], ParentType, ContextType, RequireFields<TQueryGetSignedThumbUrlArgs, 'url'>>;
  getTablesToDownload?: Resolver<Array<TResolversTypes['TableProperties']>, ParentType, ContextType>;
  getXMLRiskMessage?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TQueryGetXmlRiskMessageArgs, 'params'>>;
  hasBlockedIntegrationConfigsByOrganization?: Resolver<Array<TResolversTypes['IntegrationConfiguration']>, ParentType, ContextType>;
  hasInvite?: Resolver<TResolversTypes['EmailHasInvite'], ParentType, ContextType, RequireFields<TQueryHasInviteArgs, 'email'>>;
  hasRiskMapInBranch?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  headOffice?: Resolver<TResolversTypes['BranchWithOrganization'], ParentType, ContextType>;
  healthProgram?: Resolver<TResolversTypes['HealthProgram'], ParentType, ContextType, RequireFields<TQueryHealthProgramArgs, 'id'>>;
  healthProgramTraining?: Resolver<TResolversTypes['HealthProgramTraining'], ParentType, ContextType, RequireFields<TQueryHealthProgramTrainingArgs, 'id'>>;
  healthProgramTrainingsByHealthProgram?: Resolver<Array<TResolversTypes['HealthProgramTraining']>, ParentType, ContextType, RequireFields<TQueryHealthProgramTrainingsByHealthProgramArgs, 'healthProgram'>>;
  healthPrograms?: Resolver<TResolversTypes['PaginatedHealthProgram'], ParentType, ContextType, RequireFields<TQueryHealthProgramsArgs, 'query'>>;
  healthQuizzes?: Resolver<TResolversTypes['HealthQuizzes'], ParentType, ContextType>;
  hermesGetAllFields?: Resolver<Array<TResolversTypes['InternalFields']>, ParentType, ContextType, RequireFields<TQueryHermesGetAllFieldsArgs, 'input'>>;
  hermesGetAllGenericMetadata?: Resolver<Array<TResolversTypes['GenericMetadata']>, ParentType, ContextType, Partial<TQueryHermesGetAllGenericMetadataArgs>>;
  hermesGetAllSaasMetadata?: Resolver<Array<TResolversTypes['SaasFullMetadata']>, ParentType, ContextType, RequireFields<TQueryHermesGetAllSaasMetadataArgs, 'input'>>;
  hermesGetErpType?: Resolver<Array<TResolversTypes['ErpType']>, ParentType, ContextType, RequireFields<TQueryHermesGetErpTypeArgs, 'metadata'>>;
  importStatus?: Resolver<TResolversTypes['ImportStatus'], ParentType, ContextType, RequireFields<TQueryImportStatusArgs, 'importId'>>;
  indicators?: Resolver<Array<TResolversTypes['Indicator']>, ParentType, ContextType>;
  integrationErrorSummary?: Resolver<TResolversTypes['IntegrationErrorSummary'], ParentType, ContextType, RequireFields<TQueryIntegrationErrorSummaryArgs, 'businessEntity'>>;
  integrationErrors?: Resolver<TResolversTypes['IntegrationErrorAll'], ParentType, ContextType, Partial<TQueryIntegrationErrorsArgs>>;
  integrationFlags?: Resolver<TResolversTypes['IntegrationFlags'], ParentType, ContextType>;
  inventoryQueues?: Resolver<TResolversTypes['PaginatedInventoryQueue'], ParentType, ContextType, Partial<TQueryInventoryQueuesArgs>>;
  investigation?: Resolver<TResolversTypes['Investigation'], ParentType, ContextType, RequireFields<TQueryInvestigationArgs, 'id'>>;
  investigationByCause?: Resolver<Array<TResolversTypes['AccidentCauses']>, ParentType, ContextType>;
  investigationIndicators?: Resolver<TResolversTypes['Causes'], ParentType, ContextType>;
  investigationSuggestion?: Resolver<TResolversTypes['PaginatedInvestigationSuggestion'], ParentType, ContextType, RequireFields<TQueryInvestigationSuggestionArgs, 'query'>>;
  invite?: Resolver<TResolversTypes['Invite'], ParentType, ContextType, RequireFields<TQueryInviteArgs, 'token'>>;
  ipeDeliveries?: Resolver<Array<TResolversTypes['IpeDelivery']>, ParentType, ContextType>;
  ipeDeliveriesByPerson?: Resolver<Array<TResolversTypes['IpeDelivery']>, ParentType, ContextType, RequireFields<TQueryIpeDeliveriesByPersonArgs, 'personId'>>;
  ipeDeliveriesDashboard?: Resolver<TResolversTypes['IpeDeliveryDashboard'], ParentType, ContextType, RequireFields<TQueryIpeDeliveriesDashboardArgs, 'identifier' | 'onlyActive'>>;
  ipeDelivery?: Resolver<TResolversTypes['IpeDelivery'], ParentType, ContextType, RequireFields<TQueryIpeDeliveryArgs, 'id'>>;
  ipeDeliveryExtensionAuditReport?: Resolver<TResolversTypes['IpeDeliveryExtensionAuditReport'], ParentType, ContextType, Partial<TQueryIpeDeliveryExtensionAuditReportArgs>>;
  ipeDeliveryExtensions?: Resolver<Array<TResolversTypes['IpeDeliveryExtensionEntry']>, ParentType, ContextType, Partial<TQueryIpeDeliveryExtensionsArgs>>;
  ipeDeliveryExtensionsByPerson?: Resolver<Array<TResolversTypes['IpeDeliveryExtensionTimeline']>, ParentType, ContextType, RequireFields<TQueryIpeDeliveryExtensionsByPersonArgs, 'personId'>>;
  ipesByRisk?: Resolver<Array<TResolversTypes['IpeByRisk']>, ParentType, ContextType, RequireFields<TQueryIpesByRiskArgs, 'riskId'>>;
  isAccredited?: Resolver<TResolversTypes['isAccreditedResult'], ParentType, ContextType, RequireFields<TQueryIsAccreditedArgs, 'id'>>;
  isFirstIpeDelivery?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType, RequireFields<TQueryIsFirstIpeDeliveryArgs, 'personId'>>;
  isOwner?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  lackVoteByMandate?: Resolver<Array<TResolversTypes['EmployeeVotes']>, ParentType, ContextType, RequireFields<TQueryLackVoteByMandateArgs, 'mandateId' | 'pagination'>>;
  lastDeliveryByPerson?: Resolver<TResolversTypes['IpeDelivery'], ParentType, ContextType, RequireFields<TQueryLastDeliveryByPersonArgs, 'personId'>>;
  mandate?: Resolver<TResolversTypes['Mandate'], ParentType, ContextType, RequireFields<TQueryMandateArgs, 'id'>>;
  mandateAction?: Resolver<TResolversTypes['MandateAction'], ParentType, ContextType, RequireFields<TQueryMandateActionArgs, 'id'>>;
  mandateActions?: Resolver<Array<TResolversTypes['MandateAction']>, ParentType, ContextType, RequireFields<TQueryMandateActionsArgs, 'mandateId'>>;
  mandateCostCenter?: Resolver<TResolversTypes['MandateCostCenter'], ParentType, ContextType, RequireFields<TQueryMandateCostCenterArgs, 'id'>>;
  mandateCostCenterByMandate?: Resolver<Array<TResolversTypes['MandateCostCenter']>, ParentType, ContextType, RequireFields<TQueryMandateCostCenterByMandateArgs, 'mandate'>>;
  mandateDashboard?: Resolver<TResolversTypes['MandateDashboard'], ParentType, ContextType, Partial<TQueryMandateDashboardArgs>>;
  mandateDepartment?: Resolver<TResolversTypes['MandateDepartment'], ParentType, ContextType, RequireFields<TQueryMandateDepartmentArgs, 'id'>>;
  mandateDepartmentByMandate?: Resolver<Array<TResolversTypes['MandateDepartment']>, ParentType, ContextType, RequireFields<TQueryMandateDepartmentByMandateArgs, 'mandate'>>;
  mandateDimension?: Resolver<TResolversTypes['MandateDimension'], ParentType, ContextType, RequireFields<TQueryMandateDimensionArgs, 'mandateId'>>;
  mandateEvent?: Resolver<TResolversTypes['MandateEvent'], ParentType, ContextType, RequireFields<TQueryMandateEventArgs, 'id'>>;
  mandateEventByEvent?: Resolver<TResolversTypes['MandateEvent'], ParentType, ContextType, RequireFields<TQueryMandateEventByEventArgs, 'event' | 'mandateId'>>;
  mandateEventByMandate?: Resolver<Array<TResolversTypes['MandateEvent']>, ParentType, ContextType, RequireFields<TQueryMandateEventByMandateArgs, 'mandate'>>;
  mandateEventByMessage?: Resolver<Array<TResolversTypes['MandateEvent']>, ParentType, ContextType, RequireFields<TQueryMandateEventByMessageArgs, 'message'>>;
  mandateEventByTypeToday?: Resolver<Array<TResolversTypes['MandateEvent']>, ParentType, ContextType, RequireFields<TQueryMandateEventByTypeTodayArgs, 'type'>>;
  mandateEvents?: Resolver<Array<TResolversTypes['MandateEvent']>, ParentType, ContextType>;
  mandateEventsToday?: Resolver<Array<TResolversTypes['MandateEvent']>, ParentType, ContextType>;
  mandateLosses?: Resolver<Array<TResolversTypes['MandateLoss']>, ParentType, ContextType, RequireFields<TQueryMandateLossesArgs, 'mandateId'>>;
  mandateTraining?: Resolver<TResolversTypes['MandateTraining'], ParentType, ContextType, RequireFields<TQueryMandateTrainingArgs, 'id'>>;
  mandateTrainingByMandate?: Resolver<Array<TResolversTypes['MandateTraining']>, ParentType, ContextType, RequireFields<TQueryMandateTrainingByMandateArgs, 'mandate'>>;
  mandateTrainingByTraining?: Resolver<Array<TResolversTypes['MandateTraining']>, ParentType, ContextType, RequireFields<TQueryMandateTrainingByTrainingArgs, 'training'>>;
  mandates?: Resolver<TResolversTypes['PaginatedMandate'], ParentType, ContextType, RequireFields<TQueryMandatesArgs, 'query'>>;
  mandatesByAction?: Resolver<Array<TResolversTypes['MandateAction']>, ParentType, ContextType, RequireFields<TQueryMandatesByActionArgs, 'actionPlanId'>>;
  mandatesByDescription?: Resolver<Array<TResolversTypes['Mandate']>, ParentType, ContextType, RequireFields<TQueryMandatesByDescriptionArgs, 'description'>>;
  measurementsByRisk?: Resolver<Array<TResolversTypes['MeasurementByRisk']>, ParentType, ContextType, RequireFields<TQueryMeasurementsByRiskArgs, 'riskId'>>;
  measuringInstrument?: Resolver<TResolversTypes['MeasuringInstrument'], ParentType, ContextType, RequireFields<TQueryMeasuringInstrumentArgs, 'id'>>;
  measuringInstruments?: Resolver<TResolversTypes['PaginatedMeasuringInstrument'], ParentType, ContextType, RequireFields<TQueryMeasuringInstrumentsArgs, 'query'>>;
  medicalCertificate?: Resolver<TResolversTypes['MedicalCertificate'], ParentType, ContextType, RequireFields<TQueryMedicalCertificateArgs, 'id'>>;
  medicalCertificateByCrm?: Resolver<TResolversTypes['ExternalDoctor'], ParentType, ContextType, Partial<TQueryMedicalCertificateByCrmArgs>>;
  medicalCertificateByDoctorName?: Resolver<TResolversTypes['ExternalDoctor'], ParentType, ContextType, Partial<TQueryMedicalCertificateByDoctorNameArgs>>;
  medicalCertificates?: Resolver<Array<TResolversTypes['MedicalCertificate']>, ParentType, ContextType>;
  medicalCertificatesByIcd?: Resolver<Array<TResolversTypes['MedicalCertificateByIcd']>, ParentType, ContextType>;
  medicalCertificatesByMedicalRecord?: Resolver<Array<TResolversTypes['MedicalCertificate']>, ParentType, ContextType, RequireFields<TQueryMedicalCertificatesByMedicalRecordArgs, 'medicalRecord'>>;
  medicalHistory?: Resolver<TResolversTypes['Historic'], ParentType, ContextType, RequireFields<TQueryMedicalHistoryArgs, 'personId'>>;
  medicalRecord?: Resolver<TResolversTypes['MedicalRecord'], ParentType, ContextType, RequireFields<TQueryMedicalRecordArgs, 'id'>>;
  medicalRecordByUserId?: Resolver<TResolversTypes['MedicalRecord'], ParentType, ContextType, RequireFields<TQueryMedicalRecordByUserIdArgs, 'id'>>;
  medicalRecordHealthProgram?: Resolver<TResolversTypes['MedicalRecordHealthProgram'], ParentType, ContextType, RequireFields<TQueryMedicalRecordHealthProgramArgs, 'id'>>;
  medicalRecordHealthProgramByMedicalRecord?: Resolver<Array<TResolversTypes['MedicalRecordHealthProgram']>, ParentType, ContextType, RequireFields<TQueryMedicalRecordHealthProgramByMedicalRecordArgs, 'medicalRecord'>>;
  medicalRecordHealthPrograms?: Resolver<Array<TResolversTypes['MedicalRecordHealthProgram']>, ParentType, ContextType>;
  medicalRecordSummary?: Resolver<TResolversTypes['Summary'], ParentType, ContextType, RequireFields<TQueryMedicalRecordSummaryArgs, 'getCounter' | 'query'>>;
  medicalRecordVaccinationPlanning?: Resolver<Array<TResolversTypes['MedicalRecordVaccinationPlanning']>, ParentType, ContextType, RequireFields<TQueryMedicalRecordVaccinationPlanningArgs, 'vaccineId'>>;
  medicalRecordVaccine?: Resolver<TResolversTypes['MedicalRecordVaccine'], ParentType, ContextType, RequireFields<TQueryMedicalRecordVaccineArgs, 'id'>>;
  medicalRecordVaccines?: Resolver<Array<TResolversTypes['MedicalRecordVaccine']>, ParentType, ContextType>;
  medicalRecordVaccinesByMedicalRecord?: Resolver<Array<TResolversTypes['MedicalRecordVaccine']>, ParentType, ContextType, RequireFields<TQueryMedicalRecordVaccinesByMedicalRecordArgs, 'medicalRecord'>>;
  medicalRecords?: Resolver<TResolversTypes['PaginatedMedicalRecords'], ParentType, ContextType, RequireFields<TQueryMedicalRecordsArgs, 'orderBy' | 'query'>>;
  medicalRecordsDashboard?: Resolver<TResolversTypes['MedicalRecordDashboard'], ParentType, ContextType, RequireFields<TQueryMedicalRecordsDashboardArgs, 'filter' | 'identifier'>>;
  medicalReferral?: Resolver<TResolversTypes['MedicalReferral'], ParentType, ContextType, RequireFields<TQueryMedicalReferralArgs, 'id'>>;
  medicalReferralDoctorBiometry?: Resolver<Maybe<TResolversTypes['MedicalReferralDoctorBiometry']>, ParentType, ContextType, RequireFields<TQueryMedicalReferralDoctorBiometryArgs, 'medicalReferralId'>>;
  medicalReferrals?: Resolver<Array<TResolversTypes['MedicalReferral']>, ParentType, ContextType>;
  medicalReferralsByMedicalRecord?: Resolver<Array<TResolversTypes['MedicalReferral']>, ParentType, ContextType, RequireFields<TQueryMedicalReferralsByMedicalRecordArgs, 'medicalRecord'>>;
  medicalRestriction?: Resolver<TResolversTypes['MedicalRestriction'], ParentType, ContextType, RequireFields<TQueryMedicalRestrictionArgs, 'id'>>;
  medicalRestrictions?: Resolver<Array<TResolversTypes['MedicalRestriction']>, ParentType, ContextType>;
  medicalRestrictionsByMedicalRecord?: Resolver<Array<TResolversTypes['MedicalRestriction']>, ParentType, ContextType, RequireFields<TQueryMedicalRestrictionsByMedicalRecordArgs, 'medicalRecord'>>;
  medicine?: Resolver<TResolversTypes['Medicine'], ParentType, ContextType, RequireFields<TQueryMedicineArgs, 'id'>>;
  medicines?: Resolver<TResolversTypes['PaginatedMedicine'], ParentType, ContextType, RequireFields<TQueryMedicinesArgs, 'query'>>;
  meeting?: Resolver<TResolversTypes['Meeting'], ParentType, ContextType, RequireFields<TQueryMeetingArgs, 'id'>>;
  meetingAction?: Resolver<TResolversTypes['MeetingAction'], ParentType, ContextType, RequireFields<TQueryMeetingActionArgs, 'id'>>;
  meetingActionByDescription?: Resolver<Array<TResolversTypes['MeetingAction']>, ParentType, ContextType, RequireFields<TQueryMeetingActionByDescriptionArgs, 'description' | 'meetingId'>>;
  meetingActionPendent?: Resolver<Array<TResolversTypes['MeetingAction']>, ParentType, ContextType, RequireFields<TQueryMeetingActionPendentArgs, 'meetingId'>>;
  meetingActions?: Resolver<Array<TResolversTypes['MeetingAction']>, ParentType, ContextType, RequireFields<TQueryMeetingActionsArgs, 'meetingId'>>;
  meetingByActive?: Resolver<Array<TResolversTypes['Meeting']>, ParentType, ContextType, RequireFields<TQueryMeetingByActiveArgs, 'mandateId'>>;
  meetingByDate?: Resolver<Array<TResolversTypes['Meeting']>, ParentType, ContextType, RequireFields<TQueryMeetingByDateArgs, 'date' | 'mandateId'>>;
  meetingBySubject?: Resolver<Array<TResolversTypes['Meeting']>, ParentType, ContextType, RequireFields<TQueryMeetingBySubjectArgs, 'mandateId' | 'subject'>>;
  meetings?: Resolver<Array<TResolversTypes['Meeting']>, ParentType, ContextType, RequireFields<TQueryMeetingsArgs, 'mandateId'>>;
  notificationConfigs?: Resolver<Array<TResolversTypes['NotificationConfigDto']>, ParentType, ContextType>;
  notificationModuleRecipients?: Resolver<TResolversTypes['ModuleDefaultRecipientsDto'], ParentType, ContextType, RequireFields<TQueryNotificationModuleRecipientsArgs, 'module'>>;
  notificationUsersByRoles?: Resolver<Array<TResolversTypes['DefaultRecipientUserDto']>, ParentType, ContextType, RequireFields<TQueryNotificationUsersByRolesArgs, 'roles'>>;
  occupation?: Resolver<TResolversTypes['Occupation'], ParentType, ContextType, RequireFields<TQueryOccupationArgs, 'id'>>;
  occupationalHealthCertificate?: Resolver<TResolversTypes['OccupationalHealthCertificate'], ParentType, ContextType, RequireFields<TQueryOccupationalHealthCertificateArgs, 'id'>>;
  occupationalHealthCertificates?: Resolver<Array<TResolversTypes['OccupationalHealthCertificate']>, ParentType, ContextType>;
  occupationalHealthCertificatesByDate?: Resolver<Array<TResolversTypes['OccupationalHealthCertificateByDate']>, ParentType, ContextType>;
  occupationalHealthCertificatesByMedicalRecord?: Resolver<Array<TResolversTypes['OccupationalHealthCertificate']>, ParentType, ContextType, RequireFields<TQueryOccupationalHealthCertificatesByMedicalRecordArgs, 'medicalRecord'>>;
  occupationalHealthCertificatesByNature?: Resolver<Array<TResolversTypes['OccupationalHealthCertificateTotal']>, ParentType, ContextType>;
  occupationalHealthCertificatesByRegistration?: Resolver<Array<TResolversTypes['OccupationalHealthCertificate']>, ParentType, ContextType, RequireFields<TQueryOccupationalHealthCertificatesByRegistrationArgs, 'erpId' | 'individualRegistration'>>;
  occupations?: Resolver<TResolversTypes['PaginatedOccupation'], ParentType, ContextType, RequireFields<TQueryOccupationsArgs, 'query'>>;
  occupationsFilterByBranch?: Resolver<Array<TResolversTypes['Occupation']>, ParentType, ContextType, RequireFields<TQueryOccupationsFilterByBranchArgs, 'branchId' | 'occupations'>>;
  oneSignalHello?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  oneSignalTest?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  organization?: Resolver<TResolversTypes['OrganizationWithBranches'], ParentType, ContextType>;
  organizationCustomer?: Resolver<TResolversTypes['Customer'], ParentType, ContextType>;
  organizationLevelForecast?: Resolver<TResolversTypes['LevelsForecast'], ParentType, ContextType>;
  organizationPayments?: Resolver<Array<TResolversTypes['Payments']>, ParentType, ContextType>;
  orthoRater?: Resolver<TResolversTypes['OrthoRater'], ParentType, ContextType, RequireFields<TQueryOrthoRaterArgs, 'id'>>;
  orthoRaterByConsultation?: Resolver<TResolversTypes['OrthoRater'], ParentType, ContextType, RequireFields<TQueryOrthoRaterByConsultationArgs, 'consultationId'>>;
  people?: Resolver<TResolversTypes['PaginatedPerson'], ParentType, ContextType, RequireFields<TQueryPeopleArgs, 'query'>>;
  peopleActives?: Resolver<Array<TResolversTypes['PersonHistoryActivate']>, ParentType, ContextType>;
  peopleByOriginDeliveries?: Resolver<Array<TResolversTypes['Person']>, ParentType, ContextType, RequireFields<TQueryPeopleByOriginDeliveriesArgs, 'id'>>;
  peopleByRisk?: Resolver<Array<TResolversTypes['Person']>, ParentType, ContextType, RequireFields<TQueryPeopleByRiskArgs, 'riskId'>>;
  peopleNeedIpe?: Resolver<TResolversTypes['PaginatedPersonNeedIpe'], ParentType, ContextType, RequireFields<TQueryPeopleNeedIpeArgs, 'query'>>;
  peopleOnBrowse?: Resolver<TResolversTypes['PaginatedPeopleOnBrowse'], ParentType, ContextType, RequireFields<TQueryPeopleOnBrowseArgs, 'query'>>;
  peopleSuggestions?: Resolver<TResolversTypes['PaginatedPerson'], ParentType, ContextType, RequireFields<TQueryPeopleSuggestionsArgs, 'query'>>;
  periodicRange?: Resolver<TResolversTypes['PeriodicRange'], ParentType, ContextType, RequireFields<TQueryPeriodicRangeArgs, 'id'>>;
  periodicRanges?: Resolver<TResolversTypes['PaginatedPeriodicRange'], ParentType, ContextType, RequireFields<TQueryPeriodicRangesArgs, 'query'>>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType, RequireFields<TQueryPersonArgs, 'id'>>;
  personByIndividualRegistration?: Resolver<TResolversTypes['Person'], ParentType, ContextType, RequireFields<TQueryPersonByIndividualRegistrationArgs, 'individualRegistration'>>;
  personDoctor?: Resolver<Maybe<TResolversTypes['Person']>, ParentType, ContextType>;
  personFilterIpeDeliveries?: Resolver<TResolversTypes['PaginatedPersonIpeList'], ParentType, ContextType, RequireFields<TQueryPersonFilterIpeDeliveriesArgs, 'orderBy' | 'query'>>;
  personRequiredTrainings?: Resolver<Array<TResolversTypes['PersonRequiredTraining']>, ParentType, ContextType, RequireFields<TQueryPersonRequiredTrainingsArgs, 'personId'>>;
  personSummary?: Resolver<TResolversTypes['Summary'], ParentType, ContextType, RequireFields<TQueryPersonSummaryArgs, 'getCounter' | 'query'>>;
  personToIpeDelivery?: Resolver<TResolversTypes['Person'], ParentType, ContextType, RequireFields<TQueryPersonToIpeDeliveryArgs, 'id'>>;
  physicalEnvironment?: Resolver<TResolversTypes['PhysicalEnvironment'], ParentType, ContextType, RequireFields<TQueryPhysicalEnvironmentArgs, 'id'>>;
  physicalEnvironments?: Resolver<TResolversTypes['PaginatedPhysicalEnvironment'], ParentType, ContextType, RequireFields<TQueryPhysicalEnvironmentsArgs, 'query'>>;
  position?: Resolver<TResolversTypes['Position'], ParentType, ContextType, RequireFields<TQueryPositionArgs, 'id'>>;
  positions?: Resolver<TResolversTypes['PaginatedPosition'], ParentType, ContextType, RequireFields<TQueryPositionsArgs, 'query'>>;
  preMedicalCertificate?: Resolver<TResolversTypes['PreMedicalCertificate'], ParentType, ContextType, RequireFields<TQueryPreMedicalCertificateArgs, 'id'>>;
  preMedicalCertificateCountByStatus?: Resolver<TResolversTypes['PreMedicalCertificateCountByStatus'], ParentType, ContextType, RequireFields<TQueryPreMedicalCertificateCountByStatusArgs, 'status'>>;
  preMedicalCertificates?: Resolver<TResolversTypes['PaginatedPreMedicalCertificates'], ParentType, ContextType, Partial<TQueryPreMedicalCertificatesArgs>>;
  previewDocumentByCertificate?: Resolver<Array<TResolversTypes['BaseDocumentResponse']>, ParentType, ContextType, RequireFields<TQueryPreviewDocumentByCertificateArgs, 'certificatesId'>>;
  previewDocumentByEnvironmentalReport?: Resolver<Array<TResolversTypes['EnvironmentalReportDocumentResponse']>, ParentType, ContextType, RequireFields<TQueryPreviewDocumentByEnvironmentalReportArgs, 'environmentalReportsId'>>;
  previewDocumentByIpeDelivery?: Resolver<Array<TResolversTypes['BaseDocumentResponse']>, ParentType, ContextType, RequireFields<TQueryPreviewDocumentByIpeDeliveryArgs, 'sourceIds'>>;
  previewDocumentBySecurityWorkOrder?: Resolver<Array<TResolversTypes['BaseDocumentResponse']>, ParentType, ContextType, RequireFields<TQueryPreviewDocumentBySecurityWorkOrderArgs, 'sourceIds'>>;
  previewMedicalCertificateDocumentByCertificate?: Resolver<Array<TResolversTypes['BaseDocumentResponse']>, ParentType, ContextType, RequireFields<TQueryPreviewMedicalCertificateDocumentByCertificateArgs, 'certificatesId'>>;
  product?: Resolver<TResolversTypes['Product'], ParentType, ContextType, RequireFields<TQueryProductArgs, 'id'>>;
  productDelivery?: Resolver<TResolversTypes['ProductDelivery'], ParentType, ContextType, RequireFields<TQueryProductDeliveryArgs, 'id'>>;
  productDeliveryByPerson?: Resolver<Array<TResolversTypes['ProductDelivery']>, ParentType, ContextType, RequireFields<TQueryProductDeliveryByPersonArgs, 'personId'>>;
  productDeliveryByProduct?: Resolver<Array<TResolversTypes['ProductDelivery']>, ParentType, ContextType, RequireFields<TQueryProductDeliveryByProductArgs, 'productId'>>;
  productDeliverys?: Resolver<TResolversTypes['PaginatedProductDelivery'], ParentType, ContextType, RequireFields<TQueryProductDeliverysArgs, 'query'>>;
  productIpeManufacturer?: Resolver<TResolversTypes['ProductIpeManufacturer'], ParentType, ContextType, RequireFields<TQueryProductIpeManufacturerArgs, 'id'>>;
  productIpeManufacturers?: Resolver<Array<TResolversTypes['ProductIpeManufacturer']>, ParentType, ContextType, RequireFields<TQueryProductIpeManufacturersArgs, 'productId'>>;
  products?: Resolver<TResolversTypes['PaginatedProduct'], ParentType, ContextType, RequireFields<TQueryProductsArgs, 'query'>>;
  productsWithoutCA?: Resolver<TResolversTypes['PaginatedProduct'], ParentType, ContextType, RequireFields<TQueryProductsWithoutCaArgs, 'query'>>;
  quantityLifesActive?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  queue?: Resolver<TResolversTypes['ESocialQueue'], ParentType, ContextType, RequireFields<TQueryQueueArgs, 'id'>>;
  queues?: Resolver<TResolversTypes['ESocialQueueAll'], ParentType, ContextType, Partial<TQueryQueuesArgs>>;
  queuesByOrganization?: Resolver<TResolversTypes['ESocialQueueAll'], ParentType, ContextType, Partial<TQueryQueuesByOrganizationArgs>>;
  quiz?: Resolver<TResolversTypes['Quiz'], ParentType, ContextType, RequireFields<TQueryQuizArgs, 'id'>>;
  quizzes?: Resolver<TResolversTypes['PaginatedQuiz'], ParentType, ContextType, RequireFields<TQueryQuizzesArgs, 'query'>>;
  realGoal?: Resolver<TResolversTypes['RealGoal'], ParentType, ContextType, RequireFields<TQueryRealGoalArgs, 'id'>>;
  relativeIndex?: Resolver<Array<TResolversTypes['RelativeIndex']>, ParentType, ContextType>;
  reportSection?: Resolver<TResolversTypes['ReportSection'], ParentType, ContextType, RequireFields<TQueryReportSectionArgs, 'id'>>;
  reportStructure?: Resolver<TResolversTypes['ReportStructure'], ParentType, ContextType, RequireFields<TQueryReportStructureArgs, 'id'>>;
  reportStructures?: Resolver<TResolversTypes['PaginatedReportStructure'], ParentType, ContextType, RequireFields<TQueryReportStructuresArgs, 'query'>>;
  resendPendingEmail?: Resolver<TResolversTypes['SignBrokerResponse'], ParentType, ContextType, RequireFields<TQueryResendPendingEmailArgs, 'documentId'>>;
  responsibleAction?: Resolver<TResolversTypes['ResponsibleAction'], ParentType, ContextType, RequireFields<TQueryResponsibleActionArgs, 'id'>>;
  responsibleActionByPerson?: Resolver<Array<TResolversTypes['ResponsibleAction']>, ParentType, ContextType, RequireFields<TQueryResponsibleActionByPersonArgs, 'person'>>;
  responsiblesAction?: Resolver<Array<TResolversTypes['ResponsibleAction']>, ParentType, ContextType, RequireFields<TQueryResponsiblesActionArgs, 'actionPlanId'>>;
  resultExamIbmp?: Resolver<TResolversTypes['ResultExamIbmp'], ParentType, ContextType, RequireFields<TQueryResultExamIbmpArgs, 'id'>>;
  resultExamIbmpByConsultation?: Resolver<Maybe<TResolversTypes['ResultExamIbmp']>, ParentType, ContextType, RequireFields<TQueryResultExamIbmpByConsultationArgs, 'consultationId'>>;
  risk?: Resolver<TResolversTypes['Risk'], ParentType, ContextType, RequireFields<TQueryRiskArgs, 'id'>>;
  riskAgent?: Resolver<TResolversTypes['RiskAgent'], ParentType, ContextType, RequireFields<TQueryRiskAgentArgs, 'id'>>;
  riskAgents?: Resolver<TResolversTypes['PaginatedRiskAgent'], ParentType, ContextType, RequireFields<TQueryRiskAgentsArgs, 'query'>>;
  riskComposition?: Resolver<TResolversTypes['RiskComposition'], ParentType, ContextType, RequireFields<TQueryRiskCompositionArgs, 'id'>>;
  riskCompositions?: Resolver<Array<TResolversTypes['RiskComposition']>, ParentType, ContextType>;
  riskCompositionsByEnvironment?: Resolver<Array<TResolversTypes['RiskComposition']>, ParentType, ContextType, RequireFields<TQueryRiskCompositionsByEnvironmentArgs, 'environment'>>;
  riskCount?: Resolver<TResolversTypes['RiskCount'], ParentType, ContextType>;
  riskSuggestion?: Resolver<TResolversTypes['PaginatedRiskSuggestion'], ParentType, ContextType, RequireFields<TQueryRiskSuggestionArgs, 'query'>>;
  riskSummary?: Resolver<TResolversTypes['Summary'], ParentType, ContextType, RequireFields<TQueryRiskSummaryArgs, 'getCounter' | 'query'>>;
  risks?: Resolver<TResolversTypes['PaginatedRisk'], ParentType, ContextType, RequireFields<TQueryRisksArgs, 'orderBy' | 'query'>>;
  risksByEnvironment?: Resolver<Array<TResolversTypes['Risk']>, ParentType, ContextType, RequireFields<TQueryRisksByEnvironmentArgs, 'input'>>;
  risksByExposeByPerson?: Resolver<Array<TResolversTypes['Risk']>, ParentType, ContextType, RequireFields<TQueryRisksByExposeByPersonArgs, 'personId'>>;
  risksDashboard?: Resolver<TResolversTypes['RiskDashboard'], ParentType, ContextType, RequireFields<TQueryRisksDashboardArgs, 'filter' | 'identifier'>>;
  risksForIntegration?: Resolver<Array<TResolversTypes['Risk']>, ParentType, ContextType, RequireFields<TQueryRisksForIntegrationArgs, 'environmentId' | 'group' | 'riskDegree'>>;
  rolePermission?: Resolver<TResolversTypes['RolePermission'], ParentType, ContextType, RequireFields<TQueryRolePermissionArgs, 'id'>>;
  rolePermissions?: Resolver<TResolversTypes['PaginatedRolePermission'], ParentType, ContextType, RequireFields<TQueryRolePermissionsArgs, 'query'>>;
  routes?: Resolver<Array<TResolversTypes['Routes']>, ParentType, ContextType, RequireFields<TQueryRoutesArgs, 'isMobile'>>;
  safetyQuiz?: Resolver<TResolversTypes['SafetyQuiz'], ParentType, ContextType, RequireFields<TQuerySafetyQuizArgs, 'id'>>;
  safetyQuizDashboard?: Resolver<TResolversTypes['SafetyQuizDashboard'], ParentType, ContextType, Partial<TQuerySafetyQuizDashboardArgs>>;
  safetyQuizzes?: Resolver<Array<TResolversTypes['SafetyQuiz']>, ParentType, ContextType, RequireFields<TQuerySafetyQuizzesArgs, 'quizId'>>;
  scheduleRestriction?: Resolver<TResolversTypes['ScheduleRestriction'], ParentType, ContextType, RequireFields<TQueryScheduleRestrictionArgs, 'id'>>;
  scheduleRestrictions?: Resolver<TResolversTypes['PaginatedScheduleRestriction'], ParentType, ContextType, RequireFields<TQueryScheduleRestrictionsArgs, 'query'>>;
  scheduleRestrictionsByDate?: Resolver<Array<TResolversTypes['ScheduleRestriction']>, ParentType, ContextType, RequireFields<TQueryScheduleRestrictionsByDateArgs, 'endDate' | 'startDate'>>;
  scheduleRestrictionsByDoctor?: Resolver<TResolversTypes['PaginatedScheduleRestriction'], ParentType, ContextType, RequireFields<TQueryScheduleRestrictionsByDoctorArgs, 'doctorId' | 'query'>>;
  schedulingSettings?: Resolver<TResolversTypes['SchedulingSettings'], ParentType, ContextType>;
  semanticInconsistencies?: Resolver<TResolversTypes['PaginatedTtalkInboundSemanticInconsistency'], ParentType, ContextType, RequireFields<TQuerySemanticInconsistenciesArgs, 'unackOnly'>>;
  sendToSoc?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  sessions?: Resolver<Array<TResolversTypes['Session']>, ParentType, ContextType>;
  severityIndex?: Resolver<Array<TResolversTypes['SeverityIndex']>, ParentType, ContextType>;
  silenceMonitors?: Resolver<Array<TResolversTypes['TtalkInboundSilenceMonitor']>, ParentType, ContextType>;
  silenceThresholds?: Resolver<Array<TResolversTypes['TtalkInboundSilenceThreshold']>, ParentType, ContextType, Partial<TQuerySilenceThresholdsArgs>>;
  simulation?: Resolver<TResolversTypes['Simulation'], ParentType, ContextType, RequireFields<TQuerySimulationArgs, 'id'>>;
  simulationPlan?: Resolver<TResolversTypes['SimulationPlan'], ParentType, ContextType, RequireFields<TQuerySimulationPlanArgs, 'id'>>;
  simulationPlans?: Resolver<Array<TResolversTypes['SimulationPlan']>, ParentType, ContextType, RequireFields<TQuerySimulationPlansArgs, 'brigadeId'>>;
  simulations?: Resolver<Array<TResolversTypes['Simulation']>, ParentType, ContextType, RequireFields<TQuerySimulationsArgs, 'brigadeId'>>;
  sipat?: Resolver<TResolversTypes['Sipat'], ParentType, ContextType, RequireFields<TQuerySipatArgs, 'id'>>;
  sipatByDate?: Resolver<Array<TResolversTypes['Sipat']>, ParentType, ContextType, RequireFields<TQuerySipatByDateArgs, 'date' | 'mandateId'>>;
  sipatByDescription?: Resolver<Array<TResolversTypes['Sipat']>, ParentType, ContextType, RequireFields<TQuerySipatByDescriptionArgs, 'description' | 'mandateId'>>;
  sipatEvent?: Resolver<TResolversTypes['SipatEvent'], ParentType, ContextType, RequireFields<TQuerySipatEventArgs, 'id'>>;
  sipatEventByDate?: Resolver<Array<TResolversTypes['SipatEvent']>, ParentType, ContextType, RequireFields<TQuerySipatEventByDateArgs, 'date' | 'sipatId'>>;
  sipatEventByDescription?: Resolver<Array<TResolversTypes['SipatEvent']>, ParentType, ContextType, RequireFields<TQuerySipatEventByDescriptionArgs, 'sipatId' | 'subject'>>;
  sipatEventByPerson?: Resolver<Array<TResolversTypes['SipatEvent']>, ParentType, ContextType, RequireFields<TQuerySipatEventByPersonArgs, 'personId' | 'sipatId'>>;
  sipats?: Resolver<Array<TResolversTypes['Sipat']>, ParentType, ContextType, RequireFields<TQuerySipatsArgs, 'mandateId'>>;
  snellen?: Resolver<TResolversTypes['Snellen'], ParentType, ContextType, RequireFields<TQuerySnellenArgs, 'id'>>;
  snellenByConsultation?: Resolver<Maybe<TResolversTypes['Snellen']>, ParentType, ContextType, RequireFields<TQuerySnellenByConsultationArgs, 'consultationId'>>;
  socAttachment?: Resolver<TResolversTypes['PaginatedAttachment'], ParentType, ContextType, RequireFields<TQuerySocAttachmentArgs, 'query'>>;
  socQueue?: Resolver<TResolversTypes['PaginatedQueue'], ParentType, ContextType, RequireFields<TQuerySocQueueArgs, 'query'>>;
  socSync?: Resolver<TResolversTypes['PaginatedSync'], ParentType, ContextType, RequireFields<TQuerySocSyncArgs, 'query'>>;
  sparePart?: Resolver<TResolversTypes['SpareParts'], ParentType, ContextType, RequireFields<TQuerySparePartArgs, 'id'>>;
  spareParts?: Resolver<TResolversTypes['PaginatedSpareParts'], ParentType, ContextType, RequireFields<TQuerySparePartsArgs, 'query'>>;
  sparePartsByProduct?: Resolver<Array<TResolversTypes['SpareParts']>, ParentType, ContextType, RequireFields<TQuerySparePartsByProductArgs, 'productId'>>;
  stabilityType?: Resolver<TResolversTypes['StabilityType'], ParentType, ContextType, RequireFields<TQueryStabilityTypeArgs, 'id'>>;
  stabilityTypes?: Resolver<TResolversTypes['PaginatedStabilityType'], ParentType, ContextType, RequireFields<TQueryStabilityTypesArgs, 'query'>>;
  statementResponsibility?: Resolver<TResolversTypes['StatementResponsibility'], ParentType, ContextType, RequireFields<TQueryStatementResponsibilityArgs, 'id'>>;
  statementsResponsibility?: Resolver<TResolversTypes['PaginatedStatementResponsibility'], ParentType, ContextType, RequireFields<TQueryStatementsResponsibilityArgs, 'query'>>;
  stockLevel?: Resolver<TResolversTypes['StockLevel'], ParentType, ContextType, RequireFields<TQueryStockLevelArgs, 'id'>>;
  stockLevels?: Resolver<Array<TResolversTypes['StockLevel']>, ParentType, ContextType>;
  stockLevelsByProduct?: Resolver<Array<TResolversTypes['StockLevel']>, ParentType, ContextType, RequireFields<TQueryStockLevelsByProductArgs, 'productId'>>;
  stockLevelsByWarehouse?: Resolver<Array<TResolversTypes['StockLevel']>, ParentType, ContextType, RequireFields<TQueryStockLevelsByWarehouseArgs, 'warehouseId'>>;
  stockLevelsLotNumbers?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType, RequireFields<TQueryStockLevelsLotNumbersArgs, 'productId' | 'warehouseId'>>;
  stockMovement?: Resolver<TResolversTypes['StockMovement'], ParentType, ContextType, RequireFields<TQueryStockMovementArgs, 'id'>>;
  stockMovements?: Resolver<Array<TResolversTypes['StockMovement']>, ParentType, ContextType>;
  stockMovementsByProduct?: Resolver<Array<TResolversTypes['StockMovement']>, ParentType, ContextType, RequireFields<TQueryStockMovementsByProductArgs, 'productId'>>;
  suggestion?: Resolver<TResolversTypes['SuggestionBox'], ParentType, ContextType, RequireFields<TQuerySuggestionArgs, 'id'>>;
  suggestionAmount?: Resolver<Array<TResolversTypes['SuggestionAmount']>, ParentType, ContextType, RequireFields<TQuerySuggestionAmountArgs, 'dateEnd' | 'dateStart'>>;
  suggestionBoxByDescription?: Resolver<Array<TResolversTypes['SuggestionBox']>, ParentType, ContextType, RequireFields<TQuerySuggestionBoxByDescriptionArgs, 'description' | 'mandateId'>>;
  suggestionBoxByPriority?: Resolver<Array<TResolversTypes['SuggestionBox']>, ParentType, ContextType, RequireFields<TQuerySuggestionBoxByPriorityArgs, 'mandateId' | 'priority'>>;
  suggestionBoxByStatus?: Resolver<Array<TResolversTypes['SuggestionBox']>, ParentType, ContextType, RequireFields<TQuerySuggestionBoxByStatusArgs, 'mandateId' | 'status'>>;
  suggestionBoxListReport?: Resolver<Array<TResolversTypes['SuggestionBoxListReport']>, ParentType, ContextType, RequireFields<TQuerySuggestionBoxListReportArgs, 'mandateId'>>;
  suggestions?: Resolver<Array<TResolversTypes['SuggestionBox']>, ParentType, ContextType, RequireFields<TQuerySuggestionsArgs, 'mandateId'>>;
  task?: Resolver<TResolversTypes['Task'], ParentType, ContextType, RequireFields<TQueryTaskArgs, 'id'>>;
  taskByName?: Resolver<Maybe<TResolversTypes['Task']>, ParentType, ContextType, RequireFields<TQueryTaskByNameArgs, 'name'>>;
  tasks?: Resolver<TResolversTypes['PaginatedTask'], ParentType, ContextType, RequireFields<TQueryTasksArgs, 'query'>>;
  tasksFilterByBranch?: Resolver<Array<TResolversTypes['Task']>, ParentType, ContextType, RequireFields<TQueryTasksFilterByBranchArgs, 'branchId' | 'tasks'>>;
  terms?: Resolver<TResolversTypes['Terms'], ParentType, ContextType>;
  training?: Resolver<TResolversTypes['Training'], ParentType, ContextType, RequireFields<TQueryTrainingArgs, 'id'>>;
  trainingEligiblePersons?: Resolver<TResolversTypes['TrainingEligiblePersonsResult'], ParentType, ContextType, RequireFields<TQueryTrainingEligiblePersonsArgs, 'trainingId'>>;
  trainingHistory?: Resolver<TResolversTypes['PaginatedTrainingHistory'], ParentType, ContextType, RequireFields<TQueryTrainingHistoryArgs, 'personId' | 'query'>>;
  trainings?: Resolver<TResolversTypes['PaginatedTraining'], ParentType, ContextType, RequireFields<TQueryTrainingsArgs, 'query'>>;
  trainingsByRisk?: Resolver<Array<TResolversTypes['TrainingByRisk']>, ParentType, ContextType, RequireFields<TQueryTrainingsByRiskArgs, 'riskId'>>;
  ttalkInFlightSources?: Resolver<Array<TResolversTypes['ID']>, ParentType, ContextType, RequireFields<TQueryTtalkInFlightSourcesArgs, 'ids' | 'sourceType'>>;
  ttalkInboundDlqEvents?: Resolver<TResolversTypes['PaginatedTtalkInboundEvent'], ParentType, ContextType, Partial<TQueryTtalkInboundDlqEventsArgs>>;
  ttalkInboundEvents?: Resolver<TResolversTypes['PaginatedTtalkInboundEvent'], ParentType, ContextType, Partial<TQueryTtalkInboundEventsArgs>>;
  ttalkOutboundSummary?: Resolver<TResolversTypes['TTalkQueueSummary'], ParentType, ContextType, Partial<TQueryTtalkOutboundSummaryArgs>>;
  ttalkQueueByEntity?: Resolver<Array<TResolversTypes['TTalkQueue']>, ParentType, ContextType, RequireFields<TQueryTtalkQueueByEntityArgs, 'person' | 'type'>>;
  ttalkQueues?: Resolver<TResolversTypes['TTalkQueueAll'], ParentType, ContextType, Partial<TQueryTtalkQueuesArgs>>;
  unitiesOfMeasure?: Resolver<TResolversTypes['PaginatedUnityMeasure'], ParentType, ContextType, RequireFields<TQueryUnitiesOfMeasureArgs, 'query'>>;
  unityOfMeasure?: Resolver<TResolversTypes['UnityOfMeasure'], ParentType, ContextType, RequireFields<TQueryUnityOfMeasureArgs, 'id'>>;
  urinalysis?: Resolver<TResolversTypes['Urinalysis'], ParentType, ContextType, RequireFields<TQueryUrinalysisArgs, 'id'>>;
  urinalysisByConsultation?: Resolver<Maybe<TResolversTypes['Urinalysis']>, ParentType, ContextType, RequireFields<TQueryUrinalysisByConsultationArgs, 'consultationId'>>;
  urinalysisByMedicalRecord?: Resolver<Array<TResolversTypes['Urinalysis']>, ParentType, ContextType, RequireFields<TQueryUrinalysisByMedicalRecordArgs, 'medicalRecordId'>>;
  urinalysisByMedicalRecordForComparative?: Resolver<Array<TResolversTypes['ResultUrinalysisGroup']>, ParentType, ContextType, RequireFields<TQueryUrinalysisByMedicalRecordForComparativeArgs, 'medicalRecordId'>>;
  user?: Resolver<TResolversTypes['UserBasicInfo'], ParentType, ContextType, RequireFields<TQueryUserArgs, 'id'>>;
  userRoutes?: Resolver<TResolversTypes['UserRoutes'], ParentType, ContextType, RequireFields<TQueryUserRoutesArgs, 'isMobile'>>;
  userSpecialties?: Resolver<Array<TResolversTypes['UserSpecialty']>, ParentType, ContextType, RequireFields<TQueryUserSpecialtiesArgs, 'userId'>>;
  users?: Resolver<Array<TResolversTypes['UserOrganizationListing']>, ParentType, ContextType>;
  vaccine?: Resolver<TResolversTypes['Vaccine'], ParentType, ContextType, RequireFields<TQueryVaccineArgs, 'id'>>;
  vaccines?: Resolver<TResolversTypes['PaginatedVaccine'], ParentType, ContextType, RequireFields<TQueryVaccinesArgs, 'query'>>;
  victimSuggestions?: Resolver<TResolversTypes['PaginatedPerson'], ParentType, ContextType, RequireFields<TQueryVictimSuggestionsArgs, 'query'>>;
  voteByMandate?: Resolver<Array<TResolversTypes['EmployeeVotes']>, ParentType, ContextType, RequireFields<TQueryVoteByMandateArgs, 'mandateId' | 'pagination'>>;
  voteProgress?: Resolver<Array<TResolversTypes['VotationProgress']>, ParentType, ContextType, RequireFields<TQueryVoteProgressArgs, 'mandateId'>>;
  voteSummary?: Resolver<TResolversTypes['VoteStatus'], ParentType, ContextType, RequireFields<TQueryVoteSummaryArgs, 'mandateId'>>;
  warehouse?: Resolver<TResolversTypes['Warehouse'], ParentType, ContextType, RequireFields<TQueryWarehouseArgs, 'id'>>;
  warehouses?: Resolver<TResolversTypes['PaginatedWarehouse'], ParentType, ContextType, RequireFields<TQueryWarehousesArgs, 'query'>>;
  warehousesByProduct?: Resolver<Array<TResolversTypes['Warehouse']>, ParentType, ContextType, RequireFields<TQueryWarehousesByProductArgs, 'productId'>>;
  workHoursByDoctor?: Resolver<TResolversTypes['WorkHours'], ParentType, ContextType, RequireFields<TQueryWorkHoursByDoctorArgs, 'doctorId'>>;
  workPermission?: Resolver<TResolversTypes['WorkPermission'], ParentType, ContextType, RequireFields<TQueryWorkPermissionArgs, 'id'>>;
  workPermissionDashboard?: Resolver<TResolversTypes['WorkPermissionDashboard'], ParentType, ContextType, Partial<TQueryWorkPermissionDashboardArgs>>;
  workPermissionQuiz?: Resolver<TResolversTypes['WorkPermissionQuiz'], ParentType, ContextType, RequireFields<TQueryWorkPermissionQuizArgs, 'workPermissionId'>>;
  workPermissions?: Resolver<TResolversTypes['PaginatedWorkPermission'], ParentType, ContextType, RequireFields<TQueryWorkPermissionsArgs, 'query'>>;
  workShift?: Resolver<TResolversTypes['WorkShift'], ParentType, ContextType, RequireFields<TQueryWorkShiftArgs, 'id'>>;
  workShifts?: Resolver<TResolversTypes['PaginatedWorkShift'], ParentType, ContextType, RequireFields<TQueryWorkShiftsArgs, 'query'>>;
}>;

export type TQuestionGroupOnQuestionResolvers<ContextType = any, ParentType extends TResolversParentTypes['QuestionGroupOnQuestion'] = TResolversParentTypes['QuestionGroupOnQuestion']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  order?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TQuestionsResolvers<ContextType = any, ParentType extends TResolversParentTypes['Questions'] = TResolversParentTypes['Questions']> = ResolversObject<{
  defaultOption?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  gender?: Resolver<TResolversTypes['QuestionGenderEnum'], ParentType, ContextType>;
  hasDetails?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  order?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  questionGroup?: Resolver<TResolversTypes['QuestionGroupOnQuestion'], ParentType, ContextType>;
  required?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  responseOptions?: Resolver<Maybe<Array<TResolversTypes['ResponseOptions']>>, ParentType, ContextType>;
  responseType?: Resolver<TResolversTypes['ResponseType'], ParentType, ContextType>;
}>;

export type TQuestionsDashboardResolvers<ContextType = any, ParentType extends TResolversParentTypes['QuestionsDashboard'] = TResolversParentTypes['QuestionsDashboard']> = ResolversObject<{
  question?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  responses?: Resolver<Array<TResolversTypes['PieChart']>, ParentType, ContextType>;
}>;

export type TQuestionsGroupResolvers<ContextType = any, ParentType extends TResolversParentTypes['QuestionsGroup'] = TResolversParentTypes['QuestionsGroup']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  order?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  questionsQuiz?: Resolver<Maybe<Array<TResolversTypes['Questions']>>, ParentType, ContextType>;
}>;

export type TQueueDtoResolvers<ContextType = any, ParentType extends TResolversParentTypes['QueueDTO'] = TResolversParentTypes['QueueDTO']> = ResolversObject<{
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  error?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  key?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['Status'], ParentType, ContextType>;
  updatedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type TQuizResolvers<ContextType = any, ParentType extends TResolversParentTypes['Quiz'] = TResolversParentTypes['Quiz']> = ResolversObject<{
  clinicalQuizzes?: Resolver<Maybe<Array<TResolversTypes['ClinicalQuiz']>>, ParentType, ContextType>;
  costCenters?: Resolver<Maybe<Array<TResolversTypes['QuizCostCenter']>>, ParentType, ContextType>;
  departments?: Resolver<Maybe<Array<TResolversTypes['QuizDepartment']>>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  generatingSources?: Resolver<Maybe<Array<TResolversTypes['QuizGeneratingSource']>>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  isDefault?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  occupations?: Resolver<Maybe<Array<TResolversTypes['QuizOccupation']>>, ParentType, ContextType>;
  people?: Resolver<Maybe<Array<TResolversTypes['QuizPerson']>>, ParentType, ContextType>;
  periodicity?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  physicalEnvironments?: Resolver<Maybe<Array<TResolversTypes['QuizPhysicalEnvironment']>>, ParentType, ContextType>;
  questionsGroup?: Resolver<Maybe<Array<TResolversTypes['QuestionsGroup']>>, ParentType, ContextType>;
  quizAttachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  quizType?: Resolver<Maybe<TResolversTypes['QuizTypeEnum']>, ParentType, ContextType>;
  readonly?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  safetyQuizzes?: Resolver<Maybe<Array<TResolversTypes['SafetyQuiz']>>, ParentType, ContextType>;
}>;

export type TQuizCostCenterResolvers<ContextType = any, ParentType extends TResolversParentTypes['QuizCostCenter'] = TResolversParentTypes['QuizCostCenter']> = ResolversObject<{
  costCenter?: Resolver<TResolversTypes['CostCenter'], ParentType, ContextType>;
  costCenterId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TQuizDepartmentResolvers<ContextType = any, ParentType extends TResolversParentTypes['QuizDepartment'] = TResolversParentTypes['QuizDepartment']> = ResolversObject<{
  department?: Resolver<TResolversTypes['Department'], ParentType, ContextType>;
  departmentId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TQuizGeneratingSourceResolvers<ContextType = any, ParentType extends TResolversParentTypes['QuizGeneratingSource'] = TResolversParentTypes['QuizGeneratingSource']> = ResolversObject<{
  generatingSource?: Resolver<TResolversTypes['GeneratingSource'], ParentType, ContextType>;
  generatingSourceId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TQuizOccupationResolvers<ContextType = any, ParentType extends TResolversParentTypes['QuizOccupation'] = TResolversParentTypes['QuizOccupation']> = ResolversObject<{
  occupation?: Resolver<TResolversTypes['Occupation'], ParentType, ContextType>;
  occupationId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TQuizPersonResolvers<ContextType = any, ParentType extends TResolversParentTypes['QuizPerson'] = TResolversParentTypes['QuizPerson']> = ResolversObject<{
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  personId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TQuizPhysicalEnvironmentResolvers<ContextType = any, ParentType extends TResolversParentTypes['QuizPhysicalEnvironment'] = TResolversParentTypes['QuizPhysicalEnvironment']> = ResolversObject<{
  physicalEnvironment?: Resolver<TResolversTypes['PhysicalEnvironment'], ParentType, ContextType>;
  physicalEnvironmentId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TQuizzesChartsResolvers<ContextType = any, ParentType extends TResolversParentTypes['QuizzesCharts'] = TResolversParentTypes['QuizzesCharts']> = ResolversObject<{
  hasQuizzes?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  questions?: Resolver<Array<TResolversTypes['QuestionsDashboard']>, ParentType, ContextType>;
}>;

export type TRadarChartsResolvers<ContextType = any, ParentType extends TResolversParentTypes['RadarCharts'] = TResolversParentTypes['RadarCharts']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['Float']>, ParentType, ContextType>;
  maxDataValue?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TRankingResolvers<ContextType = any, ParentType extends TResolversParentTypes['Ranking'] = TResolversParentTypes['Ranking']> = ResolversObject<{
  average?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  certificates?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  days?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TRealGoalResolvers<ContextType = any, ParentType extends TResolversParentTypes['RealGoal'] = TResolversParentTypes['RealGoal']> = ResolversObject<{
  actionPlan?: Resolver<TResolversTypes['ActionPlan'], ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  details?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  responsible?: Resolver<Maybe<TResolversTypes['Person']>, ParentType, ContextType>;
  value?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TRealGoalOnActionPlanResolvers<ContextType = any, ParentType extends TResolversParentTypes['RealGoalOnActionPlan'] = TResolversParentTypes['RealGoalOnActionPlan']> = ResolversObject<{
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  details?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  responsible?: Resolver<Maybe<TResolversTypes['Person']>, ParentType, ContextType>;
  value?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TReasonsChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['ReasonsChart'] = TResolversParentTypes['ReasonsChart']> = ResolversObject<{
  admissional?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  damage?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  defect?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  demissional?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  dielectricTest?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  functionChange?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  hasIpeDeliveries?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  loss?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  medicalPrescription?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  other?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  sanitation?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  theft?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  wear?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TRecognizedIcdInfoResolvers<ContextType = any, ParentType extends TResolversParentTypes['RecognizedIcdInfo'] = TResolversParentTypes['RecognizedIcdInfo']> = ResolversObject<{
  code?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['ID'], ParentType, ContextType>;
}>;

export type TRecognizedMedicalCertificateDataResolvers<ContextType = any, ParentType extends TResolversParentTypes['RecognizedMedicalCertificateData'] = TResolversParentTypes['RecognizedMedicalCertificateData']> = ResolversObject<{
  amountOfTreatmentDays?: Resolver<Maybe<TResolversTypes['Int']>, ParentType, ContextType>;
  certificateType?: Resolver<Maybe<TResolversTypes['CertificateType']>, ParentType, ContextType>;
  crmState?: Resolver<Maybe<TResolversTypes['State']>, ParentType, ContextType>;
  dateStart?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  derivedDisabilityRetirement?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  doctorCrm?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctorName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctorType?: Resolver<Maybe<TResolversTypes['DoctorType']>, ParentType, ContextType>;
  filledFields?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  icd?: Resolver<Maybe<TResolversTypes['RecognizedIcdInfo']>, ParentType, ContextType>;
  icdGroup?: Resolver<Maybe<TResolversTypes['RecognizedIcdInfo']>, ParentType, ContextType>;
  origin?: Resolver<Maybe<TResolversTypes['CertificateOrigin']>, ParentType, ContextType>;
  telemedicine?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type TReferencesResolvers<ContextType = any, ParentType extends TResolversParentTypes['References'] = TResolversParentTypes['References']> = ResolversObject<{
  gender?: Resolver<TResolversTypes['ExamGenderEnum'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  maxAge?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  maxPercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  maxValue?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  minAge?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  minPercent?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  minValue?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TReferralsChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['ReferralsChart'] = TResolversParentTypes['ReferralsChart']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  hasReferrals?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TReferralsQuantityChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['ReferralsQuantityChart'] = TResolversParentTypes['ReferralsQuantityChart']> = ResolversObject<{
  hasReferrals?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  referralsCounter?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  totalReferralPercentage?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
}>;

export type TRelativeIndexResolvers<ContextType = any, ParentType extends TResolversParentTypes['RelativeIndex'] = TResolversParentTypes['RelativeIndex']> = ResolversObject<{
  description?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  index?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TReleasableResultResolvers<ContextType = any, ParentType extends TResolversParentTypes['ReleasableResult'] = TResolversParentTypes['ReleasableResult']> = ResolversObject<{
  complementaryExamId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  consultationId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  examName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  examResponsibleName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  released?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  requestedAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  resultDescription?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  resultType?: Resolver<Maybe<TResolversTypes['ResultTypeEnum']>, ParentType, ContextType>;
}>;

export type TReportMapaDataResolvers<ContextType = any, ParentType extends TResolversParentTypes['ReportMapaData'] = TResolversParentTypes['ReportMapaData']> = ResolversObject<{
  biologicalLarge?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  biologicalMedium?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  biologicalSmall?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  chemicalLarge?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  chemicalMedium?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  chemicalSmall?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  cipaManagementPeriod?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  compositions?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  controlMeasure?: Resolver<Array<TResolversTypes['RiskControlMeasure']>, ParentType, ContextType>;
  environment?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ergonomicLarge?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ergonomicMedium?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ergonomicSmall?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  fields?: Resolver<TResolversTypes['ReportMapaFields'], ParentType, ContextType>;
  footer?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  image?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  mechanicalLarge?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  mechanicalMedium?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  mechanicalSmall?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  physicalLarge?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  physicalMedium?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  physicalSmall?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TReportMapaFieldsResolvers<ContextType = any, ParentType extends TResolversParentTypes['ReportMapaFields'] = TResolversParentTypes['ReportMapaFields']> = ResolversObject<{
  biological?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  chemical?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  cipaManagement?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  environmentalRisks?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ergonomic?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  intensityOfRisk?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  large?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  mechanical?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  medium?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  physical?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  riskControl?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  small?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TReportPrescriptionResolvers<ContextType = any, ParentType extends TResolversParentTypes['ReportPrescription'] = TResolversParentTypes['ReportPrescription']> = ResolversObject<{
  address?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  addressPatient?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  age?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  cnpj?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  costCenter?: Resolver<Maybe<TResolversTypes['CostCenter']>, ParentType, ContextType>;
  crmState?: Resolver<Maybe<TResolversTypes['State']>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  doctor?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  doctorCrm?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctorRqeDisplay?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  documentNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  footer?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  gender?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  medicines?: Resolver<Array<TResolversTypes['MedicinesPrescription']>, ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  organizationPicture?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  printAmounts?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  showAddressPatient?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  telephone?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TReportSectionResolvers<ContextType = any, ParentType extends TResolversParentTypes['ReportSection'] = TResolversParentTypes['ReportSection']> = ResolversObject<{
  attachment?: Resolver<Maybe<TResolversTypes['Attachment']>, ParentType, ContextType>;
  breakPage?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  content?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  onlyLinkedOccupations?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  order?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  pageOrientation?: Resolver<TResolversTypes['PageOrientation'], ParentType, ContextType>;
  parentId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  reportStructureId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  shortcut?: Resolver<Maybe<TResolversTypes['Shortcut']>, ParentType, ContextType>;
  type?: Resolver<TResolversTypes['ReportSectionType'], ParentType, ContextType>;
}>;

export type TReportStructureResolvers<ContextType = any, ParentType extends TResolversParentTypes['ReportStructure'] = TResolversParentTypes['ReportStructure']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  sections?: Resolver<Maybe<Array<TResolversTypes['ReportSection']>>, ParentType, ContextType>;
  type?: Resolver<TResolversTypes['ReportType'], ParentType, ContextType>;
}>;

export type TResponseOptionsResolvers<ContextType = any, ParentType extends TResolversParentTypes['ResponseOptions'] = TResolversParentTypes['ResponseOptions']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TResponseWorkPermissionQuizResolvers<ContextType = any, ParentType extends TResolversParentTypes['ResponseWorkPermissionQuiz'] = TResolversParentTypes['ResponseWorkPermissionQuiz']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  question?: Resolver<TResolversTypes['Questions'], ParentType, ContextType>;
  response?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  responseOption?: Resolver<Maybe<TResolversTypes['ResponseOptions']>, ParentType, ContextType>;
}>;

export type TResponsesClinicalQuizResolvers<ContextType = any, ParentType extends TResolversParentTypes['ResponsesClinicalQuiz'] = TResolversParentTypes['ResponsesClinicalQuiz']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  question?: Resolver<TResolversTypes['Questions'], ParentType, ContextType>;
  response?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  responseOption?: Resolver<Maybe<TResolversTypes['ResponseOptions']>, ParentType, ContextType>;
}>;

export type TResponsesSafetyQuizResolvers<ContextType = any, ParentType extends TResolversParentTypes['ResponsesSafetyQuiz'] = TResolversParentTypes['ResponsesSafetyQuiz']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  question?: Resolver<TResolversTypes['Questions'], ParentType, ContextType>;
  response?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  responseOption?: Resolver<Maybe<TResolversTypes['ResponseOptions']>, ParentType, ContextType>;
}>;

export type TResponsibleActionResolvers<ContextType = any, ParentType extends TResolversParentTypes['ResponsibleAction'] = TResolversParentTypes['ResponsibleAction']> = ResolversObject<{
  actionPlan?: Resolver<TResolversTypes['ActionPlan'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
}>;

export type TResponsibleOnActionPlanResolvers<ContextType = any, ParentType extends TResolversParentTypes['ResponsibleOnActionPlan'] = TResolversParentTypes['ResponsibleOnActionPlan']> = ResolversObject<{
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
}>;

export type TResultExamIbmpResolvers<ContextType = any, ParentType extends TResolversParentTypes['ResultExamIbmp'] = TResolversParentTypes['ResultExamIbmp']> = ResolversObject<{
  complementaryExam?: Resolver<Maybe<TResolversTypes['ComplementaryExam']>, ParentType, ContextType>;
  consultation?: Resolver<Maybe<TResolversTypes['Consultation']>, ParentType, ContextType>;
  crm?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  details?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  diagnosticIndicator?: Resolver<TResolversTypes['ExamDiagnosticIndicatorEnum'], ParentType, ContextType>;
  doctor?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  examAuthorization?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  indicator?: Resolver<TResolversTypes['ExamResultIndicatorEnum'], ParentType, ContextType>;
  observations?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  quantityFound?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  restTime?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  resultAggravation?: Resolver<Maybe<TResolversTypes['ExamAggravationEnum']>, ParentType, ContextType>;
  resultAlteration?: Resolver<Maybe<TResolversTypes['ExamResultAlterationEnum']>, ParentType, ContextType>;
  state?: Resolver<Maybe<TResolversTypes['State']>, ParentType, ContextType>;
}>;

export type TResultExamIbmpForComparativeResolvers<ContextType = any, ParentType extends TResolversParentTypes['ResultExamIbmpForComparative'] = TResolversParentTypes['ResultExamIbmpForComparative']> = ResolversObject<{
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  quantityFound?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TResultExamIbmpGroupResolvers<ContextType = any, ParentType extends TResolversParentTypes['ResultExamIbmpGroup'] = TResolversParentTypes['ResultExamIbmpGroup']> = ResolversObject<{
  biologicalMaterial?: Resolver<TResolversTypes['BiologicalMaterial'], ParentType, ContextType>;
  examMeasure?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  results?: Resolver<Array<TResolversTypes['ResultExamIbmpForComparative']>, ParentType, ContextType>;
  riskAgent?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TResultExamItemForComparativeResolvers<ContextType = any, ParentType extends TResolversParentTypes['ResultExamItemForComparative'] = TResolversParentTypes['ResultExamItemForComparative']> = ResolversObject<{
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  value?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TResultExamItemGroupResolvers<ContextType = any, ParentType extends TResolversParentTypes['ResultExamItemGroup'] = TResolversParentTypes['ResultExamItemGroup']> = ResolversObject<{
  analysis?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  analysisId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  examMeasure?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  results?: Resolver<Array<TResolversTypes['ResultExamItemForComparative']>, ParentType, ContextType>;
}>;

export type TResultExamOrthoRaterForComparativeResolvers<ContextType = any, ParentType extends TResolversParentTypes['ResultExamOrthoRaterForComparative'] = TResolversParentTypes['ResultExamOrthoRaterForComparative']> = ResolversObject<{
  closeBothEyes?: Resolver<Maybe<TResolversTypes['OrthoRaterValueEnum']>, ParentType, ContextType>;
  closeLateralPhoria?: Resolver<Maybe<TResolversTypes['PhoriaEnum']>, ParentType, ContextType>;
  closeLeftEye?: Resolver<Maybe<TResolversTypes['OrthoRaterValueEnum']>, ParentType, ContextType>;
  closeRightEye?: Resolver<Maybe<TResolversTypes['OrthoRaterValueEnum']>, ParentType, ContextType>;
  closeVerticalPhoria?: Resolver<Maybe<TResolversTypes['PhoriaEnum']>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  farBothEyes?: Resolver<Maybe<TResolversTypes['OrthoRaterValueEnum']>, ParentType, ContextType>;
  farLateralPhoria?: Resolver<Maybe<TResolversTypes['PhoriaEnum']>, ParentType, ContextType>;
  farLeftEye?: Resolver<Maybe<TResolversTypes['OrthoRaterValueEnum']>, ParentType, ContextType>;
  farRightEye?: Resolver<Maybe<TResolversTypes['OrthoRaterValueEnum']>, ParentType, ContextType>;
  farVerticalPhoria?: Resolver<Maybe<TResolversTypes['PhoriaEnum']>, ParentType, ContextType>;
}>;

export type TResultExamSnellenForComparativeResolvers<ContextType = any, ParentType extends TResolversParentTypes['ResultExamSnellenForComparative'] = TResolversParentTypes['ResultExamSnellenForComparative']> = ResolversObject<{
  bothEyes?: Resolver<Maybe<TResolversTypes['SnellenValue']>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  leftEye?: Resolver<Maybe<TResolversTypes['SnellenValue']>, ParentType, ContextType>;
  rightEye?: Resolver<Maybe<TResolversTypes['SnellenValue']>, ParentType, ContextType>;
}>;

export type TResultExamSpirometryForComparativeResolvers<ContextType = any, ParentType extends TResolversParentTypes['ResultExamSpirometryForComparative'] = TResolversParentTypes['ResultExamSpirometryForComparative']> = ResolversObject<{
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  value?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TResultExamSpirometryGroupResolvers<ContextType = any, ParentType extends TResolversParentTypes['ResultExamSpirometryGroup'] = TResolversParentTypes['ResultExamSpirometryGroup']> = ResolversObject<{
  identifier?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  results?: Resolver<Array<TResolversTypes['ResultExamSpirometryForComparative']>, ParentType, ContextType>;
}>;

export type TResultUrinalysisForComparativeResolvers<ContextType = any, ParentType extends TResolversParentTypes['ResultUrinalysisForComparative'] = TResolversParentTypes['ResultUrinalysisForComparative']> = ResolversObject<{
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TResultUrinalysisGroupResolvers<ContextType = any, ParentType extends TResolversParentTypes['ResultUrinalysisGroup'] = TResolversParentTypes['ResultUrinalysisGroup']> = ResolversObject<{
  identifier?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  results?: Resolver<Array<TResolversTypes['ResultUrinalysisForComparative']>, ParentType, ContextType>;
}>;

export type TReturnReasonsChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['ReturnReasonsChart'] = TResolversParentTypes['ReturnReasonsChart']> = ResolversObject<{
  dismissal?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  functionChange?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  hasIpeDeliveries?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  medicalRestriction?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  socialSecurityLeave?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  temporary?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TRiskResolvers<ContextType = any, ParentType extends TResolversParentTypes['Risk'] = TResolversParentTypes['Risk']> = ResolversObject<{
  actionLevel?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  agent?: Resolver<TResolversTypes['RiskAgent'], ParentType, ContextType>;
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  category?: Resolver<Maybe<TResolversTypes['RiskCategory']>, ParentType, ContextType>;
  classification?: Resolver<Maybe<TResolversTypes['RiskClassification']>, ParentType, ContextType>;
  composition?: Resolver<Maybe<TResolversTypes['RiskComposition']>, ParentType, ContextType>;
  consider?: Resolver<Maybe<TResolversTypes['ConsiderPrint']>, ParentType, ContextType>;
  controlMeasures?: Resolver<Maybe<Array<TResolversTypes['ControlMeasureByRisk']>>, ParentType, ContextType>;
  costCenters?: Resolver<Maybe<Array<TResolversTypes['CostCenterByRisk']>>, ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  damageCaused?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  dangerousEvent?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  departments?: Resolver<Maybe<Array<TResolversTypes['DepartmentByRisk']>>, ParentType, ContextType>;
  desiredSituation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  elimination?: Resolver<Maybe<TResolversTypes['RiskElimination']>, ParentType, ContextType>;
  eliminationDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  environment?: Resolver<TResolversTypes['PhysicalEnvironment'], ParentType, ContextType>;
  ergonomicStatus?: Resolver<Maybe<TResolversTypes['ErgonomicStatus']>, ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  errorIntegration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  exams?: Resolver<Maybe<Array<TResolversTypes['ExamByRisk']>>, ParentType, ContextType>;
  exchangePeriodicity?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  exhibitionType?: Resolver<Maybe<TResolversTypes['ExhibitionType']>, ParentType, ContextType>;
  expirationDate?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  exposureGroup?: Resolver<Maybe<TResolversTypes['ExposureGroup']>, ParentType, ContextType>;
  exposureGroupId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  exposureTime?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  generatingSource?: Resolver<TResolversTypes['GeneratingSource'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  intensity?: Resolver<Maybe<TResolversTypes['RiskIntensity']>, ParentType, ContextType>;
  interval?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  ipes?: Resolver<Maybe<Array<TResolversTypes['IpeByRisk']>>, ParentType, ContextType>;
  isQualitative?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  justification?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  lastMeasurement?: Resolver<Maybe<TResolversTypes['MeasurementByRisk']>, ParentType, ContextType>;
  legalFramework?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  levelControl?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  maxExposureTime?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  measureType?: Resolver<Maybe<TResolversTypes['RiskMeasureType']>, ParentType, ContextType>;
  measurements?: Resolver<Maybe<Array<TResolversTypes['MeasurementByRisk']>>, ParentType, ContextType>;
  methodology?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  needCpe?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  needIpe?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  occupations?: Resolver<Maybe<Array<TResolversTypes['OccupationByRisk']>>, ParentType, ContextType>;
  organizationalControl?: Resolver<Maybe<TResolversTypes['RiskOrganizationalControl']>, ParentType, ContextType>;
  persons?: Resolver<Maybe<Array<TResolversTypes['PersonByRisk']>>, ParentType, ContextType>;
  printSWO?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  probability?: Resolver<Maybe<TResolversTypes['RiskProbability']>, ParentType, ContextType>;
  processNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  protectionMeasure?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  recognitionDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  repetition?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  riskDegree?: Resolver<Maybe<TResolversTypes['RiskDegree']>, ParentType, ContextType>;
  riskMap?: Resolver<Maybe<TResolversTypes['RiskMap']>, ParentType, ContextType>;
  sanitation?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  severity?: Resolver<Maybe<TResolversTypes['RiskSeverity']>, ParentType, ContextType>;
  situationFound?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  specialRetirement?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  tasks?: Resolver<Maybe<Array<TResolversTypes['TaskByRisk']>>, ParentType, ContextType>;
  techniqueUsed?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  tecnicalControl?: Resolver<Maybe<TResolversTypes['RiskTecnicalControl']>, ParentType, ContextType>;
  trainings?: Resolver<Maybe<Array<TResolversTypes['TrainingByRisk']>>, ParentType, ContextType>;
  uninterruptedUse?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  unitMeasurement?: Resolver<Maybe<TResolversTypes['RiskMeasure']>, ParentType, ContextType>;
  updatedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  usesExposureGroup?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  workingCondition?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type TRiskAgentResolvers<ContextType = any, ParentType extends TResolversParentTypes['RiskAgent'] = TResolversParentTypes['RiskAgent']> = ResolversObject<{
  actionLevel?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  activeSubstance?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  bonus?: Resolver<Maybe<TResolversTypes['AgentBonus']>, ParentType, ContextType>;
  classification?: Resolver<Maybe<TResolversTypes['AgentClassification']>, ParentType, ContextType>;
  considerInPca?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  endurance?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  entrance?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  evaluation?: Resolver<TResolversTypes['AgentEvaluation'], ParentType, ContextType>;
  group?: Resolver<TResolversTypes['AgentGroup'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  pathogenicity?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  propagation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  riskAgent?: Resolver<Maybe<TResolversTypes['GenericRiskAgent']>, ParentType, ContextType>;
  source?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  study?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  suggestion?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  symptomatology?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  transmissibility?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  transmissionWays?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  virulence?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TRiskCharacterizationResolvers<ContextType = any, ParentType extends TResolversParentTypes['RiskCharacterization'] = TResolversParentTypes['RiskCharacterization']> = ResolversObject<{
  costCenters?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  departments?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  emptyGHE?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  occupations?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  people?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  tasks?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TRiskChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['RiskChart'] = TResolversParentTypes['RiskChart']> = ResolversObject<{
  hasRisk?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  riskCountData?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  riskPerTotal?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
}>;

export type TRiskClassificationTableResolvers<ContextType = any, ParentType extends TResolversParentTypes['RiskClassificationTable'] = TResolversParentTypes['RiskClassificationTable']> = ResolversObject<{
  intolerable?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  moderate?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  substantial?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  tolerable?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  trivial?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TRiskCompositionResolvers<ContextType = any, ParentType extends TResolversParentTypes['RiskComposition'] = TResolversParentTypes['RiskComposition']> = ResolversObject<{
  coordinateX?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  coordinateY?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  risks?: Resolver<Array<TResolversTypes['Risk']>, ParentType, ContextType>;
}>;

export type TRiskControlMeasureResolvers<ContextType = any, ParentType extends TResolversParentTypes['RiskControlMeasure'] = TResolversParentTypes['RiskControlMeasure']> = ResolversObject<{
  riskAgent?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  riskControl?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TRiskCostCenterOccupationResolvers<ContextType = any, ParentType extends TResolversParentTypes['RiskCostCenterOccupation'] = TResolversParentTypes['RiskCostCenterOccupation']> = ResolversObject<{
  costCenterDescription?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupationDescription?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  risksInfo?: Resolver<Maybe<Array<TResolversTypes['RisksInfo']>>, ParentType, ContextType>;
}>;

export type TRiskCostCenterOccupationIdsResolvers<ContextType = any, ParentType extends TResolversParentTypes['RiskCostCenterOccupationIds'] = TResolversParentTypes['RiskCostCenterOccupationIds']> = ResolversObject<{
  costCenterId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupationId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TRiskCountResolvers<ContextType = any, ParentType extends TResolversParentTypes['RiskCount'] = TResolversParentTypes['RiskCount']> = ResolversObject<{
  active?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  eliminated?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TRiskDashboardResolvers<ContextType = any, ParentType extends TResolversParentTypes['RiskDashboard'] = TResolversParentTypes['RiskDashboard']> = ResolversObject<{
  classificationPure?: Resolver<TResolversTypes['ClassificationPure'], ParentType, ContextType>;
  controlMeasuresAppliedChart?: Resolver<TResolversTypes['RiskPieChart'], ParentType, ContextType>;
  controlMeasuresChart?: Resolver<TResolversTypes['ControlMeasuresChart'], ParentType, ContextType>;
  costCenterChart?: Resolver<TResolversTypes['RiskChart'], ParentType, ContextType>;
  departmentChart?: Resolver<TResolversTypes['RiskChart'], ParentType, ContextType>;
  epcIncidenceChart?: Resolver<TResolversTypes['EpcIncidenceChart'], ParentType, ContextType>;
  ipesChart?: Resolver<TResolversTypes['RiskPieChart'], ParentType, ContextType>;
  measurementDevicesChart?: Resolver<TResolversTypes['MeasurementDevicesChart'], ParentType, ContextType>;
  occupationChart?: Resolver<TResolversTypes['RiskChart'], ParentType, ContextType>;
  riskClassification?: Resolver<TResolversTypes['RiskClassificationTable'], ParentType, ContextType>;
  riskProbability?: Resolver<TResolversTypes['RiskProbabilityTable'], ParentType, ContextType>;
  riskSeverity?: Resolver<TResolversTypes['RiskSeverityTable'], ParentType, ContextType>;
  risksAgentChart?: Resolver<TResolversTypes['RiskPieChart'], ParentType, ContextType>;
  risksAgentTypeChart?: Resolver<TResolversTypes['AgentGroupChart'], ParentType, ContextType>;
  risksPerEnvironmentChart?: Resolver<TResolversTypes['RisksPerEnvironmentChart'], ParentType, ContextType>;
  taskChart?: Resolver<TResolversTypes['RiskChart'], ParentType, ContextType>;
}>;

export type TRiskEnvironmentResolvers<ContextType = any, ParentType extends TResolversParentTypes['RiskEnvironment'] = TResolversParentTypes['RiskEnvironment']> = ResolversObject<{
  descriptionPE?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  descriptionRA?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TRiskMeasurementResolvers<ContextType = any, ParentType extends TResolversParentTypes['RiskMeasurement'] = TResolversParentTypes['RiskMeasurement']> = ResolversObject<{
  agent?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  desiredSituation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ergonomicStatus?: Resolver<TResolversTypes['ErgonomicStatus'], ParentType, ContextType>;
  nameMeasure?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  situationFound?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TRiskMeasurementsResolvers<ContextType = any, ParentType extends TResolversParentTypes['RiskMeasurements'] = TResolversParentTypes['RiskMeasurements']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  measurements?: Resolver<Array<TResolversTypes['Measurements']>, ParentType, ContextType>;
}>;

export type TRiskPieChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['RiskPieChart'] = TResolversParentTypes['RiskPieChart']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['PieChart']>, ParentType, ContextType>;
  hasRisk?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TRiskProbabilityTableResolvers<ContextType = any, ParentType extends TResolversParentTypes['RiskProbabilityTable'] = TResolversParentTypes['RiskProbabilityTable']> = ResolversObject<{
  high?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  intermediate?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  low?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  medium?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  veryHigh?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TRiskReviewReportFieldsResolvers<ContextType = any, ParentType extends TResolversParentTypes['RiskReviewReportFields'] = TResolversParentTypes['RiskReviewReportFields']> = ResolversObject<{
  environment?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  hazard?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  lastAssessment?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  noData?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  recognitionDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  sourceGenerator?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TRiskSeverityTableResolvers<ContextType = any, ParentType extends TResolversParentTypes['RiskSeverityTable'] = TResolversParentTypes['RiskSeverityTable']> = ResolversObject<{
  intermediate?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  mild?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  moderate?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  severe?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  verySevere?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TRiskSuggestionResolvers<ContextType = any, ParentType extends TResolversParentTypes['RiskSuggestion'] = TResolversParentTypes['RiskSuggestion']> = ResolversObject<{
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TRiskToReviewResolvers<ContextType = any, ParentType extends TResolversParentTypes['RiskToReview'] = TResolversParentTypes['RiskToReview']> = ResolversObject<{
  agent?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  environment?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  lastMeasurement?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  recognitionDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  source?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TRiskToReviewReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['RiskToReviewReport'] = TResolversParentTypes['RiskToReviewReport']> = ResolversObject<{
  address?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  cnpj?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  companyName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  fields?: Resolver<TResolversTypes['RiskReviewReportFields'], ParentType, ContextType>;
  footer?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  risks?: Resolver<Array<TResolversTypes['RiskToReview']>, ParentType, ContextType>;
  telephone?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TRiskTrainingsResolvers<ContextType = any, ParentType extends TResolversParentTypes['RiskTrainings'] = TResolversParentTypes['RiskTrainings']> = ResolversObject<{
  training?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TRisksExamResolvers<ContextType = any, ParentType extends TResolversParentTypes['RisksExam'] = TResolversParentTypes['RisksExam']> = ResolversObject<{
  admission?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  backToWork?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  changeOfFunction?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  dismissal?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  examDescription?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  periodicity?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  postAdmission?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TRisksInfoResolvers<ContextType = any, ParentType extends TResolversParentTypes['RisksInfo'] = TResolversParentTypes['RisksInfo']> = ResolversObject<{
  agentDescription?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  agentGroup?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  controlMesures?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  risksExams?: Resolver<Maybe<Array<TResolversTypes['RisksExam']>>, ParentType, ContextType>;
}>;

export type TRisksPerEnvironmentChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['RisksPerEnvironmentChart'] = TResolversParentTypes['RisksPerEnvironmentChart']> = ResolversObject<{
  association?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  biological?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  chemical?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  dangerous?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  enviromentsPerTotal?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  ergonomic?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  hasRisk?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  mechanical?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  other?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  physical?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
}>;

export type TRoleResolvers<ContextType = any, ParentType extends TResolversParentTypes['Role'] = TResolversParentTypes['Role']> = ResolversObject<{
  branch?: Resolver<TResolversTypes['Branch'], ParentType, ContextType>;
  branchId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  roleId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TRolePermissionResolvers<ContextType = any, ParentType extends TResolversParentTypes['RolePermission'] = TResolversParentTypes['RolePermission']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  endHour?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  permission?: Resolver<Array<TResolversTypes['Permission']>, ParentType, ContextType>;
  reference?: Resolver<TResolversTypes['GenericRolePermission'], ParentType, ContextType>;
  referenceId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  startHour?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TRouteFeatureResolvers<ContextType = any, ParentType extends TResolversParentTypes['RouteFeature'] = TResolversParentTypes['RouteFeature']> = ResolversObject<{
  feature?: Resolver<TResolversTypes['FeatureEnum'], ParentType, ContextType>;
  route?: Resolver<TResolversTypes['RouteEnum'], ParentType, ContextType>;
}>;

export type TRowsInfoResolvers<ContextType = any, ParentType extends TResolversParentTypes['RowsInfo'] = TResolversParentTypes['RowsInfo']> = ResolversObject<{
  data?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  errors?: Resolver<Maybe<Array<TResolversTypes['ValidationError']>>, ParentType, ContextType>;
  lineNumber?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  originalLine?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  valid?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export interface TS3UrlCloudFrontScalarConfig extends GraphQLScalarTypeConfig<TResolversTypes['S3UrlCloudFront'], any> {
  name: 'S3UrlCloudFront';
}

export type TSaasFullMetadataResolvers<ContextType = any, ParentType extends TResolversParentTypes['SaasFullMetadata'] = TResolversParentTypes['SaasFullMetadata']> = ResolversObject<{
  fields?: Resolver<Array<TResolversTypes['InternalFields']>, ParentType, ContextType>;
  genericMetadata?: Resolver<Maybe<TResolversTypes['GenericMetadata']>, ParentType, ContextType>;
  genericMetadataId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  integrationType?: Resolver<TResolversTypes['ErpType'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  isCustomizable?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TSaasMetadataResolvers<ContextType = any, ParentType extends TResolversParentTypes['SaasMetadata'] = TResolversParentTypes['SaasMetadata']> = ResolversObject<{
  genericMetadata?: Resolver<Maybe<TResolversTypes['GenericMetadata']>, ParentType, ContextType>;
  genericMetadataId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  integrationType?: Resolver<TResolversTypes['ErpType'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  isCustomizable?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TSafetyQuizResolvers<ContextType = any, ParentType extends TResolversParentTypes['SafetyQuiz'] = TResolversParentTypes['SafetyQuiz']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  personId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  quiz?: Resolver<TResolversTypes['Quiz'], ParentType, ContextType>;
  realizationDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  responses?: Resolver<Array<TResolversTypes['ResponsesSafetyQuiz']>, ParentType, ContextType>;
}>;

export type TSafetyQuizConformityChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['SafetyQuizConformityChart'] = TResolversParentTypes['SafetyQuizConformityChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['SafetyQuizConformityEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  total?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TSafetyQuizConformityEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['SafetyQuizConformityEntry'] = TResolversParentTypes['SafetyQuizConformityEntry']> = ResolversObject<{
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TSafetyQuizDashboardResolvers<ContextType = any, ParentType extends TResolversParentTypes['SafetyQuizDashboard'] = TResolversParentTypes['SafetyQuizDashboard']> = ResolversObject<{
  conformity?: Resolver<TResolversTypes['SafetyQuizConformityChart'], ParentType, ContextType>;
  deviationsByCostCenter?: Resolver<TResolversTypes['SafetyQuizParetoChart'], ParentType, ContextType>;
  deviationsByDepartment?: Resolver<TResolversTypes['SafetyQuizParetoChart'], ParentType, ContextType>;
  deviationsByEnvironment?: Resolver<TResolversTypes['SafetyQuizParetoChart'], ParentType, ContextType>;
  deviationsByGeneratingSource?: Resolver<TResolversTypes['SafetyQuizParetoChart'], ParentType, ContextType>;
  deviationsByOccupation?: Resolver<TResolversTypes['SafetyQuizParetoChart'], ParentType, ContextType>;
  deviationsByPerson?: Resolver<TResolversTypes['SafetyQuizParetoChart'], ParentType, ContextType>;
  inspections?: Resolver<TResolversTypes['SafetyQuizInspectionChart'], ParentType, ContextType>;
}>;

export type TSafetyQuizInspectionChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['SafetyQuizInspectionChart'] = TResolversParentTypes['SafetyQuizInspectionChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['SafetyQuizInspectionEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  totalPlanned?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  totalRealized?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TSafetyQuizInspectionEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['SafetyQuizInspectionEntry'] = TResolversParentTypes['SafetyQuizInspectionEntry']> = ResolversObject<{
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  planned?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  realized?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TSafetyQuizParetoChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['SafetyQuizParetoChart'] = TResolversParentTypes['SafetyQuizParetoChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['SafetyQuizParetoEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  total?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TSafetyQuizParetoEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['SafetyQuizParetoEntry'] = TResolversParentTypes['SafetyQuizParetoEntry']> = ResolversObject<{
  cumulativePercent?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TScheduleRestrictionResolvers<ContextType = any, ParentType extends TResolversParentTypes['ScheduleRestriction'] = TResolversParentTypes['ScheduleRestriction']> = ResolversObject<{
  dateEnd?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  dateStart?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  doctor?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  observation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<TResolversTypes['RestrictionType'], ParentType, ContextType>;
}>;

export type TScheduledConsultationResolvers<ContextType = any, ParentType extends TResolversParentTypes['ScheduledConsultation'] = TResolversParentTypes['ScheduledConsultation']> = ResolversObject<{
  admissionDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  department?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  diagnostic?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  diagnosticDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  dismissalDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  doctor?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  estimatedDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  icd?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  icdDescription?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  individualRegistration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  medicalRecord?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nature?: Resolver<TResolversTypes['ConsultationNature'], ParentType, ContextType>;
  nurse?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  occupation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  registration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  screeningDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<TResolversTypes['ConsultationType'], ParentType, ContextType>;
}>;

export type TScheduledConsultationByBranchResolvers<ContextType = any, ParentType extends TResolversParentTypes['ScheduledConsultationByBranch'] = TResolversParentTypes['ScheduledConsultationByBranch']> = ResolversObject<{
  accredited?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  admissionDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  branch?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  department?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  diagnostic?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  diagnosticDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  dismissalDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  doctor?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  document?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  erpBranch?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  estimatedDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  icd?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  icdDescription?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  individualRegistration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  medicalRecord?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nature?: Resolver<TResolversTypes['ConsultationNature'], ParentType, ContextType>;
  nurse?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  occupation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  organization?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  registration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  screeningDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<TResolversTypes['ConsultationType'], ParentType, ContextType>;
}>;

export type TScheduledConsultationToPrintResolvers<ContextType = any, ParentType extends TResolversParentTypes['ScheduledConsultationToPrint'] = TResolversParentTypes['ScheduledConsultationToPrint']> = ResolversObject<{
  admissionDate?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  costCenter?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  department?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  diagnostic?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  diagnosticDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  dismissalDate?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  eSocialCategory?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  estimatedDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  icd?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  individualRegistration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  medicalRecord?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nature?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nurse?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  occupation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  registration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  screeningBy?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  screeningDate?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TScheduledExamResolvers<ContextType = any, ParentType extends TResolversParentTypes['ScheduledExam'] = TResolversParentTypes['ScheduledExam']> = ResolversObject<{
  endDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  estimatedDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  exam?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  medicalRecord?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nature?: Resolver<TResolversTypes['ConsultationNature'], ParentType, ContextType>;
  result?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<TResolversTypes['ConsultationType'], ParentType, ContextType>;
}>;

export type TScheduledExamByBranchResolvers<ContextType = any, ParentType extends TResolversParentTypes['ScheduledExamByBranch'] = TResolversParentTypes['ScheduledExamByBranch']> = ResolversObject<{
  accredited?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  branch?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  doctor?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  document?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  eSocialCategory?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  erpBranch?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  estimatedDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  exam?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  individualRegistration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  medicalRecord?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nature?: Resolver<TResolversTypes['ConsultationNature'], ParentType, ContextType>;
  occupation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  organization?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  registration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<TResolversTypes['ConsultationType'], ParentType, ContextType>;
}>;

export type TScheduledExamToPrintResolvers<ContextType = any, ParentType extends TResolversParentTypes['ScheduledExamToPrint'] = TResolversParentTypes['ScheduledExamToPrint']> = ResolversObject<{
  costCenter?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  eSocialCategory?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  estimatedDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  exam?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  individualRegistration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  medicalRecord?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nature?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  registration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  startDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TSchedulingByAccreditedResolvers<ContextType = any, ParentType extends TResolversParentTypes['SchedulingByAccredited'] = TResolversParentTypes['SchedulingByAccredited']> = ResolversObject<{
  accredited?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  exam?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  individualRegistration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  registration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TSchedulingParametersResolvers<ContextType = any, ParentType extends TResolversParentTypes['SchedulingParameters'] = TResolversParentTypes['SchedulingParameters']> = ResolversObject<{
  costCenters?: Resolver<Maybe<Array<TResolversTypes['String']>>, ParentType, ContextType>;
  exams?: Resolver<Maybe<Array<TResolversTypes['String']>>, ParentType, ContextType>;
  fromDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  natures?: Resolver<Maybe<Array<TResolversTypes['ConsultationNature']>>, ParentType, ContextType>;
  occupations?: Resolver<Maybe<Array<TResolversTypes['String']>>, ParentType, ContextType>;
  showsLate?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  showsNonRealized?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  showsRealized?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  situations?: Resolver<Maybe<Array<TResolversTypes['EmployeeSituation']>>, ParentType, ContextType>;
  toDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type TSchedulingReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['SchedulingReport'] = TResolversParentTypes['SchedulingReport']> = ResolversObject<{
  consultations?: Resolver<Maybe<Array<TResolversTypes['ConsultationByBranchToPrint']>>, ParentType, ContextType>;
  exams?: Resolver<Maybe<Array<TResolversTypes['ExamByBranchToPrint']>>, ParentType, ContextType>;
}>;

export type TSchedulingReportByDoctorResolvers<ContextType = any, ParentType extends TResolversParentTypes['SchedulingReportByDoctor'] = TResolversParentTypes['SchedulingReportByDoctor']> = ResolversObject<{
  consultations?: Resolver<Maybe<Array<TResolversTypes['ScheduledConsultationToPrint']>>, ParentType, ContextType>;
  exams?: Resolver<Maybe<Array<TResolversTypes['ScheduledExamToPrint']>>, ParentType, ContextType>;
}>;

export type TSchedulingSettingsResolvers<ContextType = any, ParentType extends TResolversParentTypes['SchedulingSettings'] = TResolversParentTypes['SchedulingSettings']> = ResolversObject<{
  branchDefaultConsultationMinutes?: Resolver<Maybe<TResolversTypes['Int']>, ParentType, ContextType>;
  defaultConsultationMinutes?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  organizationDefaultConsultationMinutes?: Resolver<Maybe<TResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type TSecurityPyramidResolvers<ContextType = any, ParentType extends TResolversParentTypes['SecurityPyramid'] = TResolversParentTypes['SecurityPyramid']> = ResolversObject<{
  death?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  hasAccident?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  incident?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  lostDays?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  noLostDays?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TSecurityWorkOrderResolvers<ContextType = any, ParentType extends TResolversParentTypes['SecurityWorkOrder'] = TResolversParentTypes['SecurityWorkOrder']> = ResolversObject<{
  activity?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  controlMeasures?: Resolver<Maybe<Array<TResolversTypes['FuncionalHistoryControlMeasure']>>, ParentType, ContextType>;
  emergency?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  historyStart?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  personAdmissionDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  personBirthday?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  personCostCenter?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  personCtps?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  personDepartment?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  personExam?: Resolver<Array<TResolversTypes['FuncionalHistoryExamTranslated']>, ParentType, ContextType>;
  personIpe?: Resolver<Array<TResolversTypes['FuncionalHistoryIpeTranslated']>, ParentType, ContextType>;
  personName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  personOccupation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  personRegistration?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  personRisk?: Resolver<Array<TResolversTypes['FuncionalHistoryRiskTranslated']>, ParentType, ContextType>;
  responsibilities?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  restrictions?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  term?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  trainings?: Resolver<Maybe<Array<TResolversTypes['RiskTrainings']>>, ParentType, ContextType>;
}>;

export type TSecurityWorkOrderParametersResolvers<ContextType = any, ParentType extends TResolversParentTypes['SecurityWorkOrderParameters'] = TResolversParentTypes['SecurityWorkOrderParameters']> = ResolversObject<{
  costCenters?: Resolver<Maybe<Array<TResolversTypes['String']>>, ParentType, ContextType>;
  departments?: Resolver<Maybe<Array<TResolversTypes['String']>>, ParentType, ContextType>;
  epi?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  exams?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  fromDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  observations?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  occupations?: Resolver<Maybe<Array<TResolversTypes['String']>>, ParentType, ContextType>;
  risks?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  statementsResponsibility?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  toDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type TSesmtRolesResolvers<ContextType = any, ParentType extends TResolversParentTypes['SesmtRoles'] = TResolversParentTypes['SesmtRoles']> = ResolversObject<{
  amount?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  role?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TSessionResolvers<ContextType = any, ParentType extends TResolversParentTypes['Session'] = TResolversParentTypes['Session']> = ResolversObject<{
  branch?: Resolver<Maybe<TResolversTypes['BranchWithOrganization']>, ParentType, ContextType>;
  data?: Resolver<TResolversTypes['SessionData'], ParentType, ContextType>;
  serial?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  timeZone?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<TResolversTypes['User'], ParentType, ContextType>;
  validSubscription?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TSessionDataResolvers<ContextType = any, ParentType extends TResolversParentTypes['SessionData'] = TResolversParentTypes['SessionData']> = ResolversObject<{
  userAgent?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TSettingsResolvers<ContextType = any, ParentType extends TResolversParentTypes['Settings'] = TResolversParentTypes['Settings']> = ResolversObject<{
  defaultConsultationMinutes?: Resolver<Maybe<TResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type TSeverityIndexResolvers<ContextType = any, ParentType extends TResolversParentTypes['SeverityIndex'] = TResolversParentTypes['SeverityIndex']> = ResolversObject<{
  description?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  index?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TShortcutGeneratedResolvers<ContextType = any, ParentType extends TResolversParentTypes['ShortcutGenerated'] = TResolversParentTypes['ShortcutGenerated']> = ResolversObject<{
  attachment?: Resolver<Maybe<TResolversTypes['Attachment']>, ParentType, ContextType>;
  html?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TShortcutHistoryResolvers<ContextType = any, ParentType extends TResolversParentTypes['ShortcutHistory'] = TResolversParentTypes['ShortcutHistory']> = ResolversObject<{
  cbo?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  period?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TShortcutHistoryIdResolvers<ContextType = any, ParentType extends TResolversParentTypes['ShortcutHistoryId'] = TResolversParentTypes['ShortcutHistoryId']> = ResolversObject<{
  occupationId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  period?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  realizationDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type TSickNoteResolvers<ContextType = any, ParentType extends TResolversParentTypes['SickNote'] = TResolversParentTypes['SickNote']> = ResolversObject<{
  absenceEndDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  absenceStartDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  accident?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  allowanceEndDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  allowanceStartDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  classEntityRegistrationCode?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  classEntityState?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  doctorName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  expectedEndDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  internationalDiseaseClassification?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  length?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  numberOfBenefit?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  observation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  origin?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  reviewDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  typeOfAbsence?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  typeOfAllowance?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TSignBrokerGetDocumentResolvers<ContextType = any, ParentType extends TResolversParentTypes['SignBrokerGetDocument'] = TResolversParentTypes['SignBrokerGetDocument']> = ResolversObject<{
  documentId?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  fileName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  originalFileUrl?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  pending?: Resolver<Array<TResolversTypes['DocumentPendingSigner']>, ParentType, ContextType>;
  status?: Resolver<TResolversTypes['DocumentStatus'], ParentType, ContextType>;
}>;

export type TSignBrokerGetDocumentsResolvers<ContextType = any, ParentType extends TResolversParentTypes['SignBrokerGetDocuments'] = TResolversParentTypes['SignBrokerGetDocuments']> = ResolversObject<{
  createdAt?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  documentId?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  expirationAt?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  fileName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  folder?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  modifiedAt?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  observers?: Resolver<Array<TResolversTypes['DocumentObserver']>, ParentType, ContextType>;
  pending?: Resolver<Array<TResolversTypes['DocumentPendingSigner']>, ParentType, ContextType>;
  permissions?: Resolver<TResolversTypes['DocumentPermissions'], ParentType, ContextType>;
  signers?: Resolver<Array<TResolversTypes['DocumentSigner']>, ParentType, ContextType>;
  status?: Resolver<TResolversTypes['DocumentStatus'], ParentType, ContextType>;
  user?: Resolver<TResolversTypes['DocumentUser'], ParentType, ContextType>;
}>;

export type TSignBrokerGetDocumentsAndUpdateStateResolvers<ContextType = any, ParentType extends TResolversParentTypes['SignBrokerGetDocumentsAndUpdateState'] = TResolversParentTypes['SignBrokerGetDocumentsAndUpdateState']> = ResolversObject<{
  createdAt?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  documentId?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  entity?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  pendings?: Resolver<Array<TResolversTypes['DocumentPendingSigner']>, ParentType, ContextType>;
  signers?: Resolver<Array<TResolversTypes['DocumentSigner']>, ParentType, ContextType>;
  status?: Resolver<TResolversTypes['DocumentStatus'], ParentType, ContextType>;
}>;

export type TSignBrokerResponseResolvers<ContextType = any, ParentType extends TResolversParentTypes['SignBrokerResponse'] = TResolversParentTypes['SignBrokerResponse']> = ResolversObject<{
  data?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  errors?: Resolver<Maybe<TResolversTypes['ErrorResponse']>, ParentType, ContextType>;
  success?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TSignBrokerUrlDownloadResponseResolvers<ContextType = any, ParentType extends TResolversParentTypes['SignBrokerUrlDownloadResponse'] = TResolversParentTypes['SignBrokerUrlDownloadResponse']> = ResolversObject<{
  certifiedFileUrl?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  originalFileUrl?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  signedFileUrl?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  zipUrl?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TSignCredentialsOutputResolvers<ContextType = any, ParentType extends TResolversParentTypes['SignCredentialsOutput'] = TResolversParentTypes['SignCredentialsOutput']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  signIntegration?: Resolver<TResolversTypes['SignIntegrations'], ParentType, ContextType>;
  userName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TSignatureChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['SignatureChart'] = TResolversParentTypes['SignatureChart']> = ResolversObject<{
  hasIpeDeliveries?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  signed?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  unsigned?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TSimpleComplementaryResultsResolvers<ContextType = any, ParentType extends TResolversParentTypes['SimpleComplementaryResults'] = TResolversParentTypes['SimpleComplementaryResults']> = ResolversObject<{
  result?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TSimulationResolvers<ContextType = any, ParentType extends TResolversParentTypes['Simulation'] = TResolversParentTypes['Simulation']> = ResolversObject<{
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  brigadeId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  fireBrigade?: Resolver<TResolversTypes['FireBrigade'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  plan?: Resolver<TResolversTypes['SimulationPlan'], ParentType, ContextType>;
  planId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  simulationActions?: Resolver<Array<TResolversTypes['SimulationAction']>, ParentType, ContextType>;
}>;

export type TSimulationActionResolvers<ContextType = any, ParentType extends TResolversParentTypes['SimulationAction'] = TResolversParentTypes['SimulationAction']> = ResolversObject<{
  accomplished?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  effective?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  observation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  simulation?: Resolver<TResolversTypes['Simulation'], ParentType, ContextType>;
  simulationId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  simulationPlanAction?: Resolver<TResolversTypes['SimulationPlanAction'], ParentType, ContextType>;
  simulationPlanActionId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TSimulationActionEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['SimulationActionEntry'] = TResolversParentTypes['SimulationActionEntry']> = ResolversObject<{
  accomplished?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  effective?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  planned?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TSimulationEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['SimulationEntry'] = TResolversParentTypes['SimulationEntry']> = ResolversObject<{
  accomplished?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  planned?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TSimulationPlanResolvers<ContextType = any, ParentType extends TResolversParentTypes['SimulationPlan'] = TResolversParentTypes['SimulationPlan']> = ResolversObject<{
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  brigadeId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  fireBrigade?: Resolver<TResolversTypes['FireBrigade'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  periodicity?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  simulationPlanActions?: Resolver<Array<TResolversTypes['SimulationPlanAction']>, ParentType, ContextType>;
  simulations?: Resolver<Array<TResolversTypes['Simulation']>, ParentType, ContextType>;
}>;

export type TSimulationPlanActionResolvers<ContextType = any, ParentType extends TResolversParentTypes['SimulationPlanAction'] = TResolversParentTypes['SimulationPlanAction']> = ResolversObject<{
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  planId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  simulationActions?: Resolver<Maybe<Array<TResolversTypes['SimulationAction']>>, ParentType, ContextType>;
}>;

export type TSipatResolvers<ContextType = any, ParentType extends TResolversParentTypes['Sipat'] = TResolversParentTypes['Sipat']> = ResolversObject<{
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  comments?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  dateEnd?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  dateStart?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  mandate?: Resolver<Maybe<TResolversTypes['Mandate']>, ParentType, ContextType>;
  sipatEvents?: Resolver<Maybe<Array<TResolversTypes['SipatEvent']>>, ParentType, ContextType>;
}>;

export type TSipatEventResolvers<ContextType = any, ParentType extends TResolversParentTypes['SipatEvent'] = TResolversParentTypes['SipatEvent']> = ResolversObject<{
  comments?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  cost?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  dateEnd?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  dateStart?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  localEvent?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  sipat?: Resolver<TResolversTypes['Sipat'], ParentType, ContextType>;
  subject?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TSituationCountResolvers<ContextType = any, ParentType extends TResolversParentTypes['SituationCount'] = TResolversParentTypes['SituationCount']> = ResolversObject<{
  percentage?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  total?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TSnellenResolvers<ContextType = any, ParentType extends TResolversParentTypes['Snellen'] = TResolversParentTypes['Snellen']> = ResolversObject<{
  aggravation?: Resolver<TResolversTypes['OphthalmologicAggravationEnum'], ParentType, ContextType>;
  bothEyes?: Resolver<TResolversTypes['SnellenValue'], ParentType, ContextType>;
  calibrationDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  complementaryExam?: Resolver<Maybe<TResolversTypes['ComplementaryExam']>, ParentType, ContextType>;
  consultation?: Resolver<Maybe<TResolversTypes['Consultation']>, ParentType, ContextType>;
  correction?: Resolver<TResolversTypes['OphthalmologicCorrectionEnum'], ParentType, ContextType>;
  crm?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  details?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  diagnosticIndicator?: Resolver<TResolversTypes['ExamDiagnosticIndicatorEnum'], ParentType, ContextType>;
  doctor?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  equipment?: Resolver<TResolversTypes['MeasuringInstrument'], ParentType, ContextType>;
  examAuthorization?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  gaugingDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  indicator?: Resolver<TResolversTypes['ExamResultIndicatorEnum'], ParentType, ContextType>;
  leftEye?: Resolver<TResolversTypes['SnellenValue'], ParentType, ContextType>;
  observations?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  responsibleForMeasuring?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  restTime?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  resultAggravation?: Resolver<Maybe<TResolversTypes['ExamAggravationEnum']>, ParentType, ContextType>;
  resultAlteration?: Resolver<Maybe<TResolversTypes['ExamResultAlterationEnum']>, ParentType, ContextType>;
  rightEye?: Resolver<TResolversTypes['SnellenValue'], ParentType, ContextType>;
  state?: Resolver<Maybe<TResolversTypes['State']>, ParentType, ContextType>;
  withCorrection?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TSparePartsResolvers<ContextType = any, ParentType extends TResolversParentTypes['SpareParts'] = TResolversParentTypes['SpareParts']> = ResolversObject<{
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  daysForReplacement?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  product?: Resolver<TResolversTypes['Product'], ParentType, ContextType>;
  productId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  sparePart?: Resolver<TResolversTypes['Product'], ParentType, ContextType>;
  sparePartId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TSparePartsReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['SparePartsReport'] = TResolversParentTypes['SparePartsReport']> = ResolversObject<{
  amount?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  prevDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  signDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TStabilityTypeResolvers<ContextType = any, ParentType extends TResolversParentTypes['StabilityType'] = TResolversParentTypes['StabilityType']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TStatementResponsibilityResolvers<ContextType = any, ParentType extends TResolversParentTypes['StatementResponsibility'] = TResolversParentTypes['StatementResponsibility']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  statement?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TStepMessageResolvers<ContextType = any, ParentType extends TResolversParentTypes['StepMessage'] = TResolversParentTypes['StepMessage']> = ResolversObject<{
  step?: Resolver<TResolversTypes['ProcessingStep'], ParentType, ContextType>;
  userId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TStepsResolvers<ContextType = any, ParentType extends TResolversParentTypes['Steps'] = TResolversParentTypes['Steps']> = ResolversObject<{
  done?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  query?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  time?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  title?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<TResolversTypes['S3UrlCloudFront'], ParentType, ContextType>;
}>;

export type TStockLevelResolvers<ContextType = any, ParentType extends TResolversParentTypes['StockLevel'] = TResolversParentTypes['StockLevel']> = ResolversObject<{
  amountBooked?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  lotNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  minimumBalance?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  physicalBalance?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  productId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  productRef?: Resolver<Maybe<TResolversTypes['Product']>, ParentType, ContextType>;
  warehouseId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  warehouseRef?: Resolver<Maybe<TResolversTypes['Warehouse']>, ParentType, ContextType>;
}>;

export type TStockLevelSyncResultResolvers<ContextType = any, ParentType extends TResolversParentTypes['StockLevelSyncResult'] = TResolversParentTypes['StockLevelSyncResult']> = ResolversObject<{
  errorMessage?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  hasStock?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  productId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  syncedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type TStockMovementResolvers<ContextType = any, ParentType extends TResolversParentTypes['StockMovement'] = TResolversParentTypes['StockMovement']> = ResolversObject<{
  amount?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  amountConfirmed?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  deliverySparePartId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  historicInfo?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  ipeDeliveryId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  lotNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  observation?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  productDeliveryId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  productId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['StockMovementStatus'], ParentType, ContextType>;
  type?: Resolver<TResolversTypes['StockMovementType'], ParentType, ContextType>;
  updatedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  warehouseId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  warehouseRef?: Resolver<Maybe<TResolversTypes['Warehouse']>, ParentType, ContextType>;
}>;

export type TSubscriptionResolvers<ContextType = any, ParentType extends TResolversParentTypes['Subscription'] = TResolversParentTypes['Subscription']> = ResolversObject<{
  accidentMessage?: SubscriptionResolver<TResolversTypes['StepMessage'], "accidentMessage", ParentType, ContextType>;
  candidateMessage?: SubscriptionResolver<TResolversTypes['StepMessage'], "candidateMessage", ParentType, ContextType>;
  componentMessage?: SubscriptionResolver<TResolversTypes['StepMessage'], "componentMessage", ParentType, ContextType>;
  expectedExamsMessage?: SubscriptionResolver<TResolversTypes['StepMessage'], "expectedExamsMessage", ParentType, ContextType>;
  integrationMessage?: SubscriptionResolver<TResolversTypes['StepMessage'], "integrationMessage", ParentType, ContextType>;
  medicalCertificateMessage?: SubscriptionResolver<TResolversTypes['StepMessage'], "medicalCertificateMessage", ParentType, ContextType>;
  ohcMessage?: SubscriptionResolver<TResolversTypes['StepMessage'], "ohcMessage", ParentType, ContextType>;
}>;

export type TSuggestionAmountResolvers<ContextType = any, ParentType extends TResolversParentTypes['SuggestionAmount'] = TResolversParentTypes['SuggestionAmount']> = ResolversObject<{
  amount?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  month?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  year?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TSuggestionBoxResolvers<ContextType = any, ParentType extends TResolversParentTypes['SuggestionBox'] = TResolversParentTypes['SuggestionBox']> = ResolversObject<{
  comments?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  localSuggestion?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  mandate?: Resolver<Maybe<TResolversTypes['Mandate']>, ParentType, ContextType>;
  person?: Resolver<Maybe<TResolversTypes['Person']>, ParentType, ContextType>;
  priority?: Resolver<TResolversTypes['Priority'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['StatusSuggestion'], ParentType, ContextType>;
}>;

export type TSuggestionBoxListReportResolvers<ContextType = any, ParentType extends TResolversParentTypes['SuggestionBoxListReport'] = TResolversParentTypes['SuggestionBoxListReport']> = ResolversObject<{
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  comment?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  employee?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  localSuggestion?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  mandate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  priority?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  registration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TSummaryResolvers<ContextType = any, ParentType extends TResolversParentTypes['Summary'] = TResolversParentTypes['Summary']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['SummaryEntry']>, ParentType, ContextType>;
  totalAmount?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TSummaryEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['SummaryEntry'] = TResolversParentTypes['SummaryEntry']> = ResolversObject<{
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  options?: Resolver<Array<TResolversTypes['SummaryOption']>, ParentType, ContextType>;
  title?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<TResolversTypes['FilterType'], ParentType, ContextType>;
}>;

export type TSummaryOptionResolvers<ContextType = any, ParentType extends TResolversParentTypes['SummaryOption'] = TResolversParentTypes['SummaryOption']> = ResolversObject<{
  amount?: Resolver<Maybe<TResolversTypes['Int']>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TSyncDtoResolvers<ContextType = any, ParentType extends TResolversParentTypes['SyncDTO'] = TResolversParentTypes['SyncDTO']> = ResolversObject<{
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  month?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['Status'], ParentType, ContextType>;
  updatedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  year?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TTTalkQueueResolvers<ContextType = any, ParentType extends TResolversParentTypes['TTalkQueue'] = TResolversParentTypes['TTalkQueue']> = ResolversObject<{
  attempts?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  event?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  lastErrorAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  messageSend?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nextAttemptAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  person?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  personRef?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  sendDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['TtalkQueueStatus'], ParentType, ContextType>;
  statusDescription?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  syncedAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<TResolversTypes['TypeMessage'], ParentType, ContextType>;
  updatedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  verb?: Resolver<TResolversTypes['VerbMessage'], ParentType, ContextType>;
}>;

export type TTTalkQueueAllResolvers<ContextType = any, ParentType extends TResolversParentTypes['TTalkQueueAll'] = TResolversParentTypes['TTalkQueueAll']> = ResolversObject<{
  count?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  data?: Resolver<TResolversTypes['PaginatedTTalkQueue'], ParentType, ContextType>;
}>;

export type TTTalkQueueSummaryResolvers<ContextType = any, ParentType extends TResolversParentTypes['TTalkQueueSummary'] = TResolversParentTypes['TTalkQueueSummary']> = ResolversObject<{
  error?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  legacyFailed?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  pendingSend?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  processed?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  send?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  sendFailed?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TTablePropertiesResolvers<ContextType = any, ParentType extends TResolversParentTypes['TableProperties'] = TResolversParentTypes['TableProperties']> = ResolversObject<{
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nickName?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TTaskResolvers<ContextType = any, ParentType extends TResolversParentTypes['Task'] = TResolversParentTypes['Task']> = ResolversObject<{
  description?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  effort?: Resolver<Maybe<TResolversTypes['Effort']>, ParentType, ContextType>;
  employeeTasks?: Resolver<Maybe<Array<TResolversTypes['PersonByTask']>>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  targetBranchId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  workedHours?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TTaskByPersonResolvers<ContextType = any, ParentType extends TResolversParentTypes['TaskByPerson'] = TResolversParentTypes['TaskByPerson']> = ResolversObject<{
  endDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  startDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  task?: Resolver<TResolversTypes['Task'], ParentType, ContextType>;
}>;

export type TTaskByRiskResolvers<ContextType = any, ParentType extends TResolversParentTypes['TaskByRisk'] = TResolversParentTypes['TaskByRisk']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  task?: Resolver<TResolversTypes['Task'], ParentType, ContextType>;
}>;

export type TTermsResolvers<ContextType = any, ParentType extends TResolversParentTypes['Terms'] = TResolversParentTypes['Terms']> = ResolversObject<{
  content?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TTimePointResolvers<ContextType = any, ParentType extends TResolversParentTypes['TimePoint'] = TResolversParentTypes['TimePoint']> = ResolversObject<{
  day?: Resolver<TResolversTypes['DayOfWeek'], ParentType, ContextType>;
  hour?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TTopIcdItemResolvers<ContextType = any, ParentType extends TResolversParentTypes['TopIcdItem'] = TResolversParentTypes['TopIcdItem']> = ResolversObject<{
  code?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  count?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TTopIcdsChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['TopIcdsChart'] = TResolversParentTypes['TopIcdsChart']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['TopIcdItem']>, ParentType, ContextType>;
  hasCertificate?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TTrainingResolvers<ContextType = any, ParentType extends TResolversParentTypes['Training'] = TResolversParentTypes['Training']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  referenceId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TTrainingByRiskResolvers<ContextType = any, ParentType extends TResolversParentTypes['TrainingByRisk'] = TResolversParentTypes['TrainingByRisk']> = ResolversObject<{
  errorIntegration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  training?: Resolver<TResolversTypes['Training'], ParentType, ContextType>;
  urgency?: Resolver<TResolversTypes['TrainingUrgency'], ParentType, ContextType>;
}>;

export type TTrainingEligiblePersonResolvers<ContextType = any, ParentType extends TResolversParentTypes['TrainingEligiblePerson'] = TResolversParentTypes['TrainingEligiblePerson']> = ResolversObject<{
  approved?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  costCenterId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  cpf?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  departmentId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  expirationDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  lastCompletionDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  occupationId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  origins?: Resolver<Array<TResolversTypes['TrainingNecessityOrigin']>, ParentType, ContextType>;
  personId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  registration?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<TResolversTypes['TrainingEligibleStatus'], ParentType, ContextType>;
}>;

export type TTrainingEligiblePersonsResultResolvers<ContextType = any, ParentType extends TResolversParentTypes['TrainingEligiblePersonsResult'] = TResolversParentTypes['TrainingEligiblePersonsResult']> = ResolversObject<{
  hasMore?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<TResolversTypes['TrainingEligiblePerson']>, ParentType, ContextType>;
  total?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TTrainingHistoryResolvers<ContextType = any, ParentType extends TResolversParentTypes['TrainingHistory'] = TResolversParentTypes['TrainingHistory']> = ResolversObject<{
  approved?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  completionDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  expectedDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  expirationDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  training?: Resolver<TResolversTypes['Training'], ParentType, ContextType>;
}>;

export type TTrainingHistoryBatchResultResolvers<ContextType = any, ParentType extends TResolversParentTypes['TrainingHistoryBatchResult'] = TResolversParentTypes['TrainingHistoryBatchResult']> = ResolversObject<{
  conflicts?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  created?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
  errors?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TTrainingHistoryByPersonResolvers<ContextType = any, ParentType extends TResolversParentTypes['TrainingHistoryByPerson'] = TResolversParentTypes['TrainingHistoryByPerson']> = ResolversObject<{
  approved?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  completionDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  expectedDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  expirationDate?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  training?: Resolver<TResolversTypes['Training'], ParentType, ContextType>;
}>;

export type TTransferBlockedItemResolvers<ContextType = any, ParentType extends TResolversParentTypes['TransferBlockedItem'] = TResolversParentTypes['TransferBlockedItem']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  reason?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TTransferConsultationsResultResolvers<ContextType = any, ParentType extends TResolversParentTypes['TransferConsultationsResult'] = TResolversParentTypes['TransferConsultationsResult']> = ResolversObject<{
  blocked?: Resolver<Array<TResolversTypes['TransferBlockedItem']>, ParentType, ContextType>;
  transferred?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TTtalkInboundEventResolvers<ContextType = any, ParentType extends TResolversParentTypes['TtalkInboundEvent'] = TResolversParentTypes['TtalkInboundEvent']> = ResolversObject<{
  attempts?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  entityType?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  eventIdExternal?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  lastError?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  lastErrorAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  organizationId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  payload?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  processedAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  receivedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['TtalkInboundEventStatus'], ParentType, ContextType>;
}>;

export type TTtalkInboundSemanticInconsistencyResolvers<ContextType = any, ParentType extends TResolversParentTypes['TtalkInboundSemanticInconsistency'] = TResolversParentTypes['TtalkInboundSemanticInconsistency']> = ResolversObject<{
  acknowledgedAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  acknowledgedBy?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  flaggedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  inboundEventId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  organizationId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  payload?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  ruleViolated?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TTtalkInboundSilenceMonitorResolvers<ContextType = any, ParentType extends TResolversParentTypes['TtalkInboundSilenceMonitor'] = TResolversParentTypes['TtalkInboundSilenceMonitor']> = ResolversObject<{
  branchId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  branchName?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  enabled?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  entityType?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  lastAlertAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  lastEventAt?: Resolver<Maybe<TResolversTypes['DateTime']>, ParentType, ContextType>;
  notificationRecipients?: Resolver<Maybe<Array<TResolversTypes['String']>>, ParentType, ContextType>;
  organizationId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  thresholdHours?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TTtalkInboundSilenceThresholdResolvers<ContextType = any, ParentType extends TResolversParentTypes['TtalkInboundSilenceThreshold'] = TResolversParentTypes['TtalkInboundSilenceThreshold']> = ResolversObject<{
  enabled?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  entityType?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  notificationRecipients?: Resolver<Maybe<Array<TResolversTypes['String']>>, ParentType, ContextType>;
  organizationId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  thresholdHours?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TTypeChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['TypeChart'] = TResolversParentTypes['TypeChart']> = ResolversObject<{
  hasAccident?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  incident?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  onWay?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  typical?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  workDisease?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TTypeCostCenterChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['TypeCostCenterChart'] = TResolversParentTypes['TypeCostCenterChart']> = ResolversObject<{
  costCenterPerTotal?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  hasAccident?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  incident?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  onWay?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  typical?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  workDisease?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
}>;

export type TUnityOfMeasureResolvers<ContextType = any, ParentType extends TResolversParentTypes['UnityOfMeasure'] = TResolversParentTypes['UnityOfMeasure']> = ResolversObject<{
  acronym?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export interface TUploadScalarConfig extends GraphQLScalarTypeConfig<TResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type TUrinalysisResolvers<ContextType = any, ParentType extends TResolversParentTypes['Urinalysis'] = TResolversParentTypes['Urinalysis']> = ResolversObject<{
  bilirubin?: Resolver<TResolversTypes['BilirubinEnum'], ParentType, ContextType>;
  complementaryExam?: Resolver<Maybe<TResolversTypes['ComplementaryExam']>, ParentType, ContextType>;
  consultation?: Resolver<Maybe<TResolversTypes['Consultation']>, ParentType, ContextType>;
  crm?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  density?: Resolver<TResolversTypes['DensityEnum'], ParentType, ContextType>;
  details?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  diagnosticIndicator?: Resolver<TResolversTypes['ExamDiagnosticIndicatorEnum'], ParentType, ContextType>;
  doctor?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  examAuthorization?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  glycolysis?: Resolver<TResolversTypes['GlycolysisEnum'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  indicator?: Resolver<TResolversTypes['ExamResultIndicatorEnum'], ParentType, ContextType>;
  ketones?: Resolver<TResolversTypes['KetonesEnum'], ParentType, ContextType>;
  leukocytes?: Resolver<TResolversTypes['LeukocytesEnum'], ParentType, ContextType>;
  nitrites?: Resolver<TResolversTypes['NitritesEnum'], ParentType, ContextType>;
  observations?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  ph?: Resolver<TResolversTypes['PhEnum'], ParentType, ContextType>;
  proteins?: Resolver<TResolversTypes['ProteinsEnum'], ParentType, ContextType>;
  redCells?: Resolver<TResolversTypes['RedCellsEnum'], ParentType, ContextType>;
  restTime?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  resultAggravation?: Resolver<Maybe<TResolversTypes['ExamAggravationEnum']>, ParentType, ContextType>;
  resultAlteration?: Resolver<Maybe<TResolversTypes['ExamResultAlterationEnum']>, ParentType, ContextType>;
  state?: Resolver<Maybe<TResolversTypes['State']>, ParentType, ContextType>;
  urobilinogen?: Resolver<TResolversTypes['UrobilinogenEnum'], ParentType, ContextType>;
}>;

export type TUserResolvers<ContextType = any, ParentType extends TResolversParentTypes['User'] = TResolversParentTypes['User']> = ResolversObject<{
  accessBy?: Resolver<TResolversTypes['AccessBy'], ParentType, ContextType>;
  address?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  birthDate?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  documentNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  educationLevel?: Resolver<Maybe<TResolversTypes['EducationLevel']>, ParentType, ContextType>;
  email?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  gender?: Resolver<Maybe<TResolversTypes['UserGender']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['ID'], ParentType, ContextType>;
  isDoctor?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  isScheduler?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  policiesAgreement?: Resolver<Maybe<Array<TResolversTypes['PolicyAgreement']>>, ParentType, ContextType>;
  preferences?: Resolver<Maybe<TResolversTypes['UserPreferences']>, ParentType, ContextType>;
  profilePicture?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  roles?: Resolver<Array<TResolversTypes['Role']>, ParentType, ContextType>;
  rolesMdt?: Resolver<Array<TResolversTypes['UserRoleMdt']>, ParentType, ContextType>;
  verifiedEmail?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TUserBasicInfoResolvers<ContextType = any, ParentType extends TResolversParentTypes['UserBasicInfo'] = TResolversParentTypes['UserBasicInfo']> = ResolversObject<{
  accessBy?: Resolver<TResolversTypes['AccessBy'], ParentType, ContextType>;
  address?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  birthDate?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  documentNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  educationLevel?: Resolver<Maybe<TResolversTypes['EducationLevel']>, ParentType, ContextType>;
  email?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  gender?: Resolver<Maybe<TResolversTypes['UserGender']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['ID'], ParentType, ContextType>;
  isDoctor?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  isScheduler?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  policiesAgreement?: Resolver<Maybe<Array<TResolversTypes['PolicyAgreement']>>, ParentType, ContextType>;
  preferences?: Resolver<Maybe<TResolversTypes['UserPreferences']>, ParentType, ContextType>;
  profilePicture?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  verifiedEmail?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TUserFilterPreferenceResultResolvers<ContextType = any, ParentType extends TResolversParentTypes['UserFilterPreferenceResult'] = TResolversParentTypes['UserFilterPreferenceResult']> = ResolversObject<{
  filtersJson?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['ID'], ParentType, ContextType>;
  module?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
}>;

export type TUserFromCreationResolvers<ContextType = any, ParentType extends TResolversParentTypes['UserFromCreation'] = TResolversParentTypes['UserFromCreation']> = ResolversObject<{
  accessBy?: Resolver<TResolversTypes['AccessBy'], ParentType, ContextType>;
  address?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  birthDate?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  documentNumber?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  educationLevel?: Resolver<Maybe<TResolversTypes['EducationLevel']>, ParentType, ContextType>;
  email?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  gender?: Resolver<Maybe<TResolversTypes['UserGender']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['ID'], ParentType, ContextType>;
  isDoctor?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  isScheduler?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  organization?: Resolver<Maybe<TResolversTypes['OrganizationWithBranches']>, ParentType, ContextType>;
  policiesAgreement?: Resolver<Maybe<Array<TResolversTypes['PolicyAgreement']>>, ParentType, ContextType>;
  preferences?: Resolver<Maybe<TResolversTypes['UserPreferences']>, ParentType, ContextType>;
  profilePicture?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  verifiedEmail?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TUserOrganizationListingResolvers<ContextType = any, ParentType extends TResolversParentTypes['UserOrganizationListing'] = TResolversParentTypes['UserOrganizationListing']> = ResolversObject<{
  accessBy?: Resolver<Maybe<TResolversTypes['AccessBy']>, ParentType, ContextType>;
  branches?: Resolver<Array<TResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  profilePicture?: Resolver<Maybe<TResolversTypes['S3UrlCloudFront']>, ParentType, ContextType>;
  roleId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  rolesMdt?: Resolver<Array<TResolversTypes['UserRoleMdt']>, ParentType, ContextType>;
  status?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TUserPreferencesResolvers<ContextType = any, ParentType extends TResolversParentTypes['UserPreferences'] = TResolversParentTypes['UserPreferences']> = ResolversObject<{
  designVersion?: Resolver<Maybe<TResolversTypes['DesignVersion']>, ParentType, ContextType>;
  expandedSidebar?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  favorites?: Resolver<Maybe<Array<TResolversTypes['FavoriteOption']>>, ParentType, ContextType>;
  favoritesListOpen?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  favoritesOpen?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type TUserRoleMdtResolvers<ContextType = any, ParentType extends TResolversParentTypes['UserRoleMdt'] = TResolversParentTypes['UserRoleMdt']> = ResolversObject<{
  document?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isBlocked?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  roleId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  rolePermission?: Resolver<Maybe<TResolversTypes['RolePermission']>, ParentType, ContextType>;
  rolePermissionId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<TResolversTypes['State']>, ParentType, ContextType>;
  userId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TUserRoutesResolvers<ContextType = any, ParentType extends TResolversParentTypes['UserRoutes'] = TResolversParentTypes['UserRoutes']> = ResolversObject<{
  others?: Resolver<Array<TResolversTypes['Others']>, ParentType, ContextType>;
  sidebar?: Resolver<Array<TResolversTypes['Routes']>, ParentType, ContextType>;
}>;

export type TUserSpecialtyResolvers<ContextType = any, ParentType extends TResolversParentTypes['UserSpecialty'] = TResolversParentTypes['UserSpecialty']> = ResolversObject<{
  councilState?: Resolver<TResolversTypes['State'], ParentType, ContextType>;
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  isPrimary?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  rqeNumber?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  specialty?: Resolver<TResolversTypes['MedicalSpecialty'], ParentType, ContextType>;
  updatedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  userId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TUtmDataResolvers<ContextType = any, ParentType extends TResolversParentTypes['UtmData'] = TResolversParentTypes['UtmData']> = ResolversObject<{
  referrer?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  utmCampaign?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  utmContent?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  utmMedium?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  utmSource?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  utmTerm?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TVaccineResolvers<ContextType = any, ParentType extends TResolversParentTypes['Vaccine'] = TResolversParentTypes['Vaccine']> = ResolversObject<{
  advantages?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  effects?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  fromAge?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  gender?: Resolver<TResolversTypes['VaccineGenderEnum'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  recommendations?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  referenceId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  reinforcement?: Resolver<TResolversTypes['VaccineReinforcementEnum'], ParentType, ContextType>;
  reinforcementInterval?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  secondDoseInterval?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  thirdDoseInterval?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  toAge?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  vaccineCostCenter?: Resolver<Maybe<Array<TResolversTypes['CostCenterOnVaccine']>>, ParentType, ContextType>;
  vaccineOccupation?: Resolver<Maybe<Array<TResolversTypes['OccupationOnVaccine']>>, ParentType, ContextType>;
}>;

export type TVaccineBiometryResolvers<ContextType = any, ParentType extends TResolversParentTypes['VaccineBiometry'] = TResolversParentTypes['VaccineBiometry']> = ResolversObject<{
  biometry?: Resolver<TResolversTypes['Biometry'], ParentType, ContextType>;
  biometryId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TVaccineChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['VaccineChart'] = TResolversParentTypes['VaccineChart']> = ResolversObject<{
  expected?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
  hasVaccines?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  realized?: Resolver<Array<TResolversTypes['Data']>, ParentType, ContextType>;
}>;

export type TVaccinePlanningParametersResolvers<ContextType = any, ParentType extends TResolversParentTypes['VaccinePlanningParameters'] = TResolversParentTypes['VaccinePlanningParameters']> = ResolversObject<{
  fromDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  toDate?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TVaccinePrintResolvers<ContextType = any, ParentType extends TResolversParentTypes['VaccinePrint'] = TResolversParentTypes['VaccinePrint']> = ResolversObject<{
  date?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  dose?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  signature?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  vaccine?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TVaccineQuantityChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['VaccineQuantityChart'] = TResolversParentTypes['VaccineQuantityChart']> = ResolversObject<{
  data?: Resolver<Array<TResolversTypes['PieChart']>, ParentType, ContextType>;
  hasVaccines?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TValidationErrorResolvers<ContextType = any, ParentType extends TResolversParentTypes['ValidationError'] = TResolversParentTypes['ValidationError']> = ResolversObject<{
  field?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TValidationReturnResolvers<ContextType = any, ParentType extends TResolversParentTypes['ValidationReturn'] = TResolversParentTypes['ValidationReturn']> = ResolversObject<{
  available?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  version?: Resolver<TResolversTypes['FeatureVersion'], ParentType, ContextType>;
}>;

export type TVolumeChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['VolumeChart'] = TResolversParentTypes['VolumeChart']> = ResolversObject<{
  between20and30?: Resolver<Array<TResolversTypes['Float']>, ParentType, ContextType>;
  between30and40?: Resolver<Array<TResolversTypes['Float']>, ParentType, ContextType>;
  between40and50?: Resolver<Array<TResolversTypes['Float']>, ParentType, ContextType>;
  hasCertificate?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  over50?: Resolver<Array<TResolversTypes['Float']>, ParentType, ContextType>;
  upTo20?: Resolver<Array<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TVotationProgressResolvers<ContextType = any, ParentType extends TResolversParentTypes['VotationProgress'] = TResolversParentTypes['VotationProgress']> = ResolversObject<{
  candidate?: Resolver<Maybe<TResolversTypes['Candidate']>, ParentType, ContextType>;
  count?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  nullVote?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  percentage?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  whiteVote?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type TVoteResolvers<ContextType = any, ParentType extends TResolversParentTypes['Vote'] = TResolversParentTypes['Vote']> = ResolversObject<{
  candidateId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  cypherUser?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  mandateId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  nullVote?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
  whiteVote?: Resolver<Maybe<TResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type TVoteStatusResolvers<ContextType = any, ParentType extends TResolversParentTypes['VoteStatus'] = TResolversParentTypes['VoteStatus']> = ResolversObject<{
  percentageNotVoted?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  percentageVoted?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  total?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  totalNotVoted?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  totalVoted?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
}>;

export type TWarehouseResolvers<ContextType = any, ParentType extends TResolversParentTypes['Warehouse'] = TResolversParentTypes['Warehouse']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  stockLevels?: Resolver<Maybe<Array<TResolversTypes['StockLevel']>>, ParentType, ContextType>;
  suggestion?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TWarningByPersonResolvers<ContextType = any, ParentType extends TResolversParentTypes['WarningByPerson'] = TResolversParentTypes['WarningByPerson']> = ResolversObject<{
  attachments?: Resolver<Maybe<Array<TResolversTypes['Attachment']>>, ParentType, ContextType>;
  date?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  details?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  reason?: Resolver<TResolversTypes['WarningReason'], ParentType, ContextType>;
  type?: Resolver<TResolversTypes['WarningType'], ParentType, ContextType>;
  wasSignature?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TWebhookResolvers<ContextType = any, ParentType extends TResolversParentTypes['Webhook'] = TResolversParentTypes['Webhook']> = ResolversObject<{
  apiKey?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  event?: Resolver<TResolversTypes['WebhookEvent'], ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  organization?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<TResolversTypes['WebhookType'], ParentType, ContextType>;
  url?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
}>;

export type TWebhookQueueResolvers<ContextType = any, ParentType extends TResolversParentTypes['WebhookQueue'] = TResolversParentTypes['WebhookQueue']> = ResolversObject<{
  branch?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  branchRef?: Resolver<TResolversTypes['Branch'], ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  organization?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  personId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<TResolversTypes['WebhookStatus'], ParentType, ContextType>;
  type?: Resolver<TResolversTypes['WebhookType'], ParentType, ContextType>;
}>;

export type TWitnessOnAccidentResolvers<ContextType = any, ParentType extends TResolversParentTypes['WitnessOnAccident'] = TResolversParentTypes['WitnessOnAccident']> = ResolversObject<{
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  testimony?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TWorkHourResolvers<ContextType = any, ParentType extends TResolversParentTypes['WorkHour'] = TResolversParentTypes['WorkHour']> = ResolversObject<{
  end?: Resolver<TResolversTypes['TimePoint'], ParentType, ContextType>;
  start?: Resolver<TResolversTypes['TimePoint'], ParentType, ContextType>;
}>;

export type TWorkHoursResolvers<ContextType = any, ParentType extends TResolversParentTypes['WorkHours'] = TResolversParentTypes['WorkHours']> = ResolversObject<{
  doctorId?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  friday?: Resolver<Array<TResolversTypes['WorkHour']>, ParentType, ContextType>;
  monday?: Resolver<Array<TResolversTypes['WorkHour']>, ParentType, ContextType>;
  saturday?: Resolver<Array<TResolversTypes['WorkHour']>, ParentType, ContextType>;
  sunday?: Resolver<Array<TResolversTypes['WorkHour']>, ParentType, ContextType>;
  thursday?: Resolver<Array<TResolversTypes['WorkHour']>, ParentType, ContextType>;
  tuesday?: Resolver<Array<TResolversTypes['WorkHour']>, ParentType, ContextType>;
  wednesday?: Resolver<Array<TResolversTypes['WorkHour']>, ParentType, ContextType>;
}>;

export type TWorkPermissionResolvers<ContextType = any, ParentType extends TResolversParentTypes['WorkPermission'] = TResolversParentTypes['WorkPermission']> = ResolversObject<{
  createdAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  endDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  environment?: Resolver<TResolversTypes['PhysicalEnvironment'], ParentType, ContextType>;
  exposureGroup?: Resolver<Maybe<TResolversTypes['ExposureGroup']>, ParentType, ContextType>;
  exposureGroupId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  observation?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  people?: Resolver<Maybe<Array<TResolversTypes['WorkPermissionPerson']>>, ParentType, ContextType>;
  requester?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  responsible?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  startDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  supervisor?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  tag?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  useExposureGroup?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  watchman?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
  workPermissionQuizzes?: Resolver<Maybe<Array<TResolversTypes['WorkPermissionQuiz']>>, ParentType, ContextType>;
  workPermissionType?: Resolver<TResolversTypes['WorkPermissionType'], ParentType, ContextType>;
}>;

export type TWorkPermissionDashboardResolvers<ContextType = any, ParentType extends TResolversParentTypes['WorkPermissionDashboard'] = TResolversParentTypes['WorkPermissionDashboard']> = ResolversObject<{
  permissionsByEnvironment?: Resolver<TResolversTypes['WorkPermissionParetoChart'], ParentType, ContextType>;
  permissionsByRequester?: Resolver<TResolversTypes['WorkPermissionParetoChart'], ParentType, ContextType>;
  permissionsByTag?: Resolver<TResolversTypes['WorkPermissionParetoChart'], ParentType, ContextType>;
}>;

export type TWorkPermissionParetoChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['WorkPermissionParetoChart'] = TResolversParentTypes['WorkPermissionParetoChart']> = ResolversObject<{
  entries?: Resolver<Array<TResolversTypes['WorkPermissionParetoEntry']>, ParentType, ContextType>;
  hasData?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  total?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TWorkPermissionParetoEntryResolvers<ContextType = any, ParentType extends TResolversParentTypes['WorkPermissionParetoEntry'] = TResolversParentTypes['WorkPermissionParetoEntry']> = ResolversObject<{
  cumulativePercent?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  label?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<TResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TWorkPermissionPersonResolvers<ContextType = any, ParentType extends TResolversParentTypes['WorkPermissionPerson'] = TResolversParentTypes['WorkPermissionPerson']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  person?: Resolver<TResolversTypes['Person'], ParentType, ContextType>;
}>;

export type TWorkPermissionQuizResolvers<ContextType = any, ParentType extends TResolversParentTypes['WorkPermissionQuiz'] = TResolversParentTypes['WorkPermissionQuiz']> = ResolversObject<{
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  quiz?: Resolver<TResolversTypes['Quiz'], ParentType, ContextType>;
  realizationDate?: Resolver<TResolversTypes['DateTime'], ParentType, ContextType>;
  responses?: Resolver<Array<TResolversTypes['ResponseWorkPermissionQuiz']>, ParentType, ContextType>;
}>;

export type TWorkShiftResolvers<ContextType = any, ParentType extends TResolversParentTypes['WorkShift'] = TResolversParentTypes['WorkShift']> = ResolversObject<{
  description?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  erpId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  frequency?: Resolver<Maybe<TResolversTypes['ProductiveHoursFrequency']>, ParentType, ContextType>;
  id?: Resolver<TResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  productiveHours?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
  referenceId?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  relayScheme?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TYearlyVariationChartResolvers<ContextType = any, ParentType extends TResolversParentTypes['YearlyVariationChart'] = TResolversParentTypes['YearlyVariationChart']> = ResolversObject<{
  currentDays?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  hasPrevious?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
  previousDays?: Resolver<TResolversTypes['Float'], ParentType, ContextType>;
  variationPct?: Resolver<Maybe<TResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type T_InviteResolvers<ContextType = any, ParentType extends TResolversParentTypes['_Invite'] = TResolversParentTypes['_Invite']> = ResolversObject<{
  branch?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type T_PasswordRecoveryResolvers<ContextType = any, ParentType extends TResolversParentTypes['_PasswordRecovery'] = TResolversParentTypes['_PasswordRecovery']> = ResolversObject<{
  createdAt?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type T_TermsResolvers<ContextType = any, ParentType extends TResolversParentTypes['_Terms'] = TResolversParentTypes['_Terms']> = ResolversObject<{
  content?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
  signature?: Resolver<Maybe<TResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TIsAccreditedResultResolvers<ContextType = any, ParentType extends TResolversParentTypes['isAccreditedResult'] = TResolversParentTypes['isAccreditedResult']> = ResolversObject<{
  isAccredited?: Resolver<TResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type TResolvers<ContextType = any> = ResolversObject<{
  AbnormalityAnalysis?: TAbnormalityAnalysisResolvers<ContextType>;
  AbsenceType?: TAbsenceTypeResolvers<ContextType>;
  AccessToken?: TAccessTokenResolvers<ContextType>;
  Accident?: TAccidentResolvers<ContextType>;
  AccidentAbsence?: TAccidentAbsenceResolvers<ContextType>;
  AccidentAmount?: TAccidentAmountResolvers<ContextType>;
  AccidentAnalysis?: TAccidentAnalysisResolvers<ContextType>;
  AccidentBodyPart?: TAccidentBodyPartResolvers<ContextType>;
  AccidentCause?: TAccidentCauseResolvers<ContextType>;
  AccidentCauses?: TAccidentCausesResolvers<ContextType>;
  AccidentCharts?: TAccidentChartsResolvers<ContextType>;
  AccidentCode?: TAccidentCodeResolvers<ContextType>;
  AccidentDashboard?: TAccidentDashboardResolvers<ContextType>;
  AccidentDescription?: TAccidentDescriptionResolvers<ContextType>;
  AccidentExpenseAmount?: TAccidentExpenseAmountResolvers<ContextType>;
  AccidentObject?: TAccidentObjectResolvers<ContextType>;
  AccidentType?: TAccidentTypeResolvers<ContextType>;
  AccidentVictim?: TAccidentVictimResolvers<ContextType>;
  AccidentWithInvestigation?: TAccidentWithInvestigationResolvers<ContextType>;
  AccidentWitness?: TAccidentWitnessResolvers<ContextType>;
  AccidentsPerDayChart?: TAccidentsPerDayChartResolvers<ContextType>;
  AccidentsPerMonthChart?: TAccidentsPerMonthChartResolvers<ContextType>;
  AccidentsTimeChart?: TAccidentsTimeChartResolvers<ContextType>;
  Accredited?: TAccreditedResolvers<ContextType>;
  AccreditedBilling?: TAccreditedBillingResolvers<ContextType>;
  AccreditedConsultation?: TAccreditedConsultationResolvers<ContextType>;
  AccreditedExam?: TAccreditedExamResolvers<ContextType>;
  AccreditedReportsParameters?: TAccreditedReportsParametersResolvers<ContextType>;
  AcknowledgmentFormReport?: TAcknowledgmentFormReportResolvers<ContextType>;
  ActionOnMeeting?: TActionOnMeetingResolvers<ContextType>;
  ActionPlan?: TActionPlanResolvers<ContextType>;
  ActionPlanConclusionChart?: TActionPlanConclusionChartResolvers<ContextType>;
  ActionPlanConclusionEntry?: TActionPlanConclusionEntryResolvers<ContextType>;
  ActionPlanCount?: TActionPlanCountResolvers<ContextType>;
  ActionPlanDashboard?: TActionPlanDashboardResolvers<ContextType>;
  ActionPlanInvestigation?: TActionPlanInvestigationResolvers<ContextType>;
  ActionPlanInvestigationSuggestion?: TActionPlanInvestigationSuggestionResolvers<ContextType>;
  ActionPlanMeasurementEntry?: TActionPlanMeasurementEntryResolvers<ContextType>;
  ActionPlanMeasurementsChart?: TActionPlanMeasurementsChartResolvers<ContextType>;
  ActionPlanMicroAction?: TActionPlanMicroActionResolvers<ContextType>;
  ActionPlanParetoChart?: TActionPlanParetoChartResolvers<ContextType>;
  ActionPlanParetoEntry?: TActionPlanParetoEntryResolvers<ContextType>;
  ActionPlanPriorityChart?: TActionPlanPriorityChartResolvers<ContextType>;
  ActionPlanPriorityEntry?: TActionPlanPriorityEntryResolvers<ContextType>;
  ActionPlanReport?: TActionPlanReportResolvers<ContextType>;
  ActionPlanReportSuggestion?: TActionPlanReportSuggestionResolvers<ContextType>;
  ActionPlanSchedule?: TActionPlanScheduleResolvers<ContextType>;
  ActionPlanStatusChart?: TActionPlanStatusChartResolvers<ContextType>;
  ActionPlanStatusEntry?: TActionPlanStatusEntryResolvers<ContextType>;
  ActivityGroup?: TActivityGroupResolvers<ContextType>;
  ActivityIcd?: TActivityIcdResolvers<ContextType>;
  AdditionalData?: TAdditionalDataResolvers<ContextType>;
  AgeAccidentChart?: TAgeAccidentChartResolvers<ContextType>;
  AgeChart?: TAgeChartResolvers<ContextType>;
  AgeRange?: TAgeRangeResolvers<ContextType>;
  AgeRangeEntry?: TAgeRangeEntryResolvers<ContextType>;
  AgentBonusChart?: TAgentBonusChartResolvers<ContextType>;
  AgentGroupChart?: TAgentGroupChartResolvers<ContextType>;
  Agreement?: TAgreementResolvers<ContextType>;
  AllowanceType?: TAllowanceTypeResolvers<ContextType>;
  Analysis?: TAnalysisResolvers<ContextType>;
  AnnualDeliveryVariationChart?: TAnnualDeliveryVariationChartResolvers<ContextType>;
  ApiAccess?: TApiAccessResolvers<ContextType>;
  AsaasCreditCardToken?: TAsaasCreditCardTokenResolvers<ContextType>;
  AsoEvolutionEntry?: TAsoEvolutionEntryResolvers<ContextType>;
  AsoNatureChart?: TAsoNatureChartResolvers<ContextType>;
  AsoQuantityChart?: TAsoQuantityChartResolvers<ContextType>;
  AsoSituationChart?: TAsoSituationChartResolvers<ContextType>;
  Attachment?: TAttachmentResolvers<ContextType>;
  AttachmentDTO?: TAttachmentDtoResolvers<ContextType>;
  AudiometryClassificationChart?: TAudiometryClassificationChartResolvers<ContextType>;
  AudiometryCostCenterChart?: TAudiometryCostCenterChartResolvers<ContextType>;
  AudiometryDashboard?: TAudiometryDashboardResolvers<ContextType>;
  AudiometryEvolutionChart?: TAudiometryEvolutionChartResolvers<ContextType>;
  AudiometryPcaChart?: TAudiometryPcaChartResolvers<ContextType>;
  AudiometryYearComparisonChart?: TAudiometryYearComparisonChartResolvers<ContextType>;
  AuditLogChange?: TAuditLogChangeResolvers<ContextType>;
  AuditLogDetailsDto?: TAuditLogDetailsDtoResolvers<ContextType>;
  AuditLogEntry?: TAuditLogEntryResolvers<ContextType>;
  AuditLogExportRequest?: TAuditLogExportRequestResolvers<ContextType>;
  AvailabilityChart?: TAvailabilityChartResolvers<ContextType>;
  BaseDocumentResponse?: TBaseDocumentResponseResolvers<ContextType>;
  BaseFeatureReturn?: TBaseFeatureReturnResolvers<ContextType>;
  BaseFlagReturn?: TBaseFlagReturnResolvers<ContextType>;
  BiologicMonitoring?: TBiologicMonitoringResolvers<ContextType>;
  BiologicalExams?: TBiologicalExamsResolvers<ContextType>;
  BiologicalMonitoring?: TBiologicalMonitoringResolvers<ContextType>;
  BiologicalMonitoringCommon?: TBiologicalMonitoringCommonResolvers<ContextType>;
  BiologicalMonitoringExam?: TBiologicalMonitoringExamResolvers<ContextType>;
  BiologicalMonitoringExamGroup?: TBiologicalMonitoringExamGroupResolvers<ContextType>;
  BiologicalMonitoringProtocol?: TBiologicalMonitoringProtocolResolvers<ContextType>;
  BiologicalMonitoringProtocolExams?: TBiologicalMonitoringProtocolExamsResolvers<ContextType>;
  BiologicalMonitoringProtocolParams?: TBiologicalMonitoringProtocolParamsResolvers<ContextType>;
  BiologicalMonitoringReport?: TBiologicalMonitoringReportResolvers<ContextType>;
  BiologicalProtocol?: TBiologicalProtocolResolvers<ContextType>;
  BiologicalRelease?: TBiologicalReleaseResolvers<ContextType>;
  Biometry?: TBiometryResolvers<ContextType>;
  BloodTypeChart?: TBloodTypeChartResolvers<ContextType>;
  BodyPart?: TBodyPartResolvers<ContextType>;
  BodyPartOnAccident?: TBodyPartOnAccidentResolvers<ContextType>;
  Branch?: TBranchResolvers<ContextType>;
  BranchTtalkInfo?: TBranchTtalkInfoResolvers<ContextType>;
  BranchWithOptionalOrganization?: TBranchWithOptionalOrganizationResolvers<ContextType>;
  BranchWithOrganization?: TBranchWithOrganizationResolvers<ContextType>;
  BulkSyncRun?: TBulkSyncRunResolvers<ContextType>;
  CaInUseChart?: TCaInUseChartResolvers<ContextType>;
  Calendar?: TCalendarResolvers<ContextType>;
  CalendarWorkShift?: TCalendarWorkShiftResolvers<ContextType>;
  CalendarWorkShiftEntry?: TCalendarWorkShiftEntryResolvers<ContextType>;
  Candidate?: TCandidateResolvers<ContextType>;
  CandidateByMandate?: TCandidateByMandateResolvers<ContextType>;
  CategoriesChart?: TCategoriesChartResolvers<ContextType>;
  CategorizedInputData?: TCategorizedInputDataResolvers<ContextType>;
  CauserAgent?: TCauserAgentResolvers<ContextType>;
  CauserAgentOnAccident?: TCauserAgentOnAccidentResolvers<ContextType>;
  Causes?: TCausesResolvers<ContextType>;
  CertificatePerDayChart?: TCertificatePerDayChartResolvers<ContextType>;
  CertificatesRankingDashboard?: TCertificatesRankingDashboardResolvers<ContextType>;
  ChartData?: TChartDataResolvers<ContextType>;
  CheckTableData?: TCheckTableDataResolvers<ContextType>;
  Checklist?: TChecklistResolvers<ContextType>;
  ChemicalRisk?: TChemicalRiskResolvers<ContextType>;
  ClassificationPure?: TClassificationPureResolvers<ContextType>;
  ClinicalQuiz?: TClinicalQuizResolvers<ContextType>;
  CollisionReturn?: TCollisionReturnResolvers<ContextType>;
  ComparativeResultsDashboard?: TComparativeResultsDashboardResolvers<ContextType>;
  ComplementaryExam?: TComplementaryExamResolvers<ContextType>;
  ComplementaryExams?: TComplementaryExamsResolvers<ContextType>;
  ComplementaryIcd?: TComplementaryIcdResolvers<ContextType>;
  ComplementaryIcdOnAccident?: TComplementaryIcdOnAccidentResolvers<ContextType>;
  ComplementaryIcdOnDiagnostic?: TComplementaryIcdOnDiagnosticResolvers<ContextType>;
  Component?: TComponentResolvers<ContextType>;
  ComponentActiveStatusEntry?: TComponentActiveStatusEntryResolvers<ContextType>;
  ConfirmImport?: TConfirmImportResolvers<ContextType>;
  ConsultReport?: TConsultReportResolvers<ContextType>;
  Consultation?: TConsultationResolvers<ContextType>;
  ConsultationBiologicalMonitoring?: TConsultationBiologicalMonitoringResolvers<ContextType>;
  ConsultationByBranchToPrint?: TConsultationByBranchToPrintResolvers<ContextType>;
  ConsultationByDoctorToPrint?: TConsultationByDoctorToPrintResolvers<ContextType>;
  ConsultationExamsResult?: TConsultationExamsResultResolvers<ContextType>;
  ConsultationMinimal?: TConsultationMinimalResolvers<ContextType>;
  ConsultationReason?: TConsultationReasonResolvers<ContextType>;
  ContactRequest?: TContactRequestResolvers<ContextType>;
  ControlMeasure?: TControlMeasureResolvers<ContextType>;
  ControlMeasureByRisk?: TControlMeasureByRiskResolvers<ContextType>;
  ControlMeasureFrame?: TControlMeasureFrameResolvers<ContextType>;
  ControlMeasuresChart?: TControlMeasuresChartResolvers<ContextType>;
  CostCenter?: TCostCenterResolvers<ContextType>;
  CostCenterByRisk?: TCostCenterByRiskResolvers<ContextType>;
  CostCenterEntry?: TCostCenterEntryResolvers<ContextType>;
  CostCenterGroup?: TCostCenterGroupResolvers<ContextType>;
  CostCenterOccupationChart?: TCostCenterOccupationChartResolvers<ContextType>;
  CostCenterOccupationDeficienciesChart?: TCostCenterOccupationDeficienciesChartResolvers<ContextType>;
  CostCenterOnMandate?: TCostCenterOnMandateResolvers<ContextType>;
  CostCenterOnVaccine?: TCostCenterOnVaccineResolvers<ContextType>;
  CostCenterVolumeChart?: TCostCenterVolumeChartResolvers<ContextType>;
  CostPerTypeChart?: TCostPerTypeChartResolvers<ContextType>;
  CreditCard?: TCreditCardResolvers<ContextType>;
  CronTab?: TCronTabResolvers<ContextType>;
  CrontabExecution?: TCrontabExecutionResolvers<ContextType>;
  CrontabExecutionDetail?: TCrontabExecutionDetailResolvers<ContextType>;
  CustomDocument?: TCustomDocumentResolvers<ContextType>;
  CustomOrganization?: TCustomOrganizationResolvers<ContextType>;
  Customer?: TCustomerResolvers<ContextType>;
  DashboardExport?: TDashboardExportResolvers<ContextType>;
  Data?: TDataResolvers<ContextType>;
  DataCharts?: TDataChartsResolvers<ContextType>;
  DataLogin?: TDataLoginResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  DaysAbsentChart?: TDaysAbsentChartResolvers<ContextType>;
  DaysLostWithIcdChart?: TDaysLostWithIcdChartResolvers<ContextType>;
  DaysLostWithoutIcdChart?: TDaysLostWithoutIcdChartResolvers<ContextType>;
  DaysWithoutAccidentChart?: TDaysWithoutAccidentChartResolvers<ContextType>;
  DefaultRecipientUserDto?: TDefaultRecipientUserDtoResolvers<ContextType>;
  DeficienciesChart?: TDeficienciesChartResolvers<ContextType>;
  Deficiency?: TDeficiencyResolvers<ContextType>;
  DeliveredIpesParams?: TDeliveredIpesParamsResolvers<ContextType>;
  DeliveredIpesReport?: TDeliveredIpesReportResolvers<ContextType>;
  DeliveredProductsParams?: TDeliveredProductsParamsResolvers<ContextType>;
  DeliveredSparePartsParams?: TDeliveredSparePartsParamsResolvers<ContextType>;
  DeliverySpareParts?: TDeliverySparePartsResolvers<ContextType>;
  DeliverySparePartsParams?: TDeliverySparePartsParamsResolvers<ContextType>;
  DeliverySparePartsReport?: TDeliverySparePartsReportResolvers<ContextType>;
  Department?: TDepartmentResolvers<ContextType>;
  DepartmentByRisk?: TDepartmentByRiskResolvers<ContextType>;
  DepartmentOnMandate?: TDepartmentOnMandateResolvers<ContextType>;
  Dependent?: TDependentResolvers<ContextType>;
  DependentByPerson?: TDependentByPersonResolvers<ContextType>;
  Diagnostic?: TDiagnosticResolvers<ContextType>;
  DiagnosticComplementaryIcd?: TDiagnosticComplementaryIcdResolvers<ContextType>;
  DiagnosticMedicine?: TDiagnosticMedicineResolvers<ContextType>;
  Dimension?: TDimensionResolvers<ContextType>;
  DivergingStackedBarChart?: TDivergingStackedBarChartResolvers<ContextType>;
  Doctor?: TDoctorResolvers<ContextType>;
  DoctorRqeEntry?: TDoctorRqeEntryResolvers<ContextType>;
  DocumentFromEntityResponse?: TDocumentFromEntityResponseResolvers<ContextType>;
  DocumentObserver?: TDocumentObserverResolvers<ContextType>;
  DocumentPending?: TDocumentPendingResolvers<ContextType>;
  DocumentPendingSigner?: TDocumentPendingSignerResolvers<ContextType>;
  DocumentPermissions?: TDocumentPermissionsResolvers<ContextType>;
  DocumentSigner?: TDocumentSignerResolvers<ContextType>;
  DocumentSignerDB?: TDocumentSignerDbResolvers<ContextType>;
  DocumentUser?: TDocumentUserResolvers<ContextType>;
  ESocialDeliveriesParameters?: TESocialDeliveriesParametersResolvers<ContextType>;
  ESocialDeliveriesPeriod?: TESocialDeliveriesPeriodResolvers<ContextType>;
  ESocialQueue?: TESocialQueueResolvers<ContextType>;
  ESocialQueueAll?: TESocialQueueAllResolvers<ContextType>;
  ESocialQueueError?: TESocialQueueErrorResolvers<ContextType>;
  ESocialQueueHistory?: TESocialQueueHistoryResolvers<ContextType>;
  ESocialQueueIndicators?: TESocialQueueIndicatorsResolvers<ContextType>;
  EarPart?: TEarPartResolvers<ContextType>;
  EconomicActivity?: TEconomicActivityResolvers<ContextType>;
  EffectiveDocumentTemplate?: TEffectiveDocumentTemplateResolvers<ContextType>;
  EfficiencyChart?: TEfficiencyChartResolvers<ContextType>;
  ElaboratorDocument?: TElaboratorDocumentResolvers<ContextType>;
  ElectionComission?: TElectionComissionResolvers<ContextType>;
  Email?: TEmailResolvers<ContextType>;
  EmailHasInvite?: TEmailHasInviteResolvers<ContextType>;
  Employee?: TEmployeeResolvers<ContextType>;
  EmployeeAgentGroupChart?: TEmployeeAgentGroupChartResolvers<ContextType>;
  EmployeeAnamnesis?: TEmployeeAnamnesisResolvers<ContextType>;
  EmployeeByOccupation?: TEmployeeByOccupationResolvers<ContextType>;
  EmployeeCandidate?: TEmployeeCandidateResolvers<ContextType>;
  EmployeeConsultation?: TEmployeeConsultationResolvers<ContextType>;
  EmployeeControlMeasure?: TEmployeeControlMeasureResolvers<ContextType>;
  EmployeeExam?: TEmployeeExamResolvers<ContextType>;
  EmployeeFavoriteOption?: TEmployeeFavoriteOptionResolvers<ContextType>;
  EmployeeIpeDelivery?: TEmployeeIpeDeliveryResolvers<ContextType>;
  EmployeeIpes?: TEmployeeIpesResolvers<ContextType>;
  EmployeeMandateEvent?: TEmployeeMandateEventResolvers<ContextType>;
  EmployeePerson?: TEmployeePersonResolvers<ContextType>;
  EmployeePreferences?: TEmployeePreferencesResolvers<ContextType>;
  EmployeeQuiz?: TEmployeeQuizResolvers<ContextType>;
  EmployeeRisk?: TEmployeeRiskResolvers<ContextType>;
  EmployeeRiskDashboard?: TEmployeeRiskDashboardResolvers<ContextType>;
  EmployeeRiskIpe?: TEmployeeRiskIpeResolvers<ContextType>;
  EmployeeTask?: TEmployeeTaskResolvers<ContextType>;
  EmployeeVolumeChart?: TEmployeeVolumeChartResolvers<ContextType>;
  EmployeeVotes?: TEmployeeVotesResolvers<ContextType>;
  EmployeeWarningReport?: TEmployeeWarningReportResolvers<ContextType>;
  Endpoint?: TEndpointResolvers<ContextType>;
  EnvironmentalReport?: TEnvironmentalReportResolvers<ContextType>;
  EnvironmentalReportAttachment?: TEnvironmentalReportAttachmentResolvers<ContextType>;
  EnvironmentalReportBiometry?: TEnvironmentalReportBiometryResolvers<ContextType>;
  EnvironmentalReportCostCenter?: TEnvironmentalReportCostCenterResolvers<ContextType>;
  EnvironmentalReportDocumentResponse?: TEnvironmentalReportDocumentResponseResolvers<ContextType>;
  EnvironmentalReportFace?: TEnvironmentalReportFaceResolvers<ContextType>;
  EnvironmentalReportSuggestion?: TEnvironmentalReportSuggestionResolvers<ContextType>;
  EnvironmentalReportVersion?: TEnvironmentalReportVersionResolvers<ContextType>;
  EpcByAgentGroupItem?: TEpcByAgentGroupItemResolvers<ContextType>;
  EpcIncidenceChart?: TEpcIncidenceChartResolvers<ContextType>;
  EpiLifespanChart?: TEpiLifespanChartResolvers<ContextType>;
  EpiLifespanItem?: TEpiLifespanItemResolvers<ContextType>;
  EquipmentByCostCenter?: TEquipmentByCostCenterResolvers<ContextType>;
  EquipmentByOccupation?: TEquipmentByOccupationResolvers<ContextType>;
  ErrorResponse?: TErrorResponseResolvers<ContextType>;
  Event?: TEventResolvers<ContextType>;
  Exam?: TExamResolvers<ContextType>;
  ExamAlterationTrend?: TExamAlterationTrendResolvers<ContextType>;
  ExamAnalysis?: TExamAnalysisResolvers<ContextType>;
  ExamAudiometry?: TExamAudiometryResolvers<ContextType>;
  ExamByBranchToPrint?: TExamByBranchToPrintResolvers<ContextType>;
  ExamByHealthProgram?: TExamByHealthProgramResolvers<ContextType>;
  ExamByOccupation?: TExamByOccupationResolvers<ContextType>;
  ExamByPerson?: TExamByPersonResolvers<ContextType>;
  ExamByRisk?: TExamByRiskResolvers<ContextType>;
  ExamByTag?: TExamByTagResolvers<ContextType>;
  ExamDiagnosticCount?: TExamDiagnosticCountResolvers<ContextType>;
  ExamDiagnosticImage?: TExamDiagnosticImageResolvers<ContextType>;
  ExamIbmp?: TExamIbmpResolvers<ContextType>;
  ExamItem?: TExamItemResolvers<ContextType>;
  ExamItemValue?: TExamItemValueResolvers<ContextType>;
  ExamItemsCount?: TExamItemsCountResolvers<ContextType>;
  ExamNormal?: TExamNormalResolvers<ContextType>;
  ExamNormalResult?: TExamNormalResultResolvers<ContextType>;
  ExamOnConsultation?: TExamOnConsultationResolvers<ContextType>;
  ExamOtological?: TExamOtologicalResolvers<ContextType>;
  ExamPerson?: TExamPersonResolvers<ContextType>;
  ExamProvider?: TExamProviderResolvers<ContextType>;
  ExamReferralReport?: TExamReferralReportResolvers<ContextType>;
  ExamReport?: TExamReportResolvers<ContextType>;
  ExamResultsByMedicalRecord?: TExamResultsByMedicalRecordResolvers<ContextType>;
  ExamScheduling?: TExamSchedulingResolvers<ContextType>;
  ExamSpirometry?: TExamSpirometryResolvers<ContextType>;
  ExamTimelineEntry?: TExamTimelineEntryResolvers<ContextType>;
  ExamToxicological?: TExamToxicologicalResolvers<ContextType>;
  Exams?: TExamsResolvers<ContextType>;
  ExamsDoneChart?: TExamsDoneChartResolvers<ContextType>;
  ExamsResultQuery?: TExamsResultQueryResolvers<ContextType>;
  ExamsToDelete?: TExamsToDeleteResolvers<ContextType>;
  ExpectedConsultation?: TExpectedConsultationResolvers<ContextType>;
  ExpectedExam?: TExpectedExamResolvers<ContextType>;
  ExpectedExamFromQuery?: TExpectedExamFromQueryResolvers<ContextType>;
  ExpectedGoal?: TExpectedGoalResolvers<ContextType>;
  ExpectedGoalOnActionPlan?: TExpectedGoalOnActionPlanResolvers<ContextType>;
  Expense?: TExpenseResolvers<ContextType>;
  ExpenseOnAccident?: TExpenseOnAccidentResolvers<ContextType>;
  ExpensiveAccidentsChart?: TExpensiveAccidentsChartResolvers<ContextType>;
  ExportStatus?: TExportStatusResolvers<ContextType>;
  ExposureGroup?: TExposureGroupResolvers<ContextType>;
  ExposureGroupCostCenter?: TExposureGroupCostCenterResolvers<ContextType>;
  ExposureGroupDepartment?: TExposureGroupDepartmentResolvers<ContextType>;
  ExposureGroupOccupation?: TExposureGroupOccupationResolvers<ContextType>;
  ExposureGroupPerson?: TExposureGroupPersonResolvers<ContextType>;
  ExposureGroupTask?: TExposureGroupTaskResolvers<ContextType>;
  ExternalDeliveryChart?: TExternalDeliveryChartResolvers<ContextType>;
  ExternalDoctor?: TExternalDoctorResolvers<ContextType>;
  ExternalFields?: TExternalFieldsResolvers<ContextType>;
  ExternalOccupationalHealthCertificate?: TExternalOccupationalHealthCertificateResolvers<ContextType>;
  ExternalOccupationalHealthCertificateResponse?: TExternalOccupationalHealthCertificateResponseResolvers<ContextType>;
  ExtinguishingDonutChart?: TExtinguishingDonutChartResolvers<ContextType>;
  ExtinguishingDonutEntry?: TExtinguishingDonutEntryResolvers<ContextType>;
  ExtinguishingInspectionChart?: TExtinguishingInspectionChartResolvers<ContextType>;
  ExtinguishingInspectionEntry?: TExtinguishingInspectionEntryResolvers<ContextType>;
  ExtinguishingParetoChart?: TExtinguishingParetoChartResolvers<ContextType>;
  ExtinguishingParetoEntry?: TExtinguishingParetoEntryResolvers<ContextType>;
  ExtinguishingSystem?: TExtinguishingSystemResolvers<ContextType>;
  ExtinguishingSystemDashboard?: TExtinguishingSystemDashboardResolvers<ContextType>;
  ExtinguishingSystemInspection?: TExtinguishingSystemInspectionResolvers<ContextType>;
  ExtinguishingSystemRaw?: TExtinguishingSystemRawResolvers<ContextType>;
  FavoriteOption?: TFavoriteOptionResolvers<ContextType>;
  FeatureObject?: TFeatureObjectResolvers<ContextType>;
  FeaturePermission?: TFeaturePermissionResolvers<ContextType>;
  FeatureReturn?: TFeatureReturnResolvers<ContextType>;
  FeatureVersionReturn?: TFeatureVersionReturnResolvers<ContextType>;
  FireBrigade?: TFireBrigadeResolvers<ContextType>;
  FireBrigadeBloodTypeChart?: TFireBrigadeBloodTypeChartResolvers<ContextType>;
  FireBrigadeComponent?: TFireBrigadeComponentResolvers<ContextType>;
  FireBrigadeComponentActiveStatusChart?: TFireBrigadeComponentActiveStatusChartResolvers<ContextType>;
  FireBrigadeComponentByCostCenterChart?: TFireBrigadeComponentByCostCenterChartResolvers<ContextType>;
  FireBrigadeDashboard?: TFireBrigadeDashboardResolvers<ContextType>;
  FireBrigadeExam?: TFireBrigadeExamResolvers<ContextType>;
  FireBrigadeMeeting?: TFireBrigadeMeetingResolvers<ContextType>;
  FireBrigadeMeetingAction?: TFireBrigadeMeetingActionResolvers<ContextType>;
  FireBrigadeMeetingChart?: TFireBrigadeMeetingChartResolvers<ContextType>;
  FireBrigadeMeetingParticipant?: TFireBrigadeMeetingParticipantResolvers<ContextType>;
  FireBrigadeOccurrence?: TFireBrigadeOccurrenceResolvers<ContextType>;
  FireBrigadeOccurrenceChart?: TFireBrigadeOccurrenceChartResolvers<ContextType>;
  FireBrigadePeriod?: TFireBrigadePeriodResolvers<ContextType>;
  FireBrigadeSimulationActionChart?: TFireBrigadeSimulationActionChartResolvers<ContextType>;
  FireBrigadeSimulationsChart?: TFireBrigadeSimulationsChartResolvers<ContextType>;
  FireBrigadeTraining?: TFireBrigadeTrainingResolvers<ContextType>;
  FirstSteps?: TFirstStepsResolvers<ContextType>;
  FlagRelation?: TFlagRelationResolvers<ContextType>;
  FlagReturn?: TFlagReturnResolvers<ContextType>;
  FrequencyIndex?: TFrequencyIndexResolvers<ContextType>;
  FuncionalHistory?: TFuncionalHistoryResolvers<ContextType>;
  FuncionalHistoryByPerson?: TFuncionalHistoryByPersonResolvers<ContextType>;
  FuncionalHistoryControlMeasure?: TFuncionalHistoryControlMeasureResolvers<ContextType>;
  FuncionalHistoryExam?: TFuncionalHistoryExamResolvers<ContextType>;
  FuncionalHistoryExamTranslated?: TFuncionalHistoryExamTranslatedResolvers<ContextType>;
  FuncionalHistoryIpe?: TFuncionalHistoryIpeResolvers<ContextType>;
  FuncionalHistoryIpeTranslated?: TFuncionalHistoryIpeTranslatedResolvers<ContextType>;
  FuncionalHistoryRisk?: TFuncionalHistoryRiskResolvers<ContextType>;
  FuncionalHistoryRiskTranslated?: TFuncionalHistoryRiskTranslatedResolvers<ContextType>;
  FunctionsTask?: TFunctionsTaskResolvers<ContextType>;
  GeneratingSource?: TGeneratingSourceResolvers<ContextType>;
  GenericAccidentCause?: TGenericAccidentCauseResolvers<ContextType>;
  GenericActivePrinciple?: TGenericActivePrincipleResolvers<ContextType>;
  GenericAgeRange?: TGenericAgeRangeResolvers<ContextType>;
  GenericBiologicalMonitoringExam?: TGenericBiologicalMonitoringExamResolvers<ContextType>;
  GenericBiologicalMonitoringExamGroup?: TGenericBiologicalMonitoringExamGroupResolvers<ContextType>;
  GenericCostCenter?: TGenericCostCenterResolvers<ContextType>;
  GenericExam?: TGenericExamResolvers<ContextType>;
  GenericExamIbmp?: TGenericExamIbmpResolvers<ContextType>;
  GenericExaminationProcedure?: TGenericExaminationProcedureResolvers<ContextType>;
  GenericExpense?: TGenericExpenseResolvers<ContextType>;
  GenericHealthProgram?: TGenericHealthProgramResolvers<ContextType>;
  GenericLaboratory?: TGenericLaboratoryResolvers<ContextType>;
  GenericMeasuringInstrument?: TGenericMeasuringInstrumentResolvers<ContextType>;
  GenericMedicine?: TGenericMedicineResolvers<ContextType>;
  GenericMetadata?: TGenericMetadataResolvers<ContextType>;
  GenericOccupation?: TGenericOccupationResolvers<ContextType>;
  GenericPeriodicRange?: TGenericPeriodicRangeResolvers<ContextType>;
  GenericPublicPlace?: TGenericPublicPlaceResolvers<ContextType>;
  GenericQuestionGroup?: TGenericQuestionGroupResolvers<ContextType>;
  GenericQuestionQuiz?: TGenericQuestionQuizResolvers<ContextType>;
  GenericQuiz?: TGenericQuizResolvers<ContextType>;
  GenericReportSection?: TGenericReportSectionResolvers<ContextType>;
  GenericReportStructure?: TGenericReportStructureResolvers<ContextType>;
  GenericResponseOption?: TGenericResponseOptionResolvers<ContextType>;
  GenericRiskAgent?: TGenericRiskAgentResolvers<ContextType>;
  GenericRolePermission?: TGenericRolePermissionResolvers<ContextType>;
  GenericStatementResponsibility?: TGenericStatementResponsibilityResolvers<ContextType>;
  GenericTask?: TGenericTaskResolvers<ContextType>;
  GenericTraining?: TGenericTrainingResolvers<ContextType>;
  GenericVaccine?: TGenericVaccineResolvers<ContextType>;
  GenericWorkShift?: TGenericWorkShiftResolvers<ContextType>;
  GroupAnalysis?: TGroupAnalysisResolvers<ContextType>;
  HasFinishedExam?: THasFinishedExamResolvers<ContextType>;
  HealthProgram?: THealthProgramResolvers<ContextType>;
  HealthProgramChart?: THealthProgramChartResolvers<ContextType>;
  HealthProgramOccupation?: THealthProgramOccupationResolvers<ContextType>;
  HealthProgramTraining?: THealthProgramTrainingResolvers<ContextType>;
  HealthQuizzes?: THealthQuizzesResolvers<ContextType>;
  HidraulicInspectionReport?: THidraulicInspectionReportResolvers<ContextType>;
  HidraulicInspectionReportFields?: THidraulicInspectionReportFieldsResolvers<ContextType>;
  HidraulicSystemInspection?: THidraulicSystemInspectionResolvers<ContextType>;
  Historic?: THistoricResolvers<ContextType>;
  HistoricData?: THistoricDataResolvers<ContextType>;
  Icd?: TIcdResolvers<ContextType>;
  IcdGroup?: TIcdGroupResolvers<ContextType>;
  ImcChart?: TImcChartResolvers<ContextType>;
  ImportStatus?: TImportStatusResolvers<ContextType>;
  IndexChart?: TIndexChartResolvers<ContextType>;
  Indicator?: TIndicatorResolvers<ContextType>;
  InjuryNature?: TInjuryNatureResolvers<ContextType>;
  InputData?: TInputDataResolvers<ContextType>;
  InspectionOnExtinguishingSystem?: TInspectionOnExtinguishingSystemResolvers<ContextType>;
  InspectionOnHidraulicSystem?: TInspectionOnHidraulicSystemResolvers<ContextType>;
  InspectionReport?: TInspectionReportResolvers<ContextType>;
  InspectionReportFields?: TInspectionReportFieldsResolvers<ContextType>;
  IntegrationConfiguration?: TIntegrationConfigurationResolvers<ContextType>;
  IntegrationConfigurationOption?: TIntegrationConfigurationOptionResolvers<ContextType>;
  IntegrationError?: TIntegrationErrorResolvers<ContextType>;
  IntegrationErrorAll?: TIntegrationErrorAllResolvers<ContextType>;
  IntegrationErrorSummary?: TIntegrationErrorSummaryResolvers<ContextType>;
  IntegrationErrorTypeCount?: TIntegrationErrorTypeCountResolvers<ContextType>;
  IntegrationFlags?: TIntegrationFlagsResolvers<ContextType>;
  InternalFields?: TInternalFieldsResolvers<ContextType>;
  InventoryQueue?: TInventoryQueueResolvers<ContextType>;
  Investigation?: TInvestigationResolvers<ContextType>;
  InvestigationAmountChart?: TInvestigationAmountChartResolvers<ContextType>;
  InvestigationCause?: TInvestigationCauseResolvers<ContextType>;
  InvestigationCauseOnAccident?: TInvestigationCauseOnAccidentResolvers<ContextType>;
  InvestigationIndicatorsChart?: TInvestigationIndicatorsChartResolvers<ContextType>;
  InvestigationSuggestion?: TInvestigationSuggestionResolvers<ContextType>;
  Invite?: TInviteResolvers<ContextType>;
  InviteParametersMail?: TInviteParametersMailResolvers<ContextType>;
  Invoice?: TInvoiceResolvers<ContextType>;
  Ipe?: TIpeResolvers<ContextType>;
  IpeBiometry?: TIpeBiometryResolvers<ContextType>;
  IpeByRequirementChart?: TIpeByRequirementChartResolvers<ContextType>;
  IpeByRisk?: TIpeByRiskResolvers<ContextType>;
  IpeDelivery?: TIpeDeliveryResolvers<ContextType>;
  IpeDeliveryDashboard?: TIpeDeliveryDashboardResolvers<ContextType>;
  IpeDeliveryExtensionAuditReport?: TIpeDeliveryExtensionAuditReportResolvers<ContextType>;
  IpeDeliveryExtensionAuditStats?: TIpeDeliveryExtensionAuditStatsResolvers<ContextType>;
  IpeDeliveryExtensionEntry?: TIpeDeliveryExtensionEntryResolvers<ContextType>;
  IpeDeliveryExtensionResult?: TIpeDeliveryExtensionResultResolvers<ContextType>;
  IpeDeliveryExtensionTimeline?: TIpeDeliveryExtensionTimelineResolvers<ContextType>;
  IpeDeliveryFace?: TIpeDeliveryFaceResolvers<ContextType>;
  IpeDeliveryLineCharts?: TIpeDeliveryLineChartsResolvers<ContextType>;
  IpeDeliveryMedicalReport?: TIpeDeliveryMedicalReportResolvers<ContextType>;
  IpeDeliveryParams?: TIpeDeliveryParamsResolvers<ContextType>;
  IpeDeliveryPerTotalChart?: TIpeDeliveryPerTotalChartResolvers<ContextType>;
  IpeDeliveryPieCharts?: TIpeDeliveryPieChartsResolvers<ContextType>;
  IpeDeliveryReport?: TIpeDeliveryReportResolvers<ContextType>;
  IpeDeliveryReportParams?: TIpeDeliveryReportParamsResolvers<ContextType>;
  IpeFace?: TIpeFaceResolvers<ContextType>;
  IpeInfo?: TIpeInfoResolvers<ContextType>;
  IpeManufacturer?: TIpeManufacturerResolvers<ContextType>;
  IpeManufacturerSuggestion?: TIpeManufacturerSuggestionResolvers<ContextType>;
  IpeOccupation?: TIpeOccupationResolvers<ContextType>;
  IpeReport?: TIpeReportResolvers<ContextType>;
  IpeTask?: TIpeTaskResolvers<ContextType>;
  IpesInfo?: TIpesInfoResolvers<ContextType>;
  IpesInfoSorted?: TIpesInfoSortedResolvers<ContextType>;
  Item?: TItemResolvers<ContextType>;
  ItemsSteps?: TItemsStepsResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  Level?: TLevelResolvers<ContextType>;
  LevelsForecast?: TLevelsForecastResolvers<ContextType>;
  LineChart?: TLineChartResolvers<ContextType>;
  LineCharts?: TLineChartsResolvers<ContextType>;
  LocationStructure?: TLocationStructureResolvers<ContextType>;
  Login?: TLoginResolvers<ContextType>;
  Mandate?: TMandateResolvers<ContextType>;
  MandateAction?: TMandateActionResolvers<ContextType>;
  MandateActionStatusChart?: TMandateActionStatusChartResolvers<ContextType>;
  MandateActionStatusEntry?: TMandateActionStatusEntryResolvers<ContextType>;
  MandateCostCenter?: TMandateCostCenterResolvers<ContextType>;
  MandateDashboard?: TMandateDashboardResolvers<ContextType>;
  MandateDepartment?: TMandateDepartmentResolvers<ContextType>;
  MandateDimension?: TMandateDimensionResolvers<ContextType>;
  MandateEvent?: TMandateEventResolvers<ContextType>;
  MandateEventInfo?: TMandateEventInfoResolvers<ContextType>;
  MandateLoss?: TMandateLossResolvers<ContextType>;
  MandateMeetingActionsTotalChart?: TMandateMeetingActionsTotalChartResolvers<ContextType>;
  MandateMeetingActionsTotalEntry?: TMandateMeetingActionsTotalEntryResolvers<ContextType>;
  MandateMeetingParticipantsChart?: TMandateMeetingParticipantsChartResolvers<ContextType>;
  MandateMeetingParticipantsEntry?: TMandateMeetingParticipantsEntryResolvers<ContextType>;
  MandateMeetingsChart?: TMandateMeetingsChartResolvers<ContextType>;
  MandateMeetingsEntry?: TMandateMeetingsEntryResolvers<ContextType>;
  MandateMonetaryChart?: TMandateMonetaryChartResolvers<ContextType>;
  MandateMonetaryEntry?: TMandateMonetaryEntryResolvers<ContextType>;
  MandateMonthlyCountChart?: TMandateMonthlyCountChartResolvers<ContextType>;
  MandateMonthlyCountEntry?: TMandateMonthlyCountEntryResolvers<ContextType>;
  MandateSuggestionStatusChart?: TMandateSuggestionStatusChartResolvers<ContextType>;
  MandateSuggestionStatusEntry?: TMandateSuggestionStatusEntryResolvers<ContextType>;
  MandateTraining?: TMandateTrainingResolvers<ContextType>;
  MandateValidity?: TMandateValidityResolvers<ContextType>;
  Manufacturer?: TManufacturerResolvers<ContextType>;
  MapUpload?: TMapUploadResolvers<ContextType>;
  MeasurementByAgentGroupItem?: TMeasurementByAgentGroupItemResolvers<ContextType>;
  MeasurementByRisk?: TMeasurementByRiskResolvers<ContextType>;
  MeasurementDeviceItem?: TMeasurementDeviceItemResolvers<ContextType>;
  MeasurementDevicesChart?: TMeasurementDevicesChartResolvers<ContextType>;
  Measurements?: TMeasurementsResolvers<ContextType>;
  MeasuringInstrument?: TMeasuringInstrumentResolvers<ContextType>;
  MedConsultReport?: TMedConsultReportResolvers<ContextType>;
  MedRecordHealthPrograms?: TMedRecordHealthProgramsResolvers<ContextType>;
  MedicalCertificate?: TMedicalCertificateResolvers<ContextType>;
  MedicalCertificateByIcd?: TMedicalCertificateByIcdResolvers<ContextType>;
  MedicalCertificateReport?: TMedicalCertificateReportResolvers<ContextType>;
  MedicalConsultation?: TMedicalConsultationResolvers<ContextType>;
  MedicalRecord?: TMedicalRecordResolvers<ContextType>;
  MedicalRecordCertificates?: TMedicalRecordCertificatesResolvers<ContextType>;
  MedicalRecordDashboard?: TMedicalRecordDashboardResolvers<ContextType>;
  MedicalRecordDeficiencies?: TMedicalRecordDeficienciesResolvers<ContextType>;
  MedicalRecordDiagnostics?: TMedicalRecordDiagnosticsResolvers<ContextType>;
  MedicalRecordExams?: TMedicalRecordExamsResolvers<ContextType>;
  MedicalRecordHealthProgram?: TMedicalRecordHealthProgramResolvers<ContextType>;
  MedicalRecordName?: TMedicalRecordNameResolvers<ContextType>;
  MedicalRecordReport?: TMedicalRecordReportResolvers<ContextType>;
  MedicalRecordRestrictions?: TMedicalRecordRestrictionsResolvers<ContextType>;
  MedicalRecordVaccinationPlanning?: TMedicalRecordVaccinationPlanningResolvers<ContextType>;
  MedicalRecordVaccinationPlanningReport?: TMedicalRecordVaccinationPlanningReportResolvers<ContextType>;
  MedicalRecordVaccine?: TMedicalRecordVaccineResolvers<ContextType>;
  MedicalRecordVaccinePrint?: TMedicalRecordVaccinePrintResolvers<ContextType>;
  MedicalReferral?: TMedicalReferralResolvers<ContextType>;
  MedicalReferralDoctorBiometry?: TMedicalReferralDoctorBiometryResolvers<ContextType>;
  MedicalReferralReport?: TMedicalReferralReportResolvers<ContextType>;
  MedicalRestriction?: TMedicalRestrictionResolvers<ContextType>;
  MedicalRestrictionsChart?: TMedicalRestrictionsChartResolvers<ContextType>;
  Medicine?: TMedicineResolvers<ContextType>;
  MedicineOnDiagnostic?: TMedicineOnDiagnosticResolvers<ContextType>;
  MedicinesPrescription?: TMedicinesPrescriptionResolvers<ContextType>;
  Meeting?: TMeetingResolvers<ContextType>;
  MeetingAction?: TMeetingActionResolvers<ContextType>;
  MeetingEntry?: TMeetingEntryResolvers<ContextType>;
  MeetingParticipant?: TMeetingParticipantResolvers<ContextType>;
  MicroActionStatusChart?: TMicroActionStatusChartResolvers<ContextType>;
  MicroActionStatusEntry?: TMicroActionStatusEntryResolvers<ContextType>;
  ModuleDefaultRecipientsDto?: TModuleDefaultRecipientsDtoResolvers<ContextType>;
  Mutation?: TMutationResolvers<ContextType>;
  NoiseRisk?: TNoiseRiskResolvers<ContextType>;
  Notification?: TNotificationResolvers<ContextType>;
  NotificationConfigDto?: TNotificationConfigDtoResolvers<ContextType>;
  NotificationTags?: TNotificationTagsResolvers<ContextType>;
  NtepDistributionChart?: TNtepDistributionChartResolvers<ContextType>;
  NtepEvolutionChart?: TNtepEvolutionChartResolvers<ContextType>;
  NtepPieEntry?: TNtepPieEntryResolvers<ContextType>;
  NtepSeries?: TNtepSeriesResolvers<ContextType>;
  Occupation?: TOccupationResolvers<ContextType>;
  OccupationByRisk?: TOccupationByRiskResolvers<ContextType>;
  OccupationOnVaccine?: TOccupationOnVaccineResolvers<ContextType>;
  OccupationalCertificateParameters?: TOccupationalCertificateParametersResolvers<ContextType>;
  OccupationalDiseaseAnalysis?: TOccupationalDiseaseAnalysisResolvers<ContextType>;
  OccupationalHealthBiometry?: TOccupationalHealthBiometryResolvers<ContextType>;
  OccupationalHealthCertificate?: TOccupationalHealthCertificateResolvers<ContextType>;
  OccupationalHealthCertificateByDate?: TOccupationalHealthCertificateByDateResolvers<ContextType>;
  OccupationalHealthCertificateTotal?: TOccupationalHealthCertificateTotalResolvers<ContextType>;
  OccupationalHealthFace?: TOccupationalHealthFaceResolvers<ContextType>;
  OccupationsGroup?: TOccupationsGroupResolvers<ContextType>;
  OccurrenceEntry?: TOccurrenceEntryResolvers<ContextType>;
  Organization?: TOrganizationResolvers<ContextType>;
  OrganizationOwnership?: TOrganizationOwnershipResolvers<ContextType>;
  OrganizationWithBranches?: TOrganizationWithBranchesResolvers<ContextType>;
  OrthoRater?: TOrthoRaterResolvers<ContextType>;
  PPREmployees?: TPprEmployeesResolvers<ContextType>;
  PaginatedAbsenceType?: TPaginatedAbsenceTypeResolvers<ContextType>;
  PaginatedAccident?: TPaginatedAccidentResolvers<ContextType>;
  PaginatedAccidentCause?: TPaginatedAccidentCauseResolvers<ContextType>;
  PaginatedAccidentCode?: TPaginatedAccidentCodeResolvers<ContextType>;
  PaginatedAccidentObject?: TPaginatedAccidentObjectResolvers<ContextType>;
  PaginatedAccidentType?: TPaginatedAccidentTypeResolvers<ContextType>;
  PaginatedAccredited?: TPaginatedAccreditedResolvers<ContextType>;
  PaginatedAccreditedConsultations?: TPaginatedAccreditedConsultationsResolvers<ContextType>;
  PaginatedActionPlan?: TPaginatedActionPlanResolvers<ContextType>;
  PaginatedActivityGroup?: TPaginatedActivityGroupResolvers<ContextType>;
  PaginatedActivityIcd?: TPaginatedActivityIcdResolvers<ContextType>;
  PaginatedAllowanceType?: TPaginatedAllowanceTypeResolvers<ContextType>;
  PaginatedAttachment?: TPaginatedAttachmentResolvers<ContextType>;
  PaginatedAuditLogs?: TPaginatedAuditLogsResolvers<ContextType>;
  PaginatedBiologicalMonitoringExam?: TPaginatedBiologicalMonitoringExamResolvers<ContextType>;
  PaginatedBiologicalMonitoringExamGroup?: TPaginatedBiologicalMonitoringExamGroupResolvers<ContextType>;
  PaginatedBodyPart?: TPaginatedBodyPartResolvers<ContextType>;
  PaginatedBranch?: TPaginatedBranchResolvers<ContextType>;
  PaginatedCalendar?: TPaginatedCalendarResolvers<ContextType>;
  PaginatedConsultation?: TPaginatedConsultationResolvers<ContextType>;
  PaginatedConsultationMinimal?: TPaginatedConsultationMinimalResolvers<ContextType>;
  PaginatedConsultationReason?: TPaginatedConsultationReasonResolvers<ContextType>;
  PaginatedControlMeasure?: TPaginatedControlMeasureResolvers<ContextType>;
  PaginatedCostCenter?: TPaginatedCostCenterResolvers<ContextType>;
  PaginatedCrontabExecutionDetails?: TPaginatedCrontabExecutionDetailsResolvers<ContextType>;
  PaginatedCrontabExecutions?: TPaginatedCrontabExecutionsResolvers<ContextType>;
  PaginatedDeliverySpareParts?: TPaginatedDeliverySparePartsResolvers<ContextType>;
  PaginatedDepartment?: TPaginatedDepartmentResolvers<ContextType>;
  PaginatedESocialQueue?: TPaginatedESocialQueueResolvers<ContextType>;
  PaginatedEconomicActivity?: TPaginatedEconomicActivityResolvers<ContextType>;
  PaginatedEmployeeIpeDelivery?: TPaginatedEmployeeIpeDeliveryResolvers<ContextType>;
  PaginatedEnvironmentalReport?: TPaginatedEnvironmentalReportResolvers<ContextType>;
  PaginatedEnvironmentalReportSuggestion?: TPaginatedEnvironmentalReportSuggestionResolvers<ContextType>;
  PaginatedEvent?: TPaginatedEventResolvers<ContextType>;
  PaginatedExam?: TPaginatedExamResolvers<ContextType>;
  PaginatedExamNormalResult?: TPaginatedExamNormalResultResolvers<ContextType>;
  PaginatedExpectedConsultations?: TPaginatedExpectedConsultationsResolvers<ContextType>;
  PaginatedExpense?: TPaginatedExpenseResolvers<ContextType>;
  PaginatedExposureGroup?: TPaginatedExposureGroupResolvers<ContextType>;
  PaginatedExtinguishingSystem?: TPaginatedExtinguishingSystemResolvers<ContextType>;
  PaginatedFireBrigade?: TPaginatedFireBrigadeResolvers<ContextType>;
  PaginatedGeneratingSource?: TPaginatedGeneratingSourceResolvers<ContextType>;
  PaginatedGenericAccidentCause?: TPaginatedGenericAccidentCauseResolvers<ContextType>;
  PaginatedGenericActivePrinciple?: TPaginatedGenericActivePrincipleResolvers<ContextType>;
  PaginatedGenericBiologicalMonitoringExam?: TPaginatedGenericBiologicalMonitoringExamResolvers<ContextType>;
  PaginatedGenericBiologicalMonitoringExamGroup?: TPaginatedGenericBiologicalMonitoringExamGroupResolvers<ContextType>;
  PaginatedGenericCostCenter?: TPaginatedGenericCostCenterResolvers<ContextType>;
  PaginatedGenericExam?: TPaginatedGenericExamResolvers<ContextType>;
  PaginatedGenericExaminationProcedure?: TPaginatedGenericExaminationProcedureResolvers<ContextType>;
  PaginatedGenericExpense?: TPaginatedGenericExpenseResolvers<ContextType>;
  PaginatedGenericHealthProgram?: TPaginatedGenericHealthProgramResolvers<ContextType>;
  PaginatedGenericLaboratory?: TPaginatedGenericLaboratoryResolvers<ContextType>;
  PaginatedGenericMeasuringInstrument?: TPaginatedGenericMeasuringInstrumentResolvers<ContextType>;
  PaginatedGenericMedicine?: TPaginatedGenericMedicineResolvers<ContextType>;
  PaginatedGenericOccupation?: TPaginatedGenericOccupationResolvers<ContextType>;
  PaginatedGenericPeriodicRange?: TPaginatedGenericPeriodicRangeResolvers<ContextType>;
  PaginatedGenericPublicPlace?: TPaginatedGenericPublicPlaceResolvers<ContextType>;
  PaginatedGenericQuestionGroup?: TPaginatedGenericQuestionGroupResolvers<ContextType>;
  PaginatedGenericQuestionQuiz?: TPaginatedGenericQuestionQuizResolvers<ContextType>;
  PaginatedGenericQuiz?: TPaginatedGenericQuizResolvers<ContextType>;
  PaginatedGenericReportStructure?: TPaginatedGenericReportStructureResolvers<ContextType>;
  PaginatedGenericResponseOption?: TPaginatedGenericResponseOptionResolvers<ContextType>;
  PaginatedGenericRiskAgent?: TPaginatedGenericRiskAgentResolvers<ContextType>;
  PaginatedGenericStatementResponsibility?: TPaginatedGenericStatementResponsibilityResolvers<ContextType>;
  PaginatedGenericTask?: TPaginatedGenericTaskResolvers<ContextType>;
  PaginatedGenericTraining?: TPaginatedGenericTrainingResolvers<ContextType>;
  PaginatedGenericVaccine?: TPaginatedGenericVaccineResolvers<ContextType>;
  PaginatedGenericWorkShift?: TPaginatedGenericWorkShiftResolvers<ContextType>;
  PaginatedGetDocuments?: TPaginatedGetDocumentsResolvers<ContextType>;
  PaginatedHealthProgram?: TPaginatedHealthProgramResolvers<ContextType>;
  PaginatedIcdGroups?: TPaginatedIcdGroupsResolvers<ContextType>;
  PaginatedIcds?: TPaginatedIcdsResolvers<ContextType>;
  PaginatedInjuryNature?: TPaginatedInjuryNatureResolvers<ContextType>;
  PaginatedIntegrationError?: TPaginatedIntegrationErrorResolvers<ContextType>;
  PaginatedInventoryQueue?: TPaginatedInventoryQueueResolvers<ContextType>;
  PaginatedInvestigationSuggestion?: TPaginatedInvestigationSuggestionResolvers<ContextType>;
  PaginatedIpe?: TPaginatedIpeResolvers<ContextType>;
  PaginatedIpeManufacturer?: TPaginatedIpeManufacturerResolvers<ContextType>;
  PaginatedMandate?: TPaginatedMandateResolvers<ContextType>;
  PaginatedManufacturer?: TPaginatedManufacturerResolvers<ContextType>;
  PaginatedMeasuringInstrument?: TPaginatedMeasuringInstrumentResolvers<ContextType>;
  PaginatedMedicalRecords?: TPaginatedMedicalRecordsResolvers<ContextType>;
  PaginatedMedicine?: TPaginatedMedicineResolvers<ContextType>;
  PaginatedOccupation?: TPaginatedOccupationResolvers<ContextType>;
  PaginatedPeopleOnBrowse?: TPaginatedPeopleOnBrowseResolvers<ContextType>;
  PaginatedPeriodicRange?: TPaginatedPeriodicRangeResolvers<ContextType>;
  PaginatedPerson?: TPaginatedPersonResolvers<ContextType>;
  PaginatedPersonIpeList?: TPaginatedPersonIpeListResolvers<ContextType>;
  PaginatedPersonNeedIpe?: TPaginatedPersonNeedIpeResolvers<ContextType>;
  PaginatedPhysicalEnvironment?: TPaginatedPhysicalEnvironmentResolvers<ContextType>;
  PaginatedPosition?: TPaginatedPositionResolvers<ContextType>;
  PaginatedPreMedicalCertificates?: TPaginatedPreMedicalCertificatesResolvers<ContextType>;
  PaginatedProduct?: TPaginatedProductResolvers<ContextType>;
  PaginatedProductDelivery?: TPaginatedProductDeliveryResolvers<ContextType>;
  PaginatedProductIpeManufacturer?: TPaginatedProductIpeManufacturerResolvers<ContextType>;
  PaginatedQueue?: TPaginatedQueueResolvers<ContextType>;
  PaginatedQuiz?: TPaginatedQuizResolvers<ContextType>;
  PaginatedReportStructure?: TPaginatedReportStructureResolvers<ContextType>;
  PaginatedRisk?: TPaginatedRiskResolvers<ContextType>;
  PaginatedRiskAgent?: TPaginatedRiskAgentResolvers<ContextType>;
  PaginatedRiskSuggestion?: TPaginatedRiskSuggestionResolvers<ContextType>;
  PaginatedRolePermission?: TPaginatedRolePermissionResolvers<ContextType>;
  PaginatedScheduleRestriction?: TPaginatedScheduleRestrictionResolvers<ContextType>;
  PaginatedSpareParts?: TPaginatedSparePartsResolvers<ContextType>;
  PaginatedStabilityType?: TPaginatedStabilityTypeResolvers<ContextType>;
  PaginatedStatementResponsibility?: TPaginatedStatementResponsibilityResolvers<ContextType>;
  PaginatedSync?: TPaginatedSyncResolvers<ContextType>;
  PaginatedTTalkQueue?: TPaginatedTTalkQueueResolvers<ContextType>;
  PaginatedTask?: TPaginatedTaskResolvers<ContextType>;
  PaginatedTraining?: TPaginatedTrainingResolvers<ContextType>;
  PaginatedTrainingHistory?: TPaginatedTrainingHistoryResolvers<ContextType>;
  PaginatedTtalkInboundEvent?: TPaginatedTtalkInboundEventResolvers<ContextType>;
  PaginatedTtalkInboundSemanticInconsistency?: TPaginatedTtalkInboundSemanticInconsistencyResolvers<ContextType>;
  PaginatedUnityMeasure?: TPaginatedUnityMeasureResolvers<ContextType>;
  PaginatedVaccine?: TPaginatedVaccineResolvers<ContextType>;
  PaginatedWarehouse?: TPaginatedWarehouseResolvers<ContextType>;
  PaginatedWebhookQueue?: TPaginatedWebhookQueueResolvers<ContextType>;
  PaginatedWorkPermission?: TPaginatedWorkPermissionResolvers<ContextType>;
  PaginatedWorkShift?: TPaginatedWorkShiftResolvers<ContextType>;
  ParticipantOnMeeting?: TParticipantOnMeetingResolvers<ContextType>;
  Payments?: TPaymentsResolvers<ContextType>;
  PcmsoReportData?: TPcmsoReportDataResolvers<ContextType>;
  PerDayChart?: TPerDayChartResolvers<ContextType>;
  PerTotalCharts?: TPerTotalChartsResolvers<ContextType>;
  PeriodicRange?: TPeriodicRangeResolvers<ContextType>;
  Permission?: TPermissionResolvers<ContextType>;
  Person?: TPersonResolvers<ContextType>;
  PersonByGender?: TPersonByGenderResolvers<ContextType>;
  PersonByGenderAndCC?: TPersonByGenderAndCcResolvers<ContextType>;
  PersonByMandate?: TPersonByMandateResolvers<ContextType>;
  PersonByRisk?: TPersonByRiskResolvers<ContextType>;
  PersonByTask?: TPersonByTaskResolvers<ContextType>;
  PersonChart?: TPersonChartResolvers<ContextType>;
  PersonHistory?: TPersonHistoryResolvers<ContextType>;
  PersonHistoryActivate?: TPersonHistoryActivateResolvers<ContextType>;
  PersonIpeList?: TPersonIpeListResolvers<ContextType>;
  PersonNeedIpe?: TPersonNeedIpeResolvers<ContextType>;
  PersonOnBrowse?: TPersonOnBrowseResolvers<ContextType>;
  PersonRequiredTraining?: TPersonRequiredTrainingResolvers<ContextType>;
  PhysicalEnvironment?: TPhysicalEnvironmentResolvers<ContextType>;
  PieChart?: TPieChartResolvers<ContextType>;
  PieCharts?: TPieChartsResolvers<ContextType>;
  PlanedExam?: TPlanedExamResolvers<ContextType>;
  PolicyAgreement?: TPolicyAgreementResolvers<ContextType>;
  PolicyTerms?: TPolicyTermsResolvers<ContextType>;
  Position?: TPositionResolvers<ContextType>;
  PppReport?: TPppReportResolvers<ContextType>;
  PreMedicalCertificate?: TPreMedicalCertificateResolvers<ContextType>;
  PreMedicalCertificateCountByStatus?: TPreMedicalCertificateCountByStatusResolvers<ContextType>;
  PreMedicalCertificateFollowUp?: TPreMedicalCertificateFollowUpResolvers<ContextType>;
  PreValidate?: TPreValidateResolvers<ContextType>;
  PrintBiometry?: TPrintBiometryResolvers<ContextType>;
  Product?: TProductResolvers<ContextType>;
  ProductDelivery?: TProductDeliveryResolvers<ContextType>;
  ProductDeliveryParams?: TProductDeliveryParamsResolvers<ContextType>;
  ProductDeliveryReport?: TProductDeliveryReportResolvers<ContextType>;
  ProductIpeManufacturer?: TProductIpeManufacturerResolvers<ContextType>;
  ProductReport?: TProductReportResolvers<ContextType>;
  ProductsParameters?: TProductsParametersResolvers<ContextType>;
  PubSubPayload?: TPubSubPayloadResolvers<ContextType>;
  Query?: TQueryResolvers<ContextType>;
  QuestionGroupOnQuestion?: TQuestionGroupOnQuestionResolvers<ContextType>;
  Questions?: TQuestionsResolvers<ContextType>;
  QuestionsDashboard?: TQuestionsDashboardResolvers<ContextType>;
  QuestionsGroup?: TQuestionsGroupResolvers<ContextType>;
  QueueDTO?: TQueueDtoResolvers<ContextType>;
  Quiz?: TQuizResolvers<ContextType>;
  QuizCostCenter?: TQuizCostCenterResolvers<ContextType>;
  QuizDepartment?: TQuizDepartmentResolvers<ContextType>;
  QuizGeneratingSource?: TQuizGeneratingSourceResolvers<ContextType>;
  QuizOccupation?: TQuizOccupationResolvers<ContextType>;
  QuizPerson?: TQuizPersonResolvers<ContextType>;
  QuizPhysicalEnvironment?: TQuizPhysicalEnvironmentResolvers<ContextType>;
  QuizzesCharts?: TQuizzesChartsResolvers<ContextType>;
  RadarCharts?: TRadarChartsResolvers<ContextType>;
  Ranking?: TRankingResolvers<ContextType>;
  RealGoal?: TRealGoalResolvers<ContextType>;
  RealGoalOnActionPlan?: TRealGoalOnActionPlanResolvers<ContextType>;
  ReasonsChart?: TReasonsChartResolvers<ContextType>;
  RecognizedIcdInfo?: TRecognizedIcdInfoResolvers<ContextType>;
  RecognizedMedicalCertificateData?: TRecognizedMedicalCertificateDataResolvers<ContextType>;
  References?: TReferencesResolvers<ContextType>;
  ReferralsChart?: TReferralsChartResolvers<ContextType>;
  ReferralsQuantityChart?: TReferralsQuantityChartResolvers<ContextType>;
  RelativeIndex?: TRelativeIndexResolvers<ContextType>;
  ReleasableResult?: TReleasableResultResolvers<ContextType>;
  ReportMapaData?: TReportMapaDataResolvers<ContextType>;
  ReportMapaFields?: TReportMapaFieldsResolvers<ContextType>;
  ReportPrescription?: TReportPrescriptionResolvers<ContextType>;
  ReportSection?: TReportSectionResolvers<ContextType>;
  ReportStructure?: TReportStructureResolvers<ContextType>;
  ResponseOptions?: TResponseOptionsResolvers<ContextType>;
  ResponseWorkPermissionQuiz?: TResponseWorkPermissionQuizResolvers<ContextType>;
  ResponsesClinicalQuiz?: TResponsesClinicalQuizResolvers<ContextType>;
  ResponsesSafetyQuiz?: TResponsesSafetyQuizResolvers<ContextType>;
  ResponsibleAction?: TResponsibleActionResolvers<ContextType>;
  ResponsibleOnActionPlan?: TResponsibleOnActionPlanResolvers<ContextType>;
  ResultExamIbmp?: TResultExamIbmpResolvers<ContextType>;
  ResultExamIbmpForComparative?: TResultExamIbmpForComparativeResolvers<ContextType>;
  ResultExamIbmpGroup?: TResultExamIbmpGroupResolvers<ContextType>;
  ResultExamItemForComparative?: TResultExamItemForComparativeResolvers<ContextType>;
  ResultExamItemGroup?: TResultExamItemGroupResolvers<ContextType>;
  ResultExamOrthoRaterForComparative?: TResultExamOrthoRaterForComparativeResolvers<ContextType>;
  ResultExamSnellenForComparative?: TResultExamSnellenForComparativeResolvers<ContextType>;
  ResultExamSpirometryForComparative?: TResultExamSpirometryForComparativeResolvers<ContextType>;
  ResultExamSpirometryGroup?: TResultExamSpirometryGroupResolvers<ContextType>;
  ResultUrinalysisForComparative?: TResultUrinalysisForComparativeResolvers<ContextType>;
  ResultUrinalysisGroup?: TResultUrinalysisGroupResolvers<ContextType>;
  ReturnReasonsChart?: TReturnReasonsChartResolvers<ContextType>;
  Risk?: TRiskResolvers<ContextType>;
  RiskAgent?: TRiskAgentResolvers<ContextType>;
  RiskCharacterization?: TRiskCharacterizationResolvers<ContextType>;
  RiskChart?: TRiskChartResolvers<ContextType>;
  RiskClassificationTable?: TRiskClassificationTableResolvers<ContextType>;
  RiskComposition?: TRiskCompositionResolvers<ContextType>;
  RiskControlMeasure?: TRiskControlMeasureResolvers<ContextType>;
  RiskCostCenterOccupation?: TRiskCostCenterOccupationResolvers<ContextType>;
  RiskCostCenterOccupationIds?: TRiskCostCenterOccupationIdsResolvers<ContextType>;
  RiskCount?: TRiskCountResolvers<ContextType>;
  RiskDashboard?: TRiskDashboardResolvers<ContextType>;
  RiskEnvironment?: TRiskEnvironmentResolvers<ContextType>;
  RiskMeasurement?: TRiskMeasurementResolvers<ContextType>;
  RiskMeasurements?: TRiskMeasurementsResolvers<ContextType>;
  RiskPieChart?: TRiskPieChartResolvers<ContextType>;
  RiskProbabilityTable?: TRiskProbabilityTableResolvers<ContextType>;
  RiskReviewReportFields?: TRiskReviewReportFieldsResolvers<ContextType>;
  RiskSeverityTable?: TRiskSeverityTableResolvers<ContextType>;
  RiskSuggestion?: TRiskSuggestionResolvers<ContextType>;
  RiskToReview?: TRiskToReviewResolvers<ContextType>;
  RiskToReviewReport?: TRiskToReviewReportResolvers<ContextType>;
  RiskTrainings?: TRiskTrainingsResolvers<ContextType>;
  RisksExam?: TRisksExamResolvers<ContextType>;
  RisksInfo?: TRisksInfoResolvers<ContextType>;
  RisksPerEnvironmentChart?: TRisksPerEnvironmentChartResolvers<ContextType>;
  Role?: TRoleResolvers<ContextType>;
  RolePermission?: TRolePermissionResolvers<ContextType>;
  RouteFeature?: TRouteFeatureResolvers<ContextType>;
  RowsInfo?: TRowsInfoResolvers<ContextType>;
  S3UrlCloudFront?: GraphQLScalarType;
  SaasFullMetadata?: TSaasFullMetadataResolvers<ContextType>;
  SaasMetadata?: TSaasMetadataResolvers<ContextType>;
  SafetyQuiz?: TSafetyQuizResolvers<ContextType>;
  SafetyQuizConformityChart?: TSafetyQuizConformityChartResolvers<ContextType>;
  SafetyQuizConformityEntry?: TSafetyQuizConformityEntryResolvers<ContextType>;
  SafetyQuizDashboard?: TSafetyQuizDashboardResolvers<ContextType>;
  SafetyQuizInspectionChart?: TSafetyQuizInspectionChartResolvers<ContextType>;
  SafetyQuizInspectionEntry?: TSafetyQuizInspectionEntryResolvers<ContextType>;
  SafetyQuizParetoChart?: TSafetyQuizParetoChartResolvers<ContextType>;
  SafetyQuizParetoEntry?: TSafetyQuizParetoEntryResolvers<ContextType>;
  ScheduleRestriction?: TScheduleRestrictionResolvers<ContextType>;
  ScheduledConsultation?: TScheduledConsultationResolvers<ContextType>;
  ScheduledConsultationByBranch?: TScheduledConsultationByBranchResolvers<ContextType>;
  ScheduledConsultationToPrint?: TScheduledConsultationToPrintResolvers<ContextType>;
  ScheduledExam?: TScheduledExamResolvers<ContextType>;
  ScheduledExamByBranch?: TScheduledExamByBranchResolvers<ContextType>;
  ScheduledExamToPrint?: TScheduledExamToPrintResolvers<ContextType>;
  SchedulingByAccredited?: TSchedulingByAccreditedResolvers<ContextType>;
  SchedulingParameters?: TSchedulingParametersResolvers<ContextType>;
  SchedulingReport?: TSchedulingReportResolvers<ContextType>;
  SchedulingReportByDoctor?: TSchedulingReportByDoctorResolvers<ContextType>;
  SchedulingSettings?: TSchedulingSettingsResolvers<ContextType>;
  SecurityPyramid?: TSecurityPyramidResolvers<ContextType>;
  SecurityWorkOrder?: TSecurityWorkOrderResolvers<ContextType>;
  SecurityWorkOrderParameters?: TSecurityWorkOrderParametersResolvers<ContextType>;
  SesmtRoles?: TSesmtRolesResolvers<ContextType>;
  Session?: TSessionResolvers<ContextType>;
  SessionData?: TSessionDataResolvers<ContextType>;
  Settings?: TSettingsResolvers<ContextType>;
  SeverityIndex?: TSeverityIndexResolvers<ContextType>;
  ShortcutGenerated?: TShortcutGeneratedResolvers<ContextType>;
  ShortcutHistory?: TShortcutHistoryResolvers<ContextType>;
  ShortcutHistoryId?: TShortcutHistoryIdResolvers<ContextType>;
  SickNote?: TSickNoteResolvers<ContextType>;
  SignBrokerGetDocument?: TSignBrokerGetDocumentResolvers<ContextType>;
  SignBrokerGetDocuments?: TSignBrokerGetDocumentsResolvers<ContextType>;
  SignBrokerGetDocumentsAndUpdateState?: TSignBrokerGetDocumentsAndUpdateStateResolvers<ContextType>;
  SignBrokerResponse?: TSignBrokerResponseResolvers<ContextType>;
  SignBrokerUrlDownloadResponse?: TSignBrokerUrlDownloadResponseResolvers<ContextType>;
  SignCredentialsOutput?: TSignCredentialsOutputResolvers<ContextType>;
  SignatureChart?: TSignatureChartResolvers<ContextType>;
  SimpleComplementaryResults?: TSimpleComplementaryResultsResolvers<ContextType>;
  Simulation?: TSimulationResolvers<ContextType>;
  SimulationAction?: TSimulationActionResolvers<ContextType>;
  SimulationActionEntry?: TSimulationActionEntryResolvers<ContextType>;
  SimulationEntry?: TSimulationEntryResolvers<ContextType>;
  SimulationPlan?: TSimulationPlanResolvers<ContextType>;
  SimulationPlanAction?: TSimulationPlanActionResolvers<ContextType>;
  Sipat?: TSipatResolvers<ContextType>;
  SipatEvent?: TSipatEventResolvers<ContextType>;
  SituationCount?: TSituationCountResolvers<ContextType>;
  Snellen?: TSnellenResolvers<ContextType>;
  SpareParts?: TSparePartsResolvers<ContextType>;
  SparePartsReport?: TSparePartsReportResolvers<ContextType>;
  StabilityType?: TStabilityTypeResolvers<ContextType>;
  StatementResponsibility?: TStatementResponsibilityResolvers<ContextType>;
  StepMessage?: TStepMessageResolvers<ContextType>;
  Steps?: TStepsResolvers<ContextType>;
  StockLevel?: TStockLevelResolvers<ContextType>;
  StockLevelSyncResult?: TStockLevelSyncResultResolvers<ContextType>;
  StockMovement?: TStockMovementResolvers<ContextType>;
  Subscription?: TSubscriptionResolvers<ContextType>;
  SuggestionAmount?: TSuggestionAmountResolvers<ContextType>;
  SuggestionBox?: TSuggestionBoxResolvers<ContextType>;
  SuggestionBoxListReport?: TSuggestionBoxListReportResolvers<ContextType>;
  Summary?: TSummaryResolvers<ContextType>;
  SummaryEntry?: TSummaryEntryResolvers<ContextType>;
  SummaryOption?: TSummaryOptionResolvers<ContextType>;
  SyncDTO?: TSyncDtoResolvers<ContextType>;
  TTalkQueue?: TTTalkQueueResolvers<ContextType>;
  TTalkQueueAll?: TTTalkQueueAllResolvers<ContextType>;
  TTalkQueueSummary?: TTTalkQueueSummaryResolvers<ContextType>;
  TableProperties?: TTablePropertiesResolvers<ContextType>;
  Task?: TTaskResolvers<ContextType>;
  TaskByPerson?: TTaskByPersonResolvers<ContextType>;
  TaskByRisk?: TTaskByRiskResolvers<ContextType>;
  Terms?: TTermsResolvers<ContextType>;
  TimePoint?: TTimePointResolvers<ContextType>;
  TopIcdItem?: TTopIcdItemResolvers<ContextType>;
  TopIcdsChart?: TTopIcdsChartResolvers<ContextType>;
  Training?: TTrainingResolvers<ContextType>;
  TrainingByRisk?: TTrainingByRiskResolvers<ContextType>;
  TrainingEligiblePerson?: TTrainingEligiblePersonResolvers<ContextType>;
  TrainingEligiblePersonsResult?: TTrainingEligiblePersonsResultResolvers<ContextType>;
  TrainingHistory?: TTrainingHistoryResolvers<ContextType>;
  TrainingHistoryBatchResult?: TTrainingHistoryBatchResultResolvers<ContextType>;
  TrainingHistoryByPerson?: TTrainingHistoryByPersonResolvers<ContextType>;
  TransferBlockedItem?: TTransferBlockedItemResolvers<ContextType>;
  TransferConsultationsResult?: TTransferConsultationsResultResolvers<ContextType>;
  TtalkInboundEvent?: TTtalkInboundEventResolvers<ContextType>;
  TtalkInboundSemanticInconsistency?: TTtalkInboundSemanticInconsistencyResolvers<ContextType>;
  TtalkInboundSilenceMonitor?: TTtalkInboundSilenceMonitorResolvers<ContextType>;
  TtalkInboundSilenceThreshold?: TTtalkInboundSilenceThresholdResolvers<ContextType>;
  TypeChart?: TTypeChartResolvers<ContextType>;
  TypeCostCenterChart?: TTypeCostCenterChartResolvers<ContextType>;
  UnityOfMeasure?: TUnityOfMeasureResolvers<ContextType>;
  Upload?: GraphQLScalarType;
  Urinalysis?: TUrinalysisResolvers<ContextType>;
  User?: TUserResolvers<ContextType>;
  UserBasicInfo?: TUserBasicInfoResolvers<ContextType>;
  UserFilterPreferenceResult?: TUserFilterPreferenceResultResolvers<ContextType>;
  UserFromCreation?: TUserFromCreationResolvers<ContextType>;
  UserOrganizationListing?: TUserOrganizationListingResolvers<ContextType>;
  UserPreferences?: TUserPreferencesResolvers<ContextType>;
  UserRoleMdt?: TUserRoleMdtResolvers<ContextType>;
  UserRoutes?: TUserRoutesResolvers<ContextType>;
  UserSpecialty?: TUserSpecialtyResolvers<ContextType>;
  UtmData?: TUtmDataResolvers<ContextType>;
  Vaccine?: TVaccineResolvers<ContextType>;
  VaccineBiometry?: TVaccineBiometryResolvers<ContextType>;
  VaccineChart?: TVaccineChartResolvers<ContextType>;
  VaccinePlanningParameters?: TVaccinePlanningParametersResolvers<ContextType>;
  VaccinePrint?: TVaccinePrintResolvers<ContextType>;
  VaccineQuantityChart?: TVaccineQuantityChartResolvers<ContextType>;
  ValidationError?: TValidationErrorResolvers<ContextType>;
  ValidationReturn?: TValidationReturnResolvers<ContextType>;
  VolumeChart?: TVolumeChartResolvers<ContextType>;
  VotationProgress?: TVotationProgressResolvers<ContextType>;
  Vote?: TVoteResolvers<ContextType>;
  VoteStatus?: TVoteStatusResolvers<ContextType>;
  Warehouse?: TWarehouseResolvers<ContextType>;
  WarningByPerson?: TWarningByPersonResolvers<ContextType>;
  Webhook?: TWebhookResolvers<ContextType>;
  WebhookQueue?: TWebhookQueueResolvers<ContextType>;
  WitnessOnAccident?: TWitnessOnAccidentResolvers<ContextType>;
  WorkHour?: TWorkHourResolvers<ContextType>;
  WorkHours?: TWorkHoursResolvers<ContextType>;
  WorkPermission?: TWorkPermissionResolvers<ContextType>;
  WorkPermissionDashboard?: TWorkPermissionDashboardResolvers<ContextType>;
  WorkPermissionParetoChart?: TWorkPermissionParetoChartResolvers<ContextType>;
  WorkPermissionParetoEntry?: TWorkPermissionParetoEntryResolvers<ContextType>;
  WorkPermissionPerson?: TWorkPermissionPersonResolvers<ContextType>;
  WorkPermissionQuiz?: TWorkPermissionQuizResolvers<ContextType>;
  WorkShift?: TWorkShiftResolvers<ContextType>;
  YearlyVariationChart?: TYearlyVariationChartResolvers<ContextType>;
  _Invite?: T_InviteResolvers<ContextType>;
  _PasswordRecovery?: T_PasswordRecoveryResolvers<ContextType>;
  _Terms?: T_TermsResolvers<ContextType>;
  isAccreditedResult?: TIsAccreditedResultResolvers<ContextType>;
}>;

